// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"d0Upo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _leaflet = require("leaflet");
var _leafletDefault = parcelHelpers.interopDefault(_leaflet);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _s3 = require("../../../node_modules/fine-uploader/lib/jquery/s3");
var _s3Default = parcelHelpers.interopDefault(_s3);
var _numeral = require("numeral");
var _numeralDefault = parcelHelpers.interopDefault(_numeral);
var _jqueryNicescrollMin = require("jquery.nicescroll/dist/jquery.nicescroll.min");
var _jqueryUiTouchPunch = require("../../../node_modules/jquery-ui-touch-punch/jquery.ui.touch-punch");
var _leafletAreaselect = require("../../../node_modules/leaflet-areaselect/src/leaflet-areaselect");
var _leafletDraw = require("leaflet-draw");
var _redactor = require("redactor");
var _fontcolor = require("redactor/plugins/fontcolor");
var _fontsize = require("redactor/plugins/fontsize");
var _fullscreen = require("redactor/plugins/fullscreen");
var _angular = require("angular");
var _promiseTracker = require("../../../node_modules/angular-promise-tracker/promise-tracker");
var _angularSpectrumColorpicker = require("angular-spectrum-colorpicker");
var _checklistModel = require("../../../node_modules/checklist-model/checklist-model");
var _angularAnimate = require("angular-animate");
var _angularSanitize = require("angular-sanitize");
var _ngGeolocation = require("../../../node_modules/ngGeolocation/ngGeolocation");
var _ngprogressLite = require("ngprogress-lite");
var _restangular = require("restangular");
var _angularBootstrap = require("angular-bootstrap");
var _angularUiRouter = require("angular-ui-router");
var _uiUtils = require("../../../node_modules/angular-ui-utils/ui-utils");
var _xeditable = require("../../../node_modules/angular-xeditable/dist/js/xeditable");
var _angularUiSortable = require("angular-ui-sortable");
var _truTerritorySide = require("../../../src/pages/TruTerritory/Side/TruTerritorySide");
var _map = require("../../../src/pages/TruTerritory/Map");
window._ = (0, _lodashDefault.default);
window.L = (0, _leafletDefault.default);
window.moment = (0, _momentDefault.default);
window.qq = (0, _s3Default.default);
window.numeral = (0, _numeralDefault.default);
/*
|--------------------------------------------------------------------------
| Public Maps
|--------------------------------------------------------------------------
*/ angular.module("app", [
    "ajoslin.promise-tracker",
    "ngAnimate",
    "ngGeolocation",
    "ui.router",
    "ui.bootstrap",
    "ui.utils",
    "restangular",
    require("e6da06bff48ba873").default,
    require("8f1823480f64a13c").default,
    require("2b2c1b5888abd359").default,
    require("a8ffc03563518702").default,
    require("74b4877de57b9774").default,
    require("4a21982526cac295").default,
    require("4a6ef7f5406c0e97").default,
    require("d717728abf231e91").default,
    require("5e528cfe63481c50").default,
    require("a49ab891265bf712").default,
    require("7d1464f0e850e022").default,
    require("956b93ab67d98549").default,
    require("adf53fc2ca82443b").default,
    require("288e4d36d2eaff5c").default
]).component("epiTruterritorySide", (0, _truTerritorySide.AngularTruTerritorySide)).component("epiMapV2", (0, _map.AngularEpiMap));

},{"lodash":"aq4vY","leaflet":"kg6Jw","moment":"5rvqv","../../../node_modules/fine-uploader/lib/jquery/s3":"bxMK1","numeral":"cN1Lf","jquery.nicescroll/dist/jquery.nicescroll.min":"eBiPu","../../../node_modules/jquery-ui-touch-punch/jquery.ui.touch-punch":"asMy1","../../../node_modules/leaflet-areaselect/src/leaflet-areaselect":"dlmBG","leaflet-draw":"fmytP","redactor":"bOUXL","redactor/plugins/fontcolor":"loHKk","redactor/plugins/fontsize":"75rVT","redactor/plugins/fullscreen":"1fY5t","angular":"8oyA9","../../../node_modules/angular-promise-tracker/promise-tracker":"fuLZd","angular-spectrum-colorpicker":"csQ8w","../../../node_modules/checklist-model/checklist-model":"hRgtn","angular-animate":"flF72","angular-sanitize":"dxpjJ","../../../node_modules/ngGeolocation/ngGeolocation":"4vRvj","ngprogress-lite":"hJ37d","restangular":"bsRMJ","angular-bootstrap":"knhW1","angular-ui-router":"hxe0Q","../../../node_modules/angular-ui-utils/ui-utils":"gIegj","../../../node_modules/angular-xeditable/dist/js/xeditable":"g0bYc","angular-ui-sortable":"abhSD","../../../src/pages/TruTerritory/Side/TruTerritorySide":"kiozJ","../../../src/pages/TruTerritory/Map":"cNzLb","e6da06bff48ba873":"cMsXP","8f1823480f64a13c":"91Jm1","2b2c1b5888abd359":"1KXgw","a8ffc03563518702":"hoUVw","74b4877de57b9774":"aweGh","4a21982526cac295":"4zI1v","4a6ef7f5406c0e97":"gXMvV","d717728abf231e91":"1g7LZ","5e528cfe63481c50":"abIGM","a49ab891265bf712":"dX9bK","7d1464f0e850e022":"kxn86","956b93ab67d98549":"dugeI","adf53fc2ca82443b":"9ijip","288e4d36d2eaff5c":"aBdQI","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aq4vY":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre ES5 environments */ var undefined;
    /** Used to pool arrays and objects used internally */ var arrayPool = [], objectPool = [];
    /** Used to generate unique IDs */ var idCounter = 0;
    /** Used to prefix keys to avoid issues with `__proto__` and properties on `Object.prototype` */ var keyPrefix = +new Date + "";
    /** Used as the size when optimizations are enabled for large arrays */ var largeArraySize = 75;
    /** Used as the max size of the `arrayPool` and `objectPool` */ var maxPoolSize = 40;
    /** Used to detect and test whitespace */ var whitespace = // whitespace
    " 	\v\f\xa0\uFEFF\n\r\u2028\u2029 ᠎             　";
    /** Used to match empty string literals in compiled template source */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /**
   * Used to match ES6 template delimiters
   * http://people.mozilla.org/~jorendorff/es6-draft.html#sec-literals-string-literals
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match regexp flags from their coerced string values */ var reFlags = /\w*$/;
    /** Used to detected named functions */ var reFuncName = /^\s*function[ \n\r\t]+\w/;
    /** Used to match "interpolate" template delimiters */ var reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match leading whitespace and zeros to be removed */ var reLeadingSpacesAndZeros = RegExp("^[" + whitespace + "]*0+(?=.$)");
    /** Used to ensure capturing order of template delimiters */ var reNoMatch = /($^)/;
    /** Used to detect functions containing a `this` reference */ var reThis = /\bthis\b/;
    /** Used to match unescaped characters in compiled string literals */ var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;
    /** Used to assign default `context` object properties */ var contextProps = [
        "Array",
        "Boolean",
        "Date",
        "Function",
        "Math",
        "Number",
        "Object",
        "RegExp",
        "String",
        "_",
        "attachEvent",
        "clearTimeout",
        "isFinite",
        "isNaN",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify */ var templateCounter = 0;
    /** `Object#toString` result shortcuts */ var argsClass = "[object Arguments]", arrayClass = "[object Array]", boolClass = "[object Boolean]", dateClass = "[object Date]", funcClass = "[object Function]", numberClass = "[object Number]", objectClass = "[object Object]", regexpClass = "[object RegExp]", stringClass = "[object String]";
    /** Used to identify object classifications that `_.clone` supports */ var cloneableClasses = {};
    cloneableClasses[funcClass] = false;
    cloneableClasses[argsClass] = cloneableClasses[arrayClass] = cloneableClasses[boolClass] = cloneableClasses[dateClass] = cloneableClasses[numberClass] = cloneableClasses[objectClass] = cloneableClasses[regexpClass] = cloneableClasses[stringClass] = true;
    /** Used as an internal `_.debounce` options object */ var debounceOptions = {
        "leading": false,
        "maxWait": 0,
        "trailing": false
    };
    /** Used as the property descriptor for `__bindData__` */ var descriptor = {
        "configurable": false,
        "enumerable": false,
        "value": null,
        "writable": false
    };
    /** Used to determine if values are of the language type Object */ var objectTypes = {
        "boolean": false,
        "function": true,
        "object": true,
        "number": false,
        "string": false,
        "undefined": false
    };
    /** Used to escape characters for inclusion in compiled string literals */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "	": "t",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Used as a reference to the global object */ var root = objectTypes[typeof window] && window || this;
    /** Detect free variable `exports` */ var freeExports = objectTypes["object"] && exports && !exports.nodeType && exports;
    /** Detect free variable `module` */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports` */ var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */ var freeGlobal = objectTypes[typeof global] && global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ /**
   * The base implementation of `_.indexOf` without support for binary searches
   * or `fromIndex` constraints.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        var index = (fromIndex || 0) - 1, length = array ? array.length : 0;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * An implementation of `_.contains` for cache objects that mimics the return
   * signature of `_.indexOf` by returning `0` if the value is found, else `-1`.
   *
   * @private
   * @param {Object} cache The cache object to inspect.
   * @param {*} value The value to search for.
   * @returns {number} Returns `0` if `value` is found, else `-1`.
   */ function cacheIndexOf(cache, value) {
        var type = typeof value;
        cache = cache.cache;
        if (type == "boolean" || value == null) return cache[value] ? 0 : -1;
        if (type != "number" && type != "string") type = "object";
        var key = type == "number" ? value : keyPrefix + value;
        cache = (cache = cache[type]) && cache[key];
        return type == "object" ? cache && baseIndexOf(cache, value) > -1 ? 0 : -1 : cache ? 0 : -1;
    }
    /**
   * Adds a given value to the corresponding cache object.
   *
   * @private
   * @param {*} value The value to add to the cache.
   */ function cachePush(value) {
        var cache = this.cache, type = typeof value;
        if (type == "boolean" || value == null) cache[value] = true;
        else {
            if (type != "number" && type != "string") type = "object";
            var key = type == "number" ? value : keyPrefix + value, typeCache = cache[type] || (cache[type] = {});
            if (type == "object") (typeCache[key] || (typeCache[key] = [])).push(value);
            else typeCache[key] = true;
        }
    }
    /**
   * Used by `_.max` and `_.min` as the default callback when a given
   * collection is a string value.
   *
   * @private
   * @param {string} value The character to inspect.
   * @returns {number} Returns the code unit of given character.
   */ function charAtCallback(value) {
        return value.charCodeAt(0);
    }
    /**
   * Used by `sortBy` to compare transformed `collection` elements, stable sorting
   * them in ascending order.
   *
   * @private
   * @param {Object} a The object to compare to `b`.
   * @param {Object} b The object to compare to `a`.
   * @returns {number} Returns the sort order indicator of `1` or `-1`.
   */ function compareAscending(a, b) {
        var ac = a.criteria, bc = b.criteria, index = -1, length = ac.length;
        while(++index < length){
            var value = ac[index], other = bc[index];
            if (value !== other) {
                if (value > other || typeof value == "undefined") return 1;
                if (value < other || typeof other == "undefined") return -1;
            }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to return the same value for
        // `a` and `b`. See https://github.com/jashkenas/underscore/pull/1247
        //
        // This also ensures a stable sort in V8 and other engines.
        // See http://code.google.com/p/v8/issues/detail?id=90
        return a.index - b.index;
    }
    /**
   * Creates a cache object to optimize linear searches of large arrays.
   *
   * @private
   * @param {Array} [array=[]] The array to search.
   * @returns {null|Object} Returns the cache object or `null` if caching should not be used.
   */ function createCache(array) {
        var index = -1, length = array.length, first = array[0], mid = array[length / 2 | 0], last = array[length - 1];
        if (first && typeof first == "object" && mid && typeof mid == "object" && last && typeof last == "object") return false;
        var cache = getObject();
        cache["false"] = cache["null"] = cache["true"] = cache["undefined"] = false;
        var result = getObject();
        result.array = array;
        result.cache = cache;
        result.push = cachePush;
        while(++index < length)result.push(array[index]);
        return result;
    }
    /**
   * Used by `template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(match) {
        return "\\" + stringEscapes[match];
    }
    /**
   * Gets an array from the array pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Array} The array from the pool.
   */ function getArray() {
        return arrayPool.pop() || [];
    }
    /**
   * Gets an object from the object pool or creates a new one if the pool is empty.
   *
   * @private
   * @returns {Object} The object from the pool.
   */ function getObject() {
        return objectPool.pop() || {
            "array": null,
            "cache": null,
            "criteria": null,
            "false": false,
            "index": 0,
            "null": false,
            "number": null,
            "object": null,
            "push": null,
            "string": null,
            "true": false,
            "undefined": false,
            "value": null
        };
    }
    /**
   * Releases the given array back to the array pool.
   *
   * @private
   * @param {Array} [array] The array to release.
   */ function releaseArray(array) {
        array.length = 0;
        if (arrayPool.length < maxPoolSize) arrayPool.push(array);
    }
    /**
   * Releases the given object back to the object pool.
   *
   * @private
   * @param {Object} [object] The object to release.
   */ function releaseObject(object) {
        var cache = object.cache;
        if (cache) releaseObject(cache);
        object.array = object.cache = object.criteria = object.object = object.number = object.string = object.value = null;
        if (objectPool.length < maxPoolSize) objectPool.push(object);
    }
    /**
   * Slices the `collection` from the `start` index up to, but not including,
   * the `end` index.
   *
   * Note: This function is used instead of `Array#slice` to support node lists
   * in IE < 9 and to ensure dense arrays are returned.
   *
   * @private
   * @param {Array|Object|string} collection The collection to slice.
   * @param {number} start The start index.
   * @param {number} end The end index.
   * @returns {Array} Returns the new array.
   */ function slice(array, start, end) {
        start || (start = 0);
        if (typeof end == "undefined") end = array ? array.length : 0;
        var index = -1, length = end - start || 0, result = Array(length < 0 ? 0 : length);
        while(++index < length)result[index] = array[start + index];
        return result;
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new `lodash` function using the given context object.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns the `lodash` function.
   */ function runInContext(context) {
        // Avoid issues with some ES3 environments that attempt to use values, named
        // after built-in constructors like `Object`, for the creation of literals.
        // ES5 clears this up by stating that literals must use built-in constructors.
        // See http://es5.github.io/#x11.1.5.
        context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
        /** Native constructor references */ var Array1 = context.Array, Boolean = context.Boolean, Date1 = context.Date, Function = context.Function, Math = context.Math, Number = context.Number, Object = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /**
     * Used for `Array` method references.
     *
     * Normally `Array.prototype` would suffice, however, using an array literal
     * avoids issues in Narwhal.
     */ var arrayRef = [];
        /** Used for native method references */ var objectProto = Object.prototype;
        /** Used to restore the original `_` reference in `noConflict` */ var oldDash = context._;
        /** Used to resolve the internal [[Class]] of values */ var toString = objectProto.toString;
        /** Used to detect if a method is native */ var reNative = RegExp1("^" + String(toString).replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/toString| for [^\]]+/g, ".*?") + "$");
        /** Native method shortcuts */ var ceil = Math.ceil, clearTimeout = context.clearTimeout, floor = Math.floor, fnToString = Function.prototype.toString, getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf, hasOwnProperty = objectProto.hasOwnProperty, push = arrayRef.push, setTimeout = context.setTimeout, splice = arrayRef.splice, unshift = arrayRef.unshift;
        /** Used to set meta data on functions */ var defineProperty = function() {
            // IE 8 only accepts DOM elements
            try {
                var o = {}, func = isNative(func = Object.defineProperty) && func, result = func(o, o, o) && func;
            } catch (e) {}
            return result;
        }();
        /* Native method shortcuts for methods with the same name as other `lodash` methods */ var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate, nativeIsArray = isNative(nativeIsArray = Array1.isArray) && nativeIsArray, nativeIsFinite = context.isFinite, nativeIsNaN = context.isNaN, nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys, nativeMax = Math.max, nativeMin = Math.min, nativeParseInt = context.parseInt, nativeRandom = Math.random;
        /** Used to lookup a built-in constructor by [[Class]] */ var ctorByClass = {};
        ctorByClass[arrayClass] = Array1;
        ctorByClass[boolClass] = Boolean;
        ctorByClass[dateClass] = Date1;
        ctorByClass[funcClass] = Function;
        ctorByClass[objectClass] = Object;
        ctorByClass[numberClass] = Number;
        ctorByClass[regexpClass] = RegExp1;
        ctorByClass[stringClass] = String;
        /*--------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps the given value to enable intuitive
     * method chaining.
     *
     * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
     * and `unshift`
     *
     * Chaining is supported in custom builds as long as the `value` method is
     * implicitly or explicitly included in the build.
     *
     * The chainable wrapper functions are:
     * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`,
     * `compose`, `concat`, `countBy`, `create`, `createCallback`, `curry`,
     * `debounce`, `defaults`, `defer`, `delay`, `difference`, `filter`, `flatten`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `map`, `max`, `memoize`, `merge`, `min`, `object`, `omit`,
     * `once`, `pairs`, `partial`, `partialRight`, `pick`, `pluck`, `pull`, `push`,
     * `range`, `reject`, `remove`, `rest`, `reverse`, `shuffle`, `slice`, `sort`,
     * `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`, `transform`,
     * `union`, `uniq`, `unshift`, `unzip`, `values`, `where`, `without`, `wrap`,
     * and `zip`
     *
     * The non-chainable wrapper functions are:
     * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `has`, `identity`,
     * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`,
     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`,
     * `lastIndexOf`, `mixin`, `noConflict`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `result`, `shift`, `size`, `some`, `sortedIndex`, `runInContext`,
     * `template`, `unescape`, `uniqueId`, and `value`
     *
     * The wrapper functions `first` and `last` return wrapped values when `n` is
     * provided, otherwise they return unwrapped values.
     *
     * Explicit chaining can be enabled by using the `_.chain` method.
     *
     * @name _
     * @constructor
     * @category Chaining
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns a `lodash` instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(sum, num) {
     *   return sum + num;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(num) {
     *   return num * num;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            // don't wrap if already wrapped, even if wrapped by a different `lodash` constructor
            return value && typeof value == "object" && !isArray(value) && hasOwnProperty.call(value, "__wrapped__") ? value : new lodashWrapper(value);
        }
        /**
     * A fast path for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap in a `lodash` instance.
     * @param {boolean} chainAll A flag to enable chaining for all methods
     * @returns {Object} Returns a `lodash` instance.
     */ function lodashWrapper(value, chainAll) {
            this.__chain__ = !!chainAll;
            this.__wrapped__ = value;
        }
        // ensure `new lodashWrapper` is an instance of `lodash`
        lodashWrapper.prototype = lodash.prototype;
        /**
     * An object used to flag environments features.
     *
     * @static
     * @memberOf _
     * @type Object
     */ var support = lodash.support = {};
        /**
     * Detect if functions can be decompiled by `Function#toString`
     * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
     *
     * @memberOf _.support
     * @type boolean
     */ support.funcDecomp = !isNative(context.WinRTError) && reThis.test(runInContext);
        /**
     * Detect if `Function#name` is supported (all but IE).
     *
     * @memberOf _.support
     * @type boolean
     */ support.funcNames = typeof Function.name == "string";
        /**
     * By default, the template delimiters used by Lo-Dash are similar to those in
     * embedded Ruby (ERB). Change the following template settings to use alternative
     * delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "escape": /<%-([\s\S]+?)%>/g,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "evaluate": /<%([\s\S]+?)%>/g,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */ "_": lodash
            }
        };
        /*--------------------------------------------------------------------------*/ /**
     * The base implementation of `_.bind` that creates the bound function and
     * sets its meta data.
     *
     * @private
     * @param {Array} bindData The bind data array.
     * @returns {Function} Returns the new bound function.
     */ function baseBind(bindData) {
            var func = bindData[0], partialArgs = bindData[2], thisArg = bindData[4];
            function bound() {
                // `Function#bind` spec
                // http://es5.github.io/#x15.3.4.5
                if (partialArgs) {
                    // avoid `arguments` object deoptimizations by using `slice` instead
                    // of `Array.prototype.slice.call` and not assigning `arguments` to a
                    // variable as a ternary expression
                    var args = slice(partialArgs);
                    push.apply(args, arguments);
                }
                // mimic the constructor's `return` behavior
                // http://es5.github.io/#x13.2.2
                if (this instanceof bound) {
                    // ensure `new bound` is an instance of `func`
                    var thisBinding = baseCreate(func.prototype), result = func.apply(thisBinding, args || arguments);
                    return isObject(result) ? result : thisBinding;
                }
                return func.apply(thisArg, args || arguments);
            }
            setBindData(bound, bindData);
            return bound;
        }
        /**
     * The base implementation of `_.clone` without argument juggling or support
     * for `thisArg` binding.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep=false] Specify a deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, isDeep, callback, stackA, stackB) {
            if (callback) {
                var result = callback(value);
                if (typeof result != "undefined") return result;
            }
            // inspect [[Class]]
            var isObj = isObject(value);
            if (isObj) {
                var className = toString.call(value);
                if (!cloneableClasses[className]) return value;
                var ctor = ctorByClass[className];
                switch(className){
                    case boolClass:
                    case dateClass:
                        return new ctor(+value);
                    case numberClass:
                    case stringClass:
                        return new ctor(value);
                    case regexpClass:
                        result = ctor(value.source, reFlags.exec(value));
                        result.lastIndex = value.lastIndex;
                        return result;
                }
            } else return value;
            var isArr = isArray(value);
            if (isDeep) {
                // check for circular references and return corresponding clone
                var initedStack = !stackA;
                stackA || (stackA = getArray());
                stackB || (stackB = getArray());
                var length = stackA.length;
                while(length--){
                    if (stackA[length] == value) return stackB[length];
                }
                result = isArr ? ctor(value.length) : {};
            } else result = isArr ? slice(value) : assign({}, value);
            // add array properties assigned by `RegExp#exec`
            if (isArr) {
                if (hasOwnProperty.call(value, "index")) result.index = value.index;
                if (hasOwnProperty.call(value, "input")) result.input = value.input;
            }
            // exit for shallow clone
            if (!isDeep) return result;
            // add the source value to the stack of traversed objects
            // and associate it with its clone
            stackA.push(value);
            stackB.push(result);
            // recursively populate clone (susceptible to call stack limits)
            (isArr ? forEach : forOwn)(value, function(objValue, key) {
                result[key] = baseClone(objValue, isDeep, callback, stackA, stackB);
            });
            if (initedStack) {
                releaseArray(stackA);
                releaseArray(stackB);
            }
            return result;
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */ function baseCreate(prototype, properties) {
            return isObject(prototype) ? nativeCreate(prototype) : {};
        }
        // fallback for browsers without `Object.create`
        if (!nativeCreate) baseCreate = function() {
            function Object() {}
            return function(prototype) {
                if (isObject(prototype)) {
                    Object.prototype = prototype;
                    var result = new Object;
                    Object.prototype = null;
                }
                return result || context.Object();
            };
        }();
        /**
     * The base implementation of `_.createCallback` without support for creating
     * "_.pluck" or "_.where" style callbacks.
     *
     * @private
     * @param {*} [func=identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of the created callback.
     * @param {number} [argCount] The number of arguments the callback accepts.
     * @returns {Function} Returns a callback function.
     */ function baseCreateCallback(func, thisArg, argCount) {
            if (typeof func != "function") return identity;
            // exit early for no `thisArg` or already bound by `Function#bind`
            if (typeof thisArg == "undefined" || !("prototype" in func)) return func;
            var bindData = func.__bindData__;
            if (typeof bindData == "undefined") {
                if (support.funcNames) bindData = !func.name;
                bindData = bindData || !support.funcDecomp;
                if (!bindData) {
                    var source = fnToString.call(func);
                    if (!support.funcNames) bindData = !reFuncName.test(source);
                    if (!bindData) {
                        // checks if `func` references the `this` keyword and stores the result
                        bindData = reThis.test(source);
                        setBindData(func, bindData);
                    }
                }
            }
            // exit early if there are no `this` references or `func` is bound
            if (bindData === false || bindData !== true && bindData[1] & 1) return func;
            switch(argCount){
                case 1:
                    return function(value) {
                        return func.call(thisArg, value);
                    };
                case 2:
                    return function(a, b) {
                        return func.call(thisArg, a, b);
                    };
                case 3:
                    return function(value, index, collection) {
                        return func.call(thisArg, value, index, collection);
                    };
                case 4:
                    return function(accumulator, value, index, collection) {
                        return func.call(thisArg, accumulator, value, index, collection);
                    };
            }
            return bind(func, thisArg);
        }
        /**
     * The base implementation of `createWrapper` that creates the wrapper and
     * sets its meta data.
     *
     * @private
     * @param {Array} bindData The bind data array.
     * @returns {Function} Returns the new function.
     */ function baseCreateWrapper(bindData) {
            var func = bindData[0], bitmask = bindData[1], partialArgs = bindData[2], partialRightArgs = bindData[3], thisArg = bindData[4], arity = bindData[5];
            var isBind = bitmask & 1, isBindKey = bitmask & 2, isCurry = bitmask & 4, isCurryBound = bitmask & 8, key = func;
            function bound() {
                var thisBinding = isBind ? thisArg : this;
                if (partialArgs) {
                    var args = slice(partialArgs);
                    push.apply(args, arguments);
                }
                if (partialRightArgs || isCurry) {
                    args || (args = slice(arguments));
                    if (partialRightArgs) push.apply(args, partialRightArgs);
                    if (isCurry && args.length < arity) {
                        bitmask |= 16;
                        return baseCreateWrapper([
                            func,
                            isCurryBound ? bitmask : bitmask & -4,
                            args,
                            null,
                            thisArg,
                            arity
                        ]);
                    }
                }
                args || (args = arguments);
                if (isBindKey) func = thisBinding[key];
                if (this instanceof bound) {
                    thisBinding = baseCreate(func.prototype);
                    var result = func.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                }
                return func.apply(thisBinding, args);
            }
            setBindData(bound, bindData);
            return bound;
        }
        /**
     * The base implementation of `_.difference` that accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to process.
     * @param {Array} [values] The array of values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     */ function baseDifference(array, values) {
            var index = -1, indexOf = getIndexOf(), length = array ? array.length : 0, isLarge = length >= largeArraySize && indexOf === baseIndexOf, result = [];
            if (isLarge) {
                var cache = createCache(values);
                if (cache) {
                    indexOf = cacheIndexOf;
                    values = cache;
                } else isLarge = false;
            }
            while(++index < length){
                var value = array[index];
                if (indexOf(values, value) < 0) result.push(value);
            }
            if (isLarge) releaseObject(values);
            return result;
        }
        /**
     * The base implementation of `_.flatten` without support for callback
     * shorthands or `thisArg` binding.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
     * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
     * @param {number} [fromIndex=0] The index to start from.
     * @returns {Array} Returns a new flattened array.
     */ function baseFlatten(array, isShallow, isStrict, fromIndex) {
            var index = (fromIndex || 0) - 1, length = array ? array.length : 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value && typeof value == "object" && typeof value.length == "number" && (isArray(value) || isArguments(value))) {
                    // recursively flatten arrays (susceptible to call stack limits)
                    if (!isShallow) value = baseFlatten(value, isShallow, isStrict);
                    var valIndex = -1, valLength = value.length, resIndex = result.length;
                    result.length += valLength;
                    while(++valIndex < valLength)result[resIndex++] = value[valIndex];
                } else if (!isStrict) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.isEqual`, without support for `thisArg` binding,
     * that allows partial "_.where" style comparisons.
     *
     * @private
     * @param {*} a The value to compare.
     * @param {*} b The other value to compare.
     * @param {Function} [callback] The function to customize comparing values.
     * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `a` objects.
     * @param {Array} [stackB=[]] Tracks traversed `b` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(a, b, callback, isWhere, stackA, stackB) {
            // used to indicate that when comparing objects, `a` has at least the properties of `b`
            if (callback) {
                var result = callback(a, b);
                if (typeof result != "undefined") return !!result;
            }
            // exit early for identical values
            if (a === b) // treat `+0` vs. `-0` as not equal
            return a !== 0 || 1 / a == 1 / b;
            var type = typeof a, otherType = typeof b;
            // exit early for unlike primitive values
            if (a === a && !(a && objectTypes[type]) && !(b && objectTypes[otherType])) return false;
            // exit early for `null` and `undefined` avoiding ES3's Function#call behavior
            // http://es5.github.io/#x15.3.4.4
            if (a == null || b == null) return a === b;
            // compare [[Class]] names
            var className = toString.call(a), otherClass = toString.call(b);
            if (className == argsClass) className = objectClass;
            if (otherClass == argsClass) otherClass = objectClass;
            if (className != otherClass) return false;
            switch(className){
                case boolClass:
                case dateClass:
                    // coerce dates and booleans to numbers, dates to milliseconds and booleans
                    // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
                    return +a == +b;
                case numberClass:
                    // treat `NaN` vs. `NaN` as equal
                    return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;
                case regexpClass:
                case stringClass:
                    // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
                    // treat string primitives and their corresponding object instances as equal
                    return a == String(b);
            }
            var isArr = className == arrayClass;
            if (!isArr) {
                // unwrap any `lodash` wrapped values
                var aWrapped = hasOwnProperty.call(a, "__wrapped__"), bWrapped = hasOwnProperty.call(b, "__wrapped__");
                if (aWrapped || bWrapped) return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, callback, isWhere, stackA, stackB);
                // exit for functions and DOM nodes
                if (className != objectClass) return false;
                // in older versions of Opera, `arguments` objects have `Array` constructors
                var ctorA = a.constructor, ctorB = b.constructor;
                // non `Object` object instances with different constructors are not equal
                if (ctorA != ctorB && !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) && "constructor" in a && "constructor" in b) return false;
            }
            // assume cyclic structures are equal
            // the algorithm for detecting cyclic structures is adapted from ES 5.1
            // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
            var initedStack = !stackA;
            stackA || (stackA = getArray());
            stackB || (stackB = getArray());
            var length = stackA.length;
            while(length--){
                if (stackA[length] == a) return stackB[length] == b;
            }
            var size = 0;
            result = true;
            // add `a` and `b` to the stack of traversed objects
            stackA.push(a);
            stackB.push(b);
            // recursively compare objects and arrays (susceptible to call stack limits)
            if (isArr) {
                // compare lengths to determine if a deep comparison is necessary
                length = a.length;
                size = b.length;
                result = size == length;
                if (result || isWhere) // deep compare the contents, ignoring non-numeric properties
                while(size--){
                    var index = length, value = b[size];
                    if (isWhere) while(index--){
                        if (result = baseIsEqual(a[index], value, callback, isWhere, stackA, stackB)) break;
                    }
                    else if (!(result = baseIsEqual(a[size], value, callback, isWhere, stackA, stackB))) break;
                }
            } else {
                // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
                // which, in this case, is more costly
                forIn(b, function(value, key, b) {
                    if (hasOwnProperty.call(b, key)) {
                        // count the number of properties.
                        size++;
                        // deep compare each property value.
                        return result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, callback, isWhere, stackA, stackB);
                    }
                });
                if (result && !isWhere) // ensure both objects have the same number of properties
                forIn(a, function(value, key, a) {
                    if (hasOwnProperty.call(a, key)) // `size` will be `-1` if `a` has more properties than `b`
                    return result = --size > -1;
                });
            }
            stackA.pop();
            stackB.pop();
            if (initedStack) {
                releaseArray(stackA);
                releaseArray(stackB);
            }
            return result;
        }
        /**
     * The base implementation of `_.merge` without argument juggling or support
     * for `thisArg` binding.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [callback] The function to customize merging properties.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     */ function baseMerge(object, source, callback, stackA, stackB) {
            (isArray(source) ? forEach : forOwn)(source, function(source, key) {
                var found, isArr, result = source, value = object[key];
                if (source && ((isArr = isArray(source)) || isPlainObject(source))) {
                    // avoid merging previously merged cyclic sources
                    var stackLength = stackA.length;
                    while(stackLength--)if (found = stackA[stackLength] == source) {
                        value = stackB[stackLength];
                        break;
                    }
                    if (!found) {
                        var isShallow;
                        if (callback) {
                            result = callback(value, source);
                            if (isShallow = typeof result != "undefined") value = result;
                        }
                        if (!isShallow) value = isArr ? isArray(value) ? value : [] : isPlainObject(value) ? value : {};
                        // add `source` and associated `value` to the stack of traversed objects
                        stackA.push(source);
                        stackB.push(value);
                        // recursively merge objects and arrays (susceptible to call stack limits)
                        if (!isShallow) baseMerge(value, source, callback, stackA, stackB);
                    }
                } else {
                    if (callback) {
                        result = callback(value, source);
                        if (typeof result == "undefined") result = source;
                    }
                    if (typeof result != "undefined") value = result;
                }
                object[key] = value;
            });
        }
        /**
     * The base implementation of `_.random` without argument juggling or support
     * for returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns a random number.
     */ function baseRandom(min, max) {
            return min + floor(nativeRandom() * (max - min + 1));
        }
        /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * or `thisArg` binding.
     *
     * @private
     * @param {Array} array The array to process.
     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
     * @param {Function} [callback] The function called per iteration.
     * @returns {Array} Returns a duplicate-value-free array.
     */ function baseUniq(array, isSorted, callback) {
            var index = -1, indexOf = getIndexOf(), length = array ? array.length : 0, result = [];
            var isLarge = !isSorted && length >= largeArraySize && indexOf === baseIndexOf, seen = callback || isLarge ? getArray() : result;
            if (isLarge) {
                var cache = createCache(seen);
                indexOf = cacheIndexOf;
                seen = cache;
            }
            while(++index < length){
                var value = array[index], computed = callback ? callback(value, index, array) : value;
                if (isSorted ? !index || seen[seen.length - 1] !== computed : indexOf(seen, computed) < 0) {
                    if (callback || isLarge) seen.push(computed);
                    result.push(value);
                }
            }
            if (isLarge) {
                releaseArray(seen.array);
                releaseObject(seen);
            } else if (callback) releaseArray(seen);
            return result;
        }
        /**
     * Creates a function that aggregates a collection, creating an object composed
     * of keys generated from the results of running each element of the collection
     * through a callback. The given `setter` function sets the keys and values
     * of the composed object.
     *
     * @private
     * @param {Function} setter The setter function.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter) {
            return function(collection, callback, thisArg) {
                var result = {};
                callback = lodash.createCallback(callback, thisArg, 3);
                var index = -1, length = collection ? collection.length : 0;
                if (typeof length == "number") while(++index < length){
                    var value = collection[index];
                    setter(result, value, callback(value, index, collection), collection);
                }
                else forOwn(collection, function(value, key, collection) {
                    setter(result, value, callback(value, key, collection), collection);
                });
                return result;
            };
        }
        /**
     * Creates a function that, when called, either curries or invokes `func`
     * with an optional `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of method flags to compose.
     *  The bitmask may be composed of the following flags:
     *  1 - `_.bind`
     *  2 - `_.bindKey`
     *  4 - `_.curry`
     *  8 - `_.curry` (bound)
     *  16 - `_.partial`
     *  32 - `_.partialRight`
     * @param {Array} [partialArgs] An array of arguments to prepend to those
     *  provided to the new function.
     * @param {Array} [partialRightArgs] An array of arguments to append to those
     *  provided to the new function.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new function.
     */ function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
            var isBind = bitmask & 1, isBindKey = bitmask & 2, isCurry = bitmask & 4, isCurryBound = bitmask & 8, isPartial = bitmask & 16, isPartialRight = bitmask & 32;
            if (!isBindKey && !isFunction(func)) throw new TypeError;
            if (isPartial && !partialArgs.length) {
                bitmask &= -17;
                isPartial = partialArgs = false;
            }
            if (isPartialRight && !partialRightArgs.length) {
                bitmask &= -33;
                isPartialRight = partialRightArgs = false;
            }
            var bindData = func && func.__bindData__;
            if (bindData && bindData !== true) {
                // clone `bindData`
                bindData = slice(bindData);
                if (bindData[2]) bindData[2] = slice(bindData[2]);
                if (bindData[3]) bindData[3] = slice(bindData[3]);
                // set `thisBinding` is not previously bound
                if (isBind && !(bindData[1] & 1)) bindData[4] = thisArg;
                // set if previously bound but not currently (subsequent curried functions)
                if (!isBind && bindData[1] & 1) bitmask |= 8;
                // set curried arity if not yet set
                if (isCurry && !(bindData[1] & 4)) bindData[5] = arity;
                // append partial left arguments
                if (isPartial) push.apply(bindData[2] || (bindData[2] = []), partialArgs);
                // append partial right arguments
                if (isPartialRight) unshift.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
                // merge flags
                bindData[1] |= bitmask;
                return createWrapper.apply(null, bindData);
            }
            // fast path for `_.bind`
            var creater = bitmask == 1 || bitmask === 17 ? baseBind : baseCreateWrapper;
            return creater([
                func,
                bitmask,
                partialArgs,
                partialRightArgs,
                thisArg,
                arity
            ]);
        }
        /**
     * Used by `escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} match The matched character to escape.
     * @returns {string} Returns the escaped character.
     */ function escapeHtmlChar(match) {
            return htmlEscapes[match];
        }
        /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized, this method returns the custom method, otherwise it returns
     * the `baseIndexOf` function.
     *
     * @private
     * @returns {Function} Returns the "indexOf" function.
     */ function getIndexOf() {
            var result = (result = lodash.indexOf) === indexOf ? baseIndexOf : result;
            return result;
        }
        /**
     * Checks if `value` is a native function.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
     */ function isNative(value) {
            return typeof value == "function" && reNative.test(value);
        }
        /**
     * Sets `this` binding data on a given function.
     *
     * @private
     * @param {Function} func The function to set data on.
     * @param {Array} value The data array to set.
     */ var setBindData = !defineProperty ? noop : function(func, value) {
            descriptor.value = value;
            defineProperty(func, "__bindData__", descriptor);
            descriptor.value = null;
        };
        /**
     * A fallback implementation of `isPlainObject` which checks if a given value
     * is an object created by the `Object` constructor, assuming objects created
     * by the `Object` constructor have no inherited enumerable properties and that
     * there are no `Object.prototype` extensions.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     */ function shimIsPlainObject(value) {
            var ctor, result;
            // avoid non Object objects, `arguments` objects, and DOM elements
            if (!(value && toString.call(value) == objectClass) || (ctor = value.constructor, isFunction(ctor) && !(ctor instanceof ctor))) return false;
            // In most environments an object's own properties are iterated before
            // its inherited properties. If the last iterated property is an object's
            // own property then there are no inherited enumerable properties.
            forIn(value, function(value, key) {
                result = key;
            });
            return typeof result == "undefined" || hasOwnProperty.call(value, result);
        }
        /**
     * Used by `unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} match The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */ function unescapeHtmlChar(match) {
            return htmlUnescapes[match];
        }
        /*--------------------------------------------------------------------------*/ /**
     * Checks if `value` is an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
     * @example
     *
     * (function() { return _.isArguments(arguments); })(1, 2, 3);
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ function isArguments(value) {
            return value && typeof value == "object" && typeof value.length == "number" && toString.call(value) == argsClass || false;
        }
        /**
     * Checks if `value` is an array.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
     * @example
     *
     * (function() { return _.isArray(arguments); })();
     * // => false
     *
     * _.isArray([1, 2, 3]);
     * // => true
     */ var isArray = nativeIsArray || function(value) {
            return value && typeof value == "object" && typeof value.length == "number" && toString.call(value) == arrayClass || false;
        };
        /**
     * A fallback implementation of `Object.keys` which produces an array of the
     * given object's own enumerable property names.
     *
     * @private
     * @type Function
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names.
     */ var shimKeys = function(object) {
            var index, iterable = object, result = [];
            if (!iterable) return result;
            if (!objectTypes[typeof object]) return result;
            for(index in iterable)if (hasOwnProperty.call(iterable, index)) result.push(index);
            return result;
        };
        /**
     * Creates an array composed of the own enumerable property names of an object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names.
     * @example
     *
     * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
     * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
     */ var keys = !nativeKeys ? shimKeys : function(object) {
            if (!isObject(object)) return [];
            return nativeKeys(object);
        };
        /**
     * Used to convert characters to HTML entities:
     *
     * Though the `>` character is escaped for symmetry, characters like `>` and `/`
     * don't require escaping in HTML and have no special meaning unless they're part
     * of a tag or an unquoted attribute value.
     * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
     */ var htmlEscapes = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        /** Used to convert HTML entities to characters */ var htmlUnescapes = invert(htmlEscapes);
        /** Used to match HTML entities and HTML characters */ var reEscapedHtml = RegExp1("(" + keys(htmlUnescapes).join("|") + ")", "g"), reUnescapedHtml = RegExp1("[" + keys(htmlEscapes).join("") + "]", "g");
        /*--------------------------------------------------------------------------*/ /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources will overwrite property assignments of previous
     * sources. If a callback is provided it will be executed to produce the
     * assigned values. The callback is bound to `thisArg` and invoked with two
     * arguments; (objectValue, sourceValue).
     *
     * @static
     * @memberOf _
     * @type Function
     * @alias extend
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param {Function} [callback] The function to customize assigning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
     * // => { 'name': 'fred', 'employer': 'slate' }
     *
     * var defaults = _.partialRight(_.assign, function(a, b) {
     *   return typeof a == 'undefined' ? b : a;
     * });
     *
     * var object = { 'name': 'barney' };
     * defaults(object, { 'name': 'fred', 'employer': 'slate' });
     * // => { 'name': 'barney', 'employer': 'slate' }
     */ var assign = function(object, source, guard) {
            var index, iterable = object, result = iterable;
            if (!iterable) return result;
            var args = arguments, argsIndex = 0, argsLength = typeof guard == "number" ? 2 : args.length;
            if (argsLength > 3 && typeof args[argsLength - 2] == "function") var callback = baseCreateCallback(args[--argsLength - 1], args[argsLength--], 2);
            else if (argsLength > 2 && typeof args[argsLength - 1] == "function") callback = args[--argsLength];
            while(++argsIndex < argsLength){
                iterable = args[argsIndex];
                if (iterable && objectTypes[typeof iterable]) {
                    var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
                    while(++ownIndex < length){
                        index = ownProps[ownIndex];
                        result[index] = callback ? callback(result[index], iterable[index]) : iterable[index];
                    }
                }
            }
            return result;
        };
        /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
     * be cloned, otherwise they will be assigned by reference. If a callback
     * is provided it will be executed to produce the cloned values. If the
     * callback returns `undefined` cloning will be handled by the method instead.
     * The callback is bound to `thisArg` and invoked with one argument; (value).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep=false] Specify a deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * var shallow = _.clone(characters);
     * shallow[0] === characters[0];
     * // => true
     *
     * var deep = _.clone(characters, true);
     * deep[0] === characters[0];
     * // => false
     *
     * _.mixin({
     *   'clone': _.partialRight(_.clone, function(value) {
     *     return _.isElement(value) ? value.cloneNode(false) : undefined;
     *   })
     * });
     *
     * var clone = _.clone(document.body);
     * clone.childNodes.length;
     * // => 0
     */ function clone(value, isDeep, callback, thisArg) {
            // allows working with "Collections" methods without using their `index`
            // and `collection` arguments for `isDeep` and `callback`
            if (typeof isDeep != "boolean" && isDeep != null) {
                thisArg = callback;
                callback = isDeep;
                isDeep = false;
            }
            return baseClone(value, isDeep, typeof callback == "function" && baseCreateCallback(callback, thisArg, 1));
        }
        /**
     * Creates a deep clone of `value`. If a callback is provided it will be
     * executed to produce the cloned values. If the callback returns `undefined`
     * cloning will be handled by the method instead. The callback is bound to
     * `thisArg` and invoked with one argument; (value).
     *
     * Note: This method is loosely based on the structured clone algorithm. Functions
     * and DOM nodes are **not** cloned. The enumerable properties of `arguments` objects and
     * objects created by constructors other than `Object` are cloned to plain `Object` objects.
     * See http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to deep clone.
     * @param {Function} [callback] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * var deep = _.cloneDeep(characters);
     * deep[0] === characters[0];
     * // => false
     *
     * var view = {
     *   'label': 'docs',
     *   'node': element
     * };
     *
     * var clone = _.cloneDeep(view, function(value) {
     *   return _.isElement(value) ? value.cloneNode(true) : undefined;
     * });
     *
     * clone.node == view.node;
     * // => false
     */ function cloneDeep(value, callback, thisArg) {
            return baseClone(value, true, typeof callback == "function" && baseCreateCallback(callback, thisArg, 1));
        }
        /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, { 'constructor': Circle });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties ? assign(result, properties) : result;
        }
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional defaults of the same property will be ignored.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param- {Object} [guard] Allows working with `_.reduce` without using its
     *  `key` and `object` arguments as sources.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * var object = { 'name': 'barney' };
     * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
     * // => { 'name': 'barney', 'employer': 'slate' }
     */ var defaults = function(object, source, guard) {
            var index, iterable = object, result = iterable;
            if (!iterable) return result;
            var args = arguments, argsIndex = 0, argsLength = typeof guard == "number" ? 2 : args.length;
            while(++argsIndex < argsLength){
                iterable = args[argsIndex];
                if (iterable && objectTypes[typeof iterable]) {
                    var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
                    while(++ownIndex < length){
                        index = ownProps[ownIndex];
                        if (typeof result[index] == "undefined") result[index] = iterable[index];
                    }
                }
            }
            return result;
        };
        /**
     * This method is like `_.findIndex` except that it returns the key of the
     * first element that passes the callback check, instead of the element itself.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [callback=identity] The function called per
     *  iteration. If a property name or object is provided it will be used to
     *  create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
     * @example
     *
     * var characters = {
     *   'barney': {  'age': 36, 'blocked': false },
     *   'fred': {    'age': 40, 'blocked': true },
     *   'pebbles': { 'age': 1,  'blocked': false }
     * };
     *
     * _.findKey(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (property order is not guaranteed across environments)
     *
     * // using "_.where" callback shorthand
     * _.findKey(characters, { 'age': 1 });
     * // => 'pebbles'
     *
     * // using "_.pluck" callback shorthand
     * _.findKey(characters, 'blocked');
     * // => 'fred'
     */ function findKey(object, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwn(object, function(value, key, object) {
                if (callback(value, key, object)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [callback=identity] The function called per
     *  iteration. If a property name or object is provided it will be used to
     *  create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {string|undefined} Returns the key of the found element, else `undefined`.
     * @example
     *
     * var characters = {
     *   'barney': {  'age': 36, 'blocked': true },
     *   'fred': {    'age': 40, 'blocked': false },
     *   'pebbles': { 'age': 1,  'blocked': true }
     * };
     *
     * _.findLastKey(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles`, assuming `_.findKey` returns `barney`
     *
     * // using "_.where" callback shorthand
     * _.findLastKey(characters, { 'age': 40 });
     * // => 'fred'
     *
     * // using "_.pluck" callback shorthand
     * _.findLastKey(characters, 'blocked');
     * // => 'pebbles'
     */ function findLastKey(object, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwnRight(object, function(value, key, object) {
                if (callback(value, key, object)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        /**
     * Iterates over own and inherited enumerable properties of an object,
     * executing the callback for each property. The callback is bound to `thisArg`
     * and invoked with three arguments; (value, key, object). Callbacks may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * Shape.prototype.move = function(x, y) {
     *   this.x += x;
     *   this.y += y;
     * };
     *
     * _.forIn(new Shape, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
     */ var forIn = function(collection, callback, thisArg) {
            var index, iterable = collection, result = iterable;
            if (!iterable) return result;
            if (!objectTypes[typeof iterable]) return result;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            for(index in iterable){
                if (callback(iterable[index], index, collection) === false) return result;
            }
            return result;
        };
        /**
     * This method is like `_.forIn` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * Shape.prototype.move = function(x, y) {
     *   this.x += x;
     *   this.y += y;
     * };
     *
     * _.forInRight(new Shape, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'move', 'y', and 'x' assuming `_.forIn ` logs 'x', 'y', and 'move'
     */ function forInRight(object, callback, thisArg) {
            var pairs = [];
            forIn(object, function(value, key) {
                pairs.push(key, value);
            });
            var length = pairs.length;
            callback = baseCreateCallback(callback, thisArg, 3);
            while(length--){
                if (callback(pairs[length--], pairs[length], object) === false) break;
            }
            return object;
        }
        /**
     * Iterates over own enumerable properties of an object, executing the callback
     * for each property. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, key, object). Callbacks may exit iteration early by
     * explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
     *   console.log(key);
     * });
     * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
     */ var forOwn = function(collection, callback, thisArg) {
            var index, iterable = collection, result = iterable;
            if (!iterable) return result;
            if (!objectTypes[typeof iterable]) return result;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            var ownIndex = -1, ownProps = objectTypes[typeof iterable] && keys(iterable), length = ownProps ? ownProps.length : 0;
            while(++ownIndex < length){
                index = ownProps[ownIndex];
                if (callback(iterable[index], index, collection) === false) return result;
            }
            return result;
        };
        /**
     * This method is like `_.forOwn` except that it iterates over elements
     * of a `collection` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.forOwnRight({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
     *   console.log(key);
     * });
     * // => logs 'length', '1', and '0' assuming `_.forOwn` logs '0', '1', and 'length'
     */ function forOwnRight(object, callback, thisArg) {
            var props = keys(object), length = props.length;
            callback = baseCreateCallback(callback, thisArg, 3);
            while(length--){
                var key = props[length];
                if (callback(object[key], key, object) === false) break;
            }
            return object;
        }
        /**
     * Creates a sorted array of property names of all enumerable properties,
     * own and inherited, of `object` that have function values.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property names that have function values.
     * @example
     *
     * _.functions(_);
     * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
     */ function functions(object) {
            var result = [];
            forIn(object, function(value, key) {
                if (isFunction(value)) result.push(key);
            });
            return result.sort();
        }
        /**
     * Checks if the specified property name exists as a direct property of `object`,
     * instead of an inherited property.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @param {string} key The name of the property to check.
     * @returns {boolean} Returns `true` if key is a direct property, else `false`.
     * @example
     *
     * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
     * // => true
     */ function has(object, key) {
            return object ? hasOwnProperty.call(object, key) : false;
        }
        /**
     * Creates an object composed of the inverted keys and values of the given object.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the created inverted object.
     * @example
     *
     * _.invert({ 'first': 'fred', 'second': 'barney' });
     * // => { 'fred': 'first', 'barney': 'second' }
     */ function invert(object) {
            var index = -1, props = keys(object), length = props.length, result = {};
            while(++index < length){
                var key = props[index];
                result[object[key]] = key;
            }
            return result;
        }
        /**
     * Checks if `value` is a boolean value.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a boolean value, else `false`.
     * @example
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || value && typeof value == "object" && toString.call(value) == boolClass || false;
        }
        /**
     * Checks if `value` is a date.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a date, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     */ function isDate(value) {
            return value && typeof value == "object" && toString.call(value) == dateClass || false;
        }
        /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     */ function isElement(value) {
            return value && value.nodeType === 1 || false;
        }
        /**
     * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
     * length of `0` and objects with no own enumerable properties are considered
     * "empty".
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({});
     * // => true
     *
     * _.isEmpty('');
     * // => true
     */ function isEmpty(value) {
            var result = true;
            if (!value) return result;
            var className = toString.call(value), length = value.length;
            if (className == arrayClass || className == stringClass || className == argsClass || className == objectClass && typeof length == "number" && isFunction(value.splice)) return !length;
            forOwn(value, function() {
                return result = false;
            });
            return result;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent to each other. If a callback is provided it will be executed
     * to compare values. If the callback returns `undefined` comparisons will
     * be handled by the method instead. The callback is bound to `thisArg` and
     * invoked with two arguments; (a, b).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} a The value to compare.
     * @param {*} b The other value to compare.
     * @param {Function} [callback] The function to customize comparing values.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'name': 'fred' };
     * var copy = { 'name': 'fred' };
     *
     * object == copy;
     * // => false
     *
     * _.isEqual(object, copy);
     * // => true
     *
     * var words = ['hello', 'goodbye'];
     * var otherWords = ['hi', 'goodbye'];
     *
     * _.isEqual(words, otherWords, function(a, b) {
     *   var reGreet = /^(?:hello|hi)$/i,
     *       aGreet = _.isString(a) && reGreet.test(a),
     *       bGreet = _.isString(b) && reGreet.test(b);
     *
     *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
     * });
     * // => true
     */ function isEqual(a, b, callback, thisArg) {
            return baseIsEqual(a, b, typeof callback == "function" && baseCreateCallback(callback, thisArg, 2));
        }
        /**
     * Checks if `value` is, or can be coerced to, a finite number.
     *
     * Note: This is not the same as native `isFinite` which will return true for
     * booleans and empty strings. See http://es5.github.io/#x15.1.2.5.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is finite, else `false`.
     * @example
     *
     * _.isFinite(-101);
     * // => true
     *
     * _.isFinite('10');
     * // => true
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite('');
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */ function isFinite(value) {
            return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
        }
        /**
     * Checks if `value` is a function.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     */ function isFunction(value) {
            return typeof value == "function";
        }
        /**
     * Checks if `value` is the language type of Object.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */ function isObject(value) {
            // check if the value is the ECMAScript language type of Object
            // http://es5.github.io/#x8
            // and avoid a V8 bug
            // http://code.google.com/p/v8/issues/detail?id=2291
            return !!(value && objectTypes[typeof value]);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * Note: This is not the same as native `isNaN` which will return `true` for
     * `undefined` and other non-numeric values. See http://es5.github.io/#x15.1.2.4.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // `NaN` as a primitive is the only value that is not equal to itself
            // (perform the [[Class]] check first to avoid errors with some host objects in IE)
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(undefined);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is a number.
     *
     * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(8.4 * 5);
     * // => true
     */ function isNumber(value) {
            return typeof value == "number" || value && typeof value == "object" && toString.call(value) == numberClass || false;
        }
        /**
     * Checks if `value` is an object created by the `Object` constructor.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * _.isPlainObject(new Shape);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     */ var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
            if (!(value && toString.call(value) == objectClass)) return false;
            var valueOf = value.valueOf, objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
            return objProto ? value == objProto || getPrototypeOf(value) == objProto : shimIsPlainObject(value);
        };
        /**
     * Checks if `value` is a regular expression.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a regular expression, else `false`.
     * @example
     *
     * _.isRegExp(/fred/);
     * // => true
     */ function isRegExp(value) {
            return value && typeof value == "object" && toString.call(value) == regexpClass || false;
        }
        /**
     * Checks if `value` is a string.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
     * @example
     *
     * _.isString('fred');
     * // => true
     */ function isString(value) {
            return typeof value == "string" || value && typeof value == "object" && toString.call(value) == stringClass || false;
        }
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     */ function isUndefined(value) {
            return typeof value == "undefined";
        }
        /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through the callback.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new object with values of the results of each `callback` execution.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2, 'c': 3} , function(num) { return num * 3; });
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     *
     * var characters = {
     *   'fred': { 'name': 'fred', 'age': 40 },
     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
     * };
     *
     * // using "_.pluck" callback shorthand
     * _.mapValues(characters, 'age');
     * // => { 'fred': 40, 'pebbles': 1 }
     */ function mapValues(object, callback, thisArg) {
            var result = {};
            callback = lodash.createCallback(callback, thisArg, 3);
            forOwn(object, function(value, key, object) {
                result[key] = callback(value, key, object);
            });
            return result;
        }
        /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * will overwrite property assignments of previous sources. If a callback is
     * provided it will be executed to produce the merged values of the destination
     * and source properties. If the callback returns `undefined` merging will
     * be handled by the method instead. The callback is bound to `thisArg` and
     * invoked with two arguments; (objectValue, sourceValue).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The destination object.
     * @param {...Object} [source] The source objects.
     * @param {Function} [callback] The function to customize merging properties.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the destination object.
     * @example
     *
     * var names = {
     *   'characters': [
     *     { 'name': 'barney' },
     *     { 'name': 'fred' }
     *   ]
     * };
     *
     * var ages = {
     *   'characters': [
     *     { 'age': 36 },
     *     { 'age': 40 }
     *   ]
     * };
     *
     * _.merge(names, ages);
     * // => { 'characters': [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred', 'age': 40 }] }
     *
     * var food = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var otherFood = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(food, otherFood, function(a, b) {
     *   return _.isArray(a) ? a.concat(b) : undefined;
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot] }
     */ function merge(object) {
            var args = arguments, length = 2;
            if (!isObject(object)) return object;
            // allows working with `_.reduce` and `_.reduceRight` without using
            // their `index` and `collection` arguments
            if (typeof args[2] != "number") length = args.length;
            if (length > 3 && typeof args[length - 2] == "function") var callback = baseCreateCallback(args[--length - 1], args[length--], 2);
            else if (length > 2 && typeof args[length - 1] == "function") callback = args[--length];
            var sources = slice(arguments, 1, length), index = -1, stackA = getArray(), stackB = getArray();
            while(++index < length)baseMerge(object, sources[index], callback, stackA, stackB);
            releaseArray(stackA);
            releaseArray(stackB);
            return object;
        }
        /**
     * Creates a shallow clone of `object` excluding the specified properties.
     * Property names may be specified as individual arguments or as arrays of
     * property names. If a callback is provided it will be executed for each
     * property of `object` omitting the properties the callback returns truey
     * for. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The source object.
     * @param {Function|...string|string[]} [callback] The properties to omit or the
     *  function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns an object without the omitted properties.
     * @example
     *
     * _.omit({ 'name': 'fred', 'age': 40 }, 'age');
     * // => { 'name': 'fred' }
     *
     * _.omit({ 'name': 'fred', 'age': 40 }, function(value) {
     *   return typeof value == 'number';
     * });
     * // => { 'name': 'fred' }
     */ function omit(object, callback, thisArg) {
            var result = {};
            if (typeof callback != "function") {
                var props = [];
                forIn(object, function(value, key) {
                    props.push(key);
                });
                props = baseDifference(props, baseFlatten(arguments, true, false, 1));
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    result[key] = object[key];
                }
            } else {
                callback = lodash.createCallback(callback, thisArg, 3);
                forIn(object, function(value, key, object) {
                    if (!callback(value, key, object)) result[key] = value;
                });
            }
            return result;
        }
        /**
     * Creates a two dimensional array of an object's key-value pairs,
     * i.e. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (property order is not guaranteed across environments)
     */ function pairs(object) {
            var index = -1, props = keys(object), length = props.length, result = Array1(length);
            while(++index < length){
                var key = props[index];
                result[index] = [
                    key,
                    object[key]
                ];
            }
            return result;
        }
        /**
     * Creates a shallow clone of `object` composed of the specified properties.
     * Property names may be specified as individual arguments or as arrays of
     * property names. If a callback is provided it will be executed for each
     * property of `object` picking the properties the callback returns truey
     * for. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The source object.
     * @param {Function|...string|string[]} [callback] The function called per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns an object composed of the picked properties.
     * @example
     *
     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
     * // => { 'name': 'fred' }
     *
     * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
     *   return key.charAt(0) != '_';
     * });
     * // => { 'name': 'fred' }
     */ function pick(object, callback, thisArg) {
            var result = {};
            if (typeof callback != "function") {
                var index = -1, props = baseFlatten(arguments, true, false, 1), length = isObject(object) ? props.length : 0;
                while(++index < length){
                    var key = props[index];
                    if (key in object) result[key] = object[key];
                }
            } else {
                callback = lodash.createCallback(callback, thisArg, 3);
                forIn(object, function(value, key, object) {
                    if (callback(value, key, object)) result[key] = value;
                });
            }
            return result;
        }
        /**
     * An alternative to `_.reduce` this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable properties through a callback, with each callback execution
     * potentially mutating the `accumulator` object. The callback is bound to
     * `thisArg` and invoked with four arguments; (accumulator, value, key, object).
     * Callbacks may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var squares = _.transform([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], function(result, num) {
     *   num *= num;
     *   if (num % 2) {
     *     return result.push(num) < 3;
     *   }
     * });
     * // => [1, 9, 25]
     *
     * var mapped = _.transform({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
     *   result[key] = num * 3;
     * });
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     */ function transform(object, callback, accumulator, thisArg) {
            var isArr = isArray(object);
            if (accumulator == null) {
                if (isArr) accumulator = [];
                else {
                    var ctor = object && object.constructor, proto = ctor && ctor.prototype;
                    accumulator = baseCreate(proto);
                }
            }
            if (callback) {
                callback = lodash.createCallback(callback, thisArg, 4);
                (isArr ? forEach : forOwn)(object, function(value, index, object) {
                    return callback(accumulator, value, index, object);
                });
            }
            return accumulator;
        }
        /**
     * Creates an array composed of the own enumerable property values of `object`.
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns an array of property values.
     * @example
     *
     * _.values({ 'one': 1, 'two': 2, 'three': 3 });
     * // => [1, 2, 3] (property order is not guaranteed across environments)
     */ function values(object) {
            var index = -1, props = keys(object), length = props.length, result = Array1(length);
            while(++index < length)result[index] = object[props[index]];
            return result;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates an array of elements from the specified indexes, or keys, of the
     * `collection`. Indexes may be specified as individual arguments or as arrays
     * of indexes.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [index] The indexes of `collection`
     *   to retrieve, specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns a new array of elements corresponding to the
     *  provided indexes.
     * @example
     *
     * _.at(['a', 'b', 'c', 'd', 'e'], [0, 2, 4]);
     * // => ['a', 'c', 'e']
     *
     * _.at(['fred', 'barney', 'pebbles'], 0, 2);
     * // => ['fred', 'pebbles']
     */ function at(collection) {
            var args = arguments, index = -1, props = baseFlatten(args, true, false, 1), length = args[2] && args[2][args[1]] === collection ? 1 : props.length, result = Array1(length);
            while(++index < length)result[index] = collection[props[index]];
            return result;
        }
        /**
     * Checks if a given value is present in a collection using strict equality
     * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
     * offset from the end of the collection.
     *
     * @static
     * @memberOf _
     * @alias include
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {*} target The value to check for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
     * @example
     *
     * _.contains([1, 2, 3], 1);
     * // => true
     *
     * _.contains([1, 2, 3], 1, 2);
     * // => false
     *
     * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.contains('pebbles', 'eb');
     * // => true
     */ function contains(collection, target, fromIndex) {
            var index = -1, indexOf = getIndexOf(), length = collection ? collection.length : 0, result = false;
            fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
            if (isArray(collection)) result = indexOf(collection, target, fromIndex) > -1;
            else if (typeof length == "number") result = (isString(collection) ? collection.indexOf(target, fromIndex) : indexOf(collection, target, fromIndex)) > -1;
            else forOwn(collection, function(value) {
                if (++index >= fromIndex) return !(result = value === target);
            });
            return result;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through the callback. The corresponding value
     * of each key is the number of times the key was returned by the callback.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1;
        });
        /**
     * Checks if the given callback returns truey value for **all** elements of
     * a collection. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if all elements passed the callback check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes']);
     * // => false
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.every(characters, 'age');
     * // => true
     *
     * // using "_.where" callback shorthand
     * _.every(characters, { 'age': 36 });
     * // => false
     */ function every(collection, callback, thisArg) {
            var result = true;
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                if (!(result = !!callback(collection[index], index, collection))) break;
            }
            else forOwn(collection, function(value, index, collection) {
                return result = !!callback(value, index, collection);
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, returning an array of all elements
     * the callback returns truey for. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of elements that passed the callback check.
     * @example
     *
     * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
     * // => [2, 4, 6]
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.filter(characters, 'blocked');
     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
     *
     * // using "_.where" callback shorthand
     * _.filter(characters, { 'age': 36 });
     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
     */ function filter(collection, callback, thisArg) {
            var result = [];
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                var value = collection[index];
                if (callback(value, index, collection)) result.push(value);
            }
            else forOwn(collection, function(value, index, collection) {
                if (callback(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, returning the first element that
     * the callback returns truey for. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect, findWhere
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the found element, else `undefined`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': false },
     *   { 'name': 'fred',    'age': 40, 'blocked': true },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
     * ];
     *
     * _.find(characters, function(chr) {
     *   return chr.age < 40;
     * });
     * // => { 'name': 'barney', 'age': 36, 'blocked': false }
     *
     * // using "_.where" callback shorthand
     * _.find(characters, { 'age': 1 });
     * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
     *
     * // using "_.pluck" callback shorthand
     * _.find(characters, 'blocked');
     * // => { 'name': 'fred', 'age': 40, 'blocked': true }
     */ function find(collection, callback, thisArg) {
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                var value = collection[index];
                if (callback(value, index, collection)) return value;
            }
            else {
                var result;
                forOwn(collection, function(value, index, collection) {
                    if (callback(value, index, collection)) {
                        result = value;
                        return false;
                    }
                });
                return result;
            }
        }
        /**
     * This method is like `_.find` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the found element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(num) {
     *   return num % 2 == 1;
     * });
     * // => 3
     */ function findLast(collection, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            forEachRight(collection, function(value, index, collection) {
                if (callback(value, index, collection)) {
                    result = value;
                    return false;
                }
            });
            return result;
        }
        /**
     * Iterates over elements of a collection, executing the callback for each
     * element. The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection). Callbacks may exit iteration early by
     * explicitly returning `false`.
     *
     * Note: As with other "Collections" methods, objects with a `length` property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
     * // => logs each number and returns '1,2,3'
     *
     * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
     * // => logs each number and returns the object (property order is not guaranteed across environments)
     */ function forEach(collection, callback, thisArg) {
            var index = -1, length = collection ? collection.length : 0;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            if (typeof length == "number") while(++index < length){
                if (callback(collection[index], index, collection) === false) break;
            }
            else forOwn(collection, callback);
            return collection;
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2, 3]).forEachRight(function(num) { console.log(num); }).join(',');
     * // => logs each number from right to left and returns '3,2,1'
     */ function forEachRight(collection, callback, thisArg) {
            var length = collection ? collection.length : 0;
            callback = callback && typeof thisArg == "undefined" ? callback : baseCreateCallback(callback, thisArg, 3);
            if (typeof length == "number") while(length--){
                if (callback(collection[length], length, collection) === false) break;
            }
            else {
                var props = keys(collection);
                length = props.length;
                forOwn(collection, function(value, key, collection) {
                    key = props ? props[--length] : --length;
                    return callback(collection[key], key, collection);
                });
            }
            return collection;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of a collection through the callback. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using "_.pluck" callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of the collection through the given callback. The corresponding
     * value of each key is the last element responsible for generating the key.
     * The callback is bound to `thisArg` and invoked with three arguments;
     * (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keys = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keys, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keys, function(key) { return String.fromCharCode(key.code); });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(characters, function(key) { this.fromCharCode(key.code); }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */ var indexBy = createAggregator(function(result, value, key) {
            result[key] = value;
        });
        /**
     * Invokes the method named by `methodName` on each element in the `collection`
     * returning an array of the results of each invoked method. Additional arguments
     * will be provided to each invoked method. If `methodName` is a function it
     * will be invoked for, and `this` bound to, each element in the `collection`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|string} methodName The name of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [arg] Arguments to invoke the method with.
     * @returns {Array} Returns a new array of the results of each invoked method.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ function invoke(collection, methodName) {
            var args = slice(arguments, 2), index = -1, isFunc = typeof methodName == "function", length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            forEach(collection, function(value) {
                result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
            });
            return result;
        }
        /**
     * Creates an array of values by running each element in the collection
     * through the callback. The callback is bound to `thisArg` and invoked with
     * three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of the results of each `callback` execution.
     * @example
     *
     * _.map([1, 2, 3], function(num) { return num * 3; });
     * // => [3, 6, 9]
     *
     * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
     * // => [3, 6, 9] (property order is not guaranteed across environments)
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.map(characters, 'name');
     * // => ['barney', 'fred']
     */ function map(collection, callback, thisArg) {
            var index = -1, length = collection ? collection.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            if (typeof length == "number") {
                var result = Array1(length);
                while(++index < length)result[index] = callback(collection[index], index, collection);
            } else {
                result = [];
                forOwn(collection, function(value, key, collection) {
                    result[++index] = callback(value, key, collection);
                });
            }
            return result;
        }
        /**
     * Retrieves the maximum value of a collection. If the collection is empty or
     * falsey `-Infinity` is returned. If a callback is provided it will be executed
     * for each value in the collection to generate the criterion by which the value
     * is ranked. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.max(characters, function(chr) { return chr.age; });
     * // => { 'name': 'fred', 'age': 40 };
     *
     * // using "_.pluck" callback shorthand
     * _.max(characters, 'age');
     * // => { 'name': 'fred', 'age': 40 };
     */ function max(collection, callback, thisArg) {
            var computed = -Infinity, result = computed;
            // allows working with functions like `_.map` without using
            // their `index` argument as a callback
            if (typeof callback != "function" && thisArg && thisArg[callback] === collection) callback = null;
            if (callback == null && isArray(collection)) {
                var index = -1, length = collection.length;
                while(++index < length){
                    var value = collection[index];
                    if (value > result) result = value;
                }
            } else {
                callback = callback == null && isString(collection) ? charAtCallback : lodash.createCallback(callback, thisArg, 3);
                forEach(collection, function(value, index, collection) {
                    var current = callback(value, index, collection);
                    if (current > computed) {
                        computed = current;
                        result = value;
                    }
                });
            }
            return result;
        }
        /**
     * Retrieves the minimum value of a collection. If the collection is empty or
     * falsey `Infinity` is returned. If a callback is provided it will be executed
     * for each value in the collection to generate the criterion by which the value
     * is ranked. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.min(characters, function(chr) { return chr.age; });
     * // => { 'name': 'barney', 'age': 36 };
     *
     * // using "_.pluck" callback shorthand
     * _.min(characters, 'age');
     * // => { 'name': 'barney', 'age': 36 };
     */ function min(collection, callback, thisArg) {
            var computed = Infinity, result = computed;
            // allows working with functions like `_.map` without using
            // their `index` argument as a callback
            if (typeof callback != "function" && thisArg && thisArg[callback] === collection) callback = null;
            if (callback == null && isArray(collection)) {
                var index = -1, length = collection.length;
                while(++index < length){
                    var value = collection[index];
                    if (value < result) result = value;
                }
            } else {
                callback = callback == null && isString(collection) ? charAtCallback : lodash.createCallback(callback, thisArg, 3);
                forEach(collection, function(value, index, collection) {
                    var current = callback(value, index, collection);
                    if (current < computed) {
                        computed = current;
                        result = value;
                    }
                });
            }
            return result;
        }
        /**
     * Retrieves the value of a specified property from all elements in the collection.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {string} property The name of the property to pluck.
     * @returns {Array} Returns a new array of property values.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(characters, 'name');
     * // => ['barney', 'fred']
     */ var pluck = map;
        /**
     * Reduces a collection to a value which is the accumulated result of running
     * each element in the collection through the callback, where each successive
     * callback execution consumes the return value of the previous execution. If
     * `accumulator` is not provided the first element of the collection will be
     * used as the initial `accumulator` value. The callback is bound to `thisArg`
     * and invoked with four arguments; (accumulator, value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] Initial value of the accumulator.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var sum = _.reduce([1, 2, 3], function(sum, num) {
     *   return sum + num;
     * });
     * // => 6
     *
     * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
     *   result[key] = num * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6, 'c': 9 }
     */ function reduce(collection, callback, accumulator, thisArg) {
            if (!collection) return accumulator;
            var noaccum = arguments.length < 3;
            callback = lodash.createCallback(callback, thisArg, 4);
            var index = -1, length = collection.length;
            if (typeof length == "number") {
                if (noaccum) accumulator = collection[++index];
                while(++index < length)accumulator = callback(accumulator, collection[index], index, collection);
            } else forOwn(collection, function(value, index, collection) {
                accumulator = noaccum ? (noaccum = false, value) : callback(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [callback=identity] The function called per iteration.
     * @param {*} [accumulator] Initial value of the accumulator.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var list = [[0, 1], [2, 3], [4, 5]];
     * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, callback, accumulator, thisArg) {
            var noaccum = arguments.length < 3;
            callback = lodash.createCallback(callback, thisArg, 4);
            forEachRight(collection, function(value, index, collection) {
                accumulator = noaccum ? (noaccum = false, value) : callback(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * The opposite of `_.filter` this method returns the elements of a
     * collection that the callback does **not** return truey for.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of elements that failed the callback check.
     * @example
     *
     * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
     * // => [1, 3, 5]
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.reject(characters, 'blocked');
     * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
     *
     * // using "_.where" callback shorthand
     * _.reject(characters, { 'age': 36 });
     * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
     */ function reject(collection, callback, thisArg) {
            callback = lodash.createCallback(callback, thisArg, 3);
            return filter(collection, function(value, index, collection) {
                return !callback(value, index, collection);
            });
        }
        /**
     * Retrieves a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Allows working with functions like `_.map`
     *  without using their `index` arguments as `n`.
     * @returns {Array} Returns the random sample(s) of `collection`.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */ function sample(collection, n, guard) {
            if (collection && typeof collection.length != "number") collection = values(collection);
            if (n == null || guard) return collection ? collection[baseRandom(0, collection.length - 1)] : undefined;
            var result = shuffle(collection);
            result.length = nativeMin(nativeMax(0, n), result.length);
            return result;
        }
        /**
     * Creates an array of shuffled values, using a version of the Fisher-Yates
     * shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns a new shuffled collection.
     * @example
     *
     * _.shuffle([1, 2, 3, 4, 5, 6]);
     * // => [4, 1, 6, 3, 5, 2]
     */ function shuffle(collection) {
            var index = -1, length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            forEach(collection, function(value) {
                var rand = baseRandom(0, ++index);
                result[index] = result[rand];
                result[rand] = value;
            });
            return result;
        }
        /**
     * Gets the size of the `collection` by returning `collection.length` for arrays
     * and array-like objects or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns `collection.length` or number of own enumerable properties.
     * @example
     *
     * _.size([1, 2]);
     * // => 2
     *
     * _.size({ 'one': 1, 'two': 2, 'three': 3 });
     * // => 3
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            var length = collection ? collection.length : 0;
            return typeof length == "number" ? length : keys(collection).length;
        }
        /**
     * Checks if the callback returns a truey value for **any** element of a
     * collection. The function returns as soon as it finds a passing value and
     * does not iterate over the entire collection. The callback is bound to
     * `thisArg` and invoked with three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {boolean} Returns `true` if any element passed the callback check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'blocked': false },
     *   { 'name': 'fred',   'age': 40, 'blocked': true }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.some(characters, 'blocked');
     * // => true
     *
     * // using "_.where" callback shorthand
     * _.some(characters, { 'age': 1 });
     * // => false
     */ function some(collection, callback, thisArg) {
            var result;
            callback = lodash.createCallback(callback, thisArg, 3);
            var index = -1, length = collection ? collection.length : 0;
            if (typeof length == "number") while(++index < length){
                if (result = callback(collection[index], index, collection)) break;
            }
            else forOwn(collection, function(value, index, collection) {
                return !(result = callback(value, index, collection));
            });
            return !!result;
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through the callback. This method
     * performs a stable sort, that is, it will preserve the original sort order
     * of equal elements. The callback is bound to `thisArg` and invoked with
     * three arguments; (value, index|key, collection).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an array of property names is provided for `callback` the collection
     * will be sorted by each property value.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of sorted elements.
     * @example
     *
     * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
     * // => [3, 1, 2]
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36 },
     *   { 'name': 'fred',    'age': 40 },
     *   { 'name': 'barney',  'age': 26 },
     *   { 'name': 'fred',    'age': 30 }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.map(_.sortBy(characters, 'age'), _.values);
     * // => [['barney', 26], ['fred', 30], ['barney', 36], ['fred', 40]]
     *
     * // sorting by multiple properties
     * _.map(_.sortBy(characters, ['name', 'age']), _.values);
     * // = > [['barney', 26], ['barney', 36], ['fred', 30], ['fred', 40]]
     */ function sortBy(collection, callback, thisArg) {
            var index = -1, isArr = isArray(callback), length = collection ? collection.length : 0, result = Array1(typeof length == "number" ? length : 0);
            if (!isArr) callback = lodash.createCallback(callback, thisArg, 3);
            forEach(collection, function(value, key, collection) {
                var object = result[++index] = getObject();
                if (isArr) object.criteria = map(callback, function(key) {
                    return value[key];
                });
                else (object.criteria = getArray())[0] = callback(value, key, collection);
                object.index = index;
                object.value = value;
            });
            length = result.length;
            result.sort(compareAscending);
            while(length--){
                var object = result[length];
                result[length] = object.value;
                if (!isArr) releaseArray(object.criteria);
                releaseObject(object);
            }
            return result;
        }
        /**
     * Converts the `collection` to an array.
     *
     * @static
     * @memberOf _
     * @category Collections
     * @param {Array|Object|string} collection The collection to convert.
     * @returns {Array} Returns the new converted array.
     * @example
     *
     * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
     * // => [2, 3, 4]
     */ function toArray(collection) {
            if (collection && typeof collection.length == "number") return slice(collection);
            return values(collection);
        }
        /**
     * Performs a deep comparison of each element in a `collection` to the given
     * `properties` object, returning an array of all elements that have equivalent
     * property values.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Collections
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Object} props The object of property values to filter by.
     * @returns {Array} Returns a new array of elements that have the given properties.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36, 'pets': ['hoppy'] },
     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.where(characters, { 'age': 36 });
     * // => [{ 'name': 'barney', 'age': 36, 'pets': ['hoppy'] }]
     *
     * _.where(characters, { 'pets': ['dino'] });
     * // => [{ 'name': 'fred', 'age': 40, 'pets': ['baby puss', 'dino'] }]
     */ var where = filter;
        /*--------------------------------------------------------------------------*/ /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are all falsey.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to compact.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array ? array.length : 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result.push(value);
            }
            return result;
        }
        /**
     * Creates an array excluding all values of the provided arrays using strict
     * equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to process.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
     * // => [1, 3, 4]
     */ function difference(array) {
            return baseDifference(array, baseFlatten(arguments, true, true, 1));
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element that passes the callback check, instead of the element itself.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': false },
     *   { 'name': 'fred',    'age': 40, 'blocked': true },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
     * ];
     *
     * _.findIndex(characters, function(chr) {
     *   return chr.age < 20;
     * });
     * // => 2
     *
     * // using "_.where" callback shorthand
     * _.findIndex(characters, { 'age': 36 });
     * // => 0
     *
     * // using "_.pluck" callback shorthand
     * _.findIndex(characters, 'blocked');
     * // => 1
     */ function findIndex(array, callback, thisArg) {
            var index = -1, length = array ? array.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            while(++index < length){
                if (callback(array[index], index, array)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of a `collection` from right to left.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36, 'blocked': true },
     *   { 'name': 'fred',    'age': 40, 'blocked': false },
     *   { 'name': 'pebbles', 'age': 1,  'blocked': true }
     * ];
     *
     * _.findLastIndex(characters, function(chr) {
     *   return chr.age > 30;
     * });
     * // => 1
     *
     * // using "_.where" callback shorthand
     * _.findLastIndex(characters, { 'age': 36 });
     * // => 0
     *
     * // using "_.pluck" callback shorthand
     * _.findLastIndex(characters, 'blocked');
     * // => 2
     */ function findLastIndex(array, callback, thisArg) {
            var length = array ? array.length : 0;
            callback = lodash.createCallback(callback, thisArg, 3);
            while(length--){
                if (callback(array[length], length, array)) return length;
            }
            return -1;
        }
        /**
     * Gets the first element or first `n` elements of an array. If a callback
     * is provided elements at the beginning of the array are returned as long
     * as the callback returns truey. The callback is bound to `thisArg` and
     * invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias head, take
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback] The function called
     *  per element or the number of elements to return. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the first element(s) of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.first([1, 2, 3], function(num) {
     *   return num < 3;
     * });
     * // => [1, 2]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': false, 'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.first(characters, 'blocked');
     * // => [{ 'name': 'barney', 'blocked': true, 'employer': 'slate' }]
     *
     * // using "_.where" callback shorthand
     * _.pluck(_.first(characters, { 'employer': 'slate' }), 'name');
     * // => ['barney', 'fred']
     */ function first(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = -1;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(++index < length && callback(array[index], index, array))n++;
            } else {
                n = callback;
                if (n == null || thisArg) return array ? array[0] : undefined;
            }
            return slice(array, 0, nativeMin(nativeMax(0, n), length));
        }
        /**
     * Flattens a nested array (the nesting can be to any depth). If `isShallow`
     * is truey, the array will only be flattened a single level. If a callback
     * is provided each element of the array is passed through the callback before
     * flattening. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to flatten.
     * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new flattened array.
     * @example
     *
     * _.flatten([1, [2], [3, [[4]]]]);
     * // => [1, 2, 3, 4];
     *
     * _.flatten([1, [2], [3, [[4]]]], true);
     * // => [1, 2, 3, [[4]]];
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
     *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.flatten(characters, 'pets');
     * // => ['hoppy', 'baby puss', 'dino']
     */ function flatten(array, isShallow, callback, thisArg) {
            // juggle arguments
            if (typeof isShallow != "boolean" && isShallow != null) {
                thisArg = callback;
                callback = typeof isShallow != "function" && thisArg && thisArg[isShallow] === array ? null : isShallow;
                isShallow = false;
            }
            if (callback != null) array = map(array, callback, thisArg);
            return baseFlatten(array, isShallow);
        }
        /**
     * Gets the index at which the first occurrence of `value` is found using
     * strict equality for comparisons, i.e. `===`. If the array is already sorted
     * providing `true` for `fromIndex` will run a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value or `-1`.
     * @example
     *
     * _.indexOf([1, 2, 3, 1, 2, 3], 2);
     * // => 1
     *
     * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
     * // => 4
     *
     * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
     * // => 2
     */ function indexOf(array, value, fromIndex) {
            if (typeof fromIndex == "number") {
                var length = array ? array.length : 0;
                fromIndex = fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0;
            } else if (fromIndex) {
                var index = sortedIndex(array, value);
                return array[index] === value ? index : -1;
            }
            return baseIndexOf(array, value, fromIndex);
        }
        /**
     * Gets all but the last element or last `n` elements of an array. If a
     * callback is provided elements at the end of the array are excluded from
     * the result as long as the callback returns truey. The callback is bound
     * to `thisArg` and invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback=1] The function called
     *  per element or the number of elements to exclude. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     *
     * _.initial([1, 2, 3], 2);
     * // => [1]
     *
     * _.initial([1, 2, 3], function(num) {
     *   return num > 1;
     * });
     * // => [1]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.initial(characters, 'blocked');
     * // => [{ 'name': 'barney',  'blocked': false, 'employer': 'slate' }]
     *
     * // using "_.where" callback shorthand
     * _.pluck(_.initial(characters, { 'employer': 'na' }), 'name');
     * // => ['barney', 'fred']
     */ function initial(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = length;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(index-- && callback(array[index], index, array))n++;
            } else n = callback == null || thisArg ? 1 : callback || n;
            return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
        }
        /**
     * Creates an array of unique values present in all provided arrays using
     * strict equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of shared values.
     * @example
     *
     * _.intersection([1, 2, 3], [5, 2, 1, 4], [2, 1]);
     * // => [1, 2]
     */ function intersection() {
            var args = [], argsIndex = -1, argsLength = arguments.length, caches = getArray(), indexOf = getIndexOf(), trustIndexOf = indexOf === baseIndexOf, seen = getArray();
            while(++argsIndex < argsLength){
                var value = arguments[argsIndex];
                if (isArray(value) || isArguments(value)) {
                    args.push(value);
                    caches.push(trustIndexOf && value.length >= largeArraySize && createCache(argsIndex ? args[argsIndex] : seen));
                }
            }
            var array = args[0], index = -1, length = array ? array.length : 0, result = [];
            outer: while(++index < length){
                var cache = caches[0];
                value = array[index];
                if ((cache ? cacheIndexOf(cache, value) : indexOf(seen, value)) < 0) {
                    argsIndex = argsLength;
                    (cache || seen).push(value);
                    while(--argsIndex){
                        cache = caches[argsIndex];
                        if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value)) < 0) continue outer;
                    }
                    result.push(value);
                }
            }
            while(argsLength--){
                cache = caches[argsLength];
                if (cache) releaseObject(cache);
            }
            releaseArray(caches);
            releaseArray(seen);
            return result;
        }
        /**
     * Gets the last element or last `n` elements of an array. If a callback is
     * provided elements at the end of the array are returned as long as the
     * callback returns truey. The callback is bound to `thisArg` and invoked
     * with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback] The function called
     *  per element or the number of elements to return. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {*} Returns the last element(s) of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     *
     * _.last([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.last([1, 2, 3], function(num) {
     *   return num > 1;
     * });
     * // => [2, 3]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.pluck(_.last(characters, 'blocked'), 'name');
     * // => ['fred', 'pebbles']
     *
     * // using "_.where" callback shorthand
     * _.last(characters, { 'employer': 'na' });
     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
     */ function last(array, callback, thisArg) {
            var n = 0, length = array ? array.length : 0;
            if (typeof callback != "number" && callback != null) {
                var index = length;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(index-- && callback(array[index], index, array))n++;
            } else {
                n = callback;
                if (n == null || thisArg) return array ? array[length - 1] : undefined;
            }
            return slice(array, nativeMax(0, length - n));
        }
        /**
     * Gets the index at which the last occurrence of `value` is found using strict
     * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
     * as the offset from the end of the collection.
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value or `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
     * // => 4
     *
     * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var index = array ? array.length : 0;
            if (typeof fromIndex == "number") index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return -1;
        }
        /**
     * Removes all provided values from the given array using strict equality for
     * comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to modify.
     * @param {...*} [value] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */ function pull(array) {
            var args = arguments, argsIndex = 0, argsLength = args.length, length = array ? array.length : 0;
            while(++argsIndex < argsLength){
                var index = -1, value = args[argsIndex];
                while(++index < length)if (array[index] === value) {
                    splice.call(array, index--, 1);
                    length--;
                }
            }
            return array;
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to but not including `end`. If `start` is less than `stop` a
     * zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns a new range array.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ function range(start, end, step) {
            start = +start || 0;
            step = typeof step == "number" ? step : +step || 1;
            if (end == null) {
                end = start;
                start = 0;
            }
            // use `Array(length)` so engines like Chakra and V8 avoid slower modes
            // http://youtu.be/XAqIpGU8ZZk#t=17m25s
            var index = -1, length = nativeMax(0, ceil((end - start) / (step || 1))), result = Array1(length);
            while(++index < length){
                result[index] = start;
                start += step;
            }
            return result;
        }
        /**
     * Removes all elements from an array that the callback returns truey for
     * and returns an array of removed elements. The callback is bound to `thisArg`
     * and invoked with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4, 5, 6];
     * var evens = _.remove(array, function(num) { return num % 2 == 0; });
     *
     * console.log(array);
     * // => [1, 3, 5]
     *
     * console.log(evens);
     * // => [2, 4, 6]
     */ function remove(array, callback, thisArg) {
            var index = -1, length = array ? array.length : 0, result = [];
            callback = lodash.createCallback(callback, thisArg, 3);
            while(++index < length){
                var value = array[index];
                if (callback(value, index, array)) {
                    result.push(value);
                    splice.call(array, index--, 1);
                    length--;
                }
            }
            return result;
        }
        /**
     * The opposite of `_.initial` this method gets all but the first element or
     * first `n` elements of an array. If a callback function is provided elements
     * at the beginning of the array are excluded from the result as long as the
     * callback returns truey. The callback is bound to `thisArg` and invoked
     * with three arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias drop, tail
     * @category Arrays
     * @param {Array} array The array to query.
     * @param {Function|Object|number|string} [callback=1] The function called
     *  per element or the number of elements to exclude. If a property name or
     *  object is provided it will be used to create a "_.pluck" or "_.where"
     *  style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     *
     * _.rest([1, 2, 3], 2);
     * // => [3]
     *
     * _.rest([1, 2, 3], function(num) {
     *   return num < 3;
     * });
     * // => [3]
     *
     * var characters = [
     *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
     *   { 'name': 'fred',    'blocked': false,  'employer': 'slate' },
     *   { 'name': 'pebbles', 'blocked': true, 'employer': 'na' }
     * ];
     *
     * // using "_.pluck" callback shorthand
     * _.pluck(_.rest(characters, 'blocked'), 'name');
     * // => ['fred', 'pebbles']
     *
     * // using "_.where" callback shorthand
     * _.rest(characters, { 'employer': 'slate' });
     * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
     */ function rest(array, callback, thisArg) {
            if (typeof callback != "number" && callback != null) {
                var n = 0, index = -1, length = array ? array.length : 0;
                callback = lodash.createCallback(callback, thisArg, 3);
                while(++index < length && callback(array[index], index, array))n++;
            } else n = callback == null || thisArg ? 1 : nativeMax(0, callback);
            return slice(array, n);
        }
        /**
     * Uses a binary search to determine the smallest index at which a value
     * should be inserted into a given sorted array in order to maintain the sort
     * order of the array. If a callback is provided it will be executed for
     * `value` and each element of `array` to compute their sort ranking. The
     * callback is bound to `thisArg` and invoked with one argument; (value).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([20, 30, 50], 40);
     * // => 2
     *
     * // using "_.pluck" callback shorthand
     * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 2
     *
     * var dict = {
     *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
     * };
     *
     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
     *   return dict.wordToNumber[word];
     * });
     * // => 2
     *
     * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
     *   return this.wordToNumber[word];
     * }, dict);
     * // => 2
     */ function sortedIndex(array, value, callback, thisArg) {
            var low = 0, high = array ? array.length : low;
            // explicitly reference `identity` for better inlining in Firefox
            callback = callback ? lodash.createCallback(callback, thisArg, 1) : identity;
            value = callback(value);
            while(low < high){
                var mid = low + high >>> 1;
                callback(array[mid]) < value ? low = mid + 1 : high = mid;
            }
            return low;
        }
        /**
     * Creates an array of unique values, in order, of the provided arrays using
     * strict equality for comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of combined values.
     * @example
     *
     * _.union([1, 2, 3], [5, 2, 1, 4], [2, 1]);
     * // => [1, 2, 3, 5, 4]
     */ function union() {
            return baseUniq(baseFlatten(arguments, true, true));
        }
        /**
     * Creates a duplicate-value-free version of an array using strict equality
     * for comparisons, i.e. `===`. If the array is sorted, providing
     * `true` for `isSorted` will use a faster algorithm. If a callback is provided
     * each element of `array` is passed through the callback before uniqueness
     * is computed. The callback is bound to `thisArg` and invoked with three
     * arguments; (value, index, array).
     *
     * If a property name is provided for `callback` the created "_.pluck" style
     * callback will return the property value of the given element.
     *
     * If an object is provided for `callback` the created "_.where" style callback
     * will return `true` for elements that have the properties of the given object,
     * else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Arrays
     * @param {Array} array The array to process.
     * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
     * @param {Function|Object|string} [callback=identity] The function called
     *  per iteration. If a property name or object is provided it will be used
     *  to create a "_.pluck" or "_.where" style callback, respectively.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns a duplicate-value-free array.
     * @example
     *
     * _.uniq([1, 2, 1, 3, 1]);
     * // => [1, 2, 3]
     *
     * _.uniq([1, 1, 2, 2, 3], true);
     * // => [1, 2, 3]
     *
     * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
     * // => ['A', 'b', 'C']
     *
     * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
     * // => [1, 2.5, 3]
     *
     * // using "_.pluck" callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniq(array, isSorted, callback, thisArg) {
            // juggle arguments
            if (typeof isSorted != "boolean" && isSorted != null) {
                thisArg = callback;
                callback = typeof isSorted != "function" && thisArg && thisArg[isSorted] === array ? null : isSorted;
                isSorted = false;
            }
            if (callback != null) callback = lodash.createCallback(callback, thisArg, 3);
            return baseUniq(array, isSorted, callback);
        }
        /**
     * Creates an array excluding all provided values using strict equality for
     * comparisons, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {Array} array The array to filter.
     * @param {...*} [value] The values to exclude.
     * @returns {Array} Returns a new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
     * // => [2, 3, 4]
     */ function without(array) {
            return baseDifference(array, slice(arguments, 1));
        }
        /**
     * Creates an array that is the symmetric difference of the provided arrays.
     * See http://en.wikipedia.org/wiki/Symmetric_difference.
     *
     * @static
     * @memberOf _
     * @category Arrays
     * @param {...Array} [array] The arrays to inspect.
     * @returns {Array} Returns an array of values.
     * @example
     *
     * _.xor([1, 2, 3], [5, 2, 1, 4]);
     * // => [3, 5, 4]
     *
     * _.xor([1, 2, 5], [2, 3, 5], [3, 4, 5]);
     * // => [1, 4, 5]
     */ function xor() {
            var index = -1, length = arguments.length;
            while(++index < length){
                var array = arguments[index];
                if (isArray(array) || isArguments(array)) var result = result ? baseUniq(baseDifference(result, array).concat(baseDifference(array, result))) : array;
            }
            return result || [];
        }
        /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second
     * elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @alias unzip
     * @category Arrays
     * @param {...Array} [array] Arrays to process.
     * @returns {Array} Returns a new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */ function zip() {
            var array = arguments.length > 1 ? arguments : arguments[0], index = -1, length = array ? max(pluck(array, "length")) : 0, result = Array1(length < 0 ? 0 : length);
            while(++index < length)result[index] = pluck(array, index);
            return result;
        }
        /**
     * Creates an object composed from arrays of `keys` and `values`. Provide
     * either a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`
     * or two arrays, one of `keys` and one of corresponding `values`.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Arrays
     * @param {Array} keys The array of keys.
     * @param {Array} [values=[]] The array of values.
     * @returns {Object} Returns an object composed of the given keys and
     *  corresponding values.
     * @example
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */ function zipObject(keys, values) {
            var index = -1, length = keys ? keys.length : 0, result = {};
            if (!values && length && !isArray(keys[0])) values = [];
            while(++index < length){
                var key = keys[index];
                if (values) result[key] = values[index];
                else if (key) result[key[0]] = key[1];
            }
            return result;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a function that executes `func`, with  the `this` binding and
     * arguments of the created function, only after being called `n` times.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {number} n The number of times the function must be called before
     *  `func` is executed.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('Done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'Done saving!', after all saves have completed
     */ function after(n, func) {
            if (!isFunction(func)) throw new TypeError;
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that, when called, invokes `func` with the `this`
     * binding of `thisArg` and prepends any additional `bind` arguments to those
     * provided to the bound function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var func = function(greeting) {
     *   return greeting + ' ' + this.name;
     * };
     *
     * func = _.bind(func, { 'name': 'fred' }, 'hi');
     * func();
     * // => 'hi fred'
     */ function bind(func, thisArg) {
            return arguments.length > 2 ? createWrapper(func, 17, slice(arguments, 2), null, thisArg) : createWrapper(func, 1, null, null, thisArg);
        }
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all the function properties
     * of `object` will be bound.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...string} [methodName] The object method names to
     *  bind, specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() { console.log('clicked ' + this.label); }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs', when the button is clicked
     */ function bindAll(object) {
            var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object), index = -1, length = funcs.length;
            while(++index < length){
                var key = funcs[index];
                object[key] = createWrapper(object[key], 1, null, null, object);
            }
            return object;
        }
        /**
     * Creates a function that, when called, invokes the method at `object[key]`
     * and prepends any additional `bindKey` arguments to those provided to the bound
     * function. This method differs from `_.bind` by allowing bound functions to
     * reference methods that will be redefined or don't yet exist.
     * See http://michaux.ca/articles/lazy-function-definition-pattern.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'name': 'fred',
     *   'greet': function(greeting) {
     *     return greeting + ' ' + this.name;
     *   }
     * };
     *
     * var func = _.bindKey(object, 'greet', 'hi');
     * func();
     * // => 'hi fred'
     *
     * object.greet = function(greeting) {
     *   return greeting + 'ya ' + this.name + '!';
     * };
     *
     * func();
     * // => 'hiya fred!'
     */ function bindKey(object, key) {
            return arguments.length > 2 ? createWrapper(key, 19, slice(arguments, 2), null, object) : createWrapper(key, 3, null, null, object);
        }
        /**
     * Creates a function that is the composition of the provided functions,
     * where each function consumes the return value of the function that follows.
     * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
     * Each function is executed with the `this` binding of the composed function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {...Function} [func] Functions to compose.
     * @returns {Function} Returns the new composed function.
     * @example
     *
     * var realNameMap = {
     *   'pebbles': 'penelope'
     * };
     *
     * var format = function(name) {
     *   name = realNameMap[name.toLowerCase()] || name;
     *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
     * };
     *
     * var greet = function(formatted) {
     *   return 'Hiya ' + formatted + '!';
     * };
     *
     * var welcome = _.compose(greet, format);
     * welcome('pebbles');
     * // => 'Hiya Penelope!'
     */ function compose() {
            var funcs = arguments, length = funcs.length;
            while(length--){
                if (!isFunction(funcs[length])) throw new TypeError;
            }
            return function() {
                var args = arguments, length = funcs.length;
                while(length--)args = [
                    funcs[length].apply(this, args)
                ];
                return args[0];
            };
        }
        /**
     * Creates a function which accepts one or more arguments of `func` that when
     * invoked either executes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` can be specified
     * if `func.length` is not sufficient.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var curried = _.curry(function(a, b, c) {
     *   console.log(a + b + c);
     * });
     *
     * curried(1)(2)(3);
     * // => 6
     *
     * curried(1, 2)(3);
     * // => 6
     *
     * curried(1, 2, 3);
     * // => 6
     */ function curry(func, arity) {
            arity = typeof arity == "number" ? arity : +arity || func.length;
            return createWrapper(func, 4, null, null, null, arity);
        }
        /**
     * Creates a function that will delay the execution of `func` until after
     * `wait` milliseconds have elapsed since the last time it was invoked.
     * Provide an options object to indicate that `func` should be invoked on
     * the leading and/or trailing edge of the `wait` timeout. Subsequent calls
     * to the debounced function will return the result of the last `func` call.
     *
     * Note: If `leading` and `trailing` options are `true` `func` will be called
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to debounce.
     * @param {number} wait The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify execution on the leading edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be delayed before it's called.
     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * var lazyLayout = _.debounce(calculateLayout, 150);
     * jQuery(window).on('resize', lazyLayout);
     *
     * // execute `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * });
     *
     * // ensure `batchLog` is executed once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * source.addEventListener('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }, false);
     */ function debounce(func, wait, options) {
            var args, maxTimeoutId, result, stamp, thisArg, timeoutId, trailingCall, lastCalled = 0, maxWait = false, trailing = true;
            if (!isFunction(func)) throw new TypeError;
            wait = nativeMax(0, wait) || 0;
            if (options === true) {
                var leading = true;
                trailing = false;
            } else if (isObject(options)) {
                leading = options.leading;
                maxWait = "maxWait" in options && (nativeMax(wait, options.maxWait) || 0);
                trailing = "trailing" in options ? options.trailing : trailing;
            }
            var delayed = function() {
                var remaining = wait - (now() - stamp);
                if (remaining <= 0) {
                    if (maxTimeoutId) clearTimeout(maxTimeoutId);
                    var isCalled = trailingCall;
                    maxTimeoutId = timeoutId = trailingCall = undefined;
                    if (isCalled) {
                        lastCalled = now();
                        result = func.apply(thisArg, args);
                        if (!timeoutId && !maxTimeoutId) args = thisArg = null;
                    }
                } else timeoutId = setTimeout(delayed, remaining);
            };
            var maxDelayed = function() {
                if (timeoutId) clearTimeout(timeoutId);
                maxTimeoutId = timeoutId = trailingCall = undefined;
                if (trailing || maxWait !== wait) {
                    lastCalled = now();
                    result = func.apply(thisArg, args);
                    if (!timeoutId && !maxTimeoutId) args = thisArg = null;
                }
            };
            return function() {
                args = arguments;
                stamp = now();
                thisArg = this;
                trailingCall = trailing && (timeoutId || !leading);
                if (maxWait === false) var leadingCall = leading && !timeoutId;
                else {
                    if (!maxTimeoutId && !leading) lastCalled = stamp;
                    var remaining = maxWait - (stamp - lastCalled), isCalled = remaining <= 0;
                    if (isCalled) {
                        if (maxTimeoutId) maxTimeoutId = clearTimeout(maxTimeoutId);
                        lastCalled = stamp;
                        result = func.apply(thisArg, args);
                    } else if (!maxTimeoutId) maxTimeoutId = setTimeout(maxDelayed, remaining);
                }
                if (isCalled && timeoutId) timeoutId = clearTimeout(timeoutId);
                else if (!timeoutId && wait !== maxWait) timeoutId = setTimeout(delayed, wait);
                if (leadingCall) {
                    isCalled = true;
                    result = func.apply(thisArg, args);
                }
                if (isCalled && !timeoutId && !maxTimeoutId) args = thisArg = null;
                return result;
            };
        }
        /**
     * Defers executing the `func` function until the current call stack has cleared.
     * Additional arguments will be provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to defer.
     * @param {...*} [arg] Arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) { console.log(text); }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */ function defer(func) {
            if (!isFunction(func)) throw new TypeError;
            var args = slice(arguments, 1);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, 1);
        }
        /**
     * Executes the `func` function after `wait` milliseconds. Additional arguments
     * will be provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay execution.
     * @param {...*} [arg] Arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) { console.log(text); }, 1000, 'later');
     * // => logs 'later' after one second
     */ function delay(func, wait) {
            if (!isFunction(func)) throw new TypeError;
            var args = slice(arguments, 2);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it will be used to determine the cache key for storing the result
     * based on the arguments provided to the memoized function. By default, the
     * first argument provided to the memoized function is used as the cache key.
     * The `func` is executed with the `this` binding of the memoized function.
     * The result cache is exposed as the `cache` property on the memoized function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] A function used to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var fibonacci = _.memoize(function(n) {
     *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
     * });
     *
     * fibonacci(9)
     * // => 34
     *
     * var data = {
     *   'fred': { 'name': 'fred', 'age': 40 },
     *   'pebbles': { 'name': 'pebbles', 'age': 1 }
     * };
     *
     * // modifying the result cache
     * var get = _.memoize(function(name) { return data[name]; }, _.identity);
     * get('pebbles');
     * // => { 'name': 'pebbles', 'age': 1 }
     *
     * get.cache.pebbles.name = 'penelope';
     * get('pebbles');
     * // => { 'name': 'penelope', 'age': 1 }
     */ function memoize(func, resolver) {
            if (!isFunction(func)) throw new TypeError;
            var memoized = function() {
                var cache = memoized.cache, key = resolver ? resolver.apply(this, arguments) : keyPrefix + arguments[0];
                return hasOwnProperty.call(cache, key) ? cache[key] : cache[key] = func.apply(this, arguments);
            };
            memoized.cache = {};
            return memoized;
        }
        /**
     * Creates a function that is restricted to execute `func` once. Repeat calls to
     * the function will return the value of the first call. The `func` is executed
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` executes `createApplication` once
     */ function once(func) {
            var ran, result;
            if (!isFunction(func)) throw new TypeError;
            return function() {
                if (ran) return result;
                ran = true;
                result = func.apply(this, arguments);
                // clear the `func` variable so the function may be garbage collected
                func = null;
                return result;
            };
        }
        /**
     * Creates a function that, when called, invokes `func` with any additional
     * `partial` arguments prepended to those provided to the new function. This
     * method is similar to `_.bind` except it does **not** alter the `this` binding.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) { return greeting + ' ' + name; };
     * var hi = _.partial(greet, 'hi');
     * hi('fred');
     * // => 'hi fred'
     */ function partial(func) {
            return createWrapper(func, 16, slice(arguments, 1));
        }
        /**
     * This method is like `_.partial` except that `partial` arguments are
     * appended to those provided to the new function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [arg] Arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var defaultsDeep = _.partialRight(_.merge, _.defaults);
     *
     * var options = {
     *   'variable': 'data',
     *   'imports': { 'jq': $ }
     * };
     *
     * defaultsDeep(options, _.templateSettings);
     *
     * options.variable
     * // => 'data'
     *
     * options.imports
     * // => { '_': _, 'jq': $ }
     */ function partialRight(func) {
            return createWrapper(func, 32, null, slice(arguments, 1));
        }
        /**
     * Creates a function that, when executed, will only call the `func` function
     * at most once per every `wait` milliseconds. Provide an options object to
     * indicate that `func` should be invoked on the leading and/or trailing edge
     * of the `wait` timeout. Subsequent calls to the throttled function will
     * return the result of the last `func` call.
     *
     * Note: If `leading` and `trailing` options are `true` `func` will be called
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {Function} func The function to throttle.
     * @param {number} wait The number of milliseconds to throttle executions to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * var throttled = _.throttle(updatePosition, 100);
     * jQuery(window).on('scroll', throttled);
     *
     * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (!isFunction(func)) throw new TypeError;
            if (options === false) leading = false;
            else if (isObject(options)) {
                leading = "leading" in options ? options.leading : leading;
                trailing = "trailing" in options ? options.trailing : trailing;
            }
            debounceOptions.leading = leading;
            debounceOptions.maxWait = wait;
            debounceOptions.trailing = trailing;
            return debounce(func, wait, debounceOptions);
        }
        /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Additional arguments provided to the function are appended
     * to those provided to the wrapper function. The wrapper is executed with
     * the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Functions
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('Fred, Wilma, & Pebbles');
     * // => '<p>Fred, Wilma, &amp; Pebbles</p>'
     */ function wrap(value, wrapper) {
            return createWrapper(wrapper, 16, [
                value
            ]);
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'name': 'fred' };
     * var getter = _.constant(object);
     * getter() === object;
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Produces a callback bound to an optional `thisArg`. If `func` is a property
     * name the created callback will return the property value for a given element.
     * If `func` is an object the created callback will return `true` for elements
     * that contain the equivalent object properties, otherwise it will return `false`.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} [func=identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of the created callback.
     * @param {number} [argCount] The number of arguments the callback accepts.
     * @returns {Function} Returns a callback function.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
     *   return !match ? func(callback, thisArg) : function(object) {
     *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(characters, 'age__gt38');
     * // => [{ 'name': 'fred', 'age': 40 }]
     */ function createCallback(func, thisArg, argCount) {
            var type = typeof func;
            if (func == null || type == "function") return baseCreateCallback(func, thisArg, argCount);
            // handle "_.pluck" style callback shorthands
            if (type != "object") return property(func);
            var props = keys(func), key = props[0], a = func[key];
            // handle "_.where" style callback shorthands
            if (props.length == 1 && a === a && !isObject(a)) // fast path the common case of providing an object with a single
            // property containing a primitive value
            return function(object) {
                var b = object[key];
                return a === b && (a !== 0 || 1 / a == 1 / b);
            };
            return function(object) {
                var length = props.length, result = false;
                while(length--){
                    if (!(result = baseIsEqual(object[props[length]], func[props[length]], null, true))) break;
                }
                return result;
            };
        }
        /**
     * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
     * corresponding HTML entities.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} string The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('Fred, Wilma, & Pebbles');
     * // => 'Fred, Wilma, &amp; Pebbles'
     */ function escape(string) {
            return string == null ? "" : String(string).replace(reUnescapedHtml, escapeHtmlChar);
        }
        /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'name': 'fred' };
     * _.identity(object) === object;
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Adds function properties of a source object to the destination object.
     * If `object` is a function methods will be added to its prototype as well.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {Function|Object} [object=lodash] object The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added are chainable.
     * @example
     *
     * function capitalize(string) {
     *   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
     * }
     *
     * _.mixin({ 'capitalize': capitalize });
     * _.capitalize('fred');
     * // => 'Fred'
     *
     * _('fred').capitalize().value();
     * // => 'Fred'
     *
     * _.mixin({ 'capitalize': capitalize }, { 'chain': false });
     * _('fred').capitalize();
     * // => 'Fred'
     */ function mixin(object, source, options) {
            var chain = true, methodNames = source && functions(source);
            if (!source || !options && !methodNames.length) {
                if (options == null) options = source;
                ctor = lodashWrapper;
                source = object;
                object = lodash;
                methodNames = functions(source);
            }
            if (options === false) chain = false;
            else if (isObject(options) && "chain" in options) chain = options.chain;
            var ctor = object, isFunc = isFunction(ctor);
            forEach(methodNames, function(methodName) {
                var func = object[methodName] = source[methodName];
                if (isFunc) ctor.prototype[methodName] = function() {
                    var chainAll = this.__chain__, value = this.__wrapped__, args = [
                        value
                    ];
                    push.apply(args, arguments);
                    var result = func.apply(object, args);
                    if (chain || chainAll) {
                        if (value === result && isObject(result)) return this;
                        result = new ctor(result);
                        result.__chain__ = chainAll;
                    }
                    return result;
                };
            });
        }
        /**
     * Reverts the '_' variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            context._ = oldDash;
            return this;
        }
        /**
     * A no-operation function.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @example
     *
     * var object = { 'name': 'fred' };
     * _.noop(object) === undefined;
     * // => true
     */ function noop() {
        // no operation performed
        }
        /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @example
     *
     * var stamp = _.now();
     * _.defer(function() { console.log(_.now() - stamp); });
     * // => logs the number of milliseconds it took for the deferred function to be called
     */ var now = isNative(now = Date1.now) && now || function() {
            return new Date1().getTime();
        };
        /**
     * Converts the given value into an integer of the specified radix.
     * If `radix` is `undefined` or `0` a `radix` of `10` is used unless the
     * `value` is a hexadecimal, in which case a `radix` of `16` is used.
     *
     * Note: This method avoids differences in native ES3 and ES5 `parseInt`
     * implementations. See http://es5.github.io/#E.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} value The value to parse.
     * @param {number} [radix] The radix used to interpret the value to parse.
     * @returns {number} Returns the new integer value.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     */ var parseInt = nativeParseInt(whitespace + "08") == 8 ? nativeParseInt : function(value, radix) {
            // Firefox < 21 and Opera < 15 follow the ES3 specified implementation of `parseInt`
            return nativeParseInt(isString(value) ? value.replace(reLeadingSpacesAndZeros, "") : value, radix || 0);
        };
        /**
     * Creates a "_.pluck" style function, which returns the `key` value of a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} key The name of the property to retrieve.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var characters = [
     *   { 'name': 'fred',   'age': 40 },
     *   { 'name': 'barney', 'age': 36 }
     * ];
     *
     * var getName = _.property('name');
     *
     * _.map(characters, getName);
     * // => ['barney', 'fred']
     *
     * _.sortBy(characters, getName);
     * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
     */ function property(key) {
            return function(object) {
                return object[key];
            };
        }
        /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number will be
     * returned. If `floating` is truey or either `min` or `max` are floats a
     * floating-point number will be returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating=false] Specify returning a floating-point number.
     * @returns {number} Returns a random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(min, max, floating) {
            var noMin = min == null, noMax = max == null;
            if (floating == null) {
                if (typeof min == "boolean" && noMax) {
                    floating = min;
                    min = 1;
                } else if (!noMax && typeof max == "boolean") {
                    floating = max;
                    noMax = true;
                }
            }
            if (noMin && noMax) max = 1;
            min = +min || 0;
            if (noMax) {
                max = min;
                min = 0;
            } else max = +max || 0;
            if (floating || min % 1 || max % 1) {
                var rand = nativeRandom();
                return nativeMin(min + rand * (max - min + parseFloat("1e-" + ((rand + "").length - 1))), max);
            }
            return baseRandom(min, max);
        }
        /**
     * Resolves the value of property `key` on `object`. If `key` is a function
     * it will be invoked with the `this` binding of `object` and its result returned,
     * else the property value is returned. If `object` is falsey then `undefined`
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {Object} object The object to inspect.
     * @param {string} key The name of the property to resolve.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = {
     *   'cheese': 'crumpets',
     *   'stuff': function() {
     *     return 'nonsense';
     *   }
     * };
     *
     * _.result(object, 'cheese');
     * // => 'crumpets'
     *
     * _.result(object, 'stuff');
     * // => 'nonsense'
     */ function result(object, key) {
            if (object) {
                var value = object[key];
                return isFunction(value) ? object[key]() : value;
            }
        }
        /**
     * A micro-templating method that handles arbitrary delimiters, preserves
     * whitespace, and correctly escapes quotes within interpolated code.
     *
     * Note: In the development build, `_.template` utilizes sourceURLs for easier
     * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
     *
     * For more information on precompiling templates see:
     * https://lodash.com/custom-builds
     *
     * For more information on Chrome extension sandboxes see:
     * http://developer.chrome.com/stable/extensions/sandboxingEval.html
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} text The template text.
     * @param {Object} data The data object used to populate the text.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as local variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [variable] The data object variable name.
     * @returns {Function|string} Returns a compiled function when no `data` object
     *  is given, else it returns the interpolated text.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= name %>');
     * compiled({ 'name': 'fred' });
     * // => 'hello fred'
     *
     * // using the "escape" delimiter to escape HTML in data property values
     * _.template('<b><%- value %></b>', { 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to generate HTML
     * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
     * _.template(list, { 'people': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
     * _.template('hello ${ name }', { 'name': 'pebbles' });
     * // => 'hello pebbles'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
     * // => 'hello barney!'
     *
     * // using a custom template delimiters
     * _.templateSettings = {
     *   'interpolate': /{{([\s\S]+?)}}/g
     * };
     *
     * _.template('hello {{ name }}!', { 'name': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using the `imports` option to import jQuery
     * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
     * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     *   var __t, __p = '', __e = _.escape;
     *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
     *   return __p;
     * }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(text, data, options) {
            // based on John Resig's `tmpl` implementation
            // http://ejohn.org/blog/javascript-micro-templating/
            // and Laura Doktorova's doT.js
            // https://github.com/olado/doT
            var settings = lodash.templateSettings;
            text = String(text || "");
            // avoid missing dependencies when `iteratorTemplate` is not defined
            options = defaults({}, options, settings);
            var imports = defaults({}, options.imports, settings.imports), importsKeys = keys(imports), importsValues = values(imports);
            var isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // compile the regexp to match each delimiter
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            text.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // escape characters that cannot be included in string literals
                source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // replace delimiters with snippets
                if (escapeValue) source += "' +\n__e(" + escapeValue + ") +\n'";
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // the JS engine embedded in Adobe products requires returning the `match`
                // string in order to produce the correct `offset` value
                return match;
            });
            source += "';\n";
            // if `variable` is not specified, wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain
            var variable = options.variable, hasVariable = variable;
            if (!hasVariable) {
                variable = "obj";
                source = "with (" + variable + ") {\n" + source + "\n}\n";
            }
            // cleanup code by stripping empty strings
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // frame code as the function body
            source = "function(" + variable + ") {\n" + (hasVariable ? "" : variable + " || (" + variable + " = {});\n") + "var __t, __p = '', __e = _.escape" + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            // Use a sourceURL for easier debugging.
            // http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
            var sourceURL = "\n/*\n//# sourceURL=" + (options.sourceURL || "/lodash/template/source[" + templateCounter++ + "]") + "\n*/";
            try {
                var result = Function(importsKeys, "return " + source + sourceURL).apply(undefined, importsValues);
            } catch (e) {
                e.source = source;
                throw e;
            }
            if (data) return result(data);
            // provide the compiled function's source by its `toString` method, in
            // supported environments, or the `source` property as a convenience for
            // inlining compiled templates during the build process
            result.source = source;
            return result;
        }
        /**
     * Executes the callback `n` times, returning an array of the results
     * of each callback execution. The callback is bound to `thisArg` and invoked
     * with one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {number} n The number of times to execute the callback.
     * @param {Function} callback The function called per iteration.
     * @param {*} [thisArg] The `this` binding of `callback`.
     * @returns {Array} Returns an array of the results of each `callback` execution.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) { mage.castSpell(n); });
     * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
     *
     * _.times(3, function(n) { this.cast(n); }, mage);
     * // => also calls `mage.castSpell(n)` three times
     */ function times(n, callback, thisArg) {
            n = (n = +n) > -1 ? n : 0;
            var index = -1, result = Array1(n);
            callback = baseCreateCallback(callback, thisArg, 1);
            while(++index < n)result[index] = callback(index);
            return result;
        }
        /**
     * The inverse of `_.escape` this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
     * corresponding characters.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} string The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('Fred, Barney &amp; Pebbles');
     * // => 'Fred, Barney & Pebbles'
     */ function unescape(string) {
            return string == null ? "" : String(string).replace(reEscapedHtml, unescapeHtmlChar);
        }
        /**
     * Generates a unique ID. If `prefix` is provided the ID will be appended to it.
     *
     * @static
     * @memberOf _
     * @category Utilities
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return String(prefix == null ? "" : prefix) + id;
        }
        /*--------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object that wraps the given value with explicit
     * method chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chaining
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney',  'age': 36 },
     *   { 'name': 'fred',    'age': 40 },
     *   { 'name': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(characters)
     *     .sortBy('age')
     *     .map(function(chr) { return chr.name + ' is ' + chr.age; })
     *     .first()
     *     .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            value = new lodashWrapper(value);
            value.__chain__ = true;
            return value;
        }
        /**
     * Invokes `interceptor` with the `value` as the first argument and then
     * returns `value`. The purpose of this method is to "tap into" a method
     * chain in order to perform operations on intermediate results within
     * the chain.
     *
     * @static
     * @memberOf _
     * @category Chaining
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3, 4])
     *  .tap(function(array) { array.pop(); })
     *  .reverse()
     *  .value();
     * // => [3, 2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chaining
     * @returns {*} Returns the wrapper object.
     * @example
     *
     * var characters = [
     *   { 'name': 'barney', 'age': 36 },
     *   { 'name': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(characters).first();
     * // => { 'name': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(characters).chain()
     *   .first()
     *   .pick('age')
     *   .value();
     * // => { 'age': 36 }
     */ function wrapperChain() {
            this.__chain__ = true;
            return this;
        }
        /**
     * Produces the `toString` result of the wrapped value.
     *
     * @name toString
     * @memberOf _
     * @category Chaining
     * @returns {string} Returns the string result.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */ function wrapperToString() {
            return String(this.__wrapped__);
        }
        /**
     * Extracts the wrapped value.
     *
     * @name valueOf
     * @memberOf _
     * @alias value
     * @category Chaining
     * @returns {*} Returns the wrapped value.
     * @example
     *
     * _([1, 2, 3]).valueOf();
     * // => [1, 2, 3]
     */ function wrapperValueOf() {
            return this.__wrapped__;
        }
        /*--------------------------------------------------------------------------*/ // add functions that return wrapped values when chaining
        lodash.after = after;
        lodash.assign = assign;
        lodash.at = at;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.chain = chain;
        lodash.compact = compact;
        lodash.compose = compose;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.createCallback = createCallback;
        lodash.curry = curry;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.filter = filter;
        lodash.flatten = flatten;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.functions = functions;
        lodash.groupBy = groupBy;
        lodash.indexBy = indexBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.invert = invert;
        lodash.invoke = invoke;
        lodash.keys = keys;
        lodash.map = map;
        lodash.mapValues = mapValues;
        lodash.max = max;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.min = min;
        lodash.omit = omit;
        lodash.once = once;
        lodash.pairs = pairs;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.pick = pick;
        lodash.pluck = pluck;
        lodash.property = property;
        lodash.pull = pull;
        lodash.range = range;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.shuffle = shuffle;
        lodash.sortBy = sortBy;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.times = times;
        lodash.toArray = toArray;
        lodash.transform = transform;
        lodash.union = union;
        lodash.uniq = uniq;
        lodash.values = values;
        lodash.where = where;
        lodash.without = without;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        // add aliases
        lodash.collect = map;
        lodash.drop = rest;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.extend = assign;
        lodash.methods = functions;
        lodash.object = zipObject;
        lodash.select = filter;
        lodash.tail = rest;
        lodash.unique = uniq;
        lodash.unzip = zip;
        // add functions to `lodash.prototype`
        mixin(lodash);
        /*--------------------------------------------------------------------------*/ // add functions that return unwrapped values when chaining
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.contains = contains;
        lodash.escape = escape;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.has = has;
        lodash.identity = identity;
        lodash.indexOf = indexOf;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isBoolean = isBoolean;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isNaN = isNaN;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isString = isString;
        lodash.isUndefined = isUndefined;
        lodash.lastIndexOf = lastIndexOf;
        lodash.mixin = mixin;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.result = result;
        lodash.runInContext = runInContext;
        lodash.size = size;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.template = template;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        // add aliases
        lodash.all = every;
        lodash.any = some;
        lodash.detect = find;
        lodash.findWhere = find;
        lodash.foldl = reduce;
        lodash.foldr = reduceRight;
        lodash.include = contains;
        lodash.inject = reduce;
        mixin(function() {
            var source = {};
            forOwn(lodash, function(func, methodName) {
                if (!lodash.prototype[methodName]) source[methodName] = func;
            });
            return source;
        }(), false);
        /*--------------------------------------------------------------------------*/ // add functions capable of returning wrapped and unwrapped values when chaining
        lodash.first = first;
        lodash.last = last;
        lodash.sample = sample;
        // add aliases
        lodash.take = first;
        lodash.head = first;
        forOwn(lodash, function(func, methodName) {
            var callbackable = methodName !== "sample";
            if (!lodash.prototype[methodName]) lodash.prototype[methodName] = function(n, guard) {
                var chainAll = this.__chain__, result = func(this.__wrapped__, n, guard);
                return !chainAll && (n == null || guard && !(callbackable && typeof n == "function")) ? result : new lodashWrapper(result, chainAll);
            };
        });
        /*--------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */ lodash.VERSION = "2.4.2";
        // add "Chaining" functions to the wrapper
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.toString = wrapperToString;
        lodash.prototype.value = wrapperValueOf;
        lodash.prototype.valueOf = wrapperValueOf;
        // add `Array` functions that return unwrapped values
        forEach([
            "join",
            "pop",
            "shift"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                var chainAll = this.__chain__, result = func.apply(this.__wrapped__, arguments);
                return chainAll ? new lodashWrapper(result, chainAll) : result;
            };
        });
        // add `Array` functions that return the existing wrapped value
        forEach([
            "push",
            "reverse",
            "sort",
            "unshift"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                func.apply(this.__wrapped__, arguments);
                return this;
            };
        });
        // add `Array` functions that return new wrapped values
        forEach([
            "concat",
            "slice",
            "splice"
        ], function(methodName) {
            var func = arrayRef[methodName];
            lodash.prototype[methodName] = function() {
                return new lodashWrapper(func.apply(this.__wrapped__, arguments), this.__chain__);
            };
        });
        return lodash;
    }
    /*--------------------------------------------------------------------------*/ // expose Lo-Dash
    var _ = runInContext();
    // some AMD build optimizers like r.js check for condition patterns like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lo-Dash to the global object even when an AMD loader is present in
        // case Lo-Dash is loaded with a RequireJS shim config.
        // See http://requirejs.org/docs/api.html#config-shim
        root._ = _;
        // define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module
        define(function() {
            return _;
        });
    } else if (freeExports && freeModule) {
        // in Node.js or RingoJS
        if (moduleExports) (freeModule.exports = _)._ = _;
        else freeExports._ = _;
    } else // in a browser or Rhino
    root._ = _;
}).call(this);

},{}],"kg6Jw":[function(require,module,exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

},{}],"5rvqv":[function(require,module,exports) {
//! moment.js
//! version : 2.14.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function utils_hooks__hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        return Object.prototype.toString.call(input) === "[object Object]";
    }
    function isObjectEmpty(obj) {
        var k;
        for(k in obj)// even if its not own property I'd still call it non-empty
        return false;
        return true;
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i;
        for(i = 0; i < arr.length; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function create_utc__createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this);
        var len = t.length >>> 0;
        for(var i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            m._isValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) m._isValid = m._isValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        return m._isValid;
    }
    function valid__createInvalid(flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    function isUndefined(input) {
        return input === void 0;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];
    function copyConfig(to, from) {
        var i, prop, val;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentProperties.length > 0) for(i in momentProperties){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    var updateInProgress = false;
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (utils_hooks__hooks.deprecationHandler != null) utils_hooks__hooks.deprecationHandler(null, msg);
            if (firstTime) {
                warn(msg + "\nArguments: " + Array.prototype.slice.call(arguments).join(", ") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) utils_hooks__hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;
    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function locale_set__set(config) {
        var prop, i;
        for(i in config){
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function locale_calendar__calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function(val) {
            return val.slice(1);
        });
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d";
    var defaultOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relative__relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for(var u in unitsObj)units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else return get_set__get(this, unit);
        };
    }
    function get_set__get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function get_set__set(mom, unit, value) {
        if (mom.isValid()) mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for(var i = 0; i < prioritized.length; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
    var formatFunctions = {};
    var formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/; //       0 - 9
    var match2 = /\d\d/; //      00 - 99
    var match3 = /\d{3}/; //     000 - 999
    var match4 = /\d{4}/; //    0000 - 9999
    var match6 = /[+-]?\d{6}/; // -999999 - 999999
    var match1to2 = /\d\d?/; //       0 - 99
    var match3to4 = /\d\d\d\d?/; //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/; //       0 - 999
    var match1to4 = /\d{1,4}/; //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999
    var matchUnsigned = /\d+/; //       0 - inf
    var matchSigned = /[+-]?\d+/; //    -inf - inf
    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
    var regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === "string") token = [
            token
        ];
        if (typeof callback === "number") func = function(input, array) {
            array[callback] = toInt(input);
        };
        for(i = 0; i < token.length; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
    function localeMonths(m, format) {
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    var defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
    function localeMonthsShort(m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = create_utc__createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return units_month__handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = create_utc__createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== "number") return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else return get_set__get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = create_utc__createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? "" + y : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    // HOOKS
    utils_hooks__hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);
        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) date.setFullYear(y);
        return date;
    }
    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
    function localeWeekdays(m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? "format" : "standalone"][m.day()];
    }
    var defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
    function localeWeekdaysShort(m) {
        return this._weekdaysShort[m.day()];
    }
    var defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
    function localeWeekdaysMin(m) {
        return this._weekdaysMin[m.day()];
    }
    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = create_utc__createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = create_utc__createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", ".?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", ".?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", ".?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = create_utc__createUTC([
                2000,
                1
            ]).day(i);
            minp = this.weekdaysMin(mom, "");
            shortp = this.weekdaysShort(mom, "");
            longp = this.weekdays(mom, "");
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 7; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    // MOMENTS
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet("Hours", true);
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {};
    var globalLocale;
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) break;
                j--;
            }
            i++;
        }
        return null;
    }
    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && true && module && module.exports) try {
            oldLocale = globalLocale._abbr;
            require("./locale/" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            locale_locales__getSetGlobalLocale(oldLocale);
        } catch (e) {}
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = locale_locales__getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else // treat as if there is no base config
                deprecateSimple("parentLocaleUndefined", "specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/");
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) parentConfig = locales[name]._config;
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;
            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) locales[name] = locales[name].parentLocale;
            else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function locale_locales__getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function locale_locales__listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow;
        var a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
    var isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        // YYYYMM is NOT allowed by the standard
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ]
    ];
    // iso time formats and regexes
    var isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ];
    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDates.length; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimes.length; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }
    utils_hooks__hooks.createFromInputFallback = deprecate("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse)) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to begining of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore;
        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < config._f.length; i++){
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (!valid__isValid(tempConfig)) continue;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i);
        config._a = map([
            i.year,
            i.month,
            i.day || i.date,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || locale_locales__getLocale(config._l);
        if (input === null || format === undefined && input === "") return valid__createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isArray(format)) configFromStringAndArray(config);
        else if (isDate(input)) config._d = input;
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!valid__isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) config._d = new Date(utils_hooks__hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof input === "object") configFromObject(config);
        else if (typeof input === "number") // from milliseconds
        config._d = new Date(input);
        else utils_hooks__hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (typeof locale === "boolean") {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function local__createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = local__createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return valid__createInvalid();
    });
    var prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = local__createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return valid__createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return local__createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = locale_locales__getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset();
            var sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher) || [];
        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);
        return parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else return local__createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") input = offsetFromString(matchShortOffset, input);
            else if (Math.abs(input) < 16) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) add_subtract__addSubtract(this, create__createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm) this.utcOffset(this._tzm);
        else if (typeof this._i === "string") this.utcOffset(offsetFromString(matchOffset, this._i));
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? local__createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {};
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
    function create__createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (typeof input === "number") {
            duration = {};
            if (key) duration[key] = input;
            else duration.milliseconds = input;
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        return ret;
    }
    create__createDuration.fn = Duration.prototype;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {
            milliseconds: 0,
            months: 0
        };
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            val = typeof val === "string" ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }
    function add_subtract__addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (days) get_set__set(mom, "Date", get_set__get(mom, "Date") + days * isAdding);
        if (months) setMonth(mom, get_set__get(mom, "Month") + months * isAdding);
        if (updateOffset) utils_hooks__hooks.updateOffset(mom, days || months);
    }
    var add_subtract__add = createAdder(1, "add");
    var add_subtract__subtract = createAdder(-1, "subtract");
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function moment_calendar__calendar(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = utils_hooks__hooks.calendarFormat(this, sod) || "sameElse";
        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(from, units) : !this.isBefore(from, units)) && (inclusivity[1] === ")" ? this.isBefore(to, units) : !this.isAfter(to, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units || "millisecond");
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, delta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        if (units === "year" || units === "month" || units === "quarter") {
            output = monthDiff(this, that);
            if (units === "quarter") output = output / 3;
            else if (units === "year") output = output / 12;
        } else {
            delta = this - that;
            output = units === "second" ? delta / 1e3 : units === "minute" ? delta / 6e4 : units === "hour" ? delta / 36e5 : units === "day" ? (delta - zoneDelta) / 864e5 : units === "week" ? (delta - zoneDelta) / 6048e5 : delta;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    utils_hooks__hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    utils_hooks__hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function moment_format__toISOString() {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) // native implementation is ~50x faster, use it when we can
            return this.toDate().toISOString();
            else return formatMoment(m, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
        } else return formatMoment(m, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || local__createLocal(time).isValid())) return create__createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || local__createLocal(time).isValid())) return create__createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    function startOf(units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch(units){
            case "year":
                this.month(0);
            /* falls through */ case "quarter":
            case "month":
                this.date(1);
            /* falls through */ case "week":
            case "isoWeek":
            case "day":
            case "date":
                this.hours(0);
            /* falls through */ case "hour":
                this.minutes(0);
            /* falls through */ case "minute":
                this.seconds(0);
            /* falls through */ case "second":
                this.milliseconds(0);
        }
        // weeks are a special case
        if (units === "week") this.weekday(0);
        if (units === "isoWeek") this.isoWeekday(1);
        // quarters are also special
        if (units === "quarter") this.month(Math.floor(this.month() / 3) * 3);
        return this;
    }
    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond") return this;
        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === "date") units = "day";
        return this.startOf(units).add(1, units === "isoWeek" ? "week" : units).subtract(1, "ms");
    }
    function to_type__valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function moment_valid__isValid() {
        return valid__isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIOROITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    // MOMENTS
    var getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var momentPrototype__proto = Moment.prototype;
    momentPrototype__proto.add = add_subtract__add;
    momentPrototype__proto.calendar = moment_calendar__calendar;
    momentPrototype__proto.clone = clone;
    momentPrototype__proto.diff = diff;
    momentPrototype__proto.endOf = endOf;
    momentPrototype__proto.format = format;
    momentPrototype__proto.from = from;
    momentPrototype__proto.fromNow = fromNow;
    momentPrototype__proto.to = to;
    momentPrototype__proto.toNow = toNow;
    momentPrototype__proto.get = stringGet;
    momentPrototype__proto.invalidAt = invalidAt;
    momentPrototype__proto.isAfter = isAfter;
    momentPrototype__proto.isBefore = isBefore;
    momentPrototype__proto.isBetween = isBetween;
    momentPrototype__proto.isSame = isSame;
    momentPrototype__proto.isSameOrAfter = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore = isSameOrBefore;
    momentPrototype__proto.isValid = moment_valid__isValid;
    momentPrototype__proto.lang = lang;
    momentPrototype__proto.locale = locale;
    momentPrototype__proto.localeData = localeData;
    momentPrototype__proto.max = prototypeMax;
    momentPrototype__proto.min = prototypeMin;
    momentPrototype__proto.parsingFlags = parsingFlags;
    momentPrototype__proto.set = stringSet;
    momentPrototype__proto.startOf = startOf;
    momentPrototype__proto.subtract = add_subtract__subtract;
    momentPrototype__proto.toArray = toArray;
    momentPrototype__proto.toObject = toObject;
    momentPrototype__proto.toDate = toDate;
    momentPrototype__proto.toISOString = moment_format__toISOString;
    momentPrototype__proto.toJSON = toJSON;
    momentPrototype__proto.toString = toString;
    momentPrototype__proto.unix = unix;
    momentPrototype__proto.valueOf = to_type__valueOf;
    momentPrototype__proto.creationData = creationData;
    // Year
    momentPrototype__proto.year = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;
    // Week Year
    momentPrototype__proto.weekYear = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
    // Month
    momentPrototype__proto.month = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;
    // Week
    momentPrototype__proto.week = momentPrototype__proto.weeks = getSetWeek;
    momentPrototype__proto.isoWeek = momentPrototype__proto.isoWeeks = getSetISOWeek;
    momentPrototype__proto.weeksInYear = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
    // Day
    momentPrototype__proto.date = getSetDayOfMonth;
    momentPrototype__proto.day = momentPrototype__proto.days = getSetDayOfWeek;
    momentPrototype__proto.weekday = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear = getSetDayOfYear;
    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
    // Offset
    momentPrototype__proto.utcOffset = getSetOffset;
    momentPrototype__proto.utc = setOffsetToUTC;
    momentPrototype__proto.local = setOffsetToLocal;
    momentPrototype__proto.parseZone = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST = isDaylightSavingTime;
    momentPrototype__proto.isLocal = isLocal;
    momentPrototype__proto.isUtcOffset = isUtcOffset;
    momentPrototype__proto.isUtc = isUtc;
    momentPrototype__proto.isUTC = isUtc;
    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;
    // Deprecations
    momentPrototype__proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    momentPrototype__proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    momentPrototype__proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    momentPrototype__proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    var momentPrototype = momentPrototype__proto;
    function moment__createUnix(input) {
        return local__createLocal(input * 1000);
    }
    function moment__createInZone() {
        return local__createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var prototype__proto = Locale.prototype;
    prototype__proto.calendar = locale_calendar__calendar;
    prototype__proto.longDateFormat = longDateFormat;
    prototype__proto.invalidDate = invalidDate;
    prototype__proto.ordinal = ordinal;
    prototype__proto.preparse = preParsePostFormat;
    prototype__proto.postformat = preParsePostFormat;
    prototype__proto.relativeTime = relative__relativeTime;
    prototype__proto.pastFuture = pastFuture;
    prototype__proto.set = locale_set__set;
    // Month
    prototype__proto.months = localeMonths;
    prototype__proto.monthsShort = localeMonthsShort;
    prototype__proto.monthsParse = localeMonthsParse;
    prototype__proto.monthsRegex = monthsRegex;
    prototype__proto.monthsShortRegex = monthsShortRegex;
    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
    // Day of Week
    prototype__proto.weekdays = localeWeekdays;
    prototype__proto.weekdaysMin = localeWeekdaysMin;
    prototype__proto.weekdaysShort = localeWeekdaysShort;
    prototype__proto.weekdaysParse = localeWeekdaysParse;
    prototype__proto.weekdaysRegex = weekdaysRegex;
    prototype__proto.weekdaysShortRegex = weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex = weekdaysMinRegex;
    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;
    function lists__get(format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (typeof format === "number") {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return lists__get(format, index, field, "month");
        var i;
        var out = [];
        for(i = 0; i < 12; i++)out[i] = lists__get(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (typeof format === "number") {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (typeof format === "number") {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = locale_locales__getLocale(), shift = localeSorted ? locale._week.dow : 0;
        if (index != null) return lists__get(format, (index + shift) % 7, field, "day");
        var i;
        var out = [];
        for(i = 0; i < 7; i++)out[i] = lists__get(format, (i + shift) % 7, field, "day");
        return out;
    }
    function lists__listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function lists__listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function lists__listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function lists__listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function lists__listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    locale_locales__getSetGlobalLocale("en", {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    utils_hooks__hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", locale_locales__getLocale);
    var mathAbs = Math.abs;
    function duration_abs__abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function duration_add_subtract__addSubtract(duration, input, value, direction) {
        var other = create__createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add(input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract(input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === "month" ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function duration_as__valueOf() {
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms");
    var asSeconds = makeAs("s");
    var asMinutes = makeAs("m");
    var asHours = makeAs("h");
    var asDays = makeAs("d");
    var asWeeks = makeAs("w");
    var asMonths = makeAs("M");
    var asYears = makeAs("y");
    function duration_get__get(units) {
        units = normalizeUnits(units);
        return this[units + "s"]();
    }
    function makeGetter(name) {
        return function() {
            return this._data[name];
        };
    }
    var milliseconds = makeGetter("milliseconds");
    var seconds = makeGetter("seconds");
    var minutes = makeGetter("minutes");
    var hours = makeGetter("hours");
    var days = makeGetter("days");
    var months = makeGetter("months");
    var years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round;
    var thresholds = {
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11 // months to year
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function duration_humanize__relativeTime(posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds = round(duration.as("s"));
        var minutes = round(duration.as("m"));
        var hours = round(duration.as("h"));
        var days = round(duration.as("d"));
        var months = round(duration.as("M"));
        var years = round(duration.as("y"));
        var a = seconds < thresholds.s && [
            "s",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ] || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        return true;
    }
    function humanize(withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var iso_string__abs = Math.abs;
    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days = iso_string__abs(this._days);
        var months = iso_string__abs(this._months);
        var minutes, hours, years;
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        return (total < 0 ? "-" : "") + "P" + (Y ? Y + "Y" : "") + (M ? M + "M" : "") + (D ? D + "D" : "") + (h || m || s ? "T" : "") + (h ? h + "H" : "") + (m ? m + "M" : "") + (s ? s + "S" : "");
    }
    var duration_prototype__proto = Duration.prototype;
    duration_prototype__proto.abs = duration_abs__abs;
    duration_prototype__proto.add = duration_add_subtract__add;
    duration_prototype__proto.subtract = duration_add_subtract__subtract;
    duration_prototype__proto.as = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds = asSeconds;
    duration_prototype__proto.asMinutes = asMinutes;
    duration_prototype__proto.asHours = asHours;
    duration_prototype__proto.asDays = asDays;
    duration_prototype__proto.asWeeks = asWeeks;
    duration_prototype__proto.asMonths = asMonths;
    duration_prototype__proto.asYears = asYears;
    duration_prototype__proto.valueOf = duration_as__valueOf;
    duration_prototype__proto._bubble = bubble;
    duration_prototype__proto.get = duration_get__get;
    duration_prototype__proto.milliseconds = milliseconds;
    duration_prototype__proto.seconds = seconds;
    duration_prototype__proto.minutes = minutes;
    duration_prototype__proto.hours = hours;
    duration_prototype__proto.days = days;
    duration_prototype__proto.weeks = weeks;
    duration_prototype__proto.months = months;
    duration_prototype__proto.years = years;
    duration_prototype__proto.humanize = humanize;
    duration_prototype__proto.toISOString = iso_string__toISOString;
    duration_prototype__proto.toString = iso_string__toISOString;
    duration_prototype__proto.toJSON = iso_string__toISOString;
    duration_prototype__proto.locale = locale;
    duration_prototype__proto.localeData = localeData;
    // Deprecations
    duration_prototype__proto.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", iso_string__toISOString);
    duration_prototype__proto.lang = lang;
    // Side effect imports
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    // Side effect imports
    utils_hooks__hooks.version = "2.14.1";
    setHookCallback(local__createLocal);
    utils_hooks__hooks.fn = momentPrototype;
    utils_hooks__hooks.min = min;
    utils_hooks__hooks.max = max;
    utils_hooks__hooks.now = now;
    utils_hooks__hooks.utc = create_utc__createUTC;
    utils_hooks__hooks.unix = moment__createUnix;
    utils_hooks__hooks.months = lists__listMonths;
    utils_hooks__hooks.isDate = isDate;
    utils_hooks__hooks.locale = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid = valid__createInvalid;
    utils_hooks__hooks.duration = create__createDuration;
    utils_hooks__hooks.isMoment = isMoment;
    utils_hooks__hooks.weekdays = lists__listWeekdays;
    utils_hooks__hooks.parseZone = moment__createInZone;
    utils_hooks__hooks.localeData = locale_locales__getLocale;
    utils_hooks__hooks.isDuration = isDuration;
    utils_hooks__hooks.monthsShort = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale = defineLocale;
    utils_hooks__hooks.updateLocale = updateLocale;
    utils_hooks__hooks.locales = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat = getCalendarFormat;
    utils_hooks__hooks.prototype = momentPrototype;
    var _moment = utils_hooks__hooks;
    return _moment;
});

},{}],"bxMK1":[function(require,module,exports) {
"use strict";
module.exports = require("d36460a48c4688e0");

},{"d36460a48c4688e0":"1l1Zv"}],"1l1Zv":[function(require,module,exports) {
// Fine Uploader 5.16.2 - MIT licensed. http://fineuploader.com
(function(global) {
    (function($1) {
        "use strict";
        var $el1, pluginOptions1 = [
            "uploaderType",
            "endpointType"
        ];
        function init1(options1) {
            var xformedOpts1 = transformVariables1(options1 || {}), newUploaderInstance1 = getNewUploaderInstance1(xformedOpts1);
            uploader1(newUploaderInstance1);
            addCallbacks1(xformedOpts1, newUploaderInstance1);
            return $el1;
        }
        function getNewUploaderInstance1(params1) {
            var uploaderType1 = pluginOption1("uploaderType"), namespace1 = pluginOption1("endpointType");
            if (uploaderType1) {
                uploaderType1 = uploaderType1.charAt(0).toUpperCase() + uploaderType1.slice(1).toLowerCase();
                if (namespace1) return new qq[namespace1]["FineUploader" + uploaderType1](params1);
                return new qq["FineUploader" + uploaderType1](params1);
            } else {
                if (namespace1) return new qq[namespace1].FineUploader(params1);
                return new qq.FineUploader(params1);
            }
        }
        function dataStore1(key1, val1) {
            var data1 = $el1.data("fineuploader");
            if (val1) {
                if (data1 === undefined) data1 = {};
                data1[key1] = val1;
                $el1.data("fineuploader", data1);
            } else {
                if (data1 === undefined) return null;
                return data1[key1];
            }
        }
        function uploader1(instanceToStore1) {
            return dataStore1("uploader", instanceToStore1);
        }
        function pluginOption1(option1, optionVal1) {
            return dataStore1(option1, optionVal1);
        }
        function addCallbacks1(transformedOpts1, newUploaderInstance1) {
            var callbacks1 = transformedOpts1.callbacks = {};
            $1.each(newUploaderInstance1._options.callbacks, function(prop1, nonJqueryCallback1) {
                var name1, callbackEventTarget1;
                name1 = /^on(\w+)/.exec(prop1)[1];
                name1 = name1.substring(0, 1).toLowerCase() + name1.substring(1);
                callbackEventTarget1 = $el1;
                callbacks1[prop1] = function() {
                    var originalArgs1 = Array.prototype.slice.call(arguments), transformedArgs1 = [], nonJqueryCallbackRetVal1, jqueryEventCallbackRetVal1;
                    $1.each(originalArgs1, function(idx1, arg1) {
                        transformedArgs1.push(maybeWrapInJquery1(arg1));
                    });
                    nonJqueryCallbackRetVal1 = nonJqueryCallback1.apply(this, originalArgs1);
                    try {
                        jqueryEventCallbackRetVal1 = callbackEventTarget1.triggerHandler(name1, transformedArgs1);
                    } catch (error1) {
                        qq.log("Caught error in Fine Uploader jQuery event handler: " + error1.message, "error");
                    }
                    if (nonJqueryCallbackRetVal1 != null) return nonJqueryCallbackRetVal1;
                    return jqueryEventCallbackRetVal1;
                };
            });
            newUploaderInstance1._options.callbacks = callbacks1;
        }
        function transformVariables1(source1, dest1) {
            var xformed1, arrayVals1;
            if (dest1 === undefined) {
                if (source1.uploaderType !== "basic") xformed1 = {
                    element: $el1[0]
                };
                else xformed1 = {};
            } else xformed1 = dest1;
            $1.each(source1, function(prop1, val1) {
                if ($1.inArray(prop1, pluginOptions1) >= 0) pluginOption1(prop1, val1);
                else if (val1 instanceof $1) xformed1[prop1] = val1[0];
                else if ($1.isPlainObject(val1)) {
                    xformed1[prop1] = {};
                    transformVariables1(val1, xformed1[prop1]);
                } else if ($1.isArray(val1)) {
                    arrayVals1 = [];
                    $1.each(val1, function(idx1, arrayVal1) {
                        var arrayObjDest1 = {};
                        if (arrayVal1 instanceof $1) $1.merge(arrayVals1, arrayVal1);
                        else if ($1.isPlainObject(arrayVal1)) {
                            transformVariables1(arrayVal1, arrayObjDest1);
                            arrayVals1.push(arrayObjDest1);
                        } else arrayVals1.push(arrayVal1);
                    });
                    xformed1[prop1] = arrayVals1;
                } else xformed1[prop1] = val1;
            });
            if (dest1 === undefined) return xformed1;
        }
        function isValidCommand1(command1) {
            return $1.type(command1) === "string" && !command1.match(/^_/) && uploader1()[command1] !== undefined;
        }
        function delegateCommand1(command1) {
            var xformedArgs1 = [], origArgs1 = Array.prototype.slice.call(arguments, 1), retVal1;
            transformVariables1(origArgs1, xformedArgs1);
            retVal1 = uploader1()[command1].apply(uploader1(), xformedArgs1);
            return maybeWrapInJquery1(retVal1);
        }
        function maybeWrapInJquery1(val1) {
            var transformedVal1 = val1;
            if (val1 != null && typeof val1 === "object" && (val1.nodeType === 1 || val1.nodeType === 9) && val1.cloneNode) transformedVal1 = $1(val1);
            return transformedVal1;
        }
        $1.fn.fineUploader = function(optionsOrCommand1) {
            var self1 = this, selfArgs1 = arguments, retVals1 = [];
            this.each(function(index1, el1) {
                $el1 = $1(el1);
                if (uploader1() && isValidCommand1(optionsOrCommand1)) {
                    retVals1.push(delegateCommand1.apply(self1, selfArgs1));
                    if (self1.length === 1) return false;
                } else if (typeof optionsOrCommand1 === "object" || !optionsOrCommand1) init1.apply(self1, selfArgs1);
                else $1.error("Method " + optionsOrCommand1 + " does not exist on jQuery.fineUploader");
            });
            if (retVals1.length === 1) return retVals1[0];
            else if (retVals1.length > 1) return retVals1;
            return this;
        };
    })(jQuery);
    (function($1) {
        "use strict";
        var rootDataKey1 = "fineUploaderDnd", $el1;
        function init1(options1) {
            if (!options1) options1 = {};
            options1.dropZoneElements = [
                $el1
            ];
            var xformedOpts1 = transformVariables1(options1);
            addCallbacks1(xformedOpts1);
            dnd1(new qq.DragAndDrop(xformedOpts1));
            return $el1;
        }
        function dataStore1(key1, val1) {
            var data1 = $el1.data(rootDataKey1);
            if (val1) {
                if (data1 === undefined) data1 = {};
                data1[key1] = val1;
                $el1.data(rootDataKey1, data1);
            } else {
                if (data1 === undefined) return null;
                return data1[key1];
            }
        }
        function dnd1(instanceToStore1) {
            return dataStore1("dndInstance", instanceToStore1);
        }
        function addCallbacks1(transformedOpts1) {
            var callbacks1 = transformedOpts1.callbacks = {};
            $1.each(new qq.DragAndDrop.callbacks(), function(prop1, func1) {
                var name1 = prop1, $callbackEl1;
                $callbackEl1 = $el1;
                callbacks1[prop1] = function() {
                    var args1 = Array.prototype.slice.call(arguments), jqueryHandlerResult1 = $callbackEl1.triggerHandler(name1, args1);
                    return jqueryHandlerResult1;
                };
            });
        }
        function transformVariables1(source1, dest1) {
            var xformed1, arrayVals1;
            if (dest1 === undefined) xformed1 = {};
            else xformed1 = dest1;
            $1.each(source1, function(prop1, val1) {
                if (val1 instanceof $1) xformed1[prop1] = val1[0];
                else if ($1.isPlainObject(val1)) {
                    xformed1[prop1] = {};
                    transformVariables1(val1, xformed1[prop1]);
                } else if ($1.isArray(val1)) {
                    arrayVals1 = [];
                    $1.each(val1, function(idx1, arrayVal1) {
                        if (arrayVal1 instanceof $1) $1.merge(arrayVals1, arrayVal1);
                        else arrayVals1.push(arrayVal1);
                    });
                    xformed1[prop1] = arrayVals1;
                } else xformed1[prop1] = val1;
            });
            if (dest1 === undefined) return xformed1;
        }
        function isValidCommand1(command1) {
            return $1.type(command1) === "string" && command1 === "dispose" && dnd1()[command1] !== undefined;
        }
        function delegateCommand1(command1) {
            var xformedArgs1 = [], origArgs1 = Array.prototype.slice.call(arguments, 1);
            transformVariables1(origArgs1, xformedArgs1);
            return dnd1()[command1].apply(dnd1(), xformedArgs1);
        }
        $1.fn.fineUploaderDnd = function(optionsOrCommand1) {
            var self1 = this, selfArgs1 = arguments, retVals1 = [];
            this.each(function(index1, el1) {
                $el1 = $1(el1);
                if (dnd1() && isValidCommand1(optionsOrCommand1)) {
                    retVals1.push(delegateCommand1.apply(self1, selfArgs1));
                    if (self1.length === 1) return false;
                } else if (typeof optionsOrCommand1 === "object" || !optionsOrCommand1) init1.apply(self1, selfArgs1);
                else $1.error("Method " + optionsOrCommand1 + " does not exist in Fine Uploader's DnD module.");
            });
            if (retVals1.length === 1) return retVals1[0];
            else if (retVals1.length > 1) return retVals1;
            return this;
        };
    })(jQuery);
    (function($1) {
        "use strict";
        $1.fn.fineUploaderS3 = function(optionsOrCommand1) {
            if (typeof optionsOrCommand1 === "object") optionsOrCommand1.endpointType = "s3";
            return $1.fn.fineUploader.apply(this, arguments);
        };
    })(jQuery);
    var qq = function(element1) {
        "use strict";
        return {
            hide: function() {
                element1.style.display = "none";
                return this;
            },
            attach: function(type1, fn1) {
                if (element1.addEventListener) element1.addEventListener(type1, fn1, false);
                else if (element1.attachEvent) element1.attachEvent("on" + type1, fn1);
                return function() {
                    qq(element1).detach(type1, fn1);
                };
            },
            detach: function(type1, fn1) {
                if (element1.removeEventListener) element1.removeEventListener(type1, fn1, false);
                else if (element1.attachEvent) element1.detachEvent("on" + type1, fn1);
                return this;
            },
            contains: function(descendant1) {
                if (!descendant1) return false;
                if (element1 === descendant1) return true;
                if (element1.contains) return element1.contains(descendant1);
                else return !!(descendant1.compareDocumentPosition(element1) & 8);
            },
            insertBefore: function(elementB1) {
                elementB1.parentNode.insertBefore(element1, elementB1);
                return this;
            },
            remove: function() {
                element1.parentNode.removeChild(element1);
                return this;
            },
            css: function(styles1) {
                if (element1.style == null) throw new qq.Error("Can't apply style to node as it is not on the HTMLElement prototype chain!");
                if (styles1.opacity != null) {
                    if (typeof element1.style.opacity !== "string" && typeof element1.filters !== "undefined") styles1.filter = "alpha(opacity=" + Math.round(100 * styles1.opacity) + ")";
                }
                qq.extend(element1.style, styles1);
                return this;
            },
            hasClass: function(name1, considerParent1) {
                var re1 = new RegExp("(^| )" + name1 + "( |$)");
                return re1.test(element1.className) || !!(considerParent1 && re1.test(element1.parentNode.className));
            },
            addClass: function(name1) {
                if (!qq(element1).hasClass(name1)) element1.className += " " + name1;
                return this;
            },
            removeClass: function(name1) {
                var re1 = new RegExp("(^| )" + name1 + "( |$)");
                element1.className = element1.className.replace(re1, " ").replace(/^\s+|\s+$/g, "");
                return this;
            },
            getByClass: function(className1, first1) {
                var candidates1, result1 = [];
                if (first1 && element1.querySelector) return element1.querySelector("." + className1);
                else if (element1.querySelectorAll) return element1.querySelectorAll("." + className1);
                candidates1 = element1.getElementsByTagName("*");
                qq.each(candidates1, function(idx1, val1) {
                    if (qq(val1).hasClass(className1)) result1.push(val1);
                });
                return first1 ? result1[0] : result1;
            },
            getFirstByClass: function(className1) {
                return qq(element1).getByClass(className1, true);
            },
            children: function() {
                var children1 = [], child1 = element1.firstChild;
                while(child1){
                    if (child1.nodeType === 1) children1.push(child1);
                    child1 = child1.nextSibling;
                }
                return children1;
            },
            setText: function(text1) {
                element1.innerText = text1;
                element1.textContent = text1;
                return this;
            },
            clearText: function() {
                return qq(element1).setText("");
            },
            hasAttribute: function(attrName1) {
                var attrVal1;
                if (element1.hasAttribute) {
                    if (!element1.hasAttribute(attrName1)) return false;
                    return /^false$/i.exec(element1.getAttribute(attrName1)) == null;
                } else {
                    attrVal1 = element1[attrName1];
                    if (attrVal1 === undefined) return false;
                    return /^false$/i.exec(attrVal1) == null;
                }
            }
        };
    };
    (function() {
        "use strict";
        qq.canvasToBlob = function(canvas1, mime1, quality1) {
            return qq.dataUriToBlob(canvas1.toDataURL(mime1, quality1));
        };
        qq.dataUriToBlob = function(dataUri1) {
            var arrayBuffer1, byteString1, createBlob1 = function(data1, mime1) {
                var BlobBuilder1 = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder1 = BlobBuilder1 && new BlobBuilder1();
                if (blobBuilder1) {
                    blobBuilder1.append(data1);
                    return blobBuilder1.getBlob(mime1);
                } else return new Blob([
                    data1
                ], {
                    type: mime1
                });
            }, intArray1, mimeString1;
            if (dataUri1.split(",")[0].indexOf("base64") >= 0) byteString1 = atob(dataUri1.split(",")[1]);
            else byteString1 = decodeURI(dataUri1.split(",")[1]);
            mimeString1 = dataUri1.split(",")[0].split(":")[1].split(";")[0];
            arrayBuffer1 = new ArrayBuffer(byteString1.length);
            intArray1 = new Uint8Array(arrayBuffer1);
            qq.each(byteString1, function(idx1, character1) {
                intArray1[idx1] = character1.charCodeAt(0);
            });
            return createBlob1(arrayBuffer1, mimeString1);
        };
        qq.log = function(message1, level1) {
            if (window.console) {
                if (!level1 || level1 === "info") window.console.log(message1);
                else if (window.console[level1]) window.console[level1](message1);
                else window.console.log("<" + level1 + "> " + message1);
            }
        };
        qq.isObject = function(variable1) {
            return variable1 && !variable1.nodeType && Object.prototype.toString.call(variable1) === "[object Object]";
        };
        qq.isFunction = function(variable1) {
            return typeof variable1 === "function";
        };
        qq.isArray = function(value1) {
            return Object.prototype.toString.call(value1) === "[object Array]" || value1 && window.ArrayBuffer && value1.buffer && value1.buffer.constructor === ArrayBuffer;
        };
        qq.isItemList = function(maybeItemList1) {
            return Object.prototype.toString.call(maybeItemList1) === "[object DataTransferItemList]";
        };
        qq.isNodeList = function(maybeNodeList1) {
            return Object.prototype.toString.call(maybeNodeList1) === "[object NodeList]" || maybeNodeList1.item && maybeNodeList1.namedItem;
        };
        qq.isString = function(maybeString1) {
            return Object.prototype.toString.call(maybeString1) === "[object String]";
        };
        qq.trimStr = function(string1) {
            if (String.prototype.trim) return string1.trim();
            return string1.replace(/^\s+|\s+$/g, "");
        };
        qq.format = function(str1) {
            var args1 = Array.prototype.slice.call(arguments, 1), newStr1 = str1, nextIdxToReplace1 = newStr1.indexOf("{}");
            qq.each(args1, function(idx1, val1) {
                var strBefore1 = newStr1.substring(0, nextIdxToReplace1), strAfter1 = newStr1.substring(nextIdxToReplace1 + 2);
                newStr1 = strBefore1 + val1 + strAfter1;
                nextIdxToReplace1 = newStr1.indexOf("{}", nextIdxToReplace1 + val1.length);
                if (nextIdxToReplace1 < 0) return false;
            });
            return newStr1;
        };
        qq.isFile = function(maybeFile1) {
            return window.File && Object.prototype.toString.call(maybeFile1) === "[object File]";
        };
        qq.isFileList = function(maybeFileList1) {
            return window.FileList && Object.prototype.toString.call(maybeFileList1) === "[object FileList]";
        };
        qq.isFileOrInput = function(maybeFileOrInput1) {
            return qq.isFile(maybeFileOrInput1) || qq.isInput(maybeFileOrInput1);
        };
        qq.isInput = function(maybeInput1, notFile1) {
            var evaluateType1 = function(type1) {
                var normalizedType1 = type1.toLowerCase();
                if (notFile1) return normalizedType1 !== "file";
                return normalizedType1 === "file";
            };
            if (window.HTMLInputElement) {
                if (Object.prototype.toString.call(maybeInput1) === "[object HTMLInputElement]") {
                    if (maybeInput1.type && evaluateType1(maybeInput1.type)) return true;
                }
            }
            if (maybeInput1.tagName) {
                if (maybeInput1.tagName.toLowerCase() === "input") {
                    if (maybeInput1.type && evaluateType1(maybeInput1.type)) return true;
                }
            }
            return false;
        };
        qq.isBlob = function(maybeBlob1) {
            if (window.Blob && Object.prototype.toString.call(maybeBlob1) === "[object Blob]") return true;
        };
        qq.isXhrUploadSupported = function() {
            var input1 = document.createElement("input");
            input1.type = "file";
            return input1.multiple !== undefined && typeof File !== "undefined" && typeof FormData !== "undefined" && typeof qq.createXhrInstance().upload !== "undefined";
        };
        qq.createXhrInstance = function() {
            if (window.XMLHttpRequest) return new XMLHttpRequest();
            try {
                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
            } catch (error1) {
                qq.log("Neither XHR or ActiveX are supported!", "error");
                return null;
            }
        };
        qq.isFolderDropSupported = function(dataTransfer1) {
            return dataTransfer1.items && dataTransfer1.items.length > 0 && dataTransfer1.items[0].webkitGetAsEntry;
        };
        qq.isFileChunkingSupported = function() {
            return !qq.androidStock() && qq.isXhrUploadSupported() && (File.prototype.slice !== undefined || File.prototype.webkitSlice !== undefined || File.prototype.mozSlice !== undefined);
        };
        qq.sliceBlob = function(fileOrBlob1, start1, end1) {
            var slicer1 = fileOrBlob1.slice || fileOrBlob1.mozSlice || fileOrBlob1.webkitSlice;
            return slicer1.call(fileOrBlob1, start1, end1);
        };
        qq.arrayBufferToHex = function(buffer1) {
            var bytesAsHex1 = "", bytes1 = new Uint8Array(buffer1);
            qq.each(bytes1, function(idx1, byt1) {
                var byteAsHexStr1 = byt1.toString(16);
                if (byteAsHexStr1.length < 2) byteAsHexStr1 = "0" + byteAsHexStr1;
                bytesAsHex1 += byteAsHexStr1;
            });
            return bytesAsHex1;
        };
        qq.readBlobToHex = function(blob1, startOffset1, length1) {
            var initialBlob1 = qq.sliceBlob(blob1, startOffset1, startOffset1 + length1), fileReader1 = new FileReader(), promise1 = new qq.Promise();
            fileReader1.onload = function() {
                promise1.success(qq.arrayBufferToHex(fileReader1.result));
            };
            fileReader1.onerror = promise1.failure;
            fileReader1.readAsArrayBuffer(initialBlob1);
            return promise1;
        };
        qq.extend = function(first1, second1, extendNested1) {
            qq.each(second1, function(prop1, val1) {
                if (extendNested1 && qq.isObject(val1)) {
                    if (first1[prop1] === undefined) first1[prop1] = {};
                    qq.extend(first1[prop1], val1, true);
                } else first1[prop1] = val1;
            });
            return first1;
        };
        qq.override = function(target1, sourceFn1) {
            var super_1 = {}, source1 = sourceFn1(super_1);
            qq.each(source1, function(srcPropName1, srcPropVal1) {
                if (target1[srcPropName1] !== undefined) super_1[srcPropName1] = target1[srcPropName1];
                target1[srcPropName1] = srcPropVal1;
            });
            return target1;
        };
        qq.indexOf = function(arr1, elt1, from1) {
            if (arr1.indexOf) return arr1.indexOf(elt1, from1);
            from1 = from1 || 0;
            var len1 = arr1.length;
            if (from1 < 0) from1 += len1;
            for(; from1 < len1; from1 += 1){
                if (arr1.hasOwnProperty(from1) && arr1[from1] === elt1) return from1;
            }
            return -1;
        };
        qq.getUniqueId = function() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c1) {
                var r1 = Math.random() * 16 | 0, v1 = c1 == "x" ? r1 : r1 & 3 | 8;
                return v1.toString(16);
            });
        };
        qq.ie = function() {
            return navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf("Trident") !== -1;
        };
        qq.ie7 = function() {
            return navigator.userAgent.indexOf("MSIE 7") !== -1;
        };
        qq.ie8 = function() {
            return navigator.userAgent.indexOf("MSIE 8") !== -1;
        };
        qq.ie10 = function() {
            return navigator.userAgent.indexOf("MSIE 10") !== -1;
        };
        qq.ie11 = function() {
            return qq.ie() && navigator.userAgent.indexOf("rv:11") !== -1;
        };
        qq.edge = function() {
            return navigator.userAgent.indexOf("Edge") >= 0;
        };
        qq.safari = function() {
            return navigator.vendor !== undefined && navigator.vendor.indexOf("Apple") !== -1;
        };
        qq.chrome = function() {
            return navigator.vendor !== undefined && navigator.vendor.indexOf("Google") !== -1;
        };
        qq.opera = function() {
            return navigator.vendor !== undefined && navigator.vendor.indexOf("Opera") !== -1;
        };
        qq.firefox = function() {
            return !qq.edge() && !qq.ie11() && navigator.userAgent.indexOf("Mozilla") !== -1 && navigator.vendor !== undefined && navigator.vendor === "";
        };
        qq.windows = function() {
            return navigator.platform === "Win32";
        };
        qq.android = function() {
            return navigator.userAgent.toLowerCase().indexOf("android") !== -1;
        };
        qq.androidStock = function() {
            return qq.android() && navigator.userAgent.toLowerCase().indexOf("chrome") < 0;
        };
        qq.ios6 = function() {
            return qq.ios() && navigator.userAgent.indexOf(" OS 6_") !== -1;
        };
        qq.ios7 = function() {
            return qq.ios() && navigator.userAgent.indexOf(" OS 7_") !== -1;
        };
        qq.ios8 = function() {
            return qq.ios() && navigator.userAgent.indexOf(" OS 8_") !== -1;
        };
        qq.ios800 = function() {
            return qq.ios() && navigator.userAgent.indexOf(" OS 8_0 ") !== -1;
        };
        qq.ios = function() {
            return navigator.userAgent.indexOf("iPad") !== -1 || navigator.userAgent.indexOf("iPod") !== -1 || navigator.userAgent.indexOf("iPhone") !== -1;
        };
        qq.iosChrome = function() {
            return qq.ios() && navigator.userAgent.indexOf("CriOS") !== -1;
        };
        qq.iosSafari = function() {
            return qq.ios() && !qq.iosChrome() && navigator.userAgent.indexOf("Safari") !== -1;
        };
        qq.iosSafariWebView = function() {
            return qq.ios() && !qq.iosChrome() && !qq.iosSafari();
        };
        qq.preventDefault = function(e1) {
            if (e1.preventDefault) e1.preventDefault();
            else e1.returnValue = false;
        };
        qq.toElement = function() {
            var div1 = document.createElement("div");
            return function(html1) {
                div1.innerHTML = html1;
                var element1 = div1.firstChild;
                div1.removeChild(element1);
                return element1;
            };
        }();
        qq.each = function(iterableItem1, callback1) {
            var keyOrIndex1, retVal1;
            if (iterableItem1) {
                if (window.Storage && iterableItem1.constructor === window.Storage) for(keyOrIndex1 = 0; keyOrIndex1 < iterableItem1.length; keyOrIndex1++){
                    retVal1 = callback1(iterableItem1.key(keyOrIndex1), iterableItem1.getItem(iterableItem1.key(keyOrIndex1)));
                    if (retVal1 === false) break;
                }
                else if (qq.isArray(iterableItem1) || qq.isItemList(iterableItem1) || qq.isNodeList(iterableItem1)) for(keyOrIndex1 = 0; keyOrIndex1 < iterableItem1.length; keyOrIndex1++){
                    retVal1 = callback1(keyOrIndex1, iterableItem1[keyOrIndex1]);
                    if (retVal1 === false) break;
                }
                else if (qq.isString(iterableItem1)) for(keyOrIndex1 = 0; keyOrIndex1 < iterableItem1.length; keyOrIndex1++){
                    retVal1 = callback1(keyOrIndex1, iterableItem1.charAt(keyOrIndex1));
                    if (retVal1 === false) break;
                }
                else {
                    for(keyOrIndex1 in iterableItem1)if (Object.prototype.hasOwnProperty.call(iterableItem1, keyOrIndex1)) {
                        retVal1 = callback1(keyOrIndex1, iterableItem1[keyOrIndex1]);
                        if (retVal1 === false) break;
                    }
                }
            }
        };
        qq.bind = function(oldFunc1, context1) {
            if (qq.isFunction(oldFunc1)) {
                var args1 = Array.prototype.slice.call(arguments, 2);
                return function() {
                    var newArgs1 = qq.extend([], args1);
                    if (arguments.length) newArgs1 = newArgs1.concat(Array.prototype.slice.call(arguments));
                    return oldFunc1.apply(context1, newArgs1);
                };
            }
            throw new Error("first parameter must be a function!");
        };
        qq.obj2url = function(obj1, temp1, prefixDone1) {
            var uristrings1 = [], prefix1 = "&", add1 = function(nextObj1, i1) {
                var nextTemp1 = temp1 ? /\[\]$/.test(temp1) ? temp1 : temp1 + "[" + i1 + "]" : i1;
                if (nextTemp1 !== "undefined" && i1 !== "undefined") uristrings1.push(typeof nextObj1 === "object" ? qq.obj2url(nextObj1, nextTemp1, true) : Object.prototype.toString.call(nextObj1) === "[object Function]" ? encodeURIComponent(nextTemp1) + "=" + encodeURIComponent(nextObj1()) : encodeURIComponent(nextTemp1) + "=" + encodeURIComponent(nextObj1));
            };
            if (!prefixDone1 && temp1) {
                prefix1 = /\?/.test(temp1) ? /\?$/.test(temp1) ? "" : "&" : "?";
                uristrings1.push(temp1);
                uristrings1.push(qq.obj2url(obj1));
            } else if (Object.prototype.toString.call(obj1) === "[object Array]" && typeof obj1 !== "undefined") qq.each(obj1, function(idx1, val1) {
                add1(val1, idx1);
            });
            else if (typeof obj1 !== "undefined" && obj1 !== null && typeof obj1 === "object") qq.each(obj1, function(prop1, val1) {
                add1(val1, prop1);
            });
            else uristrings1.push(encodeURIComponent(temp1) + "=" + encodeURIComponent(obj1));
            if (temp1) return uristrings1.join(prefix1);
            else return uristrings1.join(prefix1).replace(/^&/, "").replace(/%20/g, "+");
        };
        qq.obj2FormData = function(obj1, formData1, arrayKeyName1) {
            if (!formData1) formData1 = new FormData();
            qq.each(obj1, function(key1, val1) {
                key1 = arrayKeyName1 ? arrayKeyName1 + "[" + key1 + "]" : key1;
                if (qq.isObject(val1)) qq.obj2FormData(val1, formData1, key1);
                else if (qq.isFunction(val1)) formData1.append(key1, val1());
                else formData1.append(key1, val1);
            });
            return formData1;
        };
        qq.obj2Inputs = function(obj1, form1) {
            var input1;
            if (!form1) form1 = document.createElement("form");
            qq.obj2FormData(obj1, {
                append: function(key1, val1) {
                    input1 = document.createElement("input");
                    input1.setAttribute("name", key1);
                    input1.setAttribute("value", val1);
                    form1.appendChild(input1);
                }
            });
            return form1;
        };
        qq.parseJson = function(json) {
            if (window.JSON && qq.isFunction(JSON.parse)) return JSON.parse(json);
            else return eval("(" + json + ")");
        };
        qq.getExtension = function(filename1) {
            var extIdx1 = filename1.lastIndexOf(".") + 1;
            if (extIdx1 > 0) return filename1.substr(extIdx1, filename1.length - extIdx1);
        };
        qq.getFilename = function(blobOrFileInput1) {
            if (qq.isInput(blobOrFileInput1)) return blobOrFileInput1.value.replace(/.*(\/|\\)/, "");
            else if (qq.isFile(blobOrFileInput1)) {
                if (blobOrFileInput1.fileName !== null && blobOrFileInput1.fileName !== undefined) return blobOrFileInput1.fileName;
            }
            return blobOrFileInput1.name;
        };
        qq.DisposeSupport = function() {
            var disposers1 = [];
            return {
                dispose: function() {
                    var disposer1;
                    do {
                        disposer1 = disposers1.shift();
                        if (disposer1) disposer1();
                    }while (disposer1);
                },
                attach: function() {
                    var args1 = arguments;
                    this.addDisposer(qq(args1[0]).attach.apply(this, Array.prototype.slice.call(arguments, 1)));
                },
                addDisposer: function(disposeFunction1) {
                    disposers1.push(disposeFunction1);
                }
            };
        };
    })();
    (function() {
        "use strict";
        if (typeof define === "function" && define.amd) define(function() {
            return qq;
        });
        else if (0, module.exports) module.exports = qq;
        else global.qq = qq;
    })();
    (function() {
        "use strict";
        qq.Error = function(message1) {
            this.message = "[Fine Uploader " + qq.version + "] " + message1;
        };
        qq.Error.prototype = new Error();
    })();
    qq.version = "5.16.2";
    qq.supportedFeatures = function() {
        "use strict";
        var supportsUploading1, supportsUploadingBlobs1, supportsFileDrop1, supportsAjaxFileUploading1, supportsFolderDrop1, supportsChunking1, supportsResume1, supportsUploadViaPaste1, supportsUploadCors1, supportsDeleteFileXdr1, supportsDeleteFileCorsXhr1, supportsDeleteFileCors1, supportsFolderSelection1, supportsImagePreviews1, supportsUploadProgress1;
        function testSupportsFileInputElement1() {
            var supported1 = true, tempInput1;
            try {
                tempInput1 = document.createElement("input");
                tempInput1.type = "file";
                qq(tempInput1).hide();
                if (tempInput1.disabled) supported1 = false;
            } catch (ex1) {
                supported1 = false;
            }
            return supported1;
        }
        function isChrome14OrHigher1() {
            return (qq.chrome() || qq.opera()) && navigator.userAgent.match(/Chrome\/[1][4-9]|Chrome\/[2-9][0-9]/) !== undefined;
        }
        function isCrossOriginXhrSupported1() {
            if (window.XMLHttpRequest) {
                var xhr1 = qq.createXhrInstance();
                return xhr1.withCredentials !== undefined;
            }
            return false;
        }
        function isXdrSupported1() {
            return window.XDomainRequest !== undefined;
        }
        function isCrossOriginAjaxSupported1() {
            if (isCrossOriginXhrSupported1()) return true;
            return isXdrSupported1();
        }
        function isFolderSelectionSupported1() {
            return document.createElement("input").webkitdirectory !== undefined;
        }
        function isLocalStorageSupported1() {
            try {
                return !!window.localStorage && qq.isFunction(window.localStorage.setItem);
            } catch (error1) {
                return false;
            }
        }
        function isDragAndDropSupported1() {
            var span1 = document.createElement("span");
            return ("draggable" in span1 || "ondragstart" in span1 && "ondrop" in span1) && !qq.android() && !qq.ios();
        }
        supportsUploading1 = testSupportsFileInputElement1();
        supportsAjaxFileUploading1 = supportsUploading1 && qq.isXhrUploadSupported();
        supportsUploadingBlobs1 = supportsAjaxFileUploading1 && !qq.androidStock();
        supportsFileDrop1 = supportsAjaxFileUploading1 && isDragAndDropSupported1();
        supportsFolderDrop1 = supportsFileDrop1 && function() {
            var input1 = document.createElement("input");
            input1.type = "file";
            return !!("webkitdirectory" in (input1 || document.querySelectorAll("input[type=file]")[0]));
        }();
        supportsChunking1 = supportsAjaxFileUploading1 && qq.isFileChunkingSupported();
        supportsResume1 = supportsAjaxFileUploading1 && supportsChunking1 && isLocalStorageSupported1();
        supportsUploadViaPaste1 = supportsAjaxFileUploading1 && isChrome14OrHigher1();
        supportsUploadCors1 = supportsUploading1 && (window.postMessage !== undefined || supportsAjaxFileUploading1);
        supportsDeleteFileCorsXhr1 = isCrossOriginXhrSupported1();
        supportsDeleteFileXdr1 = isXdrSupported1();
        supportsDeleteFileCors1 = isCrossOriginAjaxSupported1();
        supportsFolderSelection1 = isFolderSelectionSupported1();
        supportsImagePreviews1 = supportsAjaxFileUploading1 && window.FileReader !== undefined;
        supportsUploadProgress1 = function() {
            if (supportsAjaxFileUploading1) return !qq.androidStock() && !qq.iosChrome();
            return false;
        }();
        return {
            ajaxUploading: supportsAjaxFileUploading1,
            blobUploading: supportsUploadingBlobs1,
            canDetermineSize: supportsAjaxFileUploading1,
            chunking: supportsChunking1,
            deleteFileCors: supportsDeleteFileCors1,
            deleteFileCorsXdr: supportsDeleteFileXdr1,
            deleteFileCorsXhr: supportsDeleteFileCorsXhr1,
            dialogElement: !!window.HTMLDialogElement,
            fileDrop: supportsFileDrop1,
            folderDrop: supportsFolderDrop1,
            folderSelection: supportsFolderSelection1,
            imagePreviews: supportsImagePreviews1,
            imageValidation: supportsImagePreviews1,
            itemSizeValidation: supportsAjaxFileUploading1,
            pause: supportsChunking1,
            progressBar: supportsUploadProgress1,
            resume: supportsResume1,
            scaling: supportsImagePreviews1 && supportsUploadingBlobs1,
            tiffPreviews: qq.safari(),
            unlimitedScaledImageSize: !qq.ios(),
            uploading: supportsUploading1,
            uploadCors: supportsUploadCors1,
            uploadCustomHeaders: supportsAjaxFileUploading1,
            uploadNonMultipart: supportsAjaxFileUploading1,
            uploadViaPaste: supportsUploadViaPaste1
        };
    }();
    qq.isGenericPromise = function(maybePromise1) {
        "use strict";
        return !!(maybePromise1 && maybePromise1.then && qq.isFunction(maybePromise1.then));
    };
    qq.Promise = function() {
        "use strict";
        var successArgs1, failureArgs1, successCallbacks1 = [], failureCallbacks1 = [], doneCallbacks1 = [], state1 = 0;
        qq.extend(this, {
            then: function(onSuccess1, onFailure1) {
                if (state1 === 0) {
                    if (onSuccess1) successCallbacks1.push(onSuccess1);
                    if (onFailure1) failureCallbacks1.push(onFailure1);
                } else if (state1 === -1) onFailure1 && onFailure1.apply(null, failureArgs1);
                else if (onSuccess1) onSuccess1.apply(null, successArgs1);
                return this;
            },
            done: function(callback1) {
                if (state1 === 0) doneCallbacks1.push(callback1);
                else callback1.apply(null, failureArgs1 === undefined ? successArgs1 : failureArgs1);
                return this;
            },
            success: function() {
                state1 = 1;
                successArgs1 = arguments;
                if (successCallbacks1.length) qq.each(successCallbacks1, function(idx1, callback1) {
                    callback1.apply(null, successArgs1);
                });
                if (doneCallbacks1.length) qq.each(doneCallbacks1, function(idx1, callback1) {
                    callback1.apply(null, successArgs1);
                });
                return this;
            },
            failure: function() {
                state1 = -1;
                failureArgs1 = arguments;
                if (failureCallbacks1.length) qq.each(failureCallbacks1, function(idx1, callback1) {
                    callback1.apply(null, failureArgs1);
                });
                if (doneCallbacks1.length) qq.each(doneCallbacks1, function(idx1, callback1) {
                    callback1.apply(null, failureArgs1);
                });
                return this;
            }
        });
    };
    qq.BlobProxy = function(referenceBlob1, onCreate1) {
        "use strict";
        qq.extend(this, {
            referenceBlob: referenceBlob1,
            create: function() {
                return onCreate1(referenceBlob1);
            }
        });
    };
    qq.UploadButton = function(o1) {
        "use strict";
        var self1 = this, disposeSupport1 = new qq.DisposeSupport(), options1 = {
            acceptFiles: null,
            element: null,
            focusClass: "qq-upload-button-focus",
            folders: false,
            hoverClass: "qq-upload-button-hover",
            ios8BrowserCrashWorkaround: false,
            multiple: false,
            name: "qqfile",
            onChange: function(input1) {},
            title: null
        }, input1, buttonId1;
        qq.extend(options1, o1);
        buttonId1 = qq.getUniqueId();
        function createInput1() {
            var input1 = document.createElement("input");
            input1.setAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME, buttonId1);
            input1.setAttribute("title", options1.title);
            self1.setMultiple(options1.multiple, input1);
            if (options1.folders && qq.supportedFeatures.folderSelection) input1.setAttribute("webkitdirectory", "");
            if (options1.acceptFiles) input1.setAttribute("accept", options1.acceptFiles);
            input1.setAttribute("type", "file");
            input1.setAttribute("name", options1.name);
            qq(input1).css({
                position: "absolute",
                right: 0,
                top: 0,
                fontFamily: "Arial",
                fontSize: qq.ie() && !qq.ie8() ? "3500px" : "118px",
                margin: 0,
                padding: 0,
                cursor: "pointer",
                opacity: 0
            });
            !qq.ie7() && qq(input1).css({
                height: "100%"
            });
            options1.element.appendChild(input1);
            disposeSupport1.attach(input1, "change", function() {
                options1.onChange(input1);
            });
            disposeSupport1.attach(input1, "mouseover", function() {
                qq(options1.element).addClass(options1.hoverClass);
            });
            disposeSupport1.attach(input1, "mouseout", function() {
                qq(options1.element).removeClass(options1.hoverClass);
            });
            disposeSupport1.attach(input1, "focus", function() {
                qq(options1.element).addClass(options1.focusClass);
            });
            disposeSupport1.attach(input1, "blur", function() {
                qq(options1.element).removeClass(options1.focusClass);
            });
            return input1;
        }
        qq(options1.element).css({
            position: "relative",
            overflow: "hidden",
            direction: "ltr"
        });
        qq.extend(this, {
            getInput: function() {
                return input1;
            },
            getButtonId: function() {
                return buttonId1;
            },
            setMultiple: function(isMultiple1, optInput1) {
                var input1 = optInput1 || this.getInput();
                if (options1.ios8BrowserCrashWorkaround && qq.ios8() && (qq.iosChrome() || qq.iosSafariWebView())) input1.setAttribute("multiple", "");
                else if (isMultiple1) input1.setAttribute("multiple", "");
                else input1.removeAttribute("multiple");
            },
            setAcceptFiles: function(acceptFiles1) {
                if (acceptFiles1 !== options1.acceptFiles) input1.setAttribute("accept", acceptFiles1);
            },
            reset: function() {
                if (input1.parentNode) qq(input1).remove();
                qq(options1.element).removeClass(options1.focusClass);
                input1 = null;
                input1 = createInput1();
            }
        });
        input1 = createInput1();
    };
    qq.UploadButton.BUTTON_ID_ATTR_NAME = "qq-button-id";
    qq.UploadData = function(uploaderProxy1) {
        "use strict";
        var data1 = [], byUuid1 = {}, byStatus1 = {}, byProxyGroupId1 = {}, byBatchId1 = {};
        function getDataByIds1(idOrIds1) {
            if (qq.isArray(idOrIds1)) {
                var entries1 = [];
                qq.each(idOrIds1, function(idx1, id1) {
                    entries1.push(data1[id1]);
                });
                return entries1;
            }
            return data1[idOrIds1];
        }
        function getDataByUuids1(uuids1) {
            if (qq.isArray(uuids1)) {
                var entries1 = [];
                qq.each(uuids1, function(idx1, uuid1) {
                    entries1.push(data1[byUuid1[uuid1]]);
                });
                return entries1;
            }
            return data1[byUuid1[uuids1]];
        }
        function getDataByStatus1(status1) {
            var statusResults1 = [], statuses1 = [].concat(status1);
            qq.each(statuses1, function(index1, statusEnum1) {
                var statusResultIndexes1 = byStatus1[statusEnum1];
                if (statusResultIndexes1 !== undefined) qq.each(statusResultIndexes1, function(i1, dataIndex1) {
                    statusResults1.push(data1[dataIndex1]);
                });
            });
            return statusResults1;
        }
        qq.extend(this, {
            addFile: function(spec1) {
                var status1 = spec1.status || qq.status.SUBMITTING, id1 = data1.push({
                    name: spec1.name,
                    originalName: spec1.name,
                    uuid: spec1.uuid,
                    size: spec1.size == null ? -1 : spec1.size,
                    status: status1,
                    file: spec1.file
                }) - 1;
                if (spec1.batchId) {
                    data1[id1].batchId = spec1.batchId;
                    if (byBatchId1[spec1.batchId] === undefined) byBatchId1[spec1.batchId] = [];
                    byBatchId1[spec1.batchId].push(id1);
                }
                if (spec1.proxyGroupId) {
                    data1[id1].proxyGroupId = spec1.proxyGroupId;
                    if (byProxyGroupId1[spec1.proxyGroupId] === undefined) byProxyGroupId1[spec1.proxyGroupId] = [];
                    byProxyGroupId1[spec1.proxyGroupId].push(id1);
                }
                data1[id1].id = id1;
                byUuid1[spec1.uuid] = id1;
                if (byStatus1[status1] === undefined) byStatus1[status1] = [];
                byStatus1[status1].push(id1);
                spec1.onBeforeStatusChange && spec1.onBeforeStatusChange(id1);
                uploaderProxy1.onStatusChange(id1, null, status1);
                return id1;
            },
            retrieve: function(optionalFilter1) {
                if (qq.isObject(optionalFilter1) && data1.length) {
                    if (optionalFilter1.id !== undefined) return getDataByIds1(optionalFilter1.id);
                    else if (optionalFilter1.uuid !== undefined) return getDataByUuids1(optionalFilter1.uuid);
                    else if (optionalFilter1.status) return getDataByStatus1(optionalFilter1.status);
                } else return qq.extend([], data1, true);
            },
            removeFileRef: function(id1) {
                var record1 = getDataByIds1(id1);
                if (record1) delete record1.file;
            },
            reset: function() {
                data1 = [];
                byUuid1 = {};
                byStatus1 = {};
                byBatchId1 = {};
            },
            setStatus: function(id1, newStatus1) {
                var oldStatus1 = data1[id1].status, byStatusOldStatusIndex1 = qq.indexOf(byStatus1[oldStatus1], id1);
                byStatus1[oldStatus1].splice(byStatusOldStatusIndex1, 1);
                data1[id1].status = newStatus1;
                if (byStatus1[newStatus1] === undefined) byStatus1[newStatus1] = [];
                byStatus1[newStatus1].push(id1);
                uploaderProxy1.onStatusChange(id1, oldStatus1, newStatus1);
            },
            uuidChanged: function(id1, newUuid1) {
                var oldUuid1 = data1[id1].uuid;
                data1[id1].uuid = newUuid1;
                byUuid1[newUuid1] = id1;
                delete byUuid1[oldUuid1];
            },
            updateName: function(id1, newName1) {
                data1[id1].name = newName1;
            },
            updateSize: function(id1, newSize1) {
                data1[id1].size = newSize1;
            },
            setParentId: function(targetId1, parentId1) {
                data1[targetId1].parentId = parentId1;
            },
            getIdsInProxyGroup: function(id1) {
                var proxyGroupId1 = data1[id1].proxyGroupId;
                if (proxyGroupId1) return byProxyGroupId1[proxyGroupId1];
                return [];
            },
            getIdsInBatch: function(id1) {
                var batchId1 = data1[id1].batchId;
                return byBatchId1[batchId1];
            }
        });
    };
    qq.status = {
        SUBMITTING: "submitting",
        SUBMITTED: "submitted",
        REJECTED: "rejected",
        QUEUED: "queued",
        CANCELED: "canceled",
        PAUSED: "paused",
        UPLOADING: "uploading",
        UPLOAD_FINALIZING: "upload finalizing",
        UPLOAD_RETRYING: "retrying upload",
        UPLOAD_SUCCESSFUL: "upload successful",
        UPLOAD_FAILED: "upload failed",
        DELETE_FAILED: "delete failed",
        DELETING: "deleting",
        DELETED: "deleted"
    };
    (function() {
        "use strict";
        qq.basePublicApi = {
            addBlobs: function(blobDataOrArray1, params1, endpoint1) {
                this.addFiles(blobDataOrArray1, params1, endpoint1);
            },
            addInitialFiles: function(cannedFileList1) {
                var self1 = this;
                qq.each(cannedFileList1, function(index1, cannedFile1) {
                    self1._addCannedFile(cannedFile1);
                });
            },
            addFiles: function(data1, params1, endpoint1) {
                this._maybeHandleIos8SafariWorkaround();
                var batchId1 = this._storedIds.length === 0 ? qq.getUniqueId() : this._currentBatchId, processBlob1 = qq.bind(function(blob1) {
                    this._handleNewFile({
                        blob: blob1,
                        name: this._options.blobs.defaultName
                    }, batchId1, verifiedFiles1);
                }, this), processBlobData1 = qq.bind(function(blobData1) {
                    this._handleNewFile(blobData1, batchId1, verifiedFiles1);
                }, this), processCanvas1 = qq.bind(function(canvas1) {
                    var blob1 = qq.canvasToBlob(canvas1);
                    this._handleNewFile({
                        blob: blob1,
                        name: this._options.blobs.defaultName + ".png"
                    }, batchId1, verifiedFiles1);
                }, this), processCanvasData1 = qq.bind(function(canvasData1) {
                    var normalizedQuality1 = canvasData1.quality && canvasData1.quality / 100, blob1 = qq.canvasToBlob(canvasData1.canvas, canvasData1.type, normalizedQuality1);
                    this._handleNewFile({
                        blob: blob1,
                        name: canvasData1.name
                    }, batchId1, verifiedFiles1);
                }, this), processFileOrInput1 = qq.bind(function(fileOrInput1) {
                    if (qq.isInput(fileOrInput1) && qq.supportedFeatures.ajaxUploading) {
                        var files1 = Array.prototype.slice.call(fileOrInput1.files), self1 = this;
                        qq.each(files1, function(idx1, file1) {
                            self1._handleNewFile(file1, batchId1, verifiedFiles1);
                        });
                    } else this._handleNewFile(fileOrInput1, batchId1, verifiedFiles1);
                }, this), normalizeData1 = function() {
                    if (qq.isFileList(data1)) data1 = Array.prototype.slice.call(data1);
                    data1 = [].concat(data1);
                }, self1 = this, verifiedFiles1 = [];
                this._currentBatchId = batchId1;
                if (data1) {
                    normalizeData1();
                    qq.each(data1, function(idx1, fileContainer1) {
                        if (qq.isFileOrInput(fileContainer1)) processFileOrInput1(fileContainer1);
                        else if (qq.isBlob(fileContainer1)) processBlob1(fileContainer1);
                        else if (qq.isObject(fileContainer1)) {
                            if (fileContainer1.blob && fileContainer1.name) processBlobData1(fileContainer1);
                            else if (fileContainer1.canvas && fileContainer1.name) processCanvasData1(fileContainer1);
                        } else if (fileContainer1.tagName && fileContainer1.tagName.toLowerCase() === "canvas") processCanvas1(fileContainer1);
                        else self1.log(fileContainer1 + " is not a valid file container!  Ignoring!", "warn");
                    });
                    this.log("Received " + verifiedFiles1.length + " files.");
                    this._prepareItemsForUpload(verifiedFiles1, params1, endpoint1);
                }
            },
            cancel: function(id1) {
                var uploadData1 = this._uploadData.retrieve({
                    id: id1
                });
                if (uploadData1 && uploadData1.status === qq.status.UPLOAD_FINALIZING) this.log(qq.format("Ignoring cancel for file ID {} ({}).  Finalizing upload.", id1, this.getName(id1)), "error");
                else this._handler.cancel(id1);
            },
            cancelAll: function() {
                var storedIdsCopy1 = [], self1 = this;
                qq.extend(storedIdsCopy1, this._storedIds);
                qq.each(storedIdsCopy1, function(idx1, storedFileId1) {
                    self1.cancel(storedFileId1);
                });
                this._handler.cancelAll();
            },
            clearStoredFiles: function() {
                this._storedIds = [];
            },
            continueUpload: function(id1) {
                var uploadData1 = this._uploadData.retrieve({
                    id: id1
                });
                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) return false;
                if (uploadData1.status === qq.status.PAUSED) {
                    this.log(qq.format("Paused file ID {} ({}) will be continued.  Not paused.", id1, this.getName(id1)));
                    this._uploadFile(id1);
                    return true;
                } else this.log(qq.format("Ignoring continue for file ID {} ({}).  Not paused.", id1, this.getName(id1)), "error");
                return false;
            },
            deleteFile: function(id1) {
                return this._onSubmitDelete(id1);
            },
            doesExist: function(fileOrBlobId1) {
                return this._handler.isValid(fileOrBlobId1);
            },
            drawThumbnail: function(fileId1, imgOrCanvas1, maxSize1, fromServer1, customResizeFunction1) {
                var promiseToReturn1 = new qq.Promise(), fileOrUrl1, options1;
                if (this._imageGenerator) {
                    fileOrUrl1 = this._thumbnailUrls[fileId1];
                    options1 = {
                        customResizeFunction: customResizeFunction1,
                        maxSize: maxSize1 > 0 ? maxSize1 : null,
                        scale: maxSize1 > 0
                    };
                    if (!fromServer1 && qq.supportedFeatures.imagePreviews) fileOrUrl1 = this.getFile(fileId1);
                    if (fileOrUrl1 == null) promiseToReturn1.failure({
                        container: imgOrCanvas1,
                        error: "File or URL not found."
                    });
                    else this._imageGenerator.generate(fileOrUrl1, imgOrCanvas1, options1).then(function success1(modifiedContainer1) {
                        promiseToReturn1.success(modifiedContainer1);
                    }, function failure1(container1, reason1) {
                        promiseToReturn1.failure({
                            container: container1,
                            error: reason1 || "Problem generating thumbnail"
                        });
                    });
                } else promiseToReturn1.failure({
                    container: imgOrCanvas1,
                    error: "Missing image generator module"
                });
                return promiseToReturn1;
            },
            getButton: function(fileId1) {
                return this._getButton(this._buttonIdsForFileIds[fileId1]);
            },
            getEndpoint: function(fileId1) {
                return this._endpointStore.get(fileId1);
            },
            getFile: function(fileOrBlobId1) {
                var file1 = this._handler.getFile(fileOrBlobId1);
                var uploadDataRecord1;
                if (!file1) {
                    uploadDataRecord1 = this._uploadData.retrieve({
                        id: fileOrBlobId1
                    });
                    if (uploadDataRecord1) file1 = uploadDataRecord1.file;
                }
                return file1 || null;
            },
            getInProgress: function() {
                return this._uploadData.retrieve({
                    status: [
                        qq.status.UPLOADING,
                        qq.status.UPLOAD_RETRYING,
                        qq.status.QUEUED
                    ]
                }).length;
            },
            getName: function(id1) {
                return this._uploadData.retrieve({
                    id: id1
                }).name;
            },
            getParentId: function(id1) {
                var uploadDataEntry1 = this.getUploads({
                    id: id1
                }), parentId1 = null;
                if (uploadDataEntry1) {
                    if (uploadDataEntry1.parentId !== undefined) parentId1 = uploadDataEntry1.parentId;
                }
                return parentId1;
            },
            getResumableFilesData: function() {
                return this._handler.getResumableFilesData();
            },
            getSize: function(id1) {
                return this._uploadData.retrieve({
                    id: id1
                }).size;
            },
            getNetUploads: function() {
                return this._netUploaded;
            },
            getRemainingAllowedItems: function() {
                var allowedItems1 = this._currentItemLimit;
                if (allowedItems1 > 0) return allowedItems1 - this._netUploadedOrQueued;
                return null;
            },
            getUploads: function(optionalFilter1) {
                return this._uploadData.retrieve(optionalFilter1);
            },
            getUuid: function(id1) {
                return this._uploadData.retrieve({
                    id: id1
                }).uuid;
            },
            isResumable: function(id1) {
                return this._handler.hasResumeRecord(id1);
            },
            log: function(str1, level1) {
                if (this._options.debug && (!level1 || level1 === "info")) qq.log("[Fine Uploader " + qq.version + "] " + str1);
                else if (level1 && level1 !== "info") qq.log("[Fine Uploader " + qq.version + "] " + str1, level1);
            },
            pauseUpload: function(id1) {
                var uploadData1 = this._uploadData.retrieve({
                    id: id1
                });
                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) return false;
                if (qq.indexOf([
                    qq.status.UPLOADING,
                    qq.status.UPLOAD_RETRYING
                ], uploadData1.status) >= 0) {
                    if (this._handler.pause(id1)) {
                        this._uploadData.setStatus(id1, qq.status.PAUSED);
                        return true;
                    } else this.log(qq.format("Unable to pause file ID {} ({}).", id1, this.getName(id1)), "error");
                } else this.log(qq.format("Ignoring pause for file ID {} ({}).  Not in progress.", id1, this.getName(id1)), "error");
                return false;
            },
            removeFileRef: function(id1) {
                this._handler.expunge(id1);
                this._uploadData.removeFileRef(id1);
            },
            reset: function() {
                this.log("Resetting uploader...");
                this._handler.reset();
                this._storedIds = [];
                this._autoRetries = [];
                this._retryTimeouts = [];
                this._preventRetries = [];
                this._thumbnailUrls = [];
                qq.each(this._buttons, function(idx1, button1) {
                    button1.reset();
                });
                this._paramsStore.reset();
                this._endpointStore.reset();
                this._netUploadedOrQueued = 0;
                this._netUploaded = 0;
                this._uploadData.reset();
                this._buttonIdsForFileIds = [];
                this._pasteHandler && this._pasteHandler.reset();
                this._options.session.refreshOnReset && this._refreshSessionData();
                this._succeededSinceLastAllComplete = [];
                this._failedSinceLastAllComplete = [];
                this._totalProgress && this._totalProgress.reset();
                this._customResumeDataStore.reset();
            },
            retry: function(id1) {
                return this._manualRetry(id1);
            },
            scaleImage: function(id1, specs1) {
                var self1 = this;
                return qq.Scaler.prototype.scaleImage(id1, specs1, {
                    log: qq.bind(self1.log, self1),
                    getFile: qq.bind(self1.getFile, self1),
                    uploadData: self1._uploadData
                });
            },
            setCustomHeaders: function(headers1, id1) {
                this._customHeadersStore.set(headers1, id1);
            },
            setCustomResumeData: function(id1, data1) {
                this._customResumeDataStore.set(data1, id1);
            },
            setDeleteFileCustomHeaders: function(headers1, id1) {
                this._deleteFileCustomHeadersStore.set(headers1, id1);
            },
            setDeleteFileEndpoint: function(endpoint1, id1) {
                this._deleteFileEndpointStore.set(endpoint1, id1);
            },
            setDeleteFileParams: function(params1, id1) {
                this._deleteFileParamsStore.set(params1, id1);
            },
            setEndpoint: function(endpoint1, id1) {
                this._endpointStore.set(endpoint1, id1);
            },
            setForm: function(elementOrId1) {
                this._updateFormSupportAndParams(elementOrId1);
            },
            setItemLimit: function(newItemLimit1) {
                this._currentItemLimit = newItemLimit1;
            },
            setName: function(id1, newName1) {
                this._uploadData.updateName(id1, newName1);
            },
            setParams: function(params1, id1) {
                this._paramsStore.set(params1, id1);
            },
            setUuid: function(id1, newUuid1) {
                return this._uploadData.uuidChanged(id1, newUuid1);
            },
            setStatus: function(id1, newStatus1) {
                var fileRecord1 = this.getUploads({
                    id: id1
                });
                if (!fileRecord1) throw new qq.Error(id1 + " is not a valid file ID.");
                switch(newStatus1){
                    case qq.status.DELETED:
                        this._onDeleteComplete(id1, null, false);
                        break;
                    case qq.status.DELETE_FAILED:
                        this._onDeleteComplete(id1, null, true);
                        break;
                    default:
                        var errorMessage1 = "Method setStatus called on '" + name + "' not implemented yet for " + newStatus1;
                        this.log(errorMessage1);
                        throw new qq.Error(errorMessage1);
                }
            },
            uploadStoredFiles: function() {
                if (this._storedIds.length === 0) this._itemError("noFilesError");
                else this._uploadStoredFiles();
            }
        };
        qq.basePrivateApi = {
            _addCannedFile: function(sessionData1) {
                var self1 = this;
                return this._uploadData.addFile({
                    uuid: sessionData1.uuid,
                    name: sessionData1.name,
                    size: sessionData1.size,
                    status: qq.status.UPLOAD_SUCCESSFUL,
                    onBeforeStatusChange: function(id1) {
                        sessionData1.deleteFileEndpoint && self1.setDeleteFileEndpoint(sessionData1.deleteFileEndpoint, id1);
                        sessionData1.deleteFileParams && self1.setDeleteFileParams(sessionData1.deleteFileParams, id1);
                        if (sessionData1.thumbnailUrl) self1._thumbnailUrls[id1] = sessionData1.thumbnailUrl;
                        self1._netUploaded++;
                        self1._netUploadedOrQueued++;
                    }
                });
            },
            _annotateWithButtonId: function(file1, associatedInput1) {
                if (qq.isFile(file1)) file1.qqButtonId = this._getButtonId(associatedInput1);
            },
            _batchError: function(message1) {
                this._options.callbacks.onError(null, null, message1, undefined);
            },
            _createDeleteHandler: function() {
                var self1 = this;
                return new qq.DeleteFileAjaxRequester({
                    method: this._options.deleteFile.method.toUpperCase(),
                    maxConnections: this._options.maxConnections,
                    uuidParamName: this._options.request.uuidName,
                    customHeaders: this._deleteFileCustomHeadersStore,
                    paramsStore: this._deleteFileParamsStore,
                    endpointStore: this._deleteFileEndpointStore,
                    cors: this._options.cors,
                    log: qq.bind(self1.log, self1),
                    onDelete: function(id1) {
                        self1._onDelete(id1);
                        self1._options.callbacks.onDelete(id1);
                    },
                    onDeleteComplete: function(id1, xhrOrXdr1, isError1) {
                        self1._onDeleteComplete(id1, xhrOrXdr1, isError1);
                        self1._options.callbacks.onDeleteComplete(id1, xhrOrXdr1, isError1);
                    }
                });
            },
            _createPasteHandler: function() {
                var self1 = this;
                return new qq.PasteSupport({
                    targetElement: this._options.paste.targetElement,
                    callbacks: {
                        log: qq.bind(self1.log, self1),
                        pasteReceived: function(blob1) {
                            self1._handleCheckedCallback({
                                name: "onPasteReceived",
                                callback: qq.bind(self1._options.callbacks.onPasteReceived, self1, blob1),
                                onSuccess: qq.bind(self1._handlePasteSuccess, self1, blob1),
                                identifier: "pasted image"
                            });
                        }
                    }
                });
            },
            _createStore: function(initialValue1, _readOnlyValues_1) {
                var store1 = {}, catchall1 = initialValue1, perIdReadOnlyValues1 = {}, readOnlyValues1 = _readOnlyValues_1, copy1 = function(orig1) {
                    if (qq.isObject(orig1)) return qq.extend({}, orig1);
                    return orig1;
                }, getReadOnlyValues1 = function() {
                    if (qq.isFunction(readOnlyValues1)) return readOnlyValues1();
                    return readOnlyValues1;
                }, includeReadOnlyValues1 = function(id1, existing1) {
                    if (readOnlyValues1 && qq.isObject(existing1)) qq.extend(existing1, getReadOnlyValues1());
                    if (perIdReadOnlyValues1[id1]) qq.extend(existing1, perIdReadOnlyValues1[id1]);
                };
                return {
                    set: function(val1, id1) {
                        if (id1 == null) {
                            store1 = {};
                            catchall1 = copy1(val1);
                        } else store1[id1] = copy1(val1);
                    },
                    get: function(id1) {
                        var values1;
                        if (id1 != null && store1[id1]) values1 = store1[id1];
                        else values1 = copy1(catchall1);
                        includeReadOnlyValues1(id1, values1);
                        return copy1(values1);
                    },
                    addReadOnly: function(id1, values1) {
                        if (qq.isObject(store1)) {
                            if (id1 === null) {
                                if (qq.isFunction(values1)) readOnlyValues1 = values1;
                                else {
                                    readOnlyValues1 = readOnlyValues1 || {};
                                    qq.extend(readOnlyValues1, values1);
                                }
                            } else {
                                perIdReadOnlyValues1[id1] = perIdReadOnlyValues1[id1] || {};
                                qq.extend(perIdReadOnlyValues1[id1], values1);
                            }
                        }
                    },
                    remove: function(fileId1) {
                        return delete store1[fileId1];
                    },
                    reset: function() {
                        store1 = {};
                        perIdReadOnlyValues1 = {};
                        catchall1 = initialValue1;
                    }
                };
            },
            _createUploadDataTracker: function() {
                var self1 = this;
                return new qq.UploadData({
                    getName: function(id1) {
                        return self1.getName(id1);
                    },
                    getUuid: function(id1) {
                        return self1.getUuid(id1);
                    },
                    getSize: function(id1) {
                        return self1.getSize(id1);
                    },
                    onStatusChange: function(id1, oldStatus1, newStatus1) {
                        self1._onUploadStatusChange(id1, oldStatus1, newStatus1);
                        self1._options.callbacks.onStatusChange(id1, oldStatus1, newStatus1);
                        self1._maybeAllComplete(id1, newStatus1);
                        if (self1._totalProgress) setTimeout(function() {
                            self1._totalProgress.onStatusChange(id1, oldStatus1, newStatus1);
                        }, 0);
                    }
                });
            },
            _createUploadButton: function(spec1) {
                var self1 = this, acceptFiles1 = spec1.accept || this._options.validation.acceptFiles, allowedExtensions1 = spec1.allowedExtensions || this._options.validation.allowedExtensions, button1;
                function allowMultiple1() {
                    if (qq.supportedFeatures.ajaxUploading) {
                        if (self1._options.workarounds.iosEmptyVideos && qq.ios() && !qq.ios6() && self1._isAllowedExtension(allowedExtensions1, ".mov")) return false;
                        if (spec1.multiple === undefined) return self1._options.multiple;
                        return spec1.multiple;
                    }
                    return false;
                }
                button1 = new qq.UploadButton({
                    acceptFiles: acceptFiles1,
                    element: spec1.element,
                    focusClass: this._options.classes.buttonFocus,
                    folders: spec1.folders,
                    hoverClass: this._options.classes.buttonHover,
                    ios8BrowserCrashWorkaround: this._options.workarounds.ios8BrowserCrash,
                    multiple: allowMultiple1(),
                    name: this._options.request.inputName,
                    onChange: function(input1) {
                        self1._onInputChange(input1);
                    },
                    title: spec1.title == null ? this._options.text.fileInputTitle : spec1.title
                });
                this._disposeSupport.addDisposer(function() {
                    button1.dispose();
                });
                self1._buttons.push(button1);
                return button1;
            },
            _createUploadHandler: function(additionalOptions1, namespace1) {
                var self1 = this, lastOnProgress1 = {}, options1 = {
                    debug: this._options.debug,
                    maxConnections: this._options.maxConnections,
                    cors: this._options.cors,
                    paramsStore: this._paramsStore,
                    endpointStore: this._endpointStore,
                    chunking: this._options.chunking,
                    resume: this._options.resume,
                    blobs: this._options.blobs,
                    log: qq.bind(self1.log, self1),
                    preventRetryParam: this._options.retry.preventRetryResponseProperty,
                    onProgress: function(id1, name1, loaded1, total1) {
                        if (loaded1 < 0 || total1 < 0) return;
                        if (lastOnProgress1[id1]) {
                            if (lastOnProgress1[id1].loaded !== loaded1 || lastOnProgress1[id1].total !== total1) {
                                self1._onProgress(id1, name1, loaded1, total1);
                                self1._options.callbacks.onProgress(id1, name1, loaded1, total1);
                            }
                        } else {
                            self1._onProgress(id1, name1, loaded1, total1);
                            self1._options.callbacks.onProgress(id1, name1, loaded1, total1);
                        }
                        lastOnProgress1[id1] = {
                            loaded: loaded1,
                            total: total1
                        };
                    },
                    onComplete: function(id1, name1, result1, xhr1) {
                        delete lastOnProgress1[id1];
                        var status1 = self1.getUploads({
                            id: id1
                        }).status, retVal1;
                        if (status1 === qq.status.UPLOAD_SUCCESSFUL || status1 === qq.status.UPLOAD_FAILED) return;
                        retVal1 = self1._onComplete(id1, name1, result1, xhr1);
                        if (retVal1 instanceof qq.Promise) retVal1.done(function() {
                            self1._options.callbacks.onComplete(id1, name1, result1, xhr1);
                        });
                        else self1._options.callbacks.onComplete(id1, name1, result1, xhr1);
                    },
                    onCancel: function(id1, name1, cancelFinalizationEffort1) {
                        var promise1 = new qq.Promise();
                        self1._handleCheckedCallback({
                            name: "onCancel",
                            callback: qq.bind(self1._options.callbacks.onCancel, self1, id1, name1),
                            onFailure: promise1.failure,
                            onSuccess: function() {
                                cancelFinalizationEffort1.then(function() {
                                    self1._onCancel(id1, name1);
                                });
                                promise1.success();
                            },
                            identifier: id1
                        });
                        return promise1;
                    },
                    onUploadPrep: qq.bind(this._onUploadPrep, this),
                    onUpload: function(id1, name1) {
                        self1._onUpload(id1, name1);
                        var onUploadResult1 = self1._options.callbacks.onUpload(id1, name1);
                        if (qq.isGenericPromise(onUploadResult1)) {
                            self1.log(qq.format("onUpload for {} returned a Promise - waiting for resolution.", id1));
                            return onUploadResult1;
                        }
                        return new qq.Promise().success();
                    },
                    onUploadChunk: function(id1, name1, chunkData1) {
                        self1._onUploadChunk(id1, chunkData1);
                        var onUploadChunkResult1 = self1._options.callbacks.onUploadChunk(id1, name1, chunkData1);
                        if (qq.isGenericPromise(onUploadChunkResult1)) {
                            self1.log(qq.format("onUploadChunk for {}.{} returned a Promise - waiting for resolution.", id1, chunkData1.partIndex));
                            return onUploadChunkResult1;
                        }
                        return new qq.Promise().success();
                    },
                    onUploadChunkSuccess: function(id1, chunkData1, result1, xhr1) {
                        self1._onUploadChunkSuccess(id1, chunkData1);
                        self1._options.callbacks.onUploadChunkSuccess.apply(self1, arguments);
                    },
                    onResume: function(id1, name1, chunkData1, customResumeData1) {
                        return self1._options.callbacks.onResume(id1, name1, chunkData1, customResumeData1);
                    },
                    onAutoRetry: function(id1, name1, responseJSON1, xhr1) {
                        return self1._onAutoRetry.apply(self1, arguments);
                    },
                    onUuidChanged: function(id1, newUuid1) {
                        self1.log("Server requested UUID change from '" + self1.getUuid(id1) + "' to '" + newUuid1 + "'");
                        self1.setUuid(id1, newUuid1);
                    },
                    getName: qq.bind(self1.getName, self1),
                    getUuid: qq.bind(self1.getUuid, self1),
                    getSize: qq.bind(self1.getSize, self1),
                    setSize: qq.bind(self1._setSize, self1),
                    getDataByUuid: function(uuid1) {
                        return self1.getUploads({
                            uuid: uuid1
                        });
                    },
                    isQueued: function(id1) {
                        var status1 = self1.getUploads({
                            id: id1
                        }).status;
                        return status1 === qq.status.QUEUED || status1 === qq.status.SUBMITTED || status1 === qq.status.UPLOAD_RETRYING || status1 === qq.status.PAUSED;
                    },
                    getIdsInProxyGroup: self1._uploadData.getIdsInProxyGroup,
                    getIdsInBatch: self1._uploadData.getIdsInBatch,
                    isInProgress: function(id1) {
                        return self1.getUploads({
                            id: id1
                        }).status === qq.status.UPLOADING;
                    },
                    getCustomResumeData: qq.bind(self1._getCustomResumeData, self1),
                    setStatus: function(id1, status1) {
                        self1._uploadData.setStatus(id1, status1);
                    }
                };
                qq.each(this._options.request, function(prop1, val1) {
                    options1[prop1] = val1;
                });
                options1.customHeaders = this._customHeadersStore;
                if (additionalOptions1) qq.each(additionalOptions1, function(key1, val1) {
                    options1[key1] = val1;
                });
                return new qq.UploadHandlerController(options1, namespace1);
            },
            _fileOrBlobRejected: function(id1) {
                this._netUploadedOrQueued--;
                this._uploadData.setStatus(id1, qq.status.REJECTED);
            },
            _formatSize: function(bytes1) {
                if (bytes1 === 0) return bytes1 + this._options.text.sizeSymbols[0];
                var i1 = -1;
                do {
                    bytes1 = bytes1 / 1e3;
                    i1++;
                }while (bytes1 > 999);
                return Math.max(bytes1, .1).toFixed(1) + this._options.text.sizeSymbols[i1];
            },
            _generateExtraButtonSpecs: function() {
                var self1 = this;
                this._extraButtonSpecs = {};
                qq.each(this._options.extraButtons, function(idx1, extraButtonOptionEntry1) {
                    var multiple1 = extraButtonOptionEntry1.multiple, validation1 = qq.extend({}, self1._options.validation, true), extraButtonSpec1 = qq.extend({}, extraButtonOptionEntry1);
                    if (multiple1 === undefined) multiple1 = self1._options.multiple;
                    if (extraButtonSpec1.validation) qq.extend(validation1, extraButtonOptionEntry1.validation, true);
                    qq.extend(extraButtonSpec1, {
                        multiple: multiple1,
                        validation: validation1
                    }, true);
                    self1._initExtraButton(extraButtonSpec1);
                });
            },
            _getButton: function(buttonId1) {
                var extraButtonsSpec1 = this._extraButtonSpecs[buttonId1];
                if (extraButtonsSpec1) return extraButtonsSpec1.element;
                else if (buttonId1 === this._defaultButtonId) return this._options.button;
            },
            _getButtonId: function(buttonOrFileInputOrFile1) {
                var inputs1, fileInput1, fileBlobOrInput1 = buttonOrFileInputOrFile1;
                if (fileBlobOrInput1 instanceof qq.BlobProxy) fileBlobOrInput1 = fileBlobOrInput1.referenceBlob;
                if (fileBlobOrInput1 && !qq.isBlob(fileBlobOrInput1)) {
                    if (qq.isFile(fileBlobOrInput1)) return fileBlobOrInput1.qqButtonId;
                    else if (fileBlobOrInput1.tagName.toLowerCase() === "input" && fileBlobOrInput1.type.toLowerCase() === "file") return fileBlobOrInput1.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
                    inputs1 = fileBlobOrInput1.getElementsByTagName("input");
                    qq.each(inputs1, function(idx1, input1) {
                        if (input1.getAttribute("type") === "file") {
                            fileInput1 = input1;
                            return false;
                        }
                    });
                    if (fileInput1) return fileInput1.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
                }
            },
            _getCustomResumeData: function(fileId1) {
                return this._customResumeDataStore.get(fileId1);
            },
            _getNotFinished: function() {
                return this._uploadData.retrieve({
                    status: [
                        qq.status.UPLOADING,
                        qq.status.UPLOAD_RETRYING,
                        qq.status.QUEUED,
                        qq.status.SUBMITTING,
                        qq.status.SUBMITTED,
                        qq.status.PAUSED
                    ]
                }).length;
            },
            _getValidationBase: function(buttonId1) {
                var extraButtonSpec1 = this._extraButtonSpecs[buttonId1];
                return extraButtonSpec1 ? extraButtonSpec1.validation : this._options.validation;
            },
            _getValidationDescriptor: function(fileWrapper1) {
                if (fileWrapper1.file instanceof qq.BlobProxy) return {
                    name: qq.getFilename(fileWrapper1.file.referenceBlob),
                    size: fileWrapper1.file.referenceBlob.size
                };
                return {
                    name: this.getUploads({
                        id: fileWrapper1.id
                    }).name,
                    size: this.getUploads({
                        id: fileWrapper1.id
                    }).size
                };
            },
            _getValidationDescriptors: function(fileWrappers1) {
                var self1 = this, fileDescriptors1 = [];
                qq.each(fileWrappers1, function(idx1, fileWrapper1) {
                    fileDescriptors1.push(self1._getValidationDescriptor(fileWrapper1));
                });
                return fileDescriptors1;
            },
            _handleCameraAccess: function() {
                if (this._options.camera.ios && qq.ios()) {
                    var acceptIosCamera1 = "image/*;capture=camera", button1 = this._options.camera.button, buttonId1 = button1 ? this._getButtonId(button1) : this._defaultButtonId, optionRoot1 = this._options;
                    if (buttonId1 && buttonId1 !== this._defaultButtonId) optionRoot1 = this._extraButtonSpecs[buttonId1];
                    optionRoot1.multiple = false;
                    if (optionRoot1.validation.acceptFiles === null) optionRoot1.validation.acceptFiles = acceptIosCamera1;
                    else optionRoot1.validation.acceptFiles += "," + acceptIosCamera1;
                    qq.each(this._buttons, function(idx1, button1) {
                        if (button1.getButtonId() === buttonId1) {
                            button1.setMultiple(optionRoot1.multiple);
                            button1.setAcceptFiles(optionRoot1.acceptFiles);
                            return false;
                        }
                    });
                }
            },
            _handleCheckedCallback: function(details1) {
                var self1 = this, callbackRetVal1 = details1.callback();
                if (qq.isGenericPromise(callbackRetVal1)) {
                    this.log(details1.name + " - waiting for " + details1.name + " promise to be fulfilled for " + details1.identifier);
                    return callbackRetVal1.then(function(successParam1) {
                        self1.log(details1.name + " promise success for " + details1.identifier);
                        details1.onSuccess(successParam1);
                    }, function() {
                        if (details1.onFailure) {
                            self1.log(details1.name + " promise failure for " + details1.identifier);
                            details1.onFailure();
                        } else self1.log(details1.name + " promise failure for " + details1.identifier);
                    });
                }
                if (callbackRetVal1 !== false) details1.onSuccess(callbackRetVal1);
                else if (details1.onFailure) {
                    this.log(details1.name + " - return value was 'false' for " + details1.identifier + ".  Invoking failure callback.");
                    details1.onFailure();
                } else this.log(details1.name + " - return value was 'false' for " + details1.identifier + ".  Will not proceed.");
                return callbackRetVal1;
            },
            _handleNewFile: function(file1, batchId1, newFileWrapperList1) {
                var self1 = this, uuid1 = qq.getUniqueId(), size1 = -1, name1 = qq.getFilename(file1), actualFile1 = file1.blob || file1, handler1 = this._customNewFileHandler ? this._customNewFileHandler : qq.bind(self1._handleNewFileGeneric, self1);
                if (!qq.isInput(actualFile1) && actualFile1.size >= 0) size1 = actualFile1.size;
                handler1(actualFile1, name1, uuid1, size1, newFileWrapperList1, batchId1, this._options.request.uuidName, {
                    uploadData: self1._uploadData,
                    paramsStore: self1._paramsStore,
                    addFileToHandler: function(id1, file1) {
                        self1._handler.add(id1, file1);
                        self1._netUploadedOrQueued++;
                        self1._trackButton(id1);
                    }
                });
            },
            _handleNewFileGeneric: function(file1, name1, uuid1, size1, fileList1, batchId1) {
                var id1 = this._uploadData.addFile({
                    uuid: uuid1,
                    name: name1,
                    size: size1,
                    batchId: batchId1,
                    file: file1
                });
                this._handler.add(id1, file1);
                this._trackButton(id1);
                this._netUploadedOrQueued++;
                fileList1.push({
                    id: id1,
                    file: file1
                });
            },
            _handlePasteSuccess: function(blob1, extSuppliedName1) {
                var extension1 = blob1.type.split("/")[1], name1 = extSuppliedName1;
                if (name1 == null) name1 = this._options.paste.defaultName;
                name1 += "." + extension1;
                this.addFiles({
                    name: name1,
                    blob: blob1
                });
            },
            _handleDeleteSuccess: function(id1) {
                if (this.getUploads({
                    id: id1
                }).status !== qq.status.DELETED) {
                    var name1 = this.getName(id1);
                    this._netUploadedOrQueued--;
                    this._netUploaded--;
                    this._handler.expunge(id1);
                    this._uploadData.setStatus(id1, qq.status.DELETED);
                    this.log("Delete request for '" + name1 + "' has succeeded.");
                }
            },
            _handleDeleteFailed: function(id1, xhrOrXdr1) {
                var name1 = this.getName(id1);
                this._uploadData.setStatus(id1, qq.status.DELETE_FAILED);
                this.log("Delete request for '" + name1 + "' has failed.", "error");
                if (!xhrOrXdr1 || xhrOrXdr1.withCredentials === undefined) this._options.callbacks.onError(id1, name1, "Delete request failed", xhrOrXdr1);
                else this._options.callbacks.onError(id1, name1, "Delete request failed with response code " + xhrOrXdr1.status, xhrOrXdr1);
            },
            _initExtraButton: function(spec1) {
                var button1 = this._createUploadButton({
                    accept: spec1.validation.acceptFiles,
                    allowedExtensions: spec1.validation.allowedExtensions,
                    element: spec1.element,
                    folders: spec1.folders,
                    multiple: spec1.multiple,
                    title: spec1.fileInputTitle
                });
                this._extraButtonSpecs[button1.getButtonId()] = spec1;
            },
            _initFormSupportAndParams: function() {
                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
                if (this._formSupport && this._formSupport.attachedToForm) {
                    this._paramsStore = this._createStore(this._options.request.params, this._formSupport.getFormInputsAsObject);
                    this._options.autoUpload = this._formSupport.newAutoUpload;
                    if (this._formSupport.newEndpoint) this._options.request.endpoint = this._formSupport.newEndpoint;
                } else this._paramsStore = this._createStore(this._options.request.params);
            },
            _isDeletePossible: function() {
                if (!qq.DeleteFileAjaxRequester || !this._options.deleteFile.enabled) return false;
                if (this._options.cors.expected) {
                    if (qq.supportedFeatures.deleteFileCorsXhr) return true;
                    if (qq.supportedFeatures.deleteFileCorsXdr && this._options.cors.allowXdr) return true;
                    return false;
                }
                return true;
            },
            _isAllowedExtension: function(allowed1, fileName1) {
                var valid1 = false;
                if (!allowed1.length) return true;
                qq.each(allowed1, function(idx1, allowedExt1) {
                    if (qq.isString(allowedExt1)) {
                        var extRegex1 = new RegExp("\\." + allowedExt1 + "$", "i");
                        if (fileName1.match(extRegex1) != null) {
                            valid1 = true;
                            return false;
                        }
                    }
                });
                return valid1;
            },
            _itemError: function(code1, maybeNameOrNames1, item1) {
                var message1 = this._options.messages[code1], allowedExtensions1 = [], names1 = [].concat(maybeNameOrNames1), name1 = names1[0], buttonId1 = this._getButtonId(item1), validationBase1 = this._getValidationBase(buttonId1), extensionsForMessage1, placeholderMatch1;
                function r1(name1, replacement1) {
                    message1 = message1.replace(name1, replacement1);
                }
                qq.each(validationBase1.allowedExtensions, function(idx1, allowedExtension1) {
                    if (qq.isString(allowedExtension1)) allowedExtensions1.push(allowedExtension1);
                });
                extensionsForMessage1 = allowedExtensions1.join(", ").toLowerCase();
                r1("{file}", this._options.formatFileName(name1));
                r1("{extensions}", extensionsForMessage1);
                r1("{sizeLimit}", this._formatSize(validationBase1.sizeLimit));
                r1("{minSizeLimit}", this._formatSize(validationBase1.minSizeLimit));
                placeholderMatch1 = message1.match(/(\{\w+\})/g);
                if (placeholderMatch1 !== null) qq.each(placeholderMatch1, function(idx1, placeholder1) {
                    r1(placeholder1, names1[idx1]);
                });
                this._options.callbacks.onError(null, name1, message1, undefined);
                return message1;
            },
            _manualRetry: function(id1, callback1) {
                if (this._onBeforeManualRetry(id1)) {
                    this._netUploadedOrQueued++;
                    this._uploadData.setStatus(id1, qq.status.UPLOAD_RETRYING);
                    if (callback1) callback1(id1);
                    else this._handler.retry(id1);
                    return true;
                }
            },
            _maybeAllComplete: function(id1, status1) {
                var self1 = this, notFinished1 = this._getNotFinished();
                if (status1 === qq.status.UPLOAD_SUCCESSFUL) this._succeededSinceLastAllComplete.push(id1);
                else if (status1 === qq.status.UPLOAD_FAILED) this._failedSinceLastAllComplete.push(id1);
                if (notFinished1 === 0 && (this._succeededSinceLastAllComplete.length || this._failedSinceLastAllComplete.length)) setTimeout(function() {
                    self1._onAllComplete(self1._succeededSinceLastAllComplete, self1._failedSinceLastAllComplete);
                }, 0);
            },
            _maybeHandleIos8SafariWorkaround: function() {
                var self1 = this;
                if (this._options.workarounds.ios8SafariUploads && qq.ios800() && qq.iosSafari()) {
                    setTimeout(function() {
                        window.alert(self1._options.messages.unsupportedBrowserIos8Safari);
                    }, 0);
                    throw new qq.Error(this._options.messages.unsupportedBrowserIos8Safari);
                }
            },
            _maybeParseAndSendUploadError: function(id1, name1, response1, xhr1) {
                if (!response1.success) {
                    if (xhr1 && xhr1.status !== 200 && !response1.error) this._options.callbacks.onError(id1, name1, "XHR returned response code " + xhr1.status, xhr1);
                    else {
                        var errorReason1 = response1.error ? response1.error : this._options.text.defaultResponseError;
                        this._options.callbacks.onError(id1, name1, errorReason1, xhr1);
                    }
                }
            },
            _maybeProcessNextItemAfterOnValidateCallback: function(validItem1, items1, index1, params1, endpoint1) {
                var self1 = this;
                if (items1.length > index1) {
                    if (validItem1 || !this._options.validation.stopOnFirstInvalidFile) setTimeout(function() {
                        var validationDescriptor1 = self1._getValidationDescriptor(items1[index1]), buttonId1 = self1._getButtonId(items1[index1].file), button1 = self1._getButton(buttonId1);
                        self1._handleCheckedCallback({
                            name: "onValidate",
                            callback: qq.bind(self1._options.callbacks.onValidate, self1, validationDescriptor1, button1),
                            onSuccess: qq.bind(self1._onValidateCallbackSuccess, self1, items1, index1, params1, endpoint1),
                            onFailure: qq.bind(self1._onValidateCallbackFailure, self1, items1, index1, params1, endpoint1),
                            identifier: "Item '" + validationDescriptor1.name + "', size: " + validationDescriptor1.size
                        });
                    }, 0);
                    else if (!validItem1) for(; index1 < items1.length; index1++)self1._fileOrBlobRejected(items1[index1].id);
                }
            },
            _onAllComplete: function(successful1, failed1) {
                this._totalProgress && this._totalProgress.onAllComplete(successful1, failed1, this._preventRetries);
                this._options.callbacks.onAllComplete(qq.extend([], successful1), qq.extend([], failed1));
                this._succeededSinceLastAllComplete = [];
                this._failedSinceLastAllComplete = [];
            },
            _onAutoRetry: function(id1, name1, responseJSON1, xhr1, callback1) {
                var self1 = this;
                self1._preventRetries[id1] = responseJSON1[self1._options.retry.preventRetryResponseProperty];
                if (self1._shouldAutoRetry(id1)) {
                    var retryWaitPeriod1 = self1._options.retry.autoAttemptDelay * 1e3;
                    self1._maybeParseAndSendUploadError.apply(self1, arguments);
                    self1._options.callbacks.onAutoRetry(id1, name1, self1._autoRetries[id1]);
                    self1._onBeforeAutoRetry(id1, name1);
                    self1._uploadData.setStatus(id1, qq.status.UPLOAD_RETRYING);
                    self1._retryTimeouts[id1] = setTimeout(function() {
                        self1.log("Starting retry for " + name1 + "...");
                        if (callback1) callback1(id1);
                        else self1._handler.retry(id1);
                    }, retryWaitPeriod1);
                    return true;
                }
            },
            _onBeforeAutoRetry: function(id1, name1) {
                this.log("Waiting " + this._options.retry.autoAttemptDelay + " seconds before retrying " + name1 + "...");
            },
            _onBeforeManualRetry: function(id1) {
                var itemLimit1 = this._currentItemLimit, fileName1;
                if (this._preventRetries[id1]) {
                    this.log("Retries are forbidden for id " + id1, "warn");
                    return false;
                } else if (this._handler.isValid(id1)) {
                    fileName1 = this.getName(id1);
                    if (this._options.callbacks.onManualRetry(id1, fileName1) === false) return false;
                    if (itemLimit1 > 0 && this._netUploadedOrQueued + 1 > itemLimit1) {
                        this._itemError("retryFailTooManyItems");
                        return false;
                    }
                    this.log("Retrying upload for '" + fileName1 + "' (id: " + id1 + ")...");
                    return true;
                } else {
                    this.log("'" + id1 + "' is not a valid file ID", "error");
                    return false;
                }
            },
            _onCancel: function(id1, name1) {
                this._netUploadedOrQueued--;
                clearTimeout(this._retryTimeouts[id1]);
                var storedItemIndex1 = qq.indexOf(this._storedIds, id1);
                if (!this._options.autoUpload && storedItemIndex1 >= 0) this._storedIds.splice(storedItemIndex1, 1);
                this._uploadData.setStatus(id1, qq.status.CANCELED);
            },
            _onComplete: function(id1, name1, result1, xhr1) {
                if (!result1.success) {
                    this._netUploadedOrQueued--;
                    this._uploadData.setStatus(id1, qq.status.UPLOAD_FAILED);
                    if (result1[this._options.retry.preventRetryResponseProperty] === true) this._preventRetries[id1] = true;
                } else {
                    if (result1.thumbnailUrl) this._thumbnailUrls[id1] = result1.thumbnailUrl;
                    this._netUploaded++;
                    this._uploadData.setStatus(id1, qq.status.UPLOAD_SUCCESSFUL);
                }
                this._maybeParseAndSendUploadError(id1, name1, result1, xhr1);
                return result1.success ? true : false;
            },
            _onDelete: function(id1) {
                this._uploadData.setStatus(id1, qq.status.DELETING);
            },
            _onDeleteComplete: function(id1, xhrOrXdr1, isError1) {
                var name1 = this.getName(id1);
                if (isError1) this._handleDeleteFailed(id1, xhrOrXdr1);
                else this._handleDeleteSuccess(id1);
            },
            _onInputChange: function(input1) {
                var fileIndex1;
                if (qq.supportedFeatures.ajaxUploading) {
                    for(fileIndex1 = 0; fileIndex1 < input1.files.length; fileIndex1++)this._annotateWithButtonId(input1.files[fileIndex1], input1);
                    this.addFiles(input1.files);
                } else if (input1.value.length > 0) this.addFiles(input1);
                qq.each(this._buttons, function(idx1, button1) {
                    button1.reset();
                });
            },
            _onProgress: function(id1, name1, loaded1, total1) {
                this._totalProgress && this._totalProgress.onIndividualProgress(id1, loaded1, total1);
            },
            _onSubmit: function(id1, name1) {},
            _onSubmitCallbackSuccess: function(id1, name1) {
                this._onSubmit.apply(this, arguments);
                this._uploadData.setStatus(id1, qq.status.SUBMITTED);
                this._onSubmitted.apply(this, arguments);
                if (this._options.autoUpload) {
                    this._options.callbacks.onSubmitted.apply(this, arguments);
                    this._uploadFile(id1);
                } else {
                    this._storeForLater(id1);
                    this._options.callbacks.onSubmitted.apply(this, arguments);
                }
            },
            _onSubmitDelete: function(id1, onSuccessCallback1, additionalMandatedParams1) {
                var uuid1 = this.getUuid(id1), adjustedOnSuccessCallback1;
                if (onSuccessCallback1) adjustedOnSuccessCallback1 = qq.bind(onSuccessCallback1, this, id1, uuid1, additionalMandatedParams1);
                if (this._isDeletePossible()) {
                    this._handleCheckedCallback({
                        name: "onSubmitDelete",
                        callback: qq.bind(this._options.callbacks.onSubmitDelete, this, id1),
                        onSuccess: adjustedOnSuccessCallback1 || qq.bind(this._deleteHandler.sendDelete, this, id1, uuid1, additionalMandatedParams1),
                        identifier: id1
                    });
                    return true;
                } else {
                    this.log("Delete request ignored for ID " + id1 + ", delete feature is disabled or request not possible " + "due to CORS on a user agent that does not support pre-flighting.", "warn");
                    return false;
                }
            },
            _onSubmitted: function(id1) {},
            _onTotalProgress: function(loaded1, total1) {
                this._options.callbacks.onTotalProgress(loaded1, total1);
            },
            _onUploadPrep: function(id1) {},
            _onUpload: function(id1, name1) {
                this._uploadData.setStatus(id1, qq.status.UPLOADING);
            },
            _onUploadChunk: function(id1, chunkData1) {},
            _onUploadChunkSuccess: function(id1, chunkData1) {
                if (!this._preventRetries[id1] && this._options.retry.enableAuto) this._autoRetries[id1] = 0;
            },
            _onUploadStatusChange: function(id1, oldStatus1, newStatus1) {
                if (newStatus1 === qq.status.PAUSED) clearTimeout(this._retryTimeouts[id1]);
            },
            _onValidateBatchCallbackFailure: function(fileWrappers1) {
                var self1 = this;
                qq.each(fileWrappers1, function(idx1, fileWrapper1) {
                    self1._fileOrBlobRejected(fileWrapper1.id);
                });
            },
            _onValidateBatchCallbackSuccess: function(validationDescriptors1, items1, params1, endpoint1, button1) {
                var errorMessage1, itemLimit1 = this._currentItemLimit, proposedNetFilesUploadedOrQueued1 = this._netUploadedOrQueued;
                if (itemLimit1 === 0 || proposedNetFilesUploadedOrQueued1 <= itemLimit1) {
                    if (items1.length > 0) this._handleCheckedCallback({
                        name: "onValidate",
                        callback: qq.bind(this._options.callbacks.onValidate, this, validationDescriptors1[0], button1),
                        onSuccess: qq.bind(this._onValidateCallbackSuccess, this, items1, 0, params1, endpoint1),
                        onFailure: qq.bind(this._onValidateCallbackFailure, this, items1, 0, params1, endpoint1),
                        identifier: "Item '" + items1[0].file.name + "', size: " + items1[0].file.size
                    });
                    else this._itemError("noFilesError");
                } else {
                    this._onValidateBatchCallbackFailure(items1);
                    errorMessage1 = this._options.messages.tooManyItemsError.replace(/\{netItems\}/g, proposedNetFilesUploadedOrQueued1).replace(/\{itemLimit\}/g, itemLimit1);
                    this._batchError(errorMessage1);
                }
            },
            _onValidateCallbackFailure: function(items1, index1, params1, endpoint1) {
                var nextIndex1 = index1 + 1;
                this._fileOrBlobRejected(items1[index1].id, items1[index1].file.name);
                this._maybeProcessNextItemAfterOnValidateCallback(false, items1, nextIndex1, params1, endpoint1);
            },
            _onValidateCallbackSuccess: function(items1, index1, params1, endpoint1) {
                var self1 = this, nextIndex1 = index1 + 1, validationDescriptor1 = this._getValidationDescriptor(items1[index1]);
                this._validateFileOrBlobData(items1[index1], validationDescriptor1).then(function() {
                    self1._upload(items1[index1].id, params1, endpoint1);
                    self1._maybeProcessNextItemAfterOnValidateCallback(true, items1, nextIndex1, params1, endpoint1);
                }, function() {
                    self1._maybeProcessNextItemAfterOnValidateCallback(false, items1, nextIndex1, params1, endpoint1);
                });
            },
            _prepareItemsForUpload: function(items1, params1, endpoint1) {
                if (items1.length === 0) {
                    this._itemError("noFilesError");
                    return;
                }
                var validationDescriptors1 = this._getValidationDescriptors(items1), buttonId1 = this._getButtonId(items1[0].file), button1 = this._getButton(buttonId1);
                this._handleCheckedCallback({
                    name: "onValidateBatch",
                    callback: qq.bind(this._options.callbacks.onValidateBatch, this, validationDescriptors1, button1),
                    onSuccess: qq.bind(this._onValidateBatchCallbackSuccess, this, validationDescriptors1, items1, params1, endpoint1, button1),
                    onFailure: qq.bind(this._onValidateBatchCallbackFailure, this, items1),
                    identifier: "batch validation"
                });
            },
            _preventLeaveInProgress: function() {
                var self1 = this;
                this._disposeSupport.attach(window, "beforeunload", function(e1) {
                    if (self1.getInProgress()) {
                        e1 = e1 || window.event;
                        e1.returnValue = self1._options.messages.onLeave;
                        return self1._options.messages.onLeave;
                    }
                });
            },
            _refreshSessionData: function() {
                var self1 = this, options1 = this._options.session;
                if (qq.Session && this._options.session.endpoint != null) {
                    if (!this._session) {
                        qq.extend(options1, {
                            cors: this._options.cors
                        });
                        options1.log = qq.bind(this.log, this);
                        options1.addFileRecord = qq.bind(this._addCannedFile, this);
                        this._session = new qq.Session(options1);
                    }
                    setTimeout(function() {
                        self1._session.refresh().then(function(response1, xhrOrXdr1) {
                            self1._sessionRequestComplete();
                            self1._options.callbacks.onSessionRequestComplete(response1, true, xhrOrXdr1);
                        }, function(response1, xhrOrXdr1) {
                            self1._options.callbacks.onSessionRequestComplete(response1, false, xhrOrXdr1);
                        });
                    }, 0);
                }
            },
            _sessionRequestComplete: function() {},
            _setSize: function(id1, newSize1) {
                this._uploadData.updateSize(id1, newSize1);
                this._totalProgress && this._totalProgress.onNewSize(id1);
            },
            _shouldAutoRetry: function(id1) {
                var uploadData1 = this._uploadData.retrieve({
                    id: id1
                });
                if (!this._preventRetries[id1] && this._options.retry.enableAuto && uploadData1.status !== qq.status.PAUSED) {
                    if (this._autoRetries[id1] === undefined) this._autoRetries[id1] = 0;
                    if (this._autoRetries[id1] < this._options.retry.maxAutoAttempts) {
                        this._autoRetries[id1] += 1;
                        return true;
                    }
                }
                return false;
            },
            _storeForLater: function(id1) {
                this._storedIds.push(id1);
            },
            _trackButton: function(id1) {
                var buttonId1;
                if (qq.supportedFeatures.ajaxUploading) buttonId1 = this._handler.getFile(id1).qqButtonId;
                else buttonId1 = this._getButtonId(this._handler.getInput(id1));
                if (buttonId1) this._buttonIdsForFileIds[id1] = buttonId1;
            },
            _updateFormSupportAndParams: function(formElementOrId1) {
                this._options.form.element = formElementOrId1;
                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
                if (this._formSupport && this._formSupport.attachedToForm) {
                    this._paramsStore.addReadOnly(null, this._formSupport.getFormInputsAsObject);
                    this._options.autoUpload = this._formSupport.newAutoUpload;
                    if (this._formSupport.newEndpoint) this.setEndpoint(this._formSupport.newEndpoint);
                }
            },
            _upload: function(id1, params1, endpoint1) {
                var name1 = this.getName(id1);
                if (params1) this.setParams(params1, id1);
                if (endpoint1) this.setEndpoint(endpoint1, id1);
                this._handleCheckedCallback({
                    name: "onSubmit",
                    callback: qq.bind(this._options.callbacks.onSubmit, this, id1, name1),
                    onSuccess: qq.bind(this._onSubmitCallbackSuccess, this, id1, name1),
                    onFailure: qq.bind(this._fileOrBlobRejected, this, id1, name1),
                    identifier: id1
                });
            },
            _uploadFile: function(id1) {
                if (!this._handler.upload(id1)) this._uploadData.setStatus(id1, qq.status.QUEUED);
            },
            _uploadStoredFiles: function() {
                var idToUpload1, stillSubmitting1, self1 = this;
                while(this._storedIds.length){
                    idToUpload1 = this._storedIds.shift();
                    this._uploadFile(idToUpload1);
                }
                stillSubmitting1 = this.getUploads({
                    status: qq.status.SUBMITTING
                }).length;
                if (stillSubmitting1) {
                    qq.log("Still waiting for " + stillSubmitting1 + " files to clear submit queue. Will re-parse stored IDs array shortly.");
                    setTimeout(function() {
                        self1._uploadStoredFiles();
                    }, 1e3);
                }
            },
            _validateFileOrBlobData: function(fileWrapper1, validationDescriptor1) {
                var self1 = this, file1 = function() {
                    if (fileWrapper1.file instanceof qq.BlobProxy) return fileWrapper1.file.referenceBlob;
                    return fileWrapper1.file;
                }(), name1 = validationDescriptor1.name, size1 = validationDescriptor1.size, buttonId1 = this._getButtonId(fileWrapper1.file), validationBase1 = this._getValidationBase(buttonId1), validityChecker1 = new qq.Promise();
                validityChecker1.then(function() {}, function() {
                    self1._fileOrBlobRejected(fileWrapper1.id, name1);
                });
                if (qq.isFileOrInput(file1) && !this._isAllowedExtension(validationBase1.allowedExtensions, name1)) {
                    this._itemError("typeError", name1, file1);
                    return validityChecker1.failure();
                }
                if (!this._options.validation.allowEmpty && size1 === 0) {
                    this._itemError("emptyError", name1, file1);
                    return validityChecker1.failure();
                }
                if (size1 > 0 && validationBase1.sizeLimit && size1 > validationBase1.sizeLimit) {
                    this._itemError("sizeError", name1, file1);
                    return validityChecker1.failure();
                }
                if (size1 > 0 && size1 < validationBase1.minSizeLimit) {
                    this._itemError("minSizeError", name1, file1);
                    return validityChecker1.failure();
                }
                if (qq.ImageValidation && qq.supportedFeatures.imagePreviews && qq.isFile(file1)) new qq.ImageValidation(file1, qq.bind(self1.log, self1)).validate(validationBase1.image).then(validityChecker1.success, function(errorCode1) {
                    self1._itemError(errorCode1 + "ImageError", name1, file1);
                    validityChecker1.failure();
                });
                else validityChecker1.success();
                return validityChecker1;
            },
            _wrapCallbacks: function() {
                var self1, safeCallback1, prop1;
                self1 = this;
                safeCallback1 = function(name1, callback1, args1) {
                    var errorMsg1;
                    try {
                        return callback1.apply(self1, args1);
                    } catch (exception1) {
                        errorMsg1 = exception1.message || exception1.toString();
                        self1.log("Caught exception in '" + name1 + "' callback - " + errorMsg1, "error");
                    }
                };
                for(prop1 in this._options.callbacks)(function() {
                    var callbackName1, callbackFunc1;
                    callbackName1 = prop1;
                    callbackFunc1 = self1._options.callbacks[callbackName1];
                    self1._options.callbacks[callbackName1] = function() {
                        return safeCallback1(callbackName1, callbackFunc1, arguments);
                    };
                })();
            }
        };
    })();
    (function() {
        "use strict";
        qq.FineUploaderBasic = function(o1) {
            var self1 = this;
            this._options = {
                debug: false,
                button: null,
                multiple: true,
                maxConnections: 3,
                disableCancelForFormUploads: false,
                autoUpload: true,
                warnBeforeUnload: true,
                request: {
                    customHeaders: {},
                    endpoint: "/server/upload",
                    filenameParam: "qqfilename",
                    forceMultipart: true,
                    inputName: "qqfile",
                    method: "POST",
                    omitDefaultParams: false,
                    params: {},
                    paramsInBody: true,
                    requireSuccessJson: true,
                    totalFileSizeName: "qqtotalfilesize",
                    uuidName: "qquuid"
                },
                validation: {
                    allowedExtensions: [],
                    sizeLimit: 0,
                    minSizeLimit: 0,
                    itemLimit: 0,
                    stopOnFirstInvalidFile: true,
                    acceptFiles: null,
                    image: {
                        maxHeight: 0,
                        maxWidth: 0,
                        minHeight: 0,
                        minWidth: 0
                    },
                    allowEmpty: false
                },
                callbacks: {
                    onSubmit: function(id1, name1) {},
                    onSubmitted: function(id1, name1) {},
                    onComplete: function(id1, name1, responseJSON1, maybeXhr1) {},
                    onAllComplete: function(successful1, failed1) {},
                    onCancel: function(id1, name1) {},
                    onUpload: function(id1, name1) {},
                    onUploadChunk: function(id1, name1, chunkData1) {},
                    onUploadChunkSuccess: function(id1, chunkData1, responseJSON1, xhr1) {},
                    onResume: function(id1, fileName1, chunkData1, customResumeData1) {},
                    onProgress: function(id1, name1, loaded1, total1) {},
                    onTotalProgress: function(loaded1, total1) {},
                    onError: function(id1, name1, reason1, maybeXhrOrXdr1) {},
                    onAutoRetry: function(id1, name1, attemptNumber1) {},
                    onManualRetry: function(id1, name1) {},
                    onValidateBatch: function(fileOrBlobData1) {},
                    onValidate: function(fileOrBlobData1) {},
                    onSubmitDelete: function(id1) {},
                    onDelete: function(id1) {},
                    onDeleteComplete: function(id1, xhrOrXdr1, isError1) {},
                    onPasteReceived: function(blob1) {},
                    onStatusChange: function(id1, oldStatus1, newStatus1) {},
                    onSessionRequestComplete: function(response1, success1, xhrOrXdr1) {}
                },
                messages: {
                    typeError: "{file} has an invalid extension. Valid extension(s): {extensions}.",
                    sizeError: "{file} is too large, maximum file size is {sizeLimit}.",
                    minSizeError: "{file} is too small, minimum file size is {minSizeLimit}.",
                    emptyError: "{file} is empty, please select files again without it.",
                    noFilesError: "No files to upload.",
                    tooManyItemsError: "Too many items ({netItems}) would be uploaded.  Item limit is {itemLimit}.",
                    maxHeightImageError: "Image is too tall.",
                    maxWidthImageError: "Image is too wide.",
                    minHeightImageError: "Image is not tall enough.",
                    minWidthImageError: "Image is not wide enough.",
                    retryFailTooManyItems: "Retry failed - you have reached your file limit.",
                    onLeave: "The files are being uploaded, if you leave now the upload will be canceled.",
                    unsupportedBrowserIos8Safari: "Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari.  Please use iOS8 Chrome until Apple fixes these issues."
                },
                retry: {
                    enableAuto: false,
                    maxAutoAttempts: 3,
                    autoAttemptDelay: 5,
                    preventRetryResponseProperty: "preventRetry"
                },
                classes: {
                    buttonHover: "qq-upload-button-hover",
                    buttonFocus: "qq-upload-button-focus"
                },
                chunking: {
                    enabled: false,
                    concurrent: {
                        enabled: false
                    },
                    mandatory: false,
                    paramNames: {
                        partIndex: "qqpartindex",
                        partByteOffset: "qqpartbyteoffset",
                        chunkSize: "qqchunksize",
                        totalFileSize: "qqtotalfilesize",
                        totalParts: "qqtotalparts"
                    },
                    partSize: function(id1) {
                        return 2e6;
                    },
                    success: {
                        endpoint: null,
                        headers: function(id1) {
                            return null;
                        },
                        jsonPayload: false,
                        method: "POST",
                        params: function(id1) {
                            return null;
                        },
                        resetOnStatus: []
                    }
                },
                resume: {
                    enabled: false,
                    recordsExpireIn: 7,
                    paramNames: {
                        resuming: "qqresume"
                    },
                    customKeys: function(fileId1) {
                        return [];
                    }
                },
                formatFileName: function(fileOrBlobName1) {
                    return fileOrBlobName1;
                },
                text: {
                    defaultResponseError: "Upload failure reason unknown",
                    fileInputTitle: "file input",
                    sizeSymbols: [
                        "kB",
                        "MB",
                        "GB",
                        "TB",
                        "PB",
                        "EB"
                    ]
                },
                deleteFile: {
                    enabled: false,
                    method: "DELETE",
                    endpoint: "/server/upload",
                    customHeaders: {},
                    params: {}
                },
                cors: {
                    expected: false,
                    sendCredentials: false,
                    allowXdr: false
                },
                blobs: {
                    defaultName: "misc_data"
                },
                paste: {
                    targetElement: null,
                    defaultName: "pasted_image"
                },
                camera: {
                    ios: false,
                    button: null
                },
                extraButtons: [],
                session: {
                    endpoint: null,
                    params: {},
                    customHeaders: {},
                    refreshOnReset: true
                },
                form: {
                    element: "qq-form",
                    autoUpload: false,
                    interceptSubmit: true
                },
                scaling: {
                    customResizer: null,
                    sendOriginal: true,
                    orient: true,
                    defaultType: null,
                    defaultQuality: 80,
                    failureText: "Failed to scale",
                    includeExif: false,
                    sizes: []
                },
                workarounds: {
                    iosEmptyVideos: true,
                    ios8SafariUploads: true,
                    ios8BrowserCrash: false
                }
            };
            qq.extend(this._options, o1, true);
            this._buttons = [];
            this._extraButtonSpecs = {};
            this._buttonIdsForFileIds = [];
            this._wrapCallbacks();
            this._disposeSupport = new qq.DisposeSupport();
            this._storedIds = [];
            this._autoRetries = [];
            this._retryTimeouts = [];
            this._preventRetries = [];
            this._thumbnailUrls = [];
            this._netUploadedOrQueued = 0;
            this._netUploaded = 0;
            this._uploadData = this._createUploadDataTracker();
            this._initFormSupportAndParams();
            this._customHeadersStore = this._createStore(this._options.request.customHeaders);
            this._deleteFileCustomHeadersStore = this._createStore(this._options.deleteFile.customHeaders);
            this._deleteFileParamsStore = this._createStore(this._options.deleteFile.params);
            this._endpointStore = this._createStore(this._options.request.endpoint);
            this._deleteFileEndpointStore = this._createStore(this._options.deleteFile.endpoint);
            this._handler = this._createUploadHandler();
            this._deleteHandler = qq.DeleteFileAjaxRequester && this._createDeleteHandler();
            if (this._options.button) this._defaultButtonId = this._createUploadButton({
                element: this._options.button,
                title: this._options.text.fileInputTitle
            }).getButtonId();
            this._generateExtraButtonSpecs();
            this._handleCameraAccess();
            if (this._options.paste.targetElement) {
                if (qq.PasteSupport) this._pasteHandler = this._createPasteHandler();
                else this.log("Paste support module not found", "error");
            }
            this._options.warnBeforeUnload && this._preventLeaveInProgress();
            this._imageGenerator = qq.ImageGenerator && new qq.ImageGenerator(qq.bind(this.log, this));
            this._refreshSessionData();
            this._succeededSinceLastAllComplete = [];
            this._failedSinceLastAllComplete = [];
            this._scaler = qq.Scaler && new qq.Scaler(this._options.scaling, qq.bind(this.log, this)) || {};
            if (this._scaler.enabled) this._customNewFileHandler = qq.bind(this._scaler.handleNewFile, this._scaler);
            if (qq.TotalProgress && qq.supportedFeatures.progressBar) this._totalProgress = new qq.TotalProgress(qq.bind(this._onTotalProgress, this), function(id1) {
                var entry1 = self1._uploadData.retrieve({
                    id: id1
                });
                return entry1 && entry1.size || 0;
            });
            this._currentItemLimit = this._options.validation.itemLimit;
            this._customResumeDataStore = this._createStore();
        };
        qq.FineUploaderBasic.prototype = qq.basePublicApi;
        qq.extend(qq.FineUploaderBasic.prototype, qq.basePrivateApi);
    })();
    qq.AjaxRequester = function(o1) {
        "use strict";
        var log1, shouldParamsBeInQueryString1, queue1 = [], requestData1 = {}, options1 = {
            acceptHeader: null,
            validMethods: [
                "PATCH",
                "POST",
                "PUT"
            ],
            method: "POST",
            contentType: "application/x-www-form-urlencoded",
            maxConnections: 3,
            customHeaders: {},
            endpointStore: {},
            paramsStore: {},
            mandatedParams: {},
            allowXRequestedWithAndCacheControl: true,
            successfulResponseCodes: {
                DELETE: [
                    200,
                    202,
                    204
                ],
                PATCH: [
                    200,
                    201,
                    202,
                    203,
                    204
                ],
                POST: [
                    200,
                    201,
                    202,
                    203,
                    204
                ],
                PUT: [
                    200,
                    201,
                    202,
                    203,
                    204
                ],
                GET: [
                    200
                ]
            },
            cors: {
                expected: false,
                sendCredentials: false
            },
            log: function(str1, level1) {},
            onSend: function(id1) {},
            onComplete: function(id1, xhrOrXdr1, isError1) {},
            onProgress: null
        };
        qq.extend(options1, o1);
        log1 = options1.log;
        if (qq.indexOf(options1.validMethods, options1.method) < 0) throw new Error("'" + options1.method + "' is not a supported method for this type of request!");
        function isSimpleMethod1() {
            return qq.indexOf([
                "GET",
                "POST",
                "HEAD"
            ], options1.method) >= 0;
        }
        function containsNonSimpleHeaders1(headers1) {
            var containsNonSimple1 = false;
            qq.each(containsNonSimple1, function(idx1, header1) {
                if (qq.indexOf([
                    "Accept",
                    "Accept-Language",
                    "Content-Language",
                    "Content-Type"
                ], header1) < 0) {
                    containsNonSimple1 = true;
                    return false;
                }
            });
            return containsNonSimple1;
        }
        function isXdr1(xhr1) {
            return options1.cors.expected && xhr1.withCredentials === undefined;
        }
        function getCorsAjaxTransport1() {
            var xhrOrXdr1;
            if (window.XMLHttpRequest || window.ActiveXObject) {
                xhrOrXdr1 = qq.createXhrInstance();
                if (xhrOrXdr1.withCredentials === undefined) {
                    xhrOrXdr1 = new XDomainRequest();
                    xhrOrXdr1.onload = function() {};
                    xhrOrXdr1.onerror = function() {};
                    xhrOrXdr1.ontimeout = function() {};
                    xhrOrXdr1.onprogress = function() {};
                }
            }
            return xhrOrXdr1;
        }
        function getXhrOrXdr1(id1, suppliedXhr1) {
            var xhrOrXdr1 = requestData1[id1] && requestData1[id1].xhr;
            if (!xhrOrXdr1) {
                if (suppliedXhr1) xhrOrXdr1 = suppliedXhr1;
                else if (options1.cors.expected) xhrOrXdr1 = getCorsAjaxTransport1();
                else xhrOrXdr1 = qq.createXhrInstance();
                requestData1[id1].xhr = xhrOrXdr1;
            }
            return xhrOrXdr1;
        }
        function dequeue1(id1) {
            var i1 = qq.indexOf(queue1, id1), max1 = options1.maxConnections, nextId1;
            delete requestData1[id1];
            queue1.splice(i1, 1);
            if (queue1.length >= max1 && i1 < max1) {
                nextId1 = queue1[max1 - 1];
                sendRequest1(nextId1);
            }
        }
        function onComplete1(id1, xdrError1) {
            var xhr1 = getXhrOrXdr1(id1), method1 = options1.method, isError1 = xdrError1 === true;
            dequeue1(id1);
            if (isError1) log1(method1 + " request for " + id1 + " has failed", "error");
            else if (!isXdr1(xhr1) && !isResponseSuccessful1(xhr1.status)) {
                isError1 = true;
                log1(method1 + " request for " + id1 + " has failed - response code " + xhr1.status, "error");
            }
            options1.onComplete(id1, xhr1, isError1);
        }
        function getParams1(id1) {
            var onDemandParams1 = requestData1[id1].additionalParams, mandatedParams1 = options1.mandatedParams, params1;
            if (options1.paramsStore.get) params1 = options1.paramsStore.get(id1);
            if (onDemandParams1) qq.each(onDemandParams1, function(name1, val1) {
                params1 = params1 || {};
                params1[name1] = val1;
            });
            if (mandatedParams1) qq.each(mandatedParams1, function(name1, val1) {
                params1 = params1 || {};
                params1[name1] = val1;
            });
            return params1;
        }
        function sendRequest1(id1, optXhr1) {
            var xhr1 = getXhrOrXdr1(id1, optXhr1), method1 = options1.method, params1 = getParams1(id1), payload1 = requestData1[id1].payload, url1;
            options1.onSend(id1);
            url1 = createUrl1(id1, params1, requestData1[id1].additionalQueryParams);
            if (isXdr1(xhr1)) {
                xhr1.onload = getXdrLoadHandler1(id1);
                xhr1.onerror = getXdrErrorHandler1(id1);
            } else xhr1.onreadystatechange = getXhrReadyStateChangeHandler1(id1);
            registerForUploadProgress1(id1);
            xhr1.open(method1, url1, true);
            if (options1.cors.expected && options1.cors.sendCredentials && !isXdr1(xhr1)) xhr1.withCredentials = true;
            setHeaders1(id1);
            log1("Sending " + method1 + " request for " + id1);
            if (payload1) xhr1.send(payload1);
            else if (shouldParamsBeInQueryString1 || !params1) xhr1.send();
            else if (params1 && options1.contentType && options1.contentType.toLowerCase().indexOf("application/x-www-form-urlencoded") >= 0) xhr1.send(qq.obj2url(params1, ""));
            else if (params1 && options1.contentType && options1.contentType.toLowerCase().indexOf("application/json") >= 0) xhr1.send(JSON.stringify(params1));
            else xhr1.send(params1);
            return xhr1;
        }
        function createUrl1(id1, params1, additionalQueryParams1) {
            var endpoint1 = options1.endpointStore.get(id1), addToPath1 = requestData1[id1].addToPath;
            if (addToPath1 != undefined) endpoint1 += "/" + addToPath1;
            if (shouldParamsBeInQueryString1 && params1) endpoint1 = qq.obj2url(params1, endpoint1);
            if (additionalQueryParams1) endpoint1 = qq.obj2url(additionalQueryParams1, endpoint1);
            return endpoint1;
        }
        function getXhrReadyStateChangeHandler1(id1) {
            return function() {
                if (getXhrOrXdr1(id1).readyState === 4) onComplete1(id1);
            };
        }
        function registerForUploadProgress1(id1) {
            var onProgress1 = options1.onProgress;
            if (onProgress1) getXhrOrXdr1(id1).upload.onprogress = function(e1) {
                if (e1.lengthComputable) onProgress1(id1, e1.loaded, e1.total);
            };
        }
        function getXdrLoadHandler1(id1) {
            return function() {
                onComplete1(id1);
            };
        }
        function getXdrErrorHandler1(id1) {
            return function() {
                onComplete1(id1, true);
            };
        }
        function setHeaders1(id1) {
            var xhr1 = getXhrOrXdr1(id1), customHeaders1 = options1.customHeaders, onDemandHeaders1 = requestData1[id1].additionalHeaders || {}, method1 = options1.method, allHeaders1 = {};
            if (!isXdr1(xhr1)) {
                options1.acceptHeader && xhr1.setRequestHeader("Accept", options1.acceptHeader);
                if (options1.allowXRequestedWithAndCacheControl) {
                    if (!options1.cors.expected || !isSimpleMethod1() || containsNonSimpleHeaders1(customHeaders1)) {
                        xhr1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                        xhr1.setRequestHeader("Cache-Control", "no-cache");
                    }
                }
                if (options1.contentType && (method1 === "POST" || method1 === "PUT")) xhr1.setRequestHeader("Content-Type", options1.contentType);
                qq.extend(allHeaders1, qq.isFunction(customHeaders1) ? customHeaders1(id1) : customHeaders1);
                qq.extend(allHeaders1, onDemandHeaders1);
                qq.each(allHeaders1, function(name1, val1) {
                    xhr1.setRequestHeader(name1, val1);
                });
            }
        }
        function isResponseSuccessful1(responseCode1) {
            return qq.indexOf(options1.successfulResponseCodes[options1.method], responseCode1) >= 0;
        }
        function prepareToSend1(id1, optXhr1, addToPath1, additionalParams1, additionalQueryParams1, additionalHeaders1, payload1) {
            requestData1[id1] = {
                addToPath: addToPath1,
                additionalParams: additionalParams1,
                additionalQueryParams: additionalQueryParams1,
                additionalHeaders: additionalHeaders1,
                payload: payload1
            };
            var len1 = queue1.push(id1);
            if (len1 <= options1.maxConnections) return sendRequest1(id1, optXhr1);
        }
        shouldParamsBeInQueryString1 = options1.method === "GET" || options1.method === "DELETE";
        qq.extend(this, {
            initTransport: function(id1) {
                var path1, params1, headers1, payload1, cacheBuster1, additionalQueryParams1;
                return {
                    withPath: function(appendToPath1) {
                        path1 = appendToPath1;
                        return this;
                    },
                    withParams: function(additionalParams1) {
                        params1 = additionalParams1;
                        return this;
                    },
                    withQueryParams: function(_additionalQueryParams_1) {
                        additionalQueryParams1 = _additionalQueryParams_1;
                        return this;
                    },
                    withHeaders: function(additionalHeaders1) {
                        headers1 = additionalHeaders1;
                        return this;
                    },
                    withPayload: function(thePayload1) {
                        payload1 = thePayload1;
                        return this;
                    },
                    withCacheBuster: function() {
                        cacheBuster1 = true;
                        return this;
                    },
                    send: function(optXhr1) {
                        if (cacheBuster1 && qq.indexOf([
                            "GET",
                            "DELETE"
                        ], options1.method) >= 0) params1.qqtimestamp = new Date().getTime();
                        return prepareToSend1(id1, optXhr1, path1, params1, additionalQueryParams1, headers1, payload1);
                    }
                };
            },
            canceled: function(id1) {
                dequeue1(id1);
            }
        });
    };
    qq.UploadHandler = function(spec1) {
        "use strict";
        var proxy1 = spec1.proxy, fileState1 = {}, onCancel1 = proxy1.onCancel, getName1 = proxy1.getName;
        qq.extend(this, {
            add: function(id1, fileItem1) {
                fileState1[id1] = fileItem1;
                fileState1[id1].temp = {};
            },
            cancel: function(id1) {
                var self1 = this, cancelFinalizationEffort1 = new qq.Promise(), onCancelRetVal1 = onCancel1(id1, getName1(id1), cancelFinalizationEffort1);
                onCancelRetVal1.then(function() {
                    if (self1.isValid(id1)) {
                        fileState1[id1].canceled = true;
                        self1.expunge(id1);
                    }
                    cancelFinalizationEffort1.success();
                });
            },
            expunge: function(id1) {
                delete fileState1[id1];
            },
            getThirdPartyFileId: function(id1) {
                return fileState1[id1].key;
            },
            isValid: function(id1) {
                return fileState1[id1] !== undefined;
            },
            reset: function() {
                fileState1 = {};
            },
            _getFileState: function(id1) {
                return fileState1[id1];
            },
            _setThirdPartyFileId: function(id1, thirdPartyFileId1) {
                fileState1[id1].key = thirdPartyFileId1;
            },
            _wasCanceled: function(id1) {
                return !!fileState1[id1].canceled;
            }
        });
    };
    qq.UploadHandlerController = function(o1, namespace1) {
        "use strict";
        var controller1 = this, chunkingPossible1 = false, concurrentChunkingPossible1 = false, chunking1, preventRetryResponse1, log1, handler1, options1 = {
            paramsStore: {},
            maxConnections: 3,
            chunking: {
                enabled: false,
                multiple: {
                    enabled: false
                }
            },
            log: function(str1, level1) {},
            onProgress: function(id1, fileName1, loaded1, total1) {},
            onComplete: function(id1, fileName1, response1, xhr1) {},
            onCancel: function(id1, fileName1) {},
            onUploadPrep: function(id1) {},
            onUpload: function(id1, fileName1) {},
            onUploadChunk: function(id1, fileName1, chunkData1) {},
            onUploadChunkSuccess: function(id1, chunkData1, response1, xhr1) {},
            onAutoRetry: function(id1, fileName1, response1, xhr1) {},
            onResume: function(id1, fileName1, chunkData1, customResumeData1) {},
            onUuidChanged: function(id1, newUuid1) {},
            getName: function(id1) {},
            setSize: function(id1, newSize1) {},
            isQueued: function(id1) {},
            getIdsInProxyGroup: function(id1) {},
            getIdsInBatch: function(id1) {},
            isInProgress: function(id1) {}
        }, chunked1 = {
            done: function(id1, chunkIdx1, response1, xhr1) {
                var chunkData1 = handler1._getChunkData(id1, chunkIdx1);
                handler1._getFileState(id1).attemptingResume = false;
                delete handler1._getFileState(id1).temp.chunkProgress[chunkIdx1];
                handler1._getFileState(id1).loaded += chunkData1.size;
                options1.onUploadChunkSuccess(id1, handler1._getChunkDataForCallback(chunkData1), response1, xhr1);
            },
            finalize: function(id1) {
                var size1 = options1.getSize(id1), name1 = options1.getName(id1);
                log1("All chunks have been uploaded for " + id1 + " - finalizing....");
                handler1.finalizeChunks(id1).then(function(response1, xhr1) {
                    log1("Finalize successful for " + id1);
                    var normaizedResponse1 = upload1.normalizeResponse(response1, true);
                    options1.onProgress(id1, name1, size1, size1);
                    handler1._maybeDeletePersistedChunkData(id1);
                    upload1.cleanup(id1, normaizedResponse1, xhr1);
                }, function(response1, xhr1) {
                    var normalizedResponse1 = upload1.normalizeResponse(response1, false);
                    log1("Problem finalizing chunks for file ID " + id1 + " - " + normalizedResponse1.error, "error");
                    if (normalizedResponse1.reset || xhr1 && options1.chunking.success.resetOnStatus.indexOf(xhr1.status) >= 0) chunked1.reset(id1);
                    if (!options1.onAutoRetry(id1, name1, normalizedResponse1, xhr1)) upload1.cleanup(id1, normalizedResponse1, xhr1);
                });
            },
            handleFailure: function(chunkIdx1, id1, response1, xhr1) {
                var name1 = options1.getName(id1);
                log1("Chunked upload request failed for " + id1 + ", chunk " + chunkIdx1);
                handler1.clearCachedChunk(id1, chunkIdx1);
                var responseToReport1 = upload1.normalizeResponse(response1, false), inProgressIdx1;
                if (responseToReport1.reset) chunked1.reset(id1);
                else {
                    var inProgressChunksArray1 = handler1._getFileState(id1).chunking.inProgress;
                    inProgressIdx1 = inProgressChunksArray1 ? qq.indexOf(inProgressChunksArray1, chunkIdx1) : -1;
                    if (inProgressIdx1 >= 0) {
                        handler1._getFileState(id1).chunking.inProgress.splice(inProgressIdx1, 1);
                        handler1._getFileState(id1).chunking.remaining.unshift(chunkIdx1);
                    }
                }
                if (!handler1._getFileState(id1).temp.ignoreFailure) {
                    if (concurrentChunkingPossible1) {
                        handler1._getFileState(id1).temp.ignoreFailure = true;
                        log1(qq.format("Going to attempt to abort these chunks: {}. These are currently in-progress: {}.", JSON.stringify(Object.keys(handler1._getXhrs(id1))), JSON.stringify(handler1._getFileState(id1).chunking.inProgress)));
                        qq.each(handler1._getXhrs(id1), function(ckid1, ckXhr1) {
                            log1(qq.format("Attempting to abort file {}.{}. XHR readyState {}. ", id1, ckid1, ckXhr1.readyState));
                            ckXhr1.abort();
                            ckXhr1._cancelled = true;
                        });
                        handler1.moveInProgressToRemaining(id1);
                        connectionManager1.free(id1, true);
                    }
                    if (!options1.onAutoRetry(id1, name1, responseToReport1, xhr1)) upload1.cleanup(id1, responseToReport1, xhr1);
                }
            },
            hasMoreParts: function(id1) {
                return !!handler1._getFileState(id1).chunking.remaining.length;
            },
            nextPart: function(id1) {
                var nextIdx1 = handler1._getFileState(id1).chunking.remaining.shift();
                if (nextIdx1 >= handler1._getTotalChunks(id1)) nextIdx1 = null;
                return nextIdx1;
            },
            reset: function(id1) {
                log1("Server or callback has ordered chunking effort to be restarted on next attempt for item ID " + id1, "error");
                handler1._maybeDeletePersistedChunkData(id1);
                handler1.reevaluateChunking(id1);
                handler1._getFileState(id1).loaded = 0;
                handler1._getFileState(id1).attemptingResume = false;
            },
            sendNext: function(id1) {
                var size1 = options1.getSize(id1), name1 = options1.getName(id1), chunkIdx1 = chunked1.nextPart(id1), chunkData1 = handler1._getChunkData(id1, chunkIdx1), fileState1 = handler1._getFileState(id1), resuming1 = fileState1.attemptingResume, inProgressChunks1 = fileState1.chunking.inProgress || [];
                if (fileState1.loaded == null) fileState1.loaded = 0;
                if (resuming1 && options1.onResume(id1, name1, chunkData1, fileState1.customResumeData) === false) {
                    chunked1.reset(id1);
                    chunkIdx1 = chunked1.nextPart(id1);
                    chunkData1 = handler1._getChunkData(id1, chunkIdx1);
                    resuming1 = false;
                }
                if (chunkIdx1 == null && inProgressChunks1.length === 0) chunked1.finalize(id1);
                else {
                    inProgressChunks1.push(chunkIdx1);
                    handler1._getFileState(id1).chunking.inProgress = inProgressChunks1;
                    if (concurrentChunkingPossible1) connectionManager1.open(id1, chunkIdx1);
                    if (concurrentChunkingPossible1 && connectionManager1.available() && handler1._getFileState(id1).chunking.remaining.length) chunked1.sendNext(id1);
                    if (chunkData1.blob.size === 0) {
                        log1(qq.format("Chunk {} for file {} will not be uploaded, zero sized chunk.", chunkIdx1, id1), "error");
                        chunked1.handleFailure(chunkIdx1, id1, "File is no longer available", null);
                    }
                    var onUploadChunkPromise1 = options1.onUploadChunk(id1, name1, handler1._getChunkDataForCallback(chunkData1));
                    onUploadChunkPromise1.then(function(requestOverrides1) {
                        if (!options1.isInProgress(id1)) log1(qq.format("Not sending chunked upload request for item {}.{} - no longer in progress.", id1, chunkIdx1));
                        else {
                            log1(qq.format("Sending chunked upload request for item {}.{}, bytes {}-{} of {}.", id1, chunkIdx1, chunkData1.start + 1, chunkData1.end, size1));
                            var uploadChunkData1 = {
                                chunkIdx: chunkIdx1,
                                id: id1,
                                overrides: requestOverrides1,
                                resuming: resuming1
                            };
                            handler1.uploadChunk(uploadChunkData1).then(function success1(response1, xhr1) {
                                log1("Chunked upload request succeeded for " + id1 + ", chunk " + chunkIdx1);
                                handler1.clearCachedChunk(id1, chunkIdx1);
                                var inProgressChunks1 = handler1._getFileState(id1).chunking.inProgress || [], responseToReport1 = upload1.normalizeResponse(response1, true), inProgressChunkIdx1 = qq.indexOf(inProgressChunks1, chunkIdx1);
                                log1(qq.format("Chunk {} for file {} uploaded successfully.", chunkIdx1, id1));
                                chunked1.done(id1, chunkIdx1, responseToReport1, xhr1);
                                if (inProgressChunkIdx1 >= 0) inProgressChunks1.splice(inProgressChunkIdx1, 1);
                                handler1._maybePersistChunkedState(id1);
                                if (!chunked1.hasMoreParts(id1) && inProgressChunks1.length === 0) chunked1.finalize(id1);
                                else if (chunked1.hasMoreParts(id1)) chunked1.sendNext(id1);
                                else log1(qq.format("File ID {} has no more chunks to send and these chunk indexes are still marked as in-progress: {}", id1, JSON.stringify(inProgressChunks1)));
                            }, function failure1(response1, xhr1) {
                                chunked1.handleFailure(chunkIdx1, id1, response1, xhr1);
                            }).done(function() {
                                handler1.clearXhr(id1, chunkIdx1);
                            });
                        }
                    }, function(error1) {
                        chunked1.handleFailure(chunkIdx1, id1, error1, null);
                    });
                }
            }
        }, connectionManager1 = {
            _open: [],
            _openChunks: {},
            _waiting: [],
            available: function() {
                var max1 = options1.maxConnections, openChunkEntriesCount1 = 0, openChunksCount1 = 0;
                qq.each(connectionManager1._openChunks, function(fileId1, openChunkIndexes1) {
                    openChunkEntriesCount1++;
                    openChunksCount1 += openChunkIndexes1.length;
                });
                return max1 - (connectionManager1._open.length - openChunkEntriesCount1 + openChunksCount1);
            },
            free: function(id1, dontAllowNext1) {
                var allowNext1 = !dontAllowNext1, waitingIndex1 = qq.indexOf(connectionManager1._waiting, id1), connectionsIndex1 = qq.indexOf(connectionManager1._open, id1), nextId1;
                delete connectionManager1._openChunks[id1];
                if (upload1.getProxyOrBlob(id1) instanceof qq.BlobProxy) {
                    log1("Generated blob upload has ended for " + id1 + ", disposing generated blob.");
                    delete handler1._getFileState(id1).file;
                }
                if (waitingIndex1 >= 0) connectionManager1._waiting.splice(waitingIndex1, 1);
                else if (allowNext1 && connectionsIndex1 >= 0) {
                    connectionManager1._open.splice(connectionsIndex1, 1);
                    nextId1 = connectionManager1._waiting.shift();
                    if (nextId1 >= 0) {
                        connectionManager1._open.push(nextId1);
                        upload1.start(nextId1);
                    }
                }
            },
            getWaitingOrConnected: function() {
                var waitingOrConnected1 = [];
                qq.each(connectionManager1._openChunks, function(fileId1, chunks1) {
                    if (chunks1 && chunks1.length) waitingOrConnected1.push(parseInt(fileId1));
                });
                qq.each(connectionManager1._open, function(idx1, fileId1) {
                    if (!connectionManager1._openChunks[fileId1]) waitingOrConnected1.push(parseInt(fileId1));
                });
                waitingOrConnected1 = waitingOrConnected1.concat(connectionManager1._waiting);
                return waitingOrConnected1;
            },
            isUsingConnection: function(id1) {
                return qq.indexOf(connectionManager1._open, id1) >= 0;
            },
            open: function(id1, chunkIdx1) {
                if (chunkIdx1 == null) connectionManager1._waiting.push(id1);
                if (connectionManager1.available()) {
                    if (chunkIdx1 == null) {
                        connectionManager1._waiting.pop();
                        connectionManager1._open.push(id1);
                    } else (function() {
                        var openChunksEntry1 = connectionManager1._openChunks[id1] || [];
                        openChunksEntry1.push(chunkIdx1);
                        connectionManager1._openChunks[id1] = openChunksEntry1;
                    })();
                    return true;
                }
                return false;
            },
            reset: function() {
                connectionManager1._waiting = [];
                connectionManager1._open = [];
            }
        }, simple1 = {
            send: function(id1, name1) {
                var fileState1 = handler1._getFileState(id1);
                if (!fileState1) {
                    log1("Ignoring send request as this upload may have been cancelled, File ID " + id1, "warn");
                    return;
                }
                fileState1.loaded = 0;
                log1("Sending simple upload request for " + id1);
                handler1.uploadFile(id1).then(function(response1, optXhr1) {
                    log1("Simple upload request succeeded for " + id1);
                    var responseToReport1 = upload1.normalizeResponse(response1, true), size1 = options1.getSize(id1);
                    options1.onProgress(id1, name1, size1, size1);
                    upload1.maybeNewUuid(id1, responseToReport1);
                    upload1.cleanup(id1, responseToReport1, optXhr1);
                }, function(response1, optXhr1) {
                    log1("Simple upload request failed for " + id1);
                    var responseToReport1 = upload1.normalizeResponse(response1, false);
                    if (!options1.onAutoRetry(id1, name1, responseToReport1, optXhr1)) upload1.cleanup(id1, responseToReport1, optXhr1);
                });
            }
        }, upload1 = {
            cancel: function(id1) {
                log1("Cancelling " + id1);
                options1.paramsStore.remove(id1);
                connectionManager1.free(id1);
            },
            cleanup: function(id1, response1, optXhr1) {
                var name1 = options1.getName(id1);
                options1.onComplete(id1, name1, response1, optXhr1);
                if (handler1._getFileState(id1)) handler1._clearXhrs && handler1._clearXhrs(id1);
                connectionManager1.free(id1);
            },
            getProxyOrBlob: function(id1) {
                return handler1.getProxy && handler1.getProxy(id1) || handler1.getFile && handler1.getFile(id1);
            },
            initHandler: function() {
                var handlerType1 = namespace1 ? qq[namespace1] : qq.traditional, handlerModuleSubtype1 = qq.supportedFeatures.ajaxUploading ? "Xhr" : "Form";
                handler1 = new handlerType1[handlerModuleSubtype1 + "UploadHandler"](options1, {
                    getCustomResumeData: options1.getCustomResumeData,
                    getDataByUuid: options1.getDataByUuid,
                    getName: options1.getName,
                    getSize: options1.getSize,
                    getUuid: options1.getUuid,
                    log: log1,
                    onCancel: options1.onCancel,
                    onProgress: options1.onProgress,
                    onUuidChanged: options1.onUuidChanged,
                    onFinalizing: function(id1) {
                        options1.setStatus(id1, qq.status.UPLOAD_FINALIZING);
                    }
                });
                if (handler1._removeExpiredChunkingRecords) handler1._removeExpiredChunkingRecords();
            },
            isDeferredEligibleForUpload: function(id1) {
                return options1.isQueued(id1);
            },
            maybeDefer: function(id1, blob1) {
                if (blob1 && !handler1.getFile(id1) && blob1 instanceof qq.BlobProxy) {
                    options1.onUploadPrep(id1);
                    log1("Attempting to generate a blob on-demand for " + id1);
                    blob1.create().then(function(generatedBlob1) {
                        log1("Generated an on-demand blob for " + id1);
                        handler1.updateBlob(id1, generatedBlob1);
                        options1.setSize(id1, generatedBlob1.size);
                        handler1.reevaluateChunking(id1);
                        upload1.maybeSendDeferredFiles(id1);
                    }, function(errorMessage1) {
                        var errorResponse1 = {};
                        if (errorMessage1) errorResponse1.error = errorMessage1;
                        log1(qq.format("Failed to generate blob for ID {}.  Error message: {}.", id1, errorMessage1), "error");
                        options1.onComplete(id1, options1.getName(id1), qq.extend(errorResponse1, preventRetryResponse1), null);
                        upload1.maybeSendDeferredFiles(id1);
                        connectionManager1.free(id1);
                    });
                } else return upload1.maybeSendDeferredFiles(id1);
                return false;
            },
            maybeSendDeferredFiles: function(id1) {
                var idsInGroup1 = options1.getIdsInProxyGroup(id1), uploadedThisId1 = false;
                if (idsInGroup1 && idsInGroup1.length) {
                    log1("Maybe ready to upload proxy group file " + id1);
                    qq.each(idsInGroup1, function(idx1, idInGroup1) {
                        if (upload1.isDeferredEligibleForUpload(idInGroup1) && !!handler1.getFile(idInGroup1)) {
                            uploadedThisId1 = idInGroup1 === id1;
                            upload1.now(idInGroup1);
                        } else if (upload1.isDeferredEligibleForUpload(idInGroup1)) return false;
                    });
                } else {
                    uploadedThisId1 = true;
                    upload1.now(id1);
                }
                return uploadedThisId1;
            },
            maybeNewUuid: function(id1, response1) {
                if (response1.newUuid !== undefined) options1.onUuidChanged(id1, response1.newUuid);
            },
            normalizeResponse: function(originalResponse1, successful1) {
                var response1 = originalResponse1;
                if (!qq.isObject(originalResponse1)) {
                    response1 = {};
                    if (qq.isString(originalResponse1) && !successful1) response1.error = originalResponse1;
                }
                response1.success = successful1;
                return response1;
            },
            now: function(id1) {
                var name1 = options1.getName(id1);
                if (!controller1.isValid(id1)) throw new qq.Error(id1 + " is not a valid file ID to upload!");
                options1.onUpload(id1, name1).then(function(response1) {
                    if (response1 && response1.pause) {
                        options1.setStatus(id1, qq.status.PAUSED);
                        handler1.pause(id1);
                        connectionManager1.free(id1);
                    } else if (chunkingPossible1 && handler1._shouldChunkThisFile(id1)) chunked1.sendNext(id1);
                    else simple1.send(id1, name1);
                }, function(error1) {
                    error1 = error1 || {};
                    log1(id1 + " upload start aborted due to rejected onUpload Promise - details: " + error1, "error");
                    if (!options1.onAutoRetry(id1, name1, error1.responseJSON || {})) {
                        var response1 = upload1.normalizeResponse(error1.responseJSON, false);
                        upload1.cleanup(id1, response1);
                    }
                });
            },
            start: function(id1) {
                var blobToUpload1 = upload1.getProxyOrBlob(id1);
                if (blobToUpload1) return upload1.maybeDefer(id1, blobToUpload1);
                else {
                    upload1.now(id1);
                    return true;
                }
            }
        };
        qq.extend(this, {
            add: function(id1, file1) {
                handler1.add.apply(this, arguments);
            },
            upload: function(id1) {
                if (connectionManager1.open(id1)) return upload1.start(id1);
                return false;
            },
            retry: function(id1) {
                if (concurrentChunkingPossible1) handler1._getFileState(id1).temp.ignoreFailure = false;
                if (connectionManager1.isUsingConnection(id1)) return upload1.start(id1);
                else return controller1.upload(id1);
            },
            cancel: function(id1) {
                var cancelRetVal1 = handler1.cancel(id1);
                if (qq.isGenericPromise(cancelRetVal1)) cancelRetVal1.then(function() {
                    upload1.cancel(id1);
                });
                else if (cancelRetVal1 !== false) upload1.cancel(id1);
            },
            cancelAll: function() {
                var waitingOrConnected1 = connectionManager1.getWaitingOrConnected(), i1;
                if (waitingOrConnected1.length) for(i1 = waitingOrConnected1.length - 1; i1 >= 0; i1--)controller1.cancel(waitingOrConnected1[i1]);
                connectionManager1.reset();
            },
            getFile: function(id1) {
                if (handler1.getProxy && handler1.getProxy(id1)) return handler1.getProxy(id1).referenceBlob;
                return handler1.getFile && handler1.getFile(id1);
            },
            isProxied: function(id1) {
                return !!(handler1.getProxy && handler1.getProxy(id1));
            },
            getInput: function(id1) {
                if (handler1.getInput) return handler1.getInput(id1);
            },
            reset: function() {
                log1("Resetting upload handler");
                controller1.cancelAll();
                connectionManager1.reset();
                handler1.reset();
            },
            expunge: function(id1) {
                if (controller1.isValid(id1)) return handler1.expunge(id1);
            },
            isValid: function(id1) {
                return handler1.isValid(id1);
            },
            hasResumeRecord: function(id1) {
                var key1 = handler1.isValid(id1) && handler1._getLocalStorageId && handler1._getLocalStorageId(id1);
                if (key1) return !!localStorage.getItem(key1);
                return false;
            },
            getResumableFilesData: function() {
                if (handler1.getResumableFilesData) return handler1.getResumableFilesData();
                return [];
            },
            getThirdPartyFileId: function(id1) {
                if (controller1.isValid(id1)) return handler1.getThirdPartyFileId(id1);
            },
            pause: function(id1) {
                if (controller1.isResumable(id1) && handler1.pause && controller1.isValid(id1) && handler1.pause(id1)) {
                    connectionManager1.free(id1);
                    handler1.moveInProgressToRemaining(id1);
                    return true;
                }
                return false;
            },
            isAttemptingResume: function(id1) {
                return !!handler1.isAttemptingResume && handler1.isAttemptingResume(id1);
            },
            isResumable: function(id1) {
                return !!handler1.isResumable && handler1.isResumable(id1);
            }
        });
        qq.extend(options1, o1);
        log1 = options1.log;
        chunkingPossible1 = options1.chunking.enabled && qq.supportedFeatures.chunking;
        concurrentChunkingPossible1 = chunkingPossible1 && options1.chunking.concurrent.enabled;
        preventRetryResponse1 = function() {
            var response1 = {};
            response1[options1.preventRetryParam] = true;
            return response1;
        }();
        upload1.initHandler();
    };
    qq.WindowReceiveMessage = function(o1) {
        "use strict";
        var options1 = {
            log: function(message1, level1) {}
        }, callbackWrapperDetachers1 = {};
        qq.extend(options1, o1);
        qq.extend(this, {
            receiveMessage: function(id1, callback1) {
                var onMessageCallbackWrapper1 = function(event1) {
                    callback1(event1.data);
                };
                if (window.postMessage) callbackWrapperDetachers1[id1] = qq(window).attach("message", onMessageCallbackWrapper1);
                else log("iframe message passing not supported in this browser!", "error");
            },
            stopReceivingMessages: function(id1) {
                if (window.postMessage) {
                    var detacher1 = callbackWrapperDetachers1[id1];
                    if (detacher1) detacher1();
                }
            }
        });
    };
    qq.FormUploadHandler = function(spec1) {
        "use strict";
        var options1 = spec1.options, handler1 = this, proxy1 = spec1.proxy, formHandlerInstanceId1 = qq.getUniqueId(), onloadCallbacks1 = {}, detachLoadEvents1 = {}, postMessageCallbackTimers1 = {}, isCors1 = options1.isCors, inputName1 = options1.inputName, getUuid1 = proxy1.getUuid, log1 = proxy1.log, corsMessageReceiver1 = new qq.WindowReceiveMessage({
            log: log1
        });
        function expungeFile1(id1) {
            delete detachLoadEvents1[id1];
            if (isCors1) {
                clearTimeout(postMessageCallbackTimers1[id1]);
                delete postMessageCallbackTimers1[id1];
                corsMessageReceiver1.stopReceivingMessages(id1);
            }
            var iframe1 = document.getElementById(handler1._getIframeName(id1));
            if (iframe1) {
                iframe1.setAttribute("src", "javascript:false;");
                qq(iframe1).remove();
            }
        }
        function getFileIdForIframeName1(iframeName1) {
            return iframeName1.split("_")[0];
        }
        function initIframeForUpload1(name1) {
            var iframe1 = qq.toElement("<iframe src='javascript:false;' name='" + name1 + "' />");
            iframe1.setAttribute("id", name1);
            iframe1.style.display = "none";
            document.body.appendChild(iframe1);
            return iframe1;
        }
        function registerPostMessageCallback1(iframe1, callback1) {
            var iframeName1 = iframe1.id, fileId1 = getFileIdForIframeName1(iframeName1), uuid1 = getUuid1(fileId1);
            onloadCallbacks1[uuid1] = callback1;
            detachLoadEvents1[fileId1] = qq(iframe1).attach("load", function() {
                if (handler1.getInput(fileId1)) {
                    log1("Received iframe load event for CORS upload request (iframe name " + iframeName1 + ")");
                    postMessageCallbackTimers1[iframeName1] = setTimeout(function() {
                        var errorMessage1 = "No valid message received from loaded iframe for iframe name " + iframeName1;
                        log1(errorMessage1, "error");
                        callback1({
                            error: errorMessage1
                        });
                    }, 1e3);
                }
            });
            corsMessageReceiver1.receiveMessage(iframeName1, function(message1) {
                log1("Received the following window message: '" + message1 + "'");
                var fileId1 = getFileIdForIframeName1(iframeName1), response1 = handler1._parseJsonResponse(message1), uuid1 = response1.uuid, onloadCallback1;
                if (uuid1 && onloadCallbacks1[uuid1]) {
                    log1("Handling response for iframe name " + iframeName1);
                    clearTimeout(postMessageCallbackTimers1[iframeName1]);
                    delete postMessageCallbackTimers1[iframeName1];
                    handler1._detachLoadEvent(iframeName1);
                    onloadCallback1 = onloadCallbacks1[uuid1];
                    delete onloadCallbacks1[uuid1];
                    corsMessageReceiver1.stopReceivingMessages(iframeName1);
                    onloadCallback1(response1);
                } else if (!uuid1) log1("'" + message1 + "' does not contain a UUID - ignoring.");
            });
        }
        qq.extend(this, new qq.UploadHandler(spec1));
        qq.override(this, function(super_1) {
            return {
                add: function(id1, fileInput1) {
                    super_1.add(id1, {
                        input: fileInput1
                    });
                    fileInput1.setAttribute("name", inputName1);
                    if (fileInput1.parentNode) qq(fileInput1).remove();
                },
                expunge: function(id1) {
                    expungeFile1(id1);
                    super_1.expunge(id1);
                },
                isValid: function(id1) {
                    return super_1.isValid(id1) && handler1._getFileState(id1).input !== undefined;
                }
            };
        });
        qq.extend(this, {
            getInput: function(id1) {
                return handler1._getFileState(id1).input;
            },
            _attachLoadEvent: function(iframe1, callback1) {
                var responseDescriptor1;
                if (isCors1) registerPostMessageCallback1(iframe1, callback1);
                else detachLoadEvents1[iframe1.id] = qq(iframe1).attach("load", function() {
                    log1("Received response for " + iframe1.id);
                    if (!iframe1.parentNode) return;
                    try {
                        if (iframe1.contentDocument && iframe1.contentDocument.body && iframe1.contentDocument.body.innerHTML == "false") return;
                    } catch (error1) {
                        log1("Error when attempting to access iframe during handling of upload response (" + error1.message + ")", "error");
                        responseDescriptor1 = {
                            success: false
                        };
                    }
                    callback1(responseDescriptor1);
                });
            },
            _createIframe: function(id1) {
                var iframeName1 = handler1._getIframeName(id1);
                return initIframeForUpload1(iframeName1);
            },
            _detachLoadEvent: function(id1) {
                if (detachLoadEvents1[id1] !== undefined) {
                    detachLoadEvents1[id1]();
                    delete detachLoadEvents1[id1];
                }
            },
            _getIframeName: function(fileId1) {
                return fileId1 + "_" + formHandlerInstanceId1;
            },
            _initFormForUpload: function(spec1) {
                var method1 = spec1.method, endpoint1 = spec1.endpoint, params1 = spec1.params, paramsInBody1 = spec1.paramsInBody, targetName1 = spec1.targetName, form1 = qq.toElement("<form method='" + method1 + "' enctype='multipart/form-data'></form>"), url1 = endpoint1;
                if (paramsInBody1) qq.obj2Inputs(params1, form1);
                else url1 = qq.obj2url(params1, endpoint1);
                form1.setAttribute("action", url1);
                form1.setAttribute("target", targetName1);
                form1.style.display = "none";
                document.body.appendChild(form1);
                return form1;
            },
            _parseJsonResponse: function(innerHtmlOrMessage1) {
                var response1 = {};
                try {
                    response1 = qq.parseJson(innerHtmlOrMessage1);
                } catch (error1) {
                    log1("Error when attempting to parse iframe upload response (" + error1.message + ")", "error");
                }
                return response1;
            }
        });
    };
    qq.XhrUploadHandler = function(spec1) {
        "use strict";
        var handler1 = this, namespace1 = spec1.options.namespace, proxy1 = spec1.proxy, chunking1 = spec1.options.chunking, getChunkSize1 = function(id1) {
            var fileState1 = handler1._getFileState(id1);
            if (fileState1.chunkSize) return fileState1.chunkSize;
            else {
                var chunkSize1 = chunking1.partSize;
                if (qq.isFunction(chunkSize1)) chunkSize1 = chunkSize1(id1, getSize1(id1));
                fileState1.chunkSize = chunkSize1;
                return chunkSize1;
            }
        }, resume1 = spec1.options.resume, chunkFiles1 = chunking1 && spec1.options.chunking.enabled && qq.supportedFeatures.chunking, resumeEnabled1 = resume1 && spec1.options.resume.enabled && chunkFiles1 && qq.supportedFeatures.resume, getName1 = proxy1.getName, getSize1 = proxy1.getSize, getUuid1 = proxy1.getUuid, getEndpoint1 = proxy1.getEndpoint, getDataByUuid1 = proxy1.getDataByUuid, onUuidChanged1 = proxy1.onUuidChanged, onProgress1 = proxy1.onProgress, log1 = proxy1.log, getCustomResumeData1 = proxy1.getCustomResumeData;
        function abort1(id1) {
            qq.each(handler1._getXhrs(id1), function(xhrId1, xhr1) {
                var ajaxRequester1 = handler1._getAjaxRequester(id1, xhrId1);
                xhr1.onreadystatechange = null;
                xhr1.upload.onprogress = null;
                xhr1.abort();
                ajaxRequester1 && ajaxRequester1.canceled && ajaxRequester1.canceled(id1);
            });
        }
        qq.extend(this, new qq.UploadHandler(spec1));
        qq.override(this, function(super_1) {
            return {
                add: function(id1, blobOrProxy1) {
                    if (qq.isFile(blobOrProxy1) || qq.isBlob(blobOrProxy1)) super_1.add(id1, {
                        file: blobOrProxy1
                    });
                    else if (blobOrProxy1 instanceof qq.BlobProxy) super_1.add(id1, {
                        proxy: blobOrProxy1
                    });
                    else throw new Error("Passed obj is not a File, Blob, or proxy");
                    handler1._initTempState(id1);
                    resumeEnabled1 && handler1._maybePrepareForResume(id1);
                },
                expunge: function(id1) {
                    abort1(id1);
                    handler1._maybeDeletePersistedChunkData(id1);
                    handler1._clearXhrs(id1);
                    super_1.expunge(id1);
                }
            };
        });
        qq.extend(this, {
            clearCachedChunk: function(id1, chunkIdx1) {
                var fileState1 = handler1._getFileState(id1);
                if (fileState1) delete fileState1.temp.cachedChunks[chunkIdx1];
            },
            clearXhr: function(id1, chunkIdx1) {
                var tempState1 = handler1._getFileState(id1).temp;
                if (tempState1.xhrs) delete tempState1.xhrs[chunkIdx1];
                if (tempState1.ajaxRequesters) delete tempState1.ajaxRequesters[chunkIdx1];
            },
            finalizeChunks: function(id1, responseParser1) {
                var lastChunkIdx1 = handler1._getTotalChunks(id1) - 1, xhr1 = handler1._getXhr(id1, lastChunkIdx1);
                if (responseParser1) return new qq.Promise().success(responseParser1(xhr1), xhr1);
                return new qq.Promise().success({}, xhr1);
            },
            getFile: function(id1) {
                return handler1.isValid(id1) && handler1._getFileState(id1).file;
            },
            getProxy: function(id1) {
                return handler1.isValid(id1) && handler1._getFileState(id1).proxy;
            },
            getResumableFilesData: function() {
                var resumableFilesData1 = [];
                handler1._iterateResumeRecords(function(key1, uploadData1) {
                    handler1.moveInProgressToRemaining(null, uploadData1.chunking.inProgress, uploadData1.chunking.remaining);
                    var data1 = {
                        name: uploadData1.name,
                        remaining: uploadData1.chunking.remaining,
                        size: uploadData1.size,
                        uuid: uploadData1.uuid
                    };
                    if (uploadData1.key) data1.key = uploadData1.key;
                    if (uploadData1.customResumeData) data1.customResumeData = uploadData1.customResumeData;
                    resumableFilesData1.push(data1);
                });
                return resumableFilesData1;
            },
            isAttemptingResume: function(id1) {
                return handler1._getFileState(id1).attemptingResume;
            },
            isResumable: function(id1) {
                return !!chunking1 && handler1.isValid(id1) && !handler1._getFileState(id1).notResumable;
            },
            moveInProgressToRemaining: function(id1, optInProgress1, optRemaining1) {
                var fileState1 = handler1._getFileState(id1) || {}, chunkingState1 = fileState1.chunking || {}, inProgress1 = optInProgress1 || chunkingState1.inProgress, remaining1 = optRemaining1 || chunkingState1.remaining;
                if (inProgress1) {
                    log1(qq.format("Moving these chunks from in-progress {}, to remaining.", JSON.stringify(inProgress1)));
                    inProgress1.reverse();
                    qq.each(inProgress1, function(idx1, chunkIdx1) {
                        remaining1.unshift(chunkIdx1);
                    });
                    inProgress1.length = 0;
                }
            },
            pause: function(id1) {
                if (handler1.isValid(id1)) {
                    log1(qq.format("Aborting XHR upload for {} '{}' due to pause instruction.", id1, getName1(id1)));
                    handler1._getFileState(id1).paused = true;
                    abort1(id1);
                    return true;
                }
            },
            reevaluateChunking: function(id1) {
                if (chunking1 && handler1.isValid(id1)) {
                    var state1 = handler1._getFileState(id1), totalChunks1, i1;
                    delete state1.chunking;
                    state1.chunking = {};
                    totalChunks1 = handler1._getTotalChunks(id1);
                    if (totalChunks1 > 1 || chunking1.mandatory) {
                        state1.chunking.enabled = true;
                        state1.chunking.parts = totalChunks1;
                        state1.chunking.remaining = [];
                        for(i1 = 0; i1 < totalChunks1; i1++)state1.chunking.remaining.push(i1);
                        handler1._initTempState(id1);
                    } else state1.chunking.enabled = false;
                }
            },
            updateBlob: function(id1, newBlob1) {
                if (handler1.isValid(id1)) handler1._getFileState(id1).file = newBlob1;
            },
            _clearXhrs: function(id1) {
                var tempState1 = handler1._getFileState(id1).temp;
                qq.each(tempState1.ajaxRequesters, function(chunkId1) {
                    delete tempState1.ajaxRequesters[chunkId1];
                });
                qq.each(tempState1.xhrs, function(chunkId1) {
                    delete tempState1.xhrs[chunkId1];
                });
            },
            _createXhr: function(id1, optChunkIdx1) {
                return handler1._registerXhr(id1, optChunkIdx1, qq.createXhrInstance());
            },
            _getAjaxRequester: function(id1, optChunkIdx1) {
                var chunkIdx1 = optChunkIdx1 == null ? -1 : optChunkIdx1;
                return handler1._getFileState(id1).temp.ajaxRequesters[chunkIdx1];
            },
            _getChunkData: function(id1, chunkIndex1) {
                var chunkSize1 = getChunkSize1(id1), fileSize1 = getSize1(id1), fileOrBlob1 = handler1.getFile(id1), startBytes1 = chunkSize1 * chunkIndex1, endBytes1 = startBytes1 + chunkSize1 >= fileSize1 ? fileSize1 : startBytes1 + chunkSize1, totalChunks1 = handler1._getTotalChunks(id1), cachedChunks1 = this._getFileState(id1).temp.cachedChunks, blob1 = cachedChunks1[chunkIndex1] || qq.sliceBlob(fileOrBlob1, startBytes1, endBytes1);
                cachedChunks1[chunkIndex1] = blob1;
                return {
                    part: chunkIndex1,
                    start: startBytes1,
                    end: endBytes1,
                    count: totalChunks1,
                    blob: blob1,
                    size: endBytes1 - startBytes1
                };
            },
            _getChunkDataForCallback: function(chunkData1) {
                return {
                    partIndex: chunkData1.part,
                    startByte: chunkData1.start + 1,
                    endByte: chunkData1.end,
                    totalParts: chunkData1.count
                };
            },
            _getLocalStorageId: function(id1) {
                var formatVersion1 = "5.0", name1 = getName1(id1), size1 = getSize1(id1), chunkSize1 = getChunkSize1(id1), endpoint1 = getEndpoint1(id1), customKeys1 = resume1.customKeys(id1), localStorageId1 = qq.format("qq{}resume{}-{}-{}-{}-{}", namespace1, formatVersion1, name1, size1, chunkSize1, endpoint1);
                customKeys1.forEach(function(key1) {
                    localStorageId1 += "-" + key1;
                });
                return localStorageId1;
            },
            _getMimeType: function(id1) {
                return handler1.getFile(id1).type;
            },
            _getPersistableData: function(id1) {
                return handler1._getFileState(id1).chunking;
            },
            _getTotalChunks: function(id1) {
                if (chunking1) {
                    var fileSize1 = getSize1(id1), chunkSize1 = getChunkSize1(id1);
                    return Math.ceil(fileSize1 / chunkSize1);
                }
            },
            _getXhr: function(id1, optChunkIdx1) {
                var chunkIdx1 = optChunkIdx1 == null ? -1 : optChunkIdx1;
                return handler1._getFileState(id1).temp.xhrs[chunkIdx1];
            },
            _getXhrs: function(id1) {
                return handler1._getFileState(id1).temp.xhrs;
            },
            _iterateResumeRecords: function(callback1) {
                if (resumeEnabled1) qq.each(localStorage, function(key1, item1) {
                    if (key1.indexOf(qq.format("qq{}resume", namespace1)) === 0) {
                        var uploadData1 = JSON.parse(item1);
                        callback1(key1, uploadData1);
                    }
                });
            },
            _initTempState: function(id1) {
                handler1._getFileState(id1).temp = {
                    ajaxRequesters: {},
                    chunkProgress: {},
                    xhrs: {},
                    cachedChunks: {}
                };
            },
            _markNotResumable: function(id1) {
                handler1._getFileState(id1).notResumable = true;
            },
            _maybeDeletePersistedChunkData: function(id1) {
                var localStorageId1;
                if (resumeEnabled1 && handler1.isResumable(id1)) {
                    localStorageId1 = handler1._getLocalStorageId(id1);
                    if (localStorageId1 && localStorage.getItem(localStorageId1)) {
                        localStorage.removeItem(localStorageId1);
                        return true;
                    }
                }
                return false;
            },
            _maybePrepareForResume: function(id1) {
                var state1 = handler1._getFileState(id1), localStorageId1, persistedData1;
                if (resumeEnabled1 && state1.key === undefined) {
                    localStorageId1 = handler1._getLocalStorageId(id1);
                    persistedData1 = localStorage.getItem(localStorageId1);
                    if (persistedData1) {
                        persistedData1 = JSON.parse(persistedData1);
                        if (getDataByUuid1(persistedData1.uuid)) handler1._markNotResumable(id1);
                        else {
                            log1(qq.format("Identified file with ID {} and name of {} as resumable.", id1, getName1(id1)));
                            onUuidChanged1(id1, persistedData1.uuid);
                            state1.key = persistedData1.key;
                            state1.chunking = persistedData1.chunking;
                            state1.loaded = persistedData1.loaded;
                            state1.customResumeData = persistedData1.customResumeData;
                            state1.attemptingResume = true;
                            handler1.moveInProgressToRemaining(id1);
                        }
                    }
                }
            },
            _maybePersistChunkedState: function(id1) {
                var state1 = handler1._getFileState(id1), localStorageId1, persistedData1;
                if (resumeEnabled1 && handler1.isResumable(id1)) {
                    var customResumeData1 = getCustomResumeData1(id1);
                    localStorageId1 = handler1._getLocalStorageId(id1);
                    persistedData1 = {
                        name: getName1(id1),
                        size: getSize1(id1),
                        uuid: getUuid1(id1),
                        key: state1.key,
                        chunking: state1.chunking,
                        loaded: state1.loaded,
                        lastUpdated: Date.now()
                    };
                    if (customResumeData1) persistedData1.customResumeData = customResumeData1;
                    try {
                        localStorage.setItem(localStorageId1, JSON.stringify(persistedData1));
                    } catch (error1) {
                        log1(qq.format("Unable to save resume data for '{}' due to error: '{}'.", id1, error1.toString()), "warn");
                    }
                }
            },
            _registerProgressHandler: function(id1, chunkIdx1, chunkSize1) {
                var xhr1 = handler1._getXhr(id1, chunkIdx1), name1 = getName1(id1), progressCalculator1 = {
                    simple: function(loaded1, total1) {
                        var fileSize1 = getSize1(id1);
                        if (loaded1 === total1) onProgress1(id1, name1, fileSize1, fileSize1);
                        else onProgress1(id1, name1, loaded1 >= fileSize1 ? fileSize1 - 1 : loaded1, fileSize1);
                    },
                    chunked: function(loaded1, total1) {
                        var chunkProgress1 = handler1._getFileState(id1).temp.chunkProgress, totalSuccessfullyLoadedForFile1 = handler1._getFileState(id1).loaded, loadedForRequest1 = loaded1, totalForRequest1 = total1, totalFileSize1 = getSize1(id1), estActualChunkLoaded1 = loadedForRequest1 - (totalForRequest1 - chunkSize1), totalLoadedForFile1 = totalSuccessfullyLoadedForFile1;
                        chunkProgress1[chunkIdx1] = estActualChunkLoaded1;
                        qq.each(chunkProgress1, function(chunkIdx1, chunkLoaded1) {
                            totalLoadedForFile1 += chunkLoaded1;
                        });
                        onProgress1(id1, name1, totalLoadedForFile1, totalFileSize1);
                    }
                };
                xhr1.upload.onprogress = function(e1) {
                    if (e1.lengthComputable) {
                        var type1 = chunkSize1 == null ? "simple" : "chunked";
                        progressCalculator1[type1](e1.loaded, e1.total);
                    }
                };
            },
            _registerXhr: function(id1, optChunkIdx1, xhr1, optAjaxRequester1) {
                var xhrsId1 = optChunkIdx1 == null ? -1 : optChunkIdx1, tempState1 = handler1._getFileState(id1).temp;
                tempState1.xhrs = tempState1.xhrs || {};
                tempState1.ajaxRequesters = tempState1.ajaxRequesters || {};
                tempState1.xhrs[xhrsId1] = xhr1;
                if (optAjaxRequester1) tempState1.ajaxRequesters[xhrsId1] = optAjaxRequester1;
                return xhr1;
            },
            _removeExpiredChunkingRecords: function() {
                var expirationDays1 = resume1.recordsExpireIn;
                handler1._iterateResumeRecords(function(key1, uploadData1) {
                    var expirationDate1 = new Date(uploadData1.lastUpdated);
                    expirationDate1.setDate(expirationDate1.getDate() + expirationDays1);
                    if (expirationDate1.getTime() <= Date.now()) {
                        log1("Removing expired resume record with key " + key1);
                        localStorage.removeItem(key1);
                    }
                });
            },
            _shouldChunkThisFile: function(id1) {
                var state1 = handler1._getFileState(id1);
                if (state1) {
                    if (!state1.chunking) handler1.reevaluateChunking(id1);
                    return state1.chunking.enabled;
                }
            }
        });
    };
    qq.DeleteFileAjaxRequester = function(o1) {
        "use strict";
        var requester1, options1 = {
            method: "DELETE",
            uuidParamName: "qquuid",
            endpointStore: {},
            maxConnections: 3,
            customHeaders: function(id1) {
                return {};
            },
            paramsStore: {},
            cors: {
                expected: false,
                sendCredentials: false
            },
            log: function(str1, level1) {},
            onDelete: function(id1) {},
            onDeleteComplete: function(id1, xhrOrXdr1, isError1) {}
        };
        qq.extend(options1, o1);
        function getMandatedParams1() {
            if (options1.method.toUpperCase() === "POST") return {
                _method: "DELETE"
            };
            return {};
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            acceptHeader: "application/json",
            validMethods: [
                "POST",
                "DELETE"
            ],
            method: options1.method,
            endpointStore: options1.endpointStore,
            paramsStore: options1.paramsStore,
            mandatedParams: getMandatedParams1(),
            maxConnections: options1.maxConnections,
            customHeaders: function(id1) {
                return options1.customHeaders.get(id1);
            },
            log: options1.log,
            onSend: options1.onDelete,
            onComplete: options1.onDeleteComplete,
            cors: options1.cors
        }));
        qq.extend(this, {
            sendDelete: function(id1, uuid1, additionalMandatedParams1) {
                var additionalOptions1 = additionalMandatedParams1 || {};
                options1.log("Submitting delete file request for " + id1);
                if (options1.method === "DELETE") requester1.initTransport(id1).withPath(uuid1).withParams(additionalOptions1).send();
                else {
                    additionalOptions1[options1.uuidParamName] = uuid1;
                    requester1.initTransport(id1).withParams(additionalOptions1).send();
                }
            }
        });
    };
    (function() {
        function detectSubsampling1(img1) {
            var iw1 = img1.naturalWidth, ih1 = img1.naturalHeight, canvas1 = document.createElement("canvas"), ctx1;
            if (iw1 * ih1 > 1048576) {
                canvas1.width = canvas1.height = 1;
                ctx1 = canvas1.getContext("2d");
                ctx1.drawImage(img1, -iw1 + 1, 0);
                return ctx1.getImageData(0, 0, 1, 1).data[3] === 0;
            } else return false;
        }
        function detectVerticalSquash1(img1, iw1, ih1) {
            var canvas1 = document.createElement("canvas"), sy1 = 0, ey1 = ih1, py1 = ih1, ctx1, data1, alpha1, ratio1;
            canvas1.width = 1;
            canvas1.height = ih1;
            ctx1 = canvas1.getContext("2d");
            ctx1.drawImage(img1, 0, 0);
            data1 = ctx1.getImageData(0, 0, 1, ih1).data;
            while(py1 > sy1){
                alpha1 = data1[(py1 - 1) * 4 + 3];
                if (alpha1 === 0) ey1 = py1;
                else sy1 = py1;
                py1 = ey1 + sy1 >> 1;
            }
            ratio1 = py1 / ih1;
            return ratio1 === 0 ? 1 : ratio1;
        }
        function renderImageToDataURL1(img1, blob1, options1, doSquash1) {
            var canvas1 = document.createElement("canvas"), mime1 = options1.mime || "image/jpeg", promise1 = new qq.Promise();
            renderImageToCanvas1(img1, blob1, canvas1, options1, doSquash1).then(function() {
                promise1.success(canvas1.toDataURL(mime1, options1.quality || .8));
            });
            return promise1;
        }
        function maybeCalculateDownsampledDimensions1(spec1) {
            var maxPixels1 = 5241e3;
            if (!qq.ios()) throw new qq.Error("Downsampled dimensions can only be reliably calculated for iOS!");
            if (spec1.origHeight * spec1.origWidth > maxPixels1) return {
                newHeight: Math.round(Math.sqrt(maxPixels1 * (spec1.origHeight / spec1.origWidth))),
                newWidth: Math.round(Math.sqrt(maxPixels1 * (spec1.origWidth / spec1.origHeight)))
            };
        }
        function renderImageToCanvas1(img1, blob1, canvas1, options1, doSquash1) {
            var iw1 = img1.naturalWidth, ih1 = img1.naturalHeight, width1 = options1.width, height1 = options1.height, ctx1 = canvas1.getContext("2d"), promise1 = new qq.Promise(), modifiedDimensions1;
            ctx1.save();
            if (options1.resize) return renderImageToCanvasWithCustomResizer1({
                blob: blob1,
                canvas: canvas1,
                image: img1,
                imageHeight: ih1,
                imageWidth: iw1,
                orientation: options1.orientation,
                resize: options1.resize,
                targetHeight: height1,
                targetWidth: width1
            });
            if (!qq.supportedFeatures.unlimitedScaledImageSize) {
                modifiedDimensions1 = maybeCalculateDownsampledDimensions1({
                    origWidth: width1,
                    origHeight: height1
                });
                if (modifiedDimensions1) {
                    qq.log(qq.format("Had to reduce dimensions due to device limitations from {}w / {}h to {}w / {}h", width1, height1, modifiedDimensions1.newWidth, modifiedDimensions1.newHeight), "warn");
                    width1 = modifiedDimensions1.newWidth;
                    height1 = modifiedDimensions1.newHeight;
                }
            }
            transformCoordinate1(canvas1, width1, height1, options1.orientation);
            if (qq.ios()) (function() {
                if (detectSubsampling1(img1)) {
                    iw1 /= 2;
                    ih1 /= 2;
                }
                var d1 = 1024, tmpCanvas1 = document.createElement("canvas"), vertSquashRatio1 = doSquash1 ? detectVerticalSquash1(img1, iw1, ih1) : 1, dw1 = Math.ceil(d1 * width1 / iw1), dh1 = Math.ceil(d1 * height1 / ih1 / vertSquashRatio1), sy1 = 0, dy1 = 0, tmpCtx1, sx1, dx1;
                tmpCanvas1.width = tmpCanvas1.height = d1;
                tmpCtx1 = tmpCanvas1.getContext("2d");
                while(sy1 < ih1){
                    sx1 = 0;
                    dx1 = 0;
                    while(sx1 < iw1){
                        tmpCtx1.clearRect(0, 0, d1, d1);
                        tmpCtx1.drawImage(img1, -sx1, -sy1);
                        ctx1.drawImage(tmpCanvas1, 0, 0, d1, d1, dx1, dy1, dw1, dh1);
                        sx1 += d1;
                        dx1 += dw1;
                    }
                    sy1 += d1;
                    dy1 += dh1;
                }
                ctx1.restore();
                tmpCanvas1 = tmpCtx1 = null;
            })();
            else ctx1.drawImage(img1, 0, 0, width1, height1);
            canvas1.qqImageRendered && canvas1.qqImageRendered();
            promise1.success();
            return promise1;
        }
        function renderImageToCanvasWithCustomResizer1(resizeInfo1) {
            var blob1 = resizeInfo1.blob, image1 = resizeInfo1.image, imageHeight1 = resizeInfo1.imageHeight, imageWidth1 = resizeInfo1.imageWidth, orientation1 = resizeInfo1.orientation, promise1 = new qq.Promise(), resize1 = resizeInfo1.resize, sourceCanvas1 = document.createElement("canvas"), sourceCanvasContext1 = sourceCanvas1.getContext("2d"), targetCanvas1 = resizeInfo1.canvas, targetHeight1 = resizeInfo1.targetHeight, targetWidth1 = resizeInfo1.targetWidth;
            transformCoordinate1(sourceCanvas1, imageWidth1, imageHeight1, orientation1);
            targetCanvas1.height = targetHeight1;
            targetCanvas1.width = targetWidth1;
            sourceCanvasContext1.drawImage(image1, 0, 0);
            resize1({
                blob: blob1,
                height: targetHeight1,
                image: image1,
                sourceCanvas: sourceCanvas1,
                targetCanvas: targetCanvas1,
                width: targetWidth1
            }).then(function success1() {
                targetCanvas1.qqImageRendered && targetCanvas1.qqImageRendered();
                promise1.success();
            }, promise1.failure);
            return promise1;
        }
        function transformCoordinate1(canvas1, width1, height1, orientation1) {
            switch(orientation1){
                case 5:
                case 6:
                case 7:
                case 8:
                    canvas1.width = height1;
                    canvas1.height = width1;
                    break;
                default:
                    canvas1.width = width1;
                    canvas1.height = height1;
            }
            var ctx1 = canvas1.getContext("2d");
            switch(orientation1){
                case 2:
                    ctx1.translate(width1, 0);
                    ctx1.scale(-1, 1);
                    break;
                case 3:
                    ctx1.translate(width1, height1);
                    ctx1.rotate(Math.PI);
                    break;
                case 4:
                    ctx1.translate(0, height1);
                    ctx1.scale(1, -1);
                    break;
                case 5:
                    ctx1.rotate(.5 * Math.PI);
                    ctx1.scale(1, -1);
                    break;
                case 6:
                    ctx1.rotate(.5 * Math.PI);
                    ctx1.translate(0, -height1);
                    break;
                case 7:
                    ctx1.rotate(.5 * Math.PI);
                    ctx1.translate(width1, -height1);
                    ctx1.scale(-1, 1);
                    break;
                case 8:
                    ctx1.rotate(-0.5 * Math.PI);
                    ctx1.translate(-width1, 0);
                    break;
                default:
                    break;
            }
        }
        function MegaPixImage1(srcImage1, errorCallback1) {
            var self1 = this;
            if (window.Blob && srcImage1 instanceof Blob) (function() {
                var img1 = new Image(), URL1 = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
                if (!URL1) throw Error("No createObjectURL function found to create blob url");
                img1.src = URL1.createObjectURL(srcImage1);
                self1.blob = srcImage1;
                srcImage1 = img1;
            })();
            if (!srcImage1.naturalWidth && !srcImage1.naturalHeight) {
                srcImage1.onload = function() {
                    var listeners1 = self1.imageLoadListeners;
                    if (listeners1) {
                        self1.imageLoadListeners = null;
                        setTimeout(function() {
                            for(var i1 = 0, len1 = listeners1.length; i1 < len1; i1++)listeners1[i1]();
                        }, 0);
                    }
                };
                srcImage1.onerror = errorCallback1;
                this.imageLoadListeners = [];
            }
            this.srcImage = srcImage1;
        }
        MegaPixImage1.prototype.render = function(target1, options1) {
            options1 = options1 || {};
            var self1 = this, imgWidth1 = this.srcImage.naturalWidth, imgHeight1 = this.srcImage.naturalHeight, width1 = options1.width, height1 = options1.height, maxWidth1 = options1.maxWidth, maxHeight1 = options1.maxHeight, doSquash1 = !this.blob || this.blob.type === "image/jpeg", tagName1 = target1.tagName.toLowerCase(), opt1;
            if (this.imageLoadListeners) {
                this.imageLoadListeners.push(function() {
                    self1.render(target1, options1);
                });
                return;
            }
            if (width1 && !height1) height1 = imgHeight1 * width1 / imgWidth1 << 0;
            else if (height1 && !width1) width1 = imgWidth1 * height1 / imgHeight1 << 0;
            else {
                width1 = imgWidth1;
                height1 = imgHeight1;
            }
            if (maxWidth1 && width1 > maxWidth1) {
                width1 = maxWidth1;
                height1 = imgHeight1 * width1 / imgWidth1 << 0;
            }
            if (maxHeight1 && height1 > maxHeight1) {
                height1 = maxHeight1;
                width1 = imgWidth1 * height1 / imgHeight1 << 0;
            }
            opt1 = {
                width: width1,
                height: height1
            }, qq.each(options1, function(optionsKey1, optionsValue1) {
                opt1[optionsKey1] = optionsValue1;
            });
            if (tagName1 === "img") (function() {
                var oldTargetSrc1 = target1.src;
                renderImageToDataURL1(self1.srcImage, self1.blob, opt1, doSquash1).then(function(dataUri1) {
                    target1.src = dataUri1;
                    oldTargetSrc1 === target1.src && target1.onload();
                });
            })();
            else if (tagName1 === "canvas") renderImageToCanvas1(this.srcImage, this.blob, target1, opt1, doSquash1);
            if (typeof this.onrender === "function") this.onrender(target1);
        };
        qq.MegaPixImage = MegaPixImage1;
    })();
    qq.ImageGenerator = function(log1) {
        "use strict";
        function isImg1(el1) {
            return el1.tagName.toLowerCase() === "img";
        }
        function isCanvas1(el1) {
            return el1.tagName.toLowerCase() === "canvas";
        }
        function isImgCorsSupported1() {
            return new Image().crossOrigin !== undefined;
        }
        function isCanvasSupported1() {
            var canvas1 = document.createElement("canvas");
            return canvas1.getContext && canvas1.getContext("2d");
        }
        function determineMimeOfFileName1(nameWithPath1) {
            var pathSegments1 = nameWithPath1.split("/"), name1 = pathSegments1[pathSegments1.length - 1].split("?")[0], extension1 = qq.getExtension(name1);
            extension1 = extension1 && extension1.toLowerCase();
            switch(extension1){
                case "jpeg":
                case "jpg":
                    return "image/jpeg";
                case "png":
                    return "image/png";
                case "bmp":
                    return "image/bmp";
                case "gif":
                    return "image/gif";
                case "tiff":
                case "tif":
                    return "image/tiff";
            }
        }
        function isCrossOrigin1(url1) {
            var targetAnchor1 = document.createElement("a"), targetProtocol1, targetHostname1, targetPort1;
            targetAnchor1.href = url1;
            targetProtocol1 = targetAnchor1.protocol;
            targetPort1 = targetAnchor1.port;
            targetHostname1 = targetAnchor1.hostname;
            if (targetProtocol1.toLowerCase() !== window.location.protocol.toLowerCase()) return true;
            if (targetHostname1.toLowerCase() !== window.location.hostname.toLowerCase()) return true;
            if (targetPort1 !== window.location.port && !qq.ie()) return true;
            return false;
        }
        function registerImgLoadListeners1(img1, promise1) {
            img1.onload = function() {
                img1.onload = null;
                img1.onerror = null;
                promise1.success(img1);
            };
            img1.onerror = function() {
                img1.onload = null;
                img1.onerror = null;
                log1("Problem drawing thumbnail!", "error");
                promise1.failure(img1, "Problem drawing thumbnail!");
            };
        }
        function registerCanvasDrawImageListener1(canvas1, promise1) {
            canvas1.qqImageRendered = function() {
                promise1.success(canvas1);
            };
        }
        function registerThumbnailRenderedListener1(imgOrCanvas1, promise1) {
            var registered1 = isImg1(imgOrCanvas1) || isCanvas1(imgOrCanvas1);
            if (isImg1(imgOrCanvas1)) registerImgLoadListeners1(imgOrCanvas1, promise1);
            else if (isCanvas1(imgOrCanvas1)) registerCanvasDrawImageListener1(imgOrCanvas1, promise1);
            else {
                promise1.failure(imgOrCanvas1);
                log1(qq.format("Element container of type {} is not supported!", imgOrCanvas1.tagName), "error");
            }
            return registered1;
        }
        function draw1(fileOrBlob1, container1, options1) {
            var drawPreview1 = new qq.Promise(), identifier1 = new qq.Identify(fileOrBlob1, log1), maxSize1 = options1.maxSize, orient1 = options1.orient == null ? true : options1.orient, megapixErrorHandler1 = function() {
                container1.onerror = null;
                container1.onload = null;
                log1("Could not render preview, file may be too large!", "error");
                drawPreview1.failure(container1, "Browser cannot render image!");
            };
            identifier1.isPreviewable().then(function(mime1) {
                var dummyExif1 = {
                    parse: function() {
                        return new qq.Promise().success();
                    }
                }, exif1 = orient1 ? new qq.Exif(fileOrBlob1, log1) : dummyExif1, mpImg1 = new qq.MegaPixImage(fileOrBlob1, megapixErrorHandler1);
                if (registerThumbnailRenderedListener1(container1, drawPreview1)) exif1.parse().then(function(exif1) {
                    var orientation1 = exif1 && exif1.Orientation;
                    mpImg1.render(container1, {
                        maxWidth: maxSize1,
                        maxHeight: maxSize1,
                        orientation: orientation1,
                        mime: mime1,
                        resize: options1.customResizeFunction
                    });
                }, function(failureMsg1) {
                    log1(qq.format("EXIF data could not be parsed ({}).  Assuming orientation = 1.", failureMsg1));
                    mpImg1.render(container1, {
                        maxWidth: maxSize1,
                        maxHeight: maxSize1,
                        mime: mime1,
                        resize: options1.customResizeFunction
                    });
                });
            }, function() {
                log1("Not previewable");
                drawPreview1.failure(container1, "Not previewable");
            });
            return drawPreview1;
        }
        function drawOnCanvasOrImgFromUrl1(url1, canvasOrImg1, draw1, maxSize1, customResizeFunction1) {
            var tempImg1 = new Image(), tempImgRender1 = new qq.Promise();
            registerThumbnailRenderedListener1(tempImg1, tempImgRender1);
            if (isCrossOrigin1(url1)) tempImg1.crossOrigin = "anonymous";
            tempImg1.src = url1;
            tempImgRender1.then(function rendered1() {
                registerThumbnailRenderedListener1(canvasOrImg1, draw1);
                var mpImg1 = new qq.MegaPixImage(tempImg1);
                mpImg1.render(canvasOrImg1, {
                    maxWidth: maxSize1,
                    maxHeight: maxSize1,
                    mime: determineMimeOfFileName1(url1),
                    resize: customResizeFunction1
                });
            }, draw1.failure);
        }
        function drawOnImgFromUrlWithCssScaling1(url1, img1, draw1, maxSize1) {
            registerThumbnailRenderedListener1(img1, draw1);
            qq(img1).css({
                maxWidth: maxSize1 + "px",
                maxHeight: maxSize1 + "px"
            });
            img1.src = url1;
        }
        function drawFromUrl1(url1, container1, options1) {
            var draw1 = new qq.Promise(), scale1 = options1.scale, maxSize1 = scale1 ? options1.maxSize : null;
            if (scale1 && isImg1(container1)) {
                if (isCanvasSupported1()) {
                    if (isCrossOrigin1(url1) && !isImgCorsSupported1()) drawOnImgFromUrlWithCssScaling1(url1, container1, draw1, maxSize1);
                    else drawOnCanvasOrImgFromUrl1(url1, container1, draw1, maxSize1);
                } else drawOnImgFromUrlWithCssScaling1(url1, container1, draw1, maxSize1);
            } else if (isCanvas1(container1)) drawOnCanvasOrImgFromUrl1(url1, container1, draw1, maxSize1);
            else if (registerThumbnailRenderedListener1(container1, draw1)) container1.src = url1;
            return draw1;
        }
        qq.extend(this, {
            generate: function(fileBlobOrUrl1, container1, options1) {
                if (qq.isString(fileBlobOrUrl1)) {
                    log1("Attempting to update thumbnail based on server response.");
                    return drawFromUrl1(fileBlobOrUrl1, container1, options1 || {});
                } else {
                    log1("Attempting to draw client-side image preview.");
                    return draw1(fileBlobOrUrl1, container1, options1 || {});
                }
            }
        });
        this._testing = {};
        this._testing.isImg = isImg1;
        this._testing.isCanvas = isCanvas1;
        this._testing.isCrossOrigin = isCrossOrigin1;
        this._testing.determineMimeOfFileName = determineMimeOfFileName1;
    };
    qq.Exif = function(fileOrBlob1, log1) {
        "use strict";
        var TAG_IDS1 = [
            274
        ], TAG_INFO1 = {
            274: {
                name: "Orientation",
                bytes: 2
            }
        };
        function parseLittleEndian1(hex1) {
            var result1 = 0, pow1 = 0;
            while(hex1.length > 0){
                result1 += parseInt(hex1.substring(0, 2), 16) * Math.pow(2, pow1);
                hex1 = hex1.substring(2, hex1.length);
                pow1 += 8;
            }
            return result1;
        }
        function seekToApp11(offset1, promise1) {
            var theOffset1 = offset1, thePromise1 = promise1;
            if (theOffset1 === undefined) {
                theOffset1 = 2;
                thePromise1 = new qq.Promise();
            }
            qq.readBlobToHex(fileOrBlob1, theOffset1, 4).then(function(hex1) {
                var match1 = /^ffe([0-9])/.exec(hex1), segmentLength1;
                if (match1) {
                    if (match1[1] !== "1") {
                        segmentLength1 = parseInt(hex1.slice(4, 8), 16);
                        seekToApp11(theOffset1 + segmentLength1 + 2, thePromise1);
                    } else thePromise1.success(theOffset1);
                } else thePromise1.failure("No EXIF header to be found!");
            });
            return thePromise1;
        }
        function getApp1Offset1() {
            var promise1 = new qq.Promise();
            qq.readBlobToHex(fileOrBlob1, 0, 6).then(function(hex1) {
                if (hex1.indexOf("ffd8") !== 0) promise1.failure("Not a valid JPEG!");
                else seekToApp11().then(function(offset1) {
                    promise1.success(offset1);
                }, function(error1) {
                    promise1.failure(error1);
                });
            });
            return promise1;
        }
        function isLittleEndian1(app1Start1) {
            var promise1 = new qq.Promise();
            qq.readBlobToHex(fileOrBlob1, app1Start1 + 10, 2).then(function(hex1) {
                promise1.success(hex1 === "4949");
            });
            return promise1;
        }
        function getDirEntryCount1(app1Start1, littleEndian1) {
            var promise1 = new qq.Promise();
            qq.readBlobToHex(fileOrBlob1, app1Start1 + 18, 2).then(function(hex1) {
                if (littleEndian1) return promise1.success(parseLittleEndian1(hex1));
                else promise1.success(parseInt(hex1, 16));
            });
            return promise1;
        }
        function getIfd1(app1Start1, dirEntries1) {
            var offset1 = app1Start1 + 20, bytes1 = dirEntries1 * 12;
            return qq.readBlobToHex(fileOrBlob1, offset1, bytes1);
        }
        function getDirEntries1(ifdHex1) {
            var entries1 = [], offset1 = 0;
            while(offset1 + 24 <= ifdHex1.length){
                entries1.push(ifdHex1.slice(offset1, offset1 + 24));
                offset1 += 24;
            }
            return entries1;
        }
        function getTagValues1(littleEndian1, dirEntries1) {
            var TAG_VAL_OFFSET1 = 16, tagsToFind1 = qq.extend([], TAG_IDS1), vals1 = {};
            qq.each(dirEntries1, function(idx1, entry1) {
                var idHex1 = entry1.slice(0, 4), id1 = littleEndian1 ? parseLittleEndian1(idHex1) : parseInt(idHex1, 16), tagsToFindIdx1 = tagsToFind1.indexOf(id1), tagValHex1, tagName1, tagValLength1;
                if (tagsToFindIdx1 >= 0) {
                    tagName1 = TAG_INFO1[id1].name;
                    tagValLength1 = TAG_INFO1[id1].bytes;
                    tagValHex1 = entry1.slice(TAG_VAL_OFFSET1, TAG_VAL_OFFSET1 + tagValLength1 * 2);
                    vals1[tagName1] = littleEndian1 ? parseLittleEndian1(tagValHex1) : parseInt(tagValHex1, 16);
                    tagsToFind1.splice(tagsToFindIdx1, 1);
                }
                if (tagsToFind1.length === 0) return false;
            });
            return vals1;
        }
        qq.extend(this, {
            parse: function() {
                var parser1 = new qq.Promise(), onParseFailure1 = function(message1) {
                    log1(qq.format("EXIF header parse failed: '{}' ", message1));
                    parser1.failure(message1);
                };
                getApp1Offset1().then(function(app1Offset1) {
                    log1(qq.format("Moving forward with EXIF header parsing for '{}'", fileOrBlob1.name === undefined ? "blob" : fileOrBlob1.name));
                    isLittleEndian1(app1Offset1).then(function(littleEndian1) {
                        log1(qq.format("EXIF Byte order is {} endian", littleEndian1 ? "little" : "big"));
                        getDirEntryCount1(app1Offset1, littleEndian1).then(function(dirEntryCount1) {
                            log1(qq.format("Found {} APP1 directory entries", dirEntryCount1));
                            getIfd1(app1Offset1, dirEntryCount1).then(function(ifdHex1) {
                                var dirEntries1 = getDirEntries1(ifdHex1), tagValues1 = getTagValues1(littleEndian1, dirEntries1);
                                log1("Successfully parsed some EXIF tags");
                                parser1.success(tagValues1);
                            }, onParseFailure1);
                        }, onParseFailure1);
                    }, onParseFailure1);
                }, onParseFailure1);
                return parser1;
            }
        });
        this._testing = {};
        this._testing.parseLittleEndian = parseLittleEndian1;
    };
    qq.Identify = function(fileOrBlob1, log1) {
        "use strict";
        function isIdentifiable1(magicBytes1, questionableBytes1) {
            var identifiable1 = false, magicBytesEntries1 = [].concat(magicBytes1);
            qq.each(magicBytesEntries1, function(idx1, magicBytesArrayEntry1) {
                if (questionableBytes1.indexOf(magicBytesArrayEntry1) === 0) {
                    identifiable1 = true;
                    return false;
                }
            });
            return identifiable1;
        }
        qq.extend(this, {
            isPreviewable: function() {
                var self1 = this, identifier1 = new qq.Promise(), previewable1 = false, name1 = fileOrBlob1.name === undefined ? "blob" : fileOrBlob1.name;
                log1(qq.format("Attempting to determine if {} can be rendered in this browser", name1));
                log1("First pass: check type attribute of blob object.");
                if (this.isPreviewableSync()) {
                    log1("Second pass: check for magic bytes in file header.");
                    qq.readBlobToHex(fileOrBlob1, 0, 4).then(function(hex1) {
                        qq.each(self1.PREVIEWABLE_MIME_TYPES, function(mime1, bytes1) {
                            if (isIdentifiable1(bytes1, hex1)) {
                                if (mime1 !== "image/tiff" || qq.supportedFeatures.tiffPreviews) {
                                    previewable1 = true;
                                    identifier1.success(mime1);
                                }
                                return false;
                            }
                        });
                        log1(qq.format("'{}' is {} able to be rendered in this browser", name1, previewable1 ? "" : "NOT"));
                        if (!previewable1) identifier1.failure();
                    }, function() {
                        log1("Error reading file w/ name '" + name1 + "'.  Not able to be rendered in this browser.");
                        identifier1.failure();
                    });
                } else identifier1.failure();
                return identifier1;
            },
            isPreviewableSync: function() {
                var fileMime1 = fileOrBlob1.type, isRecognizedImage1 = qq.indexOf(Object.keys(this.PREVIEWABLE_MIME_TYPES), fileMime1) >= 0, previewable1 = false, name1 = fileOrBlob1.name === undefined ? "blob" : fileOrBlob1.name;
                if (isRecognizedImage1) {
                    if (fileMime1 === "image/tiff") previewable1 = qq.supportedFeatures.tiffPreviews;
                    else previewable1 = true;
                }
                !previewable1 && log1(name1 + " is not previewable in this browser per the blob's type attr");
                return previewable1;
            }
        });
    };
    qq.Identify.prototype.PREVIEWABLE_MIME_TYPES = {
        "image/jpeg": "ffd8ff",
        "image/gif": "474946",
        "image/png": "89504e",
        "image/bmp": "424d",
        "image/tiff": [
            "49492a00",
            "4d4d002a"
        ]
    };
    qq.ImageValidation = function(blob1, log1) {
        "use strict";
        function hasNonZeroLimits1(limits1) {
            var atLeastOne1 = false;
            qq.each(limits1, function(limit1, value1) {
                if (value1 > 0) {
                    atLeastOne1 = true;
                    return false;
                }
            });
            return atLeastOne1;
        }
        function getWidthHeight1() {
            var sizeDetermination1 = new qq.Promise();
            new qq.Identify(blob1, log1).isPreviewable().then(function() {
                var image1 = new Image(), url1 = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
                if (url1) {
                    image1.onerror = function() {
                        log1("Cannot determine dimensions for image.  May be too large.", "error");
                        sizeDetermination1.failure();
                    };
                    image1.onload = function() {
                        sizeDetermination1.success({
                            width: this.width,
                            height: this.height
                        });
                    };
                    image1.src = url1.createObjectURL(blob1);
                } else {
                    log1("No createObjectURL function available to generate image URL!", "error");
                    sizeDetermination1.failure();
                }
            }, sizeDetermination1.failure);
            return sizeDetermination1;
        }
        function getFailingLimit1(limits1, dimensions1) {
            var failingLimit1;
            qq.each(limits1, function(limitName1, limitValue1) {
                if (limitValue1 > 0) {
                    var limitMatcher1 = /(max|min)(Width|Height)/.exec(limitName1), dimensionPropName1 = limitMatcher1[2].charAt(0).toLowerCase() + limitMatcher1[2].slice(1), actualValue1 = dimensions1[dimensionPropName1];
                    switch(limitMatcher1[1]){
                        case "min":
                            if (actualValue1 < limitValue1) {
                                failingLimit1 = limitName1;
                                return false;
                            }
                            break;
                        case "max":
                            if (actualValue1 > limitValue1) {
                                failingLimit1 = limitName1;
                                return false;
                            }
                            break;
                    }
                }
            });
            return failingLimit1;
        }
        this.validate = function(limits1) {
            var validationEffort1 = new qq.Promise();
            log1("Attempting to validate image.");
            if (hasNonZeroLimits1(limits1)) getWidthHeight1().then(function(dimensions1) {
                var failingLimit1 = getFailingLimit1(limits1, dimensions1);
                if (failingLimit1) validationEffort1.failure(failingLimit1);
                else validationEffort1.success();
            }, validationEffort1.success);
            else validationEffort1.success();
            return validationEffort1;
        };
    };
    qq.Session = function(spec1) {
        "use strict";
        var options1 = {
            endpoint: null,
            params: {},
            customHeaders: {},
            cors: {},
            addFileRecord: function(sessionData1) {},
            log: function(message1, level1) {}
        };
        qq.extend(options1, spec1, true);
        function isJsonResponseValid1(response1) {
            if (qq.isArray(response1)) return true;
            options1.log("Session response is not an array.", "error");
        }
        function handleFileItems1(fileItems1, success1, xhrOrXdr1, promise1) {
            var someItemsIgnored1 = false;
            success1 = success1 && isJsonResponseValid1(fileItems1);
            if (success1) qq.each(fileItems1, function(idx1, fileItem1) {
                if (fileItem1.uuid == null) {
                    someItemsIgnored1 = true;
                    options1.log(qq.format("Session response item {} did not include a valid UUID - ignoring.", idx1), "error");
                } else if (fileItem1.name == null) {
                    someItemsIgnored1 = true;
                    options1.log(qq.format("Session response item {} did not include a valid name - ignoring.", idx1), "error");
                } else try {
                    options1.addFileRecord(fileItem1);
                    return true;
                } catch (err1) {
                    someItemsIgnored1 = true;
                    options1.log(err1.message, "error");
                }
                return false;
            });
            promise1[success1 && !someItemsIgnored1 ? "success" : "failure"](fileItems1, xhrOrXdr1);
        }
        this.refresh = function() {
            var refreshEffort1 = new qq.Promise(), refreshCompleteCallback1 = function(response1, success1, xhrOrXdr1) {
                handleFileItems1(response1, success1, xhrOrXdr1, refreshEffort1);
            }, requesterOptions1 = qq.extend({}, options1), requester1 = new qq.SessionAjaxRequester(qq.extend(requesterOptions1, {
                onComplete: refreshCompleteCallback1
            }));
            requester1.queryServer();
            return refreshEffort1;
        };
    };
    qq.SessionAjaxRequester = function(spec1) {
        "use strict";
        var requester1, options1 = {
            endpoint: null,
            customHeaders: {},
            params: {},
            cors: {
                expected: false,
                sendCredentials: false
            },
            onComplete: function(response1, success1, xhrOrXdr1) {},
            log: function(str1, level1) {}
        };
        qq.extend(options1, spec1);
        function onComplete1(id1, xhrOrXdr1, isError1) {
            var response1 = null;
            if (xhrOrXdr1.responseText != null) try {
                response1 = qq.parseJson(xhrOrXdr1.responseText);
            } catch (err1) {
                options1.log("Problem parsing session response: " + err1.message, "error");
                isError1 = true;
            }
            options1.onComplete(response1, !isError1, xhrOrXdr1);
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            acceptHeader: "application/json",
            validMethods: [
                "GET"
            ],
            method: "GET",
            endpointStore: {
                get: function() {
                    return options1.endpoint;
                }
            },
            customHeaders: options1.customHeaders,
            log: options1.log,
            onComplete: onComplete1,
            cors: options1.cors
        }));
        qq.extend(this, {
            queryServer: function() {
                var params1 = qq.extend({}, options1.params);
                options1.log("Session query request.");
                requester1.initTransport("sessionRefresh").withParams(params1).withCacheBuster().send();
            }
        });
    };
    qq.Scaler = function(spec1, log1) {
        "use strict";
        var self1 = this, customResizeFunction1 = spec1.customResizer, includeOriginal1 = spec1.sendOriginal, orient1 = spec1.orient, defaultType1 = spec1.defaultType, defaultQuality1 = spec1.defaultQuality / 100, failedToScaleText1 = spec1.failureText, includeExif1 = spec1.includeExif, sizes1 = this._getSortedSizes(spec1.sizes);
        qq.extend(this, {
            enabled: qq.supportedFeatures.scaling && sizes1.length > 0,
            getFileRecords: function(originalFileUuid1, originalFileName1, originalBlobOrBlobData1) {
                var self1 = this, records1 = [], originalBlob1 = originalBlobOrBlobData1.blob ? originalBlobOrBlobData1.blob : originalBlobOrBlobData1, identifier1 = new qq.Identify(originalBlob1, log1);
                if (identifier1.isPreviewableSync()) {
                    qq.each(sizes1, function(idx1, sizeRecord1) {
                        var outputType1 = self1._determineOutputType({
                            defaultType: defaultType1,
                            requestedType: sizeRecord1.type,
                            refType: originalBlob1.type
                        });
                        records1.push({
                            uuid: qq.getUniqueId(),
                            name: self1._getName(originalFileName1, {
                                name: sizeRecord1.name,
                                type: outputType1,
                                refType: originalBlob1.type
                            }),
                            blob: new qq.BlobProxy(originalBlob1, qq.bind(self1._generateScaledImage, self1, {
                                customResizeFunction: customResizeFunction1,
                                maxSize: sizeRecord1.maxSize,
                                orient: orient1,
                                type: outputType1,
                                quality: defaultQuality1,
                                failedText: failedToScaleText1,
                                includeExif: includeExif1,
                                log: log1
                            }))
                        });
                    });
                    records1.push({
                        uuid: originalFileUuid1,
                        name: originalFileName1,
                        size: originalBlob1.size,
                        blob: includeOriginal1 ? originalBlob1 : null
                    });
                } else records1.push({
                    uuid: originalFileUuid1,
                    name: originalFileName1,
                    size: originalBlob1.size,
                    blob: originalBlob1
                });
                return records1;
            },
            handleNewFile: function(file1, name1, uuid1, size1, fileList1, batchId1, uuidParamName1, api1) {
                var self1 = this, buttonId1 = file1.qqButtonId || file1.blob && file1.blob.qqButtonId, scaledIds1 = [], originalId1 = null, addFileToHandler1 = api1.addFileToHandler, uploadData1 = api1.uploadData, paramsStore1 = api1.paramsStore, proxyGroupId1 = qq.getUniqueId();
                qq.each(self1.getFileRecords(uuid1, name1, file1), function(idx1, record1) {
                    var blobSize1 = record1.size, id1;
                    if (record1.blob instanceof qq.BlobProxy) blobSize1 = -1;
                    id1 = uploadData1.addFile({
                        uuid: record1.uuid,
                        name: record1.name,
                        size: blobSize1,
                        batchId: batchId1,
                        proxyGroupId: proxyGroupId1
                    });
                    if (record1.blob instanceof qq.BlobProxy) scaledIds1.push(id1);
                    else originalId1 = id1;
                    if (record1.blob) {
                        addFileToHandler1(id1, record1.blob);
                        fileList1.push({
                            id: id1,
                            file: record1.blob
                        });
                    } else uploadData1.setStatus(id1, qq.status.REJECTED);
                });
                if (originalId1 !== null) {
                    qq.each(scaledIds1, function(idx1, scaledId1) {
                        var params1 = {
                            qqparentuuid: uploadData1.retrieve({
                                id: originalId1
                            }).uuid,
                            qqparentsize: uploadData1.retrieve({
                                id: originalId1
                            }).size
                        };
                        params1[uuidParamName1] = uploadData1.retrieve({
                            id: scaledId1
                        }).uuid;
                        uploadData1.setParentId(scaledId1, originalId1);
                        paramsStore1.addReadOnly(scaledId1, params1);
                    });
                    if (scaledIds1.length) (function() {
                        var param1 = {};
                        param1[uuidParamName1] = uploadData1.retrieve({
                            id: originalId1
                        }).uuid;
                        paramsStore1.addReadOnly(originalId1, param1);
                    })();
                }
            }
        });
    };
    qq.extend(qq.Scaler.prototype, {
        scaleImage: function(id1, specs1, api1) {
            "use strict";
            if (!qq.supportedFeatures.scaling) throw new qq.Error("Scaling is not supported in this browser!");
            var scalingEffort1 = new qq.Promise(), log1 = api1.log, file1 = api1.getFile(id1), uploadData1 = api1.uploadData.retrieve({
                id: id1
            }), name1 = uploadData1 && uploadData1.name, uuid1 = uploadData1 && uploadData1.uuid, scalingOptions1 = {
                customResizer: specs1.customResizer,
                sendOriginal: false,
                orient: specs1.orient,
                defaultType: specs1.type || null,
                defaultQuality: specs1.quality,
                failedToScaleText: "Unable to scale",
                sizes: [
                    {
                        name: "",
                        maxSize: specs1.maxSize
                    }
                ]
            }, scaler1 = new qq.Scaler(scalingOptions1, log1);
            if (!qq.Scaler || !qq.supportedFeatures.imagePreviews || !file1) {
                scalingEffort1.failure();
                log1("Could not generate requested scaled image for " + id1 + ".  " + "Scaling is either not possible in this browser, or the file could not be located.", "error");
            } else qq.bind(function() {
                var record1 = scaler1.getFileRecords(uuid1, name1, file1)[0];
                if (record1 && record1.blob instanceof qq.BlobProxy) record1.blob.create().then(scalingEffort1.success, scalingEffort1.failure);
                else {
                    log1(id1 + " is not a scalable image!", "error");
                    scalingEffort1.failure();
                }
            }, this)();
            return scalingEffort1;
        },
        _determineOutputType: function(spec1) {
            "use strict";
            var requestedType1 = spec1.requestedType, defaultType1 = spec1.defaultType, referenceType1 = spec1.refType;
            if (!defaultType1 && !requestedType1) {
                if (referenceType1 !== "image/jpeg") return "image/png";
                return referenceType1;
            }
            if (!requestedType1) return defaultType1;
            if (qq.indexOf(Object.keys(qq.Identify.prototype.PREVIEWABLE_MIME_TYPES), requestedType1) >= 0) {
                if (requestedType1 === "image/tiff") return qq.supportedFeatures.tiffPreviews ? requestedType1 : defaultType1;
                return requestedType1;
            }
            return defaultType1;
        },
        _getName: function(originalName1, scaledVersionProperties1) {
            "use strict";
            var startOfExt1 = originalName1.lastIndexOf("."), versionType1 = scaledVersionProperties1.type || "image/png", referenceType1 = scaledVersionProperties1.refType, scaledName1 = "", scaledExt1 = qq.getExtension(originalName1), nameAppendage1 = "";
            if (scaledVersionProperties1.name && scaledVersionProperties1.name.trim().length) nameAppendage1 = " (" + scaledVersionProperties1.name + ")";
            if (startOfExt1 >= 0) {
                scaledName1 = originalName1.substr(0, startOfExt1);
                if (referenceType1 !== versionType1) scaledExt1 = versionType1.split("/")[1];
                scaledName1 += nameAppendage1 + "." + scaledExt1;
            } else scaledName1 = originalName1 + nameAppendage1;
            return scaledName1;
        },
        _getSortedSizes: function(sizes1) {
            "use strict";
            sizes1 = qq.extend([], sizes1);
            return sizes1.sort(function(a1, b1) {
                if (a1.maxSize > b1.maxSize) return 1;
                if (a1.maxSize < b1.maxSize) return -1;
                return 0;
            });
        },
        _generateScaledImage: function(spec1, sourceFile1) {
            "use strict";
            var self1 = this, customResizeFunction1 = spec1.customResizeFunction, log1 = spec1.log, maxSize1 = spec1.maxSize, orient1 = spec1.orient, type1 = spec1.type, quality1 = spec1.quality, failedText1 = spec1.failedText, includeExif1 = spec1.includeExif && sourceFile1.type === "image/jpeg" && type1 === "image/jpeg", scalingEffort1 = new qq.Promise(), imageGenerator1 = new qq.ImageGenerator(log1), canvas1 = document.createElement("canvas");
            log1("Attempting to generate scaled version for " + sourceFile1.name);
            imageGenerator1.generate(sourceFile1, canvas1, {
                maxSize: maxSize1,
                orient: orient1,
                customResizeFunction: customResizeFunction1
            }).then(function() {
                var scaledImageDataUri1 = canvas1.toDataURL(type1, quality1), signalSuccess1 = function() {
                    log1("Success generating scaled version for " + sourceFile1.name);
                    var blob1 = qq.dataUriToBlob(scaledImageDataUri1);
                    scalingEffort1.success(blob1);
                };
                if (includeExif1) self1._insertExifHeader(sourceFile1, scaledImageDataUri1, log1).then(function(scaledImageDataUriWithExif1) {
                    scaledImageDataUri1 = scaledImageDataUriWithExif1;
                    signalSuccess1();
                }, function() {
                    log1("Problem inserting EXIF header into scaled image.  Using scaled image w/out EXIF data.", "error");
                    signalSuccess1();
                });
                else signalSuccess1();
            }, function() {
                log1("Failed attempt to generate scaled version for " + sourceFile1.name, "error");
                scalingEffort1.failure(failedText1);
            });
            return scalingEffort1;
        },
        _insertExifHeader: function(originalImage1, scaledImageDataUri1, log1) {
            "use strict";
            var reader1 = new FileReader(), insertionEffort1 = new qq.Promise(), originalImageDataUri1 = "";
            reader1.onload = function() {
                originalImageDataUri1 = reader1.result;
                insertionEffort1.success(qq.ExifRestorer.restore(originalImageDataUri1, scaledImageDataUri1));
            };
            reader1.onerror = function() {
                log1("Problem reading " + originalImage1.name + " during attempt to transfer EXIF data to scaled version.", "error");
                insertionEffort1.failure();
            };
            reader1.readAsDataURL(originalImage1);
            return insertionEffort1;
        },
        _dataUriToBlob: function(dataUri1) {
            "use strict";
            var byteString1, mimeString1, arrayBuffer1, intArray1;
            if (dataUri1.split(",")[0].indexOf("base64") >= 0) byteString1 = atob(dataUri1.split(",")[1]);
            else byteString1 = decodeURI(dataUri1.split(",")[1]);
            mimeString1 = dataUri1.split(",")[0].split(":")[1].split(";")[0];
            arrayBuffer1 = new ArrayBuffer(byteString1.length);
            intArray1 = new Uint8Array(arrayBuffer1);
            qq.each(byteString1, function(idx1, character1) {
                intArray1[idx1] = character1.charCodeAt(0);
            });
            return this._createBlob(arrayBuffer1, mimeString1);
        },
        _createBlob: function(data1, mime1) {
            "use strict";
            var BlobBuilder1 = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder1 = BlobBuilder1 && new BlobBuilder1();
            if (blobBuilder1) {
                blobBuilder1.append(data1);
                return blobBuilder1.getBlob(mime1);
            } else return new Blob([
                data1
            ], {
                type: mime1
            });
        }
    });
    qq.ExifRestorer = function() {
        var ExifRestorer1 = {};
        ExifRestorer1.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        ExifRestorer1.encode64 = function(input1) {
            var output1 = "", chr11, chr21, chr31 = "", enc11, enc21, enc31, enc41 = "", i1 = 0;
            do {
                chr11 = input1[i1++];
                chr21 = input1[i1++];
                chr31 = input1[i1++];
                enc11 = chr11 >> 2;
                enc21 = (chr11 & 3) << 4 | chr21 >> 4;
                enc31 = (chr21 & 15) << 2 | chr31 >> 6;
                enc41 = chr31 & 63;
                if (isNaN(chr21)) enc31 = enc41 = 64;
                else if (isNaN(chr31)) enc41 = 64;
                output1 = output1 + this.KEY_STR.charAt(enc11) + this.KEY_STR.charAt(enc21) + this.KEY_STR.charAt(enc31) + this.KEY_STR.charAt(enc41);
                chr11 = chr21 = chr31 = "";
                enc11 = enc21 = enc31 = enc41 = "";
            }while (i1 < input1.length);
            return output1;
        };
        ExifRestorer1.restore = function(origFileBase641, resizedFileBase641) {
            var expectedBase64Header1 = "data:image/jpeg;base64,";
            if (!origFileBase641.match(expectedBase64Header1)) return resizedFileBase641;
            var rawImage1 = this.decode64(origFileBase641.replace(expectedBase64Header1, ""));
            var segments1 = this.slice2Segments(rawImage1);
            var image1 = this.exifManipulation(resizedFileBase641, segments1);
            return expectedBase64Header1 + this.encode64(image1);
        };
        ExifRestorer1.exifManipulation = function(resizedFileBase641, segments1) {
            var exifArray1 = this.getExifArray(segments1), newImageArray1 = this.insertExif(resizedFileBase641, exifArray1), aBuffer1 = new Uint8Array(newImageArray1);
            return aBuffer1;
        };
        ExifRestorer1.getExifArray = function(segments1) {
            var seg1;
            for(var x1 = 0; x1 < segments1.length; x1++){
                seg1 = segments1[x1];
                if (seg1[0] == 255 & seg1[1] == 225) return seg1;
            }
            return [];
        };
        ExifRestorer1.insertExif = function(resizedFileBase641, exifArray1) {
            var imageData1 = resizedFileBase641.replace("data:image/jpeg;base64,", ""), buf1 = this.decode64(imageData1), separatePoint1 = buf1.indexOf(255, 3), mae1 = buf1.slice(0, separatePoint1), ato1 = buf1.slice(separatePoint1), array1 = mae1;
            array1 = array1.concat(exifArray1);
            array1 = array1.concat(ato1);
            return array1;
        };
        ExifRestorer1.slice2Segments = function(rawImageArray1) {
            var head1 = 0, segments1 = [];
            while(true){
                if (rawImageArray1[head1] == 255 & rawImageArray1[head1 + 1] == 218) break;
                if (rawImageArray1[head1] == 255 & rawImageArray1[head1 + 1] == 216) head1 += 2;
                else {
                    var length1 = rawImageArray1[head1 + 2] * 256 + rawImageArray1[head1 + 3], endPoint1 = head1 + length1 + 2, seg1 = rawImageArray1.slice(head1, endPoint1);
                    segments1.push(seg1);
                    head1 = endPoint1;
                }
                if (head1 > rawImageArray1.length) break;
            }
            return segments1;
        };
        ExifRestorer1.decode64 = function(input1) {
            var output1 = "", chr11, chr21, chr31 = "", enc11, enc21, enc31, enc41 = "", i1 = 0, buf1 = [];
            var base64test1 = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test1.exec(input1)) throw new Error("There were invalid base64 characters in the input text.  Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='");
            input1 = input1.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            do {
                enc11 = this.KEY_STR.indexOf(input1.charAt(i1++));
                enc21 = this.KEY_STR.indexOf(input1.charAt(i1++));
                enc31 = this.KEY_STR.indexOf(input1.charAt(i1++));
                enc41 = this.KEY_STR.indexOf(input1.charAt(i1++));
                chr11 = enc11 << 2 | enc21 >> 4;
                chr21 = (enc21 & 15) << 4 | enc31 >> 2;
                chr31 = (enc31 & 3) << 6 | enc41;
                buf1.push(chr11);
                if (enc31 != 64) buf1.push(chr21);
                if (enc41 != 64) buf1.push(chr31);
                chr11 = chr21 = chr31 = "";
                enc11 = enc21 = enc31 = enc41 = "";
            }while (i1 < input1.length);
            return buf1;
        };
        return ExifRestorer1;
    }();
    qq.TotalProgress = function(callback1, getSize1) {
        "use strict";
        var perFileProgress1 = {}, totalLoaded1 = 0, totalSize1 = 0, lastLoadedSent1 = -1, lastTotalSent1 = -1, callbackProxy1 = function(loaded1, total1) {
            if (loaded1 !== lastLoadedSent1 || total1 !== lastTotalSent1) callback1(loaded1, total1);
            lastLoadedSent1 = loaded1;
            lastTotalSent1 = total1;
        }, noRetryableFiles1 = function(failed1, retryable1) {
            var none1 = true;
            qq.each(failed1, function(idx1, failedId1) {
                if (qq.indexOf(retryable1, failedId1) >= 0) {
                    none1 = false;
                    return false;
                }
            });
            return none1;
        }, onCancel1 = function(id1) {
            updateTotalProgress1(id1, -1, -1);
            delete perFileProgress1[id1];
        }, onAllComplete1 = function(successful1, failed1, retryable1) {
            if (failed1.length === 0 || noRetryableFiles1(failed1, retryable1)) {
                callbackProxy1(totalSize1, totalSize1);
                this.reset();
            }
        }, onNew1 = function(id1) {
            var size1 = getSize1(id1);
            if (size1 > 0) {
                updateTotalProgress1(id1, 0, size1);
                perFileProgress1[id1] = {
                    loaded: 0,
                    total: size1
                };
            }
        }, updateTotalProgress1 = function(id1, newLoaded1, newTotal1) {
            var oldLoaded1 = perFileProgress1[id1] ? perFileProgress1[id1].loaded : 0, oldTotal1 = perFileProgress1[id1] ? perFileProgress1[id1].total : 0;
            if (newLoaded1 === -1 && newTotal1 === -1) {
                totalLoaded1 -= oldLoaded1;
                totalSize1 -= oldTotal1;
            } else {
                if (newLoaded1) totalLoaded1 += newLoaded1 - oldLoaded1;
                if (newTotal1) totalSize1 += newTotal1 - oldTotal1;
            }
            callbackProxy1(totalLoaded1, totalSize1);
        };
        qq.extend(this, {
            onAllComplete: onAllComplete1,
            onStatusChange: function(id1, oldStatus1, newStatus1) {
                if (newStatus1 === qq.status.CANCELED || newStatus1 === qq.status.REJECTED) onCancel1(id1);
                else if (newStatus1 === qq.status.SUBMITTING) onNew1(id1);
            },
            onIndividualProgress: function(id1, loaded1, total1) {
                updateTotalProgress1(id1, loaded1, total1);
                perFileProgress1[id1] = {
                    loaded: loaded1,
                    total: total1
                };
            },
            onNewSize: function(id1) {
                onNew1(id1);
            },
            reset: function() {
                perFileProgress1 = {};
                totalLoaded1 = 0;
                totalSize1 = 0;
            }
        });
    };
    qq.PasteSupport = function(o1) {
        "use strict";
        var options1, detachPasteHandler1;
        options1 = {
            targetElement: null,
            callbacks: {
                log: function(message1, level1) {},
                pasteReceived: function(blob1) {}
            }
        };
        function isImage1(item1) {
            return item1.type && item1.type.indexOf("image/") === 0;
        }
        function registerPasteHandler1() {
            detachPasteHandler1 = qq(options1.targetElement).attach("paste", function(event1) {
                var clipboardData1 = event1.clipboardData;
                if (clipboardData1) qq.each(clipboardData1.items, function(idx1, item1) {
                    if (isImage1(item1)) {
                        var blob1 = item1.getAsFile();
                        options1.callbacks.pasteReceived(blob1);
                    }
                });
            });
        }
        function unregisterPasteHandler1() {
            if (detachPasteHandler1) detachPasteHandler1();
        }
        qq.extend(options1, o1);
        registerPasteHandler1();
        qq.extend(this, {
            reset: function() {
                unregisterPasteHandler1();
            }
        });
    };
    qq.FormSupport = function(options1, startUpload1, log1) {
        "use strict";
        var self1 = this, interceptSubmit1 = options1.interceptSubmit, formEl1 = options1.element, autoUpload1 = options1.autoUpload;
        qq.extend(this, {
            newEndpoint: null,
            newAutoUpload: autoUpload1,
            attachedToForm: false,
            getFormInputsAsObject: function() {
                if (formEl1 == null) return null;
                return self1._form2Obj(formEl1);
            }
        });
        function determineNewEndpoint1(formEl1) {
            if (formEl1.getAttribute("action")) self1.newEndpoint = formEl1.getAttribute("action");
        }
        function validateForm1(formEl1, nativeSubmit1) {
            if (formEl1.checkValidity && !formEl1.checkValidity()) {
                log1("Form did not pass validation checks - will not upload.", "error");
                nativeSubmit1();
            } else return true;
        }
        function maybeUploadOnSubmit1(formEl1) {
            var nativeSubmit1 = formEl1.submit;
            qq(formEl1).attach("submit", function(event1) {
                event1 = event1 || window.event;
                if (event1.preventDefault) event1.preventDefault();
                else event1.returnValue = false;
                validateForm1(formEl1, nativeSubmit1) && startUpload1();
            });
            formEl1.submit = function() {
                validateForm1(formEl1, nativeSubmit1) && startUpload1();
            };
        }
        function determineFormEl1(formEl1) {
            if (formEl1) {
                if (qq.isString(formEl1)) formEl1 = document.getElementById(formEl1);
                if (formEl1) {
                    log1("Attaching to form element.");
                    determineNewEndpoint1(formEl1);
                    interceptSubmit1 && maybeUploadOnSubmit1(formEl1);
                }
            }
            return formEl1;
        }
        formEl1 = determineFormEl1(formEl1);
        this.attachedToForm = !!formEl1;
    };
    qq.extend(qq.FormSupport.prototype, {
        _form2Obj: function(form1) {
            "use strict";
            var obj1 = {}, notIrrelevantType1 = function(type1) {
                var irrelevantTypes1 = [
                    "button",
                    "image",
                    "reset",
                    "submit"
                ];
                return qq.indexOf(irrelevantTypes1, type1.toLowerCase()) < 0;
            }, radioOrCheckbox1 = function(type1) {
                return qq.indexOf([
                    "checkbox",
                    "radio"
                ], type1.toLowerCase()) >= 0;
            }, ignoreValue1 = function(el1) {
                if (radioOrCheckbox1(el1.type) && !el1.checked) return true;
                return el1.disabled && el1.type.toLowerCase() !== "hidden";
            }, selectValue1 = function(select1) {
                var value1 = null;
                qq.each(qq(select1).children(), function(idx1, child1) {
                    if (child1.tagName.toLowerCase() === "option" && child1.selected) {
                        value1 = child1.value;
                        return false;
                    }
                });
                return value1;
            };
            qq.each(form1.elements, function(idx1, el1) {
                if ((qq.isInput(el1, true) || el1.tagName.toLowerCase() === "textarea") && notIrrelevantType1(el1.type) && !ignoreValue1(el1)) obj1[el1.name] = el1.value;
                else if (el1.tagName.toLowerCase() === "select" && !ignoreValue1(el1)) {
                    var value1 = selectValue1(el1);
                    if (value1 !== null) obj1[el1.name] = value1;
                }
            });
            return obj1;
        }
    });
    qq.CryptoJS = function(Math1, undefined1) {
        var C1 = {};
        var C_lib1 = C1.lib = {};
        var Base1 = C_lib1.Base = function() {
            function F1() {}
            return {
                extend: function(overrides1) {
                    F1.prototype = this;
                    var subtype1 = new F1();
                    if (overrides1) subtype1.mixIn(overrides1);
                    if (!subtype1.hasOwnProperty("init")) subtype1.init = function() {
                        subtype1.$super.init.apply(this, arguments);
                    };
                    subtype1.init.prototype = subtype1;
                    subtype1.$super = this;
                    return subtype1;
                },
                create: function() {
                    var instance1 = this.extend();
                    instance1.init.apply(instance1, arguments);
                    return instance1;
                },
                init: function() {},
                mixIn: function(properties1) {
                    for(var propertyName1 in properties1)if (properties1.hasOwnProperty(propertyName1)) this[propertyName1] = properties1[propertyName1];
                    if (properties1.hasOwnProperty("toString")) this.toString = properties1.toString;
                },
                clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        var WordArray1 = C_lib1.WordArray = Base1.extend({
            init: function(words1, sigBytes1) {
                words1 = this.words = words1 || [];
                if (sigBytes1 != undefined1) this.sigBytes = sigBytes1;
                else this.sigBytes = words1.length * 4;
            },
            toString: function(encoder1) {
                return (encoder1 || Hex1).stringify(this);
            },
            concat: function(wordArray1) {
                var thisWords1 = this.words;
                var thatWords1 = wordArray1.words;
                var thisSigBytes1 = this.sigBytes;
                var thatSigBytes1 = wordArray1.sigBytes;
                this.clamp();
                if (thisSigBytes1 % 4) for(var i1 = 0; i1 < thatSigBytes1; i1++){
                    var thatByte1 = thatWords1[i1 >>> 2] >>> 24 - i1 % 4 * 8 & 255;
                    thisWords1[thisSigBytes1 + i1 >>> 2] |= thatByte1 << 24 - (thisSigBytes1 + i1) % 4 * 8;
                }
                else if (thatWords1.length > 65535) for(var i1 = 0; i1 < thatSigBytes1; i1 += 4)thisWords1[thisSigBytes1 + i1 >>> 2] = thatWords1[i1 >>> 2];
                else thisWords1.push.apply(thisWords1, thatWords1);
                this.sigBytes += thatSigBytes1;
                return this;
            },
            clamp: function() {
                var words1 = this.words;
                var sigBytes1 = this.sigBytes;
                words1[sigBytes1 >>> 2] &= 4294967295 << 32 - sigBytes1 % 4 * 8;
                words1.length = Math1.ceil(sigBytes1 / 4);
            },
            clone: function() {
                var clone1 = Base1.clone.call(this);
                clone1.words = this.words.slice(0);
                return clone1;
            },
            random: function(nBytes1) {
                var words1 = [];
                for(var i1 = 0; i1 < nBytes1; i1 += 4)words1.push(Math1.random() * 4294967296 | 0);
                return new WordArray1.init(words1, nBytes1);
            }
        });
        var C_enc1 = C1.enc = {};
        var Hex1 = C_enc1.Hex = {
            stringify: function(wordArray1) {
                var words1 = wordArray1.words;
                var sigBytes1 = wordArray1.sigBytes;
                var hexChars1 = [];
                for(var i1 = 0; i1 < sigBytes1; i1++){
                    var bite1 = words1[i1 >>> 2] >>> 24 - i1 % 4 * 8 & 255;
                    hexChars1.push((bite1 >>> 4).toString(16));
                    hexChars1.push((bite1 & 15).toString(16));
                }
                return hexChars1.join("");
            },
            parse: function(hexStr1) {
                var hexStrLength1 = hexStr1.length;
                var words1 = [];
                for(var i1 = 0; i1 < hexStrLength1; i1 += 2)words1[i1 >>> 3] |= parseInt(hexStr1.substr(i1, 2), 16) << 24 - i1 % 8 * 4;
                return new WordArray1.init(words1, hexStrLength1 / 2);
            }
        };
        var Latin11 = C_enc1.Latin1 = {
            stringify: function(wordArray1) {
                var words1 = wordArray1.words;
                var sigBytes1 = wordArray1.sigBytes;
                var latin1Chars1 = [];
                for(var i1 = 0; i1 < sigBytes1; i1++){
                    var bite1 = words1[i1 >>> 2] >>> 24 - i1 % 4 * 8 & 255;
                    latin1Chars1.push(String.fromCharCode(bite1));
                }
                return latin1Chars1.join("");
            },
            parse: function(latin1Str1) {
                var latin1StrLength1 = latin1Str1.length;
                var words1 = [];
                for(var i1 = 0; i1 < latin1StrLength1; i1++)words1[i1 >>> 2] |= (latin1Str1.charCodeAt(i1) & 255) << 24 - i1 % 4 * 8;
                return new WordArray1.init(words1, latin1StrLength1);
            }
        };
        var Utf81 = C_enc1.Utf8 = {
            stringify: function(wordArray1) {
                try {
                    return decodeURIComponent(escape(Latin11.stringify(wordArray1)));
                } catch (e1) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            parse: function(utf8Str1) {
                return Latin11.parse(unescape(encodeURIComponent(utf8Str1)));
            }
        };
        var BufferedBlockAlgorithm1 = C_lib1.BufferedBlockAlgorithm = Base1.extend({
            reset: function() {
                this._data = new WordArray1.init();
                this._nDataBytes = 0;
            },
            _append: function(data1) {
                if (typeof data1 == "string") data1 = Utf81.parse(data1);
                this._data.concat(data1);
                this._nDataBytes += data1.sigBytes;
            },
            _process: function(doFlush1) {
                var data1 = this._data;
                var dataWords1 = data1.words;
                var dataSigBytes1 = data1.sigBytes;
                var blockSize1 = this.blockSize;
                var blockSizeBytes1 = blockSize1 * 4;
                var nBlocksReady1 = dataSigBytes1 / blockSizeBytes1;
                if (doFlush1) nBlocksReady1 = Math1.ceil(nBlocksReady1);
                else nBlocksReady1 = Math1.max((nBlocksReady1 | 0) - this._minBufferSize, 0);
                var nWordsReady1 = nBlocksReady1 * blockSize1;
                var nBytesReady1 = Math1.min(nWordsReady1 * 4, dataSigBytes1);
                if (nWordsReady1) {
                    for(var offset1 = 0; offset1 < nWordsReady1; offset1 += blockSize1)this._doProcessBlock(dataWords1, offset1);
                    var processedWords1 = dataWords1.splice(0, nWordsReady1);
                    data1.sigBytes -= nBytesReady1;
                }
                return new WordArray1.init(processedWords1, nBytesReady1);
            },
            clone: function() {
                var clone1 = Base1.clone.call(this);
                clone1._data = this._data.clone();
                return clone1;
            },
            _minBufferSize: 0
        });
        var Hasher1 = C_lib1.Hasher = BufferedBlockAlgorithm1.extend({
            cfg: Base1.extend(),
            init: function(cfg1) {
                this.cfg = this.cfg.extend(cfg1);
                this.reset();
            },
            reset: function() {
                BufferedBlockAlgorithm1.reset.call(this);
                this._doReset();
            },
            update: function(messageUpdate1) {
                this._append(messageUpdate1);
                this._process();
                return this;
            },
            finalize: function(messageUpdate1) {
                if (messageUpdate1) this._append(messageUpdate1);
                var hash1 = this._doFinalize();
                return hash1;
            },
            blockSize: 16,
            _createHelper: function(hasher1) {
                return function(message1, cfg1) {
                    return new hasher1.init(cfg1).finalize(message1);
                };
            },
            _createHmacHelper: function(hasher1) {
                return function(message1, key1) {
                    return new C_algo1.HMAC.init(hasher1, key1).finalize(message1);
                };
            }
        });
        var C_algo1 = C1.algo = {};
        return C1;
    }(Math);
    (function() {
        var C1 = qq.CryptoJS;
        var C_lib1 = C1.lib;
        var WordArray1 = C_lib1.WordArray;
        var C_enc1 = C1.enc;
        var Base641 = C_enc1.Base64 = {
            stringify: function(wordArray1) {
                var words1 = wordArray1.words;
                var sigBytes1 = wordArray1.sigBytes;
                var map1 = this._map;
                wordArray1.clamp();
                var base64Chars1 = [];
                for(var i1 = 0; i1 < sigBytes1; i1 += 3){
                    var byte11 = words1[i1 >>> 2] >>> 24 - i1 % 4 * 8 & 255;
                    var byte21 = words1[i1 + 1 >>> 2] >>> 24 - (i1 + 1) % 4 * 8 & 255;
                    var byte31 = words1[i1 + 2 >>> 2] >>> 24 - (i1 + 2) % 4 * 8 & 255;
                    var triplet1 = byte11 << 16 | byte21 << 8 | byte31;
                    for(var j1 = 0; j1 < 4 && i1 + j1 * .75 < sigBytes1; j1++)base64Chars1.push(map1.charAt(triplet1 >>> 6 * (3 - j1) & 63));
                }
                var paddingChar1 = map1.charAt(64);
                if (paddingChar1) while(base64Chars1.length % 4)base64Chars1.push(paddingChar1);
                return base64Chars1.join("");
            },
            parse: function(base64Str1) {
                var base64StrLength1 = base64Str1.length;
                var map1 = this._map;
                var paddingChar1 = map1.charAt(64);
                if (paddingChar1) {
                    var paddingIndex1 = base64Str1.indexOf(paddingChar1);
                    if (paddingIndex1 != -1) base64StrLength1 = paddingIndex1;
                }
                var words1 = [];
                var nBytes1 = 0;
                for(var i1 = 0; i1 < base64StrLength1; i1++)if (i1 % 4) {
                    var bits11 = map1.indexOf(base64Str1.charAt(i1 - 1)) << i1 % 4 * 2;
                    var bits21 = map1.indexOf(base64Str1.charAt(i1)) >>> 6 - i1 % 4 * 2;
                    words1[nBytes1 >>> 2] |= (bits11 | bits21) << 24 - nBytes1 % 4 * 8;
                    nBytes1++;
                }
                return WordArray1.create(words1, nBytes1);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
    })();
    (function() {
        var C1 = qq.CryptoJS;
        var C_lib1 = C1.lib;
        var Base1 = C_lib1.Base;
        var C_enc1 = C1.enc;
        var Utf81 = C_enc1.Utf8;
        var C_algo1 = C1.algo;
        var HMAC1 = C_algo1.HMAC = Base1.extend({
            init: function(hasher1, key1) {
                hasher1 = this._hasher = new hasher1.init();
                if (typeof key1 == "string") key1 = Utf81.parse(key1);
                var hasherBlockSize1 = hasher1.blockSize;
                var hasherBlockSizeBytes1 = hasherBlockSize1 * 4;
                if (key1.sigBytes > hasherBlockSizeBytes1) key1 = hasher1.finalize(key1);
                key1.clamp();
                var oKey1 = this._oKey = key1.clone();
                var iKey1 = this._iKey = key1.clone();
                var oKeyWords1 = oKey1.words;
                var iKeyWords1 = iKey1.words;
                for(var i1 = 0; i1 < hasherBlockSize1; i1++){
                    oKeyWords1[i1] ^= 1549556828;
                    iKeyWords1[i1] ^= 909522486;
                }
                oKey1.sigBytes = iKey1.sigBytes = hasherBlockSizeBytes1;
                this.reset();
            },
            reset: function() {
                var hasher1 = this._hasher;
                hasher1.reset();
                hasher1.update(this._iKey);
            },
            update: function(messageUpdate1) {
                this._hasher.update(messageUpdate1);
                return this;
            },
            finalize: function(messageUpdate1) {
                var hasher1 = this._hasher;
                var innerHash1 = hasher1.finalize(messageUpdate1);
                hasher1.reset();
                var hmac1 = hasher1.finalize(this._oKey.clone().concat(innerHash1));
                return hmac1;
            }
        });
    })();
    (function() {
        var C1 = qq.CryptoJS;
        var C_lib1 = C1.lib;
        var WordArray1 = C_lib1.WordArray;
        var Hasher1 = C_lib1.Hasher;
        var C_algo1 = C1.algo;
        var W1 = [];
        var SHA11 = C_algo1.SHA1 = Hasher1.extend({
            _doReset: function() {
                this._hash = new WordArray1.init([
                    1732584193,
                    4023233417,
                    2562383102,
                    271733878,
                    3285377520
                ]);
            },
            _doProcessBlock: function(M1, offset1) {
                var H1 = this._hash.words;
                var a1 = H1[0];
                var b1 = H1[1];
                var c1 = H1[2];
                var d1 = H1[3];
                var e1 = H1[4];
                for(var i1 = 0; i1 < 80; i1++){
                    if (i1 < 16) W1[i1] = M1[offset1 + i1] | 0;
                    else {
                        var n1 = W1[i1 - 3] ^ W1[i1 - 8] ^ W1[i1 - 14] ^ W1[i1 - 16];
                        W1[i1] = n1 << 1 | n1 >>> 31;
                    }
                    var t3 = (a1 << 5 | a1 >>> 27) + e1 + W1[i1];
                    if (i1 < 20) t3 += (b1 & c1 | ~b1 & d1) + 1518500249;
                    else if (i1 < 40) t3 += (b1 ^ c1 ^ d1) + 1859775393;
                    else if (i1 < 60) t3 += (b1 & c1 | b1 & d1 | c1 & d1) - 1894007588;
                    else t3 += (b1 ^ c1 ^ d1) - 899497514;
                    e1 = d1;
                    d1 = c1;
                    c1 = b1 << 30 | b1 >>> 2;
                    b1 = a1;
                    a1 = t3;
                }
                H1[0] = H1[0] + a1 | 0;
                H1[1] = H1[1] + b1 | 0;
                H1[2] = H1[2] + c1 | 0;
                H1[3] = H1[3] + d1 | 0;
                H1[4] = H1[4] + e1 | 0;
            },
            _doFinalize: function() {
                var data1 = this._data;
                var dataWords1 = data1.words;
                var nBitsTotal1 = this._nDataBytes * 8;
                var nBitsLeft1 = data1.sigBytes * 8;
                dataWords1[nBitsLeft1 >>> 5] |= 128 << 24 - nBitsLeft1 % 32;
                dataWords1[(nBitsLeft1 + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal1 / 4294967296);
                dataWords1[(nBitsLeft1 + 64 >>> 9 << 4) + 15] = nBitsTotal1;
                data1.sigBytes = dataWords1.length * 4;
                this._process();
                return this._hash;
            },
            clone: function() {
                var clone1 = Hasher1.clone.call(this);
                clone1._hash = this._hash.clone();
                return clone1;
            }
        });
        C1.SHA1 = Hasher1._createHelper(SHA11);
        C1.HmacSHA1 = Hasher1._createHmacHelper(SHA11);
    })();
    (function(Math1) {
        var C1 = qq.CryptoJS;
        var C_lib1 = C1.lib;
        var WordArray1 = C_lib1.WordArray;
        var Hasher1 = C_lib1.Hasher;
        var C_algo1 = C1.algo;
        var H1 = [];
        var K1 = [];
        (function() {
            function isPrime1(n1) {
                var sqrtN1 = Math1.sqrt(n1);
                for(var factor1 = 2; factor1 <= sqrtN1; factor1++){
                    if (!(n1 % factor1)) return false;
                }
                return true;
            }
            function getFractionalBits1(n1) {
                return (n1 - (n1 | 0)) * 4294967296 | 0;
            }
            var n1 = 2;
            var nPrime1 = 0;
            while(nPrime1 < 64){
                if (isPrime1(n1)) {
                    if (nPrime1 < 8) H1[nPrime1] = getFractionalBits1(Math1.pow(n1, 0.5));
                    K1[nPrime1] = getFractionalBits1(Math1.pow(n1, 1 / 3));
                    nPrime1++;
                }
                n1++;
            }
        })();
        var W1 = [];
        var SHA2561 = C_algo1.SHA256 = Hasher1.extend({
            _doReset: function() {
                this._hash = new WordArray1.init(H1.slice(0));
            },
            _doProcessBlock: function(M1, offset1) {
                var H1 = this._hash.words;
                var a1 = H1[0];
                var b1 = H1[1];
                var c1 = H1[2];
                var d1 = H1[3];
                var e1 = H1[4];
                var f1 = H1[5];
                var g1 = H1[6];
                var h1 = H1[7];
                for(var i1 = 0; i1 < 64; i1++){
                    if (i1 < 16) W1[i1] = M1[offset1 + i1] | 0;
                    else {
                        var gamma0x1 = W1[i1 - 15];
                        var gamma01 = (gamma0x1 << 25 | gamma0x1 >>> 7) ^ (gamma0x1 << 14 | gamma0x1 >>> 18) ^ gamma0x1 >>> 3;
                        var gamma1x1 = W1[i1 - 2];
                        var gamma11 = (gamma1x1 << 15 | gamma1x1 >>> 17) ^ (gamma1x1 << 13 | gamma1x1 >>> 19) ^ gamma1x1 >>> 10;
                        W1[i1] = gamma01 + W1[i1 - 7] + gamma11 + W1[i1 - 16];
                    }
                    var ch1 = e1 & f1 ^ ~e1 & g1;
                    var maj1 = a1 & b1 ^ a1 & c1 ^ b1 & c1;
                    var sigma01 = (a1 << 30 | a1 >>> 2) ^ (a1 << 19 | a1 >>> 13) ^ (a1 << 10 | a1 >>> 22);
                    var sigma11 = (e1 << 26 | e1 >>> 6) ^ (e1 << 21 | e1 >>> 11) ^ (e1 << 7 | e1 >>> 25);
                    var t11 = h1 + sigma11 + ch1 + K1[i1] + W1[i1];
                    var t21 = sigma01 + maj1;
                    h1 = g1;
                    g1 = f1;
                    f1 = e1;
                    e1 = d1 + t11 | 0;
                    d1 = c1;
                    c1 = b1;
                    b1 = a1;
                    a1 = t11 + t21 | 0;
                }
                H1[0] = H1[0] + a1 | 0;
                H1[1] = H1[1] + b1 | 0;
                H1[2] = H1[2] + c1 | 0;
                H1[3] = H1[3] + d1 | 0;
                H1[4] = H1[4] + e1 | 0;
                H1[5] = H1[5] + f1 | 0;
                H1[6] = H1[6] + g1 | 0;
                H1[7] = H1[7] + h1 | 0;
            },
            _doFinalize: function() {
                var data1 = this._data;
                var dataWords1 = data1.words;
                var nBitsTotal1 = this._nDataBytes * 8;
                var nBitsLeft1 = data1.sigBytes * 8;
                dataWords1[nBitsLeft1 >>> 5] |= 128 << 24 - nBitsLeft1 % 32;
                dataWords1[(nBitsLeft1 + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal1 / 4294967296);
                dataWords1[(nBitsLeft1 + 64 >>> 9 << 4) + 15] = nBitsTotal1;
                data1.sigBytes = dataWords1.length * 4;
                this._process();
                return this._hash;
            },
            clone: function() {
                var clone1 = Hasher1.clone.call(this);
                clone1._hash = this._hash.clone();
                return clone1;
            }
        });
        C1.SHA256 = Hasher1._createHelper(SHA2561);
        C1.HmacSHA256 = Hasher1._createHmacHelper(SHA2561);
    })(Math);
    (function() {
        if (typeof ArrayBuffer != "function") return;
        var C1 = qq.CryptoJS;
        var C_lib1 = C1.lib;
        var WordArray1 = C_lib1.WordArray;
        var superInit1 = WordArray1.init;
        var subInit1 = WordArray1.init = function(typedArray1) {
            if (typedArray1 instanceof ArrayBuffer) typedArray1 = new Uint8Array(typedArray1);
            if (typedArray1 instanceof Int8Array || typedArray1 instanceof Uint8ClampedArray || typedArray1 instanceof Int16Array || typedArray1 instanceof Uint16Array || typedArray1 instanceof Int32Array || typedArray1 instanceof Uint32Array || typedArray1 instanceof Float32Array || typedArray1 instanceof Float64Array) typedArray1 = new Uint8Array(typedArray1.buffer, typedArray1.byteOffset, typedArray1.byteLength);
            if (typedArray1 instanceof Uint8Array) {
                var typedArrayByteLength1 = typedArray1.byteLength;
                var words1 = [];
                for(var i1 = 0; i1 < typedArrayByteLength1; i1++)words1[i1 >>> 2] |= typedArray1[i1] << 24 - i1 % 4 * 8;
                superInit1.call(this, words1, typedArrayByteLength1);
            } else superInit1.apply(this, arguments);
        };
        subInit1.prototype = WordArray1;
    })();
    qq.s3 = qq.s3 || {};
    qq.s3.util = qq.s3.util || function() {
        "use strict";
        return {
            ALGORITHM_PARAM_NAME: "x-amz-algorithm",
            AWS_PARAM_PREFIX: "x-amz-meta-",
            CREDENTIAL_PARAM_NAME: "x-amz-credential",
            DATE_PARAM_NAME: "x-amz-date",
            REDUCED_REDUNDANCY_PARAM_NAME: "x-amz-storage-class",
            REDUCED_REDUNDANCY_PARAM_VALUE: "REDUCED_REDUNDANCY",
            SERVER_SIDE_ENCRYPTION_PARAM_NAME: "x-amz-server-side-encryption",
            SERVER_SIDE_ENCRYPTION_PARAM_VALUE: "AES256",
            SESSION_TOKEN_PARAM_NAME: "x-amz-security-token",
            V4_ALGORITHM_PARAM_VALUE: "AWS4-HMAC-SHA256",
            V4_SIGNATURE_PARAM_NAME: "x-amz-signature",
            CASE_SENSITIVE_PARAM_NAMES: [
                "Cache-Control",
                "Content-Disposition",
                "Content-Encoding",
                "Content-MD5"
            ],
            UNSIGNABLE_REST_HEADER_NAMES: [
                "Cache-Control",
                "Content-Disposition",
                "Content-Encoding",
                "Content-MD5"
            ],
            UNPREFIXED_PARAM_NAMES: [
                "Cache-Control",
                "Content-Disposition",
                "Content-Encoding",
                "Content-MD5",
                "x-amz-server-side-encryption",
                "x-amz-server-side-encryption-aws-kms-key-id",
                "x-amz-server-side-encryption-customer-algorithm",
                "x-amz-server-side-encryption-customer-key",
                "x-amz-server-side-encryption-customer-key-MD5"
            ],
            getBucket: function(endpoint1) {
                var patterns1 = [
                    /^(?:https?:\/\/)?([a-z0-9.\-_]+)\.s3(?:-[a-z0-9\-]+)?\.amazonaws\.com/i,
                    /^(?:https?:\/\/)?s3(?:-[a-z0-9\-]+)?\.amazonaws\.com\/([a-z0-9.\-_]+)/i,
                    /^(?:https?:\/\/)?([a-z0-9.\-_]+)/i
                ], bucket1;
                qq.each(patterns1, function(idx1, pattern1) {
                    var match1 = pattern1.exec(endpoint1);
                    if (match1) {
                        bucket1 = match1[1];
                        return false;
                    }
                });
                return bucket1;
            },
            _getPrefixedParamName: function(name1) {
                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name1) >= 0) return name1;
                return qq.s3.util.AWS_PARAM_PREFIX + name1;
            },
            getPolicy: function(spec1) {
                var policy1 = {}, conditions1 = [], bucket1 = spec1.bucket, date1 = spec1.date, drift1 = spec1.clockDrift, key1 = spec1.key, accessKey1 = spec1.accessKey, acl1 = spec1.acl, type1 = spec1.type, expectedStatus1 = spec1.expectedStatus, sessionToken1 = spec1.sessionToken, params1 = spec1.params, successRedirectUrl1 = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec1.successRedirectUrl), minFileSize1 = spec1.minFileSize, maxFileSize1 = spec1.maxFileSize, reducedRedundancy1 = spec1.reducedRedundancy, region1 = spec1.region, serverSideEncryption1 = spec1.serverSideEncryption, signatureVersion1 = spec1.signatureVersion;
                policy1.expiration = qq.s3.util.getPolicyExpirationDate(date1, drift1);
                conditions1.push({
                    acl: acl1
                });
                conditions1.push({
                    bucket: bucket1
                });
                if (type1) conditions1.push({
                    "Content-Type": type1
                });
                if (expectedStatus1) conditions1.push({
                    success_action_status: expectedStatus1.toString()
                });
                if (successRedirectUrl1) conditions1.push({
                    success_action_redirect: successRedirectUrl1
                });
                if (reducedRedundancy1) {
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
                }
                if (sessionToken1) {
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken1;
                }
                if (serverSideEncryption1) {
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
                }
                if (signatureVersion1 === 2) conditions1.push({
                    key: key1
                });
                else if (signatureVersion1 === 4) {
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
                    conditions1.push({});
                    conditions1[conditions1.length - 1].key = key1;
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
                        date: date1,
                        key: accessKey1,
                        region: region1
                    });
                    conditions1.push({});
                    conditions1[conditions1.length - 1][qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(date1, drift1);
                }
                qq.each(params1, function(name1, val1) {
                    var awsParamName1 = qq.s3.util._getPrefixedParamName(name1), param1 = {};
                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName1) >= 0) param1[awsParamName1] = val1;
                    else param1[awsParamName1] = encodeURIComponent(val1);
                    conditions1.push(param1);
                });
                policy1.conditions = conditions1;
                qq.s3.util.enforceSizeLimits(policy1, minFileSize1, maxFileSize1);
                return policy1;
            },
            refreshPolicyCredentials: function(policy1, newSessionToken1) {
                var sessionTokenFound1 = false;
                qq.each(policy1.conditions, function(oldCondIdx1, oldCondObj1) {
                    qq.each(oldCondObj1, function(oldCondName1, oldCondVal1) {
                        if (oldCondName1 === qq.s3.util.SESSION_TOKEN_PARAM_NAME) {
                            oldCondObj1[oldCondName1] = newSessionToken1;
                            sessionTokenFound1 = true;
                        }
                    });
                });
                if (!sessionTokenFound1) {
                    policy1.conditions.push({});
                    policy1.conditions[policy1.conditions.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = newSessionToken1;
                }
            },
            generateAwsParams: function(spec1, signPolicyCallback1) {
                var awsParams1 = {}, customParams1 = spec1.params, promise1 = new qq.Promise(), sessionToken1 = spec1.sessionToken, drift1 = spec1.clockDrift, type1 = spec1.type, key1 = spec1.key, accessKey1 = spec1.accessKey, acl1 = spec1.acl, expectedStatus1 = spec1.expectedStatus, successRedirectUrl1 = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec1.successRedirectUrl), reducedRedundancy1 = spec1.reducedRedundancy, region1 = spec1.region, serverSideEncryption1 = spec1.serverSideEncryption, signatureVersion1 = spec1.signatureVersion, now1 = new Date(), log1 = spec1.log, policyJson1;
                spec1.date = now1;
                policyJson1 = qq.s3.util.getPolicy(spec1);
                awsParams1.key = key1;
                if (type1) awsParams1["Content-Type"] = type1;
                if (expectedStatus1) awsParams1.success_action_status = expectedStatus1;
                if (successRedirectUrl1) awsParams1.success_action_redirect = successRedirectUrl1;
                if (reducedRedundancy1) awsParams1[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
                if (serverSideEncryption1) awsParams1[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
                if (sessionToken1) awsParams1[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken1;
                awsParams1.acl = acl1;
                qq.each(customParams1, function(name1, val1) {
                    var awsParamName1 = qq.s3.util._getPrefixedParamName(name1);
                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName1) >= 0) awsParams1[awsParamName1] = val1;
                    else awsParams1[awsParamName1] = encodeURIComponent(val1);
                });
                if (signatureVersion1 === 2) awsParams1.AWSAccessKeyId = accessKey1;
                else if (signatureVersion1 === 4) {
                    awsParams1[qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
                    awsParams1[qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
                        date: now1,
                        key: accessKey1,
                        region: region1
                    });
                    awsParams1[qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(now1, drift1);
                }
                signPolicyCallback1(policyJson1).then(function(policyAndSignature1, updatedAccessKey1, updatedSessionToken1) {
                    awsParams1.policy = policyAndSignature1.policy;
                    if (spec1.signatureVersion === 2) {
                        awsParams1.signature = policyAndSignature1.signature;
                        if (updatedAccessKey1) awsParams1.AWSAccessKeyId = updatedAccessKey1;
                    } else if (spec1.signatureVersion === 4) awsParams1[qq.s3.util.V4_SIGNATURE_PARAM_NAME] = policyAndSignature1.signature;
                    if (updatedSessionToken1) awsParams1[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken1;
                    promise1.success(awsParams1);
                }, function(errorMessage1) {
                    errorMessage1 = errorMessage1 || "Can't continue further with request to S3 as we did not receive a valid signature and policy from the server.";
                    log1("Policy signing failed.  " + errorMessage1, "error");
                    promise1.failure(errorMessage1);
                });
                return promise1;
            },
            enforceSizeLimits: function(policy1, minSize1, maxSize1) {
                var adjustedMinSize1 = minSize1 < 0 ? 0 : minSize1, adjustedMaxSize1 = maxSize1 <= 0 ? 9007199254740992 : maxSize1;
                if (minSize1 > 0 || maxSize1 > 0) policy1.conditions.push([
                    "content-length-range",
                    adjustedMinSize1.toString(),
                    adjustedMaxSize1.toString()
                ]);
            },
            getPolicyExpirationDate: function(date1, drift1) {
                var adjustedDate1 = new Date(date1.getTime() + drift1);
                return qq.s3.util.getPolicyDate(adjustedDate1, 5);
            },
            getCredentialsDate: function(date1) {
                return date1.getUTCFullYear() + "" + ("0" + (date1.getUTCMonth() + 1)).slice(-2) + ("0" + date1.getUTCDate()).slice(-2);
            },
            getPolicyDate: function(date1, _minutesToAdd_1) {
                var minutesToAdd1 = _minutesToAdd_1 || 0, pad1, r1;
                date1.setMinutes(date1.getMinutes() + (minutesToAdd1 || 0));
                if (Date.prototype.toISOString) return date1.toISOString();
                else {
                    pad1 = function(number1) {
                        r1 = String(number1);
                        if (r1.length === 1) r1 = "0" + r1;
                        return r1;
                    };
                    return date1.getUTCFullYear() + "-" + pad1(date1.getUTCMonth() + 1) + "-" + pad1(date1.getUTCDate()) + "T" + pad1(date1.getUTCHours()) + ":" + pad1(date1.getUTCMinutes()) + ":" + pad1(date1.getUTCSeconds()) + "." + String((date1.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
                }
            },
            parseIframeResponse: function(iframe1) {
                var doc1 = iframe1.contentDocument || iframe1.contentWindow.document, queryString1 = doc1.location.search, match1 = /bucket=(.+)&key=(.+)&etag=(.+)/.exec(queryString1);
                if (match1) return {
                    bucket: match1[1],
                    key: match1[2],
                    etag: match1[3].replace(/%22/g, "")
                };
            },
            getSuccessRedirectAbsoluteUrl: function(successRedirectUrl1) {
                if (successRedirectUrl1) {
                    var targetAnchorContainer1 = document.createElement("div"), targetAnchor1;
                    if (qq.ie7()) {
                        targetAnchorContainer1.innerHTML = "<a href='" + successRedirectUrl1 + "'></a>";
                        targetAnchor1 = targetAnchorContainer1.firstChild;
                        return targetAnchor1.href;
                    } else {
                        targetAnchor1 = document.createElement("a");
                        targetAnchor1.href = successRedirectUrl1;
                        targetAnchor1.href = targetAnchor1.href;
                        return targetAnchor1.href;
                    }
                }
            },
            getV4CredentialsString: function(spec1) {
                return spec1.key + "/" + qq.s3.util.getCredentialsDate(spec1.date) + "/" + spec1.region + "/s3/aws4_request";
            },
            getV4PolicyDate: function(date1, drift1) {
                var adjustedDate1 = new Date(date1.getTime() + drift1);
                return qq.s3.util.getCredentialsDate(adjustedDate1) + "T" + ("0" + adjustedDate1.getUTCHours()).slice(-2) + ("0" + adjustedDate1.getUTCMinutes()).slice(-2) + ("0" + adjustedDate1.getUTCSeconds()).slice(-2) + "Z";
            },
            encodeQueryStringParam: function(param1) {
                var percentEncoded1 = encodeURIComponent(param1);
                percentEncoded1 = percentEncoded1.replace(/[!'()]/g, escape);
                percentEncoded1 = percentEncoded1.replace(/\*/g, "%2A");
                return percentEncoded1.replace(/%20/g, "+");
            },
            uriEscape: function(string1) {
                var output1 = encodeURIComponent(string1);
                output1 = output1.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
                output1 = output1.replace(/[*]/g, function(ch1) {
                    return "%" + ch1.charCodeAt(0).toString(16).toUpperCase();
                });
                return output1;
            },
            uriEscapePath: function(path1) {
                var parts1 = [];
                qq.each(path1.split("/"), function(idx1, item1) {
                    parts1.push(qq.s3.util.uriEscape(item1));
                });
                return parts1.join("/");
            }
        };
    }();
    (function() {
        "use strict";
        qq.nonTraditionalBasePublicApi = {
            setUploadSuccessParams: function(params1, id1) {
                this._uploadSuccessParamsStore.set(params1, id1);
            },
            setUploadSuccessEndpoint: function(endpoint1, id1) {
                this._uploadSuccessEndpointStore.set(endpoint1, id1);
            }
        };
        qq.nonTraditionalBasePrivateApi = {
            _onComplete: function(id1, name1, result1, xhr1) {
                var success1 = result1.success ? true : false, self1 = this, onCompleteArgs1 = arguments, successEndpoint1 = this._uploadSuccessEndpointStore.get(id1), successCustomHeaders1 = this._options.uploadSuccess.customHeaders, successMethod1 = this._options.uploadSuccess.method, cors1 = this._options.cors, promise1 = new qq.Promise(), uploadSuccessParams1 = this._uploadSuccessParamsStore.get(id1), fileParams1 = this._paramsStore.get(id1), onSuccessFromServer1 = function(successRequestResult1) {
                    delete self1._failedSuccessRequestCallbacks[id1];
                    qq.extend(result1, successRequestResult1);
                    qq.FineUploaderBasic.prototype._onComplete.apply(self1, onCompleteArgs1);
                    promise1.success(successRequestResult1);
                }, onFailureFromServer1 = function(successRequestResult1) {
                    var callback1 = submitSuccessRequest1;
                    qq.extend(result1, successRequestResult1);
                    if (result1 && result1.reset) callback1 = null;
                    if (!callback1) delete self1._failedSuccessRequestCallbacks[id1];
                    else self1._failedSuccessRequestCallbacks[id1] = callback1;
                    if (!self1._onAutoRetry(id1, name1, result1, xhr1, callback1)) {
                        qq.FineUploaderBasic.prototype._onComplete.apply(self1, onCompleteArgs1);
                        promise1.failure(successRequestResult1);
                    }
                }, submitSuccessRequest1, successAjaxRequester1;
                if (success1 && successEndpoint1) {
                    successAjaxRequester1 = new qq.UploadSuccessAjaxRequester({
                        endpoint: successEndpoint1,
                        method: successMethod1,
                        customHeaders: successCustomHeaders1,
                        cors: cors1,
                        log: qq.bind(this.log, this)
                    });
                    qq.extend(uploadSuccessParams1, self1._getEndpointSpecificParams(id1, result1, xhr1), true);
                    fileParams1 && qq.extend(uploadSuccessParams1, fileParams1, true);
                    submitSuccessRequest1 = qq.bind(function() {
                        successAjaxRequester1.sendSuccessRequest(id1, uploadSuccessParams1).then(onSuccessFromServer1, onFailureFromServer1);
                    }, self1);
                    submitSuccessRequest1();
                    return promise1;
                }
                return qq.FineUploaderBasic.prototype._onComplete.apply(this, arguments);
            },
            _manualRetry: function(id1) {
                var successRequestCallback1 = this._failedSuccessRequestCallbacks[id1];
                return qq.FineUploaderBasic.prototype._manualRetry.call(this, id1, successRequestCallback1);
            }
        };
    })();
    (function() {
        "use strict";
        qq.s3.FineUploaderBasic = function(o1) {
            var options1 = {
                request: {
                    accessKey: null,
                    clockDrift: 0
                },
                objectProperties: {
                    acl: "private",
                    bucket: qq.bind(function(id1) {
                        return qq.s3.util.getBucket(this.getEndpoint(id1));
                    }, this),
                    host: qq.bind(function(id1) {
                        return /(?:http|https):\/\/(.+)(?:\/.+)?/.exec(this._endpointStore.get(id1))[1];
                    }, this),
                    key: "uuid",
                    reducedRedundancy: false,
                    region: "us-east-1",
                    serverSideEncryption: false
                },
                credentials: {
                    accessKey: null,
                    secretKey: null,
                    expiration: null,
                    sessionToken: null
                },
                signature: {
                    customHeaders: {},
                    endpoint: null,
                    version: 2
                },
                uploadSuccess: {
                    endpoint: null,
                    method: "POST",
                    params: {},
                    customHeaders: {}
                },
                iframeSupport: {
                    localBlankPagePath: null
                },
                chunking: {
                    partSize: 5242880
                },
                cors: {
                    allowXdr: true
                },
                callbacks: {
                    onCredentialsExpired: function() {}
                }
            };
            qq.extend(options1, o1, true);
            if (!this.setCredentials(options1.credentials, true)) this._currentCredentials.accessKey = options1.request.accessKey;
            this._aclStore = this._createStore(options1.objectProperties.acl);
            qq.FineUploaderBasic.call(this, options1);
            this._uploadSuccessParamsStore = this._createStore(this._options.uploadSuccess.params);
            this._uploadSuccessEndpointStore = this._createStore(this._options.uploadSuccess.endpoint);
            this._failedSuccessRequestCallbacks = {};
            this._cannedKeys = {};
            this._cannedBuckets = {};
            this._buckets = {};
            this._hosts = {};
        };
        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePublicApi);
        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePrivateApi);
        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePublicApi);
        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePrivateApi);
        qq.extend(qq.s3.FineUploaderBasic.prototype, {
            getBucket: function(id1) {
                if (this._cannedBuckets[id1] == null) return this._buckets[id1];
                return this._cannedBuckets[id1];
            },
            getKey: function(id1) {
                if (this._cannedKeys[id1] == null) return this._handler.getThirdPartyFileId(id1);
                return this._cannedKeys[id1];
            },
            reset: function() {
                qq.FineUploaderBasic.prototype.reset.call(this);
                this._failedSuccessRequestCallbacks = [];
                this._buckets = {};
                this._hosts = {};
            },
            setCredentials: function(credentials1, ignoreEmpty1) {
                if (credentials1 && credentials1.secretKey) {
                    if (!credentials1.accessKey) throw new qq.Error("Invalid credentials: no accessKey");
                    else if (!credentials1.expiration) throw new qq.Error("Invalid credentials: no expiration");
                    else {
                        this._currentCredentials = qq.extend({}, credentials1);
                        if (qq.isString(credentials1.expiration)) this._currentCredentials.expiration = new Date(credentials1.expiration);
                    }
                    return true;
                } else if (!ignoreEmpty1) throw new qq.Error("Invalid credentials parameter!");
                else this._currentCredentials = {};
            },
            setAcl: function(acl1, id1) {
                this._aclStore.set(acl1, id1);
            },
            _createUploadHandler: function() {
                var self1 = this, additionalOptions1 = {
                    aclStore: this._aclStore,
                    getBucket: qq.bind(this._determineBucket, this),
                    getHost: qq.bind(this._determineHost, this),
                    getKeyName: qq.bind(this._determineKeyName, this),
                    iframeSupport: this._options.iframeSupport,
                    objectProperties: this._options.objectProperties,
                    signature: this._options.signature,
                    clockDrift: this._options.request.clockDrift,
                    validation: {
                        minSizeLimit: this._options.validation.minSizeLimit,
                        maxSizeLimit: this._options.validation.sizeLimit
                    }
                };
                qq.override(this._endpointStore, function(super_1) {
                    return {
                        get: function(id1) {
                            var endpoint1 = super_1.get(id1);
                            if (endpoint1.indexOf("http") < 0) return "http://" + endpoint1;
                            return endpoint1;
                        }
                    };
                });
                qq.override(this._paramsStore, function(super_1) {
                    return {
                        get: function(id1) {
                            var oldParams1 = super_1.get(id1), modifiedParams1 = {};
                            qq.each(oldParams1, function(name1, val1) {
                                var paramName1 = name1;
                                if (qq.indexOf(qq.s3.util.CASE_SENSITIVE_PARAM_NAMES, paramName1) < 0) paramName1 = paramName1.toLowerCase();
                                modifiedParams1[paramName1] = qq.isFunction(val1) ? val1() : val1;
                            });
                            return modifiedParams1;
                        }
                    };
                });
                additionalOptions1.signature.credentialsProvider = {
                    get: function() {
                        return self1._currentCredentials;
                    },
                    onExpired: function() {
                        var updateCredentials1 = new qq.Promise(), callbackRetVal1 = self1._options.callbacks.onCredentialsExpired();
                        if (qq.isGenericPromise(callbackRetVal1)) callbackRetVal1.then(function(credentials1) {
                            try {
                                self1.setCredentials(credentials1);
                                updateCredentials1.success();
                            } catch (error1) {
                                self1.log("Invalid credentials returned from onCredentialsExpired callback! (" + error1.message + ")", "error");
                                updateCredentials1.failure("onCredentialsExpired did not return valid credentials.");
                            }
                        }, function(errorMsg1) {
                            self1.log("onCredentialsExpired callback indicated failure! (" + errorMsg1 + ")", "error");
                            updateCredentials1.failure("onCredentialsExpired callback failed.");
                        });
                        else {
                            self1.log("onCredentialsExpired callback did not return a promise!", "error");
                            updateCredentials1.failure("Unexpected return value for onCredentialsExpired.");
                        }
                        return updateCredentials1;
                    }
                };
                return qq.FineUploaderBasic.prototype._createUploadHandler.call(this, additionalOptions1, "s3");
            },
            _determineObjectPropertyValue: function(id1, property1) {
                var maybe1 = this._options.objectProperties[property1], promise1 = new qq.Promise(), self1 = this;
                if (qq.isFunction(maybe1)) {
                    maybe1 = maybe1(id1);
                    if (qq.isGenericPromise(maybe1)) promise1 = maybe1;
                    else promise1.success(maybe1);
                } else if (qq.isString(maybe1)) promise1.success(maybe1);
                promise1.then(function success1(value1) {
                    self1["_" + property1 + "s"][id1] = value1;
                }, function failure1(errorMsg1) {
                    qq.log("Problem determining " + property1 + " for ID " + id1 + " (" + errorMsg1 + ")", "error");
                });
                return promise1;
            },
            _determineBucket: function(id1) {
                return this._determineObjectPropertyValue(id1, "bucket");
            },
            _determineHost: function(id1) {
                return this._determineObjectPropertyValue(id1, "host");
            },
            _determineKeyName: function(id1, filename1) {
                var promise1 = new qq.Promise(), keynameLogic1 = this._options.objectProperties.key, extension1 = qq.getExtension(filename1), onGetKeynameFailure1 = promise1.failure, onGetKeynameSuccess1 = function(keyname1, extension1) {
                    var keynameToUse1 = keyname1;
                    if (extension1 !== undefined) keynameToUse1 += "." + extension1;
                    promise1.success(keynameToUse1);
                };
                switch(keynameLogic1){
                    case "uuid":
                        onGetKeynameSuccess1(this.getUuid(id1), extension1);
                        break;
                    case "filename":
                        onGetKeynameSuccess1(filename1);
                        break;
                    default:
                        if (qq.isFunction(keynameLogic1)) this._handleKeynameFunction(keynameLogic1, id1, onGetKeynameSuccess1, onGetKeynameFailure1);
                        else {
                            this.log(keynameLogic1 + " is not a valid value for the s3.keyname option!", "error");
                            onGetKeynameFailure1();
                        }
                }
                return promise1;
            },
            _handleKeynameFunction: function(keynameFunc1, id1, successCallback1, failureCallback1) {
                var self1 = this, onSuccess1 = function(keyname1) {
                    successCallback1(keyname1);
                }, onFailure1 = function(reason1) {
                    self1.log(qq.format("Failed to retrieve key name for {}.  Reason: {}", id1, reason1 || "null"), "error");
                    failureCallback1(reason1);
                }, keyname1 = keynameFunc1.call(this, id1);
                if (qq.isGenericPromise(keyname1)) keyname1.then(onSuccess1, onFailure1);
                else if (keyname1 == null) onFailure1();
                else onSuccess1(keyname1);
            },
            _getEndpointSpecificParams: function(id1, response1, maybeXhr1) {
                var params1 = {
                    key: this.getKey(id1),
                    uuid: this.getUuid(id1),
                    name: this.getName(id1),
                    bucket: this.getBucket(id1)
                };
                if (maybeXhr1 && maybeXhr1.getResponseHeader("ETag")) params1.etag = maybeXhr1.getResponseHeader("ETag");
                else if (response1.etag) params1.etag = response1.etag;
                return params1;
            },
            _onSubmitDelete: function(id1, onSuccessCallback1) {
                var additionalMandatedParams1 = {
                    key: this.getKey(id1),
                    bucket: this.getBucket(id1)
                };
                return qq.FineUploaderBasic.prototype._onSubmitDelete.call(this, id1, onSuccessCallback1, additionalMandatedParams1);
            },
            _addCannedFile: function(sessionData1) {
                var id1;
                if (sessionData1.s3Key == null) throw new qq.Error("Did not find s3Key property in server session response.  This is required!");
                else {
                    id1 = qq.FineUploaderBasic.prototype._addCannedFile.apply(this, arguments);
                    this._cannedKeys[id1] = sessionData1.s3Key;
                    this._cannedBuckets[id1] = sessionData1.s3Bucket;
                }
                return id1;
            }
        });
    })();
    if (!window.Uint8ClampedArray) window.Uint8ClampedArray = function() {};
    qq.s3.RequestSigner = function(o1) {
        "use strict";
        var requester1, thisSignatureRequester1 = this, pendingSignatures1 = {}, options1 = {
            expectingPolicy: false,
            method: "POST",
            signatureSpec: {
                drift: 0,
                credentialsProvider: {},
                endpoint: null,
                customHeaders: {},
                version: 2
            },
            maxConnections: 3,
            endpointStore: {},
            paramsStore: {},
            cors: {
                expected: false,
                sendCredentials: false
            },
            log: function(str1, level1) {}
        }, credentialsProvider1, generateHeaders1 = function(signatureConstructor1, signature1, promise1) {
            var headers1 = signatureConstructor1.getHeaders();
            if (options1.signatureSpec.version === 4) headers1.Authorization = qq.s3.util.V4_ALGORITHM_PARAM_VALUE + " Credential=" + options1.signatureSpec.credentialsProvider.get().accessKey + "/" + qq.s3.util.getCredentialsDate(signatureConstructor1.getRequestDate()) + "/" + options1.signatureSpec.region + "/" + "s3/aws4_request," + "SignedHeaders=" + signatureConstructor1.getSignedHeaders() + "," + "Signature=" + signature1;
            else headers1.Authorization = "AWS " + options1.signatureSpec.credentialsProvider.get().accessKey + ":" + signature1;
            promise1.success(headers1, signatureConstructor1.getEndOfUrl());
        }, v21 = {
            getStringToSign: function(signatureSpec1) {
                return qq.format("{}\n{}\n{}\n\n{}/{}/{}", signatureSpec1.method, signatureSpec1.contentMd5 || "", signatureSpec1.contentType || "", signatureSpec1.headersStr || "\n", signatureSpec1.bucket, signatureSpec1.endOfUrl);
            },
            signApiRequest: function(signatureConstructor1, headersStr1, signatureEffort1) {
                var headersWordArray1 = qq.CryptoJS.enc.Utf8.parse(headersStr1), headersHmacSha11 = qq.CryptoJS.HmacSHA1(headersWordArray1, credentialsProvider1.get().secretKey), headersHmacSha1Base641 = qq.CryptoJS.enc.Base64.stringify(headersHmacSha11);
                generateHeaders1(signatureConstructor1, headersHmacSha1Base641, signatureEffort1);
            },
            signPolicy: function(policy1, signatureEffort1, updatedAccessKey1, updatedSessionToken1) {
                var policyStr1 = JSON.stringify(policy1), policyWordArray1 = qq.CryptoJS.enc.Utf8.parse(policyStr1), base64Policy1 = qq.CryptoJS.enc.Base64.stringify(policyWordArray1), policyHmacSha11 = qq.CryptoJS.HmacSHA1(base64Policy1, credentialsProvider1.get().secretKey), policyHmacSha1Base641 = qq.CryptoJS.enc.Base64.stringify(policyHmacSha11);
                signatureEffort1.success({
                    policy: base64Policy1,
                    signature: policyHmacSha1Base641
                }, updatedAccessKey1, updatedSessionToken1);
            }
        }, v41 = {
            getCanonicalQueryString: function(endOfUri1) {
                var queryParamIdx1 = endOfUri1.indexOf("?"), canonicalQueryString1 = "", encodedQueryParams1, encodedQueryParamNames1, queryStrings1;
                if (queryParamIdx1 >= 0) {
                    encodedQueryParams1 = {};
                    queryStrings1 = endOfUri1.substr(queryParamIdx1 + 1).split("&");
                    qq.each(queryStrings1, function(idx1, queryString1) {
                        var nameAndVal1 = queryString1.split("="), paramVal1 = nameAndVal1[1];
                        if (paramVal1 == null) paramVal1 = "";
                        encodedQueryParams1[encodeURIComponent(nameAndVal1[0])] = encodeURIComponent(paramVal1);
                    });
                    encodedQueryParamNames1 = Object.keys(encodedQueryParams1).sort();
                    encodedQueryParamNames1.forEach(function(encodedQueryParamName1, idx1) {
                        canonicalQueryString1 += encodedQueryParamName1 + "=" + encodedQueryParams1[encodedQueryParamName1];
                        if (idx1 < encodedQueryParamNames1.length - 1) canonicalQueryString1 += "&";
                    });
                }
                return canonicalQueryString1;
            },
            getCanonicalRequest: function(signatureSpec1) {
                return qq.format("{}\n{}\n{}\n{}\n{}\n{}", signatureSpec1.method, v41.getCanonicalUri(signatureSpec1.endOfUrl), v41.getCanonicalQueryString(signatureSpec1.endOfUrl), signatureSpec1.headersStr || "\n", v41.getSignedHeaders(signatureSpec1.headerNames), signatureSpec1.hashedContent);
            },
            getCanonicalUri: function(endOfUri1) {
                var path1 = endOfUri1, queryParamIdx1 = endOfUri1.indexOf("?");
                if (queryParamIdx1 > 0) path1 = endOfUri1.substr(0, queryParamIdx1);
                return "/" + path1;
            },
            getEncodedHashedPayload: function(body1) {
                var promise1 = new qq.Promise(), reader1;
                if (qq.isBlob(body1)) {
                    reader1 = new FileReader();
                    reader1.onloadend = function(e1) {
                        if (e1.target.readyState === FileReader.DONE) {
                            if (e1.target.error) promise1.failure(e1.target.error);
                            else {
                                var wordArray1 = qq.CryptoJS.lib.WordArray.create(e1.target.result);
                                promise1.success(qq.CryptoJS.SHA256(wordArray1).toString());
                            }
                        }
                    };
                    reader1.readAsArrayBuffer(body1);
                } else {
                    body1 = body1 || "";
                    promise1.success(qq.CryptoJS.SHA256(body1).toString());
                }
                return promise1;
            },
            getScope: function(date1, region1) {
                return qq.s3.util.getCredentialsDate(date1) + "/" + region1 + "/s3/aws4_request";
            },
            getStringToSign: function(signatureSpec1) {
                var canonicalRequest1 = v41.getCanonicalRequest(signatureSpec1), date1 = qq.s3.util.getV4PolicyDate(signatureSpec1.date, signatureSpec1.drift), hashedRequest1 = qq.CryptoJS.SHA256(canonicalRequest1).toString(), scope1 = v41.getScope(signatureSpec1.date, options1.signatureSpec.region), stringToSignTemplate1 = "AWS4-HMAC-SHA256\n{}\n{}\n{}";
                return {
                    hashed: qq.format(stringToSignTemplate1, date1, scope1, hashedRequest1),
                    raw: qq.format(stringToSignTemplate1, date1, scope1, canonicalRequest1)
                };
            },
            getSignedHeaders: function(headerNames1) {
                var signedHeaders1 = "";
                headerNames1.forEach(function(headerName1, idx1) {
                    signedHeaders1 += headerName1.toLowerCase();
                    if (idx1 < headerNames1.length - 1) signedHeaders1 += ";";
                });
                return signedHeaders1;
            },
            signApiRequest: function(signatureConstructor1, headersStr1, signatureEffort1) {
                var secretKey1 = credentialsProvider1.get().secretKey, headersPattern1 = /.+\n.+\n(\d+)\/(.+)\/s3\/.+\n(.+)/, matches1 = headersPattern1.exec(headersStr1), dateKey1, dateRegionKey1, dateRegionServiceKey1, signingKey1;
                dateKey1 = qq.CryptoJS.HmacSHA256(matches1[1], "AWS4" + secretKey1);
                dateRegionKey1 = qq.CryptoJS.HmacSHA256(matches1[2], dateKey1);
                dateRegionServiceKey1 = qq.CryptoJS.HmacSHA256("s3", dateRegionKey1);
                signingKey1 = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey1);
                generateHeaders1(signatureConstructor1, qq.CryptoJS.HmacSHA256(headersStr1, signingKey1), signatureEffort1);
            },
            signPolicy: function(policy1, signatureEffort1, updatedAccessKey1, updatedSessionToken1) {
                var policyStr1 = JSON.stringify(policy1), policyWordArray1 = qq.CryptoJS.enc.Utf8.parse(policyStr1), base64Policy1 = qq.CryptoJS.enc.Base64.stringify(policyWordArray1), secretKey1 = credentialsProvider1.get().secretKey, credentialPattern1 = /.+\/(.+)\/(.+)\/s3\/aws4_request/, credentialCondition1 = function() {
                    var credential1 = null;
                    qq.each(policy1.conditions, function(key1, condition1) {
                        var val1 = condition1["x-amz-credential"];
                        if (val1) {
                            credential1 = val1;
                            return false;
                        }
                    });
                    return credential1;
                }(), matches1, dateKey1, dateRegionKey1, dateRegionServiceKey1, signingKey1;
                matches1 = credentialPattern1.exec(credentialCondition1);
                dateKey1 = qq.CryptoJS.HmacSHA256(matches1[1], "AWS4" + secretKey1);
                dateRegionKey1 = qq.CryptoJS.HmacSHA256(matches1[2], dateKey1);
                dateRegionServiceKey1 = qq.CryptoJS.HmacSHA256("s3", dateRegionKey1);
                signingKey1 = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey1);
                signatureEffort1.success({
                    policy: base64Policy1,
                    signature: qq.CryptoJS.HmacSHA256(base64Policy1, signingKey1).toString()
                }, updatedAccessKey1, updatedSessionToken1);
            }
        };
        qq.extend(options1, o1, true);
        credentialsProvider1 = options1.signatureSpec.credentialsProvider;
        function handleSignatureReceived1(id1, xhrOrXdr1, isError1) {
            var responseJson1 = xhrOrXdr1.responseText, pendingSignatureData1 = pendingSignatures1[id1], promise1 = pendingSignatureData1.promise, signatureConstructor1 = pendingSignatureData1.signatureConstructor, errorMessage1, response1;
            delete pendingSignatures1[id1];
            if (responseJson1) try {
                response1 = qq.parseJson(responseJson1);
            } catch (error1) {
                options1.log("Error attempting to parse signature response: " + error1, "error");
            }
            if (response1 && response1.error) {
                isError1 = true;
                errorMessage1 = response1.error;
            } else if (response1 && response1.invalid) {
                isError1 = true;
                errorMessage1 = "Invalid policy document or request headers!";
            } else if (response1) {
                if (options1.expectingPolicy && !response1.policy) {
                    isError1 = true;
                    errorMessage1 = "Response does not include the base64 encoded policy!";
                } else if (!response1.signature) {
                    isError1 = true;
                    errorMessage1 = "Response does not include the signature!";
                }
            } else {
                isError1 = true;
                errorMessage1 = "Received an empty or invalid response from the server!";
            }
            if (isError1) {
                if (errorMessage1) options1.log(errorMessage1, "error");
                promise1.failure(errorMessage1);
            } else if (signatureConstructor1) generateHeaders1(signatureConstructor1, response1.signature, promise1);
            else promise1.success(response1);
        }
        function getStringToSignArtifacts1(id1, version1, requestInfo1) {
            var promise1 = new qq.Promise(), method1 = "POST", headerNames1 = [], headersStr1 = "", now1 = new Date(), endOfUrl1, signatureSpec1, toSign1, generateStringToSign1 = function(requestInfo1) {
                var contentMd51, headerIndexesToRemove1 = [];
                qq.each(requestInfo1.headers, function(name1) {
                    headerNames1.push(name1);
                });
                headerNames1.sort();
                qq.each(headerNames1, function(idx1, headerName1) {
                    if (qq.indexOf(qq.s3.util.UNSIGNABLE_REST_HEADER_NAMES, headerName1) < 0) headersStr1 += headerName1.toLowerCase() + ":" + requestInfo1.headers[headerName1].trim() + "\n";
                    else if (headerName1 === "Content-MD5") contentMd51 = requestInfo1.headers[headerName1];
                    else headerIndexesToRemove1.unshift(idx1);
                });
                qq.each(headerIndexesToRemove1, function(idx1, headerIdx1) {
                    headerNames1.splice(headerIdx1, 1);
                });
                signatureSpec1 = {
                    bucket: requestInfo1.bucket,
                    contentMd5: contentMd51,
                    contentType: requestInfo1.contentType,
                    date: now1,
                    drift: options1.signatureSpec.drift,
                    endOfUrl: endOfUrl1,
                    hashedContent: requestInfo1.hashedContent,
                    headerNames: headerNames1,
                    headersStr: headersStr1,
                    method: method1
                };
                toSign1 = version1 === 2 ? v21.getStringToSign(signatureSpec1) : v41.getStringToSign(signatureSpec1);
                return {
                    date: now1,
                    endOfUrl: endOfUrl1,
                    signedHeaders: version1 === 4 ? v41.getSignedHeaders(signatureSpec1.headerNames) : null,
                    toSign: version1 === 4 ? toSign1.hashed : toSign1,
                    toSignRaw: version1 === 4 ? toSign1.raw : toSign1
                };
            };
            switch(requestInfo1.type){
                case thisSignatureRequester1.REQUEST_TYPE.MULTIPART_ABORT:
                    method1 = "DELETE";
                    endOfUrl1 = qq.format("uploadId={}", requestInfo1.uploadId);
                    break;
                case thisSignatureRequester1.REQUEST_TYPE.MULTIPART_INITIATE:
                    endOfUrl1 = "uploads";
                    break;
                case thisSignatureRequester1.REQUEST_TYPE.MULTIPART_COMPLETE:
                    endOfUrl1 = qq.format("uploadId={}", requestInfo1.uploadId);
                    break;
                case thisSignatureRequester1.REQUEST_TYPE.MULTIPART_UPLOAD:
                    method1 = "PUT";
                    endOfUrl1 = qq.format("partNumber={}&uploadId={}", requestInfo1.partNum, requestInfo1.uploadId);
                    break;
            }
            endOfUrl1 = requestInfo1.key + "?" + endOfUrl1;
            if (version1 === 4) v41.getEncodedHashedPayload(requestInfo1.content).then(function(hashedContent1) {
                requestInfo1.headers["x-amz-content-sha256"] = hashedContent1;
                requestInfo1.headers.Host = requestInfo1.host;
                requestInfo1.headers["x-amz-date"] = qq.s3.util.getV4PolicyDate(now1, options1.signatureSpec.drift);
                requestInfo1.hashedContent = hashedContent1;
                promise1.success(generateStringToSign1(requestInfo1));
            }, function(err1) {
                promise1.failure(err1);
            });
            else promise1.success(generateStringToSign1(requestInfo1));
            return promise1;
        }
        function determineSignatureClientSide1(id1, toBeSigned1, signatureEffort1, updatedAccessKey1, updatedSessionToken1) {
            var updatedHeaders1;
            if (toBeSigned1.signatureConstructor) {
                if (updatedSessionToken1) {
                    updatedHeaders1 = toBeSigned1.signatureConstructor.getHeaders();
                    updatedHeaders1[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken1;
                    toBeSigned1.signatureConstructor.withHeaders(updatedHeaders1);
                }
                toBeSigned1.signatureConstructor.getToSign(id1).then(function(signatureArtifacts1) {
                    signApiRequest1(toBeSigned1.signatureConstructor, signatureArtifacts1.stringToSign, signatureEffort1);
                }, function(err1) {
                    signatureEffort1.failure(err1);
                });
            } else {
                updatedSessionToken1 && qq.s3.util.refreshPolicyCredentials(toBeSigned1, updatedSessionToken1);
                signPolicy1(toBeSigned1, signatureEffort1, updatedAccessKey1, updatedSessionToken1);
            }
        }
        function signPolicy1(policy1, signatureEffort1, updatedAccessKey1, updatedSessionToken1) {
            if (options1.signatureSpec.version === 4) v41.signPolicy(policy1, signatureEffort1, updatedAccessKey1, updatedSessionToken1);
            else v21.signPolicy(policy1, signatureEffort1, updatedAccessKey1, updatedSessionToken1);
        }
        function signApiRequest1(signatureConstructor1, headersStr1, signatureEffort1) {
            if (options1.signatureSpec.version === 4) v41.signApiRequest(signatureConstructor1, headersStr1, signatureEffort1);
            else v21.signApiRequest(signatureConstructor1, headersStr1, signatureEffort1);
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            acceptHeader: "application/json",
            method: options1.method,
            contentType: "application/json; charset=utf-8",
            endpointStore: {
                get: function() {
                    return options1.signatureSpec.endpoint;
                }
            },
            paramsStore: options1.paramsStore,
            maxConnections: options1.maxConnections,
            customHeaders: options1.signatureSpec.customHeaders,
            log: options1.log,
            onComplete: handleSignatureReceived1,
            cors: options1.cors
        }));
        qq.extend(this, {
            getSignature: function(id1, toBeSigned1) {
                var params1 = toBeSigned1, signatureConstructor1 = toBeSigned1.signatureConstructor, signatureEffort1 = new qq.Promise(), queryParams1;
                if (options1.signatureSpec.version === 4) queryParams1 = {
                    v4: true
                };
                if (credentialsProvider1.get().secretKey && qq.CryptoJS) {
                    if (credentialsProvider1.get().expiration.getTime() > Date.now()) determineSignatureClientSide1(id1, toBeSigned1, signatureEffort1);
                    else credentialsProvider1.onExpired().then(function() {
                        determineSignatureClientSide1(id1, toBeSigned1, signatureEffort1, credentialsProvider1.get().accessKey, credentialsProvider1.get().sessionToken);
                    }, function(errorMsg1) {
                        options1.log("Attempt to update expired credentials apparently failed! Unable to sign request.  ", "error");
                        signatureEffort1.failure("Unable to sign request - expired credentials.");
                    });
                } else {
                    options1.log("Submitting S3 signature request for " + id1);
                    if (signatureConstructor1) signatureConstructor1.getToSign(id1).then(function(signatureArtifacts1) {
                        params1 = {
                            headers: signatureArtifacts1.stringToSignRaw
                        };
                        requester1.initTransport(id1).withParams(params1).withQueryParams(queryParams1).send();
                    }, function(err1) {
                        options1.log("Failed to construct signature. ", "error");
                        signatureEffort1.failure("Failed to construct signature.");
                    });
                    else requester1.initTransport(id1).withParams(params1).withQueryParams(queryParams1).send();
                    pendingSignatures1[id1] = {
                        promise: signatureEffort1,
                        signatureConstructor: signatureConstructor1
                    };
                }
                return signatureEffort1;
            },
            constructStringToSign: function(type1, bucket1, host1, key1) {
                var headers1 = {}, uploadId1, content1, contentType1, partNum1, artifacts1;
                return {
                    withHeaders: function(theHeaders1) {
                        headers1 = theHeaders1;
                        return this;
                    },
                    withUploadId: function(theUploadId1) {
                        uploadId1 = theUploadId1;
                        return this;
                    },
                    withContent: function(theContent1) {
                        content1 = theContent1;
                        return this;
                    },
                    withContentType: function(theContentType1) {
                        contentType1 = theContentType1;
                        return this;
                    },
                    withPartNum: function(thePartNum1) {
                        partNum1 = thePartNum1;
                        return this;
                    },
                    getToSign: function(id1) {
                        var sessionToken1 = credentialsProvider1.get().sessionToken, promise1 = new qq.Promise(), adjustedDate1 = new Date(Date.now() + options1.signatureSpec.drift);
                        headers1["x-amz-date"] = adjustedDate1.toUTCString();
                        if (sessionToken1) headers1[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken1;
                        getStringToSignArtifacts1(id1, options1.signatureSpec.version, {
                            bucket: bucket1,
                            content: content1,
                            contentType: contentType1,
                            headers: headers1,
                            host: host1,
                            key: key1,
                            partNum: partNum1,
                            type: type1,
                            uploadId: uploadId1
                        }).then(function(_artifacts_1) {
                            artifacts1 = _artifacts_1;
                            promise1.success({
                                headers: function() {
                                    if (contentType1) headers1["Content-Type"] = contentType1;
                                    delete headers1.Host;
                                    return headers1;
                                }(),
                                date: artifacts1.date,
                                endOfUrl: artifacts1.endOfUrl,
                                signedHeaders: artifacts1.signedHeaders,
                                stringToSign: artifacts1.toSign,
                                stringToSignRaw: artifacts1.toSignRaw
                            });
                        }, function(err1) {
                            promise1.failure(err1);
                        });
                        return promise1;
                    },
                    getHeaders: function() {
                        return qq.extend({}, headers1);
                    },
                    getEndOfUrl: function() {
                        return artifacts1 && artifacts1.endOfUrl;
                    },
                    getRequestDate: function() {
                        return artifacts1 && artifacts1.date;
                    },
                    getSignedHeaders: function() {
                        return artifacts1 && artifacts1.signedHeaders;
                    }
                };
            }
        });
    };
    qq.s3.RequestSigner.prototype.REQUEST_TYPE = {
        MULTIPART_INITIATE: "multipart_initiate",
        MULTIPART_COMPLETE: "multipart_complete",
        MULTIPART_ABORT: "multipart_abort",
        MULTIPART_UPLOAD: "multipart_upload"
    };
    qq.UploadSuccessAjaxRequester = function(o1) {
        "use strict";
        var requester1, pendingRequests1 = [], options1 = {
            method: "POST",
            endpoint: null,
            maxConnections: 3,
            customHeaders: {},
            paramsStore: {},
            cors: {
                expected: false,
                sendCredentials: false
            },
            log: function(str1, level1) {}
        };
        qq.extend(options1, o1);
        function handleSuccessResponse1(id1, xhrOrXdr1, isError1) {
            var promise1 = pendingRequests1[id1], responseJson1 = xhrOrXdr1.responseText, successIndicator1 = {
                success: true
            }, failureIndicator1 = {
                success: false
            }, parsedResponse1;
            delete pendingRequests1[id1];
            options1.log(qq.format("Received the following response body to an upload success request for id {}: {}", id1, responseJson1));
            try {
                parsedResponse1 = qq.parseJson(responseJson1);
                if (isError1 || parsedResponse1 && (parsedResponse1.error || parsedResponse1.success === false)) {
                    options1.log("Upload success request was rejected by the server.", "error");
                    promise1.failure(qq.extend(parsedResponse1, failureIndicator1));
                } else {
                    options1.log("Upload success was acknowledged by the server.");
                    promise1.success(qq.extend(parsedResponse1, successIndicator1));
                }
            } catch (error1) {
                if (isError1) {
                    options1.log(qq.format("Your server indicated failure in its upload success request response for id {}!", id1), "error");
                    promise1.failure(failureIndicator1);
                } else {
                    options1.log("Upload success was acknowledged by the server.");
                    promise1.success(successIndicator1);
                }
            }
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            acceptHeader: "application/json",
            method: options1.method,
            endpointStore: {
                get: function() {
                    return options1.endpoint;
                }
            },
            paramsStore: options1.paramsStore,
            maxConnections: options1.maxConnections,
            customHeaders: options1.customHeaders,
            log: options1.log,
            onComplete: handleSuccessResponse1,
            cors: options1.cors
        }));
        qq.extend(this, {
            sendSuccessRequest: function(id1, spec1) {
                var promise1 = new qq.Promise();
                options1.log("Submitting upload success request/notification for " + id1);
                requester1.initTransport(id1).withParams(spec1).send();
                pendingRequests1[id1] = promise1;
                return promise1;
            }
        });
    };
    qq.s3.InitiateMultipartAjaxRequester = function(o1) {
        "use strict";
        var requester1, pendingInitiateRequests1 = {}, options1 = {
            filenameParam: "qqfilename",
            method: "POST",
            endpointStore: null,
            paramsStore: null,
            signatureSpec: null,
            aclStore: null,
            reducedRedundancy: false,
            serverSideEncryption: false,
            maxConnections: 3,
            getContentType: function(id1) {},
            getBucket: function(id1) {},
            getHost: function(id1) {},
            getKey: function(id1) {},
            getName: function(id1) {},
            log: function(str1, level1) {}
        }, getSignatureAjaxRequester1;
        qq.extend(options1, o1);
        getSignatureAjaxRequester1 = new qq.s3.RequestSigner({
            endpointStore: options1.endpointStore,
            signatureSpec: options1.signatureSpec,
            cors: options1.cors,
            log: options1.log
        });
        function getHeaders1(id1) {
            var bucket1 = options1.getBucket(id1), host1 = options1.getHost(id1), headers1 = {}, promise1 = new qq.Promise(), key1 = options1.getKey(id1), signatureConstructor1;
            headers1["x-amz-acl"] = options1.aclStore.get(id1);
            if (options1.reducedRedundancy) headers1[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
            if (options1.serverSideEncryption) headers1[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
            headers1[qq.s3.util.AWS_PARAM_PREFIX + options1.filenameParam] = encodeURIComponent(options1.getName(id1));
            qq.each(options1.paramsStore.get(id1), function(name1, val1) {
                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name1) >= 0) headers1[name1] = val1;
                else headers1[qq.s3.util.AWS_PARAM_PREFIX + name1] = encodeURIComponent(val1);
            });
            signatureConstructor1 = getSignatureAjaxRequester1.constructStringToSign(getSignatureAjaxRequester1.REQUEST_TYPE.MULTIPART_INITIATE, bucket1, host1, key1).withContentType(options1.getContentType(id1)).withHeaders(headers1);
            getSignatureAjaxRequester1.getSignature(id1, {
                signatureConstructor: signatureConstructor1
            }).then(promise1.success, promise1.failure);
            return promise1;
        }
        function handleInitiateRequestComplete1(id1, xhr1, isError1) {
            var promise1 = pendingInitiateRequests1[id1], domParser1 = new DOMParser(), responseDoc1 = domParser1.parseFromString(xhr1.responseText, "application/xml"), uploadIdElements1, messageElements1, uploadId1, errorMessage1, status1;
            delete pendingInitiateRequests1[id1];
            if (isError1) {
                status1 = xhr1.status;
                messageElements1 = responseDoc1.getElementsByTagName("Message");
                if (messageElements1.length > 0) errorMessage1 = messageElements1[0].textContent;
            } else {
                uploadIdElements1 = responseDoc1.getElementsByTagName("UploadId");
                if (uploadIdElements1.length > 0) uploadId1 = uploadIdElements1[0].textContent;
                else errorMessage1 = "Upload ID missing from request";
            }
            if (uploadId1 === undefined) {
                if (errorMessage1) options1.log(qq.format("Specific problem detected initiating multipart upload request for {}: '{}'.", id1, errorMessage1), "error");
                else options1.log(qq.format("Unexplained error with initiate multipart upload request for {}.  Status code {}.", id1, status1), "error");
                promise1.failure("Problem initiating upload request.", xhr1);
            } else {
                options1.log(qq.format("Initiate multipart upload request successful for {}.  Upload ID is {}", id1, uploadId1));
                promise1.success(uploadId1, xhr1);
            }
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            method: options1.method,
            contentType: null,
            endpointStore: options1.endpointStore,
            maxConnections: options1.maxConnections,
            allowXRequestedWithAndCacheControl: false,
            log: options1.log,
            onComplete: handleInitiateRequestComplete1,
            successfulResponseCodes: {
                POST: [
                    200
                ]
            }
        }));
        qq.extend(this, {
            send: function(id1) {
                var promise1 = new qq.Promise();
                getHeaders1(id1).then(function(headers1, endOfUrl1) {
                    options1.log("Submitting S3 initiate multipart upload request for " + id1);
                    pendingInitiateRequests1[id1] = promise1;
                    requester1.initTransport(id1).withPath(endOfUrl1).withHeaders(headers1).send();
                }, promise1.failure);
                return promise1;
            }
        });
    };
    qq.s3.CompleteMultipartAjaxRequester = function(o1) {
        "use strict";
        var requester1, pendingCompleteRequests1 = {}, options1 = {
            method: "POST",
            contentType: "text/xml",
            endpointStore: null,
            signatureSpec: null,
            maxConnections: 3,
            getBucket: function(id1) {},
            getHost: function(id1) {},
            getKey: function(id1) {},
            log: function(str1, level1) {}
        }, getSignatureAjaxRequester1;
        qq.extend(options1, o1);
        getSignatureAjaxRequester1 = new qq.s3.RequestSigner({
            endpointStore: options1.endpointStore,
            signatureSpec: options1.signatureSpec,
            cors: options1.cors,
            log: options1.log
        });
        function getHeaders1(id1, uploadId1, body1) {
            var headers1 = {}, promise1 = new qq.Promise(), bucket1 = options1.getBucket(id1), host1 = options1.getHost(id1), signatureConstructor1 = getSignatureAjaxRequester1.constructStringToSign(getSignatureAjaxRequester1.REQUEST_TYPE.MULTIPART_COMPLETE, bucket1, host1, options1.getKey(id1)).withUploadId(uploadId1).withContent(body1).withContentType("application/xml; charset=UTF-8");
            getSignatureAjaxRequester1.getSignature(id1, {
                signatureConstructor: signatureConstructor1
            }).then(promise1.success, promise1.failure);
            return promise1;
        }
        function handleCompleteRequestComplete1(id1, xhr1, isError1) {
            var promise1 = pendingCompleteRequests1[id1], domParser1 = new DOMParser(), bucket1 = options1.getBucket(id1), key1 = options1.getKey(id1), responseDoc1 = domParser1.parseFromString(xhr1.responseText, "application/xml"), bucketEls1 = responseDoc1.getElementsByTagName("Bucket"), keyEls1 = responseDoc1.getElementsByTagName("Key");
            delete pendingCompleteRequests1[id1];
            options1.log(qq.format("Complete response status {}, body = {}", xhr1.status, xhr1.responseText));
            if (isError1) options1.log(qq.format("Complete Multipart Upload request for {} failed with status {}.", id1, xhr1.status), "error");
            else {
                if (bucketEls1.length && keyEls1.length) {
                    if (bucketEls1[0].textContent !== bucket1) {
                        isError1 = true;
                        options1.log(qq.format("Wrong bucket in response to Complete Multipart Upload request for {}.", id1), "error");
                    }
                } else {
                    isError1 = true;
                    options1.log(qq.format("Missing bucket and/or key in response to Complete Multipart Upload request for {}.", id1), "error");
                }
            }
            if (isError1) promise1.failure("Problem combining the file parts!", xhr1);
            else promise1.success({}, xhr1);
        }
        function getCompleteRequestBody1(etagEntries1) {
            var doc1 = document.implementation.createDocument(null, "CompleteMultipartUpload", null);
            etagEntries1.sort(function(a1, b1) {
                return a1.part - b1.part;
            });
            qq.each(etagEntries1, function(idx1, etagEntry1) {
                var part1 = etagEntry1.part, etag1 = etagEntry1.etag, partEl1 = doc1.createElement("Part"), partNumEl1 = doc1.createElement("PartNumber"), partNumTextEl1 = doc1.createTextNode(part1), etagTextEl1 = doc1.createTextNode(etag1), etagEl1 = doc1.createElement("ETag");
                etagEl1.appendChild(etagTextEl1);
                partNumEl1.appendChild(partNumTextEl1);
                partEl1.appendChild(partNumEl1);
                partEl1.appendChild(etagEl1);
                qq(doc1).children()[0].appendChild(partEl1);
            });
            return new XMLSerializer().serializeToString(doc1);
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            method: options1.method,
            contentType: "application/xml; charset=UTF-8",
            endpointStore: options1.endpointStore,
            maxConnections: options1.maxConnections,
            allowXRequestedWithAndCacheControl: false,
            log: options1.log,
            onComplete: handleCompleteRequestComplete1,
            successfulResponseCodes: {
                POST: [
                    200
                ]
            }
        }));
        qq.extend(this, {
            send: function(id1, uploadId1, etagEntries1) {
                var promise1 = new qq.Promise(), body1 = getCompleteRequestBody1(etagEntries1);
                getHeaders1(id1, uploadId1, body1).then(function(headers1, endOfUrl1) {
                    options1.log("Submitting S3 complete multipart upload request for " + id1);
                    pendingCompleteRequests1[id1] = promise1;
                    delete headers1["Content-Type"];
                    requester1.initTransport(id1).withPath(endOfUrl1).withHeaders(headers1).withPayload(body1).send();
                }, promise1.failure);
                return promise1;
            }
        });
    };
    qq.s3.AbortMultipartAjaxRequester = function(o1) {
        "use strict";
        var requester1, options1 = {
            method: "DELETE",
            endpointStore: null,
            signatureSpec: null,
            maxConnections: 3,
            getBucket: function(id1) {},
            getHost: function(id1) {},
            getKey: function(id1) {},
            log: function(str1, level1) {}
        }, getSignatureAjaxRequester1;
        qq.extend(options1, o1);
        getSignatureAjaxRequester1 = new qq.s3.RequestSigner({
            endpointStore: options1.endpointStore,
            signatureSpec: options1.signatureSpec,
            cors: options1.cors,
            log: options1.log
        });
        function getHeaders1(id1, uploadId1) {
            var headers1 = {}, promise1 = new qq.Promise(), bucket1 = options1.getBucket(id1), host1 = options1.getHost(id1), signatureConstructor1 = getSignatureAjaxRequester1.constructStringToSign(getSignatureAjaxRequester1.REQUEST_TYPE.MULTIPART_ABORT, bucket1, host1, options1.getKey(id1)).withUploadId(uploadId1);
            getSignatureAjaxRequester1.getSignature(id1, {
                signatureConstructor: signatureConstructor1
            }).then(promise1.success, promise1.failure);
            return promise1;
        }
        function handleAbortRequestComplete1(id1, xhr1, isError1) {
            var domParser1 = new DOMParser(), responseDoc1 = domParser1.parseFromString(xhr1.responseText, "application/xml"), errorEls1 = responseDoc1.getElementsByTagName("Error"), awsErrorMsg1;
            options1.log(qq.format("Abort response status {}, body = {}", xhr1.status, xhr1.responseText));
            if (isError1) options1.log(qq.format("Abort Multipart Upload request for {} failed with status {}.", id1, xhr1.status), "error");
            else if (errorEls1.length) {
                isError1 = true;
                awsErrorMsg1 = responseDoc1.getElementsByTagName("Message")[0].textContent;
                options1.log(qq.format("Failed to Abort Multipart Upload request for {}.  Error: {}", id1, awsErrorMsg1), "error");
            } else options1.log(qq.format("Abort MPU request succeeded for file ID {}.", id1));
        }
        requester1 = qq.extend(this, new qq.AjaxRequester({
            validMethods: [
                "DELETE"
            ],
            method: options1.method,
            contentType: null,
            endpointStore: options1.endpointStore,
            maxConnections: options1.maxConnections,
            allowXRequestedWithAndCacheControl: false,
            log: options1.log,
            onComplete: handleAbortRequestComplete1,
            successfulResponseCodes: {
                DELETE: [
                    204
                ]
            }
        }));
        qq.extend(this, {
            send: function(id1, uploadId1) {
                getHeaders1(id1, uploadId1).then(function(headers1, endOfUrl1) {
                    options1.log("Submitting S3 Abort multipart upload request for " + id1);
                    requester1.initTransport(id1).withPath(endOfUrl1).withHeaders(headers1).send();
                });
            }
        });
    };
    qq.s3.XhrUploadHandler = function(spec1, proxy1) {
        "use strict";
        var getName1 = proxy1.getName, log1 = proxy1.log, clockDrift1 = spec1.clockDrift, expectedStatus1 = 200, onGetBucket1 = spec1.getBucket, onGetHost1 = spec1.getHost, onGetKeyName1 = spec1.getKeyName, filenameParam1 = spec1.filenameParam, paramsStore1 = spec1.paramsStore, endpointStore1 = spec1.endpointStore, aclStore1 = spec1.aclStore, reducedRedundancy1 = spec1.objectProperties.reducedRedundancy, region1 = spec1.objectProperties.region, serverSideEncryption1 = spec1.objectProperties.serverSideEncryption, validation1 = spec1.validation, signature1 = qq.extend({
            region: region1,
            drift: clockDrift1
        }, spec1.signature), handler1 = this, credentialsProvider1 = spec1.signature.credentialsProvider, chunked1 = {
            combine: function(id1) {
                var uploadId1 = handler1._getPersistableData(id1).uploadId, etagMap1 = handler1._getPersistableData(id1).etags, result1 = new qq.Promise();
                requesters1.completeMultipart.send(id1, uploadId1, etagMap1).then(result1.success, function failure1(reason1, xhr1) {
                    result1.failure(upload1.done(id1, xhr1).response, xhr1);
                });
                return result1;
            },
            done: function(id1, xhr1, chunkIdx1) {
                var response1 = upload1.response.parse(id1, xhr1), etag1;
                if (response1.success) {
                    etag1 = xhr1.getResponseHeader("ETag");
                    if (!handler1._getPersistableData(id1).etags) handler1._getPersistableData(id1).etags = [];
                    handler1._getPersistableData(id1).etags.push({
                        part: chunkIdx1 + 1,
                        etag: etag1
                    });
                }
            },
            initHeaders: function(id1, chunkIdx1, blob1) {
                var headers1 = {}, bucket1 = upload1.bucket.getName(id1), host1 = upload1.host.getName(id1), key1 = upload1.key.urlSafe(id1), promise1 = new qq.Promise(), signatureConstructor1 = requesters1.restSignature.constructStringToSign(requesters1.restSignature.REQUEST_TYPE.MULTIPART_UPLOAD, bucket1, host1, key1).withPartNum(chunkIdx1 + 1).withContent(blob1).withUploadId(handler1._getPersistableData(id1).uploadId);
                requesters1.restSignature.getSignature(id1 + "." + chunkIdx1, {
                    signatureConstructor: signatureConstructor1
                }).then(promise1.success, promise1.failure);
                return promise1;
            },
            put: function(id1, chunkIdx1) {
                var xhr1 = handler1._createXhr(id1, chunkIdx1), chunkData1 = handler1._getChunkData(id1, chunkIdx1), domain1 = spec1.endpointStore.get(id1), promise1 = new qq.Promise();
                chunked1.initHeaders(id1, chunkIdx1, chunkData1.blob).then(function(headers1, endOfUrl1) {
                    if (xhr1._cancelled) {
                        log1(qq.format("Upload of item {}.{} cancelled. Upload will not start after successful signature request.", id1, chunkIdx1));
                        promise1.failure({
                            error: "Chunk upload cancelled"
                        });
                    } else {
                        var url1 = domain1 + "/" + endOfUrl1;
                        handler1._registerProgressHandler(id1, chunkIdx1, chunkData1.size);
                        upload1.track(id1, xhr1, chunkIdx1).then(promise1.success, promise1.failure);
                        xhr1.open("PUT", url1, true);
                        var hasContentType1 = false;
                        qq.each(headers1, function(name1, val1) {
                            if (name1 === "Content-Type") hasContentType1 = true;
                            xhr1.setRequestHeader(name1, val1);
                        });
                        if (!hasContentType1) xhr1.setRequestHeader("Content-Type", "");
                        xhr1.send(chunkData1.blob);
                    }
                }, function() {
                    promise1.failure({
                        error: "Problem signing the chunk!"
                    }, xhr1);
                });
                return promise1;
            },
            send: function(id1, chunkIdx1) {
                var promise1 = new qq.Promise();
                chunked1.setup(id1).then(function() {
                    chunked1.put(id1, chunkIdx1).then(promise1.success, promise1.failure);
                }, function(errorMessage1, xhr1) {
                    promise1.failure({
                        error: errorMessage1
                    }, xhr1);
                });
                return promise1;
            },
            setup: function(id1) {
                var promise1 = new qq.Promise(), uploadId1 = handler1._getPersistableData(id1).uploadId, uploadIdPromise1 = new qq.Promise();
                if (!uploadId1) {
                    handler1._getPersistableData(id1).uploadId = uploadIdPromise1;
                    requesters1.initiateMultipart.send(id1).then(function(uploadId1) {
                        handler1._getPersistableData(id1).uploadId = uploadId1;
                        uploadIdPromise1.success(uploadId1);
                        promise1.success(uploadId1);
                    }, function(errorMsg1, xhr1) {
                        handler1._getPersistableData(id1).uploadId = null;
                        promise1.failure(errorMsg1, xhr1);
                        uploadIdPromise1.failure(errorMsg1, xhr1);
                    });
                } else if (uploadId1 instanceof qq.Promise) uploadId1.then(function(uploadId1) {
                    promise1.success(uploadId1);
                });
                else promise1.success(uploadId1);
                return promise1;
            }
        }, requesters1 = {
            abortMultipart: new qq.s3.AbortMultipartAjaxRequester({
                endpointStore: endpointStore1,
                signatureSpec: signature1,
                cors: spec1.cors,
                log: log1,
                getBucket: function(id1) {
                    return upload1.bucket.getName(id1);
                },
                getHost: function(id1) {
                    return upload1.host.getName(id1);
                },
                getKey: function(id1) {
                    return upload1.key.urlSafe(id1);
                }
            }),
            completeMultipart: new qq.s3.CompleteMultipartAjaxRequester({
                endpointStore: endpointStore1,
                signatureSpec: signature1,
                cors: spec1.cors,
                log: log1,
                getBucket: function(id1) {
                    return upload1.bucket.getName(id1);
                },
                getHost: function(id1) {
                    return upload1.host.getName(id1);
                },
                getKey: function(id1) {
                    return upload1.key.urlSafe(id1);
                }
            }),
            initiateMultipart: new qq.s3.InitiateMultipartAjaxRequester({
                filenameParam: filenameParam1,
                endpointStore: endpointStore1,
                paramsStore: paramsStore1,
                signatureSpec: signature1,
                aclStore: aclStore1,
                reducedRedundancy: reducedRedundancy1,
                serverSideEncryption: serverSideEncryption1,
                cors: spec1.cors,
                log: log1,
                getContentType: function(id1) {
                    return handler1._getMimeType(id1);
                },
                getBucket: function(id1) {
                    return upload1.bucket.getName(id1);
                },
                getHost: function(id1) {
                    return upload1.host.getName(id1);
                },
                getKey: function(id1) {
                    return upload1.key.urlSafe(id1);
                },
                getName: function(id1) {
                    return getName1(id1);
                }
            }),
            policySignature: new qq.s3.RequestSigner({
                expectingPolicy: true,
                signatureSpec: signature1,
                cors: spec1.cors,
                log: log1
            }),
            restSignature: new qq.s3.RequestSigner({
                endpointStore: endpointStore1,
                signatureSpec: signature1,
                cors: spec1.cors,
                log: log1
            })
        }, simple1 = {
            initParams: function(id1) {
                var customParams1 = paramsStore1.get(id1);
                customParams1[filenameParam1] = getName1(id1);
                return qq.s3.util.generateAwsParams({
                    endpoint: endpointStore1.get(id1),
                    clockDrift: clockDrift1,
                    params: customParams1,
                    type: handler1._getMimeType(id1),
                    bucket: upload1.bucket.getName(id1),
                    key: handler1.getThirdPartyFileId(id1),
                    accessKey: credentialsProvider1.get().accessKey,
                    sessionToken: credentialsProvider1.get().sessionToken,
                    acl: aclStore1.get(id1),
                    expectedStatus: expectedStatus1,
                    minFileSize: validation1.minSizeLimit,
                    maxFileSize: validation1.maxSizeLimit,
                    reducedRedundancy: reducedRedundancy1,
                    region: region1,
                    serverSideEncryption: serverSideEncryption1,
                    signatureVersion: signature1.version,
                    log: log1
                }, qq.bind(requesters1.policySignature.getSignature, this, id1));
            },
            send: function(id1) {
                var promise1 = new qq.Promise(), xhr1 = handler1._createXhr(id1), fileOrBlob1 = handler1.getFile(id1);
                handler1._registerProgressHandler(id1);
                upload1.track(id1, xhr1).then(promise1.success, promise1.failure);
                simple1.setup(id1, xhr1, fileOrBlob1).then(function(toSend1) {
                    log1("Sending upload request for " + id1);
                    xhr1.send(toSend1);
                }, promise1.failure);
                return promise1;
            },
            setup: function(id1, xhr1, fileOrBlob1) {
                var formData1 = new FormData(), endpoint1 = endpointStore1.get(id1), url1 = endpoint1, promise1 = new qq.Promise();
                simple1.initParams(id1).then(function(awsParams1) {
                    xhr1.open("POST", url1, true);
                    qq.obj2FormData(awsParams1, formData1);
                    formData1.append("file", fileOrBlob1);
                    promise1.success(formData1);
                }, function(errorMessage1) {
                    promise1.failure({
                        error: errorMessage1
                    });
                });
                return promise1;
            }
        }, upload1 = {
            bucket: {
                promise: function(id1) {
                    var promise1 = new qq.Promise(), cachedBucket1 = handler1._getFileState(id1).bucket;
                    if (cachedBucket1) promise1.success(cachedBucket1);
                    else onGetBucket1(id1).then(function(bucket1) {
                        handler1._getFileState(id1).bucket = bucket1;
                        promise1.success(bucket1);
                    }, promise1.failure);
                    return promise1;
                },
                getName: function(id1) {
                    return handler1._getFileState(id1).bucket;
                }
            },
            host: {
                promise: function(id1) {
                    var promise1 = new qq.Promise(), cachedHost1 = handler1._getFileState(id1).host;
                    if (cachedHost1) promise1.success(cachedHost1);
                    else onGetHost1(id1).then(function(host1) {
                        handler1._getFileState(id1).host = host1;
                        promise1.success(host1);
                    }, promise1.failure);
                    return promise1;
                },
                getName: function(id1) {
                    return handler1._getFileState(id1).host;
                }
            },
            done: function(id1, xhr1) {
                var response1 = upload1.response.parse(id1, xhr1), isError1 = response1.success !== true;
                if (isError1 && upload1.response.shouldReset(response1.code)) {
                    log1("This is an unrecoverable error, we must restart the upload entirely on the next retry attempt.", "error");
                    response1.reset = true;
                }
                return {
                    success: !isError1,
                    response: response1
                };
            },
            key: {
                promise: function(id1) {
                    var promise1 = new qq.Promise(), key1 = handler1.getThirdPartyFileId(id1);
                    if (key1 == null) {
                        handler1._setThirdPartyFileId(id1, promise1);
                        onGetKeyName1(id1, getName1(id1)).then(function(keyName1) {
                            handler1._setThirdPartyFileId(id1, keyName1);
                            promise1.success(keyName1);
                        }, function(errorReason1) {
                            handler1._setThirdPartyFileId(id1, null);
                            promise1.failure(errorReason1);
                        });
                    } else if (qq.isGenericPromise(key1)) key1.then(promise1.success, promise1.failure);
                    else promise1.success(key1);
                    return promise1;
                },
                urlSafe: function(id1) {
                    var encodedKey1 = handler1.getThirdPartyFileId(id1);
                    return qq.s3.util.uriEscapePath(encodedKey1);
                }
            },
            response: {
                parse: function(id1, xhr1) {
                    var response1 = {}, parsedErrorProps1;
                    try {
                        log1(qq.format("Received response status {} with body: {}", xhr1.status, xhr1.responseText));
                        if (xhr1.status === expectedStatus1) response1.success = true;
                        else {
                            parsedErrorProps1 = upload1.response.parseError(xhr1.responseText);
                            if (parsedErrorProps1) {
                                response1.error = parsedErrorProps1.message;
                                response1.code = parsedErrorProps1.code;
                            }
                        }
                    } catch (error1) {
                        log1("Error when attempting to parse xhr response text (" + error1.message + ")", "error");
                    }
                    return response1;
                },
                parseError: function(awsResponseXml1) {
                    var parser1 = new DOMParser(), parsedDoc1 = parser1.parseFromString(awsResponseXml1, "application/xml"), errorEls1 = parsedDoc1.getElementsByTagName("Error"), errorDetails1 = {}, codeEls1, messageEls1;
                    if (errorEls1.length) {
                        codeEls1 = parsedDoc1.getElementsByTagName("Code");
                        messageEls1 = parsedDoc1.getElementsByTagName("Message");
                        if (messageEls1.length) errorDetails1.message = messageEls1[0].textContent;
                        if (codeEls1.length) errorDetails1.code = codeEls1[0].textContent;
                        return errorDetails1;
                    }
                },
                shouldReset: function(errorCode1) {
                    return errorCode1 === "EntityTooSmall" || errorCode1 === "InvalidPart" || errorCode1 === "InvalidPartOrder" || errorCode1 === "NoSuchUpload";
                }
            },
            start: function(params1) {
                var id1 = params1.id;
                var optChunkIdx1 = params1.chunkIdx;
                var promise1 = new qq.Promise();
                upload1.key.promise(id1).then(function() {
                    upload1.bucket.promise(id1).then(function() {
                        upload1.host.promise(id1).then(function() {
                            if (optChunkIdx1 == null) simple1.send(id1).then(promise1.success, promise1.failure);
                            else chunked1.send(id1, optChunkIdx1).then(promise1.success, promise1.failure);
                        });
                    });
                }, function(errorReason1) {
                    promise1.failure({
                        error: errorReason1
                    });
                });
                return promise1;
            },
            track: function(id1, xhr1, optChunkIdx1) {
                var promise1 = new qq.Promise();
                xhr1.onreadystatechange = function() {
                    if (xhr1.readyState === 4) {
                        var result1;
                        if (optChunkIdx1 == null) {
                            result1 = upload1.done(id1, xhr1);
                            promise1[result1.success ? "success" : "failure"](result1.response, xhr1);
                        } else {
                            chunked1.done(id1, xhr1, optChunkIdx1);
                            result1 = upload1.done(id1, xhr1);
                            promise1[result1.success ? "success" : "failure"](result1.response, xhr1);
                        }
                    }
                };
                return promise1;
            }
        };
        qq.extend(this, {
            uploadChunk: upload1.start,
            uploadFile: function(id1) {
                return upload1.start({
                    id: id1
                });
            }
        });
        qq.extend(this, new qq.XhrUploadHandler({
            options: qq.extend({
                namespace: "s3"
            }, spec1),
            proxy: qq.extend({
                getEndpoint: spec1.endpointStore.get
            }, proxy1)
        }));
        qq.override(this, function(super_1) {
            return {
                expunge: function(id1) {
                    var uploadId1 = handler1._getPersistableData(id1) && handler1._getPersistableData(id1).uploadId, existedInLocalStorage1 = handler1._maybeDeletePersistedChunkData(id1);
                    if (uploadId1 !== undefined && existedInLocalStorage1) requesters1.abortMultipart.send(id1, uploadId1);
                    super_1.expunge(id1);
                },
                finalizeChunks: function(id1) {
                    return chunked1.combine(id1);
                },
                _getLocalStorageId: function(id1) {
                    var baseStorageId1 = super_1._getLocalStorageId(id1), bucketName1 = upload1.bucket.getName(id1);
                    return baseStorageId1 + "-" + bucketName1;
                }
            };
        });
    };
    qq.s3.FormUploadHandler = function(options1, proxy1) {
        "use strict";
        var handler1 = this, clockDrift1 = options1.clockDrift, onUuidChanged1 = proxy1.onUuidChanged, getName1 = proxy1.getName, getUuid1 = proxy1.getUuid, log1 = proxy1.log, onGetBucket1 = options1.getBucket, onGetKeyName1 = options1.getKeyName, filenameParam1 = options1.filenameParam, paramsStore1 = options1.paramsStore, endpointStore1 = options1.endpointStore, aclStore1 = options1.aclStore, reducedRedundancy1 = options1.objectProperties.reducedRedundancy, region1 = options1.objectProperties.region, serverSideEncryption1 = options1.objectProperties.serverSideEncryption, validation1 = options1.validation, signature1 = options1.signature, successRedirectUrl1 = options1.iframeSupport.localBlankPagePath, credentialsProvider1 = options1.signature.credentialsProvider, getSignatureAjaxRequester1 = new qq.s3.RequestSigner({
            signatureSpec: signature1,
            cors: options1.cors,
            log: log1
        });
        if (successRedirectUrl1 === undefined) throw new Error("successRedirectEndpoint MUST be defined if you intend to use browsers that do not support the File API!");
        function isValidResponse1(id1, iframe1) {
            var response1, endpoint1 = options1.endpointStore.get(id1), bucket1 = handler1._getFileState(id1).bucket, doc1, innerHtml1, responseData1;
            try {
                doc1 = iframe1.contentDocument || iframe1.contentWindow.document;
                innerHtml1 = doc1.body.innerHTML;
                responseData1 = qq.s3.util.parseIframeResponse(iframe1);
                if (responseData1.bucket === bucket1 && responseData1.key === qq.s3.util.encodeQueryStringParam(handler1.getThirdPartyFileId(id1))) return true;
                log1("Response from AWS included an unexpected bucket or key name.", "error");
            } catch (error1) {
                log1("Error when attempting to parse form upload response (" + error1.message + ")", "error");
            }
            return false;
        }
        function generateAwsParams1(id1) {
            var customParams1 = paramsStore1.get(id1);
            customParams1[filenameParam1] = getName1(id1);
            return qq.s3.util.generateAwsParams({
                endpoint: endpointStore1.get(id1),
                clockDrift: clockDrift1,
                params: customParams1,
                bucket: handler1._getFileState(id1).bucket,
                key: handler1.getThirdPartyFileId(id1),
                accessKey: credentialsProvider1.get().accessKey,
                sessionToken: credentialsProvider1.get().sessionToken,
                acl: aclStore1.get(id1),
                minFileSize: validation1.minSizeLimit,
                maxFileSize: validation1.maxSizeLimit,
                successRedirectUrl: successRedirectUrl1,
                reducedRedundancy: reducedRedundancy1,
                region: region1,
                serverSideEncryption: serverSideEncryption1,
                signatureVersion: signature1.version,
                log: log1
            }, qq.bind(getSignatureAjaxRequester1.getSignature, this, id1));
        }
        function createForm1(id1, iframe1) {
            var promise1 = new qq.Promise(), method1 = "POST", endpoint1 = options1.endpointStore.get(id1), fileName1 = getName1(id1);
            generateAwsParams1(id1).then(function(params1) {
                var form1 = handler1._initFormForUpload({
                    method: method1,
                    endpoint: endpoint1,
                    params: params1,
                    paramsInBody: true,
                    targetName: iframe1.name
                });
                promise1.success(form1);
            }, function(errorMessage1) {
                promise1.failure(errorMessage1);
                handleFinishedUpload1(id1, iframe1, fileName1, {
                    error: errorMessage1
                });
            });
            return promise1;
        }
        function handleUpload1(id1) {
            var iframe1 = handler1._createIframe(id1), input1 = handler1.getInput(id1), promise1 = new qq.Promise();
            createForm1(id1, iframe1).then(function(form1) {
                form1.appendChild(input1);
                handler1._attachLoadEvent(iframe1, function(response1) {
                    log1("iframe loaded");
                    if (response1) {
                        if (response1.success === false) {
                            log1("Amazon likely rejected the upload request", "error");
                            promise1.failure(response1);
                        }
                    } else {
                        response1 = {};
                        response1.success = isValidResponse1(id1, iframe1);
                        if (response1.success === false) {
                            log1("A success response was received by Amazon, but it was invalid in some way.", "error");
                            promise1.failure(response1);
                        } else {
                            qq.extend(response1, qq.s3.util.parseIframeResponse(iframe1));
                            promise1.success(response1);
                        }
                    }
                    handleFinishedUpload1(id1, iframe1);
                });
                log1("Sending upload request for " + id1);
                form1.submit();
                qq(form1).remove();
            }, promise1.failure);
            return promise1;
        }
        function handleFinishedUpload1(id1, iframe1) {
            handler1._detachLoadEvent(id1);
            iframe1 && qq(iframe1).remove();
        }
        qq.extend(this, new qq.FormUploadHandler({
            options: {
                isCors: false,
                inputName: "file"
            },
            proxy: {
                onCancel: options1.onCancel,
                onUuidChanged: onUuidChanged1,
                getName: getName1,
                getUuid: getUuid1,
                log: log1
            }
        }));
        qq.extend(this, {
            uploadFile: function(id1) {
                var name1 = getName1(id1), promise1 = new qq.Promise();
                if (handler1.getThirdPartyFileId(id1)) {
                    if (handler1._getFileState(id1).bucket) handleUpload1(id1).then(promise1.success, promise1.failure);
                    else onGetBucket1(id1).then(function(bucket1) {
                        handler1._getFileState(id1).bucket = bucket1;
                        handleUpload1(id1).then(promise1.success, promise1.failure);
                    });
                } else onGetKeyName1(id1, name1).then(function(key1) {
                    onGetBucket1(id1).then(function(bucket1) {
                        handler1._getFileState(id1).bucket = bucket1;
                        handler1._setThirdPartyFileId(id1, key1);
                        handleUpload1(id1).then(promise1.success, promise1.failure);
                    }, function(errorReason1) {
                        promise1.failure({
                            error: errorReason1
                        });
                    });
                }, function(errorReason1) {
                    promise1.failure({
                        error: errorReason1
                    });
                });
                return promise1;
            }
        });
    };
    qq.DragAndDrop = function(o1) {
        "use strict";
        var options1, HIDE_ZONES_EVENT_NAME1 = "qq-hidezones", HIDE_BEFORE_ENTER_ATTR1 = "qq-hide-dropzone", uploadDropZones1 = [], droppedFiles1 = [], disposeSupport1 = new qq.DisposeSupport();
        options1 = {
            dropZoneElements: [],
            allowMultipleItems: true,
            classes: {
                dropActive: null
            },
            callbacks: new qq.DragAndDrop.callbacks()
        };
        qq.extend(options1, o1, true);
        function uploadDroppedFiles1(files1, uploadDropZone1) {
            var filesAsArray1 = Array.prototype.slice.call(files1);
            options1.callbacks.dropLog("Grabbed " + files1.length + " dropped files.");
            uploadDropZone1.dropDisabled(false);
            options1.callbacks.processingDroppedFilesComplete(filesAsArray1, uploadDropZone1.getElement());
        }
        function traverseFileTree1(entry1) {
            var parseEntryPromise1 = new qq.Promise();
            if (entry1.isFile) entry1.file(function(file1) {
                file1.qqPath = extractDirectoryPath1(entry1);
                droppedFiles1.push(file1);
                parseEntryPromise1.success();
            }, function(fileError1) {
                options1.callbacks.dropLog("Problem parsing '" + entry1.fullPath + "'.  FileError code " + fileError1.code + ".", "error");
                parseEntryPromise1.failure();
            });
            else if (entry1.isDirectory) getFilesInDirectory1(entry1).then(function allEntriesRead1(entries1) {
                var entriesLeft1 = entries1.length;
                qq.each(entries1, function(idx1, entry1) {
                    traverseFileTree1(entry1).done(function() {
                        entriesLeft1 -= 1;
                        if (entriesLeft1 === 0) parseEntryPromise1.success();
                    });
                });
                if (!entries1.length) parseEntryPromise1.success();
            }, function readFailure1(fileError1) {
                options1.callbacks.dropLog("Problem parsing '" + entry1.fullPath + "'.  FileError code " + fileError1.code + ".", "error");
                parseEntryPromise1.failure();
            });
            return parseEntryPromise1;
        }
        function extractDirectoryPath1(entry1) {
            var name1 = entry1.name, fullPath1 = entry1.fullPath, indexOfNameInFullPath1 = fullPath1.lastIndexOf(name1);
            fullPath1 = fullPath1.substr(0, indexOfNameInFullPath1);
            if (fullPath1.charAt(0) === "/") fullPath1 = fullPath1.substr(1);
            return fullPath1;
        }
        function getFilesInDirectory1(entry1, reader1, accumEntries1, existingPromise1) {
            var promise1 = existingPromise1 || new qq.Promise(), dirReader1 = reader1 || entry1.createReader();
            dirReader1.readEntries(function readSuccess1(entries1) {
                var newEntries1 = accumEntries1 ? accumEntries1.concat(entries1) : entries1;
                if (entries1.length) setTimeout(function() {
                    getFilesInDirectory1(entry1, dirReader1, newEntries1, promise1);
                }, 0);
                else promise1.success(newEntries1);
            }, promise1.failure);
            return promise1;
        }
        function handleDataTransfer1(dataTransfer1, uploadDropZone1) {
            var pendingFolderPromises1 = [], handleDataTransferPromise1 = new qq.Promise();
            options1.callbacks.processingDroppedFiles();
            uploadDropZone1.dropDisabled(true);
            if (dataTransfer1.files.length > 1 && !options1.allowMultipleItems) {
                options1.callbacks.processingDroppedFilesComplete([]);
                options1.callbacks.dropError("tooManyFilesError", "");
                uploadDropZone1.dropDisabled(false);
                handleDataTransferPromise1.failure();
            } else {
                droppedFiles1 = [];
                if (qq.isFolderDropSupported(dataTransfer1)) qq.each(dataTransfer1.items, function(idx1, item1) {
                    var entry1 = item1.webkitGetAsEntry();
                    if (entry1) {
                        if (entry1.isFile) droppedFiles1.push(item1.getAsFile());
                        else pendingFolderPromises1.push(traverseFileTree1(entry1).done(function() {
                            pendingFolderPromises1.pop();
                            if (pendingFolderPromises1.length === 0) handleDataTransferPromise1.success();
                        }));
                    }
                });
                else droppedFiles1 = dataTransfer1.files;
                if (pendingFolderPromises1.length === 0) handleDataTransferPromise1.success();
            }
            return handleDataTransferPromise1;
        }
        function setupDropzone1(dropArea1) {
            var dropZone1 = new qq.UploadDropZone({
                HIDE_ZONES_EVENT_NAME: HIDE_ZONES_EVENT_NAME1,
                element: dropArea1,
                onEnter: function(e1) {
                    qq(dropArea1).addClass(options1.classes.dropActive);
                    e1.stopPropagation();
                },
                onLeaveNotDescendants: function(e1) {
                    qq(dropArea1).removeClass(options1.classes.dropActive);
                },
                onDrop: function(e1) {
                    handleDataTransfer1(e1.dataTransfer, dropZone1).then(function() {
                        uploadDroppedFiles1(droppedFiles1, dropZone1);
                    }, function() {
                        options1.callbacks.dropLog("Drop event DataTransfer parsing failed.  No files will be uploaded.", "error");
                    });
                }
            });
            disposeSupport1.addDisposer(function() {
                dropZone1.dispose();
            });
            qq(dropArea1).hasAttribute(HIDE_BEFORE_ENTER_ATTR1) && qq(dropArea1).hide();
            uploadDropZones1.push(dropZone1);
            return dropZone1;
        }
        function isFileDrag1(dragEvent1) {
            var fileDrag1;
            qq.each(dragEvent1.dataTransfer.types, function(key1, val1) {
                if (val1 === "Files") {
                    fileDrag1 = true;
                    return false;
                }
            });
            return fileDrag1;
        }
        function leavingDocumentOut1(e1) {
            if (qq.safari()) return e1.x < 0 || e1.y < 0;
            return e1.x === 0 && e1.y === 0;
        }
        function setupDragDrop1() {
            var dropZones1 = options1.dropZoneElements, maybeHideDropZones1 = function() {
                setTimeout(function() {
                    qq.each(dropZones1, function(idx1, dropZone1) {
                        qq(dropZone1).hasAttribute(HIDE_BEFORE_ENTER_ATTR1) && qq(dropZone1).hide();
                        qq(dropZone1).removeClass(options1.classes.dropActive);
                    });
                }, 10);
            };
            qq.each(dropZones1, function(idx1, dropZone1) {
                var uploadDropZone1 = setupDropzone1(dropZone1);
                if (dropZones1.length && qq.supportedFeatures.fileDrop) disposeSupport1.attach(document, "dragenter", function(e1) {
                    if (!uploadDropZone1.dropDisabled() && isFileDrag1(e1)) qq.each(dropZones1, function(idx1, dropZone1) {
                        if (dropZone1 instanceof HTMLElement && qq(dropZone1).hasAttribute(HIDE_BEFORE_ENTER_ATTR1)) qq(dropZone1).css({
                            display: "block"
                        });
                    });
                });
            });
            disposeSupport1.attach(document, "dragleave", function(e1) {
                if (leavingDocumentOut1(e1)) maybeHideDropZones1();
            });
            disposeSupport1.attach(qq(document).children()[0], "mouseenter", function(e1) {
                maybeHideDropZones1();
            });
            disposeSupport1.attach(document, "drop", function(e1) {
                if (isFileDrag1(e1)) {
                    e1.preventDefault();
                    maybeHideDropZones1();
                }
            });
            disposeSupport1.attach(document, HIDE_ZONES_EVENT_NAME1, maybeHideDropZones1);
        }
        setupDragDrop1();
        qq.extend(this, {
            setupExtraDropzone: function(element1) {
                options1.dropZoneElements.push(element1);
                setupDropzone1(element1);
            },
            removeDropzone: function(element1) {
                var i1, dzs1 = options1.dropZoneElements;
                for(i1 in dzs1){
                    if (dzs1[i1] === element1) return dzs1.splice(i1, 1);
                }
            },
            dispose: function() {
                disposeSupport1.dispose();
                qq.each(uploadDropZones1, function(idx1, dropZone1) {
                    dropZone1.dispose();
                });
            }
        });
        this._testing = {};
        this._testing.extractDirectoryPath = extractDirectoryPath1;
    };
    qq.DragAndDrop.callbacks = function() {
        "use strict";
        return {
            processingDroppedFiles: function() {},
            processingDroppedFilesComplete: function(files1, targetEl1) {},
            dropError: function(code1, errorSpecifics1) {
                qq.log("Drag & drop error code '" + code1 + " with these specifics: '" + errorSpecifics1 + "'", "error");
            },
            dropLog: function(message1, level1) {
                qq.log(message1, level1);
            }
        };
    };
    qq.UploadDropZone = function(o1) {
        "use strict";
        var disposeSupport1 = new qq.DisposeSupport(), options1, element1, preventDrop1, dropOutsideDisabled1;
        options1 = {
            element: null,
            onEnter: function(e1) {},
            onLeave: function(e1) {},
            onLeaveNotDescendants: function(e1) {},
            onDrop: function(e1) {}
        };
        qq.extend(options1, o1);
        element1 = options1.element;
        function dragoverShouldBeCanceled1() {
            return qq.safari() || qq.firefox() && qq.windows();
        }
        function disableDropOutside1(e1) {
            if (!dropOutsideDisabled1) {
                if (dragoverShouldBeCanceled1) disposeSupport1.attach(document, "dragover", function(e1) {
                    e1.preventDefault();
                });
                else disposeSupport1.attach(document, "dragover", function(e1) {
                    if (e1.dataTransfer) {
                        e1.dataTransfer.dropEffect = "none";
                        e1.preventDefault();
                    }
                });
                dropOutsideDisabled1 = true;
            }
        }
        function isValidFileDrag1(e1) {
            if (!qq.supportedFeatures.fileDrop) return false;
            var effectTest1, dt1 = e1.dataTransfer, isSafari1 = qq.safari();
            effectTest1 = qq.ie() && qq.supportedFeatures.fileDrop ? true : dt1.effectAllowed !== "none";
            return dt1 && effectTest1 && (dt1.files && dt1.files.length || !isSafari1 && dt1.types.contains && dt1.types.contains("Files") || dt1.types.includes && dt1.types.includes("Files"));
        }
        function isOrSetDropDisabled1(isDisabled1) {
            if (isDisabled1 !== undefined) preventDrop1 = isDisabled1;
            return preventDrop1;
        }
        function triggerHidezonesEvent1() {
            var hideZonesEvent1;
            function triggerUsingOldApi1() {
                hideZonesEvent1 = document.createEvent("Event");
                hideZonesEvent1.initEvent(options1.HIDE_ZONES_EVENT_NAME, true, true);
            }
            if (window.CustomEvent) try {
                hideZonesEvent1 = new CustomEvent(options1.HIDE_ZONES_EVENT_NAME);
            } catch (err1) {
                triggerUsingOldApi1();
            }
            else triggerUsingOldApi1();
            document.dispatchEvent(hideZonesEvent1);
        }
        function attachEvents1() {
            disposeSupport1.attach(element1, "dragover", function(e1) {
                if (!isValidFileDrag1(e1)) return;
                var effect1 = qq.ie() && qq.supportedFeatures.fileDrop ? null : e1.dataTransfer.effectAllowed;
                if (effect1 === "move" || effect1 === "linkMove") e1.dataTransfer.dropEffect = "move";
                else e1.dataTransfer.dropEffect = "copy";
                e1.stopPropagation();
                e1.preventDefault();
            });
            disposeSupport1.attach(element1, "dragenter", function(e1) {
                if (!isOrSetDropDisabled1()) {
                    if (!isValidFileDrag1(e1)) return;
                    options1.onEnter(e1);
                }
            });
            disposeSupport1.attach(element1, "dragleave", function(e1) {
                if (!isValidFileDrag1(e1)) return;
                options1.onLeave(e1);
                var relatedTarget1 = document.elementFromPoint(e1.clientX, e1.clientY);
                if (qq(this).contains(relatedTarget1)) return;
                options1.onLeaveNotDescendants(e1);
            });
            disposeSupport1.attach(element1, "drop", function(e1) {
                if (!isOrSetDropDisabled1()) {
                    if (!isValidFileDrag1(e1)) return;
                    e1.preventDefault();
                    e1.stopPropagation();
                    options1.onDrop(e1);
                    triggerHidezonesEvent1();
                }
            });
        }
        disableDropOutside1();
        attachEvents1();
        qq.extend(this, {
            dropDisabled: function(isDisabled1) {
                return isOrSetDropDisabled1(isDisabled1);
            },
            dispose: function() {
                disposeSupport1.dispose();
            },
            getElement: function() {
                return element1;
            }
        });
        this._testing = {};
        this._testing.isValidFileDrag = isValidFileDrag1;
    };
    (function() {
        "use strict";
        qq.uiPublicApi = {
            addInitialFiles: function(cannedFileList1) {
                this._parent.prototype.addInitialFiles.apply(this, arguments);
                this._templating.addCacheToDom();
            },
            clearStoredFiles: function() {
                this._parent.prototype.clearStoredFiles.apply(this, arguments);
                this._templating.clearFiles();
            },
            addExtraDropzone: function(element1) {
                this._dnd && this._dnd.setupExtraDropzone(element1);
            },
            removeExtraDropzone: function(element1) {
                if (this._dnd) return this._dnd.removeDropzone(element1);
            },
            getItemByFileId: function(id1) {
                if (!this._templating.isHiddenForever(id1)) return this._templating.getFileContainer(id1);
            },
            reset: function() {
                this._parent.prototype.reset.apply(this, arguments);
                this._templating.reset();
                if (!this._options.button && this._templating.getButton()) this._defaultButtonId = this._createUploadButton({
                    element: this._templating.getButton(),
                    title: this._options.text.fileInputTitle
                }).getButtonId();
                if (this._dnd) {
                    this._dnd.dispose();
                    this._dnd = this._setupDragAndDrop();
                }
                this._totalFilesInBatch = 0;
                this._filesInBatchAddedToUi = 0;
                this._setupClickAndEditEventHandlers();
            },
            setName: function(id1, newName1) {
                var formattedFilename1 = this._options.formatFileName(newName1);
                this._parent.prototype.setName.apply(this, arguments);
                this._templating.updateFilename(id1, formattedFilename1);
            },
            pauseUpload: function(id1) {
                var paused1 = this._parent.prototype.pauseUpload.apply(this, arguments);
                paused1 && this._templating.uploadPaused(id1);
                return paused1;
            },
            continueUpload: function(id1) {
                var continued1 = this._parent.prototype.continueUpload.apply(this, arguments);
                continued1 && this._templating.uploadContinued(id1);
                return continued1;
            },
            getId: function(fileContainerOrChildEl1) {
                return this._templating.getFileId(fileContainerOrChildEl1);
            },
            getDropTarget: function(fileId1) {
                var file1 = this.getFile(fileId1);
                return file1.qqDropTarget;
            }
        };
        qq.uiPrivateApi = {
            _getButton: function(buttonId1) {
                var button1 = this._parent.prototype._getButton.apply(this, arguments);
                if (!button1) {
                    if (buttonId1 === this._defaultButtonId) button1 = this._templating.getButton();
                }
                return button1;
            },
            _removeFileItem: function(fileId1) {
                this._templating.removeFile(fileId1);
            },
            _setupClickAndEditEventHandlers: function() {
                this._fileButtonsClickHandler = qq.FileButtonsClickHandler && this._bindFileButtonsClickEvent();
                this._focusinEventSupported = !qq.firefox();
                if (this._isEditFilenameEnabled()) {
                    this._filenameClickHandler = this._bindFilenameClickEvent();
                    this._filenameInputFocusInHandler = this._bindFilenameInputFocusInEvent();
                    this._filenameInputFocusHandler = this._bindFilenameInputFocusEvent();
                }
            },
            _setupDragAndDrop: function() {
                var self1 = this, dropZoneElements1 = this._options.dragAndDrop.extraDropzones, templating1 = this._templating, defaultDropZone1 = templating1.getDropZone();
                defaultDropZone1 && dropZoneElements1.push(defaultDropZone1);
                return new qq.DragAndDrop({
                    dropZoneElements: dropZoneElements1,
                    allowMultipleItems: this._options.multiple,
                    classes: {
                        dropActive: this._options.classes.dropActive
                    },
                    callbacks: {
                        processingDroppedFiles: function() {
                            templating1.showDropProcessing();
                        },
                        processingDroppedFilesComplete: function(files1, targetEl1) {
                            templating1.hideDropProcessing();
                            qq.each(files1, function(idx1, file1) {
                                file1.qqDropTarget = targetEl1;
                            });
                            if (files1.length) self1.addFiles(files1, null, null);
                        },
                        dropError: function(code1, errorData1) {
                            self1._itemError(code1, errorData1);
                        },
                        dropLog: function(message1, level1) {
                            self1.log(message1, level1);
                        }
                    }
                });
            },
            _bindFileButtonsClickEvent: function() {
                var self1 = this;
                return new qq.FileButtonsClickHandler({
                    templating: this._templating,
                    log: function(message1, lvl1) {
                        self1.log(message1, lvl1);
                    },
                    onDeleteFile: function(fileId1) {
                        self1.deleteFile(fileId1);
                    },
                    onCancel: function(fileId1) {
                        self1.cancel(fileId1);
                    },
                    onRetry: function(fileId1) {
                        self1.retry(fileId1);
                    },
                    onPause: function(fileId1) {
                        self1.pauseUpload(fileId1);
                    },
                    onContinue: function(fileId1) {
                        self1.continueUpload(fileId1);
                    },
                    onGetName: function(fileId1) {
                        return self1.getName(fileId1);
                    }
                });
            },
            _isEditFilenameEnabled: function() {
                return this._templating.isEditFilenamePossible() && !this._options.autoUpload && qq.FilenameClickHandler && qq.FilenameInputFocusHandler && qq.FilenameInputFocusHandler;
            },
            _filenameEditHandler: function() {
                var self1 = this, templating1 = this._templating;
                return {
                    templating: templating1,
                    log: function(message1, lvl1) {
                        self1.log(message1, lvl1);
                    },
                    onGetUploadStatus: function(fileId1) {
                        return self1.getUploads({
                            id: fileId1
                        }).status;
                    },
                    onGetName: function(fileId1) {
                        return self1.getName(fileId1);
                    },
                    onSetName: function(id1, newName1) {
                        self1.setName(id1, newName1);
                    },
                    onEditingStatusChange: function(id1, isEditing1) {
                        var qqInput1 = qq(templating1.getEditInput(id1)), qqFileContainer1 = qq(templating1.getFileContainer(id1));
                        if (isEditing1) {
                            qqInput1.addClass("qq-editing");
                            templating1.hideFilename(id1);
                            templating1.hideEditIcon(id1);
                        } else {
                            qqInput1.removeClass("qq-editing");
                            templating1.showFilename(id1);
                            templating1.showEditIcon(id1);
                        }
                        qqFileContainer1.addClass("qq-temp").removeClass("qq-temp");
                    }
                };
            },
            _onUploadStatusChange: function(id1, oldStatus1, newStatus1) {
                this._parent.prototype._onUploadStatusChange.apply(this, arguments);
                if (this._isEditFilenameEnabled()) {
                    if (this._templating.getFileContainer(id1) && newStatus1 !== qq.status.SUBMITTED) {
                        this._templating.markFilenameEditable(id1);
                        this._templating.hideEditIcon(id1);
                    }
                }
                if (oldStatus1 === qq.status.UPLOAD_RETRYING && newStatus1 === qq.status.UPLOADING) {
                    this._templating.hideRetry(id1);
                    this._templating.setStatusText(id1);
                    qq(this._templating.getFileContainer(id1)).removeClass(this._classes.retrying);
                } else if (newStatus1 === qq.status.UPLOAD_FAILED) this._templating.hidePause(id1);
            },
            _bindFilenameInputFocusInEvent: function() {
                var spec1 = qq.extend({}, this._filenameEditHandler());
                return new qq.FilenameInputFocusInHandler(spec1);
            },
            _bindFilenameInputFocusEvent: function() {
                var spec1 = qq.extend({}, this._filenameEditHandler());
                return new qq.FilenameInputFocusHandler(spec1);
            },
            _bindFilenameClickEvent: function() {
                var spec1 = qq.extend({}, this._filenameEditHandler());
                return new qq.FilenameClickHandler(spec1);
            },
            _storeForLater: function(id1) {
                this._parent.prototype._storeForLater.apply(this, arguments);
                this._templating.hideSpinner(id1);
            },
            _onAllComplete: function(successful1, failed1) {
                this._parent.prototype._onAllComplete.apply(this, arguments);
                this._templating.resetTotalProgress();
            },
            _onSubmit: function(id1, name1) {
                var file1 = this.getFile(id1);
                if (file1 && file1.qqPath && this._options.dragAndDrop.reportDirectoryPaths) this._paramsStore.addReadOnly(id1, {
                    qqpath: file1.qqPath
                });
                this._parent.prototype._onSubmit.apply(this, arguments);
                this._addToList(id1, name1);
            },
            _onSubmitted: function(id1) {
                if (this._isEditFilenameEnabled()) {
                    this._templating.markFilenameEditable(id1);
                    this._templating.showEditIcon(id1);
                    if (!this._focusinEventSupported) this._filenameInputFocusHandler.addHandler(this._templating.getEditInput(id1));
                }
            },
            _onProgress: function(id1, name1, loaded1, total1) {
                this._parent.prototype._onProgress.apply(this, arguments);
                this._templating.updateProgress(id1, loaded1, total1);
                if (total1 === 0 || Math.round(loaded1 / total1 * 100) === 100) {
                    this._templating.hideCancel(id1);
                    this._templating.hidePause(id1);
                    this._templating.hideProgress(id1);
                    this._templating.setStatusText(id1, this._options.text.waitingForResponse);
                    this._displayFileSize(id1);
                } else this._displayFileSize(id1, loaded1, total1);
            },
            _onTotalProgress: function(loaded1, total1) {
                this._parent.prototype._onTotalProgress.apply(this, arguments);
                this._templating.updateTotalProgress(loaded1, total1);
            },
            _onComplete: function(id1, name1, result1, xhr1) {
                var parentRetVal1 = this._parent.prototype._onComplete.apply(this, arguments), templating1 = this._templating, fileContainer1 = templating1.getFileContainer(id1), self1 = this;
                function completeUpload1(result1) {
                    if (!fileContainer1) return;
                    templating1.setStatusText(id1);
                    qq(fileContainer1).removeClass(self1._classes.retrying);
                    templating1.hideProgress(id1);
                    if (self1.getUploads({
                        id: id1
                    }).status !== qq.status.UPLOAD_FAILED) templating1.hideCancel(id1);
                    templating1.hideSpinner(id1);
                    if (result1.success) self1._markFileAsSuccessful(id1);
                    else {
                        qq(fileContainer1).addClass(self1._classes.fail);
                        templating1.showCancel(id1);
                        if (templating1.isRetryPossible() && !self1._preventRetries[id1]) {
                            qq(fileContainer1).addClass(self1._classes.retryable);
                            templating1.showRetry(id1);
                        }
                        self1._controlFailureTextDisplay(id1, result1);
                    }
                }
                if (parentRetVal1 instanceof qq.Promise) parentRetVal1.done(function(newResult1) {
                    completeUpload1(newResult1);
                });
                else completeUpload1(result1);
                return parentRetVal1;
            },
            _markFileAsSuccessful: function(id1) {
                var templating1 = this._templating;
                if (this._isDeletePossible()) templating1.showDeleteButton(id1);
                qq(templating1.getFileContainer(id1)).addClass(this._classes.success);
                this._maybeUpdateThumbnail(id1);
            },
            _onUploadPrep: function(id1) {
                this._parent.prototype._onUploadPrep.apply(this, arguments);
                this._templating.showSpinner(id1);
            },
            _onUpload: function(id1, name1) {
                var parentRetVal1 = this._parent.prototype._onUpload.apply(this, arguments);
                this._templating.showSpinner(id1);
                return parentRetVal1;
            },
            _onUploadChunk: function(id1, chunkData1) {
                this._parent.prototype._onUploadChunk.apply(this, arguments);
                if (chunkData1.partIndex > 0 && this._handler.isResumable(id1)) this._templating.allowPause(id1);
            },
            _onCancel: function(id1, name1) {
                this._parent.prototype._onCancel.apply(this, arguments);
                this._removeFileItem(id1);
                if (this._getNotFinished() === 0) this._templating.resetTotalProgress();
            },
            _onBeforeAutoRetry: function(id1) {
                var retryNumForDisplay1, maxAuto1, retryNote1;
                this._parent.prototype._onBeforeAutoRetry.apply(this, arguments);
                this._showCancelLink(id1);
                if (this._options.retry.showAutoRetryNote) {
                    retryNumForDisplay1 = this._autoRetries[id1];
                    maxAuto1 = this._options.retry.maxAutoAttempts;
                    retryNote1 = this._options.retry.autoRetryNote.replace(/\{retryNum\}/g, retryNumForDisplay1);
                    retryNote1 = retryNote1.replace(/\{maxAuto\}/g, maxAuto1);
                    this._templating.setStatusText(id1, retryNote1);
                    qq(this._templating.getFileContainer(id1)).addClass(this._classes.retrying);
                }
            },
            _onBeforeManualRetry: function(id1) {
                if (this._parent.prototype._onBeforeManualRetry.apply(this, arguments)) {
                    this._templating.resetProgress(id1);
                    qq(this._templating.getFileContainer(id1)).removeClass(this._classes.fail);
                    this._templating.setStatusText(id1);
                    this._templating.showSpinner(id1);
                    this._showCancelLink(id1);
                    return true;
                } else {
                    qq(this._templating.getFileContainer(id1)).addClass(this._classes.retryable);
                    this._templating.showRetry(id1);
                    return false;
                }
            },
            _onSubmitDelete: function(id1) {
                var onSuccessCallback1 = qq.bind(this._onSubmitDeleteSuccess, this);
                this._parent.prototype._onSubmitDelete.call(this, id1, onSuccessCallback1);
            },
            _onSubmitDeleteSuccess: function(id1, uuid1, additionalMandatedParams1) {
                if (this._options.deleteFile.forceConfirm) this._showDeleteConfirm.apply(this, arguments);
                else this._sendDeleteRequest.apply(this, arguments);
            },
            _onDeleteComplete: function(id1, xhr1, isError1) {
                this._parent.prototype._onDeleteComplete.apply(this, arguments);
                this._templating.hideSpinner(id1);
                if (isError1) {
                    this._templating.setStatusText(id1, this._options.deleteFile.deletingFailedText);
                    this._templating.showDeleteButton(id1);
                } else this._removeFileItem(id1);
            },
            _sendDeleteRequest: function(id1, uuid1, additionalMandatedParams1) {
                this._templating.hideDeleteButton(id1);
                this._templating.showSpinner(id1);
                this._templating.setStatusText(id1, this._options.deleteFile.deletingStatusText);
                this._deleteHandler.sendDelete.apply(this, arguments);
            },
            _showDeleteConfirm: function(id1, uuid1, mandatedParams1) {
                var fileName1 = this.getName(id1), confirmMessage1 = this._options.deleteFile.confirmMessage.replace(/\{filename\}/g, fileName1), uuid1 = this.getUuid(id1), deleteRequestArgs1 = arguments, self1 = this, retVal1;
                retVal1 = this._options.showConfirm(confirmMessage1);
                if (qq.isGenericPromise(retVal1)) retVal1.then(function() {
                    self1._sendDeleteRequest.apply(self1, deleteRequestArgs1);
                });
                else if (retVal1 !== false) self1._sendDeleteRequest.apply(self1, deleteRequestArgs1);
            },
            _addToList: function(id1, name1, canned1) {
                var prependData1, prependIndex1 = 0, dontDisplay1 = this._handler.isProxied(id1) && this._options.scaling.hideScaled, record1;
                if (this._options.display.prependFiles) {
                    if (this._totalFilesInBatch > 1 && this._filesInBatchAddedToUi > 0) prependIndex1 = this._filesInBatchAddedToUi - 1;
                    prependData1 = {
                        index: prependIndex1
                    };
                }
                if (!canned1) {
                    if (this._options.disableCancelForFormUploads && !qq.supportedFeatures.ajaxUploading) this._templating.disableCancel();
                    if (!this._options.multiple) {
                        record1 = this.getUploads({
                            id: id1
                        });
                        this._handledProxyGroup = this._handledProxyGroup || record1.proxyGroupId;
                        if (record1.proxyGroupId !== this._handledProxyGroup || !record1.proxyGroupId) {
                            this._handler.cancelAll();
                            this._clearList();
                            this._handledProxyGroup = null;
                        }
                    }
                }
                if (canned1) {
                    this._templating.addFileToCache(id1, this._options.formatFileName(name1), prependData1, dontDisplay1);
                    this._templating.updateThumbnail(id1, this._thumbnailUrls[id1], true, this._options.thumbnails.customResizer);
                } else {
                    this._templating.addFile(id1, this._options.formatFileName(name1), prependData1, dontDisplay1);
                    this._templating.generatePreview(id1, this.getFile(id1), this._options.thumbnails.customResizer);
                }
                this._filesInBatchAddedToUi += 1;
                if (canned1 || this._options.display.fileSizeOnSubmit && qq.supportedFeatures.ajaxUploading) this._displayFileSize(id1);
            },
            _clearList: function() {
                this._templating.clearFiles();
                this.clearStoredFiles();
            },
            _displayFileSize: function(id1, loadedSize1, totalSize1) {
                var size1 = this.getSize(id1), sizeForDisplay1 = this._formatSize(size1);
                if (size1 >= 0) {
                    if (loadedSize1 !== undefined && totalSize1 !== undefined) sizeForDisplay1 = this._formatProgress(loadedSize1, totalSize1);
                    this._templating.updateSize(id1, sizeForDisplay1);
                }
            },
            _formatProgress: function(uploadedSize1, totalSize1) {
                var message1 = this._options.text.formatProgress;
                function r1(name1, replacement1) {
                    message1 = message1.replace(name1, replacement1);
                }
                r1("{percent}", Math.round(uploadedSize1 / totalSize1 * 100));
                r1("{total_size}", this._formatSize(totalSize1));
                return message1;
            },
            _controlFailureTextDisplay: function(id1, response1) {
                var mode1, responseProperty1, failureReason1;
                mode1 = this._options.failedUploadTextDisplay.mode;
                responseProperty1 = this._options.failedUploadTextDisplay.responseProperty;
                if (mode1 === "custom") {
                    failureReason1 = response1[responseProperty1];
                    if (!failureReason1) failureReason1 = this._options.text.failUpload;
                    this._templating.setStatusText(id1, failureReason1);
                    if (this._options.failedUploadTextDisplay.enableTooltip) this._showTooltip(id1, failureReason1);
                } else if (mode1 === "default") this._templating.setStatusText(id1, this._options.text.failUpload);
                else if (mode1 !== "none") this.log("failedUploadTextDisplay.mode value of '" + mode1 + "' is not valid", "warn");
            },
            _showTooltip: function(id1, text1) {
                this._templating.getFileContainer(id1).title = text1;
            },
            _showCancelLink: function(id1) {
                if (!this._options.disableCancelForFormUploads || qq.supportedFeatures.ajaxUploading) this._templating.showCancel(id1);
            },
            _itemError: function(code1, name1, item1) {
                var message1 = this._parent.prototype._itemError.apply(this, arguments);
                this._options.showMessage(message1);
            },
            _batchError: function(message1) {
                this._parent.prototype._batchError.apply(this, arguments);
                this._options.showMessage(message1);
            },
            _setupPastePrompt: function() {
                var self1 = this;
                this._options.callbacks.onPasteReceived = function() {
                    var message1 = self1._options.paste.namePromptMessage, defaultVal1 = self1._options.paste.defaultName;
                    return self1._options.showPrompt(message1, defaultVal1);
                };
            },
            _fileOrBlobRejected: function(id1, name1) {
                this._totalFilesInBatch -= 1;
                this._parent.prototype._fileOrBlobRejected.apply(this, arguments);
            },
            _prepareItemsForUpload: function(items1, params1, endpoint1) {
                this._totalFilesInBatch = items1.length;
                this._filesInBatchAddedToUi = 0;
                this._parent.prototype._prepareItemsForUpload.apply(this, arguments);
            },
            _maybeUpdateThumbnail: function(fileId1) {
                var thumbnailUrl1 = this._thumbnailUrls[fileId1], fileStatus1 = this.getUploads({
                    id: fileId1
                }).status;
                if (fileStatus1 !== qq.status.DELETED && (thumbnailUrl1 || this._options.thumbnails.placeholders.waitUntilResponse || !qq.supportedFeatures.imagePreviews)) this._templating.updateThumbnail(fileId1, thumbnailUrl1, this._options.thumbnails.customResizer);
            },
            _addCannedFile: function(sessionData1) {
                var id1 = this._parent.prototype._addCannedFile.apply(this, arguments);
                this._addToList(id1, this.getName(id1), true);
                this._templating.hideSpinner(id1);
                this._templating.hideCancel(id1);
                this._markFileAsSuccessful(id1);
                return id1;
            },
            _setSize: function(id1, newSize1) {
                this._parent.prototype._setSize.apply(this, arguments);
                this._templating.updateSize(id1, this._formatSize(newSize1));
            },
            _sessionRequestComplete: function() {
                this._templating.addCacheToDom();
                this._parent.prototype._sessionRequestComplete.apply(this, arguments);
            }
        };
    })();
    qq.FineUploader = function(o1, namespace1) {
        "use strict";
        var self1 = this;
        this._parent = namespace1 ? qq[namespace1].FineUploaderBasic : qq.FineUploaderBasic;
        this._parent.apply(this, arguments);
        qq.extend(this._options, {
            element: null,
            button: null,
            listElement: null,
            dragAndDrop: {
                extraDropzones: [],
                reportDirectoryPaths: false
            },
            text: {
                formatProgress: "{percent}% of {total_size}",
                failUpload: "Upload failed",
                waitingForResponse: "Processing...",
                paused: "Paused"
            },
            template: "qq-template",
            classes: {
                retrying: "qq-upload-retrying",
                retryable: "qq-upload-retryable",
                success: "qq-upload-success",
                fail: "qq-upload-fail",
                editable: "qq-editable",
                hide: "qq-hide",
                dropActive: "qq-upload-drop-area-active"
            },
            failedUploadTextDisplay: {
                mode: "default",
                responseProperty: "error",
                enableTooltip: true
            },
            messages: {
                tooManyFilesError: "You may only drop one file",
                unsupportedBrowser: "Unrecoverable error - this browser does not permit file uploading of any kind."
            },
            retry: {
                showAutoRetryNote: true,
                autoRetryNote: "Retrying {retryNum}/{maxAuto}..."
            },
            deleteFile: {
                forceConfirm: false,
                confirmMessage: "Are you sure you want to delete {filename}?",
                deletingStatusText: "Deleting...",
                deletingFailedText: "Delete failed"
            },
            display: {
                fileSizeOnSubmit: false,
                prependFiles: false
            },
            paste: {
                promptForName: false,
                namePromptMessage: "Please name this image"
            },
            thumbnails: {
                customResizer: null,
                maxCount: 0,
                placeholders: {
                    waitUntilResponse: false,
                    notAvailablePath: null,
                    waitingPath: null
                },
                timeBetweenThumbs: 750
            },
            scaling: {
                hideScaled: false
            },
            showMessage: function(message1) {
                if (self1._templating.hasDialog("alert")) return self1._templating.showDialog("alert", message1);
                else setTimeout(function() {
                    window.alert(message1);
                }, 0);
            },
            showConfirm: function(message1) {
                if (self1._templating.hasDialog("confirm")) return self1._templating.showDialog("confirm", message1);
                else return window.confirm(message1);
            },
            showPrompt: function(message1, defaultValue1) {
                if (self1._templating.hasDialog("prompt")) return self1._templating.showDialog("prompt", message1, defaultValue1);
                else return window.prompt(message1, defaultValue1);
            }
        }, true);
        qq.extend(this._options, o1, true);
        this._templating = new qq.Templating({
            log: qq.bind(this.log, this),
            templateIdOrEl: this._options.template,
            containerEl: this._options.element,
            fileContainerEl: this._options.listElement,
            button: this._options.button,
            imageGenerator: this._imageGenerator,
            classes: {
                hide: this._options.classes.hide,
                editable: this._options.classes.editable
            },
            limits: {
                maxThumbs: this._options.thumbnails.maxCount,
                timeBetweenThumbs: this._options.thumbnails.timeBetweenThumbs
            },
            placeholders: {
                waitUntilUpdate: this._options.thumbnails.placeholders.waitUntilResponse,
                thumbnailNotAvailable: this._options.thumbnails.placeholders.notAvailablePath,
                waitingForThumbnail: this._options.thumbnails.placeholders.waitingPath
            },
            text: this._options.text
        });
        if (this._options.workarounds.ios8SafariUploads && qq.ios800() && qq.iosSafari()) this._templating.renderFailure(this._options.messages.unsupportedBrowserIos8Safari);
        else if (!qq.supportedFeatures.uploading || this._options.cors.expected && !qq.supportedFeatures.uploadCors) this._templating.renderFailure(this._options.messages.unsupportedBrowser);
        else {
            this._wrapCallbacks();
            this._templating.render();
            this._classes = this._options.classes;
            if (!this._options.button && this._templating.getButton()) this._defaultButtonId = this._createUploadButton({
                element: this._templating.getButton(),
                title: this._options.text.fileInputTitle
            }).getButtonId();
            this._setupClickAndEditEventHandlers();
            if (qq.DragAndDrop && qq.supportedFeatures.fileDrop) this._dnd = this._setupDragAndDrop();
            if (this._options.paste.targetElement && this._options.paste.promptForName) {
                if (qq.PasteSupport) this._setupPastePrompt();
                else this.log("Paste support module not found.", "error");
            }
            this._totalFilesInBatch = 0;
            this._filesInBatchAddedToUi = 0;
        }
    };
    qq.extend(qq.FineUploader.prototype, qq.basePublicApi);
    qq.extend(qq.FineUploader.prototype, qq.basePrivateApi);
    qq.extend(qq.FineUploader.prototype, qq.uiPublicApi);
    qq.extend(qq.FineUploader.prototype, qq.uiPrivateApi);
    qq.Templating = function(spec1) {
        "use strict";
        var FILE_ID_ATTR1 = "qq-file-id", FILE_CLASS_PREFIX1 = "qq-file-id-", THUMBNAIL_MAX_SIZE_ATTR1 = "qq-max-size", THUMBNAIL_SERVER_SCALE_ATTR1 = "qq-server-scale", HIDE_DROPZONE_ATTR1 = "qq-hide-dropzone", DROPZPONE_TEXT_ATTR1 = "qq-drop-area-text", IN_PROGRESS_CLASS1 = "qq-in-progress", HIDDEN_FOREVER_CLASS1 = "qq-hidden-forever", fileBatch1 = {
            content: document.createDocumentFragment(),
            map: {}
        }, isCancelDisabled1 = false, generatedThumbnails1 = 0, thumbnailQueueMonitorRunning1 = false, thumbGenerationQueue1 = [], thumbnailMaxSize1 = -1, options1 = {
            log: null,
            limits: {
                maxThumbs: 0,
                timeBetweenThumbs: 750
            },
            templateIdOrEl: "qq-template",
            containerEl: null,
            fileContainerEl: null,
            button: null,
            imageGenerator: null,
            classes: {
                hide: "qq-hide",
                editable: "qq-editable"
            },
            placeholders: {
                waitUntilUpdate: false,
                thumbnailNotAvailable: null,
                waitingForThumbnail: null
            },
            text: {
                paused: "Paused"
            }
        }, selectorClasses1 = {
            button: "qq-upload-button-selector",
            alertDialog: "qq-alert-dialog-selector",
            dialogCancelButton: "qq-cancel-button-selector",
            confirmDialog: "qq-confirm-dialog-selector",
            dialogMessage: "qq-dialog-message-selector",
            dialogOkButton: "qq-ok-button-selector",
            promptDialog: "qq-prompt-dialog-selector",
            uploader: "qq-uploader-selector",
            drop: "qq-upload-drop-area-selector",
            list: "qq-upload-list-selector",
            progressBarContainer: "qq-progress-bar-container-selector",
            progressBar: "qq-progress-bar-selector",
            totalProgressBarContainer: "qq-total-progress-bar-container-selector",
            totalProgressBar: "qq-total-progress-bar-selector",
            file: "qq-upload-file-selector",
            spinner: "qq-upload-spinner-selector",
            size: "qq-upload-size-selector",
            cancel: "qq-upload-cancel-selector",
            pause: "qq-upload-pause-selector",
            continueButton: "qq-upload-continue-selector",
            deleteButton: "qq-upload-delete-selector",
            retry: "qq-upload-retry-selector",
            statusText: "qq-upload-status-text-selector",
            editFilenameInput: "qq-edit-filename-selector",
            editNameIcon: "qq-edit-filename-icon-selector",
            dropText: "qq-upload-drop-area-text-selector",
            dropProcessing: "qq-drop-processing-selector",
            dropProcessingSpinner: "qq-drop-processing-spinner-selector",
            thumbnail: "qq-thumbnail-selector"
        }, previewGeneration1 = {}, cachedThumbnailNotAvailableImg1 = new qq.Promise(), cachedWaitingForThumbnailImg1 = new qq.Promise(), log1, isEditElementsExist1, isRetryElementExist1, templateDom1, container1, fileList1, showThumbnails1, serverScale1, cacheThumbnailPlaceholders1 = function() {
            var notAvailableUrl1 = options1.placeholders.thumbnailNotAvailable, waitingUrl1 = options1.placeholders.waitingForThumbnail, spec1 = {
                maxSize: thumbnailMaxSize1,
                scale: serverScale1
            };
            if (showThumbnails1) {
                if (notAvailableUrl1) options1.imageGenerator.generate(notAvailableUrl1, new Image(), spec1).then(function(updatedImg1) {
                    cachedThumbnailNotAvailableImg1.success(updatedImg1);
                }, function() {
                    cachedThumbnailNotAvailableImg1.failure();
                    log1("Problem loading 'not available' placeholder image at " + notAvailableUrl1, "error");
                });
                else cachedThumbnailNotAvailableImg1.failure();
                if (waitingUrl1) options1.imageGenerator.generate(waitingUrl1, new Image(), spec1).then(function(updatedImg1) {
                    cachedWaitingForThumbnailImg1.success(updatedImg1);
                }, function() {
                    cachedWaitingForThumbnailImg1.failure();
                    log1("Problem loading 'waiting for thumbnail' placeholder image at " + waitingUrl1, "error");
                });
                else cachedWaitingForThumbnailImg1.failure();
            }
        }, displayWaitingImg1 = function(thumbnail1) {
            var waitingImgPlacement1 = new qq.Promise();
            cachedWaitingForThumbnailImg1.then(function(img1) {
                maybeScalePlaceholderViaCss1(img1, thumbnail1);
                if (!thumbnail1.src) {
                    thumbnail1.src = img1.src;
                    thumbnail1.onload = function() {
                        thumbnail1.onload = null;
                        show1(thumbnail1);
                        waitingImgPlacement1.success();
                    };
                } else waitingImgPlacement1.success();
            }, function() {
                hide1(thumbnail1);
                waitingImgPlacement1.success();
            });
            return waitingImgPlacement1;
        }, generateNewPreview1 = function(id1, blob1, spec1) {
            var thumbnail1 = getThumbnail1(id1);
            log1("Generating new thumbnail for " + id1);
            blob1.qqThumbnailId = id1;
            return options1.imageGenerator.generate(blob1, thumbnail1, spec1).then(function() {
                generatedThumbnails1++;
                show1(thumbnail1);
                previewGeneration1[id1].success();
            }, function() {
                previewGeneration1[id1].failure();
                if (!options1.placeholders.waitUntilUpdate) maybeSetDisplayNotAvailableImg1(id1, thumbnail1);
            });
        }, generateNextQueuedPreview1 = function() {
            if (thumbGenerationQueue1.length) {
                thumbnailQueueMonitorRunning1 = true;
                var queuedThumbRequest1 = thumbGenerationQueue1.shift();
                if (queuedThumbRequest1.update) processUpdateQueuedPreviewRequest1(queuedThumbRequest1);
                else processNewQueuedPreviewRequest1(queuedThumbRequest1);
            } else thumbnailQueueMonitorRunning1 = false;
        }, getCancel1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.cancel);
        }, getContinue1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.continueButton);
        }, getDialog1 = function(type1) {
            return getTemplateEl1(container1, selectorClasses1[type1 + "Dialog"]);
        }, getDelete1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.deleteButton);
        }, getDropProcessing1 = function() {
            return getTemplateEl1(container1, selectorClasses1.dropProcessing);
        }, getEditIcon1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.editNameIcon);
        }, getFile1 = function(id1) {
            return fileBatch1.map[id1] || qq(fileList1).getFirstByClass(FILE_CLASS_PREFIX1 + id1);
        }, getFilename1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.file);
        }, getPause1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.pause);
        }, getProgress1 = function(id1) {
            if (id1 == null) return getTemplateEl1(container1, selectorClasses1.totalProgressBarContainer) || getTemplateEl1(container1, selectorClasses1.totalProgressBar);
            return getTemplateEl1(getFile1(id1), selectorClasses1.progressBarContainer) || getTemplateEl1(getFile1(id1), selectorClasses1.progressBar);
        }, getRetry1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.retry);
        }, getSize1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.size);
        }, getSpinner1 = function(id1) {
            return getTemplateEl1(getFile1(id1), selectorClasses1.spinner);
        }, getTemplateEl1 = function(context1, cssClass1) {
            return context1 && qq(context1).getFirstByClass(cssClass1);
        }, getThumbnail1 = function(id1) {
            return showThumbnails1 && getTemplateEl1(getFile1(id1), selectorClasses1.thumbnail);
        }, hide1 = function(el1) {
            el1 && qq(el1).addClass(options1.classes.hide);
        }, maybeScalePlaceholderViaCss1 = function(placeholder1, thumbnail1) {
            var maxWidth1 = placeholder1.style.maxWidth, maxHeight1 = placeholder1.style.maxHeight;
            if (maxHeight1 && maxWidth1 && !thumbnail1.style.maxWidth && !thumbnail1.style.maxHeight) qq(thumbnail1).css({
                maxWidth: maxWidth1,
                maxHeight: maxHeight1
            });
        }, maybeSetDisplayNotAvailableImg1 = function(id1, thumbnail1) {
            var previewing1 = previewGeneration1[id1] || new qq.Promise().failure(), notAvailableImgPlacement1 = new qq.Promise();
            cachedThumbnailNotAvailableImg1.then(function(img1) {
                previewing1.then(function() {
                    notAvailableImgPlacement1.success();
                }, function() {
                    maybeScalePlaceholderViaCss1(img1, thumbnail1);
                    thumbnail1.onload = function() {
                        thumbnail1.onload = null;
                        notAvailableImgPlacement1.success();
                    };
                    thumbnail1.src = img1.src;
                    show1(thumbnail1);
                });
            });
            return notAvailableImgPlacement1;
        }, parseAndGetTemplate1 = function() {
            var scriptEl1, scriptHtml1, fileListNode1, tempTemplateEl1, fileListEl1, defaultButton1, dropArea1, thumbnail1, dropProcessing1, dropTextEl1, uploaderEl1;
            log1("Parsing template");
            if (options1.templateIdOrEl == null) throw new Error("You MUST specify either a template element or ID!");
            if (qq.isString(options1.templateIdOrEl)) {
                scriptEl1 = document.getElementById(options1.templateIdOrEl);
                if (scriptEl1 === null) throw new Error(qq.format("Cannot find template script at ID '{}'!", options1.templateIdOrEl));
                scriptHtml1 = scriptEl1.innerHTML;
            } else {
                if (options1.templateIdOrEl.innerHTML === undefined) throw new Error("You have specified an invalid value for the template option!  It must be an ID or an Element.");
                scriptHtml1 = options1.templateIdOrEl.innerHTML;
            }
            scriptHtml1 = qq.trimStr(scriptHtml1);
            tempTemplateEl1 = document.createElement("div");
            tempTemplateEl1.appendChild(qq.toElement(scriptHtml1));
            uploaderEl1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.uploader);
            if (options1.button) {
                defaultButton1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.button);
                if (defaultButton1) qq(defaultButton1).remove();
            }
            if (!qq.DragAndDrop || !qq.supportedFeatures.fileDrop) {
                dropProcessing1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.dropProcessing);
                if (dropProcessing1) qq(dropProcessing1).remove();
            }
            dropArea1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.drop);
            if (dropArea1 && !qq.DragAndDrop) {
                log1("DnD module unavailable.", "info");
                qq(dropArea1).remove();
            }
            if (!qq.supportedFeatures.fileDrop) {
                uploaderEl1.removeAttribute(DROPZPONE_TEXT_ATTR1);
                if (dropArea1 && qq(dropArea1).hasAttribute(HIDE_DROPZONE_ATTR1)) qq(dropArea1).css({
                    display: "none"
                });
            } else if (qq(uploaderEl1).hasAttribute(DROPZPONE_TEXT_ATTR1) && dropArea1) {
                dropTextEl1 = qq(dropArea1).getFirstByClass(selectorClasses1.dropText);
                dropTextEl1 && qq(dropTextEl1).remove();
            }
            thumbnail1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.thumbnail);
            if (!showThumbnails1) thumbnail1 && qq(thumbnail1).remove();
            else if (thumbnail1) {
                thumbnailMaxSize1 = parseInt(thumbnail1.getAttribute(THUMBNAIL_MAX_SIZE_ATTR1));
                thumbnailMaxSize1 = thumbnailMaxSize1 > 0 ? thumbnailMaxSize1 : null;
                serverScale1 = qq(thumbnail1).hasAttribute(THUMBNAIL_SERVER_SCALE_ATTR1);
            }
            showThumbnails1 = showThumbnails1 && thumbnail1;
            isEditElementsExist1 = qq(tempTemplateEl1).getByClass(selectorClasses1.editFilenameInput).length > 0;
            isRetryElementExist1 = qq(tempTemplateEl1).getByClass(selectorClasses1.retry).length > 0;
            fileListNode1 = qq(tempTemplateEl1).getFirstByClass(selectorClasses1.list);
            if (fileListNode1 == null) throw new Error("Could not find the file list container in the template!");
            fileListEl1 = fileListNode1.children[0].cloneNode(true);
            fileListNode1.innerHTML = "";
            if (tempTemplateEl1.getElementsByTagName("DIALOG").length) document.createElement("dialog");
            log1("Template parsing complete");
            return {
                template: tempTemplateEl1,
                fileTemplate: fileListEl1
            };
        }, prependFile1 = function(el1, index1, fileList1) {
            var parentEl1 = fileList1, beforeEl1 = parentEl1.firstChild;
            if (index1 > 0) beforeEl1 = qq(parentEl1).children()[index1].nextSibling;
            parentEl1.insertBefore(el1, beforeEl1);
        }, processNewQueuedPreviewRequest1 = function(queuedThumbRequest1) {
            var id1 = queuedThumbRequest1.id, optFileOrBlob1 = queuedThumbRequest1.optFileOrBlob, relatedThumbnailId1 = optFileOrBlob1 && optFileOrBlob1.qqThumbnailId, thumbnail1 = getThumbnail1(id1), spec1 = {
                customResizeFunction: queuedThumbRequest1.customResizeFunction,
                maxSize: thumbnailMaxSize1,
                orient: true,
                scale: true
            };
            if (qq.supportedFeatures.imagePreviews) {
                if (thumbnail1) {
                    if (options1.limits.maxThumbs && options1.limits.maxThumbs <= generatedThumbnails1) {
                        maybeSetDisplayNotAvailableImg1(id1, thumbnail1);
                        generateNextQueuedPreview1();
                    } else displayWaitingImg1(thumbnail1).done(function() {
                        previewGeneration1[id1] = new qq.Promise();
                        previewGeneration1[id1].done(function() {
                            setTimeout(generateNextQueuedPreview1, options1.limits.timeBetweenThumbs);
                        });
                        if (relatedThumbnailId1 != null) useCachedPreview1(id1, relatedThumbnailId1);
                        else generateNewPreview1(id1, optFileOrBlob1, spec1);
                    });
                } else generateNextQueuedPreview1();
            } else if (thumbnail1) {
                displayWaitingImg1(thumbnail1);
                generateNextQueuedPreview1();
            }
        }, processUpdateQueuedPreviewRequest1 = function(queuedThumbRequest1) {
            var id1 = queuedThumbRequest1.id, thumbnailUrl1 = queuedThumbRequest1.thumbnailUrl, showWaitingImg1 = queuedThumbRequest1.showWaitingImg, thumbnail1 = getThumbnail1(id1), spec1 = {
                customResizeFunction: queuedThumbRequest1.customResizeFunction,
                scale: serverScale1,
                maxSize: thumbnailMaxSize1
            };
            if (thumbnail1) {
                if (thumbnailUrl1) {
                    if (options1.limits.maxThumbs && options1.limits.maxThumbs <= generatedThumbnails1) {
                        maybeSetDisplayNotAvailableImg1(id1, thumbnail1);
                        generateNextQueuedPreview1();
                    } else {
                        if (showWaitingImg1) displayWaitingImg1(thumbnail1);
                        return options1.imageGenerator.generate(thumbnailUrl1, thumbnail1, spec1).then(function() {
                            show1(thumbnail1);
                            generatedThumbnails1++;
                            setTimeout(generateNextQueuedPreview1, options1.limits.timeBetweenThumbs);
                        }, function() {
                            maybeSetDisplayNotAvailableImg1(id1, thumbnail1);
                            setTimeout(generateNextQueuedPreview1, options1.limits.timeBetweenThumbs);
                        });
                    }
                } else {
                    maybeSetDisplayNotAvailableImg1(id1, thumbnail1);
                    generateNextQueuedPreview1();
                }
            }
        }, setProgressBarWidth1 = function(id1, percent1) {
            var bar1 = getProgress1(id1), progressBarSelector1 = id1 == null ? selectorClasses1.totalProgressBar : selectorClasses1.progressBar;
            if (bar1 && !qq(bar1).hasClass(progressBarSelector1)) bar1 = qq(bar1).getFirstByClass(progressBarSelector1);
            if (bar1) {
                qq(bar1).css({
                    width: percent1 + "%"
                });
                bar1.setAttribute("aria-valuenow", percent1);
            }
        }, show1 = function(el1) {
            el1 && qq(el1).removeClass(options1.classes.hide);
        }, useCachedPreview1 = function(targetThumbnailId1, cachedThumbnailId1) {
            var targetThumbnail1 = getThumbnail1(targetThumbnailId1), cachedThumbnail1 = getThumbnail1(cachedThumbnailId1);
            log1(qq.format("ID {} is the same file as ID {}.  Will use generated thumbnail from ID {} instead.", targetThumbnailId1, cachedThumbnailId1, cachedThumbnailId1));
            previewGeneration1[cachedThumbnailId1].then(function() {
                generatedThumbnails1++;
                previewGeneration1[targetThumbnailId1].success();
                log1(qq.format("Now using previously generated thumbnail created for ID {} on ID {}.", cachedThumbnailId1, targetThumbnailId1));
                targetThumbnail1.src = cachedThumbnail1.src;
                show1(targetThumbnail1);
            }, function() {
                previewGeneration1[targetThumbnailId1].failure();
                if (!options1.placeholders.waitUntilUpdate) maybeSetDisplayNotAvailableImg1(targetThumbnailId1, targetThumbnail1);
            });
        };
        qq.extend(options1, spec1);
        log1 = options1.log;
        if (!qq.supportedFeatures.imagePreviews) {
            options1.limits.timeBetweenThumbs = 0;
            options1.limits.maxThumbs = 0;
        }
        container1 = options1.containerEl;
        showThumbnails1 = options1.imageGenerator !== undefined;
        templateDom1 = parseAndGetTemplate1();
        cacheThumbnailPlaceholders1();
        qq.extend(this, {
            render: function() {
                log1("Rendering template in DOM.");
                generatedThumbnails1 = 0;
                container1.appendChild(templateDom1.template.cloneNode(true));
                hide1(getDropProcessing1());
                this.hideTotalProgress();
                fileList1 = options1.fileContainerEl || getTemplateEl1(container1, selectorClasses1.list);
                log1("Template rendering complete");
            },
            renderFailure: function(message1) {
                var cantRenderEl1 = qq.toElement(message1);
                container1.innerHTML = "";
                container1.appendChild(cantRenderEl1);
            },
            reset: function() {
                container1.innerHTML = "";
                this.render();
            },
            clearFiles: function() {
                fileList1.innerHTML = "";
            },
            disableCancel: function() {
                isCancelDisabled1 = true;
            },
            addFile: function(id1, name1, prependInfo1, hideForever1, batch1) {
                var fileEl1 = templateDom1.fileTemplate.cloneNode(true), fileNameEl1 = getTemplateEl1(fileEl1, selectorClasses1.file), uploaderEl1 = getTemplateEl1(container1, selectorClasses1.uploader), fileContainer1 = batch1 ? fileBatch1.content : fileList1, thumb1;
                if (batch1) fileBatch1.map[id1] = fileEl1;
                qq(fileEl1).addClass(FILE_CLASS_PREFIX1 + id1);
                uploaderEl1.removeAttribute(DROPZPONE_TEXT_ATTR1);
                if (fileNameEl1) {
                    qq(fileNameEl1).setText(name1);
                    fileNameEl1.setAttribute("title", name1);
                }
                fileEl1.setAttribute(FILE_ID_ATTR1, id1);
                if (prependInfo1) prependFile1(fileEl1, prependInfo1.index, fileContainer1);
                else fileContainer1.appendChild(fileEl1);
                if (hideForever1) {
                    fileEl1.style.display = "none";
                    qq(fileEl1).addClass(HIDDEN_FOREVER_CLASS1);
                } else {
                    hide1(getProgress1(id1));
                    hide1(getSize1(id1));
                    hide1(getDelete1(id1));
                    hide1(getRetry1(id1));
                    hide1(getPause1(id1));
                    hide1(getContinue1(id1));
                    if (isCancelDisabled1) this.hideCancel(id1);
                    thumb1 = getThumbnail1(id1);
                    if (thumb1 && !thumb1.src) cachedWaitingForThumbnailImg1.then(function(waitingImg1) {
                        thumb1.src = waitingImg1.src;
                        if (waitingImg1.style.maxHeight && waitingImg1.style.maxWidth) qq(thumb1).css({
                            maxHeight: waitingImg1.style.maxHeight,
                            maxWidth: waitingImg1.style.maxWidth
                        });
                        show1(thumb1);
                    });
                }
            },
            addFileToCache: function(id1, name1, prependInfo1, hideForever1) {
                this.addFile(id1, name1, prependInfo1, hideForever1, true);
            },
            addCacheToDom: function() {
                fileList1.appendChild(fileBatch1.content);
                fileBatch1.content = document.createDocumentFragment();
                fileBatch1.map = {};
            },
            removeFile: function(id1) {
                qq(getFile1(id1)).remove();
            },
            getFileId: function(el1) {
                var currentNode1 = el1;
                if (currentNode1) {
                    while(currentNode1.getAttribute(FILE_ID_ATTR1) == null)currentNode1 = currentNode1.parentNode;
                    return parseInt(currentNode1.getAttribute(FILE_ID_ATTR1));
                }
            },
            getFileList: function() {
                return fileList1;
            },
            markFilenameEditable: function(id1) {
                var filename1 = getFilename1(id1);
                filename1 && qq(filename1).addClass(options1.classes.editable);
            },
            updateFilename: function(id1, name1) {
                var filenameEl1 = getFilename1(id1);
                if (filenameEl1) {
                    qq(filenameEl1).setText(name1);
                    filenameEl1.setAttribute("title", name1);
                }
            },
            hideFilename: function(id1) {
                hide1(getFilename1(id1));
            },
            showFilename: function(id1) {
                show1(getFilename1(id1));
            },
            isFileName: function(el1) {
                return qq(el1).hasClass(selectorClasses1.file);
            },
            getButton: function() {
                return options1.button || getTemplateEl1(container1, selectorClasses1.button);
            },
            hideDropProcessing: function() {
                hide1(getDropProcessing1());
            },
            showDropProcessing: function() {
                show1(getDropProcessing1());
            },
            getDropZone: function() {
                return getTemplateEl1(container1, selectorClasses1.drop);
            },
            isEditFilenamePossible: function() {
                return isEditElementsExist1;
            },
            hideRetry: function(id1) {
                hide1(getRetry1(id1));
            },
            isRetryPossible: function() {
                return isRetryElementExist1;
            },
            showRetry: function(id1) {
                show1(getRetry1(id1));
            },
            getFileContainer: function(id1) {
                return getFile1(id1);
            },
            showEditIcon: function(id1) {
                var icon1 = getEditIcon1(id1);
                icon1 && qq(icon1).addClass(options1.classes.editable);
            },
            isHiddenForever: function(id1) {
                return qq(getFile1(id1)).hasClass(HIDDEN_FOREVER_CLASS1);
            },
            hideEditIcon: function(id1) {
                var icon1 = getEditIcon1(id1);
                icon1 && qq(icon1).removeClass(options1.classes.editable);
            },
            isEditIcon: function(el1) {
                return qq(el1).hasClass(selectorClasses1.editNameIcon, true);
            },
            getEditInput: function(id1) {
                return getTemplateEl1(getFile1(id1), selectorClasses1.editFilenameInput);
            },
            isEditInput: function(el1) {
                return qq(el1).hasClass(selectorClasses1.editFilenameInput, true);
            },
            updateProgress: function(id1, loaded1, total1) {
                var bar1 = getProgress1(id1), percent1;
                if (bar1 && total1 > 0) {
                    percent1 = Math.round(loaded1 / total1 * 100);
                    if (percent1 === 100) hide1(bar1);
                    else show1(bar1);
                    setProgressBarWidth1(id1, percent1);
                }
            },
            updateTotalProgress: function(loaded1, total1) {
                this.updateProgress(null, loaded1, total1);
            },
            hideProgress: function(id1) {
                var bar1 = getProgress1(id1);
                bar1 && hide1(bar1);
            },
            hideTotalProgress: function() {
                this.hideProgress();
            },
            resetProgress: function(id1) {
                setProgressBarWidth1(id1, 0);
                this.hideTotalProgress(id1);
            },
            resetTotalProgress: function() {
                this.resetProgress();
            },
            showCancel: function(id1) {
                if (!isCancelDisabled1) {
                    var cancel1 = getCancel1(id1);
                    cancel1 && qq(cancel1).removeClass(options1.classes.hide);
                }
            },
            hideCancel: function(id1) {
                hide1(getCancel1(id1));
            },
            isCancel: function(el1) {
                return qq(el1).hasClass(selectorClasses1.cancel, true);
            },
            allowPause: function(id1) {
                show1(getPause1(id1));
                hide1(getContinue1(id1));
            },
            uploadPaused: function(id1) {
                this.setStatusText(id1, options1.text.paused);
                this.allowContinueButton(id1);
                hide1(getSpinner1(id1));
            },
            hidePause: function(id1) {
                hide1(getPause1(id1));
            },
            isPause: function(el1) {
                return qq(el1).hasClass(selectorClasses1.pause, true);
            },
            isContinueButton: function(el1) {
                return qq(el1).hasClass(selectorClasses1.continueButton, true);
            },
            allowContinueButton: function(id1) {
                show1(getContinue1(id1));
                hide1(getPause1(id1));
            },
            uploadContinued: function(id1) {
                this.setStatusText(id1, "");
                this.allowPause(id1);
                show1(getSpinner1(id1));
            },
            showDeleteButton: function(id1) {
                show1(getDelete1(id1));
            },
            hideDeleteButton: function(id1) {
                hide1(getDelete1(id1));
            },
            isDeleteButton: function(el1) {
                return qq(el1).hasClass(selectorClasses1.deleteButton, true);
            },
            isRetry: function(el1) {
                return qq(el1).hasClass(selectorClasses1.retry, true);
            },
            updateSize: function(id1, text1) {
                var size1 = getSize1(id1);
                if (size1) {
                    show1(size1);
                    qq(size1).setText(text1);
                }
            },
            setStatusText: function(id1, text1) {
                var textEl1 = getTemplateEl1(getFile1(id1), selectorClasses1.statusText);
                if (textEl1) {
                    if (text1 == null) qq(textEl1).clearText();
                    else qq(textEl1).setText(text1);
                }
            },
            hideSpinner: function(id1) {
                qq(getFile1(id1)).removeClass(IN_PROGRESS_CLASS1);
                hide1(getSpinner1(id1));
            },
            showSpinner: function(id1) {
                qq(getFile1(id1)).addClass(IN_PROGRESS_CLASS1);
                show1(getSpinner1(id1));
            },
            generatePreview: function(id1, optFileOrBlob1, customResizeFunction1) {
                if (!this.isHiddenForever(id1)) {
                    thumbGenerationQueue1.push({
                        id: id1,
                        customResizeFunction: customResizeFunction1,
                        optFileOrBlob: optFileOrBlob1
                    });
                    !thumbnailQueueMonitorRunning1 && generateNextQueuedPreview1();
                }
            },
            updateThumbnail: function(id1, thumbnailUrl1, showWaitingImg1, customResizeFunction1) {
                if (!this.isHiddenForever(id1)) {
                    thumbGenerationQueue1.push({
                        customResizeFunction: customResizeFunction1,
                        update: true,
                        id: id1,
                        thumbnailUrl: thumbnailUrl1,
                        showWaitingImg: showWaitingImg1
                    });
                    !thumbnailQueueMonitorRunning1 && generateNextQueuedPreview1();
                }
            },
            hasDialog: function(type1) {
                return qq.supportedFeatures.dialogElement && !!getDialog1(type1);
            },
            showDialog: function(type1, message1, defaultValue1) {
                var dialog1 = getDialog1(type1), messageEl1 = getTemplateEl1(dialog1, selectorClasses1.dialogMessage), inputEl1 = dialog1.getElementsByTagName("INPUT")[0], cancelBtn1 = getTemplateEl1(dialog1, selectorClasses1.dialogCancelButton), okBtn1 = getTemplateEl1(dialog1, selectorClasses1.dialogOkButton), promise1 = new qq.Promise(), closeHandler1 = function() {
                    cancelBtn1.removeEventListener("click", cancelClickHandler1);
                    okBtn1 && okBtn1.removeEventListener("click", okClickHandler1);
                    promise1.failure();
                }, cancelClickHandler1 = function() {
                    cancelBtn1.removeEventListener("click", cancelClickHandler1);
                    dialog1.close();
                }, okClickHandler1 = function() {
                    dialog1.removeEventListener("close", closeHandler1);
                    okBtn1.removeEventListener("click", okClickHandler1);
                    dialog1.close();
                    promise1.success(inputEl1 && inputEl1.value);
                };
                dialog1.addEventListener("close", closeHandler1);
                cancelBtn1.addEventListener("click", cancelClickHandler1);
                okBtn1 && okBtn1.addEventListener("click", okClickHandler1);
                if (inputEl1) inputEl1.value = defaultValue1;
                messageEl1.textContent = message1;
                dialog1.showModal();
                return promise1;
            }
        });
    };
    qq.UiEventHandler = function(s1, protectedApi1) {
        "use strict";
        var disposer1 = new qq.DisposeSupport(), spec1 = {
            eventType: "click",
            attachTo: null,
            onHandled: function(target1, event1) {}
        };
        qq.extend(this, {
            addHandler: function(element1) {
                addHandler1(element1);
            },
            dispose: function() {
                disposer1.dispose();
            }
        });
        function addHandler1(element1) {
            disposer1.attach(element1, spec1.eventType, function(event1) {
                event1 = event1 || window.event;
                var target1 = event1.target || event1.srcElement;
                spec1.onHandled(target1, event1);
            });
        }
        qq.extend(protectedApi1, {
            getFileIdFromItem: function(item1) {
                return item1.qqFileId;
            },
            getDisposeSupport: function() {
                return disposer1;
            }
        });
        qq.extend(spec1, s1);
        if (spec1.attachTo) addHandler1(spec1.attachTo);
    };
    qq.FileButtonsClickHandler = function(s1) {
        "use strict";
        var inheritedInternalApi1 = {}, spec1 = {
            templating: null,
            log: function(message1, lvl1) {},
            onDeleteFile: function(fileId1) {},
            onCancel: function(fileId1) {},
            onRetry: function(fileId1) {},
            onPause: function(fileId1) {},
            onContinue: function(fileId1) {},
            onGetName: function(fileId1) {}
        }, buttonHandlers1 = {
            cancel: function(id1) {
                spec1.onCancel(id1);
            },
            retry: function(id1) {
                spec1.onRetry(id1);
            },
            deleteButton: function(id1) {
                spec1.onDeleteFile(id1);
            },
            pause: function(id1) {
                spec1.onPause(id1);
            },
            continueButton: function(id1) {
                spec1.onContinue(id1);
            }
        };
        function examineEvent1(target1, event1) {
            qq.each(buttonHandlers1, function(buttonType1, handler1) {
                var firstLetterCapButtonType1 = buttonType1.charAt(0).toUpperCase() + buttonType1.slice(1), fileId1;
                if (spec1.templating["is" + firstLetterCapButtonType1](target1)) {
                    fileId1 = spec1.templating.getFileId(target1);
                    qq.preventDefault(event1);
                    spec1.log(qq.format("Detected valid file button click event on file '{}', ID: {}.", spec1.onGetName(fileId1), fileId1));
                    handler1(fileId1);
                    return false;
                }
            });
        }
        qq.extend(spec1, s1);
        spec1.eventType = "click";
        spec1.onHandled = examineEvent1;
        spec1.attachTo = spec1.templating.getFileList();
        qq.extend(this, new qq.UiEventHandler(spec1, inheritedInternalApi1));
    };
    qq.FilenameClickHandler = function(s1) {
        "use strict";
        var inheritedInternalApi1 = {}, spec1 = {
            templating: null,
            log: function(message1, lvl1) {},
            classes: {
                file: "qq-upload-file",
                editNameIcon: "qq-edit-filename-icon"
            },
            onGetUploadStatus: function(fileId1) {},
            onGetName: function(fileId1) {}
        };
        qq.extend(spec1, s1);
        function examineEvent1(target1, event1) {
            if (spec1.templating.isFileName(target1) || spec1.templating.isEditIcon(target1)) {
                var fileId1 = spec1.templating.getFileId(target1), status1 = spec1.onGetUploadStatus(fileId1);
                if (status1 === qq.status.SUBMITTED) {
                    spec1.log(qq.format("Detected valid filename click event on file '{}', ID: {}.", spec1.onGetName(fileId1), fileId1));
                    qq.preventDefault(event1);
                    inheritedInternalApi1.handleFilenameEdit(fileId1, target1, true);
                }
            }
        }
        spec1.eventType = "click";
        spec1.onHandled = examineEvent1;
        qq.extend(this, new qq.FilenameEditHandler(spec1, inheritedInternalApi1));
    };
    qq.FilenameInputFocusInHandler = function(s1, inheritedInternalApi1) {
        "use strict";
        var spec1 = {
            templating: null,
            onGetUploadStatus: function(fileId1) {},
            log: function(message1, lvl1) {}
        };
        if (!inheritedInternalApi1) inheritedInternalApi1 = {};
        function handleInputFocus1(target1, event1) {
            if (spec1.templating.isEditInput(target1)) {
                var fileId1 = spec1.templating.getFileId(target1), status1 = spec1.onGetUploadStatus(fileId1);
                if (status1 === qq.status.SUBMITTED) {
                    spec1.log(qq.format("Detected valid filename input focus event on file '{}', ID: {}.", spec1.onGetName(fileId1), fileId1));
                    inheritedInternalApi1.handleFilenameEdit(fileId1, target1);
                }
            }
        }
        spec1.eventType = "focusin";
        spec1.onHandled = handleInputFocus1;
        qq.extend(spec1, s1);
        qq.extend(this, new qq.FilenameEditHandler(spec1, inheritedInternalApi1));
    };
    qq.FilenameInputFocusHandler = function(spec1) {
        "use strict";
        spec1.eventType = "focus";
        spec1.attachTo = null;
        qq.extend(this, new qq.FilenameInputFocusInHandler(spec1, {}));
    };
    qq.FilenameEditHandler = function(s1, inheritedInternalApi1) {
        "use strict";
        var spec1 = {
            templating: null,
            log: function(message1, lvl1) {},
            onGetUploadStatus: function(fileId1) {},
            onGetName: function(fileId1) {},
            onSetName: function(fileId1, newName1) {},
            onEditingStatusChange: function(fileId1, isEditing1) {}
        };
        function getFilenameSansExtension1(fileId1) {
            var filenameSansExt1 = spec1.onGetName(fileId1), extIdx1 = filenameSansExt1.lastIndexOf(".");
            if (extIdx1 > 0) filenameSansExt1 = filenameSansExt1.substr(0, extIdx1);
            return filenameSansExt1;
        }
        function getOriginalExtension1(fileId1) {
            var origName1 = spec1.onGetName(fileId1);
            return qq.getExtension(origName1);
        }
        function handleNameUpdate1(newFilenameInputEl1, fileId1) {
            var newName1 = newFilenameInputEl1.value, origExtension1;
            if (newName1 !== undefined && qq.trimStr(newName1).length > 0) {
                origExtension1 = getOriginalExtension1(fileId1);
                if (origExtension1 !== undefined) newName1 = newName1 + "." + origExtension1;
                spec1.onSetName(fileId1, newName1);
            }
            spec1.onEditingStatusChange(fileId1, false);
        }
        function registerInputBlurHandler1(inputEl1, fileId1) {
            inheritedInternalApi1.getDisposeSupport().attach(inputEl1, "blur", function() {
                handleNameUpdate1(inputEl1, fileId1);
            });
        }
        function registerInputEnterKeyHandler1(inputEl1, fileId1) {
            inheritedInternalApi1.getDisposeSupport().attach(inputEl1, "keyup", function(event1) {
                var code1 = event1.keyCode || event1.which;
                if (code1 === 13) handleNameUpdate1(inputEl1, fileId1);
            });
        }
        qq.extend(spec1, s1);
        spec1.attachTo = spec1.templating.getFileList();
        qq.extend(this, new qq.UiEventHandler(spec1, inheritedInternalApi1));
        qq.extend(inheritedInternalApi1, {
            handleFilenameEdit: function(id1, target1, focusInput1) {
                var newFilenameInputEl1 = spec1.templating.getEditInput(id1);
                spec1.onEditingStatusChange(id1, true);
                newFilenameInputEl1.value = getFilenameSansExtension1(id1);
                if (focusInput1) newFilenameInputEl1.focus();
                registerInputBlurHandler1(newFilenameInputEl1, id1);
                registerInputEnterKeyHandler1(newFilenameInputEl1, id1);
            }
        });
    };
    (function() {
        "use strict";
        qq.s3.FineUploader = function(o1) {
            var options1 = {
                failedUploadTextDisplay: {
                    mode: "custom"
                }
            };
            qq.extend(options1, o1, true);
            qq.FineUploader.call(this, options1, "s3");
            if (!qq.supportedFeatures.ajaxUploading && options1.iframeSupport.localBlankPagePath === undefined) this._options.element.innerHTML = "<div>You MUST set the <code>localBlankPagePath</code> property of the <code>iframeSupport</code> option since this browser does not support the File API!</div>";
        };
        qq.extend(qq.s3.FineUploader.prototype, qq.s3.FineUploaderBasic.prototype);
        qq.extend(qq.s3.FineUploader.prototype, qq.uiPublicApi);
        qq.extend(qq.s3.FineUploader.prototype, qq.uiPrivateApi);
    })();
})(window);

},{}],"cN1Lf":[function(require,module,exports) {
/*!
 * numeral.js
 * version : 1.5.3
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function() {
    /************************************
        Constants
    ************************************/ var numeral, VERSION = "1.5.3", // internal storage for language config files
    languages = {}, currentLanguage = "en", zeroFormat = null, defaultFormat = "0,0", // check for nodeJS
    hasModule = (0, module.exports);
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(number) {
        this._value = number;
    }
    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */ function toFixed(value, precision, roundingFunction, optionals) {
        var power = Math.pow(10, precision), optionalsRegExp, output;
        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
        // Multiply up by precision, round accurately, then divide and use native toFixed():
        output = (roundingFunction(value * power) / power).toFixed(precision);
        if (optionals) {
            optionalsRegExp = new RegExp("0{1," + optionals + "}$");
            output = output.replace(optionalsRegExp, "");
        }
        return output;
    }
    /************************************
        Formatting
    ************************************/ // determine what type of formatting we need to do
    function formatNumeral(n, format, roundingFunction) {
        var output;
        // figure out what kind of format we are dealing with
        if (format.indexOf("$") > -1) output = formatCurrency(n, format, roundingFunction);
        else if (format.indexOf("%") > -1) output = formatPercentage(n, format, roundingFunction);
        else if (format.indexOf(":") > -1) output = formatTime(n, format);
        else output = formatNumber(n._value, format, roundingFunction);
        // return string
        return output;
    }
    // revert to number
    function unformatNumeral(n, string) {
        var stringOriginal = string, thousandRegExp, millionRegExp, billionRegExp, trillionRegExp, suffixes = [
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ], bytesMultiplier = false, power;
        if (string.indexOf(":") > -1) n._value = unformatTime(string);
        else if (string === zeroFormat) n._value = 0;
        else {
            if (languages[currentLanguage].delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(languages[currentLanguage].delimiters.decimal, ".");
            // see if abbreviations are there so that we can multiply to the correct number
            thousandRegExp = new RegExp("[^a-zA-Z]" + languages[currentLanguage].abbreviations.thousand + "(?:\\)|(\\" + languages[currentLanguage].currency.symbol + ")?(?:\\))?)?$");
            millionRegExp = new RegExp("[^a-zA-Z]" + languages[currentLanguage].abbreviations.million + "(?:\\)|(\\" + languages[currentLanguage].currency.symbol + ")?(?:\\))?)?$");
            billionRegExp = new RegExp("[^a-zA-Z]" + languages[currentLanguage].abbreviations.billion + "(?:\\)|(\\" + languages[currentLanguage].currency.symbol + ")?(?:\\))?)?$");
            trillionRegExp = new RegExp("[^a-zA-Z]" + languages[currentLanguage].abbreviations.trillion + "(?:\\)|(\\" + languages[currentLanguage].currency.symbol + ")?(?:\\))?)?$");
            // see if bytes are there so that we can multiply to the correct number
            for(power = 0; power <= suffixes.length; power++){
                bytesMultiplier = string.indexOf(suffixes[power]) > -1 ? Math.pow(1024, power + 1) : false;
                if (bytesMultiplier) break;
            }
            // do some math to create our number
            n._value = (bytesMultiplier ? bytesMultiplier : 1) * (stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1) * (stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1) * (stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1) * (stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1) * (string.indexOf("%") > -1 ? 0.01 : 1) * ((string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1) * Number(string.replace(/[^0-9\.]+/g, ""));
            // round if we are talking about bytes
            n._value = bytesMultiplier ? Math.ceil(n._value) : n._value;
        }
        return n._value;
    }
    function formatCurrency(n, format, roundingFunction) {
        var symbolIndex = format.indexOf("$"), openParenIndex = format.indexOf("("), minusSignIndex = format.indexOf("-"), space = "", spliceIndex, output;
        // check for space before or after currency
        if (format.indexOf(" $") > -1) {
            space = " ";
            format = format.replace(" $", "");
        } else if (format.indexOf("$ ") > -1) {
            space = " ";
            format = format.replace("$ ", "");
        } else format = format.replace("$", "");
        // format the number
        output = formatNumber(n._value, format, roundingFunction);
        // position the symbol
        if (symbolIndex <= 1) {
            if (output.indexOf("(") > -1 || output.indexOf("-") > -1) {
                output = output.split("");
                spliceIndex = 1;
                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) // the symbol appears before the "(" or "-"
                spliceIndex = 0;
                output.splice(spliceIndex, 0, languages[currentLanguage].currency.symbol + space);
                output = output.join("");
            } else output = languages[currentLanguage].currency.symbol + space + output;
        } else if (output.indexOf(")") > -1) {
            output = output.split("");
            output.splice(-1, 0, space + languages[currentLanguage].currency.symbol);
            output = output.join("");
        } else output = output + space + languages[currentLanguage].currency.symbol;
        return output;
    }
    function formatPercentage(n, format, roundingFunction) {
        var space = "", output, value = n._value * 100;
        // check for space before %
        if (format.indexOf(" %") > -1) {
            space = " ";
            format = format.replace(" %", "");
        } else format = format.replace("%", "");
        output = formatNumber(value, format, roundingFunction);
        if (output.indexOf(")") > -1) {
            output = output.split("");
            output.splice(-1, 0, space + "%");
            output = output.join("");
        } else output = output + space + "%";
        return output;
    }
    function formatTime(n) {
        var hours = Math.floor(n._value / 60 / 60), minutes = Math.floor((n._value - hours * 3600) / 60), seconds = Math.round(n._value - hours * 3600 - minutes * 60);
        return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
    }
    function unformatTime(string) {
        var timeArray = string.split(":"), seconds = 0;
        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
            // hours
            seconds = seconds + Number(timeArray[0]) * 3600;
            // minutes
            seconds = seconds + Number(timeArray[1]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + Number(timeArray[0]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
    }
    function formatNumber(value, format, roundingFunction) {
        var negP = false, signed = false, optDec = false, abbr = "", abbrK = false, abbrM = false, abbrB = false, abbrT = false, abbrForce = false, bytes = "", ord = "", abs = Math.abs(value), suffixes = [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ], min, max, power, w, precision, thousands, d = "", neg = false;
        // check if number is zero and a custom zero format has been set
        if (value === 0 && zeroFormat !== null) return zeroFormat;
        else {
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (format.indexOf("(") > -1) {
                negP = true;
                format = format.slice(1, -1);
            } else if (format.indexOf("+") > -1) {
                signed = true;
                format = format.replace(/\+/g, "");
            }
            // see if abbreviation is wanted
            if (format.indexOf("a") > -1) {
                // check if abbreviation is specified
                abbrK = format.indexOf("aK") >= 0;
                abbrM = format.indexOf("aM") >= 0;
                abbrB = format.indexOf("aB") >= 0;
                abbrT = format.indexOf("aT") >= 0;
                abbrForce = abbrK || abbrM || abbrB || abbrT;
                // check for space before abbreviation
                if (format.indexOf(" a") > -1) {
                    abbr = " ";
                    format = format.replace(" a", "");
                } else format = format.replace("a", "");
                if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
                    // trillion
                    abbr = abbr + languages[currentLanguage].abbreviations.trillion;
                    value = value / Math.pow(10, 12);
                } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
                    // billion
                    abbr = abbr + languages[currentLanguage].abbreviations.billion;
                    value = value / Math.pow(10, 9);
                } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
                    // million
                    abbr = abbr + languages[currentLanguage].abbreviations.million;
                    value = value / Math.pow(10, 6);
                } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
                    // thousand
                    abbr = abbr + languages[currentLanguage].abbreviations.thousand;
                    value = value / Math.pow(10, 3);
                }
            }
            // see if we are formatting bytes
            if (format.indexOf("b") > -1) {
                // check for space before
                if (format.indexOf(" b") > -1) {
                    bytes = " ";
                    format = format.replace(" b", "");
                } else format = format.replace("b", "");
                for(power = 0; power <= suffixes.length; power++){
                    min = Math.pow(1024, power);
                    max = Math.pow(1024, power + 1);
                    if (value >= min && value < max) {
                        bytes = bytes + suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
            }
            // see if ordinal is wanted
            if (format.indexOf("o") > -1) {
                // check for space before
                if (format.indexOf(" o") > -1) {
                    ord = " ";
                    format = format.replace(" o", "");
                } else format = format.replace("o", "");
                ord = ord + languages[currentLanguage].ordinal(value);
            }
            if (format.indexOf("[.]") > -1) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            w = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            if (precision) {
                if (precision.indexOf("[") > -1) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else d = toFixed(value, precision.length, roundingFunction);
                w = d.split(".")[0];
                if (d.split(".")[1].length) d = languages[currentLanguage].delimiters.decimal + d.split(".")[1];
                else d = "";
                if (optDec && Number(d.slice(1)) === 0) d = "";
            } else w = toFixed(value, null, roundingFunction);
            // format number
            if (w.indexOf("-") > -1) {
                w = w.slice(1);
                neg = true;
            }
            if (thousands > -1) w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + languages[currentLanguage].delimiters.thousands);
            if (format.indexOf(".") === 0) w = "";
            return (negP && neg ? "(" : "") + (!negP && neg ? "-" : "") + (!neg && signed ? "+" : "") + w + d + (ord ? ord : "") + (abbr ? abbr : "") + (bytes ? bytes : "") + (negP && neg ? ")" : "");
        }
    }
    /************************************
        Top Level Functions
    ************************************/ numeral = function(input) {
        if (numeral.isNumeral(input)) input = input.value();
        else if (input === 0 || typeof input === "undefined") input = 0;
        else if (!Number(input)) input = numeral.fn.unformat(input);
        return new Numeral(Number(input));
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    numeral.language = function(key, values) {
        if (!key) return currentLanguage;
        if (key && !values) {
            if (!languages[key]) throw new Error("Unknown language : " + key);
            currentLanguage = key;
        }
        if (values || !languages[key]) loadLanguage(key, values);
        return numeral;
    };
    // This function provides access to the loaded language data.  If
    // no arguments are passed in, it will simply return the current
    // global language object.
    numeral.languageData = function(key) {
        if (!key) return languages[currentLanguage];
        if (!languages[key]) throw new Error("Unknown language : " + key);
        return languages[key];
    };
    numeral.language("en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    numeral.zeroFormat = function(format) {
        zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        defaultFormat = typeof format === "string" ? format : "0.0";
    };
    /************************************
        Helpers
    ************************************/ function loadLanguage(key, values) {
        languages[key] = values;
    }
    /************************************
        Floating-point helpers
    ************************************/ // The floating-point helper functions and implementation
    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
    /**
     * Array.prototype.reduce for browsers that don't support it
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce#Compatibility
     */ if ("function" !== typeof Array.prototype.reduce) Array.prototype.reduce = function(callback, opt_initialValue) {
        "use strict";
        if (null === this || "undefined" === typeof this) // At the moment all modern browsers, that support strict mode, have
        // native implementation of Array.prototype.reduce. For instance, IE8
        // does not support strict mode, so this check is actually useless.
        throw new TypeError("Array.prototype.reduce called on null or undefined");
        if ("function" !== typeof callback) throw new TypeError(callback + " is not a function");
        var index, value, length = this.length >>> 0, isValueSet = false;
        if (1 < arguments.length) {
            value = opt_initialValue;
            isValueSet = true;
        }
        for(index = 0; length > index; ++index)if (this.hasOwnProperty(index)) {
            if (isValueSet) value = callback(value, this[index], index, this);
            else {
                value = this[index];
                isValueSet = true;
            }
        }
        if (!isValueSet) throw new TypeError("Reduce of empty array with no initial value");
        return value;
    };
    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */ function multiplier(x) {
        var parts = x.toString().split(".");
        if (parts.length < 2) return 1;
        return Math.pow(10, parts[1].length);
    }
    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */ function correctionFactor() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(prev, next) {
            var mp = multiplier(prev), mn = multiplier(next);
            return mp > mn ? mp : mn;
        }, -Infinity);
    }
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            return formatNumeral(this, inputString ? inputString : defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
        },
        unformat: function(inputString) {
            if (Object.prototype.toString.call(inputString) === "[object Number]") return inputString;
            return unformatNumeral(this, inputString ? inputString : defaultFormat);
        },
        value: function() {
            return this._value;
        },
        valueOf: function() {
            return this._value;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + corrFactor * curr;
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - corrFactor * curr;
            }
            this._value = [
                value
            ].reduce(cback, this._value * corrFactor) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor / (curr * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Exposing Numeral
    ************************************/ // CommonJS module is defined
    if (hasModule) module.exports = numeral;
    /*global ender:false */ if (typeof ender === "undefined") // here, `this` means `window` in the browser, or `global` on the server
    // add `numeral` as a global object via a string identifier,
    // for Closure Compiler 'advanced' mode
    this["numeral"] = numeral;
    /*global define:false */ if (typeof define === "function" && define.amd) define([], function() {
        return numeral;
    });
}).call(this);

},{}],"eBiPu":[function(require,module,exports) {
/* jquery.nicescroll 3.6.0 InuYaksa*2014 MIT http://nicescroll.areaaperta.com */ (function(f) {
    "function" === typeof define && define.amd ? define([
        "jquery"
    ], f) : f(jQuery);
})(function(f) {
    var y = !1, D = !1, N = 0, O = 2E3, x = 0, H = [
        "webkit",
        "ms",
        "moz",
        "o"
    ], s = window.requestAnimationFrame || !1, t = window.cancelAnimationFrame || !1;
    if (!s) for(var P in H){
        var E = H[P];
        s || (s = window[E + "RequestAnimationFrame"]);
        t || (t = window[E + "CancelAnimationFrame"] || window[E + "CancelRequestAnimationFrame"]);
    }
    var v = window.MutationObserver || window.WebKitMutationObserver || !1, I = {
        zindex: "auto",
        cursoropacitymin: 0,
        cursoropacitymax: 1,
        cursorcolor: "#424242",
        cursorwidth: "5px",
        cursorborder: "1px solid #fff",
        cursorborderradius: "5px",
        scrollspeed: 60,
        mousescrollstep: 24,
        touchbehavior: !1,
        hwacceleration: !0,
        usetransition: !0,
        boxzoom: !1,
        dblclickzoom: !0,
        gesturezoom: !0,
        grabcursorenabled: !0,
        autohidemode: !0,
        background: "",
        iframeautoresize: !0,
        cursorminheight: 32,
        preservenativescrolling: !0,
        railoffset: !1,
        railhoffset: !1,
        bouncescroll: !0,
        spacebarenabled: !0,
        railpadding: {
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
        },
        disableoutline: !0,
        horizrailenabled: !0,
        railalign: "right",
        railvalign: "bottom",
        enabletranslate3d: !0,
        enablemousewheel: !0,
        enablekeyboard: !0,
        smoothscroll: !0,
        sensitiverail: !0,
        enablemouselockapi: !0,
        cursorfixedheight: !1,
        directionlockdeadzone: 6,
        hidecursordelay: 400,
        nativeparentscrolling: !0,
        enablescrollonselection: !0,
        overflowx: !0,
        overflowy: !0,
        cursordragspeed: .3,
        rtlmode: "auto",
        cursordragontouch: !1,
        oneaxismousemode: "auto",
        scriptpath: function() {
            var f = document.getElementsByTagName("script"), f = f[f.length - 1].src.split("?")[0];
            return 0 < f.split("/").length ? f.split("/").slice(0, -1).join("/") + "/" : "";
        }(),
        preventmultitouchscrolling: !0
    }, F = !1, Q = function() {
        if (F) return F;
        var f = document.createElement("DIV"), c = f.style, h = navigator.userAgent, m = navigator.platform, d = {
            haspointerlock: "pointerLockElement" in document || "webkitPointerLockElement" in document || "mozPointerLockElement" in document
        };
        d.isopera = "opera" in window;
        d.isopera12 = d.isopera && "getUserMedia" in navigator;
        d.isoperamini = "[object OperaMini]" === Object.prototype.toString.call(window.operamini);
        d.isie = "all" in document && "attachEvent" in f && !d.isopera;
        d.isieold = d.isie && !("msInterpolationMode" in c);
        d.isie7 = d.isie && !d.isieold && (!("documentMode" in document) || 7 == document.documentMode);
        d.isie8 = d.isie && "documentMode" in document && 8 == document.documentMode;
        d.isie9 = d.isie && "performance" in window && 9 <= document.documentMode;
        d.isie10 = d.isie && "performance" in window && 10 == document.documentMode;
        d.isie11 = "msRequestFullscreen" in f && 11 <= document.documentMode;
        d.isie9mobile = /iemobile.9/i.test(h);
        d.isie9mobile && (d.isie9 = !1);
        d.isie7mobile = !d.isie9mobile && d.isie7 && /iemobile/i.test(h);
        d.ismozilla = "MozAppearance" in c;
        d.iswebkit = "WebkitAppearance" in c;
        d.ischrome = "chrome" in window;
        d.ischrome22 = d.ischrome && d.haspointerlock;
        d.ischrome26 = d.ischrome && "transition" in c;
        d.cantouch = "ontouchstart" in document.documentElement || "ontouchstart" in window;
        d.hasmstouch = window.MSPointerEvent || !1;
        d.hasw3ctouch = window.PointerEvent || !1;
        d.ismac = /^mac$/i.test(m);
        d.isios = d.cantouch && /iphone|ipad|ipod/i.test(m);
        d.isios4 = d.isios && !("seal" in Object);
        d.isios7 = d.isios && "webkitHidden" in document;
        d.isandroid = /android/i.test(h);
        d.haseventlistener = "addEventListener" in f;
        d.trstyle = !1;
        d.hastransform = !1;
        d.hastranslate3d = !1;
        d.transitionstyle = !1;
        d.hastransition = !1;
        d.transitionend = !1;
        m = [
            "transform",
            "msTransform",
            "webkitTransform",
            "MozTransform",
            "OTransform"
        ];
        for(h = 0; h < m.length; h++)if ("undefined" != typeof c[m[h]]) {
            d.trstyle = m[h];
            break;
        }
        d.hastransform = !!d.trstyle;
        d.hastransform && (c[d.trstyle] = "translate3d(1px,2px,3px)", d.hastranslate3d = /translate3d/.test(c[d.trstyle]));
        d.transitionstyle = !1;
        d.prefixstyle = "";
        d.transitionend = !1;
        for(var m = "transition webkitTransition msTransition MozTransition OTransition OTransition KhtmlTransition".split(" "), n = " -webkit- -ms- -moz- -o- -o -khtml-".split(" "), p = "transitionend webkitTransitionEnd msTransitionEnd transitionend otransitionend oTransitionEnd KhtmlTransitionEnd".split(" "), h = 0; h < m.length; h++)if (m[h] in c) {
            d.transitionstyle = m[h];
            d.prefixstyle = n[h];
            d.transitionend = p[h];
            break;
        }
        d.ischrome26 && (d.prefixstyle = n[1]);
        d.hastransition = d.transitionstyle;
        a: {
            h = [
                "-webkit-grab",
                "-moz-grab",
                "grab"
            ];
            if (d.ischrome && !d.ischrome22 || d.isie) h = [];
            for(m = 0; m < h.length; m++)if (n = h[m], c.cursor = n, c.cursor == n) {
                c = n;
                break a;
            }
            c = "url(//mail.google.com/mail/images/2/openhand.cur),n-resize";
        }
        d.cursorgrabvalue = c;
        d.hasmousecapture = "setCapture" in f;
        d.hasMutationObserver = !1 !== v;
        return F = d;
    }, R = function(k, c) {
        function h() {
            var b = a.doc.css(e.trstyle);
            return b && "matrix" == b.substr(0, 6) ? b.replace(/^.*\((.*)\)$/g, "$1").replace(/px/g, "").split(/, +/) : !1;
        }
        function m() {
            var b = a.win;
            if ("zIndex" in b) return b.zIndex();
            for(; 0 < b.length && 9 != b[0].nodeType;){
                var g = b.css("zIndex");
                if (!isNaN(g) && 0 != g) return parseInt(g);
                b = b.parent();
            }
            return !1;
        }
        function d(b, g, q) {
            g = b.css(g);
            b = parseFloat(g);
            return isNaN(b) ? (b = w[g] || 0, q = 3 == b ? q ? a.win.outerHeight() - a.win.innerHeight() : a.win.outerWidth() - a.win.innerWidth() : 1, a.isie8 && b && (b += 1), q ? b : 0) : b;
        }
        function n(b, g, q, c) {
            a._bind(b, g, function(a) {
                a = a ? a : window.event;
                var c = {
                    original: a,
                    target: a.target || a.srcElement,
                    type: "wheel",
                    deltaMode: "MozMousePixelScroll" == a.type ? 0 : 1,
                    deltaX: 0,
                    deltaZ: 0,
                    preventDefault: function() {
                        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
                        return !1;
                    },
                    stopImmediatePropagation: function() {
                        a.stopImmediatePropagation ? a.stopImmediatePropagation() : a.cancelBubble = !0;
                    }
                };
                "mousewheel" == g ? (c.deltaY = -0.025 * a.wheelDelta, a.wheelDeltaX && (c.deltaX = -0.025 * a.wheelDeltaX)) : c.deltaY = a.detail;
                return q.call(b, c);
            }, c);
        }
        function p(b, g, c) {
            var d, e;
            0 == b.deltaMode ? (d = -Math.floor(a.opt.mousescrollstep / 54 * b.deltaX), e = -Math.floor(a.opt.mousescrollstep / 54 * b.deltaY)) : 1 == b.deltaMode && (d = -Math.floor(b.deltaX * a.opt.mousescrollstep), e = -Math.floor(b.deltaY * a.opt.mousescrollstep));
            g && a.opt.oneaxismousemode && 0 == d && e && (d = e, e = 0, c && (0 > d ? a.getScrollLeft() >= a.page.maxw : 0 >= a.getScrollLeft()) && (e = d, d = 0));
            d && (a.scrollmom && a.scrollmom.stop(), a.lastdeltax += d, a.debounced("mousewheelx", function() {
                var b = a.lastdeltax;
                a.lastdeltax = 0;
                a.rail.drag || a.doScrollLeftBy(b);
            }, 15));
            if (e) {
                if (a.opt.nativeparentscrolling && c && !a.ispage && !a.zoomactive) {
                    if (0 > e) {
                        if (a.getScrollTop() >= a.page.maxh) return !0;
                    } else if (0 >= a.getScrollTop()) return !0;
                }
                a.scrollmom && a.scrollmom.stop();
                a.lastdeltay += e;
                a.debounced("mousewheely", function() {
                    var b = a.lastdeltay;
                    a.lastdeltay = 0;
                    a.rail.drag || a.doScrollBy(b);
                }, 15);
            }
            b.stopImmediatePropagation();
            return b.preventDefault();
        }
        var a = this;
        this.version = "3.6.0";
        this.name = "nicescroll";
        this.me = c;
        this.opt = {
            doc: f("body"),
            win: !1
        };
        f.extend(this.opt, I);
        this.opt.snapbackspeed = 80;
        if (k) for(var G in a.opt)"undefined" != typeof k[G] && (a.opt[G] = k[G]);
        this.iddoc = (this.doc = a.opt.doc) && this.doc[0] ? this.doc[0].id || "" : "";
        this.ispage = /^BODY|HTML/.test(a.opt.win ? a.opt.win[0].nodeName : this.doc[0].nodeName);
        this.haswrapper = !1 !== a.opt.win;
        this.win = a.opt.win || (this.ispage ? f(window) : this.doc);
        this.docscroll = this.ispage && !this.haswrapper ? f(window) : this.win;
        this.body = f("body");
        this.iframe = this.isfixed = this.viewport = !1;
        this.isiframe = "IFRAME" == this.doc[0].nodeName && "IFRAME" == this.win[0].nodeName;
        this.istextarea = "TEXTAREA" == this.win[0].nodeName;
        this.forcescreen = !1;
        this.canshowonmouseevent = "scroll" != a.opt.autohidemode;
        this.page = this.view = this.onzoomout = this.onzoomin = this.onscrollcancel = this.onscrollend = this.onscrollstart = this.onclick = this.ongesturezoom = this.onkeypress = this.onmousewheel = this.onmousemove = this.onmouseup = this.onmousedown = !1;
        this.scroll = {
            x: 0,
            y: 0
        };
        this.scrollratio = {
            x: 0,
            y: 0
        };
        this.cursorheight = 20;
        this.scrollvaluemax = 0;
        this.isrtlmode = "auto" == this.opt.rtlmode ? "rtl" == (this.win[0] == window ? this.body : this.win).css("direction") : !0 === this.opt.rtlmode;
        this.observerbody = this.observerremover = this.observer = this.scrollmom = this.scrollrunning = !1;
        do this.id = "ascrail" + O++;
        while (document.getElementById(this.id));
        this.hasmousefocus = this.hasfocus = this.zoomactive = this.zoom = this.selectiondrag = this.cursorfreezed = this.cursor = this.rail = !1;
        this.visibility = !0;
        this.hidden = this.locked = this.railslocked = !1;
        this.cursoractive = !0;
        this.wheelprevented = !1;
        this.overflowx = a.opt.overflowx;
        this.overflowy = a.opt.overflowy;
        this.nativescrollingarea = !1;
        this.checkarea = 0;
        this.events = [];
        this.saved = {};
        this.delaylist = {};
        this.synclist = {};
        this.lastdeltay = this.lastdeltax = 0;
        this.detected = Q();
        var e = f.extend({}, this.detected);
        this.ishwscroll = (this.canhwscroll = e.hastransform && a.opt.hwacceleration) && a.haswrapper;
        this.hasreversehr = this.isrtlmode && !e.iswebkit;
        this.istouchcapable = !1;
        !e.cantouch || e.isios || e.isandroid || !e.iswebkit && !e.ismozilla || (this.istouchcapable = !0, e.cantouch = !1);
        a.opt.enablemouselockapi || (e.hasmousecapture = !1, e.haspointerlock = !1);
        this.debounced = function(b, g, c) {
            var d = a.delaylist[b];
            a.delaylist[b] = g;
            d || setTimeout(function() {
                var g = a.delaylist[b];
                a.delaylist[b] = !1;
                g.call(a);
            }, c);
        };
        var r = !1;
        this.synched = function(b, g) {
            a.synclist[b] = g;
            (function() {
                r || (s(function() {
                    r = !1;
                    for(var b in a.synclist){
                        var g = a.synclist[b];
                        g && g.call(a);
                        a.synclist[b] = !1;
                    }
                }), r = !0);
            })();
            return b;
        };
        this.unsynched = function(b) {
            a.synclist[b] && (a.synclist[b] = !1);
        };
        this.css = function(b, g) {
            for(var c in g)a.saved.css.push([
                b,
                c,
                b.css(c)
            ]), b.css(c, g[c]);
        };
        this.scrollTop = function(b) {
            return "undefined" == typeof b ? a.getScrollTop() : a.setScrollTop(b);
        };
        this.scrollLeft = function(b) {
            return "undefined" == typeof b ? a.getScrollLeft() : a.setScrollLeft(b);
        };
        var A = function(a, g, c, d, e, f, h) {
            this.st = a;
            this.ed = g;
            this.spd = c;
            this.p1 = d || 0;
            this.p2 = e || 1;
            this.p3 = f || 0;
            this.p4 = h || 1;
            this.ts = (new Date).getTime();
            this.df = this.ed - this.st;
        };
        A.prototype = {
            B2: function(a) {
                return 3 * a * a * (1 - a);
            },
            B3: function(a) {
                return 3 * a * (1 - a) * (1 - a);
            },
            B4: function(a) {
                return (1 - a) * (1 - a) * (1 - a);
            },
            getNow: function() {
                var a = 1 - ((new Date).getTime() - this.ts) / this.spd, g = this.B2(a) + this.B3(a) + this.B4(a);
                return 0 > a ? this.ed : this.st + Math.round(this.df * g);
            },
            update: function(a, g) {
                this.st = this.getNow();
                this.ed = a;
                this.spd = g;
                this.ts = (new Date).getTime();
                this.df = this.ed - this.st;
                return this;
            }
        };
        if (this.ishwscroll) {
            this.doc.translate = {
                x: 0,
                y: 0,
                tx: "0px",
                ty: "0px"
            };
            e.hastranslate3d && e.isios && this.doc.css("-webkit-backface-visibility", "hidden");
            this.getScrollTop = function(b) {
                if (!b) {
                    if (b = h()) return 16 == b.length ? -b[13] : -b[5];
                    if (a.timerscroll && a.timerscroll.bz) return a.timerscroll.bz.getNow();
                }
                return a.doc.translate.y;
            };
            this.getScrollLeft = function(b) {
                if (!b) {
                    if (b = h()) return 16 == b.length ? -b[12] : -b[4];
                    if (a.timerscroll && a.timerscroll.bh) return a.timerscroll.bh.getNow();
                }
                return a.doc.translate.x;
            };
            this.notifyScrollEvent = function(a) {
                var g = document.createEvent("UIEvents");
                g.initUIEvent("scroll", !1, !0, window, 1);
                g.niceevent = !0;
                a.dispatchEvent(g);
            };
            var K = this.isrtlmode ? 1 : -1;
            e.hastranslate3d && a.opt.enabletranslate3d ? (this.setScrollTop = function(b, g) {
                a.doc.translate.y = b;
                a.doc.translate.ty = -1 * b + "px";
                a.doc.css(e.trstyle, "translate3d(" + a.doc.translate.tx + "," + a.doc.translate.ty + ",0px)");
                g || a.notifyScrollEvent(a.win[0]);
            }, this.setScrollLeft = function(b, g) {
                a.doc.translate.x = b;
                a.doc.translate.tx = b * K + "px";
                a.doc.css(e.trstyle, "translate3d(" + a.doc.translate.tx + "," + a.doc.translate.ty + ",0px)");
                g || a.notifyScrollEvent(a.win[0]);
            }) : (this.setScrollTop = function(b, g) {
                a.doc.translate.y = b;
                a.doc.translate.ty = -1 * b + "px";
                a.doc.css(e.trstyle, "translate(" + a.doc.translate.tx + "," + a.doc.translate.ty + ")");
                g || a.notifyScrollEvent(a.win[0]);
            }, this.setScrollLeft = function(b, g) {
                a.doc.translate.x = b;
                a.doc.translate.tx = b * K + "px";
                a.doc.css(e.trstyle, "translate(" + a.doc.translate.tx + "," + a.doc.translate.ty + ")");
                g || a.notifyScrollEvent(a.win[0]);
            });
        } else this.getScrollTop = function() {
            return a.docscroll.scrollTop();
        }, this.setScrollTop = function(b) {
            return a.docscroll.scrollTop(b);
        }, this.getScrollLeft = function() {
            return a.detected.ismozilla && a.isrtlmode ? Math.abs(a.docscroll.scrollLeft()) : a.docscroll.scrollLeft();
        }, this.setScrollLeft = function(b) {
            return a.docscroll.scrollLeft(a.detected.ismozilla && a.isrtlmode ? -b : b);
        };
        this.getTarget = function(a) {
            return a ? a.target ? a.target : a.srcElement ? a.srcElement : !1 : !1;
        };
        this.hasParent = function(a, g) {
            if (!a) return !1;
            for(var c = a.target || a.srcElement || a || !1; c && c.id != g;)c = c.parentNode || !1;
            return !1 !== c;
        };
        var w = {
            thin: 1,
            medium: 3,
            thick: 5
        };
        this.getDocumentScrollOffset = function() {
            return {
                top: window.pageYOffset || document.documentElement.scrollTop,
                left: window.pageXOffset || document.documentElement.scrollLeft
            };
        };
        this.getOffset = function() {
            if (a.isfixed) {
                var b = a.win.offset(), g = a.getDocumentScrollOffset();
                b.top -= g.top;
                b.left -= g.left;
                return b;
            }
            b = a.win.offset();
            if (!a.viewport) return b;
            g = a.viewport.offset();
            return {
                top: b.top - g.top,
                left: b.left - g.left
            };
        };
        this.updateScrollBar = function(b) {
            if (a.ishwscroll) a.rail.css({
                height: a.win.innerHeight() - (a.opt.railpadding.top + a.opt.railpadding.bottom)
            }), a.railh && a.railh.css({
                width: a.win.innerWidth() - (a.opt.railpadding.left + a.opt.railpadding.right)
            });
            else {
                var g = a.getOffset(), c = g.top, e = g.left - (a.opt.railpadding.left + a.opt.railpadding.right), c = c + d(a.win, "border-top-width", !0), e = e + (a.rail.align ? a.win.outerWidth() - d(a.win, "border-right-width") - a.rail.width : d(a.win, "border-left-width")), f = a.opt.railoffset;
                f && (f.top && (c += f.top), a.rail.align && f.left && (e += f.left));
                a.railslocked || a.rail.css({
                    top: c,
                    left: e,
                    height: (b ? b.h : a.win.innerHeight()) - (a.opt.railpadding.top + a.opt.railpadding.bottom)
                });
                a.zoom && a.zoom.css({
                    top: c + 1,
                    left: 1 == a.rail.align ? e - 20 : e + a.rail.width + 4
                });
                if (a.railh && !a.railslocked) {
                    c = g.top;
                    e = g.left;
                    if (f = a.opt.railhoffset) f.top && (c += f.top), f.left && (e += f.left);
                    b = a.railh.align ? c + d(a.win, "border-top-width", !0) + a.win.innerHeight() - a.railh.height : c + d(a.win, "border-top-width", !0);
                    e += d(a.win, "border-left-width");
                    a.railh.css({
                        top: b - (a.opt.railpadding.top + a.opt.railpadding.bottom),
                        left: e,
                        width: a.railh.width
                    });
                }
            }
        };
        this.doRailClick = function(b, g, c) {
            var e;
            a.railslocked || (a.cancelEvent(b), g ? (g = c ? a.doScrollLeft : a.doScrollTop, e = c ? (b.pageX - a.railh.offset().left - a.cursorwidth / 2) * a.scrollratio.x : (b.pageY - a.rail.offset().top - a.cursorheight / 2) * a.scrollratio.y, g(e)) : (g = c ? a.doScrollLeftBy : a.doScrollBy, e = c ? a.scroll.x : a.scroll.y, b = c ? b.pageX - a.railh.offset().left : b.pageY - a.rail.offset().top, c = c ? a.view.w : a.view.h, g(e >= b ? c : -c)));
        };
        a.hasanimationframe = s;
        a.hascancelanimationframe = t;
        a.hasanimationframe ? a.hascancelanimationframe || (t = function() {
            a.cancelAnimationFrame = !0;
        }) : (s = function(a) {
            return setTimeout(a, 15 - Math.floor(+new Date / 1E3) % 16);
        }, t = clearInterval);
        this.init = function() {
            a.saved.css = [];
            if (e.isie7mobile || e.isoperamini) return !0;
            e.hasmstouch && a.css(a.ispage ? f("html") : a.win, {
                "-ms-touch-action": "none"
            });
            a.zindex = "auto";
            a.zindex = a.ispage || "auto" != a.opt.zindex ? a.opt.zindex : m() || "auto";
            !a.ispage && "auto" != a.zindex && a.zindex > x && (x = a.zindex);
            a.isie && 0 == a.zindex && "auto" == a.opt.zindex && (a.zindex = "auto");
            if (!a.ispage || !e.cantouch && !e.isieold && !e.isie9mobile) {
                var b = a.docscroll;
                a.ispage && (b = a.haswrapper ? a.win : a.doc);
                e.isie9mobile || a.css(b, {
                    "overflow-y": "hidden"
                });
                a.ispage && e.isie7 && ("BODY" == a.doc[0].nodeName ? a.css(f("html"), {
                    "overflow-y": "hidden"
                }) : "HTML" == a.doc[0].nodeName && a.css(f("body"), {
                    "overflow-y": "hidden"
                }));
                !e.isios || a.ispage || a.haswrapper || a.css(f("body"), {
                    "-webkit-overflow-scrolling": "touch"
                });
                var g = f(document.createElement("div"));
                g.css({
                    position: "relative",
                    top: 0,
                    "float": "right",
                    width: a.opt.cursorwidth,
                    height: "0px",
                    "background-color": a.opt.cursorcolor,
                    border: a.opt.cursorborder,
                    "background-clip": "padding-box",
                    "-webkit-border-radius": a.opt.cursorborderradius,
                    "-moz-border-radius": a.opt.cursorborderradius,
                    "border-radius": a.opt.cursorborderradius
                });
                g.hborder = parseFloat(g.outerHeight() - g.innerHeight());
                g.addClass("nicescroll-cursors");
                a.cursor = g;
                var c = f(document.createElement("div"));
                c.attr("id", a.id);
                c.addClass("nicescroll-rails nicescroll-rails-vr");
                var d, h, k = [
                    "left",
                    "right",
                    "top",
                    "bottom"
                ], J;
                for(J in k)h = k[J], (d = a.opt.railpadding[h]) ? c.css("padding-" + h, d + "px") : a.opt.railpadding[h] = 0;
                c.append(g);
                c.width = Math.max(parseFloat(a.opt.cursorwidth), g.outerWidth());
                c.css({
                    width: c.width + "px",
                    zIndex: a.zindex,
                    background: a.opt.background,
                    cursor: "default"
                });
                c.visibility = !0;
                c.scrollable = !0;
                c.align = "left" == a.opt.railalign ? 0 : 1;
                a.rail = c;
                g = a.rail.drag = !1;
                !a.opt.boxzoom || a.ispage || e.isieold || (g = document.createElement("div"), a.bind(g, "click", a.doZoom), a.bind(g, "mouseenter", function() {
                    a.zoom.css("opacity", a.opt.cursoropacitymax);
                }), a.bind(g, "mouseleave", function() {
                    a.zoom.css("opacity", a.opt.cursoropacitymin);
                }), a.zoom = f(g), a.zoom.css({
                    cursor: "pointer",
                    "z-index": a.zindex,
                    backgroundImage: "url(" + a.opt.scriptpath + "zoomico.png)",
                    height: 18,
                    width: 18,
                    backgroundPosition: "0px 0px"
                }), a.opt.dblclickzoom && a.bind(a.win, "dblclick", a.doZoom), e.cantouch && a.opt.gesturezoom && (a.ongesturezoom = function(b) {
                    1.5 < b.scale && a.doZoomIn(b);
                    .8 > b.scale && a.doZoomOut(b);
                    return a.cancelEvent(b);
                }, a.bind(a.win, "gestureend", a.ongesturezoom)));
                a.railh = !1;
                var l;
                a.opt.horizrailenabled && (a.css(b, {
                    "overflow-x": "hidden"
                }), g = f(document.createElement("div")), g.css({
                    position: "absolute",
                    top: 0,
                    height: a.opt.cursorwidth,
                    width: "0px",
                    "background-color": a.opt.cursorcolor,
                    border: a.opt.cursorborder,
                    "background-clip": "padding-box",
                    "-webkit-border-radius": a.opt.cursorborderradius,
                    "-moz-border-radius": a.opt.cursorborderradius,
                    "border-radius": a.opt.cursorborderradius
                }), e.isieold && g.css({
                    overflow: "hidden"
                }), g.wborder = parseFloat(g.outerWidth() - g.innerWidth()), g.addClass("nicescroll-cursors"), a.cursorh = g, l = f(document.createElement("div")), l.attr("id", a.id + "-hr"), l.addClass("nicescroll-rails nicescroll-rails-hr"), l.height = Math.max(parseFloat(a.opt.cursorwidth), g.outerHeight()), l.css({
                    height: l.height + "px",
                    zIndex: a.zindex,
                    background: a.opt.background
                }), l.append(g), l.visibility = !0, l.scrollable = !0, l.align = "top" == a.opt.railvalign ? 0 : 1, a.railh = l, a.railh.drag = !1);
                a.ispage ? (c.css({
                    position: "fixed",
                    top: "0px",
                    height: "100%"
                }), c.align ? c.css({
                    right: "0px"
                }) : c.css({
                    left: "0px"
                }), a.body.append(c), a.railh && (l.css({
                    position: "fixed",
                    left: "0px",
                    width: "100%"
                }), l.align ? l.css({
                    bottom: "0px"
                }) : l.css({
                    top: "0px"
                }), a.body.append(l))) : (a.ishwscroll ? ("static" == a.win.css("position") && a.css(a.win, {
                    position: "relative"
                }), b = "HTML" == a.win[0].nodeName ? a.body : a.win, f(b).scrollTop(0).scrollLeft(0), a.zoom && (a.zoom.css({
                    position: "absolute",
                    top: 1,
                    right: 0,
                    "margin-right": c.width + 4
                }), b.append(a.zoom)), c.css({
                    position: "absolute",
                    top: 0
                }), c.align ? c.css({
                    right: 0
                }) : c.css({
                    left: 0
                }), b.append(c), l && (l.css({
                    position: "absolute",
                    left: 0,
                    bottom: 0
                }), l.align ? l.css({
                    bottom: 0
                }) : l.css({
                    top: 0
                }), b.append(l))) : (a.isfixed = "fixed" == a.win.css("position"), b = a.isfixed ? "fixed" : "absolute", a.isfixed || (a.viewport = a.getViewport(a.win[0])), a.viewport && (a.body = a.viewport, 0 == /fixed|absolute/.test(a.viewport.css("position")) && a.css(a.viewport, {
                    position: "relative"
                })), c.css({
                    position: b
                }), a.zoom && a.zoom.css({
                    position: b
                }), a.updateScrollBar(), a.body.append(c), a.zoom && a.body.append(a.zoom), a.railh && (l.css({
                    position: b
                }), a.body.append(l))), e.isios && a.css(a.win, {
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    "-webkit-touch-callout": "none"
                }), e.isie && a.opt.disableoutline && a.win.attr("hideFocus", "true"), e.iswebkit && a.opt.disableoutline && a.win.css({
                    outline: "none"
                }));
                !1 === a.opt.autohidemode ? (a.autohidedom = !1, a.rail.css({
                    opacity: a.opt.cursoropacitymax
                }), a.railh && a.railh.css({
                    opacity: a.opt.cursoropacitymax
                })) : !0 === a.opt.autohidemode || "leave" === a.opt.autohidemode ? (a.autohidedom = f().add(a.rail), e.isie8 && (a.autohidedom = a.autohidedom.add(a.cursor)), a.railh && (a.autohidedom = a.autohidedom.add(a.railh)), a.railh && e.isie8 && (a.autohidedom = a.autohidedom.add(a.cursorh))) : "scroll" == a.opt.autohidemode ? (a.autohidedom = f().add(a.rail), a.railh && (a.autohidedom = a.autohidedom.add(a.railh))) : "cursor" == a.opt.autohidemode ? (a.autohidedom = f().add(a.cursor), a.railh && (a.autohidedom = a.autohidedom.add(a.cursorh))) : "hidden" == a.opt.autohidemode && (a.autohidedom = !1, a.hide(), a.railslocked = !1);
                if (e.isie9mobile) a.scrollmom = new L(a), a.onmangotouch = function() {
                    var b = a.getScrollTop(), c = a.getScrollLeft();
                    if (b == a.scrollmom.lastscrolly && c == a.scrollmom.lastscrollx) return !0;
                    var g = b - a.mangotouch.sy, e = c - a.mangotouch.sx;
                    if (0 != Math.round(Math.sqrt(Math.pow(e, 2) + Math.pow(g, 2)))) {
                        var d = 0 > g ? -1 : 1, f = 0 > e ? -1 : 1, q = +new Date;
                        a.mangotouch.lazy && clearTimeout(a.mangotouch.lazy);
                        80 < q - a.mangotouch.tm || a.mangotouch.dry != d || a.mangotouch.drx != f ? (a.scrollmom.stop(), a.scrollmom.reset(c, b), a.mangotouch.sy = b, a.mangotouch.ly = b, a.mangotouch.sx = c, a.mangotouch.lx = c, a.mangotouch.dry = d, a.mangotouch.drx = f, a.mangotouch.tm = q) : (a.scrollmom.stop(), a.scrollmom.update(a.mangotouch.sx - e, a.mangotouch.sy - g), a.mangotouch.tm = q, g = Math.max(Math.abs(a.mangotouch.ly - b), Math.abs(a.mangotouch.lx - c)), a.mangotouch.ly = b, a.mangotouch.lx = c, 2 < g && (a.mangotouch.lazy = setTimeout(function() {
                            a.mangotouch.lazy = !1;
                            a.mangotouch.dry = 0;
                            a.mangotouch.drx = 0;
                            a.mangotouch.tm = 0;
                            a.scrollmom.doMomentum(30);
                        }, 100)));
                    }
                }, c = a.getScrollTop(), l = a.getScrollLeft(), a.mangotouch = {
                    sy: c,
                    ly: c,
                    dry: 0,
                    sx: l,
                    lx: l,
                    drx: 0,
                    lazy: !1,
                    tm: 0
                }, a.bind(a.docscroll, "scroll", a.onmangotouch);
                else {
                    if (e.cantouch || a.istouchcapable || a.opt.touchbehavior || e.hasmstouch) {
                        a.scrollmom = new L(a);
                        a.ontouchstart = function(b) {
                            if (b.pointerType && 2 != b.pointerType && "touch" != b.pointerType) return !1;
                            a.hasmoving = !1;
                            if (!a.railslocked) {
                                var c;
                                if (e.hasmstouch) for(c = b.target ? b.target : !1; c;){
                                    var g = f(c).getNiceScroll();
                                    if (0 < g.length && g[0].me == a.me) break;
                                    if (0 < g.length) return !1;
                                    if ("DIV" == c.nodeName && c.id == a.id) break;
                                    c = c.parentNode ? c.parentNode : !1;
                                }
                                a.cancelScroll();
                                if ((c = a.getTarget(b)) && /INPUT/i.test(c.nodeName) && /range/i.test(c.type)) return a.stopPropagation(b);
                                !("clientX" in b) && "changedTouches" in b && (b.clientX = b.changedTouches[0].clientX, b.clientY = b.changedTouches[0].clientY);
                                a.forcescreen && (g = b, b = {
                                    original: b.original ? b.original : b
                                }, b.clientX = g.screenX, b.clientY = g.screenY);
                                a.rail.drag = {
                                    x: b.clientX,
                                    y: b.clientY,
                                    sx: a.scroll.x,
                                    sy: a.scroll.y,
                                    st: a.getScrollTop(),
                                    sl: a.getScrollLeft(),
                                    pt: 2,
                                    dl: !1
                                };
                                if (a.ispage || !a.opt.directionlockdeadzone) a.rail.drag.dl = "f";
                                else {
                                    var g = f(window).width(), d = f(window).height(), q = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth), h = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight), d = Math.max(0, h - d), g = Math.max(0, q - g);
                                    a.rail.drag.ck = !a.rail.scrollable && a.railh.scrollable ? 0 < d ? "v" : !1 : a.rail.scrollable && !a.railh.scrollable ? 0 < g ? "h" : !1 : !1;
                                    a.rail.drag.ck || (a.rail.drag.dl = "f");
                                }
                                a.opt.touchbehavior && a.isiframe && e.isie && (g = a.win.position(), a.rail.drag.x += g.left, a.rail.drag.y += g.top);
                                a.hasmoving = !1;
                                a.lastmouseup = !1;
                                a.scrollmom.reset(b.clientX, b.clientY);
                                if (!e.cantouch && !this.istouchcapable && !b.pointerType) {
                                    if (!c || !/INPUT|SELECT|TEXTAREA/i.test(c.nodeName)) return !a.ispage && e.hasmousecapture && c.setCapture(), a.opt.touchbehavior ? (c.onclick && !c._onclick && (c._onclick = c.onclick, c.onclick = function(b) {
                                        if (a.hasmoving) return !1;
                                        c._onclick.call(this, b);
                                    }), a.cancelEvent(b)) : a.stopPropagation(b);
                                    /SUBMIT|CANCEL|BUTTON/i.test(f(c).attr("type")) && (pc = {
                                        tg: c,
                                        click: !1
                                    }, a.preventclick = pc);
                                }
                            }
                        };
                        a.ontouchend = function(b) {
                            if (!a.rail.drag) return !0;
                            if (2 == a.rail.drag.pt) {
                                if (b.pointerType && 2 != b.pointerType && "touch" != b.pointerType) return !1;
                                a.scrollmom.doMomentum();
                                a.rail.drag = !1;
                                if (a.hasmoving && (a.lastmouseup = !0, a.hideCursor(), e.hasmousecapture && document.releaseCapture(), !e.cantouch)) return a.cancelEvent(b);
                            } else if (1 == a.rail.drag.pt) return a.onmouseup(b);
                        };
                        var n = a.opt.touchbehavior && a.isiframe && !e.hasmousecapture;
                        a.ontouchmove = function(b, c) {
                            if (!a.rail.drag || b.targetTouches && a.opt.preventmultitouchscrolling && 1 < b.targetTouches.length || b.pointerType && 2 != b.pointerType && "touch" != b.pointerType) return !1;
                            if (2 == a.rail.drag.pt) {
                                if (e.cantouch && e.isios && "undefined" == typeof b.original) return !0;
                                a.hasmoving = !0;
                                a.preventclick && !a.preventclick.click && (a.preventclick.click = a.preventclick.tg.onclick || !1, a.preventclick.tg.onclick = a.onpreventclick);
                                b = f.extend({
                                    original: b
                                }, b);
                                "changedTouches" in b && (b.clientX = b.changedTouches[0].clientX, b.clientY = b.changedTouches[0].clientY);
                                if (a.forcescreen) {
                                    var g = b;
                                    b = {
                                        original: b.original ? b.original : b
                                    };
                                    b.clientX = g.screenX;
                                    b.clientY = g.screenY;
                                }
                                var d, g = d = 0;
                                n && !c && (d = a.win.position(), g = -d.left, d = -d.top);
                                var q = b.clientY + d;
                                d = q - a.rail.drag.y;
                                var h = b.clientX + g, u = h - a.rail.drag.x, k = a.rail.drag.st - d;
                                a.ishwscroll && a.opt.bouncescroll ? 0 > k ? k = Math.round(k / 2) : k > a.page.maxh && (k = a.page.maxh + Math.round((k - a.page.maxh) / 2)) : (0 > k && (q = k = 0), k > a.page.maxh && (k = a.page.maxh, q = 0));
                                var l;
                                a.railh && a.railh.scrollable && (l = a.isrtlmode ? u - a.rail.drag.sl : a.rail.drag.sl - u, a.ishwscroll && a.opt.bouncescroll ? 0 > l ? l = Math.round(l / 2) : l > a.page.maxw && (l = a.page.maxw + Math.round((l - a.page.maxw) / 2)) : (0 > l && (h = l = 0), l > a.page.maxw && (l = a.page.maxw, h = 0)));
                                g = !1;
                                if (a.rail.drag.dl) g = !0, "v" == a.rail.drag.dl ? l = a.rail.drag.sl : "h" == a.rail.drag.dl && (k = a.rail.drag.st);
                                else {
                                    d = Math.abs(d);
                                    var u = Math.abs(u), z = a.opt.directionlockdeadzone;
                                    if ("v" == a.rail.drag.ck) {
                                        if (d > z && u <= .3 * d) return a.rail.drag = !1, !0;
                                        u > z && (a.rail.drag.dl = "f", f("body").scrollTop(f("body").scrollTop()));
                                    } else if ("h" == a.rail.drag.ck) {
                                        if (u > z && d <= .3 * u) return a.rail.drag = !1, !0;
                                        d > z && (a.rail.drag.dl = "f", f("body").scrollLeft(f("body").scrollLeft()));
                                    }
                                }
                                a.synched("touchmove", function() {
                                    a.rail.drag && 2 == a.rail.drag.pt && (a.prepareTransition && a.prepareTransition(0), a.rail.scrollable && a.setScrollTop(k), a.scrollmom.update(h, q), a.railh && a.railh.scrollable ? (a.setScrollLeft(l), a.showCursor(k, l)) : a.showCursor(k), e.isie10 && document.selection.clear());
                                });
                                e.ischrome && a.istouchcapable && (g = !1);
                                if (g) return a.cancelEvent(b);
                            } else if (1 == a.rail.drag.pt) return a.onmousemove(b);
                        };
                    }
                    a.onmousedown = function(b, c) {
                        if (!a.rail.drag || 1 == a.rail.drag.pt) {
                            if (a.railslocked) return a.cancelEvent(b);
                            a.cancelScroll();
                            a.rail.drag = {
                                x: b.clientX,
                                y: b.clientY,
                                sx: a.scroll.x,
                                sy: a.scroll.y,
                                pt: 1,
                                hr: !!c
                            };
                            var g = a.getTarget(b);
                            !a.ispage && e.hasmousecapture && g.setCapture();
                            a.isiframe && !e.hasmousecapture && (a.saved.csspointerevents = a.doc.css("pointer-events"), a.css(a.doc, {
                                "pointer-events": "none"
                            }));
                            a.hasmoving = !1;
                            return a.cancelEvent(b);
                        }
                    };
                    a.onmouseup = function(b) {
                        if (a.rail.drag) {
                            if (1 != a.rail.drag.pt) return !0;
                            e.hasmousecapture && document.releaseCapture();
                            a.isiframe && !e.hasmousecapture && a.doc.css("pointer-events", a.saved.csspointerevents);
                            a.rail.drag = !1;
                            a.hasmoving && a.triggerScrollEnd();
                            return a.cancelEvent(b);
                        }
                    };
                    a.onmousemove = function(b) {
                        if (a.rail.drag && 1 == a.rail.drag.pt) {
                            if (e.ischrome && 0 == b.which) return a.onmouseup(b);
                            a.cursorfreezed = !0;
                            a.hasmoving = !0;
                            if (a.rail.drag.hr) {
                                a.scroll.x = a.rail.drag.sx + (b.clientX - a.rail.drag.x);
                                0 > a.scroll.x && (a.scroll.x = 0);
                                var c = a.scrollvaluemaxw;
                                a.scroll.x > c && (a.scroll.x = c);
                            } else a.scroll.y = a.rail.drag.sy + (b.clientY - a.rail.drag.y), 0 > a.scroll.y && (a.scroll.y = 0), c = a.scrollvaluemax, a.scroll.y > c && (a.scroll.y = c);
                            a.synched("mousemove", function() {
                                a.rail.drag && 1 == a.rail.drag.pt && (a.showCursor(), a.rail.drag.hr ? a.hasreversehr ? a.doScrollLeft(a.scrollvaluemaxw - Math.round(a.scroll.x * a.scrollratio.x), a.opt.cursordragspeed) : a.doScrollLeft(Math.round(a.scroll.x * a.scrollratio.x), a.opt.cursordragspeed) : a.doScrollTop(Math.round(a.scroll.y * a.scrollratio.y), a.opt.cursordragspeed));
                            });
                            return a.cancelEvent(b);
                        }
                    };
                    if (e.cantouch || a.opt.touchbehavior) a.onpreventclick = function(b) {
                        if (a.preventclick) return a.preventclick.tg.onclick = a.preventclick.click, a.preventclick = !1, a.cancelEvent(b);
                    }, a.bind(a.win, "mousedown", a.ontouchstart), a.onclick = e.isios ? !1 : function(b) {
                        return a.lastmouseup ? (a.lastmouseup = !1, a.cancelEvent(b)) : !0;
                    }, a.opt.grabcursorenabled && e.cursorgrabvalue && (a.css(a.ispage ? a.doc : a.win, {
                        cursor: e.cursorgrabvalue
                    }), a.css(a.rail, {
                        cursor: e.cursorgrabvalue
                    }));
                    else {
                        var p = function(b) {
                            if (a.selectiondrag) {
                                if (b) {
                                    var c = a.win.outerHeight();
                                    b = b.pageY - a.selectiondrag.top;
                                    0 < b && b < c && (b = 0);
                                    b >= c && (b -= c);
                                    a.selectiondrag.df = b;
                                }
                                0 != a.selectiondrag.df && (a.doScrollBy(2 * -Math.floor(a.selectiondrag.df / 6)), a.debounced("doselectionscroll", function() {
                                    p();
                                }, 50));
                            }
                        };
                        a.hasTextSelected = "getSelection" in document ? function() {
                            return 0 < document.getSelection().rangeCount;
                        } : "selection" in document ? function() {
                            return "None" != document.selection.type;
                        } : function() {
                            return !1;
                        };
                        a.onselectionstart = function(b) {
                            a.ispage || (a.selectiondrag = a.win.offset());
                        };
                        a.onselectionend = function(b) {
                            a.selectiondrag = !1;
                        };
                        a.onselectiondrag = function(b) {
                            a.selectiondrag && a.hasTextSelected() && a.debounced("selectionscroll", function() {
                                p(b);
                            }, 250);
                        };
                    }
                    e.hasw3ctouch ? (a.css(a.rail, {
                        "touch-action": "none"
                    }), a.css(a.cursor, {
                        "touch-action": "none"
                    }), a.bind(a.win, "pointerdown", a.ontouchstart), a.bind(document, "pointerup", a.ontouchend), a.bind(document, "pointermove", a.ontouchmove)) : e.hasmstouch ? (a.css(a.rail, {
                        "-ms-touch-action": "none"
                    }), a.css(a.cursor, {
                        "-ms-touch-action": "none"
                    }), a.bind(a.win, "MSPointerDown", a.ontouchstart), a.bind(document, "MSPointerUp", a.ontouchend), a.bind(document, "MSPointerMove", a.ontouchmove), a.bind(a.cursor, "MSGestureHold", function(a) {
                        a.preventDefault();
                    }), a.bind(a.cursor, "contextmenu", function(a) {
                        a.preventDefault();
                    })) : this.istouchcapable && (a.bind(a.win, "touchstart", a.ontouchstart), a.bind(document, "touchend", a.ontouchend), a.bind(document, "touchcancel", a.ontouchend), a.bind(document, "touchmove", a.ontouchmove));
                    if (a.opt.cursordragontouch || !e.cantouch && !a.opt.touchbehavior) a.rail.css({
                        cursor: "default"
                    }), a.railh && a.railh.css({
                        cursor: "default"
                    }), a.jqbind(a.rail, "mouseenter", function() {
                        if (!a.ispage && !a.win.is(":visible")) return !1;
                        a.canshowonmouseevent && a.showCursor();
                        a.rail.active = !0;
                    }), a.jqbind(a.rail, "mouseleave", function() {
                        a.rail.active = !1;
                        a.rail.drag || a.hideCursor();
                    }), a.opt.sensitiverail && (a.bind(a.rail, "click", function(b) {
                        a.doRailClick(b, !1, !1);
                    }), a.bind(a.rail, "dblclick", function(b) {
                        a.doRailClick(b, !0, !1);
                    }), a.bind(a.cursor, "click", function(b) {
                        a.cancelEvent(b);
                    }), a.bind(a.cursor, "dblclick", function(b) {
                        a.cancelEvent(b);
                    })), a.railh && (a.jqbind(a.railh, "mouseenter", function() {
                        if (!a.ispage && !a.win.is(":visible")) return !1;
                        a.canshowonmouseevent && a.showCursor();
                        a.rail.active = !0;
                    }), a.jqbind(a.railh, "mouseleave", function() {
                        a.rail.active = !1;
                        a.rail.drag || a.hideCursor();
                    }), a.opt.sensitiverail && (a.bind(a.railh, "click", function(b) {
                        a.doRailClick(b, !1, !0);
                    }), a.bind(a.railh, "dblclick", function(b) {
                        a.doRailClick(b, !0, !0);
                    }), a.bind(a.cursorh, "click", function(b) {
                        a.cancelEvent(b);
                    }), a.bind(a.cursorh, "dblclick", function(b) {
                        a.cancelEvent(b);
                    })));
                    e.cantouch || a.opt.touchbehavior ? (a.bind(e.hasmousecapture ? a.win : document, "mouseup", a.ontouchend), a.bind(document, "mousemove", a.ontouchmove), a.onclick && a.bind(document, "click", a.onclick), a.opt.cursordragontouch && (a.bind(a.cursor, "mousedown", a.onmousedown), a.bind(a.cursor, "mouseup", a.onmouseup), a.cursorh && a.bind(a.cursorh, "mousedown", function(b) {
                        a.onmousedown(b, !0);
                    }), a.cursorh && a.bind(a.cursorh, "mouseup", a.onmouseup))) : (a.bind(e.hasmousecapture ? a.win : document, "mouseup", a.onmouseup), a.bind(document, "mousemove", a.onmousemove), a.onclick && a.bind(document, "click", a.onclick), a.bind(a.cursor, "mousedown", a.onmousedown), a.bind(a.cursor, "mouseup", a.onmouseup), a.railh && (a.bind(a.cursorh, "mousedown", function(b) {
                        a.onmousedown(b, !0);
                    }), a.bind(a.cursorh, "mouseup", a.onmouseup)), !a.ispage && a.opt.enablescrollonselection && (a.bind(a.win[0], "mousedown", a.onselectionstart), a.bind(document, "mouseup", a.onselectionend), a.bind(a.cursor, "mouseup", a.onselectionend), a.cursorh && a.bind(a.cursorh, "mouseup", a.onselectionend), a.bind(document, "mousemove", a.onselectiondrag)), a.zoom && (a.jqbind(a.zoom, "mouseenter", function() {
                        a.canshowonmouseevent && a.showCursor();
                        a.rail.active = !0;
                    }), a.jqbind(a.zoom, "mouseleave", function() {
                        a.rail.active = !1;
                        a.rail.drag || a.hideCursor();
                    })));
                    a.opt.enablemousewheel && (a.isiframe || a.bind(e.isie && a.ispage ? document : a.win, "mousewheel", a.onmousewheel), a.bind(a.rail, "mousewheel", a.onmousewheel), a.railh && a.bind(a.railh, "mousewheel", a.onmousewheelhr));
                    a.ispage || e.cantouch || /HTML|^BODY/.test(a.win[0].nodeName) || (a.win.attr("tabindex") || a.win.attr({
                        tabindex: N++
                    }), a.jqbind(a.win, "focus", function(b) {
                        y = a.getTarget(b).id || !0;
                        a.hasfocus = !0;
                        a.canshowonmouseevent && a.noticeCursor();
                    }), a.jqbind(a.win, "blur", function(b) {
                        y = !1;
                        a.hasfocus = !1;
                    }), a.jqbind(a.win, "mouseenter", function(b) {
                        D = a.getTarget(b).id || !0;
                        a.hasmousefocus = !0;
                        a.canshowonmouseevent && a.noticeCursor();
                    }), a.jqbind(a.win, "mouseleave", function() {
                        D = !1;
                        a.hasmousefocus = !1;
                        a.rail.drag || a.hideCursor();
                    }));
                }
                a.onkeypress = function(b) {
                    if (a.railslocked && 0 == a.page.maxh) return !0;
                    b = b ? b : window.e;
                    var c = a.getTarget(b);
                    if (c && /INPUT|TEXTAREA|SELECT|OPTION/.test(c.nodeName) && (!c.getAttribute("type") && !c.type || !/submit|button|cancel/i.tp) || f(c).attr("contenteditable")) return !0;
                    if (a.hasfocus || a.hasmousefocus && !y || a.ispage && !y && !D) {
                        c = b.keyCode;
                        if (a.railslocked && 27 != c) return a.cancelEvent(b);
                        var g = b.ctrlKey || !1, d = b.shiftKey || !1, e = !1;
                        switch(c){
                            case 38:
                            case 63233:
                                a.doScrollBy(72);
                                e = !0;
                                break;
                            case 40:
                            case 63235:
                                a.doScrollBy(-72);
                                e = !0;
                                break;
                            case 37:
                            case 63232:
                                a.railh && (g ? a.doScrollLeft(0) : a.doScrollLeftBy(72), e = !0);
                                break;
                            case 39:
                            case 63234:
                                a.railh && (g ? a.doScrollLeft(a.page.maxw) : a.doScrollLeftBy(-72), e = !0);
                                break;
                            case 33:
                            case 63276:
                                a.doScrollBy(a.view.h);
                                e = !0;
                                break;
                            case 34:
                            case 63277:
                                a.doScrollBy(-a.view.h);
                                e = !0;
                                break;
                            case 36:
                            case 63273:
                                a.railh && g ? a.doScrollPos(0, 0) : a.doScrollTo(0);
                                e = !0;
                                break;
                            case 35:
                            case 63275:
                                a.railh && g ? a.doScrollPos(a.page.maxw, a.page.maxh) : a.doScrollTo(a.page.maxh);
                                e = !0;
                                break;
                            case 32:
                                a.opt.spacebarenabled && (d ? a.doScrollBy(a.view.h) : a.doScrollBy(-a.view.h), e = !0);
                                break;
                            case 27:
                                a.zoomactive && (a.doZoom(), e = !0);
                        }
                        if (e) return a.cancelEvent(b);
                    }
                };
                a.opt.enablekeyboard && a.bind(document, e.isopera && !e.isopera12 ? "keypress" : "keydown", a.onkeypress);
                a.bind(document, "keydown", function(b) {
                    b.ctrlKey && (a.wheelprevented = !0);
                });
                a.bind(document, "keyup", function(b) {
                    b.ctrlKey || (a.wheelprevented = !1);
                });
                a.bind(window, "blur", function(b) {
                    a.wheelprevented = !1;
                });
                a.bind(window, "resize", a.lazyResize);
                a.bind(window, "orientationchange", a.lazyResize);
                a.bind(window, "load", a.lazyResize);
                if (e.ischrome && !a.ispage && !a.haswrapper) {
                    var r = a.win.attr("style"), c = parseFloat(a.win.css("width")) + 1;
                    a.win.css("width", c);
                    a.synched("chromefix", function() {
                        a.win.attr("style", r);
                    });
                }
                a.onAttributeChange = function(b) {
                    a.lazyResize(a.isieold ? 250 : 30);
                };
                !1 !== v && (a.observerbody = new v(function(b) {
                    b.forEach(function(b) {
                        if ("attributes" == b.type) return f("body").hasClass("modal-open") ? a.hide() : a.show();
                    });
                    if (document.body.scrollHeight != a.page.maxh) return a.lazyResize(30);
                }), a.observerbody.observe(document.body, {
                    childList: !0,
                    subtree: !0,
                    characterData: !1,
                    attributes: !0,
                    attributeFilter: [
                        "class"
                    ]
                }));
                a.ispage || a.haswrapper || (!1 !== v ? (a.observer = new v(function(b) {
                    b.forEach(a.onAttributeChange);
                }), a.observer.observe(a.win[0], {
                    childList: !0,
                    characterData: !1,
                    attributes: !0,
                    subtree: !1
                }), a.observerremover = new v(function(b) {
                    b.forEach(function(b) {
                        if (0 < b.removedNodes.length) {
                            for(var c in b.removedNodes)if (a && b.removedNodes[c] == a.win[0]) return a.remove();
                        }
                    });
                }), a.observerremover.observe(a.win[0].parentNode, {
                    childList: !0,
                    characterData: !1,
                    attributes: !1,
                    subtree: !1
                })) : (a.bind(a.win, e.isie && !e.isie9 ? "propertychange" : "DOMAttrModified", a.onAttributeChange), e.isie9 && a.win[0].attachEvent("onpropertychange", a.onAttributeChange), a.bind(a.win, "DOMNodeRemoved", function(b) {
                    b.target == a.win[0] && a.remove();
                })));
                !a.ispage && a.opt.boxzoom && a.bind(window, "resize", a.resizeZoom);
                a.istextarea && a.bind(a.win, "mouseup", a.lazyResize);
                a.lazyResize(30);
            }
            if ("IFRAME" == this.doc[0].nodeName) {
                var M = function() {
                    a.iframexd = !1;
                    var b;
                    try {
                        b = "contentDocument" in this ? this.contentDocument : this.contentWindow.document;
                    } catch (c) {
                        a.iframexd = !0, b = !1;
                    }
                    if (a.iframexd) return "console" in window && console.log("NiceScroll error: policy restriced iframe"), !0;
                    a.forcescreen = !0;
                    a.isiframe && (a.iframe = {
                        doc: f(b),
                        html: a.doc.contents().find("html")[0],
                        body: a.doc.contents().find("body")[0]
                    }, a.getContentSize = function() {
                        return {
                            w: Math.max(a.iframe.html.scrollWidth, a.iframe.body.scrollWidth),
                            h: Math.max(a.iframe.html.scrollHeight, a.iframe.body.scrollHeight)
                        };
                    }, a.docscroll = f(a.iframe.body));
                    if (!e.isios && a.opt.iframeautoresize && !a.isiframe) {
                        a.win.scrollTop(0);
                        a.doc.height("");
                        var g = Math.max(b.getElementsByTagName("html")[0].scrollHeight, b.body.scrollHeight);
                        a.doc.height(g);
                    }
                    a.lazyResize(30);
                    e.isie7 && a.css(f(a.iframe.html), {
                        "overflow-y": "hidden"
                    });
                    a.css(f(a.iframe.body), {
                        "overflow-y": "hidden"
                    });
                    e.isios && a.haswrapper && a.css(f(b.body), {
                        "-webkit-transform": "translate3d(0,0,0)"
                    });
                    "contentWindow" in this ? a.bind(this.contentWindow, "scroll", a.onscroll) : a.bind(b, "scroll", a.onscroll);
                    a.opt.enablemousewheel && a.bind(b, "mousewheel", a.onmousewheel);
                    a.opt.enablekeyboard && a.bind(b, e.isopera ? "keypress" : "keydown", a.onkeypress);
                    if (e.cantouch || a.opt.touchbehavior) a.bind(b, "mousedown", a.ontouchstart), a.bind(b, "mousemove", function(b) {
                        return a.ontouchmove(b, !0);
                    }), a.opt.grabcursorenabled && e.cursorgrabvalue && a.css(f(b.body), {
                        cursor: e.cursorgrabvalue
                    });
                    a.bind(b, "mouseup", a.ontouchend);
                    a.zoom && (a.opt.dblclickzoom && a.bind(b, "dblclick", a.doZoom), a.ongesturezoom && a.bind(b, "gestureend", a.ongesturezoom));
                };
                this.doc[0].readyState && "complete" == this.doc[0].readyState && setTimeout(function() {
                    M.call(a.doc[0], !1);
                }, 500);
                a.bind(this.doc, "load", M);
            }
        };
        this.showCursor = function(b, c) {
            a.cursortimeout && (clearTimeout(a.cursortimeout), a.cursortimeout = 0);
            if (a.rail) {
                a.autohidedom && (a.autohidedom.stop().css({
                    opacity: a.opt.cursoropacitymax
                }), a.cursoractive = !0);
                a.rail.drag && 1 == a.rail.drag.pt || ("undefined" != typeof b && !1 !== b && (a.scroll.y = Math.round(1 * b / a.scrollratio.y)), "undefined" != typeof c && (a.scroll.x = Math.round(1 * c / a.scrollratio.x)));
                a.cursor.css({
                    height: a.cursorheight,
                    top: a.scroll.y
                });
                if (a.cursorh) {
                    var d = a.hasreversehr ? a.scrollvaluemaxw - a.scroll.x : a.scroll.x;
                    !a.rail.align && a.rail.visibility ? a.cursorh.css({
                        width: a.cursorwidth,
                        left: d + a.rail.width
                    }) : a.cursorh.css({
                        width: a.cursorwidth,
                        left: d
                    });
                    a.cursoractive = !0;
                }
                a.zoom && a.zoom.stop().css({
                    opacity: a.opt.cursoropacitymax
                });
            }
        };
        this.hideCursor = function(b) {
            a.cursortimeout || !a.rail || !a.autohidedom || a.hasmousefocus && "leave" == a.opt.autohidemode || (a.cursortimeout = setTimeout(function() {
                a.rail.active && a.showonmouseevent || (a.autohidedom.stop().animate({
                    opacity: a.opt.cursoropacitymin
                }), a.zoom && a.zoom.stop().animate({
                    opacity: a.opt.cursoropacitymin
                }), a.cursoractive = !1);
                a.cursortimeout = 0;
            }, b || a.opt.hidecursordelay));
        };
        this.noticeCursor = function(b, c, d) {
            a.showCursor(c, d);
            a.rail.active || a.hideCursor(b);
        };
        this.getContentSize = a.ispage ? function() {
            return {
                w: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth),
                h: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
            };
        } : a.haswrapper ? function() {
            return {
                w: a.doc.outerWidth() + parseInt(a.win.css("paddingLeft")) + parseInt(a.win.css("paddingRight")),
                h: a.doc.outerHeight() + parseInt(a.win.css("paddingTop")) + parseInt(a.win.css("paddingBottom"))
            };
        } : function() {
            return {
                w: a.docscroll[0].scrollWidth,
                h: a.docscroll[0].scrollHeight
            };
        };
        this.onResize = function(b, c) {
            if (!a || !a.win) return !1;
            if (!a.haswrapper && !a.ispage) {
                if ("none" == a.win.css("display")) return a.visibility && a.hideRail().hideRailHr(), !1;
                a.hidden || a.visibility || a.showRail().showRailHr();
            }
            var d = a.page.maxh, e = a.page.maxw, f = a.view.h, h = a.view.w;
            a.view = {
                w: a.ispage ? a.win.width() : parseInt(a.win[0].clientWidth),
                h: a.ispage ? a.win.height() : parseInt(a.win[0].clientHeight)
            };
            a.page = c ? c : a.getContentSize();
            a.page.maxh = Math.max(0, a.page.h - a.view.h);
            a.page.maxw = Math.max(0, a.page.w - a.view.w);
            if (a.page.maxh == d && a.page.maxw == e && a.view.w == h && a.view.h == f) {
                if (a.ispage) return a;
                d = a.win.offset();
                if (a.lastposition && (e = a.lastposition, e.top == d.top && e.left == d.left)) return a;
                a.lastposition = d;
            }
            0 == a.page.maxh ? (a.hideRail(), a.scrollvaluemax = 0, a.scroll.y = 0, a.scrollratio.y = 0, a.cursorheight = 0, a.setScrollTop(0), a.rail.scrollable = !1) : (a.page.maxh -= a.opt.railpadding.top + a.opt.railpadding.bottom, a.rail.scrollable = !0);
            0 == a.page.maxw ? (a.hideRailHr(), a.scrollvaluemaxw = 0, a.scroll.x = 0, a.scrollratio.x = 0, a.cursorwidth = 0, a.setScrollLeft(0), a.railh.scrollable = !1) : (a.page.maxw -= a.opt.railpadding.left + a.opt.railpadding.right, a.railh.scrollable = !0);
            a.railslocked = a.locked || 0 == a.page.maxh && 0 == a.page.maxw;
            if (a.railslocked) return a.ispage || a.updateScrollBar(a.view), !1;
            a.hidden || a.visibility ? a.hidden || a.railh.visibility || a.showRailHr() : a.showRail().showRailHr();
            a.istextarea && a.win.css("resize") && "none" != a.win.css("resize") && (a.view.h -= 20);
            a.cursorheight = Math.min(a.view.h, Math.round(a.view.h / a.page.h * a.view.h));
            a.cursorheight = a.opt.cursorfixedheight ? a.opt.cursorfixedheight : Math.max(a.opt.cursorminheight, a.cursorheight);
            a.cursorwidth = Math.min(a.view.w, Math.round(a.view.w / a.page.w * a.view.w));
            a.cursorwidth = a.opt.cursorfixedheight ? a.opt.cursorfixedheight : Math.max(a.opt.cursorminheight, a.cursorwidth);
            a.scrollvaluemax = a.view.h - a.cursorheight - a.cursor.hborder - (a.opt.railpadding.top + a.opt.railpadding.bottom);
            a.railh && (a.railh.width = 0 < a.page.maxh ? a.view.w - a.rail.width : a.view.w, a.scrollvaluemaxw = a.railh.width - a.cursorwidth - a.cursorh.wborder - (a.opt.railpadding.left + a.opt.railpadding.right));
            a.ispage || a.updateScrollBar(a.view);
            a.scrollratio = {
                x: a.page.maxw / a.scrollvaluemaxw,
                y: a.page.maxh / a.scrollvaluemax
            };
            a.getScrollTop() > a.page.maxh ? a.doScrollTop(a.page.maxh) : (a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y)), a.scroll.x = Math.round(a.getScrollLeft() * (1 / a.scrollratio.x)), a.cursoractive && a.noticeCursor());
            a.scroll.y && 0 == a.getScrollTop() && a.doScrollTo(Math.floor(a.scroll.y * a.scrollratio.y));
            return a;
        };
        this.resize = a.onResize;
        this.lazyResize = function(b) {
            b = isNaN(b) ? 30 : b;
            a.debounced("resize", a.resize, b);
            return a;
        };
        this.jqbind = function(b, c, d) {
            a.events.push({
                e: b,
                n: c,
                f: d,
                q: !0
            });
            f(b).bind(c, d);
        };
        this.bind = function(b, c, d, f) {
            var h = "jquery" in b ? b[0] : b;
            "mousewheel" == c ? window.addEventListener || "onwheel" in document ? a._bind(h, "wheel", d, f || !1) : (b = "undefined" != typeof document.onmousewheel ? "mousewheel" : "DOMMouseScroll", n(h, b, d, f || !1), "DOMMouseScroll" == b && n(h, "MozMousePixelScroll", d, f || !1)) : h.addEventListener ? (e.cantouch && /mouseup|mousedown|mousemove/.test(c) && a._bind(h, "mousedown" == c ? "touchstart" : "mouseup" == c ? "touchend" : "touchmove", function(a) {
                if (a.touches) {
                    if (2 > a.touches.length) {
                        var b = a.touches.length ? a.touches[0] : a;
                        b.original = a;
                        d.call(this, b);
                    }
                } else a.changedTouches && (b = a.changedTouches[0], b.original = a, d.call(this, b));
            }, f || !1), a._bind(h, c, d, f || !1), e.cantouch && "mouseup" == c && a._bind(h, "touchcancel", d, f || !1)) : a._bind(h, c, function(b) {
                (b = b || window.event || !1) && b.srcElement && (b.target = b.srcElement);
                "pageY" in b || (b.pageX = b.clientX + document.documentElement.scrollLeft, b.pageY = b.clientY + document.documentElement.scrollTop);
                return !1 === d.call(h, b) || !1 === f ? a.cancelEvent(b) : !0;
            });
        };
        e.haseventlistener ? (this._bind = function(b, c, d, e) {
            a.events.push({
                e: b,
                n: c,
                f: d,
                b: e,
                q: !1
            });
            b.addEventListener(c, d, e || !1);
        }, this.cancelEvent = function(a) {
            if (!a) return !1;
            a = a.original ? a.original : a;
            a.preventDefault();
            a.stopPropagation();
            a.preventManipulation && a.preventManipulation();
            return !1;
        }, this.stopPropagation = function(a) {
            if (!a) return !1;
            a = a.original ? a.original : a;
            a.stopPropagation();
            return !1;
        }, this._unbind = function(a, c, d, e) {
            a.removeEventListener(c, d, e);
        }) : (this._bind = function(b, c, d, e) {
            a.events.push({
                e: b,
                n: c,
                f: d,
                b: e,
                q: !1
            });
            b.attachEvent ? b.attachEvent("on" + c, d) : b["on" + c] = d;
        }, this.cancelEvent = function(a) {
            a = window.event || !1;
            if (!a) return !1;
            a.cancelBubble = !0;
            a.cancel = !0;
            return a.returnValue = !1;
        }, this.stopPropagation = function(a) {
            a = window.event || !1;
            if (!a) return !1;
            a.cancelBubble = !0;
            return !1;
        }, this._unbind = function(a, c, d, e) {
            a.detachEvent ? a.detachEvent("on" + c, d) : a["on" + c] = !1;
        });
        this.unbindAll = function() {
            for(var b = 0; b < a.events.length; b++){
                var c = a.events[b];
                c.q ? c.e.unbind(c.n, c.f) : a._unbind(c.e, c.n, c.f, c.b);
            }
        };
        this.showRail = function() {
            0 == a.page.maxh || !a.ispage && "none" == a.win.css("display") || (a.visibility = !0, a.rail.visibility = !0, a.rail.css("display", "block"));
            return a;
        };
        this.showRailHr = function() {
            if (!a.railh) return a;
            0 == a.page.maxw || !a.ispage && "none" == a.win.css("display") || (a.railh.visibility = !0, a.railh.css("display", "block"));
            return a;
        };
        this.hideRail = function() {
            a.visibility = !1;
            a.rail.visibility = !1;
            a.rail.css("display", "none");
            return a;
        };
        this.hideRailHr = function() {
            if (!a.railh) return a;
            a.railh.visibility = !1;
            a.railh.css("display", "none");
            return a;
        };
        this.show = function() {
            a.hidden = !1;
            a.railslocked = !1;
            return a.showRail().showRailHr();
        };
        this.hide = function() {
            a.hidden = !0;
            a.railslocked = !0;
            return a.hideRail().hideRailHr();
        };
        this.toggle = function() {
            return a.hidden ? a.show() : a.hide();
        };
        this.remove = function() {
            a.stop();
            a.cursortimeout && clearTimeout(a.cursortimeout);
            a.doZoomOut();
            a.unbindAll();
            e.isie9 && a.win[0].detachEvent("onpropertychange", a.onAttributeChange);
            !1 !== a.observer && a.observer.disconnect();
            !1 !== a.observerremover && a.observerremover.disconnect();
            !1 !== a.observerbody && a.observerbody.disconnect();
            a.events = null;
            a.cursor && a.cursor.remove();
            a.cursorh && a.cursorh.remove();
            a.rail && a.rail.remove();
            a.railh && a.railh.remove();
            a.zoom && a.zoom.remove();
            for(var b = 0; b < a.saved.css.length; b++){
                var c = a.saved.css[b];
                c[0].css(c[1], "undefined" == typeof c[2] ? "" : c[2]);
            }
            a.saved = !1;
            a.me.data("__nicescroll", "");
            var d = f.nicescroll;
            d.each(function(b) {
                if (this && this.id === a.id) {
                    delete d[b];
                    for(var c = ++b; c < d.length; c++, b++)d[b] = d[c];
                    d.length--;
                    d.length && delete d[d.length];
                }
            });
            for(var h in a)a[h] = null, delete a[h];
            a = null;
        };
        this.scrollstart = function(b) {
            this.onscrollstart = b;
            return a;
        };
        this.scrollend = function(b) {
            this.onscrollend = b;
            return a;
        };
        this.scrollcancel = function(b) {
            this.onscrollcancel = b;
            return a;
        };
        this.zoomin = function(b) {
            this.onzoomin = b;
            return a;
        };
        this.zoomout = function(b) {
            this.onzoomout = b;
            return a;
        };
        this.isScrollable = function(a) {
            a = a.target ? a.target : a;
            if ("OPTION" == a.nodeName) return !0;
            for(; a && 1 == a.nodeType && !/^BODY|HTML/.test(a.nodeName);){
                var c = f(a), c = c.css("overflowY") || c.css("overflowX") || c.css("overflow") || "";
                if (/scroll|auto/.test(c)) return a.clientHeight != a.scrollHeight;
                a = a.parentNode ? a.parentNode : !1;
            }
            return !1;
        };
        this.getViewport = function(a) {
            for(a = a && a.parentNode ? a.parentNode : !1; a && 1 == a.nodeType && !/^BODY|HTML/.test(a.nodeName);){
                var c = f(a);
                if (/fixed|absolute/.test(c.css("position"))) return c;
                var d = c.css("overflowY") || c.css("overflowX") || c.css("overflow") || "";
                if (/scroll|auto/.test(d) && a.clientHeight != a.scrollHeight || 0 < c.getNiceScroll().length) return c;
                a = a.parentNode ? a.parentNode : !1;
            }
            return !1;
        };
        this.triggerScrollEnd = function() {
            if (a.onscrollend) {
                var b = a.getScrollLeft(), c = a.getScrollTop();
                a.onscrollend.call(a, {
                    type: "scrollend",
                    current: {
                        x: b,
                        y: c
                    },
                    end: {
                        x: b,
                        y: c
                    }
                });
            }
        };
        this.onmousewheel = function(b) {
            if (!a.wheelprevented) {
                if (a.railslocked) return a.debounced("checkunlock", a.resize, 250), !0;
                if (a.rail.drag) return a.cancelEvent(b);
                "auto" == a.opt.oneaxismousemode && 0 != b.deltaX && (a.opt.oneaxismousemode = !1);
                if (a.opt.oneaxismousemode && 0 == b.deltaX && !a.rail.scrollable) return a.railh && a.railh.scrollable ? a.onmousewheelhr(b) : !0;
                var c = +new Date, d = !1;
                a.opt.preservenativescrolling && a.checkarea + 600 < c && (a.nativescrollingarea = a.isScrollable(b), d = !0);
                a.checkarea = c;
                if (a.nativescrollingarea) return !0;
                if (b = p(b, !1, d)) a.checkarea = 0;
                return b;
            }
        };
        this.onmousewheelhr = function(b) {
            if (!a.wheelprevented) {
                if (a.railslocked || !a.railh.scrollable) return !0;
                if (a.rail.drag) return a.cancelEvent(b);
                var c = +new Date, d = !1;
                a.opt.preservenativescrolling && a.checkarea + 600 < c && (a.nativescrollingarea = a.isScrollable(b), d = !0);
                a.checkarea = c;
                return a.nativescrollingarea ? !0 : a.railslocked ? a.cancelEvent(b) : p(b, !0, d);
            }
        };
        this.stop = function() {
            a.cancelScroll();
            a.scrollmon && a.scrollmon.stop();
            a.cursorfreezed = !1;
            a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y));
            a.noticeCursor();
            return a;
        };
        this.getTransitionSpeed = function(b) {
            var c = Math.round(10 * a.opt.scrollspeed);
            b = Math.min(c, Math.round(b / 20 * a.opt.scrollspeed));
            return 20 < b ? b : 0;
        };
        a.opt.smoothscroll ? a.ishwscroll && e.hastransition && a.opt.usetransition && a.opt.smoothscroll ? (this.prepareTransition = function(b, c) {
            var d = c ? 20 < b ? b : 0 : a.getTransitionSpeed(b), f = d ? e.prefixstyle + "transform " + d + "ms ease-out" : "";
            a.lasttransitionstyle && a.lasttransitionstyle == f || (a.lasttransitionstyle = f, a.doc.css(e.transitionstyle, f));
            return d;
        }, this.doScrollLeft = function(b, c) {
            var d = a.scrollrunning ? a.newscrolly : a.getScrollTop();
            a.doScrollPos(b, d, c);
        }, this.doScrollTop = function(b, c) {
            var d = a.scrollrunning ? a.newscrollx : a.getScrollLeft();
            a.doScrollPos(d, b, c);
        }, this.doScrollPos = function(b, c, d) {
            var f = a.getScrollTop(), h = a.getScrollLeft();
            (0 > (a.newscrolly - f) * (c - f) || 0 > (a.newscrollx - h) * (b - h)) && a.cancelScroll();
            0 == a.opt.bouncescroll && (0 > c ? c = 0 : c > a.page.maxh && (c = a.page.maxh), 0 > b ? b = 0 : b > a.page.maxw && (b = a.page.maxw));
            if (a.scrollrunning && b == a.newscrollx && c == a.newscrolly) return !1;
            a.newscrolly = c;
            a.newscrollx = b;
            a.newscrollspeed = d || !1;
            if (a.timer) return !1;
            a.timer = setTimeout(function() {
                var d = a.getScrollTop(), f = a.getScrollLeft(), h, k;
                h = b - f;
                k = c - d;
                h = Math.round(Math.sqrt(Math.pow(h, 2) + Math.pow(k, 2)));
                h = a.newscrollspeed && 1 < a.newscrollspeed ? a.newscrollspeed : a.getTransitionSpeed(h);
                a.newscrollspeed && 1 >= a.newscrollspeed && (h *= a.newscrollspeed);
                a.prepareTransition(h, !0);
                a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
                0 < h && (!a.scrollrunning && a.onscrollstart && a.onscrollstart.call(a, {
                    type: "scrollstart",
                    current: {
                        x: f,
                        y: d
                    },
                    request: {
                        x: b,
                        y: c
                    },
                    end: {
                        x: a.newscrollx,
                        y: a.newscrolly
                    },
                    speed: h
                }), e.transitionend ? a.scrollendtrapped || (a.scrollendtrapped = !0, a.bind(a.doc, e.transitionend, a.onScrollTransitionEnd, !1)) : (a.scrollendtrapped && clearTimeout(a.scrollendtrapped), a.scrollendtrapped = setTimeout(a.onScrollTransitionEnd, h)), a.timerscroll = {
                    bz: new A(d, a.newscrolly, h, 0, 0, .58, 1),
                    bh: new A(f, a.newscrollx, h, 0, 0, .58, 1)
                }, a.cursorfreezed || (a.timerscroll.tm = setInterval(function() {
                    a.showCursor(a.getScrollTop(), a.getScrollLeft());
                }, 60)));
                a.synched("doScroll-set", function() {
                    a.timer = 0;
                    a.scrollendtrapped && (a.scrollrunning = !0);
                    a.setScrollTop(a.newscrolly);
                    a.setScrollLeft(a.newscrollx);
                    if (!a.scrollendtrapped) a.onScrollTransitionEnd();
                });
            }, 50);
        }, this.cancelScroll = function() {
            if (!a.scrollendtrapped) return !0;
            var b = a.getScrollTop(), c = a.getScrollLeft();
            a.scrollrunning = !1;
            e.transitionend || clearTimeout(e.transitionend);
            a.scrollendtrapped = !1;
            a._unbind(a.doc[0], e.transitionend, a.onScrollTransitionEnd);
            a.prepareTransition(0);
            a.setScrollTop(b);
            a.railh && a.setScrollLeft(c);
            a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
            a.timerscroll = !1;
            a.cursorfreezed = !1;
            a.showCursor(b, c);
            return a;
        }, this.onScrollTransitionEnd = function() {
            a.scrollendtrapped && a._unbind(a.doc[0], e.transitionend, a.onScrollTransitionEnd);
            a.scrollendtrapped = !1;
            a.prepareTransition(0);
            a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
            a.timerscroll = !1;
            var b = a.getScrollTop(), c = a.getScrollLeft();
            a.setScrollTop(b);
            a.railh && a.setScrollLeft(c);
            a.noticeCursor(!1, b, c);
            a.cursorfreezed = !1;
            0 > b ? b = 0 : b > a.page.maxh && (b = a.page.maxh);
            0 > c ? c = 0 : c > a.page.maxw && (c = a.page.maxw);
            if (b != a.newscrolly || c != a.newscrollx) return a.doScrollPos(c, b, a.opt.snapbackspeed);
            a.onscrollend && a.scrollrunning && a.triggerScrollEnd();
            a.scrollrunning = !1;
        }) : (this.doScrollLeft = function(b, c) {
            var d = a.scrollrunning ? a.newscrolly : a.getScrollTop();
            a.doScrollPos(b, d, c);
        }, this.doScrollTop = function(b, c) {
            var d = a.scrollrunning ? a.newscrollx : a.getScrollLeft();
            a.doScrollPos(d, b, c);
        }, this.doScrollPos = function(b, c, d) {
            function e() {
                if (a.cancelAnimationFrame) return !0;
                a.scrollrunning = !0;
                if (n = 1 - n) return a.timer = s(e) || 1;
                var b = 0, c, d, g = d = a.getScrollTop();
                if (a.dst.ay) {
                    g = a.bzscroll ? a.dst.py + a.bzscroll.getNow() * a.dst.ay : a.newscrolly;
                    c = g - d;
                    if (0 > c && g < a.newscrolly || 0 < c && g > a.newscrolly) g = a.newscrolly;
                    a.setScrollTop(g);
                    g == a.newscrolly && (b = 1);
                } else b = 1;
                d = c = a.getScrollLeft();
                if (a.dst.ax) {
                    d = a.bzscroll ? a.dst.px + a.bzscroll.getNow() * a.dst.ax : a.newscrollx;
                    c = d - c;
                    if (0 > c && d < a.newscrollx || 0 < c && d > a.newscrollx) d = a.newscrollx;
                    a.setScrollLeft(d);
                    d == a.newscrollx && (b += 1);
                } else b += 1;
                2 == b ? (a.timer = 0, a.cursorfreezed = !1, a.bzscroll = !1, a.scrollrunning = !1, 0 > g ? g = 0 : g > a.page.maxh && (g = a.page.maxh), 0 > d ? d = 0 : d > a.page.maxw && (d = a.page.maxw), d != a.newscrollx || g != a.newscrolly ? a.doScrollPos(d, g) : a.onscrollend && a.triggerScrollEnd()) : a.timer = s(e) || 1;
            }
            c = "undefined" == typeof c || !1 === c ? a.getScrollTop(!0) : c;
            if (a.timer && a.newscrolly == c && a.newscrollx == b) return !0;
            a.timer && t(a.timer);
            a.timer = 0;
            var f = a.getScrollTop(), h = a.getScrollLeft();
            (0 > (a.newscrolly - f) * (c - f) || 0 > (a.newscrollx - h) * (b - h)) && a.cancelScroll();
            a.newscrolly = c;
            a.newscrollx = b;
            a.bouncescroll && a.rail.visibility || (0 > a.newscrolly ? a.newscrolly = 0 : a.newscrolly > a.page.maxh && (a.newscrolly = a.page.maxh));
            a.bouncescroll && a.railh.visibility || (0 > a.newscrollx ? a.newscrollx = 0 : a.newscrollx > a.page.maxw && (a.newscrollx = a.page.maxw));
            a.dst = {};
            a.dst.x = b - h;
            a.dst.y = c - f;
            a.dst.px = h;
            a.dst.py = f;
            var k = Math.round(Math.sqrt(Math.pow(a.dst.x, 2) + Math.pow(a.dst.y, 2)));
            a.dst.ax = a.dst.x / k;
            a.dst.ay = a.dst.y / k;
            var l = 0, m = k;
            0 == a.dst.x ? (l = f, m = c, a.dst.ay = 1, a.dst.py = 0) : 0 == a.dst.y && (l = h, m = b, a.dst.ax = 1, a.dst.px = 0);
            k = a.getTransitionSpeed(k);
            d && 1 >= d && (k *= d);
            a.bzscroll = 0 < k ? a.bzscroll ? a.bzscroll.update(m, k) : new A(l, m, k, 0, 1, 0, 1) : !1;
            if (!a.timer) {
                (f == a.page.maxh && c >= a.page.maxh || h == a.page.maxw && b >= a.page.maxw) && a.checkContentSize();
                var n = 1;
                a.cancelAnimationFrame = !1;
                a.timer = 1;
                a.onscrollstart && !a.scrollrunning && a.onscrollstart.call(a, {
                    type: "scrollstart",
                    current: {
                        x: h,
                        y: f
                    },
                    request: {
                        x: b,
                        y: c
                    },
                    end: {
                        x: a.newscrollx,
                        y: a.newscrolly
                    },
                    speed: k
                });
                e();
                (f == a.page.maxh && c >= f || h == a.page.maxw && b >= h) && a.checkContentSize();
                a.noticeCursor();
            }
        }, this.cancelScroll = function() {
            a.timer && t(a.timer);
            a.timer = 0;
            a.bzscroll = !1;
            a.scrollrunning = !1;
            return a;
        }) : (this.doScrollLeft = function(b, c) {
            var d = a.getScrollTop();
            a.doScrollPos(b, d, c);
        }, this.doScrollTop = function(b, c) {
            var d = a.getScrollLeft();
            a.doScrollPos(d, b, c);
        }, this.doScrollPos = function(b, c, d) {
            var e = b > a.page.maxw ? a.page.maxw : b;
            0 > e && (e = 0);
            var f = c > a.page.maxh ? a.page.maxh : c;
            0 > f && (f = 0);
            a.synched("scroll", function() {
                a.setScrollTop(f);
                a.setScrollLeft(e);
            });
        }, this.cancelScroll = function() {});
        this.doScrollBy = function(b, c) {
            var d = 0, d = c ? Math.floor((a.scroll.y - b) * a.scrollratio.y) : (a.timer ? a.newscrolly : a.getScrollTop(!0)) - b;
            if (a.bouncescroll) {
                var e = Math.round(a.view.h / 2);
                d < -e ? d = -e : d > a.page.maxh + e && (d = a.page.maxh + e);
            }
            a.cursorfreezed = !1;
            e = a.getScrollTop(!0);
            if (0 > d && 0 >= e) return a.noticeCursor();
            if (d > a.page.maxh && e >= a.page.maxh) return a.checkContentSize(), a.noticeCursor();
            a.doScrollTop(d);
        };
        this.doScrollLeftBy = function(b, c) {
            var d = 0, d = c ? Math.floor((a.scroll.x - b) * a.scrollratio.x) : (a.timer ? a.newscrollx : a.getScrollLeft(!0)) - b;
            if (a.bouncescroll) {
                var e = Math.round(a.view.w / 2);
                d < -e ? d = -e : d > a.page.maxw + e && (d = a.page.maxw + e);
            }
            a.cursorfreezed = !1;
            e = a.getScrollLeft(!0);
            if (0 > d && 0 >= e || d > a.page.maxw && e >= a.page.maxw) return a.noticeCursor();
            a.doScrollLeft(d);
        };
        this.doScrollTo = function(b, c) {
            c && a.scrollratio.y;
            a.cursorfreezed = !1;
            a.doScrollTop(b);
        };
        this.checkContentSize = function() {
            var b = a.getContentSize();
            b.h == a.page.h && b.w == a.page.w || a.resize(!1, b);
        };
        a.onscroll = function(b) {
            a.rail.drag || a.cursorfreezed || a.synched("scroll", function() {
                a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y));
                a.railh && (a.scroll.x = Math.round(a.getScrollLeft() * (1 / a.scrollratio.x)));
                a.noticeCursor();
            });
        };
        a.bind(a.docscroll, "scroll", a.onscroll);
        this.doZoomIn = function(b) {
            if (!a.zoomactive) {
                a.zoomactive = !0;
                a.zoomrestore = {
                    style: {}
                };
                var c = "position top left zIndex backgroundColor marginTop marginBottom marginLeft marginRight".split(" "), d = a.win[0].style, h;
                for(h in c){
                    var k = c[h];
                    a.zoomrestore.style[k] = "undefined" != typeof d[k] ? d[k] : "";
                }
                a.zoomrestore.style.width = a.win.css("width");
                a.zoomrestore.style.height = a.win.css("height");
                a.zoomrestore.padding = {
                    w: a.win.outerWidth() - a.win.width(),
                    h: a.win.outerHeight() - a.win.height()
                };
                e.isios4 && (a.zoomrestore.scrollTop = f(window).scrollTop(), f(window).scrollTop(0));
                a.win.css({
                    position: e.isios4 ? "absolute" : "fixed",
                    top: 0,
                    left: 0,
                    "z-index": x + 100,
                    margin: "0px"
                });
                c = a.win.css("backgroundColor");
                ("" == c || /transparent|rgba\(0, 0, 0, 0\)|rgba\(0,0,0,0\)/.test(c)) && a.win.css("backgroundColor", "#fff");
                a.rail.css({
                    "z-index": x + 101
                });
                a.zoom.css({
                    "z-index": x + 102
                });
                a.zoom.css("backgroundPosition", "0px -18px");
                a.resizeZoom();
                a.onzoomin && a.onzoomin.call(a);
                return a.cancelEvent(b);
            }
        };
        this.doZoomOut = function(b) {
            if (a.zoomactive) return a.zoomactive = !1, a.win.css("margin", ""), a.win.css(a.zoomrestore.style), e.isios4 && f(window).scrollTop(a.zoomrestore.scrollTop), a.rail.css({
                "z-index": a.zindex
            }), a.zoom.css({
                "z-index": a.zindex
            }), a.zoomrestore = !1, a.zoom.css("backgroundPosition", "0px 0px"), a.onResize(), a.onzoomout && a.onzoomout.call(a), a.cancelEvent(b);
        };
        this.doZoom = function(b) {
            return a.zoomactive ? a.doZoomOut(b) : a.doZoomIn(b);
        };
        this.resizeZoom = function() {
            if (a.zoomactive) {
                var b = a.getScrollTop();
                a.win.css({
                    width: f(window).width() - a.zoomrestore.padding.w + "px",
                    height: f(window).height() - a.zoomrestore.padding.h + "px"
                });
                a.onResize();
                a.setScrollTop(Math.min(a.page.maxh, b));
            }
        };
        this.init();
        f.nicescroll.push(this);
    }, L = function(f) {
        var c = this;
        this.nc = f;
        this.steptime = this.lasttime = this.speedy = this.speedx = this.lasty = this.lastx = 0;
        this.snapy = this.snapx = !1;
        this.demuly = this.demulx = 0;
        this.lastscrolly = this.lastscrollx = -1;
        this.timer = this.chky = this.chkx = 0;
        this.time = function() {
            return +new Date;
        };
        this.reset = function(f, k) {
            c.stop();
            var d = c.time();
            c.steptime = 0;
            c.lasttime = d;
            c.speedx = 0;
            c.speedy = 0;
            c.lastx = f;
            c.lasty = k;
            c.lastscrollx = -1;
            c.lastscrolly = -1;
        };
        this.update = function(f, k) {
            var d = c.time();
            c.steptime = d - c.lasttime;
            c.lasttime = d;
            var d = k - c.lasty, n = f - c.lastx, p = c.nc.getScrollTop(), a = c.nc.getScrollLeft(), p = p + d, a = a + n;
            c.snapx = 0 > a || a > c.nc.page.maxw;
            c.snapy = 0 > p || p > c.nc.page.maxh;
            c.speedx = n;
            c.speedy = d;
            c.lastx = f;
            c.lasty = k;
        };
        this.stop = function() {
            c.nc.unsynched("domomentum2d");
            c.timer && clearTimeout(c.timer);
            c.timer = 0;
            c.lastscrollx = -1;
            c.lastscrolly = -1;
        };
        this.doSnapy = function(f, k) {
            var d = !1;
            0 > k ? (k = 0, d = !0) : k > c.nc.page.maxh && (k = c.nc.page.maxh, d = !0);
            0 > f ? (f = 0, d = !0) : f > c.nc.page.maxw && (f = c.nc.page.maxw, d = !0);
            d ? c.nc.doScrollPos(f, k, c.nc.opt.snapbackspeed) : c.nc.triggerScrollEnd();
        };
        this.doMomentum = function(f) {
            var k = c.time(), d = f ? k + f : c.lasttime;
            f = c.nc.getScrollLeft();
            var n = c.nc.getScrollTop(), p = c.nc.page.maxh, a = c.nc.page.maxw;
            c.speedx = 0 < a ? Math.min(60, c.speedx) : 0;
            c.speedy = 0 < p ? Math.min(60, c.speedy) : 0;
            d = d && 60 >= k - d;
            if (0 > n || n > p || 0 > f || f > a) d = !1;
            f = c.speedx && d ? c.speedx : !1;
            if (c.speedy && d && c.speedy || f) {
                var s = Math.max(16, c.steptime);
                50 < s && (f = s / 50, c.speedx *= f, c.speedy *= f, s = 50);
                c.demulxy = 0;
                c.lastscrollx = c.nc.getScrollLeft();
                c.chkx = c.lastscrollx;
                c.lastscrolly = c.nc.getScrollTop();
                c.chky = c.lastscrolly;
                var e = c.lastscrollx, r = c.lastscrolly, t = function() {
                    var d = 600 < c.time() - k ? .04 : .02;
                    c.speedx && (e = Math.floor(c.lastscrollx - c.speedx * (1 - c.demulxy)), c.lastscrollx = e, 0 > e || e > a) && (d = .1);
                    c.speedy && (r = Math.floor(c.lastscrolly - c.speedy * (1 - c.demulxy)), c.lastscrolly = r, 0 > r || r > p) && (d = .1);
                    c.demulxy = Math.min(1, c.demulxy + d);
                    c.nc.synched("domomentum2d", function() {
                        c.speedx && (c.nc.getScrollLeft() != c.chkx && c.stop(), c.chkx = e, c.nc.setScrollLeft(e));
                        c.speedy && (c.nc.getScrollTop() != c.chky && c.stop(), c.chky = r, c.nc.setScrollTop(r));
                        c.timer || (c.nc.hideCursor(), c.doSnapy(e, r));
                    });
                    1 > c.demulxy ? c.timer = setTimeout(t, s) : (c.stop(), c.nc.hideCursor(), c.doSnapy(e, r));
                };
                t();
            } else c.doSnapy(c.nc.getScrollLeft(), c.nc.getScrollTop());
        };
    }, w = f.fn.scrollTop;
    f.cssHooks.pageYOffset = {
        get: function(k, c, h) {
            return (c = f.data(k, "__nicescroll") || !1) && c.ishwscroll ? c.getScrollTop() : w.call(k);
        },
        set: function(k, c) {
            var h = f.data(k, "__nicescroll") || !1;
            h && h.ishwscroll ? h.setScrollTop(parseInt(c)) : w.call(k, c);
            return this;
        }
    };
    f.fn.scrollTop = function(k) {
        if ("undefined" == typeof k) {
            var c = this[0] ? f.data(this[0], "__nicescroll") || !1 : !1;
            return c && c.ishwscroll ? c.getScrollTop() : w.call(this);
        }
        return this.each(function() {
            var c = f.data(this, "__nicescroll") || !1;
            c && c.ishwscroll ? c.setScrollTop(parseInt(k)) : w.call(f(this), k);
        });
    };
    var B = f.fn.scrollLeft;
    f.cssHooks.pageXOffset = {
        get: function(k, c, h) {
            return (c = f.data(k, "__nicescroll") || !1) && c.ishwscroll ? c.getScrollLeft() : B.call(k);
        },
        set: function(k, c) {
            var h = f.data(k, "__nicescroll") || !1;
            h && h.ishwscroll ? h.setScrollLeft(parseInt(c)) : B.call(k, c);
            return this;
        }
    };
    f.fn.scrollLeft = function(k) {
        if ("undefined" == typeof k) {
            var c = this[0] ? f.data(this[0], "__nicescroll") || !1 : !1;
            return c && c.ishwscroll ? c.getScrollLeft() : B.call(this);
        }
        return this.each(function() {
            var c = f.data(this, "__nicescroll") || !1;
            c && c.ishwscroll ? c.setScrollLeft(parseInt(k)) : B.call(f(this), k);
        });
    };
    var C = function(k) {
        var c = this;
        this.length = 0;
        this.name = "nicescrollarray";
        this.each = function(d) {
            for(var f = 0, h = 0; f < c.length; f++)d.call(c[f], h++);
            return c;
        };
        this.push = function(d) {
            c[c.length] = d;
            c.length++;
        };
        this.eq = function(d) {
            return c[d];
        };
        if (k) for(var h = 0; h < k.length; h++){
            var m = f.data(k[h], "__nicescroll") || !1;
            m && (this[this.length] = m, this.length++);
        }
        return this;
    };
    (function(f, c, h) {
        for(var m = 0; m < c.length; m++)h(f, c[m]);
    })(C.prototype, "show hide toggle onResize resize remove stop doScrollPos".split(" "), function(f, c) {
        f[c] = function() {
            var f = arguments;
            return this.each(function() {
                this[c].apply(this, f);
            });
        };
    });
    f.fn.getNiceScroll = function(k) {
        return "undefined" == typeof k ? new C(this) : this[k] && f.data(this[k], "__nicescroll") || !1;
    };
    f.extend(f.expr[":"], {
        nicescroll: function(k) {
            return f.data(k, "__nicescroll") ? !0 : !1;
        }
    });
    f.fn.niceScroll = function(k, c) {
        "undefined" != typeof c || "object" != typeof k || "jquery" in k || (c = k, k = !1);
        c = f.extend({}, c);
        var h = new C;
        "undefined" == typeof c && (c = {});
        k && (c.doc = f(k), c.win = f(this));
        var m = !("doc" in c);
        m || "win" in c || (c.win = f(this));
        this.each(function() {
            var d = f(this).data("__nicescroll") || !1;
            d || (c.doc = m ? f(this) : c.doc, d = new R(c, f(this)), f(this).data("__nicescroll", d));
            h.push(d);
        });
        return 1 == h.length ? h[0] : h;
    };
    window.NiceScroll = {
        getjQuery: function() {
            return f;
        }
    };
    f.nicescroll || (f.nicescroll = new C, f.nicescroll.options = I);
});

},{}],"asMy1":[function(require,module,exports) {
/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */ (function($) {
    // Detect touch support
    $.support.touch = "ontouchend" in document;
    // Ignore browsers without touch support
    if (!$.support.touch) return;
    var mouseProto = $.ui.mouse.prototype, _mouseInit = mouseProto._mouseInit, _mouseDestroy = mouseProto._mouseDestroy, touchHandled;
    /**
   * Simulate a mouse event based on a corresponding touch event
   * @param {Object} event A touch event
   * @param {String} simulatedType The corresponding mouse event
   */ function simulateMouseEvent(event, simulatedType) {
        // Ignore multi-touch events
        if (event.originalEvent.touches.length > 1) return;
        event.preventDefault();
        var touch = event.originalEvent.changedTouches[0], simulatedEvent = document.createEvent("MouseEvents");
        // Initialize the simulated mouse event using the touch event's coordinates
        simulatedEvent.initMouseEvent(simulatedType, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null // relatedTarget              
        );
        // Dispatch the simulated event to the target element
        event.target.dispatchEvent(simulatedEvent);
    }
    /**
   * Handle the jQuery UI widget's touchstart events
   * @param {Object} event The widget element's touchstart event
   */ mouseProto._touchStart = function(event) {
        var self = this;
        // Ignore the event if another widget is already being handled
        if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) return;
        // Set the flag to prevent other widgets from inheriting the touch event
        touchHandled = true;
        // Track movement to determine if interaction was a click
        self._touchMoved = false;
        // Simulate the mouseover event
        simulateMouseEvent(event, "mouseover");
        // Simulate the mousemove event
        simulateMouseEvent(event, "mousemove");
        // Simulate the mousedown event
        simulateMouseEvent(event, "mousedown");
    };
    /**
   * Handle the jQuery UI widget's touchmove events
   * @param {Object} event The document's touchmove event
   */ mouseProto._touchMove = function(event) {
        // Ignore event if not handled
        if (!touchHandled) return;
        // Interaction was not a click
        this._touchMoved = true;
        // Simulate the mousemove event
        simulateMouseEvent(event, "mousemove");
    };
    /**
   * Handle the jQuery UI widget's touchend events
   * @param {Object} event The document's touchend event
   */ mouseProto._touchEnd = function(event) {
        // Ignore event if not handled
        if (!touchHandled) return;
        // Simulate the mouseup event
        simulateMouseEvent(event, "mouseup");
        // Simulate the mouseout event
        simulateMouseEvent(event, "mouseout");
        // If the touch interaction did not move, it should trigger a click
        if (!this._touchMoved) // Simulate the click event
        simulateMouseEvent(event, "click");
        // Unset the flag to allow other widgets to inherit the touch event
        touchHandled = false;
    };
    /**
   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
   * This method extends the widget with bound touch event handlers that
   * translate touch events to mouse events and pass them to the widget's
   * original mouse event handling methods.
   */ mouseProto._mouseInit = function() {
        var self = this;
        // Delegate the touch handlers to the widget's element
        self.element.bind({
            touchstart: $.proxy(self, "_touchStart"),
            touchmove: $.proxy(self, "_touchMove"),
            touchend: $.proxy(self, "_touchEnd")
        });
        // Call the original $.ui.mouse init method
        _mouseInit.call(self);
    };
    /**
   * Remove the touch event handlers
   */ mouseProto._mouseDestroy = function() {
        var self = this;
        // Delegate the touch handlers to the widget's element
        self.element.unbind({
            touchstart: $.proxy(self, "_touchStart"),
            touchmove: $.proxy(self, "_touchMove"),
            touchend: $.proxy(self, "_touchEnd")
        });
        // Call the original $.ui.mouse destroy method
        _mouseDestroy.call(self);
    };
})(jQuery);

},{}],"dlmBG":[function(require,module,exports) {
L.AreaSelect = L.Class.extend({
    includes: L.Mixin.Events,
    options: {
        width: 200,
        height: 300,
        keepAspectRatio: false
    },
    initialize: function(options) {
        L.Util.setOptions(this, options);
        this._width = this.options.width;
        this._height = this.options.height;
    },
    addTo: function(map) {
        this.map = map;
        this._createElements();
        this._render();
        return this;
    },
    getBounds: function() {
        var size = this.map.getSize();
        var topRight = new L.Point();
        var bottomLeft = new L.Point();
        bottomLeft.x = Math.round((size.x - this._width) / 2);
        topRight.y = Math.round((size.y - this._height) / 2);
        topRight.x = size.x - bottomLeft.x;
        bottomLeft.y = size.y - topRight.y;
        var sw = this.map.containerPointToLatLng(bottomLeft);
        var ne = this.map.containerPointToLatLng(topRight);
        return new L.LatLngBounds(sw, ne);
    },
    remove: function() {
        this.map.off("moveend", this._onMapChange);
        this.map.off("zoomend", this._onMapChange);
        this.map.off("resize", this._onMapResize);
        this._container.parentNode.removeChild(this._container);
    },
    setDimensions: function(dimensions) {
        if (!dimensions) return;
        this._height = parseInt(dimensions.height) || this._height;
        this._width = parseInt(dimensions.width) || this._width;
        this._render();
        this.fire("change");
    },
    _createElements: function() {
        if (!!this._container) return;
        this._container = L.DomUtil.create("div", "leaflet-areaselect-container", this.map._controlContainer);
        this._topShade = L.DomUtil.create("div", "leaflet-areaselect-shade leaflet-control", this._container);
        this._bottomShade = L.DomUtil.create("div", "leaflet-areaselect-shade leaflet-control", this._container);
        this._leftShade = L.DomUtil.create("div", "leaflet-areaselect-shade leaflet-control", this._container);
        this._rightShade = L.DomUtil.create("div", "leaflet-areaselect-shade leaflet-control", this._container);
        this._nwHandle = L.DomUtil.create("div", "leaflet-areaselect-handle leaflet-control", this._container);
        this._swHandle = L.DomUtil.create("div", "leaflet-areaselect-handle leaflet-control", this._container);
        this._neHandle = L.DomUtil.create("div", "leaflet-areaselect-handle leaflet-control", this._container);
        this._seHandle = L.DomUtil.create("div", "leaflet-areaselect-handle leaflet-control", this._container);
        this._setUpHandlerEvents(this._nwHandle);
        this._setUpHandlerEvents(this._neHandle, -1, 1);
        this._setUpHandlerEvents(this._swHandle, 1, -1);
        this._setUpHandlerEvents(this._seHandle, -1, -1);
        this.map.on("moveend", this._onMapChange, this);
        this.map.on("zoomend", this._onMapChange, this);
        this.map.on("resize", this._onMapResize, this);
        this.fire("change");
    },
    _setUpHandlerEvents: function(handle, xMod, yMod) {
        xMod = xMod || 1;
        yMod = yMod || 1;
        var self = this;
        function onMouseDown(event) {
            event.stopPropagation();
            self.map.dragging.disable();
            L.DomEvent.removeListener(this, "mousedown", onMouseDown);
            var curX = event.pageX;
            var curY = event.pageY;
            var ratio = self._width / self._height;
            var size = self.map.getSize();
            function onMouseMove(event) {
                if (self.options.keepAspectRatio) {
                    var maxHeight = (self._height >= self._width ? size.y : size.y * (1 / ratio)) - 30;
                    self._height += (curY - event.originalEvent.pageY) * 2 * yMod;
                    self._height = Math.max(30, self._height);
                    self._height = Math.min(maxHeight, self._height);
                    self._width = self._height * ratio;
                } else {
                    self._width += (curX - event.originalEvent.pageX) * 2 * xMod;
                    self._height += (curY - event.originalEvent.pageY) * 2 * yMod;
                    self._width = Math.max(30, self._width);
                    self._height = Math.max(30, self._height);
                    self._width = Math.min(size.x - 30, self._width);
                    self._height = Math.min(size.y - 30, self._height);
                }
                curX = event.originalEvent.pageX;
                curY = event.originalEvent.pageY;
                self._render();
                self.fire("changing");
            }
            function onMouseUp(event) {
                self.map.dragging.enable();
                L.DomEvent.removeListener(self.map, "mouseup", onMouseUp);
                L.DomEvent.removeListener(self.map, "mousemove", onMouseMove);
                L.DomEvent.addListener(handle, "mousedown", onMouseDown);
                self.fire("change", {
                    prevEvent: event
                });
            }
            L.DomEvent.addListener(self.map, "mousemove", onMouseMove);
            L.DomEvent.addListener(self.map, "mouseup", onMouseUp);
        }
        L.DomEvent.addListener(handle, "mousedown", onMouseDown);
    },
    _onMapResize: function() {
        this._render();
    },
    _onMapChange: function(event) {
        this.fire("change", {
            prevEvent: event
        });
    },
    _render: function() {
        var size = this.map.getSize();
        var handleOffset = Math.round(this._nwHandle.offsetWidth / 2);
        var topBottomHeight = Math.round((size.y - this._height) / 2);
        var leftRightWidth = Math.round((size.x - this._width) / 2);
        function setDimensions(element, dimension) {
            element.style.width = dimension.width + "px";
            element.style.height = dimension.height + "px";
            element.style.top = dimension.top + "px";
            element.style.left = dimension.left + "px";
            element.style.bottom = dimension.bottom + "px";
            element.style.right = dimension.right + "px";
        }
        setDimensions(this._topShade, {
            width: size.x,
            height: topBottomHeight,
            top: 0,
            left: 0
        });
        setDimensions(this._bottomShade, {
            width: size.x,
            height: topBottomHeight,
            bottom: 0,
            left: 0
        });
        setDimensions(this._leftShade, {
            width: leftRightWidth,
            height: size.y - topBottomHeight * 2,
            top: topBottomHeight,
            left: 0
        });
        setDimensions(this._rightShade, {
            width: leftRightWidth,
            height: size.y - topBottomHeight * 2,
            top: topBottomHeight,
            right: 0
        });
        setDimensions(this._nwHandle, {
            left: leftRightWidth - handleOffset,
            top: topBottomHeight - 7
        });
        setDimensions(this._neHandle, {
            right: leftRightWidth - handleOffset,
            top: topBottomHeight - 7
        });
        setDimensions(this._swHandle, {
            left: leftRightWidth - handleOffset,
            bottom: topBottomHeight - 7
        });
        setDimensions(this._seHandle, {
            right: leftRightWidth - handleOffset,
            bottom: topBottomHeight - 7
        });
    }
});
L.areaSelect = function(options) {
    return new L.AreaSelect(options);
};

},{}],"fmytP":[function(require,module,exports) {
/*
 Leaflet.draw 0.4.14, a plugin that adds drawing and editing tools to Leaflet powered maps.
 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet

 https://github.com/Leaflet/Leaflet.draw
 http://leafletjs.com
 */ !function(t, e, i) {
    function o(t, e) {
        for(; (t = t.parentElement) && !t.classList.contains(e););
        return t;
    }
    L.drawVersion = "0.4.14", L.Draw = {}, L.drawLocal = {
        draw: {
            toolbar: {
                actions: {
                    title: "Cancel drawing",
                    text: "Cancel"
                },
                finish: {
                    title: "Finish drawing",
                    text: "Finish"
                },
                undo: {
                    title: "Delete last point drawn",
                    text: "Delete last point"
                },
                buttons: {
                    polyline: "Draw a polyline",
                    polygon: "Draw a polygon",
                    rectangle: "Draw a rectangle",
                    circle: "Draw a circle",
                    marker: "Draw a marker",
                    circlemarker: "Draw a circlemarker"
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: "Click and drag to draw circle."
                    },
                    radius: "Radius"
                },
                circlemarker: {
                    tooltip: {
                        start: "Click map to place circle marker."
                    }
                },
                marker: {
                    tooltip: {
                        start: "Click map to place marker."
                    }
                },
                polygon: {
                    tooltip: {
                        start: "Click to start drawing shape.",
                        cont: "Click to continue drawing shape.",
                        end: "Click first point to close this shape."
                    }
                },
                polyline: {
                    error: "<strong>Error:</strong> shape edges cannot cross!",
                    tooltip: {
                        start: "Click to start drawing line.",
                        cont: "Click to continue drawing line.",
                        end: "Click last point to finish line."
                    }
                },
                rectangle: {
                    tooltip: {
                        start: "Click and drag to draw rectangle."
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: "Release mouse to finish drawing."
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: "Save changes",
                        text: "Save"
                    },
                    cancel: {
                        title: "Cancel editing, discards all changes",
                        text: "Cancel"
                    },
                    clearAll: {
                        title: "Clear all layers",
                        text: "Clear All"
                    }
                },
                buttons: {
                    edit: "Edit layers",
                    editDisabled: "No layers to edit",
                    remove: "Delete layers",
                    removeDisabled: "No layers to delete"
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: "Drag handles or markers to edit features.",
                        subtext: "Click cancel to undo changes."
                    }
                },
                remove: {
                    tooltip: {
                        text: "Click on a feature to remove."
                    }
                }
            }
        }
    }, L.Draw.Event = {}, L.Draw.Event.CREATED = "draw:created", L.Draw.Event.EDITED = "draw:edited", L.Draw.Event.DELETED = "draw:deleted", L.Draw.Event.DRAWSTART = "draw:drawstart", L.Draw.Event.DRAWSTOP = "draw:drawstop", L.Draw.Event.DRAWVERTEX = "draw:drawvertex", L.Draw.Event.EDITSTART = "draw:editstart", L.Draw.Event.EDITMOVE = "draw:editmove", L.Draw.Event.EDITRESIZE = "draw:editresize", L.Draw.Event.EDITVERTEX = "draw:editvertex", L.Draw.Event.EDITSTOP = "draw:editstop", L.Draw.Event.DELETESTART = "draw:deletestart", L.Draw.Event.DELETESTOP = "draw:deletestop", L.Draw.Event.TOOLBAROPENED = "draw:toolbaropened", L.Draw.Event.TOOLBARCLOSED = "draw:toolbarclosed", L.Draw.Event.MARKERCONTEXT = "draw:markercontext", L.Draw = L.Draw || {}, L.Draw.Feature = L.Handler.extend({
        initialize: function(t, e) {
            this._map = t, this._container = t._container, this._overlayPane = t._panes.overlayPane, this._popupPane = t._panes.popupPane, e && e.shapeOptions && (e.shapeOptions = L.Util.extend({}, this.options.shapeOptions, e.shapeOptions)), L.setOptions(this, e);
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.Draw.Feature.include(L.Evented.prototype) : L.Draw.Feature.include(L.Mixin.Events);
        },
        enable: function() {
            this._enabled || (L.Handler.prototype.enable.call(this), this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DRAWSTART, {
                layerType: this.type
            }));
        },
        disable: function() {
            this._enabled && (L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DRAWSTOP, {
                layerType: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (L.DomUtil.disableTextSelection(), t.getContainer().focus(), this._tooltip = new L.Draw.Tooltip(this._map), L.DomEvent.on(this._container, "keyup", this._cancelDrawing, this));
        },
        removeHooks: function() {
            this._map && (L.DomUtil.enableTextSelection(), this._tooltip.dispose(), this._tooltip = null, L.DomEvent.off(this._container, "keyup", this._cancelDrawing, this));
        },
        setOptions: function(t) {
            L.setOptions(this, t);
        },
        _fireCreatedEvent: function(t) {
            this._map.fire(L.Draw.Event.CREATED, {
                layer: t,
                layerType: this.type
            });
        },
        _cancelDrawing: function(t) {
            27 === t.keyCode && (this._map.fire("draw:canceled", {
                layerType: this.type
            }), this.disable());
        }
    }), L.Draw.Polyline = L.Draw.Feature.extend({
        statics: {
            TYPE: "polyline"
        },
        Poly: L.Polyline,
        options: {
            allowIntersection: !0,
            repeatMode: !1,
            drawError: {
                color: "#b00b00",
                timeout: 2500
            },
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            guidelineDistance: 20,
            maxGuideLineLength: 4e3,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !1,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            showLength: !0,
            zIndexOffset: 2e3,
            factor: 1,
            maxPoints: 0
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this.options.drawError.message = L.drawLocal.draw.handlers.polyline.error, e && e.drawError && (e.drawError = L.Util.extend({}, this.options.drawError, e.drawError)), this.type = L.Draw.Polyline.TYPE, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._markers = [], this._markerGroup = new L.LayerGroup, this._map.addLayer(this._markerGroup), this._poly = new L.Polyline([], this.options.shapeOptions), this._tooltip.updateContent(this._getTooltipText()), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("mouseout", this._onMouseOut, this).on("mousemove", this._onMouseMove, this).on("mousedown", this._onMouseDown, this).on("mouseup", this._onMouseUp, this).addTo(this._map), this._map.on("mouseup", this._onMouseUp, this).on("mousemove", this._onMouseMove, this).on("zoomlevelschange", this._onZoomEnd, this).on("touchstart", this._onTouch, this).on("zoomend", this._onZoomEnd, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._clearHideErrorTimeout(), this._cleanUpShape(), this._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers, this._map.removeLayer(this._poly), delete this._poly, this._mouseMarker.off("mousedown", this._onMouseDown, this).off("mouseout", this._onMouseOut, this).off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._clearGuides(), this._map.off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this).off("zoomlevelschange", this._onZoomEnd, this).off("zoomend", this._onZoomEnd, this).off("touchstart", this._onTouch, this).off("click", this._onTouch, this);
        },
        deleteLastVertex: function() {
            if (!(this._markers.length <= 1)) {
                var t = this._markers.pop(), e = this._poly, i = e.getLatLngs(), o = i.splice(-1, 1)[0];
                this._poly.setLatLngs(i), this._markerGroup.removeLayer(t), e.getLatLngs().length < 2 && this._map.removeLayer(e), this._vertexChanged(o, !1);
            }
        },
        addVertex: function(t) {
            if (this._markers.length >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(t)) return void this._showErrorTooltip();
            this._errorShown && this._hideErrorTooltip(), this._markers.push(this._createMarker(t)), this._poly.addLatLng(t), 2 === this._poly.getLatLngs().length && this._map.addLayer(this._poly), this._vertexChanged(t, !0);
        },
        completeShape: function() {
            this._markers.length <= 1 || (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
        },
        _finishShape: function() {
            var t = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs(), e = this._poly.newLatLngIntersects(t[t.length - 1]);
            if (!this.options.allowIntersection && e || !this._shapeIsValid()) return void this._showErrorTooltip();
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _shapeIsValid: function() {
            return !0;
        },
        _onZoomEnd: function() {
            null !== this._markers && this._updateGuide();
        },
        _onMouseMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent), i = this._map.layerPointToLatLng(e);
            this._currentLatLng = i, this._updateTooltip(i), this._updateGuide(e), this._mouseMarker.setLatLng(i), L.DomEvent.preventDefault(t.originalEvent);
        },
        _vertexChanged: function(t, e) {
            this._map.fire(L.Draw.Event.DRAWVERTEX, {
                layers: this._markerGroup
            }), this._updateFinishHandler(), this._updateRunningMeasure(t, e), this._clearGuides(), this._updateTooltip();
        },
        _onMouseDown: function(t) {
            if (!this._clickHandled && !this._touchHandled && !this._disableMarkers) {
                this._onMouseMove(t), this._clickHandled = !0, this._disableNewMarkers();
                var e = t.originalEvent, i = e.clientX, o = e.clientY;
                this._startPoint.call(this, i, o);
            }
        },
        _startPoint: function(t, e) {
            this._mouseDownOrigin = L.point(t, e);
        },
        _onMouseUp: function(t) {
            var e = t.originalEvent, i = e.clientX, o = e.clientY;
            this._endPoint.call(this, i, o, t), this._clickHandled = null;
        },
        _endPoint: function(e, i, o) {
            if (this._mouseDownOrigin) {
                var n = L.point(e, i).distanceTo(this._mouseDownOrigin), a = this._calculateFinishDistance(o.latlng);
                this.options.maxPoints > 1 && this.options.maxPoints == this._markers.length + 1 ? (this.addVertex(o.latlng), this._finishShape()) : a < 10 && L.Browser.touch ? this._finishShape() : Math.abs(n) < 9 * (t.devicePixelRatio || 1) && this.addVertex(o.latlng), this._enableNewMarkers();
            }
            this._mouseDownOrigin = null;
        },
        _onTouch: function(t) {
            var e, i, o = t.originalEvent;
            !o.touches || !o.touches[0] || this._clickHandled || this._touchHandled || this._disableMarkers || (e = o.touches[0].clientX, i = o.touches[0].clientY, this._disableNewMarkers(), this._touchHandled = !0, this._startPoint.call(this, e, i), this._endPoint.call(this, e, i, t), this._touchHandled = null), this._clickHandled = null;
        },
        _onMouseOut: function() {
            this._tooltip && this._tooltip._onMouseOut.call(this._tooltip);
        },
        _calculateFinishDistance: function(t) {
            var e;
            if (this._markers.length > 0) {
                var i;
                if (this.type === L.Draw.Polyline.TYPE) i = this._markers[this._markers.length - 1];
                else {
                    if (this.type !== L.Draw.Polygon.TYPE) return 1 / 0;
                    i = this._markers[0];
                }
                var o = this._map.latLngToContainerPoint(i.getLatLng()), n = new L.Marker(t, {
                    icon: this.options.icon,
                    zIndexOffset: 2 * this.options.zIndexOffset
                }), a = this._map.latLngToContainerPoint(n.getLatLng());
                e = o.distanceTo(a);
            } else e = 1 / 0;
            return e;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            t > 1 && this._markers[t - 1].on("click", this._finishShape, this), t > 2 && this._markers[t - 2].off("click", this._finishShape, this);
        },
        _createMarker: function(t) {
            var e = new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: 2 * this.options.zIndexOffset
            });
            return this._markerGroup.addLayer(e), e;
        },
        _updateGuide: function(t) {
            var e = this._markers ? this._markers.length : 0;
            e > 0 && (t = t || this._map.latLngToLayerPoint(this._currentLatLng), this._clearGuides(), this._drawGuide(this._map.latLngToLayerPoint(this._markers[e - 1].getLatLng()), t));
        },
        _updateTooltip: function(t) {
            var e = this._getTooltipText();
            t && this._tooltip.updatePosition(t), this._errorShown || this._tooltip.updateContent(e);
        },
        _drawGuide: function(t, e) {
            var i, o, n, a = Math.floor(Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))), s = this.options.guidelineDistance, r = this.options.maxGuideLineLength, l = a > r ? a - r : s;
            for(this._guidesContainer || (this._guidesContainer = L.DomUtil.create("div", "leaflet-draw-guides", this._overlayPane)); l < a; l += this.options.guidelineDistance)i = l / a, o = {
                x: Math.floor(t.x * (1 - i) + i * e.x),
                y: Math.floor(t.y * (1 - i) + i * e.y)
            }, n = L.DomUtil.create("div", "leaflet-draw-guide-dash", this._guidesContainer), n.style.backgroundColor = this._errorShown ? this.options.drawError.color : this.options.shapeOptions.color, L.DomUtil.setPosition(n, o);
        },
        _updateGuideColor: function(t) {
            if (this._guidesContainer) for(var e = 0, i = this._guidesContainer.childNodes.length; e < i; e++)this._guidesContainer.childNodes[e].style.backgroundColor = t;
        },
        _clearGuides: function() {
            if (this._guidesContainer) for(; this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild);
        },
        _getTooltipText: function() {
            var t, e, i = this.options.showLength;
            return 0 === this._markers.length ? t = {
                text: L.drawLocal.draw.handlers.polyline.tooltip.start
            } : (e = i ? this._getMeasurementString() : "", t = 1 === this._markers.length ? {
                text: L.drawLocal.draw.handlers.polyline.tooltip.cont,
                subtext: e
            } : {
                text: L.drawLocal.draw.handlers.polyline.tooltip.end,
                subtext: e
            }), t;
        },
        _updateRunningMeasure: function(t, e) {
            var i, o, n = this._markers.length;
            1 === this._markers.length ? this._measurementRunningTotal = 0 : (i = n - (e ? 2 : 1), o = L.GeometryUtil.isVersion07x() ? t.distanceTo(this._markers[i].getLatLng()) * (this.options.factor || 1) : this._map.distance(t, this._markers[i].getLatLng()) * (this.options.factor || 1), this._measurementRunningTotal += o * (e ? 1 : -1));
        },
        _getMeasurementString: function() {
            var t, e = this._currentLatLng, i = this._markers[this._markers.length - 1].getLatLng();
            return t = L.GeometryUtil.isVersion07x() ? i && e && e.distanceTo ? this._measurementRunningTotal + e.distanceTo(i) * (this.options.factor || 1) : this._measurementRunningTotal || 0 : i && e ? this._measurementRunningTotal + this._map.distance(e, i) * (this.options.factor || 1) : this._measurementRunningTotal || 0, L.GeometryUtil.readableDistance(t, this.options.metric, this.options.feet, this.options.nautic, this.options.precision);
        },
        _showErrorTooltip: function() {
            this._errorShown = !0, this._tooltip.showAsError().updateContent({
                text: this.options.drawError.message
            }), this._updateGuideColor(this.options.drawError.color), this._poly.setStyle({
                color: this.options.drawError.color
            }), this._clearHideErrorTimeout(), this._hideErrorTimeout = setTimeout(L.Util.bind(this._hideErrorTooltip, this), this.options.drawError.timeout);
        },
        _hideErrorTooltip: function() {
            this._errorShown = !1, this._clearHideErrorTimeout(), this._tooltip.removeError().updateContent(this._getTooltipText()), this._updateGuideColor(this.options.shapeOptions.color), this._poly.setStyle({
                color: this.options.shapeOptions.color
            });
        },
        _clearHideErrorTimeout: function() {
            this._hideErrorTimeout && (clearTimeout(this._hideErrorTimeout), this._hideErrorTimeout = null);
        },
        _disableNewMarkers: function() {
            this._disableMarkers = !0;
        },
        _enableNewMarkers: function() {
            setTimeout((function() {
                this._disableMarkers = !1;
            }).bind(this), 50);
        },
        _cleanUpShape: function() {
            this._markers.length > 1 && this._markers[this._markers.length - 1].off("click", this._finishShape, this);
        },
        _fireCreatedEvent: function() {
            var t = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.Polygon = L.Draw.Polyline.extend({
        statics: {
            TYPE: "polygon"
        },
        Poly: L.Polygon,
        options: {
            showArea: !1,
            showLength: !1,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            precision: {}
        },
        initialize: function(t, e) {
            L.Draw.Polyline.prototype.initialize.call(this, t, e), this.type = L.Draw.Polygon.TYPE;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            1 === t && this._markers[0].on("click", this._finishShape, this), t > 2 && (this._markers[t - 1].on("dblclick", this._finishShape, this), t > 3 && this._markers[t - 2].off("dblclick", this._finishShape, this));
        },
        _getTooltipText: function() {
            var t, e;
            return 0 === this._markers.length ? t = L.drawLocal.draw.handlers.polygon.tooltip.start : this._markers.length < 3 ? (t = L.drawLocal.draw.handlers.polygon.tooltip.cont, e = this._getMeasurementString()) : (t = L.drawLocal.draw.handlers.polygon.tooltip.end, e = this._getMeasurementString()), {
                text: t,
                subtext: e
            };
        },
        _getMeasurementString: function() {
            var t = this._area, e = "";
            return t || this.options.showLength ? (this.options.showLength && (e = L.Draw.Polyline.prototype._getMeasurementString.call(this)), t && (e += "<br>" + L.GeometryUtil.readableArea(t, this.options.metric, this.options.precision)), e) : null;
        },
        _shapeIsValid: function() {
            return this._markers.length >= 3;
        },
        _vertexChanged: function(t, e) {
            var i;
            !this.options.allowIntersection && this.options.showArea && (i = this._poly.getLatLngs(), this._area = L.GeometryUtil.geodesicArea(i)), L.Draw.Polyline.prototype._vertexChanged.call(this, t, e);
        },
        _cleanUpShape: function() {
            var t = this._markers.length;
            t > 0 && (this._markers[0].off("click", this._finishShape, this), t > 2 && this._markers[t - 1].off("dblclick", this._finishShape, this));
        }
    }), L.SimpleShape = {}, L.Draw.SimpleShape = L.Draw.Feature.extend({
        options: {
            repeatMode: !1
        },
        initialize: function(t, e) {
            this._endLabelText = L.drawLocal.draw.handlers.simpleshape.tooltip.end, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._mapDraggable = this._map.dragging.enabled(), this._mapDraggable && this._map.dragging.disable(), this._container.style.cursor = "crosshair", this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._map.on("mousedown", this._onMouseDown, this).on("mousemove", this._onMouseMove, this).on("touchstart", this._onMouseDown, this).on("touchmove", this._onMouseMove, this), e.addEventListener("touchstart", L.DomEvent.preventDefault, {
                passive: !1
            }));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._mapDraggable && this._map.dragging.enable(), this._container.style.cursor = "", this._map.off("mousedown", this._onMouseDown, this).off("mousemove", this._onMouseMove, this).off("touchstart", this._onMouseDown, this).off("touchmove", this._onMouseMove, this), L.DomEvent.off(e, "mouseup", this._onMouseUp, this), L.DomEvent.off(e, "touchend", this._onMouseUp, this), e.removeEventListener("touchstart", L.DomEvent.preventDefault), this._shape && (this._map.removeLayer(this._shape), delete this._shape)), this._isDrawing = !1;
        },
        _getTooltipText: function() {
            return {
                text: this._endLabelText
            };
        },
        _onMouseDown: function(t) {
            this._isDrawing = !0, this._startLatLng = t.latlng, L.DomEvent.on(e, "mouseup", this._onMouseUp, this).on(e, "touchend", this._onMouseUp, this).preventDefault(t.originalEvent);
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._isDrawing && (this._tooltip.updateContent(this._getTooltipText()), this._drawShape(e));
        },
        _onMouseUp: function() {
            this._shape && this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        }
    }), L.Draw.Rectangle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "rectangle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                showArea: !0,
                clickable: !0
            },
            metric: !0
        },
        initialize: function(t, e) {
            this.type = L.Draw.Rectangle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.rectangle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        disable: function() {
            this._enabled && (this._isCurrentlyTwoClickDrawing = !1, L.Draw.SimpleShape.prototype.disable.call(this));
        },
        _onMouseUp: function(t) {
            if (!this._shape && !this._isCurrentlyTwoClickDrawing) return void (this._isCurrentlyTwoClickDrawing = !0);
            this._isCurrentlyTwoClickDrawing && !o(t.target, "leaflet-pane") || L.Draw.SimpleShape.prototype._onMouseUp.call(this);
        },
        _drawShape: function(t) {
            this._shape ? this._shape.setBounds(new L.LatLngBounds(this._startLatLng, t)) : (this._shape = new L.Rectangle(new L.LatLngBounds(this._startLatLng, t), this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Rectangle(this._shape.getBounds(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _getTooltipText: function() {
            var t, e, i, o = L.Draw.SimpleShape.prototype._getTooltipText.call(this), n = this._shape, a = this.options.showArea;
            return n && (t = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), e = L.GeometryUtil.geodesicArea(t), i = a ? L.GeometryUtil.readableArea(e, this.options.metric) : ""), {
                text: o.text,
                subtext: i
            };
        }
    }), L.Draw.Marker = L.Draw.Feature.extend({
        statics: {
            TYPE: "marker"
        },
        options: {
            icon: new L.Icon.Default,
            repeatMode: !1,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.Marker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.marker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("click", this._onClick, this).addTo(this._map), this._map.on("mousemove", this._onMouseMove, this), this._map.on("click", this._onTouch, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._map.off("click", this._onClick, this).off("click", this._onTouch, this), this._marker && (this._marker.off("click", this._onClick, this), this._map.removeLayer(this._marker), delete this._marker), this._mouseMarker.off("click", this._onClick, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._map.off("mousemove", this._onMouseMove, this));
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._mouseMarker.setLatLng(e), this._marker ? (e = this._mouseMarker.getLatLng(), this._marker.setLatLng(e)) : (this._marker = this._createMarker(e), this._marker.on("click", this._onClick, this), this._map.on("click", this._onClick, this).addLayer(this._marker));
        },
        _createMarker: function(t) {
            return new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: this.options.zIndexOffset
            });
        },
        _onClick: function() {
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _onTouch: function(t) {
            this._onMouseMove(t), this._onClick();
        },
        _fireCreatedEvent: function() {
            var t = new L.Marker.Touch(this._marker.getLatLng(), {
                icon: this.options.icon
            });
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.CircleMarker = L.Draw.Marker.extend({
        statics: {
            TYPE: "circlemarker"
        },
        options: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            clickable: !0,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.CircleMarker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circlemarker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        _fireCreatedEvent: function() {
            var t = new L.CircleMarker(this._marker.getLatLng(), this.options);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        },
        _createMarker: function(t) {
            return new L.CircleMarker(t, this.options);
        }
    }), L.Draw.Circle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "circle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            showRadius: !0,
            metric: !0,
            feet: !0,
            nautic: !1
        },
        initialize: function(t, e) {
            this.type = L.Draw.Circle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        _drawShape: function(t) {
            if (L.GeometryUtil.isVersion07x()) var e = this._startLatLng.distanceTo(t);
            else var e = this._map.distance(this._startLatLng, t);
            this._shape ? this._shape.setRadius(e) : (this._shape = new L.Circle(this._startLatLng, e, this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Circle(this._startLatLng, this._shape.getRadius(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _onMouseMove: function(t) {
            var e, i = t.latlng, o = this.options.showRadius, n = this.options.metric;
            if (this._tooltip.updatePosition(i), this._isDrawing) {
                this._drawShape(i), e = this._shape.getRadius().toFixed(1);
                var a = "";
                o && (a = L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(e, n, this.options.feet, this.options.nautic)), this._tooltip.updateContent({
                    text: this._endLabelText,
                    subtext: a
                });
            }
        }
    }), L.Edit = L.Edit || {}, L.Edit.Marker = L.Handler.extend({
        initialize: function(t, e) {
            this._marker = t, L.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._marker;
            t.dragging.enable(), t.on("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        removeHooks: function() {
            var t = this._marker;
            t.dragging.disable(), t.off("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        _onDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _toggleMarkerHighlight: function() {
            var t = this._marker._icon;
            t && (t.style.display = "none", L.DomUtil.hasClass(t, "leaflet-edit-marker-selected") ? (L.DomUtil.removeClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, -4)) : (L.DomUtil.addClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, 4)), t.style.display = "");
        },
        _offsetMarker: function(t, e) {
            var i = parseInt(t.style.marginTop, 10) - e, o = parseInt(t.style.marginLeft, 10) - e;
            t.style.marginTop = i + "px", t.style.marginLeft = o + "px";
        }
    }), L.Marker.addInitHook(function() {
        L.Edit.Marker && (this.editing = new L.Edit.Marker(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.Poly = L.Handler.extend({
        initialize: function(t) {
            this.latlngs = [
                t._latlngs
            ], t._holes && (this.latlngs = this.latlngs.concat(t._holes)), this._poly = t, this._poly.on("revert-edited", this._updateLatLngs, this);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._poly._latlngs) ? this._poly._latlngs : this._poly._latlngs[0] : this._poly._latlngs;
        },
        _eachVertexHandler: function(t) {
            for(var e = 0; e < this._verticesHandlers.length; e++)t(this._verticesHandlers[e]);
        },
        addHooks: function() {
            this._initHandlers(), this._eachVertexHandler(function(t) {
                t.addHooks();
            });
        },
        removeHooks: function() {
            this._eachVertexHandler(function(t) {
                t.removeHooks();
            });
        },
        updateMarkers: function() {
            this._eachVertexHandler(function(t) {
                t.updateMarkers();
            });
        },
        _initHandlers: function() {
            this._verticesHandlers = [];
            for(var t = 0; t < this.latlngs.length; t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly, this.latlngs[t], this._poly.options.poly));
        },
        _updateLatLngs: function(t) {
            this.latlngs = [
                t.layer._latlngs
            ], t.layer._holes && (this.latlngs = this.latlngs.concat(t.layer._holes));
        }
    }), L.Edit.PolyVerticesEdit = L.Handler.extend({
        options: {
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            drawError: {
                color: "#b00b00",
                timeout: 1e3
            }
        },
        initialize: function(t, e, i) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this._poly = t, i && i.drawError && (i.drawError = L.Util.extend({}, this.options.drawError, i.drawError)), this._latlngs = e, L.setOptions(this, i);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0] : this._latlngs;
        },
        addHooks: function() {
            var t = this._poly, e = t._path;
            t instanceof L.Polygon || (t.options.fill = !1, t.options.editing && (t.options.editing.fill = !1)), e && t.options.editing.className && (t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.editing), this._poly._map && (this._map = this._poly._map, this._markerGroup || this._initMarkers(), this._poly._map.addLayer(this._markerGroup));
        },
        removeHooks: function() {
            var t = this._poly, e = t._path;
            e && t.options.editing.className && (t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.original), t._map && (t._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers);
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._markers = [];
            var t, e, i, o, n = this._defaultShape();
            for(t = 0, i = n.length; t < i; t++)o = this._createMarker(n[t], t), o.on("click", this._onMarkerClick, this), o.on("contextmenu", this._onContextMenu, this), this._markers.push(o);
            var a, s;
            for(t = 0, e = i - 1; t < i; e = t++)(0 !== t || L.Polygon && this._poly instanceof L.Polygon) && (a = this._markers[e], s = this._markers[t], this._createMiddleMarker(a, s), this._updatePrevNext(a, s));
        },
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: this.options.icon
            });
            return i._origLatLng = t, i._index = e, i.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._fireEdit, this).on("touchmove", this._onTouchMove, this).on("touchend", this._fireEdit, this).on("MSPointerMove", this._onTouchMove, this).on("MSPointerUp", this._fireEdit, this), this._markerGroup.addLayer(i), i;
        },
        _onMarkerDragStart: function() {
            this._poly.fire("editstart");
        },
        _spliceLatLngs: function() {
            var t = this._defaultShape(), e = [].splice.apply(t, arguments);
            return this._poly._convertLatLngs(t, !0), this._poly.redraw(), e;
        },
        _removeMarker: function(t) {
            var e = t._index;
            this._markerGroup.removeLayer(t), this._markers.splice(e, 1), this._spliceLatLngs(e, 1), this._updateIndexes(e, -1), t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._fireEdit, this).off("touchmove", this._onMarkerDrag, this).off("touchend", this._fireEdit, this).off("click", this._onMarkerClick, this).off("MSPointerMove", this._onTouchMove, this).off("MSPointerUp", this._fireEdit, this);
        },
        _fireEdit: function() {
            this._poly.edited = !0, this._poly.fire("edit"), this._poly._map.fire(L.Draw.Event.EDITVERTEX, {
                layers: this._markerGroup,
                poly: this._poly
            });
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = this._poly;
            if (L.extend(e._origLatLng, e._latlng), e._middleLeft && e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev, e)), e._middleRight && e._middleRight.setLatLng(this._getMiddleLatLng(e, e._next)), i.options.poly) {
                var o = i._map._editTooltip;
                if (!i.options.poly.allowIntersection && i.intersects()) {
                    var n = i.options.color;
                    i.setStyle({
                        color: this.options.drawError.color
                    }), 0 !== L.version.indexOf("0.7") && e.dragging._draggable._onUp(t), this._onMarkerClick(t), o && o.updateContent({
                        text: L.drawLocal.draw.handlers.polyline.error
                    }), setTimeout(function() {
                        i.setStyle({
                            color: n
                        }), o && o.updateContent({
                            text: L.drawLocal.edit.handlers.edit.tooltip.text,
                            subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
                        });
                    }, 1e3);
                }
            }
            this._poly._bounds._southWest = L.latLng(1 / 0, 1 / 0), this._poly._bounds._northEast = L.latLng(-1 / 0, -1 / 0);
            var a = this._poly.getLatLngs();
            this._poly._convertLatLngs(a, !0), this._poly.redraw(), this._poly.fire("editdrag");
        },
        _onMarkerClick: function(t) {
            var e = L.Polygon && this._poly instanceof L.Polygon ? 4 : 3, i = t.target;
            this._defaultShape().length < e || (this._removeMarker(i), this._updatePrevNext(i._prev, i._next), i._middleLeft && this._markerGroup.removeLayer(i._middleLeft), i._middleRight && this._markerGroup.removeLayer(i._middleRight), i._prev && i._next ? this._createMiddleMarker(i._prev, i._next) : i._prev ? i._next || (i._prev._middleRight = null) : i._next._middleLeft = null, this._fireEdit());
        },
        _onContextMenu: function(t) {
            var e = t.target;
            this._poly;
            this._poly._map.fire(L.Draw.Event.MARKERCONTEXT, {
                marker: e,
                layers: this._markerGroup,
                poly: this._poly
            }), L.DomEvent.stopPropagation;
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e), o = t.target;
            L.extend(o._origLatLng, i), o._middleLeft && o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev, o)), o._middleRight && o._middleRight.setLatLng(this._getMiddleLatLng(o, o._next)), this._poly.redraw(), this.updateMarkers();
        },
        _updateIndexes: function(t, e) {
            this._markerGroup.eachLayer(function(i) {
                i._index > t && (i._index += e);
            });
        },
        _createMiddleMarker: function(t, e) {
            var i, o, n, a = this._getMiddleLatLng(t, e), s = this._createMarker(a);
            s.setOpacity(.6), t._middleRight = e._middleLeft = s, o = function() {
                s.off("touchmove", o, this);
                var n = e._index;
                s._index = n, s.off("click", i, this).on("click", this._onMarkerClick, this), a.lat = s.getLatLng().lat, a.lng = s.getLatLng().lng, this._spliceLatLngs(n, 0, a), this._markers.splice(n, 0, s), s.setOpacity(1), this._updateIndexes(n, 1), e._index++, this._updatePrevNext(t, s), this._updatePrevNext(s, e), this._poly.fire("editstart");
            }, n = function() {
                s.off("dragstart", o, this), s.off("dragend", n, this), s.off("touchmove", o, this), this._createMiddleMarker(t, s), this._createMiddleMarker(s, e);
            }, i = function() {
                o.call(this), n.call(this), this._fireEdit();
            }, s.on("click", i, this).on("dragstart", o, this).on("dragend", n, this).on("touchmove", o, this), this._markerGroup.addLayer(s);
        },
        _updatePrevNext: function(t, e) {
            t && (t._next = e), e && (e._prev = t);
        },
        _getMiddleLatLng: function(t, e) {
            var i = this._poly._map, o = i.project(t.getLatLng()), n = i.project(e.getLatLng());
            return i.unproject(o._add(n)._divideBy(2));
        }
    }), L.Polyline.addInitHook(function() {
        this.editing || (L.Edit.Poly && (this.editing = new L.Edit.Poly(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        }));
    }), L.Edit = L.Edit || {}, L.Edit.SimpleShape = L.Handler.extend({
        options: {
            moveIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move"
            }),
            resizeIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"
            }),
            touchMoveIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"
            }),
            touchResizeIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"
            })
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.moveIcon = this.options.touchMoveIcon, this.options.resizeIcon = this.options.touchResizeIcon), this._shape = t, L.Util.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._shape;
            this._shape._map && (this._map = this._shape._map, t.setStyle(t.options.editing), t._map && (this._map = t._map, this._markerGroup || this._initMarkers(), this._map.addLayer(this._markerGroup)));
        },
        removeHooks: function() {
            var t = this._shape;
            if (t.setStyle(t.options.original), t._map) {
                this._unbindMarker(this._moveMarker);
                for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._unbindMarker(this._resizeMarkers[e]);
                this._resizeMarkers = null, this._map.removeLayer(this._markerGroup), delete this._markerGroup;
            }
            this._map = null;
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._createMoveMarker(), this._createResizeMarker();
        },
        _createMoveMarker: function() {},
        _createResizeMarker: function() {},
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: e,
                zIndexOffset: 10
            });
            return this._bindMarker(i), this._markerGroup.addLayer(i), i;
        },
        _bindMarker: function(t) {
            t.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._onMarkerDragEnd, this).on("touchstart", this._onTouchStart, this).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onTouchEnd, this).on("MSPointerUp", this._onTouchEnd, this);
        },
        _unbindMarker: function(t) {
            t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._onMarkerDragEnd, this).off("touchstart", this._onTouchStart, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onTouchEnd, this).off("MSPointerUp", this._onTouchEnd, this);
        },
        _onMarkerDragStart: function(t) {
            t.target.setOpacity(0), this._shape.fire("editstart");
        },
        _fireEdit: function() {
            this._shape.edited = !0, this._shape.fire("edit");
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = e.getLatLng();
            e === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), this._shape.fire("editdrag");
        },
        _onMarkerDragEnd: function(t) {
            t.target.setOpacity(1), this._fireEdit();
        },
        _onTouchStart: function(t) {
            if (L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t), "function" == typeof this._getCorners) {
                var e = this._getCorners(), i = t.target, o = i._cornerIndex;
                i.setOpacity(0), this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
            }
            this._shape.fire("editstart");
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e);
            return t.target === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), !1;
        },
        _onTouchEnd: function(t) {
            t.target.setOpacity(1), this.updateMarkers(), this._fireEdit();
        },
        _move: function() {},
        _resize: function() {}
    }), L.Edit = L.Edit || {}, L.Edit.Rectangle = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getBounds(), e = t.getCenter();
            this._moveMarker = this._createMarker(e, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            var t = this._getCorners();
            this._resizeMarkers = [];
            for(var e = 0, i = t.length; e < i; e++)this._resizeMarkers.push(this._createMarker(t[e], this.options.resizeIcon)), this._resizeMarkers[e]._cornerIndex = e;
        },
        _onMarkerDragStart: function(t) {
            L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t);
            var e = this._getCorners(), i = t.target, o = i._cornerIndex;
            this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
        },
        _onMarkerDragEnd: function(t) {
            var e, i, o = t.target;
            o === this._moveMarker && (e = this._shape.getBounds(), i = e.getCenter(), o.setLatLng(i)), this._toggleCornerMarkers(1), this._repositionCornerMarkers(), L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, t);
        },
        _move: function(t) {
            for(var e, i = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), o = this._shape.getBounds(), n = o.getCenter(), a = [], s = 0, r = i.length; s < r; s++)e = [
                i[s].lat - n.lat,
                i[s].lng - n.lng
            ], a.push([
                t.lat + e[0],
                t.lng + e[1]
            ]);
            this._shape.setLatLngs(a), this._repositionCornerMarkers(), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        },
        _resize: function(t) {
            var e;
            this._shape.setBounds(L.latLngBounds(t, this._oppositeCorner)), e = this._shape.getBounds(), this._moveMarker.setLatLng(e.getCenter()), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        },
        _getCorners: function() {
            var t = this._shape.getBounds();
            return [
                t.getNorthWest(),
                t.getNorthEast(),
                t.getSouthEast(),
                t.getSouthWest()
            ];
        },
        _toggleCornerMarkers: function(t) {
            for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setOpacity(t);
        },
        _repositionCornerMarkers: function() {
            for(var t = this._getCorners(), e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setLatLng(t[e]);
        }
    }), L.Rectangle.addInitHook(function() {
        L.Edit.Rectangle && (this.editing = new L.Edit.Rectangle(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.CircleMarker = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getLatLng();
            this._moveMarker = this._createMarker(t, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            this._resizeMarkers = [];
        },
        _move: function(t) {
            if (this._resizeMarkers.length) {
                var e = this._getResizeMarkerPoint(t);
                this._resizeMarkers[0].setLatLng(e);
            }
            this._shape.setLatLng(t), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        }
    }), L.CircleMarker.addInitHook(function() {
        L.Edit.CircleMarker && (this.editing = new L.Edit.CircleMarker(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
    }), L.Edit = L.Edit || {}, L.Edit.Circle = L.Edit.CircleMarker.extend({
        _createResizeMarker: function() {
            var t = this._shape.getLatLng(), e = this._getResizeMarkerPoint(t);
            this._resizeMarkers = [], this._resizeMarkers.push(this._createMarker(e, this.options.resizeIcon));
        },
        _getResizeMarkerPoint: function(t) {
            var e = this._shape._radius * Math.cos(Math.PI / 4), i = this._map.project(t);
            return this._map.unproject([
                i.x + e,
                i.y - e
            ]);
        },
        _resize: function(t) {
            var e = this._moveMarker.getLatLng();
            L.GeometryUtil.isVersion07x() ? radius = e.distanceTo(t) : radius = this._map.distance(e, t), this._shape.setRadius(radius), this._map._editTooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.subtext + "<br />" + L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(radius, !0, this.options.feet, this.options.nautic)
            }), this._shape.setRadius(radius), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        }
    }), L.Circle.addInitHook(function() {
        L.Edit.Circle && (this.editing = new L.Edit.Circle(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
    }), L.Map.mergeOptions({
        touchExtend: !0
    }), L.Map.TouchExtend = L.Handler.extend({
        initialize: function(t) {
            this._map = t, this._container = t._container, this._pane = t._panes.overlayPane;
        },
        addHooks: function() {
            L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.on(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.on(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.on(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.on(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.on(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.on(this._container, "touchleave", this._onTouchLeave, this));
        },
        removeHooks: function() {
            L.DomEvent.off(this._container, "touchstart", this._onTouchStart), L.DomEvent.off(this._container, "touchend", this._onTouchEnd), L.DomEvent.off(this._container, "touchmove", this._onTouchMove), this._detectIE() ? (L.DomEvent.off(this._container, "MSPointerDowm", this._onTouchStart), L.DomEvent.off(this._container, "MSPointerUp", this._onTouchEnd), L.DomEvent.off(this._container, "MSPointerMove", this._onTouchMove), L.DomEvent.off(this._container, "MSPointerCancel", this._onTouchCancel)) : (L.DomEvent.off(this._container, "touchcancel", this._onTouchCancel), L.DomEvent.off(this._container, "touchleave", this._onTouchLeave));
        },
        _touchEvent: function(t, e) {
            var i = {};
            if (void 0 !== t.touches) {
                if (!t.touches.length) return;
                i = t.touches[0];
            } else {
                if ("touch" !== t.pointerType) return;
                if (i = t, !this._filterClick(t)) return;
            }
            var o = this._map.mouseEventToContainerPoint(i), n = this._map.mouseEventToLayerPoint(i), a = this._map.layerPointToLatLng(n);
            this._map.fire(e, {
                latlng: a,
                layerPoint: n,
                containerPoint: o,
                pageX: i.pageX,
                pageY: i.pageY,
                originalEvent: t
            });
        },
        _filterClick: function(t) {
            var e = t.timeStamp || t.originalEvent.timeStamp, i = L.DomEvent._lastClick && e - L.DomEvent._lastClick;
            return i && i > 100 && i < 500 || t.target._simulatedClick && !t._simulated ? (L.DomEvent.stop(t), !1) : (L.DomEvent._lastClick = e, !0);
        },
        _onTouchStart: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchstart");
        },
        _onTouchEnd: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchend");
        },
        _onTouchCancel: function(t) {
            if (this._map._loaded) {
                var e = "touchcancel";
                this._detectIE() && (e = "pointercancel"), this._touchEvent(t, e);
            }
        },
        _onTouchLeave: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchleave");
        },
        _onTouchMove: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchmove");
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var n = e.indexOf("Edge/");
            return n > 0 && parseInt(e.substring(n + 5, e.indexOf(".", n)), 10);
        }
    }), L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend), L.Marker.Touch = L.Marker.extend({
        _initInteraction: function() {
            return this.addInteractiveTarget ? L.Marker.prototype._initInteraction.apply(this) : this._initInteractionLegacy();
        },
        _initInteractionLegacy: function() {
            if (this.options.clickable) {
                var t = this._icon, e = [
                    "dblclick",
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "contextmenu",
                    "touchstart",
                    "touchend",
                    "touchmove"
                ];
                this._detectIE ? e.concat([
                    "MSPointerDown",
                    "MSPointerUp",
                    "MSPointerMove",
                    "MSPointerCancel"
                ]) : e.concat([
                    "touchcancel"
                ]), L.DomUtil.addClass(t, "leaflet-clickable"), L.DomEvent.on(t, "click", this._onMouseClick, this), L.DomEvent.on(t, "keypress", this._onKeyPress, this);
                for(var i = 0; i < e.length; i++)L.DomEvent.on(t, e[i], this._fireMouseEvent, this);
                L.Handler.MarkerDrag && (this.dragging = new L.Handler.MarkerDrag(this), this.options.draggable && this.dragging.enable());
            }
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var n = e.indexOf("Edge/");
            return n > 0 && parseInt(e.substring(n + 5, e.indexOf(".", n)), 10);
        }
    }), L.LatLngUtil = {
        cloneLatLngs: function(t) {
            for(var e = [], i = 0, o = t.length; i < o; i++)Array.isArray(t[i]) ? e.push(L.LatLngUtil.cloneLatLngs(t[i])) : e.push(this.cloneLatLng(t[i]));
            return e;
        },
        cloneLatLng: function(t) {
            return L.latLng(t.lat, t.lng);
        }
    }, function() {
        var t = {
            km: 2,
            ha: 2,
            m: 0,
            mi: 2,
            ac: 2,
            yd: 0,
            ft: 0,
            nm: 2
        };
        L.GeometryUtil = L.extend(L.GeometryUtil || {}, {
            geodesicArea: function(t) {
                var e, i, o = t.length, n = 0, a = Math.PI / 180;
                if (o > 2) {
                    for(var s = 0; s < o; s++)e = t[s], i = t[(s + 1) % o], n += (i.lng - e.lng) * a * (2 + Math.sin(e.lat * a) + Math.sin(i.lat * a));
                    n = 6378137 * n * 6378137 / 2;
                }
                return Math.abs(n);
            },
            formattedNumber: function(t, e) {
                var i = parseFloat(t).toFixed(e), o = L.drawLocal.format && L.drawLocal.format.numeric, n = o && o.delimiters, a = n && n.thousands, s = n && n.decimal;
                if (a || s) {
                    var r = i.split(".");
                    i = a ? r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + a) : r[0], s = s || ".", r.length > 1 && (i = i + s + r[1]);
                }
                return i;
            },
            readableArea: function(e, i, o) {
                var n, a, o = L.Util.extend({}, t, o);
                return i ? (a = [
                    "ha",
                    "m"
                ], type = typeof i, "string" === type ? a = [
                    i
                ] : "boolean" !== type && (a = i), n = e >= 1e6 && -1 !== a.indexOf("km") ? L.GeometryUtil.formattedNumber(1e-6 * e, o.km) + " km\xb2" : e >= 1e4 && -1 !== a.indexOf("ha") ? L.GeometryUtil.formattedNumber(1e-4 * e, o.ha) + " ha" : L.GeometryUtil.formattedNumber(e, o.m) + " m\xb2") : (e /= .836127, n = e >= 3097600 ? L.GeometryUtil.formattedNumber(e / 3097600, o.mi) + " mi\xb2" : e >= 4840 ? L.GeometryUtil.formattedNumber(e / 4840, o.ac) + " acres" : L.GeometryUtil.formattedNumber(e, o.yd) + " yd\xb2"), n;
            },
            readableDistance: function(e, i, o, n, a) {
                var s, a = L.Util.extend({}, t, a);
                switch(i ? "string" == typeof i ? i : "metric" : o ? "feet" : n ? "nauticalMile" : "yards"){
                    case "metric":
                        s = e > 1e3 ? L.GeometryUtil.formattedNumber(e / 1e3, a.km) + " km" : L.GeometryUtil.formattedNumber(e, a.m) + " m";
                        break;
                    case "feet":
                        e *= 3.28083, s = L.GeometryUtil.formattedNumber(e, a.ft) + " ft";
                        break;
                    case "nauticalMile":
                        e *= .53996, s = L.GeometryUtil.formattedNumber(e / 1e3, a.nm) + " nm";
                        break;
                    case "yards":
                    default:
                        e *= 1.09361, s = e > 1760 ? L.GeometryUtil.formattedNumber(e / 1760, a.mi) + " miles" : L.GeometryUtil.formattedNumber(e, a.yd) + " yd";
                }
                return s;
            },
            isVersion07x: function() {
                var t = L.version.split(".");
                return 0 === parseInt(t[0], 10) && 7 === parseInt(t[1], 10);
            }
        });
    }(), L.Util.extend(L.LineUtil, {
        segmentsIntersect: function(t, e, i, o) {
            return this._checkCounterclockwise(t, i, o) !== this._checkCounterclockwise(e, i, o) && this._checkCounterclockwise(t, e, i) !== this._checkCounterclockwise(t, e, o);
        },
        _checkCounterclockwise: function(t, e, i) {
            return (i.y - t.y) * (e.x - t.x) > (e.y - t.y) * (i.x - t.x);
        }
    }), L.Polyline.include({
        intersects: function() {
            var t, e, i, o = this._getProjectedPoints(), n = o ? o.length : 0;
            if (this._tooFewPointsForIntersection()) return !1;
            for(t = n - 1; t >= 3; t--)if (e = o[t - 1], i = o[t], this._lineSegmentsIntersectsRange(e, i, t - 2)) return !0;
            return !1;
        },
        newLatLngIntersects: function(t, e) {
            return !!this._map && this.newPointIntersects(this._map.latLngToLayerPoint(t), e);
        },
        newPointIntersects: function(t, e) {
            var i = this._getProjectedPoints(), o = i ? i.length : 0, n = i ? i[o - 1] : null, a = o - 2;
            return !this._tooFewPointsForIntersection(1) && this._lineSegmentsIntersectsRange(n, t, a, e ? 1 : 0);
        },
        _tooFewPointsForIntersection: function(t) {
            var e = this._getProjectedPoints(), i = e ? e.length : 0;
            return i += t || 0, !e || i <= 3;
        },
        _lineSegmentsIntersectsRange: function(t, e, i, o) {
            var n, a, s = this._getProjectedPoints();
            o = o || 0;
            for(var r = i; r > o; r--)if (n = s[r - 1], a = s[r], L.LineUtil.segmentsIntersect(t, e, n, a)) return !0;
            return !1;
        },
        _getProjectedPoints: function() {
            if (!this._defaultShape) return this._originalPoints;
            for(var t = [], e = this._defaultShape(), i = 0; i < e.length; i++)t.push(this._map.latLngToLayerPoint(e[i]));
            return t;
        }
    }), L.Polygon.include({
        intersects: function() {
            var t, e, i, o, n = this._getProjectedPoints();
            return !this._tooFewPointsForIntersection() && (!!L.Polyline.prototype.intersects.call(this) || (t = n.length, e = n[0], i = n[t - 1], o = t - 2, this._lineSegmentsIntersectsRange(i, e, o, 1)));
        }
    }), L.Control.Draw = L.Control.extend({
        options: {
            position: "topleft",
            draw: {},
            edit: !1
        },
        initialize: function(t) {
            if (L.version < "0.7") throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");
            L.Control.prototype.initialize.call(this, t);
            var e;
            this._toolbars = {}, L.DrawToolbar && this.options.draw && (e = new L.DrawToolbar(this.options.draw), this._toolbars[L.DrawToolbar.TYPE] = e, this._toolbars[L.DrawToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.EditToolbar && this.options.edit && (e = new L.EditToolbar(this.options.edit), this._toolbars[L.EditToolbar.TYPE] = e, this._toolbars[L.EditToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.toolbar = this;
        },
        onAdd: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw"), o = !1;
            for(var n in this._toolbars)this._toolbars.hasOwnProperty(n) && (e = this._toolbars[n].addToolbar(t)) && (o || (L.DomUtil.hasClass(e, "leaflet-draw-toolbar-top") || L.DomUtil.addClass(e.childNodes[0], "leaflet-draw-toolbar-top"), o = !0), i.appendChild(e));
            return i;
        },
        onRemove: function() {
            for(var t in this._toolbars)this._toolbars.hasOwnProperty(t) && this._toolbars[t].removeToolbar();
        },
        setDrawingOptions: function(t) {
            for(var e in this._toolbars)this._toolbars[e] instanceof L.DrawToolbar && this._toolbars[e].setOptions(t);
        },
        _toolbarEnabled: function(t) {
            var e = t.target;
            for(var i in this._toolbars)this._toolbars[i] !== e && this._toolbars[i].disable();
        }
    }), L.Map.mergeOptions({
        drawControlTooltips: !0,
        drawControl: !1
    }), L.Map.addInitHook(function() {
        this.options.drawControl && (this.drawControl = new L.Control.Draw, this.addControl(this.drawControl));
    }), L.Toolbar = L.Class.extend({
        initialize: function(t) {
            L.setOptions(this, t), this._modes = {}, this._actionButtons = [], this._activeMode = null;
            var e = L.version.split(".");
            1 === parseInt(e[0], 10) && parseInt(e[1], 10) >= 2 ? L.Toolbar.include(L.Evented.prototype) : L.Toolbar.include(L.Mixin.Events);
        },
        enabled: function() {
            return null !== this._activeMode;
        },
        disable: function() {
            this.enabled() && this._activeMode.handler.disable();
        },
        addToolbar: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw-section"), o = 0, n = this._toolbarClass || "", a = this.getModeHandlers(t);
            for(this._toolbarContainer = L.DomUtil.create("div", "leaflet-draw-toolbar leaflet-bar"), this._map = t, e = 0; e < a.length; e++)a[e].enabled && this._initModeHandler(a[e].handler, this._toolbarContainer, o++, n, a[e].title);
            if (o) return this._lastButtonIndex = --o, this._actionsContainer = L.DomUtil.create("ul", "leaflet-draw-actions"), i.appendChild(this._toolbarContainer), i.appendChild(this._actionsContainer), i;
        },
        removeToolbar: function() {
            for(var t in this._modes)this._modes.hasOwnProperty(t) && (this._disposeButton(this._modes[t].button, this._modes[t].handler.enable, this._modes[t].handler), this._modes[t].handler.disable(), this._modes[t].handler.off("enabled", this._handlerActivated, this).off("disabled", this._handlerDeactivated, this));
            this._modes = {};
            for(var e = 0, i = this._actionButtons.length; e < i; e++)this._disposeButton(this._actionButtons[e].button, this._actionButtons[e].callback, this);
            this._actionButtons = [], this._actionsContainer = null;
        },
        _initModeHandler: function(t, e, i, o, n) {
            var a = t.type;
            this._modes[a] = {}, this._modes[a].handler = t, this._modes[a].button = this._createButton({
                type: a,
                title: n,
                className: o + "-" + a,
                container: e,
                callback: this._modes[a].handler.enable,
                context: this._modes[a].handler
            }), this._modes[a].buttonIndex = i, this._modes[a].handler.on("enabled", this._handlerActivated, this).on("disabled", this._handlerDeactivated, this);
        },
        _detectIOS: function() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream;
        },
        _createButton: function(t) {
            var e = L.DomUtil.create("a", t.className || "", t.container), i = L.DomUtil.create("span", "sr-only", t.container);
            e.href = "#", e.appendChild(i), t.title && (e.title = t.title, i.innerHTML = t.title), t.text && (e.innerHTML = t.text, i.innerHTML = t.text);
            var o = this._detectIOS() ? "touchstart" : "click";
            return L.DomEvent.on(e, "click", L.DomEvent.stopPropagation).on(e, "mousedown", L.DomEvent.stopPropagation).on(e, "dblclick", L.DomEvent.stopPropagation).on(e, "touchstart", L.DomEvent.stopPropagation).on(e, "click", L.DomEvent.preventDefault).on(e, o, t.callback, t.context), e;
        },
        _disposeButton: function(t, e) {
            var i = this._detectIOS() ? "touchstart" : "click";
            L.DomEvent.off(t, "click", L.DomEvent.stopPropagation).off(t, "mousedown", L.DomEvent.stopPropagation).off(t, "dblclick", L.DomEvent.stopPropagation).off(t, "touchstart", L.DomEvent.stopPropagation).off(t, "click", L.DomEvent.preventDefault).off(t, i, e);
        },
        _handlerActivated: function(t) {
            this.disable(), this._activeMode = this._modes[t.handler], L.DomUtil.addClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._showActionsToolbar(), this.fire("enable");
        },
        _handlerDeactivated: function() {
            this._hideActionsToolbar(), L.DomUtil.removeClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._activeMode = null, this.fire("disable");
        },
        _createActions: function(t) {
            var e, i, o, n, a = this._actionsContainer, s = this.getActions(t), r = s.length;
            for(i = 0, o = this._actionButtons.length; i < o; i++)this._disposeButton(this._actionButtons[i].button, this._actionButtons[i].callback);
            for(this._actionButtons = []; a.firstChild;)a.removeChild(a.firstChild);
            for(var l = 0; l < r; l++)"enabled" in s[l] && !s[l].enabled || (e = L.DomUtil.create("li", "", a), n = this._createButton({
                title: s[l].title,
                text: s[l].text,
                container: e,
                callback: s[l].callback,
                context: s[l].context
            }), this._actionButtons.push({
                button: n,
                callback: s[l].callback
            }));
        },
        _showActionsToolbar: function() {
            var t = this._activeMode.buttonIndex, e = this._lastButtonIndex, i = this._activeMode.button.offsetTop - 1;
            this._createActions(this._activeMode.handler), this._actionsContainer.style.top = i + "px", 0 === t && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-top")), t === e && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-bottom")), this._actionsContainer.style.display = "block", this._map.fire(L.Draw.Event.TOOLBAROPENED);
        },
        _hideActionsToolbar: function() {
            this._actionsContainer.style.display = "none", L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-top"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-bottom"), this._map.fire(L.Draw.Event.TOOLBARCLOSED);
        }
    }), L.Draw = L.Draw || {}, L.Draw.Tooltip = L.Class.extend({
        initialize: function(t) {
            this._map = t, this._popupPane = t._panes.popupPane, this._visible = !1, this._container = t.options.drawControlTooltips ? L.DomUtil.create("div", "leaflet-draw-tooltip", this._popupPane) : null, this._singleLineLabel = !1, this._map.on("mouseout", this._onMouseOut, this);
        },
        dispose: function() {
            this._map.off("mouseout", this._onMouseOut, this), this._container && (this._popupPane.removeChild(this._container), this._container = null);
        },
        updateContent: function(t) {
            return this._container ? (t.subtext = t.subtext || "", 0 !== t.subtext.length || this._singleLineLabel ? t.subtext.length > 0 && this._singleLineLabel && (L.DomUtil.removeClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !1) : (L.DomUtil.addClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !0), this._container.innerHTML = (t.subtext.length > 0 ? '<span class="leaflet-draw-tooltip-subtext">' + t.subtext + "</span><br />" : "") + "<span>" + t.text + "</span>", t.text || t.subtext ? (this._visible = !0, this._container.style.visibility = "inherit") : (this._visible = !1, this._container.style.visibility = "hidden"), this) : this;
        },
        updatePosition: function(t) {
            var e = this._map.latLngToLayerPoint(t), i = this._container;
            return this._container && (this._visible && (i.style.visibility = "inherit"), L.DomUtil.setPosition(i, e)), this;
        },
        showAsError: function() {
            return this._container && L.DomUtil.addClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        removeError: function() {
            return this._container && L.DomUtil.removeClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        _onMouseOut: function() {
            this._container && (this._container.style.visibility = "hidden");
        }
    }), L.DrawToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "draw"
        },
        options: {
            polyline: {},
            polygon: {},
            rectangle: {},
            circle: {},
            marker: {},
            circlemarker: {}
        },
        initialize: function(t) {
            for(var e in this.options)this.options.hasOwnProperty(e) && t[e] && (t[e] = L.extend({}, this.options[e], t[e]));
            this._toolbarClass = "leaflet-draw-draw", L.Toolbar.prototype.initialize.call(this, t);
        },
        getModeHandlers: function(t) {
            return [
                {
                    enabled: this.options.polyline,
                    handler: new L.Draw.Polyline(t, this.options.polyline),
                    title: L.drawLocal.draw.toolbar.buttons.polyline
                },
                {
                    enabled: this.options.polygon,
                    handler: new L.Draw.Polygon(t, this.options.polygon),
                    title: L.drawLocal.draw.toolbar.buttons.polygon
                },
                {
                    enabled: this.options.rectangle,
                    handler: new L.Draw.Rectangle(t, this.options.rectangle),
                    title: L.drawLocal.draw.toolbar.buttons.rectangle
                },
                {
                    enabled: this.options.circle,
                    handler: new L.Draw.Circle(t, this.options.circle),
                    title: L.drawLocal.draw.toolbar.buttons.circle
                },
                {
                    enabled: this.options.marker,
                    handler: new L.Draw.Marker(t, this.options.marker),
                    title: L.drawLocal.draw.toolbar.buttons.marker
                },
                {
                    enabled: this.options.circlemarker,
                    handler: new L.Draw.CircleMarker(t, this.options.circlemarker),
                    title: L.drawLocal.draw.toolbar.buttons.circlemarker
                }
            ];
        },
        getActions: function(t) {
            return [
                {
                    enabled: t.completeShape,
                    title: L.drawLocal.draw.toolbar.finish.title,
                    text: L.drawLocal.draw.toolbar.finish.text,
                    callback: t.completeShape,
                    context: t
                },
                {
                    enabled: t.deleteLastVertex,
                    title: L.drawLocal.draw.toolbar.undo.title,
                    text: L.drawLocal.draw.toolbar.undo.text,
                    callback: t.deleteLastVertex,
                    context: t
                },
                {
                    title: L.drawLocal.draw.toolbar.actions.title,
                    text: L.drawLocal.draw.toolbar.actions.text,
                    callback: this.disable,
                    context: this
                }
            ];
        },
        setOptions: function(t) {
            L.setOptions(this, t);
            for(var e in this._modes)this._modes.hasOwnProperty(e) && t.hasOwnProperty(e) && this._modes[e].handler.setOptions(t[e]);
        }
    }), L.EditToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "edit"
        },
        options: {
            edit: {
                selectedPathOptions: {
                    dashArray: "10, 10",
                    fill: !0,
                    fillColor: "#fe57a1",
                    fillOpacity: .1,
                    maintainColor: !1
                }
            },
            remove: {},
            poly: null,
            featureGroup: null
        },
        initialize: function(t) {
            t.edit && (void 0 === t.edit.selectedPathOptions && (t.edit.selectedPathOptions = this.options.edit.selectedPathOptions), t.edit.selectedPathOptions = L.extend({}, this.options.edit.selectedPathOptions, t.edit.selectedPathOptions)), t.remove && (t.remove = L.extend({}, this.options.remove, t.remove)), t.poly && (t.poly = L.extend({}, this.options.poly, t.poly)), this._toolbarClass = "leaflet-draw-edit", L.Toolbar.prototype.initialize.call(this, t), this._selectedFeatureCount = 0;
        },
        getModeHandlers: function(t) {
            var e = this.options.featureGroup;
            return [
                {
                    enabled: this.options.edit,
                    handler: new L.EditToolbar.Edit(t, {
                        featureGroup: e,
                        selectedPathOptions: this.options.edit.selectedPathOptions,
                        poly: this.options.poly
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.edit
                },
                {
                    enabled: this.options.remove,
                    handler: new L.EditToolbar.Delete(t, {
                        featureGroup: e
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.remove
                }
            ];
        },
        getActions: function(t) {
            var e = [
                {
                    title: L.drawLocal.edit.toolbar.actions.save.title,
                    text: L.drawLocal.edit.toolbar.actions.save.text,
                    callback: this._save,
                    context: this
                },
                {
                    title: L.drawLocal.edit.toolbar.actions.cancel.title,
                    text: L.drawLocal.edit.toolbar.actions.cancel.text,
                    callback: this.disable,
                    context: this
                }
            ];
            return t.removeAllLayers && e.push({
                title: L.drawLocal.edit.toolbar.actions.clearAll.title,
                text: L.drawLocal.edit.toolbar.actions.clearAll.text,
                callback: this._clearAllLayers,
                context: this
            }), e;
        },
        addToolbar: function(t) {
            var e = L.Toolbar.prototype.addToolbar.call(this, t);
            return this._checkDisabled(), this.options.featureGroup.on("layeradd layerremove", this._checkDisabled, this), e;
        },
        removeToolbar: function() {
            this.options.featureGroup.off("layeradd layerremove", this._checkDisabled, this), L.Toolbar.prototype.removeToolbar.call(this);
        },
        disable: function() {
            this.enabled() && (this._activeMode.handler.revertLayers(), L.Toolbar.prototype.disable.call(this));
        },
        _save: function() {
            this._activeMode.handler.save(), this._activeMode && this._activeMode.handler.disable();
        },
        _clearAllLayers: function() {
            this._activeMode.handler.removeAllLayers(), this._activeMode && this._activeMode.handler.disable();
        },
        _checkDisabled: function() {
            var t, e = this.options.featureGroup, i = 0 !== e.getLayers().length;
            this.options.edit && (t = this._modes[L.EditToolbar.Edit.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.edit : L.drawLocal.edit.toolbar.buttons.editDisabled)), this.options.remove && (t = this._modes[L.EditToolbar.Delete.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.remove : L.drawLocal.edit.toolbar.buttons.removeDisabled));
        }
    }), L.EditToolbar.Edit = L.Handler.extend({
        statics: {
            TYPE: "edit"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.setOptions(this, e), this._featureGroup = e.featureGroup, !(this._featureGroup instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this._uneditedLayerProps = {}, this.type = L.EditToolbar.Edit.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Edit.include(L.Evented.prototype) : L.EditToolbar.Edit.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.EDITSTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._featureGroup.on("layeradd", this._enableLayerEdit, this).on("layerremove", this._disableLayerEdit, this));
        },
        disable: function() {
            this._enabled && (this._featureGroup.off("layeradd", this._enableLayerEdit, this).off("layerremove", this._disableLayerEdit, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.EDITSTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._featureGroup.eachLayer(this._enableLayerEdit, this), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            }), t._editTooltip = this._tooltip, this._updateTooltip(), this._map.on("mousemove", this._onMouseMove, this).on("touchmove", this._onMouseMove, this).on("MSPointerMove", this._onMouseMove, this).on(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        removeHooks: function() {
            this._map && (this._featureGroup.eachLayer(this._disableLayerEdit, this), this._uneditedLayerProps = {}, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this).off("touchmove", this._onMouseMove, this).off("MSPointerMove", this._onMouseMove, this).off(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        revertLayers: function() {
            this._featureGroup.eachLayer(function(t) {
                this._revertLayer(t);
            }, this);
        },
        save: function() {
            var t = new L.LayerGroup;
            this._featureGroup.eachLayer(function(e) {
                e.edited && (t.addLayer(e), e.edited = !1);
            }), this._map.fire(L.Draw.Event.EDITED, {
                layers: t
            });
        },
        _backupLayer: function(t) {
            var e = L.Util.stamp(t);
            this._uneditedLayerProps[e] || (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? this._uneditedLayerProps[e] = {
                latlngs: L.LatLngUtil.cloneLatLngs(t.getLatLngs())
            } : t instanceof L.Circle ? this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng()),
                radius: t.getRadius()
            } : (t instanceof L.Marker || t instanceof L.CircleMarker) && (this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng())
            }));
        },
        _getTooltipText: function() {
            return {
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            };
        },
        _updateTooltip: function() {
            this._tooltip.updateContent(this._getTooltipText());
        },
        _revertLayer: function(t) {
            var e = L.Util.stamp(t);
            t.edited = !1, this._uneditedLayerProps.hasOwnProperty(e) && (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? t.setLatLngs(this._uneditedLayerProps[e].latlngs) : t instanceof L.Circle ? (t.setLatLng(this._uneditedLayerProps[e].latlng), t.setRadius(this._uneditedLayerProps[e].radius)) : (t instanceof L.Marker || t instanceof L.CircleMarker) && t.setLatLng(this._uneditedLayerProps[e].latlng), t.fire("revert-edited", {
                layer: t
            }));
        },
        _enableLayerEdit: function(t) {
            var e, i, o = t.layer || t.target || t;
            this._backupLayer(o), this.options.poly && (i = L.Util.extend({}, this.options.poly), o.options.poly = i), this.options.selectedPathOptions && (e = L.Util.extend({}, this.options.selectedPathOptions), e.maintainColor && (e.color = o.options.color, e.fillColor = o.options.fillColor), o.options.original = L.extend({}, o.options), o.options.editing = e), o instanceof L.Marker ? (o.editing && o.editing.enable(), o.dragging.enable(), o.on("dragend", this._onMarkerDragEnd).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onMarkerDragEnd, this).on("MSPointerUp", this._onMarkerDragEnd, this)) : o.editing.enable();
        },
        _disableLayerEdit: function(t) {
            var e = t.layer || t.target || t;
            e.edited = !1, e.editing && e.editing.disable(), delete e.options.editing, delete e.options.original, this._selectedPathOptions && (e instanceof L.Marker ? this._toggleMarkerHighlight(e) : (e.setStyle(e.options.previousOptions), delete e.options.previousOptions)), e instanceof L.Marker ? (e.dragging.disable(), e.off("dragend", this._onMarkerDragEnd, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onMarkerDragEnd, this).off("MSPointerUp", this._onMarkerDragEnd, this)) : e.editing.disable();
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _onMarkerDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _onTouchMove: function(t) {
            var e = t.originalEvent.changedTouches[0], i = this._map.mouseEventToLayerPoint(e), o = this._map.layerPointToLatLng(i);
            t.target.setLatLng(o);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._featureGroup.getLayers().length;
        }
    }), L.EditToolbar.Delete = L.Handler.extend({
        statics: {
            TYPE: "remove"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.Util.setOptions(this, e), this._deletableLayers = this.options.featureGroup, !(this._deletableLayers instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this.type = L.EditToolbar.Delete.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Delete.include(L.Evented.prototype) : L.EditToolbar.Delete.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DELETESTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._deletableLayers.on("layeradd", this._enableLayerDelete, this).on("layerremove", this._disableLayerDelete, this));
        },
        disable: function() {
            this._enabled && (this._deletableLayers.off("layeradd", this._enableLayerDelete, this).off("layerremove", this._disableLayerDelete, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DELETESTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._deletableLayers.eachLayer(this._enableLayerDelete, this), this._deletedLayers = new L.LayerGroup, this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.remove.tooltip.text
            }), this._map.on("mousemove", this._onMouseMove, this));
        },
        removeHooks: function() {
            this._map && (this._deletableLayers.eachLayer(this._disableLayerDelete, this), this._deletedLayers = null, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this));
        },
        revertLayers: function() {
            this._deletedLayers.eachLayer(function(t) {
                this._deletableLayers.addLayer(t), t.fire("revert-deleted", {
                    layer: t
                });
            }, this);
        },
        save: function() {
            this._map.fire(L.Draw.Event.DELETED, {
                layers: this._deletedLayers
            });
        },
        removeAllLayers: function() {
            this._deletableLayers.eachLayer(function(t) {
                this._removeLayer({
                    layer: t
                });
            }, this), this.save();
        },
        _enableLayerDelete: function(t) {
            (t.layer || t.target || t).on("click", this._removeLayer, this);
        },
        _disableLayerDelete: function(t) {
            var e = t.layer || t.target || t;
            e.off("click", this._removeLayer, this), this._deletedLayers.removeLayer(e);
        },
        _removeLayer: function(t) {
            var e = t.layer || t.target || t;
            this._deletableLayers.removeLayer(e), this._deletedLayers.addLayer(e), e.fire("deleted");
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._deletableLayers.getLayers().length;
        }
    });
}(window, document);

},{}],"bOUXL":[function(require,module,exports) {
/*
	Redactor v10.1.3
	Updated: June 4, 2015

	http://imperavi.com/redactor/

	Copyright (c) 2009-2015, Imperavi LLC.
	License: http://imperavi.com/redactor/license/

	Usage: $('#content').redactor();
*/ eval(function(p1, a1, c1, k1, e1, d1) {
    e1 = function(c1) {
        return (c1 < a1 ? "" : e1(parseInt(c1 / a1))) + ((c1 = c1 % a1) > 35 ? String.fromCharCode(c1 + 29) : c1.toString(36));
    };
    if (!"".replace(/^/, String)) {
        while(c1--)d1[e1(c1)] = k1[c1] || e1(c1);
        k1 = [
            function(e1) {
                return d1[e1];
            }
        ];
        e1 = function() {
            return "\\w+";
        };
        c1 = 1;
    }
    while(c1--)if (k1[c1]) p1 = p1.replace(new RegExp("\\b" + e1(c1) + "\\b", "g"), k1[c1]);
    return p1;
}('(C(c){if(!cY.4M.8U){cY.4M.8U=C(e){E d=B;F C(){F d.6S(e)}}}E a=0;c.fn.I=C(e){E f=[];E d=7K.4M.aU.5k(fr,1);if(1l e==="5z"){B.1m(C(){E h=c.1g(B,"I");E i;if(e.2Z(/\\./)!="-1"){i=e.3J(".");if(1l h[i[0]]!="1s"){i=h[i[0]][i[1]]}}L{i=h[e]}if(1l h!=="1s"&&c.4I(i)){E g=i.6S(h,d);if(g!==1s&&g!==h){f.2q(g)}}L{c.56(\'hS i0 m4 "\'+e+\'" 29 4g\')}})}L{B.1m(C(){c.1g(B,"I",{});c.1g(B,"I",b(B,e))})}if(f.R===0){F B}L{if(f.R===1){F f[0]}L{F f}}};C b(e,d){F 1P b.4M.3b(e,d)}c.4g=b;c.4g.ml="10.1.3";c.4g.9w=["2s","2E","U","1M","1W","1D","1I","1p","1h","1O","1E","2x","2c","Q","2T","1N","1H","1i","1Z","1z","3i","1d","3q","T","2k","2v","4E","2y","4B","K","4X","2d","1u","1n","1f","N","2F"];c.4g.G={1z:"en",aI:"lK",7e:M,2c:M,cE:M,2y:M,5e:1j,7L:M,9b:M,95:M,1A:M,64:1j,2v:1j,bO:M,8D:1j,gz:1j,cz:1j,cu:M,2E:M,9I:M,7b:60,9T:M,8I:M,eQ:1j,5L:"7v",ct:M,ay:50,8E:1j,dF:1j,dE:1j,77:"lP",bq:1j,6H:3x,g6:"2x",lX:M,c9:1j,6K:3x,g7:"2x",ca:1j,6u:M,8i:1j,9Y:1j,a0:1j,7w:1j,5o:4,9t:M,c3:1j,7l:M,1n:1j,fh:1j,5w:14,6t:0,9j:M,fc:M,3U:1j,3Y:["1b","2p","3G","3z","58","4Y","4D","6o","2T","Q","2x","1d","2s","9o"],as:[],ai:[],2p:["p","1L","2n","h1","h2","h3","h4","h5","h6"],bd:M,2d:1j,3w:["3l","1e"],3N:M,bb:["4t","1q","2n","5h","2L","2O","h1","h2","h3","h4","h5","h6","dl","1L","5W","a2","3o","9n","ar","dV","dU","4G","1e","3l","43","6f","31","1Y","1D","3j","fE","fx","lT","hr","fy","mR","kU","kW","dz","l0","kZ","kY","p"],5T:M,4w:[["5X","3D"],["b","4l"]],4A:[["3d-69:\\\\s?3G","4l"],["3d-1e:\\\\s?3z","em"],["1C-5Z:\\\\s?4P","u"],["1C-5Z:\\\\s?3i-dX","3D"]],4z:M,1w:M,4c:M,5K:["1c"],3t:["p"],9u:["58","3z","3G","4P","4Y","4D","le","lx","lv","7c"],aB:{b:"3G",4l:"3G",i:"3z",em:"3z",3D:"58",5X:"58",2L:"4Y",2O:"4D",u:"4P"},4X:{"3n+5Q+m, 4u+5Q+m":{1K:"1N.ah"},"3n+b, 4u+b":{1K:"1N.2o",53:["3G"]},"3n+i, 4u+i":{1K:"1N.2o",53:["3z"]},"3n+h, 4u+h":{1K:"1N.2o",53:["e1"]},"3n+l, 4u+l":{1K:"1N.2o",53:["e2"]},"3n+k, 4u+k":{1K:"1d.2i"},"3n+5Q+7":{1K:"3q.2A",53:["4D"]},"3n+5Q+8":{1K:"3q.2A",53:["4Y"]}},d4:M,1M:[],6R:[],5s:"<p>&#ac;</p>",5l:"&#ac;",ge:["Q/cS","Q/ly","Q/cR"],8L:20,b6:["a","1J","b","4l","5U","5V","i","em","u","7P","5X","3D","7E","2L","2O","li"],5c:["4l","b","u","em","i","1h","3D","lC","9i","8Q","5V","5U","93","E","7E","7P"],7r:["P","ba","bs","aL","9H","9R","9S","lA","ls","lr","6v","4x","9r","lj","cv","lh","ll","lm","lp","lo","kR"],70:["7O","7H","6U","4j"],bx:{en:{1b:"kQ",5t:"5v d1",Q:"5v d2",4t:"9Q",1d:"b7",bj:"5v 1d",kl:"cL 1d",5G:"kk",2p:"kj",gp:"k7 1C",aC:"ka",1h:"cV",eX:"6X 1",eY:"6X 2",eZ:"6X 3",eW:"6X 4",eV:"6X 5",3G:"kf",3z:"ke",kc:"kH cX",kK:"kO cX",4Y:"kF cW",4D:"ms cW",6o:"mP",2T:"mT",gY:"mU",1H:"5v",2C:"mW",e7:"7m",my:"5v 9Q",mq:"6O bt lY",lQ:"6O bt lG",lF:"6O bn d0",lJ:"6O bn d3",lO:"7m bn",lM:"7m bt",m2:"7m 9Q",mm:"me",k5:"hW",i5:"6O cZ",iv:"7m cZ",1Q:"jW",gE:"jV",4S:"jU",2a:"d0",3I:"d3",4K:"cO",k2:"d2 jM b7",1C:"jN",al:"jO",iL:"gv",iQ:"d1 iz cV cT iC/iF b7",2x:"5v iU",1f:"j9",j8:"jc",cU:"iZ",j3:"j2 cU",j1:"cP 2x cQ",eR:"cN 1C cM 8X 2a",eS:"cO 1C",eT:"cN 1C cM 8X 3I",eU:"j0 1C",9o:"5v iV iW",58:"iX",eI:"iY",aS:"j5 1d in 1P 6W",4P:"j6",2s:"jd",5P:"je (jf)",78:"cL",g8:"cP 2x cQ cT "}},2F:{3L:{5E:/4Q?:\\/\\/(?:[0-9A-Z-]+\\.)?(?:ja\\.be\\/|5E\\.8k\\S*[^\\w\\-\\s])([\\w\\-]{11})(?=[^\\w\\-]|$)(?![?=&+%\\w.\\-]*(?:[\'"][^<>]*>|<\\/a>))[?=&+%\\w.-]*/ig,5q:/4Q?:\\/\\/(6E\\.)?5q.8k\\/(\\d+)($|\\/)/,Q:/((4Q?|6E)[^\\s]+\\.)(iT?g|cS|cR)(\\?[^\\s-]+)?/ig,2b:/(4Q?:\\/\\/(?:6E\\.|(?!6E))[^\\s\\.]+\\.[^\\s]{2,}|6E\\.[^\\s]+\\.[^\\s]{2,})/ig,}},7p:M};b.fn=c.4g.4M={2G:{6D:8,7A:46,9J:40,5R:13,8c:32,at:27,bg:9,bT:17,bM:91,bP:16,bR:18,bF:39,iG:37,c0:91},3b:C(g,e){B.$3a=c(g);B.2h=a++;B.6c=M;B.$4y=M;B.d5(e);B.dj();B.2p={};c.iB(B.G.70,B.G.7r);B.fT=1P 1U("^("+B.G.70.2t("|")+")$","i");B.1u.fD();if(B.G.3w!==M){E d=["1b","au","1d","2D","4u","ix"];29(E f=0;f<d.R;f++){B.G.3w.2q(d[f])}}B.1z.2r();c.6n(B.G.4X,B.G.d4);B.1O.28("7F");B.7F=1j;B.1W.cj()},d5:C(d){B.G=c.6n({},c.6n(1j,{},c.4g.G),B.$3a.1g(),d)},9K:C(d){F fJ.iy(d).ao(C(e){F 1l d[e]=="C"})},dj:C(){E d=c.4g.9w.R;29(E e=0;e<d;e++){B.di(c.4g.9w[e])}},di:C(f){if(1l B[f]=="1s"){F}B[f]=B[f]();E e=B.9K(B[f]);E d=e.R;29(E g=0;g<d;g++){B[f][e[g]]=B[f][e[g]].8U(B)}},2s:C(){F{2a:C(){B.2s.1G("")},3I:C(){B.2s.1G("3I")},4K:C(){B.2s.1G("4K")},7c:C(){B.2s.1G("7c")},1G:C(d){if(!B.N.1R("2e")){B.$O.2c()}B.1M.1G();B.K.2C();B.2s.3V=B.K.3E();B.2s.1F=d;if(B.2s.dm()){B.2s.dh()}L{B.2s.dk()}B.K.2w();B.1h.1B()},dh:C(){E d=B.K.4W("1q");c(d).1a("1g-7k","I").1y("1C-5a",B.2s.1F)},dk:C(){c.1m(B.2s.3V,c.V(C(e,f){E d=B.N.7W(f);if(!d){F}if(B.2s.dp(d)){B.2s.do(d)}L{B.2s.dn(d)}},B))},dm:C(){F(B.G.1A&&B.2s.3V[0]===M)},dp:C(d){F(B.2s.1F===""&&1l(d.1g("7k"))!=="1s")},do:C(d){d.22(d.1b())},dn:C(d){d.1y("1C-5a",B.2s.1F);B.N.4J(d,"1e")}}},2E:C(){F{1b:M,8t:C(){if(!B.G.2E){F}B.2E.2l=(B.G.9I)?B.G.9I:B.$1Y.1a("2l");if(B.G.9T){F}B.7b=iR(B.2E.2r,B.G.7b*iS)},ef:C(){if(!B.G.9T){F}B.2E.2r()},2r:C(){B.2E.3U=B.1h.Y();if(B.2E.1b===B.2E.3U){F}E e={};e.2l=B.2E.2l;e[B.2E.2l]=B.2E.3U;e=B.2E.5p(e);E d=c.iN({2b:B.G.2E,1F:"iJ",1g:e});d.iK(B.2E.dg)},5p:C(d){if(B.G.8I===M||1l B.G.8I!=="4G"){F d}c.1m(B.G.8I,c.V(C(f,e){if(e!==3x&&e.3O().3X("#")===0){e=c(e).2H()}d[f]=e},B));F d},dg:C(f){E d;49{d=c.gm(f)}42(h){d=f}E g=(1l d.56=="1s")?"2E":"iM";B.1O.28(g,B.2E.2l,d);B.2E.1b=B.2E.3U},jh:C(){ey(B.7b)}}},U:C(){F{2p:C(d){B.U.8A=M;E e,f;if(1l B.2p[d].1g!="1s"){e="1g"}L{if(1l B.2p[d].1a!="1s"){e="1a"}L{if(1l B.2p[d]["1v"]!="1s"){e="1v"}}}if(1l B.2p[d].7g!="1s"){B.U.8A=1j}if(e){f=B.2p[d][e]}B.U.2o(B.2p[d].3f,e,f)},2o:C(d,f,g){if(d=="aC"){d="1L"}E e=["p","2n","1L","h1","h2","h3","h4","h5","h6"];if(c.2K(d,e)==-1){F}B.U.7Q=(d=="2n"||d.2Z(/h[1-6]/i)!=-1);if(!B.N.1R("2e")){B.$O.2c()}B.U.3V=B.K.3E();B.U.6A=B.U.3V.R;B.U.1F=f;B.U.23=g;B.1M.1G();B.K.2C();B.U.1G(d);B.K.2w();B.1h.1B()},1G:C(d){B.K.Y();B.U.5n=B.1t.d7.1k;if(B.1t.4s){B.U.df(d)}L{B.U.d8(d)}},df:C(d){E h=B.U.3V[0];if(h===M){F}if(h.1k=="4j"){if(d!="1L"){F}B.U.7Y();F}E g=(B.U.5n=="4x"||B.U.5n=="8s");if(g&&!B.G.1A){14.3m("8C",M,"<"+d+">");h=B.K.3B();B.U.2A(c(h))}L{if(h.1k.2u()!=d){if(B.G.1A&&d=="p"){c(h).4b("<br>").1r("<br>");B.N.5m(h)}L{E f=B.N.4a(h,d);B.U.2A(f);if(d!="p"&&d!="1L"){f.12("1J").1o()}if(B.U.7Q){B.N.5B(f)}if(d=="p"||B.U.bi){f.12("p").1S().3p()}B.U.aX(f)}}L{if(d=="1L"&&h.1k.2u()==d){if(B.G.1A){c(h).4b("<br>").1r("<br>");B.N.5m(h)}L{E e=B.N.4a(h,"p");B.U.2A(e)}}L{if(h.1k.2u()==d){B.U.2A(c(h))}}}}if(1l B.U.1F=="1s"&&1l B.U.23=="1s"){c(h).1w("1v").1w("1e")}},d8:C(n){E f=B.U.3V[0];E l=(B.U.5n=="4x"||B.U.5n=="8s");if(f!==M&&B.U.6A===1){if(f.1k.2u()==n&&n=="1L"){if(B.G.1A){c(f).4b("<br>").1r("<br>");B.N.5m(f)}L{E m=B.N.4a(f,"p");B.U.2A(m)}}L{if(f.1k=="4j"){if(n!="1L"){F}B.U.7Y()}L{if(B.U.5n=="9r"){B.U.d9(n)}L{if(B.G.1A&&((l)||(B.1t.d7!=f))){B.U.84(n)}L{if(B.G.1A&&n=="p"){c(f).4b("<br>").1r("<br>");B.N.5m(f)}L{if(f.1k==="4x"){B.U.84(n)}L{E e=B.N.4a(f,n);B.U.2A(e);if(B.U.7Q){B.N.5B(e)}if(n=="p"||B.U.bi){e.12("p").1S().3p()}}}}}}}}L{if(B.G.1A||n!="p"){if(n=="1L"){E j=0;29(E h=0;h<B.U.6A;h++){if(B.U.3V[h].1k=="9r"){j++}}if(j==B.U.6A){c.1m(B.U.3V,c.V(C(p,q){E o=M;if(B.G.1A){c(q).4b("<br>").1r("<br>");o=B.N.5m(q)}L{o=B.N.4a(q,"p")}if(o&&1l B.U.1F=="1s"&&1l B.U.23=="1s"){o.1w("1v").1w("1e")}},B));F}}B.U.84(n)}L{E k=0;E g=M;if(B.U.1F=="1v"){g="2A";k=c(B.U.3V).ao("."+B.U.23).R;if(B.U.6A==k){g="2A"}L{if(B.U.6A>k){g="1G"}L{if(k===0){g="1G"}}}}E d=["2L","2O","li","3r","5g","dl","dt","dd"];c.1m(B.U.3V,c.V(C(p,q){if(c.2K(q.1k.2u(),d)!=-1){F}E o=B.N.4a(q,n);if(g){if(g=="2A"){B.U.2A(o)}L{if(g=="1o"){B.U.1o(o)}L{if(g=="1G"){B.U.d6(o)}}}}L{B.U.2A(o)}if(n!="p"&&n!="1L"){o.12("1J").1o()}if(B.U.7Q){B.N.5B(o)}if(n=="p"||B.U.bi){o.12("p").1S().3p()}if(1l B.U.1F=="1s"&&1l B.U.23=="1s"){o.1w("1v").1w("1e")}},B))}}},d6:C(d){if(B.U.8A){d.1w("1v").1w("1e")}if(B.U.1F=="1v"){d.1X(B.U.23);F}L{if(B.U.1F=="1a"||B.U.1F=="1g"){d.1a(B.U.23.2l,B.U.23.23);F}}},2A:C(d){if(B.U.8A){d.1w("1v").1w("1e")}if(B.U.1F=="1v"){d.6B(B.U.23);F}L{if(B.U.1F=="1a"||B.U.1F=="1g"){if(d.1a(B.U.23.2l)==B.U.23.23){d.1w(B.U.23.2l)}L{d.1a(B.U.23.2l,B.U.23.23)}F}L{d.1w("1e 1v");F}}},1o:C(d){d.2j(B.U.23)},7Y:C(){E e=c(B.U.3V[0]).25("2L, 2O",B.$O[0]);c(e).12("2L, 2O").1S().3p();c(e).12("li").1r(c("<br>")).1S().3p();E d=B.N.4a(e,"1L");B.U.2A(d)},d9:C(d){14.3m("6o");14.3m("8C",M,d);B.1p.3M();B.$O.12("p:da").1o();E e=B.K.3B();if(d!="p"){c(e).12("1J").1o()}if(!B.G.1A){B.U.2A(c(e))}B.$O.12("2L, 2O, 5x, 1L, p").1m(c.V(B.N.3t,B));if(B.G.1A&&d=="p"){B.N.5m(e)}},84:C(d){if(B.U.5n=="7H"||B.U.5n=="6U"){if(d=="1L"){B.U.7Y()}L{F}}E g=B.K.4W(d);if(g===M){F}E e=c(g);B.U.aX(e);E f=e.12(B.G.70.2t(",")+", 3r, 4t, aM, az, aN, 5g, 5x");if((B.G.1A&&d=="p")||d=="2n"||d=="1L"){f.1r("<br />")}f.1S().3p();if(d!="p"&&d!="1L"){e.12("1J").1o()}c.1m(B.U.3V,c.V(B.N.3t,B));e.1r(B.K.5u(2));if(!B.G.1A){B.U.2A(e)}B.$O.12("2L, 2O, 5x, 1L, p").1m(c.V(B.N.3t,B));e.12("1L:da").1o();if(B.U.7Q){B.N.5B(e)}if(B.G.1A&&d=="p"){B.N.5m(e)}},aX:C(d){if(d.25("4t",B.$O[0]).R===0){F}if(d.25("5x",B.$O[0]).R===0){d.4W("<5x>")}if(d.25("3r",B.$O[0]).R===0&&d.25("5g").R===0){d.4W("<3r>")}},ez:C(d,e){E f=B.K.3E();c(f).1w("1g-"+d);B.1h.1B()},jL:C(d,e){E f=B.K.3E();c(f).1a("1g-"+d,e);B.1h.1B()},jS:C(d,e){E f=B.K.3E();c.1m(f,C(){if(c(B).1a("1g-"+d)){c(B).1w("1g-"+d)}L{c(B).1a("1g-"+d,e)}})},1w:C(d,e){E f=B.K.3E();c(f).1w(d);B.1h.1B()},jT:C(d,e){E f=B.K.3E();c(f).1a(d,e);B.1h.1B()},k0:C(d,e){E f=B.K.3E();c.1m(f,C(){if(c(B).1a(2l)){c(B).1w(2l)}L{c(B).1a(2l,e)}})},2j:C(d){E e=B.K.3E();c(e).2j(d);B.N.4J(e,"1v");B.1h.1B()},7S:C(d){E e=B.K.3E();c(e).1X(d);B.1h.1B()},6B:C(d){E e=B.K.3E();c(e).6B(d);B.1h.1B()}}},1M:C(){F{1G:C(d){if(1l d=="1s"||d=="7B"){B.1M.de()}L{B.1M.dc()}},de:C(){B.K.2C();B.G.1M.2q(B.$O.1b());B.K.2w()},dc:C(){B.K.2C();B.G.6R.2q(B.$O.1b());B.K.2w()},cK:C(){B.$O.1b(B.G.1M.db())},cJ:C(){B.$O.1b(B.G.6R.db())},aD:C(){B.G.1M.2q(B.$O.1b())},7B:C(){if(B.G.1M.R===0){F}B.1M.1G("8S");B.1M.cK();B.K.2w();2Q(c.V(B.2k.2r,B),50)},8S:C(){if(B.G.6R.R===0){F}B.1M.1G("7B");B.1M.cJ();B.K.2w();2Q(c.V(B.2k.2r,B),50)}}},1W:C(){F{cj:C(){B.1W.ci();B.1W.ck();B.1W.co();B.1W.cl();B.1W.c8()},82:C(){F(B.$3a[0].1k==="jY")},ci:C(){B.$2g=c(\'<1q 1v="I-2g"/>\')},cf:C(){B.$1Y=c("<1Y />").1a("2l",B.1W.cg())},cg:C(){F((1l(2l)=="1s"))?"aA-"+B.2h:B.$3a.1a("id")},ck:C(){E d=(B.1W.82())?"2H":"1b";B.aA=c.2J(B.$3a[d]())},cl:C(){B.$O.1a({6r:1j,c5:B.G.aI})},co:C(){E d=(B.1W.82())?"cn":"cm";B.1W[d]()},cn:C(){B.$O=c("<1q/>");B.$1Y=B.$3a;B.$2g.ce(B.$3a).1r(B.$O).1r(B.$3a);B.$O.1X("I-O");B.$3a.2z()},cm:C(){B.$O=B.$3a;B.1W.cf();B.$2g.ce(B.$O).1r(B.$O).1r(B.$1Y);B.$O.1X("I-O");B.$1Y.2z()},c8:C(){B.1h.1G(B.aA);B.1W.c6();B.1W.c7();if(B.G.5e){F}2Q(c.V(B.1h.b5,B),8P)},c7:C(){B.1W.cF();B.1W.cI();B.1W.cd();B.1W.cB();if(B.G.1n){B.G.1n=B.1n.3b();B.1n.1W()}B.T.gN();B.1W.7e();2Q(c.V(B.2k.2r,B),4);B.1O.28("3b")},c6:C(){c(B.$1Y).1a("c5",B.G.aI);if(B.G.1A){B.$O.1X("I-1A")}if(B.G.7L){B.$O.1a("7L",B.G.7L)}if(B.G.9b){B.$O.1y("9b",B.G.9b)}if(B.G.95){B.$O.1y("95",B.G.95)}},cb:C(f){f.21();if(!B.G.c9||!B.G.ca){F}E d=f.9p.9z;B.1f.g5(d[0],f)},cc:C(d){B.1h.1B();2Q(B.1p.3M,1);B.1O.28("4e",d)},cd:C(){B.$O.1x("4e.I",c.V(C(f){f=f.62||f;if(3e.9D===1s||!f.9p){F 1j}if(f.9p.9z.R===0){F B.1W.cc(f)}L{B.1W.cb(f)}2Q(B.1p.3M,1);B.1O.28("4e",f)},B));B.$O.1x("1V.I",c.V(C(h){E g=B.1O.6b();E f=(g=="1V"||g=="85")?M:"1V";B.1O.7n(f);B.N.76();B.1O.28("1V",h)},B));B.$O.1x("4E.I",c.V(B.4E.3b,B));B.$O.1x("jn.I",c.V(B.1h.1B,B));B.$O.1x("1i.I",c.V(B.1i.3b,B));B.$O.1x("1Z.I",c.V(B.1Z.3b,B));if(c.4I(B.G.cp)){B.$1Y.1x("1i.I-1Y",c.V(B.G.cp,B))}if(c.4I(B.G.cq)){B.$1Y.1x("1Z.I-1Y",c.V(B.G.cq,B))}if(c.4I(B.G.cD)){B.$O.1x("2c.I",c.V(B.G.cD,B))}E d;c(14).1x("bf",C(f){d=f.2m});B.$O.1x("9k.I",c.V(C(f){if(B.6c){F}if(!B.1W.cC(d)){F}B.N.76();if(c.4I(B.G.jC)){B.1O.28("9k",f)}},B))},cC:C(e){E d=c(e);F(!d.2U("I-1n, I-1E")&&!d.is("#I-T")&&d.g0(".I-1n, .I-1E, #I-T").R===0)},cB:C(){if(B.2F.88()){B.2F.2o()}B.2y.8t();if(B.G.2c){2Q(B.2c.2I,7i)}if(B.G.cE){2Q(B.2c.3k,7i)}},7e:C(){if(!B.G.7e){F}if(!8W){F}c.1m(B.G.7e,c.V(C(f,g){if(1l 8W[g]==="1s"){F}if(c.2K(g,c.4g.9w)!==-1){c.56(\'jA 2l"\'+g+"\\"jw 8X 2l jx 8X 4g\'s k4.");F}if(!c.4I(8W[g])){F}B[g]=8W[g]();E e=B.9K(B[g]);E d=e.R;29(E h=0;h<d;h++){B[g][e[h]]=B[g][e[h]].8U(B)}if(c.4I(B[g].3b)){B[g].3b()}},B))},cF:C(){if(!B.N.1R("4r")){F}49{14.3m("hD",M,M);14.3m("hF",M,M)}42(d){}},cI:C(){if(!B.N.1R("ie")){F}14.3m("hI",M,M)}}},1D:C(){F{1W:C(g,d){E e=c(\'<a 2B="#"1v="48-7C 48-\'+g+\'"3g="\'+g+\'"/>\').1a("7L","-1");if(d.1K||d.5b||d.1E){B.1D.cH(e,g,d)}if(d.1E){E f=c(\'<1q 1v="I-1E I-1E-\'+B.2h+" I-1E-2g-"+g+\'" 1e="5I: 4S;">\');e.1g("1E",f);B.1E.1W(g,f,d.1E)}if(B.N.6F()){B.1D.cG(e,g,d.1Q)}F e},cH:C(e,f,d){e.1x("5f 1V",c.V(C(h){if(e.2U("I-1D-7q")){F M}E g="1K";E i=d.1K;if(d.5b){g="5b";i=d.5b}L{if(d.1E){g="1E";i=M}}B.1D.83(h,f,g,i)},B))},cG:C(f,d,g){E e=c("<1c>").1X("I-1n-3S I-1n-3S-"+B.2h+" I-1n-3S-"+d).2z().1b(g);e.9e("2D");f.1x("eB",C(){if(c(B).2U("I-1D-7q")){F}E h=f.4p();e.2i();e.1y({3s:(h.3s+f.4U())+"2W",2a:(h.2a+f.7D()/2-e.7D()/2)+"2W"})});f.1x("eE",C(){e.2z()})},83:C(f,h,d,g){B.1D.hj=B.1I.9C();f.21();if(B.N.1R("2e")){f.hB=M}if(d=="5b"){B.1N.2o(g)}L{if(d=="1E"){B.1E.2i(f,h)}L{B.1D.cA(f,g,h)}}},cA:C(f,h,g){E d;if(c.4I(h)){h.5k(B,g)}L{if(h.2Z(/\\./)!="-1"){d=h.3J(".");if(1l B[d[0]]=="1s"){F}B[d[0]][d[1]](g)}L{B[h](g)}}B.2k.3Y(f,g)},Y:C(d){F B.$1n.12("a.48-"+d)},7M:C(d){B.1D.Y(d).1X("I-72")},eN:C(d){B.1D.Y(d).2j("I-72")},aP:C(d){if(1l d==="1s"){B.$1n.12("a.48-7C").2j("I-72")}L{B.$1n.12("a.48-7C").57(".48-"+d).2j("I-72")}},eO:C(){B.$1n.12("a.48-7C").57("a.48-1b").2j("I-1D-7q")},ew:C(){B.$1n.12("a.48-7C").57("a.48-1b").1X("I-1D-7q")},hd:C(d,e){B.1D.Y(d).1X("48-"+e)},hh:C(d,e){B.1D.Y(d).2j("48-"+e)},hy:C(e,d){E f=B.1D.Y(e);f.2j("I-44-Q").1X("fa-I-44");f.1b(\'<i 1v="fa \'+d+\'"></i>\')},aQ:C(f,g){if(f=="1M"){F}E e=(g=="1E")?"1E":"1K";E d=f.1a("3g");f.1x("5f 1V",c.V(C(h){if(f.2U("I-1D-7q")){F M}B.1D.83(h,d,e,g)},B))},hx:C(e,g){E d=e.1a("3g");B.1D.aQ(e,"1E");E f=c(\'<1q 1v="I-1E I-1E-\'+B.2h+" I-1E-2g-"+d+\'" 1e="5I: 4S;">\');e.1g("1E",f);if(g){B.1E.1W(d,f,g)}F f},aD:C(e,f){if(!B.G.1n){F}if(B.1D.7o(e)){F"1M"}E d=B.1D.1W(e,{1Q:f});d.1X("I-44-Q");B.$1n.1r(c("<li>").1r(d));F d},hu:C(e,f){if(!B.G.1n){F}if(B.1D.7o(e)){F"1M"}E d=B.1D.1W(e,{1Q:f});d.1X("I-44-Q");B.$1n.4b(c("<li>").1r(d));F d},hA:C(h,e,g){if(!B.G.1n){F}if(B.1D.7o(e)){F"1M"}E d=B.1D.1W(e,{1Q:g});d.1X("I-44-Q");E f=B.1D.Y(h);if(f.R!==0){f.2P().2N(c("<li>").1r(d))}L{B.$1n.1r(c("<li>").1r(d))}F d},hE:C(h,e,g){if(!B.G.1n){F}if(B.1D.7o(e)){F"1M"}E d=B.1D.1W(e,{1Q:g});d.1X("I-44-Q");E f=B.1D.Y(h);if(f.R!==0){f.2P().8p(c("<li>").1r(d))}L{B.$1n.1r(c("<li>").1r(d))}F d},1o:C(d){B.1D.Y(d).1o()},7o:C(d){F(d=="7B"||d=="8S")&&!B.N.6F()}}},1I:C(){F{2I:C(d){if(!B.N.5D(d)){E e=B.N.6Z();c(d).4b(e);B.1I.3k(e)}L{B.1I.1G(d,0,d,0)}},3k:C(d){B.1I.1G(d,1,d,1)},1G:C(j,i,h,f){j=j[0]||j;h=h[0]||h;if(B.N.6y(j.1k)&&j.2X===""){j.2X=B.G.5l}if(j.1k=="4N"&&B.G.1A===M){E d=c(B.G.5s)[0];c(j).22(d);j=d;h=j}B.K.Y();49{B.1t.2I(j,i);B.1t.3k(h,f)}42(g){}B.K.4i()},4o:C(f){49{E d=c(f)[0].1k;if(d!="4N"&&!B.N.5D(f)){E g=B.N.6Z();c(f).2N(g);B.1I.3k(g)}L{if(d!="4N"&&B.N.1R("2e")){B.1I.2I(c(f).3R())}L{B.1I.am(f,"2N")}}}42(h){E g=B.N.6Z();c(f).2N(g);B.1I.3k(g)}},9G:C(d){if(B.N.5D(d)){B.1I.3k(c(d).86())}L{B.1I.am(d,"8p")}},am:C(f,d){if(!B.N.1R("2e")){B.$O.2c()}f=f[0]||f;B.K.Y();if(d=="2N"){49{B.1t.dO(f);B.1t.hs(f)}42(g){}}L{49{B.1t.hk(f);B.1t.hp(f)}42(g){}}B.1t.3Z(M);B.K.4i()},7X:C(e){e=e[0]||e;B.K.Y();E d=B.1t.7x();d.8r(e);d.3k(B.1t.b3,B.1t.aV);F c.2J(d.3O()).R},9C:C(){E g=0;E e=3e.51();if(e.7u>0){E d=3e.51().5N(0);E f=d.7x();f.8r(B.$O[0]);f.3k(d.b3,d.aV);g=f.3O().R}F g},a3:C(i,d){if(1l d=="1s"){d=i}if(!B.2c.eD()){B.2c.2I()}E f=B.K.Y();E e,h=0;E g=14.hq(B.$O[0],hn.hH,3x,3x);4h(e=g.iu()){h+=e.4V.R;if(h>i){B.1t.2I(e,e.4V.R+i-h);i=ib}if(h>=d){B.1t.3k(e,e.4V.R+d-h);54}}B.1t.3Z(M);B.K.4i()},ic:C(e,d){B.1I.a3(e,d)},ih:C(){F B.1I.9C()}}},1p:C(){F{ed:C(e){e=B.1p.eu(e);e=e.J(/<3l(.*?[^>]?)>([\\w\\W]*?)<\\/3l>/gi,\'<2n 1v="I-3l-3f" 1e="5I: 4S;" $1>$2</2n>\');e=e.J(/\\$/g,"&#36;");e=e.J(/<a 2B="(.*?[^>]?)\xae(.*?[^>]?)">/gi,\'<a 2B="$1&ia$2">\');if(B.G.64){e=B.1p.64(e)}if(B.G.1A){e=B.1p.9h(e)}e=B.1p.aK(e);E d=c("<1q>");d.1b(e);E f=d.12("3d[1e]");if(f.R!==0){f.22(C(){E h=c(B);E g=c("<1c>").1a("1e",h.1a("1e"));F g.1r(h.1S())});e=d.1b()}d.1o();e=e.J(/<3d(.*?[^<])>/gi,"");e=e.J(/<\\/3d>/gi,"");e=B.1u.2r(e);if(B.G.2v){e=B.2v.2r(e)}e=B.1p.67(e);e=B.1p.aH(e);F e},8b:C(e){e=e.J(/[\\5S-\\6w\\6x]/g,"");e=e.J(/&#ac;/gi,"");if(B.G.cz){e=e.J(/&4v;/gi," ")}if(e.2Z(/^<p>(||\\s||<br\\s?\\/?>||&4v;)<\\/p>$/i)!=-1){F""}e=e.J(/<2n 1v="I-3l-3f" 1e="5I: 4S;"(.*?[^>]?)>([\\w\\W]*?)<\\/2n>/gi,"<3l$1>$2<\\/3l>");e=B.1p.ec(e);E f={"\\i6":"&i7;","\\hJ":"&ii;","\\ij":"&iq;","\\ir":"&it;","\\ip":"&io;"};c.1m(f,C(g,h){e=e.J(1P 1U(g,"g"),h)});e=e.J(1P 1U("<br\\\\s?/?></li>","gi"),"</li>");e=e.J(1P 1U("</li><br\\\\s?/?>","gi"),"</li>");e=e.J(/(1e|3g)="\\s*?"/,"");e=e.J(/<1q(.*?[^>]) 1g-7k="I"(.*?[^>])>/gi,"<1q$1$2>");e=e.J(/<(.*?) 1g-2Y="I"(.*?[^>])>/gi,"<$1$2>");E d=c("<1q/>").1b(c.aW(e,14,1j));d.12("1c").1w("3g");e=d.1b();e=e.J(/<1J(.*?[^>])3g="(.*?[^>])"(.*?[^>])>/gi,"<1J$1$3>");e=e.J(/<1c 1v="I-6N-5A">(.*?)<\\/1c>/gi,"$1");e=e.J(/ 1g-2C-2b="(.*?[^>])"/gi,"");e=e.J(/<1c(.*?)id="I-Q-2g"(.*?[^>])>([\\w\\W]*?)<1J(.*?)><\\/1c>/gi,"$3<1J$4>");e=e.J(/<1c(.*?)id="I-Q-75"(.*?[^>])>(.*?)<\\/1c>/gi,"");e=e.J(/<1c(.*?)id="I-Q-4O"(.*?[^>])>(.*?)<\\/1c>/gi,"");e=e.J(/<3d(.*?[^<])>/gi,"");e=e.J(/<\\/3d>/gi,"");e=B.1u.2r(e);if(B.G.ct){e=e.J(/<a(.*?)3g="cs"(.*?[^>])>/gi,"<a$1$2>");e=e.J(/<a(.*?[^>])>/gi,\'<a$1 3g="cs">\')}e=e.J(/\\im-I-(3f|1v|1e)="(.*?[^>])"/gi,"");e=e.J(1P 1U(\'<(.*?) 1g-2Y="I"(.*?[^>])>\',"gi"),"<$1$2>");e=e.J(1P 1U(\'<(.*?) 1g-2Y="I">\',"gi"),"<$1>");F e},6M:C(e,d){e=c.2J(e);e=e.J(/\\$/g,"&#36;");e=e.J(/<1c 1v="i4">/gi,"<1c>");e=e.J(/<1c 1v="cr-i3-5A">&4v;<\\/1c>/gi," ");e=e.J(/<1c 1v="cr-6W-1c"[^>]*>\\t<\\/1c>/gi,"\\t");e=e.J(/<1c[^>]*>(\\s|&4v;)<\\/1c>/gi," ");if(B.G.cu){F B.1p.8g(e)}if(!B.N.7a()&&1l d=="1s"){if(B.N.4f(["cv","A"])){F B.1p.8g(e,M)}if(B.N.4f("7O")){e=e.J(/”/g,\'"\');e=e.J(/“/g,\'"\');e=e.J(/‘/g,"\'");e=e.J(/’/g,"\'");F B.1p.eh(e)}if(B.N.4f(["9r","ba","bs","aL","9H","9R","9S"])){e=B.1p.c4(e);if(!B.N.1R("2e")){E f=B.K.3B();if(f&&f.1k=="P"){e=e.J(/<1J(.*?)>/gi,"<p><1J$1></p>")}}F e}if(B.N.4f(["4x"])){e=B.1p.9l(e,"3r");if(B.G.1A){e=B.1p.9h(e)}e=B.1p.e8(e);F e}if(B.N.4f(["4j"])){F B.1p.9l(e,"li")}}e=B.1p.er(e,d);if(!B.1p.7t){if(B.G.1A){e=B.1p.9h(e)}if(B.G.64){e=B.1p.64(e)}e=B.1p.aK(e)}e=B.1p.cy(e);e=B.1p.dq(e);e=B.1p.9l(e,"eo");if(!B.1p.7t&&B.G.2v){e=B.2v.2r(e)}e=B.1p.e9(e);e=B.1p.ej(e);e=B.1p.ek(e);e=B.1p.aH(e);F e},cy:C(f){f=f.J(/<!--[\\s\\S]*?-->/gi,"");f=f.J(/<1e[^>]*>[\\s\\S]*?<\\/1e>/gi,"");if(f.1T(/1v="?cw|1e="[^"]*\\cx-|1e=\'[^\'\']*\\cx-|w:hP/i)){f=f.J(/<!--[\\s\\S]+?-->/gi,"");f=f.J(/<(!|3l[^>]*>.*?<\\/3l(?=[>\\s])|\\/?(\\?hO(:\\w+)?|1J|4u|1d|1e|\\w:\\w+)(?=[\\s\\/>]))[^>]*>/gi,"");f=f.J(/<(\\/?)s>/gi,"<$hK>");f=f.J(/ /gi," ");f=f.J(/<1c\\s+1e\\s*=\\s*"\\s*9q-hL\\s*:\\s*hM\\s*;?\\s*"\\s*>([\\s\\9m]*)<\\/1c>/gi,C(j,i){F(i.R>0)?i.J(/./," ").aU(8y.hN(i.R/2)).3J("").2t("\\9m"):""});f=B.1p.ep(f);f=f.J(/<1J(.*?)v:hT=(.*?)>/gi,"");f=f.J(/3Q="2x\\:\\/\\/(.*?)"/,\'3Q=""\');E e=c("<1q/>").1b(f);E h=M;E g=1;E d=[];e.12("p[1e]").1m(C(){E n=c(B).1a("1e").1T(/9q\\-3q\\:l([0-9]+)\\hU([0-9]+)/);if(n){E o=4C(n[1]);E l=4C(n[2]);E r=c(B).1b().1T(/^[\\w]+\\./)?"2O":"2L";E q=c("<li/>").1b(c(B).1b());q.1b(q.1b().J(/^([\\w\\.]+)\\</,"<"));q.12("1c:bp").1o();if(l==1&&c.2K(o,d)==-1){E p=c("<"+r+"/>").1a({"1g-63":l,"1g-3q":o}).1b(q);c(B).22(p);h=o;d.2q(o)}L{if(l>g){E k=e.12(\'[1g-63="\'+g+\'"][1g-3q="\'+h+\'"]\');E j=k;29(E m=g;m<l;m++){p=c("<"+r+"/>");p.9e(j.12("li").4T());j=p}j.1a({"1g-63":l,"1g-3q":o}).1b(q)}L{E k=e.12(\'[1g-63="\'+l+\'"][1g-3q="\'+o+\'"]\').4T();k.1r(q)}g=l;h=o;c(B).1o()}}});e.12("[1g-63][1g-3q]").1w("1g-63 1g-3q");f=e.1b();f=f.J(/\xb7/g,"");f=f.J(/<p 1v="cw(.*?)"/gi,"<p");f=f.J(/ 1v=\\"(9q[^\\"]*)\\"/gi,"");f=f.J(/ 1v=(9q\\w+)/gi,"");f=f.J(/<o:p(.*?)>([\\w\\W]*?)<\\/o:p>/gi,"$2");f=f.J(/\\n/g," ");f=f.J(/<p>\\n?<li>/gi,"<li>")}F f},dq:C(d){d=d.J(/<b\\i2="dr-3U-2f(.*?)">([\\w\\W]*?)<\\/b>/gi,"$2");d=d.J(/<b(.*?)id="hZ-dr-hV(.*?)">([\\w\\W]*?)<\\/b>/gi,"$3");d=d.J(/<1c[^>]*(3d-1e: 3z; 3d-69: 3G|3d-69: 3G; 3d-1e: 3z)[^>]*>/gi,\'<1c 1e="3d-69: 3G;"><1c 1e="3d-1e: 3z;">\');d=d.J(/<1c[^>]*3d-1e: 3z[^>]*>/gi,\'<1c 1e="3d-1e: 3z;">\');d=d.J(/<1c[^>]*3d-69: 3G[^>]*>/gi,\'<1c 1e="3d-69: 3G;">\');d=d.J(/<1c[^>]*1C-5Z: 4P[^>]*>/gi,\'<1c 1e="1C-5Z: 4P;">\');d=d.J(/<1J>/gi,"");d=d.J(/\\n{3,}/gi,"\\n");d=d.J(/<3d(.*?)>([\\w\\W]*?)<\\/3d>/gi,"$2");d=d.J(/<p><p>/gi,"<p>");d=d.J(/<\\/p><\\/p>/gi,"</p>");d=d.J(/<li>(\\s*|\\t*|\\n*)<p>/gi,"<li>");d=d.J(/<\\/p>(\\s*|\\t*|\\n*)<\\/li>/gi,"</li>");d=d.J(/<\\/p>\\s<p/gi,"</p><p");d=d.J(/<1J 3Q="6C-hX-2b\\:\\/\\/(.*?)"(.*?)>/gi,"");d=d.J(/<p>•([\\w\\W]*?)<\\/p>/gi,"<li>$1</li>");if(B.N.1R("4r")){d=d.J(/<br\\s?\\/?>$/gi,"")}F d},9l:C(f,h){E e=["1c","a","2n","1L","7P","em","4l","1h","8Q","93","a2","7E","E","9i","ad","5V","5U","b","i","u","3D","2O","2L","li","dl","dt","dd","p","br","5t","7h","43","6L","6P","4G","1J","4t","3r","5g","5x","az","aN","aM","h1","h2","h3","h4","h5","h6"];E i=M;E g=[["a","*"],["1J",["3Q","6a"]],["1c",["1v","3g","1g-2Y"]],["43","*"],["5t","*"],["7h","*"],["6L","*"],["4G","*"],["6P","*"],["3U","*"]];if(h=="eo"){i=["p","1c","h1","h2","h3","h4","h5","h6"];g=[["4t","1v"],["3r",["m9","ma"]],["a","*"],["1J",["3Q","6a","1g-I-7d-Q"]],["1c",["1v","3g","1g-2Y"]],["43","*"],["5t","*"],["7h","*"],["6L","*"],["4G","*"],["6P","*"],["3U","*"]]}L{if(h=="3r"){e=["2L","2O","li","1c","a","7P","em","4l","1h","8Q","93","7E","E","9i","ad","5V","5U","b","i","u","3D","2O","2L","li","dl","dt","dd","br","43","5t","7h","6L","6P","4G","1J","h1","h2","h3","h4","h5","h6"]}L{if(h=="li"){e=["2L","2O","li","1c","a","7P","em","4l","1h","8Q","93","7E","E","9i","ad","5V","5U","b","i","u","3D","br","43","5t","7h","6L","6P","4G","1J"]}}}E d={3w:(B.G.3w)?B.G.3w:M,3N:(B.G.3N)?B.G.3N:e,5T:1j,m7:1j,1w:(B.G.1w)?B.G.1w:M,4c:(B.G.4c)?B.G.4c:g,3t:i};F B.1u.2r(f,d)},ek:C(d){d=d.J(/<(p|h[1-6])>(|\\s|\\n|\\t|<br\\s?\\/?>)<\\/(p|h[1-6])>/gi,"");if(!B.G.1A){d=d.J(/<br>$/i,"")}F d},ej:C(d){d=d.J(/<1c>(.*?)<\\/1c>/gi,"$1");d=d.J(/<1c[^>]*>\\s|&4v;<\\/1c>/gi," ");F d},ep:C(e){if(!B.N.1R("2e")){F e}E d=c.2J(e);if(d.2Z(/^<a(.*?)>(.*?)<\\/a>$/i)===0){e=e.J(/^<a(.*?)>(.*?)<\\/a>$/i,"$2")}F e},er:C(f,e){B.1p.7t=M;if(!B.N.7a()&&1l e=="1s"){E i=B.G.70.2t("|").J("P|","").J("6v|","");E j=f.1T(1P 1U("</("+i+")>","gi"));E h=f.1T(/<\\/(p|1q)>/gi);if(!j&&(h===3x||(h&&h.R<=1))){E d=f.1T(/<br\\s?\\/?>/gi);E g=f.1T(/<1J(.*?[^>])>/gi);if(!d&&!g){B.1p.7t=1j;f=f.J(/<\\/?(p|1q)(.*?)>/gi,"")}}}F f},m6:C(d,f){f=(((f||"")+"").2u().1T(/<[a-z][a-6G-9]*>/g)||[]).2t("");E e=/<\\/?([a-z][a-6G-9]*)\\b[^>]*>/gi;F d.J(e,C(h,g){F f.3X("<"+g.2u()+">")>-1?h:""})},eu:C(d){d=B.1p.et(d);d=B.1p.es(d);d=B.1p.ei(d);F d},et:C(d){E e=d.1T(/<2n(.*?)>([\\w\\W]*?)<\\/2n>/gi);if(e!==3x){c.1m(e,c.V(C(g,h){E f=h.1T(/<2n(.*?)>([\\w\\W]*?)<\\/2n>/i);f[2]=f[2].J(/<br\\s?\\/?>/g,"\\n");f[2]=f[2].J(/&4v;/g," ");if(B.G.5o){f[2]=f[2].J(/\\t/g,7K(B.G.5o+1).2t(" "))}f[2]=B.1p.9x(f[2]);f[2]=f[2].J(/\\$/g,"&#36;");d=d.J(h,"<2n"+f[1]+">"+f[2]+"</2n>")},B))}F d},es:C(d){E e=d.1T(/<1h(.*?)>([\\w\\W]*?)<\\/1h>/gi);if(e!==3x){c.1m(e,c.V(C(g,h){E f=h.1T(/<1h(.*?)>([\\w\\W]*?)<\\/1h>/i);f[2]=f[2].J(/&4v;/g," ");f[2]=B.1p.9x(f[2]);f[2]=f[2].J(/\\$/g,"&#36;");d=d.J(h,"<1h"+f[1]+">"+f[2]+"</1h>")},B))}F d},ei:C(d){d=d.J(/&lt;1c id=&55;K-2f-([0-9])&55; 1v=&55;I-K-2f&55; 1g-2Y=&55;I&55;&gt;​&lt;\\/1c&gt;/g,\'<1c id="K-2f-$1" 1v="I-K-2f" 1g-2Y="I">​</1c>\');F d},9O:C(e){e=e.J(/<br\\s?\\/?>|<\\/H[1-6]>|<\\/p>|<\\/1q>|<\\/li>|<\\/3r>/gi,"\\n");E d=14.3c("1q");d.2X=e;e=d.mn||d.mo;F c.2J(e)},8g:C(e,d){e=B.1p.9O(e);e=e.J(/\\n/g,"<br />");if(B.G.2v&&1l d=="1s"&&!B.N.1R("4r")){e=B.2v.2r(e)}F e},eh:C(d){d=d.J(/<1J(.*?) 1e="(.*?)"(.*?[^>])>/gi,"<1J$1$3>");d=d.J(/<1J(.*?)>/gi,"&lt;1J$1&gt;");d=B.1p.9O(d);if(B.G.5o){d=d.J(/\\t/g,7K(B.G.5o+1).2t(" "))}d=B.1p.9x(d);F d},c4:C(d){d=d.J(/<1J(.*?)>/gi,"[1J$1]");d=d.J(/<([mf]*?)>/gi,"");d=d.J(/\\[1J(.*?)\\]/gi,"<1J$1>");F d},mg:C(d){d=d.J(/<a(.*?)2B="(.*?)"(.*?)>([\\w\\W]*?)<\\/a>/gi,\'[a 2B="$2"]$4[/a]\');d=d.J(/<1J(.*?)>/gi,"[1J$1]");d=d.J(/<(.*?)>/gi,"");d=d.J(/\\[a 2B="(.*?)"\\]([\\w\\W]*?)\\[\\/a\\]/gi,\'<a 2B="$1">$2</a>\');d=d.J(/\\[1J(.*?)\\]/gi,"<1J$1>");F d},9x:C(d){d=5d(d).J(/&ea;/g,"&").J(/&lt;/g,"<").J(/&gt;/g,">").J(/&55;/g,\'"\');F d.J(/&/g,"&ea;").J(/</g,"&lt;").J(/>/g,"&gt;").J(/"/g,"&55;")},e9:C(d){if(B.N.1R("2e")){F d}E e=14.3c("1q");e.2X=d;B.1p.bo(c(e));d=e.2X;c(e).1o();F d},3M:C(){if(B.N.1R("2e")){F}B.1p.bo(B.$O);E d=B.$O.12("h1, h2, h3, h4, h5, h6");d.12("1c").1w("1e");d.12(B.G.b6.2t(", ")).1w("1e");B.1h.1B()},bo:C(d){d.12(B.G.b6.2t(", ")).1w("1e");d.12("1c").57(\'[1g-2Y="I"]\').1w("1e");d.12(\'1c[1g-2Y="I"], 1J[1g-2Y="I"]\').1m(C(f,g){E e=c(g);e.1a("1e",e.1a("3g"))})},lN:C(){},67:C(g){if(B.N.1R("2e")){F g}g=g.J(1P 1U("<1J(.*?[^>])>","gi"),\'<1J$1 1g-2Y="I">\');g=g.J(1P 1U("<1c(.*?[^>])>","gi"),\'<1c$1 1g-2Y="I">\');E j=g.1T(1P 1U(\'<(1c|1J)(.*?)1e="(.*?)"(.*?[^>])>\',"gi"));if(j){E d=j.R;29(E f=0;f<d;f++){49{E h=j[f].J(/1e="(.*?)"/i,\'1e="$1" 3g="$1"\');g=g.J(j[f],h)}42(k){}}}F g},aH:C(f){E d=c("<1q />").1b(f);E e=B.G.5c;e.2q("1c");d.12(e.2t(",")).1m(C(){E h=c(B);E g=B.1k.2u();h.1a("1g-I-3f",g);if(g=="1c"){if(h.1a("1e")){h.1a("1g-I-1e",h.1a("1e"))}L{if(h.1a("1v")){h.1a("1g-I-1v",h.1a("1v"))}}}});f=d.1b();d.1o();F f},8h:C(){B.$O.12("li").1m(C(e,f){E d=c(f).3R();if(d.R!==0&&(d[0].1k=="7H"||d[0].1k=="6U")){c(f).1r(d)}})},b4:C(d){d=d.J(/\\n/g,"");d=d.J(/[\\t]*/g,"");d=d.J(/\\n\\s*\\n/g,"\\n");d=d.J(/^[\\s\\n]*/g," ");d=d.J(/[\\s\\n]*$/g," ");d=d.J(/>\\s{2,}</g,"> <");d=d.J(/\\n\\n/g,"\\n");d=d.J(/[\\5S-\\6w\\6x]/g,"");F d},64:C(d){if(B.G.1A){d=d.J(/<1q><br\\s?\\/?><\\/1q>/gi,"<br />");d=d.J(/<1q(.*?)>([\\w\\W]*?)<\\/1q>/gi,"$2<br />")}L{d=d.J(/<1q(.*?)>([\\w\\W]*?)<\\/1q>/gi,"<p$1>$2</p>")}d=d.J(/<1q(.*?[^>])>/gi,"");d=d.J(/<\\/1q>/gi,"");F d},e8:C(d){d=d.J(/<1q\\s(.*?)>/gi,"<p>");d=d.J(/<1q><br\\s?\\/?><\\/1q>/gi,"<br /><br />");d=d.J(/<1q>([\\w\\W]*?)<\\/1q>/gi,"$1<br /><br />");F d},9h:C(d){d=d.J(/<p\\s(.*?)>/gi,"<p>");d=d.J(/<p><br\\s?\\/?><\\/p>/gi,"<br />");d=d.J(/<p>([\\w\\W]*?)<\\/p>/gi,"$1<br /><br />");d=d.J(/(<br\\s?\\/?>){1,}\\n?<\\/1L>/gi,"</1L>");F d},aK:C(d){F d.J(/<5h(.*?)>([\\w\\W]*?)<\\/5h>/gi,\'<3o$1 3g="I-5h-3f">$2</3o>\')},ec:C(d){F d.J(/<3o(.*?) 3g="I-5h-3f"(.*?)>([\\w\\W]*?)<\\/3o>/gi,"<5h$1$2>$3</5h>")}}},1h:C(){F{1G:C(d){d=c.2J(d.3O());d=B.1p.ed(d);B.$O.1b(d);B.1h.1B();if(d!==""){B.2y.1o()}2Q(c.V(B.1M.aD,B),15);if(B.7F===M){B.2k.2r()}},Y:C(){E d=B.$1Y.2H();d=B.2d.Y(d);F d},1B:C(){2Q(c.V(B.1h.eg,B),10)},eg:C(){E d=B.$O.1b();if(B.1h.aZ&&B.1h.aZ==d){F}B.1h.aZ=d;d=B.1O.28("lH",d);d=B.1p.8b(d);B.$1Y.2H(d);B.1O.28("1B",d);if(B.7F===M){B.1O.28("g4",d)}B.7F=M;if(B.2E.1b==M){B.2E.1b=B.1h.Y()}if(B.G.7p){B.$1Y.3R(".2S").1m(C(e,f){f.2S.ee(d)})}B.2E.ef();B.2E.8t()},2A:C(){if(B.G.5e){B.1h.b5()}L{B.1h.eJ()}},b5:C(){B.K.2C();B.1h.4p=B.1I.9C();E j=c(3e).4d();E e=B.$O.7D(),l=B.$O.4U();B.$O.2z();E g=B.$1Y.2H();B.eK=B.1p.b4(g);g=B.2d.Y(g);E d=0,f=0;E i=c("<1q/>").1r(c.aW(B.1p.8b(B.$O.1b()),14,1j));E h=i.12("1c.I-K-2f");if(h.R>0){E k=B.2d.Y(i.1b());if(h.R==1){d=B.N.8d(k,i.12("#K-2f-1").4Z("6h"));f=d}L{if(h.R==2){d=B.N.8d(k,i.12("#K-2f-1").4Z("6h"));f=B.N.8d(k,i.12("#K-2f-2").4Z("6h"))-i.12("#K-2f-1").4Z("6h").3O().R}}}B.K.7y();B.$1Y.2H(g);if(B.G.7p){B.$1Y.3R(".2S").1m(C(m,n){c(n).2i();n.2S.ee(g);n.2S.lZ(e,l);n.2S.m0();if(d==f){n.2S.lW(n.2S.6l(d).3i,n.2S.6l(f).ch)}L{n.2S.lV({3i:n.2S.6l(d).3i,ch:n.2S.6l(d).ch},{3i:n.2S.6l(f).3i,ch:n.2S.6l(f).ch})}n.2S.2c()})}L{B.$1Y.4n(l).2i().2c();B.$1Y.1x("1i.I-1Y-eL",B.1h.eM);c(3e).4d(j);if(B.$1Y[0].ev){B.$1Y[0].ev(d,f)}B.$1Y[0].4d=0}B.G.5e=M;B.1D.ew();B.1D.7M("1b");B.1O.28("3U",g)},eJ:C(){E f;if(B.G.5e){F}E j=0,d=0;if(B.G.7p){E h;B.$1Y.3R(".2S").1m(C(k,l){h=l.2S.mp();j=l.2S.eH(h[0].eI);d=l.2S.eH(h[0].au);f=l.2S.mV()})}L{j=B.$1Y.Y(0).ax;d=B.$1Y.Y(0).av;f=B.$1Y.2z().2H()}if(j>d&&d>0){E i=d;E g=j;j=i;d=g}j=B.1h.aw(f,j);d=B.1h.aw(f,d);f=f.3K(0,j)+B.K.4k(1)+f.3K(j);if(d>j){E e=B.K.4k(1).3O().R;f=f.3K(0,d+e)+B.K.4k(2)+f.3K(d+e)}if(B.eK!==B.1p.b4(f)){B.1h.1G(f)}if(B.G.7p){B.$1Y.3R(".2S").2z()}B.$O.2i();if(!B.N.3C(f)){B.2y.1o()}B.K.2w();B.$1Y.2R("1i.I-1Y-eL");B.1D.eO();B.1D.eN("1b");B.2k.2r();B.G.5e=1j;B.1O.28("5e",f)},eM:C(f){if(f.2G!==9){F 1j}E d=B.$1Y;E g=d.Y(0).ax;d.2H(d.2H().80(0,g)+"\\t"+d.2H().80(d.Y(0).av));d.Y(0).ax=d.Y(0).av=g+1;F M},aw:C(f,g){E d=f.R;E h=0;if(f[g]==">"){h++}L{29(E e=g;e<=d;e++){h++;if(f[e]==">"){54}L{if(f[e]=="<"||e==d){h=0;54}}}}F g+h}}},1O:C(){F{n0:C(){F c.6n({},B)},mZ:C(){F B.$O},n1:C(){F B.$2g},n2:C(){F B.$3a},mS:C(){F B.$1Y},mM:C(){F(B.$1n)?B.$1n:M},7n:C(d){B.1O.eG=d},6b:C(){F B.1O.eG},28:C(i,k,j){E f=i+"mN";E d="I";E l=B.G[f];if(B.$1Y){E h=M;E g=c.mz(B.$1Y[0],"mw");if(1l g!="1s"&&1l g[f]!="1s"){c.1m(g[f],c.V(C(e,n){if(n.mv==d){E m=(1l m=="1s")?[k]:[k,m];h=(1l m=="1s")?n.8e.5k(B,k):n.8e.5k(B,k,m)}},B))}if(h){F h}}if(c.4I(l)){F(1l j=="1s")?l.5k(B,k):l.5k(B,k,j)}L{F(1l j=="1s")?k:j}},eF:C(){B.G.gQ=1j;B.1O.28("eF");B.$3a.2R(".I").ez("I");B.$O.2R(".I");c(14).2R("1V.I-Q-6z."+B.2h);c(14).2R("1V.I-Q-3P-2z."+B.2h);c(14).2R("5f.I."+B.2h+" 1V.I."+B.2h);c("2D").2R("6k.I."+B.2h);c(B.G.5w).2R("6k.I."+B.2h);B.$O.2j("I-O I-1A I-2y");B.$O.1w("6r");E d=B.1h.Y();if(B.G.1n){B.$1n.12("a").1m(C(){E e=c(B);if(e.1g("1E")){e.1g("1E").1o();e.1g("1E",{})}})}if(B.1W.82()){B.$2g.2N(B.$3a);B.$2g.1o();B.$3a.2H(d).2i()}L{B.$2g.2N(B.$O);B.$2g.1o();B.$3a.1b(d).2i()}if(B.$4y){B.$4y.1o()}if(B.$47){B.$47.1o()}if(B.$5Y){B.$5Y.1o()}c(".I-1n-3S-"+B.2h).1o();ey(B.7b)}}},1E:C(){F{1W:C(d,f,e){if(d=="2p"&&B.G.bd){c.1m(B.G.bd,c.V(C(h,j){E g=j.3f,k;if(1l j["1v"]!="1s"){g=g+"-"+j["1v"]}j.1F=(B.N.6y(j.3f))?"U":"1N";if(1l j.1K!=="1s"){k=j.1K}L{k=(j.1F=="1N")?"1N.2p":"U.2p"}if(B.G.1A&&j.1F=="U"&&j.3f=="p"){F}B.2p[g]={3f:j.3f,1e:j.1e,"1v":j["1v"],1a:j.1a,1g:j.1g,7g:j.7g};e[g]={1K:k,1Q:j.1Q}},B))}c.1m(e,c.V(C(i,h){E g=c(\'<a 2B="#" 1v="I-1E-\'+i+\'">\'+h.1Q+"</a>");if(d=="2p"){g.1X("I-2p-"+i)}g.1x("1V",c.V(C(k){k.21();E j="1K";E l=h.1K;if(h.5b){j="5b";l=h.5b}L{if(h.1E){j="1E";l=h.1E}}B.1D.83(k,i,j,l);B.1E.7J()},B));f.1r(g)},B))},2i:C(j,n){if(!B.G.5e){j.21();F M}E d=B.1D.Y(n);E k=d.1g("1E").9e(14.2D);if(B.N.4H()&&!B.N.1R("2e")){14.ha.9k()}if(d.2U("6e")){B.1E.7J()}L{B.1E.7J();B.1O.28("mI",{1E:k,ex:n,1D:d});B.1D.7M(n);d.1X("6e");E o=d.4p();E l=k.2M();if((o.2a+l)>c(14).2M()){o.2a=8y.mH(0,o.2a-l)}E g=o.2a+"2W";if(B.$1n.2U("1n-6p-2g")){E m=B.$1n.4U()+B.G.6t;E i="6p";if(B.G.5w!==14){m=(B.$1n.4U()+B.$1n.4p().3s)+B.G.6t;i="7z"}k.1y({4q:i,2a:g,3s:m+"2W"}).2i()}L{E m=(d.4U()+o.3s)+"2W";k.1y({4q:"7z",2a:g,3s:m}).2i()}B.1O.28("mD",{1E:k,ex:n,1D:d})}c(14).eA("1V",c.V(B.1E.2z,B));B.$O.eA("1V",c.V(B.1E.2z,B));E h=c(14.2D);E f=h.2M();k.1x("eB",C(){h.1X("2D-I-6q");h.1y("3H-3I",(h.2M()-f)+"2W")});k.1x("eE",C(){h.2j("2D-I-6q").1y("3H-3I",0)});j.bX()},7J:C(){B.$1n.12("a.6e").2j("I-72").2j("6e");c(14.2D).2j("2D-I-6q").1y("3H-3I",0);c(".I-1E-"+B.2h).2z();B.1O.28("kA")},2z:C(f){E d=c(f.2m);if(!d.2U("6e")){d.2j("6e");B.1E.7J()}}}},2x:C(){F{2i:C(){B.T.2r("2x",B.1z.Y("2x"),eC);B.1f.3b("#I-T-2x-1f",B.G.6K,B.2x.1H);B.K.2C();B.K.Y();E d=B.3h.3O();c("#I-5P").2H(d);B.T.2i()},1H:C(g,k,i){if(1l g.56!="1s"){B.T.3A();B.K.2w();B.1O.28("kD",g);F}E h;if(1l g=="5z"){h=g}L{E j=c("#I-5P").2H();if(1l j=="1s"||j===""){j=g.5P}h=\'<a 2B="\'+g.79+\'" id="79-2f">\'+j+"</a>"}if(k){B.K.7y();E d=B.K.5u();B.1H.a4(i,d)}L{B.T.3A()}B.K.2w();B.1M.1G();B.1H.dR(h);if(1l g=="5z"){F}E f=c(B.$O.12("a#79-2f"));if(f.R!==0){f.1w("id").1w("1e")}L{f=M}B.1O.28("6K",f,g)}}},2c:C(){F{2I:C(){B.$O.2c();E d=B.$O.4F().bp();if(d.R===0){F}if(d[0].R===0||d[0].1k=="4N"||d[0].an==3){F}if(d[0].1k=="7H"||d[0].1k=="6U"){E e=d.12("li").bp();if(!B.N.5D(e)&&e.1C()===""){B.1I.2I(e);F}}if(B.G.1A&&!B.N.6y(d[0].1k)){B.K.Y();B.1t.2I(B.$O[0],0);B.1t.3k(B.$O[0],0);B.K.4i();F}B.1I.2I(d)},3k:C(){if(B.N.1R("4r")||B.N.1R("2e")){E d=B.$O.4F().4T();B.$O.2c();B.1I.3k(d)}L{B.K.Y();49{B.1t.8r(B.$O[0]);B.1t.3Z(M);B.K.4i()}42(f){}}},eD:C(){E d=14.51().ku;if(d===3x){F M}if(B.G.1A&&c(d.a8).2U("I-1A")){F 1j}L{if(!B.N.3T(d.a8)){F M}}F B.$O.is(":2c")}}},Q:C(){F{2i:C(){B.T.2r("Q",B.1z.Y("Q"),eC);B.1f.3b("#I-T-Q-3v",B.G.6H,B.Q.1H);B.K.2C();B.T.2i()},dB:C(f){E e=f.25("a",B.$O[0]);B.T.2r("gM",B.1z.Y("78"),kw);B.T.9V();B.Q.e6=B.T.gT(B.1z.Y("e7"));B.Q.dG=B.T.b2(B.1z.Y("2C"));B.Q.e6.1x("1V",c.V(C(){B.Q.1o(f)},B));B.Q.dG.1x("1V",c.V(C(){B.Q.dH(f)},B));c(".I-1d-3S").1o();c("#I-Q-1Q").2H(f.1a("6a"));if(!B.G.dF){c(".I-Q-1d-3j").2z()}L{E d=c("#I-Q-1d");d.1a("2B",f.1a("3Q"));if(e.R!==0){d.2H(e.1a("2B"));if(e.1a("2m")=="6d"){c("#I-Q-1d-6I").4Z("8m",1j)}}}if(!B.G.dE){c(".I-Q-4q-3j").2z()}L{E g=(f.1y("5I")=="U"&&f.1y("6i")=="4S")?"4K":f.1y("6i");c("#I-Q-5a").2H(g)}B.T.2i()},dI:C(e){E h=c("#I-Q-5a").2H();E f="";E d="";E g="";dP(h){6Q"2a":f="2a";g="0 "+B.G.77+" "+B.G.77+" 0";54;6Q"3I":f="3I";g="0 0 "+B.G.77+" "+B.G.77;54;6Q"4K":d="U";g="8T";54}e.1y({"6i":f,5I:d,3H:g});e.1a("3g",e.1a("1e"))},dH:C(h){B.Q.5F();B.1M.1G();E e=h.25("a",B.$O[0]);h.1a("6a",c("#I-Q-1Q").2H());B.Q.dI(h);E i=c.2J(c("#I-Q-1d").2H());if(i!==""){E j="((gG--)?[a-6G-9]+(-[a-6G-9]+)*\\\\.)+[a-z]{2,}";E g=1P 1U("^(7v|7j|4Q)://"+j,"i");E f=1P 1U("^"+j,"i");if(i.2Z(g)==-1&&i.2Z(f)===0&&B.G.5L){i=B.G.5L+"://"+i}E k=(c("#I-Q-1d-6I").4Z("8m"))?1j:M;if(e.R===0){E d=c(\'<a 2B="\'+i+\'">\'+B.N.5j(h)+"</a>");if(k){d.1a("2m","6d")}h.22(d)}L{e.1a("2B",i);if(k){e.1a("2m","6d")}L{e.1w("2m")}}}L{if(e.R!==0){e.22(B.N.5j(h))}}B.T.3A();B.2k.7Z();B.1h.1B()},gC:C(d){if(B.G.8E){d.1x("kL",c.V(B.Q.8Z,B))}d.1x("bf",c.V(B.Q.5F,B));d.1x("1V.I 5f",c.V(C(f){B.2k.Q=d;if(B.$O.12("#I-Q-2g").R!==0){F M}B.Q.75=B.Q.dx(d);c(14).1x("1V.I-Q-3P-2z."+B.2h,c.V(B.Q.5F,B));B.$O.1x("1V.I-Q-3P-2z."+B.2h,c.V(B.Q.5F,B));if(!B.G.bq){F}B.Q.75.1x("bf.I 5f.I",c.V(C(g){B.Q.dL(g,d)},B))},B))},dL:C(f,d){f.21();B.Q.3F={x:f.dK,y:f.8z,el:d,b8:d.2M()/d.4n(),h:d.4n()};f=f.62||f;if(f.74){B.Q.3F.x=f.74[0].dK;B.Q.3F.y=f.74[0].8z}B.Q.dJ()},dJ:C(){c(14).1x("kJ.I-Q-3P kt.I-Q-3P",c.V(B.Q.dD,B));c(14).1x("f0.I-Q-3P ks.I-Q-3P",c.V(B.Q.dw,B))},dD:C(g){g.21();g=g.62||g;E d=B.Q.3F.h;if(g.74){d+=(g.74[0].8z-B.Q.3F.y)}L{d+=(g.8z-B.Q.3F.y)}E f=8y.dC(d*B.Q.3F.b8);if(d<50||f<7i){F}E d=8y.dC(B.Q.3F.el.2M()/B.Q.3F.b8);B.Q.3F.el.1a({2M:f,4n:d});B.Q.3F.el.2M(f);B.Q.3F.el.4n(d);B.1h.1B()},dw:C(){B.h0=M;c(14).2R(".I-Q-3P");B.Q.5F()},8Z:C(d){if(B.$O.12("#I-Q-2g").R!==0){d.21();F M}B.$O.1x("4e.I-Q-dv-4e",c.V(C(){2Q(c.V(B.Q.9E,B),1)},B))},9E:C(){B.Q.du();B.2k.7Z();B.$O.2R("4e.I-Q-dv-4e");B.1p.3M();B.1h.1B()},du:C(){B.$O.12("1J[1g-2C-2b]").1m(C(){E d=c(B);d.1a("3Q",d.1a("1g-2C-2b"));d.1w("1g-2C-2b")})},5F:C(g){if(g&&c(g.2m).25("#I-Q-2g",B.$O[0]).R!==0){F}if(g&&g.2m.1k=="7T"){E d=c(g.2m);d.1a("1g-2C-2b",d.1a("3Q"))}E f=B.$O.12("#I-Q-2g");if(f.R===0){F}if(B.G.8E){B.Q.4O.1o()}c(B.Q.75).1o();f.12("1J").1y({52:f[0].1e.52,8v:f[0].1e.8v,8w:f[0].1e.8w,8x:f[0].1e.8x});f.1y("3H","");f.12("1J").1y("dy","");f.22(C(){F c(B).1S()});c(14).2R("1V.I-Q-3P-2z."+B.2h);B.$O.2R("1V.I-Q-3P-2z."+B.2h);if(1l B.Q.3F!=="1s"){B.Q.3F.el.1a("3g",B.Q.3F.el.1a("1e"))}B.1h.1B()},dA:C(e,f){if(B.G.bq&&!B.N.4H()){E d=c(\'<1c id="I-Q-75" 1g-I="2Y"></1c>\');if(!B.N.6F()){d.1y({2M:"ds",4n:"ds"})}d.1a("6r",M);f.1r(d);f.1r(e);F d}L{f.1r(e);F M}},dx:C(e){E f=c(\'<1c id="I-Q-2g" 1g-I="2Y">\');f.1y("6i",e.1y("6i")).1a("6r",M);if(e[0].1e.3H!="8T"){f.1y({52:e[0].1e.52,8v:e[0].1e.8v,8w:e[0].1e.8w,8x:e[0].1e.8x});e.1y("3H","")}L{f.1y({5I:"U",3H:"8T"})}e.1y("dy",".5").2N(f);if(B.G.8E){B.Q.4O=c(\'<1c id="I-Q-4O" 1g-I="2Y">\'+B.1z.Y("78")+"</1c>");B.Q.4O.1a("6r",M);B.Q.4O.1x("1V",c.V(C(){B.Q.dB(e)},B));f.1r(B.Q.4O);E d=B.Q.4O.7D();B.Q.4O.1y("3H-2a","-"+d/2+"2W")}F B.Q.dA(e,f)},1o:C(i){E g=c(i);E e=g.25("a",B.$O[0]);E f=g.25("dz",B.$O[0]);E h=g.2P();if(c("#I-Q-2g").R!==0){h=c("#I-Q-2g").2P()}E d;if(f.R!==0){d=f.3R();f.1o()}L{if(e.R!==0){h=e.2P();e.1o()}L{g.1o()}}c("#I-Q-2g").1o();if(f.R!==0){B.1I.2I(d)}L{B.1I.2I(h)}B.1O.28("b9",g[0].3Q,g);B.T.3A();B.1h.1B()},1H:C(h,l,k){if(1l h.56!="1s"){B.T.3A();B.K.2w();B.1O.28("ln",h);F}E g;if(1l h=="5z"){g=c(h).1a("1g-I-7d-Q","1j")}L{g=c("<1J>");g.1a("3Q",h.79).1a("1g-I-7d-Q","1j")}E j=g;E f=B.N.4f("P");if(f){j=c("<1L />").1r(g)}if(l){B.K.7y();E d=B.K.5u();B.1H.a4(k,d)}L{B.T.3A()}B.K.2w();B.1M.1G();B.1H.1b(B.N.5j(j),M);E i=B.$O.12("1J[1g-I-7d-Q=1j]").1w("1g-I-7d-Q");if(f){i.2P().1S().3p().4W("<p />")}L{if(B.G.1A){if(!B.N.3C(B.1h.Y())){i.8p("<br>")}i.2N("<br>")}}if(1l h=="5z"){F}B.1O.28("6H",i,h)}}},2T:C(){F{8Y:C(){if(!B.N.1R("2e")){B.$O.2c()}B.1M.1G();B.K.2C();E d=B.K.3B();if(d&&d.1k=="4j"){B.2T.dM()}L{if(d===M&&B.G.1A){B.2T.e0()}L{B.2T.dN()}}B.K.2w();B.1h.1B()},dM:C(){14.3m("2T");B.2T.87();B.1p.8h();B.1p.3M()},dN:C(){c.1m(B.K.3E(),c.V(C(e,f){if(f.1k==="4x"||f.1k==="8s"){F}E d=B.N.7W(f);E g=B.N.aT(d.1y("3H-2a"))+B.G.8L;d.1y("3H-2a",g+"2W")},B))},e0:C(){E d=B.K.4W("1q");c(d).1a("1g-7k","I");c(d).1y("3H-2a",B.G.8L+"2W")},92:C(){B.1M.1G();B.K.2C();E d=B.K.3B();if(d&&d.1k=="4j"){B.2T.dZ()}L{B.2T.dY()}B.K.2w();B.1h.1B()},dZ:C(){14.3m("6o");E f=B.K.30();E d=c(f).25("li",B.$O[0]);E e=d.2P();if(d.R!==0&&e.R!==0&&e[0].1k=="4j"){e.2N(d)}B.2T.87();if(!B.G.1A&&d.R===0){14.3m("8C",M,"p");B.$O.12("2L, 2O, 1L, p").1m(c.V(B.N.3t,B))}B.1p.3M()},dY:C(){c.1m(B.K.3E(),c.V(C(e,f){E d=B.N.7W(f);E g=B.N.aT(d.1y("3H-2a"))-B.G.8L;if(g<=0){if(B.G.1A&&1l(d.1g("7k"))!=="1s"){d.22(d.1b()+"<br />")}L{d.1y("3H-2a","");B.N.4J(d,"1e")}}L{d.1y("3H-2a",g+"2W")}},B))},87:C(){E e=B.K.3B();if(B.1t.4s&&e&&e.1k=="4j"&&B.N.3C(c(e).1C())){E d=c(e);d.12("1c").57(".I-K-2f").1S().3p();d.1r("<br>")}}}},1N:C(){F{2p:C(d){E e,f;if(1l B.2p[d].1e!="1s"){e="1e"}L{if(1l B.2p[d]["1v"]!="1s"){e="1v"}}if(e){f=B.2p[d][e]}B.1N.2o(B.2p[d].3f,e,f)},2o:C(d,g,j){if(B.N.4f("7O")||B.N.g1()){F}E e=["b","3G","i","3z","4P","e3","58","e1","e2"];E h=["4l","4l","em","em","u","3D","3D","5V","5U"];29(E f=0;f<e.R;f++){if(d==e[f]){d=h[f]}}if(B.G.3N){if(c.2K(d,B.G.3N)==-1){F}}L{if(c.2K(d,B.G.3w)!==-1){F}}B.1N.1F=g||M;B.1N.23=j||M;B.1M.1G();if(!B.N.1R("2e")){B.$O.2c()}B.K.Y();if(B.1t.4s){B.1N.e5(d)}L{B.1N.e4(d)}},e5:C(d){E g=B.K.30();E f=c(g).25(d+"[1g-I-3f="+d+"]",B.$O[0]);if(f.R!==0&&(B.1N.1F!="1e"&&f[0].1k!="5J")){if(B.N.3C(f.1C())){B.1I.4o(f[0]);f.1o();B.1h.1B()}L{if(B.N.5y(f)){B.1I.4o(f[0])}}F}E e=c("<"+d+">").1a("1g-2Y","I").1a("1g-I-3f",d);e.1b(B.G.5l);e=B.1N.9N(e);E e=B.1H.41(e);B.1I.3k(e);B.1h.1B()},e4:C(d){B.1N.dQ(d);B.K.2C();14.3m("e3");B.$O.12("5X").1m(c.V(C(j,l){E h=c(l);B.1N.dW(h,d);E g;if(B.1N.1F){g=c("<1c>").1a("1g-I-3f",d).1a("1g-2Y","I");g=B.1N.9N(g)}L{g=c("<"+d+">").1a("1g-I-3f",d).1a("1g-2Y","I")}h.22(g.1b(h.1S()));if(d=="1c"){E m=g.2P();if(m&&m[0].1k=="5J"&&B.1N.1F=="1e"){E f=B.1N.23.3J(";");29(E n=0;n<f.R;n++){if(f[n]===""){F}E k=f[n].3J(":");m.1y(k[0],"");if(B.N.4J(m,"1e")){m.22(m.1S())}}}}},B));if(d!="1c"){B.$O.12(B.G.5c.2t(", ")).1m(c.V(C(g,h){E f=c(h);E j=f.1y("1C-5Z");if(j=="3i-dX"){f.1y("1C-5Z","");B.N.4J(f,"1e")}},B))}if(d!="3D"){E e=B;B.$O.12("1N").1m(C(f,g){e.N.4a(g,"3D")})}B.K.2w();B.1h.1B()},dW:C(f,d){E e=B;f.4F(d).1m(C(){E i=c(B);if(!i.2U("I-K-2f")){if(e.1N.1F=="1e"){E g=e.1N.23.3J(";");29(E j=0;j<g.R;j++){if(g[j]===""){F}E h=g[j].3J(":");i.1y(h[0],"");if(e.N.4J(i,"1e")){i.22(i.1S())}}}L{i.1S().3p()}}})},dQ:C(d){B.K.2C();E f="";if(B.1N.1F=="1v"){f="[1g-I-1v="+B.1N.23+"]"}L{if(B.1N.1F=="1e"){f=\'[1g-I-1e="\'+B.1N.23+\'"]\'}}E e=B;if(d!="3D"){B.$O.12("3D").1m(C(g,h){e.N.4a(h,"1N")})}if(d!="1c"){B.$O.12(d).1m(C(){E g=c(B);g.22(c("<5X />").1b(g.1S()))})}B.$O.12(\'[1g-I-3f="\'+d+\'"]\'+f).1m(C(){if(f===""&&d=="1c"&&B.1k.2u()==d){F}E g=c(B);g.22(c("<5X />").1b(g.1S()))});B.K.2w()},9N:C(d){dP(B.1N.1F){6Q"1v":if(d.2U(B.1N.23)){d.2j(B.1N.23);d.1w("1g-I-1v")}L{d.1X(B.1N.23);d.1a("1g-I-1v",B.1N.23)}54;6Q"1e":d[0].1e.kX=B.1N.23;d.1a("1g-I-1e",B.1N.23);54}F d},kS:C(){B.1M.1G();E f=B.K.30();E e=B.K.a5();B.K.2C();if(f&&f.1k==="5J"){E d=c(f);d.1w("1e");if(d[0].3W.R===0){d.22(d.1S())}}c.1m(e,c.V(C(h,j){E g=c(j);if(c.2K(j.1k.2u(),B.G.5c)!=-1&&!g.2U("I-K-2f")){g.1w("1e");if(g[0].3W.R===0){g.22(g.1S())}}},B));B.K.2w();B.1h.1B()},kT:C(f){B.1M.1G();E g=B.K.4R();E e=B.K.a5();B.K.2C();if(g&&g.1k==="5J"){E d=c(g);d.1y(f,"");B.N.4J(d,"1e");if(d[0].3W.R===0){d.22(d.1S())}}c.1m(e,c.V(C(j,k){E h=c(k);if(c.2K(k.1k.2u(),B.G.5c)!=-1&&!h.2U("I-K-2f")){h.1y(f,"");B.N.4J(h,"1e");if(h[0].3W.R===0){h.22(h.1S())}}},B));B.K.2w();B.1h.1B()},ah:C(){B.1M.1G();E d=B.K.30();B.K.2C();14.3m("ah");if(d&&d.1k==="5J"){c(d).22(c(d).1S())}c.1m(B.K.5r(),c.V(C(f,g){E e=c(g);if(c.2K(g.1k.2u(),B.G.5c)!=-1&&!e.2U("I-K-2f")){e.22(e.1S())}},B));B.K.2w();B.1h.1B()},6B:C(d){B.1N.2o("1c","1v",d)},kV:C(d){B.1N.2o("1c","1e",d)}}},1H:C(){F{1G:C(e,d){B.2y.1o();e=B.1p.67(e);if(1l d=="1s"){e=B.1p.6M(e,M)}B.$O.1b(e);B.K.1o();B.2c.3k();B.1p.8h();B.1h.1B();B.2k.2r();if(1l d=="1s"){2Q(c.V(B.1p.3M,B),10)}},1C:C(h){B.2y.1o();h=h.3O();h=c.2J(h);h=B.1p.8g(h,M);B.$O.2c();if(B.N.1R("2e")){B.1H.9W(h)}L{B.K.Y();B.1t.4L();E e=14.3c("1q");e.2X=h;E i=14.8a(),g,f;4h((g=e.89)){f=i.6m(g)}B.1t.3u(i);if(f){E d=B.1t.7x();d.dO(f);d.3Z(1j);B.3h.9X();B.3h.4i(d)}}B.1h.1B();B.1p.3M()},dR:C(d){B.1H.1b(d,M)},1b:C(e,d){B.2y.1o();if(1l d=="1s"){d=1j}B.$O.2c();e=B.1p.67(e);if(d){e=B.1p.6M(e)}if(B.N.1R("2e")){B.1H.9W(e)}L{if(B.1p.7t){B.1H.dT(e)}L{14.3m("eb",M,e)}B.1H.dS()}B.1p.8h();if(!B.G.1A){B.$O.12("p").1m(c.V(B.N.3t,B))}B.1h.1B();B.2k.2r();if(d){B.1p.3M()}},dS:C(){if(!B.N.1R("4r")){F}E d=c(B.K.3B()).3R();if(d.R>0&&d[0].1k=="P"&&d.1b()===""){d.1o()}},9W:C(f){if(B.N.fY()){E g=B.N.4f("P");E d=c("<1q>").1r(f);E e=d.1S().is("p, :9n, dl, 2L, 2O, 1q, 4t, 3r, 1L, 2n, a2, 3o, 9n, ar, dV, dU");if(g&&e){B.1H.bW(g,f)}L{B.1H.bw(f)}F}14.K.ak().fo(f)},dT:C(d){d=B.1p.67(d);B.K.Y();B.1t.4L();E e=14.3c("1q");e.2X=d;E h=14.8a(),g,f;4h((g=e.89)){f=h.6m(g)}B.1t.3u(h);B.1t.3Z(1j);B.1I.4o(f)},41:C(f,e){f=f[0]||f;E d=B.N.5j(f);d=B.1p.67(d);if(d.1T(/</g)!==3x){f=c(d)[0]}B.K.Y();if(e!==M){B.1t.4L()}B.1t.3u(f);B.1t.3Z(M);B.K.4i();F f},l6:C(g,d,i){g=g[0]||g;B.K.Y();E e;if(14.8l){E h=14.8l(d,i);B.1t.2I(h.eP,h.4p);B.1t.3Z(1j);B.1t.3u(g)}L{if(14.8n){e=14.8n(d,i);e.3u(g)}L{if(1l 14.2D.8o!="1s"){e=14.2D.8o();e.8F(d,i);E f=e.bZ();f.8F(d,i);e.c2("bV",f);e.6f()}}}},a4:C(j,h){h=h[0]||h;E f;E d=j.l7,l=j.mc;if(14.8l){E k=14.8l(d,l);E i=14.51();f=i.5N(0);f.2I(k.eP,k.4p);f.3Z(1j);f.3u(h)}L{if(14.8n){f=14.8n(d,l);f.3u(h)}L{if(1l 14.2D.8o!="1s"){f=14.2D.8o();f.8F(d,l);E g=f.bZ();g.8F(d,l);f.c2("bV",g);f.6f()}}}},bW:C(f,e){E g=14.3c("1c");g.fS="I-ie-4E";B.1H.41(g);E d=c(f).1b();d="<p>"+d.J(/<1c 1v="I-ie-4E"><\\/1c>/gi,"</p>"+e+"<p>")+"</p>";c(f).22(d)},bw:C(d){B.K.Y();B.1t.4L();E e=14.3c("1q");e.2X=d;E h=14.8a(),g,f;4h((g=e.89)){f=h.6m(g)}B.1t.3u(h);B.1t.3Z(M);B.K.4i()}}},1i:C(){F{3b:C(u){if(B.6c){F}E w=u.7f;E g=(w>=37&&w<=40);B.1i.3n=u.7G||u.5H;B.1i.2V=B.K.30();B.1i.2P=B.K.4R();B.1i.U=B.K.3B();B.1i.2n=B.N.8N(B.1i.2V,"2n");B.1i.1L=B.N.8N(B.1i.2V,"1L");B.1i.5W=B.N.8N(B.1i.2V,"5W");B.4X.3b(u,w);if(B.N.6F()){B.1i.by(g,w);B.1i.bC(u,w)}B.1i.bQ(g);B.1i.c1(u,w);E s=B.1O.28("1i",u);if(s===M){u.21();F M}if(B.G.8D&&(B.N.1R("2e")||B.N.1R("4r"))&&(w===B.2G.9J||w===B.2G.bF)){E f=M;E k=M;if(B.1i.U&&B.1i.U.1k==="4x"){k=c(B.1i.U).25("4t",B.$O[0])}if(k&&k.12("3r").4T()[0]===B.1i.U){f=1j}if(B.N.5y()&&f){E p=c(B.G.5s);k.2N(p);B.1I.2I(p)}}if(B.G.8D&&w===B.2G.9J){B.1i.bJ()}if(!B.G.8D&&w===B.2G.5R){u.21();if(!B.1t.4s){B.1t.4L()}F}if(w==B.2G.5R&&!u.5C&&!u.7G&&!u.5H){E q=B.1O.28("lU",u);if(q===M){u.21();F M}if(B.1i.1L&&B.1i.bE(u)===1j){F M}E n,v;if(B.1i.2n){F B.1i.bI(u)}L{if(B.1i.1L||B.1i.5W){n=B.K.30();v=c(n).3R();if(v.R!==0&&v[0].1k=="4N"){F B.1i.5O(u)}L{if(B.N.5y()&&(n&&n!="5J")){F B.1i.6T(u)}L{F B.1i.5O(u)}}}L{if(B.G.1A&&!B.1i.U){n=B.K.30();v=c(B.1i.2V).3R();if(v.R!==0&&v[0].1k=="4N"){F B.1i.5O(u)}L{if(n!==M&&c(n).2U("I-6N-5A")){B.1I.4o(n);c(n).1S().3p();F B.1i.6T(u)}L{if(B.N.aJ()){F B.1i.6T(u)}L{if(v.R===0&&n===M&&1l v.lS!="1s"){F B.1i.5O(u)}}F B.1i.5O(u)}}}L{if(B.G.1A&&B.1i.U){2Q(c.V(B.1i.bL,B),1)}L{if(!B.G.1A&&B.1i.U){if(B.1i.U.1k!=="4j"){2Q(c.V(B.1i.bK,B),1)}L{n=B.K.30();E m=c(n).25("li",B.$O[0]);E d=m.25("2L,2O",B.$O[0]);if(m.R!==0&&B.N.3C(m.1b())&&d.3R().R===0&&B.N.3C(d.12("li").4T().1b())){d.12("li").4T().1o();E p=c(B.G.5s);d.2N(p);B.1I.2I(p);F M}}}L{if(!B.G.1A&&!B.1i.U){F B.1i.bN(u)}}}}}}}if(w===B.2G.5R&&(u.7G||u.5C)){F B.1i.bv(u)}if(w===B.2G.bg||u.5H&&w===aE||u.5H&&w===aG){F B.1i.bH(u,w)}if(w===B.2G.6D||w===B.2G.7A){if(B.N.1R("4r")&&B.1i.2V&&B.1i.2V.1k==="4x"){u.21();F M}E o=B.K.5r();if(o){E t=o.R;E j;29(E r=0;r<t;r++){E h=c(o[r]).4F("1J");if(h.R!==0){E l=B;c.1m(h,C(x,i){E e=c(i);if(e.1y("6i")!="4S"){F}l.1O.28("b9",i.3Q,e);j=i})}L{if(o[r].1k=="7T"){if(j!=o[r]){B.1O.28("b9",o[r].3Q,c(o[r]));j=o[r]}}}}}}if(w===B.2G.6D){B.1i.bB();B.1i.bz(u)}B.1h.1B()},by:C(e,d){if(!e&&(B.1O.6b()=="1V"||B.1O.6b()=="85")){B.1O.7n(M);if(B.1i.bY(d)){B.1M.1G()}}},bY:C(e){E d=B.2G;E f=[d.6D,d.7A,d.5R,d.8c,d.at,d.bg,d.bT,d.bM,d.bR,d.bP];F(c.2K(e,f)==-1)?1j:M},bQ:C(d){if(!d){F}if((B.1O.6b()=="1V"||B.1O.6b()=="85")){B.1O.7n(M);F}B.1O.7n("85")},bC:C(f,d){if(B.1i.3n&&d===90&&!f.5C&&!f.bD&&B.G.1M.R){f.21();B.1M.7B();F}L{if(B.1i.3n&&d===90&&f.5C&&!f.bD&&B.G.6R.R!==0){f.21();B.1M.8S();F}L{if(!B.1i.3n){if(d==B.2G.6D||d==B.2G.7A||(d==B.2G.5R&&!f.7G&&!f.5C)||d==B.2G.8c){B.1M.1G()}}}}},c1:C(f,d){if(B.1i.3n&&d===65){B.N.fZ()}L{if(d!=B.2G.c0&&!B.1i.3n){B.N.76()}}},bJ:C(){E d=[B.1i.1L,B.1i.2n,B.1i.5W];29(E e=0;e<d.R;e++){if(d[e]){B.1i.bG(d[e]);F M}}},bv:C(d){B.1M.1G();if(B.N.5y()){F B.1i.6T(d)}F B.1i.5O(d)},bH:C(g,d){if(!B.G.c3){F 1j}if(B.N.3C(B.1h.Y())&&B.G.9t===M){F 1j}g.21();E f;if(B.1i.2n&&!g.5C){f=(B.G.5o)?14.9g(7K(B.G.5o+1).2t("\\9m")):14.9g("\\t");B.1H.41(f);B.1h.1B()}L{if(B.G.9t!==M){f=14.9g(7K(B.G.9t+1).2t("\\9m"));B.1H.41(f);B.1h.1B()}L{if(g.5H&&d===aG){B.2T.92()}L{if(g.5H&&d===aE){B.2T.8Y()}L{if(!g.5C){B.2T.8Y()}L{B.2T.92()}}}}}F M},bL:C(){E f=B.K.3B();E e=f.2X.J(/<br\\s?\\/?>/gi,"");if((f.1k==="6v"||f.1k==="P")&&e===""&&!c(f).2U("I-O")){E d=14.3c("br");c(f).22(d);B.1I.9G(d);B.1h.1B();F M}},bK:C(){E e=B.K.3B();E d=e.2X.J(/<br\\s?\\/?>/gi,"");if(e.1k==="6v"&&d===""&&!c(e).2U("I-O")){E f=14.3c("p");f.2X=B.G.5l;c(e).22(f);B.1I.2I(f);B.1h.1B();F M}L{if(B.G.bO&&e.1k=="P"){c(e).1w("1v").1w("1e")}}},bN:C(f){f.21();B.K.Y();E d=14.3c("p");d.2X=B.G.5l;B.1t.4L();B.1t.3u(d);B.1I.2I(d);B.1h.1B();F M},bE:C(h){if(!B.N.5y()){F}E f=c.2J(c(B.1i.U).1b());if(f.2Z(/(<br\\s?\\/?>){2}$/i)!=-1){h.21();if(B.G.1A){E d=14.3c("br");c(B.1i.1L).2N(d);B.1I.9G(d);c(B.1i.U).1b(f.J(/<br\\s?\\/?>$/i,""))}L{E g=c(B.G.5s);c(B.1i.1L).2N(g);B.1I.2I(g)}F 1j}F},bG:C(e){if(!B.N.5y()){F}B.1M.1G();if(B.G.1A){E h=c("<1q>").1r(c.2J(B.$O.1b())).1S();E g=h.4T()[0];if(g.1k=="5J"&&g.2X===""){g=h.86()[0]}if(B.N.5j(g)!=B.N.5j(e)){F}E d=14.3c("br");c(e).2N(d);B.1I.4o(d)}L{if(B.$O.1S().4T()[0]!==e){F}E f=c(B.G.5s);c(e).2N(f);B.1I.2I(f)}},bI:C(f){f.21();E d=14.9g("\\n");B.K.Y();B.1t.4L();B.1t.3u(d);B.1I.4o(d);B.1h.1B();F M},5O:C(d){F B.1i.aY(d)},6T:C(d){F B.1i.aY(d,1j)},aY:C(j,i){j.bX();B.K.Y();E h=14.3c("br");if(B.N.1R("2e")){B.1t.3Z(M);B.1t.3k(B.1t.b3,B.1t.aV)}L{B.1t.4L()}B.1t.3u(h);E g=c(h).2P("a");if(g.R>0){g.12(h).1o();g.2N(h)}if(i===1j){E d=c(h).3R();if(d.R!==0&&d[0].1k==="4N"&&B.N.aJ()){B.1I.4o(h);B.1h.1B();F M}E f=14.3c("br");B.1t.3u(f);B.1I.4o(f)}L{B.1i.bA(h)}B.1h.1B();F M},bA:C(d){E e=B.N.6Z();c(d).2N(e);B.K.6s(e);c(e).22(C(){F c(B).1S()})},bB:C(){E d=c(B.1i.2V);if(d.1C().2Z(/^\\5S$/g)===0){d.1o()}},bz:C(g){E d=c(B.1i.2V);E f=c(B.1i.2P);E h=d.25("3r",B.$O[0]);if(h.R!==0&&d.25("li",B.$O[0])&&f.4F("li").R===1){if(!B.N.3C(d.1C())){F}g.21();d.1o();f.1o();B.1I.2I(h)}}}},1Z:C(){F{3b:C(h){if(B.6c){F}E d=h.7f;B.1Z.2V=B.K.30();B.1Z.2P=B.K.4R();E g=B.N.3T(c(B.1Z.2P).2P());E f=B.1O.28("1Z",h);if(f===M){h.21();F M}if(!B.G.1A&&B.1Z.2V.an==3&&B.1Z.2V.R<=1&&(B.1Z.2P===M||B.1Z.2P.1k=="aa")){B.1Z.8q()}if(!B.G.1A&&B.N.3T(B.1Z.2V)&&B.1Z.2V.1k==="6v"){B.1Z.8q(M)}if(!B.G.1A&&c(B.1Z.2P).2U("I-6N-5A")&&(g===M||g[0].1k=="aa")){c(B.1Z.2P).1S().3p();B.1Z.8q()}if(B.2F.88()&&B.2F.fV(d)){B.2F.2o()}if(d===B.2G.7A||d===B.2G.6D){B.1p.3M();if(B.2k.Q){h.21();B.Q.5F();B.1M.1G();B.Q.1o(B.2k.Q);B.2k.Q=M;F M}B.$O.12("p").1m(c.V(C(e,j){B.N.3t(e,c(j).1b())},B));if(B.G.1A&&B.1Z.2V&&B.1Z.2V.1k=="6v"&&B.N.3C(B.1Z.2V.2X)){c(B.1Z.2V).2N(B.K.4k());B.K.2w();c(B.1Z.2V).1o()}F B.1Z.bu(h)}},8q:C(g){E e=c(B.1Z.2V);E f;if(g===M){f=c("<p>").1r(e.1b())}L{f=c("<p>").1r(e.fK())}e.22(f);E d=c(f).3R();if(1l(d[0])!=="1s"&&d[0].1k=="4N"){d.1o()}B.1I.3k(f)},bu:C(f){E d=c.2J(B.$O.1b());if(!B.N.3C(d)){F}f.21();if(B.G.1A){B.$O.1b(B.K.4k());B.K.2w()}L{d="<p><br /></p>";B.$O.1b(d);B.2c.2I()}B.1h.1B();F M}}},1z:C(){F{2r:C(){B.G.bl=B.G.bx[B.G.1z]},Y:C(d){F(1l B.G.bl[d]!="1s")?B.G.bl[d]:""}}},3i:C(){F{1H:C(){B.1M.1G();E d=B.K.3E();if(d[0]!==M&&B.3i.bU(d)){if(!B.N.1R("2e")){B.$O.2c()}F}if(B.N.1R("2e")){B.3i.8J()}L{B.3i.bS()}},bU:C(h){E i=["li","3r","5g","1L","5W","2n","dl","dt","dd"];E g=h[0].1k.2u();E f=B.K.gZ();f=(1l f=="1s")?g:f.1k.2u();E e=c.2K(g,i)!=-1;E d=c.2K(f,i)!=-1;if((e&&d)||e){F 1j}},8J:C(){B.N.7s();B.1M.1G();B.1H.41(14.3c("hr"));B.N.81();B.1h.1B()},bS:C(){B.1M.1G();E d=\'<p id="I-1H-3i"><br /></p>\';if(B.G.1A){d=\'<br id="I-1H-3i">\'}14.3m("eb",M,"<hr>"+d);B.3i.g9();B.1h.1B()},g9:C(){E e=B.$O.12("#I-1H-3i");E d=c(e).3R()[0];if(d){B.1I.4o(e);e.1o()}L{e.1w("id")}}}},1d:C(){F{2i:C(d){if(1l d!="1s"&&d.21){d.21()}B.T.2r("1d",B.1z.Y("bj"),jg);B.T.9V();B.1d.gx=B.T.b2(B.1z.Y("1H"));B.K.Y();B.1d.gK();B.1d.gw();if(B.1d.2m=="6d"){c("#I-1d-6I").4Z("8m",1j)}B.1d.$7I=c("#I-1d-2b");B.1d.$9P=c("#I-1d-2b-1C");B.1d.$9P.2H(B.1d.1C);B.1d.$7I.2H(B.1d.2b);B.1d.gx.1x("1V",c.V(B.1d.1H,B));c(".I-1d-3S").1o();B.K.2C();B.T.2i();B.1d.$7I.2c()},gw:C(){E e=gD.gP.2B.J(/\\/$/i,"");if(1l B.1d.2b!=="1s"){B.1d.2b=B.1d.2b.J(e,"");B.1d.2b=B.1d.2b.J(/^\\/#/,"#");B.1d.2b=B.1d.2b.J("al:","");if(!B.G.5L){E d=1P 1U("^(7v|7j|4Q)://"+gD.gP.jR,"i");B.1d.2b=B.1d.2b.J(d,"")}}},gK:C(){B.1d.$41=M;E d=c(B.K.30()).25("a",B.$O[0]);if(d.R!==0&&d[0].1k==="A"){B.1d.$41=d;B.1d.2b=d.1a("2B");B.1d.1C=d.1C();B.1d.2m=d.1a("2m")}L{B.1d.1C=B.3h.3O();B.1d.2b="";B.1d.2m=""}},1H:C(){B.2y.1o();E i="";E g=B.1d.$7I.2H();E j=B.1d.$9P.2H();if(c.2J(g)===""){B.1d.$7I.1X("I-31-56").1x("1Z",C(){c(B).2j("I-31-56");c(B).2R("1Z")});F}if(g.2Z("@")!=-1&&/(7v|7j|4Q):\\/\\//i.7V(g)===M){g="al:"+g}L{if(g.2Z("#")!==0){if(c("#I-1d-6I").4Z("8m")){i="6d"}E h="((gG--)?[a-6G-9]+(-[a-6G-9]+)*\\\\.)+[a-z]{2,}";E f=1P 1U("^(7v|7j|4Q)://"+h,"i");E e=1P 1U("^"+h,"i");E d=1P 1U(".(1b|jJ)$","i");if(g.2Z(f)==-1&&g.2Z(d)==-1&&g.2Z(e)===0&&B.G.5L){g=B.G.5L+"://"+g}}}B.1d.1G(j,g,i);B.T.3A()},1G:C(i,f,h){i=c.2J(i.J(/<|>/g,""));B.K.2w();if(i===""&&f===""){F}if(i===""&&f!==""){i=f}if(B.1d.$41){B.1M.1G();E d=B.1d.$41,e=d.4F();if(e.R>0){4h(e.R){e=e.4F()}e=e.fp()}L{e=d}d.1a("2B",f);e.1C(i);if(h!==""){d.1a("2m",h)}L{d.1w("2m")}B.K.6s(d);B.1h.1B()}L{if(B.N.1R("4r")&&B.1d.1C===""){E g=c("<a />").1a("2B",f).1C(i);if(h!==""){g.1a("2m",h)}B.1H.41(g);B.K.6s(g)}L{E g;if(B.N.1R("2e")){g=c(\'<a 2B="\'+f+\'">\').1C(i);if(h!==""){g.1a("2m",h)}g=c(B.1H.41(g));if(B.K.ab().1T(/\\s$/)){g.2N(" ")}B.K.6s(g)}L{14.3m("jK",M,f);g=c(B.K.30()).25("a",B.$O[0]);if(B.N.1R("4r")){g=c(\'a[gH=""]\')}if(h!==""){g.1a("2m",h)}g.1w("1e").1w("gH");if(B.K.ab().1T(/\\s$/)){g.2N(" ")}if(B.1d.1C!==""||B.1d.1C!=i){g.1C(i);B.K.6s(g)}}}B.1h.1B();B.1O.28("k1",g)}2Q(c.V(C(){B.2k.aF()},B),5)},5G:C(j){if(1l j!="1s"&&j.21){j.21()}E g=B.K.5r();if(!g){F}B.1M.1G();E d=g.R;29(E h=0;h<d;h++){E f=c(g[h]).25("a",B.$O[0]);f.22(f.1S())}c(".I-1d-3S").1o();B.1h.1B()},6B:C(d){B.1d.7S(d,"6B")},1X:C(d){B.1d.7S(d,"1X")},2j:C(d){B.1d.7S(d,"2j")},7S:C(e,f){E d=B.K.h7(["a"]);if(d===M){F}c.1m(d,C(){c(B)[f](e)})}}},3q:C(){F{2A:C(i){B.2y.1o();if(!B.N.1R("2e")){B.$O.2c()}B.1M.1G();B.K.2C();E h=B.K.4R();E g=c(h).25("2O, 2L",B.$O[0]);if(!B.N.3T(g)&&g.R!==0){g=M}E j,f;E d=M;if(g&&g.R){d=1j;E e=g[0].1k;j=(i==="4D"&&e==="7H");f=(i==="4Y"&&e==="6U")}if(j){B.N.4a(g,"2O")}L{if(f){B.N.4a(g,"2L")}L{if(d){B.3q.1o(i)}L{B.3q.1H(i)}}}B.K.2w();B.1h.1B()},1H:C(e){E k=B.K.4R();E j=B.K.30();E d=c(j).25("3r, 5g",B.$O[0]);if(B.N.1R("2e")&&B.G.1A){B.3q.8J(e)}L{14.3m("1H"+e)}E h=c(B.K.4R()).25("2O, 2L",B.$O[0]);if(d.R!==0){E f=d.86();E g=d.1b();d.1b("");if(f&&f.R===1&&(f[0].1k==="4x"||f[0].1k==="8s")){c(f).2N(d)}L{c(k).4b(d)}d.1b(g)}if(B.N.3C(h.12("li").1C())){E l=h.4F("li");l.12("br").1o();l.1r(B.K.4k())}if(h.R){E i=h.2P();if(B.N.3T(i)&&i[0].1k!="4j"&&B.N.5D(i[0])){i.22(i.1S())}}if(!B.N.1R("2e")){B.$O.2c()}B.1p.3M()},8J:C(j){E k=B.K.4W("1q");E h=c(k).1b();E g=(j=="4D")?c("<2O>"):c("<2L>");E d=c("<li>");if(c.2J(h)===""){d.1r(B.K.4k());g.1r(d);B.$O.12("#K-2f-1").22(g)}L{E e=h.3J(/<br\\s?\\/?>/gi);if(e){29(E f=0;f<e.R;f++){if(c.2J(e[f])!==""){g.1r(c("<li>").1b(e[f]))}}}L{d.1r(h);g.1r(d)}c(k).22(g)}},1o:C(g){14.3m("1H"+g);E f=c(B.K.30());B.2T.87();if(!B.G.1A&&f.25("li, 5g, 3r",B.$O[0]).R===0){14.3m("8C",M,"p");B.$O.12("2L, 2O, 1L").1m(c.V(B.N.3t,B))}E e=c(B.K.30()).25("4t",B.$O[0]);E d=e.86();if(!B.G.1A&&e.R!==0&&d.R!==0&&d[0].1k=="4N"){d.1o()}B.1p.3M()}}},T:C(){F{8R:{},gN:C(){B.G.T={gM:5d()+\'<3o id="I-T-Q-78"><3y>\'+B.1z.Y("1Q")+\'</3y><31 1F="1C" id="I-Q-1Q" /><3y 1v="I-Q-1d-3j">\'+B.1z.Y("1d")+\'</3y><31 1F="1C" id="I-Q-1d" 1v="I-Q-1d-3j" /><3y 1v="I-Q-1d-3j"><31 1F="gu" id="I-Q-1d-6I"> \'+B.1z.Y("aS")+\'</3y><3y 1v="I-Q-4q-3j">\'+B.1z.Y("gE")+\'</3y><6f 1v="I-Q-4q-3j" id="I-Q-5a"><3j 23="4S">\'+B.1z.Y("4S")+\'</3j><3j 23="2a">\'+B.1z.Y("2a")+\'</3j><3j 23="4K">\'+B.1z.Y("4K")+\'</3j><3j 23="3I">\'+B.1z.Y("3I")+"</3j></6f></3o>",Q:5d()+\'<3o id="I-T-Q-1H"><1q id="I-T-Q-3v"></1q></3o>\',2x:5d()+\'<3o id="I-T-2x-1H"><1q id="I-T-2x-1f-2g"><3y>\'+B.1z.Y("5P")+\'</3y><31 1F="1C" id="I-5P" /><br><br><1q id="I-T-2x-1f"></1q></1q></3o>\',1d:5d()+\'<3o id="I-T-1d-1H"><3y>gv</3y><31 1F="2b" id="I-1d-2b" /><3y>\'+B.1z.Y("1C")+\'</3y><31 1F="1C" id="I-1d-2b-1C" /><3y><31 1F="gu" id="I-1d-6I"> \'+B.1z.Y("aS")+"</3y></3o>"};c.6n(B.G,B.G.T)},aQ:C(d,e){B.T.8R[d]=e},jm:C(d){B.T.$7R=c("<1q>").1a("id","I-T-7R");d.4b(B.T.$7R)},ju:C(h,e,g){E f=c(\'<a 2B="#" 3g="6W\'+h+\'">\').1C(e);if(g){f.1X("b1")}E d=B;f.1x("1V",C(i){i.21();c(".I-6W").2z();c(".I-"+c(B).1a("3g")).2i();d.T.$7R.12("a").2j("b1");c(B).1X("b1")});B.T.$7R.1r(f)},jv:C(d,e){B.G.T[d]=e},gy:C(d){F B.G.T[d]},jF:C(){F B.$9d.12("3o")},2r:C(d,f,e){B.T.8M=d;B.T.2M=e;B.T.1W();B.T.gW();B.T.gR(f);B.T.hb();B.T.gA();if(1l B.T.8R[d]!="1s"){B.T.8R[d].5k(B)}},2i:C(){if(B.N.4H()&&!B.N.1R("2e")){14.ha.9k()}c(14.2D).2j("2D-I-6q");B.T.hc=c(14.2D).1y("9c");c(14.2D).1y("9c","6q");if(B.N.4H()){B.T.bk()}L{B.T.9B()}B.$5Y.2i();B.$47.2i();B.T.gS();B.N.7s();if(!B.N.4H()){2Q(c.V(B.T.9B,B),0);c(3e).1x("3P.I-T",c.V(B.T.3P,B))}B.1O.28("hm",B.T.8M,B.$T);c(14).2R("hg.T");B.$T.12("31[1F=1C],31[1F=2b],31[1F=hG]").1x("1i.I-T",c.V(B.T.h8,B))},9B:C(){E d=B.$T.hz();E f=c(3e).4n();E e=c(3e).2M();if(B.T.2M>e){B.$T.1y({2M:"96%",52:(f/2-d/2)+"2W"});F}if(d>f){B.$T.1y({2M:B.T.2M+"2W",52:"ht"})}L{B.$T.1y({2M:B.T.2M+"2W",52:(f/2-d/2)+"2W"})}},bk:C(){B.$T.1y({2M:"96%",52:"2%"})},3P:C(){if(B.N.4H()){B.T.bk()}L{B.T.9B()}},gR:C(d){B.$6Y.1b(d)},gA:C(){B.$9d.1b(B.T.gy(B.T.8M))},hb:C(){if(1l c.fn.gV==="1s"){F}B.$T.gV({h0:B.$6Y});B.$6Y.1y("jE","kC")},h8:C(d){if(d.7f!=13){F}d.21();B.$T.12("1D.I-T-6g-44").1V()},9V:C(){E d=c("<1D>").1X("I-T-44 I-T-3A-44").1b(B.1z.Y("gY"));d.1x("1V",c.V(B.T.3A,B));B.$6V.1r(d)},gT:C(d){F B.T.a7(d,"6z")},b2:C(d){F B.T.a7(d,"6g")},a7:C(d,f){E e=c("<1D>").1X("I-T-44").1X("I-T-"+f+"-44").1b(d);B.$6V.1r(e);F e},gS:C(){E d=B.$6V.12("1D");E e=d.R;if(e===0){F}d.1y("2M",(7i/e)+"%")},1W:C(){B.T.gU();B.$47=c(\'<1q id="I-T-2g" />\').2z();B.$T=c(\'<1q id="I-T" />\');B.$6Y=c("<9n />");B.$71=c(\'<1c id="I-T-3A" />\').1b("&m8;");B.$9d=c(\'<1q id="I-T-2D" />\');B.$6V=c("<ar />");B.$T.1r(B.$6Y);B.$T.1r(B.$71);B.$T.1r(B.$9d);B.$T.1r(B.$6V);B.$47.1r(B.$T);B.$47.9e(14.2D)},gU:C(){B.$5Y=c(\'<1q id="I-T-m3">\').2z();c("2D").4b(B.$5Y)},gW:C(){B.$71.1x("1V.I-T",c.V(B.T.3A,B));c(14).1x("1Z.I-T",c.V(B.T.9M,B));B.$O.1x("1Z.I-T",c.V(B.T.9M,B));B.$47.1x("1V.I-T",c.V(B.T.3A,B))},h9:C(){B.$71.2R("1V.I-T");c(14).2R("1Z.I-T");B.$O.2R("1Z.I-T");B.$47.2R("1V.I-T");c(3e).2R("3P.I-T")},9M:C(d){if(d.7f!=B.2G.at){F}B.T.3A(M)},3A:C(d){if(d){if(!c(d.2m).2U("I-T-3A-44")&&d.2m!=B.$71[0]&&d.2m!=B.$47[0]){F}d.21()}if(!B.$47){F}B.T.h9();B.$5Y.1o();B.$47.gX("m5",c.V(C(){B.$47.1o();2Q(c.V(B.N.81,B),0);if(d!==1s){B.K.2w()}c(14.2D).1y("9c",B.T.hc);B.1O.28("mk",B.T.8M)},B))}}},2k:C(){F{2r:C(){if(1l B.G.gQ!="1s"){F}B.2k.7Z();B.2k.aF()},3Y:C(h,j){E g=B.K.30();E d=B.K.4R();if(h!==M){B.1D.aP()}L{B.1D.aP(j)}if(h===M&&j!=="1b"){if(c.2K(j,B.G.9u)!=-1){B.1D.mj(j)}F}c.1m(B.G.aB,c.V(C(e,m){E k=c(d).25(e,B.$O[0]);E l=c(g).25(e,B.$O[0]);if(k.R!==0&&!B.N.3T(k)){F}if(!B.N.3T(l)){F}if(k.R!==0||l.25(e,B.$O[0]).R!==0){B.1D.7M(m)}},B));E f=c(d).25(B.G.7r.3O().2u(),B.$O[0]);if(B.N.3T(d)&&f.R){E i=(f.1y("1C-5a")==="")?"2a":f.1y("1C-5a");B.1D.7M("5a"+i)}},mh:C(d,e){B.G.9u.2q(e);B.G.aB[d]=e},7Z:C(){B.$O.12("1J").1m(c.V(C(f,d){E e=c(d);e.25("a",B.$O[0]).1x("1V",C(g){g.21()});if(B.N.1R("2e")){e.1a("mi","1x")}B.Q.gC(e)},B));c(14).1x("1V.I-Q-6z."+B.2h,c.V(C(d){B.2k.Q=M;if(d.2m.1k=="7T"&&B.N.3T(d.2m)){B.2k.Q=(B.2k.Q&&B.2k.Q==d.2m)?M:d.2m}},B))},aF:C(){if(!B.G.eQ){F}B.$O.12("a").1x("5f.I."+B.2h+" 1V.I."+B.2h,c.V(B.2k.gq,B));B.$O.1x("5f.I."+B.2h+" 1V.I."+B.2h,c.V(B.2k.bc,B));c(14).1x("5f.I."+B.2h+" 1V.I."+B.2h,c.V(B.2k.bc,B))},gs:C(d){F d.4p()},gq:C(f){E m=c(f.2m);if(m[0].1k=="7T"){F}if(m[0].1k!=="A"){m=m.25("a",B.$O[0])}if(m[0].1k!=="A"){F}E g=m;E i=B.2k.gs(g);E l=c(\'<1c 1v="I-1d-3S"></1c>\');E d=g.1a("2B");if(d===1s){d=""}if(d.R>24){d=d.80(0,24)+"..."}E h=c(\'<a 2B="\'+g.1a("2B")+\'" 2m="6d" />\').1b(d).1X("I-1d-3S-6g");E j=c(\'<a 2B="#" />\').1b(B.1z.Y("78")).1x("1V",c.V(B.1d.2i,B)).1X("I-1d-3S-6g");E k=c(\'<a 2B="#" />\').1b(B.1z.Y("5G")).1x("1V",c.V(B.1d.5G,B)).1X("I-1d-3S-6g");l.1r(h).1r(" | ").1r(j).1r(" | ").1r(k);l.1y({3s:(i.3s+4C(g.1y("3i-4n"),10))+"2W",2a:i.2a+"2W"});c(".I-1d-3S").1o();c("2D").1r(l)},bc:C(g){g=g.62||g;E f=g.2m;E d=c(f).25("a",B.$O[0]);if(d.R!==0&&d[0].1k==="A"&&f.1k!=="A"){F}L{if((f.1k==="A"&&B.N.3T(f))||c(f).2U("I-1d-3S-6g")){F}}c(".I-1d-3S").1o()}}},2v:C(){F{2r:C(d){if(B.G.1A){F d}if(d===""||d==="<p></p>"){F B.G.5s}d=d+"\\n";B.2v.8u=[];B.2v.z=0;d=d.J(/(<br\\s?\\/?>){1,}\\n?<\\/1L>/gi,"</1L>");d=B.2v.gO(d);d=B.2v.gL(d);d=B.2v.gr(d);d=B.2v.gF(d);d=B.2v.7g(d);d=B.2v.gJ(d);d=d.J(1P 1U("<br\\\\s?/?>\\n?<("+B.G.bb.2t("|")+")(.*?[^>])>","gi"),"<p><br /></p>\\n<$1$2>");F c.2J(d)},gO:C(e){E d=c("<1q />").1r(e);d.12("1L p").22(C(){F c(B).1r("<br />").1S()});e=d.1b();d.12(B.G.bb.2t(", ")).1m(c.V(C(f,g){B.2v.z++;B.2v.8u[B.2v.z]=g.6h;e=e.J(g.6h,"\\n{J"+B.2v.z+"}")},B));F e},gL:C(e){E d=e.1T(/<!--([\\w\\W]*?)-->/gi);if(!d){F e}c.1m(d,c.V(C(f,g){B.2v.z++;B.2v.8u[B.2v.z]=g;e=e.J(g,"\\n{J"+B.2v.z+"}")},B));F e},gJ:C(d){c.1m(B.2v.8u,C(e,f){f=(1l f!=="1s")?f.J(/\\$/g,"&#36;"):f;d=d.J("{J"+e+"}",f)});F d},gF:C(f){E g=f.3J(1P 1U("\\n","g"),-1);f="";if(g){E d=g.R;29(E e=0;e<d;e++){if(!g.mX(e)){F}if(g[e].2Z("{J")==-1){g[e]=g[e].J(/<p>\\n\\t?<\\/p>/gi,"");g[e]=g[e].J(/<p><\\/p>/gi,"");if(g[e]!==""){f+="<p>"+g[e].J(/^\\n+|\\n+$/g,"")+"</p>"}}L{f+=g[e]}}}F f},gr:C(d){d=d.J(/<br \\/>\\s*<br \\/>/gi,"\\n\\n");d=d.J(/<br\\s?\\/?>\\n?<br\\s?\\/?>/gi,"\\n<br /><br />");d=d.J(1P 1U("\\r\\n","g"),"\\n");d=d.J(1P 1U("\\r","g"),"\\n");d=d.J(1P 1U("/\\n\\n+/"),"g","\\n\\n");F d},7g:C(d){d=d.J(1P 1U("</1L></p>","gi"),"</1L>");d=d.J(1P 1U("<p></1L>","gi"),"</1L>");d=d.J(1P 1U("<p><1L>","gi"),"<1L>");d=d.J(1P 1U("<1L></p>","gi"),"<1L>");d=d.J(1P 1U("<p><p ","gi"),"<p ");d=d.J(1P 1U("<p><p>","gi"),"<p>");d=d.J(1P 1U("</p></p>","gi"),"</p>");d=d.J(1P 1U("<p>\\\\s?</p>","gi"),"");d=d.J(1P 1U("\\n</p>","gi"),"</p>");d=d.J(1P 1U("<p>\\t?\\t?\\n?<p>","gi"),"<p>");d=d.J(1P 1U("<p>\\t*</p>","gi"),"");F d}}},4E:C(){F{3b:C(d){if(!B.G.gz){2Q(c.V(B.1h.1B,B),1);F}B.6c=1j;B.1M.1G();B.K.2C();B.N.7s();B.4E.gB();c(3e).1x("6k.I-gI",c.V(C(){c(3e).4d(B.8O)},B));2Q(c.V(C(){E e=B.$4y.1b();B.$4y.1o();B.K.2w();B.N.81();B.4E.1H(e);c(3e).2R("6k.I-gI");if(B.2F.88()){B.2F.2o()}},B),1)},gB:C(){B.$4y=c("<1q>").1b("").1a("6r","1j").1y({4q:"6p",2M:0,3s:0,2a:"-l2"});if(B.N.1R("2e")){B.$2g.1r(B.$4y)}L{c("2D").1r(B.$4y)}B.$4y.2c()},1H:C(d){d=B.1O.28("l3",d);d=(B.N.7a())?B.1p.6M(d,M):B.1p.6M(d);d=B.1O.28("4E",d);if(B.N.7a()){B.1H.1G(d,M)}L{B.1H.1b(d,M)}B.N.76();B.6c=M;2Q(c.V(B.1p.3M,B),10);2Q(c.V(C(){E e=B.$O.12("1c");c.1m(e,C(g,h){E f=h.2X.J(/[\\5S-\\6w\\6x]/,"");if(f===""&&h.3W.R===0){c(h).1o()}})},B),10)}}},2y:C(){F{8t:C(){if(!B.2y.is()){F}B.$O.1a("2y",B.$3a.1a("2y"));B.2y.2A();B.$O.1x("1i.I-2y",c.V(B.2y.2A,B))},2A:C(){2Q(c.V(C(){E d=B.N.3C(B.$O.1b(),M)?"1X":"2j";B.$O[d]("I-2y")},B),5)},1o:C(){B.$O.2j("I-2y")},is:C(){if(B.G.2y){F B.$3a.1a("2y",B.G.2y)}L{F!(1l B.$3a.1a("2y")=="1s"||B.$3a.1a("2y")==="")}}}},4B:C(){F{2i:C(){c(14.2D).1r(c(\'<1q id="I-4B"><1c></1c></1q>\'));c("#I-4B").ld()},2z:C(){c("#I-4B").gX(l4,C(){c(B).1o()})}}},K:C(){F{Y:C(){B.3h=14.51();if(14.51&&B.3h.5N&&B.3h.7u){B.1t=B.3h.5N(0)}L{B.1t=14.ak()}},4i:C(){49{B.3h.9X()}42(d){}B.3h.4i(B.1t)},30:C(){E d=M;B.K.Y();if(B.3h&&B.3h.7u>0){d=B.3h.5N(0).fu}F B.N.3T(d)},4R:C(d){d=d||B.K.30();if(d){F B.N.3T(c(d).2P()[0])}F M},3B:C(d){d=d||B.K.30();4h(d){if(B.N.6y(d.1k)){F(c(d).2U("I-O"))?M:d}d=d.a8}F M},a5:C(e,f){B.K.Y();if(B.1t&&B.1t.4s){F M}E d=[];e=(1l e=="1s"||e===M)?B.K.5r():e;E h=B.G.5c;h.2q("1c");if(1l f!=="1s"){29(E g=0;g<f.R;g++){h.2q(f[g])}}c.1m(e,c.V(C(j,k){if(c.2K(k.1k.2u(),h)!=-1){d.2q(k)}},B));F(d.R===0)?M:d},h7:C(f){B.K.Y();if(B.1t&&B.1t.4s){F M}E e=[];E d=B.K.5r();c.1m(d,c.V(C(g,h){if(c.2K(h.1k.2u(),f)!=-1){e.2q(h)}},B));F(e.R===0)?M:e},3E:C(d){B.K.Y();if(B.1t&&B.1t.4s){F[B.K.3B()]}E e=[];d=(1l d=="1s")?B.K.5r():d;c.1m(d,c.V(C(f,g){if(B.N.5D(g)){B.K.go=g;e.2q(g)}},B));F(e.R===0)?[B.K.3B()]:e},gZ:C(){F B.K.go},5r:C(){B.K.Y();E f=B.K.a9(1);E l=B.K.a9(2);E k=B.1t.7x();if(B.1t.4s===M){E g=k.fu;E n=k.l5;B.K.8j(k,l,M);k.2I(g,n);B.K.8j(k,f,1j)}L{B.K.8j(k,f,1j);l=f}E e=[];E d=0;E o=B;B.$O.12("*").1m(C(){if(B==f){E i=c(B).2P();if(i.R!==0&&i[0].1k!="aa"&&o.N.3T(i[0])){e.2q(i[0])}e.2q(B);d=1}L{if(d>0){e.2q(B);d=d+1}}if(B==l){F M}});E h=[];E m=e.R;29(E j=0;j<m;j++){if(e[j].id!="68-2f-1"&&e[j].id!="68-2f-2"){h.2q(e[j])}}B.K.fv();F h},a9:C(d){F c(\'<1c id="68-2f-\'+d+\'" 1v="I-68-2f" 1g-2Y="I">\'+B.G.5l+"</1c>")[0]},8j:C(d,g,f){49{d.3Z(f);d.3u(g)}42(h){}},fv:C(){c(14).12("1c.I-68-2f").1o();B.$O.12("1c.I-68-2f").1o()},l8:C(e,d){B.1I.a3(e,d)},4W:C(d){B.K.Y();if(B.1t.4s){F M}E e=14.3c(d);e.6m(B.1t.l9());B.1t.3u(e);F e},6s:C(d){B.1I.1G(d,0,d,1)},8B:C(){B.K.Y();B.1t.8r(B.$O[0]);B.K.4i()},1o:C(){B.K.Y();B.3h.9X()},2C:C(){B.K.fw()},fw:C(){B.K.Y();E e=B.K.5u(1);B.K.9Z(B.1t,e,1j);if(B.1t.4s===M){E d=B.K.5u(2);B.K.9Z(B.1t,d,M)}B.ft=B.$O.1b()},5u:C(d){if(1l d=="1s"){d=1}F c(\'<1c id="K-2f-\'+d+\'" 1v="I-K-2f"  1g-2Y="I">\'+B.G.5l+"</1c>")[0]},4k:C(d){F B.N.5j(B.K.5u(d))},9Z:C(d,g,f){d=d.7x();49{d.3Z(f);d.3u(g)}42(h){B.2c.2I()}},2w:C(){E e=B.$O.12("1c#K-2f-1");E d=B.$O.12("1c#K-2f-2");if(e.R!==0&&d.R!==0){B.1I.1G(e,0,d,0)}L{if(e.R!==0){B.1I.1G(e,0,e,0)}L{B.$O.2c()}}B.K.7y();B.ft=M},7y:C(){B.$O.12("1c.I-K-2f").1m(C(d,e){E f=c(e).1C().J(/[\\5S-\\6w\\6x]/g,"");if(f===""){c(e).1o()}L{c(e).22(C(){F c(B).1S()})}})},ab:C(){B.K.Y();F B.3h.3O()},lc:C(){E g="";B.K.Y();if(B.3h.7u){E e=14.3c("1q");E d=B.3h.7u;29(E f=0;f<d;++f){e.6m(B.3h.5N(f).lb())}g=e.2X}F B.1p.8b(g)},fs:C(d){B.K.Y();B.1t.4L();E g=14.3c("1q");g.2X=d;E f=14.8a(),e;4h((e=g.89)){f.6m(e)}B.1t.3u(f)},la:C(d){d=B.K.4k(1)+d+B.K.4k(2);B.K.Y();if(3e.51&&3e.51().5N){B.K.fs(d)}L{if(14.K&&14.K.ak){B.1t.fo(d)}}B.K.2w();B.1h.1B()}}},4X:C(){F{3b:C(f,d){if(!B.G.4X){if((f.7G||f.5H)&&(d===66||d===73)){f.21()}F M}c.1m(B.G.4X,c.V(C(k,j){E h=k.3J(",");E e=h.R;29(E g=0;g<e;g++){if(1l h[g]==="5z"){B.4X.8e(f,c.2J(h[g]),c.V(C(){E i;if(j.1K.2Z(/\\./)!="-1"){i=j.1K.3J(".");if(1l B[i[0]]!="1s"){B[i[0]][i[1]].6S(B,j.53)}}L{B[j.1K].6S(B,j.53)}},B))}}},B))},8e:C(n,p,h){E k={8:"l1",9:"6W",10:"F",13:"F",16:"5Q",17:"3n",18:"6a",19:"lf",20:"lw",27:"lu",32:"5A",33:"lz",34:"lB",35:"fp",36:"lk",37:"2a",38:"lg",39:"3I",40:"lq",45:"1H",46:"3D",59:";",61:"=",96:"0",97:"1",98:"2",99:"3",7i:"4",ki:"5",km:"6",kn:"7",kr:"8",kq:"9",kp:"*",ko:"+",kh:"-",kg:".",k9:"/",k8:"f1",k6:"f2",kb:"f3",kd:"f4",kI:"f5",kG:"f6",kP:"f7",kN:"f8",kM:"f9",kE:"kx",kv:"ky",kz:"lE",kB:"lD",lR:"6k",mG:"-",mF:";",mE:"=",mL:",",mK:"-",mJ:".",mC:"/",mB:"`",aG:"[",mu:"\\\\",aE:"]",mt:"\'"};E d={"`":"~","1":"!","2":"@","3":"#","4":"$","5":"%","6":"^","7":"&","8":"*","9":"(","0":")","-":"mr","=":"+",";":": ","\'":\'"\',",":"<",".":">","/":"?","\\\\":"|"};p=p.2u().3J(" ");E o=k[n.2G],m=5d.mA(n.7f).2u(),f="",g={};c.1m(["6a","3n","4u","5Q"],C(e,i){if(n[i+"mx"]&&o!==i){f+=i+"+"}});if(o){g[f+o]=1j}if(m){g[f+m]=1j;g[f+d[m]]=1j;if(f==="5Q+"){g[d[m]]=1j}}29(E j=0,l=p.R;j<l;j++){if(g[p[j]]){n.21();F h.6S(B,fr)}}}}},2d:C(){F{Y:C(e){if(!B.G.2d){F e}E l=["fx","2D","au","hr","i?mQ","1d","4u","mO","1e","3l","4t","az","aM","aN"];E k=["li","dt","dt","h[1-6]","3j","3l"];E h=["p","1L","1q","dl","fy","5h","mY","fE","2O","2n","6f","3r","5g","5x","2L"];B.2d.fF=1P 1U("^<(/?"+l.2t("|/?")+"|"+k.2t("|")+")[ >]");B.2d.fG=1P 1U("^<(br|/?"+l.2t("|/?")+"|/"+k.2t("|/")+")[ >]");B.2d.af=1P 1U("^</?("+h.2t("|")+")[ >]");E j=0,n=e.R,m=0,d=3x,f=3x,q="",g="",p="";B.2d.7N=0;29(;j<n;j++){m=j;if(-1==e.3K(j).3X("<")){g+=e.3K(j);F B.2d.aO(g)}4h(m<n&&e.5i(m)!="<"){m++}if(j!=m){p=e.3K(j,m-j);if(!p.1T(/^\\s{2,}$/g)){if("\\n"==g.5i(g.R-1)){g+=B.2d.6j()}L{if("\\n"==p.5i(0)){g+="\\n"+B.2d.6j();p=p.J(/^\\s+/,"")}}g+=p}if(p.1T(/\\n/)){g+="\\n"+B.2d.6j()}}d=m;4h(m<n&&">"!=e.5i(m)){m++}q=e.3K(d,m-d);j=m;E o;if("!--"==q.3K(1,3)){if(!q.1T(/--$/)){4h("-->"!=e.3K(m,3)){m++}m+=2;q=e.3K(d,m-d);j=m}if("\\n"!=g.5i(g.R-1)){g+="\\n"}g+=B.2d.6j();g+=q+">\\n"}L{if("!"==q[1]){g=B.2d.7U(q+">",g)}L{if("?"==q[1]){g+=q+">\\n"}L{if(o=q.1T(/^<(3l|1e|2n)/i)){o[1]=o[1].2u();q=B.2d.aR(q);g=B.2d.7U(q,g);f=5d(e.3K(j+1)).2u().3X("</"+o[1]);if(f){p=e.3K(j+1,f);j+=f;g+=p}}L{q=B.2d.aR(q);g=B.2d.7U(q,g)}}}}}F B.2d.aO(g)},6j:C(){E e="";29(E d=0;d<B.2d.7N;d++){e+="\\t"}F e},aO:C(d){d=d.J(/\\n\\s*\\n/g,"\\n");d=d.J(/^[\\s\\n]*/,"");d=d.J(/[\\s\\n]*$/,"");d=d.J(/<3l(.*?)>\\n<\\/3l>/gi,"<3l$1><\\/3l>");B.2d.7N=0;F d},aR:C(e){E g="";e=e.J(/\\n/g," ");e=e.J(/\\s{2,}/g," ");e=e.J(/^\\s+|\\s+$/g," ");E f="";if(e.1T(/\\/$/)){f="/";e=e.J(/\\/+$/,"")}E d;4h(d=/\\s*([^= ]+)(?:=(([\'"\']).*?\\3|[^ ]+))?/.4m(e)){if(d[2]){g+=d[1].2u()+"="+d[2]}L{if(d[1]){g+=d[1].2u()}}g+=" ";e=e.3K(d[0].R)}F g.J(/\\s*$/,"")+f+">"},7U:C(d,f){E e=d.1T(B.2d.af);if(d.1T(B.2d.fF)||e){f=f.J(/\\s*$/,"");f+="\\n"}if(e&&"/"==d.5i(1)){B.2d.7N--}if("\\n"==f.5i(f.R-1)){f+=B.2d.6j()}if(e&&"/"!=d.5i(1)){B.2d.7N++}f+=d;if(d.1T(B.2d.fG)||d.1T(B.2d.af)){f=f.J(/ *$/,"")}F f}}},1u:C(){F{fD:C(){if(B.G.3N){B.G.3w=M}if(B.G.4c){B.G.1w=M}if(B.G.1A){F}E d=["p","3o"];if(B.G.3N){B.1u.fC(d)}if(B.G.3w){B.1u.fz(d)}},fC:C(e){E d=e.R;29(E f=0;f<d;f++){if(c.2K(e[f],B.G.3N)==-1){B.G.3N.2q(e[f])}}},fz:C(e){E d=e.R;29(E f=0;f<d;f++){E g=c.2K(e[f],B.G.3w);if(g!=-1){B.G.3w.9f(g,1)}}},2r:C(e,d){B.1u.26={3w:B.G.3w,3N:B.G.3N,5T:B.G.5T,4w:B.G.4w,4A:B.G.4A,4z:B.G.4z,1w:B.G.1w,4c:B.G.4c,5K:B.G.5K,3t:B.G.3t};c.6n(B.1u.26,d);e=B.1u.5T(e);B.1u.$1q=c("<1q />").1r(e);B.1u.4w();B.1u.4A();B.1u.fA();B.1u.1w();B.1u.3t();B.1u.fm();B.1u.4z();B.1u.5K();e=B.1u.$1q.1b();B.1u.$1q.1o();F e},5T:C(d){if(!B.1u.26.5T){F d}F d.J(/<!--[\\s\\S]*?-->/gi,"")},4w:C(g){if(!B.1u.26.4w){F g}E d=B.1u.26.4w.R;E h=[],e=[];29(E f=0;f<d;f++){e.2q(B.1u.26.4w[f][1]);h.2q(B.1u.26.4w[f][0])}c.1m(h,c.V(C(i,j){B.1u.$1q.12(j).22(C(){F c("<"+e[i]+" />",{1b:c(B).1b()})})},B))},4A:C(){if(!B.1u.26.4A){F}E d=B.1u.26.4A.R;B.1u.$1q.12("1c").1m(c.V(C(k,j){E g=c(j);E h=g.1a("1e");29(E f=0;f<d;f++){if(h&&h.1T(1P 1U("^"+B.1u.26.4A[f][0],"i"))){E e=B.1u.26.4A[f][1];g.22(C(){E i=14.3c(e);F c(i).1r(c(B).1S())})}}},B))},fA:C(){if(!B.1u.26.3w&&B.1u.26.3N){B.1u.$1q.12("*").57(B.1u.26.3N.2t(",")).1m(C(d,e){if(e.2X===""){c(e).1o()}L{c(e).1S().3p()}})}if(B.1u.26.3w){B.1u.$1q.12(B.1u.26.3w.2t(",")).1m(C(d,e){if(e.2X===""){c(e).1o()}L{c(e).1S().3p()}})}},1w:C(){E d;if(!B.1u.26.1w&&B.1u.26.4c){E h=[],f=[];d=B.1u.26.4c.R;29(E g=0;g<d;g++){h.2q(B.1u.26.4c[g][0]);f.2q(B.1u.26.4c[g][1])}B.1u.$1q.12("*").1m(c.V(C(m,k){E j=c(k);E l=c.2K(j[0].1k.2u(),h);E i=B.1u.fB(l,f,j);if(i){c.1m(i,C(o,n){j.1w(n)})}},B))}if(B.1u.26.1w){d=B.1u.26.1w.R;29(E g=0;g<d;g++){E e=B.1u.26.1w[g][1];if(c.8K(e)){e=e.2t(" ")}B.1u.$1q.12(B.1u.26.1w[g][0]).1w(e)}}},fB:C(g,f,e){E d=[];if(g==-1){c.1m(e[0].3W,C(h,j){d.2q(j.2l)})}L{if(f[g]=="*"){d=[]}L{c.1m(e[0].3W,C(h,j){if(c.8K(f[g])){if(c.2K(j.2l,f[g])==-1){d.2q(j.2l)}}L{if(f[g]!=j.2l){d.2q(j.2l)}}})}}F d},fl:C(d,e){e=1P 1U(e,"g");F d.1m(C(){E g=c(B);E f=B.3W.R-1;29(E h=f;h>=0;h--){E j=B.3W[h];if(j&&j.lI&&j.2l.2Z(e)>=0){g.1w(j.2l)}}})},3t:C(){if(!B.1u.26.3t){F}B.1u.$1q.12(B.1u.26.3t.2t(",")).1m(C(){E d=c(B);E e=d.1C();e=e.J(/[\\5S-\\6w\\6x]/g,"");e=e.J(/&4v;/gi,"");e=e.J(/\\s/g,"");if(e===""&&d.4F().R===0){d.1o()}})},fm:C(){B.1u.$1q.12("li p").1S().3p()},4z:C(){if(!B.1u.26.4z){F}E d=B.1u.26.4z;if(c.8K(B.1u.26.4z)){d=B.1u.26.4z.2t(",")}B.1u.fl(B.1u.$1q.12(d),"^(1g-)")},5K:C(){if(!B.1u.26.5K){F}B.1u.$1q.12(B.1u.26.5K.2t(",")).1m(C(){if(B.3W.R===0){c(B).1S().3p()}})}}},1n:C(){F{3b:C(){F{1b:{1Q:B.1z.Y("1b"),1K:"1h.2A"},2p:{1Q:B.1z.Y("2p"),1E:{p:{1Q:B.1z.Y("gp"),1K:"U.2o"},1L:{1Q:B.1z.Y("aC"),1K:"U.2o"},2n:{1Q:B.1z.Y("1h"),1K:"U.2o"},h1:{1Q:B.1z.Y("eX"),1K:"U.2o"},h2:{1Q:B.1z.Y("eY"),1K:"U.2o"},h3:{1Q:B.1z.Y("eZ"),1K:"U.2o"},h4:{1Q:B.1z.Y("eW"),1K:"U.2o"},h5:{1Q:B.1z.Y("eV"),1K:"U.2o"}}},3G:{1Q:B.1z.Y("3G"),1K:"1N.2o"},3z:{1Q:B.1z.Y("3z"),1K:"1N.2o"},58:{1Q:B.1z.Y("58"),1K:"1N.2o"},4P:{1Q:B.1z.Y("4P"),1K:"1N.2o"},4Y:{1Q:"&m1; "+B.1z.Y("4Y"),1K:"3q.2A"},4D:{1Q:"1. "+B.1z.Y("4D"),1K:"3q.2A"},6o:{1Q:"< "+B.1z.Y("6o"),1K:"2T.92"},2T:{1Q:"> "+B.1z.Y("2T"),1K:"2T.8Y"},Q:{1Q:B.1z.Y("Q"),1K:"Q.2i"},2x:{1Q:B.1z.Y("2x"),1K:"2x.2i"},1d:{1Q:B.1z.Y("1d"),1E:{1d:{1Q:B.1z.Y("bj"),1K:"1d.2i"},5G:{1Q:B.1z.Y("5G"),1K:"1d.5G"}}},2s:{1Q:B.1z.Y("2s"),1E:{2a:{1Q:B.1z.Y("eR"),1K:"2s.2a"},4K:{1Q:B.1z.Y("eS"),1K:"2s.4K"},3I:{1Q:B.1z.Y("eT"),1K:"2s.3I"},7c:{1Q:B.1z.Y("eU"),1K:"2s.7c"}}},9o:{1Q:B.1z.Y("9o"),1K:"3i.1H"}}},1W:C(){B.1n.fe();B.1n.ff();B.1n.fd();if(B.G.3Y.R===0){F}B.$1n=B.1n.fb();B.1n.fg();B.1n.1r();B.1n.fi();B.1n.fj();B.1n.fk();if(B.G.9u){B.$O.1x("f0.I 1Z.I 2c.I",c.V(B.2k.3Y,B))}},fb:C(){F c("<2L>").1X("I-1n").1a("id","I-1n-"+B.2h)},fi:C(){c.1m(B.G.1n.2p.1E,c.V(C(d,e){if(c.2K(d,B.G.2p)==-1){6z B.G.1n.2p.1E[d]}},B))},fj:C(){c.1m(B.G.3Y,c.V(C(e,f){if(!B.G.1n[f]){F}if(f==="2x"){if(B.G.6K===M){F}L{if(!B.G.6K&&B.G.6u===M){F}}}if(f==="Q"){if(B.G.6H===M){F}L{if(!B.G.6H&&B.G.6u===M){F}}}E d=B.G.1n[f];B.$1n.1r(c("<li>").1r(B.1D.1W(f,d)))},B))},1r:C(){if(B.G.9j){B.$1n.1X("I-1n-md");c(B.G.9j).1b(B.$1n)}L{B.$2g.4b(B.$1n)}},fk:C(){if(!B.N.6F()){F}if(B.G.9j){F}if(!B.G.fh){F}B.1n.ag();c(B.G.5w).1x("6k.I."+B.2h,c.V(B.1n.ag,B))},fg:C(){if(B.N.4H()&&B.G.fc){B.$1n.1X("I-1n-9c")}},fd:C(){if(B.G.3U){F}E d=B.G.3Y.3X("1b");if(d!==-1){B.G.3Y.9f(d,1)}},fe:C(){if(B.G.as.R===0){F}c.1m(B.G.as,c.V(C(e,f){E d=B.G.3Y.3X(f);B.G.3Y.9f(d,1)},B))},ff:C(){if(!B.N.4H()||B.G.ai.R===0){F}c.1m(B.G.ai,c.V(C(e,f){E d=B.G.3Y.3X(f);B.G.3Y.9f(d,1)},B))},ag:C(){E e=c(B.G.5w).4d();E d=1;if(B.G.5w===14){d=B.$2g.4p().3s}if(e>d){B.1n.fH(e,d)}L{B.1n.fI()}},fH:C(i,f){E h=B.G.6t+i-f;E g=0;E d=f+B.$2g.4n()-32;E e=B.$2g.7D();B.$1n.1X("1n-6p-2g");B.$1n.1y({4q:"7z",2M:e,3s:h+"2W",2a:g});if(i>d){c(".I-1E-"+B.2h+":aq").2z()}B.1n.gb();B.$1n.1y("ga",(i<d)?"aq":"6q")},fI:C(){B.$1n.1y({4q:"mb",2M:"8T",3s:0,2a:0,ga:"aq"});B.1n.gc();B.$1n.2j("1n-6p-2g")},gb:C(){E e=B.$1n.4U()+B.G.6t;E d="6p";if(B.G.5w!==14){e=(B.$1n.4U()+B.$1n.4p().3s)+B.G.6t;d="7z"}c(".I-1E-"+B.2h).1m(C(){c(B).1y({4q:d,3s:e+"2W"})})},gc:C(){E d=(B.$1n.4U()+B.$1n.4p().3s);c(".I-1E-"+B.2h).1m(C(){c(B).1y({4q:"7z",3s:d+"2W"})})}}},1f:C(){F{3b:C(f,d,e){B.1f.5M=M;B.1f.94=e;B.1f.2b=d;B.1f.$el=c(f);B.1f.$3v=c(\'<1q id="I-3v" />\');B.1f.$a1=c(\'<1q id="I-3v-2y" />\').1C(B.1z.Y("g8"));B.1f.$31=c(\'<31 1F="2x" 2l="2x" />\');B.1f.$a1.1r(B.1f.$31);B.1f.$3v.1r(B.1f.$a1);B.1f.$el.1r(B.1f.$3v);B.1f.$3v.2R("I.1f");B.1f.$31.2R("I.1f");B.1f.$3v.1x("hY.I.1f",c.V(B.1f.8Z,B));B.1f.$3v.1x("i1.I.1f",c.V(B.1f.gn,B));B.1f.$31.1x("g4.I.1f",c.V(C(g){g=g.62||g;B.1f.9s(B.1f.$31[0].9z[0],g)},B));B.1f.$3v.1x("4e.I.1f",c.V(C(g){g.21();B.1f.$3v.2j("6J-ap").1X("6J-4e");B.1f.9E(g)},B))},g5:C(d,f){B.1f.5M=1j;B.1f.9s(d,f)},9E:C(f){f=f.62||f;E d=f.9p.9z;B.1f.9s(d[0],f)},9s:C(f,h){if(B.G.6u){B.1f.a6(f);B.1f.gk(f);F}E g=!!3e.9D?1P 9D():3x;if(3e.9D){B.1f.a6(f);E d=(B.1f.1F=="Q")?B.G.g6:B.G.g7;g.1r(d,f)}B.4B.2i();B.1O.28("hR",h,g);B.1f.gl(g,h)},a6:C(d){B.1f.gd(d);if(B.1f.5M){B.1f.2b=(B.1f.1F=="Q")?B.G.6H:B.G.6K;B.1f.94=(B.1f.1F=="Q")?B.Q.1H:B.2x.1H}},gd:C(d){B.1f.1F="Q";if(B.G.ge.3X(d.1F)==-1){B.1f.1F="2x"}},5p:C(e,d){if(e===M||1l e!=="4G"){F d}c.1m(e,c.V(C(g,f){if(f!==3x&&f.3O().3X("#")===0){f=c(f).2H()}d.1r(g,f)},B));F d},gl:C(f,d){if(B.1f.1F=="Q"){f=B.1f.5p(B.G.hQ,f);f=B.1f.5p(B.1f.8V,f)}L{f=B.1f.5p(B.G.il,f);f=B.1f.5p(B.1f.9a,f)}E g=1P 9y();g.9v("ik",B.1f.2b);g.bm("X-i9-hi","9y");g.gg=c.V(C(){if(g.9F==4){E i=g.gh;i=i.J(/^\\[/,"");i=i.J(/\\]$/,"");E e;49{e=(1l i==="5z"?c.gm(i):i)}42(h){e={56:1j}}B.4B.2z();if(!B.1f.5M){B.1f.$3v.2j("6J-4e")}B.1f.94(e,B.1f.5M,d)}},B);g.b0(f)},8Z:C(d){d.21();B.1f.$3v.1X("6J-ap")},gn:C(d){d.21();B.1f.$3v.2j("6J-ap")},hv:C(){B.1f.8V={}},ho:C(d,e){B.1f.8V[d]=e},hl:C(d){6z B.1f.8V[d]},hf:C(){B.1f.9a={}},hC:C(d,e){B.1f.9a[d]=e},hw:C(d){6z B.1f.9a[d]},gk:C(d){B.1f.gj(d,c.V(C(e){B.1f.g2(d,e)},B))},gj:C(d,h){E f=1P 9y();E g="?";if(B.G.6u.2Z(/\\?/)!="-1"){g="&"}f.9v("he",B.G.6u+g+"2l="+d.2l+"&1F="+d.1F,1j);if(f.gf){f.gf("1C/i8; jz=x-jy-jB")}E e=B;f.gg=C(i){if(B.9F==4&&B.bh==8P){e.4B.2i();h(fX(B.gh))}L{if(B.9F==4&&B.bh!=8P){}}};f.b0()},fP:C(f,d){E e=1P 9y();if("jD"in e){e.9v(f,d,1j)}L{if(1l g3!="1s"){e=1P g3();e.9v(f,d)}L{e=3x}}F e},g2:C(e,d){E f=B.1f.fP("jl",d);if(!f){}L{f.jj=c.V(C(){if(f.bh==8P){B.4B.2z();E i=d.3J("?");if(!i[0]){F M}if(!B.1f.5M){B.1f.$3v.2j("6J-4e")}E h={79:i[0]};if(B.1f.1F=="2x"){E g=i[0].3J("/");h.5P=g[g.R-1]}B.1f.94(h,B.1f.5M,M)}L{}},B);f.jk=C(){};f.1f.jo=C(g){};f.bm("jp-jt",e.1F);f.bm("x-js-jr","jq-jG");f.b0(e)}}}},N:C(){F{4H:C(){F/(fQ|fR|fO|fN)/.7V(8G.8H)},6F:C(){F!/(fQ|fR|jH|fO|fN)/.7V(8G.8H)},jX:C(d){F fJ.4M.3O.5k(d)=="[4G 5d]"},3C:C(e,d){e=e.J(/[\\5S-\\6w\\6x]/g,"");e=e.J(/&4v;/gi,"");e=e.J(/<\\/?br\\s?\\/?>/g,"");e=e.J(/\\s/g,"");e=e.J(/^<p>[^\\W\\w\\D\\d]*?<\\/p>$/i,"");e=e.J(/<43(.*?[^>])>$/i,"43");e=e.J(/<3U(.*?[^>])>$/i,"3U");if(d!==M){e=e.J(/<[^\\/>][^>]*><\\/[^>]+>/gi,"");e=e.J(/<[^\\/>][^>]*><\\/[^>]+>/gi,"")}e=c.2J(e);F e===""},aT:C(d){if(1l(d)==="1s"){F 0}F 4C(d.J("2W",""),10)},jZ:C(f){if(1l f=="1s"){F}if(f.2Z(/^#/)==-1){F f}E e=/^#?([a-f\\d])([a-f\\d])([a-f\\d])$/i;f=f.J(e,C(i,k,j,h){F k+k+j+j+h+h});E d=/^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i.4m(f);F"k3("+4C(d[1],16)+", "+4C(d[2],16)+", "+4C(d[3],16)+")"},5j:C(d){F c("<1q>").1r(c(d).eq(0).fK()).1b()},7W:C(d){if(c.2K(d.1k,B.G.7r)!==-1){F c(d)}L{F c(d).25(B.G.7r.3O().2u(),B.$O[0])}},4J:C(f,d){E e=c(f);if(1l e.1a(d)=="1s"){F 1j}if(e.1a(d)===""){e.1w(d);F 1j}F M},3t:C(e,f){E d=c(c.aW(f));d.12(".I-6N-5A").1w("1e").1w("1v");if(d.12("hr, br, 1J, 43, 3U").R!==0){F}E g=c.2J(d.1C());if(B.N.3C(g,M)){d.1o()}},7s:C(){B.fL=B.$O.4d();B.8O=c(3e).4d();if(B.G.7l){B.fM=c(B.G.7l).4d()}},81:C(){if(1l B.7s==="1s"&&1l B.8O==="1s"){F}c(3e).4d(B.8O);B.$O.4d(B.fL);if(B.G.7l){c(B.G.7l).4d(B.fM)}},6Z:C(){E d=14.3c("1c");d.fS="I-6N-5A";d.2X=B.G.5l;F d},5B:C(e){E d=B.G.5c;d.2q("1c");if(e.1k=="7O"){d.2q("a")}c(e).12(d.2t(",")).57("1c.I-K-2f").1S().3p()},5m:C(e,f){E d=B;c(e).22(C(){if(f===1j){d.N.5B(B)}F c(B).1S()});F c(e)},4a:C(g,d,h){E f;E e=B;c(g).22(C(){f=c("<"+d+" />").1r(c(B).1S());29(E j=0;j<B.3W.R;j++){f.1a(B.3W[j].2l,B.3W[j].23)}if(h===1j){e.N.5B(f)}F f});F f},jI:C(){E e=B.K.3B();if(!e){F M}E d=B.1I.7X(e);F(d===0)?1j:M},5y:C(d){if(1l d=="1s"){E d=B.K.3B();if(!d){F M}}E f=B.1I.7X(d);E e=c.2J(c(d).1C()).J(/\\n\\r\\n/g,"");F(f==e.R)?1j:M},aJ:C(){E f=B.$O[0];E e=B.1I.7X(f);E d=c.2J(c(f).1b().J(/(<([^>]+)>)/gi,""));F(e==d.R)?1j:M},5D:C(d){d=d[0]||d;F d&&B.N.6y(d.1k)},6y:C(d){if(1l d=="1s"){F M}F B.fT.7V(d)},8N:C(f,d){E e=c(f).25(d,B.$O[0]);if(e.R==1){F e[0]}F M},7a:C(){F B.8B},fZ:C(){B.8B=1j},76:C(){B.8B=M},3T:C(d){if(!d){F M}if(c(d).g0(".I-O").R===0||c(d).2U("I-O")){F M}F d},g1:C(){F B.N.4f(["ba","bs","aL","9H","9R","9S"])},4f:C(e){E f=B.K.4R();E g=B.K.30();if(c.8K(e)){E d=0;c.1m(e,c.V(C(h,j){if(B.N.9L(g,f,j)){d++}},B));F(d===0)?M:1j}L{F B.N.9L(g,f,e)}},9L:C(f,e,d){d=d.jQ();F e&&e.1k===d?e:f&&f.1k===d?f:M},jP:C(){F(B.N.1R("2e")&&4C(B.N.1R("8f"),10)<9)?1j:M},ji:C(){F(B.N.1R("2e")&&4C(B.N.1R("8f"),10)<10)?1j:M},fY:C(){F!!8G.8H.1T(/iO\\/7\\./)},1R:C(e){E f=8G.8H.2u();E d=/(9U)[\\/]([\\w.]+)/.4m(f)||/(fU)[ \\/]([\\w.]+)/.4m(f)||/(6C)[ \\/]([\\w.]+).*(aj)[ \\/]([\\w.]+)/.4m(f)||/(6C)[ \\/]([\\w.]+)/.4m(f)||/(iP)(?:.*8f|)[ \\/]([\\w.]+)/.4m(f)||/(2e) ([\\w.]+)/.4m(f)||f.3X("iI")>=0&&/(ae)(?::| )([\\w.]+)/.4m(f)||f.3X("iH")<0&&/(4r)(?:.*? ae:([\\w.]+)|)/.4m(f)||[];if(e=="aj"){F(1l d[3]!="1s")?d[3]=="aj":M}if(e=="8f"){F d[2]}if(e=="6C"){F(d[1]=="fU"||d[1]=="9U"||d[1]=="6C")}if(d[1]=="ae"){F e=="2e"}if(d[1]=="9U"){F e=="6C"}F e==d[1]},8d:C(e,f,g){E d=e.3X(f,g);F d>=0?d:M},}},2F:C(){F{fV:C(d){F d==B.2G.5R||d==B.2G.8c},88:C(){F B.G.8i&&(B.G.9Y||B.G.a0||B.G.7w)&&!B.N.4f("7O")},2o:C(){E e=B.2F,d=B.G;B.$O.12(":57(43,1J,a,2n)").iA().1S().ao(C(){F B.an===3&&c.2J(B.4V)!=""&&!c(B).2P().is("2n")&&(B.4V.1T(d.2F.3L.5E)||B.4V.1T(d.2F.3L.5q)||B.4V.1T(d.2F.3L.Q)||B.4V.1T(d.2F.3L.2b))}).1m(C(){E g=c(B).1C(),f=g;if(d.7w&&(f.1T(d.2F.3L.5E)||f.1T(d.2F.3L.5q))){f=e.7w(f)}L{if(d.a0&&f.1T(d.2F.3L.Q)){f=e.fW(f)}L{if(d.9Y){f=e.8i(f)}}}c(B).8p(g.J(g,f)).1o()});B.1h.1B()},7w:C(e){E f=\'<43 2M="iw" 4n="iE" 3Q="\',d=\'" iD="0" j7></43>\';if(e.1T(B.G.2F.3L.5E)){e=e.J(B.G.2F.3L.5E,f+"//6E.5E.8k/6L/$1"+d)}if(e.1T(B.G.2F.3L.5q)){e=e.J(B.G.2F.3L.5q,f+"//jb.5q.8k/5t/$2"+d)}F e},fW:C(d){E e=d.1T(B.G.2F.3L.Q);if(e){d=d.J(d,\'<1J 3Q="\'+e+\'" />\');if(B.G.1A){if(!B.N.3C(B.1h.Y())){d="<br>"+d}}d+="<br>"}F d},8i:C(j){E h=j.1T(B.G.2F.3L.2b);if(h){h=c.j4(h,C(n,i){F c.2K(n,h)===i});E e=h.R;29(E g=0;g<e;g++){E d=h[g],m=d,f=B.G.5L+"://";if(d.1T(/(4Q?|7j):\\/\\//i)!==3x){f=""}if(m.R>B.G.ay){m=m.80(0,B.G.ay)+"..."}m=fX(m);E l="\\\\b";if(c.2K(d.aU(-1),["/","&","="])!=-1){l=""}E k=1P 1U("("+d.J(/[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\\^\\$\\|]/g,"\\\\$&")+l+")","g");j=j.J(k,\'<a 2B="\'+f+c.2J(d)+\'">\'+c.2J(m)+"</a>")}}F j}}}};c(3e).1x("2r.fq.I",C(){c(\'[1g-fq="I"]\').I()});b.4M.3b.4M=b.4M})(lL);', 62, 1429, "|||||||||||||||||||||||||||||||||||||this|function||var|return|opts||redactor|replace|selection|else|false|utils|editor||image|length||modal|block|proxy|||get||||find||document||||||attr|html|span|link|style|upload|data|code|keydown|true|tagName|typeof|each|toolbar|remove|clean|div|append|undefined|range|tidy|class|removeAttr|on|css|lang|linebreaks|sync|text|button|dropdown|type|set|insert|caret|img|func|blockquote|buffer|inline|core|new|title|browser|contents|match|RegExp|click|build|addClass|textarea|keyup||preventDefault|replaceWith|value||closest|settings||setCallback|for|left|url|focus|tabifier|msie|marker|box|uuid|show|removeClass|observe|name|target|pre|format|formatting|push|load|alignment|join|toLowerCase|paragraphize|restore|file|placeholder|hide|toggle|href|save|body|autosave|linkify|keyCode|val|setStart|trim|inArray|ul|width|after|ol|parent|setTimeout|off|CodeMirror|indent|hasClass|current|px|innerHTML|verified|search|getCurrent|input|||||||||element|init|createElement|font|window|tag|rel|sel|line|option|setEnd|script|execCommand|ctrl|section|unwrap|list|td|top|removeEmpty|insertNode|droparea|deniedTags|null|label|italic|close|getBlock|isEmpty|del|getBlocks|resizeHandle|bold|margin|right|split|substr|regexps|clearUnverified|allowedTags|toString|resize|src|next|tooltip|isRedactorParent|source|blocks|attributes|indexOf|buttons|collapse||node|catch|iframe|btn|||modalBox|re|try|replaceToTag|prepend|allowedAttr|scrollTop|drop|isCurrentOrParent|Redactor|while|addRange|LI|getMarkerAsHtml|strong|exec|height|setAfter|offset|position|mozilla|collapsed|table|meta|nbsp|replaceTags|TD|pasteBox|removeDataAttr|replaceStyles|progress|parseInt|orderedlist|paste|children|object|isMobile|isFunction|removeEmptyAttr|center|deleteContents|prototype|BR|editter|underline|https|getParent|none|last|innerHeight|nodeValue|wrap|shortcuts|unorderedlist|prop||getSelection|marginTop|params|break|quot|error|not|deleted||align|command|inlineTags|String|visual|touchstart|th|form|charAt|getOuterHtml|call|invisibleSpace|replaceWithContents|containerTag|preSpaces|getHiddenFields|vimeo|getNodes|emptyHtml|video|getMarker|Insert|toolbarFixedTarget|tr|isEndOfElement|string|space|removeInlineTags|shiftKey|isBlock|youtube|hideResize|unlink|metaKey|display|SPAN|removeWithoutAttr|linkProtocol|direct|getRangeAt|insertBreakLine|filename|shift|ENTER|u200B|removeComments|sub|sup|figcaption|strike|modalOverlay|decoration|||originalEvent|level|replaceDivs|||setVerified|nodes|weight|alt|getEvent|rtePaste|_blank|dropact|select|action|outerHTML|float|getTabs|scroll|posFromIndex|appendChild|extend|outdent|fixed|hidden|contenteditable|selectElement|toolbarFixedTopOffset|s3|DIV|u200D|uFEFF|isBlockTag|delete|blocksSize|toggleClass|webkit|BACKSPACE|www|isDesktop|z0|imageUpload|blank|drag|fileUpload|embed|onPaste|invisible|Add|param|case|rebuffer|apply|insertDblBreakLine|OL|modalFooter|tab|Header|modalHeader|createSpaceElement|blockLevelElements|modalClose|act||targetTouches|resizer|disableSelectAll|imageFloatMargin|edit|filelink|isSelectAll|autosaveInterval|justify|inserted|plugins|which|clear|audio|100|ftp|tagblock|scrollTarget|Delete|addEvent|isMobileUndoRedo|codemirror|disabled|alignmentTags|saveScroll|singleLine|rangeCount|http|convertVideoLinks|cloneRange|removeMarkers|absolute|DELETE|undo|icon|innerWidth|cite|start|ctrlKey|UL|inputUrl|hideAll|Array|tabindex|setActive|cleanlevel|PRE|small|isRemoveInline|tabber|setClass|IMG|placeTag|test|getAlignmentElement|getOffsetOfElement|formatListToBlockquote|images|substring|restoreScroll|isTextarea|onClick|formatWrap|arrow|prev|fixEmptyIndent|isEnabled|firstChild|createDocumentFragment|onSync|SPACE|strpos|handler|version|getPlainText|normalizeLists|convertLinks|setNodesMarker|com|caretPositionFromPoint|checked|caretRangeFromPoint|createTextRange|before|replaceToParagraph|selectNodeContents|TH|enable|safes|marginBottom|marginLeft|marginRight|Math|pageY|clearStyle|selectAll|formatblock|enterKey|imageEditable|moveToPoint|navigator|userAgent|autosaveFields|insertInIe|isArray|indentValue|templateName|isTag|saveBodyScroll|200|kbd|callbacks|redo|auto|bind|imageFields|RedactorPlugins|the|increase|onDrag|||decrease|mark|callback|maxHeight|||||fileFields|minHeight|overflow|modalBody|appendTo|splice|createTextNode|replaceParagraphsToBr|samp|toolbarExternal|blur|onPasteTidy|u00a0|header|horizontalrule|dataTransfer|mso|BLOCKQUOTE|traverseFile|tabAsSpaces|activeButtons|open|modules|encodeEntities|XMLHttpRequest|files||showOnDesktop|getOffset|FormData|onDrop|readyState|setBefore|H4|autosaveName|DOWN|getModuleMethods|isCurrentOrParentOne|closeHandler|setFormat|getTextFromHtml|inputText|Table|H5|H6|autosaveOnChange|opr|createCancelButton|htmlIe|removeAllRanges|convertUrlLinks|setMarker|convertImageLinks|placeholdler|address|setOffset|nodeToCaretPositionFromPoint|getInlines|setConfig|createButton|parentNode|getNodesMarker|BODY|getText|x200b|dfn|rv|newLevel|observeScroll|removeFormat|buttonsHideOnMobile|safari|createRange|mailto|setAfterOrBefore|nodeType|filter|hover|visible|footer|buttonsHide|ESC|head|selectionEnd|enlargeOffset|selectionStart|linkSize|tbody|content|activeButtonsStates|quote|add|221|links|219|convertInline|direction|isEndOfEditor|saveFormTags|H3|thead|tfoot|finish|setInactiveAll|addCallback|cleanTag|link_new_tab|normalize|slice|endOffset|parseHTML|formatTableWrapping|insertBreakLineProcessing|syncCode|send|active|createActionButton|endContainer|removeSpaces|showCode|verifiedTags|Link|ratio|imageDelete|H1|paragraphizeBlocks|closeTooltip|formattingAdd||mousedown|TAB|status|headTag|link_insert|showOnMobile|curLang|setRequestHeader|Column|clearUnverifiedRemove|first|imageResizable||H2|Row|formatEmpty|onShiftEnter|ie11PasteFrag|langs|checkEvents|removeEmptyListInTable|insertBreakLineProcessingAfter|removeInvisibleSpace|setupBuffer|altKey|exitFromBlockquote|RIGHT|insertAfterLastElement|onTab|insertNewLine|onArrowDown|replaceDivToParagraph|replaceDivToBreakLine|META|insertParagraph|cleanStyleOnEnter|SHIFT|addArrowsEvent|ALT|insertInOthersBrowsers|CTRL|isExceptLastOrFirst|EndToEnd|ie11FixInserting|stopPropagation|checkKeyEvents|duplicate|LEFT_WIN|setupSelectAll|setEndPoint|tabKey|getOnlyImages|dir|setOptions|callEditor|setCodeAndCall|dragImageUpload|dragFileUpload|setEventDropUpload|setEventDrop|setEvents|insertAfter|createTextarea|getTextareaName||createContainerBox|run|loadContent|enableEditor|fromElement|fromTextarea|loadEditor|codeKeydownCallback|codeKeyupCallback|Apple|nofollow|linkNofollow|pastePlainText|FIGCAPTION|Mso|bmso|onPasteWord|cleanSpaces|onClickCallback|setHelpers|isBlured|focusCallback|focusEnd|disableMozillaEditing|createTooltip|setEvent|disableIeLinks|getRedo|getUndo|Edit|to|Align|Center|Drop|here|gif|png|or|choose|Code|List|Color|Function|Head|Left|Video|Image|Right|shortcutsAdd|loadOptions|setForce|commonAncestorContainer|setMultiple|formatBlockquote|empty|pop|setRedo||setUndo|setCollapsed|success|setText|bindModuleMethods|loadModules|setBlocks||isLinebreaksOrNoBlocks|alignElement|replaceElement|isNeedReplaceElement|onPasteExtra|internal|15px||fixImageSourceAfterDrop|inside|stopResize|loadEditableControls|opacity|figure|loadResizableControls|showEdit|round|moveResize|imagePosition|imageLink|buttonSave|update|setFloating|startResize|pageX|setResizable|increaseLists|increaseBlocks|setStartAfter|switch|formatConvert|htmlWithoutClean|htmlFixMozilla|execHtml|article|aside|formatRemoveSameChildren|through|decreaseBlocks|decreaseLists|increaseText|superscript|subscript|strikethrough|formatMultiple|formatCollapsed|buttonDelete|_delete|replaceDivsToBr|removeDirtyStyles|amp|insertHTML|restoreFormTags|onSet|setValue|onChange|startSync|getPreCode|restoreSelectionMarker|onPasteRemoveSpans|onPasteRemoveEmpty||||all|onPasteIeFixLinks||isSingleLine|saveCodeFormatting|savePreFormatting|savePreCode|setSelectionRange|setInactiveInCode|key|clearInterval|removeData|one|mouseover|700|isFocused|mouseout|destroy|event|indexFromPos|anchor|showVisual|modified|indenting|textareaIndenting|setInactive|setActiveInVisual|offsetNode|linkTooltip|align_left|align_center|align_right|align_justify|header5|header4|header1|header2|header3|mouseup|||||||||||createContainer|toolbarOverflow|isButtonSourceNeeded|hideButtons|hideButtonsOnMobile|setOverflow|toolbarFixed|setFormattingTags|loadButtons|setFixed|removeAttrs|removeParagraphsInLists||pasteHTML|end|tools|arguments|replaceSelection|savedSel|startContainer|removeNodesMarkers|createMarkers|area|fieldset|removeFromDenied|removeTags|removeAttrGetRemoves|addToAllowed|setupAllowed|map|lineBefore|lineAfter|observeScrollEnable|observeScrollDisable|Object|clone|saveEditorScroll|saveTargetScroll|Android|BlackBerry|s3createCORSRequest|iPhone|iPod|className|reIsBlock|chrome|isKey|convertImages|decodeURIComponent|isIe11|enableSelectAll|parents|isCurrentOrParentHeader|s3uploadToS3|XDomainRequest|change|directUpload|imageUploadParam|fileUploadParam|upload_label|setFocus|visibility|setDropdownsFixed|unsetDropdownsFixed|getType|imageTypes|overrideMimeType|onreadystatechange|responseText||s3executeOnSignedUrl|s3uploadFile|sendData|parseJSON|onDragLeave|lastBlock|paragraph|showTooltip|replaceBreaksToNewLines|getTooltipPosition||checkbox|URL|cleanUrl|buttonInsert|getTemplate|cleanOnPaste|setContent|createPasteBox|setEditable|self|image_position|replaceBreaksToParagraphs|xn|_moz_dirty|freeze|restoreSafes|getData|getSafesComments|imageEdit|loadTemplates|getSafes|location|destroyed|setTitle|setButtonsWidth|createDeleteButton|buildOverlay|draggable|enableEvents|fadeOut|cancel|getLastBlock|handle|||||||getInlinesTags|setEnter|disableEvents|activeElement|setDraggable|bodyOveflow|changeIcon|GET|clearFileFields|focusin|removeIcon|With|caretOffset|setStartBefore|removeImageFields|modalOpened|NodeFilter|addImageFields|setEndBefore|createTreeWalker||setEndAfter|20px|addFirst|clearImageFields|removeFileFields|addDropdown|setAwesome|outerHeight|addAfter|returnValue|addFileFields|enableObjectResizing|addBefore|enableInlineTableEditing|email|SHOW_TEXT|AutoUrlDetect|u00a9|1strike|spacerun|yes|floor|xml|WordDocument|uploadImageFields|uploadStart|No|shapes|slevel|guid|Columns|fake|dragover|docs|such|dragleave|sid|converted|s1|add_head|u2122|trade|plain|Requested|reg|Infinity|setToPoint|||||getCoords|copy|u2026|POST|uploadFileFields|sdata||dash|u2010|hellip|u2014||mdash|nextNode|delete_head|500|applet|getOwnPropertyNames|Embed|addBack|merge|Youtube|frameborder|281|Vimeo|LEFT|compatible|trident|post|done|web|autosaveError|ajax|Trident|opera|video_html_code|setInterval|1000|jpe|File|Horizontal|Rule|Deleted|Anchor|Choose|Justify|drop_file_here|Or|or_choose|grep|Open|Underline|allowfullscreen|download|Upload|youtu|player|Download|Alignment|Name|optional|600|disable|isLessIe10|onload|onerror|PUT|createTabber|cut|onprogress|Content|public|acl|amz|Type|addTab|addTemplate|matches|of|user|charset|Plugin|defined|blurCallback|withCredentials|cursor|getModal|read|iPad|isStartOfElement|php|createLink|setData|Web|Text|Email|isOldIe|toUpperCase|host|toggleData|setAttr|None|Position|Title|isString|TEXTAREA|hexToRgb|toggleAttr|insertedLink|image_web_link|rgb|module|columns|113|Normal|112|111|Quote|114|fontcolor|115|Italic|Bold|110|109|101|Formatting|Unlink|link_edit|102|103|107|106|105|104|touchend|touchmove|focusNode|122|705|f10|f11|123|dropdownHide|144|move|fileUploadError|121|Unordered|117|Font|116|mousemove|backcolor|dragstart|120|119|Back|118|HTML|ARTICLE|removeStyle|removeStyleRule|hgroup|toggleStyle|nav|cssText|summary|menu|details|backspace|9999px|pasteBefore|1500|startOffset|nodeToPoint|clientX|fromPoint|extractContents|replaceWithHtml|cloneContents|getHtml|fadeIn|alignleft|pause|up|ADDRESS||OUTPUT|home|SECTION|HEADER|imageUploadError|ASIDE|FOOTER|down|DD|DT||esc|alignright|capslock|aligncenter|jpeg|pageup|DL|pagedown|ins|numlock|f12|insert_column_left|Below|syncBefore|specified|insert_column_right|ltr|jQuery|delete_row|cleanEmptyParagraph|delete_column|10px|insert_row_below|145|context|math|enter|setSelection|setCursor|uploadImageField|Above|setSize|refresh|bull|delete_table|overlay|method|fast|stripTags|removePhp|times|colspan|rowspan|relative|clientY|external|Rows|Ss|getOnlyLinksAndImages|addButton|unselectable|toggleActive|modalClosed|VERSION|rows|textContent|innerText|listSelections|insert_row_above|_|Ordered|222|220|namespace|events|Key|insert_table|_data|fromCharCode|192|191|dropdownShown|187|186|173|max|dropdownShow|190|189|188|getToolbar|Callback|noscript|Outdent|frame|legend|getTextarea|Indent|Cancel|getValue|Save|hasOwnProperty|frameset|getEditor|getObject|getBox|getElement".split("|"), 0, {}));

},{}],"loHKk":[function(require,module,exports) {
if (!RedactorPlugins) var RedactorPlugins = {};
(function($) {
    RedactorPlugins.fontcolor = function() {
        return {
            init: function() {
                var colors = [
                    "#ffffff",
                    "#000000",
                    "#eeece1",
                    "#1f497d",
                    "#4f81bd",
                    "#c0504d",
                    "#9bbb59",
                    "#8064a2",
                    "#4bacc6",
                    "#f79646",
                    "#ffff00",
                    "#f2f2f2",
                    "#7f7f7f",
                    "#ddd9c3",
                    "#c6d9f0",
                    "#dbe5f1",
                    "#f2dcdb",
                    "#ebf1dd",
                    "#e5e0ec",
                    "#dbeef3",
                    "#fdeada",
                    "#fff2ca",
                    "#d8d8d8",
                    "#595959",
                    "#c4bd97",
                    "#8db3e2",
                    "#b8cce4",
                    "#e5b9b7",
                    "#d7e3bc",
                    "#ccc1d9",
                    "#b7dde8",
                    "#fbd5b5",
                    "#ffe694",
                    "#bfbfbf",
                    "#3f3f3f",
                    "#938953",
                    "#548dd4",
                    "#95b3d7",
                    "#d99694",
                    "#c3d69b",
                    "#b2a2c7",
                    "#b7dde8",
                    "#fac08f",
                    "#f2c314",
                    "#a5a5a5",
                    "#262626",
                    "#494429",
                    "#17365d",
                    "#366092",
                    "#953734",
                    "#76923c",
                    "#5f497a",
                    "#92cddc",
                    "#e36c09",
                    "#c09100",
                    "#7f7f7f",
                    "#0c0c0c",
                    "#1d1b10",
                    "#0f243e",
                    "#244061",
                    "#632423",
                    "#4f6128",
                    "#3f3151",
                    "#31859b",
                    "#974806",
                    "#7f6000"
                ];
                var buttons = [
                    "fontcolor",
                    "backcolor"
                ];
                for(var i = 0; i < 2; i++){
                    var name = buttons[i];
                    var button = this.button.add(name, this.lang.get(name));
                    var $dropdown = this.button.addDropdown(button);
                    $dropdown.width(242);
                    this.fontcolor.buildPicker($dropdown, name, colors);
                }
            },
            buildPicker: function($dropdown, name, colors) {
                var rule = name == "backcolor" ? "background-color" : "color";
                var len = colors.length;
                var self = this;
                var func = function(e) {
                    e.preventDefault();
                    self.fontcolor.set($(this).data("rule"), $(this).attr("rel"));
                };
                for(var z = 0; z < len; z++){
                    var color = colors[z];
                    var $swatch = $('<a rel="' + color + '" data-rule="' + rule + '" href="#" style="float: left; font-size: 0; border: 2px solid #fff; padding: 0; margin: 0; width: 22px; height: 22px;"></a>');
                    $swatch.css("background-color", color);
                    $swatch.on("click", func);
                    $dropdown.append($swatch);
                }
                var $elNone = $('<a href="#" style="display: block; clear: both; padding: 5px; font-size: 12px; line-height: 1;"></a>').html(this.lang.get("none"));
                $elNone.on("click", $.proxy(function(e) {
                    e.preventDefault();
                    this.fontcolor.remove(rule);
                }, this));
                $dropdown.append($elNone);
            },
            set: function(rule, type) {
                this.inline.format("span", "style", rule + ": " + type + ";");
            },
            remove: function(rule) {
                this.inline.removeStyleRule(rule);
            }
        };
    };
})(jQuery);

},{}],"75rVT":[function(require,module,exports) {
if (!RedactorPlugins) var RedactorPlugins = {};
(function($) {
    RedactorPlugins.fontsize = function() {
        return {
            init: function() {
                var fonts = [
                    10,
                    11,
                    12,
                    14,
                    16,
                    18,
                    20,
                    24,
                    28,
                    30
                ];
                var that = this;
                var dropdown = {};
                $.each(fonts, function(i, s) {
                    dropdown["s" + i] = {
                        title: s + "px",
                        func: function() {
                            that.fontsize.set(s);
                        }
                    };
                });
                dropdown.remove = {
                    title: "Remove Font Size",
                    func: that.fontsize.reset
                };
                var button = this.button.add("fontsize", "Change Font Size");
                this.button.addDropdown(button, dropdown);
            },
            set: function(size) {
                this.inline.format("span", "style", "font-size: " + size + "px;");
            },
            reset: function() {
                this.inline.removeStyleRule("font-size");
            }
        };
    };
})(jQuery);

},{}],"1fY5t":[function(require,module,exports) {
if (!RedactorPlugins) var RedactorPlugins = {};
(function($) {
    RedactorPlugins.fullscreen = function() {
        return {
            init: function() {
                this.fullscreen.isOpen = false;
                var button = this.button.add("fullscreen", "Fullscreen");
                this.button.addCallback(button, this.fullscreen.toggle);
                if (this.opts.fullscreen) this.fullscreen.toggle();
            },
            enable: function() {
                this.button.changeIcon("fullscreen", "normalscreen");
                this.button.setActive("fullscreen");
                this.fullscreen.isOpen = true;
                if (this.opts.toolbarExternal) {
                    this.fullscreen.toolcss = {};
                    this.fullscreen.boxcss = {};
                    this.fullscreen.toolcss.width = this.$toolbar.css("width");
                    this.fullscreen.toolcss.top = this.$toolbar.css("top");
                    this.fullscreen.toolcss.position = this.$toolbar.css("position");
                    this.fullscreen.boxcss.top = this.$box.css("top");
                }
                this.fullscreen.height = this.$editor.height();
                if (this.opts.maxHeight) this.$editor.css("max-height", "");
                if (this.opts.minHeight) this.$editor.css("min-height", "");
                if (!this.$fullscreenPlaceholder) this.$fullscreenPlaceholder = $("<div/>");
                this.$fullscreenPlaceholder.insertAfter(this.$box);
                this.$box.appendTo(document.body);
                this.$box.addClass("redactor-box-fullscreen");
                $("body, html").css("overflow", "hidden");
                this.fullscreen.resize();
                $(window).on("resize.redactor.fullscreen", $.proxy(this.fullscreen.resize, this));
                $(document).scrollTop(0, 0);
                $(".redactor-toolbar-tooltip").hide();
                this.$editor.focus();
                this.observe.load();
            },
            disable: function() {
                this.button.removeIcon("fullscreen", "normalscreen");
                this.button.setInactive("fullscreen");
                this.fullscreen.isOpen = false;
                $(window).off("resize.redactor.fullscreen");
                $("body, html").css("overflow", "");
                this.$box.insertBefore(this.$fullscreenPlaceholder);
                this.$fullscreenPlaceholder.remove();
                this.$box.removeClass("redactor-box-fullscreen").css({
                    width: "auto",
                    height: "auto"
                });
                this.code.sync();
                if (this.opts.toolbarExternal) {
                    this.$box.css("top", this.fullscreen.boxcss.top);
                    this.$toolbar.css({
                        "width": this.fullscreen.toolcss.width,
                        "top": this.fullscreen.toolcss.top,
                        "position": this.fullscreen.toolcss.position
                    });
                }
                if (this.opts.minHeight) this.$editor.css("minHeight", this.opts.minHeight);
                if (this.opts.maxHeight) this.$editor.css("maxHeight", this.opts.maxHeight);
                $(".redactor-toolbar-tooltip").hide();
                this.$editor.css("height", "auto");
                this.$editor.focus();
                this.observe.load();
            },
            toggle: function() {
                if (this.fullscreen.isOpen) this.fullscreen.disable();
                else this.fullscreen.enable();
            },
            resize: function() {
                if (!this.fullscreen.isOpen) return;
                var toolbarHeight = this.$toolbar.height();
                var height = $(window).height() - toolbarHeight - this.utils.normalize(this.$editor.css("padding-top")) - this.utils.normalize(this.$editor.css("padding-bottom"));
                this.$box.width($(window).width()).height(height);
                if (this.opts.toolbarExternal) {
                    this.$toolbar.css({
                        "top": "0px",
                        "position": "absolute",
                        "width": "100%"
                    });
                    this.$box.css("top", toolbarHeight + "px");
                }
                this.$editor.height(height);
            }
        };
    };
})(jQuery);

},{}],"8oyA9":[function(require,module,exports) {
require("4bf9f8f30a40b8a");
module.exports = angular;

},{"4bf9f8f30a40b8a":"7sfz6"}],"7sfz6":[function(require,module,exports) {
/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1) {
    "use strict";
    /* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/ var minErrConfig = {
        objectMaxDepth: 5,
        urlErrorParamsEnabled: true
    };
    /**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */ function errorHandlingConfig(config) {
        if (isObject(config)) {
            if (isDefined(config.objectMaxDepth)) minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
            if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
        } else return minErrConfig;
    }
    /**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */ function isValidObjectMaxDepth(maxDepth) {
        return isNumber(maxDepth) && maxDepth > 0;
    }
    /**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace'). Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */ function minErr(module, ErrorConstructor) {
        ErrorConstructor = ErrorConstructor || Error;
        var url = "https://errors.angularjs.org/1.8.2/";
        var regex = url.replace(".", "\\.") + "[\\s\\S]*";
        var errRegExp = new RegExp(regex, "g");
        return function() {
            var code = arguments[0], template = arguments[1], message = "[" + (module ? module + ":" : "") + code + "] ", templateArgs = sliceArgs(arguments, 2).map(function(arg) {
                return toDebugString(arg, minErrConfig.objectMaxDepth);
            }), paramPrefix, i;
            // A minErr message has two parts: the message itself and the url that contains the
            // encoded message.
            // The message's parameters can contain other error messages which also include error urls.
            // To prevent the messages from getting too long, we strip the error urls from the parameters.
            message += template.replace(/\{\d+\}/g, function(match) {
                var index = +match.slice(1, -1);
                if (index < templateArgs.length) return templateArgs[index].replace(errRegExp, "");
                return match;
            });
            message += "\n" + url + (module ? module + "/" : "") + code;
            if (minErrConfig.urlErrorParamsEnabled) for(i = 0, paramPrefix = "?"; i < templateArgs.length; i++, paramPrefix = "&")message += paramPrefix + "p" + i + "=" + encodeURIComponent(templateArgs[i]);
            return new ErrorConstructor(message);
        };
    }
    /* We need to tell ESLint what variables are being exported */ /* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,
  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/ ////////////////////////////////////
    /**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */ var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
    // The name of a form control's ValidityState property.
    // This is used so that it's possible for internal tests to create mock ValidityStates.
    var VALIDITY_STATE_PROPERTY = "validity";
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */ var lowercase = function(string) {
        return isString(string) ? string.toLowerCase() : string;
    };
    /**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */ var uppercase = function(string) {
        return isString(string) ? string.toUpperCase() : string;
    };
    var msie, jqLite, jQuery, slice = [].slice, splice = [].splice, push = [].push, toString = Object.prototype.toString, getPrototypeOf = Object.getPrototypeOf, ngMinErr = minErr("ng"), /** @name angular */ angular = window1.angular || (window1.angular = {}), angularModule, uid = 0;
    // Support: IE 9-11 only
    /**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */ msie = window1.document.documentMode;
    /**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */ function isArrayLike(obj) {
        // `null`, `undefined` and `window` are not array-like
        if (obj == null || isWindow(obj)) return false;
        // arrays, strings and jQuery/jqLite objects are array like
        // * jqLite is either the jQuery or jqLite constructor function
        // * we have to check the existence of jqLite first as this method is called
        //   via the forEach method when constructing the jqLite object in the first place
        if (isArray(obj) || isString(obj) || jqLite && obj instanceof jqLite) return true;
        // Support: iOS 8.2 (not reproducible in simulator)
        // "length" in obj used to prevent JIT error (gh-11508)
        var length = "length" in Object(obj) && obj.length;
        // NodeList objects (with `item` method) and
        // other objects with suitable length characteristics are array-like
        return isNumber(length) && (length >= 0 && length - 1 in obj || typeof obj.item === "function");
    }
    /**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */ function forEach(obj, iterator, context) {
        var key, length;
        if (obj) {
            if (isFunction(obj)) {
                for(key in obj)if (key !== "prototype" && key !== "length" && key !== "name" && obj.hasOwnProperty(key)) iterator.call(context, obj[key], key, obj);
            } else if (isArray(obj) || isArrayLike(obj)) {
                var isPrimitive = typeof obj !== "object";
                for(key = 0, length = obj.length; key < length; key++)if (isPrimitive || key in obj) iterator.call(context, obj[key], key, obj);
            } else if (obj.forEach && obj.forEach !== forEach) obj.forEach(iterator, context, obj);
            else if (isBlankObject(obj)) // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for(key in obj)iterator.call(context, obj[key], key, obj);
            else if (typeof obj.hasOwnProperty === "function") {
                // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
                for(key in obj)if (obj.hasOwnProperty(key)) iterator.call(context, obj[key], key, obj);
            } else {
                // Slow path for objects which do not have a method `hasOwnProperty`
                for(key in obj)if (hasOwnProperty.call(obj, key)) iterator.call(context, obj[key], key, obj);
            }
        }
        return obj;
    }
    function forEachSorted(obj, iterator, context) {
        var keys = Object.keys(obj).sort();
        for(var i = 0; i < keys.length; i++)iterator.call(context, obj[keys[i]], keys[i]);
        return keys;
    }
    /**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */ function reverseParams(iteratorFn) {
        return function(value, key) {
            iteratorFn(key, value);
        };
    }
    /**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */ function nextUid() {
        return ++uid;
    }
    /**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */ function setHashKey(obj, h) {
        if (h) obj.$$hashKey = h;
        else delete obj.$$hashKey;
    }
    function baseExtend(dst, objs, deep) {
        var h = dst.$$hashKey;
        for(var i = 0, ii = objs.length; i < ii; ++i){
            var obj = objs[i];
            if (!isObject(obj) && !isFunction(obj)) continue;
            var keys = Object.keys(obj);
            for(var j = 0, jj = keys.length; j < jj; j++){
                var key = keys[j];
                var src = obj[key];
                if (deep && isObject(src)) {
                    if (isDate(src)) dst[key] = new Date(src.valueOf());
                    else if (isRegExp(src)) dst[key] = new RegExp(src);
                    else if (src.nodeName) dst[key] = src.cloneNode(true);
                    else if (isElement(src)) dst[key] = src.clone();
                    else if (key !== "__proto__") {
                        if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
                        baseExtend(dst[key], [
                            src
                        ], true);
                    }
                } else dst[key] = src;
            }
        }
        setHashKey(dst, h);
        return dst;
    }
    /**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */ function extend(dst) {
        return baseExtend(dst, slice.call(arguments, 1), false);
    }
    /**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest using another, similar library for all-purpose merging,
* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* `angular.merge` also does not support merging objects with circular references.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/ function merge(dst) {
        return baseExtend(dst, slice.call(arguments, 1), true);
    }
    function toInt(str) {
        return parseInt(str, 10);
    }
    var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
        // eslint-disable-next-line no-self-compare
        return num !== num;
    };
    function inherit(parent, extra) {
        return extend(Object.create(parent), extra);
    }
    /**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */ function noop() {}
    noop.$inject = [];
    /**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */ function identity($) {
        return $;
    }
    identity.$inject = [];
    function valueFn(value) {
        return function valueRef() {
            return value;
        };
    }
    function hasCustomToString(obj) {
        return isFunction(obj.toString) && obj.toString !== toString;
    }
    /**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */ function isUndefined(value) {
        return typeof value === "undefined";
    }
    /**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */ function isDefined(value) {
        return typeof value !== "undefined";
    }
    /**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */ function isObject(value) {
        // http://jsperf.com/isobject4
        return value !== null && typeof value === "object";
    }
    /**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */ function isBlankObject(value) {
        return value !== null && typeof value === "object" && !getPrototypeOf(value);
    }
    /**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */ function isString(value) {
        return typeof value === "string";
    }
    /**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */ function isNumber(value) {
        return typeof value === "number";
    }
    /**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */ function isDate(value) {
        return toString.call(value) === "[object Date]";
    }
    /**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */ function isArray(arr) {
        return Array.isArray(arr) || arr instanceof Array;
    }
    /**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */ function isError(value) {
        var tag = toString.call(value);
        switch(tag){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    /**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */ function isFunction(value) {
        return typeof value === "function";
    }
    /**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */ function isRegExp(value) {
        return toString.call(value) === "[object RegExp]";
    }
    /**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */ function isWindow(obj) {
        return obj && obj.window === obj;
    }
    function isScope(obj) {
        return obj && obj.$evalAsync && obj.$watch;
    }
    function isFile(obj) {
        return toString.call(obj) === "[object File]";
    }
    function isFormData(obj) {
        return toString.call(obj) === "[object FormData]";
    }
    function isBlob(obj) {
        return toString.call(obj) === "[object Blob]";
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isPromiseLike(obj) {
        return obj && isFunction(obj.then);
    }
    var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
    function isTypedArray(value) {
        return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
    }
    function isArrayBuffer(obj) {
        return toString.call(obj) === "[object ArrayBuffer]";
    }
    var trim = function(value) {
        return isString(value) ? value.trim() : value;
    };
    // Copied from:
    // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
    // Prereq: s is a string.
    var escapeForRegexp = function(s) {
        return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, "\\$1")// eslint-disable-next-line no-control-regex
        .replace(/\x08/g, "\\x08");
    };
    /**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */ function isElement(node) {
        return !!(node && (node.nodeName // We are a direct element.
         || node.prop && node.attr && node.find)); // We have an on and find method part of jQuery API.
    }
    /**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */ function makeMap(str) {
        var obj = {}, items = str.split(","), i;
        for(i = 0; i < items.length; i++)obj[items[i]] = true;
        return obj;
    }
    function nodeName_(element) {
        return lowercase(element.nodeName || element[0] && element[0].nodeName);
    }
    function includes(array, obj) {
        return Array.prototype.indexOf.call(array, obj) !== -1;
    }
    function arrayRemove(array, value) {
        var index = array.indexOf(value);
        if (index >= 0) array.splice(index, 1);
        return index;
    }
    /**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
 * function, and has several limitations (see below).
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 *
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * <div class="alert alert-warning">
 *   `angular.copy` does not check if destination and source are of the same type. It's the
 *   developer's responsibility to make sure they are compatible.
 * </div>
 *
 * @knownIssue
 * This is a non-exhaustive list of object types / features that are not handled correctly by
 * `angular.copy`. Note that since this functions is used by the change detection code, this
 * means binding or watching objects of these types (or that include these types) might not work
 * correctly.
 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
 *
 * @param {*} source The source that will be used to make a copy. Can be any type, including
 *     primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
 *     must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */ function copy(source, destination, maxDepth) {
        var stackSource = [];
        var stackDest = [];
        maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
        if (destination) {
            if (isTypedArray(destination) || isArrayBuffer(destination)) throw ngMinErr("cpta", "Can't copy! TypedArray destination cannot be mutated.");
            if (source === destination) throw ngMinErr("cpi", "Can't copy! Source and destination are identical.");
            // Empty the destination object
            if (isArray(destination)) destination.length = 0;
            else forEach(destination, function(value, key) {
                if (key !== "$$hashKey") delete destination[key];
            });
            stackSource.push(source);
            stackDest.push(destination);
            return copyRecurse(source, destination, maxDepth);
        }
        return copyElement(source, maxDepth);
        function copyRecurse(source, destination, maxDepth) {
            maxDepth--;
            if (maxDepth < 0) return "...";
            var h = destination.$$hashKey;
            var key;
            if (isArray(source)) for(var i = 0, ii = source.length; i < ii; i++)destination.push(copyElement(source[i], maxDepth));
            else if (isBlankObject(source)) // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for(key in source)destination[key] = copyElement(source[key], maxDepth);
            else if (source && typeof source.hasOwnProperty === "function") {
                // Slow path, which must rely on hasOwnProperty
                for(key in source)if (source.hasOwnProperty(key)) destination[key] = copyElement(source[key], maxDepth);
            } else {
                // Slowest path --- hasOwnProperty can't be called as a method
                for(key in source)if (hasOwnProperty.call(source, key)) destination[key] = copyElement(source[key], maxDepth);
            }
            setHashKey(destination, h);
            return destination;
        }
        function copyElement(source, maxDepth) {
            // Simple values
            if (!isObject(source)) return source;
            // Already copied values
            var index = stackSource.indexOf(source);
            if (index !== -1) return stackDest[index];
            if (isWindow(source) || isScope(source)) throw ngMinErr("cpws", "Can't copy! Making copies of Window or Scope instances is not supported.");
            var needsRecurse = false;
            var destination = copyType(source);
            if (destination === undefined) {
                destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
                needsRecurse = true;
            }
            stackSource.push(source);
            stackDest.push(destination);
            return needsRecurse ? copyRecurse(source, destination, maxDepth) : destination;
        }
        function copyType(source) {
            switch(toString.call(source)){
                case "[object Int8Array]":
                case "[object Int16Array]":
                case "[object Int32Array]":
                case "[object Float32Array]":
                case "[object Float64Array]":
                case "[object Uint8Array]":
                case "[object Uint8ClampedArray]":
                case "[object Uint16Array]":
                case "[object Uint32Array]":
                    return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
                case "[object ArrayBuffer]":
                    // Support: IE10
                    if (!source.slice) {
                        // If we're in this case we know the environment supports ArrayBuffer
                        /* eslint-disable no-undef */ var copied = new ArrayBuffer(source.byteLength);
                        new Uint8Array(copied).set(new Uint8Array(source));
                        /* eslint-enable */ return copied;
                    }
                    return source.slice(0);
                case "[object Boolean]":
                case "[object Number]":
                case "[object String]":
                case "[object Date]":
                    return new source.constructor(source.valueOf());
                case "[object RegExp]":
                    var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
                    re.lastIndex = source.lastIndex;
                    return re;
                case "[object Blob]":
                    return new source.constructor([
                        source
                    ], {
                        type: source.type
                    });
            }
            if (isFunction(source.cloneNode)) return source.cloneNode(true);
        }
    }
    // eslint-disable-next-line no-self-compare
    function simpleCompare(a, b) {
        return a === b || a !== a && b !== b;
    }
    /**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */ function equals(o1, o2) {
        if (o1 === o2) return true;
        if (o1 === null || o2 === null) return false;
        // eslint-disable-next-line no-self-compare
        if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
        var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
        if (t1 === t2 && t1 === "object") {
            if (isArray(o1)) {
                if (!isArray(o2)) return false;
                if ((length = o1.length) === o2.length) {
                    for(key = 0; key < length; key++){
                        if (!equals(o1[key], o2[key])) return false;
                    }
                    return true;
                }
            } else if (isDate(o1)) {
                if (!isDate(o2)) return false;
                return simpleCompare(o1.getTime(), o2.getTime());
            } else if (isRegExp(o1)) {
                if (!isRegExp(o2)) return false;
                return o1.toString() === o2.toString();
            } else {
                if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
                keySet = createMap();
                for(key in o1){
                    if (key.charAt(0) === "$" || isFunction(o1[key])) continue;
                    if (!equals(o1[key], o2[key])) return false;
                    keySet[key] = true;
                }
                for(key in o2){
                    if (!(key in keySet) && key.charAt(0) !== "$" && isDefined(o2[key]) && !isFunction(o2[key])) return false;
                }
                return true;
            }
        }
        return false;
    }
    var csp = function() {
        if (!isDefined(csp.rules)) {
            var ngCspElement = window1.document.querySelector("[ng-csp]") || window1.document.querySelector("[data-ng-csp]");
            if (ngCspElement) {
                var ngCspAttribute = ngCspElement.getAttribute("ng-csp") || ngCspElement.getAttribute("data-ng-csp");
                csp.rules = {
                    noUnsafeEval: !ngCspAttribute || ngCspAttribute.indexOf("no-unsafe-eval") !== -1,
                    noInlineStyle: !ngCspAttribute || ngCspAttribute.indexOf("no-inline-style") !== -1
                };
            } else csp.rules = {
                noUnsafeEval: noUnsafeEval(),
                noInlineStyle: false
            };
        }
        return csp.rules;
        function noUnsafeEval() {
            try {
                // eslint-disable-next-line no-new, no-new-func
                new Function("");
                return false;
            } catch (e) {
                return true;
            }
        }
    };
    /**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */ var jq = function() {
        if (isDefined(jq.name_)) return jq.name_;
        var el;
        var i, ii = ngAttrPrefixes.length, prefix, name;
        for(i = 0; i < ii; ++i){
            prefix = ngAttrPrefixes[i];
            el = window1.document.querySelector("[" + prefix.replace(":", "\\:") + "jq]");
            if (el) {
                name = el.getAttribute(prefix + "jq");
                break;
            }
        }
        return jq.name_ = name;
    };
    function concat(array1, array2, index) {
        return array1.concat(slice.call(array2, index));
    }
    function sliceArgs(args, startIndex) {
        return slice.call(args, startIndex || 0);
    }
    /**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */ function bind(self, fn) {
        var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
        if (isFunction(fn) && !(fn instanceof RegExp)) return curryArgs.length ? function() {
            return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
        } : function() {
            return arguments.length ? fn.apply(self, arguments) : fn.call(self);
        };
        else // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
        return fn;
    }
    function toJsonReplacer(key, value) {
        var val = value;
        if (typeof key === "string" && key.charAt(0) === "$" && key.charAt(1) === "$") val = undefined;
        else if (isWindow(value)) val = "$WINDOW";
        else if (value && window1.document === value) val = "$DOCUMENT";
        else if (isScope(value)) val = "$SCOPE";
        return val;
    }
    /**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */ function toJson(obj, pretty) {
        if (isUndefined(obj)) return undefined;
        if (!isNumber(pretty)) pretty = pretty ? 2 : null;
        return JSON.stringify(obj, toJsonReplacer, pretty);
    }
    /**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */ function fromJson(json) {
        return isString(json) ? JSON.parse(json) : json;
    }
    var ALL_COLONS = /:/g;
    function timezoneToOffset(timezone, fallback) {
        // Support: IE 9-11 only, Edge 13-15+
        // IE/Edge do not "understand" colon (`:`) in timezone
        timezone = timezone.replace(ALL_COLONS, "");
        var requestedTimezoneOffset = Date.parse("Jan 01, 1970 00:00:00 " + timezone) / 60000;
        return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
    }
    function addDateMinutes(date, minutes) {
        date = new Date(date.getTime());
        date.setMinutes(date.getMinutes() + minutes);
        return date;
    }
    function convertTimezoneToLocal(date, timezone, reverse) {
        reverse = reverse ? -1 : 1;
        var dateTimezoneOffset = date.getTimezoneOffset();
        var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
    }
    /**
 * @returns {string} Returns the string representation of the element.
 */ function startingTag(element) {
        element = jqLite(element).clone().empty();
        var elemHtml = jqLite("<div></div>").append(element).html();
        try {
            return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function(match, nodeName) {
                return "<" + lowercase(nodeName);
            });
        } catch (e) {
            return lowercase(elemHtml);
        }
    }
    /////////////////////////////////////////////////
    /**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */ function tryDecodeURIComponent(value) {
        try {
            return decodeURIComponent(value);
        } catch (e) {
        // Ignore any invalid uri component.
        }
    }
    /**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */ function parseKeyValue(/**string*/ keyValue) {
        var obj = {};
        forEach((keyValue || "").split("&"), function(keyValue) {
            var splitPoint, key, val;
            if (keyValue) {
                key = keyValue = keyValue.replace(/\+/g, "%20");
                splitPoint = keyValue.indexOf("=");
                if (splitPoint !== -1) {
                    key = keyValue.substring(0, splitPoint);
                    val = keyValue.substring(splitPoint + 1);
                }
                key = tryDecodeURIComponent(key);
                if (isDefined(key)) {
                    val = isDefined(val) ? tryDecodeURIComponent(val) : true;
                    if (!hasOwnProperty.call(obj, key)) obj[key] = val;
                    else if (isArray(obj[key])) obj[key].push(val);
                    else obj[key] = [
                        obj[key],
                        val
                    ];
                }
            }
        });
        return obj;
    }
    function toKeyValue(obj) {
        var parts = [];
        forEach(obj, function(value, key) {
            if (isArray(value)) forEach(value, function(arrayValue) {
                parts.push(encodeUriQuery(key, true) + (arrayValue === true ? "" : "=" + encodeUriQuery(arrayValue, true)));
            });
            else parts.push(encodeUriQuery(key, true) + (value === true ? "" : "=" + encodeUriQuery(value, true)));
        });
        return parts.length ? parts.join("&") : "";
    }
    /**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */ function encodeUriSegment(val) {
        return encodeUriQuery(val, true).replace(/%26/gi, "&").replace(/%3D/gi, "=").replace(/%2B/gi, "+");
    }
    /**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */ function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%3B/gi, ";").replace(/%20/g, pctEncodeSpaces ? "%20" : "+");
    }
    var ngAttrPrefixes = [
        "ng-",
        "data-ng-",
        "ng:",
        "x-ng-"
    ];
    function getNgAttribute(element, ngAttr) {
        var attr, i, ii = ngAttrPrefixes.length;
        for(i = 0; i < ii; ++i){
            attr = ngAttrPrefixes[i] + ngAttr;
            if (isString(attr = element.getAttribute(attr))) return attr;
        }
        return null;
    }
    function allowAutoBootstrap(document1) {
        var script = document1.currentScript;
        if (!script) // Support: IE 9-11 only
        // IE does not have `document.currentScript`
        return true;
        // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
        if (!(script instanceof window1.HTMLScriptElement || script instanceof window1.SVGScriptElement)) return false;
        var attributes = script.attributes;
        var srcs = [
            attributes.getNamedItem("src"),
            attributes.getNamedItem("href"),
            attributes.getNamedItem("xlink:href")
        ];
        return srcs.every(function(src) {
            if (!src) return true;
            if (!src.value) return false;
            var link = document1.createElement("a");
            link.href = src.value;
            if (document1.location.origin === link.origin) // Same-origin resources are always allowed, even for banned URL schemes.
            return true;
            // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
            // This is to prevent angular.js bundled with browser extensions from being used to bypass the
            // content security policy in web pages and other browser extensions.
            switch(link.protocol){
                case "http:":
                case "https:":
                case "ftp:":
                case "blob:":
                case "file:":
                case "data:":
                    return true;
                default:
                    return false;
            }
        });
    }
    // Cached as it has to run during loading so that document.currentScript is available.
    var isAutoBootstrapAllowed = allowAutoBootstrap(window1.document);
    /**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */ function angularInit(element, bootstrap) {
        var appElement, module, config = {};
        // The element `element` has priority over any other element.
        forEach(ngAttrPrefixes, function(prefix) {
            var name = prefix + "app";
            if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
                appElement = element;
                module = element.getAttribute(name);
            }
        });
        forEach(ngAttrPrefixes, function(prefix) {
            var name = prefix + "app";
            var candidate;
            if (!appElement && (candidate = element.querySelector("[" + name.replace(":", "\\:") + "]"))) {
                appElement = candidate;
                module = candidate.getAttribute(name);
            }
        });
        if (appElement) {
            if (!isAutoBootstrapAllowed) {
                window1.console.error("AngularJS: disabling automatic bootstrap. <script> protocol indicates an extension, document.location.href does not match.");
                return;
            }
            config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
            bootstrap(appElement, module ? [
                module
            ] : [], config);
        }
    }
    /**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */ function bootstrap(element, modules, config) {
        if (!isObject(config)) config = {};
        var defaultConfig = {
            strictDi: false
        };
        config = extend(defaultConfig, config);
        var doBootstrap = function() {
            element = jqLite(element);
            if (element.injector()) {
                var tag = element[0] === window1.document ? "document" : startingTag(element);
                // Encode angle brackets to prevent input from being sanitized to empty string #8683.
                throw ngMinErr("btstrpd", "App already bootstrapped with this element '{0}'", tag.replace(/</, "&lt;").replace(/>/, "&gt;"));
            }
            modules = modules || [];
            modules.unshift([
                "$provide",
                function($provide) {
                    $provide.value("$rootElement", element);
                }
            ]);
            if (config.debugInfoEnabled) // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
            modules.push([
                "$compileProvider",
                function($compileProvider) {
                    $compileProvider.debugInfoEnabled(true);
                }
            ]);
            modules.unshift("ng");
            var injector = createInjector(modules, config.strictDi);
            injector.invoke([
                "$rootScope",
                "$rootElement",
                "$compile",
                "$injector",
                function bootstrapApply(scope, element, compile, injector) {
                    scope.$apply(function() {
                        element.data("$injector", injector);
                        compile(element)(scope);
                    });
                }
            ]);
            return injector;
        };
        var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
        var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
        if (window1 && NG_ENABLE_DEBUG_INFO.test(window1.name)) {
            config.debugInfoEnabled = true;
            window1.name = window1.name.replace(NG_ENABLE_DEBUG_INFO, "");
        }
        if (window1 && !NG_DEFER_BOOTSTRAP.test(window1.name)) return doBootstrap();
        window1.name = window1.name.replace(NG_DEFER_BOOTSTRAP, "");
        angular.resumeBootstrap = function(extraModules) {
            forEach(extraModules, function(module) {
                modules.push(module);
            });
            return doBootstrap();
        };
        if (isFunction(angular.resumeDeferredBootstrap)) angular.resumeDeferredBootstrap();
    }
    /**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */ function reloadWithDebugInfo() {
        window1.name = "NG_ENABLE_DEBUG_INFO!" + window1.name;
        window1.location.reload();
    }
    /**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */ function getTestability(rootElement) {
        var injector = angular.element(rootElement).injector();
        if (!injector) throw ngMinErr("test", "no injector found for element argument to getTestability");
        return injector.get("$$testability");
    }
    var SNAKE_CASE_REGEXP = /[A-Z]/g;
    function snake_case(name, separator) {
        separator = separator || "_";
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
            return (pos ? separator : "") + letter.toLowerCase();
        });
    }
    var bindJQueryFired = false;
    function bindJQuery() {
        var originalCleanData;
        if (bindJQueryFired) return;
        // bind to jQuery if present;
        var jqName = jq();
        jQuery = isUndefined(jqName) ? window1.jQuery : !jqName ? undefined : window1[jqName]; // use jQuery specified by `ngJq`
        // Use jQuery if it exists with proper functionality, otherwise default to us.
        // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
        // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
        // versions. It will not work for sure with jQuery <1.7, though.
        if (jQuery && jQuery.fn.on) {
            jqLite = jQuery;
            extend(jQuery.fn, {
                scope: JQLitePrototype.scope,
                isolateScope: JQLitePrototype.isolateScope,
                controller: /** @type {?} */ JQLitePrototype.controller,
                injector: JQLitePrototype.injector,
                inheritedData: JQLitePrototype.inheritedData
            });
        } else jqLite = JQLite;
        // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
        // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
        // the $destroy event on all removed nodes.
        originalCleanData = jqLite.cleanData;
        jqLite.cleanData = function(elems) {
            var events;
            for(var i = 0, elem; (elem = elems[i]) != null; i++){
                events = (jqLite._data(elem) || {}).events;
                if (events && events.$destroy) jqLite(elem).triggerHandler("$destroy");
            }
            originalCleanData(elems);
        };
        angular.element = jqLite;
        // Prevent double-proxying.
        bindJQueryFired = true;
    }
    /**
 * @ngdoc function
 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
 * @module ng
 * @kind function
 *
 * @description
 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
 * your code for this change and remove your use of this function as soon as possible.

 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 */ function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
        JQLite.legacyXHTMLReplacement = true;
    }
    /**
 * throw error if the argument is falsy.
 */ function assertArg(arg, name, reason) {
        if (!arg) throw ngMinErr("areq", "Argument '{0}' is {1}", name || "?", reason || "required");
        return arg;
    }
    function assertArgFn(arg, name, acceptArrayAnnotation) {
        if (acceptArrayAnnotation && isArray(arg)) arg = arg[arg.length - 1];
        assertArg(isFunction(arg), name, "not a function, got " + (arg && typeof arg === "object" ? arg.constructor.name || "Object" : typeof arg));
        return arg;
    }
    /**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */ function assertNotHasOwnProperty(name, context) {
        if (name === "hasOwnProperty") throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
    }
    /**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */ //TODO(misko): this function needs to be removed
    function getter(obj, path, bindFnToScope) {
        if (!path) return obj;
        var keys = path.split(".");
        var key;
        var lastInstance = obj;
        var len = keys.length;
        for(var i = 0; i < len; i++){
            key = keys[i];
            if (obj) obj = (lastInstance = obj)[key];
        }
        if (!bindFnToScope && isFunction(obj)) return bind(lastInstance, obj);
        return obj;
    }
    /**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */ function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;
        for(var i = 1; node !== endNode && (node = node.nextSibling); i++)if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) blockNodes = jqLite(slice.call(nodes, 0, i));
            blockNodes.push(node);
        }
        return blockNodes || nodes;
    }
    /**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */ function createMap() {
        return Object.create(null);
    }
    function stringify(value) {
        if (value == null) return "";
        switch(typeof value){
            case "string":
                break;
            case "number":
                value = "" + value;
                break;
            default:
                if (hasCustomToString(value) && !isArray(value) && !isDate(value)) value = value.toString();
                else value = toJson(value);
        }
        return value;
    }
    var NODE_TYPE_ELEMENT = 1;
    var NODE_TYPE_ATTRIBUTE = 2;
    var NODE_TYPE_TEXT = 3;
    var NODE_TYPE_COMMENT = 8;
    var NODE_TYPE_DOCUMENT = 9;
    var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
    /**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */ function setupModuleLoader(window1) {
        var $injectorMinErr = minErr("$injector");
        var ngMinErr = minErr("ng");
        function ensure(obj, name, factory) {
            return obj[name] || (obj[name] = factory());
        }
        var angular = ensure(window1, "angular", Object);
        // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
        angular.$$minErr = angular.$$minErr || minErr;
        return ensure(angular, "module", function() {
            /** @type {Object.<string, angular.Module>} */ var modules = {};
            /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */ return function module(name, requires, configFn) {
                var info = {};
                var assertNotHasOwnProperty = function(name, context) {
                    if (name === "hasOwnProperty") throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
                };
                assertNotHasOwnProperty(name, "module");
                if (requires && modules.hasOwnProperty(name)) modules[name] = null;
                return ensure(modules, name, function() {
                    if (!requires) throw $injectorMinErr("nomod", "Module '{0}' is not available! You either misspelled the module name or forgot to load it. If registering a module ensure that you specify the dependencies as the second argument.", name);
                    /** @type {!Array.<Array.<*>>} */ var invokeQueue = [];
                    /** @type {!Array.<Function>} */ var configBlocks = [];
                    /** @type {!Array.<Function>} */ var runBlocks = [];
                    var config = invokeLater("$injector", "invoke", "push", configBlocks);
                    /** @type {angular.Module} */ var moduleInstance = {
                        // Private state
                        _invokeQueue: invokeQueue,
                        _configBlocks: configBlocks,
                        _runBlocks: runBlocks,
                        /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */ info: function(value) {
                            if (isDefined(value)) {
                                if (!isObject(value)) throw ngMinErr("aobj", "Argument '{0}' must be an object", "value");
                                info = value;
                                return this;
                            }
                            return info;
                        },
                        /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */ requires: requires,
                        /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */ name: name,
                        /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */ provider: invokeLaterAndSetModuleName("$provide", "provider"),
                        /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */ factory: invokeLaterAndSetModuleName("$provide", "factory"),
                        /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */ service: invokeLaterAndSetModuleName("$provide", "service"),
                        /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */ value: invokeLater("$provide", "value"),
                        /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */ constant: invokeLater("$provide", "constant", "unshift"),
                        /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */ decorator: invokeLaterAndSetModuleName("$provide", "decorator", configBlocks),
                        /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */ animation: invokeLaterAndSetModuleName("$animateProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */ filter: invokeLaterAndSetModuleName("$filterProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */ controller: invokeLaterAndSetModuleName("$controllerProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */ directive: invokeLaterAndSetModuleName("$compileProvider", "directive"),
                        /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */ component: invokeLaterAndSetModuleName("$compileProvider", "component"),
                        /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */ config: config,
                        /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */ run: function(block) {
                            runBlocks.push(block);
                            return this;
                        }
                    };
                    if (configFn) config(configFn);
                    return moduleInstance;
                    /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */ function invokeLater(provider, method, insertMethod, queue) {
                        if (!queue) queue = invokeQueue;
                        return function() {
                            queue[insertMethod || "push"]([
                                provider,
                                method,
                                arguments
                            ]);
                            return moduleInstance;
                        };
                    }
                    /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */ function invokeLaterAndSetModuleName(provider, method, queue) {
                        if (!queue) queue = invokeQueue;
                        return function(recipeName, factoryFunction) {
                            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
                            queue.push([
                                provider,
                                method,
                                arguments
                            ]);
                            return moduleInstance;
                        };
                    }
                });
            };
        });
    }
    /* global shallowCopy: true */ /**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */ function shallowCopy(src, dst) {
        if (isArray(src)) {
            dst = dst || [];
            for(var i = 0, ii = src.length; i < ii; i++)dst[i] = src[i];
        } else if (isObject(src)) {
            dst = dst || {};
            for(var key in src)if (!(key.charAt(0) === "$" && key.charAt(1) === "$")) dst[key] = src[key];
        }
        return dst || src;
    }
    /* exported toDebugString */ function serializeObject(obj, maxDepth) {
        var seen = [];
        // There is no direct way to stringify object until reaching a specific depth
        // and a very deep object can cause a performance issue, so we copy the object
        // based on this specific depth and then stringify it.
        if (isValidObjectMaxDepth(maxDepth)) // This file is also included in `angular-loader`, so `copy()` might not always be available in
        // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
        obj = angular.copy(obj, null, maxDepth);
        return JSON.stringify(obj, function(key, val) {
            val = toJsonReplacer(key, val);
            if (isObject(val)) {
                if (seen.indexOf(val) >= 0) return "...";
                seen.push(val);
            }
            return val;
        });
    }
    function toDebugString(obj, maxDepth) {
        if (typeof obj === "function") return obj.toString().replace(/ \{[\s\S]*$/, "");
        else if (isUndefined(obj)) return "undefined";
        else if (typeof obj !== "string") return serializeObject(obj, maxDepth);
        return obj;
    }
    /* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  hiddenInputBrowserCacheDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/ /**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */ var version = {
        // These placeholder strings will be replaced by grunt's `build` task.
        // They need to be double- or single-quoted.
        full: "1.8.2",
        major: 1,
        minor: 8,
        dot: 2,
        codeName: "meteoric-mining"
    };
    function publishExternalAPI(angular) {
        extend(angular, {
            "errorHandlingConfig": errorHandlingConfig,
            "bootstrap": bootstrap,
            "copy": copy,
            "extend": extend,
            "merge": merge,
            "equals": equals,
            "element": jqLite,
            "forEach": forEach,
            "injector": createInjector,
            "noop": noop,
            "bind": bind,
            "toJson": toJson,
            "fromJson": fromJson,
            "identity": identity,
            "isUndefined": isUndefined,
            "isDefined": isDefined,
            "isString": isString,
            "isFunction": isFunction,
            "isObject": isObject,
            "isNumber": isNumber,
            "isElement": isElement,
            "isArray": isArray,
            "version": version,
            "isDate": isDate,
            "callbacks": {
                $$counter: 0
            },
            "getTestability": getTestability,
            "reloadWithDebugInfo": reloadWithDebugInfo,
            "UNSAFE_restoreLegacyJqLiteXHTMLReplacement": UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
            "$$minErr": minErr,
            "$$csp": csp,
            "$$encodeUriSegment": encodeUriSegment,
            "$$encodeUriQuery": encodeUriQuery,
            "$$lowercase": lowercase,
            "$$stringify": stringify,
            "$$uppercase": uppercase
        });
        angularModule = setupModuleLoader(window1);
        angularModule("ng", [
            "ngLocale"
        ], [
            "$provide",
            function ngModule($provide) {
                // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
                $provide.provider({
                    $$sanitizeUri: $$SanitizeUriProvider
                });
                $provide.provider("$compile", $CompileProvider).directive({
                    a: htmlAnchorDirective,
                    input: inputDirective,
                    textarea: inputDirective,
                    form: formDirective,
                    script: scriptDirective,
                    select: selectDirective,
                    option: optionDirective,
                    ngBind: ngBindDirective,
                    ngBindHtml: ngBindHtmlDirective,
                    ngBindTemplate: ngBindTemplateDirective,
                    ngClass: ngClassDirective,
                    ngClassEven: ngClassEvenDirective,
                    ngClassOdd: ngClassOddDirective,
                    ngCloak: ngCloakDirective,
                    ngController: ngControllerDirective,
                    ngForm: ngFormDirective,
                    ngHide: ngHideDirective,
                    ngIf: ngIfDirective,
                    ngInclude: ngIncludeDirective,
                    ngInit: ngInitDirective,
                    ngNonBindable: ngNonBindableDirective,
                    ngPluralize: ngPluralizeDirective,
                    ngRef: ngRefDirective,
                    ngRepeat: ngRepeatDirective,
                    ngShow: ngShowDirective,
                    ngStyle: ngStyleDirective,
                    ngSwitch: ngSwitchDirective,
                    ngSwitchWhen: ngSwitchWhenDirective,
                    ngSwitchDefault: ngSwitchDefaultDirective,
                    ngOptions: ngOptionsDirective,
                    ngTransclude: ngTranscludeDirective,
                    ngModel: ngModelDirective,
                    ngList: ngListDirective,
                    ngChange: ngChangeDirective,
                    pattern: patternDirective,
                    ngPattern: patternDirective,
                    required: requiredDirective,
                    ngRequired: requiredDirective,
                    minlength: minlengthDirective,
                    ngMinlength: minlengthDirective,
                    maxlength: maxlengthDirective,
                    ngMaxlength: maxlengthDirective,
                    ngValue: ngValueDirective,
                    ngModelOptions: ngModelOptionsDirective
                }).directive({
                    ngInclude: ngIncludeFillContentDirective,
                    input: hiddenInputBrowserCacheDirective
                }).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
                $provide.provider({
                    $anchorScroll: $AnchorScrollProvider,
                    $animate: $AnimateProvider,
                    $animateCss: $CoreAnimateCssProvider,
                    $$animateJs: $$CoreAnimateJsProvider,
                    $$animateQueue: $$CoreAnimateQueueProvider,
                    $$AnimateRunner: $$AnimateRunnerFactoryProvider,
                    $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
                    $browser: $BrowserProvider,
                    $cacheFactory: $CacheFactoryProvider,
                    $controller: $ControllerProvider,
                    $document: $DocumentProvider,
                    $$isDocumentHidden: $$IsDocumentHiddenProvider,
                    $exceptionHandler: $ExceptionHandlerProvider,
                    $filter: $FilterProvider,
                    $$forceReflow: $$ForceReflowProvider,
                    $interpolate: $InterpolateProvider,
                    $interval: $IntervalProvider,
                    $$intervalFactory: $$IntervalFactoryProvider,
                    $http: $HttpProvider,
                    $httpParamSerializer: $HttpParamSerializerProvider,
                    $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
                    $httpBackend: $HttpBackendProvider,
                    $xhrFactory: $xhrFactoryProvider,
                    $jsonpCallbacks: $jsonpCallbacksProvider,
                    $location: $LocationProvider,
                    $log: $LogProvider,
                    $parse: $ParseProvider,
                    $rootScope: $RootScopeProvider,
                    $q: $QProvider,
                    $$q: $$QProvider,
                    $sce: $SceProvider,
                    $sceDelegate: $SceDelegateProvider,
                    $sniffer: $SnifferProvider,
                    $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
                    $templateCache: $TemplateCacheProvider,
                    $templateRequest: $TemplateRequestProvider,
                    $$testability: $$TestabilityProvider,
                    $timeout: $TimeoutProvider,
                    $window: $WindowProvider,
                    $$rAF: $$RAFProvider,
                    $$jqLite: $$jqLiteProvider,
                    $$Map: $$MapProvider,
                    $$cookieReader: $$CookieReaderProvider
                });
            }
        ]).info({
            angularVersion: "1.8.2"
        });
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/ //////////////////////////////////
    //JQLite
    //////////////////////////////////
    /**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
 * ```js
 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
 * ```
 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */ JQLite.expando = "ng339";
    var jqCache = JQLite.cache = {}, jqId = 1;
    /*
 * !!! This is an undocumented "private" function !!!
 */ JQLite._data = function(node) {
        //jQuery always returns an object on cache miss
        return this.cache[node[this.expando]] || {};
    };
    function jqNextId() {
        return ++jqId;
    }
    var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
    var MS_HACK_REGEXP = /^-ms-/;
    var MOUSE_EVENT_MAP = {
        mouseleave: "mouseout",
        mouseenter: "mouseover"
    };
    var jqLiteMinErr = minErr("jqLite");
    /**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */ function cssKebabToCamel(name) {
        return kebabToCamel(name.replace(MS_HACK_REGEXP, "ms-"));
    }
    function fnCamelCaseReplace(all, letter) {
        return letter.toUpperCase();
    }
    /**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */ function kebabToCamel(name) {
        return name.replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
    }
    var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
    var HTML_REGEXP = /<|&#?\w+;/;
    var TAG_NAME_REGEXP = /<([\w:-]+)/;
    var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
    // Table parts need to be wrapped with `<table>` or they're
    // stripped to their contents when put in a div.
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do, so we cannot shorten
    // this by omitting <tbody> or other required elements.
    var wrapMap = {
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <10 only
    // IE 9 requires an option wrapper & it needs to have the whole table structure
    // set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
    var wrapMapIE9 = {
        option: [
            1,
            '<select multiple="multiple">',
            "</select>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    for(var key in wrapMap){
        var wrapMapValueClosing = wrapMap[key];
        var wrapMapValue = wrapMapValueClosing.slice().reverse();
        wrapMapIE9[key] = [
            wrapMapValue.length,
            "<" + wrapMapValue.join("><") + ">",
            "</" + wrapMapValueClosing.join("></") + ">"
        ];
    }
    wrapMapIE9.optgroup = wrapMapIE9.option;
    function jqLiteIsTextNode(html) {
        return !HTML_REGEXP.test(html);
    }
    function jqLiteAcceptsData(node) {
        // The window object can accept data but has no nodeType
        // Otherwise we are only interested in elements (1) and documents (9)
        var nodeType = node.nodeType;
        return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
    }
    function jqLiteHasData(node) {
        for(var key in jqCache[node.ng339])return true;
        return false;
    }
    function jqLiteBuildFragment(html, context) {
        var tmp, tag, wrap, finalHtml, fragment = context.createDocumentFragment(), nodes = [], i;
        if (jqLiteIsTextNode(html)) // Convert non-html into a text node
        nodes.push(context.createTextNode(html));
        else {
            // Convert html into DOM nodes
            tmp = fragment.appendChild(context.createElement("div"));
            tag = (TAG_NAME_REGEXP.exec(html) || [
                "",
                ""
            ])[1].toLowerCase();
            finalHtml = JQLite.legacyXHTMLReplacement ? html.replace(XHTML_TAG_REGEXP, "<$1></$2>") : html;
            if (msie < 10) {
                wrap = wrapMapIE9[tag] || wrapMapIE9._default;
                tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
                // Descend through wrappers to the right content
                i = wrap[0];
                while(i--)tmp = tmp.firstChild;
            } else {
                wrap = wrapMap[tag] || [];
                // Create wrappers & descend into them
                i = wrap.length;
                while(--i > -1){
                    tmp.appendChild(window1.document.createElement(wrap[i]));
                    tmp = tmp.firstChild;
                }
                tmp.innerHTML = finalHtml;
            }
            nodes = concat(nodes, tmp.childNodes);
            tmp = fragment.firstChild;
            tmp.textContent = "";
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        fragment.innerHTML = ""; // Clear inner HTML
        forEach(nodes, function(node) {
            fragment.appendChild(node);
        });
        return fragment;
    }
    function jqLiteParseHTML(html, context) {
        context = context || window1.document;
        var parsed;
        if (parsed = SINGLE_TAG_REGEXP.exec(html)) return [
            context.createElement(parsed[1])
        ];
        if (parsed = jqLiteBuildFragment(html, context)) return parsed.childNodes;
        return [];
    }
    function jqLiteWrapNode(node, wrapper) {
        var parent = node.parentNode;
        if (parent) parent.replaceChild(wrapper, node);
        wrapper.appendChild(node);
    }
    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var jqLiteContains = window1.Node.prototype.contains || /** @this */ function(arg) {
        // eslint-disable-next-line no-bitwise
        return !!(this.compareDocumentPosition(arg) & 16);
    };
    /////////////////////////////////////////////
    function JQLite(element) {
        if (element instanceof JQLite) return element;
        var argIsString;
        if (isString(element)) {
            element = trim(element);
            argIsString = true;
        }
        if (!(this instanceof JQLite)) {
            if (argIsString && element.charAt(0) !== "<") throw jqLiteMinErr("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");
            return new JQLite(element);
        }
        if (argIsString) jqLiteAddNodes(this, jqLiteParseHTML(element));
        else if (isFunction(element)) jqLiteReady(element);
        else jqLiteAddNodes(this, element);
    }
    function jqLiteClone(element) {
        return element.cloneNode(true);
    }
    function jqLiteDealoc(element, onlyDescendants) {
        if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([
            element
        ]);
        if (element.querySelectorAll) jqLite.cleanData(element.querySelectorAll("*"));
    }
    function isEmptyObject(obj) {
        var name;
        for(name in obj)return false;
        return true;
    }
    function removeIfEmptyData(element) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];
        var events = expandoStore && expandoStore.events;
        var data = expandoStore && expandoStore.data;
        if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
            delete jqCache[expandoId];
            element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
        }
    }
    function jqLiteOff(element, type, fn, unsupported) {
        if (isDefined(unsupported)) throw jqLiteMinErr("offargs", "jqLite#off() does not support the `selector` argument");
        var expandoStore = jqLiteExpandoStore(element);
        var events = expandoStore && expandoStore.events;
        var handle = expandoStore && expandoStore.handle;
        if (!handle) return; //no listeners registered
        if (!type) for(type in events){
            if (type !== "$destroy") element.removeEventListener(type, handle);
            delete events[type];
        }
        else {
            var removeHandler = function(type) {
                var listenerFns = events[type];
                if (isDefined(fn)) arrayRemove(listenerFns || [], fn);
                if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
                    element.removeEventListener(type, handle);
                    delete events[type];
                }
            };
            forEach(type.split(" "), function(type) {
                removeHandler(type);
                if (MOUSE_EVENT_MAP[type]) removeHandler(MOUSE_EVENT_MAP[type]);
            });
        }
        removeIfEmptyData(element);
    }
    function jqLiteRemoveData(element, name) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];
        if (expandoStore) {
            if (name) delete expandoStore.data[name];
            else expandoStore.data = {};
            removeIfEmptyData(element);
        }
    }
    function jqLiteExpandoStore(element, createIfNecessary) {
        var expandoId = element.ng339, expandoStore = expandoId && jqCache[expandoId];
        if (createIfNecessary && !expandoStore) {
            element.ng339 = expandoId = jqNextId();
            expandoStore = jqCache[expandoId] = {
                events: {},
                data: {},
                handle: undefined
            };
        }
        return expandoStore;
    }
    function jqLiteData(element, key, value) {
        if (jqLiteAcceptsData(element)) {
            var prop;
            var isSimpleSetter = isDefined(value);
            var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
            var massGetter = !key;
            var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
            var data = expandoStore && expandoStore.data;
            if (isSimpleSetter) data[kebabToCamel(key)] = value;
            else {
                if (massGetter) return data;
                else {
                    if (isSimpleGetter) // don't force creation of expandoStore if it doesn't exist yet
                    return data && data[kebabToCamel(key)];
                    else for(prop in key)data[kebabToCamel(prop)] = key[prop];
                }
            }
        }
    }
    function jqLiteHasClass(element, selector) {
        if (!element.getAttribute) return false;
        return (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").indexOf(" " + selector + " ") > -1;
    }
    function jqLiteRemoveClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
            var existingClasses = (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");
            var newClasses = existingClasses;
            forEach(cssClasses.split(" "), function(cssClass) {
                cssClass = trim(cssClass);
                newClasses = newClasses.replace(" " + cssClass + " ", " ");
            });
            if (newClasses !== existingClasses) element.setAttribute("class", trim(newClasses));
        }
    }
    function jqLiteAddClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
            var existingClasses = (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");
            var newClasses = existingClasses;
            forEach(cssClasses.split(" "), function(cssClass) {
                cssClass = trim(cssClass);
                if (newClasses.indexOf(" " + cssClass + " ") === -1) newClasses += cssClass + " ";
            });
            if (newClasses !== existingClasses) element.setAttribute("class", trim(newClasses));
        }
    }
    function jqLiteAddNodes(root, elements) {
        // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
        if (elements) {
            // if a Node (the most common case)
            if (elements.nodeType) root[root.length++] = elements;
            else {
                var length = elements.length;
                // if an Array or NodeList and not a Window
                if (typeof length === "number" && elements.window !== elements) {
                    if (length) for(var i = 0; i < length; i++)root[root.length++] = elements[i];
                } else root[root.length++] = elements;
            }
        }
    }
    function jqLiteController(element, name) {
        return jqLiteInheritedData(element, "$" + (name || "ngController") + "Controller");
    }
    function jqLiteInheritedData(element, name, value) {
        // if element is the document object work with the html element instead
        // this makes $(document).scope() possible
        if (element.nodeType === NODE_TYPE_DOCUMENT) element = element.documentElement;
        var names = isArray(name) ? name : [
            name
        ];
        while(element){
            for(var i = 0, ii = names.length; i < ii; i++){
                if (isDefined(value = jqLite.data(element, names[i]))) return value;
            }
            // If dealing with a document fragment node with a host element, and no parent, use the host
            // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
            // to lookup parent controllers.
            element = element.parentNode || element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host;
        }
    }
    function jqLiteEmpty(element) {
        jqLiteDealoc(element, true);
        while(element.firstChild)element.removeChild(element.firstChild);
    }
    function jqLiteRemove(element, keepData) {
        if (!keepData) jqLiteDealoc(element);
        var parent = element.parentNode;
        if (parent) parent.removeChild(element);
    }
    function jqLiteDocumentLoaded(action, win) {
        win = win || window1;
        if (win.document.readyState === "complete") // Force the action to be run async for consistent behavior
        // from the action's point of view
        // i.e. it will definitely not be in a $apply
        win.setTimeout(action);
        else // No need to unbind this handler as load is only ever called once
        jqLite(win).on("load", action);
    }
    function jqLiteReady(fn) {
        function trigger() {
            window1.document.removeEventListener("DOMContentLoaded", trigger);
            window1.removeEventListener("load", trigger);
            fn();
        }
        // check if document is already loaded
        if (window1.document.readyState === "complete") window1.setTimeout(fn);
        else {
            // We can not use jqLite since we are not done loading and jQuery could be loaded later.
            // Works for modern browsers and IE9
            window1.document.addEventListener("DOMContentLoaded", trigger);
            // Fallback to window.onload for others
            window1.addEventListener("load", trigger);
        }
    }
    //////////////////////////////////////////
    // Functions which are declared directly.
    //////////////////////////////////////////
    var JQLitePrototype = JQLite.prototype = {
        ready: jqLiteReady,
        toString: function() {
            var value = [];
            forEach(this, function(e) {
                value.push("" + e);
            });
            return "[" + value.join(", ") + "]";
        },
        eq: function(index) {
            return index >= 0 ? jqLite(this[index]) : jqLite(this[this.length + index]);
        },
        length: 0,
        push: push,
        sort: [].sort,
        splice: [].splice
    };
    //////////////////////////////////////////
    // Functions iterating getter/setters.
    // these functions return self on setter and
    // value on get.
    //////////////////////////////////////////
    var BOOLEAN_ATTR = {};
    forEach("multiple,selected,checked,disabled,readOnly,required,open".split(","), function(value) {
        BOOLEAN_ATTR[lowercase(value)] = value;
    });
    var BOOLEAN_ELEMENTS = {};
    forEach("input,select,option,textarea,button,form,details".split(","), function(value) {
        BOOLEAN_ELEMENTS[value] = true;
    });
    var ALIASED_ATTR = {
        "ngMinlength": "minlength",
        "ngMaxlength": "maxlength",
        "ngMin": "min",
        "ngMax": "max",
        "ngPattern": "pattern",
        "ngStep": "step"
    };
    function getBooleanAttrName(element, name) {
        // check dom last since we will most likely fail on name
        var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
        // booleanAttr is here twice to minimize DOM access
        return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
    }
    function getAliasedAttrName(name) {
        return ALIASED_ATTR[name];
    }
    forEach({
        data: jqLiteData,
        removeData: jqLiteRemoveData,
        hasData: jqLiteHasData,
        cleanData: function jqLiteCleanData(nodes) {
            for(var i = 0, ii = nodes.length; i < ii; i++){
                jqLiteRemoveData(nodes[i]);
                jqLiteOff(nodes[i]);
            }
        }
    }, function(fn, name) {
        JQLite[name] = fn;
    });
    forEach({
        data: jqLiteData,
        inheritedData: jqLiteInheritedData,
        scope: function(element) {
            // Can't use jqLiteData here directly so we stay compatible with jQuery!
            return jqLite.data(element, "$scope") || jqLiteInheritedData(element.parentNode || element, [
                "$isolateScope",
                "$scope"
            ]);
        },
        isolateScope: function(element) {
            // Can't use jqLiteData here directly so we stay compatible with jQuery!
            return jqLite.data(element, "$isolateScope") || jqLite.data(element, "$isolateScopeNoTemplate");
        },
        controller: jqLiteController,
        injector: function(element) {
            return jqLiteInheritedData(element, "$injector");
        },
        removeAttr: function(element, name) {
            element.removeAttribute(name);
        },
        hasClass: jqLiteHasClass,
        css: function(element, name, value) {
            name = cssKebabToCamel(name);
            if (isDefined(value)) element.style[name] = value;
            else return element.style[name];
        },
        attr: function(element, name, value) {
            var ret;
            var nodeType = element.nodeType;
            if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT || !element.getAttribute) return;
            var lowercasedName = lowercase(name);
            var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
            if (isDefined(value)) {
                // setter
                if (value === null || value === false && isBooleanAttr) element.removeAttribute(name);
                else element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
            } else {
                // getter
                ret = element.getAttribute(name);
                if (isBooleanAttr && ret !== null) ret = lowercasedName;
                // Normalize non-existing attributes to undefined (as jQuery).
                return ret === null ? undefined : ret;
            }
        },
        prop: function(element, name, value) {
            if (isDefined(value)) element[name] = value;
            else return element[name];
        },
        text: function() {
            getText.$dv = "";
            return getText;
            function getText(element, value) {
                if (isUndefined(value)) {
                    var nodeType = element.nodeType;
                    return nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT ? element.textContent : "";
                }
                element.textContent = value;
            }
        }(),
        val: function(element, value) {
            if (isUndefined(value)) {
                if (element.multiple && nodeName_(element) === "select") {
                    var result = [];
                    forEach(element.options, function(option) {
                        if (option.selected) result.push(option.value || option.text);
                    });
                    return result;
                }
                return element.value;
            }
            element.value = value;
        },
        html: function(element, value) {
            if (isUndefined(value)) return element.innerHTML;
            jqLiteDealoc(element, true);
            element.innerHTML = value;
        },
        empty: jqLiteEmpty
    }, function(fn, name) {
        /**
   * Properties: writes return selection, reads return first value
   */ JQLite.prototype[name] = function(arg1, arg2) {
            var i, key;
            var nodeCount = this.length;
            // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
            // in a way that survives minification.
            // jqLiteEmpty takes no arguments but is a setter.
            if (fn !== jqLiteEmpty && isUndefined(fn.length === 2 && fn !== jqLiteHasClass && fn !== jqLiteController ? arg1 : arg2)) {
                if (isObject(arg1)) {
                    // we are a write, but the object properties are the key/values
                    for(i = 0; i < nodeCount; i++){
                        if (fn === jqLiteData) // data() takes the whole object in jQuery
                        fn(this[i], arg1);
                        else for(key in arg1)fn(this[i], key, arg1[key]);
                    }
                    // return self for chaining
                    return this;
                } else {
                    // we are a read, so read the first child.
                    // TODO: do we still need this?
                    var value = fn.$dv;
                    // Only if we have $dv do we iterate over all, otherwise it is just the first element.
                    var jj = isUndefined(value) ? Math.min(nodeCount, 1) : nodeCount;
                    for(var j = 0; j < jj; j++){
                        var nodeValue = fn(this[j], arg1, arg2);
                        value = value ? value + nodeValue : nodeValue;
                    }
                    return value;
                }
            } else {
                // we are a write, so apply to all children
                for(i = 0; i < nodeCount; i++)fn(this[i], arg1, arg2);
                // return self for chaining
                return this;
            }
        };
    });
    function createEventHandler(element, events) {
        var eventHandler = function(event, type) {
            // jQuery specific api
            event.isDefaultPrevented = function() {
                return event.defaultPrevented;
            };
            var eventFns = events[type || event.type];
            var eventFnsLength = eventFns ? eventFns.length : 0;
            if (!eventFnsLength) return;
            if (isUndefined(event.immediatePropagationStopped)) {
                var originalStopImmediatePropagation = event.stopImmediatePropagation;
                event.stopImmediatePropagation = function() {
                    event.immediatePropagationStopped = true;
                    if (event.stopPropagation) event.stopPropagation();
                    if (originalStopImmediatePropagation) originalStopImmediatePropagation.call(event);
                };
            }
            event.isImmediatePropagationStopped = function() {
                return event.immediatePropagationStopped === true;
            };
            // Some events have special handlers that wrap the real handler
            var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
            // Copy event handlers in case event handlers array is modified during execution.
            if (eventFnsLength > 1) eventFns = shallowCopy(eventFns);
            for(var i = 0; i < eventFnsLength; i++)if (!event.isImmediatePropagationStopped()) handlerWrapper(element, event, eventFns[i]);
        };
        // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
        //       events on `element`
        eventHandler.elem = element;
        return eventHandler;
    }
    function defaultHandlerWrapper(element, event, handler) {
        handler.call(element, event);
    }
    function specialMouseHandlerWrapper(target, event, handler) {
        // Refer to jQuery's implementation of mouseenter & mouseleave
        // Read about mouseenter and mouseleave:
        // http://www.quirksmode.org/js/events_mouse.html#link8
        var related = event.relatedTarget;
        // For mousenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if (!related || related !== target && !jqLiteContains.call(target, related)) handler.call(target, event);
    }
    //////////////////////////////////////////
    // Functions iterating traversal.
    // These functions chain results into a single
    // selector.
    //////////////////////////////////////////
    forEach({
        removeData: jqLiteRemoveData,
        on: function jqLiteOn(element, type, fn, unsupported) {
            if (isDefined(unsupported)) throw jqLiteMinErr("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");
            // Do not add event handlers to non-elements because they will not be cleaned up.
            if (!jqLiteAcceptsData(element)) return;
            var expandoStore = jqLiteExpandoStore(element, true);
            var events = expandoStore.events;
            var handle = expandoStore.handle;
            if (!handle) handle = expandoStore.handle = createEventHandler(element, events);
            // http://jsperf.com/string-indexof-vs-split
            var types = type.indexOf(" ") >= 0 ? type.split(" ") : [
                type
            ];
            var i = types.length;
            var addHandler = function(type, specialHandlerWrapper, noEventListener) {
                var eventFns = events[type];
                if (!eventFns) {
                    eventFns = events[type] = [];
                    eventFns.specialHandlerWrapper = specialHandlerWrapper;
                    if (type !== "$destroy" && !noEventListener) element.addEventListener(type, handle);
                }
                eventFns.push(fn);
            };
            while(i--){
                type = types[i];
                if (MOUSE_EVENT_MAP[type]) {
                    addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
                    addHandler(type, undefined, true);
                } else addHandler(type);
            }
        },
        off: jqLiteOff,
        one: function(element, type, fn) {
            element = jqLite(element);
            //add the listener twice so that when it is called
            //you can remove the original function and still be
            //able to call element.off(ev, fn) normally
            element.on(type, function onFn() {
                element.off(type, fn);
                element.off(type, onFn);
            });
            element.on(type, fn);
        },
        replaceWith: function(element, replaceNode) {
            var index, parent = element.parentNode;
            jqLiteDealoc(element);
            forEach(new JQLite(replaceNode), function(node) {
                if (index) parent.insertBefore(node, index.nextSibling);
                else parent.replaceChild(node, element);
                index = node;
            });
        },
        children: function(element) {
            var children = [];
            forEach(element.childNodes, function(element) {
                if (element.nodeType === NODE_TYPE_ELEMENT) children.push(element);
            });
            return children;
        },
        contents: function(element) {
            return element.contentDocument || element.childNodes || [];
        },
        append: function(element, node) {
            var nodeType = element.nodeType;
            if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
            node = new JQLite(node);
            for(var i = 0, ii = node.length; i < ii; i++){
                var child = node[i];
                element.appendChild(child);
            }
        },
        prepend: function(element, node) {
            if (element.nodeType === NODE_TYPE_ELEMENT) {
                var index = element.firstChild;
                forEach(new JQLite(node), function(child) {
                    element.insertBefore(child, index);
                });
            }
        },
        wrap: function(element, wrapNode) {
            jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
        },
        remove: jqLiteRemove,
        detach: function(element) {
            jqLiteRemove(element, true);
        },
        after: function(element, newElement) {
            var index = element, parent = element.parentNode;
            if (parent) {
                newElement = new JQLite(newElement);
                for(var i = 0, ii = newElement.length; i < ii; i++){
                    var node = newElement[i];
                    parent.insertBefore(node, index.nextSibling);
                    index = node;
                }
            }
        },
        addClass: jqLiteAddClass,
        removeClass: jqLiteRemoveClass,
        toggleClass: function(element, selector, condition) {
            if (selector) forEach(selector.split(" "), function(className) {
                var classCondition = condition;
                if (isUndefined(classCondition)) classCondition = !jqLiteHasClass(element, className);
                (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
            });
        },
        parent: function(element) {
            var parent = element.parentNode;
            return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
        },
        next: function(element) {
            return element.nextElementSibling;
        },
        find: function(element, selector) {
            if (element.getElementsByTagName) return element.getElementsByTagName(selector);
            else return [];
        },
        clone: jqLiteClone,
        triggerHandler: function(element, event, extraParameters) {
            var dummyEvent, eventFnsCopy, handlerArgs;
            var eventName = event.type || event;
            var expandoStore = jqLiteExpandoStore(element);
            var events = expandoStore && expandoStore.events;
            var eventFns = events && events[eventName];
            if (eventFns) {
                // Create a dummy event to pass to the handlers
                dummyEvent = {
                    preventDefault: function() {
                        this.defaultPrevented = true;
                    },
                    isDefaultPrevented: function() {
                        return this.defaultPrevented === true;
                    },
                    stopImmediatePropagation: function() {
                        this.immediatePropagationStopped = true;
                    },
                    isImmediatePropagationStopped: function() {
                        return this.immediatePropagationStopped === true;
                    },
                    stopPropagation: noop,
                    type: eventName,
                    target: element
                };
                // If a custom event was provided then extend our dummy event with it
                if (event.type) dummyEvent = extend(dummyEvent, event);
                // Copy event handlers in case event handlers array is modified during execution.
                eventFnsCopy = shallowCopy(eventFns);
                handlerArgs = extraParameters ? [
                    dummyEvent
                ].concat(extraParameters) : [
                    dummyEvent
                ];
                forEach(eventFnsCopy, function(fn) {
                    if (!dummyEvent.isImmediatePropagationStopped()) fn.apply(element, handlerArgs);
                });
            }
        }
    }, function(fn, name) {
        /**
   * chaining functions
   */ JQLite.prototype[name] = function(arg1, arg2, arg3) {
            var value;
            for(var i = 0, ii = this.length; i < ii; i++)if (isUndefined(value)) {
                value = fn(this[i], arg1, arg2, arg3);
                if (isDefined(value)) // any function which returns a value needs to be wrapped
                value = jqLite(value);
            } else jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
            return isDefined(value) ? value : this;
        };
    });
    // bind legacy bind/unbind to on/off
    JQLite.prototype.bind = JQLite.prototype.on;
    JQLite.prototype.unbind = JQLite.prototype.off;
    // Provider for private $$jqLite service
    /** @this */ function $$jqLiteProvider() {
        this.$get = function $$jqLite() {
            return extend(JQLite, {
                hasClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteHasClass(node, classes);
                },
                addClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteAddClass(node, classes);
                },
                removeClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteRemoveClass(node, classes);
                }
            });
        };
    }
    /**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */ function hashKey(obj, nextUidFn) {
        var key = obj && obj.$$hashKey;
        if (key) {
            if (typeof key === "function") key = obj.$$hashKey();
            return key;
        }
        var objType = typeof obj;
        if (objType === "function" || objType === "object" && obj !== null) key = obj.$$hashKey = objType + ":" + (nextUidFn || nextUid)();
        else key = objType + ":" + obj;
        return key;
    }
    // A minimal ES2015 Map implementation.
    // Should be bug/feature equivalent to the native implementations of supported browsers
    // (for the features required in Angular).
    // See https://kangax.github.io/compat-table/es6/#test-Map
    var nanKey = Object.create(null);
    function NgMapShim() {
        this._keys = [];
        this._values = [];
        this._lastKey = NaN;
        this._lastIndex = -1;
    }
    NgMapShim.prototype = {
        _idx: function(key) {
            if (key !== this._lastKey) {
                this._lastKey = key;
                this._lastIndex = this._keys.indexOf(key);
            }
            return this._lastIndex;
        },
        _transformKey: function(key) {
            return isNumberNaN(key) ? nanKey : key;
        },
        get: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx !== -1) return this._values[idx];
        },
        has: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            return idx !== -1;
        },
        set: function(key, value) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx === -1) idx = this._lastIndex = this._keys.length;
            this._keys[idx] = key;
            this._values[idx] = value;
        // Support: IE11
        // Do not `return this` to simulate the partial IE11 implementation
        },
        delete: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx === -1) return false;
            this._keys.splice(idx, 1);
            this._values.splice(idx, 1);
            this._lastKey = NaN;
            this._lastIndex = -1;
            return true;
        }
    };
    // For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
    // are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
    // implementations get more stable, we can reconsider switching to `window.Map` (when available).
    var NgMap = NgMapShim;
    var $$MapProvider = [
        /** @this */ function() {
            this.$get = [
                function() {
                    return NgMap;
                }
            ];
        }
    ];
    /**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */ /**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */ var ARROW_ARG = /^([^(]+?)=>/;
    var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
    var FN_ARG_SPLIT = /,/;
    var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
    var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
    var $injectorMinErr = minErr("$injector");
    function stringifyFn(fn) {
        return Function.prototype.toString.call(fn);
    }
    function extractArgs(fn) {
        var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ""), args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
        return args;
    }
    function anonFn(fn) {
        // For anonymous functions, showing at the very least the function signature can help in
        // debugging.
        var args = extractArgs(fn);
        if (args) return "function(" + (args[1] || "").replace(/[\s\r\n]+/, " ") + ")";
        return "fn";
    }
    function annotate(fn, strictDi, name) {
        var $inject, argDecl, last;
        if (typeof fn === "function") {
            if (!($inject = fn.$inject)) {
                $inject = [];
                if (fn.length) {
                    if (strictDi) {
                        if (!isString(name) || !name) name = fn.name || anonFn(fn);
                        throw $injectorMinErr("strictdi", "{0} is not using explicit annotation and cannot be invoked in strict mode", name);
                    }
                    argDecl = extractArgs(fn);
                    forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
                        arg.replace(FN_ARG, function(all, underscore, name) {
                            $inject.push(name);
                        });
                    });
                }
                fn.$inject = $inject;
            }
        } else if (isArray(fn)) {
            last = fn.length - 1;
            assertArgFn(fn[last], "fn");
            $inject = fn.slice(0, last);
        } else assertArgFn(fn, "fn", true);
        return $inject;
    }
    ///////////////////////////////////////
    /**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */ /**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */ /**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */ /**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */ /**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */ /**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */ /**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */ /**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */ /**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */ /**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */ function createInjector(modulesToLoad, strictDi) {
        strictDi = strictDi === true;
        var INSTANTIATING = {}, providerSuffix = "Provider", path = [], loadedModules = new NgMap(), providerCache = {
            $provide: {
                provider: supportObject(provider),
                factory: supportObject(factory),
                service: supportObject(service),
                value: supportObject(value),
                constant: supportObject(constant),
                decorator: decorator
            }
        }, providerInjector = providerCache.$injector = createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) path.push(caller);
            throw $injectorMinErr("unpr", "Unknown provider: {0}", path.join(" <- "));
        }), instanceCache = {}, protoInstanceInjector = createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
        }), instanceInjector = protoInstanceInjector;
        providerCache["$injector" + providerSuffix] = {
            $get: valueFn(protoInstanceInjector)
        };
        instanceInjector.modules = providerInjector.modules = createMap();
        var runBlocks = loadModules(modulesToLoad);
        instanceInjector = protoInstanceInjector.get("$injector");
        instanceInjector.strictDi = strictDi;
        forEach(runBlocks, function(fn) {
            if (fn) instanceInjector.invoke(fn);
        });
        instanceInjector.loadNewModules = function(mods) {
            forEach(loadModules(mods), function(fn) {
                if (fn) instanceInjector.invoke(fn);
            });
        };
        return instanceInjector;
        ////////////////////////////////////
        // $provider
        ////////////////////////////////////
        function supportObject(delegate) {
            return function(key, value) {
                if (isObject(key)) forEach(key, reverseParams(delegate));
                else return delegate(key, value);
            };
        }
        function provider(name, provider_) {
            assertNotHasOwnProperty(name, "service");
            if (isFunction(provider_) || isArray(provider_)) provider_ = providerInjector.instantiate(provider_);
            if (!provider_.$get) throw $injectorMinErr("pget", "Provider '{0}' must define $get factory method.", name);
            return providerCache[name + providerSuffix] = provider_;
        }
        function enforceReturnValue(name, factory) {
            return /** @this */ function enforcedReturnValue() {
                var result = instanceInjector.invoke(factory, this);
                if (isUndefined(result)) throw $injectorMinErr("undef", "Provider '{0}' must return a value from $get factory method.", name);
                return result;
            };
        }
        function factory(name, factoryFn, enforce) {
            return provider(name, {
                $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
            });
        }
        function service(name, constructor) {
            return factory(name, [
                "$injector",
                function($injector) {
                    return $injector.instantiate(constructor);
                }
            ]);
        }
        function value(name, val) {
            return factory(name, valueFn(val), false);
        }
        function constant(name, value) {
            assertNotHasOwnProperty(name, "constant");
            providerCache[name] = value;
            instanceCache[name] = value;
        }
        function decorator(serviceName, decorFn) {
            var origProvider = providerInjector.get(serviceName + providerSuffix), orig$get = origProvider.$get;
            origProvider.$get = function() {
                var origInstance = instanceInjector.invoke(orig$get, origProvider);
                return instanceInjector.invoke(decorFn, null, {
                    $delegate: origInstance
                });
            };
        }
        ////////////////////////////////////
        // Module Loading
        ////////////////////////////////////
        function loadModules(modulesToLoad) {
            assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), "modulesToLoad", "not an array");
            var runBlocks = [], moduleFn;
            forEach(modulesToLoad, function(module) {
                if (loadedModules.get(module)) return;
                loadedModules.set(module, true);
                function runInvokeQueue(queue) {
                    var i, ii;
                    for(i = 0, ii = queue.length; i < ii; i++){
                        var invokeArgs = queue[i], provider = providerInjector.get(invokeArgs[0]);
                        provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                    }
                }
                try {
                    if (isString(module)) {
                        moduleFn = angularModule(module);
                        instanceInjector.modules[module] = moduleFn;
                        runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
                        runInvokeQueue(moduleFn._invokeQueue);
                        runInvokeQueue(moduleFn._configBlocks);
                    } else if (isFunction(module)) runBlocks.push(providerInjector.invoke(module));
                    else if (isArray(module)) runBlocks.push(providerInjector.invoke(module));
                    else assertArgFn(module, "module");
                } catch (e) {
                    if (isArray(module)) module = module[module.length - 1];
                    if (e.message && e.stack && e.stack.indexOf(e.message) === -1) // Safari & FF's stack traces don't contain error.message content
                    // unlike those of Chrome and IE
                    // So if stack doesn't contain message, we create a new string that contains both.
                    // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
                    // eslint-disable-next-line no-ex-assign
                    e = e.message + "\n" + e.stack;
                    throw $injectorMinErr("modulerr", "Failed to instantiate module {0} due to:\n{1}", module, e.stack || e.message || e);
                }
            });
            return runBlocks;
        }
        ////////////////////////////////////
        // internal Injector
        ////////////////////////////////////
        function createInternalInjector(cache, factory) {
            function getService(serviceName, caller) {
                if (cache.hasOwnProperty(serviceName)) {
                    if (cache[serviceName] === INSTANTIATING) throw $injectorMinErr("cdep", "Circular dependency found: {0}", serviceName + " <- " + path.join(" <- "));
                    return cache[serviceName];
                } else try {
                    path.unshift(serviceName);
                    cache[serviceName] = INSTANTIATING;
                    cache[serviceName] = factory(serviceName, caller);
                    return cache[serviceName];
                } catch (err) {
                    if (cache[serviceName] === INSTANTIATING) delete cache[serviceName];
                    throw err;
                } finally{
                    path.shift();
                }
            }
            function injectionArgs(fn, locals, serviceName) {
                var args = [], $inject = createInjector.$$annotate(fn, strictDi, serviceName);
                for(var i = 0, length = $inject.length; i < length; i++){
                    var key = $inject[i];
                    if (typeof key !== "string") throw $injectorMinErr("itkn", "Incorrect injection token! Expected service name as string, got {0}", key);
                    args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
                }
                return args;
            }
            function isClass(func) {
                // Support: IE 9-11 only
                // IE 9-11 do not support classes and IE9 leaks with the code below.
                if (msie || typeof func !== "function") return false;
                var result = func.$$ngIsClass;
                if (!isBoolean(result)) result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
                return result;
            }
            function invoke(fn, self, locals, serviceName) {
                if (typeof locals === "string") {
                    serviceName = locals;
                    locals = null;
                }
                var args = injectionArgs(fn, locals, serviceName);
                if (isArray(fn)) fn = fn[fn.length - 1];
                if (!isClass(fn)) // http://jsperf.com/angularjs-invoke-apply-vs-switch
                // #5388
                return fn.apply(self, args);
                else {
                    args.unshift(null);
                    return new (Function.prototype.bind.apply(fn, args))();
                }
            }
            function instantiate(Type, locals, serviceName) {
                // Check if Type is annotated and use just the given function at n-1 as parameter
                // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
                var ctor = isArray(Type) ? Type[Type.length - 1] : Type;
                var args = injectionArgs(Type, locals, serviceName);
                // Empty object at position 0 is ignored for invocation with `new`, but required.
                args.unshift(null);
                return new (Function.prototype.bind.apply(ctor, args))();
            }
            return {
                invoke: invoke,
                instantiate: instantiate,
                get: getService,
                annotate: createInjector.$$annotate,
                has: function(name) {
                    return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
                }
            };
        }
    }
    createInjector.$$annotate = annotate;
    /**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */ function $AnchorScrollProvider() {
        var autoScrollingEnabled = true;
        /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */ this.disableAutoScrolling = function() {
            autoScrollingEnabled = false;
        };
        /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */ this.$get = [
            "$window",
            "$location",
            "$rootScope",
            function($window, $location, $rootScope) {
                var document1 = $window.document;
                // Helper function to get first anchor from a NodeList
                // (using `Array#some()` instead of `angular#forEach()` since it's more performant
                //  and working in all supported browsers.)
                function getFirstAnchor(list) {
                    var result = null;
                    Array.prototype.some.call(list, function(element) {
                        if (nodeName_(element) === "a") {
                            result = element;
                            return true;
                        }
                    });
                    return result;
                }
                function getYOffset() {
                    var offset = scroll.yOffset;
                    if (isFunction(offset)) offset = offset();
                    else if (isElement(offset)) {
                        var elem = offset[0];
                        var style = $window.getComputedStyle(elem);
                        if (style.position !== "fixed") offset = 0;
                        else offset = elem.getBoundingClientRect().bottom;
                    } else if (!isNumber(offset)) offset = 0;
                    return offset;
                }
                function scrollTo(elem) {
                    if (elem) {
                        elem.scrollIntoView();
                        var offset = getYOffset();
                        if (offset) {
                            // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
                            // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
                            // top of the viewport.
                            //
                            // IF the number of pixels from the top of `elem` to the end of the page's content is less
                            // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
                            // way down the page.
                            //
                            // This is often the case for elements near the bottom of the page.
                            //
                            // In such cases we do not need to scroll the whole `offset` up, just the difference between
                            // the top of the element and the offset, which is enough to align the top of `elem` at the
                            // desired position.
                            var elemTop = elem.getBoundingClientRect().top;
                            $window.scrollBy(0, elemTop - offset);
                        }
                    } else $window.scrollTo(0, 0);
                }
                function scroll(hash) {
                    // Allow numeric hashes
                    hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
                    var elm;
                    // empty hash, scroll to the top of the page
                    if (!hash) scrollTo(null);
                    else if (elm = document1.getElementById(hash)) scrollTo(elm);
                    else if (elm = getFirstAnchor(document1.getElementsByName(hash))) scrollTo(elm);
                    else if (hash === "top") scrollTo(null);
                }
                // does not scroll when user clicks on anchor link that is currently on
                // (no url change, no $location.hash() change), browser native does scroll
                if (autoScrollingEnabled) $rootScope.$watch(function autoScrollWatch() {
                    return $location.hash();
                }, function autoScrollWatchAction(newVal, oldVal) {
                    // skip the initial scroll if $location.hash is empty
                    if (newVal === oldVal && newVal === "") return;
                    jqLiteDocumentLoaded(function() {
                        $rootScope.$evalAsync(scroll);
                    });
                });
                return scroll;
            }
        ];
    }
    var $animateMinErr = minErr("$animate");
    var ELEMENT_NODE = 1;
    var NG_ANIMATE_CLASSNAME = "ng-animate";
    function mergeClasses(a, b) {
        if (!a && !b) return "";
        if (!a) return b;
        if (!b) return a;
        if (isArray(a)) a = a.join(" ");
        if (isArray(b)) b = b.join(" ");
        return a + " " + b;
    }
    function extractElementNode(element) {
        for(var i = 0; i < element.length; i++){
            var elm = element[i];
            if (elm.nodeType === ELEMENT_NODE) return elm;
        }
    }
    function splitClasses(classes) {
        if (isString(classes)) classes = classes.split(" ");
        // Use createMap() to prevent class assumptions involving property names in
        // Object.prototype
        var obj = createMap();
        forEach(classes, function(klass) {
            // sometimes the split leaves empty string values
            // incase extra spaces were applied to the options
            if (klass.length) obj[klass] = true;
        });
        return obj;
    }
    // if any other type of options value besides an Object value is
    // passed into the $animate.method() animation then this helper code
    // will be run which will ignore it. While this patch is not the
    // greatest solution to this, a lot of existing plugins depend on
    // $animate to either call the callback (< 1.2) or return a promise
    // that can be changed. This helper function ensures that the options
    // are wiped clean incase a callback function is provided.
    function prepareAnimateOptions(options) {
        return isObject(options) ? options : {};
    }
    var $$CoreAnimateJsProvider = /** @this */ function() {
        this.$get = noop;
    };
    // this is prefixed with Core since it conflicts with
    // the animateQueueProvider defined in ngAnimate/animateQueue.js
    var $$CoreAnimateQueueProvider = /** @this */ function() {
        var postDigestQueue = new NgMap();
        var postDigestElements = [];
        this.$get = [
            "$$AnimateRunner",
            "$rootScope",
            function($$AnimateRunner, $rootScope) {
                return {
                    enabled: noop,
                    on: noop,
                    off: noop,
                    pin: noop,
                    push: function(element, event, options, domOperation) {
                        if (domOperation) domOperation();
                        options = options || {};
                        if (options.from) element.css(options.from);
                        if (options.to) element.css(options.to);
                        if (options.addClass || options.removeClass) addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
                        var runner = new $$AnimateRunner();
                        // since there are no animations to run the runner needs to be
                        // notified that the animation call is complete.
                        runner.complete();
                        return runner;
                    }
                };
                function updateData(data, classes, value) {
                    var changed = false;
                    if (classes) {
                        classes = isString(classes) ? classes.split(" ") : isArray(classes) ? classes : [];
                        forEach(classes, function(className) {
                            if (className) {
                                changed = true;
                                data[className] = value;
                            }
                        });
                    }
                    return changed;
                }
                function handleCSSClassChanges() {
                    forEach(postDigestElements, function(element) {
                        var data = postDigestQueue.get(element);
                        if (data) {
                            var existing = splitClasses(element.attr("class"));
                            var toAdd = "";
                            var toRemove = "";
                            forEach(data, function(status, className) {
                                var hasClass = !!existing[className];
                                if (status !== hasClass) {
                                    if (status) toAdd += (toAdd.length ? " " : "") + className;
                                    else toRemove += (toRemove.length ? " " : "") + className;
                                }
                            });
                            forEach(element, function(elm) {
                                if (toAdd) jqLiteAddClass(elm, toAdd);
                                if (toRemove) jqLiteRemoveClass(elm, toRemove);
                            });
                            postDigestQueue.delete(element);
                        }
                    });
                    postDigestElements.length = 0;
                }
                function addRemoveClassesPostDigest(element, add, remove) {
                    var data = postDigestQueue.get(element) || {};
                    var classesAdded = updateData(data, add, true);
                    var classesRemoved = updateData(data, remove, false);
                    if (classesAdded || classesRemoved) {
                        postDigestQueue.set(element, data);
                        postDigestElements.push(element);
                        if (postDigestElements.length === 1) $rootScope.$$postDigest(handleCSSClassChanges);
                    }
                }
            }
        ];
    };
    /**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */ var $AnimateProvider = [
        "$provide",
        /** @this */ function($provide) {
            var provider = this;
            var classNameFilter = null;
            var customFilter = null;
            this.$$registeredAnimations = Object.create(null);
            /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */ this.register = function(name, factory) {
                if (name && name.charAt(0) !== ".") throw $animateMinErr("notcsel", "Expecting class selector starting with '.' got '{0}'.", name);
                var key = name + "-animation";
                provider.$$registeredAnimations[name.substr(1)] = key;
                $provide.factory(key, factory);
            };
            /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */ this.customFilter = function(filterFn) {
                if (arguments.length === 1) customFilter = isFunction(filterFn) ? filterFn : null;
                return customFilter;
            };
            /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */ this.classNameFilter = function(expression) {
                if (arguments.length === 1) {
                    classNameFilter = expression instanceof RegExp ? expression : null;
                    if (classNameFilter) {
                        var reservedRegex = new RegExp("[(\\s|\\/)]" + NG_ANIMATE_CLASSNAME + "[(\\s|\\/)]");
                        if (reservedRegex.test(classNameFilter.toString())) {
                            classNameFilter = null;
                            throw $animateMinErr("nongcls", '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
                        }
                    }
                }
                return classNameFilter;
            };
            this.$get = [
                "$$animateQueue",
                function($$animateQueue) {
                    function domInsert(element, parentElement, afterElement) {
                        // if for some reason the previous element was removed
                        // from the dom sometime before this code runs then let's
                        // just stick to using the parent element as the anchor
                        if (afterElement) {
                            var afterNode = extractElementNode(afterElement);
                            if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) afterElement = null;
                        }
                        if (afterElement) afterElement.after(element);
                        else parentElement.prepend(element);
                    }
                    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */ return {
                        // we don't call it directly since non-existant arguments may
                        // be interpreted as null within the sub enabled function
                        /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */ on: $$animateQueue.on,
                        /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */ off: $$animateQueue.off,
                        /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */ pin: $$animateQueue.pin,
                        /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */ enabled: $$animateQueue.enabled,
                        /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */ cancel: function(runner) {
                            if (runner.cancel) runner.cancel();
                        },
                        /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ enter: function(element, parent, after, options) {
                            parent = parent && jqLite(parent);
                            after = after && jqLite(after);
                            parent = parent || after.parent();
                            domInsert(element, parent, after);
                            return $$animateQueue.push(element, "enter", prepareAnimateOptions(options));
                        },
                        /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ move: function(element, parent, after, options) {
                            parent = parent && jqLite(parent);
                            after = after && jqLite(after);
                            parent = parent || after.parent();
                            domInsert(element, parent, after);
                            return $$animateQueue.push(element, "move", prepareAnimateOptions(options));
                        },
                        /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ leave: function(element, options) {
                            return $$animateQueue.push(element, "leave", prepareAnimateOptions(options), function() {
                                element.remove();
                            });
                        },
                        /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */ addClass: function(element, className, options) {
                            options = prepareAnimateOptions(options);
                            options.addClass = mergeClasses(options.addclass, className);
                            return $$animateQueue.push(element, "addClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ removeClass: function(element, className, options) {
                            options = prepareAnimateOptions(options);
                            options.removeClass = mergeClasses(options.removeClass, className);
                            return $$animateQueue.push(element, "removeClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ setClass: function(element, add, remove, options) {
                            options = prepareAnimateOptions(options);
                            options.addClass = mergeClasses(options.addClass, add);
                            options.removeClass = mergeClasses(options.removeClass, remove);
                            return $$animateQueue.push(element, "setClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ animate: function(element, from, to, className, options) {
                            options = prepareAnimateOptions(options);
                            options.from = options.from ? extend(options.from, from) : from;
                            options.to = options.to ? extend(options.to, to) : to;
                            className = className || "ng-inline-animate";
                            options.tempClasses = mergeClasses(options.tempClasses, className);
                            return $$animateQueue.push(element, "animate", options);
                        }
                    };
                }
            ];
        }
    ];
    var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
        this.$get = [
            "$$rAF",
            function($$rAF) {
                var waitQueue = [];
                function waitForTick(fn) {
                    waitQueue.push(fn);
                    if (waitQueue.length > 1) return;
                    $$rAF(function() {
                        for(var i = 0; i < waitQueue.length; i++)waitQueue[i]();
                        waitQueue = [];
                    });
                }
                return function() {
                    var passed = false;
                    waitForTick(function() {
                        passed = true;
                    });
                    return function(callback) {
                        if (passed) callback();
                        else waitForTick(callback);
                    };
                };
            }
        ];
    };
    var $$AnimateRunnerFactoryProvider = /** @this */ function() {
        this.$get = [
            "$q",
            "$sniffer",
            "$$animateAsyncRun",
            "$$isDocumentHidden",
            "$timeout",
            function($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {
                var INITIAL_STATE = 0;
                var DONE_PENDING_STATE = 1;
                var DONE_COMPLETE_STATE = 2;
                AnimateRunner.chain = function(chain, callback) {
                    var index = 0;
                    next();
                    function next() {
                        if (index === chain.length) {
                            callback(true);
                            return;
                        }
                        chain[index](function(response) {
                            if (response === false) {
                                callback(false);
                                return;
                            }
                            index++;
                            next();
                        });
                    }
                };
                AnimateRunner.all = function(runners, callback) {
                    var count = 0;
                    var status = true;
                    forEach(runners, function(runner) {
                        runner.done(onProgress);
                    });
                    function onProgress(response) {
                        status = status && response;
                        if (++count === runners.length) callback(status);
                    }
                };
                function AnimateRunner(host) {
                    this.setHost(host);
                    var rafTick = $$animateAsyncRun();
                    var timeoutTick = function(fn) {
                        $timeout(fn, 0, false);
                    };
                    this._doneCallbacks = [];
                    this._tick = function(fn) {
                        if ($$isDocumentHidden()) timeoutTick(fn);
                        else rafTick(fn);
                    };
                    this._state = 0;
                }
                AnimateRunner.prototype = {
                    setHost: function(host) {
                        this.host = host || {};
                    },
                    done: function(fn) {
                        if (this._state === DONE_COMPLETE_STATE) fn();
                        else this._doneCallbacks.push(fn);
                    },
                    progress: noop,
                    getPromise: function() {
                        if (!this.promise) {
                            var self = this;
                            this.promise = $q(function(resolve, reject) {
                                self.done(function(status) {
                                    if (status === false) reject();
                                    else resolve();
                                });
                            });
                        }
                        return this.promise;
                    },
                    then: function(resolveHandler, rejectHandler) {
                        return this.getPromise().then(resolveHandler, rejectHandler);
                    },
                    "catch": function(handler) {
                        return this.getPromise()["catch"](handler);
                    },
                    "finally": function(handler) {
                        return this.getPromise()["finally"](handler);
                    },
                    pause: function() {
                        if (this.host.pause) this.host.pause();
                    },
                    resume: function() {
                        if (this.host.resume) this.host.resume();
                    },
                    end: function() {
                        if (this.host.end) this.host.end();
                        this._resolve(true);
                    },
                    cancel: function() {
                        if (this.host.cancel) this.host.cancel();
                        this._resolve(false);
                    },
                    complete: function(response) {
                        var self = this;
                        if (self._state === INITIAL_STATE) {
                            self._state = DONE_PENDING_STATE;
                            self._tick(function() {
                                self._resolve(response);
                            });
                        }
                    },
                    _resolve: function(response) {
                        if (this._state !== DONE_COMPLETE_STATE) {
                            forEach(this._doneCallbacks, function(fn) {
                                fn(response);
                            });
                            this._doneCallbacks.length = 0;
                            this._state = DONE_COMPLETE_STATE;
                        }
                    }
                };
                return AnimateRunner;
            }
        ];
    };
    /* exported $CoreAnimateCssProvider */ /**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */ var $CoreAnimateCssProvider = function() {
        this.$get = [
            "$$rAF",
            "$q",
            "$$AnimateRunner",
            function($$rAF, $q, $$AnimateRunner) {
                return function(element, initialOptions) {
                    // all of the animation functions should create
                    // a copy of the options data, however, if a
                    // parent service has already created a copy then
                    // we should stick to using that
                    var options = initialOptions || {};
                    if (!options.$$prepared) options = copy(options);
                    // there is no point in applying the styles since
                    // there is no animation that goes on at all in
                    // this version of $animateCss.
                    if (options.cleanupStyles) options.from = options.to = null;
                    if (options.from) {
                        element.css(options.from);
                        options.from = null;
                    }
                    var closed, runner = new $$AnimateRunner();
                    return {
                        start: run,
                        end: run
                    };
                    function run() {
                        $$rAF(function() {
                            applyAnimationContents();
                            if (!closed) runner.complete();
                            closed = true;
                        });
                        return runner;
                    }
                    function applyAnimationContents() {
                        if (options.addClass) {
                            element.addClass(options.addClass);
                            options.addClass = null;
                        }
                        if (options.removeClass) {
                            element.removeClass(options.removeClass);
                            options.removeClass = null;
                        }
                        if (options.to) {
                            element.css(options.to);
                            options.to = null;
                        }
                    }
                };
            }
        ];
    };
    /* global getHash: true, stripHash: false */ function getHash(url) {
        var index = url.indexOf("#");
        return index === -1 ? "" : url.substr(index);
    }
    function trimEmptyHash(url) {
        return url.replace(/#$/, "");
    }
    /**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */ /**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */ function Browser(window1, document1, $log, $sniffer, $$taskTrackerFactory) {
        var self = this, location = window1.location, history = window1.history, setTimeout = window1.setTimeout, clearTimeout = window1.clearTimeout, pendingDeferIds = {}, taskTracker = $$taskTrackerFactory($log);
        self.isMock = false;
        //////////////////////////////////////////////////////////////
        // Task-tracking API
        //////////////////////////////////////////////////////////////
        // TODO(vojta): remove this temporary api
        self.$$completeOutstandingRequest = taskTracker.completeTask;
        self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
        // TODO(vojta): prefix this method with $$ ?
        self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
        //////////////////////////////////////////////////////////////
        // URL API
        //////////////////////////////////////////////////////////////
        var cachedState, lastHistoryState, lastBrowserUrl = location.href, baseElement = document1.find("base"), pendingLocation = null, getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
            try {
                return history.state;
            } catch (e) {
            // MSIE can reportedly throw when there is no state (UNCONFIRMED).
            }
        };
        cacheState();
        /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */ self.url = function(url, replace, state) {
            // In modern browsers `history.state` is `null` by default; treating it separately
            // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
            // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
            if (isUndefined(state)) state = null;
            // Android Browser BFCache causes location, history reference to become stale.
            if (location !== window1.location) location = window1.location;
            if (history !== window1.history) history = window1.history;
            // setter
            if (url) {
                var sameState = lastHistoryState === state;
                // Normalize the inputted URL
                url = urlResolve(url).href;
                // Don't change anything if previous and current URLs and states match. This also prevents
                // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
                // See https://github.com/angular/angular.js/commit/ffb2701
                if (lastBrowserUrl === url && (!$sniffer.history || sameState)) return self;
                var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
                lastBrowserUrl = url;
                lastHistoryState = state;
                // Don't use history API if only the hash changed
                // due to a bug in IE10/IE11 which leads
                // to not firing a `hashchange` nor `popstate` event
                // in some cases (see #9143).
                if ($sniffer.history && (!sameBase || !sameState)) {
                    history[replace ? "replaceState" : "pushState"](state, "", url);
                    cacheState();
                } else {
                    if (!sameBase) pendingLocation = url;
                    if (replace) location.replace(url);
                    else if (!sameBase) location.href = url;
                    else location.hash = getHash(url);
                    if (location.href !== url) pendingLocation = url;
                }
                if (pendingLocation) pendingLocation = url;
                return self;
            // getter
            } else // - pendingLocation is needed as browsers don't allow to read out
            //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
            //   https://openradar.appspot.com/22186109).
            return trimEmptyHash(pendingLocation || location.href);
        };
        /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */ self.state = function() {
            return cachedState;
        };
        var urlChangeListeners = [], urlChangeInit = false;
        function cacheStateAndFireUrlChange() {
            pendingLocation = null;
            fireStateOrUrlChange();
        }
        // This variable should be used *only* inside the cacheState function.
        var lastCachedState = null;
        function cacheState() {
            // This should be the only place in $browser where `history.state` is read.
            cachedState = getCurrentState();
            cachedState = isUndefined(cachedState) ? null : cachedState;
            // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
            if (equals(cachedState, lastCachedState)) cachedState = lastCachedState;
            lastCachedState = cachedState;
            lastHistoryState = cachedState;
        }
        function fireStateOrUrlChange() {
            var prevLastHistoryState = lastHistoryState;
            cacheState();
            if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) return;
            lastBrowserUrl = self.url();
            lastHistoryState = cachedState;
            forEach(urlChangeListeners, function(listener) {
                listener(self.url(), cachedState);
            });
        }
        /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */ self.onUrlChange = function(callback) {
            // TODO(vojta): refactor to use node's syntax for events
            if (!urlChangeInit) {
                // We listen on both (hashchange/popstate) when available, as some browsers don't
                // fire popstate when user changes the address bar and don't fire hashchange when url
                // changed by push/replaceState
                // html5 history api - popstate event
                if ($sniffer.history) jqLite(window1).on("popstate", cacheStateAndFireUrlChange);
                // hashchange event
                jqLite(window1).on("hashchange", cacheStateAndFireUrlChange);
                urlChangeInit = true;
            }
            urlChangeListeners.push(callback);
            return callback;
        };
        /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */ self.$$applicationDestroyed = function() {
            jqLite(window1).off("hashchange popstate", cacheStateAndFireUrlChange);
        };
        /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */ self.$$checkUrlChange = fireStateOrUrlChange;
        //////////////////////////////////////////////////////////////
        // Misc API
        //////////////////////////////////////////////////////////////
        /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */ self.baseHref = function() {
            var href = baseElement.attr("href");
            return href ? href.replace(/^(https?:)?\/\/[^/]*/, "") : "";
        };
        /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */ self.defer = function(fn, delay, taskType) {
            var timeoutId;
            delay = delay || 0;
            taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
            taskTracker.incTaskCount(taskType);
            timeoutId = setTimeout(function() {
                delete pendingDeferIds[timeoutId];
                taskTracker.completeTask(fn, taskType);
            }, delay);
            pendingDeferIds[timeoutId] = taskType;
            return timeoutId;
        };
        /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */ self.defer.cancel = function(deferId) {
            if (pendingDeferIds.hasOwnProperty(deferId)) {
                var taskType = pendingDeferIds[deferId];
                delete pendingDeferIds[deferId];
                clearTimeout(deferId);
                taskTracker.completeTask(noop, taskType);
                return true;
            }
            return false;
        };
    }
    /** @this */ function $BrowserProvider() {
        this.$get = [
            "$window",
            "$log",
            "$sniffer",
            "$document",
            "$$taskTrackerFactory",
            function($window, $log, $sniffer, $document, $$taskTrackerFactory) {
                return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */ function $CacheFactoryProvider() {
        this.$get = function() {
            var caches = {};
            function cacheFactory(cacheId, options) {
                if (cacheId in caches) throw minErr("$cacheFactory")("iid", "CacheId '{0}' is already taken!", cacheId);
                var size = 0, stats = extend({}, options, {
                    id: cacheId
                }), data = createMap(), capacity = options && options.capacity || Number.MAX_VALUE, lruHash = createMap(), freshEnd = null, staleEnd = null;
                /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */ return caches[cacheId] = {
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */ put: function(key, value) {
                        if (isUndefined(value)) return;
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key] || (lruHash[key] = {
                                key: key
                            });
                            refresh(lruEntry);
                        }
                        if (!(key in data)) size++;
                        data[key] = value;
                        if (size > capacity) this.remove(staleEnd.key);
                        return value;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */ get: function(key) {
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key];
                            if (!lruEntry) return;
                            refresh(lruEntry);
                        }
                        return data[key];
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */ remove: function(key) {
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key];
                            if (!lruEntry) return;
                            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
                            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
                            link(lruEntry.n, lruEntry.p);
                            delete lruHash[key];
                        }
                        if (!(key in data)) return;
                        delete data[key];
                        size--;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */ removeAll: function() {
                        data = createMap();
                        size = 0;
                        lruHash = createMap();
                        freshEnd = staleEnd = null;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */ destroy: function() {
                        data = null;
                        stats = null;
                        lruHash = null;
                        delete caches[cacheId];
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */ info: function() {
                        return extend({}, stats, {
                            size: size
                        });
                    }
                };
                /**
       * makes the `entry` the freshEnd of the LRU linked list
       */ function refresh(entry) {
                    if (entry !== freshEnd) {
                        if (!staleEnd) staleEnd = entry;
                        else if (staleEnd === entry) staleEnd = entry.n;
                        link(entry.n, entry.p);
                        link(entry, freshEnd);
                        freshEnd = entry;
                        freshEnd.n = null;
                    }
                }
                /**
       * bidirectionally links two entries of the LRU linked list
       */ function link(nextEntry, prevEntry) {
                    if (nextEntry !== prevEntry) {
                        if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
                        if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
                    }
                }
            }
            /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */ cacheFactory.info = function() {
                var info = {};
                forEach(caches, function(cache, cacheId) {
                    info[cacheId] = cache.info();
                });
                return info;
            };
            /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */ cacheFactory.get = function(cacheId) {
                return caches[cacheId];
            };
            return cacheFactory;
        };
    }
    /**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */ function $TemplateCacheProvider() {
        this.$get = [
            "$cacheFactory",
            function($cacheFactory) {
                return $cacheFactory("templates");
            }
        ];
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */ /**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance.)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that are defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // Configure new 'compile' directive by passing a directive
        // factory function. The factory function injects '$compile'.
        $compileProvider.directive('compile', function($compile) {
          // The directive factory creates a link function.
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                // Watch the 'compile' expression for changes.
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // When the 'compile' expression changes
                // assign it into the current DOM.
                element.html(value);

                // Compile the new DOM and link it to the current scope.
                // NOTE: we only compile '.childNodes' so that we
                // don't get into an infinite loop compiling ourselves.
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
 *        elements (e.g. SVG elements). See also the `directive.controller` property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to `$digest`, which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = angular.element('<p>{{total}}</p>');
 *     $compile(element)(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
 *   linking function:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>');
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       // Attach the clone to DOM document at the right place.
 *     });
 *
 *     // Now we have reference to the cloned DOM via `clonedElement`.
 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
 *     //       `clonedElement` passed to `cloneAttachFn`.
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */ /**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */ /** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */ var $compileMinErr = minErr("$compile");
    function UNINITIALIZED_VALUE() {}
    var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
    /**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */ $CompileProvider.$inject = [
        "$provide",
        "$$sanitizeUriProvider"
    ];
    /** @this */ function $CompileProvider($provide, $$sanitizeUriProvider) {
        var hasDirectives = {}, Suffix = "Directive", COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/, CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/, ALL_OR_NOTHING_ATTRS = makeMap("ngSrc,ngSrcset,src,srcset"), REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
        // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
        // The assumption is that future DOM event attribute names will begin with
        // 'on' and be composed of only English letters.
        var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
        var bindingCache = createMap();
        function parseIsolateBindings(scope, directiveName, isController) {
            var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
            var bindings = createMap();
            forEach(scope, function(definition, scopeName) {
                definition = definition.trim();
                if (definition in bindingCache) {
                    bindings[scopeName] = bindingCache[definition];
                    return;
                }
                var match = definition.match(LOCAL_REGEXP);
                if (!match) throw $compileMinErr("iscp", "Invalid {3} for directive '{0}'. Definition: {... {1}: '{2}' ...}", directiveName, scopeName, definition, isController ? "controller bindings definition" : "isolate scope definition");
                bindings[scopeName] = {
                    mode: match[1][0],
                    collection: match[2] === "*",
                    optional: match[3] === "?",
                    attrName: match[4] || scopeName
                };
                if (match[4]) bindingCache[definition] = bindings[scopeName];
            });
            return bindings;
        }
        function parseDirectiveBindings(directive, directiveName) {
            var bindings = {
                isolateScope: null,
                bindToController: null
            };
            if (isObject(directive.scope)) {
                if (directive.bindToController === true) {
                    bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
                    bindings.isolateScope = {};
                } else bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
            }
            if (isObject(directive.bindToController)) bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
            if (bindings.bindToController && !directive.controller) // There is no controller
            throw $compileMinErr("noctrl", "Cannot bind to controller without directive '{0}'s controller.", directiveName);
            return bindings;
        }
        function assertValidDirectiveName(name) {
            var letter = name.charAt(0);
            if (!letter || letter !== lowercase(letter)) throw $compileMinErr("baddir", "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
            if (name !== name.trim()) throw $compileMinErr("baddir", "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces", name);
        }
        function getDirectiveRequire(directive) {
            var require = directive.require || directive.controller && directive.name;
            if (!isArray(require) && isObject(require)) forEach(require, function(value, key) {
                var match = value.match(REQUIRE_PREFIX_REGEXP);
                var name = value.substring(match[0].length);
                if (!name) require[key] = match[0] + key;
            });
            return require;
        }
        function getDirectiveRestrict(restrict, name) {
            if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) throw $compileMinErr("badrestrict", "Restrict property '{0}' of directive '{1}' is invalid", restrict, name);
            return restrict || "EA";
        }
        /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
   *    are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */ this.directive = function registerDirective(name, directiveFactory) {
            assertArg(name, "name");
            assertNotHasOwnProperty(name, "directive");
            if (isString(name)) {
                assertValidDirectiveName(name);
                assertArg(directiveFactory, "directiveFactory");
                if (!hasDirectives.hasOwnProperty(name)) {
                    hasDirectives[name] = [];
                    $provide.factory(name + Suffix, [
                        "$injector",
                        "$exceptionHandler",
                        function($injector, $exceptionHandler) {
                            var directives = [];
                            forEach(hasDirectives[name], function(directiveFactory, index) {
                                try {
                                    var directive = $injector.invoke(directiveFactory);
                                    if (isFunction(directive)) directive = {
                                        compile: valueFn(directive)
                                    };
                                    else if (!directive.compile && directive.link) directive.compile = valueFn(directive.link);
                                    directive.priority = directive.priority || 0;
                                    directive.index = index;
                                    directive.name = directive.name || name;
                                    directive.require = getDirectiveRequire(directive);
                                    directive.restrict = getDirectiveRestrict(directive.restrict, name);
                                    directive.$$moduleName = directiveFactory.$$moduleName;
                                    directives.push(directive);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            });
                            return directives;
                        }
                    ]);
                }
                hasDirectives[name].push(directiveFactory);
            } else forEach(name, reverseParams(registerDirective));
            return this;
        };
        /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */ this.component = function registerComponent(name, options) {
            if (!isString(name)) {
                forEach(name, reverseParams(bind(this, registerComponent)));
                return this;
            }
            var controller = options.controller || function() {};
            function factory($injector) {
                function makeInjectable(fn) {
                    if (isFunction(fn) || isArray(fn)) return /** @this */ function(tElement, tAttrs) {
                        return $injector.invoke(fn, this, {
                            $element: tElement,
                            $attrs: tAttrs
                        });
                    };
                    else return fn;
                }
                var template = !options.template && !options.templateUrl ? "" : options.template;
                var ddo = {
                    controller: controller,
                    controllerAs: identifierForController(options.controller) || options.controllerAs || "$ctrl",
                    template: makeInjectable(template),
                    templateUrl: makeInjectable(options.templateUrl),
                    transclude: options.transclude,
                    scope: {},
                    bindToController: options.bindings || {},
                    restrict: "E",
                    require: options.require
                };
                // Copy annotations (starting with $) over to the DDO
                forEach(options, function(val, key) {
                    if (key.charAt(0) === "$") ddo[key] = val;
                });
                return ddo;
            }
            // TODO(pete) remove the following `forEach` before we release 1.6.0
            // The component-router@0.2.0 looks for the annotations on the controller constructor
            // Nothing in AngularJS looks for annotations on the factory function but we can't remove
            // it from 1.5.x yet.
            // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
            // These could be used by libraries such as the new component router
            forEach(options, function(val, key) {
                if (key.charAt(0) === "$") {
                    factory[key] = val;
                    // Don't try to copy over annotations to named controller
                    if (isFunction(controller)) controller[key] = val;
                }
            });
            factory.$inject = [
                "$injector"
            ];
            return this.directive(name, factory);
        };
        /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.aHrefSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
                return this;
            } else return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
        };
        /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
   * aHrefSanitizationTrustedUrlList} instead.
   */ Object.defineProperty(this, "aHrefSanitizationWhitelist", {
            get: function() {
                return this.aHrefSanitizationTrustedUrlList;
            },
            set: function(value) {
                this.aHrefSanitizationTrustedUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.imgSrcSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
                return this;
            } else return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
        };
        /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
   * imgSrcSanitizationTrustedUrlList} instead.
   */ Object.defineProperty(this, "imgSrcSanitizationWhitelist", {
            get: function() {
                return this.imgSrcSanitizationTrustedUrlList;
            },
            set: function(value) {
                this.imgSrcSanitizationTrustedUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */ var debugInfoEnabled = true;
        this.debugInfoEnabled = function(enabled) {
            if (isDefined(enabled)) {
                debugInfoEnabled = enabled;
                return this;
            }
            return debugInfoEnabled;
        };
        /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */ var strictComponentBindingsEnabled = false;
        this.strictComponentBindingsEnabled = function(enabled) {
            if (isDefined(enabled)) {
                strictComponentBindingsEnabled = enabled;
                return this;
            }
            return strictComponentBindingsEnabled;
        };
        var TTL = 10;
        /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */ this.onChangesTtl = function(value) {
            if (arguments.length) {
                TTL = value;
                return this;
            }
            return TTL;
        };
        var commentDirectivesEnabledConfig = true;
        /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */ this.commentDirectivesEnabled = function(value) {
            if (arguments.length) {
                commentDirectivesEnabledConfig = value;
                return this;
            }
            return commentDirectivesEnabledConfig;
        };
        var cssClassDirectivesEnabledConfig = true;
        /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */ this.cssClassDirectivesEnabled = function(value) {
            if (arguments.length) {
                cssClassDirectivesEnabledConfig = value;
                return this;
            }
            return cssClassDirectivesEnabledConfig;
        };
        /**
   * The security context of DOM Properties.
   * @private
   */ var PROP_CONTEXTS = createMap();
        /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */ this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
            var key = elementName.toLowerCase() + "|" + propertyName.toLowerCase();
            if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) throw $compileMinErr("ctxoverride", "Property context '{0}.{1}' already set to '{2}', cannot override to '{3}'.", elementName, propertyName, PROP_CONTEXTS[key], ctx);
            PROP_CONTEXTS[key] = ctx;
            return this;
        };
        /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */ (function registerNativePropertyContexts() {
            function registerContext(ctx, values) {
                forEach(values, function(v) {
                    PROP_CONTEXTS[v.toLowerCase()] = ctx;
                });
            }
            registerContext(SCE_CONTEXTS.HTML, [
                "iframe|srcdoc",
                "*|innerHTML",
                "*|outerHTML"
            ]);
            registerContext(SCE_CONTEXTS.CSS, [
                "*|style"
            ]);
            registerContext(SCE_CONTEXTS.URL, [
                "area|href",
                "area|ping",
                "a|href",
                "a|ping",
                "blockquote|cite",
                "body|background",
                "del|cite",
                "input|src",
                "ins|cite",
                "q|cite"
            ]);
            registerContext(SCE_CONTEXTS.MEDIA_URL, [
                "audio|src",
                "img|src",
                "img|srcset",
                "source|src",
                "source|srcset",
                "track|src",
                "video|src",
                "video|poster"
            ]);
            registerContext(SCE_CONTEXTS.RESOURCE_URL, [
                "*|formAction",
                "applet|code",
                "applet|codebase",
                "base|href",
                "embed|src",
                "frame|src",
                "form|action",
                "head|profile",
                "html|manifest",
                "iframe|src",
                "link|href",
                "media|src",
                "object|codebase",
                "object|data",
                "script|src"
            ]);
        })();
        this.$get = [
            "$injector",
            "$interpolate",
            "$exceptionHandler",
            "$templateRequest",
            "$parse",
            "$controller",
            "$rootScope",
            "$sce",
            "$animate",
            function($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate) {
                var SIMPLE_ATTR_NAME = /^\w/;
                var specialAttrHolder = window1.document.createElement("div");
                var commentDirectivesEnabled = commentDirectivesEnabledConfig;
                var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
                var onChangesTtl = TTL;
                // The onChanges hooks should all be run together in a single digest
                // When changes occur, the call to trigger their hooks will be added to this queue
                var onChangesQueue;
                // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
                function flushOnChangesQueue() {
                    try {
                        if (!--onChangesTtl) {
                            // We have hit the TTL limit so reset everything
                            onChangesQueue = undefined;
                            throw $compileMinErr("infchng", "{0} $onChanges() iterations reached. Aborting!\n", TTL);
                        }
                        // We must run this hook in an apply since the $$postDigest runs outside apply
                        $rootScope.$apply(function() {
                            for(var i = 0, ii = onChangesQueue.length; i < ii; ++i)try {
                                onChangesQueue[i]();
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            // Reset the queue to trigger a new schedule next time there is a change
                            onChangesQueue = undefined;
                        });
                    } finally{
                        onChangesTtl++;
                    }
                }
                function sanitizeSrcset(value, invokeType) {
                    if (!value) return value;
                    if (!isString(value)) throw $compileMinErr("srcset", 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
                    // Such values are a bit too complex to handle automatically inside $sce.
                    // Instead, we sanitize each of the URIs individually, which works, even dynamically.
                    // It's not possible to work around this using `$sce.trustAsMediaUrl`.
                    // If you want to programmatically set explicitly trusted unsafe URLs, you should use
                    // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
                    // `ng-bind-html` directive.
                    var result = "";
                    // first check if there are spaces because it's not the same pattern
                    var trimmedSrcset = trim(value);
                    //                (   999x   ,|   999w   ,|   ,|,   )
                    var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
                    var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
                    // split srcset into tuple of uri and descriptor except for the last item
                    var rawUris = trimmedSrcset.split(pattern);
                    // for each tuples
                    var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
                    for(var i = 0; i < nbrUrisWith2parts; i++){
                        var innerIdx = i * 2;
                        // sanitize the uri
                        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
                        // add the descriptor
                        result += " " + trim(rawUris[innerIdx + 1]);
                    }
                    // split the last item into uri and descriptor
                    var lastTuple = trim(rawUris[i * 2]).split(/\s/);
                    // sanitize the last uri
                    result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
                    // and add the last descriptor if any
                    if (lastTuple.length === 2) result += " " + trim(lastTuple[1]);
                    return result;
                }
                function Attributes(element, attributesToCopy) {
                    if (attributesToCopy) {
                        var keys = Object.keys(attributesToCopy);
                        var i, l, key;
                        for(i = 0, l = keys.length; i < l; i++){
                            key = keys[i];
                            this[key] = attributesToCopy[key];
                        }
                    } else this.$attr = {};
                    this.$$element = element;
                }
                Attributes.prototype = {
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */ $normalize: directiveNormalize,
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */ $addClass: function(classVal) {
                        if (classVal && classVal.length > 0) $animate.addClass(this.$$element, classVal);
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */ $removeClass: function(classVal) {
                        if (classVal && classVal.length > 0) $animate.removeClass(this.$$element, classVal);
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */ $updateClass: function(newClasses, oldClasses) {
                        var toAdd = tokenDifference(newClasses, oldClasses);
                        if (toAdd && toAdd.length) $animate.addClass(this.$$element, toAdd);
                        var toRemove = tokenDifference(oldClasses, newClasses);
                        if (toRemove && toRemove.length) $animate.removeClass(this.$$element, toRemove);
                    },
                    /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */ $set: function(key, value, writeAttr, attrName) {
                        // TODO: decide whether or not to throw an error if "class"
                        // is set through this function since it may cause $updateClass to
                        // become unstable.
                        var node = this.$$element[0], booleanKey = getBooleanAttrName(node, key), aliasedKey = getAliasedAttrName(key), observer = key, nodeName;
                        if (booleanKey) {
                            this.$$element.prop(key, value);
                            attrName = booleanKey;
                        } else if (aliasedKey) {
                            this[aliasedKey] = value;
                            observer = aliasedKey;
                        }
                        this[key] = value;
                        // translate normalized key to actual key
                        if (attrName) this.$attr[key] = attrName;
                        else {
                            attrName = this.$attr[key];
                            if (!attrName) this.$attr[key] = attrName = snake_case(key, "-");
                        }
                        nodeName = nodeName_(this.$$element);
                        // Sanitize img[srcset] values.
                        if (nodeName === "img" && key === "srcset") this[key] = value = sanitizeSrcset(value, "$set('srcset', value)");
                        if (writeAttr !== false) {
                            if (value === null || isUndefined(value)) this.$$element.removeAttr(attrName);
                            else if (SIMPLE_ATTR_NAME.test(attrName)) {
                                // jQuery skips special boolean attrs treatment in XML nodes for
                                // historical reasons and hence AngularJS cannot freely call
                                // `.attr(attrName, false) with such attributes. To avoid issues
                                // in XHTML, call `removeAttr` in such cases instead.
                                // See https://github.com/jquery/jquery/issues/4249
                                if (booleanKey && value === false) this.$$element.removeAttr(attrName);
                                else this.$$element.attr(attrName, value);
                            } else setSpecialAttr(this.$$element[0], attrName, value);
                        }
                        // fire observers
                        var $$observers = this.$$observers;
                        if ($$observers) forEach($$observers[observer], function(fn) {
                            try {
                                fn(value);
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                        });
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */ $observe: function(key, fn) {
                        var attrs = this, $$observers = attrs.$$observers || (attrs.$$observers = createMap()), listeners = $$observers[key] || ($$observers[key] = []);
                        listeners.push(fn);
                        $rootScope.$evalAsync(function() {
                            if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) // no one registered attribute interpolation function, so lets call it manually
                            fn(attrs[key]);
                        });
                        return function() {
                            arrayRemove(listeners, fn);
                        };
                    }
                };
                function setSpecialAttr(element, attrName, value) {
                    // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
                    // so we have to jump through some hoops to get such an attribute
                    // https://github.com/angular/angular.js/pull/13318
                    specialAttrHolder.innerHTML = "<span " + attrName + ">";
                    var attributes = specialAttrHolder.firstChild.attributes;
                    var attribute = attributes[0];
                    // We have to remove the attribute from its container element before we can add it to the destination element
                    attributes.removeNamedItem(attribute.name);
                    attribute.value = value;
                    element.attributes.setNamedItem(attribute);
                }
                function safeAddClass($element, className) {
                    try {
                        $element.addClass(className);
                    } catch (e) {
                    // ignore, since it means that we are trying to set class on
                    // SVG element, where class name is read-only.
                    }
                }
                var startSymbol = $interpolate.startSymbol(), endSymbol = $interpolate.endSymbol(), denormalizeTemplate = startSymbol === "{{" && endSymbol === "}}" ? identity : function denormalizeTemplate(template) {
                    return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
                }, NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
                var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
                compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
                    var bindings = $element.data("$binding") || [];
                    if (isArray(binding)) bindings = bindings.concat(binding);
                    else bindings.push(binding);
                    $element.data("$binding", bindings);
                } : noop;
                compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
                    safeAddClass($element, "ng-binding");
                } : noop;
                compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
                    var dataName = isolated ? noTemplate ? "$isolateScopeNoTemplate" : "$isolateScope" : "$scope";
                    $element.data(dataName, scope);
                } : noop;
                compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
                    safeAddClass($element, isolated ? "ng-isolate-scope" : "ng-scope");
                } : noop;
                compile.$$createComment = function(directiveName, comment) {
                    var content = "";
                    if (debugInfoEnabled) {
                        content = " " + (directiveName || "") + ": ";
                        if (comment) content += comment + " ";
                    }
                    return window1.document.createComment(content);
                };
                return compile;
                //================================
                function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
                    if (!($compileNodes instanceof jqLite)) // jquery always rewraps, whereas we need to preserve the original selector so that we can
                    // modify it.
                    $compileNodes = jqLite($compileNodes);
                    var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
                    compile.$$addScopeClass($compileNodes);
                    var namespace = null;
                    return function publicLinkFn(scope, cloneConnectFn, options) {
                        if (!$compileNodes) throw $compileMinErr("multilink", "This element has already been linked.");
                        assertArg(scope, "scope");
                        if (previousCompileContext && previousCompileContext.needsNewScope) // A parent directive did a replace and a directive on this element asked
                        // for transclusion, which caused us to lose a layer of element on which
                        // we could hold the new transclusion scope, so we will create it manually
                        // here.
                        scope = scope.$parent.$new();
                        options = options || {};
                        var parentBoundTranscludeFn = options.parentBoundTranscludeFn, transcludeControllers = options.transcludeControllers, futureParentElement = options.futureParentElement;
                        // When `parentBoundTranscludeFn` is passed, it is a
                        // `controllersBoundTransclude` function (it was previously passed
                        // as `transclude` to directive.link) so we must unwrap it to get
                        // its `boundTranscludeFn`
                        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
                        if (!namespace) namespace = detectNamespaceForChildElements(futureParentElement);
                        var $linkNode;
                        if (namespace !== "html") // When using a directive with replace:true and templateUrl the $compileNodes
                        // (or a child element inside of them)
                        // might change, so we need to recreate the namespace adapted compileNodes
                        // for call to the link function.
                        // Note: This will already clone the nodes...
                        $linkNode = jqLite(wrapTemplate(namespace, jqLite("<div></div>").append($compileNodes).html()));
                        else if (cloneConnectFn) // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
                        // and sometimes changes the structure of the DOM.
                        $linkNode = JQLitePrototype.clone.call($compileNodes);
                        else $linkNode = $compileNodes;
                        if (transcludeControllers) for(var controllerName in transcludeControllers)$linkNode.data("$" + controllerName + "Controller", transcludeControllers[controllerName].instance);
                        compile.$$addScopeInfo($linkNode, scope);
                        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
                        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
                        if (!cloneConnectFn) $compileNodes = compositeLinkFn = null;
                        return $linkNode;
                    };
                }
                function detectNamespaceForChildElements(parentElement) {
                    // TODO: Make this detect MathML as well...
                    var node = parentElement && parentElement[0];
                    if (!node) return "html";
                    else return nodeName_(node) !== "foreignobject" && toString.call(node).match(/SVG/) ? "svg" : "html";
                }
                /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */ function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
                    var linkFns = [], // `nodeList` can be either an element's `.childNodes` (live NodeList)
                    // or a jqLite/jQuery collection or an array
                    notLiveList = isArray(nodeList) || nodeList instanceof jqLite, attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
                    for(var i = 0; i < nodeList.length; i++){
                        attrs = new Attributes();
                        // Support: IE 11 only
                        // Workaround for #11781 and #14924
                        if (msie === 11) mergeConsecutiveTextNodes(nodeList, i, notLiveList);
                        // We must always refer to `nodeList[i]` hereafter,
                        // since the nodes can be replaced underneath us.
                        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);
                        nodeLinkFn = directives.length ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;
                        if (nodeLinkFn && nodeLinkFn.scope) compile.$$addScopeClass(attrs.$$element);
                        childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length ? null : compileNodes(childNodes, nodeLinkFn ? (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude : transcludeFn);
                        if (nodeLinkFn || childLinkFn) {
                            linkFns.push(i, nodeLinkFn, childLinkFn);
                            linkFnFound = true;
                            nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
                        }
                        //use the previous context only for the first element in the virtual group
                        previousCompileContext = null;
                    }
                    // return a linking function if we have found anything, null otherwise
                    return linkFnFound ? compositeLinkFn : null;
                    function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
                        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
                        var stableNodeList;
                        if (nodeLinkFnFound) {
                            // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
                            // offsets don't get screwed up
                            var nodeListLength = nodeList.length;
                            stableNodeList = new Array(nodeListLength);
                            // create a sparse array by only copying the elements which have a linkFn
                            for(i = 0; i < linkFns.length; i += 3){
                                idx = linkFns[i];
                                stableNodeList[idx] = nodeList[idx];
                            }
                        } else stableNodeList = nodeList;
                        for(i = 0, ii = linkFns.length; i < ii;){
                            node = stableNodeList[linkFns[i++]];
                            nodeLinkFn = linkFns[i++];
                            childLinkFn = linkFns[i++];
                            if (nodeLinkFn) {
                                if (nodeLinkFn.scope) {
                                    childScope = scope.$new();
                                    compile.$$addScopeInfo(jqLite(node), childScope);
                                } else childScope = scope;
                                if (nodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
                                else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) childBoundTranscludeFn = parentBoundTranscludeFn;
                                else if (!parentBoundTranscludeFn && transcludeFn) childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
                                else childBoundTranscludeFn = null;
                                nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
                            } else if (childLinkFn) childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
                        }
                    }
                }
                function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
                    var node = nodeList[idx];
                    var parent = node.parentNode;
                    var sibling;
                    if (node.nodeType !== NODE_TYPE_TEXT) return;
                    while(true){
                        sibling = parent ? node.nextSibling : nodeList[idx + 1];
                        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) break;
                        node.nodeValue = node.nodeValue + sibling.nodeValue;
                        if (sibling.parentNode) sibling.parentNode.removeChild(sibling);
                        if (notLiveList && sibling === nodeList[idx + 1]) nodeList.splice(idx + 1, 1);
                    }
                }
                function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
                    function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
                        if (!transcludedScope) {
                            transcludedScope = scope.$new(false, containingScope);
                            transcludedScope.$$transcluded = true;
                        }
                        return transcludeFn(transcludedScope, cloneFn, {
                            parentBoundTranscludeFn: previousBoundTranscludeFn,
                            transcludeControllers: controllers,
                            futureParentElement: futureParentElement
                        });
                    }
                    // We need  to attach the transclusion slots onto the `boundTranscludeFn`
                    // so that they are available inside the `controllersBoundTransclude` function
                    var boundSlots = boundTranscludeFn.$$slots = createMap();
                    for(var slotName in transcludeFn.$$slots)if (transcludeFn.$$slots[slotName]) boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
                    else boundSlots[slotName] = null;
                    return boundTranscludeFn;
                }
                /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */ function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
                    var nodeType = node.nodeType, attrsMap = attrs.$attr, match, nodeName, className;
                    switch(nodeType){
                        case NODE_TYPE_ELEMENT:
                            /* Element */ nodeName = nodeName_(node);
                            // use the node name: <directive>
                            addDirective(directives, directiveNormalize(nodeName), "E", maxPriority, ignoreDirective);
                            // iterate over the attributes
                            for(var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes, j = 0, jj = nAttrs && nAttrs.length; j < jj; j++){
                                var attrStartName = false;
                                var attrEndName = false;
                                var isNgAttr = false, isNgProp = false, isNgEvent = false;
                                var multiElementMatch;
                                attr = nAttrs[j];
                                name = attr.name;
                                value = attr.value;
                                nName = directiveNormalize(name.toLowerCase());
                                // Support ng-attr-*, ng-prop-* and ng-on-*
                                if (ngPrefixMatch = nName.match(NG_PREFIX_BINDING)) {
                                    isNgAttr = ngPrefixMatch[1] === "Attr";
                                    isNgProp = ngPrefixMatch[1] === "Prop";
                                    isNgEvent = ngPrefixMatch[1] === "On";
                                    // Normalize the non-prefixed name
                                    name = name.replace(PREFIX_REGEXP, "").toLowerCase().substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                                        return letter.toUpperCase();
                                    });
                                // Support *-start / *-end multi element directives
                                } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
                                    attrStartName = name;
                                    attrEndName = name.substr(0, name.length - 5) + "end";
                                    name = name.substr(0, name.length - 6);
                                }
                                if (isNgProp || isNgEvent) {
                                    attrs[nName] = value;
                                    attrsMap[nName] = attr.name;
                                    if (isNgProp) addPropertyDirective(node, directives, nName, name);
                                    else addEventDirective(directives, nName, name);
                                } else {
                                    // Update nName for cases where a prefix was removed
                                    // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
                                    nName = directiveNormalize(name.toLowerCase());
                                    attrsMap[nName] = name;
                                    if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                                        attrs[nName] = value;
                                        if (getBooleanAttrName(node, nName)) attrs[nName] = true; // presence means true
                                    }
                                    addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                                    addDirective(directives, nName, "A", maxPriority, ignoreDirective, attrStartName, attrEndName);
                                }
                            }
                            if (nodeName === "input" && node.getAttribute("type") === "hidden") // Hidden input elements can have strange behaviour when navigating back to the page
                            // This tells the browser not to try to cache and reinstate previous values
                            node.setAttribute("autocomplete", "off");
                            // use class as directive
                            if (!cssClassDirectivesEnabled) break;
                            className = node.className;
                            if (isObject(className)) // Maybe SVGAnimatedString
                            className = className.animVal;
                            if (isString(className) && className !== "") while(match = CLASS_DIRECTIVE_REGEXP.exec(className)){
                                nName = directiveNormalize(match[2]);
                                if (addDirective(directives, nName, "C", maxPriority, ignoreDirective)) attrs[nName] = trim(match[3]);
                                className = className.substr(match.index + match[0].length);
                            }
                            break;
                        case NODE_TYPE_TEXT:
                            /* Text Node */ addTextInterpolateDirective(directives, node.nodeValue);
                            break;
                        case NODE_TYPE_COMMENT:
                            /* Comment */ if (!commentDirectivesEnabled) break;
                            collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
                            break;
                    }
                    directives.sort(byPriority);
                    return directives;
                }
                function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
                    // function created because of performance, try/catch disables
                    // the optimization of the whole function #14848
                    try {
                        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
                        if (match) {
                            var nName = directiveNormalize(match[1]);
                            if (addDirective(directives, nName, "M", maxPriority, ignoreDirective)) attrs[nName] = trim(match[2]);
                        }
                    } catch (e) {
                    // turns out that under some circumstances IE9 throws errors when one attempts to read
                    // comment's node value.
                    // Just ignore it and continue. (Can't seem to reproduce in test case.)
                    }
                }
                /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */ function groupScan(node, attrStart, attrEnd) {
                    var nodes = [];
                    var depth = 0;
                    if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) do {
                        if (!node) throw $compileMinErr("uterdir", "Unterminated attribute, found '{0}' but no matching '{1}' found.", attrStart, attrEnd);
                        if (node.nodeType === NODE_TYPE_ELEMENT) {
                            if (node.hasAttribute(attrStart)) depth++;
                            if (node.hasAttribute(attrEnd)) depth--;
                        }
                        nodes.push(node);
                        node = node.nextSibling;
                    }while (depth > 0);
                    else nodes.push(node);
                    return jqLite(nodes);
                }
                /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */ function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
                    return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
                        element = groupScan(element[0], attrStart, attrEnd);
                        return linkFn(scope, element, attrs, controllers, transcludeFn);
                    };
                }
                /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */ function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
                    var compiled;
                    if (eager) return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
                    return /** @this */ function lazyCompilation() {
                        if (!compiled) {
                            compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
                            // Null out all of these references in order to make them eligible for garbage collection
                            // since this is a potentially long lived closure
                            $compileNodes = transcludeFn = previousCompileContext = null;
                        }
                        return compiled.apply(this, arguments);
                    };
                }
                /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */ function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
                    previousCompileContext = previousCompileContext || {};
                    var terminalPriority = -Number.MAX_VALUE, newScopeDirective = previousCompileContext.newScopeDirective, controllerDirectives = previousCompileContext.controllerDirectives, newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective, templateDirective = previousCompileContext.templateDirective, nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective, hasTranscludeDirective = false, hasTemplate = false, hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective, $compileNode = templateAttrs.$$element = jqLite(compileNode), directive, directiveName, $template, replaceDirective = originalReplaceDirective, childTranscludeFn = transcludeFn, linkFn, didScanForMultipleTransclusion = false, mightHaveMultipleTransclusionError = false, directiveValue;
                    // executes all directives on the current element
                    for(var i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        var attrStart = directive.$$start;
                        var attrEnd = directive.$$end;
                        // collect multiblock sections
                        if (attrStart) $compileNode = groupScan(compileNode, attrStart, attrEnd);
                        $template = undefined;
                        if (terminalPriority > directive.priority) break; // prevent further processing of directives
                        directiveValue = directive.scope;
                        if (directiveValue) {
                            // skip the check for directives with async templates, we'll check the derived sync
                            // directive when the template arrives
                            if (!directive.templateUrl) {
                                if (isObject(directiveValue)) {
                                    // This directive is trying to add an isolated scope.
                                    // Check that there is no scope of any kind already
                                    assertNoDuplicate("new/isolated scope", newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                                    newIsolateScopeDirective = directive;
                                } else // This directive is trying to add a child scope.
                                // Check that there is no isolated scope already
                                assertNoDuplicate("new/isolated scope", newIsolateScopeDirective, directive, $compileNode);
                            }
                            newScopeDirective = newScopeDirective || directive;
                        }
                        directiveName = directive.name;
                        // If we encounter a condition that can result in transclusion on the directive,
                        // then scan ahead in the remaining directives for others that may cause a multiple
                        // transclusion error to be thrown during the compilation process.  If a matching directive
                        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
                        // compile the `transclude` function rather than doing it lazily in order to throw
                        // exceptions at the correct time
                        if (!didScanForMultipleTransclusion && (directive.replace && (directive.templateUrl || directive.template) || directive.transclude && !directive.$$tlb)) {
                            var candidateDirective;
                            for(var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];)if (candidateDirective.transclude && !candidateDirective.$$tlb || candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template)) {
                                mightHaveMultipleTransclusionError = true;
                                break;
                            }
                            didScanForMultipleTransclusion = true;
                        }
                        if (!directive.templateUrl && directive.controller) {
                            controllerDirectives = controllerDirectives || createMap();
                            assertNoDuplicate("'" + directiveName + "' controller", controllerDirectives[directiveName], directive, $compileNode);
                            controllerDirectives[directiveName] = directive;
                        }
                        directiveValue = directive.transclude;
                        if (directiveValue) {
                            hasTranscludeDirective = true;
                            // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
                            // This option should only be used by directives that know how to safely handle element transclusion,
                            // where the transcluded nodes are added or replaced after linking.
                            if (!directive.$$tlb) {
                                assertNoDuplicate("transclusion", nonTlbTranscludeDirective, directive, $compileNode);
                                nonTlbTranscludeDirective = directive;
                            }
                            if (directiveValue === "element") {
                                hasElementTranscludeDirective = true;
                                terminalPriority = directive.priority;
                                $template = $compileNode;
                                $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
                                compileNode = $compileNode[0];
                                replaceWith(jqCollection, sliceArgs($template), compileNode);
                                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {
                                    // Don't pass in:
                                    // - controllerDirectives - otherwise we'll create duplicates controllers
                                    // - newIsolateScopeDirective or templateDirective - combining templates with
                                    //   element transclusion doesn't make sense.
                                    //
                                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                    // on the same element more than once.
                                    nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                });
                            } else {
                                var slots = createMap();
                                if (!isObject(directiveValue)) $template = jqLite(jqLiteClone(compileNode)).contents();
                                else {
                                    // We have transclusion slots,
                                    // collect them up, compile them and store their transclusion functions
                                    $template = window1.document.createDocumentFragment();
                                    var slotMap = createMap();
                                    var filledSlots = createMap();
                                    // Parse the element selectors
                                    forEach(directiveValue, function(elementSelector, slotName) {
                                        // If an element selector starts with a ? then it is optional
                                        var optional = elementSelector.charAt(0) === "?";
                                        elementSelector = optional ? elementSelector.substring(1) : elementSelector;
                                        slotMap[elementSelector] = slotName;
                                        // We explicitly assign `null` since this implies that a slot was defined but not filled.
                                        // Later when calling boundTransclusion functions with a slot name we only error if the
                                        // slot is `undefined`
                                        slots[slotName] = null;
                                        // filledSlots contains `true` for all slots that are either optional or have been
                                        // filled. This is used to check that we have not missed any required slots
                                        filledSlots[slotName] = optional;
                                    });
                                    // Add the matching elements into their slot
                                    forEach($compileNode.contents(), function(node) {
                                        var slotName = slotMap[directiveNormalize(nodeName_(node))];
                                        if (slotName) {
                                            filledSlots[slotName] = true;
                                            slots[slotName] = slots[slotName] || window1.document.createDocumentFragment();
                                            slots[slotName].appendChild(node);
                                        } else $template.appendChild(node);
                                    });
                                    // Check for required slots that were not filled
                                    forEach(filledSlots, function(filled, slotName) {
                                        if (!filled) throw $compileMinErr("reqslot", "Required transclusion slot `{0}` was not filled.", slotName);
                                    });
                                    for(var slotName in slots)if (slots[slotName]) {
                                        // Only define a transclusion function if the slot was filled
                                        var slotCompileNodes = jqLite(slots[slotName].childNodes);
                                        slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                                    }
                                    $template = jqLite($template.childNodes);
                                }
                                $compileNode.empty(); // clear contents
                                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, {
                                    needsNewScope: directive.$$isolateScope || directive.$$newScope
                                });
                                childTranscludeFn.$$slots = slots;
                            }
                        }
                        if (directive.template) {
                            hasTemplate = true;
                            assertNoDuplicate("template", templateDirective, directive, $compileNode);
                            templateDirective = directive;
                            directiveValue = isFunction(directive.template) ? directive.template($compileNode, templateAttrs) : directive.template;
                            directiveValue = denormalizeTemplate(directiveValue);
                            if (directive.replace) {
                                replaceDirective = directive;
                                if (jqLiteIsTextNode(directiveValue)) $template = [];
                                else $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
                                compileNode = $template[0];
                                if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", directiveName, "");
                                replaceWith(jqCollection, $compileNode, compileNode);
                                var newTemplateAttrs = {
                                    $attr: {}
                                };
                                // combine directives from the original node and from the template:
                                // - take the array of directives for this element
                                // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
                                // - collect directives from the template and sort them by priority
                                // - combine directives as: processed + template + unprocessed
                                var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
                                var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
                                if (newIsolateScopeDirective || newScopeDirective) // The original directive caused the current element to be replaced but this element
                                // also needs to have a new scope, so we need to tell the template directives
                                // that they would need to get their scope from further up, if they require transclusion
                                markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
                                directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
                                mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
                                ii = directives.length;
                            } else $compileNode.html(directiveValue);
                        }
                        if (directive.templateUrl) {
                            hasTemplate = true;
                            assertNoDuplicate("template", templateDirective, directive, $compileNode);
                            templateDirective = directive;
                            if (directive.replace) replaceDirective = directive;
                            // eslint-disable-next-line no-func-assign
                            nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                                controllerDirectives: controllerDirectives,
                                newScopeDirective: newScopeDirective !== directive && newScopeDirective,
                                newIsolateScopeDirective: newIsolateScopeDirective,
                                templateDirective: templateDirective,
                                nonTlbTranscludeDirective: nonTlbTranscludeDirective
                            });
                            ii = directives.length;
                        } else if (directive.compile) try {
                            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
                            var context = directive.$$originalDirective || directive;
                            if (isFunction(linkFn)) addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
                            else if (linkFn) addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
                        } catch (e) {
                            $exceptionHandler(e, startingTag($compileNode));
                        }
                        if (directive.terminal) {
                            nodeLinkFn.terminal = true;
                            terminalPriority = Math.max(terminalPriority, directive.priority);
                        }
                    }
                    nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
                    nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
                    nodeLinkFn.templateOnThisElement = hasTemplate;
                    nodeLinkFn.transclude = childTranscludeFn;
                    previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
                    // might be normal or delayed nodeLinkFn depending on if templateUrl is present
                    return nodeLinkFn;
                    ////////////////////
                    function addLinkFns(pre, post, attrStart, attrEnd) {
                        if (pre) {
                            if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
                            pre.require = directive.require;
                            pre.directiveName = directiveName;
                            if (newIsolateScopeDirective === directive || directive.$$isolateScope) pre = cloneAndAnnotateFn(pre, {
                                isolateScope: true
                            });
                            preLinkFns.push(pre);
                        }
                        if (post) {
                            if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
                            post.require = directive.require;
                            post.directiveName = directiveName;
                            if (newIsolateScopeDirective === directive || directive.$$isolateScope) post = cloneAndAnnotateFn(post, {
                                isolateScope: true
                            });
                            postLinkFns.push(post);
                        }
                    }
                    function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
                        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element, attrs, scopeBindingInfo;
                        if (compileNode === linkNode) {
                            attrs = templateAttrs;
                            $element = templateAttrs.$$element;
                        } else {
                            $element = jqLite(linkNode);
                            attrs = new Attributes($element, templateAttrs);
                        }
                        controllerScope = scope;
                        if (newIsolateScopeDirective) isolateScope = scope.$new(true);
                        else if (newScopeDirective) controllerScope = scope.$parent;
                        if (boundTranscludeFn) {
                            // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
                            // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
                            transcludeFn = controllersBoundTransclude;
                            transcludeFn.$$boundTransclude = boundTranscludeFn;
                            // expose the slots on the `$transclude` function
                            transcludeFn.isSlotFilled = function(slotName) {
                                return !!boundTranscludeFn.$$slots[slotName];
                            };
                        }
                        if (controllerDirectives) elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
                        if (newIsolateScopeDirective) {
                            // Initialize isolate scope bindings for new isolate scope directive.
                            compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
                            compile.$$addScopeClass($element, true);
                            isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
                            scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
                            if (scopeBindingInfo.removeWatches) isolateScope.$on("$destroy", scopeBindingInfo.removeWatches);
                        }
                        // Initialize bindToController bindings
                        for(var name in elementControllers){
                            var controllerDirective = controllerDirectives[name];
                            var controller = elementControllers[name];
                            var bindings = controllerDirective.$$bindings.bindToController;
                            controller.instance = controller();
                            $element.data("$" + controllerDirective.name + "Controller", controller.instance);
                            controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                        }
                        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
                        forEach(controllerDirectives, function(controllerDirective, name) {
                            var require = controllerDirective.require;
                            if (controllerDirective.bindToController && !isArray(require) && isObject(require)) extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
                        });
                        // Handle the init and destroy lifecycle hooks on all controllers that have them
                        forEach(elementControllers, function(controller) {
                            var controllerInstance = controller.instance;
                            if (isFunction(controllerInstance.$onChanges)) try {
                                controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            if (isFunction(controllerInstance.$onInit)) try {
                                controllerInstance.$onInit();
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            if (isFunction(controllerInstance.$doCheck)) {
                                controllerScope.$watch(function() {
                                    controllerInstance.$doCheck();
                                });
                                controllerInstance.$doCheck();
                            }
                            if (isFunction(controllerInstance.$onDestroy)) controllerScope.$on("$destroy", function callOnDestroyHook() {
                                controllerInstance.$onDestroy();
                            });
                        });
                        // PRELINKING
                        for(i = 0, ii = preLinkFns.length; i < ii; i++){
                            linkFn = preLinkFns[i];
                            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
                        }
                        // RECURSION
                        // We only pass the isolate scope, if the isolate directive has a template,
                        // otherwise the child elements do not belong to the isolate directive.
                        var scopeToChild = scope;
                        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) scopeToChild = isolateScope;
                        if (childLinkFn) childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
                        // POSTLINKING
                        for(i = postLinkFns.length - 1; i >= 0; i--){
                            linkFn = postLinkFns[i];
                            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
                        }
                        // Trigger $postLink lifecycle hooks
                        forEach(elementControllers, function(controller) {
                            var controllerInstance = controller.instance;
                            if (isFunction(controllerInstance.$postLink)) controllerInstance.$postLink();
                        });
                        // This is the function that is injected as `$transclude`.
                        // Note: all arguments are optional!
                        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
                            var transcludeControllers;
                            // No scope passed in:
                            if (!isScope(scope)) {
                                slotName = futureParentElement;
                                futureParentElement = cloneAttachFn;
                                cloneAttachFn = scope;
                                scope = undefined;
                            }
                            if (hasElementTranscludeDirective) transcludeControllers = elementControllers;
                            if (!futureParentElement) futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
                            if (slotName) {
                                // slotTranscludeFn can be one of three things:
                                //  * a transclude function - a filled slot
                                //  * `null` - an optional slot that was not filled
                                //  * `undefined` - a slot that was not declared (i.e. invalid)
                                var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
                                if (slotTranscludeFn) return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                                else if (isUndefined(slotTranscludeFn)) throw $compileMinErr("noslot", 'No parent directive that requires a transclusion with slot name "{0}". Element: {1}', slotName, startingTag($element));
                            } else return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                        }
                    }
                }
                function getControllers(directiveName, require, $element, elementControllers) {
                    var value;
                    if (isString(require)) {
                        var match = require.match(REQUIRE_PREFIX_REGEXP);
                        var name = require.substring(match[0].length);
                        var inheritType = match[1] || match[3];
                        var optional = match[2] === "?";
                        //If only parents then start at the parent element
                        if (inheritType === "^^") $element = $element.parent();
                        else {
                            value = elementControllers && elementControllers[name];
                            value = value && value.instance;
                        }
                        if (!value) {
                            var dataName = "$" + name + "Controller";
                            if (inheritType === "^^" && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) // inheritedData() uses the documentElement when it finds the document, so we would
                            // require from the element itself.
                            value = null;
                            else value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
                        }
                        if (!value && !optional) throw $compileMinErr("ctreq", "Controller '{0}', required by directive '{1}', can't be found!", name, directiveName);
                    } else if (isArray(require)) {
                        value = [];
                        for(var i = 0, ii = require.length; i < ii; i++)value[i] = getControllers(directiveName, require[i], $element, elementControllers);
                    } else if (isObject(require)) {
                        value = {};
                        forEach(require, function(controller, property) {
                            value[property] = getControllers(directiveName, controller, $element, elementControllers);
                        });
                    }
                    return value || null;
                }
                function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
                    var elementControllers = createMap();
                    for(var controllerKey in controllerDirectives){
                        var directive = controllerDirectives[controllerKey];
                        var locals = {
                            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
                            $element: $element,
                            $attrs: attrs,
                            $transclude: transcludeFn
                        };
                        var controller = directive.controller;
                        if (controller === "@") controller = attrs[directive.name];
                        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
                        // For directives with element transclusion the element is a comment.
                        // In this case .data will not attach any data.
                        // Instead, we save the controllers for the element in a local hash and attach to .data
                        // later, once we have the actual element.
                        elementControllers[directive.name] = controllerInstance;
                        $element.data("$" + directive.name + "Controller", controllerInstance.instance);
                    }
                    return elementControllers;
                }
                // Depending upon the context in which a directive finds itself it might need to have a new isolated
                // or child scope created. For instance:
                // * if the directive has been pulled into a template because another directive with a higher priority
                // asked for element transclusion
                // * if the directive itself asks for transclusion but it is at the root of a template and the original
                // element was replaced. See https://github.com/angular/angular.js/issues/12936
                function markDirectiveScope(directives, isolateScope, newScope) {
                    for(var j = 0, jj = directives.length; j < jj; j++)directives[j] = inherit(directives[j], {
                        $$isolateScope: isolateScope,
                        $$newScope: newScope
                    });
                }
                /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */ function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
                    if (name === ignoreDirective) return null;
                    var match = null;
                    if (hasDirectives.hasOwnProperty(name)) for(var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) !== -1) {
                            if (startAttrName) directive = inherit(directive, {
                                $$start: startAttrName,
                                $$end: endAttrName
                            });
                            if (!directive.$$bindings) {
                                var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                                if (isObject(bindings.isolateScope)) directive.$$isolateBindings = bindings.isolateScope;
                            }
                            tDirectives.push(directive);
                            match = directive;
                        }
                    }
                    return match;
                }
                /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */ function directiveIsMultiElement(name) {
                    if (hasDirectives.hasOwnProperty(name)) for(var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        if (directive.multiElement) return true;
                    }
                    return false;
                }
                /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */ function mergeTemplateAttributes(dst, src) {
                    var srcAttr = src.$attr, dstAttr = dst.$attr;
                    // reapply the old attributes to the new element
                    forEach(dst, function(value, key) {
                        if (key.charAt(0) !== "$") {
                            if (src[key] && src[key] !== value) {
                                if (value.length) value += (key === "style" ? ";" : " ") + src[key];
                                else value = src[key];
                            }
                            dst.$set(key, value, true, srcAttr[key]);
                        }
                    });
                    // copy the new attributes on the old attrs object
                    forEach(src, function(value, key) {
                        // Check if we already set this attribute in the loop above.
                        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
                        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
                        // have an attribute like "has-own-property" or "data-has-own-property", etc.
                        if (!dst.hasOwnProperty(key) && key.charAt(0) !== "$") {
                            dst[key] = value;
                            if (key !== "class" && key !== "style") dstAttr[key] = srcAttr[key];
                        }
                    });
                }
                function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
                    var linkQueue = [], afterTemplateNodeLinkFn, afterTemplateChildLinkFn, beforeTemplateCompileNode = $compileNode[0], origAsyncDirective = directives.shift(), derivedSyncDirective = inherit(origAsyncDirective, {
                        templateUrl: null,
                        transclude: null,
                        replace: null,
                        $$originalDirective: origAsyncDirective
                    }), templateUrl = isFunction(origAsyncDirective.templateUrl) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl, templateNamespace = origAsyncDirective.templateNamespace;
                    $compileNode.empty();
                    $templateRequest(templateUrl).then(function(content) {
                        var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
                        content = denormalizeTemplate(content);
                        if (origAsyncDirective.replace) {
                            if (jqLiteIsTextNode(content)) $template = [];
                            else $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
                            compileNode = $template[0];
                            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", origAsyncDirective.name, templateUrl);
                            tempTemplateAttrs = {
                                $attr: {}
                            };
                            replaceWith($rootElement, $compileNode, compileNode);
                            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
                            if (isObject(origAsyncDirective.scope)) // the original directive that caused the template to be loaded async required
                            // an isolate scope
                            markDirectiveScope(templateDirectives, true);
                            directives = templateDirectives.concat(directives);
                            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
                        } else {
                            compileNode = beforeTemplateCompileNode;
                            $compileNode.html(content);
                        }
                        directives.unshift(derivedSyncDirective);
                        afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
                        forEach($rootElement, function(node, i) {
                            if (node === compileNode) $rootElement[i] = $compileNode[0];
                        });
                        afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
                        while(linkQueue.length){
                            var scope = linkQueue.shift(), beforeTemplateLinkNode = linkQueue.shift(), linkRootElement = linkQueue.shift(), boundTranscludeFn = linkQueue.shift(), linkNode = $compileNode[0];
                            if (scope.$$destroyed) continue;
                            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
                                var oldClasses = beforeTemplateLinkNode.className;
                                if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) // it was cloned therefore we have to clone as well.
                                linkNode = jqLiteClone(compileNode);
                                replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
                                // Copy in CSS classes from original node
                                safeAddClass(jqLite(linkNode), oldClasses);
                            }
                            if (afterTemplateNodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                            else childBoundTranscludeFn = boundTranscludeFn;
                            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
                        }
                        linkQueue = null;
                    }).catch(function(error) {
                        if (isError(error)) $exceptionHandler(error);
                    });
                    return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
                        var childBoundTranscludeFn = boundTranscludeFn;
                        if (scope.$$destroyed) return;
                        if (linkQueue) linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
                        else {
                            if (afterTemplateNodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
                        }
                    };
                }
                /**
     * Sorting function for bound directives.
     */ function byPriority(a, b) {
                    var diff = b.priority - a.priority;
                    if (diff !== 0) return diff;
                    if (a.name !== b.name) return a.name < b.name ? -1 : 1;
                    return a.index - b.index;
                }
                function assertNoDuplicate(what, previousDirective, directive, element) {
                    function wrapModuleNameIfDefined(moduleName) {
                        return moduleName ? " (module: " + moduleName + ")" : "";
                    }
                    if (previousDirective) throw $compileMinErr("multidir", "Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}", previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
                }
                function addTextInterpolateDirective(directives, text) {
                    var interpolateFn = $interpolate(text, true);
                    if (interpolateFn) directives.push({
                        priority: 0,
                        compile: function textInterpolateCompileFn(templateNode) {
                            var templateNodeParent = templateNode.parent(), hasCompileParent = !!templateNodeParent.length;
                            // When transcluding a template that has bindings in the root
                            // we don't have a parent and thus need to add the class during linking fn.
                            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
                            return function textInterpolateLinkFn(scope, node) {
                                var parent = node.parent();
                                if (!hasCompileParent) compile.$$addBindingClass(parent);
                                compile.$$addBindingInfo(parent, interpolateFn.expressions);
                                scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                                    node[0].nodeValue = value;
                                });
                            };
                        }
                    });
                }
                function wrapTemplate(type, template) {
                    type = lowercase(type || "html");
                    switch(type){
                        case "svg":
                        case "math":
                            var wrapper = window1.document.createElement("div");
                            wrapper.innerHTML = "<" + type + ">" + template + "</" + type + ">";
                            return wrapper.childNodes[0].childNodes;
                        default:
                            return template;
                    }
                }
                function getTrustedAttrContext(nodeName, attrNormalizedName) {
                    if (attrNormalizedName === "srcdoc") return $sce.HTML;
                    // All nodes with src attributes require a RESOURCE_URL value, except for
                    // img and various html5 media nodes, which require the MEDIA_URL context.
                    if (attrNormalizedName === "src" || attrNormalizedName === "ngSrc") {
                        if ([
                            "img",
                            "video",
                            "audio",
                            "source",
                            "track"
                        ].indexOf(nodeName) === -1) return $sce.RESOURCE_URL;
                        return $sce.MEDIA_URL;
                    } else if (attrNormalizedName === "xlinkHref") {
                        // Some xlink:href are okay, most aren't
                        if (nodeName === "image") return $sce.MEDIA_URL;
                        if (nodeName === "a") return $sce.URL;
                        return $sce.RESOURCE_URL;
                    } else if (// Formaction
                    nodeName === "form" && attrNormalizedName === "action" || // If relative URLs can go where they are not expected to, then
                    // all sorts of trust issues can arise.
                    nodeName === "base" && attrNormalizedName === "href" || // links can be stylesheets or imports, which can run script in the current origin
                    nodeName === "link" && attrNormalizedName === "href") return $sce.RESOURCE_URL;
                    else if (nodeName === "a" && (attrNormalizedName === "href" || attrNormalizedName === "ngHref")) return $sce.URL;
                }
                function getTrustedPropContext(nodeName, propNormalizedName) {
                    var prop = propNormalizedName.toLowerCase();
                    return PROP_CONTEXTS[nodeName + "|" + prop] || PROP_CONTEXTS["*|" + prop];
                }
                function sanitizeSrcsetPropertyValue(value) {
                    return sanitizeSrcset($sce.valueOf(value), "ng-prop-srcset");
                }
                function addPropertyDirective(node, directives, attrName, propName) {
                    if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) throw $compileMinErr("nodomevents", "Property bindings for HTML DOM event properties are disallowed");
                    var nodeName = nodeName_(node);
                    var trustedContext = getTrustedPropContext(nodeName, propName);
                    var sanitizer = identity;
                    // Sanitize img[srcset] + source[srcset] values.
                    if (propName === "srcset" && (nodeName === "img" || nodeName === "source")) sanitizer = sanitizeSrcsetPropertyValue;
                    else if (trustedContext) sanitizer = $sce.getTrusted.bind($sce, trustedContext);
                    directives.push({
                        priority: 100,
                        compile: function ngPropCompileFn(_, attr) {
                            var ngPropGetter = $parse(attr[attrName]);
                            var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
                                // Unwrap the value to compare the actual inner safe value, not the wrapper object.
                                return $sce.valueOf(val);
                            });
                            return {
                                pre: function ngPropPreLinkFn(scope, $element) {
                                    function applyPropValue() {
                                        var propValue = ngPropGetter(scope);
                                        $element[0][propName] = sanitizer(propValue);
                                    }
                                    applyPropValue();
                                    scope.$watch(ngPropWatch, applyPropValue);
                                }
                            };
                        }
                    });
                }
                function addEventDirective(directives, attrName, eventName) {
                    directives.push(createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/ false));
                }
                function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
                    var nodeName = nodeName_(node);
                    var trustedContext = getTrustedAttrContext(nodeName, name);
                    var mustHaveExpression = !isNgAttr;
                    var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
                    var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
                    // no interpolation found -> ignore
                    if (!interpolateFn) return;
                    if (name === "multiple" && nodeName === "select") throw $compileMinErr("selmulti", "Binding to the 'multiple' attribute is not supported. Element: {0}", startingTag(node));
                    if (EVENT_HANDLER_ATTR_REGEXP.test(name)) throw $compileMinErr("nodomevents", "Interpolations for HTML DOM event attributes are disallowed");
                    directives.push({
                        priority: 100,
                        compile: function() {
                            return {
                                pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                                    var $$observers = attr.$$observers || (attr.$$observers = createMap());
                                    // If the attribute has changed since last $interpolate()ed
                                    var newValue = attr[name];
                                    if (newValue !== value) {
                                        // we need to interpolate again since the attribute value has been updated
                                        // (e.g. by another directive's compile function)
                                        // ensure unset/empty values make interpolateFn falsy
                                        interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                                        value = newValue;
                                    }
                                    // if attribute was updated so that there is no interpolation going on we don't want to
                                    // register any observers
                                    if (!interpolateFn) return;
                                    // initialize attr object so that it's ready in case we need the value for isolate
                                    // scope initialization, otherwise the value would not be available from isolate
                                    // directive's linking fn during linking phase
                                    attr[name] = interpolateFn(scope);
                                    ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                                    (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                                        //special case for class attribute addition + removal
                                        //so that class changes can tap into the animation
                                        //hooks provided by the $animate service. Be sure to
                                        //skip animations when the first digest occurs (when
                                        //both the new and the old values are the same) since
                                        //the CSS classes are the non-interpolated values
                                        if (name === "class" && newValue !== oldValue) attr.$updateClass(newValue, oldValue);
                                        else attr.$set(name, newValue);
                                    });
                                }
                            };
                        }
                    });
                }
                /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */ function replaceWith($rootElement, elementsToRemove, newNode) {
                    var firstElementToRemove = elementsToRemove[0], removeCount = elementsToRemove.length, parent = firstElementToRemove.parentNode, i, ii;
                    if ($rootElement) {
                        for(i = 0, ii = $rootElement.length; i < ii; i++)if ($rootElement[i] === firstElementToRemove) {
                            $rootElement[i++] = newNode;
                            for(var j = i, j2 = j + removeCount - 1, jj = $rootElement.length; j < jj; j++, j2++)if (j2 < jj) $rootElement[j] = $rootElement[j2];
                            else delete $rootElement[j];
                            $rootElement.length -= removeCount - 1;
                            // If the replaced element is also the jQuery .context then replace it
                            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
                            // http://api.jquery.com/context/
                            if ($rootElement.context === firstElementToRemove) $rootElement.context = newNode;
                            break;
                        }
                    }
                    if (parent) parent.replaceChild(newNode, firstElementToRemove);
                    // Append all the `elementsToRemove` to a fragment. This will...
                    // - remove them from the DOM
                    // - allow them to still be traversed with .nextSibling
                    // - allow a single fragment.qSA to fetch all elements being removed
                    var fragment = window1.document.createDocumentFragment();
                    for(i = 0; i < removeCount; i++)fragment.appendChild(elementsToRemove[i]);
                    if (jqLite.hasData(firstElementToRemove)) {
                        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
                        // data here because there's no public interface in jQuery to do that and copying over
                        // event listeners (which is the main use of private data) wouldn't work anyway.
                        jqLite.data(newNode, jqLite.data(firstElementToRemove));
                        // Remove $destroy event listeners from `firstElementToRemove`
                        jqLite(firstElementToRemove).off("$destroy");
                    }
                    // Cleanup any data/listeners on the elements and children.
                    // This includes invoking the $destroy event on any elements with listeners.
                    jqLite.cleanData(fragment.querySelectorAll("*"));
                    // Update the jqLite collection to only contain the `newNode`
                    for(i = 1; i < removeCount; i++)delete elementsToRemove[i];
                    elementsToRemove[0] = newNode;
                    elementsToRemove.length = 1;
                }
                function cloneAndAnnotateFn(fn, annotation) {
                    return extend(function() {
                        return fn.apply(null, arguments);
                    }, fn, annotation);
                }
                function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
                    try {
                        linkFn(scope, $element, attrs, controllers, transcludeFn);
                    } catch (e) {
                        $exceptionHandler(e, startingTag($element));
                    }
                }
                function strictBindingsCheck(attrName, directiveName) {
                    if (strictComponentBindingsEnabled) throw $compileMinErr("missingattr", "Attribute '{0}' of '{1}' is non-optional and must be set!", attrName, directiveName);
                }
                // Set up $watches for isolate scope and controller bindings.
                function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
                    var removeWatchCollection = [];
                    var initialChanges = {};
                    var changes;
                    forEach(bindings, function initializeBinding(definition, scopeName) {
                        var attrName = definition.attrName, optional = definition.optional, mode = definition.mode, lastValue, parentGet, parentSet, compare, removeWatch;
                        switch(mode){
                            case "@":
                                if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                                    strictBindingsCheck(attrName, directive.name);
                                    destination[scopeName] = attrs[attrName] = undefined;
                                }
                                removeWatch = attrs.$observe(attrName, function(value) {
                                    if (isString(value) || isBoolean(value)) {
                                        var oldValue = destination[scopeName];
                                        recordChanges(scopeName, value, oldValue);
                                        destination[scopeName] = value;
                                    }
                                });
                                attrs.$$observers[attrName].$$scope = scope;
                                lastValue = attrs[attrName];
                                if (isString(lastValue)) // If the attribute has been provided then we trigger an interpolation to ensure
                                // the value is there for use in the link fn
                                destination[scopeName] = $interpolate(lastValue)(scope);
                                else if (isBoolean(lastValue)) // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
                                // the value to boolean rather than a string, so we special case this situation
                                destination[scopeName] = lastValue;
                                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "=":
                                if (!hasOwnProperty.call(attrs, attrName)) {
                                    if (optional) break;
                                    strictBindingsCheck(attrName, directive.name);
                                    attrs[attrName] = undefined;
                                }
                                if (optional && !attrs[attrName]) break;
                                parentGet = $parse(attrs[attrName]);
                                if (parentGet.literal) compare = equals;
                                else compare = simpleCompare;
                                parentSet = parentGet.assign || function() {
                                    // reset the change, or we will throw this exception on every $digest
                                    lastValue = destination[scopeName] = parentGet(scope);
                                    throw $compileMinErr("nonassign", "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!", attrs[attrName], attrName, directive.name);
                                };
                                lastValue = destination[scopeName] = parentGet(scope);
                                var parentValueWatch = function parentValueWatch(parentValue) {
                                    if (!compare(parentValue, destination[scopeName])) {
                                        // we are out of sync and need to copy
                                        if (!compare(parentValue, lastValue)) // parent changed and it has precedence
                                        destination[scopeName] = parentValue;
                                        else // if the parent can be assigned then do so
                                        parentSet(scope, parentValue = destination[scopeName]);
                                    }
                                    lastValue = parentValue;
                                    return lastValue;
                                };
                                parentValueWatch.$stateful = true;
                                if (definition.collection) removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                                else removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "<":
                                if (!hasOwnProperty.call(attrs, attrName)) {
                                    if (optional) break;
                                    strictBindingsCheck(attrName, directive.name);
                                    attrs[attrName] = undefined;
                                }
                                if (optional && !attrs[attrName]) break;
                                parentGet = $parse(attrs[attrName]);
                                var isLiteral = parentGet.literal;
                                var initialValue = destination[scopeName] = parentGet(scope);
                                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                                removeWatch = scope[definition.collection ? "$watchCollection" : "$watch"](parentGet, function parentValueWatchAction(newValue, oldValue) {
                                    if (oldValue === newValue) {
                                        if (oldValue === initialValue || isLiteral && equals(oldValue, initialValue)) return;
                                        oldValue = initialValue;
                                    }
                                    recordChanges(scopeName, newValue, oldValue);
                                    destination[scopeName] = newValue;
                                });
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "&":
                                if (!optional && !hasOwnProperty.call(attrs, attrName)) strictBindingsCheck(attrName, directive.name);
                                // Don't assign Object.prototype method to scope
                                parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
                                // Don't assign noop to destination if expression is not valid
                                if (parentGet === noop && optional) break;
                                destination[scopeName] = function(locals) {
                                    return parentGet(scope, locals);
                                };
                                break;
                        }
                    });
                    function recordChanges(key, currentValue, previousValue) {
                        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
                            // If we have not already scheduled the top level onChangesQueue handler then do so now
                            if (!onChangesQueue) {
                                scope.$$postDigest(flushOnChangesQueue);
                                onChangesQueue = [];
                            }
                            // If we have not already queued a trigger of onChanges for this controller then do so now
                            if (!changes) {
                                changes = {};
                                onChangesQueue.push(triggerOnChangesHook);
                            }
                            // If the has been a change on this property already then we need to reuse the previous value
                            if (changes[key]) previousValue = changes[key].previousValue;
                            // Store this change
                            changes[key] = new SimpleChange(previousValue, currentValue);
                        }
                    }
                    function triggerOnChangesHook() {
                        destination.$onChanges(changes);
                        // Now clear the changes so that we schedule onChanges when more changes arrive
                        changes = undefined;
                    }
                    return {
                        initialChanges: initialChanges,
                        removeWatches: removeWatchCollection.length && function removeWatches() {
                            for(var i = 0, ii = removeWatchCollection.length; i < ii; ++i)removeWatchCollection[i]();
                        }
                    };
                }
            }
        ];
    }
    function SimpleChange(previous, current) {
        this.previousValue = previous;
        this.currentValue = current;
    }
    SimpleChange.prototype.isFirstChange = function() {
        return this.previousValue === _UNINITIALIZED_VALUE;
    };
    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
    var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
    /**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */ function directiveNormalize(name) {
        return name.replace(PREFIX_REGEXP, "").replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
            return offset ? letter.toUpperCase() : letter;
        });
    }
    /**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */ /**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */ /**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */ /**
 * Closure compiler type information
 */ function nodesetLinkingFn(/* angular.Scope */ scope, /* NodeList */ nodeList, /* Element */ rootElement, /* function(Function) */ boundTranscludeFn) {}
    function directiveLinkingFn(/* nodesetLinkingFn */ nodesetLinkingFn, /* angular.Scope */ scope, /* Node */ node, /* Element */ rootElement, /* function(Function) */ boundTranscludeFn) {}
    function tokenDifference(str1, str2) {
        var values = "", tokens1 = str1.split(/\s+/), tokens2 = str2.split(/\s+/);
        outer: for(var i = 0; i < tokens1.length; i++){
            var token = tokens1[i];
            for(var j = 0; j < tokens2.length; j++){
                if (token === tokens2[j]) continue outer;
            }
            values += (values.length > 0 ? " " : "") + token;
        }
        return values;
    }
    function removeComments(jqNodes) {
        jqNodes = jqLite(jqNodes);
        var i = jqNodes.length;
        if (i <= 1) return jqNodes;
        while(i--){
            var node = jqNodes[i];
            if (node.nodeType === NODE_TYPE_COMMENT || node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === "") splice.call(jqNodes, i, 1);
        }
        return jqNodes;
    }
    var $controllerMinErr = minErr("$controller");
    var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
    function identifierForController(controller, ident) {
        if (ident && isString(ident)) return ident;
        if (isString(controller)) {
            var match = CNTRL_REG.exec(controller);
            if (match) return match[3];
        }
    }
    /**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */ function $ControllerProvider() {
        var controllers = {};
        /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */ this.has = function(name) {
            return controllers.hasOwnProperty(name);
        };
        /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */ this.register = function(name, constructor) {
            assertNotHasOwnProperty(name, "controller");
            if (isObject(name)) extend(controllers, name);
            else controllers[name] = constructor;
        };
        this.$get = [
            "$injector",
            function($injector) {
                /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */ return function $controller(expression, locals, later, ident) {
                    // PRIVATE API:
                    //   param `later` --- indicates that the controller's constructor is invoked at a later time.
                    //                     If true, $controller will allocate the object with the correct
                    //                     prototype chain, but will not invoke the controller until a returned
                    //                     callback is invoked.
                    //   param `ident` --- An optional label which overrides the label parsed from the controller
                    //                     expression, if any.
                    var instance, match, constructor, identifier;
                    later = later === true;
                    if (ident && isString(ident)) identifier = ident;
                    if (isString(expression)) {
                        match = expression.match(CNTRL_REG);
                        if (!match) throw $controllerMinErr("ctrlfmt", "Badly formed controller string '{0}'. Must match `__name__ as __id__` or `__name__`.", expression);
                        constructor = match[1];
                        identifier = identifier || match[3];
                        expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true);
                        if (!expression) throw $controllerMinErr("ctrlreg", "The controller with the name '{0}' is not registered.", constructor);
                        assertArgFn(expression, constructor, true);
                    }
                    if (later) {
                        // Instantiate controller later:
                        // This machinery is used to create an instance of the object before calling the
                        // controller's constructor itself.
                        //
                        // This allows properties to be added to the controller before the constructor is
                        // invoked. Primarily, this is used for isolate scope bindings in $compile.
                        //
                        // This feature is not intended for use by applications, and is thus not documented
                        // publicly.
                        // Object creation: http://jsperf.com/create-constructor/2
                        var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
                        instance = Object.create(controllerPrototype || null);
                        if (identifier) addIdentifier(locals, identifier, instance, constructor || expression.name);
                        return extend(function $controllerInit() {
                            var result = $injector.invoke(expression, instance, locals, constructor);
                            if (result !== instance && (isObject(result) || isFunction(result))) {
                                instance = result;
                                if (identifier) // If result changed, re-assign controllerAs value to scope.
                                addIdentifier(locals, identifier, instance, constructor || expression.name);
                            }
                            return instance;
                        }, {
                            instance: instance,
                            identifier: identifier
                        });
                    }
                    instance = $injector.instantiate(expression, locals, constructor);
                    if (identifier) addIdentifier(locals, identifier, instance, constructor || expression.name);
                    return instance;
                };
                function addIdentifier(locals, identifier, instance, name) {
                    if (!(locals && isObject(locals.$scope))) throw minErr("$controller")("noscp", "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.", name, identifier);
                    locals.$scope[identifier] = instance;
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */ function $DocumentProvider() {
        this.$get = [
            "$window",
            function(window1) {
                return jqLite(window1.document);
            }
        ];
    }
    /**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */ function $$IsDocumentHiddenProvider() {
        this.$get = [
            "$document",
            "$rootScope",
            function($document, $rootScope) {
                var doc = $document[0];
                var hidden = doc && doc.hidden;
                $document.on("visibilitychange", changeListener);
                $rootScope.$on("$destroy", function() {
                    $document.off("visibilitychange", changeListener);
                });
                function changeListener() {
                    hidden = doc.hidden;
                }
                return function() {
                    return hidden;
                };
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */ function $ExceptionHandlerProvider() {
        this.$get = [
            "$log",
            function($log) {
                return function(exception, cause) {
                    $log.error.apply($log, arguments);
                };
            }
        ];
    }
    var $$ForceReflowProvider = /** @this */ function() {
        this.$get = [
            "$document",
            function($document) {
                return function(domNode) {
                    //the line below will force the browser to perform a repaint so
                    //that all the animated elements within the animation frame will
                    //be properly updated and drawn on screen. This is required to
                    //ensure that the preparation animation is properly flushed so that
                    //the active state picks up from there. DO NOT REMOVE THIS LINE.
                    //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
                    //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
                    //WILL TAKE YEARS AWAY FROM YOUR LIFE.
                    if (domNode) {
                        if (!domNode.nodeType && domNode instanceof jqLite) domNode = domNode[0];
                    } else domNode = $document[0].body;
                    return domNode.offsetWidth + 1;
                };
            }
        ];
    };
    var APPLICATION_JSON = "application/json";
    var CONTENT_TYPE_APPLICATION_JSON = {
        "Content-Type": APPLICATION_JSON + ";charset=utf-8"
    };
    var JSON_START = /^\[|^\{(?!\{)/;
    var JSON_ENDS = {
        "[": /]$/,
        "{": /}$/
    };
    var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
    var $httpMinErr = minErr("$http");
    function serializeValue(v) {
        if (isObject(v)) return isDate(v) ? v.toISOString() : toJson(v);
        return v;
    }
    /** @this */ function $HttpParamSerializerProvider() {
        /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */ this.$get = function() {
            return function ngParamSerializer(params) {
                if (!params) return "";
                var parts = [];
                forEachSorted(params, function(value, key) {
                    if (value === null || isUndefined(value) || isFunction(value)) return;
                    if (isArray(value)) forEach(value, function(v) {
                        parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(v)));
                    });
                    else parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(value)));
                });
                return parts.join("&");
            };
        };
    }
    /** @this */ function $HttpParamSerializerJQLikeProvider() {
        /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */ this.$get = function() {
            return function jQueryLikeParamSerializer(params) {
                if (!params) return "";
                var parts = [];
                serialize(params, "", true);
                return parts.join("&");
                function serialize(toSerialize, prefix, topLevel) {
                    if (isArray(toSerialize)) forEach(toSerialize, function(value, index) {
                        serialize(value, prefix + "[" + (isObject(value) ? index : "") + "]");
                    });
                    else if (isObject(toSerialize) && !isDate(toSerialize)) forEachSorted(toSerialize, function(value, key) {
                        serialize(value, prefix + (topLevel ? "" : "[") + key + (topLevel ? "" : "]"));
                    });
                    else {
                        if (isFunction(toSerialize)) toSerialize = toSerialize();
                        parts.push(encodeUriQuery(prefix) + "=" + (toSerialize == null ? "" : encodeUriQuery(serializeValue(toSerialize))));
                    }
                }
            };
        };
    }
    function defaultHttpResponseTransform(data, headers) {
        if (isString(data)) {
            // Strip json vulnerability protection prefix and trim whitespace
            var tempData = data.replace(JSON_PROTECTION_PREFIX, "").trim();
            if (tempData) {
                var contentType = headers("Content-Type");
                var hasJsonContentType = contentType && contentType.indexOf(APPLICATION_JSON) === 0;
                if (hasJsonContentType || isJsonLike(tempData)) try {
                    data = fromJson(tempData);
                } catch (e) {
                    if (!hasJsonContentType) return data;
                    throw $httpMinErr("baddata", 'Data must be a valid JSON object. Received: "{0}". Parse error: "{1}"', data, e);
                }
            }
        }
        return data;
    }
    function isJsonLike(str) {
        var jsonStart = str.match(JSON_START);
        return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
    }
    /**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */ function parseHeaders(headers) {
        var parsed = createMap(), i;
        function fillInParsed(key, val) {
            if (key) parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
        if (isString(headers)) forEach(headers.split("\n"), function(line) {
            i = line.indexOf(":");
            fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
        });
        else if (isObject(headers)) forEach(headers, function(headerVal, headerKey) {
            fillInParsed(lowercase(headerKey), trim(headerVal));
        });
        return parsed;
    }
    /**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */ function headersGetter(headers) {
        var headersObj;
        return function(name) {
            if (!headersObj) headersObj = parseHeaders(headers);
            if (name) {
                var value = headersObj[lowercase(name)];
                if (value === undefined) value = null;
                return value;
            }
            return headersObj;
        };
    }
    /**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */ function transformData(data, headers, status, fns) {
        if (isFunction(fns)) return fns(data, headers, status);
        forEach(fns, function(fn) {
            data = fn(data, headers, status);
        });
        return data;
    }
    function isSuccess(status) {
        return 200 <= status && status < 300;
    }
    /**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */ function $HttpProvider() {
        /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */ var defaults = this.defaults = {
            // transform incoming response data
            transformResponse: [
                defaultHttpResponseTransform
            ],
            // transform outgoing request data
            transformRequest: [
                function(d) {
                    return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
                }
            ],
            // default headers
            headers: {
                common: {
                    "Accept": "application/json, text/plain, */*"
                },
                post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
                put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
                patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
            },
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            paramSerializer: "$httpParamSerializer",
            jsonpCallbackParam: "callback"
        };
        var useApplyAsync = false;
        /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */ this.useApplyAsync = function(value) {
            if (isDefined(value)) {
                useApplyAsync = !!value;
                return this;
            }
            return useApplyAsync;
        };
        /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */ var interceptorFactories = this.interceptors = [];
        /**
   * @ngdoc property
   * @name $httpProvider#xsrfTrustedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfTrustedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */ var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
        /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
   * instead.
   */ Object.defineProperty(this, "xsrfWhitelistedOrigins", {
            get: function() {
                return this.xsrfTrustedOrigins;
            },
            set: function(origins) {
                this.xsrfTrustedOrigins = origins;
            }
        });
        this.$get = [
            "$browser",
            "$httpBackend",
            "$$cookieReader",
            "$cacheFactory",
            "$rootScope",
            "$q",
            "$injector",
            "$sce",
            function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
                var defaultCache = $cacheFactory("$http");
                /**
     * Make sure that default param serializer is exposed as a function
     */ defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
                /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */ var reversedInterceptors = [];
                forEach(interceptorFactories, function(interceptorFactory) {
                    reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
                });
                /**
     * A function to check request URLs against a list of allowed origins.
     */ var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
                /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can trust additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only trusted origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */ function $http(requestConfig) {
                    if (!isObject(requestConfig)) throw minErr("$http")("badreq", "Http request configuration must be an object.  Received: {0}", requestConfig);
                    if (!isString($sce.valueOf(requestConfig.url))) throw minErr("$http")("badreq", "Http request configuration url must be a string or a $sce trusted object.  Received: {0}", requestConfig.url);
                    var config = extend({
                        method: "get",
                        transformRequest: defaults.transformRequest,
                        transformResponse: defaults.transformResponse,
                        paramSerializer: defaults.paramSerializer,
                        jsonpCallbackParam: defaults.jsonpCallbackParam
                    }, requestConfig);
                    config.headers = mergeHeaders(requestConfig);
                    config.method = uppercase(config.method);
                    config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;
                    $browser.$$incOutstandingRequestCount("$http");
                    var requestInterceptors = [];
                    var responseInterceptors = [];
                    var promise = $q.resolve(config);
                    // apply interceptors
                    forEach(reversedInterceptors, function(interceptor) {
                        if (interceptor.request || interceptor.requestError) requestInterceptors.unshift(interceptor.request, interceptor.requestError);
                        if (interceptor.response || interceptor.responseError) responseInterceptors.push(interceptor.response, interceptor.responseError);
                    });
                    promise = chainInterceptors(promise, requestInterceptors);
                    promise = promise.then(serverRequest);
                    promise = chainInterceptors(promise, responseInterceptors);
                    promise = promise.finally(completeOutstandingRequest);
                    return promise;
                    function chainInterceptors(promise, interceptors) {
                        for(var i = 0, ii = interceptors.length; i < ii;){
                            var thenFn = interceptors[i++];
                            var rejectFn = interceptors[i++];
                            promise = promise.then(thenFn, rejectFn);
                        }
                        interceptors.length = 0;
                        return promise;
                    }
                    function completeOutstandingRequest() {
                        $browser.$$completeOutstandingRequest(noop, "$http");
                    }
                    function executeHeaderFns(headers, config) {
                        var headerContent, processedHeaders = {};
                        forEach(headers, function(headerFn, header) {
                            if (isFunction(headerFn)) {
                                headerContent = headerFn(config);
                                if (headerContent != null) processedHeaders[header] = headerContent;
                            } else processedHeaders[header] = headerFn;
                        });
                        return processedHeaders;
                    }
                    function mergeHeaders(config) {
                        var defHeaders = defaults.headers, reqHeaders = extend({}, config.headers), defHeaderName, lowercaseDefHeaderName, reqHeaderName;
                        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
                        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
                        defaultHeadersIteration: for(defHeaderName in defHeaders){
                            lowercaseDefHeaderName = lowercase(defHeaderName);
                            for(reqHeaderName in reqHeaders){
                                if (lowercase(reqHeaderName) === lowercaseDefHeaderName) continue defaultHeadersIteration;
                            }
                            reqHeaders[defHeaderName] = defHeaders[defHeaderName];
                        }
                        // execute if header value is a function for merged headers
                        return executeHeaderFns(reqHeaders, shallowCopy(config));
                    }
                    function serverRequest(config) {
                        var headers = config.headers;
                        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
                        // strip content-type if data is undefined
                        if (isUndefined(reqData)) forEach(headers, function(value, header) {
                            if (lowercase(header) === "content-type") delete headers[header];
                        });
                        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) config.withCredentials = defaults.withCredentials;
                        // send request
                        return sendReq(config, reqData).then(transformResponse, transformResponse);
                    }
                    function transformResponse(response) {
                        // make a copy since the response must be cacheable
                        var resp = extend({}, response);
                        resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
                        return isSuccess(response.status) ? resp : $q.reject(resp);
                    }
                }
                $http.pendingRequests = [];
                /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the trusted resource URL list via
     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ createShortMethods("get", "delete", "head", "jsonp");
                /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */ createShortMethodsWithData("post", "put", "patch");
                /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */ $http.defaults = defaults;
                return $http;
                function createShortMethods(names) {
                    forEach(arguments, function(name) {
                        $http[name] = function(url, config) {
                            return $http(extend({}, config || {}, {
                                method: name,
                                url: url
                            }));
                        };
                    });
                }
                function createShortMethodsWithData(name) {
                    forEach(arguments, function(name) {
                        $http[name] = function(url, data, config) {
                            return $http(extend({}, config || {}, {
                                method: name,
                                url: url,
                                data: data
                            }));
                        };
                    });
                }
                /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */ function sendReq(config, reqData) {
                    var deferred = $q.defer(), promise = deferred.promise, cache, cachedResp, reqHeaders = config.headers, isJsonp = lowercase(config.method) === "jsonp", url = config.url;
                    if (isJsonp) // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
                    // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
                    url = $sce.getTrustedResourceUrl(url);
                    else if (!isString(url)) // If it is not a string then the URL must be a $sce trusted object
                    url = $sce.valueOf(url);
                    url = buildUrl(url, config.paramSerializer(config.params));
                    if (isJsonp) // Check the url and add the JSONP callback placeholder
                    url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
                    $http.pendingRequests.push(config);
                    promise.then(removePendingReq, removePendingReq);
                    if ((config.cache || defaults.cache) && config.cache !== false && (config.method === "GET" || config.method === "JSONP")) cache = isObject(config.cache) ? config.cache : isObject(/** @type {?} */ defaults.cache) ? /** @type {?} */ defaults.cache : defaultCache;
                    if (cache) {
                        cachedResp = cache.get(url);
                        if (isDefined(cachedResp)) {
                            if (isPromiseLike(cachedResp)) // cached request has already been sent, but there is no response yet
                            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
                            else // serving from cache
                            if (isArray(cachedResp)) resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
                            else resolvePromise(cachedResp, 200, {}, "OK", "complete");
                        } else // put the promise for the non-transformed response into cache as a placeholder
                        cache.put(url, promise);
                    }
                    // if we won't have the response in cache, set the xsrf headers and
                    // send the request to the backend
                    if (isUndefined(cachedResp)) {
                        var xsrfValue = urlIsAllowedOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
                        if (xsrfValue) reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
                        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
                    }
                    return promise;
                    function createApplyHandlers(eventHandlers) {
                        if (eventHandlers) {
                            var applyHandlers = {};
                            forEach(eventHandlers, function(eventHandler, key) {
                                applyHandlers[key] = function(event) {
                                    if (useApplyAsync) $rootScope.$applyAsync(callEventHandler);
                                    else if ($rootScope.$$phase) callEventHandler();
                                    else $rootScope.$apply(callEventHandler);
                                    function callEventHandler() {
                                        eventHandler(event);
                                    }
                                };
                            });
                            return applyHandlers;
                        }
                    }
                    /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */ function done(status, response, headersString, statusText, xhrStatus) {
                        if (cache) {
                            if (isSuccess(status)) cache.put(url, [
                                status,
                                response,
                                parseHeaders(headersString),
                                statusText,
                                xhrStatus
                            ]);
                            else // remove promise from the cache
                            cache.remove(url);
                        }
                        function resolveHttpPromise() {
                            resolvePromise(response, status, headersString, statusText, xhrStatus);
                        }
                        if (useApplyAsync) $rootScope.$applyAsync(resolveHttpPromise);
                        else {
                            resolveHttpPromise();
                            if (!$rootScope.$$phase) $rootScope.$apply();
                        }
                    }
                    /**
       * Resolves the raw $http promise.
       */ function resolvePromise(response, status, headers, statusText, xhrStatus) {
                        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
                        status = status >= -1 ? status : 0;
                        (isSuccess(status) ? deferred.resolve : deferred.reject)({
                            data: response,
                            status: status,
                            headers: headersGetter(headers),
                            config: config,
                            statusText: statusText,
                            xhrStatus: xhrStatus
                        });
                    }
                    function resolvePromiseWithResult(result) {
                        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
                    }
                    function removePendingReq() {
                        var idx = $http.pendingRequests.indexOf(config);
                        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
                    }
                }
                function buildUrl(url, serializedParams) {
                    if (serializedParams.length > 0) url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    return url;
                }
                function sanitizeJsonpCallbackParam(url, cbKey) {
                    var parts = url.split("?");
                    if (parts.length > 2) // Throw if the url contains more than one `?` query indicator
                    throw $httpMinErr("badjsonp", 'Illegal use more than one "?", in url, "{1}"', url);
                    var params = parseKeyValue(parts[1]);
                    forEach(params, function(value, key) {
                        if (value === "JSON_CALLBACK") // Throw if the url already contains a reference to JSON_CALLBACK
                        throw $httpMinErr("badjsonp", 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
                        if (key === cbKey) // Throw if the callback param was already provided
                        throw $httpMinErr("badjsonp", 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
                    });
                    // Add in the JSON_CALLBACK callback param value
                    url += (url.indexOf("?") === -1 ? "?" : "&") + cbKey + "=JSON_CALLBACK";
                    return url;
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */ function $xhrFactoryProvider() {
        this.$get = function() {
            return function createXhr() {
                return new window1.XMLHttpRequest();
            };
        };
    }
    /**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */ function $HttpBackendProvider() {
        this.$get = [
            "$browser",
            "$jsonpCallbacks",
            "$document",
            "$xhrFactory",
            function($browser, $jsonpCallbacks, $document, $xhrFactory) {
                return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
            }
        ];
    }
    function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
        // TODO(vojta): fix the signature
        return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
            url = url || $browser.url();
            if (lowercase(method) === "jsonp") {
                var callbackPath = callbacks.createCallback(url);
                var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
                    // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
                    var response = status === 200 && callbacks.getResponse(callbackPath);
                    completeRequest(callback, status, response, "", text, "complete");
                    callbacks.removeCallback(callbackPath);
                });
            } else {
                var xhr = createXhr(method, url);
                var abortedByTimeout = false;
                xhr.open(method, url, true);
                forEach(headers, function(value, key) {
                    if (isDefined(value)) xhr.setRequestHeader(key, value);
                });
                xhr.onload = function requestLoaded() {
                    var statusText = xhr.statusText || "";
                    // responseText is the old-school way of retrieving response (supported by IE9)
                    // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
                    var response = "response" in xhr ? xhr.response : xhr.responseText;
                    // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                    var status = xhr.status === 1223 ? 204 : xhr.status;
                    // fix status code when it is 0 (0 status is undocumented).
                    // Occurs when accessing file resources or on Android 4.1 stock browser
                    // while retrieving files from application cache.
                    if (status === 0) status = response ? 200 : urlResolve(url).protocol === "file" ? 404 : 0;
                    completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText, "complete");
                };
                var requestError = function() {
                    // The response is always empty
                    // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
                    completeRequest(callback, -1, null, null, "", "error");
                };
                var requestAborted = function() {
                    completeRequest(callback, -1, null, null, "", abortedByTimeout ? "timeout" : "abort");
                };
                var requestTimeout = function() {
                    // The response is always empty
                    // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
                    completeRequest(callback, -1, null, null, "", "timeout");
                };
                xhr.onerror = requestError;
                xhr.ontimeout = requestTimeout;
                xhr.onabort = requestAborted;
                forEach(eventHandlers, function(value, key) {
                    xhr.addEventListener(key, value);
                });
                forEach(uploadEventHandlers, function(value, key) {
                    xhr.upload.addEventListener(key, value);
                });
                if (withCredentials) xhr.withCredentials = true;
                if (responseType) try {
                    xhr.responseType = responseType;
                } catch (e) {
                    // WebKit added support for the json responseType value on 09/03/2013
                    // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
                    // known to throw when setting the value "json" as the response type. Other older
                    // browsers implementing the responseType
                    //
                    // The json response type can be ignored if not supported, because JSON payloads are
                    // parsed on the client-side regardless.
                    if (responseType !== "json") throw e;
                }
                xhr.send(isUndefined(post) ? null : post);
            }
            // Since we are using xhr.abort() when a request times out, we have to set a flag that
            // indicates to requestAborted if the request timed out or was aborted.
            //
            // http.timeout = numerical timeout   timeout
            // http.timeout = $timeout            timeout
            // http.timeout = promise             abort
            // xhr.abort()                        abort (The xhr object is normally inaccessible, but
            //                                    can be exposed with the xhrFactory)
            if (timeout > 0) var timeoutId = $browserDefer(function() {
                timeoutRequest("timeout");
            }, timeout);
            else if (isPromiseLike(timeout)) timeout.then(function() {
                timeoutRequest(isDefined(timeout.$$timeoutId) ? "timeout" : "abort");
            });
            function timeoutRequest(reason) {
                abortedByTimeout = reason === "timeout";
                if (jsonpDone) jsonpDone();
                if (xhr) xhr.abort();
            }
            function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
                // cancel timeout and subsequent timeout promise resolution
                if (isDefined(timeoutId)) $browserDefer.cancel(timeoutId);
                jsonpDone = xhr = null;
                callback(status, response, headersString, statusText, xhrStatus);
            }
        };
        function jsonpReq(url, callbackPath, done) {
            url = url.replace("JSON_CALLBACK", callbackPath);
            // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
            // - fetches local scripts via XHR and evals them
            // - adds and immediately removes script elements from the document
            var script = rawDocument.createElement("script"), callback = null;
            script.type = "text/javascript";
            script.src = url;
            script.async = true;
            callback = function(event) {
                script.removeEventListener("load", callback);
                script.removeEventListener("error", callback);
                rawDocument.body.removeChild(script);
                script = null;
                var status = -1;
                var text = "unknown";
                if (event) {
                    if (event.type === "load" && !callbacks.wasCalled(callbackPath)) event = {
                        type: "error"
                    };
                    text = event.type;
                    status = event.type === "error" ? 404 : 200;
                }
                if (done) done(status, text);
            };
            script.addEventListener("load", callback);
            script.addEventListener("error", callback);
            rawDocument.body.appendChild(script);
            return callback;
        }
    }
    var $interpolateMinErr = angular.$interpolateMinErr = minErr("$interpolate");
    $interpolateMinErr.throwNoconcat = function(text) {
        throw $interpolateMinErr("noconcat", "Error while interpolating: {0}\nStrict Contextual Escaping disallows interpolations that concatenate multiple expressions when a trusted value is required.  See http://docs.angularjs.org/api/ng.$sce", text);
    };
    $interpolateMinErr.interr = function(text, err) {
        return $interpolateMinErr("interr", "Can't interpolate: {0}\n{1}", text, err.toString());
    };
    /**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */ function $InterpolateProvider() {
        var startSymbol = "{{";
        var endSymbol = "}}";
        /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */ this.startSymbol = function(value) {
            if (value) {
                startSymbol = value;
                return this;
            }
            return startSymbol;
        };
        /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */ this.endSymbol = function(value) {
            if (value) {
                endSymbol = value;
                return this;
            }
            return endSymbol;
        };
        this.$get = [
            "$parse",
            "$exceptionHandler",
            "$sce",
            function($parse, $exceptionHandler, $sce) {
                var startSymbolLength = startSymbol.length, endSymbolLength = endSymbol.length, escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), "g"), escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), "g");
                function escape(ch) {
                    return "\\\\\\" + ch;
                }
                function unescapeText(text) {
                    return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
                }
                // TODO: this is the same as the constantWatchDelegate in parse.js
                function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
                    var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
                        unwatch();
                        return constantInterp(scope);
                    }, listener, objectEquality);
                    return unwatch;
                }
                /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */ function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
                    var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
                    // Provide a quick exit and simplified result function for text with no interpolation
                    if (!text.length || text.indexOf(startSymbol) === -1) {
                        if (mustHaveExpression) return;
                        var unescapedText = unescapeText(text);
                        if (contextAllowsConcatenation) unescapedText = $sce.getTrusted(trustedContext, unescapedText);
                        var constantInterp = valueFn(unescapedText);
                        constantInterp.exp = text;
                        constantInterp.expressions = [];
                        constantInterp.$$watchDelegate = constantWatchDelegate;
                        return constantInterp;
                    }
                    allOrNothing = !!allOrNothing;
                    var startIndex, endIndex, index = 0, expressions = [], parseFns, textLength = text.length, exp, concat = [], expressionPositions = [], singleExpression;
                    while(index < textLength)if ((startIndex = text.indexOf(startSymbol, index)) !== -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1) {
                        if (index !== startIndex) concat.push(unescapeText(text.substring(index, startIndex)));
                        exp = text.substring(startIndex + startSymbolLength, endIndex);
                        expressions.push(exp);
                        index = endIndex + endSymbolLength;
                        expressionPositions.push(concat.length);
                        concat.push(""); // Placeholder that will get replaced with the evaluated expression.
                    } else {
                        // we did not find an interpolation, so we have to add the remainder to the separators array
                        if (index !== textLength) concat.push(unescapeText(text.substring(index)));
                        break;
                    }
                    singleExpression = concat.length === 1 && expressionPositions.length === 1;
                    // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
                    // objects rather than simple strings
                    // (we don't modify the expression if the input consists of only a single trusted input)
                    var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
                    parseFns = expressions.map(function(exp) {
                        return $parse(exp, interceptor);
                    });
                    // Concatenating expressions makes it hard to reason about whether some combination of
                    // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
                    // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
                    // we ensure that the value that's used is assigned or constructed by some JS code somewhere
                    // that is more testable or make it obvious that you bound the value to some user controlled
                    // value.  This helps reduce the load when auditing for XSS issues.
                    // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
                    // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
                    // or on the overall concatenated string (losing trusted types used in the mix, by design).
                    // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
                    // only used in srcdoc attributes, this would not be very useful.
                    if (!mustHaveExpression || expressions.length) {
                        var compute = function(values) {
                            for(var i = 0, ii = expressions.length; i < ii; i++){
                                if (allOrNothing && isUndefined(values[i])) return;
                                concat[expressionPositions[i]] = values[i];
                            }
                            if (contextAllowsConcatenation) // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
                            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(""));
                            else if (trustedContext && concat.length > 1) // This context does not allow more than one part, e.g. expr + string or exp + exp.
                            $interpolateMinErr.throwNoconcat(text);
                            // In an unprivileged context or only one part: just concatenate and return.
                            return concat.join("");
                        };
                        return extend(function interpolationFn(context) {
                            var i = 0;
                            var ii = expressions.length;
                            var values = new Array(ii);
                            try {
                                for(; i < ii; i++)values[i] = parseFns[i](context);
                                return compute(values);
                            } catch (err) {
                                $exceptionHandler($interpolateMinErr.interr(text, err));
                            }
                        }, {
                            // all of these properties are undocumented for now
                            exp: text,
                            expressions: expressions,
                            $$watchDelegate: function(scope, listener) {
                                var lastValue;
                                return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
                                    var currValue = compute(values);
                                    listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                                    lastValue = currValue;
                                });
                            }
                        });
                    }
                    function parseStringifyInterceptor(value) {
                        try {
                            // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
                            // parts of a full URL. We don't care about losing the trustedness here.
                            // In non-concatenable contexts, where there is only one expression, this interceptor is
                            // not applied to the expression.
                            value = trustedContext && !contextAllowsConcatenation ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
                            return allOrNothing && !isDefined(value) ? value : stringify(value);
                        } catch (err) {
                            $exceptionHandler($interpolateMinErr.interr(text, err));
                        }
                    }
                }
                /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */ $interpolate.startSymbol = function() {
                    return startSymbol;
                };
                /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */ $interpolate.endSymbol = function() {
                    return endSymbol;
                };
                return $interpolate;
            }
        ];
    }
    var $intervalMinErr = minErr("$interval");
    /** @this */ function $IntervalProvider() {
        this.$get = [
            "$$intervalFactory",
            "$window",
            function($$intervalFactory, $window) {
                var intervals = {};
                var setIntervalFn = function(tick, delay, deferred) {
                    var id = $window.setInterval(tick, delay);
                    intervals[id] = deferred;
                    return id;
                };
                var clearIntervalFn = function(id) {
                    $window.clearInterval(id);
                    delete intervals[id];
                };
                /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */ var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
                /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */ interval.cancel = function(promise) {
                    if (!promise) return false;
                    if (!promise.hasOwnProperty("$$intervalId")) throw $intervalMinErr("badprom", "`$interval.cancel()` called with a promise that was not generated by `$interval()`.");
                    if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
                    var id = promise.$$intervalId;
                    var deferred = intervals[id];
                    // Interval cancels should not report an unhandled promise.
                    markQExceptionHandled(deferred.promise);
                    deferred.reject("canceled");
                    clearIntervalFn(id);
                    return true;
                };
                return interval;
            }
        ];
    }
    /** @this */ function $$IntervalFactoryProvider() {
        this.$get = [
            "$browser",
            "$q",
            "$$q",
            "$rootScope",
            function($browser, $q, $$q, $rootScope) {
                return function intervalFactory(setIntervalFn, clearIntervalFn) {
                    return function intervalFn(fn, delay, count, invokeApply) {
                        var hasParams = arguments.length > 4, args = hasParams ? sliceArgs(arguments, 4) : [], iteration = 0, skipApply = isDefined(invokeApply) && !invokeApply, deferred = (skipApply ? $$q : $q).defer(), promise = deferred.promise;
                        count = isDefined(count) ? count : 0;
                        function callback() {
                            if (!hasParams) fn(iteration);
                            else fn.apply(null, args);
                        }
                        function tick() {
                            if (skipApply) $browser.defer(callback);
                            else $rootScope.$evalAsync(callback);
                            deferred.notify(iteration++);
                            if (count > 0 && iteration >= count) {
                                deferred.resolve(iteration);
                                clearIntervalFn(promise.$$intervalId);
                            }
                            if (!skipApply) $rootScope.$apply();
                        }
                        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
                        return promise;
                    };
                };
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */ var $jsonpCallbacksProvider = /** @this */ function() {
        this.$get = function() {
            var callbacks = angular.callbacks;
            var callbackMap = {};
            function createCallback(callbackId) {
                var callback = function(data) {
                    callback.data = data;
                    callback.called = true;
                };
                callback.id = callbackId;
                return callback;
            }
            return {
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */ createCallback: function(url) {
                    var callbackId = "_" + (callbacks.$$counter++).toString(36);
                    var callbackPath = "angular.callbacks." + callbackId;
                    var callback = createCallback(callbackId);
                    callbackMap[callbackPath] = callbacks[callbackId] = callback;
                    return callbackPath;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */ wasCalled: function(callbackPath) {
                    return callbackMap[callbackPath].called;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */ getResponse: function(callbackPath) {
                    return callbackMap[callbackPath].data;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */ removeCallback: function(callbackPath) {
                    var callback = callbackMap[callbackPath];
                    delete callbacks[callback.id];
                    delete callbackMap[callbackPath];
                }
            };
        };
    };
    /**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */ /* global stripHash: true */ var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/, DEFAULT_PORTS = {
        "http": 80,
        "https": 443,
        "ftp": 21
    };
    var $locationMinErr = minErr("$location");
    /**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */ function encodePath(path) {
        var segments = path.split("/"), i = segments.length;
        while(i--)// decode forward slashes to prevent them from being double encoded
        segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, "/"));
        return segments.join("/");
    }
    function decodePath(path, html5Mode) {
        var segments = path.split("/"), i = segments.length;
        while(i--){
            segments[i] = decodeURIComponent(segments[i]);
            if (html5Mode) // encode forward slashes to prevent them from being mistaken for path separators
            segments[i] = segments[i].replace(/\//g, "%2F");
        }
        return segments.join("/");
    }
    function normalizePath(pathValue, searchValue, hashValue) {
        var search = toKeyValue(searchValue), hash = hashValue ? "#" + encodeUriSegment(hashValue) : "", path = encodePath(pathValue);
        return path + (search ? "?" + search : "") + hash;
    }
    function parseAbsoluteUrl(absoluteUrl, locationObj) {
        var parsedUrl = urlResolve(absoluteUrl);
        locationObj.$$protocol = parsedUrl.protocol;
        locationObj.$$host = parsedUrl.hostname;
        locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
    }
    var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
    function parseAppUrl(url, locationObj, html5Mode) {
        if (DOUBLE_SLASH_REGEX.test(url)) throw $locationMinErr("badpath", 'Invalid url "{0}".', url);
        var prefixed = url.charAt(0) !== "/";
        if (prefixed) url = "/" + url;
        var match = urlResolve(url);
        var path = prefixed && match.pathname.charAt(0) === "/" ? match.pathname.substring(1) : match.pathname;
        locationObj.$$path = decodePath(path, html5Mode);
        locationObj.$$search = parseKeyValue(match.search);
        locationObj.$$hash = decodeURIComponent(match.hash);
        // make sure path starts with '/';
        if (locationObj.$$path && locationObj.$$path.charAt(0) !== "/") locationObj.$$path = "/" + locationObj.$$path;
    }
    function startsWith(str, search) {
        return str.slice(0, search.length) === search;
    }
    /**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */ function stripBaseUrl(base, url) {
        if (startsWith(url, base)) return url.substr(base.length);
    }
    function stripHash(url) {
        var index = url.indexOf("#");
        return index === -1 ? url : url.substr(0, index);
    }
    function stripFile(url) {
        return url.substr(0, stripHash(url).lastIndexOf("/") + 1);
    }
    /* return the server only (scheme://host:port) */ function serverBase(url) {
        return url.substring(0, url.indexOf("/", url.indexOf("//") + 2));
    }
    /**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */ function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
        this.$$html5 = true;
        basePrefix = basePrefix || "";
        parseAbsoluteUrl(appBase, this);
        /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */ this.$$parse = function(url) {
            var pathUrl = stripBaseUrl(appBaseNoFile, url);
            if (!isString(pathUrl)) throw $locationMinErr("ipthprfx", 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
            parseAppUrl(pathUrl, this, true);
            if (!this.$$path) this.$$path = "/";
            this.$$compose();
        };
        this.$$normalizeUrl = function(url) {
            return appBaseNoFile + url.substr(1); // first char is always '/'
        };
        this.$$parseLinkUrl = function(url, relHref) {
            if (relHref && relHref[0] === "#") {
                // special case for links to hash fragments:
                // keep the old url and only replace the hash fragment
                this.hash(relHref.slice(1));
                return true;
            }
            var appUrl, prevAppUrl;
            var rewrittenUrl;
            if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
                prevAppUrl = appUrl;
                if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) rewrittenUrl = appBaseNoFile + (stripBaseUrl("/", appUrl) || appUrl);
                else rewrittenUrl = appBase + prevAppUrl;
            } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) rewrittenUrl = appBaseNoFile + appUrl;
            else if (appBaseNoFile === url + "/") rewrittenUrl = appBaseNoFile;
            if (rewrittenUrl) this.$$parse(rewrittenUrl);
            return !!rewrittenUrl;
        };
    }
    /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */ function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
        parseAbsoluteUrl(appBase, this);
        /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */ this.$$parse = function(url) {
            var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
            var withoutHashUrl;
            if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === "#") {
                // The rest of the URL starts with a hash so we have
                // got either a hashbang path or a plain hash fragment
                withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
                if (isUndefined(withoutHashUrl)) // There was no hashbang prefix so we just have a hash fragment
                withoutHashUrl = withoutBaseUrl;
            } else // There was no hashbang path nor hash fragment:
            // If we are in HTML5 mode we use what is left as the path;
            // Otherwise we ignore what is left
            if (this.$$html5) withoutHashUrl = withoutBaseUrl;
            else {
                withoutHashUrl = "";
                if (isUndefined(withoutBaseUrl)) {
                    appBase = url;
                    /** @type {?} */ this.replace();
                }
            }
            parseAppUrl(withoutHashUrl, this, false);
            this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
            this.$$compose();
            /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */ function removeWindowsDriveName(path, url, base) {
                /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */ var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
                var firstPathSegmentMatch;
                //Get the relative path from the input URL.
                if (startsWith(url, base)) url = url.replace(base, "");
                // The input URL intentionally contains a first path segment that ends with a colon.
                if (windowsFilePathExp.exec(url)) return path;
                firstPathSegmentMatch = windowsFilePathExp.exec(path);
                return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
            }
        };
        this.$$normalizeUrl = function(url) {
            return appBase + (url ? hashPrefix + url : "");
        };
        this.$$parseLinkUrl = function(url, relHref) {
            if (stripHash(appBase) === stripHash(url)) {
                this.$$parse(url);
                return true;
            }
            return false;
        };
    }
    /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */ function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
        this.$$html5 = true;
        LocationHashbangUrl.apply(this, arguments);
        this.$$parseLinkUrl = function(url, relHref) {
            if (relHref && relHref[0] === "#") {
                // special case for links to hash fragments:
                // keep the old url and only replace the hash fragment
                this.hash(relHref.slice(1));
                return true;
            }
            var rewrittenUrl;
            var appUrl;
            if (appBase === stripHash(url)) rewrittenUrl = url;
            else if (appUrl = stripBaseUrl(appBaseNoFile, url)) rewrittenUrl = appBase + hashPrefix + appUrl;
            else if (appBaseNoFile === url + "/") rewrittenUrl = appBaseNoFile;
            if (rewrittenUrl) this.$$parse(rewrittenUrl);
            return !!rewrittenUrl;
        };
        this.$$normalizeUrl = function(url) {
            // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
            return appBase + hashPrefix + url;
        };
    }
    var locationPrototype = {
        /**
   * Ensure absolute URL is initialized.
   * @private
   */ $$absUrl: "",
        /**
   * Are we in html5 mode?
   * @private
   */ $$html5: false,
        /**
   * Has any change been replacing?
   * @private
   */ $$replace: false,
        /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */ $$compose: function() {
            this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
            this.$$absUrl = this.$$normalizeUrl(this.$$url);
            this.$$urlUpdatedByLocation = true;
        },
        /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */ absUrl: locationGetter("$$absUrl"),
        /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */ url: function(url) {
            if (isUndefined(url)) return this.$$url;
            var match = PATH_MATCH.exec(url);
            if (match[1] || url === "") this.path(decodeURIComponent(match[1]));
            if (match[2] || match[1] || url === "") this.search(match[3] || "");
            this.hash(match[5] || "");
            return this;
        },
        /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */ protocol: locationGetter("$$protocol"),
        /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */ host: locationGetter("$$host"),
        /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */ port: locationGetter("$$port"),
        /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */ path: locationGetterSetter("$$path", function(path) {
            path = path !== null ? path.toString() : "";
            return path.charAt(0) === "/" ? path : "/" + path;
        }),
        /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */ search: function(search, paramValue) {
            switch(arguments.length){
                case 0:
                    return this.$$search;
                case 1:
                    if (isString(search) || isNumber(search)) {
                        search = search.toString();
                        this.$$search = parseKeyValue(search);
                    } else if (isObject(search)) {
                        search = copy(search, {});
                        // remove object undefined or null properties
                        forEach(search, function(value, key) {
                            if (value == null) delete search[key];
                        });
                        this.$$search = search;
                    } else throw $locationMinErr("isrcharg", "The first argument of the `$location#search()` call must be a string or an object.");
                    break;
                default:
                    if (isUndefined(paramValue) || paramValue === null) delete this.$$search[search];
                    else this.$$search[search] = paramValue;
            }
            this.$$compose();
            return this;
        },
        /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */ hash: locationGetterSetter("$$hash", function(hash) {
            return hash !== null ? hash.toString() : "";
        }),
        /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */ replace: function() {
            this.$$replace = true;
            return this;
        }
    };
    forEach([
        LocationHashbangInHtml5Url,
        LocationHashbangUrl,
        LocationHtml5Url
    ], function(Location) {
        Location.prototype = Object.create(locationPrototype);
        /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */ Location.prototype.state = function(state) {
            if (!arguments.length) return this.$$state;
            if (Location !== LocationHtml5Url || !this.$$html5) throw $locationMinErr("nostate", "History API state support is available only in HTML5 mode and only in browsers supporting HTML5 History API");
            // The user might modify `stateObject` after invoking `$location.state(stateObject)`
            // but we're changing the $$state reference to $browser.state() during the $digest
            // so the modification window is narrow.
            this.$$state = isUndefined(state) ? null : state;
            this.$$urlUpdatedByLocation = true;
            return this;
        };
    });
    function locationGetter(property) {
        return /** @this */ function() {
            return this[property];
        };
    }
    function locationGetterSetter(property, preprocess) {
        return /** @this */ function(value) {
            if (isUndefined(value)) return this[property];
            this[property] = preprocess(value);
            this.$$compose();
            return this;
        };
    }
    /**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */ /**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */ function $LocationProvider() {
        var hashPrefix = "!", html5Mode = {
            enabled: false,
            requireBase: true,
            rewriteLinks: true
        };
        /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */ this.hashPrefix = function(prefix) {
            if (isDefined(prefix)) {
                hashPrefix = prefix;
                return this;
            } else return hashPrefix;
        };
        /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */ this.html5Mode = function(mode) {
            if (isBoolean(mode)) {
                html5Mode.enabled = mode;
                return this;
            } else if (isObject(mode)) {
                if (isBoolean(mode.enabled)) html5Mode.enabled = mode.enabled;
                if (isBoolean(mode.requireBase)) html5Mode.requireBase = mode.requireBase;
                if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) html5Mode.rewriteLinks = mode.rewriteLinks;
                return this;
            } else return html5Mode;
        };
        /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */ /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */ this.$get = [
            "$rootScope",
            "$browser",
            "$sniffer",
            "$rootElement",
            "$window",
            function($rootScope, $browser, $sniffer, $rootElement, $window) {
                var $location, LocationMode, baseHref = $browser.baseHref(), initialUrl = $browser.url(), appBase;
                if (html5Mode.enabled) {
                    if (!baseHref && html5Mode.requireBase) throw $locationMinErr("nobase", "$location in HTML5 mode requires a <base> tag to be present!");
                    appBase = serverBase(initialUrl) + (baseHref || "/");
                    LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
                } else {
                    appBase = stripHash(initialUrl);
                    LocationMode = LocationHashbangUrl;
                }
                var appBaseNoFile = stripFile(appBase);
                $location = new LocationMode(appBase, appBaseNoFile, "#" + hashPrefix);
                $location.$$parseLinkUrl(initialUrl, initialUrl);
                $location.$$state = $browser.state();
                var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
                // Determine if two URLs are equal despite potentially having different encoding/normalizing
                //  such as $location.absUrl() vs $browser.url()
                // See https://github.com/angular/angular.js/issues/16592
                function urlsEqual(a, b) {
                    return a === b || urlResolve(a).href === urlResolve(b).href;
                }
                function setBrowserUrlWithFallback(url, replace, state) {
                    var oldUrl = $location.url();
                    var oldState = $location.$$state;
                    try {
                        $browser.url(url, replace, state);
                        // Make sure $location.state() returns referentially identical (not just deeply equal)
                        // state object; this makes possible quick checking if the state changed in the digest
                        // loop. Checking deep equality would be too expensive.
                        $location.$$state = $browser.state();
                    } catch (e) {
                        // Restore old values if pushState fails
                        $location.url(oldUrl);
                        $location.$$state = oldState;
                        throw e;
                    }
                }
                $rootElement.on("click", function(event) {
                    var rewriteLinks = html5Mode.rewriteLinks;
                    // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
                    // currently we open nice url link and redirect then
                    if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
                    var elm = jqLite(event.target);
                    // traverse the DOM up to find first A tag
                    while(nodeName_(elm[0]) !== "a"){
                        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
                        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
                    }
                    if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
                    var absHref = elm.prop("href");
                    // get the actual href attribute - see
                    // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
                    var relHref = elm.attr("href") || elm.attr("xlink:href");
                    if (isObject(absHref) && absHref.toString() === "[object SVGAnimatedString]") // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
                    // an animation.
                    absHref = urlResolve(absHref.animVal).href;
                    // Ignore when url is started with javascript: or mailto:
                    if (IGNORE_URI_REGEXP.test(absHref)) return;
                    if (absHref && !elm.attr("target") && !event.isDefaultPrevented()) {
                        if ($location.$$parseLinkUrl(absHref, relHref)) {
                            // We do a preventDefault for all urls that are part of the AngularJS application,
                            // in html5mode and also without, so that we are able to abort navigation without
                            // getting double entries in the location history.
                            event.preventDefault();
                            // update location manually
                            if ($location.absUrl() !== $browser.url()) $rootScope.$apply();
                        }
                    }
                });
                // rewrite hashbang url <> html5 url
                if ($location.absUrl() !== initialUrl) $browser.url($location.absUrl(), true);
                var initializing = true;
                // update $location when $browser url changes
                $browser.onUrlChange(function(newUrl, newState) {
                    if (!startsWith(newUrl, appBaseNoFile)) {
                        // If we are navigating outside of the app then force a reload
                        $window.location.href = newUrl;
                        return;
                    }
                    $rootScope.$evalAsync(function() {
                        var oldUrl = $location.absUrl();
                        var oldState = $location.$$state;
                        var defaultPrevented;
                        $location.$$parse(newUrl);
                        $location.$$state = newState;
                        defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl, newState, oldState).defaultPrevented;
                        // if the location was changed by a `$locationChangeStart` handler then stop
                        // processing this location change
                        if ($location.absUrl() !== newUrl) return;
                        if (defaultPrevented) {
                            $location.$$parse(oldUrl);
                            $location.$$state = oldState;
                            setBrowserUrlWithFallback(oldUrl, false, oldState);
                        } else {
                            initializing = false;
                            afterLocationChange(oldUrl, oldState);
                        }
                    });
                    if (!$rootScope.$$phase) $rootScope.$digest();
                });
                // update browser
                $rootScope.$watch(function $locationWatch() {
                    if (initializing || $location.$$urlUpdatedByLocation) {
                        $location.$$urlUpdatedByLocation = false;
                        var oldUrl = $browser.url();
                        var newUrl = $location.absUrl();
                        var oldState = $browser.state();
                        var currentReplace = $location.$$replace;
                        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) || $location.$$html5 && $sniffer.history && oldState !== $location.$$state;
                        if (initializing || urlOrStateChanged) {
                            initializing = false;
                            $rootScope.$evalAsync(function() {
                                var newUrl = $location.absUrl();
                                var defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;
                                // if the location was changed by a `$locationChangeStart` handler then stop
                                // processing this location change
                                if ($location.absUrl() !== newUrl) return;
                                if (defaultPrevented) {
                                    $location.$$parse(oldUrl);
                                    $location.$$state = oldState;
                                } else {
                                    if (urlOrStateChanged) setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                                    afterLocationChange(oldUrl, oldState);
                                }
                            });
                        }
                    }
                    $location.$$replace = false;
                // we don't need to return anything because $evalAsync will make the digest loop dirty when
                // there is a change
                });
                return $location;
                function afterLocationChange(oldUrl, oldState) {
                    $rootScope.$broadcast("$locationChangeSuccess", $location.absUrl(), oldUrl, $location.$$state, oldState);
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */ /**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */ function $LogProvider() {
        var debug = true, self = this;
        /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */ this.debugEnabled = function(flag) {
            if (isDefined(flag)) {
                debug = flag;
                return this;
            } else return debug;
        };
        this.$get = [
            "$window",
            function($window) {
                // Support: IE 9-11, Edge 12-14+
                // IE/Edge display errors in such a way that it requires the user to click in 4 places
                // to see the stack trace. There is no way to feature-detect it so there's a chance
                // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
                // break apps. Other browsers display errors in a sensible way and some of them map stack
                // traces along source maps if available so it makes sense to let browsers display it
                // as they want.
                var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
                return {
                    /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */ log: consoleLog("log"),
                    /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */ info: consoleLog("info"),
                    /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */ warn: consoleLog("warn"),
                    /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */ error: consoleLog("error"),
                    /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */ debug: function() {
                        var fn = consoleLog("debug");
                        return function() {
                            if (debug) fn.apply(self, arguments);
                        };
                    }()
                };
                function formatError(arg) {
                    if (isError(arg)) {
                        if (arg.stack && formatStackTrace) arg = arg.message && arg.stack.indexOf(arg.message) === -1 ? "Error: " + arg.message + "\n" + arg.stack : arg.stack;
                        else if (arg.sourceURL) arg = arg.message + "\n" + arg.sourceURL + ":" + arg.line;
                    }
                    return arg;
                }
                function consoleLog(type) {
                    var console1 = $window.console || {}, logFn = console1[type] || console1.log || noop;
                    return function() {
                        var args = [];
                        forEach(arguments, function(arg) {
                            args.push(formatError(arg));
                        });
                        // Support: IE 9 only
                        // console methods don't inherit from Function.prototype in IE 9 so we can't
                        // call `logFn.apply(console, args)` directly.
                        return Function.prototype.apply.call(logFn, console1, args);
                    };
                }
            }
        ];
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ var $parseMinErr = minErr("$parse");
    var objectValueOf = {}.constructor.prototype.valueOf;
    // Sandboxing AngularJS Expressions
    // ------------------------------
    // AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
    // various means such as obtaining a reference to native JS functions like the Function constructor.
    //
    // As an example, consider the following AngularJS expression:
    //
    //   {}.toString.constructor('alert("evil JS code")')
    //
    // It is important to realize that if you create an expression from a string that contains user provided
    // content then it is possible that your application contains a security vulnerability to an XSS style attack.
    //
    // See https://docs.angularjs.org/guide/security
    function getStringValue(name) {
        // Property names must be strings. This means that non-string objects cannot be used
        // as keys in an object. Any non-string object, including a number, is typecasted
        // into a string via the toString method.
        // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
        //
        // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
        // to a string. It's not always possible. If `name` is an object and its `toString` method is
        // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
        //
        // TypeError: Cannot convert object to primitive value
        //
        // For performance reasons, we don't catch this error here and allow it to propagate up the call
        // stack. Note that you'll get the same error in JavaScript if you try to access a property using
        // such a 'broken' object as a key.
        return name + "";
    }
    var OPERATORS = createMap();
    forEach("+ - * / % === !== == != < > <= >= && || ! = |".split(" "), function(operator) {
        OPERATORS[operator] = true;
    });
    var ESCAPE = {
        "n": "\n",
        "f": "\f",
        "r": "\r",
        "t": "	",
        "v": "\v",
        "'": "'",
        '"': '"'
    };
    /////////////////////////////////////////
    /**
 * @constructor
 */ var Lexer = function Lexer(options) {
        this.options = options;
    };
    Lexer.prototype = {
        constructor: Lexer,
        lex: function(text) {
            this.text = text;
            this.index = 0;
            this.tokens = [];
            while(this.index < this.text.length){
                var ch = this.text.charAt(this.index);
                if (ch === '"' || ch === "'") this.readString(ch);
                else if (this.isNumber(ch) || ch === "." && this.isNumber(this.peek())) this.readNumber();
                else if (this.isIdentifierStart(this.peekMultichar())) this.readIdent();
                else if (this.is(ch, "(){}[].,;:?")) {
                    this.tokens.push({
                        index: this.index,
                        text: ch
                    });
                    this.index++;
                } else if (this.isWhitespace(ch)) this.index++;
                else {
                    var ch2 = ch + this.peek();
                    var ch3 = ch2 + this.peek(2);
                    var op1 = OPERATORS[ch];
                    var op2 = OPERATORS[ch2];
                    var op3 = OPERATORS[ch3];
                    if (op1 || op2 || op3) {
                        var token = op3 ? ch3 : op2 ? ch2 : ch;
                        this.tokens.push({
                            index: this.index,
                            text: token,
                            operator: true
                        });
                        this.index += token.length;
                    } else this.throwError("Unexpected next character ", this.index, this.index + 1);
                }
            }
            return this.tokens;
        },
        is: function(ch, chars) {
            return chars.indexOf(ch) !== -1;
        },
        peek: function(i) {
            var num = i || 1;
            return this.index + num < this.text.length ? this.text.charAt(this.index + num) : false;
        },
        isNumber: function(ch) {
            return "0" <= ch && ch <= "9" && typeof ch === "string";
        },
        isWhitespace: function(ch) {
            // IE treats non-breaking space as \u00A0
            return ch === " " || ch === "\r" || ch === "	" || ch === "\n" || ch === "\v" || ch === "\xa0";
        },
        isIdentifierStart: function(ch) {
            return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
        },
        isValidIdentifierStart: function(ch) {
            return "a" <= ch && ch <= "z" || "A" <= ch && ch <= "Z" || "_" === ch || ch === "$";
        },
        isIdentifierContinue: function(ch) {
            return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
        },
        isValidIdentifierContinue: function(ch, cp) {
            return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
        },
        codePointAt: function(ch) {
            if (ch.length === 1) return ch.charCodeAt(0);
            // eslint-disable-next-line no-bitwise
            return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
        },
        peekMultichar: function() {
            var ch = this.text.charAt(this.index);
            var peek = this.peek();
            if (!peek) return ch;
            var cp1 = ch.charCodeAt(0);
            var cp2 = peek.charCodeAt(0);
            if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) return ch + peek;
            return ch;
        },
        isExpOperator: function(ch) {
            return ch === "-" || ch === "+" || this.isNumber(ch);
        },
        throwError: function(error, start, end) {
            end = end || this.index;
            var colStr = isDefined(start) ? "s " + start + "-" + this.index + " [" + this.text.substring(start, end) + "]" : " " + end;
            throw $parseMinErr("lexerr", "Lexer Error: {0} at column{1} in expression [{2}].", error, colStr, this.text);
        },
        readNumber: function() {
            var number = "";
            var start = this.index;
            while(this.index < this.text.length){
                var ch = lowercase(this.text.charAt(this.index));
                if (ch === "." || this.isNumber(ch)) number += ch;
                else {
                    var peekCh = this.peek();
                    if (ch === "e" && this.isExpOperator(peekCh)) number += ch;
                    else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) === "e") number += ch;
                    else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) === "e") this.throwError("Invalid exponent");
                    else break;
                }
                this.index++;
            }
            this.tokens.push({
                index: start,
                text: number,
                constant: true,
                value: Number(number)
            });
        },
        readIdent: function() {
            var start = this.index;
            this.index += this.peekMultichar().length;
            while(this.index < this.text.length){
                var ch = this.peekMultichar();
                if (!this.isIdentifierContinue(ch)) break;
                this.index += ch.length;
            }
            this.tokens.push({
                index: start,
                text: this.text.slice(start, this.index),
                identifier: true
            });
        },
        readString: function(quote) {
            var start = this.index;
            this.index++;
            var string = "";
            var rawString = quote;
            var escape = false;
            while(this.index < this.text.length){
                var ch = this.text.charAt(this.index);
                rawString += ch;
                if (escape) {
                    if (ch === "u") {
                        var hex = this.text.substring(this.index + 1, this.index + 5);
                        if (!hex.match(/[\da-f]{4}/i)) this.throwError("Invalid unicode escape [\\u" + hex + "]");
                        this.index += 4;
                        string += String.fromCharCode(parseInt(hex, 16));
                    } else {
                        var rep = ESCAPE[ch];
                        string = string + (rep || ch);
                    }
                    escape = false;
                } else if (ch === "\\") escape = true;
                else if (ch === quote) {
                    this.index++;
                    this.tokens.push({
                        index: start,
                        text: rawString,
                        constant: true,
                        value: string
                    });
                    return;
                } else string += ch;
                this.index++;
            }
            this.throwError("Unterminated quote", start);
        }
    };
    var AST = function AST(lexer, options) {
        this.lexer = lexer;
        this.options = options;
    };
    AST.Program = "Program";
    AST.ExpressionStatement = "ExpressionStatement";
    AST.AssignmentExpression = "AssignmentExpression";
    AST.ConditionalExpression = "ConditionalExpression";
    AST.LogicalExpression = "LogicalExpression";
    AST.BinaryExpression = "BinaryExpression";
    AST.UnaryExpression = "UnaryExpression";
    AST.CallExpression = "CallExpression";
    AST.MemberExpression = "MemberExpression";
    AST.Identifier = "Identifier";
    AST.Literal = "Literal";
    AST.ArrayExpression = "ArrayExpression";
    AST.Property = "Property";
    AST.ObjectExpression = "ObjectExpression";
    AST.ThisExpression = "ThisExpression";
    AST.LocalsExpression = "LocalsExpression";
    // Internal use only
    AST.NGValueParameter = "NGValueParameter";
    AST.prototype = {
        ast: function(text) {
            this.text = text;
            this.tokens = this.lexer.lex(text);
            var value = this.program();
            if (this.tokens.length !== 0) this.throwError("is an unexpected token", this.tokens[0]);
            return value;
        },
        program: function() {
            var body = [];
            while(true){
                if (this.tokens.length > 0 && !this.peek("}", ")", ";", "]")) body.push(this.expressionStatement());
                if (!this.expect(";")) return {
                    type: AST.Program,
                    body: body
                };
            }
        },
        expressionStatement: function() {
            return {
                type: AST.ExpressionStatement,
                expression: this.filterChain()
            };
        },
        filterChain: function() {
            var left = this.expression();
            while(this.expect("|"))left = this.filter(left);
            return left;
        },
        expression: function() {
            return this.assignment();
        },
        assignment: function() {
            var result = this.ternary();
            if (this.expect("=")) {
                if (!isAssignable(result)) throw $parseMinErr("lval", "Trying to assign a value to a non l-value");
                result = {
                    type: AST.AssignmentExpression,
                    left: result,
                    right: this.assignment(),
                    operator: "="
                };
            }
            return result;
        },
        ternary: function() {
            var test = this.logicalOR();
            var alternate;
            var consequent;
            if (this.expect("?")) {
                alternate = this.expression();
                if (this.consume(":")) {
                    consequent = this.expression();
                    return {
                        type: AST.ConditionalExpression,
                        test: test,
                        alternate: alternate,
                        consequent: consequent
                    };
                }
            }
            return test;
        },
        logicalOR: function() {
            var left = this.logicalAND();
            while(this.expect("||"))left = {
                type: AST.LogicalExpression,
                operator: "||",
                left: left,
                right: this.logicalAND()
            };
            return left;
        },
        logicalAND: function() {
            var left = this.equality();
            while(this.expect("&&"))left = {
                type: AST.LogicalExpression,
                operator: "&&",
                left: left,
                right: this.equality()
            };
            return left;
        },
        equality: function() {
            var left = this.relational();
            var token;
            while(token = this.expect("==", "!=", "===", "!=="))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.relational()
            };
            return left;
        },
        relational: function() {
            var left = this.additive();
            var token;
            while(token = this.expect("<", ">", "<=", ">="))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.additive()
            };
            return left;
        },
        additive: function() {
            var left = this.multiplicative();
            var token;
            while(token = this.expect("+", "-"))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.multiplicative()
            };
            return left;
        },
        multiplicative: function() {
            var left = this.unary();
            var token;
            while(token = this.expect("*", "/", "%"))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.unary()
            };
            return left;
        },
        unary: function() {
            var token;
            if (token = this.expect("+", "-", "!")) return {
                type: AST.UnaryExpression,
                operator: token.text,
                prefix: true,
                argument: this.unary()
            };
            else return this.primary();
        },
        primary: function() {
            var primary;
            if (this.expect("(")) {
                primary = this.filterChain();
                this.consume(")");
            } else if (this.expect("[")) primary = this.arrayDeclaration();
            else if (this.expect("{")) primary = this.object();
            else if (this.selfReferential.hasOwnProperty(this.peek().text)) primary = copy(this.selfReferential[this.consume().text]);
            else if (this.options.literals.hasOwnProperty(this.peek().text)) primary = {
                type: AST.Literal,
                value: this.options.literals[this.consume().text]
            };
            else if (this.peek().identifier) primary = this.identifier();
            else if (this.peek().constant) primary = this.constant();
            else this.throwError("not a primary expression", this.peek());
            var next;
            while(next = this.expect("(", "[", ".")){
                if (next.text === "(") {
                    primary = {
                        type: AST.CallExpression,
                        callee: primary,
                        arguments: this.parseArguments()
                    };
                    this.consume(")");
                } else if (next.text === "[") {
                    primary = {
                        type: AST.MemberExpression,
                        object: primary,
                        property: this.expression(),
                        computed: true
                    };
                    this.consume("]");
                } else if (next.text === ".") primary = {
                    type: AST.MemberExpression,
                    object: primary,
                    property: this.identifier(),
                    computed: false
                };
                else this.throwError("IMPOSSIBLE");
            }
            return primary;
        },
        filter: function(baseExpression) {
            var args = [
                baseExpression
            ];
            var result = {
                type: AST.CallExpression,
                callee: this.identifier(),
                arguments: args,
                filter: true
            };
            while(this.expect(":"))args.push(this.expression());
            return result;
        },
        parseArguments: function() {
            var args = [];
            if (this.peekToken().text !== ")") do args.push(this.filterChain());
            while (this.expect(","));
            return args;
        },
        identifier: function() {
            var token = this.consume();
            if (!token.identifier) this.throwError("is not a valid identifier", token);
            return {
                type: AST.Identifier,
                name: token.text
            };
        },
        constant: function() {
            // TODO check that it is a constant
            return {
                type: AST.Literal,
                value: this.consume().value
            };
        },
        arrayDeclaration: function() {
            var elements = [];
            if (this.peekToken().text !== "]") do {
                if (this.peek("]")) break;
                elements.push(this.expression());
            }while (this.expect(","));
            this.consume("]");
            return {
                type: AST.ArrayExpression,
                elements: elements
            };
        },
        object: function() {
            var properties = [], property;
            if (this.peekToken().text !== "}") do {
                if (this.peek("}")) break;
                property = {
                    type: AST.Property,
                    kind: "init"
                };
                if (this.peek().constant) {
                    property.key = this.constant();
                    property.computed = false;
                    this.consume(":");
                    property.value = this.expression();
                } else if (this.peek().identifier) {
                    property.key = this.identifier();
                    property.computed = false;
                    if (this.peek(":")) {
                        this.consume(":");
                        property.value = this.expression();
                    } else property.value = property.key;
                } else if (this.peek("[")) {
                    this.consume("[");
                    property.key = this.expression();
                    this.consume("]");
                    property.computed = true;
                    this.consume(":");
                    property.value = this.expression();
                } else this.throwError("invalid key", this.peek());
                properties.push(property);
            }while (this.expect(","));
            this.consume("}");
            return {
                type: AST.ObjectExpression,
                properties: properties
            };
        },
        throwError: function(msg, token) {
            throw $parseMinErr("syntax", "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].", token.text, msg, token.index + 1, this.text, this.text.substring(token.index));
        },
        consume: function(e1) {
            if (this.tokens.length === 0) throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
            var token = this.expect(e1);
            if (!token) this.throwError("is unexpected, expecting [" + e1 + "]", this.peek());
            return token;
        },
        peekToken: function() {
            if (this.tokens.length === 0) throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
            return this.tokens[0];
        },
        peek: function(e1, e2, e3, e4) {
            return this.peekAhead(0, e1, e2, e3, e4);
        },
        peekAhead: function(i, e1, e2, e3, e4) {
            if (this.tokens.length > i) {
                var token = this.tokens[i];
                var t = token.text;
                if (t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4) return token;
            }
            return false;
        },
        expect: function(e1, e2, e3, e4) {
            var token = this.peek(e1, e2, e3, e4);
            if (token) {
                this.tokens.shift();
                return token;
            }
            return false;
        },
        selfReferential: {
            "this": {
                type: AST.ThisExpression
            },
            "$locals": {
                type: AST.LocalsExpression
            }
        }
    };
    function ifDefined(v, d) {
        return typeof v !== "undefined" ? v : d;
    }
    function plusFn(l, r) {
        if (typeof l === "undefined") return r;
        if (typeof r === "undefined") return l;
        return l + r;
    }
    function isStateless($filter, filterName) {
        var fn = $filter(filterName);
        return !fn.$stateful;
    }
    var PURITY_ABSOLUTE = 1;
    var PURITY_RELATIVE = 2;
    // Detect nodes which could depend on non-shallow state of objects
    function isPure(node, parentIsPure) {
        switch(node.type){
            // Computed members might invoke a stateful toString()
            case AST.MemberExpression:
                if (node.computed) return false;
                break;
            // Unary always convert to primative
            case AST.UnaryExpression:
                return PURITY_ABSOLUTE;
            // The binary + operator can invoke a stateful toString().
            case AST.BinaryExpression:
                return node.operator !== "+" ? PURITY_ABSOLUTE : false;
            // Functions / filters probably read state from within objects
            case AST.CallExpression:
                return false;
        }
        return undefined === parentIsPure ? PURITY_RELATIVE : parentIsPure;
    }
    function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
        var allConstants;
        var argsToWatch;
        var isStatelessFilter;
        var astIsPure = ast.isPure = isPure(ast, parentIsPure);
        switch(ast.type){
            case AST.Program:
                allConstants = true;
                forEach(ast.body, function(expr) {
                    findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
                    allConstants = allConstants && expr.expression.constant;
                });
                ast.constant = allConstants;
                break;
            case AST.Literal:
                ast.constant = true;
                ast.toWatch = [];
                break;
            case AST.UnaryExpression:
                findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
                ast.constant = ast.argument.constant;
                ast.toWatch = ast.argument.toWatch;
                break;
            case AST.BinaryExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
                break;
            case AST.LogicalExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.ConditionalExpression:
                findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
                ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.Identifier:
                ast.constant = false;
                ast.toWatch = [
                    ast
                ];
                break;
            case AST.MemberExpression:
                findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
                if (ast.computed) findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
                ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.CallExpression:
                isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
                allConstants = isStatelessFilter;
                argsToWatch = [];
                forEach(ast.arguments, function(expr) {
                    findConstantAndWatchExpressions(expr, $filter, astIsPure);
                    allConstants = allConstants && expr.constant;
                    argsToWatch.push.apply(argsToWatch, expr.toWatch);
                });
                ast.constant = allConstants;
                ast.toWatch = isStatelessFilter ? argsToWatch : [
                    ast
                ];
                break;
            case AST.AssignmentExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = [
                    ast
                ];
                break;
            case AST.ArrayExpression:
                allConstants = true;
                argsToWatch = [];
                forEach(ast.elements, function(expr) {
                    findConstantAndWatchExpressions(expr, $filter, astIsPure);
                    allConstants = allConstants && expr.constant;
                    argsToWatch.push.apply(argsToWatch, expr.toWatch);
                });
                ast.constant = allConstants;
                ast.toWatch = argsToWatch;
                break;
            case AST.ObjectExpression:
                allConstants = true;
                argsToWatch = [];
                forEach(ast.properties, function(property) {
                    findConstantAndWatchExpressions(property.value, $filter, astIsPure);
                    allConstants = allConstants && property.value.constant;
                    argsToWatch.push.apply(argsToWatch, property.value.toWatch);
                    if (property.computed) {
                        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
                        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/ false);
                        allConstants = allConstants && property.key.constant;
                        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
                    }
                });
                ast.constant = allConstants;
                ast.toWatch = argsToWatch;
                break;
            case AST.ThisExpression:
                ast.constant = false;
                ast.toWatch = [];
                break;
            case AST.LocalsExpression:
                ast.constant = false;
                ast.toWatch = [];
                break;
        }
    }
    function getInputs(body) {
        if (body.length !== 1) return;
        var lastExpression = body[0].expression;
        var candidate = lastExpression.toWatch;
        if (candidate.length !== 1) return candidate;
        return candidate[0] !== lastExpression ? candidate : undefined;
    }
    function isAssignable(ast) {
        return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
    }
    function assignableAST(ast) {
        if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) return {
            type: AST.AssignmentExpression,
            left: ast.body[0].expression,
            right: {
                type: AST.NGValueParameter
            },
            operator: "="
        };
    }
    function isLiteral(ast) {
        return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
    }
    function isConstant(ast) {
        return ast.constant;
    }
    function ASTCompiler($filter) {
        this.$filter = $filter;
    }
    ASTCompiler.prototype = {
        compile: function(ast) {
            var self = this;
            this.state = {
                nextId: 0,
                filters: {},
                fn: {
                    vars: [],
                    body: [],
                    own: {}
                },
                assign: {
                    vars: [],
                    body: [],
                    own: {}
                },
                inputs: []
            };
            findConstantAndWatchExpressions(ast, self.$filter);
            var extra = "";
            var assignable;
            this.stage = "assign";
            if (assignable = assignableAST(ast)) {
                this.state.computing = "assign";
                var result = this.nextId();
                this.recurse(assignable, result);
                this.return_(result);
                extra = "fn.assign=" + this.generateFunction("assign", "s,v,l");
            }
            var toWatch = getInputs(ast.body);
            self.stage = "inputs";
            forEach(toWatch, function(watch, key) {
                var fnKey = "fn" + key;
                self.state[fnKey] = {
                    vars: [],
                    body: [],
                    own: {}
                };
                self.state.computing = fnKey;
                var intoId = self.nextId();
                self.recurse(watch, intoId);
                self.return_(intoId);
                self.state.inputs.push({
                    name: fnKey,
                    isPure: watch.isPure
                });
                watch.watchId = key;
            });
            this.state.computing = "fn";
            this.stage = "main";
            this.recurse(ast);
            var fnString = // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
            // This is a workaround for this until we do a better job at only removing the prefix only when we should.
            '"' + this.USE + " " + this.STRICT + '";\n' + this.filterPrefix() + "var fn=" + this.generateFunction("fn", "s,l,a,i") + extra + this.watchFns() + "return fn;";
            // eslint-disable-next-line no-new-func
            var fn = new Function("$filter", "getStringValue", "ifDefined", "plus", fnString)(this.$filter, getStringValue, ifDefined, plusFn);
            this.state = this.stage = undefined;
            return fn;
        },
        USE: "use",
        STRICT: "strict",
        watchFns: function() {
            var result = [];
            var inputs = this.state.inputs;
            var self = this;
            forEach(inputs, function(input) {
                result.push("var " + input.name + "=" + self.generateFunction(input.name, "s"));
                if (input.isPure) result.push(input.name, ".isPure=" + JSON.stringify(input.isPure) + ";");
            });
            if (inputs.length) result.push("fn.inputs=[" + inputs.map(function(i) {
                return i.name;
            }).join(",") + "];");
            return result.join("");
        },
        generateFunction: function(name, params) {
            return "function(" + params + "){" + this.varsPrefix(name) + this.body(name) + "};";
        },
        filterPrefix: function() {
            var parts = [];
            var self = this;
            forEach(this.state.filters, function(id, filter) {
                parts.push(id + "=$filter(" + self.escape(filter) + ")");
            });
            if (parts.length) return "var " + parts.join(",") + ";";
            return "";
        },
        varsPrefix: function(section) {
            return this.state[section].vars.length ? "var " + this.state[section].vars.join(",") + ";" : "";
        },
        body: function(section) {
            return this.state[section].body.join("");
        },
        recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
            var left, right, self = this, args, expression, computed;
            recursionFn = recursionFn || noop;
            if (!skipWatchIdCheck && isDefined(ast.watchId)) {
                intoId = intoId || this.nextId();
                this.if_("i", this.lazyAssign(intoId, this.computedMember("i", ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
                return;
            }
            switch(ast.type){
                case AST.Program:
                    forEach(ast.body, function(expression, pos) {
                        self.recurse(expression.expression, undefined, undefined, function(expr) {
                            right = expr;
                        });
                        if (pos !== ast.body.length - 1) self.current().body.push(right, ";");
                        else self.return_(right);
                    });
                    break;
                case AST.Literal:
                    expression = this.escape(ast.value);
                    this.assign(intoId, expression);
                    recursionFn(intoId || expression);
                    break;
                case AST.UnaryExpression:
                    this.recurse(ast.argument, undefined, undefined, function(expr) {
                        right = expr;
                    });
                    expression = ast.operator + "(" + this.ifDefined(right, 0) + ")";
                    this.assign(intoId, expression);
                    recursionFn(expression);
                    break;
                case AST.BinaryExpression:
                    this.recurse(ast.left, undefined, undefined, function(expr) {
                        left = expr;
                    });
                    this.recurse(ast.right, undefined, undefined, function(expr) {
                        right = expr;
                    });
                    if (ast.operator === "+") expression = this.plus(left, right);
                    else if (ast.operator === "-") expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
                    else expression = "(" + left + ")" + ast.operator + "(" + right + ")";
                    this.assign(intoId, expression);
                    recursionFn(expression);
                    break;
                case AST.LogicalExpression:
                    intoId = intoId || this.nextId();
                    self.recurse(ast.left, intoId);
                    self.if_(ast.operator === "&&" ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
                    recursionFn(intoId);
                    break;
                case AST.ConditionalExpression:
                    intoId = intoId || this.nextId();
                    self.recurse(ast.test, intoId);
                    self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
                    recursionFn(intoId);
                    break;
                case AST.Identifier:
                    intoId = intoId || this.nextId();
                    if (nameId) {
                        nameId.context = self.stage === "inputs" ? "s" : this.assign(this.nextId(), this.getHasOwnProperty("l", ast.name) + "?l:s");
                        nameId.computed = false;
                        nameId.name = ast.name;
                    }
                    self.if_(self.stage === "inputs" || self.not(self.getHasOwnProperty("l", ast.name)), function() {
                        self.if_(self.stage === "inputs" || "s", function() {
                            if (create && create !== 1) self.if_(self.isNull(self.nonComputedMember("s", ast.name)), self.lazyAssign(self.nonComputedMember("s", ast.name), "{}"));
                            self.assign(intoId, self.nonComputedMember("s", ast.name));
                        });
                    }, intoId && self.lazyAssign(intoId, self.nonComputedMember("l", ast.name)));
                    recursionFn(intoId);
                    break;
                case AST.MemberExpression:
                    left = nameId && (nameId.context = this.nextId()) || this.nextId();
                    intoId = intoId || this.nextId();
                    self.recurse(ast.object, left, undefined, function() {
                        self.if_(self.notNull(left), function() {
                            if (ast.computed) {
                                right = self.nextId();
                                self.recurse(ast.property, right);
                                self.getStringValue(right);
                                if (create && create !== 1) self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), "{}"));
                                expression = self.computedMember(left, right);
                                self.assign(intoId, expression);
                                if (nameId) {
                                    nameId.computed = true;
                                    nameId.name = right;
                                }
                            } else {
                                if (create && create !== 1) self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), "{}"));
                                expression = self.nonComputedMember(left, ast.property.name);
                                self.assign(intoId, expression);
                                if (nameId) {
                                    nameId.computed = false;
                                    nameId.name = ast.property.name;
                                }
                            }
                        }, function() {
                            self.assign(intoId, "undefined");
                        });
                        recursionFn(intoId);
                    }, !!create);
                    break;
                case AST.CallExpression:
                    intoId = intoId || this.nextId();
                    if (ast.filter) {
                        right = self.filter(ast.callee.name);
                        args = [];
                        forEach(ast.arguments, function(expr) {
                            var argument = self.nextId();
                            self.recurse(expr, argument);
                            args.push(argument);
                        });
                        expression = right + "(" + args.join(",") + ")";
                        self.assign(intoId, expression);
                        recursionFn(intoId);
                    } else {
                        right = self.nextId();
                        left = {};
                        args = [];
                        self.recurse(ast.callee, right, left, function() {
                            self.if_(self.notNull(right), function() {
                                forEach(ast.arguments, function(expr) {
                                    self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                                        args.push(argument);
                                    });
                                });
                                if (left.name) expression = self.member(left.context, left.name, left.computed) + "(" + args.join(",") + ")";
                                else expression = right + "(" + args.join(",") + ")";
                                self.assign(intoId, expression);
                            }, function() {
                                self.assign(intoId, "undefined");
                            });
                            recursionFn(intoId);
                        });
                    }
                    break;
                case AST.AssignmentExpression:
                    right = this.nextId();
                    left = {};
                    this.recurse(ast.left, undefined, left, function() {
                        self.if_(self.notNull(left.context), function() {
                            self.recurse(ast.right, right);
                            expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
                            self.assign(intoId, expression);
                            recursionFn(intoId || expression);
                        });
                    }, 1);
                    break;
                case AST.ArrayExpression:
                    args = [];
                    forEach(ast.elements, function(expr) {
                        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                            args.push(argument);
                        });
                    });
                    expression = "[" + args.join(",") + "]";
                    this.assign(intoId, expression);
                    recursionFn(intoId || expression);
                    break;
                case AST.ObjectExpression:
                    args = [];
                    computed = false;
                    forEach(ast.properties, function(property) {
                        if (property.computed) computed = true;
                    });
                    if (computed) {
                        intoId = intoId || this.nextId();
                        this.assign(intoId, "{}");
                        forEach(ast.properties, function(property) {
                            if (property.computed) {
                                left = self.nextId();
                                self.recurse(property.key, left);
                            } else left = property.key.type === AST.Identifier ? property.key.name : "" + property.key.value;
                            right = self.nextId();
                            self.recurse(property.value, right);
                            self.assign(self.member(intoId, left, property.computed), right);
                        });
                    } else {
                        forEach(ast.properties, function(property) {
                            self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
                                args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : "" + property.key.value) + ":" + expr);
                            });
                        });
                        expression = "{" + args.join(",") + "}";
                        this.assign(intoId, expression);
                    }
                    recursionFn(intoId || expression);
                    break;
                case AST.ThisExpression:
                    this.assign(intoId, "s");
                    recursionFn(intoId || "s");
                    break;
                case AST.LocalsExpression:
                    this.assign(intoId, "l");
                    recursionFn(intoId || "l");
                    break;
                case AST.NGValueParameter:
                    this.assign(intoId, "v");
                    recursionFn(intoId || "v");
                    break;
            }
        },
        getHasOwnProperty: function(element, property) {
            var key = element + "." + property;
            var own = this.current().own;
            if (!own.hasOwnProperty(key)) own[key] = this.nextId(false, element + "&&(" + this.escape(property) + " in " + element + ")");
            return own[key];
        },
        assign: function(id, value) {
            if (!id) return;
            this.current().body.push(id, "=", value, ";");
            return id;
        },
        filter: function(filterName) {
            if (!this.state.filters.hasOwnProperty(filterName)) this.state.filters[filterName] = this.nextId(true);
            return this.state.filters[filterName];
        },
        ifDefined: function(id, defaultValue) {
            return "ifDefined(" + id + "," + this.escape(defaultValue) + ")";
        },
        plus: function(left, right) {
            return "plus(" + left + "," + right + ")";
        },
        return_: function(id) {
            this.current().body.push("return ", id, ";");
        },
        if_: function(test, alternate, consequent) {
            if (test === true) alternate();
            else {
                var body = this.current().body;
                body.push("if(", test, "){");
                alternate();
                body.push("}");
                if (consequent) {
                    body.push("else{");
                    consequent();
                    body.push("}");
                }
            }
        },
        not: function(expression) {
            return "!(" + expression + ")";
        },
        isNull: function(expression) {
            return expression + "==null";
        },
        notNull: function(expression) {
            return expression + "!=null";
        },
        nonComputedMember: function(left, right) {
            var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
            var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
            if (SAFE_IDENTIFIER.test(right)) return left + "." + right;
            else return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
        },
        computedMember: function(left, right) {
            return left + "[" + right + "]";
        },
        member: function(left, right, computed) {
            if (computed) return this.computedMember(left, right);
            return this.nonComputedMember(left, right);
        },
        getStringValue: function(item) {
            this.assign(item, "getStringValue(" + item + ")");
        },
        lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
            var self = this;
            return function() {
                self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
            };
        },
        lazyAssign: function(id, value) {
            var self = this;
            return function() {
                self.assign(id, value);
            };
        },
        stringEscapeRegex: /[^ a-zA-Z0-9]/g,
        stringEscapeFn: function(c) {
            return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
        },
        escape: function(value) {
            if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
            if (isNumber(value)) return value.toString();
            if (value === true) return "true";
            if (value === false) return "false";
            if (value === null) return "null";
            if (typeof value === "undefined") return "undefined";
            throw $parseMinErr("esc", "IMPOSSIBLE");
        },
        nextId: function(skip, init) {
            var id = "v" + this.state.nextId++;
            if (!skip) this.current().vars.push(id + (init ? "=" + init : ""));
            return id;
        },
        current: function() {
            return this.state[this.state.computing];
        }
    };
    function ASTInterpreter($filter) {
        this.$filter = $filter;
    }
    ASTInterpreter.prototype = {
        compile: function(ast) {
            var self = this;
            findConstantAndWatchExpressions(ast, self.$filter);
            var assignable;
            var assign;
            if (assignable = assignableAST(ast)) assign = this.recurse(assignable);
            var toWatch = getInputs(ast.body);
            var inputs;
            if (toWatch) {
                inputs = [];
                forEach(toWatch, function(watch, key) {
                    var input = self.recurse(watch);
                    input.isPure = watch.isPure;
                    watch.input = input;
                    inputs.push(input);
                    watch.watchId = key;
                });
            }
            var expressions = [];
            forEach(ast.body, function(expression) {
                expressions.push(self.recurse(expression.expression));
            });
            var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function(scope, locals) {
                var lastValue;
                forEach(expressions, function(exp) {
                    lastValue = exp(scope, locals);
                });
                return lastValue;
            };
            if (assign) fn.assign = function(scope, value, locals) {
                return assign(scope, locals, value);
            };
            if (inputs) fn.inputs = inputs;
            return fn;
        },
        recurse: function(ast, context, create) {
            var left, right, self = this, args;
            if (ast.input) return this.inputs(ast.input, ast.watchId);
            switch(ast.type){
                case AST.Literal:
                    return this.value(ast.value, context);
                case AST.UnaryExpression:
                    right = this.recurse(ast.argument);
                    return this["unary" + ast.operator](right, context);
                case AST.BinaryExpression:
                    left = this.recurse(ast.left);
                    right = this.recurse(ast.right);
                    return this["binary" + ast.operator](left, right, context);
                case AST.LogicalExpression:
                    left = this.recurse(ast.left);
                    right = this.recurse(ast.right);
                    return this["binary" + ast.operator](left, right, context);
                case AST.ConditionalExpression:
                    return this["ternary?:"](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
                case AST.Identifier:
                    return self.identifier(ast.name, context, create);
                case AST.MemberExpression:
                    left = this.recurse(ast.object, false, !!create);
                    if (!ast.computed) right = ast.property.name;
                    if (ast.computed) right = this.recurse(ast.property);
                    return ast.computed ? this.computedMember(left, right, context, create) : this.nonComputedMember(left, right, context, create);
                case AST.CallExpression:
                    args = [];
                    forEach(ast.arguments, function(expr) {
                        args.push(self.recurse(expr));
                    });
                    if (ast.filter) right = this.$filter(ast.callee.name);
                    if (!ast.filter) right = this.recurse(ast.callee, true);
                    return ast.filter ? function(scope, locals, assign, inputs) {
                        var values = [];
                        for(var i = 0; i < args.length; ++i)values.push(args[i](scope, locals, assign, inputs));
                        var value = right.apply(undefined, values, inputs);
                        return context ? {
                            context: undefined,
                            name: undefined,
                            value: value
                        } : value;
                    } : function(scope, locals, assign, inputs) {
                        var rhs = right(scope, locals, assign, inputs);
                        var value;
                        if (rhs.value != null) {
                            var values = [];
                            for(var i = 0; i < args.length; ++i)values.push(args[i](scope, locals, assign, inputs));
                            value = rhs.value.apply(rhs.context, values);
                        }
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.AssignmentExpression:
                    left = this.recurse(ast.left, true, 1);
                    right = this.recurse(ast.right);
                    return function(scope, locals, assign, inputs) {
                        var lhs = left(scope, locals, assign, inputs);
                        var rhs = right(scope, locals, assign, inputs);
                        lhs.context[lhs.name] = rhs;
                        return context ? {
                            value: rhs
                        } : rhs;
                    };
                case AST.ArrayExpression:
                    args = [];
                    forEach(ast.elements, function(expr) {
                        args.push(self.recurse(expr));
                    });
                    return function(scope, locals, assign, inputs) {
                        var value = [];
                        for(var i = 0; i < args.length; ++i)value.push(args[i](scope, locals, assign, inputs));
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.ObjectExpression:
                    args = [];
                    forEach(ast.properties, function(property) {
                        if (property.computed) args.push({
                            key: self.recurse(property.key),
                            computed: true,
                            value: self.recurse(property.value)
                        });
                        else args.push({
                            key: property.key.type === AST.Identifier ? property.key.name : "" + property.key.value,
                            computed: false,
                            value: self.recurse(property.value)
                        });
                    });
                    return function(scope, locals, assign, inputs) {
                        var value = {};
                        for(var i = 0; i < args.length; ++i)if (args[i].computed) value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
                        else value[args[i].key] = args[i].value(scope, locals, assign, inputs);
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.ThisExpression:
                    return function(scope) {
                        return context ? {
                            value: scope
                        } : scope;
                    };
                case AST.LocalsExpression:
                    return function(scope, locals) {
                        return context ? {
                            value: locals
                        } : locals;
                    };
                case AST.NGValueParameter:
                    return function(scope, locals, assign) {
                        return context ? {
                            value: assign
                        } : assign;
                    };
            }
        },
        "unary+": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = argument(scope, locals, assign, inputs);
                if (isDefined(arg)) arg = +arg;
                else arg = 0;
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "unary-": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = argument(scope, locals, assign, inputs);
                if (isDefined(arg)) arg = -arg;
                else arg = -0;
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "unary!": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = !argument(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary+": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                var arg = plusFn(lhs, rhs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary-": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary*": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary/": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary%": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary===": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary!==": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary==": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                // eslint-disable-next-line eqeqeq
                var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary!=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                // eslint-disable-next-line eqeqeq
                var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary<": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary>": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary<=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary>=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary&&": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary||": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "ternary?:": function(test, alternate, consequent, context) {
            return function(scope, locals, assign, inputs) {
                var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        value: function(value, context) {
            return function() {
                return context ? {
                    context: undefined,
                    name: undefined,
                    value: value
                } : value;
            };
        },
        identifier: function(name, context, create) {
            return function(scope, locals, assign, inputs) {
                var base = locals && name in locals ? locals : scope;
                if (create && create !== 1 && base && base[name] == null) base[name] = {};
                var value = base ? base[name] : undefined;
                if (context) return {
                    context: base,
                    name: name,
                    value: value
                };
                else return value;
            };
        },
        computedMember: function(left, right, context, create) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs;
                var value;
                if (lhs != null) {
                    rhs = right(scope, locals, assign, inputs);
                    rhs = getStringValue(rhs);
                    if (create && create !== 1) {
                        if (lhs && !lhs[rhs]) lhs[rhs] = {};
                    }
                    value = lhs[rhs];
                }
                if (context) return {
                    context: lhs,
                    name: rhs,
                    value: value
                };
                else return value;
            };
        },
        nonComputedMember: function(left, right, context, create) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                if (create && create !== 1) {
                    if (lhs && lhs[right] == null) lhs[right] = {};
                }
                var value = lhs != null ? lhs[right] : undefined;
                if (context) return {
                    context: lhs,
                    name: right,
                    value: value
                };
                else return value;
            };
        },
        inputs: function(input, watchId) {
            return function(scope, value, locals, inputs) {
                if (inputs) return inputs[watchId];
                return input(scope, value, locals);
            };
        }
    };
    /**
 * @constructor
 */ function Parser(lexer, $filter, options) {
        this.ast = new AST(lexer, options);
        this.astCompiler = options.csp ? new ASTInterpreter($filter) : new ASTCompiler($filter);
    }
    Parser.prototype = {
        constructor: Parser,
        parse: function(text) {
            var ast = this.getAst(text);
            var fn = this.astCompiler.compile(ast.ast);
            fn.literal = isLiteral(ast.ast);
            fn.constant = isConstant(ast.ast);
            fn.oneTime = ast.oneTime;
            return fn;
        },
        getAst: function(exp) {
            var oneTime = false;
            exp = exp.trim();
            if (exp.charAt(0) === ":" && exp.charAt(1) === ":") {
                oneTime = true;
                exp = exp.substring(2);
            }
            return {
                ast: this.ast.ast(exp),
                oneTime: oneTime
            };
        }
    };
    function getValueOf(value) {
        return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
    }
    ///////////////////////////////////
    /**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */ /**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */ function $ParseProvider() {
        var cache = createMap();
        var literals = {
            "true": true,
            "false": false,
            "null": null,
            "undefined": undefined
        };
        var identStart, identContinue;
        /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/ this.addLiteral = function(literalName, literalValue) {
            literals[literalName] = literalValue;
        };
        /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */ this.setIdentifierFns = function(identifierStart, identifierContinue) {
            identStart = identifierStart;
            identContinue = identifierContinue;
            return this;
        };
        this.$get = [
            "$filter",
            function($filter) {
                var noUnsafeEval = csp().noUnsafeEval;
                var $parseOptions = {
                    csp: noUnsafeEval,
                    literals: copy(literals),
                    isIdentifierStart: isFunction(identStart) && identStart,
                    isIdentifierContinue: isFunction(identContinue) && identContinue
                };
                $parse.$$getAst = $$getAst;
                return $parse;
                function $parse(exp, interceptorFn) {
                    var parsedExpression, cacheKey;
                    switch(typeof exp){
                        case "string":
                            exp = exp.trim();
                            cacheKey = exp;
                            parsedExpression = cache[cacheKey];
                            if (!parsedExpression) {
                                var lexer = new Lexer($parseOptions);
                                var parser = new Parser(lexer, $filter, $parseOptions);
                                parsedExpression = parser.parse(exp);
                                cache[cacheKey] = addWatchDelegate(parsedExpression);
                            }
                            return addInterceptor(parsedExpression, interceptorFn);
                        case "function":
                            return addInterceptor(exp, interceptorFn);
                        default:
                            return addInterceptor(noop, interceptorFn);
                    }
                }
                function $$getAst(exp) {
                    var lexer = new Lexer($parseOptions);
                    var parser = new Parser(lexer, $filter, $parseOptions);
                    return parser.getAst(exp).ast;
                }
                function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
                    if (newValue == null || oldValueOfValue == null) return newValue === oldValueOfValue;
                    if (typeof newValue === "object") {
                        // attempt to convert the value to a primitive type
                        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
                        //             be cheaply dirty-checked
                        newValue = getValueOf(newValue);
                        if (typeof newValue === "object" && !compareObjectIdentity) // objects/arrays are not supported - deep-watching them would be too expensive
                        return false;
                    // fall-through to the primitive equality check
                    }
                    //Primitive or NaN
                    // eslint-disable-next-line no-self-compare
                    return newValue === oldValueOfValue || newValue !== newValue && oldValueOfValue !== oldValueOfValue;
                }
                function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
                    var inputExpressions = parsedExpression.inputs;
                    var lastResult;
                    if (inputExpressions.length === 1) {
                        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
                        inputExpressions = inputExpressions[0];
                        return scope.$watch(function expressionInputWatch(scope) {
                            var newInputValue = inputExpressions(scope);
                            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
                                lastResult = parsedExpression(scope, undefined, undefined, [
                                    newInputValue
                                ]);
                                oldInputValueOf = newInputValue && getValueOf(newInputValue);
                            }
                            return lastResult;
                        }, listener, objectEquality, prettyPrintExpression);
                    }
                    var oldInputValueOfValues = [];
                    var oldInputValues = [];
                    for(var i = 0, ii = inputExpressions.length; i < ii; i++){
                        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
                        oldInputValues[i] = null;
                    }
                    return scope.$watch(function expressionInputsWatch(scope) {
                        var changed = false;
                        for(var i = 0, ii = inputExpressions.length; i < ii; i++){
                            var newInputValue = inputExpressions[i](scope);
                            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
                                oldInputValues[i] = newInputValue;
                                oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
                            }
                        }
                        if (changed) lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
                        return lastResult;
                    }, listener, objectEquality, prettyPrintExpression);
                }
                function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
                    var isDone = parsedExpression.literal ? isAllDefined : isDefined;
                    var unwatch, lastValue;
                    var exp = parsedExpression.$$intercepted || parsedExpression;
                    var post = parsedExpression.$$interceptor || identity;
                    var useInputs = parsedExpression.inputs && !exp.inputs;
                    // Propogate the literal/inputs/constant attributes
                    // ... but not oneTime since we are handling it
                    oneTimeWatch.literal = parsedExpression.literal;
                    oneTimeWatch.constant = parsedExpression.constant;
                    oneTimeWatch.inputs = parsedExpression.inputs;
                    // Allow other delegates to run on this wrapped expression
                    addWatchDelegate(oneTimeWatch);
                    unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
                    return unwatch;
                    function unwatchIfDone() {
                        if (isDone(lastValue)) unwatch();
                    }
                    function oneTimeWatch(scope, locals, assign, inputs) {
                        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
                        if (isDone(lastValue)) scope.$$postDigest(unwatchIfDone);
                        return post(lastValue);
                    }
                }
                function isAllDefined(value) {
                    var allDefined = true;
                    forEach(value, function(val) {
                        if (!isDefined(val)) allDefined = false;
                    });
                    return allDefined;
                }
                function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
                    var unwatch = scope.$watch(function constantWatch(scope) {
                        unwatch();
                        return parsedExpression(scope);
                    }, listener, objectEquality);
                    return unwatch;
                }
                function addWatchDelegate(parsedExpression) {
                    if (parsedExpression.constant) parsedExpression.$$watchDelegate = constantWatchDelegate;
                    else if (parsedExpression.oneTime) parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
                    else if (parsedExpression.inputs) parsedExpression.$$watchDelegate = inputsWatchDelegate;
                    return parsedExpression;
                }
                function chainInterceptors(first, second) {
                    function chainedInterceptor(value) {
                        return second(first(value));
                    }
                    chainedInterceptor.$stateful = first.$stateful || second.$stateful;
                    chainedInterceptor.$$pure = first.$$pure && second.$$pure;
                    return chainedInterceptor;
                }
                function addInterceptor(parsedExpression, interceptorFn) {
                    if (!interceptorFn) return parsedExpression;
                    // Extract any existing interceptors out of the parsedExpression
                    // to ensure the original parsedExpression is always the $$intercepted
                    if (parsedExpression.$$interceptor) {
                        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
                        parsedExpression = parsedExpression.$$intercepted;
                    }
                    var useInputs = false;
                    var fn = function interceptedExpression(scope, locals, assign, inputs) {
                        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
                        return interceptorFn(value);
                    };
                    // Maintain references to the interceptor/intercepted
                    fn.$$intercepted = parsedExpression;
                    fn.$$interceptor = interceptorFn;
                    // Propogate the literal/oneTime/constant attributes
                    fn.literal = parsedExpression.literal;
                    fn.oneTime = parsedExpression.oneTime;
                    fn.constant = parsedExpression.constant;
                    // Treat the interceptor like filters.
                    // If it is not $stateful then only watch its inputs.
                    // If the expression itself has no inputs then use the full expression as an input.
                    if (!interceptorFn.$stateful) {
                        useInputs = !parsedExpression.inputs;
                        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [
                            parsedExpression
                        ];
                        if (!interceptorFn.$$pure) fn.inputs = fn.inputs.map(function(e) {
                            // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
                            // non-pure interceptor function.
                            if (e.isPure === PURITY_RELATIVE) return function depurifier(s) {
                                return e(s);
                            };
                            return e;
                        });
                    }
                    return addWatchDelegate(fn);
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */ /**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */ function $QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = [
            "$rootScope",
            "$exceptionHandler",
            function($rootScope, $exceptionHandler) {
                return qFactory(function(callback) {
                    $rootScope.$evalAsync(callback);
                }, $exceptionHandler, errorOnUnhandledRejections);
            }
        ];
        /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */ this.errorOnUnhandledRejections = function(value) {
            if (isDefined(value)) {
                errorOnUnhandledRejections = value;
                return this;
            } else return errorOnUnhandledRejections;
        };
    }
    /** @this */ function $$QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = [
            "$browser",
            "$exceptionHandler",
            function($browser, $exceptionHandler) {
                return qFactory(function(callback) {
                    $browser.defer(callback);
                }, $exceptionHandler, errorOnUnhandledRejections);
            }
        ];
        this.errorOnUnhandledRejections = function(value) {
            if (isDefined(value)) {
                errorOnUnhandledRejections = value;
                return this;
            } else return errorOnUnhandledRejections;
        };
    }
    /**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */ function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
        var $qMinErr = minErr("$q", TypeError);
        var queueSize = 0;
        var checkQueue = [];
        /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */ function defer() {
            return new Deferred();
        }
        function Deferred() {
            var promise = this.promise = new Promise();
            //Non prototype methods necessary to support unbound execution :/
            this.resolve = function(val) {
                resolvePromise(promise, val);
            };
            this.reject = function(reason) {
                rejectPromise(promise, reason);
            };
            this.notify = function(progress) {
                notifyPromise(promise, progress);
            };
        }
        function Promise() {
            this.$$state = {
                status: 0
            };
        }
        extend(Promise.prototype, {
            then: function(onFulfilled, onRejected, progressBack) {
                if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) return this;
                var result = new Promise();
                this.$$state.pending = this.$$state.pending || [];
                this.$$state.pending.push([
                    result,
                    onFulfilled,
                    onRejected,
                    progressBack
                ]);
                if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
                return result;
            },
            "catch": function(callback) {
                return this.then(null, callback);
            },
            "finally": function(callback, progressBack) {
                return this.then(function(value) {
                    return handleCallback(value, resolve, callback);
                }, function(error) {
                    return handleCallback(error, reject, callback);
                }, progressBack);
            }
        });
        function processQueue(state) {
            var fn, promise, pending;
            pending = state.pending;
            state.processScheduled = false;
            state.pending = undefined;
            try {
                for(var i = 0, ii = pending.length; i < ii; ++i){
                    markQStateExceptionHandled(state);
                    promise = pending[i][0];
                    fn = pending[i][state.status];
                    try {
                        if (isFunction(fn)) resolvePromise(promise, fn(state.value));
                        else if (state.status === 1) resolvePromise(promise, state.value);
                        else rejectPromise(promise, state.value);
                    } catch (e) {
                        rejectPromise(promise, e);
                        // This error is explicitly marked for being passed to the $exceptionHandler
                        if (e && e.$$passToExceptionHandler === true) exceptionHandler(e);
                    }
                }
            } finally{
                --queueSize;
                if (errorOnUnhandledRejections && queueSize === 0) nextTick(processChecks);
            }
        }
        function processChecks() {
            // eslint-disable-next-line no-unmodified-loop-condition
            while(!queueSize && checkQueue.length){
                var toCheck = checkQueue.shift();
                if (!isStateExceptionHandled(toCheck)) {
                    markQStateExceptionHandled(toCheck);
                    var errorMessage = "Possibly unhandled rejection: " + toDebugString(toCheck.value);
                    if (isError(toCheck.value)) exceptionHandler(toCheck.value, errorMessage);
                    else exceptionHandler(errorMessage);
                }
            }
        }
        function scheduleProcessQueue(state) {
            if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
                if (queueSize === 0 && checkQueue.length === 0) nextTick(processChecks);
                checkQueue.push(state);
            }
            if (state.processScheduled || !state.pending) return;
            state.processScheduled = true;
            ++queueSize;
            nextTick(function() {
                processQueue(state);
            });
        }
        function resolvePromise(promise, val) {
            if (promise.$$state.status) return;
            if (val === promise) $$reject(promise, $qMinErr("qcycle", "Expected promise to be resolved with value other than itself '{0}'", val));
            else $$resolve(promise, val);
        }
        function $$resolve(promise, val) {
            var then;
            var done = false;
            try {
                if (isObject(val) || isFunction(val)) then = val.then;
                if (isFunction(then)) {
                    promise.$$state.status = -1;
                    then.call(val, doResolve, doReject, doNotify);
                } else {
                    promise.$$state.value = val;
                    promise.$$state.status = 1;
                    scheduleProcessQueue(promise.$$state);
                }
            } catch (e) {
                doReject(e);
            }
            function doResolve(val) {
                if (done) return;
                done = true;
                $$resolve(promise, val);
            }
            function doReject(val) {
                if (done) return;
                done = true;
                $$reject(promise, val);
            }
            function doNotify(progress) {
                notifyPromise(promise, progress);
            }
        }
        function rejectPromise(promise, reason) {
            if (promise.$$state.status) return;
            $$reject(promise, reason);
        }
        function $$reject(promise, reason) {
            promise.$$state.value = reason;
            promise.$$state.status = 2;
            scheduleProcessQueue(promise.$$state);
        }
        function notifyPromise(promise, progress) {
            var callbacks = promise.$$state.pending;
            if (promise.$$state.status <= 0 && callbacks && callbacks.length) nextTick(function() {
                var callback, result;
                for(var i = 0, ii = callbacks.length; i < ii; i++){
                    result = callbacks[i][0];
                    callback = callbacks[i][3];
                    try {
                        notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
                    } catch (e) {
                        exceptionHandler(e);
                    }
                }
            });
        }
        /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */ function reject(reason) {
            var result = new Promise();
            rejectPromise(result, reason);
            return result;
        }
        function handleCallback(value, resolver, callback) {
            var callbackOutput = null;
            try {
                if (isFunction(callback)) callbackOutput = callback();
            } catch (e) {
                return reject(e);
            }
            if (isPromiseLike(callbackOutput)) return callbackOutput.then(function() {
                return resolver(value);
            }, reject);
            else return resolver(value);
        }
        /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */ function when(value, callback, errback, progressBack) {
            var result = new Promise();
            resolvePromise(result, value);
            return result.then(callback, errback, progressBack);
        }
        /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */ var resolve = when;
        /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */ function all(promises) {
            var result = new Promise(), counter = 0, results = isArray(promises) ? [] : {};
            forEach(promises, function(promise, key) {
                counter++;
                when(promise).then(function(value) {
                    results[key] = value;
                    if (!--counter) resolvePromise(result, results);
                }, function(reason) {
                    rejectPromise(result, reason);
                });
            });
            if (counter === 0) resolvePromise(result, results);
            return result;
        }
        /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */ function race(promises) {
            var deferred = defer();
            forEach(promises, function(promise) {
                when(promise).then(deferred.resolve, deferred.reject);
            });
            return deferred.promise;
        }
        function $Q(resolver) {
            if (!isFunction(resolver)) throw $qMinErr("norslvr", "Expected resolverFn, got '{0}'", resolver);
            var promise = new Promise();
            function resolveFn(value) {
                resolvePromise(promise, value);
            }
            function rejectFn(reason) {
                rejectPromise(promise, reason);
            }
            resolver(resolveFn, rejectFn);
            return promise;
        }
        // Let's make the instanceof operator work for promises, so that
        // `new $q(fn) instanceof $q` would evaluate to true.
        $Q.prototype = Promise.prototype;
        $Q.defer = defer;
        $Q.reject = reject;
        $Q.when = when;
        $Q.resolve = resolve;
        $Q.all = all;
        $Q.race = race;
        return $Q;
    }
    function isStateExceptionHandled(state) {
        return !!state.pur;
    }
    function markQStateExceptionHandled(state) {
        state.pur = true;
    }
    function markQExceptionHandled(q) {
        // Built-in `$q` promises will always have a `$$state` property. This check is to allow
        // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
        // (Currently, this is the only method that might be called with a promise, even if it is not
        // created by the built-in `$q`.)
        if (q.$$state) markQStateExceptionHandled(q.$$state);
    }
    /** @this */ function $$RAFProvider() {
        this.$get = [
            "$window",
            "$timeout",
            function($window, $timeout) {
                var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;
                var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
                var rafSupported = !!requestAnimationFrame;
                var raf = rafSupported ? function(fn) {
                    var id = requestAnimationFrame(fn);
                    return function() {
                        cancelAnimationFrame(id);
                    };
                } : function(fn) {
                    var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
                    return function() {
                        $timeout.cancel(timer);
                    };
                };
                raf.supported = rafSupported;
                return raf;
            }
        ];
    }
    /**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */ /**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */ /**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */ /**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */ function $RootScopeProvider() {
        var TTL = 10;
        var $rootScopeMinErr = minErr("$rootScope");
        var lastDirtyWatch = null;
        var applyAsyncId = null;
        this.digestTtl = function(value) {
            if (arguments.length) TTL = value;
            return TTL;
        };
        function createChildScopeClass(parent) {
            function ChildScope() {
                this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
                this.$$listeners = {};
                this.$$listenerCount = {};
                this.$$watchersCount = 0;
                this.$id = nextUid();
                this.$$ChildScope = null;
                this.$$suspended = false;
            }
            ChildScope.prototype = parent;
            return ChildScope;
        }
        this.$get = [
            "$exceptionHandler",
            "$parse",
            "$browser",
            function($exceptionHandler, $parse, $browser) {
                function destroyChildScope($event) {
                    $event.currentScope.$$destroyed = true;
                }
                function cleanUpScope($scope) {
                    // Support: IE 9 only
                    if (msie === 9) {
                        // There is a memory leak in IE9 if all child scopes are not disconnected
                        // completely when a scope is destroyed. So this code will recurse up through
                        // all this scopes children
                        //
                        // See issue https://github.com/angular/angular.js/issues/10706
                        if ($scope.$$childHead) cleanUpScope($scope.$$childHead);
                        if ($scope.$$nextSibling) cleanUpScope($scope.$$nextSibling);
                    }
                    // The code below works around IE9 and V8's memory leaks
                    //
                    // See:
                    // - https://code.google.com/p/v8/issues/detail?id=2073#c26
                    // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
                    // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
                    $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
                }
                /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */ function Scope() {
                    this.$id = nextUid();
                    this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
                    this.$root = this;
                    this.$$destroyed = false;
                    this.$$suspended = false;
                    this.$$listeners = {};
                    this.$$listenerCount = {};
                    this.$$watchersCount = 0;
                    this.$$isolateBindings = null;
                }
                /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */ /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */ /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */ Scope.prototype = {
                    constructor: Scope,
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */ $new: function(isolate, parent) {
                        var child;
                        parent = parent || this;
                        if (isolate) {
                            child = new Scope();
                            child.$root = this.$root;
                        } else {
                            // Only create a child scope class if somebody asks for one,
                            // but cache it to allow the VM to optimize lookups.
                            if (!this.$$ChildScope) this.$$ChildScope = createChildScopeClass(this);
                            child = new this.$$ChildScope();
                        }
                        child.$parent = parent;
                        child.$$prevSibling = parent.$$childTail;
                        if (parent.$$childHead) {
                            parent.$$childTail.$$nextSibling = child;
                            parent.$$childTail = child;
                        } else parent.$$childHead = parent.$$childTail = child;
                        // When the new scope is not isolated or we inherit from `this`, and
                        // the parent scope is destroyed, the property `$$destroyed` is inherited
                        // prototypically. In all other cases, this property needs to be set
                        // when the parent scope is destroyed.
                        // The listener needs to be added after the parent is set
                        if (isolate || parent !== this) child.$on("$destroy", destroyChildScope);
                        return child;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */ $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
                        var get = $parse(watchExp);
                        var fn = isFunction(listener) ? listener : noop;
                        if (get.$$watchDelegate) return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
                        var scope = this, array = scope.$$watchers, watcher = {
                            fn: fn,
                            last: initWatchVal,
                            get: get,
                            exp: prettyPrintExpression || watchExp,
                            eq: !!objectEquality
                        };
                        lastDirtyWatch = null;
                        if (!array) {
                            array = scope.$$watchers = [];
                            array.$$digestWatchIndex = -1;
                        }
                        // we use unshift since we use a while loop in $digest for speed.
                        // the while loop reads in reverse order.
                        array.unshift(watcher);
                        array.$$digestWatchIndex++;
                        incrementWatchersCount(this, 1);
                        return function deregisterWatch() {
                            var index = arrayRemove(array, watcher);
                            if (index >= 0) {
                                incrementWatchersCount(scope, -1);
                                if (index < array.$$digestWatchIndex) array.$$digestWatchIndex--;
                            }
                            lastDirtyWatch = null;
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */ $watchGroup: function(watchExpressions, listener) {
                        var oldValues = new Array(watchExpressions.length);
                        var newValues = new Array(watchExpressions.length);
                        var deregisterFns = [];
                        var self = this;
                        var changeReactionScheduled = false;
                        var firstRun = true;
                        if (!watchExpressions.length) {
                            // No expressions means we call the listener ASAP
                            var shouldCall = true;
                            self.$evalAsync(function() {
                                if (shouldCall) listener(newValues, newValues, self);
                            });
                            return function deregisterWatchGroup() {
                                shouldCall = false;
                            };
                        }
                        if (watchExpressions.length === 1) // Special case size of one
                        return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
                            newValues[0] = value;
                            oldValues[0] = oldValue;
                            listener(newValues, value === oldValue ? newValues : oldValues, scope);
                        });
                        forEach(watchExpressions, function(expr, i) {
                            var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
                                newValues[i] = value;
                                if (!changeReactionScheduled) {
                                    changeReactionScheduled = true;
                                    self.$evalAsync(watchGroupAction);
                                }
                            });
                            deregisterFns.push(unwatchFn);
                        });
                        function watchGroupAction() {
                            changeReactionScheduled = false;
                            try {
                                if (firstRun) {
                                    firstRun = false;
                                    listener(newValues, newValues, self);
                                } else listener(newValues, oldValues, self);
                            } finally{
                                for(var i = 0; i < watchExpressions.length; i++)oldValues[i] = newValues[i];
                            }
                        }
                        return function deregisterWatchGroup() {
                            while(deregisterFns.length)deregisterFns.shift()();
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */ $watchCollection: function(obj, listener) {
                        // Mark the interceptor as
                        // ... $$pure when literal since the instance will change when any input changes
                        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
                        // ... $stateful when non-literal since we must read the state of the collection
                        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
                        var self = this;
                        // the current value, updated on each dirty-check run
                        var newValue;
                        // a shallow copy of the newValue from the last dirty-check run,
                        // updated to match newValue during dirty-check run
                        var oldValue;
                        // a shallow copy of the newValue from when the last change happened
                        var veryOldValue;
                        // only track veryOldValue if the listener is asking for it
                        var trackVeryOldValue = listener.length > 1;
                        var changeDetected = 0;
                        var changeDetector = $parse(obj, $watchCollectionInterceptor);
                        var internalArray = [];
                        var internalObject = {};
                        var initRun = true;
                        var oldLength = 0;
                        function $watchCollectionInterceptor(_value) {
                            newValue = _value;
                            var newLength, key, bothNaN, newItem, oldItem;
                            // If the new value is undefined, then return undefined as the watch may be a one-time watch
                            if (isUndefined(newValue)) return;
                            if (!isObject(newValue)) {
                                if (oldValue !== newValue) {
                                    oldValue = newValue;
                                    changeDetected++;
                                }
                            } else if (isArrayLike(newValue)) {
                                if (oldValue !== internalArray) {
                                    // we are transitioning from something which was not an array into array.
                                    oldValue = internalArray;
                                    oldLength = oldValue.length = 0;
                                    changeDetected++;
                                }
                                newLength = newValue.length;
                                if (oldLength !== newLength) {
                                    // if lengths do not match we need to trigger change notification
                                    changeDetected++;
                                    oldValue.length = oldLength = newLength;
                                }
                                // copy the items to oldValue and look for changes.
                                for(var i = 0; i < newLength; i++){
                                    oldItem = oldValue[i];
                                    newItem = newValue[i];
                                    // eslint-disable-next-line no-self-compare
                                    bothNaN = oldItem !== oldItem && newItem !== newItem;
                                    if (!bothNaN && oldItem !== newItem) {
                                        changeDetected++;
                                        oldValue[i] = newItem;
                                    }
                                }
                            } else {
                                if (oldValue !== internalObject) {
                                    // we are transitioning from something which was not an object into object.
                                    oldValue = internalObject = {};
                                    oldLength = 0;
                                    changeDetected++;
                                }
                                // copy the items to oldValue and look for changes.
                                newLength = 0;
                                for(key in newValue)if (hasOwnProperty.call(newValue, key)) {
                                    newLength++;
                                    newItem = newValue[key];
                                    oldItem = oldValue[key];
                                    if (key in oldValue) {
                                        // eslint-disable-next-line no-self-compare
                                        bothNaN = oldItem !== oldItem && newItem !== newItem;
                                        if (!bothNaN && oldItem !== newItem) {
                                            changeDetected++;
                                            oldValue[key] = newItem;
                                        }
                                    } else {
                                        oldLength++;
                                        oldValue[key] = newItem;
                                        changeDetected++;
                                    }
                                }
                                if (oldLength > newLength) {
                                    // we used to have more keys, need to find them and destroy them.
                                    changeDetected++;
                                    for(key in oldValue)if (!hasOwnProperty.call(newValue, key)) {
                                        oldLength--;
                                        delete oldValue[key];
                                    }
                                }
                            }
                            return changeDetected;
                        }
                        function $watchCollectionAction() {
                            if (initRun) {
                                initRun = false;
                                listener(newValue, newValue, self);
                            } else listener(newValue, veryOldValue, self);
                            // make a copy for the next time a collection is changed
                            if (trackVeryOldValue) {
                                if (!isObject(newValue)) //primitive
                                veryOldValue = newValue;
                                else if (isArrayLike(newValue)) {
                                    veryOldValue = new Array(newValue.length);
                                    for(var i = 0; i < newValue.length; i++)veryOldValue[i] = newValue[i];
                                } else {
                                    veryOldValue = {};
                                    for(var key in newValue)if (hasOwnProperty.call(newValue, key)) veryOldValue[key] = newValue[key];
                                }
                            }
                        }
                        return this.$watch(changeDetector, $watchCollectionAction);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */ $digest: function() {
                        var watch, value, last, fn, get, watchers, dirty, ttl = TTL, next, current, target = asyncQueue.length ? $rootScope : this, watchLog = [], logIdx, asyncTask;
                        beginPhase("$digest");
                        // Check for changes to browser url that happened in sync before the call to $digest
                        $browser.$$checkUrlChange();
                        if (this === $rootScope && applyAsyncId !== null) {
                            // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
                            // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
                            $browser.defer.cancel(applyAsyncId);
                            flushApplyAsync();
                        }
                        lastDirtyWatch = null;
                        do {
                            dirty = false;
                            current = target;
                            // It's safe for asyncQueuePosition to be a local variable here because this loop can't
                            // be reentered recursively. Calling $digest from a function passed to $evalAsync would
                            // lead to a '$digest already in progress' error.
                            for(var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++){
                                try {
                                    asyncTask = asyncQueue[asyncQueuePosition];
                                    fn = asyncTask.fn;
                                    fn(asyncTask.scope, asyncTask.locals);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                                lastDirtyWatch = null;
                            }
                            asyncQueue.length = 0;
                            traverseScopesLoop: do {
                                if (watchers = !current.$$suspended && current.$$watchers) {
                                    // process our watches
                                    watchers.$$digestWatchIndex = watchers.length;
                                    while(watchers.$$digestWatchIndex--)try {
                                        watch = watchers[watchers.$$digestWatchIndex];
                                        // Most common watches are on primitives, in which case we can short
                                        // circuit it with === operator, only when === fails do we use .equals
                                        if (watch) {
                                            get = watch.get;
                                            if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : isNumberNaN(value) && isNumberNaN(last))) {
                                                dirty = true;
                                                lastDirtyWatch = watch;
                                                watch.last = watch.eq ? copy(value, null) : value;
                                                fn = watch.fn;
                                                fn(value, last === initWatchVal ? value : last, current);
                                                if (ttl < 5) {
                                                    logIdx = 4 - ttl;
                                                    if (!watchLog[logIdx]) watchLog[logIdx] = [];
                                                    watchLog[logIdx].push({
                                                        msg: isFunction(watch.exp) ? "fn: " + (watch.exp.name || watch.exp.toString()) : watch.exp,
                                                        newVal: value,
                                                        oldVal: last
                                                    });
                                                }
                                            } else if (watch === lastDirtyWatch) {
                                                // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                                                // have already been tested.
                                                dirty = false;
                                                break traverseScopesLoop;
                                            }
                                        }
                                    } catch (e) {
                                        $exceptionHandler(e);
                                    }
                                }
                                // Insanity Warning: scope depth-first traversal
                                // yes, this code is a bit crazy, but it works and we have tests to prove it!
                                // this piece should be kept in sync with the traversal in $broadcast
                                // (though it differs due to having the extra check for $$suspended and does not
                                // check $$listenerCount)
                                if (!(next = !current.$$suspended && current.$$watchersCount && current.$$childHead || current !== target && current.$$nextSibling)) while(current !== target && !(next = current.$$nextSibling))current = current.$parent;
                            }while (current = next);
                            // `break traverseScopesLoop;` takes us to here
                            if ((dirty || asyncQueue.length) && !ttl--) {
                                clearPhase();
                                throw $rootScopeMinErr("infdig", "{0} $digest() iterations reached. Aborting!\nWatchers fired in the last 5 iterations: {1}", TTL, watchLog);
                            }
                        }while (dirty || asyncQueue.length);
                        clearPhase();
                        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
                        while(postDigestQueuePosition < postDigestQueue.length)try {
                            postDigestQueue[postDigestQueuePosition++]();
                        } catch (e) {
                            $exceptionHandler(e);
                        }
                        postDigestQueue.length = postDigestQueuePosition = 0;
                        // Check for changes to browser url that happened during the $digest
                        // (for which no event is fired; e.g. via `history.pushState()`)
                        $browser.$$checkUrlChange();
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */ $suspend: function() {
                        this.$$suspended = true;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */ $isSuspended: function() {
                        return this.$$suspended;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */ $resume: function() {
                        this.$$suspended = false;
                    },
                    /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */ /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */ $destroy: function() {
                        // We can't destroy a scope that has been already destroyed.
                        if (this.$$destroyed) return;
                        var parent = this.$parent;
                        this.$broadcast("$destroy");
                        this.$$destroyed = true;
                        if (this === $rootScope) //Remove handlers attached to window when $rootScope is removed
                        $browser.$$applicationDestroyed();
                        incrementWatchersCount(this, -this.$$watchersCount);
                        for(var eventName in this.$$listenerCount)decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
                        // sever all the references to parent scopes (after this cleanup, the current scope should
                        // not be retained by any of our references and should be eligible for garbage collection)
                        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
                        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
                        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
                        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
                        // Disable listeners, watchers and apply/digest methods
                        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
                        this.$on = this.$watch = this.$watchGroup = function() {
                            return noop;
                        };
                        this.$$listeners = {};
                        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
                        this.$$nextSibling = null;
                        cleanUpScope(this);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */ $eval: function(expr, locals) {
                        return $parse(expr)(this, locals);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */ $evalAsync: function(expr, locals) {
                        // if we are outside of an $digest loop and this is the first time we are scheduling async
                        // task also schedule async auto-flush
                        if (!$rootScope.$$phase && !asyncQueue.length) $browser.defer(function() {
                            if (asyncQueue.length) $rootScope.$digest();
                        }, null, "$evalAsync");
                        asyncQueue.push({
                            scope: this,
                            fn: $parse(expr),
                            locals: locals
                        });
                    },
                    $$postDigest: function(fn) {
                        postDigestQueue.push(fn);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */ $apply: function(expr) {
                        try {
                            beginPhase("$apply");
                            try {
                                return this.$eval(expr);
                            } finally{
                                clearPhase();
                            }
                        } catch (e) {
                            $exceptionHandler(e);
                        } finally{
                            try {
                                $rootScope.$digest();
                            } catch (e) {
                                $exceptionHandler(e);
                                // eslint-disable-next-line no-unsafe-finally
                                throw e;
                            }
                        }
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */ $applyAsync: function(expr) {
                        var scope = this;
                        if (expr) applyAsyncQueue.push($applyAsyncExpression);
                        expr = $parse(expr);
                        scheduleApplyAsync();
                        function $applyAsyncExpression() {
                            scope.$eval(expr);
                        }
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */ $on: function(name, listener) {
                        var namedListeners = this.$$listeners[name];
                        if (!namedListeners) this.$$listeners[name] = namedListeners = [];
                        namedListeners.push(listener);
                        var current = this;
                        do {
                            if (!current.$$listenerCount[name]) current.$$listenerCount[name] = 0;
                            current.$$listenerCount[name]++;
                        }while (current = current.$parent);
                        var self = this;
                        return function() {
                            var indexOfListener = namedListeners.indexOf(listener);
                            if (indexOfListener !== -1) {
                                // Use delete in the hope of the browser deallocating the memory for the array entry,
                                // while not shifting the array indexes of other listeners.
                                // See issue https://github.com/angular/angular.js/issues/16135
                                delete namedListeners[indexOfListener];
                                decrementListenerCount(self, 1, name);
                            }
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */ $emit: function(name, args) {
                        var empty = [], namedListeners, scope = this, stopPropagation = false, event = {
                            name: name,
                            targetScope: scope,
                            stopPropagation: function() {
                                stopPropagation = true;
                            },
                            preventDefault: function() {
                                event.defaultPrevented = true;
                            },
                            defaultPrevented: false
                        }, listenerArgs = concat([
                            event
                        ], arguments, 1), i, length;
                        do {
                            namedListeners = scope.$$listeners[name] || empty;
                            event.currentScope = scope;
                            for(i = 0, length = namedListeners.length; i < length; i++){
                                // if listeners were deregistered, defragment the array
                                if (!namedListeners[i]) {
                                    namedListeners.splice(i, 1);
                                    i--;
                                    length--;
                                    continue;
                                }
                                try {
                                    //allow all listeners attached to the current scope to run
                                    namedListeners[i].apply(null, listenerArgs);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            }
                            //if any listener on the current scope stops propagation, prevent bubbling
                            if (stopPropagation) break;
                            //traverse upwards
                            scope = scope.$parent;
                        }while (scope);
                        event.currentScope = null;
                        return event;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */ $broadcast: function(name, args) {
                        var target = this, current = target, next = target, event = {
                            name: name,
                            targetScope: target,
                            preventDefault: function() {
                                event.defaultPrevented = true;
                            },
                            defaultPrevented: false
                        };
                        if (!target.$$listenerCount[name]) return event;
                        var listenerArgs = concat([
                            event
                        ], arguments, 1), listeners, i, length;
                        //down while you can, then up and next sibling or up and next sibling until back at root
                        while(current = next){
                            event.currentScope = current;
                            listeners = current.$$listeners[name] || [];
                            for(i = 0, length = listeners.length; i < length; i++){
                                // if listeners were deregistered, defragment the array
                                if (!listeners[i]) {
                                    listeners.splice(i, 1);
                                    i--;
                                    length--;
                                    continue;
                                }
                                try {
                                    listeners[i].apply(null, listenerArgs);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            }
                            // Insanity Warning: scope depth-first traversal
                            // yes, this code is a bit crazy, but it works and we have tests to prove it!
                            // this piece should be kept in sync with the traversal in $digest
                            // (though it differs due to having the extra check for $$listenerCount and
                            // does not check $$suspended)
                            if (!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)) while(current !== target && !(next = current.$$nextSibling))current = current.$parent;
                        }
                        event.currentScope = null;
                        return event;
                    }
                };
                var $rootScope = new Scope();
                //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
                var asyncQueue = $rootScope.$$asyncQueue = [];
                var postDigestQueue = $rootScope.$$postDigestQueue = [];
                var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
                var postDigestQueuePosition = 0;
                return $rootScope;
                function beginPhase(phase) {
                    if ($rootScope.$$phase) throw $rootScopeMinErr("inprog", "{0} already in progress", $rootScope.$$phase);
                    $rootScope.$$phase = phase;
                }
                function clearPhase() {
                    $rootScope.$$phase = null;
                }
                function incrementWatchersCount(current, count) {
                    do current.$$watchersCount += count;
                    while (current = current.$parent);
                }
                function decrementListenerCount(current, count, name) {
                    do {
                        current.$$listenerCount[name] -= count;
                        if (current.$$listenerCount[name] === 0) delete current.$$listenerCount[name];
                    }while (current = current.$parent);
                }
                /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */ function initWatchVal() {}
                function flushApplyAsync() {
                    while(applyAsyncQueue.length)try {
                        applyAsyncQueue.shift()();
                    } catch (e) {
                        $exceptionHandler(e);
                    }
                    applyAsyncId = null;
                }
                function scheduleApplyAsync() {
                    if (applyAsyncId === null) applyAsyncId = $browser.defer(function() {
                        $rootScope.$apply(flushApplyAsync);
                    }, null, "$applyAsync");
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */ // the implementation is in angular.bootstrap
    /**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */ function $$SanitizeUriProvider() {
        var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/, imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
        /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.aHrefSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                aHrefSanitizationTrustedUrlList = regexp;
                return this;
            }
            return aHrefSanitizationTrustedUrlList;
        };
        /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
   * unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.imgSrcSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                imgSrcSanitizationTrustedUrlList = regexp;
                return this;
            }
            return imgSrcSanitizationTrustedUrlList;
        };
        this.$get = function() {
            return function sanitizeUri(uri, isMediaUrl) {
                // if (!uri) return uri;
                var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
                var normalizedVal = urlResolve(uri && uri.trim()).href;
                if (normalizedVal !== "" && !normalizedVal.match(regex)) return "unsafe:" + normalizedVal;
                return uri;
            };
        };
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* exported $SceProvider, $SceDelegateProvider */ var $sceMinErr = minErr("$sce");
    var SCE_CONTEXTS = {
        // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
        HTML: "html",
        // Style statements or stylesheets. Currently unused in AngularJS.
        CSS: "css",
        // An URL used in a context where it refers to the source of media, which are not expected to be run
        // as scripts, such as an image, audio, video, etc.
        MEDIA_URL: "mediaUrl",
        // An URL used in a context where it does not refer to a resource that loads code.
        // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
        URL: "url",
        // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
        // code. (e.g. ng-include, script src binding, templateUrl)
        // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
        RESOURCE_URL: "resourceUrl",
        // Script. Currently unused in AngularJS.
        JS: "js"
    };
    // Helper functions follow.
    var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
    function snakeToCamel(name) {
        return name.replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
    }
    function adjustMatcher(matcher) {
        if (matcher === "self") return matcher;
        else if (isString(matcher)) {
            // Strings match exactly except for 2 wildcards - '*' and '**'.
            // '*' matches any character except those from the set ':/.?&'.
            // '**' matches any character (like .* in a RegExp).
            // More than 2 *'s raises an error as it's ill defined.
            if (matcher.indexOf("***") > -1) throw $sceMinErr("iwcard", "Illegal sequence *** in string matcher.  String: {0}", matcher);
            matcher = escapeForRegexp(matcher).replace(/\\\*\\\*/g, ".*").replace(/\\\*/g, "[^:/.?&;]*");
            return new RegExp("^" + matcher + "$");
        } else if (isRegExp(matcher)) // The only other type of matcher allowed is a Regexp.
        // Match entire URL / disallow partial matches.
        // Flags are reset (i.e. no global, ignoreCase or multiline)
        return new RegExp("^" + matcher.source + "$");
        else throw $sceMinErr("imatcher", 'Matchers may only be "self", string patterns or RegExp objects');
    }
    function adjustMatchers(matchers) {
        var adjustedMatchers = [];
        if (isDefined(matchers)) forEach(matchers, function(matcher) {
            adjustedMatchers.push(adjustMatcher(matcher));
        });
        return adjustedMatchers;
    }
    /**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
 */ /**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and
 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.trustedResourceUrlList([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
 *    // here is blocked.
 *    $sceDelegateProvider.bannedResourceUrlList([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
 * of issues, like for instance attacker-controlled `ng-includes`.
 */ function $SceDelegateProvider() {
        this.SCE_CONTEXTS = SCE_CONTEXTS;
        // Resource URLs can also be trusted by policy.
        var trustedResourceUrlList = [
            "self"
        ], bannedResourceUrlList = [];
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#trustedResourceUrlList
   * @kind function
   *
   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
   *     further changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set trusted resource URL array.
   *
   * @description
   * Sets/Gets the list trusted of resource URLs.
   *
   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
   * allowing only same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
   * its origin with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */ this.trustedResourceUrlList = function(value) {
            if (arguments.length) trustedResourceUrlList = adjustMatchers(value);
            return trustedResourceUrlList;
        };
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
   * trustedResourceUrlList} instead.
   */ Object.defineProperty(this, "resourceUrlWhitelist", {
            get: function() {
                return this.trustedResourceUrlList;
            },
            set: function(value) {
                this.trustedResourceUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#bannedResourceUrlList
   * @kind function
   *
   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
   *     the value provided. This must be an array or null. A snapshot of this array is used so
   *     further changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the `bannedResourceUrlList` is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
   *     the final say.
   *
   * @return {Array} The currently set `bannedResourceUrlList` array.
   *
   * @description
   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
   *
   * The **default value** when no trusted resource URL list has been explicitly set is the empty
   * array (i.e. there is no `bannedResourceUrlList`.)
   */ this.bannedResourceUrlList = function(value) {
            if (arguments.length) bannedResourceUrlList = adjustMatchers(value);
            return bannedResourceUrlList;
        };
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
   * bannedResourceUrlList} instead.
   */ Object.defineProperty(this, "resourceUrlBlacklist", {
            get: function() {
                return this.bannedResourceUrlList;
            },
            set: function(value) {
                this.bannedResourceUrlList = value;
            }
        });
        this.$get = [
            "$injector",
            "$$sanitizeUri",
            function($injector, $$sanitizeUri) {
                var htmlSanitizer = function htmlSanitizer(html) {
                    throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
                };
                if ($injector.has("$sanitize")) htmlSanitizer = $injector.get("$sanitize");
                function matchUrl(matcher, parsedUrl) {
                    if (matcher === "self") return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
                    else // definitely a regex.  See adjustMatchers()
                    return !!matcher.exec(parsedUrl.href);
                }
                function isResourceUrlAllowedByPolicy(url) {
                    var parsedUrl = urlResolve(url.toString());
                    var i, n, allowed = false;
                    // Ensure that at least one item from the trusted resource URL list allows this url.
                    for(i = 0, n = trustedResourceUrlList.length; i < n; i++)if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
                        allowed = true;
                        break;
                    }
                    if (allowed) {
                        // Ensure that no item from the banned resource URL list has blocked this url.
                        for(i = 0, n = bannedResourceUrlList.length; i < n; i++)if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
                            allowed = false;
                            break;
                        }
                    }
                    return allowed;
                }
                function generateHolderType(Base) {
                    var holderType = function TrustedValueHolderType(trustedValue) {
                        this.$$unwrapTrustedValue = function() {
                            return trustedValue;
                        };
                    };
                    if (Base) holderType.prototype = new Base();
                    holderType.prototype.valueOf = function sceValueOf() {
                        return this.$$unwrapTrustedValue();
                    };
                    holderType.prototype.toString = function sceToString() {
                        return this.$$unwrapTrustedValue().toString();
                    };
                    return holderType;
                }
                var trustedValueHolderBase = generateHolderType(), byType = {};
                byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
                byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
                /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */ function trustAs(type, trustedValue) {
                    var Constructor = byType.hasOwnProperty(type) ? byType[type] : null;
                    if (!Constructor) throw $sceMinErr("icontext", "Attempted to trust a value in invalid context. Context: {0}; Value: {1}", type, trustedValue);
                    if (trustedValue === null || isUndefined(trustedValue) || trustedValue === "") return trustedValue;
                    // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
                    // mutable objects, we ensure here that the value passed in is actually a string.
                    if (typeof trustedValue !== "string") throw $sceMinErr("itype", "Attempted to trust a non-string value in a content requiring a string: Context: {0}", type);
                    return new Constructor(trustedValue);
                }
                /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */ function valueOf(maybeTrusted) {
                    if (maybeTrusted instanceof trustedValueHolderBase) return maybeTrusted.$$unwrapTrustedValue();
                    else return maybeTrusted;
                }
                /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */ function getTrusted(type, maybeTrusted) {
                    if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === "") return maybeTrusted;
                    var constructor = byType.hasOwnProperty(type) ? byType[type] : null;
                    // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
                    // as-is.
                    if (constructor && maybeTrusted instanceof constructor) return maybeTrusted.$$unwrapTrustedValue();
                    // If maybeTrusted is a trusted class instance but not of the correct trusted type
                    // then unwrap it and allow it to pass through to the rest of the checks
                    if (isFunction(maybeTrusted.$$unwrapTrustedValue)) maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
                    // If we get here, then we will either sanitize the value or throw an exception.
                    if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) // we attempt to sanitize non-resource URLs
                    return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
                    else if (type === SCE_CONTEXTS.RESOURCE_URL) {
                        if (isResourceUrlAllowedByPolicy(maybeTrusted)) return maybeTrusted;
                        else throw $sceMinErr("insecurl", "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}", maybeTrusted.toString());
                    } else if (type === SCE_CONTEXTS.HTML) // htmlSanitizer throws its own error when no sanitizer is available.
                    return htmlSanitizer(maybeTrusted);
                    // Default error when the $sce service has no way to make the input safe.
                    throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
                }
                return {
                    trustAs: trustAs,
                    getTrusted: getTrusted,
                    valueOf: valueOf
                };
            }
        ];
    }
    /**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */ /**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
 * HTML can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      for matching resource URL lists.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */ function $SceProvider() {
        var enabled = true;
        /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */ this.enabled = function(value) {
            if (arguments.length) enabled = !!value;
            return enabled;
        };
        /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */ this.$get = [
            "$parse",
            "$sceDelegate",
            function($parse, $sceDelegate) {
                // Support: IE 9-11 only
                // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
                // the "expression(javascript expression)" syntax which is insecure.
                if (enabled && msie < 8) throw $sceMinErr("iequirks", "Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks mode.  You can fix this by adding the text <!doctype html> to the top of your HTML document.  See http://docs.angularjs.org/api/ng.$sce for more information.");
                var sce = shallowCopy(SCE_CONTEXTS);
                /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */ sce.isEnabled = function() {
                    return enabled;
                };
                sce.trustAs = $sceDelegate.trustAs;
                sce.getTrusted = $sceDelegate.getTrusted;
                sce.valueOf = $sceDelegate.valueOf;
                if (!enabled) {
                    sce.trustAs = sce.getTrusted = function(type, value) {
                        return value;
                    };
                    sce.valueOf = identity;
                }
                /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ sce.parseAs = function sceParseAs(type, expr) {
                    var parsed = $parse(expr);
                    if (parsed.literal && parsed.constant) return parsed;
                    else return $parse(expr, function(value) {
                        return sce.getTrusted(type, value);
                    });
                };
                /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */ /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */ /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */ /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ // Shorthand delegations.
                var parse = sce.parseAs, getTrusted = sce.getTrusted, trustAs = sce.trustAs;
                forEach(SCE_CONTEXTS, function(enumValue, name) {
                    var lName = lowercase(name);
                    sce[snakeToCamel("parse_as_" + lName)] = function(expr) {
                        return parse(enumValue, expr);
                    };
                    sce[snakeToCamel("get_trusted_" + lName)] = function(value) {
                        return getTrusted(enumValue, value);
                    };
                    sce[snakeToCamel("trust_as_" + lName)] = function(value) {
                        return trustAs(enumValue, value);
                    };
                });
                return sce;
            }
        ];
    }
    /* exported $SnifferProvider */ /**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */ function $SnifferProvider() {
        this.$get = [
            "$window",
            "$document",
            function($window, $document) {
                var eventSupport = {}, // Chrome Packaged Apps are not allowed to access `history.pushState`.
                // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
                // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
                // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
                // (see https://developer.chrome.com/apps/manifest/sandbox).
                // (NW.js apps have access to Chrome APIs, but do support `history`.)
                isNw = $window.nw && $window.nw.process, isChromePackagedApp = !isNw && $window.chrome && ($window.chrome.app && $window.chrome.app.runtime || !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id), hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState, android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]), boxee = /Boxee/i.test(($window.navigator || {}).userAgent), document1 = $document[0] || {}, bodyStyle = document1.body && document1.body.style, transitions = false, animations = false;
                if (bodyStyle) {
                    // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
                    // Mentioned browsers need a -webkit- prefix for transitions & animations.
                    transitions = !!("transition" in bodyStyle || "webkitTransition" in bodyStyle);
                    animations = !!("animation" in bodyStyle || "webkitAnimation" in bodyStyle);
                }
                return {
                    // Android has history.pushState, but it does not update location correctly
                    // so let's not use the history API at all.
                    // http://code.google.com/p/android/issues/detail?id=17471
                    // https://github.com/angular/angular.js/issues/904
                    // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
                    // so let's not use the history API also
                    // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
                    history: !!(hasHistoryPushState && !(android < 4) && !boxee),
                    hasEvent: function(event) {
                        // Support: IE 9-11 only
                        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
                        // it. In particular the event is not fired when backspace or delete key are pressed or
                        // when cut operation is performed.
                        // IE10+ implements 'input' event but it erroneously fires under various situations,
                        // e.g. when placeholder changes, or a form is focused.
                        if (event === "input" && msie) return false;
                        if (isUndefined(eventSupport[event])) {
                            var divElm = document1.createElement("div");
                            eventSupport[event] = "on" + event in divElm;
                        }
                        return eventSupport[event];
                    },
                    csp: csp(),
                    transitions: transitions,
                    animations: animations,
                    android: android
                };
            }
        ];
    }
    /**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */ function $$TaskTrackerFactoryProvider() {
        this.$get = valueFn(function(log) {
            return new TaskTracker(log);
        });
    }
    function TaskTracker(log) {
        var self = this;
        var taskCounts = {};
        var taskCallbacks = [];
        var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = "$$all$$";
        var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = "$$default$$";
        /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */ self.completeTask = completeTask;
        /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */ self.incTaskCount = incTaskCount;
        /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */ self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
        function completeTask(fn, taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            try {
                fn();
            } finally{
                decTaskCount(taskType);
                var countForType = taskCounts[taskType];
                var countForAll = taskCounts[ALL_TASKS_TYPE];
                // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
                if (!countForAll || !countForType) {
                    var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
                    var nextCb;
                    while(nextCb = getNextCallback(taskType))try {
                        nextCb();
                    } catch (e) {
                        log.error(e);
                    }
                }
            }
        }
        function decTaskCount(taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            if (taskCounts[taskType]) {
                taskCounts[taskType]--;
                taskCounts[ALL_TASKS_TYPE]--;
            }
        }
        function getLastCallback() {
            var cbInfo = taskCallbacks.pop();
            return cbInfo && cbInfo.cb;
        }
        function getLastCallbackForType(taskType) {
            for(var i = taskCallbacks.length - 1; i >= 0; --i){
                var cbInfo = taskCallbacks[i];
                if (cbInfo.type === taskType) {
                    taskCallbacks.splice(i, 1);
                    return cbInfo.cb;
                }
            }
        }
        function incTaskCount(taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
            taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
        }
        function notifyWhenNoPendingTasks(callback, taskType) {
            taskType = taskType || ALL_TASKS_TYPE;
            if (!taskCounts[taskType]) callback();
            else taskCallbacks.push({
                type: taskType,
                cb: callback
            });
        }
    }
    var $templateRequestMinErr = minErr("$templateRequest");
    /**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */ function $TemplateRequestProvider() {
        var httpOptions;
        /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */ this.httpOptions = function(val) {
            if (val) {
                httpOptions = val;
                return this;
            }
            return httpOptions;
        };
        /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */ this.$get = [
            "$exceptionHandler",
            "$templateCache",
            "$http",
            "$q",
            "$sce",
            function($exceptionHandler, $templateCache, $http, $q, $sce) {
                function handleRequestFn(tpl, ignoreRequestError) {
                    handleRequestFn.totalPendingRequests++;
                    // We consider the template cache holds only trusted templates, so
                    // there's no need to go through adding the template again to the trusted
                    // resources for keys that already are included in there. This also makes
                    // AngularJS accept any script directive, no matter its name. However, we
                    // still need to unwrap trusted types.
                    if (!isString(tpl) || isUndefined($templateCache.get(tpl))) tpl = $sce.getTrustedResourceUrl(tpl);
                    var transformResponse = $http.defaults && $http.defaults.transformResponse;
                    if (isArray(transformResponse)) transformResponse = transformResponse.filter(function(transformer) {
                        return transformer !== defaultHttpResponseTransform;
                    });
                    else if (transformResponse === defaultHttpResponseTransform) transformResponse = null;
                    return $http.get(tpl, extend({
                        cache: $templateCache,
                        transformResponse: transformResponse
                    }, httpOptions)).finally(function() {
                        handleRequestFn.totalPendingRequests--;
                    }).then(function(response) {
                        return $templateCache.put(tpl, response.data);
                    }, handleError);
                    function handleError(resp) {
                        if (!ignoreRequestError) {
                            resp = $templateRequestMinErr("tpload", "Failed to load template: {0} (HTTP status: {1} {2})", tpl, resp.status, resp.statusText);
                            $exceptionHandler(resp);
                        }
                        return $q.reject(resp);
                    }
                }
                handleRequestFn.totalPendingRequests = 0;
                return handleRequestFn;
            }
        ];
    }
    /** @this */ function $$TestabilityProvider() {
        this.$get = [
            "$rootScope",
            "$browser",
            "$location",
            function($rootScope, $browser, $location) {
                /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */ var testability = {};
                /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */ testability.findBindings = function(element, expression, opt_exactMatch) {
                    var bindings = element.getElementsByClassName("ng-binding");
                    var matches = [];
                    forEach(bindings, function(binding) {
                        var dataBinding = angular.element(binding).data("$binding");
                        if (dataBinding) forEach(dataBinding, function(bindingName) {
                            if (opt_exactMatch) {
                                var matcher = new RegExp("(^|\\s)" + escapeForRegexp(expression) + "(\\s|\\||$)");
                                if (matcher.test(bindingName)) matches.push(binding);
                            } else if (bindingName.indexOf(expression) !== -1) matches.push(binding);
                        });
                    });
                    return matches;
                };
                /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */ testability.findModels = function(element, expression, opt_exactMatch) {
                    var prefixes = [
                        "ng-",
                        "data-ng-",
                        "ng\\:"
                    ];
                    for(var p = 0; p < prefixes.length; ++p){
                        var attributeEquals = opt_exactMatch ? "=" : "*=";
                        var selector = "[" + prefixes[p] + "model" + attributeEquals + '"' + expression + '"]';
                        var elements = element.querySelectorAll(selector);
                        if (elements.length) return elements;
                    }
                };
                /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */ testability.getLocation = function() {
                    return $location.url();
                };
                /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */ testability.setLocation = function(url) {
                    if (url !== $location.url()) {
                        $location.url(url);
                        $rootScope.$digest();
                    }
                };
                /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */ testability.whenStable = function(callback) {
                    $browser.notifyWhenNoOutstandingRequests(callback);
                };
                return testability;
            }
        ];
    }
    var $timeoutMinErr = minErr("$timeout");
    /** @this */ function $TimeoutProvider() {
        this.$get = [
            "$rootScope",
            "$browser",
            "$q",
            "$$q",
            "$exceptionHandler",
            function($rootScope, $browser, $q, $$q, $exceptionHandler) {
                var deferreds = {};
                /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */ function timeout(fn, delay, invokeApply) {
                    if (!isFunction(fn)) {
                        invokeApply = delay;
                        delay = fn;
                        fn = noop;
                    }
                    var args = sliceArgs(arguments, 3), skipApply = isDefined(invokeApply) && !invokeApply, deferred = (skipApply ? $$q : $q).defer(), promise = deferred.promise, timeoutId;
                    timeoutId = $browser.defer(function() {
                        try {
                            deferred.resolve(fn.apply(null, args));
                        } catch (e) {
                            deferred.reject(e);
                            $exceptionHandler(e);
                        } finally{
                            delete deferreds[promise.$$timeoutId];
                        }
                        if (!skipApply) $rootScope.$apply();
                    }, delay, "$timeout");
                    promise.$$timeoutId = timeoutId;
                    deferreds[timeoutId] = deferred;
                    return promise;
                }
                /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */ timeout.cancel = function(promise) {
                    if (!promise) return false;
                    if (!promise.hasOwnProperty("$$timeoutId")) throw $timeoutMinErr("badprom", "`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.");
                    if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
                    var id = promise.$$timeoutId;
                    var deferred = deferreds[id];
                    // Timeout cancels should not report an unhandled promise.
                    markQExceptionHandled(deferred.promise);
                    deferred.reject("canceled");
                    delete deferreds[id];
                    return $browser.defer.cancel(id);
                };
                return timeout;
            }
        ];
    }
    // NOTE:  The usage of window and document instead of $window and $document here is
    // deliberate.  This service depends on the specific behavior of anchor nodes created by the
    // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
    // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
    // doesn't know about mocked locations and resolves URLs to the real document - which is
    // exactly the behavior needed here.  There is little value is mocking these out for this
    // service.
    var urlParsingNode = window1.document.createElement("a");
    var originUrl = urlResolve(window1.location.href);
    var baseUrlParsingNode;
    urlParsingNode.href = "http://[::1]";
    // Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
    // IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
    // when parsed out of an anchor element.
    var ipv6InBrackets = urlParsingNode.hostname === "[::1]";
    /**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */ function urlResolve(url) {
        if (!isString(url)) return url;
        var href = url;
        // Support: IE 9-11 only
        if (msie) {
            // Normalize before parse.  Refer Implementation Notes on why this is
            // done in two steps on IE.
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        var hostname = urlParsingNode.hostname;
        if (!ipv6InBrackets && hostname.indexOf(":") > -1) hostname = "[" + hostname + "]";
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    /**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */ function urlIsSameOrigin(requestUrl) {
        return urlsAreSameOrigin(requestUrl, originUrl);
    }
    /**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */ function urlIsSameOriginAsBaseUrl(requestUrl) {
        return urlsAreSameOrigin(requestUrl, getBaseUrl());
    }
    /**
 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */ function urlIsAllowedOriginFactory(trustedOriginUrls) {
        var parsedAllowedOriginUrls = [
            originUrl
        ].concat(trustedOriginUrls.map(urlResolve));
        /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of trusted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */ return function urlIsAllowedOrigin(requestUrl) {
            var parsedUrl = urlResolve(requestUrl);
            return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
        };
    }
    /**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */ function urlsAreSameOrigin(url1, url2) {
        url1 = urlResolve(url1);
        url2 = urlResolve(url2);
        return url1.protocol === url2.protocol && url1.host === url2.host;
    }
    /**
 * Returns the current document base URL.
 * @returns {string}
 */ function getBaseUrl() {
        if (window1.document.baseURI) return window1.document.baseURI;
        // `document.baseURI` is available everywhere except IE
        if (!baseUrlParsingNode) {
            baseUrlParsingNode = window1.document.createElement("a");
            baseUrlParsingNode.href = ".";
            // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
            // suitable here because we need to track changes to the base URL.
            baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
        }
        return baseUrlParsingNode.href;
    }
    /**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */ function $WindowProvider() {
        this.$get = valueFn(window1);
    }
    /**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */ function $$CookieReader($document) {
        var rawDocument = $document[0] || {};
        var lastCookies = {};
        var lastCookieString = "";
        function safeGetCookie(rawDocument) {
            try {
                return rawDocument.cookie || "";
            } catch (e) {
                return "";
            }
        }
        function safeDecodeURIComponent(str) {
            try {
                return decodeURIComponent(str);
            } catch (e) {
                return str;
            }
        }
        return function() {
            var cookieArray, cookie, i, index, name;
            var currentCookieString = safeGetCookie(rawDocument);
            if (currentCookieString !== lastCookieString) {
                lastCookieString = currentCookieString;
                cookieArray = lastCookieString.split("; ");
                lastCookies = {};
                for(i = 0; i < cookieArray.length; i++){
                    cookie = cookieArray[i];
                    index = cookie.indexOf("=");
                    if (index > 0) {
                        name = safeDecodeURIComponent(cookie.substring(0, index));
                        // the first value that is seen for a cookie is the most
                        // specific one.  values for the same cookie name that
                        // follow are for less specific paths.
                        if (isUndefined(lastCookies[name])) lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
            return lastCookies;
        };
    }
    $$CookieReader.$inject = [
        "$document"
    ];
    /** @this */ function $$CookieReaderProvider() {
        this.$get = $$CookieReader;
    }
    /* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */ /**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */ /**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */ $FilterProvider.$inject = [
        "$provide"
    ];
    /** @this */ function $FilterProvider($provide) {
        var suffix = "Filter";
        /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */ function register(name, factory) {
            if (isObject(name)) {
                var filters = {};
                forEach(name, function(filter, key) {
                    filters[key] = register(key, filter);
                });
                return filters;
            } else return $provide.factory(name + suffix, factory);
        }
        this.register = register;
        this.$get = [
            "$injector",
            function($injector) {
                return function(name) {
                    return $injector.get(name + suffix);
                };
            }
        ];
        ////////////////////////////////////////
        /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */ register("currency", currencyFilter);
        register("date", dateFilter);
        register("filter", filterFilter);
        register("json", jsonFilter);
        register("limitTo", limitToFilter);
        register("lowercase", lowercaseFilter);
        register("number", numberFilter);
        register("orderBy", orderByFilter);
        register("uppercase", uppercaseFilter);
    }
    /**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */ function filterFilter() {
        return function(array, expression, comparator, anyPropertyKey) {
            if (!isArrayLike(array)) {
                if (array == null) return array;
                else throw minErr("filter")("notarray", "Expected array but received: {0}", array);
            }
            anyPropertyKey = anyPropertyKey || "$";
            var expressionType = getTypeForFilter(expression);
            var predicateFn;
            var matchAgainstAnyProp;
            switch(expressionType){
                case "function":
                    predicateFn = expression;
                    break;
                case "boolean":
                case "null":
                case "number":
                case "string":
                    matchAgainstAnyProp = true;
                // falls through
                case "object":
                    predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
                    break;
                default:
                    return array;
            }
            return Array.prototype.filter.call(array, predicateFn);
        };
    }
    // Helper functions for `filterFilter`
    function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
        var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
        var predicateFn;
        if (comparator === true) comparator = equals;
        else if (!isFunction(comparator)) comparator = function(actual, expected) {
            if (isUndefined(actual)) // No substring matching against `undefined`
            return false;
            if (actual === null || expected === null) // No substring matching against `null`; only match against `null`
            return actual === expected;
            if (isObject(expected) || isObject(actual) && !hasCustomToString(actual)) // Should not compare primitives against objects, unless they have custom `toString` method
            return false;
            actual = lowercase("" + actual);
            expected = lowercase("" + expected);
            return actual.indexOf(expected) !== -1;
        };
        predicateFn = function(item) {
            if (shouldMatchPrimitives && !isObject(item)) return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
            return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        };
        return predicateFn;
    }
    function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
        var actualType = getTypeForFilter(actual);
        var expectedType = getTypeForFilter(expected);
        if (expectedType === "string" && expected.charAt(0) === "!") return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
        else if (isArray(actual)) // In case `actual` is an array, consider it a match
        // if ANY of it's items matches `expected`
        return actual.some(function(item) {
            return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
        });
        switch(actualType){
            case "object":
                var key;
                if (matchAgainstAnyProp) {
                    for(key in actual){
                        // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
                        // See: https://github.com/angular/angular.js/issues/15644
                        if (key.charAt && key.charAt(0) !== "$" && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) return true;
                    }
                    return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
                } else if (expectedType === "object") {
                    for(key in expected){
                        var expectedVal = expected[key];
                        if (isFunction(expectedVal) || isUndefined(expectedVal)) continue;
                        var matchAnyProperty = key === anyPropertyKey;
                        var actualVal = matchAnyProperty ? actual : actual[key];
                        if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) return false;
                    }
                    return true;
                } else return comparator(actual, expected);
            case "function":
                return false;
            default:
                return comparator(actual, expected);
        }
    }
    // Used for easily differentiating between `null` and actual `object`
    function getTypeForFilter(val) {
        return val === null ? "null" : typeof val;
    }
    var MAX_DIGITS = 22;
    var DECIMAL_SEP = ".";
    var ZERO_CHAR = "0";
    /**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */ currencyFilter.$inject = [
        "$locale"
    ];
    function currencyFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(amount, currencySymbol, fractionSize) {
            if (isUndefined(currencySymbol)) currencySymbol = formats.CURRENCY_SYM;
            if (isUndefined(fractionSize)) fractionSize = formats.PATTERNS[1].maxFrac;
            // If the currency symbol is empty, trim whitespace around the symbol
            var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
            // if null or undefined pass it through
            return amount == null ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(currencySymbolRe, currencySymbol);
        };
    }
    /**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */ numberFilter.$inject = [
        "$locale"
    ];
    function numberFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(number, fractionSize) {
            // if null or undefined pass it through
            return number == null ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
        };
    }
    /**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */ function parse(numStr) {
        var exponent = 0, digits, numberOfIntegerDigits;
        var i, j, zeros;
        // Decimal point?
        if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) numStr = numStr.replace(DECIMAL_SEP, "");
        // Exponential form?
        if ((i = numStr.search(/e/i)) > 0) {
            // Work out the exponent.
            if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
            numberOfIntegerDigits += +numStr.slice(i + 1);
            numStr = numStr.substring(0, i);
        } else if (numberOfIntegerDigits < 0) // There was no decimal point or exponent so it is an integer.
        numberOfIntegerDigits = numStr.length;
        // Count the number of leading zeros.
        for(i = 0; numStr.charAt(i) === ZERO_CHAR; i++);
        if (i === (zeros = numStr.length)) {
            // The digits are all zero.
            digits = [
                0
            ];
            numberOfIntegerDigits = 1;
        } else {
            // Count the number of trailing zeros
            zeros--;
            while(numStr.charAt(zeros) === ZERO_CHAR)zeros--;
            // Trailing zeros are insignificant so ignore them
            numberOfIntegerDigits -= i;
            digits = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(j = 0; i <= zeros; i++, j++)digits[j] = +numStr.charAt(i);
        }
        // If the number overflows the maximum allowed digits then use an exponent.
        if (numberOfIntegerDigits > MAX_DIGITS) {
            digits = digits.splice(0, MAX_DIGITS - 1);
            exponent = numberOfIntegerDigits - 1;
            numberOfIntegerDigits = 1;
        }
        return {
            d: digits,
            e: exponent,
            i: numberOfIntegerDigits
        };
    }
    /**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */ function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
        var digits = parsedNumber.d;
        var fractionLen = digits.length - parsedNumber.i;
        // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
        fractionSize = isUndefined(fractionSize) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
        // The index of the digit to where rounding is to occur
        var roundAt = fractionSize + parsedNumber.i;
        var digit = digits[roundAt];
        if (roundAt > 0) {
            // Drop fractional digits beyond `roundAt`
            digits.splice(Math.max(parsedNumber.i, roundAt));
            // Set non-fractional digits beyond `roundAt` to 0
            for(var j = roundAt; j < digits.length; j++)digits[j] = 0;
        } else {
            // We rounded to zero so reset the parsedNumber
            fractionLen = Math.max(0, fractionLen);
            parsedNumber.i = 1;
            digits.length = Math.max(1, roundAt = fractionSize + 1);
            digits[0] = 0;
            for(var i = 1; i < roundAt; i++)digits[i] = 0;
        }
        if (digit >= 5) {
            if (roundAt - 1 < 0) {
                for(var k = 0; k > roundAt; k--){
                    digits.unshift(0);
                    parsedNumber.i++;
                }
                digits.unshift(1);
                parsedNumber.i++;
            } else digits[roundAt - 1]++;
        }
        // Pad out with zeros to get the required fraction length
        for(; fractionLen < Math.max(0, fractionSize); fractionLen++)digits.push(0);
        // Do any carrying, e.g. a digit was rounded up to 10
        var carry = digits.reduceRight(function(carry, d, i, digits) {
            d = d + carry;
            digits[i] = d % 10;
            return Math.floor(d / 10);
        }, 0);
        if (carry) {
            digits.unshift(carry);
            parsedNumber.i++;
        }
    }
    /**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */ function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
        if (!(isString(number) || isNumber(number)) || isNaN(number)) return "";
        var isInfinity = !isFinite(number);
        var isZero = false;
        var numStr = Math.abs(number) + "", formattedText = "", parsedNumber;
        if (isInfinity) formattedText = "∞";
        else {
            parsedNumber = parse(numStr);
            roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
            var digits = parsedNumber.d;
            var integerLen = parsedNumber.i;
            var exponent = parsedNumber.e;
            var decimals = [];
            isZero = digits.reduce(function(isZero, d) {
                return isZero && !d;
            }, true);
            // pad zeros for small numbers
            while(integerLen < 0){
                digits.unshift(0);
                integerLen++;
            }
            // extract decimals digits
            if (integerLen > 0) decimals = digits.splice(integerLen, digits.length);
            else {
                decimals = digits;
                digits = [
                    0
                ];
            }
            // format the integer digits with grouping separators
            var groups = [];
            if (digits.length >= pattern.lgSize) groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(""));
            while(digits.length > pattern.gSize)groups.unshift(digits.splice(-pattern.gSize, digits.length).join(""));
            if (digits.length) groups.unshift(digits.join(""));
            formattedText = groups.join(groupSep);
            // append the decimal digits
            if (decimals.length) formattedText += decimalSep + decimals.join("");
            if (exponent) formattedText += "e+" + exponent;
        }
        if (number < 0 && !isZero) return pattern.negPre + formattedText + pattern.negSuf;
        else return pattern.posPre + formattedText + pattern.posSuf;
    }
    function padNumber(num, digits, trim, negWrap) {
        var neg = "";
        if (num < 0 || negWrap && num <= 0) {
            if (negWrap) num = -num + 1;
            else {
                num = -num;
                neg = "-";
            }
        }
        num = "" + num;
        while(num.length < digits)num = ZERO_CHAR + num;
        if (trim) num = num.substr(num.length - digits);
        return neg + num;
    }
    function dateGetter(name, size, offset, trim, negWrap) {
        offset = offset || 0;
        return function(date) {
            var value = date["get" + name]();
            if (offset > 0 || value > -offset) value += offset;
            if (value === 0 && offset === -12) value = 12;
            return padNumber(value, size, trim, negWrap);
        };
    }
    function dateStrGetter(name, shortForm, standAlone) {
        return function(date, formats) {
            var value = date["get" + name]();
            var propPrefix = (standAlone ? "STANDALONE" : "") + (shortForm ? "SHORT" : "");
            var get = uppercase(propPrefix + name);
            return formats[get][value];
        };
    }
    function timeZoneGetter(date, formats, offset) {
        var zone = -1 * offset;
        var paddedZone = zone >= 0 ? "+" : "";
        paddedZone += padNumber(Math[zone > 0 ? "floor" : "ceil"](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);
        return paddedZone;
    }
    function getFirstThursdayOfYear(year) {
        // 0 = index of January
        var dayOfWeekOnFirst = new Date(year, 0, 1).getDay();
        // 4 = index of Thursday (+1 to account for 1st = 5)
        // 11 = index of *next* Thursday (+1 account for 1st = 12)
        return new Date(year, 0, (dayOfWeekOnFirst <= 4 ? 5 : 12) - dayOfWeekOnFirst);
    }
    function getThursdayThisWeek(datetime) {
        return new Date(datetime.getFullYear(), datetime.getMonth(), // 4 = index of Thursday
        datetime.getDate() + (4 - datetime.getDay()));
    }
    function weekGetter(size) {
        return function(date) {
            var firstThurs = getFirstThursdayOfYear(date.getFullYear()), thisThurs = getThursdayThisWeek(date);
            var diff = +thisThurs - +firstThurs, result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
            return padNumber(result, size);
        };
    }
    function ampmGetter(date, formats) {
        return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
    }
    function eraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
    }
    function longEraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
    }
    var DATE_FORMATS = {
        yyyy: dateGetter("FullYear", 4, 0, false, true),
        yy: dateGetter("FullYear", 2, 0, true, true),
        y: dateGetter("FullYear", 1, 0, false, true),
        MMMM: dateStrGetter("Month"),
        MMM: dateStrGetter("Month", true),
        MM: dateGetter("Month", 2, 1),
        M: dateGetter("Month", 1, 1),
        LLLL: dateStrGetter("Month", false, true),
        dd: dateGetter("Date", 2),
        d: dateGetter("Date", 1),
        HH: dateGetter("Hours", 2),
        H: dateGetter("Hours", 1),
        hh: dateGetter("Hours", 2, -12),
        h: dateGetter("Hours", 1, -12),
        mm: dateGetter("Minutes", 2),
        m: dateGetter("Minutes", 1),
        ss: dateGetter("Seconds", 2),
        s: dateGetter("Seconds", 1),
        // while ISO 8601 requires fractions to be prefixed with `.` or `,`
        // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
        sss: dateGetter("Milliseconds", 3),
        EEEE: dateStrGetter("Day"),
        EEE: dateStrGetter("Day", true),
        a: ampmGetter,
        Z: timeZoneGetter,
        ww: weekGetter(2),
        w: weekGetter(1),
        G: eraGetter,
        GG: eraGetter,
        GGG: eraGetter,
        GGGG: longEraGetter
    };
    var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/, NUMBER_STRING = /^-?\d+$/;
    /**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */ dateFilter.$inject = [
        "$locale"
    ];
    function dateFilter($locale) {
        var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
        // 1        2       3         4          5          6          7          8  9     10      11
        function jsonStringToDate(string) {
            var match;
            if (match = string.match(R_ISO8601_STR)) {
                var date = new Date(0), tzHour = 0, tzMin = 0, dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear, timeSetter = match[8] ? date.setUTCHours : date.setHours;
                if (match[9]) {
                    tzHour = toInt(match[9] + match[10]);
                    tzMin = toInt(match[9] + match[11]);
                }
                dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
                var h = toInt(match[4] || 0) - tzHour;
                var m = toInt(match[5] || 0) - tzMin;
                var s = toInt(match[6] || 0);
                var ms = Math.round(parseFloat("0." + (match[7] || 0)) * 1000);
                timeSetter.call(date, h, m, s, ms);
                return date;
            }
            return string;
        }
        return function(date, format, timezone) {
            var text = "", parts = [], fn, match;
            format = format || "mediumDate";
            format = $locale.DATETIME_FORMATS[format] || format;
            if (isString(date)) date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
            if (isNumber(date)) date = new Date(date);
            if (!isDate(date) || !isFinite(date.getTime())) return date;
            while(format){
                match = DATE_FORMATS_SPLIT.exec(format);
                if (match) {
                    parts = concat(parts, match, 1);
                    format = parts.pop();
                } else {
                    parts.push(format);
                    format = null;
                }
            }
            var dateTimezoneOffset = date.getTimezoneOffset();
            if (timezone) {
                dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
                date = convertTimezoneToLocal(date, timezone, true);
            }
            forEach(parts, function(value) {
                fn = DATE_FORMATS[value];
                text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === "''" ? "'" : value.replace(/(^'|'$)/g, "").replace(/''/g, "'");
            });
            return text;
        };
    }
    /**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */ function jsonFilter() {
        return function(object, spacing) {
            if (isUndefined(spacing)) spacing = 2;
            return toJson(object, spacing);
        };
    }
    /**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */ var lowercaseFilter = valueFn(lowercase);
    /**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */ var uppercaseFilter = valueFn(uppercase);
    /**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/ function limitToFilter() {
        return function(input, limit, begin) {
            if (Math.abs(Number(limit)) === Infinity) limit = Number(limit);
            else limit = toInt(limit);
            if (isNumberNaN(limit)) return input;
            if (isNumber(input)) input = input.toString();
            if (!isArrayLike(input)) return input;
            begin = !begin || isNaN(begin) ? 0 : toInt(begin);
            begin = begin < 0 ? Math.max(0, input.length + begin) : begin;
            if (limit >= 0) return sliceFn(input, begin, begin + limit);
            else {
                if (begin === 0) return sliceFn(input, limit, input.length);
                else return sliceFn(input, Math.max(0, begin + limit), begin);
            }
        };
    }
    function sliceFn(input, begin, end) {
        if (isString(input)) return input.slice(begin, end);
        return slice.call(input, begin, end);
    }
    /**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */ orderByFilter.$inject = [
        "$parse"
    ];
    function orderByFilter($parse) {
        return function(array, sortPredicate, reverseOrder, compareFn) {
            if (array == null) return array;
            if (!isArrayLike(array)) throw minErr("orderBy")("notarray", "Expected array but received: {0}", array);
            if (!isArray(sortPredicate)) sortPredicate = [
                sortPredicate
            ];
            if (sortPredicate.length === 0) sortPredicate = [
                "+"
            ];
            var predicates = processPredicates(sortPredicate);
            var descending = reverseOrder ? -1 : 1;
            // Define the `compare()` function. Use a default comparator if none is specified.
            var compare = isFunction(compareFn) ? compareFn : defaultCompare;
            // The next three lines are a version of a Swartzian Transform idiom from Perl
            // (sometimes called the Decorate-Sort-Undecorate idiom)
            // See https://en.wikipedia.org/wiki/Schwartzian_transform
            var compareValues = Array.prototype.map.call(array, getComparisonObject);
            compareValues.sort(doComparison);
            array = compareValues.map(function(item) {
                return item.value;
            });
            return array;
            function getComparisonObject(value, index) {
                // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
                // This will be used to keep the sort stable when none of the input predicates can
                // distinguish between two elements.
                return {
                    value: value,
                    tieBreaker: {
                        value: index,
                        type: "number",
                        index: index
                    },
                    predicateValues: predicates.map(function(predicate) {
                        return getPredicateValue(predicate.get(value), index);
                    })
                };
            }
            function doComparison(v1, v2) {
                for(var i = 0, ii = predicates.length; i < ii; i++){
                    var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
                    if (result) return result * predicates[i].descending * descending;
                }
                return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
            }
        };
        function processPredicates(sortPredicates) {
            return sortPredicates.map(function(predicate) {
                var descending = 1, get = identity;
                if (isFunction(predicate)) get = predicate;
                else if (isString(predicate)) {
                    if (predicate.charAt(0) === "+" || predicate.charAt(0) === "-") {
                        descending = predicate.charAt(0) === "-" ? -1 : 1;
                        predicate = predicate.substring(1);
                    }
                    if (predicate !== "") {
                        get = $parse(predicate);
                        if (get.constant) {
                            var key = get();
                            get = function(value) {
                                return value[key];
                            };
                        }
                    }
                }
                return {
                    get: get,
                    descending: descending
                };
            });
        }
        function isPrimitive(value) {
            switch(typeof value){
                case "number":
                /* falls through */ case "boolean":
                /* falls through */ case "string":
                    return true;
                default:
                    return false;
            }
        }
        function objectValue(value) {
            // If `valueOf` is a valid function use that
            if (isFunction(value.valueOf)) {
                value = value.valueOf();
                if (isPrimitive(value)) return value;
            }
            // If `toString` is a valid function and not the one from `Object.prototype` use that
            if (hasCustomToString(value)) {
                value = value.toString();
                if (isPrimitive(value)) return value;
            }
            return value;
        }
        function getPredicateValue(value, index) {
            var type = typeof value;
            if (value === null) type = "null";
            else if (type === "object") value = objectValue(value);
            return {
                value: value,
                type: type,
                index: index
            };
        }
        function defaultCompare(v1, v2) {
            var result = 0;
            var type1 = v1.type;
            var type2 = v2.type;
            if (type1 === type2) {
                var value1 = v1.value;
                var value2 = v2.value;
                if (type1 === "string") {
                    // Compare strings case-insensitively
                    value1 = value1.toLowerCase();
                    value2 = value2.toLowerCase();
                } else if (type1 === "object") {
                    // For basic objects, use the position of the object
                    // in the collection instead of the value
                    if (isObject(value1)) value1 = v1.index;
                    if (isObject(value2)) value2 = v2.index;
                }
                if (value1 !== value2) result = value1 < value2 ? -1 : 1;
            } else result = type1 === "undefined" ? 1 : type2 === "undefined" ? -1 : type1 === "null" ? 1 : type2 === "null" ? -1 : type1 < type2 ? -1 : 1;
            return result;
        }
    }
    function ngDirective(directive) {
        if (isFunction(directive)) directive = {
            link: directive
        };
        directive.restrict = directive.restrict || "AC";
        return valueFn(directive);
    }
    /**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */ var htmlAnchorDirective = valueFn({
        restrict: "E",
        compile: function(element, attr) {
            if (!attr.href && !attr.xlinkHref) return function(scope, element) {
                // If the linked element is not an anchor tag anymore, do nothing
                if (element[0].nodeName.toLowerCase() !== "a") return;
                // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
                var href = toString.call(element.prop("href")) === "[object SVGAnimatedString]" ? "xlink:href" : "href";
                element.on("click", function(event) {
                    // if we have no href url, then don't navigate anywhere.
                    if (!element.attr(href)) event.preventDefault();
                });
            };
        }
    });
    /**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */ /**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */ /**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */ /**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */ var ngAttributeAliasDirectives = {};
    // boolean attrs are evaluated
    forEach(BOOLEAN_ATTR, function(propName, attrName) {
        // binding to multiple is not supported
        if (propName === "multiple") return;
        function defaultLinkFn(scope, element, attr) {
            scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
                attr.$set(attrName, !!value);
            });
        }
        var normalized = directiveNormalize("ng-" + attrName);
        var linkFn = defaultLinkFn;
        if (propName === "checked") linkFn = function(scope, element, attr) {
            // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
            if (attr.ngModel !== attr[normalized]) defaultLinkFn(scope, element, attr);
        };
        ngAttributeAliasDirectives[normalized] = function() {
            return {
                restrict: "A",
                priority: 100,
                link: linkFn
            };
        };
    });
    // aliased input attrs are evaluated
    forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
        ngAttributeAliasDirectives[ngAttr] = function() {
            return {
                priority: 100,
                link: function(scope, element, attr) {
                    //special case ngPattern when a literal regular expression value
                    //is used as the expression (this way we don't have to watch anything).
                    if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) === "/") {
                        var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
                        if (match) {
                            attr.$set("ngPattern", new RegExp(match[1], match[2]));
                            return;
                        }
                    }
                    scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
                        attr.$set(ngAttr, value);
                    });
                }
            };
        };
    });
    // ng-src, ng-srcset, ng-href are interpolated
    forEach([
        "src",
        "srcset",
        "href"
    ], function(attrName) {
        var normalized = directiveNormalize("ng-" + attrName);
        ngAttributeAliasDirectives[normalized] = [
            "$sce",
            function($sce) {
                return {
                    priority: 99,
                    link: function(scope, element, attr) {
                        var propName = attrName, name = attrName;
                        if (attrName === "href" && toString.call(element.prop("href")) === "[object SVGAnimatedString]") {
                            name = "xlinkHref";
                            attr.$attr[name] = "xlink:href";
                            propName = null;
                        }
                        // We need to sanitize the url at least once, in case it is a constant
                        // non-interpolated attribute.
                        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
                        attr.$observe(normalized, function(value) {
                            if (!value) {
                                if (attrName === "href") attr.$set(name, null);
                                return;
                            }
                            attr.$set(name, value);
                            // Support: IE 9-11 only
                            // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
                            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
                            // to set the property as well to achieve the desired effect.
                            // We use attr[attrName] value since $set might have sanitized the url.
                            if (msie && propName) element.prop(propName, attr[name]);
                        });
                    }
                };
            }
        ];
    });
    /* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */ var nullFormCtrl = {
        $addControl: noop,
        $getControls: valueFn([]),
        $$renameControl: nullFormRenameControl,
        $removeControl: noop,
        $setValidity: noop,
        $setDirty: noop,
        $setPristine: noop,
        $setSubmitted: noop,
        $$setSubmitted: noop
    }, PENDING_CLASS = "ng-pending", SUBMITTED_CLASS = "ng-submitted";
    function nullFormRenameControl(control, name) {
        control.$name = name;
    }
    /**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */ //asks for $scope to fool the BC controller module
    FormController.$inject = [
        "$element",
        "$attrs",
        "$scope",
        "$animate",
        "$interpolate"
    ];
    function FormController($element, $attrs, $scope, $animate, $interpolate) {
        this.$$controls = [];
        // init state
        this.$error = {};
        this.$$success = {};
        this.$pending = undefined;
        this.$name = $interpolate($attrs.name || $attrs.ngForm || "")($scope);
        this.$dirty = false;
        this.$pristine = true;
        this.$valid = true;
        this.$invalid = false;
        this.$submitted = false;
        this.$$parentForm = nullFormCtrl;
        this.$$element = $element;
        this.$$animate = $animate;
        setupValidity(this);
    }
    FormController.prototype = {
        /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */ $rollbackViewValue: function() {
            forEach(this.$$controls, function(control) {
                control.$rollbackViewValue();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */ $commitViewValue: function() {
            forEach(this.$$controls, function(control) {
                control.$commitViewValue();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */ $addControl: function(control) {
            // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
            // and not added to the scope.  Now we throw an error.
            assertNotHasOwnProperty(control.$name, "input");
            this.$$controls.push(control);
            if (control.$name) this[control.$name] = control;
            control.$$parentForm = this;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */ $getControls: function() {
            return shallowCopy(this.$$controls);
        },
        // Private API: rename a form control
        $$renameControl: function(control, newName) {
            var oldName = control.$name;
            if (this[oldName] === control) delete this[oldName];
            this[newName] = control;
            control.$name = newName;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */ $removeControl: function(control) {
            if (control.$name && this[control.$name] === control) delete this[control.$name];
            forEach(this.$pending, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            forEach(this.$error, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            forEach(this.$$success, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            arrayRemove(this.$$controls, control);
            control.$$parentForm = nullFormCtrl;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */ $setDirty: function() {
            this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
            this.$$animate.addClass(this.$$element, DIRTY_CLASS);
            this.$dirty = true;
            this.$pristine = false;
            this.$$parentForm.$setDirty();
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */ $setPristine: function() {
            this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + " " + SUBMITTED_CLASS);
            this.$dirty = false;
            this.$pristine = true;
            this.$submitted = false;
            forEach(this.$$controls, function(control) {
                control.$setPristine();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */ $setUntouched: function() {
            forEach(this.$$controls, function(control) {
                control.$setUntouched();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */ $setSubmitted: function() {
            var rootForm = this;
            while(rootForm.$$parentForm && rootForm.$$parentForm !== nullFormCtrl)rootForm = rootForm.$$parentForm;
            rootForm.$$setSubmitted();
        },
        $$setSubmitted: function() {
            this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
            this.$submitted = true;
            forEach(this.$$controls, function(control) {
                if (control.$$setSubmitted) control.$$setSubmitted();
            });
        }
    };
    /**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */ addSetValidityMethod({
        clazz: FormController,
        set: function(object, property, controller) {
            var list = object[property];
            if (!list) object[property] = [
                controller
            ];
            else {
                var index = list.indexOf(controller);
                if (index === -1) list.push(controller);
            }
        },
        unset: function(object, property, controller) {
            var list = object[property];
            if (!list) return;
            arrayRemove(list, controller);
            if (list.length === 0) delete object[property];
        }
    });
    /**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */ /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */ var formDirectiveFactory = function(isNgForm) {
        return [
            "$timeout",
            "$parse",
            function($timeout, $parse) {
                var formDirective = {
                    name: "form",
                    restrict: isNgForm ? "EAC" : "E",
                    require: [
                        "form",
                        "^^?form"
                    ],
                    controller: FormController,
                    compile: function ngFormCompile(formElement, attr) {
                        // Setup initial state of the control
                        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
                        var nameAttr = attr.name ? "name" : isNgForm && attr.ngForm ? "ngForm" : false;
                        return {
                            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
                                var controller = ctrls[0];
                                // if `action` attr is not present on the form, prevent the default action (submission)
                                if (!("action" in attr)) {
                                    // we can't use jq events because if a form is destroyed during submission the default
                                    // action is not prevented. see #1238
                                    //
                                    // IE 9 is not affected because it doesn't fire a submit event and try to do a full
                                    // page reload if the form was destroyed by submission of the form via a click handler
                                    // on a button in the form. Looks like an IE9 specific bug.
                                    var handleFormSubmission = function(event) {
                                        scope.$apply(function() {
                                            controller.$commitViewValue();
                                            controller.$setSubmitted();
                                        });
                                        event.preventDefault();
                                    };
                                    formElement[0].addEventListener("submit", handleFormSubmission);
                                    // unregister the preventDefault listener so that we don't not leak memory but in a
                                    // way that will achieve the prevention of the default action.
                                    formElement.on("$destroy", function() {
                                        $timeout(function() {
                                            formElement[0].removeEventListener("submit", handleFormSubmission);
                                        }, 0, false);
                                    });
                                }
                                var parentFormCtrl = ctrls[1] || controller.$$parentForm;
                                parentFormCtrl.$addControl(controller);
                                var setter = nameAttr ? getSetter(controller.$name) : noop;
                                if (nameAttr) {
                                    setter(scope, controller);
                                    attr.$observe(nameAttr, function(newValue) {
                                        if (controller.$name === newValue) return;
                                        setter(scope, undefined);
                                        controller.$$parentForm.$$renameControl(controller, newValue);
                                        setter = getSetter(controller.$name);
                                        setter(scope, controller);
                                    });
                                }
                                formElement.on("$destroy", function() {
                                    controller.$$parentForm.$removeControl(controller);
                                    setter(scope, undefined);
                                    extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
                                });
                            }
                        };
                    }
                };
                return formDirective;
                function getSetter(expression) {
                    if (expression === "") //create an assignable expression, so forms with an empty name can be renamed later
                    return $parse('this[""]').assign;
                    return $parse(expression).assign || noop;
                }
            }
        ];
    };
    var formDirective = formDirectiveFactory();
    var ngFormDirective = formDirectiveFactory(true);
    // helper methods
    function setupValidity(instance) {
        instance.$$classCache = {};
        instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
    }
    function addSetValidityMethod(context) {
        var clazz = context.clazz, set = context.set, unset = context.unset;
        clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
            if (isUndefined(state)) createAndSet(this, "$pending", validationErrorKey, controller);
            else unsetAndCleanup(this, "$pending", validationErrorKey, controller);
            if (!isBoolean(state)) {
                unset(this.$error, validationErrorKey, controller);
                unset(this.$$success, validationErrorKey, controller);
            } else if (state) {
                unset(this.$error, validationErrorKey, controller);
                set(this.$$success, validationErrorKey, controller);
            } else {
                set(this.$error, validationErrorKey, controller);
                unset(this.$$success, validationErrorKey, controller);
            }
            if (this.$pending) {
                cachedToggleClass(this, PENDING_CLASS, true);
                this.$valid = this.$invalid = undefined;
                toggleValidationCss(this, "", null);
            } else {
                cachedToggleClass(this, PENDING_CLASS, false);
                this.$valid = isObjectEmpty(this.$error);
                this.$invalid = !this.$valid;
                toggleValidationCss(this, "", this.$valid);
            }
            // re-read the state as the set/unset methods could have
            // combined state in this.$error[validationError] (used for forms),
            // where setting/unsetting only increments/decrements the value,
            // and does not replace it.
            var combinedState;
            if (this.$pending && this.$pending[validationErrorKey]) combinedState = undefined;
            else if (this.$error[validationErrorKey]) combinedState = false;
            else if (this.$$success[validationErrorKey]) combinedState = true;
            else combinedState = null;
            toggleValidationCss(this, validationErrorKey, combinedState);
            this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
        };
        function createAndSet(ctrl, name, value, controller) {
            if (!ctrl[name]) ctrl[name] = {};
            set(ctrl[name], value, controller);
        }
        function unsetAndCleanup(ctrl, name, value, controller) {
            if (ctrl[name]) unset(ctrl[name], value, controller);
            if (isObjectEmpty(ctrl[name])) ctrl[name] = undefined;
        }
        function cachedToggleClass(ctrl, className, switchValue) {
            if (switchValue && !ctrl.$$classCache[className]) {
                ctrl.$$animate.addClass(ctrl.$$element, className);
                ctrl.$$classCache[className] = true;
            } else if (!switchValue && ctrl.$$classCache[className]) {
                ctrl.$$animate.removeClass(ctrl.$$element, className);
                ctrl.$$classCache[className] = false;
            }
        }
        function toggleValidationCss(ctrl, validationErrorKey, isValid) {
            validationErrorKey = validationErrorKey ? "-" + snake_case(validationErrorKey, "-") : "";
            cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
            cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
        }
    }
    function isObjectEmpty(obj) {
        if (obj) for(var prop in obj){
            if (obj.hasOwnProperty(prop)) return false;
        }
        return true;
    }
    /* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/ // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
    var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
    // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
    // Note: We are being more lenient, because browsers are too.
    //   1. Scheme
    //   2. Slashes
    //   3. Username
    //   4. Password
    //   5. Hostname
    //   6. Port
    //   7. Path
    //   8. Query
    //   9. Fragment
    //                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
    var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
    // eslint-disable-next-line max-len
    var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
    var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
    var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
    var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
    var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
    var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
    var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
    var PARTIAL_VALIDATION_EVENTS = "keydown wheel mousedown";
    var PARTIAL_VALIDATION_TYPES = createMap();
    forEach("date,datetime-local,month,time,week".split(","), function(type) {
        PARTIAL_VALIDATION_TYPES[type] = true;
    });
    var inputType = {
        /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "text": textInputType,
        /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */ "date": createDateInputType("date", DATE_REGEXP, createDateParser(DATE_REGEXP, [
            "yyyy",
            "MM",
            "dd"
        ]), "yyyy-MM-dd"),
        /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */ "datetime-local": createDateInputType("datetimelocal", DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, [
            "yyyy",
            "MM",
            "dd",
            "HH",
            "mm",
            "ss",
            "sss"
        ]), "yyyy-MM-ddTHH:mm:ss.sss"),
        /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */ "time": createDateInputType("time", TIME_REGEXP, createDateParser(TIME_REGEXP, [
            "HH",
            "mm",
            "ss",
            "sss"
        ]), "HH:mm:ss.sss"),
        /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */ "week": createDateInputType("week", WEEK_REGEXP, weekParser, "yyyy-Www"),
        /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */ "month": createDateInputType("month", MONTH_REGEXP, createDateParser(MONTH_REGEXP, [
            "yyyy",
            "MM"
        ]), "yyyy-MM"),
        /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "number": numberInputType,
        /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "url": urlInputType,
        /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium, which may not fulfill your app's requirements.
   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
   * modify the built-in validators (see the {@link guide/forms Forms guide}).
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "email": emailInputType,
        /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */ "radio": radioInputType,
        /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */ "range": rangeInputType,
        /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */ "checkbox": checkboxInputType,
        "hidden": noop,
        "button": noop,
        "submit": noop,
        "reset": noop,
        "file": noop
    };
    function stringBasedInputType(ctrl) {
        ctrl.$formatters.push(function(value) {
            return ctrl.$isEmpty(value) ? value : value.toString();
        });
    }
    function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
    }
    function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        var type = lowercase(element[0].type);
        // In composition mode, users are still inputting intermediate text buffer,
        // hold the listener until composition is done.
        // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
        if (!$sniffer.android) {
            var composing = false;
            element.on("compositionstart", function() {
                composing = true;
            });
            // Support: IE9+
            element.on("compositionupdate", function(ev) {
                // End composition when ev.data is empty string on 'compositionupdate' event.
                // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
                // instead of 'compositionend'.
                if (isUndefined(ev.data) || ev.data === "") composing = false;
            });
            element.on("compositionend", function() {
                composing = false;
                listener();
            });
        }
        var timeout;
        var listener = function(ev) {
            if (timeout) {
                $browser.defer.cancel(timeout);
                timeout = null;
            }
            if (composing) return;
            var value = element.val(), event = ev && ev.type;
            // By default we will trim the value
            // If the attribute ng-trim exists we will avoid trimming
            // If input type is 'password', the value is never trimmed
            if (type !== "password" && (!attr.ngTrim || attr.ngTrim !== "false")) value = trim(value);
            // If a control is suffering from bad input (due to native validators), browsers discard its
            // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
            // control's value is the same empty value twice in a row.
            if (ctrl.$viewValue !== value || value === "" && ctrl.$$hasNativeValidators) ctrl.$setViewValue(value, event);
        };
        // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
        // input event on backspace, delete or cut
        if ($sniffer.hasEvent("input")) element.on("input", listener);
        else {
            var deferListener = function(ev, input, origValue) {
                if (!timeout) timeout = $browser.defer(function() {
                    timeout = null;
                    if (!input || input.value !== origValue) listener(ev);
                });
            };
            element.on("keydown", /** @this */ function(event) {
                var key = event.keyCode;
                // ignore
                //    command            modifiers                   arrows
                if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;
                deferListener(event, this, this.value);
            });
            // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
            if ($sniffer.hasEvent("paste")) element.on("paste cut drop", deferListener);
        }
        // if user paste into input using mouse on older browser
        // or form autocomplete on newer browser, we need "change" event to catch it
        element.on("change", listener);
        // Some native input types (date-family) have the ability to change validity without
        // firing any input/change events.
        // For these event types, when native validators are present and the browser supports the type,
        // check for validity changes on various DOM events.
        if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
            if (!timeout) {
                var validity = this[VALIDITY_STATE_PROPERTY];
                var origBadInput = validity.badInput;
                var origTypeMismatch = validity.typeMismatch;
                timeout = $browser.defer(function() {
                    timeout = null;
                    if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) listener(ev);
                });
            }
        });
        ctrl.$render = function() {
            // Workaround for Firefox validation #12102.
            var value = ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue;
            if (element.val() !== value) element.val(value);
        };
    }
    function weekParser(isoWeek, existingDate) {
        if (isDate(isoWeek)) return isoWeek;
        if (isString(isoWeek)) {
            WEEK_REGEXP.lastIndex = 0;
            var parts = WEEK_REGEXP.exec(isoWeek);
            if (parts) {
                var year = +parts[1], week = +parts[2], hours = 0, minutes = 0, seconds = 0, milliseconds = 0, firstThurs = getFirstThursdayOfYear(year), addDays = (week - 1) * 7;
                if (existingDate) {
                    hours = existingDate.getHours();
                    minutes = existingDate.getMinutes();
                    seconds = existingDate.getSeconds();
                    milliseconds = existingDate.getMilliseconds();
                }
                return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
            }
        }
        return NaN;
    }
    function createDateParser(regexp, mapping) {
        return function(iso, previousDate) {
            var parts, map;
            if (isDate(iso)) return iso;
            if (isString(iso)) {
                // When a date is JSON'ified to wraps itself inside of an extra
                // set of double quotes. This makes the date parsing code unable
                // to match the date string and parse it as a date.
                if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') iso = iso.substring(1, iso.length - 1);
                if (ISO_DATE_REGEXP.test(iso)) return new Date(iso);
                regexp.lastIndex = 0;
                parts = regexp.exec(iso);
                if (parts) {
                    parts.shift();
                    if (previousDate) map = {
                        yyyy: previousDate.getFullYear(),
                        MM: previousDate.getMonth() + 1,
                        dd: previousDate.getDate(),
                        HH: previousDate.getHours(),
                        mm: previousDate.getMinutes(),
                        ss: previousDate.getSeconds(),
                        sss: previousDate.getMilliseconds() / 1000
                    };
                    else map = {
                        yyyy: 1970,
                        MM: 1,
                        dd: 1,
                        HH: 0,
                        mm: 0,
                        ss: 0,
                        sss: 0
                    };
                    forEach(parts, function(part, index) {
                        if (index < mapping.length) map[mapping[index]] = +part;
                    });
                    var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
                    if (map.yyyy < 100) // In the constructor, 2-digit years map to 1900-1999.
                    // Use `setFullYear()` to set the correct year.
                    date.setFullYear(map.yyyy);
                    return date;
                }
            }
            return NaN;
        };
    }
    function createDateInputType(type, regexp, parseDate, format) {
        return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
            badInputChecker(scope, element, attr, ctrl, type);
            baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
            var isTimeType = type === "time" || type === "datetimelocal";
            var previousDate;
            var previousTimezone;
            ctrl.$parsers.push(function(value) {
                if (ctrl.$isEmpty(value)) return null;
                if (regexp.test(value)) // Note: We cannot read ctrl.$modelValue, as there might be a different
                // parser/formatter in the processing chain so that the model
                // contains some different data format!
                return parseDateAndConvertTimeZoneToLocal(value, previousDate);
                ctrl.$$parserName = type;
                return undefined;
            });
            ctrl.$formatters.push(function(value) {
                if (value && !isDate(value)) throw ngModelMinErr("datefmt", "Expected `{0}` to be a date", value);
                if (isValidDate(value)) {
                    previousDate = value;
                    var timezone = ctrl.$options.getOption("timezone");
                    if (timezone) {
                        previousTimezone = timezone;
                        previousDate = convertTimezoneToLocal(previousDate, timezone, true);
                    }
                    return formatter(value, timezone);
                } else {
                    previousDate = null;
                    previousTimezone = null;
                    return "";
                }
            });
            if (isDefined(attr.min) || attr.ngMin) {
                var minVal = attr.min || $parse(attr.ngMin)(scope);
                var parsedMinVal = parseObservedDateValue(minVal);
                ctrl.$validators.min = function(value) {
                    return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
                };
                attr.$observe("min", function(val) {
                    if (val !== minVal) {
                        parsedMinVal = parseObservedDateValue(val);
                        minVal = val;
                        ctrl.$validate();
                    }
                });
            }
            if (isDefined(attr.max) || attr.ngMax) {
                var maxVal = attr.max || $parse(attr.ngMax)(scope);
                var parsedMaxVal = parseObservedDateValue(maxVal);
                ctrl.$validators.max = function(value) {
                    return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
                };
                attr.$observe("max", function(val) {
                    if (val !== maxVal) {
                        parsedMaxVal = parseObservedDateValue(val);
                        maxVal = val;
                        ctrl.$validate();
                    }
                });
            }
            function isValidDate(value) {
                // Invalid Date: getTime() returns NaN
                return value && !(value.getTime && value.getTime() !== value.getTime());
            }
            function parseObservedDateValue(val) {
                return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
            }
            function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
                var timezone = ctrl.$options.getOption("timezone");
                if (previousTimezone && previousTimezone !== timezone) // If the timezone has changed, adjust the previousDate to the default timezone
                // so that the new date is converted with the correct timezone offset
                previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
                var parsedDate = parseDate(value, previousDate);
                if (!isNaN(parsedDate) && timezone) parsedDate = convertTimezoneToLocal(parsedDate, timezone);
                return parsedDate;
            }
            function formatter(value, timezone) {
                var targetFormat = format;
                if (isTimeType && isString(ctrl.$options.getOption("timeSecondsFormat"))) targetFormat = format.replace("ss.sss", ctrl.$options.getOption("timeSecondsFormat")).replace(/:$/, "");
                var formatted = $filter("date")(value, targetFormat, timezone);
                if (isTimeType && ctrl.$options.getOption("timeStripZeroSeconds")) formatted = formatted.replace(/(?::00)?(?:\.000)?$/, "");
                return formatted;
            }
        };
    }
    function badInputChecker(scope, element, attr, ctrl, parserName) {
        var node = element[0];
        var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
        if (nativeValidation) ctrl.$parsers.push(function(value) {
            var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
            if (validity.badInput || validity.typeMismatch) {
                ctrl.$$parserName = parserName;
                return undefined;
            }
            return value;
        });
    }
    function numberFormatterParser(ctrl) {
        ctrl.$parsers.push(function(value) {
            if (ctrl.$isEmpty(value)) return null;
            if (NUMBER_REGEXP.test(value)) return parseFloat(value);
            ctrl.$$parserName = "number";
            return undefined;
        });
        ctrl.$formatters.push(function(value) {
            if (!ctrl.$isEmpty(value)) {
                if (!isNumber(value)) throw ngModelMinErr("numfmt", "Expected `{0}` to be a number", value);
                value = value.toString();
            }
            return value;
        });
    }
    function parseNumberAttrVal(val) {
        if (isDefined(val) && !isNumber(val)) val = parseFloat(val);
        return !isNumberNaN(val) ? val : undefined;
    }
    function isNumberInteger(num) {
        // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
        // (minus the assumption that `num` is a number)
        // eslint-disable-next-line no-bitwise
        return (num | 0) === num;
    }
    function countDecimals(num) {
        var numString = num.toString();
        var decimalSymbolIndex = numString.indexOf(".");
        if (decimalSymbolIndex === -1) {
            if (-1 < num && num < 1) {
                // It may be in the exponential notation format (`1e-X`)
                var match = /e-(\d+)$/.exec(numString);
                if (match) return Number(match[1]);
            }
            return 0;
        }
        return numString.length - decimalSymbolIndex - 1;
    }
    function isValidForStep(viewValue, stepBase, step) {
        // At this point `stepBase` and `step` are expected to be non-NaN values
        // and `viewValue` is expected to be a valid stringified number.
        var value = Number(viewValue);
        var isNonIntegerValue = !isNumberInteger(value);
        var isNonIntegerStepBase = !isNumberInteger(stepBase);
        var isNonIntegerStep = !isNumberInteger(step);
        // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
        // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
        if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
            var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
            var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
            var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
            var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
            var multiplier = Math.pow(10, decimalCount);
            value = value * multiplier;
            stepBase = stepBase * multiplier;
            step = step * multiplier;
            if (isNonIntegerValue) value = Math.round(value);
            if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
            if (isNonIntegerStep) step = Math.round(step);
        }
        return (value - stepBase) % step === 0;
    }
    function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        badInputChecker(scope, element, attr, ctrl, "number");
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var parsedMinVal;
        if (isDefined(attr.min) || attr.ngMin) {
            var minVal = attr.min || $parse(attr.ngMin)(scope);
            parsedMinVal = parseNumberAttrVal(minVal);
            ctrl.$validators.min = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
            };
            attr.$observe("min", function(val) {
                if (val !== minVal) {
                    parsedMinVal = parseNumberAttrVal(val);
                    minVal = val;
                    // TODO(matsko): implement validateLater to reduce number of validations
                    ctrl.$validate();
                }
            });
        }
        if (isDefined(attr.max) || attr.ngMax) {
            var maxVal = attr.max || $parse(attr.ngMax)(scope);
            var parsedMaxVal = parseNumberAttrVal(maxVal);
            ctrl.$validators.max = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
            };
            attr.$observe("max", function(val) {
                if (val !== maxVal) {
                    parsedMaxVal = parseNumberAttrVal(val);
                    maxVal = val;
                    // TODO(matsko): implement validateLater to reduce number of validations
                    ctrl.$validate();
                }
            });
        }
        if (isDefined(attr.step) || attr.ngStep) {
            var stepVal = attr.step || $parse(attr.ngStep)(scope);
            var parsedStepVal = parseNumberAttrVal(stepVal);
            ctrl.$validators.step = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) || isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
            };
            attr.$observe("step", function(val) {
                // TODO(matsko): implement validateLater to reduce number of validations
                if (val !== stepVal) {
                    parsedStepVal = parseNumberAttrVal(val);
                    stepVal = val;
                    ctrl.$validate();
                }
            });
        }
    }
    function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        badInputChecker(scope, element, attr, ctrl, "range");
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var supportsRange = ctrl.$$hasNativeValidators && element[0].type === "range", minVal = supportsRange ? 0 : undefined, maxVal = supportsRange ? 100 : undefined, stepVal = supportsRange ? 1 : undefined, validity = element[0].validity, hasMinAttr = isDefined(attr.min), hasMaxAttr = isDefined(attr.max), hasStepAttr = isDefined(attr.step);
        var originalRender = ctrl.$render;
        ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ? //Browsers that implement range will set these values automatically, but reading the adjusted values after
        //$render would cause the min / max validators to be applied with the wrong value
        function rangeRender() {
            originalRender();
            ctrl.$setViewValue(element.val());
        } : originalRender;
        if (hasMinAttr) {
            minVal = parseNumberAttrVal(attr.min);
            ctrl.$validators.min = supportsRange ? // Since all browsers set the input to a valid value, we don't need to check validity
            function noopMinValidator() {
                return true;
            } : // non-support browsers validate the min val
            function minValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
            };
            setInitialValueAndObserver("min", minChange);
        }
        if (hasMaxAttr) {
            maxVal = parseNumberAttrVal(attr.max);
            ctrl.$validators.max = supportsRange ? // Since all browsers set the input to a valid value, we don't need to check validity
            function noopMaxValidator() {
                return true;
            } : // non-support browsers validate the max val
            function maxValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
            };
            setInitialValueAndObserver("max", maxChange);
        }
        if (hasStepAttr) {
            stepVal = parseNumberAttrVal(attr.step);
            ctrl.$validators.step = supportsRange ? function nativeStepValidator() {
                // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
                // input element value to a valid value). It's possible that other browsers set the stepMismatch
                // validity error instead, so we can at least report an error in that case.
                return !validity.stepMismatch;
            } : // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
            function stepValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
            };
            setInitialValueAndObserver("step", stepChange);
        }
        function setInitialValueAndObserver(htmlAttrName, changeFn) {
            // interpolated attributes set the attribute value only after a digest, but we need the
            // attribute value when the input is first rendered, so that the browser can adjust the
            // input value based on the min/max value
            element.attr(htmlAttrName, attr[htmlAttrName]);
            var oldVal = attr[htmlAttrName];
            attr.$observe(htmlAttrName, function wrappedObserver(val) {
                if (val !== oldVal) {
                    oldVal = val;
                    changeFn(val);
                }
            });
        }
        function minChange(val) {
            minVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            if (supportsRange) {
                var elVal = element.val();
                // IE11 doesn't set the el val correctly if the minVal is greater than the element value
                if (minVal > elVal) {
                    elVal = minVal;
                    element.val(elVal);
                }
                ctrl.$setViewValue(elVal);
            } else // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
        }
        function maxChange(val) {
            maxVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            if (supportsRange) {
                var elVal = element.val();
                // IE11 doesn't set the el val correctly if the maxVal is less than the element value
                if (maxVal < elVal) {
                    element.val(maxVal);
                    // IE11 and Chrome don't set the value to the minVal when max < min
                    elVal = maxVal < minVal ? minVal : maxVal;
                }
                ctrl.$setViewValue(elVal);
            } else // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
        }
        function stepChange(val) {
            stepVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            // Some browsers don't adjust the input value correctly, but set the stepMismatch error
            if (!supportsRange) // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
            else if (ctrl.$viewValue !== element.val()) ctrl.$setViewValue(element.val());
        }
    }
    function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$validators.url = function(modelValue, viewValue) {
            var value = modelValue || viewValue;
            return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
        };
    }
    function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$validators.email = function(modelValue, viewValue) {
            var value = modelValue || viewValue;
            return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
        };
    }
    function radioInputType(scope, element, attr, ctrl) {
        var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== "false";
        // make the name unique, if not defined
        if (isUndefined(attr.name)) element.attr("name", nextUid());
        var listener = function(ev) {
            var value;
            if (element[0].checked) {
                value = attr.value;
                if (doTrim) value = trim(value);
                ctrl.$setViewValue(value, ev && ev.type);
            }
        };
        element.on("change", listener);
        ctrl.$render = function() {
            var value = attr.value;
            if (doTrim) value = trim(value);
            element[0].checked = value === ctrl.$viewValue;
        };
        attr.$observe("value", ctrl.$render);
    }
    function parseConstantExpr($parse, context, name, expression, fallback) {
        var parseFn;
        if (isDefined(expression)) {
            parseFn = $parse(expression);
            if (!parseFn.constant) throw ngModelMinErr("constexpr", "Expected constant expression for `{0}`, but saw `{1}`.", name, expression);
            return parseFn(context);
        }
        return fallback;
    }
    function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        var trueValue = parseConstantExpr($parse, scope, "ngTrueValue", attr.ngTrueValue, true);
        var falseValue = parseConstantExpr($parse, scope, "ngFalseValue", attr.ngFalseValue, false);
        var listener = function(ev) {
            ctrl.$setViewValue(element[0].checked, ev && ev.type);
        };
        element.on("change", listener);
        ctrl.$render = function() {
            element[0].checked = ctrl.$viewValue;
        };
        // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
        // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
        // it to a boolean.
        ctrl.$isEmpty = function(value) {
            return value === false;
        };
        ctrl.$formatters.push(function(value) {
            return equals(value, trueValue);
        });
        ctrl.$parsers.push(function(value) {
            return value ? trueValue : falseValue;
        });
    }
    /**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */ /**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */ var inputDirective = [
        "$browser",
        "$sniffer",
        "$filter",
        "$parse",
        function($browser, $sniffer, $filter, $parse) {
            return {
                restrict: "E",
                require: [
                    "?ngModel"
                ],
                link: {
                    pre: function(scope, element, attr, ctrls) {
                        if (ctrls[0]) (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
                    }
                }
            };
        }
    ];
    var hiddenInputBrowserCacheDirective = function() {
        var valueProperty = {
            configurable: true,
            enumerable: false,
            get: function() {
                return this.getAttribute("value") || "";
            },
            set: function(val) {
                this.setAttribute("value", val);
            }
        };
        return {
            restrict: "E",
            priority: 200,
            compile: function(_, attr) {
                if (lowercase(attr.type) !== "hidden") return;
                return {
                    pre: function(scope, element, attr, ctrls) {
                        var node = element[0];
                        // Support: Edge
                        // Moving the DOM around prevents autofillling
                        if (node.parentNode) node.parentNode.insertBefore(node, node.nextSibling);
                        // Support: FF, IE
                        // Avoiding direct assignment to .value prevents autofillling
                        if (Object.defineProperty) Object.defineProperty(node, "value", valueProperty);
                    }
                };
            }
        };
    };
    var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
    /**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */ var ngValueDirective = function() {
        /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */ function updateElementValue(element, attr, value) {
            // Support: IE9 only
            // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
            var propValue = isDefined(value) ? value : msie === 9 ? "" : null;
            element.prop("value", propValue);
            attr.$set("value", value);
        }
        return {
            restrict: "A",
            priority: 100,
            compile: function(tpl, tplAttr) {
                if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) return function ngValueConstantLink(scope, elm, attr) {
                    var value = scope.$eval(attr.ngValue);
                    updateElementValue(elm, attr, value);
                };
                else return function ngValueLink(scope, elm, attr) {
                    scope.$watch(attr.ngValue, function valueWatchAction(value) {
                        updateElementValue(elm, attr, value);
                    });
                };
            }
        };
    };
    /**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */ var ngBindDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "AC",
                compile: function ngBindCompile(templateElement) {
                    $compile.$$addBindingClass(templateElement);
                    return function ngBindLink(scope, element, attr) {
                        $compile.$$addBindingInfo(element, attr.ngBind);
                        element = element[0];
                        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
                            element.textContent = stringify(value);
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */ var ngBindTemplateDirective = [
        "$interpolate",
        "$compile",
        function($interpolate, $compile) {
            return {
                compile: function ngBindTemplateCompile(templateElement) {
                    $compile.$$addBindingClass(templateElement);
                    return function ngBindTemplateLink(scope, element, attr) {
                        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
                        $compile.$$addBindingInfo(element, interpolateFn.expressions);
                        element = element[0];
                        attr.$observe("ngBindTemplate", function(value) {
                            element.textContent = isUndefined(value) ? "" : value;
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */ var ngBindHtmlDirective = [
        "$sce",
        "$parse",
        "$compile",
        function($sce, $parse, $compile) {
            return {
                restrict: "A",
                compile: function ngBindHtmlCompile(tElement, tAttrs) {
                    var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
                    var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
                        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
                        return $sce.valueOf(val);
                    });
                    $compile.$$addBindingClass(tElement);
                    return function ngBindHtmlLink(scope, element, attr) {
                        $compile.$$addBindingInfo(element, attr.ngBindHtml);
                        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
                            // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
                            var value = ngBindHtmlGetter(scope);
                            element.html($sce.getTrustedHtml(value) || "");
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */ var ngChangeDirective = valueFn({
        restrict: "A",
        require: "ngModel",
        link: function(scope, element, attr, ctrl) {
            ctrl.$viewChangeListeners.push(function() {
                scope.$eval(attr.ngChange);
            });
        }
    });
    /* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/ function classDirective(name, selector) {
        name = "ngClass" + name;
        var indexWatchExpression;
        return [
            "$parse",
            function($parse) {
                return {
                    restrict: "AC",
                    link: function(scope, element, attr) {
                        var classCounts = element.data("$classCounts");
                        var oldModulo = true;
                        var oldClassString;
                        if (!classCounts) {
                            // Use createMap() to prevent class assumptions involving property
                            // names in Object.prototype
                            classCounts = createMap();
                            element.data("$classCounts", classCounts);
                        }
                        if (name !== "ngClass") {
                            if (!indexWatchExpression) indexWatchExpression = $parse("$index", function moduloTwo($index) {
                                // eslint-disable-next-line no-bitwise
                                return $index & 1;
                            });
                            scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
                        }
                        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
                        function addClasses(classString) {
                            classString = digestClassCounts(split(classString), 1);
                            attr.$addClass(classString);
                        }
                        function removeClasses(classString) {
                            classString = digestClassCounts(split(classString), -1);
                            attr.$removeClass(classString);
                        }
                        function updateClasses(oldClassString, newClassString) {
                            var oldClassArray = split(oldClassString);
                            var newClassArray = split(newClassString);
                            var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
                            var toAddArray = arrayDifference(newClassArray, oldClassArray);
                            var toRemoveString = digestClassCounts(toRemoveArray, -1);
                            var toAddString = digestClassCounts(toAddArray, 1);
                            attr.$addClass(toAddString);
                            attr.$removeClass(toRemoveString);
                        }
                        function digestClassCounts(classArray, count) {
                            var classesToUpdate = [];
                            forEach(classArray, function(className) {
                                if (count > 0 || classCounts[className]) {
                                    classCounts[className] = (classCounts[className] || 0) + count;
                                    if (classCounts[className] === +(count > 0)) classesToUpdate.push(className);
                                }
                            });
                            return classesToUpdate.join(" ");
                        }
                        function ngClassIndexWatchAction(newModulo) {
                            // This watch-action should run before the `ngClassWatchAction()`, thus it
                            // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
                            // `ngClassWatchAction()` will update the classes.
                            if (newModulo === selector) addClasses(oldClassString);
                            else removeClasses(oldClassString);
                            oldModulo = newModulo;
                        }
                        function ngClassWatchAction(newClassString) {
                            if (oldModulo === selector) updateClasses(oldClassString, newClassString);
                            oldClassString = newClassString;
                        }
                    }
                };
            }
        ];
        // Helpers
        function arrayDifference(tokens1, tokens2) {
            if (!tokens1 || !tokens1.length) return [];
            if (!tokens2 || !tokens2.length) return tokens1;
            var values = [];
            outer: for(var i = 0; i < tokens1.length; i++){
                var token = tokens1[i];
                for(var j = 0; j < tokens2.length; j++){
                    if (token === tokens2[j]) continue outer;
                }
                values.push(token);
            }
            return values;
        }
        function split(classString) {
            return classString && classString.split(" ");
        }
        function toClassString(classValue) {
            if (!classValue) return classValue;
            var classString = classValue;
            if (isArray(classValue)) classString = classValue.map(toClassString).join(" ");
            else if (isObject(classValue)) classString = Object.keys(classValue).filter(function(key) {
                return classValue[key];
            }).join(" ");
            else if (!isString(classValue)) classString = classValue + "";
            return classString;
        }
    }
    /**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */ var ngClassDirective = classDirective("", true);
    /**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */ var ngClassOddDirective = classDirective("Odd", 0);
    /**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */ var ngClassEvenDirective = classDirective("Even", 1);
    /**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */ var ngCloakDirective = ngDirective({
        compile: function(element, attr) {
            attr.$set("ngCloak", undefined);
            element.removeClass("ng-cloak");
        }
    });
    /**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */ var ngControllerDirective = [
        function() {
            return {
                restrict: "A",
                scope: true,
                controller: "@",
                priority: 500
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */ // `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
    // we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
    // fn that looks for the `ng-csp` attribute anywhere in the current doc.
    /**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */ /*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */ var ngEventDirectives = {};
    // For events that might fire synchronously during DOM manipulation
    // we need to execute their event handlers asynchronously using $evalAsync,
    // so that they are not executed in an inconsistent state.
    var forceAsyncEvents = {
        "blur": true,
        "focus": true
    };
    forEach("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "), function(eventName) {
        var directiveName = directiveNormalize("ng-" + eventName);
        ngEventDirectives[directiveName] = [
            "$parse",
            "$rootScope",
            "$exceptionHandler",
            function($parse, $rootScope, $exceptionHandler) {
                return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
            }
        ];
    });
    function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
        return {
            restrict: "A",
            compile: function($element, attr) {
                // NOTE:
                // We expose the powerful `$event` object on the scope that provides access to the Window,
                // etc. This is OK, because expressions are not sandboxed any more (and the expression
                // sandbox was never meant to be a security feature anyway).
                var fn = $parse(attr[directiveName]);
                return function ngEventHandler(scope, element) {
                    element.on(eventName, function(event) {
                        var callback = function() {
                            fn(scope, {
                                $event: event
                            });
                        };
                        if (!$rootScope.$$phase) scope.$apply(callback);
                        else if (forceAsync) scope.$evalAsync(callback);
                        else try {
                            callback();
                        } catch (error) {
                            $exceptionHandler(error);
                        }
                    });
                };
            }
        };
    }
    /**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */ /**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */ /**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */ var ngIfDirective = [
        "$animate",
        "$compile",
        function($animate, $compile) {
            return {
                multiElement: true,
                transclude: "element",
                priority: 600,
                terminal: true,
                restrict: "A",
                $$tlb: true,
                link: function($scope, $element, $attr, ctrl, $transclude) {
                    var block, childScope, previousElements;
                    $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
                        if (value) {
                            if (!childScope) $transclude(function(clone, newScope) {
                                childScope = newScope;
                                clone[clone.length++] = $compile.$$createComment("end ngIf", $attr.ngIf);
                                // Note: We only need the first/last node of the cloned nodes.
                                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                                // by a directive with templateUrl when its template arrives.
                                block = {
                                    clone: clone
                                };
                                $animate.enter(clone, $element.parent(), $element);
                            });
                        } else {
                            if (previousElements) {
                                previousElements.remove();
                                previousElements = null;
                            }
                            if (childScope) {
                                childScope.$destroy();
                                childScope = null;
                            }
                            if (block) {
                                previousElements = getBlockNodes(block.clone);
                                $animate.leave(previousElements).done(function(response) {
                                    if (response !== false) previousElements = null;
                                });
                                block = null;
                            }
                        }
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ var ngIncludeDirective = [
        "$templateRequest",
        "$anchorScroll",
        "$animate",
        function($templateRequest, $anchorScroll, $animate) {
            return {
                restrict: "ECA",
                priority: 400,
                terminal: true,
                transclude: "element",
                controller: angular.noop,
                compile: function(element, attr) {
                    var srcExp = attr.ngInclude || attr.src, onloadExp = attr.onload || "", autoScrollExp = attr.autoscroll;
                    return function(scope, $element, $attr, ctrl, $transclude) {
                        var changeCounter = 0, currentScope, previousElement, currentElement;
                        var cleanupLastIncludeContent = function() {
                            if (previousElement) {
                                previousElement.remove();
                                previousElement = null;
                            }
                            if (currentScope) {
                                currentScope.$destroy();
                                currentScope = null;
                            }
                            if (currentElement) {
                                $animate.leave(currentElement).done(function(response) {
                                    if (response !== false) previousElement = null;
                                });
                                previousElement = currentElement;
                                currentElement = null;
                            }
                        };
                        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
                            var afterAnimation = function(response) {
                                if (response !== false && isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) $anchorScroll();
                            };
                            var thisChangeId = ++changeCounter;
                            if (src) {
                                //set the 2nd param to true to ignore the template request error so that the inner
                                //contents and scope can be cleaned up.
                                $templateRequest(src, true).then(function(response) {
                                    if (scope.$$destroyed) return;
                                    if (thisChangeId !== changeCounter) return;
                                    var newScope = scope.$new();
                                    ctrl.template = response;
                                    // Note: This will also link all children of ng-include that were contained in the original
                                    // html. If that content contains controllers, ... they could pollute/change the scope.
                                    // However, using ng-include on an element with additional content does not make sense...
                                    // Note: We can't remove them in the cloneAttchFn of $transclude as that
                                    // function is called before linking the content, which would apply child
                                    // directives to non existing elements.
                                    var clone = $transclude(newScope, function(clone) {
                                        cleanupLastIncludeContent();
                                        $animate.enter(clone, null, $element).done(afterAnimation);
                                    });
                                    currentScope = newScope;
                                    currentElement = clone;
                                    currentScope.$emit("$includeContentLoaded", src);
                                    scope.$eval(onloadExp);
                                }, function() {
                                    if (scope.$$destroyed) return;
                                    if (thisChangeId === changeCounter) {
                                        cleanupLastIncludeContent();
                                        scope.$emit("$includeContentError", src);
                                    }
                                });
                                scope.$emit("$includeContentRequested", src);
                            } else {
                                cleanupLastIncludeContent();
                                ctrl.template = null;
                            }
                        });
                    };
                }
            };
        }
    ];
    // This directive is called during the $transclude call of the first `ngInclude` directive.
    // It will replace and compile the content of the element with the loaded template.
    // We need this directive so that the element content is already filled when
    // the link function of another directive on the same element as ngInclude
    // is called.
    var ngIncludeFillContentDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "ECA",
                priority: -400,
                require: "ngInclude",
                link: function(scope, $element, $attr, ctrl) {
                    if (toString.call($element[0]).match(/SVG/)) {
                        // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
                        // support innerHTML, so detect this here and try to generate the contents
                        // specially.
                        $element.empty();
                        $compile(jqLiteBuildFragment(ctrl.template, window1.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
                            $element.append(clone);
                        }, {
                            futureParentElement: $element
                        });
                        return;
                    }
                    $element.html(ctrl.template);
                    $compile($element.contents())(scope);
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */ var ngInitDirective = ngDirective({
        priority: 450,
        compile: function() {
            return {
                pre: function(scope, element, attrs) {
                    scope.$eval(attrs.ngInit);
                }
            };
        }
    });
    /**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */ var ngListDirective = function() {
        return {
            restrict: "A",
            priority: 100,
            require: "ngModel",
            link: function(scope, element, attr, ctrl) {
                var ngList = attr.ngList || ", ";
                var trimValues = attr.ngTrim !== "false";
                var separator = trimValues ? trim(ngList) : ngList;
                var parse = function(viewValue) {
                    // If the viewValue is invalid (say required but empty) it will be `undefined`
                    if (isUndefined(viewValue)) return;
                    var list = [];
                    if (viewValue) forEach(viewValue.split(separator), function(value) {
                        if (value) list.push(trimValues ? trim(value) : value);
                    });
                    return list;
                };
                ctrl.$parsers.push(parse);
                ctrl.$formatters.push(function(value) {
                    if (isArray(value)) return value.join(ngList);
                    return undefined;
                });
                // Override the standard $isEmpty because an empty array means the input is empty.
                ctrl.$isEmpty = function(value) {
                    return !value || !value.length;
                };
            }
        };
    };
    /* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/ var VALID_CLASS = "ng-valid", INVALID_CLASS = "ng-invalid", PRISTINE_CLASS = "ng-pristine", DIRTY_CLASS = "ng-dirty", UNTOUCHED_CLASS = "ng-untouched", TOUCHED_CLASS = "ng-touched", EMPTY_CLASS = "ng-empty", NOT_EMPTY_CLASS = "ng-not-empty";
    var ngModelMinErr = minErr("ngModel");
    /**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */ NgModelController.$inject = [
        "$scope",
        "$exceptionHandler",
        "$attrs",
        "$element",
        "$parse",
        "$animate",
        "$timeout",
        "$q",
        "$interpolate"
    ];
    function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
        this.$viewValue = Number.NaN;
        this.$modelValue = Number.NaN;
        this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
        this.$validators = {};
        this.$asyncValidators = {};
        this.$parsers = [];
        this.$formatters = [];
        this.$viewChangeListeners = [];
        this.$untouched = true;
        this.$touched = false;
        this.$pristine = true;
        this.$dirty = false;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {}; // keep invalid keys here
        this.$$success = {}; // keep valid keys here
        this.$pending = undefined; // keep pending keys here
        this.$name = $interpolate($attr.name || "", false)($scope);
        this.$$parentForm = nullFormCtrl;
        this.$options = defaultModelOptions;
        this.$$updateEvents = "";
        // Attach the correct context to the event handler function for updateOn
        this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
        this.$$parsedNgModel = $parse($attr.ngModel);
        this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
        this.$$ngModelGet = this.$$parsedNgModel;
        this.$$ngModelSet = this.$$parsedNgModelAssign;
        this.$$pendingDebounce = null;
        this.$$parserValid = undefined;
        this.$$parserName = "parse";
        this.$$currentValidationRunId = 0;
        this.$$scope = $scope;
        this.$$rootScope = $scope.$root;
        this.$$attr = $attr;
        this.$$element = $element;
        this.$$animate = $animate;
        this.$$timeout = $timeout;
        this.$$parse = $parse;
        this.$$q = $q;
        this.$$exceptionHandler = $exceptionHandler;
        setupValidity(this);
        setupModelWatcher(this);
    }
    NgModelController.prototype = {
        $$initGetterSetters: function() {
            if (this.$options.getOption("getterSetter")) {
                var invokeModelGetter = this.$$parse(this.$$attr.ngModel + "()"), invokeModelSetter = this.$$parse(this.$$attr.ngModel + "($$$p)");
                this.$$ngModelGet = function($scope) {
                    var modelValue = this.$$parsedNgModel($scope);
                    if (isFunction(modelValue)) modelValue = invokeModelGetter($scope);
                    return modelValue;
                };
                this.$$ngModelSet = function($scope, newValue) {
                    if (isFunction(this.$$parsedNgModel($scope))) invokeModelSetter($scope, {
                        $$$p: newValue
                    });
                    else this.$$parsedNgModelAssign($scope, newValue);
                };
            } else if (!this.$$parsedNgModel.assign) throw ngModelMinErr("nonassign", "Expression '{0}' is non-assignable. Element: {1}", this.$$attr.ngModel, startingTag(this.$$element));
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */ $render: noop,
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */ $isEmpty: function(value) {
            // eslint-disable-next-line no-self-compare
            return isUndefined(value) || value === "" || value === null || value !== value;
        },
        $$updateEmptyClasses: function(value) {
            if (this.$isEmpty(value)) {
                this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
                this.$$animate.addClass(this.$$element, EMPTY_CLASS);
            } else {
                this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
                this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
            }
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */ $setPristine: function() {
            this.$dirty = false;
            this.$pristine = true;
            this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
            this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */ $setDirty: function() {
            this.$dirty = true;
            this.$pristine = false;
            this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
            this.$$animate.addClass(this.$$element, DIRTY_CLASS);
            this.$$parentForm.$setDirty();
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */ $setUntouched: function() {
            this.$touched = false;
            this.$untouched = true;
            this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */ $setTouched: function() {
            this.$touched = true;
            this.$untouched = false;
            this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */ $rollbackViewValue: function() {
            this.$$timeout.cancel(this.$$pendingDebounce);
            this.$viewValue = this.$$lastCommittedViewValue;
            this.$render();
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */ $validate: function() {
            // ignore $validate before model is initialized
            if (isNumberNaN(this.$modelValue)) return;
            var viewValue = this.$$lastCommittedViewValue;
            // Note: we use the $$rawModelValue as $modelValue might have been
            // set to undefined during a view -> model update that found validation
            // errors. We can't parse the view here, since that could change
            // the model although neither viewValue nor the model on the scope changed
            var modelValue = this.$$rawModelValue;
            var prevValid = this.$valid;
            var prevModelValue = this.$modelValue;
            var allowInvalid = this.$options.getOption("allowInvalid");
            var that = this;
            this.$$runValidators(modelValue, viewValue, function(allValid) {
                // If there was no change in validity, don't update the model
                // This prevents changing an invalid modelValue to undefined
                if (!allowInvalid && prevValid !== allValid) {
                    // Note: Don't check this.$valid here, as we could have
                    // external validators (e.g. calculated on the server),
                    // that just call $setValidity and need the model value
                    // to calculate their validity.
                    that.$modelValue = allValid ? modelValue : undefined;
                    if (that.$modelValue !== prevModelValue) that.$$writeModelToScope();
                }
            });
        },
        $$runValidators: function(modelValue, viewValue, doneCallback) {
            this.$$currentValidationRunId++;
            var localValidationRunId = this.$$currentValidationRunId;
            var that = this;
            // check parser error
            if (!processParseErrors()) {
                validationDone(false);
                return;
            }
            if (!processSyncValidators()) {
                validationDone(false);
                return;
            }
            processAsyncValidators();
            function processParseErrors() {
                var errorKey = that.$$parserName;
                if (isUndefined(that.$$parserValid)) setValidity(errorKey, null);
                else {
                    if (!that.$$parserValid) {
                        forEach(that.$validators, function(v, name) {
                            setValidity(name, null);
                        });
                        forEach(that.$asyncValidators, function(v, name) {
                            setValidity(name, null);
                        });
                    }
                    // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
                    setValidity(errorKey, that.$$parserValid);
                    return that.$$parserValid;
                }
                return true;
            }
            function processSyncValidators() {
                var syncValidatorsValid = true;
                forEach(that.$validators, function(validator, name) {
                    var result = Boolean(validator(modelValue, viewValue));
                    syncValidatorsValid = syncValidatorsValid && result;
                    setValidity(name, result);
                });
                if (!syncValidatorsValid) {
                    forEach(that.$asyncValidators, function(v, name) {
                        setValidity(name, null);
                    });
                    return false;
                }
                return true;
            }
            function processAsyncValidators() {
                var validatorPromises = [];
                var allValid = true;
                forEach(that.$asyncValidators, function(validator, name) {
                    var promise = validator(modelValue, viewValue);
                    if (!isPromiseLike(promise)) throw ngModelMinErr("nopromise", "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
                    setValidity(name, undefined);
                    validatorPromises.push(promise.then(function() {
                        setValidity(name, true);
                    }, function() {
                        allValid = false;
                        setValidity(name, false);
                    }));
                });
                if (!validatorPromises.length) validationDone(true);
                else that.$$q.all(validatorPromises).then(function() {
                    validationDone(allValid);
                }, noop);
            }
            function setValidity(name, isValid) {
                if (localValidationRunId === that.$$currentValidationRunId) that.$setValidity(name, isValid);
            }
            function validationDone(allValid) {
                if (localValidationRunId === that.$$currentValidationRunId) doneCallback(allValid);
            }
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */ $commitViewValue: function() {
            var viewValue = this.$viewValue;
            this.$$timeout.cancel(this.$$pendingDebounce);
            // If the view value has not changed then we should just exit, except in the case where there is
            // a native validator on the element. In this case the validation state may have changed even though
            // the viewValue has stayed empty.
            if (this.$$lastCommittedViewValue === viewValue && (viewValue !== "" || !this.$$hasNativeValidators)) return;
            this.$$updateEmptyClasses(viewValue);
            this.$$lastCommittedViewValue = viewValue;
            // change to dirty
            if (this.$pristine) this.$setDirty();
            this.$$parseAndValidate();
        },
        $$parseAndValidate: function() {
            var viewValue = this.$$lastCommittedViewValue;
            var modelValue = viewValue;
            var that = this;
            this.$$parserValid = isUndefined(modelValue) ? undefined : true;
            // Reset any previous parse error
            this.$setValidity(this.$$parserName, null);
            this.$$parserName = "parse";
            if (this.$$parserValid) for(var i = 0; i < this.$parsers.length; i++){
                modelValue = this.$parsers[i](modelValue);
                if (isUndefined(modelValue)) {
                    this.$$parserValid = false;
                    break;
                }
            }
            if (isNumberNaN(this.$modelValue)) // this.$modelValue has not been touched yet...
            this.$modelValue = this.$$ngModelGet(this.$$scope);
            var prevModelValue = this.$modelValue;
            var allowInvalid = this.$options.getOption("allowInvalid");
            this.$$rawModelValue = modelValue;
            if (allowInvalid) {
                this.$modelValue = modelValue;
                writeToModelIfNeeded();
            }
            // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
            // This can happen if e.g. $setViewValue is called from inside a parser
            this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
                if (!allowInvalid) {
                    // Note: Don't check this.$valid here, as we could have
                    // external validators (e.g. calculated on the server),
                    // that just call $setValidity and need the model value
                    // to calculate their validity.
                    that.$modelValue = allValid ? modelValue : undefined;
                    writeToModelIfNeeded();
                }
            });
            function writeToModelIfNeeded() {
                if (that.$modelValue !== prevModelValue) that.$$writeModelToScope();
            }
        },
        $$writeModelToScope: function() {
            this.$$ngModelSet(this.$$scope, this.$modelValue);
            forEach(this.$viewChangeListeners, function(listener) {
                try {
                    listener();
                } catch (e) {
                    // eslint-disable-next-line no-invalid-this
                    this.$$exceptionHandler(e);
                }
            }, this);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */ $setViewValue: function(value, trigger) {
            this.$viewValue = value;
            if (this.$options.getOption("updateOnDefault")) this.$$debounceViewValueCommit(trigger);
        },
        $$debounceViewValueCommit: function(trigger) {
            var debounceDelay = this.$options.getOption("debounce");
            if (isNumber(debounceDelay[trigger])) debounceDelay = debounceDelay[trigger];
            else if (isNumber(debounceDelay["default"]) && this.$options.getOption("updateOn").indexOf(trigger) === -1) debounceDelay = debounceDelay["default"];
            else if (isNumber(debounceDelay["*"])) debounceDelay = debounceDelay["*"];
            this.$$timeout.cancel(this.$$pendingDebounce);
            var that = this;
            if (debounceDelay > 0) this.$$pendingDebounce = this.$$timeout(function() {
                that.$commitViewValue();
            }, debounceDelay);
            else if (this.$$rootScope.$$phase) this.$commitViewValue();
            else this.$$scope.$apply(function() {
                that.$commitViewValue();
            });
        },
        /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */ $overrideModelOptions: function(options) {
            this.$options = this.$options.createChild(options);
            this.$$setUpdateOnEvents();
        },
        /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */ $processModelValue: function() {
            var viewValue = this.$$format();
            if (this.$viewValue !== viewValue) {
                this.$$updateEmptyClasses(viewValue);
                this.$viewValue = this.$$lastCommittedViewValue = viewValue;
                this.$render();
                // It is possible that model and view value have been updated during render
                this.$$runValidators(this.$modelValue, this.$viewValue, noop);
            }
        },
        /**
   * This method is called internally to run the $formatters on the $modelValue
   */ $$format: function() {
            var formatters = this.$formatters, idx = formatters.length;
            var viewValue = this.$modelValue;
            while(idx--)viewValue = formatters[idx](viewValue);
            return viewValue;
        },
        /**
   * This method is called internally when the bound scope value changes.
   */ $$setModelValue: function(modelValue) {
            this.$modelValue = this.$$rawModelValue = modelValue;
            this.$$parserValid = undefined;
            this.$processModelValue();
        },
        $$setUpdateOnEvents: function() {
            if (this.$$updateEvents) this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
            this.$$updateEvents = this.$options.getOption("updateOn");
            if (this.$$updateEvents) this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
        },
        $$updateEventHandler: function(ev) {
            this.$$debounceViewValueCommit(ev && ev.type);
        }
    };
    function setupModelWatcher(ctrl) {
        // model -> value
        // Note: we cannot use a normal scope.$watch as we want to detect the following:
        // 1. scope value is 'a'
        // 2. user enters 'b'
        // 3. ng-change kicks in and reverts scope value to 'a'
        //    -> scope value did not change since the last digest as
        //       ng-change executes in apply phase
        // 4. view should be changed back to 'a'
        ctrl.$$scope.$watch(function ngModelWatch(scope) {
            var modelValue = ctrl.$$ngModelGet(scope);
            // if scope model value and ngModel value are out of sync
            // This cannot be moved to the action function, because it would not catch the
            // case where the model is changed in the ngChange function or the model setter
            if (modelValue !== ctrl.$modelValue && // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
            // eslint-disable-next-line no-self-compare
            (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) ctrl.$$setModelValue(modelValue);
            return modelValue;
        });
    }
    /**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */ addSetValidityMethod({
        clazz: NgModelController,
        set: function(object, property) {
            object[property] = true;
        },
        unset: function(object, property) {
            delete object[property];
        }
    });
    /**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */ var ngModelDirective = [
        "$rootScope",
        function($rootScope) {
            return {
                restrict: "A",
                require: [
                    "ngModel",
                    "^?form",
                    "^?ngModelOptions"
                ],
                controller: NgModelController,
                // Prelink needs to run before any input directive
                // so that we can set the NgModelOptions in NgModelController
                // before anyone else uses it.
                priority: 1,
                compile: function ngModelCompile(element) {
                    // Setup initial state of the control
                    element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
                    return {
                        pre: function ngModelPreLink(scope, element, attr, ctrls) {
                            var modelCtrl = ctrls[0], formCtrl = ctrls[1] || modelCtrl.$$parentForm, optionsCtrl = ctrls[2];
                            if (optionsCtrl) modelCtrl.$options = optionsCtrl.$options;
                            modelCtrl.$$initGetterSetters();
                            // notify others, especially parent forms
                            formCtrl.$addControl(modelCtrl);
                            attr.$observe("name", function(newValue) {
                                if (modelCtrl.$name !== newValue) modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
                            });
                            scope.$on("$destroy", function() {
                                modelCtrl.$$parentForm.$removeControl(modelCtrl);
                            });
                        },
                        post: function ngModelPostLink(scope, element, attr, ctrls) {
                            var modelCtrl = ctrls[0];
                            modelCtrl.$$setUpdateOnEvents();
                            function setTouched() {
                                modelCtrl.$setTouched();
                            }
                            element.on("blur", function() {
                                if (modelCtrl.$touched) return;
                                if ($rootScope.$$phase) scope.$evalAsync(setTouched);
                                else scope.$apply(setTouched);
                            });
                        }
                    };
                }
            };
        }
    ];
    /* exported defaultModelOptions */ var defaultModelOptions;
    var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
    /**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */ function ModelOptions(options) {
        this.$$options = options;
    }
    ModelOptions.prototype = {
        /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */ getOption: function(name) {
            return this.$$options[name];
        },
        /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */ createChild: function(options) {
            var inheritAll = false;
            // make a shallow copy
            options = extend({}, options);
            // Inherit options from the parent if specified by the value `"$inherit"`
            forEach(options, /** @this */ function(option, key) {
                if (option === "$inherit") {
                    if (key === "*") inheritAll = true;
                    else {
                        options[key] = this.$$options[key];
                        // `updateOn` is special so we must also inherit the `updateOnDefault` option
                        if (key === "updateOn") options.updateOnDefault = this.$$options.updateOnDefault;
                    }
                } else if (key === "updateOn") {
                    // If the `updateOn` property contains the `default` event then we have to remove
                    // it from the event list and set the `updateOnDefault` flag.
                    options.updateOnDefault = false;
                    options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
                        options.updateOnDefault = true;
                        return " ";
                    }));
                }
            }, this);
            if (inheritAll) {
                // We have a property of the form: `"*": "$inherit"`
                delete options["*"];
                defaults(options, this.$$options);
            }
            // Finally add in any missing defaults
            defaults(options, defaultModelOptions.$$options);
            return new ModelOptions(options);
        }
    };
    defaultModelOptions = new ModelOptions({
        updateOn: "",
        updateOnDefault: true,
        debounce: 0,
        getterSetter: false,
        allowInvalid: false,
        timezone: null
    });
    /**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */ var ngModelOptionsDirective = function() {
        NgModelOptionsController.$inject = [
            "$attrs",
            "$scope"
        ];
        function NgModelOptionsController($attrs, $scope) {
            this.$$attrs = $attrs;
            this.$$scope = $scope;
        }
        NgModelOptionsController.prototype = {
            $onInit: function() {
                var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
                var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
                this.$options = parentOptions.createChild(modelOptionsDefinition);
            }
        };
        return {
            restrict: "A",
            // ngModelOptions needs to run before ngModel and input directives
            priority: 10,
            require: {
                parentCtrl: "?^^ngModelOptions"
            },
            bindToController: true,
            controller: NgModelOptionsController
        };
    };
    // shallow copy over values from `src` that are not already specified on `dst`
    function defaults(dst, src) {
        forEach(src, function(value, key) {
            if (!isDefined(dst[key])) dst[key] = value;
        });
    }
    /**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */ var ngNonBindableDirective = ngDirective({
        terminal: true,
        priority: 1000
    });
    /* exported ngOptionsDirective */ /* global jqLiteRemove */ var ngOptionsMinErr = minErr("ngOptions");
    /**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */ /* eslint-disable max-len */ //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
    var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
    // 1: value expression (valueFn)
    // 2: label expression (displayFn)
    // 3: group by expression (groupByFn)
    // 4: disable when expression (disableWhenFn)
    // 5: array item variable name
    // 6: object item key variable name
    // 7: object item value variable name
    // 8: collection expression
    // 9: track by expression
    /* eslint-enable */ var ngOptionsDirective = [
        "$compile",
        "$document",
        "$parse",
        function($compile, $document, $parse) {
            function parseOptionsExpression(optionsExp, selectElement, scope) {
                var match = optionsExp.match(NG_OPTIONS_REGEXP);
                if (!match) throw ngOptionsMinErr("iexp", "Expected expression in form of '_select_ (as _label_)? for (_key_,)?_value_ in _collection_' but got '{0}'. Element: {1}", optionsExp, startingTag(selectElement));
                // Extract the parts from the ngOptions expression
                // The variable name for the value of the item in the collection
                var valueName = match[5] || match[7];
                // The variable name for the key of the item in the collection
                var keyName = match[6];
                // An expression that generates the viewValue for an option if there is a label expression
                var selectAs = / as /.test(match[0]) && match[1];
                // An expression that is used to track the id of each object in the options collection
                var trackBy = match[9];
                // An expression that generates the viewValue for an option if there is no label expression
                var valueFn = $parse(match[2] ? match[1] : valueName);
                var selectAsFn = selectAs && $parse(selectAs);
                var viewValueFn = selectAsFn || valueFn;
                var trackByFn = trackBy && $parse(trackBy);
                // Get the value by which we are going to track the option
                // if we have a trackFn then use that (passing scope and locals)
                // otherwise just hash the given viewValue
                var getTrackByValueFn = trackBy ? function(value, locals) {
                    return trackByFn(scope, locals);
                } : function getHashOfValue(value) {
                    return hashKey(value);
                };
                var getTrackByValue = function(value, key) {
                    return getTrackByValueFn(value, getLocals(value, key));
                };
                var displayFn = $parse(match[2] || match[1]);
                var groupByFn = $parse(match[3] || "");
                var disableWhenFn = $parse(match[4] || "");
                var valuesFn = $parse(match[8]);
                var locals = {};
                var getLocals = keyName ? function(value, key) {
                    locals[keyName] = key;
                    locals[valueName] = value;
                    return locals;
                } : function(value) {
                    locals[valueName] = value;
                    return locals;
                };
                function Option(selectValue, viewValue, label, group, disabled) {
                    this.selectValue = selectValue;
                    this.viewValue = viewValue;
                    this.label = label;
                    this.group = group;
                    this.disabled = disabled;
                }
                function getOptionValuesKeys(optionValues) {
                    var optionValuesKeys;
                    if (!keyName && isArrayLike(optionValues)) optionValuesKeys = optionValues;
                    else {
                        // if object, extract keys, in enumeration order, unsorted
                        optionValuesKeys = [];
                        for(var itemKey in optionValues)if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== "$") optionValuesKeys.push(itemKey);
                    }
                    return optionValuesKeys;
                }
                return {
                    trackBy: trackBy,
                    getTrackByValue: getTrackByValue,
                    getWatchables: $parse(valuesFn, function(optionValues) {
                        // Create a collection of things that we would like to watch (watchedArray)
                        // so that they can all be watched using a single $watchCollection
                        // that only runs the handler once if anything changes
                        var watchedArray = [];
                        optionValues = optionValues || [];
                        var optionValuesKeys = getOptionValuesKeys(optionValues);
                        var optionValuesLength = optionValuesKeys.length;
                        for(var index = 0; index < optionValuesLength; index++){
                            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                            var value = optionValues[key];
                            var locals = getLocals(value, key);
                            var selectValue = getTrackByValueFn(value, locals);
                            watchedArray.push(selectValue);
                            // Only need to watch the displayFn if there is a specific label expression
                            if (match[2] || match[1]) {
                                var label = displayFn(scope, locals);
                                watchedArray.push(label);
                            }
                            // Only need to watch the disableWhenFn if there is a specific disable expression
                            if (match[4]) {
                                var disableWhen = disableWhenFn(scope, locals);
                                watchedArray.push(disableWhen);
                            }
                        }
                        return watchedArray;
                    }),
                    getOptions: function() {
                        var optionItems = [];
                        var selectValueMap = {};
                        // The option values were already computed in the `getWatchables` fn,
                        // which must have been called to trigger `getOptions`
                        var optionValues = valuesFn(scope) || [];
                        var optionValuesKeys = getOptionValuesKeys(optionValues);
                        var optionValuesLength = optionValuesKeys.length;
                        for(var index = 0; index < optionValuesLength; index++){
                            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                            var value = optionValues[key];
                            var locals = getLocals(value, key);
                            var viewValue = viewValueFn(scope, locals);
                            var selectValue = getTrackByValueFn(viewValue, locals);
                            var label = displayFn(scope, locals);
                            var group = groupByFn(scope, locals);
                            var disabled = disableWhenFn(scope, locals);
                            var optionItem = new Option(selectValue, viewValue, label, group, disabled);
                            optionItems.push(optionItem);
                            selectValueMap[selectValue] = optionItem;
                        }
                        return {
                            items: optionItems,
                            selectValueMap: selectValueMap,
                            getOptionFromViewValue: function(value) {
                                return selectValueMap[getTrackByValue(value)];
                            },
                            getViewValueFromOption: function(option) {
                                // If the viewValue could be an object that may be mutated by the application,
                                // we need to make a copy and not return the reference to the value on the option.
                                return trackBy ? copy(option.viewValue) : option.viewValue;
                            }
                        };
                    }
                };
            }
            // Support: IE 9 only
            // We can't just jqLite('<option>') since jqLite is not smart enough
            // to create it in <select> and IE barfs otherwise.
            var optionTemplate = window1.document.createElement("option"), optGroupTemplate = window1.document.createElement("optgroup");
            function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
                var selectCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1];
                var multiple = attr.multiple;
                // The emptyOption allows the application developer to provide their own custom "empty"
                // option when the viewValue does not match any of the option values.
                for(var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++)if (children[i].value === "") {
                    selectCtrl.hasEmptyOption = true;
                    selectCtrl.emptyOption = children.eq(i);
                    break;
                }
                // The empty option will be compiled and rendered before we first generate the options
                selectElement.empty();
                var providedEmptyOption = !!selectCtrl.emptyOption;
                var unknownOption = jqLite(optionTemplate.cloneNode(false));
                unknownOption.val("?");
                var options;
                var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
                // This stores the newly created options before they are appended to the select.
                // Since the contents are removed from the fragment when it is appended,
                // we only need to create it once.
                var listFragment = $document[0].createDocumentFragment();
                // Overwrite the implementation. ngOptions doesn't use hashes
                selectCtrl.generateUnknownOptionValue = function(val) {
                    return "?";
                };
                // Update the controller methods for multiple selectable options
                if (!multiple) {
                    selectCtrl.writeValue = function writeNgOptionsValue(value) {
                        // The options might not be defined yet when ngModel tries to render
                        if (!options) return;
                        var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
                        var option = options.getOptionFromViewValue(value);
                        // Make sure to remove the selected attribute from the previously selected option
                        // Otherwise, screen readers might get confused
                        if (selectedOption) selectedOption.removeAttribute("selected");
                        if (option) {
                            // Don't update the option when it is already selected.
                            // For example, the browser will select the first option by default. In that case,
                            // most properties are set automatically - except the `selected` attribute, which we
                            // set always
                            if (selectElement[0].value !== option.selectValue) {
                                selectCtrl.removeUnknownOption();
                                selectElement[0].value = option.selectValue;
                                option.element.selected = true;
                            }
                            option.element.setAttribute("selected", "selected");
                        } else selectCtrl.selectUnknownOrEmptyOption(value);
                    };
                    selectCtrl.readValue = function readNgOptionsValue() {
                        var selectedOption = options.selectValueMap[selectElement.val()];
                        if (selectedOption && !selectedOption.disabled) {
                            selectCtrl.unselectEmptyOption();
                            selectCtrl.removeUnknownOption();
                            return options.getViewValueFromOption(selectedOption);
                        }
                        return null;
                    };
                    // If we are using `track by` then we must watch the tracked value on the model
                    // since ngModel only watches for object identity change
                    // FIXME: When a user selects an option, this watch will fire needlessly
                    if (ngOptions.trackBy) scope.$watch(function() {
                        return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
                    }, function() {
                        ngModelCtrl.$render();
                    });
                } else {
                    selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
                        // The options might not be defined yet when ngModel tries to render
                        if (!options) return;
                        // Only set `<option>.selected` if necessary, in order to prevent some browsers from
                        // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
                        var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
                        options.items.forEach(function(option) {
                            if (option.element.selected && !includes(selectedOptions, option)) option.element.selected = false;
                        });
                    };
                    selectCtrl.readValue = function readNgOptionsMultiple() {
                        var selectedValues = selectElement.val() || [], selections = [];
                        forEach(selectedValues, function(value) {
                            var option = options.selectValueMap[value];
                            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
                        });
                        return selections;
                    };
                    // If we are using `track by` then we must watch these tracked values on the model
                    // since ngModel only watches for object identity change
                    if (ngOptions.trackBy) scope.$watchCollection(function() {
                        if (isArray(ngModelCtrl.$viewValue)) return ngModelCtrl.$viewValue.map(function(value) {
                            return ngOptions.getTrackByValue(value);
                        });
                    }, function() {
                        ngModelCtrl.$render();
                    });
                }
                if (providedEmptyOption) {
                    // compile the element since there might be bindings in it
                    $compile(selectCtrl.emptyOption)(scope);
                    selectElement.prepend(selectCtrl.emptyOption);
                    if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
                        // This means the empty option has currently no actual DOM node, probably because
                        // it has been modified by a transclusion directive.
                        selectCtrl.hasEmptyOption = false;
                        // Redefine the registerOption function, which will catch
                        // options that are added by ngIf etc. (rendering of the node is async because of
                        // lazy transclusion)
                        selectCtrl.registerOption = function(optionScope, optionEl) {
                            if (optionEl.val() === "") {
                                selectCtrl.hasEmptyOption = true;
                                selectCtrl.emptyOption = optionEl;
                                selectCtrl.emptyOption.removeClass("ng-scope");
                                // This ensures the new empty option is selected if previously no option was selected
                                ngModelCtrl.$render();
                                optionEl.on("$destroy", function() {
                                    var needsRerender = selectCtrl.$isEmptyOptionSelected();
                                    selectCtrl.hasEmptyOption = false;
                                    selectCtrl.emptyOption = undefined;
                                    if (needsRerender) ngModelCtrl.$render();
                                });
                            }
                        };
                    } else // remove the class, which is added automatically because we recompile the element and it
                    // becomes the compilation root
                    selectCtrl.emptyOption.removeClass("ng-scope");
                }
                // We will re-render the option elements if the option values or labels change
                scope.$watchCollection(ngOptions.getWatchables, updateOptions);
                // ------------------------------------------------------------------ //
                function addOptionElement(option, parent) {
                    var optionElement = optionTemplate.cloneNode(false);
                    parent.appendChild(optionElement);
                    updateOptionElement(option, optionElement);
                }
                function getAndUpdateSelectedOption(viewValue) {
                    var option = options.getOptionFromViewValue(viewValue);
                    var element = option && option.element;
                    if (element && !element.selected) element.selected = true;
                    return option;
                }
                function updateOptionElement(option, element) {
                    option.element = element;
                    element.disabled = option.disabled;
                    // Support: IE 11 only, Edge 12-13 only
                    // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
                    // selects in certain circumstances when multiple selects are next to each other and display
                    // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
                    // See https://github.com/angular/angular.js/issues/11314 for more info.
                    // This is unfortunately untestable with unit / e2e tests
                    if (option.label !== element.label) {
                        element.label = option.label;
                        element.textContent = option.label;
                    }
                    element.value = option.selectValue;
                }
                function updateOptions() {
                    var previousValue = options && selectCtrl.readValue();
                    // We must remove all current options, but cannot simply set innerHTML = null
                    // since the providedEmptyOption might have an ngIf on it that inserts comments which we
                    // must preserve.
                    // Instead, iterate over the current option elements and remove them or their optgroup
                    // parents
                    if (options) for(var i = options.items.length - 1; i >= 0; i--){
                        var option = options.items[i];
                        if (isDefined(option.group)) jqLiteRemove(option.element.parentNode);
                        else jqLiteRemove(option.element);
                    }
                    options = ngOptions.getOptions();
                    var groupElementMap = {};
                    options.items.forEach(function addOption(option) {
                        var groupElement;
                        if (isDefined(option.group)) {
                            // This option is to live in a group
                            // See if we have already created this group
                            groupElement = groupElementMap[option.group];
                            if (!groupElement) {
                                groupElement = optGroupTemplate.cloneNode(false);
                                listFragment.appendChild(groupElement);
                                // Update the label on the group element
                                // "null" is special cased because of Safari
                                groupElement.label = option.group === null ? "null" : option.group;
                                // Store it for use later
                                groupElementMap[option.group] = groupElement;
                            }
                            addOptionElement(option, groupElement);
                        } else // This option is not in a group
                        addOptionElement(option, listFragment);
                    });
                    selectElement[0].appendChild(listFragment);
                    ngModelCtrl.$render();
                    // Check to see if the value has changed due to the update to the options
                    if (!ngModelCtrl.$isEmpty(previousValue)) {
                        var nextValue = selectCtrl.readValue();
                        var isNotPrimitive = ngOptions.trackBy || multiple;
                        if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
                            ngModelCtrl.$setViewValue(nextValue);
                            ngModelCtrl.$render();
                        }
                    }
                }
            }
            return {
                restrict: "A",
                terminal: true,
                require: [
                    "select",
                    "ngModel"
                ],
                link: {
                    pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
                        // Deactivate the SelectController.register method to prevent
                        // option directives from accidentally registering themselves
                        // (and unwanted $destroy handlers etc.)
                        ctrls[0].registerOption = noop;
                    },
                    post: ngOptionsPostLink
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */ var ngPluralizeDirective = [
        "$locale",
        "$interpolate",
        "$log",
        function($locale, $interpolate, $log) {
            var BRACE = /{}/g, IS_WHEN = /^when(Minus)?(.+)$/;
            return {
                link: function(scope, element, attr) {
                    var numberExp = attr.count, whenExp = attr.$attr.when && element.attr(attr.$attr.when), offset = attr.offset || 0, whens = scope.$eval(whenExp) || {}, whensExpFns = {}, startSymbol = $interpolate.startSymbol(), endSymbol = $interpolate.endSymbol(), braceReplacement = startSymbol + numberExp + "-" + offset + endSymbol, watchRemover = angular.noop, lastCount;
                    forEach(attr, function(expression, attributeName) {
                        var tmpMatch = IS_WHEN.exec(attributeName);
                        if (tmpMatch) {
                            var whenKey = (tmpMatch[1] ? "-" : "") + lowercase(tmpMatch[2]);
                            whens[whenKey] = element.attr(attr.$attr[attributeName]);
                        }
                    });
                    forEach(whens, function(expression, key) {
                        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
                    });
                    scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
                        var count = parseFloat(newVal);
                        var countIsNaN = isNumberNaN(count);
                        if (!countIsNaN && !(count in whens)) // If an explicit number rule such as 1, 2, 3... is defined, just use it.
                        // Otherwise, check it against pluralization rules in $locale service.
                        count = $locale.pluralCat(count - offset);
                        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
                        // In JS `NaN !== NaN`, so we have to explicitly check.
                        if (count !== lastCount && !(countIsNaN && isNumberNaN(lastCount))) {
                            watchRemover();
                            var whenExpFn = whensExpFns[count];
                            if (isUndefined(whenExpFn)) {
                                if (newVal != null) $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
                                watchRemover = noop;
                                updateElementText();
                            } else watchRemover = scope.$watch(whenExpFn, updateElementText);
                            lastCount = count;
                        }
                    });
                    function updateElementText(newText) {
                        element.text(newText || "");
                    }
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */ var ngRefMinErr = minErr("ngRef");
    var ngRefDirective = [
        "$parse",
        function($parse) {
            return {
                priority: -1,
                restrict: "A",
                compile: function(tElement, tAttrs) {
                    // Get the expected controller name, converts <data-some-thing> into "someThing"
                    var controllerName = directiveNormalize(nodeName_(tElement));
                    // Get the expression for value binding
                    var getter = $parse(tAttrs.ngRef);
                    var setter = getter.assign || function() {
                        throw ngRefMinErr("nonassign", 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
                    };
                    return function(scope, element, attrs) {
                        var refValue;
                        if (attrs.hasOwnProperty("ngRefRead")) {
                            if (attrs.ngRefRead === "$element") refValue = element;
                            else {
                                refValue = element.data("$" + attrs.ngRefRead + "Controller");
                                if (!refValue) throw ngRefMinErr("noctrl", 'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"', attrs.ngRefRead, tAttrs.ngRef);
                            }
                        } else refValue = element.data("$" + controllerName + "Controller");
                        refValue = refValue || element;
                        setter(scope, refValue);
                        // when the element is removed, remove it (nullify it)
                        element.on("$destroy", function() {
                            // only remove it if value has not changed,
                            // because animations (and other procedures) may duplicate elements
                            if (getter(scope) === refValue) setter(scope, null);
                        });
                    };
                }
            };
        }
    ];
    /* exported ngRepeatDirective */ /**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */ var ngRepeatDirective = [
        "$parse",
        "$animate",
        "$compile",
        function($parse, $animate, $compile) {
            var NG_REMOVED = "$$NG_REMOVED";
            var ngRepeatMinErr = minErr("ngRepeat");
            var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
                // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
                scope[valueIdentifier] = value;
                if (keyIdentifier) scope[keyIdentifier] = key;
                scope.$index = index;
                scope.$first = index === 0;
                scope.$last = index === arrayLength - 1;
                scope.$middle = !(scope.$first || scope.$last);
                // eslint-disable-next-line no-bitwise
                scope.$odd = !(scope.$even = (index & 1) === 0);
            };
            var getBlockStart = function(block) {
                return block.clone[0];
            };
            var getBlockEnd = function(block) {
                return block.clone[block.clone.length - 1];
            };
            var trackByIdArrayFn = function($scope, key, value) {
                return hashKey(value);
            };
            var trackByIdObjFn = function($scope, key) {
                return key;
            };
            return {
                restrict: "A",
                multiElement: true,
                transclude: "element",
                priority: 1000,
                terminal: true,
                $$tlb: true,
                compile: function ngRepeatCompile($element, $attr) {
                    var expression = $attr.ngRepeat;
                    var ngRepeatEndComment = $compile.$$createComment("end ngRepeat", expression);
                    var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
                    if (!match) throw ngRepeatMinErr("iexp", "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
                    var lhs = match[1];
                    var rhs = match[2];
                    var aliasAs = match[3];
                    var trackByExp = match[4];
                    match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
                    if (!match) throw ngRepeatMinErr("iidexp", "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.", lhs);
                    var valueIdentifier = match[3] || match[1];
                    var keyIdentifier = match[2];
                    if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) throw ngRepeatMinErr("badident", "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.", aliasAs);
                    var trackByIdExpFn;
                    if (trackByExp) {
                        var hashFnLocals = {
                            $id: hashKey
                        };
                        var trackByExpGetter = $parse(trackByExp);
                        trackByIdExpFn = function($scope, key, value, index) {
                            // assign key, value, and $index to the locals so that they can be used in hash functions
                            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
                            hashFnLocals[valueIdentifier] = value;
                            hashFnLocals.$index = index;
                            return trackByExpGetter($scope, hashFnLocals);
                        };
                    }
                    return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
                        // Store a list of elements from previous run. This is a hash where key is the item from the
                        // iterator, and the value is objects with following properties.
                        //   - scope: bound scope
                        //   - clone: previous element.
                        //   - index: position
                        //
                        // We are using no-proto object so that we don't need to guard against inherited props via
                        // hasOwnProperty.
                        var lastBlockMap = createMap();
                        //watch props
                        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
                            var index, length, previousNode = $element[0], // initialized to the comment node anchor
                            nextNode, // Same as lastBlockMap but it has the current state. It will become the
                            // lastBlockMap on the next iteration.
                            nextBlockMap = createMap(), collectionLength, key, value, trackById, trackByIdFn, collectionKeys, block, nextBlockOrder, elementsToRemove;
                            if (aliasAs) $scope[aliasAs] = collection;
                            if (isArrayLike(collection)) {
                                collectionKeys = collection;
                                trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
                            } else {
                                trackByIdFn = trackByIdExpFn || trackByIdObjFn;
                                // if object, extract keys, in enumeration order, unsorted
                                collectionKeys = [];
                                for(var itemKey in collection)if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== "$") collectionKeys.push(itemKey);
                            }
                            collectionLength = collectionKeys.length;
                            nextBlockOrder = new Array(collectionLength);
                            // locate existing items
                            for(index = 0; index < collectionLength; index++){
                                key = collection === collectionKeys ? index : collectionKeys[index];
                                value = collection[key];
                                trackById = trackByIdFn($scope, key, value, index);
                                if (lastBlockMap[trackById]) {
                                    // found previously seen block
                                    block = lastBlockMap[trackById];
                                    delete lastBlockMap[trackById];
                                    nextBlockMap[trackById] = block;
                                    nextBlockOrder[index] = block;
                                } else if (nextBlockMap[trackById]) {
                                    // if collision detected. restore lastBlockMap and throw an error
                                    forEach(nextBlockOrder, function(block) {
                                        if (block && block.scope) lastBlockMap[block.id] = block;
                                    });
                                    throw ngRepeatMinErr("dupes", "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}", expression, trackById, value);
                                } else {
                                    // new never before seen block
                                    nextBlockOrder[index] = {
                                        id: trackById,
                                        scope: undefined,
                                        clone: undefined
                                    };
                                    nextBlockMap[trackById] = true;
                                }
                            }
                            // Clear the value property from the hashFnLocals object to prevent a reference to the last value
                            // being leaked into the ngRepeatCompile function scope
                            if (hashFnLocals) hashFnLocals[valueIdentifier] = undefined;
                            // remove leftover items
                            for(var blockKey in lastBlockMap){
                                block = lastBlockMap[blockKey];
                                elementsToRemove = getBlockNodes(block.clone);
                                $animate.leave(elementsToRemove);
                                if (elementsToRemove[0].parentNode) // if the element was not removed yet because of pending animation, mark it as deleted
                                // so that we can ignore it later
                                for(index = 0, length = elementsToRemove.length; index < length; index++)elementsToRemove[index][NG_REMOVED] = true;
                                block.scope.$destroy();
                            }
                            // we are not using forEach for perf reasons (trying to avoid #call)
                            for(index = 0; index < collectionLength; index++){
                                key = collection === collectionKeys ? index : collectionKeys[index];
                                value = collection[key];
                                block = nextBlockOrder[index];
                                if (block.scope) {
                                    // if we have already seen this object, then we need to reuse the
                                    // associated scope/element
                                    nextNode = previousNode;
                                    // skip nodes that are already pending removal via leave animation
                                    do nextNode = nextNode.nextSibling;
                                    while (nextNode && nextNode[NG_REMOVED]);
                                    if (getBlockStart(block) !== nextNode) // existing item which got moved
                                    $animate.move(getBlockNodes(block.clone), null, previousNode);
                                    previousNode = getBlockEnd(block);
                                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                                } else // new item which we don't know about
                                $transclude(function ngRepeatTransclude(clone, scope) {
                                    block.scope = scope;
                                    // http://jsperf.com/clone-vs-createcomment
                                    var endNode = ngRepeatEndComment.cloneNode(false);
                                    clone[clone.length++] = endNode;
                                    $animate.enter(clone, null, previousNode);
                                    previousNode = endNode;
                                    // Note: We only need the first/last node of the cloned nodes.
                                    // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                                    // by a directive with templateUrl when its template arrives.
                                    block.clone = clone;
                                    nextBlockMap[block.id] = block;
                                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                                });
                            }
                            lastBlockMap = nextBlockMap;
                        });
                    };
                }
            };
        }
    ];
    var NG_HIDE_CLASS = "ng-hide";
    var NG_HIDE_IN_PROGRESS_CLASS = "ng-hide-animate";
    /**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */ var ngShowDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                multiElement: true,
                link: function(scope, element, attr) {
                    scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
                        // we're adding a temporary, animation-specific class for ng-hide since this way
                        // we can control when the element is actually displayed on screen without having
                        // to have a global/greedy CSS selector that breaks when other animations are run.
                        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
                        $animate[value ? "removeClass" : "addClass"](element, NG_HIDE_CLASS, {
                            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */ var ngHideDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                multiElement: true,
                link: function(scope, element, attr) {
                    scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
                        // The comment inside of the ngShowDirective explains why we add and
                        // remove a temporary class for the show/hide animation
                        $animate[value ? "addClass" : "removeClass"](element, NG_HIDE_CLASS, {
                            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
       });
     </file>
   </example>
 */ var ngStyleDirective = ngDirective(function(scope, element, attr) {
        scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
            if (oldStyles && newStyles !== oldStyles) forEach(oldStyles, function(val, style) {
                element.css(style, "");
            });
            if (newStyles) element.css(newStyles);
        });
    });
    /**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */ var ngSwitchDirective = [
        "$animate",
        "$compile",
        function($animate, $compile) {
            return {
                require: "ngSwitch",
                // asks for $scope to fool the BC controller module
                controller: [
                    "$scope",
                    function NgSwitchController() {
                        this.cases = {};
                    }
                ],
                link: function(scope, element, attr, ngSwitchController) {
                    var watchExpr = attr.ngSwitch || attr.on, selectedTranscludes = [], selectedElements = [], previousLeaveAnimations = [], selectedScopes = [];
                    var spliceFactory = function(array, index) {
                        return function(response) {
                            if (response !== false) array.splice(index, 1);
                        };
                    };
                    scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
                        var i, ii;
                        // Start with the last, in case the array is modified during the loop
                        while(previousLeaveAnimations.length)$animate.cancel(previousLeaveAnimations.pop());
                        for(i = 0, ii = selectedScopes.length; i < ii; ++i){
                            var selected = getBlockNodes(selectedElements[i].clone);
                            selectedScopes[i].$destroy();
                            var runner = previousLeaveAnimations[i] = $animate.leave(selected);
                            runner.done(spliceFactory(previousLeaveAnimations, i));
                        }
                        selectedElements.length = 0;
                        selectedScopes.length = 0;
                        if (selectedTranscludes = ngSwitchController.cases["!" + value] || ngSwitchController.cases["?"]) forEach(selectedTranscludes, function(selectedTransclude) {
                            selectedTransclude.transclude(function(caseElement, selectedScope) {
                                selectedScopes.push(selectedScope);
                                var anchor = selectedTransclude.element;
                                caseElement[caseElement.length++] = $compile.$$createComment("end ngSwitchWhen");
                                var block = {
                                    clone: caseElement
                                };
                                selectedElements.push(block);
                                $animate.enter(caseElement, anchor.parent(), anchor);
                            });
                        });
                    });
                }
            };
        }
    ];
    var ngSwitchWhenDirective = ngDirective({
        transclude: "element",
        priority: 1200,
        require: "^ngSwitch",
        multiElement: true,
        link: function(scope, element, attrs, ctrl, $transclude) {
            var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(// Filter duplicate cases
            function(element, index, array) {
                return array[index - 1] !== element;
            });
            forEach(cases, function(whenCase) {
                ctrl.cases["!" + whenCase] = ctrl.cases["!" + whenCase] || [];
                ctrl.cases["!" + whenCase].push({
                    transclude: $transclude,
                    element: element
                });
            });
        }
    });
    var ngSwitchDefaultDirective = ngDirective({
        transclude: "element",
        priority: 1200,
        require: "^ngSwitch",
        multiElement: true,
        link: function(scope, element, attr, ctrl, $transclude) {
            ctrl.cases["?"] = ctrl.cases["?"] || [];
            ctrl.cases["?"].push({
                transclude: $transclude,
                element: element
            });
        }
    });
    /**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */ var ngTranscludeMinErr = minErr("ngTransclude");
    var ngTranscludeDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "EAC",
                compile: function ngTranscludeCompile(tElement) {
                    // Remove and cache any original content to act as a fallback
                    var fallbackLinkFn = $compile(tElement.contents());
                    tElement.empty();
                    return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
                        if (!$transclude) throw ngTranscludeMinErr("orphan", "Illegal use of ngTransclude directive in the template! No parent directive that requires a transclusion found. Element: {0}", startingTag($element));
                        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
                        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) $attrs.ngTransclude = "";
                        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
                        // If the slot is required and no transclusion content is provided then this call will throw an error
                        $transclude(ngTranscludeCloneAttachFn, null, slotName);
                        // If the slot is optional and no transclusion content is provided then use the fallback content
                        if (slotName && !$transclude.isSlotFilled(slotName)) useFallbackContent();
                        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
                            if (clone.length && notWhitespace(clone)) $element.append(clone);
                            else {
                                useFallbackContent();
                                // There is nothing linked against the transcluded scope since no content was available,
                                // so it should be safe to clean up the generated scope.
                                transcludedScope.$destroy();
                            }
                        }
                        function useFallbackContent() {
                            // Since this is the fallback content rather than the transcluded content,
                            // we link against the scope of this directive rather than the transcluded scope
                            fallbackLinkFn($scope, function(clone) {
                                $element.append(clone);
                            });
                        }
                        function notWhitespace(nodes) {
                            for(var i = 0, ii = nodes.length; i < ii; i++){
                                var node = nodes[i];
                                if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) return true;
                            }
                        }
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */ var scriptDirective = [
        "$templateCache",
        function($templateCache) {
            return {
                restrict: "E",
                terminal: true,
                compile: function(element, attr) {
                    if (attr.type === "text/ng-template") {
                        var templateUrl = attr.id, text = element[0].text;
                        $templateCache.put(templateUrl, text);
                    }
                }
            };
        }
    ];
    /* exported selectDirective, optionDirective */ var noopNgModelController = {
        $setViewValue: noop,
        $render: noop
    };
    function setOptionSelectedStatus(optionEl, value) {
        optionEl.prop("selected", value);
        /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */ optionEl.attr("selected", value);
    }
    /**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */ var SelectController = [
        "$element",
        "$scope",
        /** @this */ function($element, $scope) {
            var self = this, optionsMap = new NgMap();
            self.selectValueMap = {}; // Keys are the hashed values, values the original values
            // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
            self.ngModelCtrl = noopNgModelController;
            self.multiple = false;
            // The "unknown" option is one that is prepended to the list if the viewValue
            // does not match any of the options. When it is rendered the value of the unknown
            // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
            //
            // Support: IE 9 only
            // We can't just jqLite('<option>') since jqLite is not smart enough
            // to create it in <select> and IE barfs otherwise.
            self.unknownOption = jqLite(window1.document.createElement("option"));
            // The empty option is an option with the value '' that the application developer can
            // provide inside the select. It is always selectable and indicates that a "null" selection has
            // been made by the user.
            // If the select has an empty option, and the model of the select is set to "undefined" or "null",
            // the empty option is selected.
            // If the model is set to a different unmatched value, the unknown option is rendered and
            // selected, i.e both are present, because a "null" selection and an unknown value are different.
            self.hasEmptyOption = false;
            self.emptyOption = undefined;
            self.renderUnknownOption = function(val) {
                var unknownVal = self.generateUnknownOptionValue(val);
                self.unknownOption.val(unknownVal);
                $element.prepend(self.unknownOption);
                setOptionSelectedStatus(self.unknownOption, true);
                $element.val(unknownVal);
            };
            self.updateUnknownOption = function(val) {
                var unknownVal = self.generateUnknownOptionValue(val);
                self.unknownOption.val(unknownVal);
                setOptionSelectedStatus(self.unknownOption, true);
                $element.val(unknownVal);
            };
            self.generateUnknownOptionValue = function(val) {
                return "? " + hashKey(val) + " ?";
            };
            self.removeUnknownOption = function() {
                if (self.unknownOption.parent()) self.unknownOption.remove();
            };
            self.selectEmptyOption = function() {
                if (self.emptyOption) {
                    $element.val("");
                    setOptionSelectedStatus(self.emptyOption, true);
                }
            };
            self.unselectEmptyOption = function() {
                if (self.hasEmptyOption) setOptionSelectedStatus(self.emptyOption, false);
            };
            $scope.$on("$destroy", function() {
                // disable unknown option so that we don't do work when the whole select is being destroyed
                self.renderUnknownOption = noop;
            });
            // Read the value of the select control, the implementation of this changes depending
            // upon whether the select can have multiple values and whether ngOptions is at work.
            self.readValue = function readSingleValue() {
                var val = $element.val();
                // ngValue added option values are stored in the selectValueMap, normal interpolations are not
                var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
                if (self.hasOption(realVal)) return realVal;
                return null;
            };
            // Write the value to the select control, the implementation of this changes depending
            // upon whether the select can have multiple values and whether ngOptions is at work.
            self.writeValue = function writeSingleValue(value) {
                // Make sure to remove the selected attribute from the previously selected option
                // Otherwise, screen readers might get confused
                var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
                if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
                if (self.hasOption(value)) {
                    self.removeUnknownOption();
                    var hashedVal = hashKey(value);
                    $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
                    // Set selected attribute and property on selected option for screen readers
                    var selectedOption = $element[0].options[$element[0].selectedIndex];
                    setOptionSelectedStatus(jqLite(selectedOption), true);
                } else self.selectUnknownOrEmptyOption(value);
            };
            // Tell the select control that an option, with the given value, has been added
            self.addOption = function(value, element) {
                // Skip comment nodes, as they only pollute the `optionsMap`
                if (element[0].nodeType === NODE_TYPE_COMMENT) return;
                assertNotHasOwnProperty(value, '"option value"');
                if (value === "") {
                    self.hasEmptyOption = true;
                    self.emptyOption = element;
                }
                var count = optionsMap.get(value) || 0;
                optionsMap.set(value, count + 1);
                // Only render at the end of a digest. This improves render performance when many options
                // are added during a digest and ensures all relevant options are correctly marked as selected
                scheduleRender();
            };
            // Tell the select control that an option, with the given value, has been removed
            self.removeOption = function(value) {
                var count = optionsMap.get(value);
                if (count) {
                    if (count === 1) {
                        optionsMap.delete(value);
                        if (value === "") {
                            self.hasEmptyOption = false;
                            self.emptyOption = undefined;
                        }
                    } else optionsMap.set(value, count - 1);
                }
            };
            // Check whether the select control has an option matching the given value
            self.hasOption = function(value) {
                return !!optionsMap.get(value);
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */ self.$hasEmptyOption = function() {
                return self.hasEmptyOption;
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */ self.$isUnknownOptionSelected = function() {
                // Presence of the unknown option means it is selected
                return $element[0].options[0] === self.unknownOption[0];
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */ self.$isEmptyOptionSelected = function() {
                return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
            };
            self.selectUnknownOrEmptyOption = function(value) {
                if (value == null && self.emptyOption) {
                    self.removeUnknownOption();
                    self.selectEmptyOption();
                } else if (self.unknownOption.parent().length) self.updateUnknownOption(value);
                else self.renderUnknownOption(value);
            };
            var renderScheduled = false;
            function scheduleRender() {
                if (renderScheduled) return;
                renderScheduled = true;
                $scope.$$postDigest(function() {
                    renderScheduled = false;
                    self.ngModelCtrl.$render();
                });
            }
            var updateScheduled = false;
            function scheduleViewValueUpdate(renderAfter) {
                if (updateScheduled) return;
                updateScheduled = true;
                $scope.$$postDigest(function() {
                    if ($scope.$$destroyed) return;
                    updateScheduled = false;
                    self.ngModelCtrl.$setViewValue(self.readValue());
                    if (renderAfter) self.ngModelCtrl.$render();
                });
            }
            self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
                if (optionAttrs.$attr.ngValue) {
                    // The value attribute is set by ngValue
                    var oldVal, hashedVal;
                    optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {
                        var removal;
                        var previouslySelected = optionElement.prop("selected");
                        if (isDefined(hashedVal)) {
                            self.removeOption(oldVal);
                            delete self.selectValueMap[hashedVal];
                            removal = true;
                        }
                        hashedVal = hashKey(newVal);
                        oldVal = newVal;
                        self.selectValueMap[hashedVal] = newVal;
                        self.addOption(newVal, optionElement);
                        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
                        // from firing a second time. Other $observers on value will also get the result of the
                        // ngValue expression, not the hashed value
                        optionElement.attr("value", hashedVal);
                        if (removal && previouslySelected) scheduleViewValueUpdate();
                    });
                } else if (interpolateValueFn) // The value attribute is interpolated
                optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {
                    // This method is overwritten in ngOptions and has side-effects!
                    self.readValue();
                    var removal;
                    var previouslySelected = optionElement.prop("selected");
                    if (isDefined(oldVal)) {
                        self.removeOption(oldVal);
                        removal = true;
                    }
                    oldVal = newVal;
                    self.addOption(newVal, optionElement);
                    if (removal && previouslySelected) scheduleViewValueUpdate();
                });
                else if (interpolateTextFn) // The text content is interpolated
                optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
                    optionAttrs.$set("value", newVal);
                    var previouslySelected = optionElement.prop("selected");
                    if (oldVal !== newVal) self.removeOption(oldVal);
                    self.addOption(newVal, optionElement);
                    if (oldVal && previouslySelected) scheduleViewValueUpdate();
                });
                else // The value attribute is static
                self.addOption(optionAttrs.value, optionElement);
                optionAttrs.$observe("disabled", function(newVal) {
                    // Since model updates will also select disabled options (like ngOptions),
                    // we only have to handle options becoming disabled, not enabled
                    if (newVal === "true" || newVal && optionElement.prop("selected")) {
                        if (self.multiple) scheduleViewValueUpdate(true);
                        else {
                            self.ngModelCtrl.$setViewValue(null);
                            self.ngModelCtrl.$render();
                        }
                    }
                });
                optionElement.on("$destroy", function() {
                    var currentValue = self.readValue();
                    var removeValue = optionAttrs.value;
                    self.removeOption(removeValue);
                    scheduleRender();
                    if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 || currentValue === removeValue) // When multiple (selected) options are destroyed at the same time, we don't want
                    // to run a model update for each of them. Instead, run a single update in the $$postDigest
                    scheduleViewValueUpdate(true);
                });
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */ var selectDirective = function() {
        return {
            restrict: "E",
            require: [
                "select",
                "?ngModel"
            ],
            controller: SelectController,
            priority: 1,
            link: {
                pre: selectPreLink,
                post: selectPostLink
            }
        };
        function selectPreLink(scope, element, attr, ctrls) {
            var selectCtrl = ctrls[0];
            var ngModelCtrl = ctrls[1];
            // if ngModel is not defined, we don't need to do anything but set the registerOption
            // function to noop, so options don't get added internally
            if (!ngModelCtrl) {
                selectCtrl.registerOption = noop;
                return;
            }
            selectCtrl.ngModelCtrl = ngModelCtrl;
            // When the selected item(s) changes we delegate getting the value of the select control
            // to the `readValue` method, which can be changed if the select can have multiple
            // selected values or if the options are being generated by `ngOptions`
            element.on("change", function() {
                selectCtrl.removeUnknownOption();
                scope.$apply(function() {
                    ngModelCtrl.$setViewValue(selectCtrl.readValue());
                });
            });
            // If the select allows multiple values then we need to modify how we read and write
            // values from and to the control; also what it means for the value to be empty and
            // we have to add an extra watch since ngModel doesn't work well with arrays - it
            // doesn't trigger rendering if only an item in the array changes.
            if (attr.multiple) {
                selectCtrl.multiple = true;
                // Read value now needs to check each option to see if it is selected
                selectCtrl.readValue = function readMultipleValue() {
                    var array = [];
                    forEach(element.find("option"), function(option) {
                        if (option.selected && !option.disabled) {
                            var val = option.value;
                            array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
                        }
                    });
                    return array;
                };
                // Write value now needs to set the selected property of each matching option
                selectCtrl.writeValue = function writeMultipleValue(value) {
                    forEach(element.find("option"), function(option) {
                        var shouldBeSelected = !!value && (includes(value, option.value) || includes(value, selectCtrl.selectValueMap[option.value]));
                        var currentlySelected = option.selected;
                        // Support: IE 9-11 only, Edge 12-15+
                        // In IE and Edge adding options to the selection via shift+click/UP/DOWN
                        // will de-select already selected options if "selected" on those options was set
                        // more than once (i.e. when the options were already selected)
                        // So we only modify the selected property if necessary.
                        // Note: this behavior cannot be replicated via unit tests because it only shows in the
                        // actual user interface.
                        if (shouldBeSelected !== currentlySelected) setOptionSelectedStatus(jqLite(option), shouldBeSelected);
                    });
                };
                // we have to do it on each watch since ngModel watches reference, but
                // we need to work of an array, so we need to see if anything was inserted/removed
                var lastView, lastViewRef = NaN;
                scope.$watch(function selectMultipleWatch() {
                    if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
                        lastView = shallowCopy(ngModelCtrl.$viewValue);
                        ngModelCtrl.$render();
                    }
                    lastViewRef = ngModelCtrl.$viewValue;
                });
                // If we are a multiple select then value is now a collection
                // so the meaning of $isEmpty changes
                ngModelCtrl.$isEmpty = function(value) {
                    return !value || value.length === 0;
                };
            }
        }
        function selectPostLink(scope, element, attrs, ctrls) {
            // if ngModel is not defined, we don't need to do anything
            var ngModelCtrl = ctrls[1];
            if (!ngModelCtrl) return;
            var selectCtrl = ctrls[0];
            // We delegate rendering to the `writeValue` method, which can be changed
            // if the select can have multiple selected values or if the options are being
            // generated by `ngOptions`.
            // This must be done in the postLink fn to prevent $render to be called before
            // all nodes have been linked correctly.
            ngModelCtrl.$render = function() {
                selectCtrl.writeValue(ngModelCtrl.$viewValue);
            };
        }
    };
    // The option directive is purely designed to communicate the existence (or lack of)
    // of dynamically created (and destroyed) option elements to their containing select
    // directive via its controller.
    var optionDirective = [
        "$interpolate",
        function($interpolate) {
            return {
                restrict: "E",
                priority: 100,
                compile: function(element, attr) {
                    var interpolateValueFn, interpolateTextFn;
                    if (isDefined(attr.ngValue)) ;
                    else if (isDefined(attr.value)) // If the value attribute is defined, check if it contains an interpolation
                    interpolateValueFn = $interpolate(attr.value, true);
                    else {
                        // If the value attribute is not defined then we fall back to the
                        // text content of the option element, which may be interpolated
                        interpolateTextFn = $interpolate(element.text(), true);
                        if (!interpolateTextFn) attr.$set("value", element.text());
                    }
                    return function(scope, element, attr) {
                        // This is an optimization over using ^^ since we don't want to have to search
                        // all the way to the root of the DOM for every single option element
                        var selectCtrlName = "$selectController", parent = element.parent(), selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName); // in case we are in optgroup
                        if (selectCtrl) selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */ var requiredDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    // For boolean attributes like required, presence means true
                    var value = attr.hasOwnProperty("required") || $parse(attr.ngRequired)(scope);
                    if (!attr.ngRequired) // force truthy in case we are on non input element
                    // (input elements do this automatically for boolean attributes like required)
                    attr.required = true;
                    ctrl.$validators.required = function(modelValue, viewValue) {
                        return !value || !ctrl.$isEmpty(viewValue);
                    };
                    attr.$observe("required", function(newVal) {
                        if (value !== newVal) {
                            value = newVal;
                            ctrl.$validate();
                        }
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */ var patternDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                compile: function(tElm, tAttr) {
                    var patternExp;
                    var parseFn;
                    if (tAttr.ngPattern) {
                        patternExp = tAttr.ngPattern;
                        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
                        // We get value of the attribute here, so we can compare the old and the new value
                        // in the observer to avoid unnecessary validations
                        if (tAttr.ngPattern.charAt(0) === "/" && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) parseFn = function() {
                            return tAttr.ngPattern;
                        };
                        else parseFn = $parse(tAttr.ngPattern);
                    }
                    return function(scope, elm, attr, ctrl) {
                        if (!ctrl) return;
                        var attrVal = attr.pattern;
                        if (attr.ngPattern) attrVal = parseFn(scope);
                        else patternExp = attr.pattern;
                        var regexp = parsePatternAttr(attrVal, patternExp, elm);
                        attr.$observe("pattern", function(newVal) {
                            var oldRegexp = regexp;
                            regexp = parsePatternAttr(newVal, patternExp, elm);
                            if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) ctrl.$validate();
                        });
                        ctrl.$validators.pattern = function(modelValue, viewValue) {
                            // HTML5 pattern constraint validates the input value, so we validate the viewValue
                            return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
                        };
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */ var maxlengthDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
                    var maxlengthParsed = parseLength(maxlength);
                    attr.$observe("maxlength", function(value) {
                        if (maxlength !== value) {
                            maxlengthParsed = parseLength(value);
                            maxlength = value;
                            ctrl.$validate();
                        }
                    });
                    ctrl.$validators.maxlength = function(modelValue, viewValue) {
                        return maxlengthParsed < 0 || ctrl.$isEmpty(viewValue) || viewValue.length <= maxlengthParsed;
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */ var minlengthDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
                    var minlengthParsed = parseLength(minlength) || -1;
                    attr.$observe("minlength", function(value) {
                        if (minlength !== value) {
                            minlengthParsed = parseLength(value) || -1;
                            minlength = value;
                            ctrl.$validate();
                        }
                    });
                    ctrl.$validators.minlength = function(modelValue, viewValue) {
                        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
                    };
                }
            };
        }
    ];
    function parsePatternAttr(regex, patternExp, elm) {
        if (!regex) return undefined;
        if (isString(regex)) regex = new RegExp("^" + regex + "$");
        if (!regex.test) throw minErr("ngPattern")("noregexp", "Expected {0} to be a RegExp but was {1}. Element: {2}", patternExp, regex, startingTag(elm));
        return regex;
    }
    function parseLength(val) {
        var intVal = toInt(val);
        return isNumberNaN(intVal) ? -1 : intVal;
    }
    if (window1.angular.bootstrap) {
        // AngularJS is already loaded, so we can return here...
        if (window1.console) console.log("WARNING: Tried to load AngularJS more than once.");
        return;
    }
    // try to bind to jquery now so that one can write jqLite(fn)
    // but we will rebind on bootstrap again.
    bindJQuery();
    publishExternalAPI(angular);
    angular.module("ngLocale", [], [
        "$provide",
        function($provide) {
            var PLURAL_CATEGORY = {
                ZERO: "zero",
                ONE: "one",
                TWO: "two",
                FEW: "few",
                MANY: "many",
                OTHER: "other"
            };
            function getDecimals(n) {
                n = n + "";
                var i = n.indexOf(".");
                return i == -1 ? 0 : n.length - i - 1;
            }
            function getVF(n, opt_precision) {
                var v = opt_precision;
                if (undefined === v) v = Math.min(getDecimals(n), 3);
                var base = Math.pow(10, v);
                var f = (n * base | 0) % base;
                return {
                    v: v,
                    f: f
                };
            }
            $provide.value("$locale", {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    "ERANAMES": [
                        "Before Christ",
                        "Anno Domini"
                    ],
                    "ERAS": [
                        "BC",
                        "AD"
                    ],
                    "FIRSTDAYOFWEEK": 6,
                    "MONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "SHORTDAY": [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    "SHORTMONTH": [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    "STANDALONEMONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "WEEKENDRANGE": [
                        5,
                        6
                    ],
                    "fullDate": "EEEE, MMMM d, y",
                    "longDate": "MMMM d, y",
                    "medium": "MMM d, y h:mm:ss a",
                    "mediumDate": "MMM d, y",
                    "mediumTime": "h:mm:ss a",
                    "short": "M/d/yy h:mm a",
                    "shortDate": "M/d/yy",
                    "shortTime": "h:mm a"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "$",
                    "DECIMAL_SEP": ".",
                    "GROUP_SEP": ",",
                    "PATTERNS": [
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "maxFrac": 3,
                            "minFrac": 0,
                            "minInt": 1,
                            "negPre": "-",
                            "negSuf": "",
                            "posPre": "",
                            "posSuf": ""
                        },
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "maxFrac": 2,
                            "minFrac": 2,
                            "minInt": 1,
                            "negPre": "-\xa4",
                            "negSuf": "",
                            "posPre": "\xa4",
                            "posSuf": ""
                        }
                    ]
                },
                "id": "en-us",
                "localeID": "en_US",
                "pluralCat": function(n, opt_precision) {
                    var i = n | 0;
                    var vf = getVF(n, opt_precision);
                    if (i == 1 && vf.v == 0) return PLURAL_CATEGORY.ONE;
                    return PLURAL_CATEGORY.OTHER;
                }
            });
        }
    ]);
    jqLite(function() {
        angularInit(window1.document, bootstrap);
    });
})(window);
!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element("<style>").text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

},{}],"fuLZd":[function(require,module,exports) {
/*
 * promise-tracker - v2.1.0 - 2014-11-15
 * http://github.com/ajoslin/angular-promise-tracker
 * Created by Andy Joslin; Licensed under Public Domain
 */ (function() {
    angular.module("ajoslin.promise-tracker", []).provider("promiseTracker", function() {
        var trackers = {};
        this.$get = [
            "$q",
            "$timeout",
            function($q, $timeout) {
                function cancelTimeout(promise) {
                    if (promise) $timeout.cancel(promise);
                }
                return function PromiseTracker(options) {
                    //do new if user doesn't
                    if (!(this instanceof PromiseTracker)) return new PromiseTracker(options);
                    options = options || {};
                    //Array of promises being tracked
                    var tracked = [];
                    var self = this;
                    //Allow an optional "minimum duration" that the tracker has to stay active for.
                    var minDuration = options.minDuration;
                    //Allow a delay that will stop the tracker from activating until that time is reached
                    var activationDelay = options.activationDelay;
                    var minDurationPromise;
                    var activationDelayPromise;
                    self.active = function() {
                        //Even if we have a promise in our tracker, we aren't active until delay is elapsed
                        if (activationDelayPromise) return false;
                        return tracked.length > 0;
                    };
                    self.tracking = function() {
                        //Even if we aren't active, we could still have a promise in our tracker
                        return tracked.length > 0;
                    };
                    self.destroy = self.cancel = function() {
                        minDurationPromise = cancelTimeout(minDurationPromise);
                        activationDelayPromise = cancelTimeout(activationDelayPromise);
                        for(var i = tracked.length - 1; i >= 0; i--)tracked[i].resolve();
                        tracked.length = 0;
                    };
                    //Create a promise that will make our tracker active until it is resolved.
                    // @return deferred - our deferred object that is being tracked
                    self.createPromise = function() {
                        var deferred = $q.defer();
                        tracked.push(deferred);
                        //If the tracker was just inactive and this the first in the list of
                        //promises, we reset our delay and minDuration
                        //again.
                        if (tracked.length === 1) {
                            if (activationDelay) activationDelayPromise = $timeout(function() {
                                activationDelayPromise = cancelTimeout(activationDelayPromise);
                                startMinDuration();
                            }, activationDelay);
                            else startMinDuration();
                        }
                        deferred.promise.then(onDone(false), onDone(true));
                        return deferred;
                        function startMinDuration() {
                            if (minDuration) minDurationPromise = $timeout(angular.noop, minDuration);
                        }
                        //Create a callback for when this promise is done. It will remove our
                        //tracked promise from the array if once minDuration is complete
                        function onDone(isError) {
                            return function(value) {
                                (minDurationPromise || $q.when()).then(function() {
                                    var index = tracked.indexOf(deferred);
                                    tracked.splice(index, 1);
                                    //If this is the last promise, cleanup the timeouts
                                    //for activationDelay
                                    if (tracked.length === 0) activationDelayPromise = cancelTimeout(activationDelayPromise);
                                });
                            };
                        }
                    };
                    self.addPromise = function(promise) {
                        promise = promise && (promise.$promise || promise) || {};
                        if (!promise.then) throw new Error("promiseTracker#addPromise expects a promise object!");
                        var deferred = self.createPromise();
                        //When given promise is done, resolve our created promise
                        //Allow $then for angular-resource objects
                        promise.then(function success(value) {
                            deferred.resolve(value);
                            return value;
                        }, function error(value) {
                            deferred.reject(value);
                            return $q.reject(value);
                        });
                        return deferred;
                    };
                };
            }
        ];
    });
})();

},{}],"csQ8w":[function(require,module,exports) {
/*!
 * angular-spectrum-colorpicker v1.4.5
 * https://github.com/Jimdo/angular-spectrum-colorpicker
 *
 * Angular directive for a colorpicker, that bases on http://bgrins.github.io/spectrum/
 * Idea from http://jsfiddle.net/g/LAJCa/
 *
 * Copyright 2016, Jimdo GmbH
 * Released under the MIT license
 */ (function(angular, undefined) {
    "use strict";
    // src/js/helper.module.js
    var angularSpectrumColorpicker = angular.module("angularSpectrumColorpicker", []);
    // src/js/spectrumColorpicker.directive.js
    (function(undefined) {
        "use strict";
        angularSpectrumColorpicker.directive("spectrumColorpicker", function() {
            return {
                restrict: "EA",
                require: "ngModel",
                scope: {
                    fallbackValue: "=",
                    disabled: "=?",
                    format: "=?",
                    options: "=?",
                    triggerId: "@?",
                    palette: "=?",
                    onChange: "&?",
                    onShow: "&?",
                    onHide: "&?",
                    onMove: "&?",
                    onBeforeShow: "&?",
                    onChangeOptions: "=?",
                    onShowOptions: "=?",
                    onHideOptions: "=?",
                    onMoveOptions: "=?"
                },
                replace: true,
                templateUrl: "directive.html",
                link: function($scope, $element, attrs, $ngModel) {
                    var $input = $element.find("input");
                    function formatColor(tiny) {
                        var formatted = tiny;
                        if (formatted) formatted = tiny.toString($scope.format);
                        return formatted;
                    }
                    function callOnChange(color) {
                        if (angular.isFunction($scope.onChange)) $scope.onChange({
                            color: color
                        });
                    }
                    function setViewValue(color) {
                        var value = $scope.fallbackValue;
                        if (color) value = formatColor(color);
                        else if (angular.isUndefined($scope.fallbackValue)) value = color;
                        $ngModel.$setViewValue(value);
                        callOnChange(value);
                    }
                    var onChange = function(color) {
                        $scope.$evalAsync(function() {
                            setViewValue(color);
                        });
                    };
                    var onToggle = function() {
                        $input.spectrum("toggle");
                        return false;
                    };
                    var baseOpts = {
                        color: $ngModel.$viewValue
                    };
                    var localOpts = {};
                    angular.forEach({
                        "change": "onChange",
                        "move": "onMove",
                        "hide": "onHide",
                        "show": "onShow"
                    }, function(eventHandlerName, eventName) {
                        var spectrumEventHandlerOptions = $scope[eventHandlerName + "Options"];
                        localOpts[eventName] = function(color) {
                            if (!spectrumEventHandlerOptions || spectrumEventHandlerOptions.update) onChange(color);
                            // we don't do this for change, because we expose the current
                            // value actively through the model
                            if (eventHandlerName !== "change" && angular.isFunction($scope[eventHandlerName])) return $scope[eventHandlerName]({
                                color: formatColor(color)
                            });
                            else return null;
                        };
                    });
                    if (angular.isFunction($scope.onBeforeShow)) localOpts.beforeShow = function(color) {
                        return $scope.onBeforeShow({
                            color: formatColor(color)
                        });
                    };
                    if ($scope.palette) localOpts.palette = $scope.palette;
                    var options = angular.extend({}, baseOpts, $scope.options, localOpts);
                    if ($scope.triggerId) angular.element(document.body).on("click", "#" + $scope.triggerId, onToggle);
                    $ngModel.$render = function() {
                        $input.spectrum("set", $ngModel.$viewValue || "");
                        callOnChange($ngModel.$viewValue);
                    };
                    if (options.color) {
                        $input.spectrum("set", options.color || "");
                        setViewValue(options.color);
                    }
                    $input.spectrum(options);
                    $scope.$on("$destroy", function() {
                        if ($scope.triggerId) angular.element(document.body).off("click", "#" + $scope.triggerId, onToggle);
                    });
                    $element.on("$destroy", function() {
                        $input.spectrum("destroy");
                    });
                    if (angular.isDefined(options.disabled)) $scope.disabled = !!options.disabled;
                    $scope.$watch("disabled", function(newDisabled) {
                        $input.spectrum(newDisabled ? "disable" : "enable");
                    });
                    $scope.$watch("palette", function(palette) {
                        $input.spectrum("option", "palette", palette);
                    }, true);
                }
            };
        });
    })();
    // .tmp/all-partials.js
    angular.module("angularSpectrumColorpicker").run([
        "$templateCache",
        function($templateCache) {
            "use strict";
            $templateCache.put("directive.html", '<span><input class="input-small"></span>');
        }
    ]);
})(window.angular);

},{}],"hRgtn":[function(require,module,exports) {
/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 */ angular.module("checklist-model", []).directive("checklistModel", [
    "$parse",
    "$compile",
    function($parse, $compile) {
        // contains
        function contains(arr, item, comparator) {
            if (angular.isArray(arr)) for(var i = arr.length; i--;){
                if (comparator(arr[i], item)) return true;
            }
            return false;
        }
        // add
        function add(arr, item, comparator) {
            arr = angular.isArray(arr) ? arr : [];
            if (!contains(arr, item, comparator)) arr.push(item);
            return arr;
        }
        // remove
        function remove(arr, item, comparator) {
            if (angular.isArray(arr)) {
                for(var i = arr.length; i--;)if (comparator(arr[i], item)) {
                    arr.splice(i, 1);
                    break;
                }
            }
            return arr;
        }
        // http://stackoverflow.com/a/19228302/1458162
        function postLinkFn(scope, elem, attrs) {
            // compile with `ng-model` pointing to `checked`
            $compile(elem)(scope);
            // getter / setter for original model
            var getter = $parse(attrs.checklistModel);
            var setter = getter.assign;
            var checklistChange = $parse(attrs.checklistChange);
            // value added to list
            var value = $parse(attrs.checklistValue)(scope.$parent);
            var comparator = angular.equals;
            if (attrs.hasOwnProperty("checklistComparator")) comparator = $parse(attrs.checklistComparator)(scope.$parent);
            // watch UI checked change
            scope.$watch("checked", function(newValue, oldValue) {
                if (newValue === oldValue) return;
                var current = getter(scope.$parent);
                if (newValue === true) setter(scope.$parent, add(current, value, comparator));
                else setter(scope.$parent, remove(current, value, comparator));
                if (checklistChange) checklistChange(scope);
            });
            // declare one function to be used for both $watch functions
            function setChecked(newArr, oldArr) {
                scope.checked = contains(newArr, value, comparator);
            }
            // watch original model change
            // use the faster $watchCollection method if it's available
            if (angular.isFunction(scope.$parent.$watchCollection)) scope.$parent.$watchCollection(attrs.checklistModel, setChecked);
            else scope.$parent.$watch(attrs.checklistModel, setChecked, true);
        }
        return {
            restrict: "A",
            priority: 1000,
            terminal: true,
            scope: true,
            compile: function(tElement, tAttrs) {
                if (tElement[0].tagName !== "INPUT" || tAttrs.type !== "checkbox") throw 'checklist-model should be applied to `input[type="checkbox"]`.';
                if (!tAttrs.checklistValue) throw "You should provide `checklist-value`.";
                // exclude recursion
                tElement.removeAttr("checklist-model");
                // local scope var storing individual checkbox model
                tElement.attr("ng-model", "checked");
                return postLinkFn;
            }
        };
    }
]);

},{}],"flF72":[function(require,module,exports) {
require("77b41c0874a0ba93");
module.exports = "ngAnimate";

},{"77b41c0874a0ba93":"i1Ivw"}],"i1Ivw":[function(require,module,exports) {
/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1, angular) {
    "use strict";
    var ELEMENT_NODE = 1;
    var COMMENT_NODE = 8;
    var ADD_CLASS_SUFFIX = "-add";
    var REMOVE_CLASS_SUFFIX = "-remove";
    var EVENT_CLASS_PREFIX = "ng-";
    var ACTIVE_CLASS_SUFFIX = "-active";
    var PREPARE_CLASS_SUFFIX = "-prepare";
    var NG_ANIMATE_CLASSNAME = "ng-animate";
    var NG_ANIMATE_CHILDREN_DATA = "$$ngAnimateChildren";
    // Detect proper transitionend/animationend event names.
    var CSS_PREFIX = "", TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
    // If unprefixed events are not supported but webkit-prefixed are, use the latter.
    // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
    // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
    // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
    // Register both events in case `window.onanimationend` is not supported because of that,
    // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
    // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
    // therefore there is no reason to test anymore for other vendor prefixes:
    // http://caniuse.com/#search=transition
    if (window1.ontransitionend === undefined && window1.onwebkittransitionend !== undefined) {
        CSS_PREFIX = "-webkit-";
        TRANSITION_PROP = "WebkitTransition";
        TRANSITIONEND_EVENT = "webkitTransitionEnd transitionend";
    } else {
        TRANSITION_PROP = "transition";
        TRANSITIONEND_EVENT = "transitionend";
    }
    if (window1.onanimationend === undefined && window1.onwebkitanimationend !== undefined) {
        CSS_PREFIX = "-webkit-";
        ANIMATION_PROP = "WebkitAnimation";
        ANIMATIONEND_EVENT = "webkitAnimationEnd animationend";
    } else {
        ANIMATION_PROP = "animation";
        ANIMATIONEND_EVENT = "animationend";
    }
    var DURATION_KEY = "Duration";
    var PROPERTY_KEY = "Property";
    var DELAY_KEY = "Delay";
    var TIMING_KEY = "TimingFunction";
    var ANIMATION_ITERATION_COUNT_KEY = "IterationCount";
    var ANIMATION_PLAYSTATE_KEY = "PlayState";
    var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
    var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
    var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
    var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
    var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
    var ngMinErr = angular.$$minErr("ng");
    function assertArg(arg, name, reason) {
        if (!arg) throw ngMinErr("areq", "Argument '{0}' is {1}", name || "?", reason || "required");
        return arg;
    }
    function mergeClasses(a, b) {
        if (!a && !b) return "";
        if (!a) return b;
        if (!b) return a;
        if (isArray(a)) a = a.join(" ");
        if (isArray(b)) b = b.join(" ");
        return a + " " + b;
    }
    function packageStyles(options) {
        var styles = {};
        if (options && (options.to || options.from)) {
            styles.to = options.to;
            styles.from = options.from;
        }
        return styles;
    }
    function pendClasses(classes, fix, isPrefix) {
        var className = "";
        classes = isArray(classes) ? classes : classes && isString(classes) && classes.length ? classes.split(/\s+/) : [];
        forEach(classes, function(klass, i) {
            if (klass && klass.length > 0) {
                className += i > 0 ? " " : "";
                className += isPrefix ? fix + klass : klass + fix;
            }
        });
        return className;
    }
    function removeFromArray(arr, val) {
        var index = arr.indexOf(val);
        if (val >= 0) arr.splice(index, 1);
    }
    function stripCommentsFromElement(element) {
        if (element instanceof jqLite) switch(element.length){
            case 0:
                return element;
            case 1:
                // there is no point of stripping anything if the element
                // is the only element within the jqLite wrapper.
                // (it's important that we retain the element instance.)
                if (element[0].nodeType === ELEMENT_NODE) return element;
                break;
            default:
                return jqLite(extractElementNode(element));
        }
        if (element.nodeType === ELEMENT_NODE) return jqLite(element);
    }
    function extractElementNode(element) {
        if (!element[0]) return element;
        for(var i = 0; i < element.length; i++){
            var elm = element[i];
            if (elm.nodeType === ELEMENT_NODE) return elm;
        }
    }
    function $$addClass($$jqLite, element, className) {
        forEach(element, function(elm) {
            $$jqLite.addClass(elm, className);
        });
    }
    function $$removeClass($$jqLite, element, className) {
        forEach(element, function(elm) {
            $$jqLite.removeClass(elm, className);
        });
    }
    function applyAnimationClassesFactory($$jqLite) {
        return function(element, options) {
            if (options.addClass) {
                $$addClass($$jqLite, element, options.addClass);
                options.addClass = null;
            }
            if (options.removeClass) {
                $$removeClass($$jqLite, element, options.removeClass);
                options.removeClass = null;
            }
        };
    }
    function prepareAnimationOptions(options) {
        options = options || {};
        if (!options.$$prepared) {
            var domOperation = options.domOperation || noop;
            options.domOperation = function() {
                options.$$domOperationFired = true;
                domOperation();
                domOperation = noop;
            };
            options.$$prepared = true;
        }
        return options;
    }
    function applyAnimationStyles(element, options) {
        applyAnimationFromStyles(element, options);
        applyAnimationToStyles(element, options);
    }
    function applyAnimationFromStyles(element, options) {
        if (options.from) {
            element.css(options.from);
            options.from = null;
        }
    }
    function applyAnimationToStyles(element, options) {
        if (options.to) {
            element.css(options.to);
            options.to = null;
        }
    }
    function mergeAnimationDetails(element, oldAnimation, newAnimation) {
        var target = oldAnimation.options || {};
        var newOptions = newAnimation.options || {};
        var toAdd = (target.addClass || "") + " " + (newOptions.addClass || "");
        var toRemove = (target.removeClass || "") + " " + (newOptions.removeClass || "");
        var classes = resolveElementClasses(element.attr("class"), toAdd, toRemove);
        if (newOptions.preparationClasses) {
            target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
            delete newOptions.preparationClasses;
        }
        // noop is basically when there is no callback; otherwise something has been set
        var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
        extend(target, newOptions);
        // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
        if (realDomOperation) target.domOperation = realDomOperation;
        if (classes.addClass) target.addClass = classes.addClass;
        else target.addClass = null;
        if (classes.removeClass) target.removeClass = classes.removeClass;
        else target.removeClass = null;
        oldAnimation.addClass = target.addClass;
        oldAnimation.removeClass = target.removeClass;
        return target;
    }
    function resolveElementClasses(existing, toAdd, toRemove) {
        var ADD_CLASS = 1;
        var REMOVE_CLASS = -1;
        var flags = {};
        existing = splitClassesToLookup(existing);
        toAdd = splitClassesToLookup(toAdd);
        forEach(toAdd, function(value, key) {
            flags[key] = ADD_CLASS;
        });
        toRemove = splitClassesToLookup(toRemove);
        forEach(toRemove, function(value, key) {
            flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
        });
        var classes = {
            addClass: "",
            removeClass: ""
        };
        forEach(flags, function(val, klass) {
            var prop, allow;
            if (val === ADD_CLASS) {
                prop = "addClass";
                allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
            } else if (val === REMOVE_CLASS) {
                prop = "removeClass";
                allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
            }
            if (allow) {
                if (classes[prop].length) classes[prop] += " ";
                classes[prop] += klass;
            }
        });
        function splitClassesToLookup(classes) {
            if (isString(classes)) classes = classes.split(" ");
            var obj = {};
            forEach(classes, function(klass) {
                // sometimes the split leaves empty string values
                // incase extra spaces were applied to the options
                if (klass.length) obj[klass] = true;
            });
            return obj;
        }
        return classes;
    }
    function getDomNode(element) {
        return element instanceof jqLite ? element[0] : element;
    }
    function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
        var classes = "";
        if (event) classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
        if (options.addClass) classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
        if (options.removeClass) classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
        if (classes.length) {
            options.preparationClasses = classes;
            element.addClass(classes);
        }
    }
    function clearGeneratedClasses(element, options) {
        if (options.preparationClasses) {
            element.removeClass(options.preparationClasses);
            options.preparationClasses = null;
        }
        if (options.activeClasses) {
            element.removeClass(options.activeClasses);
            options.activeClasses = null;
        }
    }
    function blockKeyframeAnimations(node, applyBlock) {
        var value = applyBlock ? "paused" : "";
        var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
        applyInlineStyle(node, [
            key,
            value
        ]);
        return [
            key,
            value
        ];
    }
    function applyInlineStyle(node, styleTuple) {
        var prop = styleTuple[0];
        var value = styleTuple[1];
        node.style[prop] = value;
    }
    function concatWithSpace(a, b) {
        if (!a) return b;
        if (!b) return a;
        return a + " " + b;
    }
    var helpers = {
        blockTransitions: function(node, duration) {
            // we use a negative delay value since it performs blocking
            // yet it doesn't kill any existing transitions running on the
            // same element which makes this safe for class-based animations
            var value = duration ? "-" + duration + "s" : "";
            applyInlineStyle(node, [
                TRANSITION_DELAY_PROP,
                value
            ]);
            return [
                TRANSITION_DELAY_PROP,
                value
            ];
        }
    };
    var $$rAFSchedulerFactory = [
        "$$rAF",
        function($$rAF) {
            var queue, cancelFn;
            function scheduler(tasks) {
                // we make a copy since RAFScheduler mutates the state
                // of the passed in array variable and this would be difficult
                // to track down on the outside code
                queue = queue.concat(tasks);
                nextTick();
            }
            queue = scheduler.queue = [];
            /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */ scheduler.waitUntilQuiet = function(fn) {
                if (cancelFn) cancelFn();
                cancelFn = $$rAF(function() {
                    cancelFn = null;
                    fn();
                    nextTick();
                });
            };
            return scheduler;
            function nextTick() {
                if (!queue.length) return;
                var items = queue.shift();
                for(var i = 0; i < items.length; i++)items[i]();
                if (!cancelFn) $$rAF(function() {
                    if (!cancelFn) nextTick();
                });
            }
        }
    ];
    /**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */ var $$AnimateChildrenDirective = [
        "$interpolate",
        function($interpolate) {
            return {
                link: function(scope, element, attrs) {
                    var val = attrs.ngAnimateChildren;
                    if (isString(val) && val.length === 0) element.data(NG_ANIMATE_CHILDREN_DATA, true);
                    else {
                        // Interpolate and set the value, so that it is available to
                        // animations that run right after compilation
                        setData($interpolate(val)(scope));
                        attrs.$observe("ngAnimateChildren", setData);
                    }
                    function setData(value) {
                        value = value === "on" || value === "true";
                        element.data(NG_ANIMATE_CHILDREN_DATA, value);
                    }
                }
            };
        }
    ];
    /* exported $AnimateCssProvider */ var ANIMATE_TIMER_KEY = "$$animateCss";
    /**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */ var ONE_SECOND = 1000;
    var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
    var CLOSING_TIME_BUFFER = 1.5;
    var DETECT_CSS_PROPERTIES = {
        transitionDuration: TRANSITION_DURATION_PROP,
        transitionDelay: TRANSITION_DELAY_PROP,
        transitionProperty: TRANSITION_PROP + PROPERTY_KEY,
        animationDuration: ANIMATION_DURATION_PROP,
        animationDelay: ANIMATION_DELAY_PROP,
        animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
    };
    var DETECT_STAGGER_CSS_PROPERTIES = {
        transitionDuration: TRANSITION_DURATION_PROP,
        transitionDelay: TRANSITION_DELAY_PROP,
        animationDuration: ANIMATION_DURATION_PROP,
        animationDelay: ANIMATION_DELAY_PROP
    };
    function getCssKeyframeDurationStyle(duration) {
        return [
            ANIMATION_DURATION_PROP,
            duration + "s"
        ];
    }
    function getCssDelayStyle(delay, isKeyframeAnimation) {
        var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
        return [
            prop,
            delay + "s"
        ];
    }
    function computeCssStyles($window, element, properties) {
        var styles = Object.create(null);
        var detectedStyles = $window.getComputedStyle(element) || {};
        forEach(properties, function(formalStyleName, actualStyleName) {
            var val = detectedStyles[formalStyleName];
            if (val) {
                var c = val.charAt(0);
                // only numerical-based values have a negative sign or digit as the first value
                if (c === "-" || c === "+" || c >= 0) val = parseMaxTime(val);
                // by setting this to null in the event that the delay is not set or is set directly as 0
                // then we can still allow for negative values to be used later on and not mistake this
                // value for being greater than any other negative value.
                if (val === 0) val = null;
                styles[actualStyleName] = val;
            }
        });
        return styles;
    }
    function parseMaxTime(str) {
        var maxValue = 0;
        var values = str.split(/\s*,\s*/);
        forEach(values, function(value) {
            // it's always safe to consider only second values and omit `ms` values since
            // getComputedStyle will always handle the conversion for us
            if (value.charAt(value.length - 1) === "s") value = value.substring(0, value.length - 1);
            value = parseFloat(value) || 0;
            maxValue = maxValue ? Math.max(value, maxValue) : value;
        });
        return maxValue;
    }
    function truthyTimingValue(val) {
        return val === 0 || val != null;
    }
    function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
        var style = TRANSITION_PROP;
        var value = duration + "s";
        if (applyOnlyDuration) style += DURATION_KEY;
        else value += " linear all";
        return [
            style,
            value
        ];
    }
    // we do not reassign an already present style value since
    // if we detect the style property value again we may be
    // detecting styles that were added via the `from` styles.
    // We make use of `isDefined` here since an empty string
    // or null value (which is what getPropertyValue will return
    // for a non-existing style) will still be marked as a valid
    // value for the style (a falsy value implies that the style
    // is to be removed at the end of the animation). If we had a simple
    // "OR" statement then it would not be enough to catch that.
    function registerRestorableStyles(backup, node, properties) {
        forEach(properties, function(prop) {
            backup[prop] = isDefined(backup[prop]) ? backup[prop] : node.style.getPropertyValue(prop);
        });
    }
    var $AnimateCssProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            this.$get = [
                "$window",
                "$$jqLite",
                "$$AnimateRunner",
                "$timeout",
                "$$animateCache",
                "$$forceReflow",
                "$sniffer",
                "$$rAFScheduler",
                "$$animateQueue",
                function($window, $$jqLite, $$AnimateRunner, $timeout, $$animateCache, $$forceReflow, $sniffer, $$rAFScheduler, $$animateQueue) {
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
                        var timings = $$animateCache.get(cacheKey);
                        if (!timings) {
                            timings = computeCssStyles($window, node, properties);
                            if (timings.animationIterationCount === "infinite") timings.animationIterationCount = 1;
                        }
                        // if a css animation has no duration we
                        // should mark that so that repeated addClass/removeClass calls are skipped
                        var hasDuration = allowNoDuration || timings.transitionDuration > 0 || timings.animationDuration > 0;
                        // we keep putting this in multiple times even though the value and the cacheKey are the same
                        // because we're keeping an internal tally of how many duplicate animations are detected.
                        $$animateCache.put(cacheKey, timings, hasDuration);
                        return timings;
                    }
                    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
                        var stagger;
                        var staggerCacheKey = "stagger-" + cacheKey;
                        // if we have one or more existing matches of matching elements
                        // containing the same parent + CSS styles (which is how cacheKey works)
                        // then staggering is possible
                        if ($$animateCache.count(cacheKey) > 0) {
                            stagger = $$animateCache.get(staggerCacheKey);
                            if (!stagger) {
                                var staggerClassName = pendClasses(className, "-stagger");
                                $$jqLite.addClass(node, staggerClassName);
                                stagger = computeCssStyles($window, node, properties);
                                // force the conversion of a null value to zero incase not set
                                stagger.animationDuration = Math.max(stagger.animationDuration, 0);
                                stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
                                $$jqLite.removeClass(node, staggerClassName);
                                $$animateCache.put(staggerCacheKey, stagger, true);
                            }
                        }
                        return stagger || {};
                    }
                    var rafWaitQueue = [];
                    function waitUntilQuiet(callback) {
                        rafWaitQueue.push(callback);
                        $$rAFScheduler.waitUntilQuiet(function() {
                            $$animateCache.flush();
                            // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
                            // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
                            var pageWidth = $$forceReflow();
                            // we use a for loop to ensure that if the queue is changed
                            // during this looping then it will consider new requests
                            for(var i = 0; i < rafWaitQueue.length; i++)rafWaitQueue[i](pageWidth);
                            rafWaitQueue.length = 0;
                        });
                    }
                    function computeTimings(node, className, cacheKey, allowNoDuration) {
                        var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
                        var aD = timings.animationDelay;
                        var tD = timings.transitionDelay;
                        timings.maxDelay = aD && tD ? Math.max(aD, tD) : aD || tD;
                        timings.maxDuration = Math.max(timings.animationDuration * timings.animationIterationCount, timings.transitionDuration);
                        return timings;
                    }
                    return function init(element, initialOptions) {
                        // all of the animation functions should create
                        // a copy of the options data, however, if a
                        // parent service has already created a copy then
                        // we should stick to using that
                        var options = initialOptions || {};
                        if (!options.$$prepared) options = prepareAnimationOptions(copy(options));
                        var restoreStyles = {};
                        var node = getDomNode(element);
                        if (!node || !node.parentNode || !$$animateQueue.enabled()) return closeAndReturnNoopAnimator();
                        var temporaryStyles = [];
                        var classes = element.attr("class");
                        var styles = packageStyles(options);
                        var animationClosed;
                        var animationPaused;
                        var animationCompleted;
                        var runner;
                        var runnerHost;
                        var maxDelay;
                        var maxDelayTime;
                        var maxDuration;
                        var maxDurationTime;
                        var startTime;
                        var events = [];
                        if (options.duration === 0 || !$sniffer.animations && !$sniffer.transitions) return closeAndReturnNoopAnimator();
                        var method = options.event && isArray(options.event) ? options.event.join(" ") : options.event;
                        var isStructural = method && options.structural;
                        var structuralClassName = "";
                        var addRemoveClassName = "";
                        if (isStructural) structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
                        else if (method) structuralClassName = method;
                        if (options.addClass) addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
                        if (options.removeClass) {
                            if (addRemoveClassName.length) addRemoveClassName += " ";
                            addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
                        }
                        // there may be a situation where a structural animation is combined together
                        // with CSS classes that need to resolve before the animation is computed.
                        // However this means that there is no explicit CSS code to block the animation
                        // from happening (by setting 0s none in the class name). If this is the case
                        // we need to apply the classes before the first rAF so we know to continue if
                        // there actually is a detected transition or keyframe animation
                        if (options.applyClassesEarly && addRemoveClassName.length) applyAnimationClasses(element, options);
                        var preparationClasses = [
                            structuralClassName,
                            addRemoveClassName
                        ].join(" ").trim();
                        var fullClassName = classes + " " + preparationClasses;
                        var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
                        var containsKeyframeAnimation = (options.keyframeStyle || "").length > 0;
                        // there is no way we can trigger an animation if no styles and
                        // no classes are being applied which would then trigger a transition,
                        // unless there a is raw keyframe value that is applied to the element.
                        if (!containsKeyframeAnimation && !hasToStyles && !preparationClasses) return closeAndReturnNoopAnimator();
                        var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
                        if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                            preparationClasses = null;
                            return closeAndReturnNoopAnimator();
                        }
                        if (options.stagger > 0) {
                            var staggerVal = parseFloat(options.stagger);
                            stagger = {
                                transitionDelay: staggerVal,
                                animationDelay: staggerVal,
                                transitionDuration: 0,
                                animationDuration: 0
                            };
                        } else stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
                        if (!options.$$skipPreparationClasses) $$jqLite.addClass(element, preparationClasses);
                        var applyOnlyDuration;
                        if (options.transitionStyle) {
                            var transitionStyle = [
                                TRANSITION_PROP,
                                options.transitionStyle
                            ];
                            applyInlineStyle(node, transitionStyle);
                            temporaryStyles.push(transitionStyle);
                        }
                        if (options.duration >= 0) {
                            applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
                            var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
                            // we set the duration so that it will be picked up by getComputedStyle later
                            applyInlineStyle(node, durationStyle);
                            temporaryStyles.push(durationStyle);
                        }
                        if (options.keyframeStyle) {
                            var keyframeStyle = [
                                ANIMATION_PROP,
                                options.keyframeStyle
                            ];
                            applyInlineStyle(node, keyframeStyle);
                            temporaryStyles.push(keyframeStyle);
                        }
                        var itemIndex = stagger ? options.staggerIndex >= 0 ? options.staggerIndex : $$animateCache.count(cacheKey) : 0;
                        var isFirst = itemIndex === 0;
                        // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
                        // without causing any combination of transitions to kick in. By adding a negative delay value
                        // it forces the setup class' transition to end immediately. We later then remove the negative
                        // transition delay to allow for the transition to naturally do it's thing. The beauty here is
                        // that if there is no transition defined then nothing will happen and this will also allow
                        // other transitions to be stacked on top of each other without any chopping them out.
                        if (isFirst && !options.skipBlocking) helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
                        var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
                        var relativeDelay = timings.maxDelay;
                        maxDelay = Math.max(relativeDelay, 0);
                        maxDuration = timings.maxDuration;
                        var flags = {};
                        flags.hasTransitions = timings.transitionDuration > 0;
                        flags.hasAnimations = timings.animationDuration > 0;
                        flags.hasTransitionAll = flags.hasTransitions && timings.transitionProperty === "all";
                        flags.applyTransitionDuration = hasToStyles && (flags.hasTransitions && !flags.hasTransitionAll || flags.hasAnimations && !flags.hasTransitions);
                        flags.applyAnimationDuration = options.duration && flags.hasAnimations;
                        flags.applyTransitionDelay = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
                        flags.applyAnimationDelay = truthyTimingValue(options.delay) && flags.hasAnimations;
                        flags.recalculateTimingStyles = addRemoveClassName.length > 0;
                        if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
                            maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
                            if (flags.applyTransitionDuration) {
                                flags.hasTransitions = true;
                                timings.transitionDuration = maxDuration;
                                applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
                                temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
                            }
                            if (flags.applyAnimationDuration) {
                                flags.hasAnimations = true;
                                timings.animationDuration = maxDuration;
                                temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
                            }
                        }
                        if (maxDuration === 0 && !flags.recalculateTimingStyles) return closeAndReturnNoopAnimator();
                        var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
                        if (options.delay != null) {
                            var delayStyle;
                            if (typeof options.delay !== "boolean") {
                                delayStyle = parseFloat(options.delay);
                                // number in options.delay means we have to recalculate the delay for the closing timeout
                                maxDelay = Math.max(delayStyle, 0);
                            }
                            if (flags.applyTransitionDelay) temporaryStyles.push(getCssDelayStyle(delayStyle));
                            if (flags.applyAnimationDelay) temporaryStyles.push(getCssDelayStyle(delayStyle, true));
                        }
                        // we need to recalculate the delay value since we used a pre-emptive negative
                        // delay value and the delay value is required for the final event checking. This
                        // property will ensure that this will happen after the RAF phase has passed.
                        if (options.duration == null && timings.transitionDuration > 0) flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
                        maxDelayTime = maxDelay * ONE_SECOND;
                        maxDurationTime = maxDuration * ONE_SECOND;
                        if (!options.skipBlocking) {
                            flags.blockTransition = timings.transitionDuration > 0;
                            flags.blockKeyframeAnimation = timings.animationDuration > 0 && stagger.animationDelay > 0 && stagger.animationDuration === 0;
                        }
                        if (options.from) {
                            if (options.cleanupStyles) registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
                            applyAnimationFromStyles(element, options);
                        }
                        if (flags.blockTransition || flags.blockKeyframeAnimation) applyBlocking(maxDuration);
                        else if (!options.skipBlocking) helpers.blockTransitions(node, false);
                        // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
                        return {
                            $$willAnimate: true,
                            end: endFn,
                            start: function() {
                                if (animationClosed) return;
                                runnerHost = {
                                    end: endFn,
                                    cancel: cancelFn,
                                    resume: null,
                                    pause: null
                                };
                                runner = new $$AnimateRunner(runnerHost);
                                waitUntilQuiet(start);
                                // we don't have access to pause/resume the animation
                                // since it hasn't run yet. AnimateRunner will therefore
                                // set noop functions for resume and pause and they will
                                // later be overridden once the animation is triggered
                                return runner;
                            }
                        };
                        function endFn() {
                            close();
                        }
                        function cancelFn() {
                            close(true);
                        }
                        function close(rejected) {
                            // if the promise has been called already then we shouldn't close
                            // the animation again
                            if (animationClosed || animationCompleted && animationPaused) return;
                            animationClosed = true;
                            animationPaused = false;
                            if (preparationClasses && !options.$$skipPreparationClasses) $$jqLite.removeClass(element, preparationClasses);
                            if (activeClasses) $$jqLite.removeClass(element, activeClasses);
                            blockKeyframeAnimations(node, false);
                            helpers.blockTransitions(node, false);
                            forEach(temporaryStyles, function(entry) {
                                // There is only one way to remove inline style properties entirely from elements.
                                // By using `removeProperty` this works, but we need to convert camel-cased CSS
                                // styles down to hyphenated values.
                                node.style[entry[0]] = "";
                            });
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            if (Object.keys(restoreStyles).length) forEach(restoreStyles, function(value, prop) {
                                if (value) node.style.setProperty(prop, value);
                                else node.style.removeProperty(prop);
                            });
                            // the reason why we have this option is to allow a synchronous closing callback
                            // that is fired as SOON as the animation ends (when the CSS is removed) or if
                            // the animation never takes off at all. A good example is a leave animation since
                            // the element must be removed just after the animation is over or else the element
                            // will appear on screen for one animation frame causing an overbearing flicker.
                            if (options.onDone) options.onDone();
                            if (events && events.length) // Remove the transitionend / animationend listener(s)
                            element.off(events.join(" "), onAnimationProgress);
                            //Cancel the fallback closing timeout and remove the timer data
                            var animationTimerData = element.data(ANIMATE_TIMER_KEY);
                            if (animationTimerData) {
                                $timeout.cancel(animationTimerData[0].timer);
                                element.removeData(ANIMATE_TIMER_KEY);
                            }
                            // if the preparation function fails then the promise is not setup
                            if (runner) runner.complete(!rejected);
                        }
                        function applyBlocking(duration) {
                            if (flags.blockTransition) helpers.blockTransitions(node, duration);
                            if (flags.blockKeyframeAnimation) blockKeyframeAnimations(node, !!duration);
                        }
                        function closeAndReturnNoopAnimator() {
                            runner = new $$AnimateRunner({
                                end: endFn,
                                cancel: cancelFn
                            });
                            // should flush the cache animation
                            waitUntilQuiet(noop);
                            close();
                            return {
                                $$willAnimate: false,
                                start: function() {
                                    return runner;
                                },
                                end: endFn
                            };
                        }
                        function onAnimationProgress(event) {
                            event.stopPropagation();
                            var ev = event.originalEvent || event;
                            if (ev.target !== node) // Since TransitionEvent / AnimationEvent bubble up,
                            // we have to ignore events by finished child animations
                            return;
                            // we now always use `Date.now()` due to the recent changes with
                            // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
                            var timeStamp = ev.$manualTimeStamp || Date.now();
                            /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */ var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
                            /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */ if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                                // we set this flag to ensure that if the transition is paused then, when resumed,
                                // the animation will automatically close itself since transitions cannot be paused.
                                animationCompleted = true;
                                close();
                            }
                        }
                        function start() {
                            if (animationClosed) return;
                            if (!node.parentNode) {
                                close();
                                return;
                            }
                            // even though we only pause keyframe animations here the pause flag
                            // will still happen when transitions are used. Only the transition will
                            // not be paused since that is not possible. If the animation ends when
                            // paused then it will not complete until unpaused or cancelled.
                            var playPause = function(playAnimation) {
                                if (!animationCompleted) {
                                    animationPaused = !playAnimation;
                                    if (timings.animationDuration) {
                                        var value = blockKeyframeAnimations(node, animationPaused);
                                        if (animationPaused) temporaryStyles.push(value);
                                        else removeFromArray(temporaryStyles, value);
                                    }
                                } else if (animationPaused && playAnimation) {
                                    animationPaused = false;
                                    close();
                                }
                            };
                            // checking the stagger duration prevents an accidentally cascade of the CSS delay style
                            // being inherited from the parent. If the transition duration is zero then we can safely
                            // rely that the delay value is an intentional stagger delay style.
                            var maxStagger = itemIndex > 0 && (timings.transitionDuration && stagger.transitionDuration === 0 || timings.animationDuration && stagger.animationDuration === 0) && Math.max(stagger.animationDelay, stagger.transitionDelay);
                            if (maxStagger) $timeout(triggerAnimationStart, Math.floor(maxStagger * itemIndex * ONE_SECOND), false);
                            else triggerAnimationStart();
                            // this will decorate the existing promise runner with pause/resume methods
                            runnerHost.resume = function() {
                                playPause(true);
                            };
                            runnerHost.pause = function() {
                                playPause(false);
                            };
                            function triggerAnimationStart() {
                                // just incase a stagger animation kicks in when the animation
                                // itself was cancelled entirely
                                if (animationClosed) return;
                                applyBlocking(false);
                                forEach(temporaryStyles, function(entry) {
                                    var key = entry[0];
                                    var value = entry[1];
                                    node.style[key] = value;
                                });
                                applyAnimationClasses(element, options);
                                $$jqLite.addClass(element, activeClasses);
                                if (flags.recalculateTimingStyles) {
                                    fullClassName = node.getAttribute("class") + " " + preparationClasses;
                                    cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
                                    timings = computeTimings(node, fullClassName, cacheKey, false);
                                    relativeDelay = timings.maxDelay;
                                    maxDelay = Math.max(relativeDelay, 0);
                                    maxDuration = timings.maxDuration;
                                    if (maxDuration === 0) {
                                        close();
                                        return;
                                    }
                                    flags.hasTransitions = timings.transitionDuration > 0;
                                    flags.hasAnimations = timings.animationDuration > 0;
                                }
                                if (flags.applyAnimationDelay) {
                                    relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay) ? parseFloat(options.delay) : relativeDelay;
                                    maxDelay = Math.max(relativeDelay, 0);
                                    timings.animationDelay = relativeDelay;
                                    delayStyle = getCssDelayStyle(relativeDelay, true);
                                    temporaryStyles.push(delayStyle);
                                    node.style[delayStyle[0]] = delayStyle[1];
                                }
                                maxDelayTime = maxDelay * ONE_SECOND;
                                maxDurationTime = maxDuration * ONE_SECOND;
                                if (options.easing) {
                                    var easeProp, easeVal = options.easing;
                                    if (flags.hasTransitions) {
                                        easeProp = TRANSITION_PROP + TIMING_KEY;
                                        temporaryStyles.push([
                                            easeProp,
                                            easeVal
                                        ]);
                                        node.style[easeProp] = easeVal;
                                    }
                                    if (flags.hasAnimations) {
                                        easeProp = ANIMATION_PROP + TIMING_KEY;
                                        temporaryStyles.push([
                                            easeProp,
                                            easeVal
                                        ]);
                                        node.style[easeProp] = easeVal;
                                    }
                                }
                                if (timings.transitionDuration) events.push(TRANSITIONEND_EVENT);
                                if (timings.animationDuration) events.push(ANIMATIONEND_EVENT);
                                startTime = Date.now();
                                var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
                                var endTime = startTime + timerTime;
                                var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
                                var setupFallbackTimer = true;
                                if (animationsData.length) {
                                    var currentTimerData = animationsData[0];
                                    setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
                                    if (setupFallbackTimer) $timeout.cancel(currentTimerData.timer);
                                    else animationsData.push(close);
                                }
                                if (setupFallbackTimer) {
                                    var timer = $timeout(onAnimationExpired, timerTime, false);
                                    animationsData[0] = {
                                        timer: timer,
                                        expectedEndTime: endTime
                                    };
                                    animationsData.push(close);
                                    element.data(ANIMATE_TIMER_KEY, animationsData);
                                }
                                if (events.length) element.on(events.join(" "), onAnimationProgress);
                                if (options.to) {
                                    if (options.cleanupStyles) registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
                                    applyAnimationToStyles(element, options);
                                }
                            }
                            function onAnimationExpired() {
                                var animationsData = element.data(ANIMATE_TIMER_KEY);
                                // this will be false in the event that the element was
                                // removed from the DOM (via a leave animation or something
                                // similar)
                                if (animationsData) {
                                    for(var i = 1; i < animationsData.length; i++)animationsData[i]();
                                    element.removeData(ANIMATE_TIMER_KEY);
                                }
                            }
                        }
                    };
                }
            ];
        }
    ];
    var $$AnimateCssDriverProvider = [
        "$$animationProvider",
        /** @this */ function($$animationProvider) {
            $$animationProvider.drivers.push("$$animateCssDriver");
            var NG_ANIMATE_SHIM_CLASS_NAME = "ng-animate-shim";
            var NG_ANIMATE_ANCHOR_CLASS_NAME = "ng-anchor";
            var NG_OUT_ANCHOR_CLASS_NAME = "ng-anchor-out";
            var NG_IN_ANCHOR_CLASS_NAME = "ng-anchor-in";
            function isDocumentFragment(node) {
                return node.parentNode && node.parentNode.nodeType === 11;
            }
            this.$get = [
                "$animateCss",
                "$rootScope",
                "$$AnimateRunner",
                "$rootElement",
                "$sniffer",
                "$$jqLite",
                "$document",
                function($animateCss, $rootScope, $$AnimateRunner, $rootElement, $sniffer, $$jqLite, $document) {
                    // only browsers that support these properties can render animations
                    if (!$sniffer.animations && !$sniffer.transitions) return noop;
                    var bodyNode = $document[0].body;
                    var rootNode = getDomNode($rootElement);
                    var rootBodyElement = jqLite(// this is to avoid using something that exists outside of the body
                    // we also special case the doc fragment case because our unit test code
                    // appends the $rootElement to the body after the app has been bootstrapped
                    isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode);
                    return function initDriverFn(animationDetails) {
                        return animationDetails.from && animationDetails.to ? prepareFromToAnchorAnimation(animationDetails.from, animationDetails.to, animationDetails.classes, animationDetails.anchors) : prepareRegularAnimation(animationDetails);
                    };
                    function filterCssClasses(classes) {
                        //remove all the `ng-` stuff
                        return classes.replace(/\bng-\S+\b/g, "");
                    }
                    function getUniqueValues(a, b) {
                        if (isString(a)) a = a.split(" ");
                        if (isString(b)) b = b.split(" ");
                        return a.filter(function(val) {
                            return b.indexOf(val) === -1;
                        }).join(" ");
                    }
                    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
                        var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
                        var startingClasses = filterCssClasses(getClassVal(clone));
                        outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
                        rootBodyElement.append(clone);
                        var animatorIn, animatorOut = prepareOutAnimation();
                        // the user may not end up using the `out` animation and
                        // only making use of the `in` animation or vice-versa.
                        // In either case we should allow this and not assume the
                        // animation is over unless both animations are not used.
                        if (!animatorOut) {
                            animatorIn = prepareInAnimation();
                            if (!animatorIn) return end();
                        }
                        var startingAnimator = animatorOut || animatorIn;
                        return {
                            start: function() {
                                var runner;
                                var currentAnimation = startingAnimator.start();
                                currentAnimation.done(function() {
                                    currentAnimation = null;
                                    if (!animatorIn) {
                                        animatorIn = prepareInAnimation();
                                        if (animatorIn) {
                                            currentAnimation = animatorIn.start();
                                            currentAnimation.done(function() {
                                                currentAnimation = null;
                                                end();
                                                runner.complete();
                                            });
                                            return currentAnimation;
                                        }
                                    }
                                    // in the event that there is no `in` animation
                                    end();
                                    runner.complete();
                                });
                                runner = new $$AnimateRunner({
                                    end: endFn,
                                    cancel: endFn
                                });
                                return runner;
                                function endFn() {
                                    if (currentAnimation) currentAnimation.end();
                                }
                            }
                        };
                        function calculateAnchorStyles(anchor) {
                            var styles = {};
                            var coords = getDomNode(anchor).getBoundingClientRect();
                            // we iterate directly since safari messes up and doesn't return
                            // all the keys for the coords object when iterated
                            forEach([
                                "width",
                                "height",
                                "top",
                                "left"
                            ], function(key) {
                                var value = coords[key];
                                switch(key){
                                    case "top":
                                        value += bodyNode.scrollTop;
                                        break;
                                    case "left":
                                        value += bodyNode.scrollLeft;
                                        break;
                                }
                                styles[key] = Math.floor(value) + "px";
                            });
                            return styles;
                        }
                        function prepareOutAnimation() {
                            var animator = $animateCss(clone, {
                                addClass: NG_OUT_ANCHOR_CLASS_NAME,
                                delay: true,
                                from: calculateAnchorStyles(outAnchor)
                            });
                            // read the comment within `prepareRegularAnimation` to understand
                            // why this check is necessary
                            return animator.$$willAnimate ? animator : null;
                        }
                        function getClassVal(element) {
                            return element.attr("class") || "";
                        }
                        function prepareInAnimation() {
                            var endingClasses = filterCssClasses(getClassVal(inAnchor));
                            var toAdd = getUniqueValues(endingClasses, startingClasses);
                            var toRemove = getUniqueValues(startingClasses, endingClasses);
                            var animator = $animateCss(clone, {
                                to: calculateAnchorStyles(inAnchor),
                                addClass: NG_IN_ANCHOR_CLASS_NAME + " " + toAdd,
                                removeClass: NG_OUT_ANCHOR_CLASS_NAME + " " + toRemove,
                                delay: true
                            });
                            // read the comment within `prepareRegularAnimation` to understand
                            // why this check is necessary
                            return animator.$$willAnimate ? animator : null;
                        }
                        function end() {
                            clone.remove();
                            outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
                            inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        }
                    }
                    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
                        var fromAnimation = prepareRegularAnimation(from, noop);
                        var toAnimation = prepareRegularAnimation(to, noop);
                        var anchorAnimations = [];
                        forEach(anchors, function(anchor) {
                            var outElement = anchor["out"];
                            var inElement = anchor["in"];
                            var animator = prepareAnchoredAnimation(classes, outElement, inElement);
                            if (animator) anchorAnimations.push(animator);
                        });
                        // no point in doing anything when there are no elements to animate
                        if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
                        return {
                            start: function() {
                                var animationRunners = [];
                                if (fromAnimation) animationRunners.push(fromAnimation.start());
                                if (toAnimation) animationRunners.push(toAnimation.start());
                                forEach(anchorAnimations, function(animation) {
                                    animationRunners.push(animation.start());
                                });
                                var runner = new $$AnimateRunner({
                                    end: endFn,
                                    cancel: endFn // CSS-driven animations cannot be cancelled, only ended
                                });
                                $$AnimateRunner.all(animationRunners, function(status) {
                                    runner.complete(status);
                                });
                                return runner;
                                function endFn() {
                                    forEach(animationRunners, function(runner) {
                                        runner.end();
                                    });
                                }
                            }
                        };
                    }
                    function prepareRegularAnimation(animationDetails) {
                        var element = animationDetails.element;
                        var options = animationDetails.options || {};
                        if (animationDetails.structural) {
                            options.event = animationDetails.event;
                            options.structural = true;
                            options.applyClassesEarly = true;
                            // we special case the leave animation since we want to ensure that
                            // the element is removed as soon as the animation is over. Otherwise
                            // a flicker might appear or the element may not be removed at all
                            if (animationDetails.event === "leave") options.onDone = options.domOperation;
                        }
                        // We assign the preparationClasses as the actual animation event since
                        // the internals of $animateCss will just suffix the event token values
                        // with `-active` to trigger the animation.
                        if (options.preparationClasses) options.event = concatWithSpace(options.event, options.preparationClasses);
                        var animator = $animateCss(element, options);
                        // the driver lookup code inside of $$animation attempts to spawn a
                        // driver one by one until a driver returns a.$$willAnimate animator object.
                        // $animateCss will always return an object, however, it will pass in
                        // a flag as a hint as to whether an animation was detected or not
                        return animator.$$willAnimate ? animator : null;
                    }
                }
            ];
        }
    ];
    // TODO(matsko): use caching here to speed things up for detection
    // TODO(matsko): add documentation
    //  by the time...
    var $$AnimateJsProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            this.$get = [
                "$injector",
                "$$AnimateRunner",
                "$$jqLite",
                function($injector, $$AnimateRunner, $$jqLite) {
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    // $animateJs(element, 'enter');
                    return function(element, event, classes, options) {
                        var animationClosed = false;
                        // the `classes` argument is optional and if it is not used
                        // then the classes will be resolved from the element's className
                        // property as well as options.addClass/options.removeClass.
                        if (arguments.length === 3 && isObject(classes)) {
                            options = classes;
                            classes = null;
                        }
                        options = prepareAnimationOptions(options);
                        if (!classes) {
                            classes = element.attr("class") || "";
                            if (options.addClass) classes += " " + options.addClass;
                            if (options.removeClass) classes += " " + options.removeClass;
                        }
                        var classesToAdd = options.addClass;
                        var classesToRemove = options.removeClass;
                        // the lookupAnimations function returns a series of animation objects that are
                        // matched up with one or more of the CSS classes. These animation objects are
                        // defined via the module.animation factory function. If nothing is detected then
                        // we don't return anything which then makes $animation query the next driver.
                        var animations = lookupAnimations(classes);
                        var before, after;
                        if (animations.length) {
                            var afterFn, beforeFn;
                            if (event === "leave") {
                                beforeFn = "leave";
                                afterFn = "afterLeave"; // TODO(matsko): get rid of this
                            } else {
                                beforeFn = "before" + event.charAt(0).toUpperCase() + event.substr(1);
                                afterFn = event;
                            }
                            if (event !== "enter" && event !== "move") before = packageAnimations(element, event, options, animations, beforeFn);
                            after = packageAnimations(element, event, options, animations, afterFn);
                        }
                        // no matching animations
                        if (!before && !after) return;
                        function applyOptions() {
                            options.domOperation();
                            applyAnimationClasses(element, options);
                        }
                        function close() {
                            animationClosed = true;
                            applyOptions();
                            applyAnimationStyles(element, options);
                        }
                        var runner;
                        return {
                            $$willAnimate: true,
                            end: function() {
                                if (runner) runner.end();
                                else {
                                    close();
                                    runner = new $$AnimateRunner();
                                    runner.complete(true);
                                }
                                return runner;
                            },
                            start: function() {
                                if (runner) return runner;
                                runner = new $$AnimateRunner();
                                var closeActiveAnimations;
                                var chain = [];
                                if (before) chain.push(function(fn) {
                                    closeActiveAnimations = before(fn);
                                });
                                if (chain.length) chain.push(function(fn) {
                                    applyOptions();
                                    fn(true);
                                });
                                else applyOptions();
                                if (after) chain.push(function(fn) {
                                    closeActiveAnimations = after(fn);
                                });
                                runner.setHost({
                                    end: function() {
                                        endAnimations();
                                    },
                                    cancel: function() {
                                        endAnimations(true);
                                    }
                                });
                                $$AnimateRunner.chain(chain, onComplete);
                                return runner;
                                function onComplete(success) {
                                    close(success);
                                    runner.complete(success);
                                }
                                function endAnimations(cancelled) {
                                    if (!animationClosed) {
                                        (closeActiveAnimations || noop)(cancelled);
                                        onComplete(cancelled);
                                    }
                                }
                            }
                        };
                        function executeAnimationFn(fn, element, event, options, onDone) {
                            var args;
                            switch(event){
                                case "animate":
                                    args = [
                                        element,
                                        options.from,
                                        options.to,
                                        onDone
                                    ];
                                    break;
                                case "setClass":
                                    args = [
                                        element,
                                        classesToAdd,
                                        classesToRemove,
                                        onDone
                                    ];
                                    break;
                                case "addClass":
                                    args = [
                                        element,
                                        classesToAdd,
                                        onDone
                                    ];
                                    break;
                                case "removeClass":
                                    args = [
                                        element,
                                        classesToRemove,
                                        onDone
                                    ];
                                    break;
                                default:
                                    args = [
                                        element,
                                        onDone
                                    ];
                                    break;
                            }
                            args.push(options);
                            var value = fn.apply(fn, args);
                            if (value) {
                                if (isFunction(value.start)) value = value.start();
                                if (value instanceof $$AnimateRunner) value.done(onDone);
                                else if (isFunction(value)) // optional onEnd / onCancel callback
                                return value;
                            }
                            return noop;
                        }
                        function groupEventedAnimations(element, event, options, animations, fnName) {
                            var operations = [];
                            forEach(animations, function(ani) {
                                var animation = ani[fnName];
                                if (!animation) return;
                                // note that all of these animations will run in parallel
                                operations.push(function() {
                                    var runner;
                                    var endProgressCb;
                                    var resolved = false;
                                    var onAnimationComplete = function(rejected) {
                                        if (!resolved) {
                                            resolved = true;
                                            (endProgressCb || noop)(rejected);
                                            runner.complete(!rejected);
                                        }
                                    };
                                    runner = new $$AnimateRunner({
                                        end: function() {
                                            onAnimationComplete();
                                        },
                                        cancel: function() {
                                            onAnimationComplete(true);
                                        }
                                    });
                                    endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
                                        var cancelled = result === false;
                                        onAnimationComplete(cancelled);
                                    });
                                    return runner;
                                });
                            });
                            return operations;
                        }
                        function packageAnimations(element, event, options, animations, fnName) {
                            var operations = groupEventedAnimations(element, event, options, animations, fnName);
                            if (operations.length === 0) {
                                var a, b;
                                if (fnName === "beforeSetClass") {
                                    a = groupEventedAnimations(element, "removeClass", options, animations, "beforeRemoveClass");
                                    b = groupEventedAnimations(element, "addClass", options, animations, "beforeAddClass");
                                } else if (fnName === "setClass") {
                                    a = groupEventedAnimations(element, "removeClass", options, animations, "removeClass");
                                    b = groupEventedAnimations(element, "addClass", options, animations, "addClass");
                                }
                                if (a) operations = operations.concat(a);
                                if (b) operations = operations.concat(b);
                            }
                            if (operations.length === 0) return;
                            // TODO(matsko): add documentation
                            return function startAnimation(callback) {
                                var runners = [];
                                if (operations.length) forEach(operations, function(animateFn) {
                                    runners.push(animateFn());
                                });
                                if (runners.length) $$AnimateRunner.all(runners, callback);
                                else callback();
                                return function endFn(reject) {
                                    forEach(runners, function(runner) {
                                        if (reject) runner.cancel();
                                        else runner.end();
                                    });
                                };
                            };
                        }
                    };
                    function lookupAnimations(classes) {
                        classes = isArray(classes) ? classes : classes.split(" ");
                        var matches = [], flagMap = {};
                        for(var i = 0; i < classes.length; i++){
                            var klass = classes[i], animationFactory = $animateProvider.$$registeredAnimations[klass];
                            if (animationFactory && !flagMap[klass]) {
                                matches.push($injector.get(animationFactory));
                                flagMap[klass] = true;
                            }
                        }
                        return matches;
                    }
                }
            ];
        }
    ];
    var $$AnimateJsDriverProvider = [
        "$$animationProvider",
        /** @this */ function($$animationProvider) {
            $$animationProvider.drivers.push("$$animateJsDriver");
            this.$get = [
                "$$animateJs",
                "$$AnimateRunner",
                function($$animateJs, $$AnimateRunner) {
                    return function initDriverFn(animationDetails) {
                        if (animationDetails.from && animationDetails.to) {
                            var fromAnimation = prepareAnimation(animationDetails.from);
                            var toAnimation = prepareAnimation(animationDetails.to);
                            if (!fromAnimation && !toAnimation) return;
                            return {
                                start: function() {
                                    var animationRunners = [];
                                    if (fromAnimation) animationRunners.push(fromAnimation.start());
                                    if (toAnimation) animationRunners.push(toAnimation.start());
                                    $$AnimateRunner.all(animationRunners, done);
                                    var runner = new $$AnimateRunner({
                                        end: endFnFactory(),
                                        cancel: endFnFactory()
                                    });
                                    return runner;
                                    function endFnFactory() {
                                        return function() {
                                            forEach(animationRunners, function(runner) {
                                                // at this point we cannot cancel animations for groups just yet. 1.5+
                                                runner.end();
                                            });
                                        };
                                    }
                                    function done(status) {
                                        runner.complete(status);
                                    }
                                }
                            };
                        } else return prepareAnimation(animationDetails);
                    };
                    function prepareAnimation(animationDetails) {
                        // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
                        var element = animationDetails.element;
                        var event = animationDetails.event;
                        var options = animationDetails.options;
                        var classes = animationDetails.classes;
                        return $$animateJs(element, event, classes, options);
                    }
                }
            ];
        }
    ];
    var NG_ANIMATE_ATTR_NAME = "data-ng-animate";
    var NG_ANIMATE_PIN_DATA = "$ngAnimatePin";
    var $$AnimateQueueProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            var PRE_DIGEST_STATE = 1;
            var RUNNING_STATE = 2;
            var ONE_SPACE = " ";
            var rules = this.rules = {
                skip: [],
                cancel: [],
                join: []
            };
            function getEventData(options) {
                return {
                    addClass: options.addClass,
                    removeClass: options.removeClass,
                    from: options.from,
                    to: options.to
                };
            }
            function makeTruthyCssClassMap(classString) {
                if (!classString) return null;
                var keys = classString.split(ONE_SPACE);
                var map = Object.create(null);
                forEach(keys, function(key) {
                    map[key] = true;
                });
                return map;
            }
            function hasMatchingClasses(newClassString, currentClassString) {
                if (newClassString && currentClassString) {
                    var currentClassMap = makeTruthyCssClassMap(currentClassString);
                    return newClassString.split(ONE_SPACE).some(function(className) {
                        return currentClassMap[className];
                    });
                }
            }
            function isAllowed(ruleType, currentAnimation, previousAnimation) {
                return rules[ruleType].some(function(fn) {
                    return fn(currentAnimation, previousAnimation);
                });
            }
            function hasAnimationClasses(animation, and) {
                var a = (animation.addClass || "").length > 0;
                var b = (animation.removeClass || "").length > 0;
                return and ? a && b : a || b;
            }
            rules.join.push(function(newAnimation, currentAnimation) {
                // if the new animation is class-based then we can just tack that on
                return !newAnimation.structural && hasAnimationClasses(newAnimation);
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // there is no need to animate anything if no classes are being added and
                // there is no structural animation that will be triggered
                return !newAnimation.structural && !hasAnimationClasses(newAnimation);
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // why should we trigger a new structural animation if the element will
                // be removed from the DOM anyway?
                return currentAnimation.event === "leave" && newAnimation.structural;
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // if there is an ongoing current animation then don't even bother running the class-based animation
                return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // there can never be two structural animations running at the same time
                return currentAnimation.structural && newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // if the previous animation is already running, but the new animation will
                // be triggered, but the new animation is structural
                return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // cancel the animation if classes added / removed in both animation cancel each other out,
                // but only if the current animation isn't structural
                if (currentAnimation.structural) return false;
                var nA = newAnimation.addClass;
                var nR = newAnimation.removeClass;
                var cA = currentAnimation.addClass;
                var cR = currentAnimation.removeClass;
                // early detection to save the global CPU shortage :)
                if (isUndefined(nA) && isUndefined(nR) || isUndefined(cA) && isUndefined(cR)) return false;
                return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
            });
            this.$get = [
                "$$rAF",
                "$rootScope",
                "$rootElement",
                "$document",
                "$$Map",
                "$$animation",
                "$$AnimateRunner",
                "$templateRequest",
                "$$jqLite",
                "$$forceReflow",
                "$$isDocumentHidden",
                function($$rAF, $rootScope, $rootElement, $document, $$Map, $$animation, $$AnimateRunner, $templateRequest, $$jqLite, $$forceReflow, $$isDocumentHidden) {
                    var activeAnimationsLookup = new $$Map();
                    var disabledElementsLookup = new $$Map();
                    var animationsEnabled = null;
                    function removeFromDisabledElementsLookup(evt) {
                        disabledElementsLookup.delete(evt.target);
                    }
                    function postDigestTaskFactory() {
                        var postDigestCalled = false;
                        return function(fn) {
                            // we only issue a call to postDigest before
                            // it has first passed. This prevents any callbacks
                            // from not firing once the animation has completed
                            // since it will be out of the digest cycle.
                            if (postDigestCalled) fn();
                            else $rootScope.$$postDigest(function() {
                                postDigestCalled = true;
                                fn();
                            });
                        };
                    }
                    // Wait until all directive and route-related templates are downloaded and
                    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
                    // all of the remote templates being currently downloaded. If there are no
                    // templates currently downloading then the watcher will still fire anyway.
                    var deregisterWatch = $rootScope.$watch(function() {
                        return $templateRequest.totalPendingRequests === 0;
                    }, function(isEmpty) {
                        if (!isEmpty) return;
                        deregisterWatch();
                        // Now that all templates have been downloaded, $animate will wait until
                        // the post digest queue is empty before enabling animations. By having two
                        // calls to $postDigest calls we can ensure that the flag is enabled at the
                        // very end of the post digest queue. Since all of the animations in $animate
                        // use $postDigest, it's important that the code below executes at the end.
                        // This basically means that the page is fully downloaded and compiled before
                        // any animations are triggered.
                        $rootScope.$$postDigest(function() {
                            $rootScope.$$postDigest(function() {
                                // we check for null directly in the event that the application already called
                                // .enabled() with whatever arguments that it provided it with
                                if (animationsEnabled === null) animationsEnabled = true;
                            });
                        });
                    });
                    var callbackRegistry = Object.create(null);
                    // remember that the `customFilter`/`classNameFilter` are set during the
                    // provider/config stage therefore we can optimize here and setup helper functions
                    var customFilter = $animateProvider.customFilter();
                    var classNameFilter = $animateProvider.classNameFilter();
                    var returnTrue = function() {
                        return true;
                    };
                    var isAnimatableByFilter = customFilter || returnTrue;
                    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
                        var className = [
                            node.getAttribute("class"),
                            options.addClass,
                            options.removeClass
                        ].join(" ");
                        return classNameFilter.test(className);
                    };
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function normalizeAnimationDetails(element, animation) {
                        return mergeAnimationDetails(element, animation, {});
                    }
                    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
                    var contains = window1.Node.prototype.contains || /** @this */ function(arg) {
                        // eslint-disable-next-line no-bitwise
                        return this === arg || !!(this.compareDocumentPosition(arg) & 16);
                    };
                    function findCallbacks(targetParentNode, targetNode, event) {
                        var matches = [];
                        var entries = callbackRegistry[event];
                        if (entries) forEach(entries, function(entry) {
                            if (contains.call(entry.node, targetNode)) matches.push(entry.callback);
                            else if (event === "leave" && contains.call(entry.node, targetParentNode)) matches.push(entry.callback);
                        });
                        return matches;
                    }
                    function filterFromRegistry(list, matchContainer, matchCallback) {
                        var containerNode = extractElementNode(matchContainer);
                        return list.filter(function(entry) {
                            var isMatch = entry.node === containerNode && (!matchCallback || entry.callback === matchCallback);
                            return !isMatch;
                        });
                    }
                    function cleanupEventListeners(phase, node) {
                        if (phase === "close" && !node.parentNode) // If the element is not attached to a parentNode, it has been removed by
                        // the domOperation, and we can safely remove the event callbacks
                        $animate.off(node);
                    }
                    var $animate = {
                        on: function(event, container, callback) {
                            var node = extractElementNode(container);
                            callbackRegistry[event] = callbackRegistry[event] || [];
                            callbackRegistry[event].push({
                                node: node,
                                callback: callback
                            });
                            // Remove the callback when the element is removed from the DOM
                            jqLite(container).on("$destroy", function() {
                                var animationDetails = activeAnimationsLookup.get(node);
                                if (!animationDetails) // If there's an animation ongoing, the callback calling code will remove
                                // the event listeners. If we'd remove here, the callbacks would be removed
                                // before the animation ends
                                $animate.off(event, container, callback);
                            });
                        },
                        off: function(event, container, callback) {
                            if (arguments.length === 1 && !isString(arguments[0])) {
                                container = arguments[0];
                                for(var eventType in callbackRegistry)callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
                                return;
                            }
                            var entries = callbackRegistry[event];
                            if (!entries) return;
                            callbackRegistry[event] = arguments.length === 1 ? null : filterFromRegistry(entries, container, callback);
                        },
                        pin: function(element, parentElement) {
                            assertArg(isElement(element), "element", "not an element");
                            assertArg(isElement(parentElement), "parentElement", "not an element");
                            element.data(NG_ANIMATE_PIN_DATA, parentElement);
                        },
                        push: function(element, event, options, domOperation) {
                            options = options || {};
                            options.domOperation = domOperation;
                            return queueAnimation(element, event, options);
                        },
                        // this method has four signatures:
                        //  () - global getter
                        //  (bool) - global setter
                        //  (element) - element getter
                        //  (element, bool) - element setter<F37>
                        enabled: function(element, bool) {
                            var argCount = arguments.length;
                            if (argCount === 0) // () - Global getter
                            bool = !!animationsEnabled;
                            else {
                                var hasElement = isElement(element);
                                if (!hasElement) // (bool) - Global setter
                                bool = animationsEnabled = !!element;
                                else {
                                    var node = getDomNode(element);
                                    if (argCount === 1) // (element) - Element getter
                                    bool = !disabledElementsLookup.get(node);
                                    else {
                                        // (element, bool) - Element setter
                                        if (!disabledElementsLookup.has(node)) // The element is added to the map for the first time.
                                        // Create a listener to remove it on `$destroy` (to avoid memory leak).
                                        jqLite(element).on("$destroy", removeFromDisabledElementsLookup);
                                        disabledElementsLookup.set(node, !bool);
                                    }
                                }
                            }
                            return bool;
                        }
                    };
                    return $animate;
                    function queueAnimation(originalElement, event, initialOptions) {
                        // we always make a copy of the options since
                        // there should never be any side effects on
                        // the input data when running `$animateCss`.
                        var options = copy(initialOptions);
                        var element = stripCommentsFromElement(originalElement);
                        var node = getDomNode(element);
                        var parentNode = node && node.parentNode;
                        options = prepareAnimationOptions(options);
                        // we create a fake runner with a working promise.
                        // These methods will become available after the digest has passed
                        var runner = new $$AnimateRunner();
                        // this is used to trigger callbacks in postDigest mode
                        var runInNextPostDigestOrNow = postDigestTaskFactory();
                        if (isArray(options.addClass)) options.addClass = options.addClass.join(" ");
                        if (options.addClass && !isString(options.addClass)) options.addClass = null;
                        if (isArray(options.removeClass)) options.removeClass = options.removeClass.join(" ");
                        if (options.removeClass && !isString(options.removeClass)) options.removeClass = null;
                        if (options.from && !isObject(options.from)) options.from = null;
                        if (options.to && !isObject(options.to)) options.to = null;
                        // If animations are hard-disabled for the whole application there is no need to continue.
                        // There are also situations where a directive issues an animation for a jqLite wrapper that
                        // contains only comment nodes. In this case, there is no way we can perform an animation.
                        if (!animationsEnabled || !node || !isAnimatableByFilter(node, event, initialOptions) || !isAnimatableClassName(node, options)) {
                            close();
                            return runner;
                        }
                        var isStructural = [
                            "enter",
                            "move",
                            "leave"
                        ].indexOf(event) >= 0;
                        var documentHidden = $$isDocumentHidden();
                        // This is a hard disable of all animations the element itself, therefore  there is no need to
                        // continue further past this point if not enabled
                        // Animations are also disabled if the document is currently hidden (page is not visible
                        // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
                        var skipAnimations = documentHidden || disabledElementsLookup.get(node);
                        var existingAnimation = !skipAnimations && activeAnimationsLookup.get(node) || {};
                        var hasExistingAnimation = !!existingAnimation.state;
                        // there is no point in traversing the same collection of parent ancestors if a followup
                        // animation will be run on the same element that already did all that checking work
                        if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) skipAnimations = !areAnimationsAllowed(node, parentNode, event);
                        if (skipAnimations) {
                            // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
                            if (documentHidden) notifyProgress(runner, event, "start", getEventData(options));
                            close();
                            if (documentHidden) notifyProgress(runner, event, "close", getEventData(options));
                            return runner;
                        }
                        if (isStructural) closeChildAnimations(node);
                        var newAnimation = {
                            structural: isStructural,
                            element: element,
                            event: event,
                            addClass: options.addClass,
                            removeClass: options.removeClass,
                            close: close,
                            options: options,
                            runner: runner
                        };
                        if (hasExistingAnimation) {
                            var skipAnimationFlag = isAllowed("skip", newAnimation, existingAnimation);
                            if (skipAnimationFlag) {
                                if (existingAnimation.state === RUNNING_STATE) {
                                    close();
                                    return runner;
                                } else {
                                    mergeAnimationDetails(element, existingAnimation, newAnimation);
                                    return existingAnimation.runner;
                                }
                            }
                            var cancelAnimationFlag = isAllowed("cancel", newAnimation, existingAnimation);
                            if (cancelAnimationFlag) {
                                if (existingAnimation.state === RUNNING_STATE) // this will end the animation right away and it is safe
                                // to do so since the animation is already running and the
                                // runner callback code will run in async
                                existingAnimation.runner.end();
                                else if (existingAnimation.structural) // this means that the animation is queued into a digest, but
                                // hasn't started yet. Therefore it is safe to run the close
                                // method which will call the runner methods in async.
                                existingAnimation.close();
                                else {
                                    // this will merge the new animation options into existing animation options
                                    mergeAnimationDetails(element, existingAnimation, newAnimation);
                                    return existingAnimation.runner;
                                }
                            } else {
                                // a joined animation means that this animation will take over the existing one
                                // so an example would involve a leave animation taking over an enter. Then when
                                // the postDigest kicks in the enter will be ignored.
                                var joinAnimationFlag = isAllowed("join", newAnimation, existingAnimation);
                                if (joinAnimationFlag) {
                                    if (existingAnimation.state === RUNNING_STATE) normalizeAnimationDetails(element, newAnimation);
                                    else {
                                        applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);
                                        event = newAnimation.event = existingAnimation.event;
                                        options = mergeAnimationDetails(element, existingAnimation, newAnimation);
                                        //we return the same runner since only the option values of this animation will
                                        //be fed into the `existingAnimation`.
                                        return existingAnimation.runner;
                                    }
                                }
                            }
                        } else // normalization in this case means that it removes redundant CSS classes that
                        // already exist (addClass) or do not exist (removeClass) on the element
                        normalizeAnimationDetails(element, newAnimation);
                        // when the options are merged and cleaned up we may end up not having to do
                        // an animation at all, therefore we should check this before issuing a post
                        // digest callback. Structural animations will always run no matter what.
                        var isValidAnimation = newAnimation.structural;
                        if (!isValidAnimation) // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
                        isValidAnimation = newAnimation.event === "animate" && Object.keys(newAnimation.options.to || {}).length > 0 || hasAnimationClasses(newAnimation);
                        if (!isValidAnimation) {
                            close();
                            clearElementAnimationState(node);
                            return runner;
                        }
                        // the counter keeps track of cancelled animations
                        var counter = (existingAnimation.counter || 0) + 1;
                        newAnimation.counter = counter;
                        markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
                        $rootScope.$$postDigest(function() {
                            // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
                            // happen if the animated element is a transcluded clone and also has a `templateUrl`
                            // directive on it. Therefore, we must recreate `element` in order to interact with the
                            // actual DOM nodes.
                            // Note: We still need to use the old `node` for certain things, such as looking up in
                            //       HashMaps where it was used as the key.
                            element = stripCommentsFromElement(originalElement);
                            var animationDetails = activeAnimationsLookup.get(node);
                            var animationCancelled = !animationDetails;
                            animationDetails = animationDetails || {};
                            // if addClass/removeClass is called before something like enter then the
                            // registered parent element may not be present. The code below will ensure
                            // that a final value for parent element is obtained
                            var parentElement = element.parent() || [];
                            // animate/structural/class-based animations all have requirements. Otherwise there
                            // is no point in performing an animation. The parent node must also be set.
                            var isValidAnimation = parentElement.length > 0 && (animationDetails.event === "animate" || animationDetails.structural || hasAnimationClasses(animationDetails));
                            // this means that the previous animation was cancelled
                            // even if the follow-up animation is the same event
                            if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
                                // if another animation did not take over then we need
                                // to make sure that the domOperation and options are
                                // handled accordingly
                                if (animationCancelled) {
                                    applyAnimationClasses(element, options);
                                    applyAnimationStyles(element, options);
                                }
                                // if the event changed from something like enter to leave then we do
                                // it, otherwise if it's the same then the end result will be the same too
                                if (animationCancelled || isStructural && animationDetails.event !== event) {
                                    options.domOperation();
                                    runner.end();
                                }
                                // in the event that the element animation was not cancelled or a follow-up animation
                                // isn't allowed to animate from here then we need to clear the state of the element
                                // so that any future animations won't read the expired animation data.
                                if (!isValidAnimation) clearElementAnimationState(node);
                                return;
                            }
                            // this combined multiple class to addClass / removeClass into a setClass event
                            // so long as a structural event did not take over the animation
                            event = !animationDetails.structural && hasAnimationClasses(animationDetails, true) ? "setClass" : animationDetails.event;
                            markElementAnimationState(node, RUNNING_STATE);
                            var realRunner = $$animation(element, event, animationDetails.options);
                            // this will update the runner's flow-control events based on
                            // the `realRunner` object.
                            runner.setHost(realRunner);
                            notifyProgress(runner, event, "start", getEventData(options));
                            realRunner.done(function(status) {
                                close(!status);
                                var animationDetails = activeAnimationsLookup.get(node);
                                if (animationDetails && animationDetails.counter === counter) clearElementAnimationState(node);
                                notifyProgress(runner, event, "close", getEventData(options));
                            });
                        });
                        return runner;
                        function notifyProgress(runner, event, phase, data) {
                            runInNextPostDigestOrNow(function() {
                                var callbacks = findCallbacks(parentNode, node, event);
                                if (callbacks.length) // do not optimize this call here to RAF because
                                // we don't know how heavy the callback code here will
                                // be and if this code is buffered then this can
                                // lead to a performance regression.
                                $$rAF(function() {
                                    forEach(callbacks, function(callback) {
                                        callback(element, phase, data);
                                    });
                                    cleanupEventListeners(phase, node);
                                });
                                else cleanupEventListeners(phase, node);
                            });
                            runner.progress(event, phase, data);
                        }
                        function close(reject) {
                            clearGeneratedClasses(element, options);
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            options.domOperation();
                            runner.complete(!reject);
                        }
                    }
                    function closeChildAnimations(node) {
                        var children = node.querySelectorAll("[" + NG_ANIMATE_ATTR_NAME + "]");
                        forEach(children, function(child) {
                            var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
                            var animationDetails = activeAnimationsLookup.get(child);
                            if (animationDetails) switch(state){
                                case RUNNING_STATE:
                                    animationDetails.runner.end();
                                /* falls through */ case PRE_DIGEST_STATE:
                                    activeAnimationsLookup.delete(child);
                                    break;
                            }
                        });
                    }
                    function clearElementAnimationState(node) {
                        node.removeAttribute(NG_ANIMATE_ATTR_NAME);
                        activeAnimationsLookup.delete(node);
                    }
                    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */ function areAnimationsAllowed(node, parentNode, event) {
                        var bodyNode = $document[0].body;
                        var rootNode = getDomNode($rootElement);
                        var bodyNodeDetected = node === bodyNode || node.nodeName === "HTML";
                        var rootNodeDetected = node === rootNode;
                        var parentAnimationDetected = false;
                        var elementDisabled = disabledElementsLookup.get(node);
                        var animateChildren;
                        var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
                        if (parentHost) parentNode = getDomNode(parentHost);
                        while(parentNode){
                            if (!rootNodeDetected) // AngularJS doesn't want to attempt to animate elements outside of the application
                            // therefore we need to ensure that the rootElement is an ancestor of the current element
                            rootNodeDetected = parentNode === rootNode;
                            if (parentNode.nodeType !== ELEMENT_NODE) break;
                            var details = activeAnimationsLookup.get(parentNode) || {};
                            // either an enter, leave or move animation will commence
                            // therefore we can't allow any animations to take place
                            // but if a parent animation is class-based then that's ok
                            if (!parentAnimationDetected) {
                                var parentNodeDisabled = disabledElementsLookup.get(parentNode);
                                if (parentNodeDisabled === true && elementDisabled !== false) {
                                    // disable animations if the user hasn't explicitly enabled animations on the
                                    // current element
                                    elementDisabled = true;
                                    break;
                                } else if (parentNodeDisabled === false) elementDisabled = false;
                                parentAnimationDetected = details.structural;
                            }
                            if (isUndefined(animateChildren) || animateChildren === true) {
                                var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
                                if (isDefined(value)) animateChildren = value;
                            }
                            // there is no need to continue traversing at this point
                            if (parentAnimationDetected && animateChildren === false) break;
                            if (!bodyNodeDetected) // we also need to ensure that the element is or will be a part of the body element
                            // otherwise it is pointless to even issue an animation to be rendered
                            bodyNodeDetected = parentNode === bodyNode;
                            if (bodyNodeDetected && rootNodeDetected) break;
                            if (!rootNodeDetected) {
                                // If `rootNode` is not detected, check if `parentNode` is pinned to another element
                                parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
                                if (parentHost) {
                                    // The pin target element becomes the next parent element
                                    parentNode = getDomNode(parentHost);
                                    continue;
                                }
                            }
                            parentNode = parentNode.parentNode;
                        }
                        var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
                        return allowAnimation && rootNodeDetected && bodyNodeDetected;
                    }
                    function markElementAnimationState(node, state, details) {
                        details = details || {};
                        details.state = state;
                        node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
                        var oldValue = activeAnimationsLookup.get(node);
                        var newValue = oldValue ? extend(oldValue, details) : details;
                        activeAnimationsLookup.set(node, newValue);
                    }
                }
            ];
        }
    ];
    /** @this */ var $$AnimateCacheProvider = function() {
        var KEY = "$$ngAnimateParentKey";
        var parentCounter = 0;
        var cache = Object.create(null);
        this.$get = [
            function() {
                return {
                    cacheKey: function(node, method, addClass, removeClass) {
                        var parentNode = node.parentNode;
                        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
                        var parts = [
                            parentID,
                            method,
                            node.getAttribute("class")
                        ];
                        if (addClass) parts.push(addClass);
                        if (removeClass) parts.push(removeClass);
                        return parts.join(" ");
                    },
                    containsCachedAnimationWithoutDuration: function(key) {
                        var entry = cache[key];
                        // nothing cached, so go ahead and animate
                        // otherwise it should be a valid animation
                        return entry && !entry.isValid || false;
                    },
                    flush: function() {
                        cache = Object.create(null);
                    },
                    count: function(key) {
                        var entry = cache[key];
                        return entry ? entry.total : 0;
                    },
                    get: function(key) {
                        var entry = cache[key];
                        return entry && entry.value;
                    },
                    put: function(key, value, isValid) {
                        if (!cache[key]) cache[key] = {
                            total: 1,
                            value: value,
                            isValid: isValid
                        };
                        else {
                            cache[key].total++;
                            cache[key].value = value;
                        }
                    }
                };
            }
        ];
    };
    /* exported $$AnimationProvider */ var $$AnimationProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            var NG_ANIMATE_REF_ATTR = "ng-animate-ref";
            var drivers = this.drivers = [];
            var RUNNER_STORAGE_KEY = "$$animationRunner";
            var PREPARE_CLASSES_KEY = "$$animatePrepareClasses";
            function setRunner(element, runner) {
                element.data(RUNNER_STORAGE_KEY, runner);
            }
            function removeRunner(element) {
                element.removeData(RUNNER_STORAGE_KEY);
            }
            function getRunner(element) {
                return element.data(RUNNER_STORAGE_KEY);
            }
            this.$get = [
                "$$jqLite",
                "$rootScope",
                "$injector",
                "$$AnimateRunner",
                "$$Map",
                "$$rAFScheduler",
                "$$animateCache",
                function($$jqLite, $rootScope, $injector, $$AnimateRunner, $$Map, $$rAFScheduler, $$animateCache) {
                    var animationQueue = [];
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function sortAnimations(animations) {
                        var tree = {
                            children: []
                        };
                        var i, lookup = new $$Map();
                        // this is done first beforehand so that the map
                        // is filled with a list of the elements that will be animated
                        for(i = 0; i < animations.length; i++){
                            var animation = animations[i];
                            lookup.set(animation.domNode, animations[i] = {
                                domNode: animation.domNode,
                                element: animation.element,
                                fn: animation.fn,
                                children: []
                            });
                        }
                        for(i = 0; i < animations.length; i++)processNode(animations[i]);
                        return flatten(tree);
                        function processNode(entry) {
                            if (entry.processed) return entry;
                            entry.processed = true;
                            var elementNode = entry.domNode;
                            var parentNode = elementNode.parentNode;
                            lookup.set(elementNode, entry);
                            var parentEntry;
                            while(parentNode){
                                parentEntry = lookup.get(parentNode);
                                if (parentEntry) {
                                    if (!parentEntry.processed) parentEntry = processNode(parentEntry);
                                    break;
                                }
                                parentNode = parentNode.parentNode;
                            }
                            (parentEntry || tree).children.push(entry);
                            return entry;
                        }
                        function flatten(tree) {
                            var result = [];
                            var queue = [];
                            var i;
                            for(i = 0; i < tree.children.length; i++)queue.push(tree.children[i]);
                            var remainingLevelEntries = queue.length;
                            var nextLevelEntries = 0;
                            var row = [];
                            for(i = 0; i < queue.length; i++){
                                var entry = queue[i];
                                if (remainingLevelEntries <= 0) {
                                    remainingLevelEntries = nextLevelEntries;
                                    nextLevelEntries = 0;
                                    result.push(row);
                                    row = [];
                                }
                                row.push(entry);
                                entry.children.forEach(function(childEntry) {
                                    nextLevelEntries++;
                                    queue.push(childEntry);
                                });
                                remainingLevelEntries--;
                            }
                            if (row.length) result.push(row);
                            return result;
                        }
                    }
                    // TODO(matsko): document the signature in a better way
                    return function(element, event, options) {
                        options = prepareAnimationOptions(options);
                        var isStructural = [
                            "enter",
                            "move",
                            "leave"
                        ].indexOf(event) >= 0;
                        // there is no animation at the current moment, however
                        // these runner methods will get later updated with the
                        // methods leading into the driver's end/cancel methods
                        // for now they just stop the animation from starting
                        var runner = new $$AnimateRunner({
                            end: function() {
                                close();
                            },
                            cancel: function() {
                                close(true);
                            }
                        });
                        if (!drivers.length) {
                            close();
                            return runner;
                        }
                        var classes = mergeClasses(element.attr("class"), mergeClasses(options.addClass, options.removeClass));
                        var tempClasses = options.tempClasses;
                        if (tempClasses) {
                            classes += " " + tempClasses;
                            options.tempClasses = null;
                        }
                        if (isStructural) element.data(PREPARE_CLASSES_KEY, "ng-" + event + PREPARE_CLASS_SUFFIX);
                        setRunner(element, runner);
                        animationQueue.push({
                            // this data is used by the postDigest code and passed into
                            // the driver step function
                            element: element,
                            classes: classes,
                            event: event,
                            structural: isStructural,
                            options: options,
                            beforeStart: beforeStart,
                            close: close
                        });
                        element.on("$destroy", handleDestroyedElement);
                        // we only want there to be one function called within the post digest
                        // block. This way we can group animations for all the animations that
                        // were apart of the same postDigest flush call.
                        if (animationQueue.length > 1) return runner;
                        $rootScope.$$postDigest(function() {
                            var animations = [];
                            forEach(animationQueue, function(entry) {
                                // the element was destroyed early on which removed the runner
                                // form its storage. This means we can't animate this element
                                // at all and it already has been closed due to destruction.
                                if (getRunner(entry.element)) animations.push(entry);
                                else entry.close();
                            });
                            // now any future animations will be in another postDigest
                            animationQueue.length = 0;
                            var groupedAnimations = groupAnimations(animations);
                            var toBeSortedAnimations = [];
                            forEach(groupedAnimations, function(animationEntry) {
                                var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
                                var extraClasses = options.addClass;
                                extraClasses = (extraClasses ? extraClasses + " " : "") + NG_ANIMATE_CLASSNAME;
                                var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);
                                toBeSortedAnimations.push({
                                    element: element,
                                    domNode: getDomNode(element),
                                    fn: function triggerAnimationStart() {
                                        var startAnimationFn, closeFn = animationEntry.close;
                                        // in the event that we've cached the animation status for this element
                                        // and it's in fact an invalid animation (something that has duration = 0)
                                        // then we should skip all the heavy work from here on
                                        if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                                            closeFn();
                                            return;
                                        }
                                        // it's important that we apply the `ng-animate` CSS class and the
                                        // temporary classes before we do any driver invoking since these
                                        // CSS classes may be required for proper CSS detection.
                                        animationEntry.beforeStart();
                                        // in the event that the element was removed before the digest runs or
                                        // during the RAF sequencing then we should not trigger the animation.
                                        var targetElement = animationEntry.anchors ? animationEntry.from.element || animationEntry.to.element : animationEntry.element;
                                        if (getRunner(targetElement)) {
                                            var operation = invokeFirstDriver(animationEntry);
                                            if (operation) startAnimationFn = operation.start;
                                        }
                                        if (!startAnimationFn) closeFn();
                                        else {
                                            var animationRunner = startAnimationFn();
                                            animationRunner.done(function(status) {
                                                closeFn(!status);
                                            });
                                            updateAnimationRunners(animationEntry, animationRunner);
                                        }
                                    }
                                });
                            });
                            // we need to sort each of the animations in order of parent to child
                            // relationships. This ensures that the child classes are applied at the
                            // right time.
                            var finalAnimations = sortAnimations(toBeSortedAnimations);
                            for(var i = 0; i < finalAnimations.length; i++){
                                var innerArray = finalAnimations[i];
                                for(var j = 0; j < innerArray.length; j++){
                                    var entry = innerArray[j];
                                    var element = entry.element;
                                    // the RAFScheduler code only uses functions
                                    finalAnimations[i][j] = entry.fn;
                                    // the first row of elements shouldn't have a prepare-class added to them
                                    // since the elements are at the top of the animation hierarchy and they
                                    // will be applied without a RAF having to pass...
                                    if (i === 0) {
                                        element.removeData(PREPARE_CLASSES_KEY);
                                        continue;
                                    }
                                    var prepareClassName = element.data(PREPARE_CLASSES_KEY);
                                    if (prepareClassName) $$jqLite.addClass(element, prepareClassName);
                                }
                            }
                            $$rAFScheduler(finalAnimations);
                        });
                        return runner;
                        // TODO(matsko): change to reference nodes
                        function getAnchorNodes(node) {
                            var SELECTOR = "[" + NG_ANIMATE_REF_ATTR + "]";
                            var items = node.hasAttribute(NG_ANIMATE_REF_ATTR) ? [
                                node
                            ] : node.querySelectorAll(SELECTOR);
                            var anchors = [];
                            forEach(items, function(node) {
                                var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
                                if (attr && attr.length) anchors.push(node);
                            });
                            return anchors;
                        }
                        function groupAnimations(animations) {
                            var preparedAnimations = [];
                            var refLookup = {};
                            forEach(animations, function(animation, index) {
                                var element = animation.element;
                                var node = getDomNode(element);
                                var event = animation.event;
                                var enterOrMove = [
                                    "enter",
                                    "move"
                                ].indexOf(event) >= 0;
                                var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
                                if (anchorNodes.length) {
                                    var direction = enterOrMove ? "to" : "from";
                                    forEach(anchorNodes, function(anchor) {
                                        var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
                                        refLookup[key] = refLookup[key] || {};
                                        refLookup[key][direction] = {
                                            animationID: index,
                                            element: jqLite(anchor)
                                        };
                                    });
                                } else preparedAnimations.push(animation);
                            });
                            var usedIndicesLookup = {};
                            var anchorGroups = {};
                            forEach(refLookup, function(operations, key) {
                                var from = operations.from;
                                var to = operations.to;
                                if (!from || !to) {
                                    // only one of these is set therefore we can't have an
                                    // anchor animation since all three pieces are required
                                    var index = from ? from.animationID : to.animationID;
                                    var indexKey = index.toString();
                                    if (!usedIndicesLookup[indexKey]) {
                                        usedIndicesLookup[indexKey] = true;
                                        preparedAnimations.push(animations[index]);
                                    }
                                    return;
                                }
                                var fromAnimation = animations[from.animationID];
                                var toAnimation = animations[to.animationID];
                                var lookupKey = from.animationID.toString();
                                if (!anchorGroups[lookupKey]) {
                                    var group = anchorGroups[lookupKey] = {
                                        structural: true,
                                        beforeStart: function() {
                                            fromAnimation.beforeStart();
                                            toAnimation.beforeStart();
                                        },
                                        close: function() {
                                            fromAnimation.close();
                                            toAnimation.close();
                                        },
                                        classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
                                        from: fromAnimation,
                                        to: toAnimation,
                                        anchors: [] // TODO(matsko): change to reference nodes
                                    };
                                    // the anchor animations require that the from and to elements both have at least
                                    // one shared CSS class which effectively marries the two elements together to use
                                    // the same animation driver and to properly sequence the anchor animation.
                                    if (group.classes.length) preparedAnimations.push(group);
                                    else {
                                        preparedAnimations.push(fromAnimation);
                                        preparedAnimations.push(toAnimation);
                                    }
                                }
                                anchorGroups[lookupKey].anchors.push({
                                    "out": from.element,
                                    "in": to.element
                                });
                            });
                            return preparedAnimations;
                        }
                        function cssClassesIntersection(a, b) {
                            a = a.split(" ");
                            b = b.split(" ");
                            var matches = [];
                            for(var i = 0; i < a.length; i++){
                                var aa = a[i];
                                if (aa.substring(0, 3) === "ng-") continue;
                                for(var j = 0; j < b.length; j++)if (aa === b[j]) {
                                    matches.push(aa);
                                    break;
                                }
                            }
                            return matches.join(" ");
                        }
                        function invokeFirstDriver(animationDetails) {
                            // we loop in reverse order since the more general drivers (like CSS and JS)
                            // may attempt more elements, but custom drivers are more particular
                            for(var i = drivers.length - 1; i >= 0; i--){
                                var driverName = drivers[i];
                                var factory = $injector.get(driverName);
                                var driver = factory(animationDetails);
                                if (driver) return driver;
                            }
                        }
                        function beforeStart() {
                            tempClasses = (tempClasses ? tempClasses + " " : "") + NG_ANIMATE_CLASSNAME;
                            $$jqLite.addClass(element, tempClasses);
                            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
                            if (prepareClassName) {
                                $$jqLite.removeClass(element, prepareClassName);
                                prepareClassName = null;
                            }
                        }
                        function updateAnimationRunners(animation, newRunner) {
                            if (animation.from && animation.to) {
                                update(animation.from.element);
                                update(animation.to.element);
                            } else update(animation.element);
                            function update(element) {
                                var runner = getRunner(element);
                                if (runner) runner.setHost(newRunner);
                            }
                        }
                        function handleDestroyedElement() {
                            var runner = getRunner(element);
                            if (runner && (event !== "leave" || !options.$$domOperationFired)) runner.end();
                        }
                        function close(rejected) {
                            element.off("$destroy", handleDestroyedElement);
                            removeRunner(element);
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            options.domOperation();
                            if (tempClasses) $$jqLite.removeClass(element, tempClasses);
                            runner.complete(!rejected);
                        }
                    };
                }
            ];
        }
    ];
    /**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */ var ngAnimateSwapDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                transclude: "element",
                terminal: true,
                priority: 550,
                // but after `ngIf` (at priority 600).
                link: function(scope, $element, attrs, ctrl, $transclude) {
                    var previousElement, previousScope;
                    scope.$watchCollection(attrs.ngAnimateSwap || attrs["for"], function(value) {
                        if (previousElement) $animate.leave(previousElement);
                        if (previousScope) {
                            previousScope.$destroy();
                            previousScope = null;
                        }
                        if (value || value === 0) $transclude(function(clone, childScope) {
                            previousElement = clone;
                            previousScope = childScope;
                            $animate.enter(clone, null, $element);
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */ var copy;
    var extend;
    var forEach;
    var isArray;
    var isDefined;
    var isElement;
    var isFunction;
    var isObject;
    var isString;
    var isUndefined;
    var jqLite;
    var noop;
    /**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */ angular.module("ngAnimate", [], function initAngularHelpers() {
        // Access helpers from AngularJS core.
        // Do it inside a `config` block to ensure `window.angular` is available.
        noop = angular.noop;
        copy = angular.copy;
        extend = angular.extend;
        jqLite = angular.element;
        forEach = angular.forEach;
        isArray = angular.isArray;
        isString = angular.isString;
        isObject = angular.isObject;
        isUndefined = angular.isUndefined;
        isDefined = angular.isDefined;
        isFunction = angular.isFunction;
        isElement = angular.isElement;
    }).info({
        angularVersion: "1.8.2"
    }).directive("ngAnimateSwap", ngAnimateSwapDirective).directive("ngAnimateChildren", $$AnimateChildrenDirective).factory("$$rAFScheduler", $$rAFSchedulerFactory).provider("$$animateQueue", $$AnimateQueueProvider).provider("$$animateCache", $$AnimateCacheProvider).provider("$$animation", $$AnimationProvider).provider("$animateCss", $AnimateCssProvider).provider("$$animateCssDriver", $$AnimateCssDriverProvider).provider("$$animateJs", $$AnimateJsProvider).provider("$$animateJsDriver", $$AnimateJsDriverProvider);
})(window, window.angular);

},{}],"dxpjJ":[function(require,module,exports) {
require("e052fce72192c71b");
module.exports = "ngSanitize";

},{"e052fce72192c71b":"aW7zL"}],"aW7zL":[function(require,module,exports) {
/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1, angular) {
    "use strict";
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ var $sanitizeMinErr = angular.$$minErr("$sanitize");
    var bind;
    var extend;
    var forEach;
    var isArray;
    var isDefined;
    var lowercase;
    var noop;
    var nodeContains;
    var htmlParser;
    var htmlSanitizeWriter;
    /**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */ /**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */ /**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */ function $SanitizeProvider() {
        var hasBeenInstantiated = false;
        var svgEnabled = false;
        this.$get = [
            "$$sanitizeUri",
            function($$sanitizeUri) {
                hasBeenInstantiated = true;
                if (svgEnabled) extend(validElements, svgElements);
                return function(html) {
                    var buf = [];
                    htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
                        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
                    }));
                    return buf.join("");
                };
            }
        ];
        /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */ this.enableSvg = function(enableSvg) {
            if (isDefined(enableSvg)) {
                svgEnabled = enableSvg;
                return this;
            } else return svgEnabled;
        };
        /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */ this.addValidElements = function(elements) {
            if (!hasBeenInstantiated) {
                if (isArray(elements)) elements = {
                    htmlElements: elements
                };
                addElementsTo(svgElements, elements.svgElements);
                addElementsTo(voidElements, elements.htmlVoidElements);
                addElementsTo(validElements, elements.htmlVoidElements);
                addElementsTo(validElements, elements.htmlElements);
            }
            return this;
        };
        /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */ this.addValidAttrs = function(attrs) {
            if (!hasBeenInstantiated) extend(validAttrs, arrayToMap(attrs, true));
            return this;
        };
        //////////////////////////////////////////////////////////////////////////////////////////////////
        // Private stuff
        //////////////////////////////////////////////////////////////////////////////////////////////////
        bind = angular.bind;
        extend = angular.extend;
        forEach = angular.forEach;
        isArray = angular.isArray;
        isDefined = angular.isDefined;
        lowercase = angular.$$lowercase;
        noop = angular.noop;
        htmlParser = htmlParserImpl;
        htmlSanitizeWriter = htmlSanitizeWriterImpl;
        nodeContains = window1.Node.prototype.contains || /** @this */ function(arg) {
            // eslint-disable-next-line no-bitwise
            return !!(this.compareDocumentPosition(arg) & 16);
        };
        // Regular Expressions for parsing tags and attributes
        var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, // Match everything outside of normal chars and " (quote character)
        NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
        // Good source of info about elements and attributes
        // http://dev.w3.org/html5/spec/Overview.html#semantics
        // http://simon.html5.org/html-elements
        // Safe Void Elements - HTML5
        // http://dev.w3.org/html5/spec/Overview.html#void-elements
        var voidElements = stringToMap("area,br,col,hr,img,wbr");
        // Elements that you can, intentionally, leave open (and which close themselves)
        // http://dev.w3.org/html5/spec/Overview.html#optional-tags
        var optionalEndTagBlockElements = stringToMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"), optionalEndTagInlineElements = stringToMap("rp,rt"), optionalEndTagElements = extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);
        // Safe Block Elements - HTML5
        var blockElements = extend({}, optionalEndTagBlockElements, stringToMap("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
        // Inline Elements - HTML5
        var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
        // SVG Elements
        // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
        // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
        // They can potentially allow for arbitrary javascript to be executed. See #11290
        var svgElements = stringToMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,stop,svg,switch,text,title,tspan");
        // Blocked Elements (will be stripped)
        var blockedElements = stringToMap("script,style");
        var validElements = extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements);
        //Attributes that have href and hence need to be sanitized
        var uriAttrs = stringToMap("background,cite,href,longdesc,src,xlink:href,xml:base");
        var htmlAttrs = stringToMap("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,valign,value,vspace,width");
        // SVG attributes (without "id" and "name" attributes)
        // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
        var svgAttrs = stringToMap("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan", true);
        var validAttrs = extend({}, uriAttrs, svgAttrs, htmlAttrs);
        function stringToMap(str, lowercaseKeys) {
            return arrayToMap(str.split(","), lowercaseKeys);
        }
        function arrayToMap(items, lowercaseKeys) {
            var obj = {}, i;
            for(i = 0; i < items.length; i++)obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
            return obj;
        }
        function addElementsTo(elementsMap, newElements) {
            if (newElements && newElements.length) extend(elementsMap, arrayToMap(newElements));
        }
        /**
   * Create an inert document that contains the dirty HTML that needs sanitizing.
   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
   * available.
   */ var getInertBodyElement /* function(html: string): HTMLBodyElement */  = function(window1, document) {
            if (isDOMParserAvailable()) return getInertBodyElement_DOMParser;
            if (!document || !document.implementation) throw $sanitizeMinErr("noinert", "Can't create an inert html document");
            var inertDocument = document.implementation.createHTMLDocument("inert");
            var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector("body");
            return getInertBodyElement_InertDocument;
            function isDOMParserAvailable() {
                try {
                    return !!getInertBodyElement_DOMParser("");
                } catch (e) {
                    return false;
                }
            }
            function getInertBodyElement_DOMParser(html) {
                // We add this dummy element to ensure that the rest of the content is parsed as expected
                // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
                html = "<remove></remove>" + html;
                try {
                    var body = new window1.DOMParser().parseFromString(html, "text/html").body;
                    body.firstChild.remove();
                    return body;
                } catch (e) {
                    return undefined;
                }
            }
            function getInertBodyElement_InertDocument(html) {
                inertBodyElement.innerHTML = html;
                // Support: IE 9-11 only
                // strip custom-namespaced attributes on IE<=11
                if (document.documentMode) stripCustomNsAttrs(inertBodyElement);
                return inertBodyElement;
            }
        }(window1, window1.document);
        /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */ function htmlParserImpl(html, handler) {
            if (html === null || html === undefined) html = "";
            else if (typeof html !== "string") html = "" + html;
            var inertBodyElement = getInertBodyElement(html);
            if (!inertBodyElement) return "";
            //mXSS protection
            var mXSSAttempts = 5;
            do {
                if (mXSSAttempts === 0) throw $sanitizeMinErr("uinput", "Failed to sanitize html because the input is unstable");
                mXSSAttempts--;
                // trigger mXSS if it is going to happen by reading and writing the innerHTML
                html = inertBodyElement.innerHTML;
                inertBodyElement = getInertBodyElement(html);
            }while (html !== inertBodyElement.innerHTML);
            var node = inertBodyElement.firstChild;
            while(node){
                switch(node.nodeType){
                    case 1:
                        handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
                        break;
                    case 3:
                        handler.chars(node.textContent);
                        break;
                }
                var nextNode;
                if (!(nextNode = node.firstChild)) {
                    if (node.nodeType === 1) handler.end(node.nodeName.toLowerCase());
                    nextNode = getNonDescendant("nextSibling", node);
                    if (!nextNode) while(nextNode == null){
                        node = getNonDescendant("parentNode", node);
                        if (node === inertBodyElement) break;
                        nextNode = getNonDescendant("nextSibling", node);
                        if (node.nodeType === 1) handler.end(node.nodeName.toLowerCase());
                    }
                }
                node = nextNode;
            }
            while(node = inertBodyElement.firstChild)inertBodyElement.removeChild(node);
        }
        function attrToMap(attrs) {
            var map = {};
            for(var i = 0, ii = attrs.length; i < ii; i++){
                var attr = attrs[i];
                map[attr.name] = attr.value;
            }
            return map;
        }
        /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */ function encodeEntities(value) {
            return value.replace(/&/g, "&amp;").replace(SURROGATE_PAIR_REGEXP, function(value) {
                var hi = value.charCodeAt(0);
                var low = value.charCodeAt(1);
                return "&#" + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ";";
            }).replace(NON_ALPHANUMERIC_REGEXP, function(value) {
                return "&#" + value.charCodeAt(0) + ";";
            }).replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }
        /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */ function htmlSanitizeWriterImpl(buf, uriValidator) {
            var ignoreCurrentElement = false;
            var out = bind(buf, buf.push);
            return {
                start: function(tag, attrs) {
                    tag = lowercase(tag);
                    if (!ignoreCurrentElement && blockedElements[tag]) ignoreCurrentElement = tag;
                    if (!ignoreCurrentElement && validElements[tag] === true) {
                        out("<");
                        out(tag);
                        forEach(attrs, function(value, key) {
                            var lkey = lowercase(key);
                            var isImage = tag === "img" && lkey === "src" || lkey === "background";
                            if (validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
                                out(" ");
                                out(key);
                                out('="');
                                out(encodeEntities(value));
                                out('"');
                            }
                        });
                        out(">");
                    }
                },
                end: function(tag) {
                    tag = lowercase(tag);
                    if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
                        out("</");
                        out(tag);
                        out(">");
                    }
                    // eslint-disable-next-line eqeqeq
                    if (tag == ignoreCurrentElement) ignoreCurrentElement = false;
                },
                chars: function(chars) {
                    if (!ignoreCurrentElement) out(encodeEntities(chars));
                }
            };
        }
        /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */ function stripCustomNsAttrs(node) {
            while(node){
                if (node.nodeType === window1.Node.ELEMENT_NODE) {
                    var attrs = node.attributes;
                    for(var i = 0, l = attrs.length; i < l; i++){
                        var attrNode = attrs[i];
                        var attrName = attrNode.name.toLowerCase();
                        if (attrName === "xmlns:ns1" || attrName.lastIndexOf("ns1:", 0) === 0) {
                            node.removeAttributeNode(attrNode);
                            i--;
                            l--;
                        }
                    }
                }
                var nextNode = node.firstChild;
                if (nextNode) stripCustomNsAttrs(nextNode);
                node = getNonDescendant("nextSibling", node);
            }
        }
        function getNonDescendant(propName, node) {
            // An element is clobbered if its `propName` property points to one of its descendants
            var nextNode = node[propName];
            if (nextNode && nodeContains.call(node, nextNode)) throw $sanitizeMinErr("elclob", "Failed to sanitize html because the element is clobbered: {0}", node.outerHTML || node.outerText);
            return nextNode;
        }
    }
    function sanitizeText(chars) {
        var buf = [];
        var writer = htmlSanitizeWriter(buf, noop);
        writer.chars(chars);
        return buf.join("");
    }
    // define ngSanitize module and register $sanitize service
    angular.module("ngSanitize", []).provider("$sanitize", $SanitizeProvider).info({
        angularVersion: "1.8.2"
    });
    /**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */ angular.module("ngSanitize").filter("linky", [
        "$sanitize",
        function($sanitize) {
            var LINKY_URL_REGEXP = /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i, MAILTO_REGEXP = /^mailto:/i;
            var linkyMinErr = angular.$$minErr("linky");
            var isDefined = angular.isDefined;
            var isFunction = angular.isFunction;
            var isObject = angular.isObject;
            var isString = angular.isString;
            return function(text, target, attributes) {
                if (text == null || text === "") return text;
                if (!isString(text)) throw linkyMinErr("notstring", "Expected string but received: {0}", text);
                var attributesFn = isFunction(attributes) ? attributes : isObject(attributes) ? function getAttributesObject() {
                    return attributes;
                } : function getEmptyAttributesObject() {
                    return {};
                };
                var match;
                var raw = text;
                var html = [];
                var url;
                var i;
                while(match = raw.match(LINKY_URL_REGEXP)){
                    // We can not end in these as they are sometimes found at the end of the sentence
                    url = match[0];
                    // if we did not match ftp/http/www/mailto then assume mailto
                    if (!match[2] && !match[4]) url = (match[3] ? "http://" : "mailto:") + url;
                    i = match.index;
                    addText(raw.substr(0, i));
                    addLink(url, match[0].replace(MAILTO_REGEXP, ""));
                    raw = raw.substring(i + match[0].length);
                }
                addText(raw);
                return $sanitize(html.join(""));
                function addText(text) {
                    if (!text) return;
                    html.push(sanitizeText(text));
                }
                function addLink(url, text) {
                    var key, linkAttributes = attributesFn(url);
                    html.push("<a ");
                    for(key in linkAttributes)html.push(key + '="' + linkAttributes[key] + '" ');
                    if (isDefined(target) && !("target" in linkAttributes)) html.push('target="', target, '" ');
                    html.push('href="', url.replace(/"/g, "&quot;"), '">');
                    addText(text);
                    html.push("</a>");
                }
            };
        }
    ]);
})(window, window.angular);

},{}],"4vRvj":[function(require,module,exports) {
(function() {
    "use strict";
    angular.module("ngGeolocation", []).factory("$geolocation", [
        "$rootScope",
        "$window",
        "$q",
        function($rootScope, $window, $q) {
            function supported() {
                return "geolocation" in $window.navigator;
            }
            var retVal = {
                getCurrentPosition: function(options) {
                    var deferred = $q.defer();
                    if (supported()) $window.navigator.geolocation.getCurrentPosition(function(position) {
                        $rootScope.$apply(function() {
                            retVal.position.coords = position.coords;
                            retVal.position.timestamp = position.timestamp;
                            deferred.resolve(position);
                        });
                    }, function(error) {
                        $rootScope.$apply(function() {
                            deferred.reject({
                                error: error
                            });
                        });
                    }, options);
                    else deferred.reject({
                        error: {
                            code: 2,
                            message: "This web browser does not support HTML5 Geolocation"
                        }
                    });
                    return deferred.promise;
                },
                watchPosition: function(options) {
                    if (supported()) {
                        if (!this.watchId) this.watchId = $window.navigator.geolocation.watchPosition(function(position) {
                            $rootScope.$apply(function() {
                                retVal.position.coords = position.coords;
                                retVal.position.timestamp = position.timestamp;
                                delete retVal.position.error;
                                $rootScope.$broadcast("$geolocation.position.changed", position);
                            });
                        }, function(error) {
                            $rootScope.$apply(function() {
                                retVal.position.error = error;
                                delete retVal.position.coords;
                                delete retVal.position.timestamp;
                                $rootScope.$broadcast("$geolocation.position.error", error);
                            });
                        }, options);
                    } else retVal.position = {
                        error: {
                            code: 2,
                            message: "This web browser does not support HTML5 Geolocation"
                        }
                    };
                },
                clearWatch: function() {
                    if (this.watchId) {
                        $window.navigator.geolocation.clearWatch(this.watchId);
                        delete this.watchId;
                    }
                },
                position: {}
            };
            return retVal;
        }
    ]);
})();

},{}],"hJ37d":[function(require,module,exports) {
/*
 * ngProgressLite - small && slim angular progressbars
 * http://github.com/voronianski/ngprogress-lite
 * Dmitri Voronianski http://pixelhunter.me
 * (c) 2013-2014 MIT License
 */ (function(root, factory) {
    if (0, module.exports) // CommonJS
    module.exports = factory(require("1fe9bbd312100f52"));
    else if (typeof define === "function" && define.amd) // AMD
    define([
        "angular"
    ], factory);
    else // Global Variables
    factory(root.angular);
})(this, function(angular, undefined) {
    "use strict";
    return angular.module("ngProgressLite", []).provider("ngProgressLite", function() {
        // global configs
        var settings = this.settings = {
            minimum: 0.08,
            speed: 300,
            ease: "ease",
            trickleRate: 0.02,
            trickleSpeed: 500,
            template: '<div class="ngProgressLite"><div class="ngProgressLiteBar"><div class="ngProgressLiteBarShadow"></div></div></div>'
        };
        this.$get = [
            "$document",
            function($document) {
                var $body = $document.find("body");
                var $progressBarEl, status, cleanForElement;
                var privateMethods = {
                    render: function() {
                        if (this.isRendered()) return $progressBarEl;
                        $body.addClass("ngProgressLite-on");
                        $progressBarEl = angular.element(settings.template);
                        $body.append($progressBarEl);
                        cleanForElement = false;
                        return $progressBarEl;
                    },
                    remove: function() {
                        $body.removeClass("ngProgressLite-on");
                        $progressBarEl.remove();
                        cleanForElement = true;
                    },
                    isRendered: function() {
                        return $progressBarEl && $progressBarEl.children().length > 0 && !cleanForElement;
                    },
                    trickle: function() {
                        return publicMethods.inc(Math.random() * settings.trickleRate);
                    },
                    clamp: function(num, min, max) {
                        if (num < min) return min;
                        if (num > max) return max;
                        return num;
                    },
                    toBarPercents: function(num) {
                        return num * 100;
                    },
                    positioning: function(num, speed, ease) {
                        return {
                            "width": this.toBarPercents(num) + "%",
                            "transition": "all " + speed + "ms " + ease
                        };
                    }
                };
                var publicMethods = {
                    set: function(num) {
                        var $progress = privateMethods.render();
                        num = privateMethods.clamp(num, settings.minimum, 1);
                        status = num === 1 ? null : num;
                        setTimeout(function() {
                            $progress.children().eq(0).css(privateMethods.positioning(num, settings.speed, settings.ease));
                        }, 100);
                        if (num === 1) setTimeout(function() {
                            $progress.css({
                                "transition": "all " + settings.speed + "ms linear",
                                "opacity": 0
                            });
                            setTimeout(function() {
                                privateMethods.remove();
                            }, settings.speed);
                        }, settings.speed);
                        return publicMethods;
                    },
                    get: function() {
                        return status;
                    },
                    start: function() {
                        if (!status) publicMethods.set(0);
                        var worker = function() {
                            setTimeout(function() {
                                if (!status) return;
                                privateMethods.trickle();
                                worker();
                            }, settings.trickleSpeed);
                        };
                        worker();
                        return publicMethods;
                    },
                    inc: function(amount) {
                        var n = status;
                        if (!n) return publicMethods.start();
                        if (typeof amount !== "number") amount = (1 - n) * privateMethods.clamp(Math.random() * n, 0.1, 0.95);
                        n = privateMethods.clamp(n + amount, 0, 0.994);
                        return publicMethods.set(n);
                    },
                    done: function() {
                        if (status) publicMethods.inc(0.3 + 0.5 * Math.random()).set(1);
                    }
                };
                return publicMethods;
            }
        ];
    }).name;
});

},{"1fe9bbd312100f52":"8oyA9"}],"bsRMJ":[function(require,module,exports) {
/**
 * Restful Resources service for AngularJS apps
 * @version v1.6.1 - 2017-01-06 * @link https://github.com/mgonto/restangular
 * @author Martin Gontovnikas <martin@gon.to>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ (function(root, factory) {
    /* global define, require */ // https://github.com/umdjs/umd/blob/master/templates/returnExports.js
    if (typeof define === "function" && define.amd) define([
        "lodash",
        "angular"
    ], factory);
    else if (0, module.exports) module.exports = factory(require("a1ab2afe0cee4cff"), require("24067559bde95dd9"));
    else // No global export, Restangular will register itself as Angular.js module
    factory(root._, root.angular);
})(this, function(_, angular) {
    var restangular = angular.module("restangular", []);
    restangular.provider("Restangular", function() {
        // Configuration
        var Configurer = {};
        Configurer.init = function(object, config) {
            object.configuration = config;
            /**
       * Those are HTTP safe methods for which there is no need to pass any data with the request.
       */ var safeMethods = [
                "get",
                "head",
                "options",
                "trace",
                "getlist"
            ];
            config.isSafe = function(operation) {
                return _.includes(safeMethods, operation.toLowerCase());
            };
            var absolutePattern = /^https?:\/\//i;
            config.isAbsoluteUrl = function(string) {
                return _.isUndefined(config.absoluteUrl) || _.isNull(config.absoluteUrl) ? string && absolutePattern.test(string) : config.absoluteUrl;
            };
            config.absoluteUrl = _.isUndefined(config.absoluteUrl) ? true : config.absoluteUrl;
            object.setSelfLinkAbsoluteUrl = function(value) {
                config.absoluteUrl = value;
            };
            /**
       * This is the BaseURL to be used with Restangular
       */ config.baseUrl = _.isUndefined(config.baseUrl) ? "" : config.baseUrl;
            object.setBaseUrl = function(newBaseUrl) {
                config.baseUrl = /\/$/.test(newBaseUrl) ? newBaseUrl.substring(0, newBaseUrl.length - 1) : newBaseUrl;
                return this;
            };
            /**
       * Sets the extra fields to keep from the parents
       */ config.extraFields = config.extraFields || [];
            object.setExtraFields = function(newExtraFields) {
                config.extraFields = newExtraFields;
                return this;
            };
            /**
       * Some default $http parameter to be used in EVERY call
       **/ config.defaultHttpFields = config.defaultHttpFields || {};
            object.setDefaultHttpFields = function(values) {
                config.defaultHttpFields = values;
                return this;
            };
            /**
       * Always return plain data, no restangularized object
       **/ config.plainByDefault = config.plainByDefault || false;
            object.setPlainByDefault = function(value) {
                config.plainByDefault = value === true ? true : false;
                return this;
            };
            config.withHttpValues = function(httpLocalConfig, obj) {
                return _.defaults(obj, httpLocalConfig, config.defaultHttpFields);
            };
            config.encodeIds = _.isUndefined(config.encodeIds) ? true : config.encodeIds;
            object.setEncodeIds = function(encode) {
                config.encodeIds = encode;
            };
            config.defaultRequestParams = config.defaultRequestParams || {
                get: {},
                post: {},
                put: {},
                remove: {},
                common: {}
            };
            object.setDefaultRequestParams = function(param1, param2) {
                var methods = [], params = param2 || param1;
                if (!_.isUndefined(param2)) {
                    if (_.isArray(param1)) methods = param1;
                    else methods.push(param1);
                } else methods.push("common");
                _.each(methods, function(method) {
                    config.defaultRequestParams[method] = params;
                });
                return this;
            };
            object.requestParams = config.defaultRequestParams;
            config.defaultHeaders = config.defaultHeaders || {};
            object.setDefaultHeaders = function(headers) {
                config.defaultHeaders = headers;
                object.defaultHeaders = config.defaultHeaders;
                return this;
            };
            object.defaultHeaders = config.defaultHeaders;
            /**
       * Method overriders will set which methods are sent via POST with an X-HTTP-Method-Override
       **/ config.methodOverriders = config.methodOverriders || [];
            object.setMethodOverriders = function(values) {
                var overriders = _.extend([], values);
                if (config.isOverridenMethod("delete", overriders)) overriders.push("remove");
                config.methodOverriders = overriders;
                return this;
            };
            config.jsonp = _.isUndefined(config.jsonp) ? false : config.jsonp;
            object.setJsonp = function(active) {
                config.jsonp = active;
            };
            config.isOverridenMethod = function(method, values) {
                var search = values || config.methodOverriders;
                return !_.isUndefined(_.find(search, function(one) {
                    return one.toLowerCase() === method.toLowerCase();
                }));
            };
            /**
       * Sets the URL creator type. For now, only Path is created. In the future we'll have queryParams
       **/ config.urlCreator = config.urlCreator || "path";
            object.setUrlCreator = function(name) {
                if (!_.has(config.urlCreatorFactory, name)) throw new Error("URL Path selected isn't valid");
                config.urlCreator = name;
                return this;
            };
            /**
       * You can set the restangular fields here. The 3 required fields for Restangular are:
       *
       * id: Id of the element
       * route: name of the route of this element
       * parentResource: the reference to the parent resource
       *
       *  All of this fields except for id, are handled (and created) by Restangular. By default,
       *  the field values will be id, route and parentResource respectively
       */ config.restangularFields = config.restangularFields || {
                id: "id",
                route: "route",
                parentResource: "parentResource",
                restangularCollection: "restangularCollection",
                cannonicalId: "__cannonicalId",
                etag: "restangularEtag",
                selfLink: "href",
                get: "get",
                getList: "getList",
                put: "put",
                post: "post",
                remove: "remove",
                head: "head",
                trace: "trace",
                options: "options",
                patch: "patch",
                getRestangularUrl: "getRestangularUrl",
                getRequestedUrl: "getRequestedUrl",
                putElement: "putElement",
                addRestangularMethod: "addRestangularMethod",
                getParentList: "getParentList",
                clone: "clone",
                ids: "ids",
                httpConfig: "_$httpConfig",
                reqParams: "reqParams",
                one: "one",
                all: "all",
                several: "several",
                oneUrl: "oneUrl",
                allUrl: "allUrl",
                customPUT: "customPUT",
                customPATCH: "customPATCH",
                customPOST: "customPOST",
                customDELETE: "customDELETE",
                customGET: "customGET",
                customGETLIST: "customGETLIST",
                customOperation: "customOperation",
                doPUT: "doPUT",
                doPATCH: "doPATCH",
                doPOST: "doPOST",
                doDELETE: "doDELETE",
                doGET: "doGET",
                doGETLIST: "doGETLIST",
                fromServer: "fromServer",
                withConfig: "withConfig",
                withHttpConfig: "withHttpConfig",
                singleOne: "singleOne",
                plain: "plain",
                save: "save",
                restangularized: "restangularized"
            };
            object.setRestangularFields = function(resFields) {
                config.restangularFields = _.extend(config.restangularFields, resFields);
                return this;
            };
            config.isRestangularized = function(obj) {
                return !!obj[config.restangularFields.restangularized];
            };
            config.setFieldToElem = function(field, elem, value) {
                var properties = field.split(".");
                var idValue = elem;
                _.each(_.initial(properties), function(prop) {
                    idValue[prop] = {};
                    idValue = idValue[prop];
                });
                idValue[_.last(properties)] = value;
                return this;
            };
            config.getFieldFromElem = function(field, elem) {
                var properties = field.split(".");
                var idValue = elem;
                _.each(properties, function(prop) {
                    if (idValue) idValue = idValue[prop];
                });
                return angular.copy(idValue);
            };
            config.setIdToElem = function(elem, id /*, route */ ) {
                config.setFieldToElem(config.restangularFields.id, elem, id);
                return this;
            };
            config.getIdFromElem = function(elem) {
                return config.getFieldFromElem(config.restangularFields.id, elem);
            };
            config.isValidId = function(elemId) {
                return "" !== elemId && !_.isUndefined(elemId) && !_.isNull(elemId);
            };
            config.setUrlToElem = function(elem, url /*, route */ ) {
                config.setFieldToElem(config.restangularFields.selfLink, elem, url);
                return this;
            };
            config.getUrlFromElem = function(elem) {
                return config.getFieldFromElem(config.restangularFields.selfLink, elem);
            };
            config.useCannonicalId = _.isUndefined(config.useCannonicalId) ? false : config.useCannonicalId;
            object.setUseCannonicalId = function(value) {
                config.useCannonicalId = value;
                return this;
            };
            config.getCannonicalIdFromElem = function(elem) {
                var cannonicalId = elem[config.restangularFields.cannonicalId];
                var actualId = config.isValidId(cannonicalId) ? cannonicalId : config.getIdFromElem(elem);
                return actualId;
            };
            /**
       * Sets the Response parser. This is used in case your response isn't directly the data.
       * For example if you have a response like {meta: {'meta'}, data: {name: 'Gonto'}}
       * you can extract this data which is the one that needs wrapping
       *
       * The ResponseExtractor is a function that receives the response and the method executed.
       */ config.responseInterceptors = config.responseInterceptors || [];
            config.defaultResponseInterceptor = function(data /*, operation, what, url, response, deferred */ ) {
                return data;
            };
            config.responseExtractor = function(data, operation, what, url, response, deferred) {
                var interceptors = angular.copy(config.responseInterceptors);
                interceptors.push(config.defaultResponseInterceptor);
                var theData = data;
                _.each(interceptors, function(interceptor) {
                    theData = interceptor(theData, operation, what, url, response, deferred);
                });
                return theData;
            };
            object.addResponseInterceptor = function(extractor) {
                config.responseInterceptors.push(extractor);
                return this;
            };
            config.errorInterceptors = config.errorInterceptors || [];
            object.addErrorInterceptor = function(interceptor) {
                config.errorInterceptors.push(interceptor);
                return this;
            };
            object.setResponseInterceptor = object.addResponseInterceptor;
            object.setResponseExtractor = object.addResponseInterceptor;
            object.setErrorInterceptor = object.addErrorInterceptor;
            /**
       * Response interceptor is called just before resolving promises.
       */ /**
       * Request interceptor is called before sending an object to the server.
       */ config.requestInterceptors = config.requestInterceptors || [];
            config.defaultInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
                return {
                    element: element,
                    headers: headers,
                    params: params,
                    httpConfig: httpConfig
                };
            };
            config.fullRequestInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
                var interceptors = angular.copy(config.requestInterceptors);
                var defaultRequest = config.defaultInterceptor(element, operation, path, url, headers, params, httpConfig);
                return _.reduce(interceptors, function(request, interceptor) {
                    return _.extend(request, interceptor(request.element, operation, path, url, request.headers, request.params, request.httpConfig));
                }, defaultRequest);
            };
            object.addRequestInterceptor = function(interceptor) {
                config.requestInterceptors.push(function(elem, operation, path, url, headers, params, httpConfig) {
                    return {
                        headers: headers,
                        params: params,
                        element: interceptor(elem, operation, path, url),
                        httpConfig: httpConfig
                    };
                });
                return this;
            };
            object.setRequestInterceptor = object.addRequestInterceptor;
            object.addFullRequestInterceptor = function(interceptor) {
                config.requestInterceptors.push(interceptor);
                return this;
            };
            object.setFullRequestInterceptor = object.addFullRequestInterceptor;
            config.onBeforeElemRestangularized = config.onBeforeElemRestangularized || function(elem) {
                return elem;
            };
            object.setOnBeforeElemRestangularized = function(post) {
                config.onBeforeElemRestangularized = post;
                return this;
            };
            object.setRestangularizePromiseInterceptor = function(interceptor) {
                config.restangularizePromiseInterceptor = interceptor;
                return this;
            };
            /**
       * This method is called after an element has been "Restangularized".
       *
       * It receives the element, a boolean indicating if it's an element or a collection
       * and the name of the model
       *
       */ config.onElemRestangularized = config.onElemRestangularized || function(elem) {
                return elem;
            };
            object.setOnElemRestangularized = function(post) {
                config.onElemRestangularized = post;
                return this;
            };
            config.shouldSaveParent = config.shouldSaveParent || function() {
                return true;
            };
            object.setParentless = function(values) {
                if (_.isArray(values)) config.shouldSaveParent = function(route) {
                    return !_.includes(values, route);
                };
                else if (_.isBoolean(values)) config.shouldSaveParent = function() {
                    return !values;
                };
                return this;
            };
            /**
       * This lets you set a suffix to every request.
       *
       * For example, if your api requires that for JSon requests you do /users/123.json, you can set that
       * in here.
       *
       *
       * By default, the suffix is null
       */ config.suffix = _.isUndefined(config.suffix) ? null : config.suffix;
            object.setRequestSuffix = function(newSuffix) {
                config.suffix = newSuffix;
                return this;
            };
            /**
       * Add element transformers for certain routes.
       */ config.transformers = config.transformers || {};
            config.matchTransformers = config.matchTransformers || [];
            object.addElementTransformer = function(type, secondArg, thirdArg) {
                var isCollection = null;
                var transformer = null;
                if (arguments.length === 2) transformer = secondArg;
                else {
                    transformer = thirdArg;
                    isCollection = secondArg;
                }
                var transformerFn = function(coll, elem) {
                    if (_.isNull(isCollection) || coll === isCollection) return transformer(elem);
                    return elem;
                };
                if (_.isRegExp(type)) config.matchTransformers.push({
                    regexp: type,
                    transformer: transformerFn
                });
                else {
                    if (!config.transformers[type]) config.transformers[type] = [];
                    config.transformers[type].push(transformerFn);
                }
                return object;
            };
            object.extendCollection = function(route, fn) {
                return object.addElementTransformer(route, true, fn);
            };
            object.extendModel = function(route, fn) {
                return object.addElementTransformer(route, false, fn);
            };
            config.transformElem = function(elem, isCollection, route, Restangular, force) {
                if (!force && !config.transformLocalElements && !elem[config.restangularFields.fromServer]) return elem;
                var changedElem = elem;
                var matchTransformers = config.matchTransformers;
                if (matchTransformers) _.each(matchTransformers, function(transformer) {
                    if (transformer.regexp.test(route)) changedElem = transformer.transformer(isCollection, changedElem);
                });
                var typeTransformers = config.transformers[route];
                if (typeTransformers) _.each(typeTransformers, function(transformer) {
                    changedElem = transformer(isCollection, changedElem);
                });
                return config.onElemRestangularized(changedElem, isCollection, route, Restangular);
            };
            config.transformLocalElements = _.isUndefined(config.transformLocalElements) ? false : config.transformLocalElements;
            object.setTransformOnlyServerElements = function(active) {
                config.transformLocalElements = !active;
            };
            config.fullResponse = _.isUndefined(config.fullResponse) ? false : config.fullResponse;
            object.setFullResponse = function(full) {
                config.fullResponse = full;
                return this;
            };
            //Internal values and functions
            config.urlCreatorFactory = {};
            /**
       * Base URL Creator. Base prototype for everything related to it
       **/ var BaseCreator = function() {};
            BaseCreator.prototype.setConfig = function(config) {
                this.config = config;
                return this;
            };
            BaseCreator.prototype.parentsArray = function(current) {
                var parents = [];
                while(current){
                    parents.push(current);
                    current = current[this.config.restangularFields.parentResource];
                }
                return parents.reverse();
            };
            function RestangularResource(config, $http, url, configurer) {
                var resource = {};
                _.each(_.keys(configurer), function(key) {
                    var value = configurer[key];
                    // Add default parameters
                    value.params = _.extend({}, value.params, config.defaultRequestParams[value.method.toLowerCase()]);
                    // We don't want the ? if no params are there
                    if (_.isEmpty(value.params)) delete value.params;
                    if (config.isSafe(value.method)) resource[key] = function() {
                        return $http(_.extend(value, {
                            url: url
                        }));
                    };
                    else resource[key] = function(data) {
                        return $http(_.extend(value, {
                            url: url,
                            data: data
                        }));
                    };
                });
                return resource;
            }
            BaseCreator.prototype.resource = function(current, $http, localHttpConfig, callHeaders, callParams, what, etag, operation) {
                var params = _.defaults(callParams || {}, this.config.defaultRequestParams.common);
                var headers = _.defaults(callHeaders || {}, this.config.defaultHeaders);
                if (etag) {
                    if (!config.isSafe(operation)) headers["If-Match"] = etag;
                    else headers["If-None-Match"] = etag;
                }
                var url = this.base(current);
                if (what || what === 0) {
                    var add = "";
                    if (!/\/$/.test(url)) add += "/";
                    add += what;
                    url += add;
                }
                if (this.config.suffix && url.indexOf(this.config.suffix, url.length - this.config.suffix.length) === -1 && !this.config.getUrlFromElem(current)) url += this.config.suffix;
                current[this.config.restangularFields.httpConfig] = undefined;
                return RestangularResource(this.config, $http, url, {
                    getList: this.config.withHttpValues(localHttpConfig, {
                        method: "GET",
                        params: params,
                        headers: headers
                    }),
                    get: this.config.withHttpValues(localHttpConfig, {
                        method: "GET",
                        params: params,
                        headers: headers
                    }),
                    jsonp: this.config.withHttpValues(localHttpConfig, {
                        method: "jsonp",
                        params: params,
                        headers: headers
                    }),
                    put: this.config.withHttpValues(localHttpConfig, {
                        method: "PUT",
                        params: params,
                        headers: headers
                    }),
                    post: this.config.withHttpValues(localHttpConfig, {
                        method: "POST",
                        params: params,
                        headers: headers
                    }),
                    remove: this.config.withHttpValues(localHttpConfig, {
                        method: "DELETE",
                        params: params,
                        headers: headers
                    }),
                    head: this.config.withHttpValues(localHttpConfig, {
                        method: "HEAD",
                        params: params,
                        headers: headers
                    }),
                    trace: this.config.withHttpValues(localHttpConfig, {
                        method: "TRACE",
                        params: params,
                        headers: headers
                    }),
                    options: this.config.withHttpValues(localHttpConfig, {
                        method: "OPTIONS",
                        params: params,
                        headers: headers
                    }),
                    patch: this.config.withHttpValues(localHttpConfig, {
                        method: "PATCH",
                        params: params,
                        headers: headers
                    })
                });
            };
            /**
       * This is the Path URL creator. It uses Path to show Hierarchy in the Rest API.
       * This means that if you have an Account that then has a set of Buildings, a URL to a building
       * would be /accounts/123/buildings/456
       **/ var Path = function() {};
            Path.prototype = new BaseCreator();
            Path.prototype.normalizeUrl = function(url) {
                var parts = /((?:http[s]?:)?\/\/)?(.*)?/.exec(url);
                parts[2] = parts[2].replace(/[\\\/]+/g, "/");
                return typeof parts[1] !== "undefined" ? parts[1] + parts[2] : parts[2];
            };
            Path.prototype.base = function(current) {
                var __this = this;
                return _.reduce(this.parentsArray(current), function(acum, elem) {
                    var elemUrl;
                    var elemSelfLink = __this.config.getUrlFromElem(elem);
                    if (elemSelfLink) {
                        if (__this.config.isAbsoluteUrl(elemSelfLink)) return elemSelfLink;
                        else elemUrl = elemSelfLink;
                    } else {
                        elemUrl = elem[__this.config.restangularFields.route];
                        if (elem[__this.config.restangularFields.restangularCollection]) {
                            var ids = elem[__this.config.restangularFields.ids];
                            if (ids) elemUrl += "/" + ids.join(",");
                        } else {
                            var elemId;
                            if (__this.config.useCannonicalId) elemId = __this.config.getCannonicalIdFromElem(elem);
                            else elemId = __this.config.getIdFromElem(elem);
                            if (config.isValidId(elemId) && !elem.singleOne) elemUrl += "/" + (__this.config.encodeIds ? encodeURIComponent(elemId) : elemId);
                        }
                    }
                    acum = acum.replace(/\/$/, "") + "/" + elemUrl;
                    return __this.normalizeUrl(acum);
                }, this.config.baseUrl);
            };
            Path.prototype.fetchUrl = function(current, what) {
                var baseUrl = this.base(current);
                if (what) baseUrl += "/" + what;
                return baseUrl;
            };
            Path.prototype.fetchRequestedUrl = function(current, what) {
                var url = this.fetchUrl(current, what);
                var params = current[config.restangularFields.reqParams];
                // From here on and until the end of fetchRequestedUrl,
                // the code has been kindly borrowed from angular.js
                // The reason for such code bloating is coherence:
                //   If the user were to use this for cache management, the
                //   serialization of parameters would need to be identical
                //   to the one done by angular for cache keys to match.
                function sortedKeys(obj) {
                    var keys = [];
                    for(var key in obj)if (obj.hasOwnProperty(key)) keys.push(key);
                    return keys.sort();
                }
                function forEachSorted(obj, iterator, context) {
                    var keys = sortedKeys(obj);
                    for(var i = 0; i < keys.length; i++)iterator.call(context, obj[keys[i]], keys[i]);
                    return keys;
                }
                function encodeUriQuery(val, pctEncodeSpaces) {
                    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, pctEncodeSpaces ? "%20" : "+");
                }
                if (!params) return url + (this.config.suffix || "");
                var parts = [];
                forEachSorted(params, function(value, key) {
                    if (value === null || value === undefined) return;
                    if (!angular.isArray(value)) value = [
                        value
                    ];
                    angular.forEach(value, function(v) {
                        if (angular.isObject(v)) v = angular.toJson(v);
                        parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(v));
                    });
                });
                return url + (this.config.suffix || "") + (url.indexOf("?") === -1 ? "?" : "&") + parts.join("&");
            };
            config.urlCreatorFactory.path = Path;
        };
        var globalConfiguration = {};
        Configurer.init(this, globalConfiguration);
        this.$get = [
            "$http",
            "$q",
            function($http, $q) {
                function createServiceForConfiguration(config) {
                    var service = {};
                    var urlHandler = new config.urlCreatorFactory[config.urlCreator]();
                    urlHandler.setConfig(config);
                    function restangularizeBase(parent, elem, route, reqParams, fromServer) {
                        elem[config.restangularFields.route] = route;
                        elem[config.restangularFields.getRestangularUrl] = _.bind(urlHandler.fetchUrl, urlHandler, elem);
                        elem[config.restangularFields.getRequestedUrl] = _.bind(urlHandler.fetchRequestedUrl, urlHandler, elem);
                        elem[config.restangularFields.addRestangularMethod] = _.bind(addRestangularMethodFunction, elem);
                        elem[config.restangularFields.clone] = _.bind(copyRestangularizedElement, elem, elem);
                        elem[config.restangularFields.reqParams] = _.isEmpty(reqParams) ? null : reqParams;
                        elem[config.restangularFields.withHttpConfig] = _.bind(withHttpConfig, elem);
                        elem[config.restangularFields.plain] = _.bind(stripRestangular, elem, elem);
                        // Tag element as restangularized
                        elem[config.restangularFields.restangularized] = true;
                        // RequestLess connection
                        elem[config.restangularFields.one] = _.bind(one, elem, elem);
                        elem[config.restangularFields.all] = _.bind(all, elem, elem);
                        elem[config.restangularFields.several] = _.bind(several, elem, elem);
                        elem[config.restangularFields.oneUrl] = _.bind(oneUrl, elem, elem);
                        elem[config.restangularFields.allUrl] = _.bind(allUrl, elem, elem);
                        elem[config.restangularFields.fromServer] = !!fromServer;
                        if (parent && config.shouldSaveParent(route)) {
                            var parentId = config.getIdFromElem(parent);
                            var parentUrl = config.getUrlFromElem(parent);
                            var restangularFieldsForParent = _.union(_.values(_.pick(config.restangularFields, [
                                "route",
                                "singleOne",
                                "parentResource"
                            ])), config.extraFields);
                            var parentResource = _.pick(parent, restangularFieldsForParent);
                            if (config.isValidId(parentId)) config.setIdToElem(parentResource, parentId, route);
                            if (config.isValidId(parentUrl)) config.setUrlToElem(parentResource, parentUrl, route);
                            elem[config.restangularFields.parentResource] = parentResource;
                        } else elem[config.restangularFields.parentResource] = null;
                        return elem;
                    }
                    function one(parent, route, id, singleOne) {
                        var error;
                        if (_.isNumber(route) || _.isNumber(parent)) {
                            error = "You're creating a Restangular entity with the number ";
                            error += "instead of the route or the parent. For example, you can't call .one(12).";
                            throw new Error(error);
                        }
                        if (_.isUndefined(route)) {
                            error = "You're creating a Restangular entity either without the path. ";
                            error += "For example you can't call .one(). Please check if your arguments are valid.";
                            throw new Error(error);
                        }
                        var elem = {};
                        config.setIdToElem(elem, id, route);
                        config.setFieldToElem(config.restangularFields.singleOne, elem, singleOne);
                        return restangularizeElem(parent, elem, route, false);
                    }
                    function all(parent, route) {
                        return restangularizeCollection(parent, [], route, false);
                    }
                    function several(parent, route /*, ids */ ) {
                        var collection = [];
                        collection[config.restangularFields.ids] = Array.prototype.splice.call(arguments, 2);
                        return restangularizeCollection(parent, collection, route, false);
                    }
                    function oneUrl(parent, route, url) {
                        if (!route) throw new Error("Route is mandatory when creating new Restangular objects.");
                        var elem = {};
                        config.setUrlToElem(elem, url, route);
                        return restangularizeElem(parent, elem, route, false);
                    }
                    function allUrl(parent, route, url) {
                        if (!route) throw new Error("Route is mandatory when creating new Restangular objects.");
                        var elem = {};
                        config.setUrlToElem(elem, url, route);
                        return restangularizeCollection(parent, elem, route, false);
                    }
                    // Promises
                    function restangularizePromise(promise, isCollection, valueToFill) {
                        promise.call = _.bind(promiseCall, promise);
                        promise.get = _.bind(promiseGet, promise);
                        promise[config.restangularFields.restangularCollection] = isCollection;
                        if (isCollection) promise.push = _.bind(promiseCall, promise, "push");
                        promise.$object = valueToFill;
                        if (config.restangularizePromiseInterceptor) config.restangularizePromiseInterceptor(promise);
                        return promise;
                    }
                    function promiseCall(method) {
                        var deferred = $q.defer();
                        var callArgs = arguments;
                        var filledValue = {};
                        this.then(function(val) {
                            var params = Array.prototype.slice.call(callArgs, 1);
                            var func = val[method];
                            func.apply(val, params);
                            filledValue = val;
                            deferred.resolve(val);
                        });
                        return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
                    }
                    function promiseGet(what) {
                        var deferred = $q.defer();
                        var filledValue = {};
                        this.then(function(val) {
                            filledValue = val[what];
                            deferred.resolve(filledValue);
                        });
                        return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
                    }
                    function resolvePromise(deferred, response, data, filledValue) {
                        _.extend(filledValue, data);
                        // Trigger the full response interceptor.
                        if (config.fullResponse) return deferred.resolve(_.extend(response, {
                            data: data
                        }));
                        else deferred.resolve(data);
                    }
                    // Elements
                    function stripRestangular(elem) {
                        if (_.isArray(elem)) {
                            var array = [];
                            _.each(elem, function(value) {
                                array.push(config.isRestangularized(value) ? stripRestangular(value) : value);
                            });
                            return array;
                        } else return _.omit(elem, _.values(_.omit(config.restangularFields, "id")));
                    }
                    function addCustomOperation(elem) {
                        elem[config.restangularFields.customOperation] = _.bind(customFunction, elem);
                        var requestMethods = {
                            get: customFunction,
                            delete: customFunction
                        };
                        _.each([
                            "put",
                            "patch",
                            "post"
                        ], function(name) {
                            requestMethods[name] = function(operation, elem, path, params, headers) {
                                return _.bind(customFunction, this)(operation, path, params, headers, elem);
                            };
                        });
                        _.each(requestMethods, function(requestFunc, name) {
                            var callOperation = name === "delete" ? "remove" : name;
                            _.each([
                                "do",
                                "custom"
                            ], function(alias) {
                                elem[alias + name.toUpperCase()] = _.bind(requestFunc, elem, callOperation);
                            });
                        });
                        elem[config.restangularFields.customGETLIST] = _.bind(fetchFunction, elem);
                        elem[config.restangularFields.doGETLIST] = elem[config.restangularFields.customGETLIST];
                    }
                    function copyRestangularizedElement(element) {
                        var copiedElement = angular.copy(element);
                        // check if we're dealing with a collection (i.e. an array)
                        // and restangularize the element using the proper restangularizer,
                        // element / collection
                        if (_.isArray(element)) return restangularizeCollection(element[config.restangularFields.parentResource], copiedElement, element[config.restangularFields.route], element[config.restangularFields.fromServer], element[config.restangularFields.reqParams]);
                        // not a collection, restangularize it as an element
                        return restangularizeElem(element[config.restangularFields.parentResource], copiedElement, element[config.restangularFields.route], element[config.restangularFields.fromServer], element[config.restangularFields.restangularCollection], element[config.restangularFields.reqParams]);
                    }
                    function restangularizeElem(parent, element, route, fromServer, collection, reqParams) {
                        var elem = config.onBeforeElemRestangularized(element, false, route);
                        var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
                        if (config.useCannonicalId) localElem[config.restangularFields.cannonicalId] = config.getIdFromElem(localElem);
                        if (collection) localElem[config.restangularFields.getParentList] = function() {
                            return collection;
                        };
                        localElem[config.restangularFields.restangularCollection] = false;
                        localElem[config.restangularFields.get] = _.bind(getFunction, localElem);
                        localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem);
                        localElem[config.restangularFields.put] = _.bind(putFunction, localElem);
                        localElem[config.restangularFields.post] = _.bind(postFunction, localElem);
                        localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
                        localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
                        localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
                        localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
                        localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
                        localElem[config.restangularFields.save] = _.bind(save, localElem);
                        addCustomOperation(localElem);
                        return config.transformElem(localElem, false, route, service, true);
                    }
                    function restangularizeCollection(parent, element, route, fromServer, reqParams) {
                        var elem = config.onBeforeElemRestangularized(element, true, route);
                        var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
                        localElem[config.restangularFields.restangularCollection] = true;
                        localElem[config.restangularFields.post] = _.bind(postFunction, localElem, null);
                        localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
                        localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
                        localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
                        localElem[config.restangularFields.putElement] = _.bind(putElementFunction, localElem);
                        localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
                        localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
                        localElem[config.restangularFields.get] = _.bind(getById, localElem);
                        localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem, null);
                        addCustomOperation(localElem);
                        return config.transformElem(localElem, true, route, service, true);
                    }
                    function restangularizeCollectionAndElements(parent, element, route, fromServer) {
                        var collection = restangularizeCollection(parent, element, route, fromServer);
                        _.each(collection, function(elem) {
                            if (elem) restangularizeElem(parent, elem, route, fromServer);
                        });
                        return collection;
                    }
                    function getById(id, reqParams, headers) {
                        return this.customGET(id.toString(), reqParams, headers);
                    }
                    function putElementFunction(idx, params, headers) {
                        var __this = this;
                        var elemToPut = this[idx];
                        var deferred = $q.defer();
                        var filledArray = [];
                        filledArray = config.transformElem(filledArray, true, elemToPut[config.restangularFields.route], service);
                        elemToPut.put(params, headers).then(function(serverElem) {
                            var newArray = copyRestangularizedElement(__this);
                            newArray[idx] = serverElem;
                            filledArray = newArray;
                            deferred.resolve(newArray);
                        }, function(response) {
                            deferred.reject(response);
                        });
                        return restangularizePromise(deferred.promise, true, filledArray);
                    }
                    function parseResponse(resData, operation, route, fetchUrl, response, deferred) {
                        var data = config.responseExtractor(resData, operation, route, fetchUrl, response, deferred);
                        var etag = response.headers("ETag");
                        if (data && etag) data[config.restangularFields.etag] = etag;
                        return data;
                    }
                    function fetchFunction(what, reqParams, headers) {
                        var __this = this;
                        var deferred = $q.defer();
                        var operation = "getList";
                        var url = urlHandler.fetchUrl(this, what);
                        var whatFetched = what || __this[config.restangularFields.route];
                        var request = config.fullRequestInterceptor(null, operation, whatFetched, url, headers || {}, reqParams || {}, this[config.restangularFields.httpConfig] || {});
                        var filledArray = [];
                        filledArray = config.transformElem(filledArray, true, whatFetched, service);
                        var method = "getList";
                        if (config.jsonp) method = "jsonp";
                        var okCallback = function(response) {
                            var resData = response.data;
                            var fullParams = response.config.params;
                            var data = parseResponse(resData, operation, whatFetched, url, response, deferred);
                            // support empty response for getList() calls (some APIs respond with 204 and empty body)
                            if (_.isUndefined(data) || "" === data) data = [];
                            if (!_.isArray(data)) throw new Error("Response for getList SHOULD be an array and not an object or something else");
                            if (true === config.plainByDefault) return resolvePromise(deferred, response, data, filledArray);
                            var processedData = _.map(data, function(elem) {
                                if (!__this[config.restangularFields.restangularCollection]) return restangularizeElem(__this, elem, what, true, data);
                                else return restangularizeElem(__this[config.restangularFields.parentResource], elem, __this[config.restangularFields.route], true, data);
                            });
                            processedData = _.extend(data, processedData);
                            if (!__this[config.restangularFields.restangularCollection]) resolvePromise(deferred, response, restangularizeCollection(__this, processedData, what, true, fullParams), filledArray);
                            else resolvePromise(deferred, response, restangularizeCollection(__this[config.restangularFields.parentResource], processedData, __this[config.restangularFields.route], true, fullParams), filledArray);
                        };
                        urlHandler.resource(this, $http, request.httpConfig, request.headers, request.params, what, this[config.restangularFields.etag], operation)[method]().then(okCallback, function error(response) {
                            if (response.status === 304 && __this[config.restangularFields.restangularCollection]) resolvePromise(deferred, response, __this, filledArray);
                            else if (_.every(config.errorInterceptors, function(cb) {
                                return cb(response, deferred, okCallback) !== false;
                            })) // triggered if no callback returns false
                            deferred.reject(response);
                        });
                        return restangularizePromise(deferred.promise, true, filledArray);
                    }
                    function withHttpConfig(httpConfig) {
                        this[config.restangularFields.httpConfig] = httpConfig;
                        return this;
                    }
                    function save(params, headers) {
                        if (this[config.restangularFields.fromServer]) return this[config.restangularFields.put](params, headers);
                        else return _.bind(elemFunction, this)("post", undefined, params, undefined, headers);
                    }
                    function elemFunction(operation, what, params, obj, headers) {
                        var __this = this;
                        var deferred = $q.defer();
                        var resParams = params || {};
                        var route = what || this[config.restangularFields.route];
                        var fetchUrl = urlHandler.fetchUrl(this, what);
                        var callObj = obj || this;
                        // fallback to etag on restangular object (since for custom methods we probably don't explicitly specify the etag field)
                        var etag = callObj[config.restangularFields.etag] || (operation !== "post" ? this[config.restangularFields.etag] : null);
                        if (_.isObject(callObj) && config.isRestangularized(callObj)) callObj = stripRestangular(callObj);
                        var request = config.fullRequestInterceptor(callObj, operation, route, fetchUrl, headers || {}, resParams || {}, this[config.restangularFields.httpConfig] || {});
                        var filledObject = {};
                        filledObject = config.transformElem(filledObject, false, route, service);
                        var okCallback = function(response) {
                            var resData = response.data;
                            var fullParams = response.config.params;
                            var elem = parseResponse(resData, operation, route, fetchUrl, response, deferred);
                            // accept 0 as response
                            if (elem !== null && elem !== undefined && elem !== "") {
                                var data;
                                if (true === config.plainByDefault) return resolvePromise(deferred, response, elem, filledObject);
                                if (operation === "post" && !__this[config.restangularFields.restangularCollection]) {
                                    data = restangularizeElem(__this[config.restangularFields.parentResource], elem, route, true, null, fullParams);
                                    resolvePromise(deferred, response, data, filledObject);
                                } else {
                                    data = restangularizeElem(__this[config.restangularFields.parentResource], elem, __this[config.restangularFields.route], true, null, fullParams);
                                    data[config.restangularFields.singleOne] = __this[config.restangularFields.singleOne];
                                    resolvePromise(deferred, response, data, filledObject);
                                }
                            } else resolvePromise(deferred, response, undefined, filledObject);
                        };
                        var errorCallback = function(response) {
                            if (response.status === 304 && config.isSafe(operation)) resolvePromise(deferred, response, __this, filledObject);
                            else if (_.every(config.errorInterceptors, function(cb) {
                                return cb(response, deferred, okCallback) !== false;
                            })) // triggered if no callback returns false
                            deferred.reject(response);
                        };
                        // Overriding HTTP Method
                        var callOperation = operation;
                        var callHeaders = _.extend({}, request.headers);
                        var isOverrideOperation = config.isOverridenMethod(operation);
                        if (isOverrideOperation) {
                            callOperation = "post";
                            callHeaders = _.extend(callHeaders, {
                                "X-HTTP-Method-Override": operation === "remove" ? "DELETE" : operation.toUpperCase()
                            });
                        } else if (config.jsonp && callOperation === "get") callOperation = "jsonp";
                        if (config.isSafe(operation)) {
                            if (isOverrideOperation) urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params, what, etag, callOperation)[callOperation]({}).then(okCallback, errorCallback);
                            else urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params, what, etag, callOperation)[callOperation]().then(okCallback, errorCallback);
                        } else urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params, what, etag, callOperation)[callOperation](request.element).then(okCallback, errorCallback);
                        return restangularizePromise(deferred.promise, false, filledObject);
                    }
                    function getFunction(params, headers) {
                        return _.bind(elemFunction, this)("get", undefined, params, undefined, headers);
                    }
                    function deleteFunction(params, headers) {
                        return _.bind(elemFunction, this)("remove", undefined, params, undefined, headers);
                    }
                    function putFunction(params, headers) {
                        return _.bind(elemFunction, this)("put", undefined, params, undefined, headers);
                    }
                    function postFunction(what, elem, params, headers) {
                        return _.bind(elemFunction, this)("post", what, params, elem, headers);
                    }
                    function headFunction(params, headers) {
                        return _.bind(elemFunction, this)("head", undefined, params, undefined, headers);
                    }
                    function traceFunction(params, headers) {
                        return _.bind(elemFunction, this)("trace", undefined, params, undefined, headers);
                    }
                    function optionsFunction(params, headers) {
                        return _.bind(elemFunction, this)("options", undefined, params, undefined, headers);
                    }
                    function patchFunction(elem, params, headers) {
                        return _.bind(elemFunction, this)("patch", undefined, params, elem, headers);
                    }
                    function customFunction(operation, path, params, headers, elem) {
                        return _.bind(elemFunction, this)(operation, path, params, elem, headers);
                    }
                    function addRestangularMethodFunction(name, operation, path, defaultParams, defaultHeaders, defaultElem) {
                        var bindedFunction;
                        if (operation === "getList") bindedFunction = _.bind(fetchFunction, this, path);
                        else bindedFunction = _.bind(customFunction, this, operation, path);
                        var createdFunction = function(params, headers, elem) {
                            var callParams = _.defaults({
                                params: params,
                                headers: headers,
                                elem: elem
                            }, {
                                params: defaultParams,
                                headers: defaultHeaders,
                                elem: defaultElem
                            });
                            return bindedFunction(callParams.params, callParams.headers, callParams.elem);
                        };
                        if (config.isSafe(operation)) this[name] = createdFunction;
                        else this[name] = function(elem, params, headers) {
                            return createdFunction(params, headers, elem);
                        };
                    }
                    function withConfigurationFunction(configurer) {
                        var newConfig = angular.copy(_.omit(config, "configuration"));
                        Configurer.init(newConfig, newConfig);
                        configurer(newConfig);
                        return createServiceForConfiguration(newConfig);
                    }
                    function toService(route, parent) {
                        var knownCollectionMethods = _.values(config.restangularFields);
                        var serv = {};
                        var collection = (parent || service).all(route);
                        serv.one = _.bind(one, parent || service, parent, route);
                        serv.post = _.bind(collection.post, collection);
                        serv.getList = _.bind(collection.getList, collection);
                        serv.withHttpConfig = _.bind(collection.withHttpConfig, collection);
                        serv.get = _.bind(collection.get, collection);
                        for(var prop in collection)if (collection.hasOwnProperty(prop) && _.isFunction(collection[prop]) && !_.includes(knownCollectionMethods, prop)) serv[prop] = _.bind(collection[prop], collection);
                        return serv;
                    }
                    Configurer.init(service, config);
                    service.copy = _.bind(copyRestangularizedElement, service);
                    service.service = _.bind(toService, service);
                    service.withConfig = _.bind(withConfigurationFunction, service);
                    service.one = _.bind(one, service, null);
                    service.all = _.bind(all, service, null);
                    service.several = _.bind(several, service, null);
                    service.oneUrl = _.bind(oneUrl, service, null);
                    service.allUrl = _.bind(allUrl, service, null);
                    service.stripRestangular = _.bind(stripRestangular, service);
                    service.restangularizeElement = _.bind(restangularizeElem, service);
                    service.restangularizeCollection = _.bind(restangularizeCollectionAndElements, service);
                    return service;
                }
                return createServiceForConfiguration(globalConfiguration);
            }
        ];
    });
    return restangular.name;
});

},{"a1ab2afe0cee4cff":"30pa7","24067559bde95dd9":"8oyA9"}],"30pa7":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"knhW1":[function(require,module,exports) {
require("57b79677b8508e3");
module.exports = "ui.bootstrap";

},{"57b79677b8508e3":"irlqz"}],"irlqz":[function(require,module,exports) {
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.14.3 - 2015-10-23
 * License: MIT
 */ angular.module("ui.bootstrap", [
    "ui.bootstrap.tpls",
    "ui.bootstrap.collapse",
    "ui.bootstrap.accordion",
    "ui.bootstrap.alert",
    "ui.bootstrap.buttons",
    "ui.bootstrap.carousel",
    "ui.bootstrap.dateparser",
    "ui.bootstrap.position",
    "ui.bootstrap.datepicker",
    "ui.bootstrap.dropdown",
    "ui.bootstrap.stackedMap",
    "ui.bootstrap.modal",
    "ui.bootstrap.pagination",
    "ui.bootstrap.tooltip",
    "ui.bootstrap.popover",
    "ui.bootstrap.progressbar",
    "ui.bootstrap.rating",
    "ui.bootstrap.tabs",
    "ui.bootstrap.timepicker",
    "ui.bootstrap.typeahead"
]);
angular.module("ui.bootstrap.tpls", [
    "template/accordion/accordion-group.html",
    "template/accordion/accordion.html",
    "template/alert/alert.html",
    "template/carousel/carousel.html",
    "template/carousel/slide.html",
    "template/datepicker/datepicker.html",
    "template/datepicker/day.html",
    "template/datepicker/month.html",
    "template/datepicker/popup.html",
    "template/datepicker/year.html",
    "template/modal/backdrop.html",
    "template/modal/window.html",
    "template/pagination/pager.html",
    "template/pagination/pagination.html",
    "template/tooltip/tooltip-html-popup.html",
    "template/tooltip/tooltip-popup.html",
    "template/tooltip/tooltip-template-popup.html",
    "template/popover/popover-html.html",
    "template/popover/popover-template.html",
    "template/popover/popover.html",
    "template/progressbar/bar.html",
    "template/progressbar/progress.html",
    "template/progressbar/progressbar.html",
    "template/rating/rating.html",
    "template/tabs/tab.html",
    "template/tabs/tabset.html",
    "template/timepicker/timepicker.html",
    "template/typeahead/typeahead-match.html",
    "template/typeahead/typeahead-popup.html"
]);
angular.module("ui.bootstrap.collapse", []).directive("uibCollapse", [
    "$animate",
    "$injector",
    function($animate, $injector) {
        var $animateCss = $injector.has("$animateCss") ? $injector.get("$animateCss") : null;
        return {
            link: function(scope, element, attrs) {
                function expand() {
                    element.removeClass("collapse").addClass("collapsing").attr("aria-expanded", true).attr("aria-hidden", false);
                    if ($animateCss) $animateCss(element, {
                        addClass: "in",
                        easing: "ease",
                        to: {
                            height: element[0].scrollHeight + "px"
                        }
                    }).start().finally(expandDone);
                    else $animate.addClass(element, "in", {
                        to: {
                            height: element[0].scrollHeight + "px"
                        }
                    }).then(expandDone);
                }
                function expandDone() {
                    element.removeClass("collapsing").addClass("collapse").css({
                        height: "auto"
                    });
                }
                function collapse() {
                    if (!element.hasClass("collapse") && !element.hasClass("in")) return collapseDone();
                    element// IMPORTANT: The height must be set before adding "collapsing" class.
                    // Otherwise, the browser attempts to animate from height 0 (in
                    // collapsing class) to the given height here.
                    .css({
                        height: element[0].scrollHeight + "px"
                    })// initially all panel collapse have the collapse class, this removal
                    // prevents the animation from jumping to collapsed state
                    .removeClass("collapse").addClass("collapsing").attr("aria-expanded", false).attr("aria-hidden", true);
                    if ($animateCss) $animateCss(element, {
                        removeClass: "in",
                        to: {
                            height: "0"
                        }
                    }).start().finally(collapseDone);
                    else $animate.removeClass(element, "in", {
                        to: {
                            height: "0"
                        }
                    }).then(collapseDone);
                }
                function collapseDone() {
                    element.css({
                        height: "0"
                    }); // Required so that collapse works when animation is disabled
                    element.removeClass("collapsing").addClass("collapse");
                }
                scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
                    if (shouldCollapse) collapse();
                    else expand();
                });
            }
        };
    }
]);
/* Deprecated collapse below */ angular.module("ui.bootstrap.collapse").value("$collapseSuppressWarning", false).directive("collapse", [
    "$animate",
    "$injector",
    "$log",
    "$collapseSuppressWarning",
    function($animate, $injector, $log, $collapseSuppressWarning) {
        var $animateCss = $injector.has("$animateCss") ? $injector.get("$animateCss") : null;
        return {
            link: function(scope, element, attrs) {
                if (!$collapseSuppressWarning) $log.warn("collapse is now deprecated. Use uib-collapse instead.");
                function expand() {
                    element.removeClass("collapse").addClass("collapsing").attr("aria-expanded", true).attr("aria-hidden", false);
                    if ($animateCss) $animateCss(element, {
                        easing: "ease",
                        to: {
                            height: element[0].scrollHeight + "px"
                        }
                    }).start().done(expandDone);
                    else $animate.animate(element, {}, {
                        height: element[0].scrollHeight + "px"
                    }).then(expandDone);
                }
                function expandDone() {
                    element.removeClass("collapsing").addClass("collapse in").css({
                        height: "auto"
                    });
                }
                function collapse() {
                    if (!element.hasClass("collapse") && !element.hasClass("in")) return collapseDone();
                    element// IMPORTANT: The height must be set before adding "collapsing" class.
                    // Otherwise, the browser attempts to animate from height 0 (in
                    // collapsing class) to the given height here.
                    .css({
                        height: element[0].scrollHeight + "px"
                    })// initially all panel collapse have the collapse class, this removal
                    // prevents the animation from jumping to collapsed state
                    .removeClass("collapse in").addClass("collapsing").attr("aria-expanded", false).attr("aria-hidden", true);
                    if ($animateCss) $animateCss(element, {
                        to: {
                            height: "0"
                        }
                    }).start().done(collapseDone);
                    else $animate.animate(element, {}, {
                        height: "0"
                    }).then(collapseDone);
                }
                function collapseDone() {
                    element.css({
                        height: "0"
                    }); // Required so that collapse works when animation is disabled
                    element.removeClass("collapsing").addClass("collapse");
                }
                scope.$watch(attrs.collapse, function(shouldCollapse) {
                    if (shouldCollapse) collapse();
                    else expand();
                });
            }
        };
    }
]);
angular.module("ui.bootstrap.accordion", [
    "ui.bootstrap.collapse"
]).constant("uibAccordionConfig", {
    closeOthers: true
}).controller("UibAccordionController", [
    "$scope",
    "$attrs",
    "uibAccordionConfig",
    function($scope, $attrs, accordionConfig) {
        // This array keeps track of the accordion groups
        this.groups = [];
        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        this.closeOthers = function(openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if (closeOthers) angular.forEach(this.groups, function(group) {
                if (group !== openGroup) group.isOpen = false;
            });
        };
        // This is called from the accordion-group directive to add itself to the accordion
        this.addGroup = function(groupScope) {
            var that = this;
            this.groups.push(groupScope);
            groupScope.$on("$destroy", function(event) {
                that.removeGroup(groupScope);
            });
        };
        // This is called from the accordion-group directive when to remove itself
        this.removeGroup = function(group) {
            var index = this.groups.indexOf(group);
            if (index !== -1) this.groups.splice(index, 1);
        };
    }
])// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive("uibAccordion", function() {
    return {
        controller: "UibAccordionController",
        controllerAs: "accordion",
        transclude: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/accordion/accordion.html";
        }
    };
})// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive("uibAccordionGroup", function() {
    return {
        require: "^uibAccordion",
        transclude: true,
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/accordion/accordion-group.html";
        },
        scope: {
            heading: "@",
            isOpen: "=?",
            isDisabled: "=?"
        },
        controller: function() {
            this.setHeading = function(element) {
                this.heading = element;
            };
        },
        link: function(scope, element, attrs, accordionCtrl) {
            accordionCtrl.addGroup(scope);
            scope.openClass = attrs.openClass || "panel-open";
            scope.panelClass = attrs.panelClass;
            scope.$watch("isOpen", function(value) {
                element.toggleClass(scope.openClass, !!value);
                if (value) accordionCtrl.closeOthers(scope);
            });
            scope.toggleOpen = function($event) {
                if (!scope.isDisabled) {
                    if (!$event || $event.which === 32) scope.isOpen = !scope.isOpen;
                }
            };
        }
    };
})// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive("uibAccordionHeading", function() {
    return {
        transclude: true,
        template: "",
        replace: true,
        require: "^uibAccordionGroup",
        link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
            // Pass the heading to the accordion-group controller
            // so that it can be transcluded into the right place in the template
            // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
            accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
        }
    };
})// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive("uibAccordionTransclude", function() {
    return {
        require: [
            "?^uibAccordionGroup",
            "?^accordionGroup"
        ],
        link: function(scope, element, attrs, controller) {
            controller = controller[0] ? controller[0] : controller[1]; // Delete after we remove deprecation
            scope.$watch(function() {
                return controller[attrs.uibAccordionTransclude];
            }, function(heading) {
                if (heading) {
                    element.find("span").html("");
                    element.find("span").append(heading);
                }
            });
        }
    };
});
/* Deprecated accordion below */ angular.module("ui.bootstrap.accordion").value("$accordionSuppressWarning", false).controller("AccordionController", [
    "$scope",
    "$attrs",
    "$controller",
    "$log",
    "$accordionSuppressWarning",
    function($scope, $attrs, $controller, $log, $accordionSuppressWarning) {
        if (!$accordionSuppressWarning) $log.warn("AccordionController is now deprecated. Use UibAccordionController instead.");
        angular.extend(this, $controller("UibAccordionController", {
            $scope: $scope,
            $attrs: $attrs
        }));
    }
]).directive("accordion", [
    "$log",
    "$accordionSuppressWarning",
    function($log, $accordionSuppressWarning) {
        return {
            restrict: "EA",
            controller: "AccordionController",
            controllerAs: "accordion",
            transclude: true,
            replace: false,
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/accordion/accordion.html";
            },
            link: function() {
                if (!$accordionSuppressWarning) $log.warn("accordion is now deprecated. Use uib-accordion instead.");
            }
        };
    }
]).directive("accordionGroup", [
    "$log",
    "$accordionSuppressWarning",
    function($log, $accordionSuppressWarning) {
        return {
            require: "^accordion",
            restrict: "EA",
            transclude: true,
            replace: true,
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/accordion/accordion-group.html";
            },
            scope: {
                heading: "@",
                isOpen: "=?",
                isDisabled: "=?"
            },
            controller: function() {
                this.setHeading = function(element) {
                    this.heading = element;
                };
            },
            link: function(scope, element, attrs, accordionCtrl) {
                if (!$accordionSuppressWarning) $log.warn("accordion-group is now deprecated. Use uib-accordion-group instead.");
                accordionCtrl.addGroup(scope);
                scope.openClass = attrs.openClass || "panel-open";
                scope.panelClass = attrs.panelClass;
                scope.$watch("isOpen", function(value) {
                    element.toggleClass(scope.openClass, !!value);
                    if (value) accordionCtrl.closeOthers(scope);
                });
                scope.toggleOpen = function($event) {
                    if (!scope.isDisabled) {
                        if (!$event || $event.which === 32) scope.isOpen = !scope.isOpen;
                    }
                };
            }
        };
    }
]).directive("accordionHeading", [
    "$log",
    "$accordionSuppressWarning",
    function($log, $accordionSuppressWarning) {
        return {
            restrict: "EA",
            transclude: true,
            template: "",
            replace: true,
            require: "^accordionGroup",
            link: function(scope, element, attr, accordionGroupCtrl, transclude) {
                if (!$accordionSuppressWarning) $log.warn("accordion-heading is now deprecated. Use uib-accordion-heading instead.");
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
            }
        };
    }
]).directive("accordionTransclude", [
    "$log",
    "$accordionSuppressWarning",
    function($log, $accordionSuppressWarning) {
        return {
            require: "^accordionGroup",
            link: function(scope, element, attr, controller) {
                if (!$accordionSuppressWarning) $log.warn("accordion-transclude is now deprecated. Use uib-accordion-transclude instead.");
                scope.$watch(function() {
                    return controller[attr.accordionTransclude];
                }, function(heading) {
                    if (heading) {
                        element.find("span").html("");
                        element.find("span").append(heading);
                    }
                });
            }
        };
    }
]);
angular.module("ui.bootstrap.alert", []).controller("UibAlertController", [
    "$scope",
    "$attrs",
    "$interpolate",
    "$timeout",
    function($scope, $attrs, $interpolate, $timeout) {
        $scope.closeable = !!$attrs.close;
        var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
        if (dismissOnTimeout) $timeout(function() {
            $scope.close();
        }, parseInt(dismissOnTimeout, 10));
    }
]).directive("uibAlert", function() {
    return {
        controller: "UibAlertController",
        controllerAs: "alert",
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/alert/alert.html";
        },
        transclude: true,
        replace: true,
        scope: {
            type: "@",
            close: "&"
        }
    };
});
/* Deprecated alert below */ angular.module("ui.bootstrap.alert").value("$alertSuppressWarning", false).controller("AlertController", [
    "$scope",
    "$attrs",
    "$controller",
    "$log",
    "$alertSuppressWarning",
    function($scope, $attrs, $controller, $log, $alertSuppressWarning) {
        if (!$alertSuppressWarning) $log.warn("AlertController is now deprecated. Use UibAlertController instead.");
        angular.extend(this, $controller("UibAlertController", {
            $scope: $scope,
            $attrs: $attrs
        }));
    }
]).directive("alert", [
    "$log",
    "$alertSuppressWarning",
    function($log, $alertSuppressWarning) {
        return {
            controller: "AlertController",
            controllerAs: "alert",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/alert/alert.html";
            },
            transclude: true,
            replace: true,
            scope: {
                type: "@",
                close: "&"
            },
            link: function() {
                if (!$alertSuppressWarning) $log.warn("alert is now deprecated. Use uib-alert instead.");
            }
        };
    }
]);
angular.module("ui.bootstrap.buttons", []).constant("uibButtonConfig", {
    activeClass: "active",
    toggleEvent: "click"
}).controller("UibButtonsController", [
    "uibButtonConfig",
    function(buttonConfig) {
        this.activeClass = buttonConfig.activeClass || "active";
        this.toggleEvent = buttonConfig.toggleEvent || "click";
    }
]).directive("uibBtnRadio", function() {
    return {
        require: [
            "uibBtnRadio",
            "ngModel"
        ],
        controller: "UibButtonsController",
        controllerAs: "buttons",
        link: function(scope, element, attrs, ctrls) {
            var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            element.find("input").css({
                display: "none"
            });
            //model -> UI
            ngModelCtrl.$render = function() {
                element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
            };
            //ui->model
            element.on(buttonsCtrl.toggleEvent, function() {
                if (attrs.disabled) return;
                var isActive = element.hasClass(buttonsCtrl.activeClass);
                if (!isActive || angular.isDefined(attrs.uncheckable)) scope.$apply(function() {
                    ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
                    ngModelCtrl.$render();
                });
            });
        }
    };
}).directive("uibBtnCheckbox", function() {
    return {
        require: [
            "uibBtnCheckbox",
            "ngModel"
        ],
        controller: "UibButtonsController",
        controllerAs: "button",
        link: function(scope, element, attrs, ctrls) {
            var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            element.find("input").css({
                display: "none"
            });
            function getTrueValue() {
                return getCheckboxValue(attrs.btnCheckboxTrue, true);
            }
            function getFalseValue() {
                return getCheckboxValue(attrs.btnCheckboxFalse, false);
            }
            function getCheckboxValue(attribute, defaultValue) {
                return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
            }
            //model -> UI
            ngModelCtrl.$render = function() {
                element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
            };
            //ui->model
            element.on(buttonsCtrl.toggleEvent, function() {
                if (attrs.disabled) return;
                scope.$apply(function() {
                    ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                    ngModelCtrl.$render();
                });
            });
        }
    };
});
/* Deprecated buttons below */ angular.module("ui.bootstrap.buttons").value("$buttonsSuppressWarning", false).controller("ButtonsController", [
    "$controller",
    "$log",
    "$buttonsSuppressWarning",
    function($controller, $log, $buttonsSuppressWarning) {
        if (!$buttonsSuppressWarning) $log.warn("ButtonsController is now deprecated. Use UibButtonsController instead.");
        angular.extend(this, $controller("UibButtonsController"));
    }
]).directive("btnRadio", [
    "$log",
    "$buttonsSuppressWarning",
    function($log, $buttonsSuppressWarning) {
        return {
            require: [
                "btnRadio",
                "ngModel"
            ],
            controller: "ButtonsController",
            controllerAs: "buttons",
            link: function(scope, element, attrs, ctrls) {
                if (!$buttonsSuppressWarning) $log.warn("btn-radio is now deprecated. Use uib-btn-radio instead.");
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                element.find("input").css({
                    display: "none"
                });
                //model -> UI
                ngModelCtrl.$render = function() {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
                };
                //ui->model
                element.bind(buttonsCtrl.toggleEvent, function() {
                    if (attrs.disabled) return;
                    var isActive = element.hasClass(buttonsCtrl.activeClass);
                    if (!isActive || angular.isDefined(attrs.uncheckable)) scope.$apply(function() {
                        ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    }
]).directive("btnCheckbox", [
    "$document",
    "$log",
    "$buttonsSuppressWarning",
    function($document, $log, $buttonsSuppressWarning) {
        return {
            require: [
                "btnCheckbox",
                "ngModel"
            ],
            controller: "ButtonsController",
            controllerAs: "button",
            link: function(scope, element, attrs, ctrls) {
                if (!$buttonsSuppressWarning) $log.warn("btn-checkbox is now deprecated. Use uib-btn-checkbox instead.");
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                element.find("input").css({
                    display: "none"
                });
                function getTrueValue() {
                    return getCheckboxValue(attrs.btnCheckboxTrue, true);
                }
                function getFalseValue() {
                    return getCheckboxValue(attrs.btnCheckboxFalse, false);
                }
                function getCheckboxValue(attributeValue, defaultValue) {
                    var val = scope.$eval(attributeValue);
                    return angular.isDefined(val) ? val : defaultValue;
                }
                //model -> UI
                ngModelCtrl.$render = function() {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };
                //ui->model
                element.bind(buttonsCtrl.toggleEvent, function() {
                    if (attrs.disabled) return;
                    scope.$apply(function() {
                        ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
                //accessibility
                element.on("keypress", function(e) {
                    if (attrs.disabled || e.which !== 32 || $document[0].activeElement !== element[0]) return;
                    scope.$apply(function() {
                        ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    }
]);
/**
 * @ngdoc overview
 * @name ui.bootstrap.carousel
 *
 * @description
 * AngularJS version of an image carousel.
 *
 */ angular.module("ui.bootstrap.carousel", []).controller("UibCarouselController", [
    "$scope",
    "$element",
    "$interval",
    "$animate",
    function($scope, $element, $interval, $animate) {
        var self = this, slides = self.slides = $scope.slides = [], NEW_ANIMATE = angular.version.minor >= 4, NO_TRANSITION = "uib-noTransition", SLIDE_DIRECTION = "uib-slideDirection", currentIndex = -1, currentInterval, isPlaying;
        self.currentSlide = null;
        var destroyed = false;
        /* direction: "prev" or "next" */ self.select = $scope.select = function(nextSlide, direction) {
            var nextIndex = $scope.indexOfSlide(nextSlide);
            //Decide direction if it's not given
            if (direction === undefined) direction = nextIndex > self.getCurrentIndex() ? "next" : "prev";
            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) goNext(nextSlide, nextIndex, direction);
        };
        function goNext(slide, index, direction) {
            // Scope has been destroyed, stop here.
            if (destroyed) return;
            angular.extend(slide, {
                direction: direction,
                active: true
            });
            angular.extend(self.currentSlide || {}, {
                direction: direction,
                active: false
            });
            if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition && slide.$element && self.slides.length > 1) {
                slide.$element.data(SLIDE_DIRECTION, slide.direction);
                if (self.currentSlide && self.currentSlide.$element) self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
                $scope.$currentTransition = true;
                if (NEW_ANIMATE) $animate.on("addClass", slide.$element, function(element, phase) {
                    if (phase === "close") {
                        $scope.$currentTransition = null;
                        $animate.off("addClass", element);
                    }
                });
                else slide.$element.one("$animate:close", function closeFn() {
                    $scope.$currentTransition = null;
                });
            }
            self.currentSlide = slide;
            currentIndex = index;
            //every time you change slides, reset the timer
            restartTimer();
        }
        $scope.$on("$destroy", function() {
            destroyed = true;
        });
        function getSlideByIndex(index) {
            if (angular.isUndefined(slides[index].index)) return slides[index];
            var i, len = slides.length;
            for(i = 0; i < slides.length; ++i){
                if (slides[i].index == index) return slides[i];
            }
        }
        self.getCurrentIndex = function() {
            if (self.currentSlide && angular.isDefined(self.currentSlide.index)) return +self.currentSlide.index;
            return currentIndex;
        };
        /* Allow outside people to call indexOf on slides array */ $scope.indexOfSlide = function(slide) {
            return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
        };
        $scope.next = function() {
            var newIndex = (self.getCurrentIndex() + 1) % slides.length;
            if (newIndex === 0 && $scope.noWrap()) {
                $scope.pause();
                return;
            }
            return self.select(getSlideByIndex(newIndex), "next");
        };
        $scope.prev = function() {
            var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
            if ($scope.noWrap() && newIndex === slides.length - 1) {
                $scope.pause();
                return;
            }
            return self.select(getSlideByIndex(newIndex), "prev");
        };
        $scope.isActive = function(slide) {
            return self.currentSlide === slide;
        };
        $scope.$watch("interval", restartTimer);
        $scope.$watchCollection("slides", resetTransition);
        $scope.$on("$destroy", resetTimer);
        function restartTimer() {
            resetTimer();
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval > 0) currentInterval = $interval(timerFn, interval);
        }
        function resetTimer() {
            if (currentInterval) {
                $interval.cancel(currentInterval);
                currentInterval = null;
            }
        }
        function timerFn() {
            var interval = +$scope.interval;
            if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) $scope.next();
            else $scope.pause();
        }
        function resetTransition(slides) {
            if (!slides.length) $scope.$currentTransition = null;
        }
        $scope.play = function() {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };
        $scope.pause = function() {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };
        self.addSlide = function(slide, element) {
            slide.$element = element;
            slides.push(slide);
            //if this is the first slide or the slide is set to active, select it
            if (slides.length === 1 || slide.active) {
                self.select(slides[slides.length - 1]);
                if (slides.length === 1) $scope.play();
            } else slide.active = false;
        };
        self.removeSlide = function(slide) {
            if (angular.isDefined(slide.index)) slides.sort(function(a, b) {
                return +a.index > +b.index;
            });
            //get the index of the slide inside the carousel
            var index = slides.indexOf(slide);
            slides.splice(index, 1);
            if (slides.length > 0 && slide.active) {
                if (index >= slides.length) self.select(slides[index - 1]);
                else self.select(slides[index]);
            } else if (currentIndex > index) currentIndex--;
            //clean the currentSlide when no more slide
            if (slides.length === 0) self.currentSlide = null;
        };
        $scope.$watch("noTransition", function(noTransition) {
            $element.data(NO_TRANSITION, noTransition);
        });
    }
])/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <uib-carousel>
      <uib-slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </uib-slide>
      <uib-slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </uib-slide>
    </uib-carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */ .directive("uibCarousel", [
    function() {
        return {
            transclude: true,
            replace: true,
            controller: "UibCarouselController",
            controllerAs: "carousel",
            require: "carousel",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/carousel/carousel.html";
            },
            scope: {
                interval: "=",
                noTransition: "=",
                noPause: "=",
                noWrap: "&"
            }
        };
    }
])/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <uib-carousel>
    <uib-slide ng-repeat="slide in slides" active="slide.active" index="$index">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </uib-slide>
  </uib-carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/ .directive("uibSlide", function() {
    return {
        require: "^uibCarousel",
        restrict: "EA",
        transclude: true,
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/carousel/slide.html";
        },
        scope: {
            active: "=?",
            actual: "=?",
            index: "=?"
        },
        link: function(scope, element, attrs, carouselCtrl) {
            carouselCtrl.addSlide(scope, element);
            //when the scope is destroyed then remove the slide from the current slides array
            scope.$on("$destroy", function() {
                carouselCtrl.removeSlide(scope);
            });
            scope.$watch("active", function(active) {
                if (active) carouselCtrl.select(scope);
            });
        }
    };
}).animation(".item", [
    "$injector",
    "$animate",
    function($injector, $animate) {
        var NO_TRANSITION = "uib-noTransition", SLIDE_DIRECTION = "uib-slideDirection", $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        function removeClass(element, className, callback) {
            element.removeClass(className);
            if (callback) callback();
        }
        return {
            beforeAddClass: function(element, className, done) {
                // Due to transclusion, noTransition property is on parent's scope
                if (className == "active" && element.parent() && element.parent().parent() && !element.parent().parent().data(NO_TRANSITION)) {
                    var stopped = false;
                    var direction = element.data(SLIDE_DIRECTION);
                    var directionClass = direction == "next" ? "left" : "right";
                    var removeClassFn = removeClass.bind(this, element, directionClass + " " + direction, done);
                    element.addClass(direction);
                    if ($animateCss) $animateCss(element, {
                        addClass: directionClass
                    }).start().done(removeClassFn);
                    else $animate.addClass(element, directionClass).then(function() {
                        if (!stopped) removeClassFn();
                        done();
                    });
                    return function() {
                        stopped = true;
                    };
                }
                done();
            },
            beforeRemoveClass: function(element, className, done) {
                // Due to transclusion, noTransition property is on parent's scope
                if (className === "active" && element.parent() && element.parent().parent() && !element.parent().parent().data(NO_TRANSITION)) {
                    var stopped = false;
                    var direction = element.data(SLIDE_DIRECTION);
                    var directionClass = direction == "next" ? "left" : "right";
                    var removeClassFn = removeClass.bind(this, element, directionClass, done);
                    if ($animateCss) $animateCss(element, {
                        addClass: directionClass
                    }).start().done(removeClassFn);
                    else $animate.addClass(element, directionClass).then(function() {
                        if (!stopped) removeClassFn();
                        done();
                    });
                    return function() {
                        stopped = true;
                    };
                }
                done();
            }
        };
    }
]);
/* deprecated carousel below */ angular.module("ui.bootstrap.carousel").value("$carouselSuppressWarning", false).controller("CarouselController", [
    "$scope",
    "$element",
    "$controller",
    "$log",
    "$carouselSuppressWarning",
    function($scope, $element, $controller, $log, $carouselSuppressWarning) {
        if (!$carouselSuppressWarning) $log.warn("CarouselController is now deprecated. Use UibCarouselController instead.");
        angular.extend(this, $controller("UibCarouselController", {
            $scope: $scope,
            $element: $element
        }));
    }
]).directive("carousel", [
    "$log",
    "$carouselSuppressWarning",
    function($log, $carouselSuppressWarning) {
        return {
            transclude: true,
            replace: true,
            controller: "CarouselController",
            controllerAs: "carousel",
            require: "carousel",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/carousel/carousel.html";
            },
            scope: {
                interval: "=",
                noTransition: "=",
                noPause: "=",
                noWrap: "&"
            },
            link: function() {
                if (!$carouselSuppressWarning) $log.warn("carousel is now deprecated. Use uib-carousel instead.");
            }
        };
    }
]).directive("slide", [
    "$log",
    "$carouselSuppressWarning",
    function($log, $carouselSuppressWarning) {
        return {
            require: "^carousel",
            transclude: true,
            replace: true,
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/carousel/slide.html";
            },
            scope: {
                active: "=?",
                actual: "=?",
                index: "=?"
            },
            link: function(scope, element, attrs, carouselCtrl) {
                if (!$carouselSuppressWarning) $log.warn("slide is now deprecated. Use uib-slide instead.");
                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on("$destroy", function() {
                    carouselCtrl.removeSlide(scope);
                });
                scope.$watch("active", function(active) {
                    if (active) carouselCtrl.select(scope);
                });
            }
        };
    }
]);
angular.module("ui.bootstrap.dateparser", []).service("uibDateParser", [
    "$log",
    "$locale",
    "orderByFilter",
    function($log, $locale, orderByFilter) {
        // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
        var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
        var localeId;
        var formatCodeToRegex;
        this.init = function() {
            localeId = $locale.id;
            this.parsers = {};
            formatCodeToRegex = {
                "yyyy": {
                    regex: "\\d{4}",
                    apply: function(value) {
                        this.year = +value;
                    }
                },
                "yy": {
                    regex: "\\d{2}",
                    apply: function(value) {
                        this.year = +value + 2000;
                    }
                },
                "y": {
                    regex: "\\d{1,4}",
                    apply: function(value) {
                        this.year = +value;
                    }
                },
                "MMMM": {
                    regex: $locale.DATETIME_FORMATS.MONTH.join("|"),
                    apply: function(value) {
                        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
                    }
                },
                "MMM": {
                    regex: $locale.DATETIME_FORMATS.SHORTMONTH.join("|"),
                    apply: function(value) {
                        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
                    }
                },
                "MM": {
                    regex: "0[1-9]|1[0-2]",
                    apply: function(value) {
                        this.month = value - 1;
                    }
                },
                "M": {
                    regex: "[1-9]|1[0-2]",
                    apply: function(value) {
                        this.month = value - 1;
                    }
                },
                "dd": {
                    regex: "[0-2][0-9]{1}|3[0-1]{1}",
                    apply: function(value) {
                        this.date = +value;
                    }
                },
                "d": {
                    regex: "[1-2]?[0-9]{1}|3[0-1]{1}",
                    apply: function(value) {
                        this.date = +value;
                    }
                },
                "EEEE": {
                    regex: $locale.DATETIME_FORMATS.DAY.join("|")
                },
                "EEE": {
                    regex: $locale.DATETIME_FORMATS.SHORTDAY.join("|")
                },
                "HH": {
                    regex: "(?:0|1)[0-9]|2[0-3]",
                    apply: function(value) {
                        this.hours = +value;
                    }
                },
                "hh": {
                    regex: "0[0-9]|1[0-2]",
                    apply: function(value) {
                        this.hours = +value;
                    }
                },
                "H": {
                    regex: "1?[0-9]|2[0-3]",
                    apply: function(value) {
                        this.hours = +value;
                    }
                },
                "h": {
                    regex: "[0-9]|1[0-2]",
                    apply: function(value) {
                        this.hours = +value;
                    }
                },
                "mm": {
                    regex: "[0-5][0-9]",
                    apply: function(value) {
                        this.minutes = +value;
                    }
                },
                "m": {
                    regex: "[0-9]|[1-5][0-9]",
                    apply: function(value) {
                        this.minutes = +value;
                    }
                },
                "sss": {
                    regex: "[0-9][0-9][0-9]",
                    apply: function(value) {
                        this.milliseconds = +value;
                    }
                },
                "ss": {
                    regex: "[0-5][0-9]",
                    apply: function(value) {
                        this.seconds = +value;
                    }
                },
                "s": {
                    regex: "[0-9]|[1-5][0-9]",
                    apply: function(value) {
                        this.seconds = +value;
                    }
                },
                "a": {
                    regex: $locale.DATETIME_FORMATS.AMPMS.join("|"),
                    apply: function(value) {
                        if (this.hours === 12) this.hours = 0;
                        if (value === "PM") this.hours += 12;
                    }
                }
            };
        };
        this.init();
        function createParser(format) {
            var map = [], regex = format.split("");
            angular.forEach(formatCodeToRegex, function(data, code) {
                var index = format.indexOf(code);
                if (index > -1) {
                    format = format.split("");
                    regex[index] = "(" + data.regex + ")";
                    format[index] = "$"; // Custom symbol to define consumed part of format
                    for(var i = index + 1, n = index + code.length; i < n; i++){
                        regex[i] = "";
                        format[i] = "$";
                    }
                    format = format.join("");
                    map.push({
                        index: index,
                        apply: data.apply
                    });
                }
            });
            return {
                regex: new RegExp("^" + regex.join("") + "$"),
                map: orderByFilter(map, "index")
            };
        }
        this.parse = function(input, format, baseDate) {
            if (!angular.isString(input) || !format) return input;
            format = $locale.DATETIME_FORMATS[format] || format;
            format = format.replace(SPECIAL_CHARACTERS_REGEXP, "\\$&");
            if ($locale.id !== localeId) this.init();
            if (!this.parsers[format]) this.parsers[format] = createParser(format);
            var parser = this.parsers[format], regex = parser.regex, map = parser.map, results = input.match(regex);
            if (results && results.length) {
                var fields, dt;
                if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) fields = {
                    year: baseDate.getFullYear(),
                    month: baseDate.getMonth(),
                    date: baseDate.getDate(),
                    hours: baseDate.getHours(),
                    minutes: baseDate.getMinutes(),
                    seconds: baseDate.getSeconds(),
                    milliseconds: baseDate.getMilliseconds()
                };
                else {
                    if (baseDate) $log.warn("dateparser:", "baseDate is not a valid date");
                    fields = {
                        year: 1900,
                        month: 0,
                        date: 1,
                        hours: 0,
                        minutes: 0,
                        seconds: 0,
                        milliseconds: 0
                    };
                }
                for(var i = 1, n = results.length; i < n; i++){
                    var mapper = map[i - 1];
                    if (mapper.apply) mapper.apply.call(fields, results[i]);
                }
                if (isValid(fields.year, fields.month, fields.date)) {
                    if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
                        dt = new Date(baseDate);
                        dt.setFullYear(fields.year, fields.month, fields.date, fields.hours, fields.minutes, fields.seconds, fields.milliseconds || 0);
                    } else dt = new Date(fields.year, fields.month, fields.date, fields.hours, fields.minutes, fields.seconds, fields.milliseconds || 0);
                }
                return dt;
            }
        };
        // Check if date is valid for specific month (and year for February).
        // Month: 0 = Jan, 1 = Feb, etc
        function isValid(year, month, date) {
            if (date < 1) return false;
            if (month === 1 && date > 28) return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
            if (month === 3 || month === 5 || month === 8 || month === 10) return date < 31;
            return true;
        }
    }
]);
/* Deprecated dateparser below */ angular.module("ui.bootstrap.dateparser").value("$dateParserSuppressWarning", false).service("dateParser", [
    "$log",
    "$dateParserSuppressWarning",
    "uibDateParser",
    function($log, $dateParserSuppressWarning, uibDateParser) {
        if (!$dateParserSuppressWarning) $log.warn("dateParser is now deprecated. Use uibDateParser instead.");
        angular.extend(this, uibDateParser);
    }
]);
angular.module("ui.bootstrap.position", [])/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */ .factory("$uibPosition", [
    "$document",
    "$window",
    function($document, $window) {
        function getStyle(el, cssprop) {
            if (el.currentStyle) return el.currentStyle[cssprop];
            else if ($window.getComputedStyle) return $window.getComputedStyle(el)[cssprop];
            // finally try and get inline style
            return el.style[cssprop];
        }
        /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */ function isStaticPositioned(element) {
            return (getStyle(element, "position") || "static") === "static";
        }
        /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */ var parentOffsetEl = function(element) {
            var docDomEl = $document[0];
            var offsetParent = element.offsetParent || docDomEl;
            while(offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent))offsetParent = offsetParent.offsetParent;
            return offsetParent || docDomEl;
        };
        return {
            /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */ position: function(element) {
                var elBCR = this.offset(element);
                var offsetParentBCR = {
                    top: 0,
                    left: 0
                };
                var offsetParentEl = parentOffsetEl(element[0]);
                if (offsetParentEl != $document[0]) {
                    offsetParentBCR = this.offset(angular.element(offsetParentEl));
                    offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                    offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
                }
                var boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: boundingClientRect.width || element.prop("offsetWidth"),
                    height: boundingClientRect.height || element.prop("offsetHeight"),
                    top: elBCR.top - offsetParentBCR.top,
                    left: elBCR.left - offsetParentBCR.left
                };
            },
            /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */ offset: function(element) {
                var boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: boundingClientRect.width || element.prop("offsetWidth"),
                    height: boundingClientRect.height || element.prop("offsetHeight"),
                    top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
                    left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
                };
            },
            /**
       * Provides coordinates for the targetEl in relation to hostEl
       */ positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
                var positionStrParts = positionStr.split("-");
                var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || "center";
                var hostElPos, targetElWidth, targetElHeight, targetElPos;
                hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
                targetElWidth = targetEl.prop("offsetWidth");
                targetElHeight = targetEl.prop("offsetHeight");
                var shiftWidth = {
                    center: function() {
                        return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
                    },
                    left: function() {
                        return hostElPos.left;
                    },
                    right: function() {
                        return hostElPos.left + hostElPos.width;
                    }
                };
                var shiftHeight = {
                    center: function() {
                        return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
                    },
                    top: function() {
                        return hostElPos.top;
                    },
                    bottom: function() {
                        return hostElPos.top + hostElPos.height;
                    }
                };
                switch(pos0){
                    case "right":
                        targetElPos = {
                            top: shiftHeight[pos1](),
                            left: shiftWidth[pos0]()
                        };
                        break;
                    case "left":
                        targetElPos = {
                            top: shiftHeight[pos1](),
                            left: hostElPos.left - targetElWidth
                        };
                        break;
                    case "bottom":
                        targetElPos = {
                            top: shiftHeight[pos0](),
                            left: shiftWidth[pos1]()
                        };
                        break;
                    default:
                        targetElPos = {
                            top: hostElPos.top - targetElHeight,
                            left: shiftWidth[pos1]()
                        };
                        break;
                }
                return targetElPos;
            }
        };
    }
]);
/* Deprecated position below */ angular.module("ui.bootstrap.position").value("$positionSuppressWarning", false).service("$position", [
    "$log",
    "$positionSuppressWarning",
    "$uibPosition",
    function($log, $positionSuppressWarning, $uibPosition) {
        if (!$positionSuppressWarning) $log.warn("$position is now deprecated. Use $uibPosition instead.");
        angular.extend(this, $uibPosition);
    }
]);
angular.module("ui.bootstrap.datepicker", [
    "ui.bootstrap.dateparser",
    "ui.bootstrap.position"
]).value("$datepickerSuppressError", false).constant("uibDatepickerConfig", {
    formatDay: "dd",
    formatMonth: "MMMM",
    formatYear: "yyyy",
    formatDayHeader: "EEE",
    formatDayTitle: "MMMM yyyy",
    formatMonthTitle: "yyyy",
    datepickerMode: "day",
    minMode: "day",
    maxMode: "year",
    showWeeks: true,
    startingDay: 0,
    yearRange: 20,
    minDate: null,
    maxDate: null,
    shortcutPropagation: false
}).controller("UibDatepickerController", [
    "$scope",
    "$attrs",
    "$parse",
    "$interpolate",
    "$log",
    "dateFilter",
    "uibDatepickerConfig",
    "$datepickerSuppressError",
    function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
        var self = this, ngModelCtrl = {
            $setViewValue: angular.noop
        }; // nullModelCtrl;
        // Modes chain
        this.modes = [
            "day",
            "month",
            "year"
        ];
        // Configuration attributes
        angular.forEach([
            "formatDay",
            "formatMonth",
            "formatYear",
            "formatDayHeader",
            "formatDayTitle",
            "formatMonthTitle",
            "showWeeks",
            "startingDay",
            "yearRange",
            "shortcutPropagation"
        ], function(key, index) {
            self[key] = angular.isDefined($attrs[key]) ? index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
        });
        // Watchable date attributes
        angular.forEach([
            "minDate",
            "maxDate"
        ], function(key) {
            if ($attrs[key]) $scope.$parent.$watch($parse($attrs[key]), function(value) {
                self[key] = value ? new Date(value) : null;
                self.refreshView();
            });
            else self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
        });
        angular.forEach([
            "minMode",
            "maxMode"
        ], function(key) {
            if ($attrs[key]) $scope.$parent.$watch($parse($attrs[key]), function(value) {
                self[key] = angular.isDefined(value) ? value : $attrs[key];
                $scope[key] = self[key];
                if (key == "minMode" && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) || key == "maxMode" && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) $scope.datepickerMode = self[key];
            });
            else {
                self[key] = datepickerConfig[key] || null;
                $scope[key] = self[key];
            }
        });
        $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
        $scope.uniqueId = "datepicker-" + $scope.$id + "-" + Math.floor(Math.random() * 10000);
        if (angular.isDefined($attrs.initDate)) {
            this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
            $scope.$parent.$watch($attrs.initDate, function(initDate) {
                if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                    self.activeDate = initDate;
                    self.refreshView();
                }
            });
        } else this.activeDate = new Date();
        $scope.isActive = function(dateObject) {
            if (self.compare(dateObject.date, self.activeDate) === 0) {
                $scope.activeDateId = dateObject.uid;
                return true;
            }
            return false;
        };
        this.init = function(ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = function() {
                self.render();
            };
        };
        this.render = function() {
            if (ngModelCtrl.$viewValue) {
                var date = new Date(ngModelCtrl.$viewValue), isValid = !isNaN(date);
                if (isValid) this.activeDate = date;
                else if (!$datepickerSuppressError) $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            }
            this.refreshView();
        };
        this.refreshView = function() {
            if (this.element) {
                this._refreshView();
                var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                ngModelCtrl.$setValidity("dateDisabled", !date || this.element && !this.isDisabled(date));
            }
        };
        this.createDateObject = function(date, format) {
            var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
            return {
                date: date,
                label: dateFilter(date, format),
                selected: model && this.compare(date, model) === 0,
                disabled: this.isDisabled(date),
                current: this.compare(date, new Date()) === 0,
                customClass: this.customClass(date)
            };
        };
        this.isDisabled = function(date) {
            return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({
                date: date,
                mode: $scope.datepickerMode
            });
        };
        this.customClass = function(date) {
            return $scope.customClass({
                date: date,
                mode: $scope.datepickerMode
            });
        };
        // Split array into smaller arrays
        this.split = function(arr, size) {
            var arrays = [];
            while(arr.length > 0)arrays.push(arr.splice(0, size));
            return arrays;
        };
        $scope.select = function(date) {
            if ($scope.datepickerMode === self.minMode) {
                var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
                dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                ngModelCtrl.$setViewValue(dt);
                ngModelCtrl.$render();
            } else {
                self.activeDate = date;
                $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
            }
        };
        $scope.move = function(direction) {
            var year = self.activeDate.getFullYear() + direction * (self.step.years || 0), month = self.activeDate.getMonth() + direction * (self.step.months || 0);
            self.activeDate.setFullYear(year, month, 1);
            self.refreshView();
        };
        $scope.toggleMode = function(direction) {
            direction = direction || 1;
            if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) return;
            $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
        };
        // Key event mapper
        $scope.keys = {
            13: "enter",
            32: "space",
            33: "pageup",
            34: "pagedown",
            35: "end",
            36: "home",
            37: "left",
            38: "up",
            39: "right",
            40: "down"
        };
        var focusElement = function() {
            self.element[0].focus();
        };
        // Listen for focus requests from popup directive
        $scope.$on("uib:datepicker.focus", focusElement);
        $scope.keydown = function(evt) {
            var key = $scope.keys[evt.which];
            if (!key || evt.shiftKey || evt.altKey) return;
            evt.preventDefault();
            if (!self.shortcutPropagation) evt.stopPropagation();
            if (key === "enter" || key === "space") {
                if (self.isDisabled(self.activeDate)) return; // do nothing
                $scope.select(self.activeDate);
            } else if (evt.ctrlKey && (key === "up" || key === "down")) $scope.toggleMode(key === "up" ? 1 : -1);
            else {
                self.handleKeyDown(key, evt);
                self.refreshView();
            }
        };
    }
]).controller("UibDaypickerController", [
    "$scope",
    "$element",
    "dateFilter",
    function(scope, $element, dateFilter) {
        var DAYS_IN_MONTH = [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        this.step = {
            months: 1
        };
        this.element = $element;
        function getDaysInMonth(year, month) {
            return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
        }
        this.init = function(ctrl) {
            angular.extend(ctrl, this);
            scope.showWeeks = ctrl.showWeeks;
            ctrl.refreshView();
        };
        this.getDates = function(startDate, n) {
            var dates = new Array(n), current = new Date(startDate), i = 0, date;
            while(i < n){
                date = new Date(current);
                dates[i++] = date;
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };
        this._refreshView = function() {
            var year = this.activeDate.getFullYear(), month = this.activeDate.getMonth(), firstDayOfMonth = new Date(this.activeDate);
            firstDayOfMonth.setFullYear(year, month, 1);
            var difference = this.startingDay - firstDayOfMonth.getDay(), numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference, firstDate = new Date(firstDayOfMonth);
            if (numDisplayedFromPreviousMonth > 0) firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            // 42 is the number of days on a six-month calendar
            var days = this.getDates(firstDate, 42);
            for(var i = 0; i < 42; i++)days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
                secondary: days[i].getMonth() !== month,
                uid: scope.uniqueId + "-" + i
            });
            scope.labels = new Array(7);
            for(var j = 0; j < 7; j++)scope.labels[j] = {
                abbr: dateFilter(days[j].date, this.formatDayHeader),
                full: dateFilter(days[j].date, "EEEE")
            };
            scope.title = dateFilter(this.activeDate, this.formatDayTitle);
            scope.rows = this.split(days, 7);
            if (scope.showWeeks) {
                scope.weekNumbers = [];
                var thursdayIndex = (11 - this.startingDay) % 7, numWeeks = scope.rows.length;
                for(var curWeek = 0; curWeek < numWeeks; curWeek++)scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
            }
        };
        this.compare = function(date1, date2) {
            return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        };
        function getISO8601WeekNumber(date) {
            var checkDate = new Date(date);
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
            var time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        }
        this.handleKeyDown = function(key, evt) {
            var date = this.activeDate.getDate();
            if (key === "left") date = date - 1; // up
            else if (key === "up") date = date - 7; // down
            else if (key === "right") date = date + 1; // down
            else if (key === "down") date = date + 7;
            else if (key === "pageup" || key === "pagedown") {
                var month = this.activeDate.getMonth() + (key === "pageup" ? -1 : 1);
                this.activeDate.setMonth(month, 1);
                date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
            } else if (key === "home") date = 1;
            else if (key === "end") date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
            this.activeDate.setDate(date);
        };
    }
]).controller("UibMonthpickerController", [
    "$scope",
    "$element",
    "dateFilter",
    function(scope, $element, dateFilter) {
        this.step = {
            years: 1
        };
        this.element = $element;
        this.init = function(ctrl) {
            angular.extend(ctrl, this);
            ctrl.refreshView();
        };
        this._refreshView = function() {
            var months = new Array(12), year = this.activeDate.getFullYear(), date;
            for(var i = 0; i < 12; i++){
                date = new Date(this.activeDate);
                date.setFullYear(year, i, 1);
                months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
                    uid: scope.uniqueId + "-" + i
                });
            }
            scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
            scope.rows = this.split(months, 3);
        };
        this.compare = function(date1, date2) {
            return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
        };
        this.handleKeyDown = function(key, evt) {
            var date = this.activeDate.getMonth();
            if (key === "left") date = date - 1; // up
            else if (key === "up") date = date - 3; // down
            else if (key === "right") date = date + 1; // down
            else if (key === "down") date = date + 3;
            else if (key === "pageup" || key === "pagedown") {
                var year = this.activeDate.getFullYear() + (key === "pageup" ? -1 : 1);
                this.activeDate.setFullYear(year);
            } else if (key === "home") date = 0;
            else if (key === "end") date = 11;
            this.activeDate.setMonth(date);
        };
    }
]).controller("UibYearpickerController", [
    "$scope",
    "$element",
    "dateFilter",
    function(scope, $element, dateFilter) {
        var range;
        this.element = $element;
        function getStartingYear(year) {
            return parseInt((year - 1) / range, 10) * range + 1;
        }
        this.yearpickerInit = function() {
            range = this.yearRange;
            this.step = {
                years: range
            };
        };
        this._refreshView = function() {
            var years = new Array(range), date;
            for(var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++){
                date = new Date(this.activeDate);
                date.setFullYear(start + i, 0, 1);
                years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
                    uid: scope.uniqueId + "-" + i
                });
            }
            scope.title = [
                years[0].label,
                years[range - 1].label
            ].join(" - ");
            scope.rows = this.split(years, 5);
        };
        this.compare = function(date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        };
        this.handleKeyDown = function(key, evt) {
            var date = this.activeDate.getFullYear();
            if (key === "left") date = date - 1; // up
            else if (key === "up") date = date - 5; // down
            else if (key === "right") date = date + 1; // down
            else if (key === "down") date = date + 5;
            else if (key === "pageup" || key === "pagedown") date += (key === "pageup" ? -1 : 1) * this.step.years;
            else if (key === "home") date = getStartingYear(this.activeDate.getFullYear());
            else if (key === "end") date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
            this.activeDate.setFullYear(date);
        };
    }
]).directive("uibDatepicker", function() {
    return {
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/datepicker/datepicker.html";
        },
        scope: {
            datepickerMode: "=?",
            dateDisabled: "&",
            customClass: "&",
            shortcutPropagation: "&?"
        },
        require: [
            "uibDatepicker",
            "^ngModel"
        ],
        controller: "UibDatepickerController",
        controllerAs: "datepicker",
        link: function(scope, element, attrs, ctrls) {
            var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            datepickerCtrl.init(ngModelCtrl);
        }
    };
}).directive("uibDaypicker", function() {
    return {
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/datepicker/day.html";
        },
        require: [
            "^?uibDatepicker",
            "uibDaypicker",
            "^?datepicker"
        ],
        controller: "UibDaypickerController",
        link: function(scope, element, attrs, ctrls) {
            var datepickerCtrl = ctrls[0] || ctrls[2], daypickerCtrl = ctrls[1];
            daypickerCtrl.init(datepickerCtrl);
        }
    };
}).directive("uibMonthpicker", function() {
    return {
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/datepicker/month.html";
        },
        require: [
            "^?uibDatepicker",
            "uibMonthpicker",
            "^?datepicker"
        ],
        controller: "UibMonthpickerController",
        link: function(scope, element, attrs, ctrls) {
            var datepickerCtrl = ctrls[0] || ctrls[2], monthpickerCtrl = ctrls[1];
            monthpickerCtrl.init(datepickerCtrl);
        }
    };
}).directive("uibYearpicker", function() {
    return {
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/datepicker/year.html";
        },
        require: [
            "^?uibDatepicker",
            "uibYearpicker",
            "^?datepicker"
        ],
        controller: "UibYearpickerController",
        link: function(scope, element, attrs, ctrls) {
            var ctrl = ctrls[0] || ctrls[2];
            angular.extend(ctrl, ctrls[1]);
            ctrl.yearpickerInit();
            ctrl.refreshView();
        }
    };
}).constant("uibDatepickerPopupConfig", {
    datepickerPopup: "yyyy-MM-dd",
    datepickerPopupTemplateUrl: "template/datepicker/popup.html",
    datepickerTemplateUrl: "template/datepicker/datepicker.html",
    html5Types: {
        date: "yyyy-MM-dd",
        "datetime-local": "yyyy-MM-ddTHH:mm:ss.sss",
        "month": "yyyy-MM"
    },
    currentText: "Today",
    clearText: "Clear",
    closeText: "Done",
    closeOnDateSelection: true,
    appendToBody: false,
    showButtonBar: true,
    onOpenFocus: true
}).controller("UibDatepickerPopupController", [
    "$scope",
    "$element",
    "$attrs",
    "$compile",
    "$parse",
    "$document",
    "$rootScope",
    "$uibPosition",
    "dateFilter",
    "uibDateParser",
    "uibDatepickerPopupConfig",
    "$timeout",
    function(scope, element, attrs, $compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
        var self = this;
        var cache = {}, isHtml5DateInput = false;
        var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus, datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, ngModel, $popup;
        scope.watchData = {};
        this.init = function(_ngModel_) {
            ngModel = _ngModel_;
            closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
            appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
            onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
            datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
            datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
            scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
            if (datepickerPopupConfig.html5Types[attrs.type]) {
                dateFormat = datepickerPopupConfig.html5Types[attrs.type];
                isHtml5DateInput = true;
            } else {
                dateFormat = attrs.datepickerPopup || attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
                attrs.$observe("uibDatepickerPopup", function(value, oldValue) {
                    var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
                    // Invalidate the $modelValue to ensure that formatters re-run
                    // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                    if (newDateFormat !== dateFormat) {
                        dateFormat = newDateFormat;
                        ngModel.$modelValue = null;
                        if (!dateFormat) throw new Error("uibDatepickerPopup must have a date format specified.");
                    }
                });
            }
            if (!dateFormat) throw new Error("uibDatepickerPopup must have a date format specified.");
            if (isHtml5DateInput && attrs.datepickerPopup) throw new Error("HTML5 date input types do not support custom formats.");
            // popup element used to display calendar
            popupEl = angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>");
            popupEl.attr({
                "ng-model": "date",
                "ng-change": "dateSelection(date)",
                "template-url": datepickerPopupTemplateUrl
            });
            // datepicker element
            datepickerEl = angular.element(popupEl.children()[0]);
            datepickerEl.attr("template-url", datepickerTemplateUrl);
            if (isHtml5DateInput) {
                if (attrs.type === "month") {
                    datepickerEl.attr("datepicker-mode", '"month"');
                    datepickerEl.attr("min-mode", "month");
                }
            }
            if (attrs.datepickerOptions) {
                var options = scope.$parent.$eval(attrs.datepickerOptions);
                if (options && options.initDate) {
                    scope.initDate = options.initDate;
                    datepickerEl.attr("init-date", "initDate");
                    delete options.initDate;
                }
                angular.forEach(options, function(value, option) {
                    datepickerEl.attr(cameltoDash(option), value);
                });
            }
            angular.forEach([
                "minMode",
                "maxMode",
                "minDate",
                "maxDate",
                "datepickerMode",
                "initDate",
                "shortcutPropagation"
            ], function(key) {
                if (attrs[key]) {
                    var getAttribute = $parse(attrs[key]);
                    scope.$parent.$watch(getAttribute, function(value) {
                        scope.watchData[key] = value;
                        if (key === "minDate" || key === "maxDate") cache[key] = new Date(value);
                    });
                    datepickerEl.attr(cameltoDash(key), "watchData." + key);
                    // Propagate changes from datepicker to outside
                    if (key === "datepickerMode") {
                        var setAttribute = getAttribute.assign;
                        scope.$watch("watchData." + key, function(value, oldvalue) {
                            if (angular.isFunction(setAttribute) && value !== oldvalue) setAttribute(scope.$parent, value);
                        });
                    }
                }
            });
            if (attrs.dateDisabled) datepickerEl.attr("date-disabled", "dateDisabled({ date: date, mode: mode })");
            if (attrs.showWeeks) datepickerEl.attr("show-weeks", attrs.showWeeks);
            if (attrs.customClass) datepickerEl.attr("custom-class", "customClass({ date: date, mode: mode })");
            if (!isHtml5DateInput) {
                // Internal API to maintain the correct ng-invalid-[key] class
                ngModel.$$parserName = "date";
                ngModel.$validators.date = validator;
                ngModel.$parsers.unshift(parseDate);
                ngModel.$formatters.push(function(value) {
                    scope.date = value;
                    return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
                });
            } else ngModel.$formatters.push(function(value) {
                scope.date = value;
                return value;
            });
            // Detect changes in the view from the text box
            ngModel.$viewChangeListeners.push(function() {
                scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
            });
            element.bind("keydown", inputKeydownBind);
            $popup = $compile(popupEl)(scope);
            // Prevent jQuery cache memory leak (template is now redundant after linking)
            popupEl.remove();
            if (appendToBody) $document.find("body").append($popup);
            else element.after($popup);
            scope.$on("$destroy", function() {
                if (scope.isOpen === true) {
                    if (!$rootScope.$$phase) scope.$apply(function() {
                        scope.isOpen = false;
                    });
                }
                $popup.remove();
                element.unbind("keydown", inputKeydownBind);
                $document.unbind("click", documentClickBind);
            });
        };
        scope.getText = function(key) {
            return scope[key + "Text"] || datepickerPopupConfig[key + "Text"];
        };
        scope.isDisabled = function(date) {
            if (date === "today") date = new Date();
            return scope.watchData.minDate && scope.compare(date, cache.minDate) < 0 || scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0;
        };
        scope.compare = function(date1, date2) {
            return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        };
        // Inner change
        scope.dateSelection = function(dt) {
            if (angular.isDefined(dt)) scope.date = dt;
            var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
            element.val(date);
            ngModel.$setViewValue(date);
            if (closeOnDateSelection) {
                scope.isOpen = false;
                element[0].focus();
            }
        };
        scope.keydown = function(evt) {
            if (evt.which === 27) {
                scope.isOpen = false;
                element[0].focus();
            }
        };
        scope.select = function(date) {
            if (date === "today") {
                var today = new Date();
                if (angular.isDate(scope.date)) {
                    date = new Date(scope.date);
                    date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                } else date = new Date(today.setHours(0, 0, 0, 0));
            }
            scope.dateSelection(date);
        };
        scope.close = function() {
            scope.isOpen = false;
            element[0].focus();
        };
        scope.$watch("isOpen", function(value) {
            if (value) {
                scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                scope.position.top = scope.position.top + element.prop("offsetHeight");
                $timeout(function() {
                    if (onOpenFocus) scope.$broadcast("uib:datepicker.focus");
                    $document.bind("click", documentClickBind);
                }, 0, false);
            } else $document.unbind("click", documentClickBind);
        });
        function cameltoDash(string) {
            return string.replace(/([A-Z])/g, function($1) {
                return "-" + $1.toLowerCase();
            });
        }
        function parseDate(viewValue) {
            if (angular.isNumber(viewValue)) // presumably timestamp to date object
            viewValue = new Date(viewValue);
            if (!viewValue) return null;
            else if (angular.isDate(viewValue) && !isNaN(viewValue)) return viewValue;
            else if (angular.isString(viewValue)) {
                var date = dateParser.parse(viewValue, dateFormat, scope.date);
                if (isNaN(date)) return undefined;
                else return date;
            } else return undefined;
        }
        function validator(modelValue, viewValue) {
            var value = modelValue || viewValue;
            if (!attrs.ngRequired && !value) return true;
            if (angular.isNumber(value)) value = new Date(value);
            if (!value) return true;
            else if (angular.isDate(value) && !isNaN(value)) return true;
            else if (angular.isString(value)) {
                var date = dateParser.parse(value, dateFormat);
                return !isNaN(date);
            } else return false;
        }
        function documentClickBind(event) {
            var popup = $popup[0];
            var dpContainsTarget = element[0].contains(event.target);
            // The popup node may not be an element node
            // In some browsers (IE) only element nodes have the 'contains' function
            var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
            if (scope.isOpen && !(dpContainsTarget || popupContainsTarget)) scope.$apply(function() {
                scope.isOpen = false;
            });
        }
        function inputKeydownBind(evt) {
            if (evt.which === 27 && scope.isOpen) {
                evt.preventDefault();
                evt.stopPropagation();
                scope.$apply(function() {
                    scope.isOpen = false;
                });
                element[0].focus();
            } else if (evt.which === 40 && !scope.isOpen) {
                evt.preventDefault();
                evt.stopPropagation();
                scope.$apply(function() {
                    scope.isOpen = true;
                });
            }
        }
    }
]).directive("uibDatepickerPopup", function() {
    return {
        require: [
            "ngModel",
            "uibDatepickerPopup"
        ],
        controller: "UibDatepickerPopupController",
        scope: {
            isOpen: "=?",
            currentText: "@",
            clearText: "@",
            closeText: "@",
            dateDisabled: "&",
            customClass: "&"
        },
        link: function(scope, element, attrs, ctrls) {
            var ngModel = ctrls[0], ctrl = ctrls[1];
            ctrl.init(ngModel);
        }
    };
}).directive("uibDatepickerPopupWrap", function() {
    return {
        replace: true,
        transclude: true,
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/datepicker/popup.html";
        }
    };
});
/* Deprecated datepicker below */ angular.module("ui.bootstrap.datepicker").value("$datepickerSuppressWarning", false).controller("DatepickerController", [
    "$scope",
    "$attrs",
    "$parse",
    "$interpolate",
    "$log",
    "dateFilter",
    "uibDatepickerConfig",
    "$datepickerSuppressError",
    "$datepickerSuppressWarning",
    function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError, $datepickerSuppressWarning) {
        if (!$datepickerSuppressWarning) $log.warn("DatepickerController is now deprecated. Use UibDatepickerController instead.");
        var self = this, ngModelCtrl = {
            $setViewValue: angular.noop
        }; // nullModelCtrl;
        this.modes = [
            "day",
            "month",
            "year"
        ];
        angular.forEach([
            "formatDay",
            "formatMonth",
            "formatYear",
            "formatDayHeader",
            "formatDayTitle",
            "formatMonthTitle",
            "showWeeks",
            "startingDay",
            "yearRange",
            "shortcutPropagation"
        ], function(key, index) {
            self[key] = angular.isDefined($attrs[key]) ? index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
        });
        angular.forEach([
            "minDate",
            "maxDate"
        ], function(key) {
            if ($attrs[key]) $scope.$parent.$watch($parse($attrs[key]), function(value) {
                self[key] = value ? new Date(value) : null;
                self.refreshView();
            });
            else self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
        });
        angular.forEach([
            "minMode",
            "maxMode"
        ], function(key) {
            if ($attrs[key]) $scope.$parent.$watch($parse($attrs[key]), function(value) {
                self[key] = angular.isDefined(value) ? value : $attrs[key];
                $scope[key] = self[key];
                if (key == "minMode" && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) || key == "maxMode" && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) $scope.datepickerMode = self[key];
            });
            else {
                self[key] = datepickerConfig[key] || null;
                $scope[key] = self[key];
            }
        });
        $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
        $scope.uniqueId = "datepicker-" + $scope.$id + "-" + Math.floor(Math.random() * 10000);
        if (angular.isDefined($attrs.initDate)) {
            this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
            $scope.$parent.$watch($attrs.initDate, function(initDate) {
                if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                    self.activeDate = initDate;
                    self.refreshView();
                }
            });
        } else this.activeDate = new Date();
        $scope.isActive = function(dateObject) {
            if (self.compare(dateObject.date, self.activeDate) === 0) {
                $scope.activeDateId = dateObject.uid;
                return true;
            }
            return false;
        };
        this.init = function(ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = function() {
                self.render();
            };
        };
        this.render = function() {
            if (ngModelCtrl.$viewValue) {
                var date = new Date(ngModelCtrl.$viewValue), isValid = !isNaN(date);
                if (isValid) this.activeDate = date;
                else if (!$datepickerSuppressError) $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            }
            this.refreshView();
        };
        this.refreshView = function() {
            if (this.element) {
                this._refreshView();
                var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                ngModelCtrl.$setValidity("dateDisabled", !date || this.element && !this.isDisabled(date));
            }
        };
        this.createDateObject = function(date, format) {
            var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
            return {
                date: date,
                label: dateFilter(date, format),
                selected: model && this.compare(date, model) === 0,
                disabled: this.isDisabled(date),
                current: this.compare(date, new Date()) === 0,
                customClass: this.customClass(date)
            };
        };
        this.isDisabled = function(date) {
            return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({
                date: date,
                mode: $scope.datepickerMode
            });
        };
        this.customClass = function(date) {
            return $scope.customClass({
                date: date,
                mode: $scope.datepickerMode
            });
        };
        // Split array into smaller arrays
        this.split = function(arr, size) {
            var arrays = [];
            while(arr.length > 0)arrays.push(arr.splice(0, size));
            return arrays;
        };
        this.fixTimeZone = function(date) {
            var hours = date.getHours();
            date.setHours(hours === 23 ? hours + 2 : 0);
        };
        $scope.select = function(date) {
            if ($scope.datepickerMode === self.minMode) {
                var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
                dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                ngModelCtrl.$setViewValue(dt);
                ngModelCtrl.$render();
            } else {
                self.activeDate = date;
                $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
            }
        };
        $scope.move = function(direction) {
            var year = self.activeDate.getFullYear() + direction * (self.step.years || 0), month = self.activeDate.getMonth() + direction * (self.step.months || 0);
            self.activeDate.setFullYear(year, month, 1);
            self.refreshView();
        };
        $scope.toggleMode = function(direction) {
            direction = direction || 1;
            if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) return;
            $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
        };
        // Key event mapper
        $scope.keys = {
            13: "enter",
            32: "space",
            33: "pageup",
            34: "pagedown",
            35: "end",
            36: "home",
            37: "left",
            38: "up",
            39: "right",
            40: "down"
        };
        var focusElement = function() {
            self.element[0].focus();
        };
        $scope.$on("uib:datepicker.focus", focusElement);
        $scope.keydown = function(evt) {
            var key = $scope.keys[evt.which];
            if (!key || evt.shiftKey || evt.altKey) return;
            evt.preventDefault();
            if (!self.shortcutPropagation) evt.stopPropagation();
            if (key === "enter" || key === "space") {
                if (self.isDisabled(self.activeDate)) return; // do nothing
                $scope.select(self.activeDate);
            } else if (evt.ctrlKey && (key === "up" || key === "down")) $scope.toggleMode(key === "up" ? 1 : -1);
            else {
                self.handleKeyDown(key, evt);
                self.refreshView();
            }
        };
    }
]).directive("datepicker", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            replace: true,
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/datepicker/datepicker.html";
            },
            scope: {
                datepickerMode: "=?",
                dateDisabled: "&",
                customClass: "&",
                shortcutPropagation: "&?"
            },
            require: [
                "datepicker",
                "^ngModel"
            ],
            controller: "DatepickerController",
            controllerAs: "datepicker",
            link: function(scope, element, attrs, ctrls) {
                if (!$datepickerSuppressWarning) $log.warn("datepicker is now deprecated. Use uib-datepicker instead.");
                var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                datepickerCtrl.init(ngModelCtrl);
            }
        };
    }
]).directive("daypicker", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            replace: true,
            templateUrl: "template/datepicker/day.html",
            require: [
                "^datepicker",
                "daypicker"
            ],
            controller: "UibDaypickerController",
            link: function(scope, element, attrs, ctrls) {
                if (!$datepickerSuppressWarning) $log.warn("daypicker is now deprecated. Use uib-daypicker instead.");
                var datepickerCtrl = ctrls[0], daypickerCtrl = ctrls[1];
                daypickerCtrl.init(datepickerCtrl);
            }
        };
    }
]).directive("monthpicker", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            replace: true,
            templateUrl: "template/datepicker/month.html",
            require: [
                "^datepicker",
                "monthpicker"
            ],
            controller: "UibMonthpickerController",
            link: function(scope, element, attrs, ctrls) {
                if (!$datepickerSuppressWarning) $log.warn("monthpicker is now deprecated. Use uib-monthpicker instead.");
                var datepickerCtrl = ctrls[0], monthpickerCtrl = ctrls[1];
                monthpickerCtrl.init(datepickerCtrl);
            }
        };
    }
]).directive("yearpicker", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            replace: true,
            templateUrl: "template/datepicker/year.html",
            require: [
                "^datepicker",
                "yearpicker"
            ],
            controller: "UibYearpickerController",
            link: function(scope, element, attrs, ctrls) {
                if (!$datepickerSuppressWarning) $log.warn("yearpicker is now deprecated. Use uib-yearpicker instead.");
                var ctrl = ctrls[0];
                angular.extend(ctrl, ctrls[1]);
                ctrl.yearpickerInit();
                ctrl.refreshView();
            }
        };
    }
]).directive("datepickerPopup", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            require: [
                "ngModel",
                "datepickerPopup"
            ],
            controller: "UibDatepickerPopupController",
            scope: {
                isOpen: "=?",
                currentText: "@",
                clearText: "@",
                closeText: "@",
                dateDisabled: "&",
                customClass: "&"
            },
            link: function(scope, element, attrs, ctrls) {
                if (!$datepickerSuppressWarning) $log.warn("datepicker-popup is now deprecated. Use uib-datepicker-popup instead.");
                var ngModel = ctrls[0], ctrl = ctrls[1];
                ctrl.init(ngModel);
            }
        };
    }
]).directive("datepickerPopupWrap", [
    "$log",
    "$datepickerSuppressWarning",
    function($log, $datepickerSuppressWarning) {
        return {
            replace: true,
            transclude: true,
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/datepicker/popup.html";
            },
            link: function() {
                if (!$datepickerSuppressWarning) $log.warn("datepicker-popup-wrap is now deprecated. Use uib-datepicker-popup-wrap instead.");
            }
        };
    }
]);
angular.module("ui.bootstrap.dropdown", [
    "ui.bootstrap.position"
]).constant("uibDropdownConfig", {
    openClass: "open"
}).service("uibDropdownService", [
    "$document",
    "$rootScope",
    function($document, $rootScope) {
        var openScope = null;
        this.open = function(dropdownScope) {
            if (!openScope) {
                $document.bind("click", closeDropdown);
                $document.bind("keydown", keybindFilter);
            }
            if (openScope && openScope !== dropdownScope) openScope.isOpen = false;
            openScope = dropdownScope;
        };
        this.close = function(dropdownScope) {
            if (openScope === dropdownScope) {
                openScope = null;
                $document.unbind("click", closeDropdown);
                $document.unbind("keydown", keybindFilter);
            }
        };
        var closeDropdown = function(evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope) return;
            if (evt && openScope.getAutoClose() === "disabled") return;
            var toggleElement = openScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) return;
            var dropdownElement = openScope.getDropdownElement();
            if (evt && openScope.getAutoClose() === "outsideClick" && dropdownElement && dropdownElement[0].contains(evt.target)) return;
            openScope.isOpen = false;
            if (!$rootScope.$$phase) openScope.$apply();
        };
        var keybindFilter = function(evt) {
            if (evt.which === 27) {
                openScope.focusToggleElement();
                closeDropdown();
            } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
                evt.preventDefault();
                evt.stopPropagation();
                openScope.focusDropdownEntry(evt.which);
            }
        };
    }
]).controller("UibDropdownController", [
    "$scope",
    "$element",
    "$attrs",
    "$parse",
    "uibDropdownConfig",
    "uibDropdownService",
    "$animate",
    "$uibPosition",
    "$document",
    "$compile",
    "$templateRequest",
    function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
        var self = this, scope = $scope.$new(), templateScope, openClass = dropdownConfig.openClass, getIsOpen, setIsOpen = angular.noop, toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop, appendToBody = false, keynavEnabled = false, selectedOption = null;
        $element.addClass("dropdown");
        this.init = function() {
            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;
                $scope.$watch(getIsOpen, function(value) {
                    scope.isOpen = !!value;
                });
            }
            appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
            keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
            if (appendToBody && self.dropdownMenu) {
                $document.find("body").append(self.dropdownMenu);
                $element.on("$destroy", function handleDestroyEvent() {
                    self.dropdownMenu.remove();
                });
            }
        };
        this.toggle = function(open) {
            return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
        };
        // Allow other directives to watch status
        this.isOpen = function() {
            return scope.isOpen;
        };
        scope.getToggleElement = function() {
            return self.toggleElement;
        };
        scope.getAutoClose = function() {
            return $attrs.autoClose || "always"; //or 'outsideClick' or 'disabled'
        };
        scope.getElement = function() {
            return $element;
        };
        scope.isKeynavEnabled = function() {
            return keynavEnabled;
        };
        scope.focusDropdownEntry = function(keyCode) {
            var elems = self.dropdownMenu ? angular.element(self.dropdownMenu).find("a") : angular.element($element).find("ul").eq(0).find("a");
            switch(keyCode){
                case 40:
                    if (!angular.isNumber(self.selectedOption)) self.selectedOption = 0;
                    else self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
                    break;
                case 38:
                    if (!angular.isNumber(self.selectedOption)) self.selectedOption = elems.length - 1;
                    else self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
                    break;
            }
            elems[self.selectedOption].focus();
        };
        scope.getDropdownElement = function() {
            return self.dropdownMenu;
        };
        scope.focusToggleElement = function() {
            if (self.toggleElement) self.toggleElement[0].focus();
        };
        scope.$watch("isOpen", function(isOpen, wasOpen) {
            if (appendToBody && self.dropdownMenu) {
                var pos = $position.positionElements($element, self.dropdownMenu, "bottom-left", true);
                var css = {
                    top: pos.top + "px",
                    display: isOpen ? "block" : "none"
                };
                var rightalign = self.dropdownMenu.hasClass("dropdown-menu-right");
                if (!rightalign) {
                    css.left = pos.left + "px";
                    css.right = "auto";
                } else {
                    css.left = "auto";
                    css.right = window.innerWidth - (pos.left + $element.prop("offsetWidth")) + "px";
                }
                self.dropdownMenu.css(css);
            }
            $animate[isOpen ? "addClass" : "removeClass"]($element, openClass).then(function() {
                if (angular.isDefined(isOpen) && isOpen !== wasOpen) toggleInvoker($scope, {
                    open: !!isOpen
                });
            });
            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
                    templateScope = scope.$new();
                    $compile(tplContent.trim())(templateScope, function(dropdownElement) {
                        var newEl = dropdownElement;
                        self.dropdownMenu.replaceWith(newEl);
                        self.dropdownMenu = newEl;
                    });
                });
                scope.focusToggleElement();
                uibDropdownService.open(scope);
            } else {
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) templateScope.$destroy();
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }
                uibDropdownService.close(scope);
                self.selectedOption = null;
            }
            if (angular.isFunction(setIsOpen)) setIsOpen($scope, isOpen);
        });
        $scope.$on("$locationChangeSuccess", function() {
            if (scope.getAutoClose() !== "disabled") scope.isOpen = false;
        });
        var offDestroy = $scope.$on("$destroy", function() {
            scope.$destroy();
        });
        scope.$on("$destroy", offDestroy);
    }
]).directive("uibDropdown", function() {
    return {
        controller: "UibDropdownController",
        link: function(scope, element, attrs, dropdownCtrl) {
            dropdownCtrl.init();
        }
    };
}).directive("uibDropdownMenu", function() {
    return {
        restrict: "AC",
        require: "?^uibDropdown",
        link: function(scope, element, attrs, dropdownCtrl) {
            if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) return;
            element.addClass("dropdown-menu");
            var tplUrl = attrs.templateUrl;
            if (tplUrl) dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
            if (!dropdownCtrl.dropdownMenu) dropdownCtrl.dropdownMenu = element;
        }
    };
}).directive("uibKeyboardNav", function() {
    return {
        restrict: "A",
        require: "?^uibDropdown",
        link: function(scope, element, attrs, dropdownCtrl) {
            element.bind("keydown", function(e) {
                if ([
                    38,
                    40
                ].indexOf(e.which) !== -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    var elems = dropdownCtrl.dropdownMenu.find("a");
                    switch(e.which){
                        case 40:
                            if (!angular.isNumber(dropdownCtrl.selectedOption)) dropdownCtrl.selectedOption = 0;
                            else dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length - 1 ? dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
                            break;
                        case 38:
                            if (!angular.isNumber(dropdownCtrl.selectedOption)) dropdownCtrl.selectedOption = elems.length - 1;
                            else dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ? 0 : dropdownCtrl.selectedOption - 1;
                            break;
                    }
                    elems[dropdownCtrl.selectedOption].focus();
                }
            });
        }
    };
}).directive("uibDropdownToggle", function() {
    return {
        require: "?^uibDropdown",
        link: function(scope, element, attrs, dropdownCtrl) {
            if (!dropdownCtrl) return;
            element.addClass("dropdown-toggle");
            dropdownCtrl.toggleElement = element;
            var toggleDropdown = function(event) {
                event.preventDefault();
                if (!element.hasClass("disabled") && !attrs.disabled) scope.$apply(function() {
                    dropdownCtrl.toggle();
                });
            };
            element.bind("click", toggleDropdown);
            // WAI-ARIA
            element.attr({
                "aria-haspopup": true,
                "aria-expanded": false
            });
            scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
                element.attr("aria-expanded", !!isOpen);
            });
            scope.$on("$destroy", function() {
                element.unbind("click", toggleDropdown);
            });
        }
    };
});
/* Deprecated dropdown below */ angular.module("ui.bootstrap.dropdown").value("$dropdownSuppressWarning", false).service("dropdownService", [
    "$log",
    "$dropdownSuppressWarning",
    "uibDropdownService",
    function($log, $dropdownSuppressWarning, uibDropdownService) {
        if (!$dropdownSuppressWarning) $log.warn("dropdownService is now deprecated. Use uibDropdownService instead.");
        angular.extend(this, uibDropdownService);
    }
]).controller("DropdownController", [
    "$scope",
    "$element",
    "$attrs",
    "$parse",
    "uibDropdownConfig",
    "uibDropdownService",
    "$animate",
    "$uibPosition",
    "$document",
    "$compile",
    "$templateRequest",
    "$log",
    "$dropdownSuppressWarning",
    function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest, $log, $dropdownSuppressWarning) {
        if (!$dropdownSuppressWarning) $log.warn("DropdownController is now deprecated. Use UibDropdownController instead.");
        var self = this, scope = $scope.$new(), templateScope, openClass = dropdownConfig.openClass, getIsOpen, setIsOpen = angular.noop, toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop, appendToBody = false, keynavEnabled = false, selectedOption = null;
        $element.addClass("dropdown");
        this.init = function() {
            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;
                $scope.$watch(getIsOpen, function(value) {
                    scope.isOpen = !!value;
                });
            }
            appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
            keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
            if (appendToBody && self.dropdownMenu) {
                $document.find("body").append(self.dropdownMenu);
                $element.on("$destroy", function handleDestroyEvent() {
                    self.dropdownMenu.remove();
                });
            }
        };
        this.toggle = function(open) {
            return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
        };
        // Allow other directives to watch status
        this.isOpen = function() {
            return scope.isOpen;
        };
        scope.getToggleElement = function() {
            return self.toggleElement;
        };
        scope.getAutoClose = function() {
            return $attrs.autoClose || "always"; //or 'outsideClick' or 'disabled'
        };
        scope.getElement = function() {
            return $element;
        };
        scope.isKeynavEnabled = function() {
            return keynavEnabled;
        };
        scope.focusDropdownEntry = function(keyCode) {
            var elems = self.dropdownMenu ? angular.element(self.dropdownMenu).find("a") : angular.element($element).find("ul").eq(0).find("a");
            switch(keyCode){
                case 40:
                    if (!angular.isNumber(self.selectedOption)) self.selectedOption = 0;
                    else self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
                    break;
                case 38:
                    if (!angular.isNumber(self.selectedOption)) self.selectedOption = elems.length - 1;
                    else self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
                    break;
            }
            elems[self.selectedOption].focus();
        };
        scope.getDropdownElement = function() {
            return self.dropdownMenu;
        };
        scope.focusToggleElement = function() {
            if (self.toggleElement) self.toggleElement[0].focus();
        };
        scope.$watch("isOpen", function(isOpen, wasOpen) {
            if (appendToBody && self.dropdownMenu) {
                var pos = $position.positionElements($element, self.dropdownMenu, "bottom-left", true);
                var css = {
                    top: pos.top + "px",
                    display: isOpen ? "block" : "none"
                };
                var rightalign = self.dropdownMenu.hasClass("dropdown-menu-right");
                if (!rightalign) {
                    css.left = pos.left + "px";
                    css.right = "auto";
                } else {
                    css.left = "auto";
                    css.right = window.innerWidth - (pos.left + $element.prop("offsetWidth")) + "px";
                }
                self.dropdownMenu.css(css);
            }
            $animate[isOpen ? "addClass" : "removeClass"]($element, openClass).then(function() {
                if (angular.isDefined(isOpen) && isOpen !== wasOpen) toggleInvoker($scope, {
                    open: !!isOpen
                });
            });
            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
                    templateScope = scope.$new();
                    $compile(tplContent.trim())(templateScope, function(dropdownElement) {
                        var newEl = dropdownElement;
                        self.dropdownMenu.replaceWith(newEl);
                        self.dropdownMenu = newEl;
                    });
                });
                scope.focusToggleElement();
                uibDropdownService.open(scope);
            } else {
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) templateScope.$destroy();
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }
                uibDropdownService.close(scope);
                self.selectedOption = null;
            }
            if (angular.isFunction(setIsOpen)) setIsOpen($scope, isOpen);
        });
        $scope.$on("$locationChangeSuccess", function() {
            if (scope.getAutoClose() !== "disabled") scope.isOpen = false;
        });
        var offDestroy = $scope.$on("$destroy", function() {
            scope.$destroy();
        });
        scope.$on("$destroy", offDestroy);
    }
]).directive("dropdown", [
    "$log",
    "$dropdownSuppressWarning",
    function($log, $dropdownSuppressWarning) {
        return {
            controller: "DropdownController",
            link: function(scope, element, attrs, dropdownCtrl) {
                if (!$dropdownSuppressWarning) $log.warn("dropdown is now deprecated. Use uib-dropdown instead.");
                dropdownCtrl.init();
            }
        };
    }
]).directive("dropdownMenu", [
    "$log",
    "$dropdownSuppressWarning",
    function($log, $dropdownSuppressWarning) {
        return {
            restrict: "AC",
            require: "?^dropdown",
            link: function(scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) return;
                if (!$dropdownSuppressWarning) $log.warn("dropdown-menu is now deprecated. Use uib-dropdown-menu instead.");
                element.addClass("dropdown-menu");
                var tplUrl = attrs.templateUrl;
                if (tplUrl) dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                if (!dropdownCtrl.dropdownMenu) dropdownCtrl.dropdownMenu = element;
            }
        };
    }
]).directive("keyboardNav", [
    "$log",
    "$dropdownSuppressWarning",
    function($log, $dropdownSuppressWarning) {
        return {
            restrict: "A",
            require: "?^dropdown",
            link: function(scope, element, attrs, dropdownCtrl) {
                if (!$dropdownSuppressWarning) $log.warn("keyboard-nav is now deprecated. Use uib-keyboard-nav instead.");
                element.bind("keydown", function(e) {
                    if ([
                        38,
                        40
                    ].indexOf(e.which) !== -1) {
                        e.preventDefault();
                        e.stopPropagation();
                        var elems = dropdownCtrl.dropdownMenu.find("a");
                        switch(e.which){
                            case 40:
                                if (!angular.isNumber(dropdownCtrl.selectedOption)) dropdownCtrl.selectedOption = 0;
                                else dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length - 1 ? dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
                                break;
                            case 38:
                                if (!angular.isNumber(dropdownCtrl.selectedOption)) dropdownCtrl.selectedOption = elems.length - 1;
                                else dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ? 0 : dropdownCtrl.selectedOption - 1;
                                break;
                        }
                        elems[dropdownCtrl.selectedOption].focus();
                    }
                });
            }
        };
    }
]).directive("dropdownToggle", [
    "$log",
    "$dropdownSuppressWarning",
    function($log, $dropdownSuppressWarning) {
        return {
            require: "?^dropdown",
            link: function(scope, element, attrs, dropdownCtrl) {
                if (!$dropdownSuppressWarning) $log.warn("dropdown-toggle is now deprecated. Use uib-dropdown-toggle instead.");
                if (!dropdownCtrl) return;
                element.addClass("dropdown-toggle");
                dropdownCtrl.toggleElement = element;
                var toggleDropdown = function(event) {
                    event.preventDefault();
                    if (!element.hasClass("disabled") && !attrs.disabled) scope.$apply(function() {
                        dropdownCtrl.toggle();
                    });
                };
                element.bind("click", toggleDropdown);
                // WAI-ARIA
                element.attr({
                    "aria-haspopup": true,
                    "aria-expanded": false
                });
                scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
                    element.attr("aria-expanded", !!isOpen);
                });
                scope.$on("$destroy", function() {
                    element.unbind("click", toggleDropdown);
                });
            }
        };
    }
]);
angular.module("ui.bootstrap.stackedMap", [])/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */ .factory("$$stackedMap", function() {
    return {
        createNew: function() {
            var stack = [];
            return {
                add: function(key, value) {
                    stack.push({
                        key: key,
                        value: value
                    });
                },
                get: function(key) {
                    for(var i = 0; i < stack.length; i++){
                        if (key == stack[i].key) return stack[i];
                    }
                },
                keys: function() {
                    var keys = [];
                    for(var i = 0; i < stack.length; i++)keys.push(stack[i].key);
                    return keys;
                },
                top: function() {
                    return stack[stack.length - 1];
                },
                remove: function(key) {
                    var idx = -1;
                    for(var i = 0; i < stack.length; i++)if (key == stack[i].key) {
                        idx = i;
                        break;
                    }
                    return stack.splice(idx, 1)[0];
                },
                removeTop: function() {
                    return stack.splice(stack.length - 1, 1)[0];
                },
                length: function() {
                    return stack.length;
                }
            };
        }
    };
});
angular.module("ui.bootstrap.modal", [
    "ui.bootstrap.stackedMap"
])/**
 * A helper, internal data structure that stores all references attached to key
 */ .factory("$$multiMap", function() {
    return {
        createNew: function() {
            var map = {};
            return {
                entries: function() {
                    return Object.keys(map).map(function(key) {
                        return {
                            key: key,
                            value: map[key]
                        };
                    });
                },
                get: function(key) {
                    return map[key];
                },
                hasKey: function(key) {
                    return !!map[key];
                },
                keys: function() {
                    return Object.keys(map);
                },
                put: function(key, value) {
                    if (!map[key]) map[key] = [];
                    map[key].push(value);
                },
                remove: function(key, value) {
                    var values = map[key];
                    if (!values) return;
                    var idx = values.indexOf(value);
                    if (idx !== -1) values.splice(idx, 1);
                    if (!values.length) delete map[key];
                }
            };
        }
    };
})/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */ .directive("uibModalBackdrop", [
    "$animate",
    "$injector",
    "$uibModalStack",
    function($animate, $injector, $modalStack) {
        var $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        return {
            replace: true,
            templateUrl: "template/modal/backdrop.html",
            compile: function(tElement, tAttrs) {
                tElement.addClass(tAttrs.backdropClass);
                return linkFn;
            }
        };
        function linkFn(scope, element, attrs) {
            // Temporary fix for prefixing
            element.addClass("modal-backdrop");
            if (attrs.modalInClass) {
                if ($animateCss) $animateCss(element, {
                    addClass: attrs.modalInClass
                }).start();
                else $animate.addClass(element, attrs.modalInClass);
                scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
                    var done = setIsAsync();
                    if ($animateCss) $animateCss(element, {
                        removeClass: attrs.modalInClass
                    }).start().then(done);
                    else $animate.removeClass(element, attrs.modalInClass).then(done);
                });
            }
        }
    }
]).directive("uibModalWindow", [
    "$uibModalStack",
    "$q",
    "$animate",
    "$injector",
    function($modalStack, $q, $animate, $injector) {
        var $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        return {
            scope: {
                index: "@"
            },
            replace: true,
            transclude: true,
            templateUrl: function(tElement, tAttrs) {
                return tAttrs.templateUrl || "template/modal/window.html";
            },
            link: function(scope, element, attrs) {
                element.addClass(attrs.windowClass || "");
                element.addClass(attrs.windowTopClass || "");
                scope.size = attrs.size;
                scope.close = function(evt) {
                    var modal = $modalStack.getTop();
                    if (modal && modal.value.backdrop && modal.value.backdrop !== "static" && evt.target === evt.currentTarget) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        $modalStack.dismiss(modal.key, "backdrop click");
                    }
                };
                // moved from template to fix issue #2280
                element.on("click", scope.close);
                // This property is only added to the scope for the purpose of detecting when this directive is rendered.
                // We can detect that by using this property in the template associated with this directive and then use
                // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
                scope.$isRendered = true;
                // Deferred object that will be resolved when this modal is render.
                var modalRenderDeferObj = $q.defer();
                // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
                // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
                attrs.$observe("modalRender", function(value) {
                    if (value == "true") modalRenderDeferObj.resolve();
                });
                modalRenderDeferObj.promise.then(function() {
                    var animationPromise = null;
                    if (attrs.modalInClass) {
                        if ($animateCss) animationPromise = $animateCss(element, {
                            addClass: attrs.modalInClass
                        }).start();
                        else animationPromise = $animate.addClass(element, attrs.modalInClass);
                        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
                            var done = setIsAsync();
                            if ($animateCss) $animateCss(element, {
                                removeClass: attrs.modalInClass
                            }).start().then(done);
                            else $animate.removeClass(element, attrs.modalInClass).then(done);
                        });
                    }
                    $q.when(animationPromise).then(function() {
                        var inputWithAutofocus = element[0].querySelector("[autofocus]");
                        /**
             * Auto-focusing of a freshly-opened modal element causes any child elements
             * with the autofocus attribute to lose focus. This is an issue on touch
             * based devices which will show and then hide the onscreen keyboard.
             * Attempts to refocus the autofocus element via JavaScript will not reopen
             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
             * the modal element if the modal does not contain an autofocus element.
             */ if (inputWithAutofocus) inputWithAutofocus.focus();
                        else element[0].focus();
                    });
                    // Notify {@link $modalStack} that modal is rendered.
                    var modal = $modalStack.getTop();
                    if (modal) $modalStack.modalRendered(modal.key);
                });
            }
        };
    }
]).directive("uibModalAnimationClass", function() {
    return {
        compile: function(tElement, tAttrs) {
            if (tAttrs.modalAnimation) tElement.addClass(tAttrs.uibModalAnimationClass);
        }
    };
}).directive("uibModalTransclude", function() {
    return {
        link: function($scope, $element, $attrs, controller, $transclude) {
            $transclude($scope.$parent, function(clone) {
                $element.empty();
                $element.append(clone);
            });
        }
    };
}).factory("$uibModalStack", [
    "$animate",
    "$timeout",
    "$document",
    "$compile",
    "$rootScope",
    "$q",
    "$injector",
    "$$multiMap",
    "$$stackedMap",
    function($animate, $timeout, $document, $compile, $rootScope, $q, $injector, $$multiMap, $$stackedMap) {
        var $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        var OPENED_MODAL_CLASS = "modal-open";
        var backdropDomEl, backdropScope;
        var openedWindows = $$stackedMap.createNew();
        var openedClasses = $$multiMap.createNew();
        var $modalStack = {
            NOW_CLOSING_EVENT: "modal.stack.now-closing"
        };
        //Modal focus behavior
        var focusableElementList;
        var focusIndex = 0;
        var tababbleSelector = "a[href], area[href], input:not([disabled]), button:not([disabled]),select:not([disabled]), textarea:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable=true]";
        function backdropIndex() {
            var topBackdropIndex = -1;
            var opened = openedWindows.keys();
            for(var i = 0; i < opened.length; i++)if (openedWindows.get(opened[i]).value.backdrop) topBackdropIndex = i;
            return topBackdropIndex;
        }
        $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
            if (backdropScope) backdropScope.index = newBackdropIndex;
        });
        function removeModalWindow(modalInstance, elementToReceiveFocus) {
            var body = $document.find("body").eq(0);
            var modalWindow = openedWindows.get(modalInstance).value;
            //clean up the stack
            openedWindows.remove(modalInstance);
            removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
                var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
                openedClasses.remove(modalBodyClass, modalInstance);
                body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
                toggleTopWindowClass(true);
            });
            checkRemoveBackdrop();
            //move focus to specified element if available, or else to body
            if (elementToReceiveFocus && elementToReceiveFocus.focus) elementToReceiveFocus.focus();
            else body.focus();
        }
        // Add or remove "windowTopClass" from the top window in the stack
        function toggleTopWindowClass(toggleSwitch) {
            var modalWindow;
            if (openedWindows.length() > 0) {
                modalWindow = openedWindows.top().value;
                modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || "", toggleSwitch);
            }
        }
        function checkRemoveBackdrop() {
            //remove backdrop if no longer needed
            if (backdropDomEl && backdropIndex() == -1) {
                var backdropScopeRef = backdropScope;
                removeAfterAnimate(backdropDomEl, backdropScope, function() {
                    backdropScopeRef = null;
                });
                backdropDomEl = undefined;
                backdropScope = undefined;
            }
        }
        function removeAfterAnimate(domEl, scope, done) {
            var asyncDeferred;
            var asyncPromise = null;
            var setIsAsync = function() {
                if (!asyncDeferred) {
                    asyncDeferred = $q.defer();
                    asyncPromise = asyncDeferred.promise;
                }
                return function asyncDone() {
                    asyncDeferred.resolve();
                };
            };
            scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
            // Note that it's intentional that asyncPromise might be null.
            // That's when setIsAsync has not been called during the
            // NOW_CLOSING_EVENT broadcast.
            return $q.when(asyncPromise).then(afterAnimating);
            function afterAnimating() {
                if (afterAnimating.done) return;
                afterAnimating.done = true;
                if ($animateCss) $animateCss(domEl, {
                    event: "leave"
                }).start().then(function() {
                    domEl.remove();
                });
                else $animate.leave(domEl);
                scope.$destroy();
                if (done) done();
            }
        }
        $document.bind("keydown", function(evt) {
            if (evt.isDefaultPrevented()) return evt;
            var modal = openedWindows.top();
            if (modal && modal.value.keyboard) switch(evt.which){
                case 27:
                    evt.preventDefault();
                    $rootScope.$apply(function() {
                        $modalStack.dismiss(modal.key, "escape key press");
                    });
                    break;
                case 9:
                    $modalStack.loadFocusElementList(modal);
                    var focusChanged = false;
                    if (evt.shiftKey) {
                        if ($modalStack.isFocusInFirstItem(evt)) focusChanged = $modalStack.focusLastFocusableElement();
                    } else if ($modalStack.isFocusInLastItem(evt)) focusChanged = $modalStack.focusFirstFocusableElement();
                    if (focusChanged) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    break;
            }
        });
        $modalStack.open = function(modalInstance, modal) {
            var modalOpener = $document[0].activeElement, modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
            toggleTopWindowClass(false);
            openedWindows.add(modalInstance, {
                deferred: modal.deferred,
                renderDeferred: modal.renderDeferred,
                modalScope: modal.scope,
                backdrop: modal.backdrop,
                keyboard: modal.keyboard,
                openedClass: modal.openedClass,
                windowTopClass: modal.windowTopClass
            });
            openedClasses.put(modalBodyClass, modalInstance);
            var body = $document.find("body").eq(0), currBackdropIndex = backdropIndex();
            if (currBackdropIndex >= 0 && !backdropDomEl) {
                backdropScope = $rootScope.$new(true);
                backdropScope.index = currBackdropIndex;
                var angularBackgroundDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
                angularBackgroundDomEl.attr("backdrop-class", modal.backdropClass);
                if (modal.animation) angularBackgroundDomEl.attr("modal-animation", "true");
                backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
                body.append(backdropDomEl);
            }
            var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
            angularDomEl.attr({
                "template-url": modal.windowTemplateUrl,
                "window-class": modal.windowClass,
                "window-top-class": modal.windowTopClass,
                "size": modal.size,
                "index": openedWindows.length() - 1,
                "animate": "animate"
            }).html(modal.content);
            if (modal.animation) angularDomEl.attr("modal-animation", "true");
            var modalDomEl = $compile(angularDomEl)(modal.scope);
            openedWindows.top().value.modalDomEl = modalDomEl;
            openedWindows.top().value.modalOpener = modalOpener;
            body.append(modalDomEl);
            body.addClass(modalBodyClass);
            $modalStack.clearFocusListCache();
        };
        function broadcastClosing(modalWindow, resultOrReason, closing) {
            return !modalWindow.value.modalScope.$broadcast("modal.closing", resultOrReason, closing).defaultPrevented;
        }
        $modalStack.close = function(modalInstance, result) {
            var modalWindow = openedWindows.get(modalInstance);
            if (modalWindow && broadcastClosing(modalWindow, result, true)) {
                modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                modalWindow.value.deferred.resolve(result);
                removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                return true;
            }
            return !modalWindow;
        };
        $modalStack.dismiss = function(modalInstance, reason) {
            var modalWindow = openedWindows.get(modalInstance);
            if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
                modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                modalWindow.value.deferred.reject(reason);
                removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                return true;
            }
            return !modalWindow;
        };
        $modalStack.dismissAll = function(reason) {
            var topModal = this.getTop();
            while(topModal && this.dismiss(topModal.key, reason))topModal = this.getTop();
        };
        $modalStack.getTop = function() {
            return openedWindows.top();
        };
        $modalStack.modalRendered = function(modalInstance) {
            var modalWindow = openedWindows.get(modalInstance);
            if (modalWindow) modalWindow.value.renderDeferred.resolve();
        };
        $modalStack.focusFirstFocusableElement = function() {
            if (focusableElementList.length > 0) {
                focusableElementList[0].focus();
                return true;
            }
            return false;
        };
        $modalStack.focusLastFocusableElement = function() {
            if (focusableElementList.length > 0) {
                focusableElementList[focusableElementList.length - 1].focus();
                return true;
            }
            return false;
        };
        $modalStack.isFocusInFirstItem = function(evt) {
            if (focusableElementList.length > 0) return (evt.target || evt.srcElement) == focusableElementList[0];
            return false;
        };
        $modalStack.isFocusInLastItem = function(evt) {
            if (focusableElementList.length > 0) return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
            return false;
        };
        $modalStack.clearFocusListCache = function() {
            focusableElementList = [];
            focusIndex = 0;
        };
        $modalStack.loadFocusElementList = function(modalWindow) {
            if (focusableElementList === undefined || !focusableElementList.length) {
                if (modalWindow) {
                    var modalDomE1 = modalWindow.value.modalDomEl;
                    if (modalDomE1 && modalDomE1.length) focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
                }
            }
        };
        return $modalStack;
    }
]).provider("$uibModal", function() {
    var $modalProvider = {
        options: {
            animation: true,
            backdrop: true,
            keyboard: true
        },
        $get: [
            "$injector",
            "$rootScope",
            "$q",
            "$templateRequest",
            "$controller",
            "$uibModalStack",
            "$modalSuppressWarning",
            "$log",
            function($injector, $rootScope, $q, $templateRequest, $controller, $modalStack, $modalSuppressWarning, $log) {
                var $modal = {};
                function getTemplatePromise(options) {
                    return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
                }
                function getResolvePromises(resolves) {
                    var promisesArr = [];
                    angular.forEach(resolves, function(value) {
                        if (angular.isFunction(value) || angular.isArray(value)) promisesArr.push($q.when($injector.invoke(value)));
                        else if (angular.isString(value)) promisesArr.push($q.when($injector.get(value)));
                        else promisesArr.push($q.when(value));
                    });
                    return promisesArr;
                }
                var promiseChain = null;
                $modal.getPromiseChain = function() {
                    return promiseChain;
                };
                $modal.open = function(modalOptions) {
                    var modalResultDeferred = $q.defer();
                    var modalOpenedDeferred = $q.defer();
                    var modalRenderDeferred = $q.defer();
                    //prepare an instance of a modal to be injected into controllers and returned to a caller
                    var modalInstance = {
                        result: modalResultDeferred.promise,
                        opened: modalOpenedDeferred.promise,
                        rendered: modalRenderDeferred.promise,
                        close: function(result) {
                            return $modalStack.close(modalInstance, result);
                        },
                        dismiss: function(reason) {
                            return $modalStack.dismiss(modalInstance, reason);
                        }
                    };
                    //merge and clean up options
                    modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                    modalOptions.resolve = modalOptions.resolve || {};
                    //verify options
                    if (!modalOptions.template && !modalOptions.templateUrl) throw new Error("One of template or templateUrl options is required.");
                    var templateAndResolvePromise = $q.all([
                        getTemplatePromise(modalOptions)
                    ].concat(getResolvePromises(modalOptions.resolve)));
                    function resolveWithTemplate() {
                        return templateAndResolvePromise;
                    }
                    // Wait for the resolution of the existing promise chain.
                    // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                    // Then add to $modalStack and resolve opened.
                    // Finally clean up the chain variable if no subsequent modal has overwritten it.
                    var samePromise;
                    samePromise = promiseChain = $q.all([
                        promiseChain
                    ]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
                        var modalScope = (modalOptions.scope || $rootScope).$new();
                        modalScope.$close = modalInstance.close;
                        modalScope.$dismiss = modalInstance.dismiss;
                        modalScope.$on("$destroy", function() {
                            if (!modalScope.$$uibDestructionScheduled) modalScope.$dismiss("$uibUnscheduledDestruction");
                        });
                        var ctrlInstance, ctrlLocals = {};
                        var resolveIter = 1;
                        //controllers
                        if (modalOptions.controller) {
                            ctrlLocals.$scope = modalScope;
                            ctrlLocals.$uibModalInstance = modalInstance;
                            Object.defineProperty(ctrlLocals, "$modalInstance", {
                                get: function() {
                                    if (!$modalSuppressWarning) $log.warn("$modalInstance is now deprecated. Use $uibModalInstance instead.");
                                    return modalInstance;
                                }
                            });
                            angular.forEach(modalOptions.resolve, function(value, key) {
                                ctrlLocals[key] = tplAndVars[resolveIter++];
                            });
                            ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                            if (modalOptions.controllerAs) {
                                if (modalOptions.bindToController) angular.extend(ctrlInstance, modalScope);
                                modalScope[modalOptions.controllerAs] = ctrlInstance;
                            }
                        }
                        $modalStack.open(modalInstance, {
                            scope: modalScope,
                            deferred: modalResultDeferred,
                            renderDeferred: modalRenderDeferred,
                            content: tplAndVars[0],
                            animation: modalOptions.animation,
                            backdrop: modalOptions.backdrop,
                            keyboard: modalOptions.keyboard,
                            backdropClass: modalOptions.backdropClass,
                            windowTopClass: modalOptions.windowTopClass,
                            windowClass: modalOptions.windowClass,
                            windowTemplateUrl: modalOptions.windowTemplateUrl,
                            size: modalOptions.size,
                            openedClass: modalOptions.openedClass
                        });
                        modalOpenedDeferred.resolve(true);
                    }, function resolveError(reason) {
                        modalOpenedDeferred.reject(reason);
                        modalResultDeferred.reject(reason);
                    }).finally(function() {
                        if (promiseChain === samePromise) promiseChain = null;
                    });
                    return modalInstance;
                };
                return $modal;
            }
        ]
    };
    return $modalProvider;
});
/* deprecated modal below */ angular.module("ui.bootstrap.modal").value("$modalSuppressWarning", false)/**
   * A helper directive for the $modal service. It creates a backdrop element.
   */ .directive("modalBackdrop", [
    "$animate",
    "$injector",
    "$modalStack",
    "$log",
    "$modalSuppressWarning",
    function($animate, $injector, $modalStack, $log, $modalSuppressWarning) {
        var $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        return {
            replace: true,
            templateUrl: "template/modal/backdrop.html",
            compile: function(tElement, tAttrs) {
                tElement.addClass(tAttrs.backdropClass);
                return linkFn;
            }
        };
        function linkFn(scope, element, attrs) {
            if (!$modalSuppressWarning) $log.warn("modal-backdrop is now deprecated. Use uib-modal-backdrop instead.");
            element.addClass("modal-backdrop");
            if (attrs.modalInClass) {
                if ($animateCss) $animateCss(element, {
                    addClass: attrs.modalInClass
                }).start();
                else $animate.addClass(element, attrs.modalInClass);
                scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
                    var done = setIsAsync();
                    if ($animateCss) $animateCss(element, {
                        removeClass: attrs.modalInClass
                    }).start().then(done);
                    else $animate.removeClass(element, attrs.modalInClass).then(done);
                });
            }
        }
    }
]).directive("modalWindow", [
    "$modalStack",
    "$q",
    "$animate",
    "$injector",
    "$log",
    "$modalSuppressWarning",
    function($modalStack, $q, $animate, $injector, $log, $modalSuppressWarning) {
        var $animateCss = null;
        if ($injector.has("$animateCss")) $animateCss = $injector.get("$animateCss");
        return {
            scope: {
                index: "@"
            },
            replace: true,
            transclude: true,
            templateUrl: function(tElement, tAttrs) {
                return tAttrs.templateUrl || "template/modal/window.html";
            },
            link: function(scope, element, attrs) {
                if (!$modalSuppressWarning) $log.warn("modal-window is now deprecated. Use uib-modal-window instead.");
                element.addClass(attrs.windowClass || "");
                element.addClass(attrs.windowTopClass || "");
                scope.size = attrs.size;
                scope.close = function(evt) {
                    var modal = $modalStack.getTop();
                    if (modal && modal.value.backdrop && modal.value.backdrop !== "static" && evt.target === evt.currentTarget) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        $modalStack.dismiss(modal.key, "backdrop click");
                    }
                };
                // moved from template to fix issue #2280
                element.on("click", scope.close);
                // This property is only added to the scope for the purpose of detecting when this directive is rendered.
                // We can detect that by using this property in the template associated with this directive and then use
                // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
                scope.$isRendered = true;
                // Deferred object that will be resolved when this modal is render.
                var modalRenderDeferObj = $q.defer();
                // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
                // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
                attrs.$observe("modalRender", function(value) {
                    if (value == "true") modalRenderDeferObj.resolve();
                });
                modalRenderDeferObj.promise.then(function() {
                    var animationPromise = null;
                    if (attrs.modalInClass) {
                        if ($animateCss) animationPromise = $animateCss(element, {
                            addClass: attrs.modalInClass
                        }).start();
                        else animationPromise = $animate.addClass(element, attrs.modalInClass);
                        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
                            var done = setIsAsync();
                            if ($animateCss) $animateCss(element, {
                                removeClass: attrs.modalInClass
                            }).start().then(done);
                            else $animate.removeClass(element, attrs.modalInClass).then(done);
                        });
                    }
                    $q.when(animationPromise).then(function() {
                        var inputWithAutofocus = element[0].querySelector("[autofocus]");
                        /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */ if (inputWithAutofocus) inputWithAutofocus.focus();
                        else element[0].focus();
                    });
                    // Notify {@link $modalStack} that modal is rendered.
                    var modal = $modalStack.getTop();
                    if (modal) $modalStack.modalRendered(modal.key);
                });
            }
        };
    }
]).directive("modalAnimationClass", [
    "$log",
    "$modalSuppressWarning",
    function($log, $modalSuppressWarning) {
        return {
            compile: function(tElement, tAttrs) {
                if (!$modalSuppressWarning) $log.warn("modal-animation-class is now deprecated. Use uib-modal-animation-class instead.");
                if (tAttrs.modalAnimation) tElement.addClass(tAttrs.modalAnimationClass);
            }
        };
    }
]).directive("modalTransclude", [
    "$log",
    "$modalSuppressWarning",
    function($log, $modalSuppressWarning) {
        return {
            link: function($scope, $element, $attrs, controller, $transclude) {
                if (!$modalSuppressWarning) $log.warn("modal-transclude is now deprecated. Use uib-modal-transclude instead.");
                $transclude($scope.$parent, function(clone) {
                    $element.empty();
                    $element.append(clone);
                });
            }
        };
    }
]).service("$modalStack", [
    "$animate",
    "$timeout",
    "$document",
    "$compile",
    "$rootScope",
    "$q",
    "$injector",
    "$$multiMap",
    "$$stackedMap",
    "$uibModalStack",
    "$log",
    "$modalSuppressWarning",
    function($animate, $timeout, $document, $compile, $rootScope, $q, $injector, $$multiMap, $$stackedMap, $uibModalStack, $log, $modalSuppressWarning) {
        if (!$modalSuppressWarning) $log.warn("$modalStack is now deprecated. Use $uibModalStack instead.");
        angular.extend(this, $uibModalStack);
    }
]).provider("$modal", [
    "$uibModalProvider",
    function($uibModalProvider) {
        angular.extend(this, $uibModalProvider);
        this.$get = [
            "$injector",
            "$log",
            "$modalSuppressWarning",
            function($injector, $log, $modalSuppressWarning) {
                if (!$modalSuppressWarning) $log.warn("$modal is now deprecated. Use $uibModal instead.");
                return $injector.invoke($uibModalProvider.$get);
            }
        ];
    }
]);
angular.module("ui.bootstrap.pagination", []).controller("UibPaginationController", [
    "$scope",
    "$attrs",
    "$parse",
    function($scope, $attrs, $parse) {
        var self = this, ngModelCtrl = {
            $setViewValue: angular.noop
        }, setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
        this.init = function(ngModelCtrl_, config) {
            ngModelCtrl = ngModelCtrl_;
            this.config = config;
            ngModelCtrl.$render = function() {
                self.render();
            };
            if ($attrs.itemsPerPage) $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
                self.itemsPerPage = parseInt(value, 10);
                $scope.totalPages = self.calculateTotalPages();
            });
            else this.itemsPerPage = config.itemsPerPage;
            $scope.$watch("totalItems", function() {
                $scope.totalPages = self.calculateTotalPages();
            });
            $scope.$watch("totalPages", function(value) {
                setNumPages($scope.$parent, value); // Readonly variable
                if ($scope.page > value) $scope.selectPage(value);
                else ngModelCtrl.$render();
            });
        };
        this.calculateTotalPages = function() {
            var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
            return Math.max(totalPages || 0, 1);
        };
        this.render = function() {
            $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
        };
        $scope.selectPage = function(page, evt) {
            if (evt) evt.preventDefault();
            var clickAllowed = !$scope.ngDisabled || !evt;
            if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                if (evt && evt.target) evt.target.blur();
                ngModelCtrl.$setViewValue(page);
                ngModelCtrl.$render();
            }
        };
        $scope.getText = function(key) {
            return $scope[key + "Text"] || self.config[key + "Text"];
        };
        $scope.noPrevious = function() {
            return $scope.page === 1;
        };
        $scope.noNext = function() {
            return $scope.page === $scope.totalPages;
        };
    }
]).constant("uibPaginationConfig", {
    itemsPerPage: 10,
    boundaryLinks: false,
    directionLinks: true,
    firstText: "First",
    previousText: "Previous",
    nextText: "Next",
    lastText: "Last",
    rotate: true
}).directive("uibPagination", [
    "$parse",
    "uibPaginationConfig",
    function($parse, paginationConfig) {
        return {
            restrict: "EA",
            scope: {
                totalItems: "=",
                firstText: "@",
                previousText: "@",
                nextText: "@",
                lastText: "@",
                ngDisabled: "="
            },
            require: [
                "uibPagination",
                "?ngModel"
            ],
            controller: "UibPaginationController",
            controllerAs: "pagination",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/pagination/pagination.html";
            },
            replace: true,
            link: function(scope, element, attrs, ctrls) {
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                if (!ngModelCtrl) return; // do nothing if no ng-model
                // Setup configuration parameters
                var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize, rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
                scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
                scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
                paginationCtrl.init(ngModelCtrl, paginationConfig);
                if (attrs.maxSize) scope.$parent.$watch($parse(attrs.maxSize), function(value) {
                    maxSize = parseInt(value, 10);
                    paginationCtrl.render();
                });
                // Create page object used in template
                function makePage(number, text, isActive) {
                    return {
                        number: number,
                        text: text,
                        active: isActive
                    };
                }
                function getPages(currentPage, totalPages) {
                    var pages = [];
                    // Default page limits
                    var startPage = 1, endPage = totalPages;
                    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
                    // recompute if maxSize
                    if (isMaxSized) {
                        if (rotate) {
                            // Current page is displayed in the middle of the visible ones
                            startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                            endPage = startPage + maxSize - 1;
                            // Adjust if limit is exceeded
                            if (endPage > totalPages) {
                                endPage = totalPages;
                                startPage = endPage - maxSize + 1;
                            }
                        } else {
                            // Visible pages are paginated with maxSize
                            startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
                            // Adjust last page if limit is exceeded
                            endPage = Math.min(startPage + maxSize - 1, totalPages);
                        }
                    }
                    // Add page number links
                    for(var number = startPage; number <= endPage; number++){
                        var page = makePage(number, number, number === currentPage);
                        pages.push(page);
                    }
                    // Add links to move between page sets
                    if (isMaxSized && !rotate) {
                        if (startPage > 1) {
                            var previousPageSet = makePage(startPage - 1, "...", false);
                            pages.unshift(previousPageSet);
                        }
                        if (endPage < totalPages) {
                            var nextPageSet = makePage(endPage + 1, "...", false);
                            pages.push(nextPageSet);
                        }
                    }
                    return pages;
                }
                var originalRender = paginationCtrl.render;
                paginationCtrl.render = function() {
                    originalRender();
                    if (scope.page > 0 && scope.page <= scope.totalPages) scope.pages = getPages(scope.page, scope.totalPages);
                };
            }
        };
    }
]).constant("uibPagerConfig", {
    itemsPerPage: 10,
    previousText: "\xab Previous",
    nextText: "Next \xbb",
    align: true
}).directive("uibPager", [
    "uibPagerConfig",
    function(pagerConfig) {
        return {
            restrict: "EA",
            scope: {
                totalItems: "=",
                previousText: "@",
                nextText: "@",
                ngDisabled: "="
            },
            require: [
                "uibPager",
                "?ngModel"
            ],
            controller: "UibPaginationController",
            controllerAs: "pagination",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/pagination/pager.html";
            },
            replace: true,
            link: function(scope, element, attrs, ctrls) {
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                if (!ngModelCtrl) return; // do nothing if no ng-model
                scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
                paginationCtrl.init(ngModelCtrl, pagerConfig);
            }
        };
    }
]);
/* Deprecated Pagination Below */ angular.module("ui.bootstrap.pagination").value("$paginationSuppressWarning", false).controller("PaginationController", [
    "$scope",
    "$attrs",
    "$parse",
    "$log",
    "$paginationSuppressWarning",
    function($scope, $attrs, $parse, $log, $paginationSuppressWarning) {
        if (!$paginationSuppressWarning) $log.warn("PaginationController is now deprecated. Use UibPaginationController instead.");
        var self = this, ngModelCtrl = {
            $setViewValue: angular.noop
        }, setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
        this.init = function(ngModelCtrl_, config) {
            ngModelCtrl = ngModelCtrl_;
            this.config = config;
            ngModelCtrl.$render = function() {
                self.render();
            };
            if ($attrs.itemsPerPage) $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
                self.itemsPerPage = parseInt(value, 10);
                $scope.totalPages = self.calculateTotalPages();
            });
            else this.itemsPerPage = config.itemsPerPage;
            $scope.$watch("totalItems", function() {
                $scope.totalPages = self.calculateTotalPages();
            });
            $scope.$watch("totalPages", function(value) {
                setNumPages($scope.$parent, value); // Readonly variable
                if ($scope.page > value) $scope.selectPage(value);
                else ngModelCtrl.$render();
            });
        };
        this.calculateTotalPages = function() {
            var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
            return Math.max(totalPages || 0, 1);
        };
        this.render = function() {
            $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
        };
        $scope.selectPage = function(page, evt) {
            if (evt) evt.preventDefault();
            var clickAllowed = !$scope.ngDisabled || !evt;
            if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                if (evt && evt.target) evt.target.blur();
                ngModelCtrl.$setViewValue(page);
                ngModelCtrl.$render();
            }
        };
        $scope.getText = function(key) {
            return $scope[key + "Text"] || self.config[key + "Text"];
        };
        $scope.noPrevious = function() {
            return $scope.page === 1;
        };
        $scope.noNext = function() {
            return $scope.page === $scope.totalPages;
        };
    }
]).directive("pagination", [
    "$parse",
    "uibPaginationConfig",
    "$log",
    "$paginationSuppressWarning",
    function($parse, paginationConfig, $log, $paginationSuppressWarning) {
        return {
            restrict: "EA",
            scope: {
                totalItems: "=",
                firstText: "@",
                previousText: "@",
                nextText: "@",
                lastText: "@",
                ngDisabled: "="
            },
            require: [
                "pagination",
                "?ngModel"
            ],
            controller: "PaginationController",
            controllerAs: "pagination",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/pagination/pagination.html";
            },
            replace: true,
            link: function(scope, element, attrs, ctrls) {
                if (!$paginationSuppressWarning) $log.warn("pagination is now deprecated. Use uib-pagination instead.");
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                if (!ngModelCtrl) return; // do nothing if no ng-model
                // Setup configuration parameters
                var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize, rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
                scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
                scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
                paginationCtrl.init(ngModelCtrl, paginationConfig);
                if (attrs.maxSize) scope.$parent.$watch($parse(attrs.maxSize), function(value) {
                    maxSize = parseInt(value, 10);
                    paginationCtrl.render();
                });
                // Create page object used in template
                function makePage(number, text, isActive) {
                    return {
                        number: number,
                        text: text,
                        active: isActive
                    };
                }
                function getPages(currentPage, totalPages) {
                    var pages = [];
                    // Default page limits
                    var startPage = 1, endPage = totalPages;
                    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
                    // recompute if maxSize
                    if (isMaxSized) {
                        if (rotate) {
                            // Current page is displayed in the middle of the visible ones
                            startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                            endPage = startPage + maxSize - 1;
                            // Adjust if limit is exceeded
                            if (endPage > totalPages) {
                                endPage = totalPages;
                                startPage = endPage - maxSize + 1;
                            }
                        } else {
                            // Visible pages are paginated with maxSize
                            startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
                            // Adjust last page if limit is exceeded
                            endPage = Math.min(startPage + maxSize - 1, totalPages);
                        }
                    }
                    // Add page number links
                    for(var number = startPage; number <= endPage; number++){
                        var page = makePage(number, number, number === currentPage);
                        pages.push(page);
                    }
                    // Add links to move between page sets
                    if (isMaxSized && !rotate) {
                        if (startPage > 1) {
                            var previousPageSet = makePage(startPage - 1, "...", false);
                            pages.unshift(previousPageSet);
                        }
                        if (endPage < totalPages) {
                            var nextPageSet = makePage(endPage + 1, "...", false);
                            pages.push(nextPageSet);
                        }
                    }
                    return pages;
                }
                var originalRender = paginationCtrl.render;
                paginationCtrl.render = function() {
                    originalRender();
                    if (scope.page > 0 && scope.page <= scope.totalPages) scope.pages = getPages(scope.page, scope.totalPages);
                };
            }
        };
    }
]).directive("pager", [
    "uibPagerConfig",
    "$log",
    "$paginationSuppressWarning",
    function(pagerConfig, $log, $paginationSuppressWarning) {
        return {
            restrict: "EA",
            scope: {
                totalItems: "=",
                previousText: "@",
                nextText: "@",
                ngDisabled: "="
            },
            require: [
                "pager",
                "?ngModel"
            ],
            controller: "PaginationController",
            controllerAs: "pagination",
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/pagination/pager.html";
            },
            replace: true,
            link: function(scope, element, attrs, ctrls) {
                if (!$paginationSuppressWarning) $log.warn("pager is now deprecated. Use uib-pager instead.");
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                if (!ngModelCtrl) return; // do nothing if no ng-model
                scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
                paginationCtrl.init(ngModelCtrl, pagerConfig);
            }
        };
    }
]);
/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */ angular.module("ui.bootstrap.tooltip", [
    "ui.bootstrap.position",
    "ui.bootstrap.stackedMap"
])/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */ .provider("$uibTooltip", function() {
    // The default options tooltip and popover.
    var defaultOptions = {
        placement: "top",
        animation: true,
        popupDelay: 0,
        popupCloseDelay: 0,
        useContentExp: false
    };
    // Default hide triggers for each show trigger
    var triggerMap = {
        "mouseenter": "mouseleave",
        "click": "click",
        "focus": "blur",
        "none": ""
    };
    // The options specified to the provider globally.
    var globalOptions = {};
    /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */ this.options = function(value) {
        angular.extend(globalOptions, value);
    };
    /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
   */ this.setTriggers = function setTriggers(triggers) {
        angular.extend(triggerMap, triggers);
    };
    /**
   * This is a helper function for translating camel-case to snake-case.
   */ function snake_case(name) {
        var regexp = /[A-Z]/g;
        var separator = "-";
        return name.replace(regexp, function(letter, pos) {
            return (pos ? separator : "") + letter.toLowerCase();
        });
    }
    /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */ this.$get = [
        "$window",
        "$compile",
        "$timeout",
        "$document",
        "$uibPosition",
        "$interpolate",
        "$rootScope",
        "$parse",
        "$$stackedMap",
        function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
            var openedTooltips = $$stackedMap.createNew();
            $document.on("keypress", function(e) {
                if (e.which === 27) {
                    var last = openedTooltips.top();
                    if (last) {
                        last.value.close();
                        openedTooltips.removeTop();
                        last = null;
                    }
                }
            });
            return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
                options = angular.extend({}, defaultOptions, globalOptions, options);
                /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */ function getTriggers(trigger) {
                    var show = (trigger || options.trigger || defaultTriggerShow).split(" ");
                    var hide = show.map(function(trigger) {
                        return triggerMap[trigger] || trigger;
                    });
                    return {
                        show: show,
                        hide: hide
                    };
                }
                var directiveName = snake_case(ttType);
                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template = "<div " + directiveName + "-popup " + 'title="' + startSym + "title" + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + "content" + endSym + '" ') + 'placement="' + startSym + "placement" + endSym + '" ' + 'popup-class="' + startSym + "popupClass" + endSym + '" ' + 'animation="animation" ' + 'is-open="isOpen"' + 'origin-scope="origScope" ' + 'style="visibility: hidden; display: block; top: -9999px; left: -9999px;"' + ">" + "</div>";
                return {
                    compile: function(tElem, tAttrs) {
                        var tooltipLinker = $compile(template);
                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var showTimeout;
                            var hideTimeout;
                            var positionTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + "Enable"]);
                            var ttScope = scope.$new(true);
                            var repositionScheduled = false;
                            var isOpenParse = angular.isDefined(attrs[prefix + "IsOpen"]) ? $parse(attrs[prefix + "IsOpen"]) : false;
                            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
                            var observers = [];
                            var positionTooltip = function() {
                                // check if tooltip exists and is not empty
                                if (!tooltip || !tooltip.html()) return;
                                if (!positionTimeout) positionTimeout = $timeout(function() {
                                    // Reset the positioning.
                                    tooltip.css({
                                        top: 0,
                                        left: 0
                                    });
                                    // Now set the calculated positioning.
                                    var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                    ttCss.top += "px";
                                    ttCss.left += "px";
                                    ttCss.visibility = "visible";
                                    tooltip.css(ttCss);
                                    positionTimeout = null;
                                }, 0, false);
                            };
                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;
                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;
                            openedTooltips.add(ttScope, {
                                close: hide
                            });
                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) showTooltipBind();
                                else hideTooltipBind();
                            }
                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + "Enable"])) return;
                                cancelHide();
                                prepareTooltip();
                                if (ttScope.popupDelay) // Do nothing if the tooltip was already scheduled to pop-up.
                                // This happens if show is triggered multiple times before any hide is triggered.
                                {
                                    if (!showTimeout) showTimeout = $timeout(show, ttScope.popupDelay, false);
                                } else show();
                            }
                            function hideTooltipBind() {
                                cancelShow();
                                if (ttScope.popupCloseDelay) {
                                    if (!hideTimeout) hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                                } else hide();
                            }
                            // Show the tooltip popup element.
                            function show() {
                                cancelShow();
                                cancelHide();
                                // Don't show empty tooltips.
                                if (!ttScope.content) return angular.noop;
                                createTooltip();
                                // And show the tooltip.
                                ttScope.$evalAsync(function() {
                                    ttScope.isOpen = true;
                                    assignIsOpen(true);
                                    positionTooltip();
                                });
                            }
                            function cancelShow() {
                                if (showTimeout) {
                                    $timeout.cancel(showTimeout);
                                    showTimeout = null;
                                }
                                if (positionTimeout) {
                                    $timeout.cancel(positionTimeout);
                                    positionTimeout = null;
                                }
                            }
                            // Hide the tooltip popup element.
                            function hide() {
                                cancelShow();
                                cancelHide();
                                if (!ttScope) return;
                                // First things first: we don't show it anymore.
                                ttScope.$evalAsync(function() {
                                    ttScope.isOpen = false;
                                    assignIsOpen(false);
                                    // And now we remove it from the DOM. However, if we have animation, we
                                    // need to wait for it to expire beforehand.
                                    // FIXME: this is a placeholder for a port of the transitions library.
                                    // The fade transition in TWBS is 150ms.
                                    if (ttScope.animation) {
                                        if (!transitionTimeout) transitionTimeout = $timeout(removeTooltip, 150, false);
                                    } else removeTooltip();
                                });
                            }
                            function cancelHide() {
                                if (hideTimeout) {
                                    $timeout.cancel(hideTimeout);
                                    hideTimeout = null;
                                }
                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }
                            }
                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) return;
                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                                    if (appendToBody) $document.find("body").append(tooltip);
                                    else element.after(tooltip);
                                });
                                prepObservers();
                            }
                            function removeTooltip() {
                                unregisterObservers();
                                transitionTimeout = null;
                                if (tooltip) {
                                    tooltip.remove();
                                    tooltip = null;
                                }
                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }
                            /**
             * Set the inital scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in synch.
             */ function prepareTooltip() {
                                ttScope.title = attrs[prefix + "Title"];
                                if (contentParse) ttScope.content = contentParse(scope);
                                else ttScope.content = attrs[ttType];
                                ttScope.popupClass = attrs[prefix + "Class"];
                                ttScope.placement = angular.isDefined(attrs[prefix + "Placement"]) ? attrs[prefix + "Placement"] : options.placement;
                                var delay = parseInt(attrs[prefix + "PopupDelay"], 10);
                                var closeDelay = parseInt(attrs[prefix + "PopupCloseDelay"], 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
                            }
                            function assignIsOpen(isOpen) {
                                if (isOpenParse && angular.isFunction(isOpenParse.assign)) isOpenParse.assign(scope, isOpen);
                            }
                            ttScope.contentExp = function() {
                                return ttScope.content;
                            };
                            /**
             * Observe the relevant attributes.
             */ attrs.$observe("disabled", function(val) {
                                if (val) cancelShow();
                                if (val && ttScope.isOpen) hide();
                            });
                            if (isOpenParse) scope.$watch(isOpenParse, function(val) {
                                /*jshint -W018 */ if (ttScope && !val === ttScope.isOpen) toggleTooltipBind();
                            /*jshint +W018 */ });
                            function prepObservers() {
                                observers.length = 0;
                                if (contentParse) {
                                    observers.push(scope.$watch(contentParse, function(val) {
                                        ttScope.content = val;
                                        if (!val && ttScope.isOpen) hide();
                                    }));
                                    observers.push(tooltipLinkedScope.$watch(function() {
                                        if (!repositionScheduled) {
                                            repositionScheduled = true;
                                            tooltipLinkedScope.$$postDigest(function() {
                                                repositionScheduled = false;
                                                if (ttScope && ttScope.isOpen) positionTooltip();
                                            });
                                        }
                                    }));
                                } else observers.push(attrs.$observe(ttType, function(val) {
                                    ttScope.content = val;
                                    if (!val && ttScope.isOpen) hide();
                                    else positionTooltip();
                                }));
                                observers.push(attrs.$observe(prefix + "Title", function(val) {
                                    ttScope.title = val;
                                    if (ttScope.isOpen) positionTooltip();
                                }));
                                observers.push(attrs.$observe(prefix + "Placement", function(val) {
                                    ttScope.placement = val ? val : options.placement;
                                    if (ttScope.isOpen) positionTooltip();
                                }));
                            }
                            function unregisterObservers() {
                                if (observers.length) {
                                    angular.forEach(observers, function(observer) {
                                        observer();
                                    });
                                    observers.length = 0;
                                }
                            }
                            var unregisterTriggers = function() {
                                triggers.show.forEach(function(trigger) {
                                    element.unbind(trigger, showTooltipBind);
                                });
                                triggers.hide.forEach(function(trigger) {
                                    trigger.split(" ").forEach(function(hideTrigger) {
                                        element[0].removeEventListener(hideTrigger, hideTooltipBind);
                                    });
                                });
                            };
                            function prepTriggers() {
                                var val = attrs[prefix + "Trigger"];
                                unregisterTriggers();
                                triggers = getTriggers(val);
                                if (triggers.show !== "none") triggers.show.forEach(function(trigger, idx) {
                                    // Using raw addEventListener due to jqLite/jQuery bug - #4060
                                    if (trigger === triggers.hide[idx]) element[0].addEventListener(trigger, toggleTooltipBind);
                                    else if (trigger) {
                                        element[0].addEventListener(trigger, showTooltipBind);
                                        triggers.hide[idx].split(" ").forEach(function(trigger) {
                                            element[0].addEventListener(trigger, hideTooltipBind);
                                        });
                                    }
                                    element.on("keypress", function(e) {
                                        if (e.which === 27) hideTooltipBind();
                                    });
                                });
                            }
                            prepTriggers();
                            var animation = scope.$eval(attrs[prefix + "Animation"]);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
                            var appendToBodyVal = scope.$eval(attrs[prefix + "AppendToBody"]);
                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
                            // if a tooltip is attached to <body> we need to remove it on
                            // location change as its parent scope will probably not be destroyed
                            // by the change.
                            if (appendToBody) scope.$on("$locationChangeSuccess", function closeTooltipOnLocationChangeSuccess() {
                                if (ttScope.isOpen) hide();
                            });
                            // Make sure tooltip is destroyed and removed.
                            scope.$on("$destroy", function onDestroyTooltip() {
                                cancelShow();
                                cancelHide();
                                unregisterTriggers();
                                removeTooltip();
                                openedTooltips.remove(ttScope);
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }
    ];
})// This is mostly ngInclude code but with a custom scope
.directive("uibTooltipTemplateTransclude", [
    "$animate",
    "$sce",
    "$compile",
    "$templateRequest",
    function($animate, $sce, $compile, $templateRequest) {
        return {
            link: function(scope, elem, attrs) {
                var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
                var changeCounter = 0, currentScope, previousElement, currentElement;
                var cleanupLastIncludeContent = function() {
                    if (previousElement) {
                        previousElement.remove();
                        previousElement = null;
                    }
                    if (currentScope) {
                        currentScope.$destroy();
                        currentScope = null;
                    }
                    if (currentElement) {
                        $animate.leave(currentElement).then(function() {
                            previousElement = null;
                        });
                        previousElement = currentElement;
                        currentElement = null;
                    }
                };
                scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
                    var thisChangeId = ++changeCounter;
                    if (src) {
                        //set the 2nd param to true to ignore the template request error so that the inner
                        //contents and scope can be cleaned up.
                        $templateRequest(src, true).then(function(response) {
                            if (thisChangeId !== changeCounter) return;
                            var newScope = origScope.$new();
                            var template = response;
                            var clone = $compile(template)(newScope, function(clone) {
                                cleanupLastIncludeContent();
                                $animate.enter(clone, elem);
                            });
                            currentScope = newScope;
                            currentElement = clone;
                            currentScope.$emit("$includeContentLoaded", src);
                        }, function() {
                            if (thisChangeId === changeCounter) {
                                cleanupLastIncludeContent();
                                scope.$emit("$includeContentError", src);
                            }
                        });
                        scope.$emit("$includeContentRequested", src);
                    } else cleanupLastIncludeContent();
                });
                scope.$on("$destroy", cleanupLastIncludeContent);
            }
        };
    }
])/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */ .directive("uibTooltipClasses", function() {
    return {
        restrict: "A",
        link: function(scope, element, attrs) {
            if (scope.placement) element.addClass(scope.placement);
            if (scope.popupClass) element.addClass(scope.popupClass);
            if (scope.animation()) element.addClass(attrs.tooltipAnimationClass);
        }
    };
}).directive("uibTooltipPopup", function() {
    return {
        replace: true,
        scope: {
            content: "@",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&"
        },
        templateUrl: "template/tooltip/tooltip-popup.html",
        link: function(scope, element) {
            element.addClass("tooltip");
        }
    };
}).directive("uibTooltip", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibTooltip", "tooltip", "mouseenter");
    }
]).directive("uibTooltipTemplatePopup", function() {
    return {
        replace: true,
        scope: {
            contentExp: "&",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&",
            originScope: "&"
        },
        templateUrl: "template/tooltip/tooltip-template-popup.html",
        link: function(scope, element) {
            element.addClass("tooltip");
        }
    };
}).directive("uibTooltipTemplate", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibTooltipTemplate", "tooltip", "mouseenter", {
            useContentExp: true
        });
    }
]).directive("uibTooltipHtmlPopup", function() {
    return {
        replace: true,
        scope: {
            contentExp: "&",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&"
        },
        templateUrl: "template/tooltip/tooltip-html-popup.html",
        link: function(scope, element) {
            element.addClass("tooltip");
        }
    };
}).directive("uibTooltipHtml", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibTooltipHtml", "tooltip", "mouseenter", {
            useContentExp: true
        });
    }
]);
/* Deprecated tooltip below */ angular.module("ui.bootstrap.tooltip").value("$tooltipSuppressWarning", false).provider("$tooltip", [
    "$uibTooltipProvider",
    function($uibTooltipProvider) {
        angular.extend(this, $uibTooltipProvider);
        this.$get = [
            "$log",
            "$tooltipSuppressWarning",
            "$injector",
            function($log, $tooltipSuppressWarning, $injector) {
                if (!$tooltipSuppressWarning) $log.warn("$tooltip is now deprecated. Use $uibTooltip instead.");
                return $injector.invoke($uibTooltipProvider.$get);
            }
        ];
    }
])// This is mostly ngInclude code but with a custom scope
.directive("tooltipTemplateTransclude", [
    "$animate",
    "$sce",
    "$compile",
    "$templateRequest",
    "$log",
    "$tooltipSuppressWarning",
    function($animate, $sce, $compile, $templateRequest, $log, $tooltipSuppressWarning) {
        return {
            link: function(scope, elem, attrs) {
                if (!$tooltipSuppressWarning) $log.warn("tooltip-template-transclude is now deprecated. Use uib-tooltip-template-transclude instead.");
                var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
                var changeCounter = 0, currentScope, previousElement, currentElement;
                var cleanupLastIncludeContent = function() {
                    if (previousElement) {
                        previousElement.remove();
                        previousElement = null;
                    }
                    if (currentScope) {
                        currentScope.$destroy();
                        currentScope = null;
                    }
                    if (currentElement) {
                        $animate.leave(currentElement).then(function() {
                            previousElement = null;
                        });
                        previousElement = currentElement;
                        currentElement = null;
                    }
                };
                scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
                    var thisChangeId = ++changeCounter;
                    if (src) {
                        //set the 2nd param to true to ignore the template request error so that the inner
                        //contents and scope can be cleaned up.
                        $templateRequest(src, true).then(function(response) {
                            if (thisChangeId !== changeCounter) return;
                            var newScope = origScope.$new();
                            var template = response;
                            var clone = $compile(template)(newScope, function(clone) {
                                cleanupLastIncludeContent();
                                $animate.enter(clone, elem);
                            });
                            currentScope = newScope;
                            currentElement = clone;
                            currentScope.$emit("$includeContentLoaded", src);
                        }, function() {
                            if (thisChangeId === changeCounter) {
                                cleanupLastIncludeContent();
                                scope.$emit("$includeContentError", src);
                            }
                        });
                        scope.$emit("$includeContentRequested", src);
                    } else cleanupLastIncludeContent();
                });
                scope.$on("$destroy", cleanupLastIncludeContent);
            }
        };
    }
]).directive("tooltipClasses", [
    "$log",
    "$tooltipSuppressWarning",
    function($log, $tooltipSuppressWarning) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                if (!$tooltipSuppressWarning) $log.warn("tooltip-classes is now deprecated. Use uib-tooltip-classes instead.");
                if (scope.placement) element.addClass(scope.placement);
                if (scope.popupClass) element.addClass(scope.popupClass);
                if (scope.animation()) element.addClass(attrs.tooltipAnimationClass);
            }
        };
    }
]).directive("tooltipPopup", [
    "$log",
    "$tooltipSuppressWarning",
    function($log, $tooltipSuppressWarning) {
        return {
            replace: true,
            scope: {
                content: "@",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&"
            },
            templateUrl: "template/tooltip/tooltip-popup.html",
            link: function(scope, element) {
                if (!$tooltipSuppressWarning) $log.warn("tooltip-popup is now deprecated. Use uib-tooltip-popup instead.");
                element.addClass("tooltip");
            }
        };
    }
]).directive("tooltip", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("tooltip", "tooltip", "mouseenter");
    }
]).directive("tooltipTemplatePopup", [
    "$log",
    "$tooltipSuppressWarning",
    function($log, $tooltipSuppressWarning) {
        return {
            replace: true,
            scope: {
                contentExp: "&",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&",
                originScope: "&"
            },
            templateUrl: "template/tooltip/tooltip-template-popup.html",
            link: function(scope, element) {
                if (!$tooltipSuppressWarning) $log.warn("tooltip-template-popup is now deprecated. Use uib-tooltip-template-popup instead.");
                element.addClass("tooltip");
            }
        };
    }
]).directive("tooltipTemplate", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("tooltipTemplate", "tooltip", "mouseenter", {
            useContentExp: true
        });
    }
]).directive("tooltipHtmlPopup", [
    "$log",
    "$tooltipSuppressWarning",
    function($log, $tooltipSuppressWarning) {
        return {
            replace: true,
            scope: {
                contentExp: "&",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&"
            },
            templateUrl: "template/tooltip/tooltip-html-popup.html",
            link: function(scope, element) {
                if (!$tooltipSuppressWarning) $log.warn("tooltip-html-popup is now deprecated. Use uib-tooltip-html-popup instead.");
                element.addClass("tooltip");
            }
        };
    }
]).directive("tooltipHtml", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("tooltipHtml", "tooltip", "mouseenter", {
            useContentExp: true
        });
    }
]);
/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */ angular.module("ui.bootstrap.popover", [
    "ui.bootstrap.tooltip"
]).directive("uibPopoverTemplatePopup", function() {
    return {
        replace: true,
        scope: {
            title: "@",
            contentExp: "&",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&",
            originScope: "&"
        },
        templateUrl: "template/popover/popover-template.html",
        link: function(scope, element) {
            element.addClass("popover");
        }
    };
}).directive("uibPopoverTemplate", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibPopoverTemplate", "popover", "click", {
            useContentExp: true
        });
    }
]).directive("uibPopoverHtmlPopup", function() {
    return {
        replace: true,
        scope: {
            contentExp: "&",
            title: "@",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&"
        },
        templateUrl: "template/popover/popover-html.html",
        link: function(scope, element) {
            element.addClass("popover");
        }
    };
}).directive("uibPopoverHtml", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibPopoverHtml", "popover", "click", {
            useContentExp: true
        });
    }
]).directive("uibPopoverPopup", function() {
    return {
        replace: true,
        scope: {
            title: "@",
            content: "@",
            placement: "@",
            popupClass: "@",
            animation: "&",
            isOpen: "&"
        },
        templateUrl: "template/popover/popover.html",
        link: function(scope, element) {
            element.addClass("popover");
        }
    };
}).directive("uibPopover", [
    "$uibTooltip",
    function($uibTooltip) {
        return $uibTooltip("uibPopover", "popover", "click");
    }
]);
/* Deprecated popover below */ angular.module("ui.bootstrap.popover").value("$popoverSuppressWarning", false).directive("popoverTemplatePopup", [
    "$log",
    "$popoverSuppressWarning",
    function($log, $popoverSuppressWarning) {
        return {
            replace: true,
            scope: {
                title: "@",
                contentExp: "&",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&",
                originScope: "&"
            },
            templateUrl: "template/popover/popover-template.html",
            link: function(scope, element) {
                if (!$popoverSuppressWarning) $log.warn("popover-template-popup is now deprecated. Use uib-popover-template-popup instead.");
                element.addClass("popover");
            }
        };
    }
]).directive("popoverTemplate", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("popoverTemplate", "popover", "click", {
            useContentExp: true
        });
    }
]).directive("popoverHtmlPopup", [
    "$log",
    "$popoverSuppressWarning",
    function($log, $popoverSuppressWarning) {
        return {
            replace: true,
            scope: {
                contentExp: "&",
                title: "@",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&"
            },
            templateUrl: "template/popover/popover-html.html",
            link: function(scope, element) {
                if (!$popoverSuppressWarning) $log.warn("popover-html-popup is now deprecated. Use uib-popover-html-popup instead.");
                element.addClass("popover");
            }
        };
    }
]).directive("popoverHtml", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("popoverHtml", "popover", "click", {
            useContentExp: true
        });
    }
]).directive("popoverPopup", [
    "$log",
    "$popoverSuppressWarning",
    function($log, $popoverSuppressWarning) {
        return {
            replace: true,
            scope: {
                title: "@",
                content: "@",
                placement: "@",
                popupClass: "@",
                animation: "&",
                isOpen: "&"
            },
            templateUrl: "template/popover/popover.html",
            link: function(scope, element) {
                if (!$popoverSuppressWarning) $log.warn("popover-popup is now deprecated. Use uib-popover-popup instead.");
                element.addClass("popover");
            }
        };
    }
]).directive("popover", [
    "$tooltip",
    function($tooltip) {
        return $tooltip("popover", "popover", "click");
    }
]);
angular.module("ui.bootstrap.progressbar", []).constant("uibProgressConfig", {
    animate: true,
    max: 100
}).controller("UibProgressController", [
    "$scope",
    "$attrs",
    "uibProgressConfig",
    function($scope, $attrs, progressConfig) {
        var self = this, animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
        this.bars = [];
        $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
        this.addBar = function(bar, element, attrs) {
            if (!animate) element.css({
                "transition": "none"
            });
            this.bars.push(bar);
            bar.max = $scope.max;
            bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : "progressbar";
            bar.$watch("value", function(value) {
                bar.recalculatePercentage();
            });
            bar.recalculatePercentage = function() {
                var totalPercentage = self.bars.reduce(function(total, bar) {
                    bar.percent = +(100 * bar.value / bar.max).toFixed(2);
                    return total + bar.percent;
                }, 0);
                if (totalPercentage > 100) bar.percent -= totalPercentage - 100;
            };
            bar.$on("$destroy", function() {
                element = null;
                self.removeBar(bar);
            });
        };
        this.removeBar = function(bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
            this.bars.forEach(function(bar) {
                bar.recalculatePercentage();
            });
        };
        $scope.$watch("max", function(max) {
            self.bars.forEach(function(bar) {
                bar.max = $scope.max;
                bar.recalculatePercentage();
            });
        });
    }
]).directive("uibProgress", function() {
    return {
        replace: true,
        transclude: true,
        controller: "UibProgressController",
        require: "uibProgress",
        scope: {
            max: "=?"
        },
        templateUrl: "template/progressbar/progress.html"
    };
}).directive("uibBar", function() {
    return {
        replace: true,
        transclude: true,
        require: "^uibProgress",
        scope: {
            value: "=",
            type: "@"
        },
        templateUrl: "template/progressbar/bar.html",
        link: function(scope, element, attrs, progressCtrl) {
            progressCtrl.addBar(scope, element, attrs);
        }
    };
}).directive("uibProgressbar", function() {
    return {
        replace: true,
        transclude: true,
        controller: "UibProgressController",
        scope: {
            value: "=",
            max: "=?",
            type: "@"
        },
        templateUrl: "template/progressbar/progressbar.html",
        link: function(scope, element, attrs, progressCtrl) {
            progressCtrl.addBar(scope, angular.element(element.children()[0]), {
                title: attrs.title
            });
        }
    };
});
/* Deprecated progressbar below */ angular.module("ui.bootstrap.progressbar").value("$progressSuppressWarning", false).controller("ProgressController", [
    "$scope",
    "$attrs",
    "uibProgressConfig",
    "$log",
    "$progressSuppressWarning",
    function($scope, $attrs, progressConfig, $log, $progressSuppressWarning) {
        if (!$progressSuppressWarning) $log.warn("ProgressController is now deprecated. Use UibProgressController instead.");
        var self = this, animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
        this.bars = [];
        $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
        this.addBar = function(bar, element, attrs) {
            if (!animate) element.css({
                "transition": "none"
            });
            this.bars.push(bar);
            bar.max = $scope.max;
            bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : "progressbar";
            bar.$watch("value", function(value) {
                bar.recalculatePercentage();
            });
            bar.recalculatePercentage = function() {
                bar.percent = +(100 * bar.value / bar.max).toFixed(2);
                var totalPercentage = self.bars.reduce(function(total, bar) {
                    return total + bar.percent;
                }, 0);
                if (totalPercentage > 100) bar.percent -= totalPercentage - 100;
            };
            bar.$on("$destroy", function() {
                element = null;
                self.removeBar(bar);
            });
        };
        this.removeBar = function(bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
        };
        $scope.$watch("max", function(max) {
            self.bars.forEach(function(bar) {
                bar.max = $scope.max;
                bar.recalculatePercentage();
            });
        });
    }
]).directive("progress", [
    "$log",
    "$progressSuppressWarning",
    function($log, $progressSuppressWarning) {
        return {
            replace: true,
            transclude: true,
            controller: "ProgressController",
            require: "progress",
            scope: {
                max: "=?",
                title: "@?"
            },
            templateUrl: "template/progressbar/progress.html",
            link: function() {
                if (!$progressSuppressWarning) $log.warn("progress is now deprecated. Use uib-progress instead.");
            }
        };
    }
]).directive("bar", [
    "$log",
    "$progressSuppressWarning",
    function($log, $progressSuppressWarning) {
        return {
            replace: true,
            transclude: true,
            require: "^progress",
            scope: {
                value: "=",
                type: "@"
            },
            templateUrl: "template/progressbar/bar.html",
            link: function(scope, element, attrs, progressCtrl) {
                if (!$progressSuppressWarning) $log.warn("bar is now deprecated. Use uib-bar instead.");
                progressCtrl.addBar(scope, element);
            }
        };
    }
]).directive("progressbar", [
    "$log",
    "$progressSuppressWarning",
    function($log, $progressSuppressWarning) {
        return {
            replace: true,
            transclude: true,
            controller: "ProgressController",
            scope: {
                value: "=",
                max: "=?",
                type: "@"
            },
            templateUrl: "template/progressbar/progressbar.html",
            link: function(scope, element, attrs, progressCtrl) {
                if (!$progressSuppressWarning) $log.warn("progressbar is now deprecated. Use uib-progressbar instead.");
                progressCtrl.addBar(scope, angular.element(element.children()[0]), {
                    title: attrs.title
                });
            }
        };
    }
]);
angular.module("ui.bootstrap.rating", []).constant("uibRatingConfig", {
    max: 5,
    stateOn: null,
    stateOff: null,
    titles: [
        "one",
        "two",
        "three",
        "four",
        "five"
    ]
}).controller("UibRatingController", [
    "$scope",
    "$attrs",
    "uibRatingConfig",
    function($scope, $attrs, ratingConfig) {
        var ngModelCtrl = {
            $setViewValue: angular.noop
        };
        this.init = function(ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;
            ngModelCtrl.$formatters.push(function(value) {
                if (angular.isNumber(value) && value << 0 !== value) value = Math.round(value);
                return value;
            });
            this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
            this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
            var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
            this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ? tmpTitles : ratingConfig.titles;
            var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) : new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
            $scope.range = this.buildTemplateObjects(ratingStates);
        };
        this.buildTemplateObjects = function(states) {
            for(var i = 0, n = states.length; i < n; i++)states[i] = angular.extend({
                index: i
            }, {
                stateOn: this.stateOn,
                stateOff: this.stateOff,
                title: this.getTitle(i)
            }, states[i]);
            return states;
        };
        this.getTitle = function(index) {
            if (index >= this.titles.length) return index + 1;
            else return this.titles[index];
        };
        $scope.rate = function(value) {
            if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
                ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
                ngModelCtrl.$render();
            }
        };
        $scope.enter = function(value) {
            if (!$scope.readonly) $scope.value = value;
            $scope.onHover({
                value: value
            });
        };
        $scope.reset = function() {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.onLeave();
        };
        $scope.onKeydown = function(evt) {
            if (/(37|38|39|40)/.test(evt.which)) {
                evt.preventDefault();
                evt.stopPropagation();
                $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
            }
        };
        this.render = function() {
            $scope.value = ngModelCtrl.$viewValue;
        };
    }
]).directive("uibRating", function() {
    return {
        require: [
            "uibRating",
            "ngModel"
        ],
        scope: {
            readonly: "=?",
            onHover: "&",
            onLeave: "&"
        },
        controller: "UibRatingController",
        templateUrl: "template/rating/rating.html",
        replace: true,
        link: function(scope, element, attrs, ctrls) {
            var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            ratingCtrl.init(ngModelCtrl);
        }
    };
});
/* Deprecated rating below */ angular.module("ui.bootstrap.rating").value("$ratingSuppressWarning", false).controller("RatingController", [
    "$scope",
    "$attrs",
    "$controller",
    "$log",
    "$ratingSuppressWarning",
    function($scope, $attrs, $controller, $log, $ratingSuppressWarning) {
        if (!$ratingSuppressWarning) $log.warn("RatingController is now deprecated. Use UibRatingController instead.");
        angular.extend(this, $controller("UibRatingController", {
            $scope: $scope,
            $attrs: $attrs
        }));
    }
]).directive("rating", [
    "$log",
    "$ratingSuppressWarning",
    function($log, $ratingSuppressWarning) {
        return {
            require: [
                "rating",
                "ngModel"
            ],
            scope: {
                readonly: "=?",
                onHover: "&",
                onLeave: "&"
            },
            controller: "RatingController",
            templateUrl: "template/rating/rating.html",
            replace: true,
            link: function(scope, element, attrs, ctrls) {
                if (!$ratingSuppressWarning) $log.warn("rating is now deprecated. Use uib-rating instead.");
                var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                ratingCtrl.init(ngModelCtrl);
            }
        };
    }
]);
/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */ angular.module("ui.bootstrap.tabs", []).controller("UibTabsetController", [
    "$scope",
    function($scope) {
        var ctrl = this, tabs = ctrl.tabs = $scope.tabs = [];
        ctrl.select = function(selectedTab) {
            angular.forEach(tabs, function(tab) {
                if (tab.active && tab !== selectedTab) {
                    tab.active = false;
                    tab.onDeselect();
                    selectedTab.selectCalled = false;
                }
            });
            selectedTab.active = true;
            // only call select if it has not already been called
            if (!selectedTab.selectCalled) {
                selectedTab.onSelect();
                selectedTab.selectCalled = true;
            }
        };
        ctrl.addTab = function addTab(tab) {
            tabs.push(tab);
            // we can't run the select function on the first tab
            // since that would select it twice
            if (tabs.length === 1 && tab.active !== false) tab.active = true;
            else if (tab.active) ctrl.select(tab);
            else tab.active = false;
        };
        ctrl.removeTab = function removeTab(tab) {
            var index = tabs.indexOf(tab);
            //Select a new tab if the tab to be removed is selected and not destroyed
            if (tab.active && tabs.length > 1 && !destroyed) {
                //If this is the last tab, select the previous tab. else, the next tab.
                var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
                ctrl.select(tabs[newActiveIndex]);
            }
            tabs.splice(index, 1);
        };
        var destroyed;
        $scope.$on("$destroy", function() {
            destroyed = true;
        });
    }
])/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <uib-tabset>
      <uib-tab heading="Tab 1"><b>First</b> Content!</uib-tab>
      <uib-tab heading="Tab 2"><i>Second</i> Content!</uib-tab>
    </uib-tabset>
    <hr />
    <uib-tabset vertical="true">
      <uib-tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</uib-tab>
      <uib-tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</uib-tab>
    </uib-tabset>
    <uib-tabset justified="true">
      <uib-tab heading="Justified Tab 1"><b>First</b> Justified Content!</uib-tab>
      <uib-tab heading="Justified Tab 2"><i>Second</i> Justified Content!</uib-tab>
    </uib-tabset>
  </file>
</example>
 */ .directive("uibTabset", function() {
    return {
        restrict: "EA",
        transclude: true,
        replace: true,
        scope: {
            type: "@"
        },
        controller: "UibTabsetController",
        templateUrl: "template/tabs/tabset.html",
        link: function(scope, element, attrs) {
            scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
            scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
        }
    };
})/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <div ng-controller="TabsDemoCtrl">
      <button class="btn btn-small" ng-click="items[0].active = true">
        Select item 1, using active binding
      </button>
      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
        Enable/disable item 2, using disabled binding
      </button>
      <br />
      <uib-tabset>
        <uib-tab heading="Tab 1">First Tab</uib-tab>
        <uib-tab select="alertMe()">
          <uib-tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
          Second Tab, with alert callback and html heading!
        </uib-tab>
        <uib-tab ng-repeat="item in items"
          heading="{{item.title}}"
          disabled="item.disabled"
          active="item.active">
          {{item.content}}
        </uib-tab>
      </uib-tabset>
    </div>
  </file>
  <file name="script.js">
    function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
  </file>
</example>
 */ /**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <uib-tabset>
      <uib-tab>
        <uib-tab-heading><b>HTML</b> in my titles?!</tab-heading>
        And some content, too!
      </uib-tab>
      <uib-tab>
        <uib-tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
        That's right.
      </uib-tab>
    </uib-tabset>
  </file>
</example>
 */ .directive("uibTab", [
    "$parse",
    function($parse) {
        return {
            require: "^uibTabset",
            restrict: "EA",
            replace: true,
            templateUrl: "template/tabs/tab.html",
            transclude: true,
            scope: {
                active: "=?",
                heading: "@",
                onSelect: "&select",
                //once it inserts the tab's content into the dom
                onDeselect: "&deselect"
            },
            controller: function() {
            //Empty controller so other directives can require being 'under' a tab
            },
            link: function(scope, elm, attrs, tabsetCtrl, transclude) {
                scope.$watch("active", function(active) {
                    if (active) tabsetCtrl.select(scope);
                });
                scope.disabled = false;
                if (attrs.disable) scope.$parent.$watch($parse(attrs.disable), function(value) {
                    scope.disabled = !!value;
                });
                scope.select = function() {
                    if (!scope.disabled) scope.active = true;
                };
                tabsetCtrl.addTab(scope);
                scope.$on("$destroy", function() {
                    tabsetCtrl.removeTab(scope);
                });
                //We need to transclude later, once the content container is ready.
                //when this link happens, we're inside a tab heading.
                scope.$transcludeFn = transclude;
            }
        };
    }
]).directive("uibTabHeadingTransclude", function() {
    return {
        restrict: "A",
        require: [
            "?^uibTab",
            "?^tab"
        ],
        link: function(scope, elm) {
            scope.$watch("headingElement", function updateHeadingElement(heading) {
                if (heading) {
                    elm.html("");
                    elm.append(heading);
                }
            });
        }
    };
}).directive("uibTabContentTransclude", function() {
    return {
        restrict: "A",
        require: [
            "?^uibTabset",
            "?^tabset"
        ],
        link: function(scope, elm, attrs) {
            var tab = scope.$eval(attrs.uibTabContentTransclude);
            //Now our tab is ready to be transcluded: both the tab heading area
            //and the tab content area are loaded.  Transclude 'em both.
            tab.$transcludeFn(tab.$parent, function(contents) {
                angular.forEach(contents, function(node) {
                    if (isTabHeading(node)) //Let tabHeadingTransclude know.
                    tab.headingElement = node;
                    else elm.append(node);
                });
            });
        }
    };
    function isTabHeading(node) {
        return node.tagName && (node.hasAttribute("tab-heading") || // TODO: remove after deprecation removal
        node.hasAttribute("data-tab-heading") || // TODO: remove after deprecation removal
        node.hasAttribute("x-tab-heading") || // TODO: remove after deprecation removal
        node.hasAttribute("uib-tab-heading") || node.hasAttribute("data-uib-tab-heading") || node.hasAttribute("x-uib-tab-heading") || node.tagName.toLowerCase() === "tab-heading" || // TODO: remove after deprecation removal
        node.tagName.toLowerCase() === "data-tab-heading" || // TODO: remove after deprecation removal
        node.tagName.toLowerCase() === "x-tab-heading" || // TODO: remove after deprecation removal
        node.tagName.toLowerCase() === "uib-tab-heading" || node.tagName.toLowerCase() === "data-uib-tab-heading" || node.tagName.toLowerCase() === "x-uib-tab-heading");
    }
});
/* deprecated tabs below */ angular.module("ui.bootstrap.tabs").value("$tabsSuppressWarning", false).controller("TabsetController", [
    "$scope",
    "$controller",
    "$log",
    "$tabsSuppressWarning",
    function($scope, $controller, $log, $tabsSuppressWarning) {
        if (!$tabsSuppressWarning) $log.warn("TabsetController is now deprecated. Use UibTabsetController instead.");
        angular.extend(this, $controller("UibTabsetController", {
            $scope: $scope
        }));
    }
]).directive("tabset", [
    "$log",
    "$tabsSuppressWarning",
    function($log, $tabsSuppressWarning) {
        return {
            restrict: "EA",
            transclude: true,
            replace: true,
            scope: {
                type: "@"
            },
            controller: "TabsetController",
            templateUrl: "template/tabs/tabset.html",
            link: function(scope, element, attrs) {
                if (!$tabsSuppressWarning) $log.warn("tabset is now deprecated. Use uib-tabset instead.");
                scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
                scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
            }
        };
    }
]).directive("tab", [
    "$parse",
    "$log",
    "$tabsSuppressWarning",
    function($parse, $log, $tabsSuppressWarning) {
        return {
            require: "^tabset",
            restrict: "EA",
            replace: true,
            templateUrl: "template/tabs/tab.html",
            transclude: true,
            scope: {
                active: "=?",
                heading: "@",
                onSelect: "&select",
                //once it inserts the tab's content into the dom
                onDeselect: "&deselect"
            },
            controller: function() {
            //Empty controller so other directives can require being 'under' a tab
            },
            link: function(scope, elm, attrs, tabsetCtrl, transclude) {
                if (!$tabsSuppressWarning) $log.warn("tab is now deprecated. Use uib-tab instead.");
                scope.$watch("active", function(active) {
                    if (active) tabsetCtrl.select(scope);
                });
                scope.disabled = false;
                if (attrs.disable) scope.$parent.$watch($parse(attrs.disable), function(value) {
                    scope.disabled = !!value;
                });
                scope.select = function() {
                    if (!scope.disabled) scope.active = true;
                };
                tabsetCtrl.addTab(scope);
                scope.$on("$destroy", function() {
                    tabsetCtrl.removeTab(scope);
                });
                //We need to transclude later, once the content container is ready.
                //when this link happens, we're inside a tab heading.
                scope.$transcludeFn = transclude;
            }
        };
    }
]).directive("tabHeadingTransclude", [
    "$log",
    "$tabsSuppressWarning",
    function($log, $tabsSuppressWarning) {
        return {
            restrict: "A",
            require: "^tab",
            link: function(scope, elm) {
                if (!$tabsSuppressWarning) $log.warn("tab-heading-transclude is now deprecated. Use uib-tab-heading-transclude instead.");
                scope.$watch("headingElement", function updateHeadingElement(heading) {
                    if (heading) {
                        elm.html("");
                        elm.append(heading);
                    }
                });
            }
        };
    }
]).directive("tabContentTransclude", [
    "$log",
    "$tabsSuppressWarning",
    function($log, $tabsSuppressWarning) {
        return {
            restrict: "A",
            require: "^tabset",
            link: function(scope, elm, attrs) {
                if (!$tabsSuppressWarning) $log.warn("tab-content-transclude is now deprecated. Use uib-tab-content-transclude instead.");
                var tab = scope.$eval(attrs.tabContentTransclude);
                //Now our tab is ready to be transcluded: both the tab heading area
                //and the tab content area are loaded.  Transclude 'em both.
                tab.$transcludeFn(tab.$parent, function(contents) {
                    angular.forEach(contents, function(node) {
                        if (isTabHeading(node)) //Let tabHeadingTransclude know.
                        tab.headingElement = node;
                        else elm.append(node);
                    });
                });
            }
        };
        function isTabHeading(node) {
            return node.tagName && (node.hasAttribute("tab-heading") || node.hasAttribute("data-tab-heading") || node.hasAttribute("x-tab-heading") || node.tagName.toLowerCase() === "tab-heading" || node.tagName.toLowerCase() === "data-tab-heading" || node.tagName.toLowerCase() === "x-tab-heading");
        }
    }
]);
angular.module("ui.bootstrap.timepicker", []).constant("uibTimepickerConfig", {
    hourStep: 1,
    minuteStep: 1,
    showMeridian: true,
    meridians: null,
    readonlyInput: false,
    mousewheel: true,
    arrowkeys: true,
    showSpinners: true
}).controller("UibTimepickerController", [
    "$scope",
    "$element",
    "$attrs",
    "$parse",
    "$log",
    "$locale",
    "uibTimepickerConfig",
    function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
        var selected = new Date(), ngModelCtrl = {
            $setViewValue: angular.noop
        }, meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
        $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
        $element.removeAttr("tabindex");
        this.init = function(ngModelCtrl_, inputs) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;
            ngModelCtrl.$formatters.unshift(function(modelValue) {
                return modelValue ? new Date(modelValue) : null;
            });
            var hoursInputEl = inputs.eq(0), minutesInputEl = inputs.eq(1);
            var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
            if (mousewheel) this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
            var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
            if (arrowkeys) this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
            $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
            this.setupInputEvents(hoursInputEl, minutesInputEl);
        };
        var hourStep = timepickerConfig.hourStep;
        if ($attrs.hourStep) $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
            hourStep = parseInt(value, 10);
        });
        var minuteStep = timepickerConfig.minuteStep;
        if ($attrs.minuteStep) $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
            minuteStep = parseInt(value, 10);
        });
        var min;
        $scope.$parent.$watch($parse($attrs.min), function(value) {
            var dt = new Date(value);
            min = isNaN(dt) ? undefined : dt;
        });
        var max;
        $scope.$parent.$watch($parse($attrs.max), function(value) {
            var dt = new Date(value);
            max = isNaN(dt) ? undefined : dt;
        });
        $scope.noIncrementHours = function() {
            var incrementedSelected = addMinutes(selected, hourStep * 60);
            return incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
        };
        $scope.noDecrementHours = function() {
            var decrementedSelected = addMinutes(selected, -hourStep * 60);
            return decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
        };
        $scope.noIncrementMinutes = function() {
            var incrementedSelected = addMinutes(selected, minuteStep);
            return incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
        };
        $scope.noDecrementMinutes = function() {
            var decrementedSelected = addMinutes(selected, -minuteStep);
            return decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
        };
        $scope.noToggleMeridian = function() {
            if (selected.getHours() < 13) return addMinutes(selected, 720) > max;
            else return addMinutes(selected, -720) < min;
        };
        // 12H / 24H mode
        $scope.showMeridian = timepickerConfig.showMeridian;
        if ($attrs.showMeridian) $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
            $scope.showMeridian = !!value;
            if (ngModelCtrl.$error.time) {
                // Evaluate from template
                var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    refresh();
                }
            } else updateTemplate();
        });
        // Get $scope.hours in 24H mode if valid
        function getHoursFromTemplate() {
            var hours = parseInt($scope.hours, 10);
            var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
            if (!valid) return undefined;
            if ($scope.showMeridian) {
                if (hours === 12) hours = 0;
                if ($scope.meridian === meridians[1]) hours = hours + 12;
            }
            return hours;
        }
        function getMinutesFromTemplate() {
            var minutes = parseInt($scope.minutes, 10);
            return minutes >= 0 && minutes < 60 ? minutes : undefined;
        }
        function pad(value) {
            return angular.isDefined(value) && value.toString().length < 2 ? "0" + value : value.toString();
        }
        // Respond on mousewheel spin
        this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl) {
            var isScrollingUp = function(e) {
                if (e.originalEvent) e = e.originalEvent;
                //pick correct delta variable depending on event
                var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                return e.detail || delta > 0;
            };
            hoursInputEl.bind("mousewheel wheel", function(e) {
                $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
                e.preventDefault();
            });
            minutesInputEl.bind("mousewheel wheel", function(e) {
                $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
                e.preventDefault();
            });
        };
        // Respond on up/down arrowkeys
        this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl) {
            hoursInputEl.bind("keydown", function(e) {
                if (e.which === 38) {
                    e.preventDefault();
                    $scope.incrementHours();
                    $scope.$apply();
                } else if (e.which === 40) {
                    e.preventDefault();
                    $scope.decrementHours();
                    $scope.$apply();
                }
            });
            minutesInputEl.bind("keydown", function(e) {
                if (e.which === 38) {
                    e.preventDefault();
                    $scope.incrementMinutes();
                    $scope.$apply();
                } else if (e.which === 40) {
                    e.preventDefault();
                    $scope.decrementMinutes();
                    $scope.$apply();
                }
            });
        };
        this.setupInputEvents = function(hoursInputEl, minutesInputEl) {
            if ($scope.readonlyInput) {
                $scope.updateHours = angular.noop;
                $scope.updateMinutes = angular.noop;
                return;
            }
            var invalidate = function(invalidHours, invalidMinutes) {
                ngModelCtrl.$setViewValue(null);
                ngModelCtrl.$setValidity("time", false);
                if (angular.isDefined(invalidHours)) $scope.invalidHours = invalidHours;
                if (angular.isDefined(invalidMinutes)) $scope.invalidMinutes = invalidMinutes;
            };
            $scope.updateHours = function() {
                var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    if (selected < min || selected > max) invalidate(true);
                    else refresh("h");
                } else invalidate(true);
            };
            hoursInputEl.bind("blur", function(e) {
                if (!$scope.invalidHours && $scope.hours < 10) $scope.$apply(function() {
                    $scope.hours = pad($scope.hours);
                });
            });
            $scope.updateMinutes = function() {
                var minutes = getMinutesFromTemplate(), hours = getHoursFromTemplate();
                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) invalidate(undefined, true);
                    else refresh("m");
                } else invalidate(undefined, true);
            };
            minutesInputEl.bind("blur", function(e) {
                if (!$scope.invalidMinutes && $scope.minutes < 10) $scope.$apply(function() {
                    $scope.minutes = pad($scope.minutes);
                });
            });
        };
        this.render = function() {
            var date = ngModelCtrl.$viewValue;
            if (isNaN(date)) {
                ngModelCtrl.$setValidity("time", false);
                $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            } else {
                if (date) selected = date;
                if (selected < min || selected > max) {
                    ngModelCtrl.$setValidity("time", false);
                    $scope.invalidHours = true;
                    $scope.invalidMinutes = true;
                } else makeValid();
                updateTemplate();
            }
        };
        // Call internally when we know that model is valid.
        function refresh(keyboardChange) {
            makeValid();
            ngModelCtrl.$setViewValue(new Date(selected));
            updateTemplate(keyboardChange);
        }
        function makeValid() {
            ngModelCtrl.$setValidity("time", true);
            $scope.invalidHours = false;
            $scope.invalidMinutes = false;
        }
        function updateTemplate(keyboardChange) {
            var hours = selected.getHours(), minutes = selected.getMinutes();
            if ($scope.showMeridian) hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
            $scope.hours = keyboardChange === "h" ? hours : pad(hours);
            if (keyboardChange !== "m") $scope.minutes = pad(minutes);
            $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
        }
        function addMinutes(date, minutes) {
            var dt = new Date(date.getTime() + minutes * 60000);
            var newDate = new Date(date);
            newDate.setHours(dt.getHours(), dt.getMinutes());
            return newDate;
        }
        function addMinutesToSelected(minutes) {
            selected = addMinutes(selected, minutes);
            refresh();
        }
        $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
        $scope.incrementHours = function() {
            if (!$scope.noIncrementHours()) addMinutesToSelected(hourStep * 60);
        };
        $scope.decrementHours = function() {
            if (!$scope.noDecrementHours()) addMinutesToSelected(-hourStep * 60);
        };
        $scope.incrementMinutes = function() {
            if (!$scope.noIncrementMinutes()) addMinutesToSelected(minuteStep);
        };
        $scope.decrementMinutes = function() {
            if (!$scope.noDecrementMinutes()) addMinutesToSelected(-minuteStep);
        };
        $scope.toggleMeridian = function() {
            if (!$scope.noToggleMeridian()) addMinutesToSelected(720 * (selected.getHours() < 12 ? 1 : -1));
        };
    }
]).directive("uibTimepicker", function() {
    return {
        restrict: "EA",
        require: [
            "uibTimepicker",
            "?^ngModel"
        ],
        controller: "UibTimepickerController",
        controllerAs: "timepicker",
        replace: true,
        scope: {},
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || "template/timepicker/timepicker.html";
        },
        link: function(scope, element, attrs, ctrls) {
            var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            if (ngModelCtrl) timepickerCtrl.init(ngModelCtrl, element.find("input"));
        }
    };
});
/* Deprecated timepicker below */ angular.module("ui.bootstrap.timepicker").value("$timepickerSuppressWarning", false).controller("TimepickerController", [
    "$scope",
    "$element",
    "$attrs",
    "$controller",
    "$log",
    "$timepickerSuppressWarning",
    function($scope, $element, $attrs, $controller, $log, $timepickerSuppressWarning) {
        if (!$timepickerSuppressWarning) $log.warn("TimepickerController is now deprecated. Use UibTimepickerController instead.");
        angular.extend(this, $controller("UibTimepickerController", {
            $scope: $scope,
            $element: $element,
            $attrs: $attrs
        }));
    }
]).directive("timepicker", [
    "$log",
    "$timepickerSuppressWarning",
    function($log, $timepickerSuppressWarning) {
        return {
            restrict: "EA",
            require: [
                "timepicker",
                "?^ngModel"
            ],
            controller: "TimepickerController",
            controllerAs: "timepicker",
            replace: true,
            scope: {},
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || "template/timepicker/timepicker.html";
            },
            link: function(scope, element, attrs, ctrls) {
                if (!$timepickerSuppressWarning) $log.warn("timepicker is now deprecated. Use uib-timepicker instead.");
                var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                if (ngModelCtrl) timepickerCtrl.init(ngModelCtrl, element.find("input"));
            }
        };
    }
]);
angular.module("ui.bootstrap.typeahead", [
    "ui.bootstrap.position"
])/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */ .factory("uibTypeaheadParser", [
    "$parse",
    function($parse) {
        //                      00000111000000000000022200000000000000003333333333333330000000000044000
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        return {
            parse: function(input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "' + input + '".');
                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    }
]).controller("UibTypeaheadController", [
    "$scope",
    "$element",
    "$attrs",
    "$compile",
    "$parse",
    "$q",
    "$timeout",
    "$document",
    "$window",
    "$rootScope",
    "$uibPosition",
    "uibTypeaheadParser",
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
        var HOT_KEYS = [
            9,
            13,
            27,
            38,
            40
        ];
        var eventDebounceTime = 200;
        var modelCtrl, ngModelOptions;
        //SUPPORTED ATTRIBUTES (OPTIONS)
        //minimal no of characters that needs to be entered before typeahead kicks-in
        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
        if (!minLength && minLength !== 0) minLength = 1;
        //minimal wait time after last character typed before typeahead kicks-in
        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
        //should it restrict model values to the ones selected from the popup only?
        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
        //binding to a variable that indicates if matches are being retrieved asynchronously
        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
        //a callback executed when a match is selected
        var onSelectCallback = $parse(attrs.typeaheadOnSelect);
        //should it select highlighted popup value when losing focus?
        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
        //binding to a variable that indicates if there were no results after the query is completed
        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
        var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
        var appendToElementId = attrs.typeaheadAppendToElementId || false;
        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
        //If input matches an item of the list exactly, select it automatically
        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
        //INTERNAL VARIABLES
        //model setter executed upon match selection
        var parsedModel = $parse(attrs.ngModel);
        var invokeModelSetter = $parse(attrs.ngModel + "($$$p)");
        var $setModelValue = function(scope, newValue) {
            if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) return invokeModelSetter(scope, {
                $$$p: newValue
            });
            else return parsedModel.assign(scope, newValue);
        };
        //expressions used by typeahead
        var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
        var hasFocus;
        //Used to avoid bug in iOS webview where iOS keyboard does not fire
        //mousedown & mouseup events
        //Issue #3699
        var selected;
        //create a child scope for the typeahead directive so we are not polluting original scope
        //with typeahead-specific data (matches, query etc.)
        var scope = originalScope.$new();
        var offDestroy = originalScope.$on("$destroy", function() {
            scope.$destroy();
        });
        scope.$on("$destroy", offDestroy);
        // WAI-ARIA
        var popupId = "typeahead-" + scope.$id + "-" + Math.floor(Math.random() * 10000);
        element.attr({
            "aria-autocomplete": "list",
            "aria-expanded": false,
            "aria-owns": popupId
        });
        //pop-up element used to display matches
        var popUpEl = angular.element("<div uib-typeahead-popup></div>");
        popUpEl.attr({
            id: popupId,
            matches: "matches",
            active: "activeIdx",
            select: "select(activeIdx)",
            "move-in-progress": "moveInProgress",
            query: "query",
            position: "position"
        });
        //custom item template
        if (angular.isDefined(attrs.typeaheadTemplateUrl)) popUpEl.attr("template-url", attrs.typeaheadTemplateUrl);
        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) popUpEl.attr("popup-template-url", attrs.typeaheadPopupTemplateUrl);
        var resetMatches = function() {
            scope.matches = [];
            scope.activeIdx = -1;
            element.attr("aria-expanded", false);
        };
        var getMatchId = function(index) {
            return popupId + "-option-" + index;
        };
        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
        // This attribute is added or removed automatically when the `activeIdx` changes.
        scope.$watch("activeIdx", function(index) {
            if (index < 0) element.removeAttr("aria-activedescendant");
            else element.attr("aria-activedescendant", getMatchId(index));
        });
        var inputIsExactMatch = function(inputValue, index) {
            if (scope.matches.length > index && inputValue) return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
            return false;
        };
        var getMatchesAsync = function(inputValue) {
            var locals = {
                $viewValue: inputValue
            };
            isLoadingSetter(originalScope, true);
            isNoResultsSetter(originalScope, false);
            $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
                //it might happen that several async queries were in progress if a user were typing fast
                //but we are interested only in responses that correspond to the current view value
                var onCurrentRequest = inputValue === modelCtrl.$viewValue;
                if (onCurrentRequest && hasFocus) {
                    if (matches && matches.length > 0) {
                        scope.activeIdx = focusFirst ? 0 : -1;
                        isNoResultsSetter(originalScope, false);
                        scope.matches.length = 0;
                        //transform labels
                        for(var i = 0; i < matches.length; i++){
                            locals[parserResult.itemName] = matches[i];
                            scope.matches.push({
                                id: getMatchId(i),
                                label: parserResult.viewMapper(scope, locals),
                                model: matches[i]
                            });
                        }
                        scope.query = inputValue;
                        //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                        //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                        //due to other elements being rendered
                        recalculatePosition();
                        element.attr("aria-expanded", true);
                        //Select the single remaining option if user input matches
                        if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) scope.select(0);
                    } else {
                        resetMatches();
                        isNoResultsSetter(originalScope, true);
                    }
                }
                if (onCurrentRequest) isLoadingSetter(originalScope, false);
            }, function() {
                resetMatches();
                isLoadingSetter(originalScope, false);
                isNoResultsSetter(originalScope, true);
            });
        };
        // bind events only if appendToBody params exist - performance feature
        if (appendToBody) {
            angular.element($window).bind("resize", fireRecalculating);
            $document.find("body").bind("scroll", fireRecalculating);
        }
        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutEventPromise;
        // Default progress type
        scope.moveInProgress = false;
        function fireRecalculating() {
            if (!scope.moveInProgress) {
                scope.moveInProgress = true;
                scope.$digest();
            }
            // Cancel previous timeout
            if (timeoutEventPromise) $timeout.cancel(timeoutEventPromise);
            // Debounced executing recalculate after events fired
            timeoutEventPromise = $timeout(function() {
                // if popup is visible
                if (scope.matches.length) recalculatePosition();
                scope.moveInProgress = false;
            }, eventDebounceTime);
        }
        // recalculate actual position and set new values to scope
        // after digest loop is popup in right position
        function recalculatePosition() {
            scope.position = appendToBody ? $position.offset(element) : $position.position(element);
            scope.position.top += element.prop("offsetHeight");
        }
        //we need to propagate user's query so we can higlight matches
        scope.query = undefined;
        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutPromise;
        var scheduleSearchWithTimeout = function(inputValue) {
            timeoutPromise = $timeout(function() {
                getMatchesAsync(inputValue);
            }, waitTime);
        };
        var cancelPreviousTimeout = function() {
            if (timeoutPromise) $timeout.cancel(timeoutPromise);
        };
        resetMatches();
        scope.select = function(activeIdx) {
            //called from within the $digest() cycle
            var locals = {};
            var model, item;
            selected = true;
            locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
            model = parserResult.modelMapper(originalScope, locals);
            $setModelValue(originalScope, model);
            modelCtrl.$setValidity("editable", true);
            modelCtrl.$setValidity("parse", true);
            onSelectCallback(originalScope, {
                $item: item,
                $model: model,
                $label: parserResult.viewMapper(originalScope, locals)
            });
            resetMatches();
            //return focus to the input element if a match was selected via a mouse click event
            // use timeout to avoid $rootScope:inprog error
            if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) $timeout(function() {
                element[0].focus();
            }, 0, false);
        };
        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
        element.bind("keydown", function(evt) {
            //typeahead is open and an "interesting" key was pressed
            if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) return;
            // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
            if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
                resetMatches();
                scope.$digest();
                return;
            }
            evt.preventDefault();
            if (evt.which === 40) {
                scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                scope.$digest();
            } else if (evt.which === 38) {
                scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                scope.$digest();
            } else if (evt.which === 13 || evt.which === 9) scope.$apply(function() {
                scope.select(scope.activeIdx);
            });
            else if (evt.which === 27) {
                evt.stopPropagation();
                resetMatches();
                scope.$digest();
            }
        });
        element.bind("blur", function() {
            if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
                selected = true;
                scope.$apply(function() {
                    scope.select(scope.activeIdx);
                });
            }
            hasFocus = false;
            selected = false;
        });
        // Keep reference to click handler to unbind it.
        var dismissClickHandler = function(evt) {
            // Issue #3973
            // Firefox treats right click as a click on document
            if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
                resetMatches();
                if (!$rootScope.$$phase) scope.$digest();
            }
        };
        $document.bind("click", dismissClickHandler);
        originalScope.$on("$destroy", function() {
            $document.unbind("click", dismissClickHandler);
            if (appendToBody || appendToElementId) $popup.remove();
            if (appendToBody) {
                angular.element($window).unbind("resize", fireRecalculating);
                $document.find("body").unbind("scroll", fireRecalculating);
            }
            // Prevent jQuery cache memory leak
            popUpEl.remove();
        });
        var $popup = $compile(popUpEl)(scope);
        if (appendToBody) $document.find("body").append($popup);
        else if (appendToElementId !== false) angular.element($document[0].getElementById(appendToElementId)).append($popup);
        else element.after($popup);
        this.init = function(_modelCtrl, _ngModelOptions) {
            modelCtrl = _modelCtrl;
            ngModelOptions = _ngModelOptions;
            //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
            //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
            modelCtrl.$parsers.unshift(function(inputValue) {
                hasFocus = true;
                if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                    if (waitTime > 0) {
                        cancelPreviousTimeout();
                        scheduleSearchWithTimeout(inputValue);
                    } else getMatchesAsync(inputValue);
                } else {
                    isLoadingSetter(originalScope, false);
                    cancelPreviousTimeout();
                    resetMatches();
                }
                if (isEditable) return inputValue;
                else if (!inputValue) {
                    // Reset in case user had typed something previously.
                    modelCtrl.$setValidity("editable", true);
                    return null;
                } else {
                    modelCtrl.$setValidity("editable", false);
                    return undefined;
                }
            });
            modelCtrl.$formatters.push(function(modelValue) {
                var candidateViewValue, emptyViewValue;
                var locals = {};
                // The validity may be set to false via $parsers (see above) if
                // the model is restricted to selected values. If the model
                // is set manually it is considered to be valid.
                if (!isEditable) modelCtrl.$setValidity("editable", true);
                if (inputFormatter) {
                    locals.$model = modelValue;
                    return inputFormatter(originalScope, locals);
                } else {
                    //it might happen that we don't have enough info to properly render input value
                    //we need to check for this situation and simply return model value if we can't apply custom formatting
                    locals[parserResult.itemName] = modelValue;
                    candidateViewValue = parserResult.viewMapper(originalScope, locals);
                    locals[parserResult.itemName] = undefined;
                    emptyViewValue = parserResult.viewMapper(originalScope, locals);
                    return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                }
            });
        };
    }
]).directive("uibTypeahead", function() {
    return {
        controller: "UibTypeaheadController",
        require: [
            "ngModel",
            "^?ngModelOptions",
            "uibTypeahead"
        ],
        link: function(originalScope, element, attrs, ctrls) {
            ctrls[2].init(ctrls[0], ctrls[1]);
        }
    };
}).directive("uibTypeaheadPopup", function() {
    return {
        scope: {
            matches: "=",
            query: "=",
            active: "=",
            position: "&",
            moveInProgress: "=",
            select: "&"
        },
        replace: true,
        templateUrl: function(element, attrs) {
            return attrs.popupTemplateUrl || "template/typeahead/typeahead-popup.html";
        },
        link: function(scope, element, attrs) {
            scope.templateUrl = attrs.templateUrl;
            scope.isOpen = function() {
                return scope.matches.length > 0;
            };
            scope.isActive = function(matchIdx) {
                return scope.active == matchIdx;
            };
            scope.selectActive = function(matchIdx) {
                scope.active = matchIdx;
            };
            scope.selectMatch = function(activeIdx) {
                scope.select({
                    activeIdx: activeIdx
                });
            };
        }
    };
}).directive("uibTypeaheadMatch", [
    "$templateRequest",
    "$compile",
    "$parse",
    function($templateRequest, $compile, $parse) {
        return {
            scope: {
                index: "=",
                match: "=",
                query: "="
            },
            link: function(scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || "template/typeahead/typeahead-match.html";
                $templateRequest(tplUrl).then(function(tplContent) {
                    $compile(tplContent.trim())(scope, function(clonedElement) {
                        element.replaceWith(clonedElement);
                    });
                });
            }
        };
    }
]).filter("uibTypeaheadHighlight", [
    "$sce",
    "$injector",
    "$log",
    function($sce, $injector, $log) {
        var isSanitizePresent;
        isSanitizePresent = $injector.has("$sanitize");
        function escapeRegexp(queryToEscape) {
            // Regex: capture the whole query string and replace it with the string that will be used to match
            // the results, for example if the capture is "a" the result will be \a
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        }
        function containsHtml(matchItem) {
            return /<.*>/g.test(matchItem);
        }
        return function(matchItem, query) {
            if (!isSanitizePresent && containsHtml(matchItem)) $log.warn("Unsafe use of typeahead please use ngSanitize"); // Warn the user about the danger
            matchItem = query ? ("" + matchItem).replace(new RegExp(escapeRegexp(query), "gi"), "<strong>$&</strong>") : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
            if (!isSanitizePresent) matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
            return matchItem;
        };
    }
]);
/* Deprecated typeahead below */ angular.module("ui.bootstrap.typeahead").value("$typeaheadSuppressWarning", false).service("typeaheadParser", [
    "$parse",
    "uibTypeaheadParser",
    "$log",
    "$typeaheadSuppressWarning",
    function($parse, uibTypeaheadParser, $log, $typeaheadSuppressWarning) {
        if (!$typeaheadSuppressWarning) $log.warn("typeaheadParser is now deprecated. Use uibTypeaheadParser instead.");
        return uibTypeaheadParser;
    }
]).directive("typeahead", [
    "$compile",
    "$parse",
    "$q",
    "$timeout",
    "$document",
    "$window",
    "$rootScope",
    "$uibPosition",
    "typeaheadParser",
    "$log",
    "$typeaheadSuppressWarning",
    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser, $log, $typeaheadSuppressWarning) {
        var HOT_KEYS = [
            9,
            13,
            27,
            38,
            40
        ];
        var eventDebounceTime = 200;
        return {
            require: [
                "ngModel",
                "^?ngModelOptions"
            ],
            link: function(originalScope, element, attrs, ctrls) {
                if (!$typeaheadSuppressWarning) $log.warn("typeahead is now deprecated. Use uib-typeahead instead.");
                var modelCtrl = ctrls[0];
                var ngModelOptions = ctrls[1];
                //SUPPORTED ATTRIBUTES (OPTIONS)
                //minimal no of characters that needs to be entered before typeahead kicks-in
                var minLength = originalScope.$eval(attrs.typeaheadMinLength);
                if (!minLength && minLength !== 0) minLength = 1;
                //minimal wait time after last character typed before typeahead kicks-in
                var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
                //should it restrict model values to the ones selected from the popup only?
                var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
                //binding to a variable that indicates if matches are being retrieved asynchronously
                var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
                //a callback executed when a match is selected
                var onSelectCallback = $parse(attrs.typeaheadOnSelect);
                //should it select highlighted popup value when losing focus?
                var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
                //binding to a variable that indicates if there were no results after the query is completed
                var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
                var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
                var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
                var appendToElementId = attrs.typeaheadAppendToElementId || false;
                var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
                //If input matches an item of the list exactly, select it automatically
                var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
                //INTERNAL VARIABLES
                //model setter executed upon match selection
                var parsedModel = $parse(attrs.ngModel);
                var invokeModelSetter = $parse(attrs.ngModel + "($$$p)");
                var $setModelValue = function(scope, newValue) {
                    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) return invokeModelSetter(scope, {
                        $$$p: newValue
                    });
                    else return parsedModel.assign(scope, newValue);
                };
                //expressions used by typeahead
                var parserResult = typeaheadParser.parse(attrs.typeahead);
                var hasFocus;
                //Used to avoid bug in iOS webview where iOS keyboard does not fire
                //mousedown & mouseup events
                //Issue #3699
                var selected;
                //create a child scope for the typeahead directive so we are not polluting original scope
                //with typeahead-specific data (matches, query etc.)
                var scope = originalScope.$new();
                var offDestroy = originalScope.$on("$destroy", function() {
                    scope.$destroy();
                });
                scope.$on("$destroy", offDestroy);
                // WAI-ARIA
                var popupId = "typeahead-" + scope.$id + "-" + Math.floor(Math.random() * 10000);
                element.attr({
                    "aria-autocomplete": "list",
                    "aria-expanded": false,
                    "aria-owns": popupId
                });
                //pop-up element used to display matches
                var popUpEl = angular.element("<div typeahead-popup></div>");
                popUpEl.attr({
                    id: popupId,
                    matches: "matches",
                    active: "activeIdx",
                    select: "select(activeIdx)",
                    "move-in-progress": "moveInProgress",
                    query: "query",
                    position: "position"
                });
                //custom item template
                if (angular.isDefined(attrs.typeaheadTemplateUrl)) popUpEl.attr("template-url", attrs.typeaheadTemplateUrl);
                if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) popUpEl.attr("popup-template-url", attrs.typeaheadPopupTemplateUrl);
                var resetMatches = function() {
                    scope.matches = [];
                    scope.activeIdx = -1;
                    element.attr("aria-expanded", false);
                };
                var getMatchId = function(index) {
                    return popupId + "-option-" + index;
                };
                // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
                // This attribute is added or removed automatically when the `activeIdx` changes.
                scope.$watch("activeIdx", function(index) {
                    if (index < 0) element.removeAttr("aria-activedescendant");
                    else element.attr("aria-activedescendant", getMatchId(index));
                });
                var inputIsExactMatch = function(inputValue, index) {
                    if (scope.matches.length > index && inputValue) return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
                    return false;
                };
                var getMatchesAsync = function(inputValue) {
                    var locals = {
                        $viewValue: inputValue
                    };
                    isLoadingSetter(originalScope, true);
                    isNoResultsSetter(originalScope, false);
                    $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
                        //it might happen that several async queries were in progress if a user were typing fast
                        //but we are interested only in responses that correspond to the current view value
                        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
                        if (onCurrentRequest && hasFocus) {
                            if (matches && matches.length > 0) {
                                scope.activeIdx = focusFirst ? 0 : -1;
                                isNoResultsSetter(originalScope, false);
                                scope.matches.length = 0;
                                //transform labels
                                for(var i = 0; i < matches.length; i++){
                                    locals[parserResult.itemName] = matches[i];
                                    scope.matches.push({
                                        id: getMatchId(i),
                                        label: parserResult.viewMapper(scope, locals),
                                        model: matches[i]
                                    });
                                }
                                scope.query = inputValue;
                                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                                //due to other elements being rendered
                                recalculatePosition();
                                element.attr("aria-expanded", true);
                                //Select the single remaining option if user input matches
                                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) scope.select(0);
                            } else {
                                resetMatches();
                                isNoResultsSetter(originalScope, true);
                            }
                        }
                        if (onCurrentRequest) isLoadingSetter(originalScope, false);
                    }, function() {
                        resetMatches();
                        isLoadingSetter(originalScope, false);
                        isNoResultsSetter(originalScope, true);
                    });
                };
                // bind events only if appendToBody params exist - performance feature
                if (appendToBody) {
                    angular.element($window).bind("resize", fireRecalculating);
                    $document.find("body").bind("scroll", fireRecalculating);
                }
                // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
                var timeoutEventPromise;
                // Default progress type
                scope.moveInProgress = false;
                function fireRecalculating() {
                    if (!scope.moveInProgress) {
                        scope.moveInProgress = true;
                        scope.$digest();
                    }
                    // Cancel previous timeout
                    if (timeoutEventPromise) $timeout.cancel(timeoutEventPromise);
                    // Debounced executing recalculate after events fired
                    timeoutEventPromise = $timeout(function() {
                        // if popup is visible
                        if (scope.matches.length) recalculatePosition();
                        scope.moveInProgress = false;
                    }, eventDebounceTime);
                }
                // recalculate actual position and set new values to scope
                // after digest loop is popup in right position
                function recalculatePosition() {
                    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                    scope.position.top += element.prop("offsetHeight");
                }
                resetMatches();
                //we need to propagate user's query so we can higlight matches
                scope.query = undefined;
                //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
                var timeoutPromise;
                var scheduleSearchWithTimeout = function(inputValue) {
                    timeoutPromise = $timeout(function() {
                        getMatchesAsync(inputValue);
                    }, waitTime);
                };
                var cancelPreviousTimeout = function() {
                    if (timeoutPromise) $timeout.cancel(timeoutPromise);
                };
                //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                modelCtrl.$parsers.unshift(function(inputValue) {
                    hasFocus = true;
                    if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                        if (waitTime > 0) {
                            cancelPreviousTimeout();
                            scheduleSearchWithTimeout(inputValue);
                        } else getMatchesAsync(inputValue);
                    } else {
                        isLoadingSetter(originalScope, false);
                        cancelPreviousTimeout();
                        resetMatches();
                    }
                    if (isEditable) return inputValue;
                    else if (!inputValue) {
                        // Reset in case user had typed something previously.
                        modelCtrl.$setValidity("editable", true);
                        return null;
                    } else {
                        modelCtrl.$setValidity("editable", false);
                        return undefined;
                    }
                });
                modelCtrl.$formatters.push(function(modelValue) {
                    var candidateViewValue, emptyViewValue;
                    var locals = {};
                    // The validity may be set to false via $parsers (see above) if
                    // the model is restricted to selected values. If the model
                    // is set manually it is considered to be valid.
                    if (!isEditable) modelCtrl.$setValidity("editable", true);
                    if (inputFormatter) {
                        locals.$model = modelValue;
                        return inputFormatter(originalScope, locals);
                    } else {
                        //it might happen that we don't have enough info to properly render input value
                        //we need to check for this situation and simply return model value if we can't apply custom formatting
                        locals[parserResult.itemName] = modelValue;
                        candidateViewValue = parserResult.viewMapper(originalScope, locals);
                        locals[parserResult.itemName] = undefined;
                        emptyViewValue = parserResult.viewMapper(originalScope, locals);
                        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                    }
                });
                scope.select = function(activeIdx) {
                    //called from within the $digest() cycle
                    var locals = {};
                    var model, item;
                    selected = true;
                    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                    model = parserResult.modelMapper(originalScope, locals);
                    $setModelValue(originalScope, model);
                    modelCtrl.$setValidity("editable", true);
                    modelCtrl.$setValidity("parse", true);
                    onSelectCallback(originalScope, {
                        $item: item,
                        $model: model,
                        $label: parserResult.viewMapper(originalScope, locals)
                    });
                    resetMatches();
                    //return focus to the input element if a match was selected via a mouse click event
                    // use timeout to avoid $rootScope:inprog error
                    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) $timeout(function() {
                        element[0].focus();
                    }, 0, false);
                };
                //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                element.bind("keydown", function(evt) {
                    //typeahead is open and an "interesting" key was pressed
                    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) return;
                    // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
                    if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
                        resetMatches();
                        scope.$digest();
                        return;
                    }
                    evt.preventDefault();
                    if (evt.which === 40) {
                        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                        scope.$digest();
                    } else if (evt.which === 38) {
                        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                        scope.$digest();
                    } else if (evt.which === 13 || evt.which === 9) scope.$apply(function() {
                        scope.select(scope.activeIdx);
                    });
                    else if (evt.which === 27) {
                        evt.stopPropagation();
                        resetMatches();
                        scope.$digest();
                    }
                });
                element.bind("blur", function() {
                    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
                        selected = true;
                        scope.$apply(function() {
                            scope.select(scope.activeIdx);
                        });
                    }
                    hasFocus = false;
                    selected = false;
                });
                // Keep reference to click handler to unbind it.
                var dismissClickHandler = function(evt) {
                    // Issue #3973
                    // Firefox treats right click as a click on document
                    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
                        resetMatches();
                        if (!$rootScope.$$phase) scope.$digest();
                    }
                };
                $document.bind("click", dismissClickHandler);
                originalScope.$on("$destroy", function() {
                    $document.unbind("click", dismissClickHandler);
                    if (appendToBody || appendToElementId) $popup.remove();
                    if (appendToBody) {
                        angular.element($window).unbind("resize", fireRecalculating);
                        $document.find("body").unbind("scroll", fireRecalculating);
                    }
                    // Prevent jQuery cache memory leak
                    popUpEl.remove();
                });
                var $popup = $compile(popUpEl)(scope);
                if (appendToBody) $document.find("body").append($popup);
                else if (appendToElementId !== false) angular.element($document[0].getElementById(appendToElementId)).append($popup);
                else element.after($popup);
            }
        };
    }
]).directive("typeaheadPopup", [
    "$typeaheadSuppressWarning",
    "$log",
    function($typeaheadSuppressWarning, $log) {
        return {
            scope: {
                matches: "=",
                query: "=",
                active: "=",
                position: "&",
                moveInProgress: "=",
                select: "&"
            },
            replace: true,
            templateUrl: function(element, attrs) {
                return attrs.popupTemplateUrl || "template/typeahead/typeahead-popup.html";
            },
            link: function(scope, element, attrs) {
                if (!$typeaheadSuppressWarning) $log.warn("typeahead-popup is now deprecated. Use uib-typeahead-popup instead.");
                scope.templateUrl = attrs.templateUrl;
                scope.isOpen = function() {
                    return scope.matches.length > 0;
                };
                scope.isActive = function(matchIdx) {
                    return scope.active == matchIdx;
                };
                scope.selectActive = function(matchIdx) {
                    scope.active = matchIdx;
                };
                scope.selectMatch = function(activeIdx) {
                    scope.select({
                        activeIdx: activeIdx
                    });
                };
            }
        };
    }
]).directive("typeaheadMatch", [
    "$templateRequest",
    "$compile",
    "$parse",
    "$typeaheadSuppressWarning",
    "$log",
    function($templateRequest, $compile, $parse, $typeaheadSuppressWarning, $log) {
        return {
            restrict: "EA",
            scope: {
                index: "=",
                match: "=",
                query: "="
            },
            link: function(scope, element, attrs) {
                if (!$typeaheadSuppressWarning) $log.warn("typeahead-match is now deprecated. Use uib-typeahead-match instead.");
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || "template/typeahead/typeahead-match.html";
                $templateRequest(tplUrl).then(function(tplContent) {
                    $compile(tplContent.trim())(scope, function(clonedElement) {
                        element.replaceWith(clonedElement);
                    });
                });
            }
        };
    }
]).filter("typeaheadHighlight", [
    "$sce",
    "$injector",
    "$log",
    "$typeaheadSuppressWarning",
    function($sce, $injector, $log, $typeaheadSuppressWarning) {
        var isSanitizePresent;
        isSanitizePresent = $injector.has("$sanitize");
        function escapeRegexp(queryToEscape) {
            // Regex: capture the whole query string and replace it with the string that will be used to match
            // the results, for example if the capture is "a" the result will be \a
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        }
        function containsHtml(matchItem) {
            return /<.*>/g.test(matchItem);
        }
        return function(matchItem, query) {
            if (!$typeaheadSuppressWarning) $log.warn("typeaheadHighlight is now deprecated. Use uibTypeaheadHighlight instead.");
            if (!isSanitizePresent && containsHtml(matchItem)) $log.warn("Unsafe use of typeahead please use ngSanitize"); // Warn the user about the danger
            matchItem = query ? ("" + matchItem).replace(new RegExp(escapeRegexp(query), "gi"), "<strong>$&</strong>") : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
            if (!isSanitizePresent) matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
            return matchItem;
        };
    }
]);
angular.module("template/accordion/accordion-group.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/accordion/accordion-group.html", '<div class="panel {{panelClass || \'panel-default\'}}">\n  <div class="panel-heading" ng-keypress="toggleOpen($event)">\n    <h4 class="panel-title">\n      <a href tabindex="0" class="accordion-toggle" ng-click="toggleOpen()" uib-accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div class="panel-collapse collapse" uib-collapse="!isOpen">\n	  <div class="panel-body" ng-transclude></div>\n  </div>\n</div>\n');
    }
]);
angular.module("template/accordion/accordion.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/accordion/accordion.html", '<div class="panel-group" ng-transclude></div>');
    }
]);
angular.module("template/alert/alert.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/alert/alert.html", '<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissible\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close({$event: $event})">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n');
    }
]);
angular.module("template/carousel/carousel.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/carousel/carousel.html", '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n  <div class="carousel-inner" ng-transclude></div>\n  <a role="button" href class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>\n    <span class="sr-only">previous</span>\n  </a>\n  <a role="button" href class="right carousel-control" ng-click="next()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>\n    <span class="sr-only">next</span>\n  </a>\n  <ol class="carousel-indicators" ng-show="slides.length > 1">\n    <li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)">\n      <span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span>\n    </li>\n  </ol>\n</div>');
    }
]);
angular.module("template/carousel/slide.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/carousel/slide.html", '<div ng-class="{\n    \'active\': active\n  }" class="item text-center" ng-transclude></div>\n');
    }
]);
angular.module("template/datepicker/datepicker.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/datepicker/datepicker.html", '<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <uib-daypicker ng-switch-when="day" tabindex="0"></uib-daypicker>\n  <uib-monthpicker ng-switch-when="month" tabindex="0"></uib-monthpicker>\n  <uib-yearpicker ng-switch-when="year" tabindex="0"></uib-yearpicker>\n</div>');
    }
]);
angular.module("template/datepicker/day.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/datepicker/day.html", '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
    }
]);
angular.module("template/datepicker/month.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/datepicker/month.html", '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
    }
]);
angular.module("template/datepicker/popup.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/datepicker/popup.html", '<ul class="dropdown-menu" dropdown-nested ng-if="isOpen" style="display: block" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n	<li ng-transclude></li>\n	<li ng-if="showButtonBar" style="padding:10px 9px 2px">\n		<span class="btn-group pull-left">\n			<button type="button" class="btn btn-sm btn-info" ng-click="select(\'today\')" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n			<button type="button" class="btn btn-sm btn-danger" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n		</span>\n		<button type="button" class="btn btn-sm btn-success pull-right" ng-click="close()">{{ getText(\'close\') }}</button>\n	</li>\n</ul>\n');
    }
]);
angular.module("template/datepicker/year.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/datepicker/year.html", '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
    }
]);
angular.module("template/modal/backdrop.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/modal/backdrop.html", '<div uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n');
    }
]);
angular.module("template/modal/window.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/modal/window.html", '<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n    uib-modal-animation-class="fade"\n    modal-in-class="in"\n    ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}">\n    <div class="modal-dialog" ng-class="size ? \'modal-\' + size : \'\'"><div class="modal-content" uib-modal-transclude></div></div>\n</div>\n');
    }
]);
angular.module("template/pagination/pager.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/pagination/pager.html", '<ul class="pager">\n  <li ng-class="{disabled: noPrevious()||ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext()||ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>\n');
    }
]);
angular.module("template/pagination/pagination.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/pagination/pagination.html", '<ul class="pagination">\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-first"><a href ng-click="selectPage(1, $event)">{{::getText(\'first\')}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-prev"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}" class="pagination-page"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-next"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-last"><a href ng-click="selectPage(totalPages, $event)">{{::getText(\'last\')}}</a></li>\n</ul>\n');
    }
]);
angular.module("template/tooltip/tooltip-html-popup.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/tooltip/tooltip-html-popup.html", '<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n</div>\n');
    }
]);
angular.module("template/tooltip/tooltip-popup.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/tooltip/tooltip-popup.html", '<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n');
    }
]);
angular.module("template/tooltip/tooltip-template-popup.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/tooltip/tooltip-template-popup.html", '<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner"\n    uib-tooltip-template-transclude="contentExp()"\n    tooltip-template-transclude-scope="originScope()"></div>\n</div>\n');
    }
]);
angular.module("template/popover/popover-html.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/popover/popover-html.html", '<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind-html="contentExp()"></div>\n  </div>\n</div>\n');
    }
]);
angular.module("template/popover/popover-template.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/popover/popover-template.html", '<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content"\n        uib-tooltip-template-transclude="contentExp()"\n        tooltip-template-transclude-scope="originScope()"></div>\n  </div>\n</div>\n');
    }
]);
angular.module("template/popover/popover.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/popover/popover.html", '<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n');
    }
]);
angular.module("template/progressbar/bar.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/progressbar/bar.html", '<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" style="min-width: 0;" ng-transclude></div>\n');
    }
]);
angular.module("template/progressbar/progress.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/progressbar/progress.html", '<div class="progress" ng-transclude aria-labelledby="{{::title}}"></div>');
    }
]);
angular.module("template/progressbar/progressbar.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/progressbar/progressbar.html", '<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" style="min-width: 0;" ng-transclude></div>\n</div>\n');
    }
]);
angular.module("template/rating/rating.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/rating/rating.html", '<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <span ng-repeat-start="r in range track by $index" class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    <i ng-repeat-end ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')" ng-attr-title="{{r.title}}" aria-valuetext="{{r.title}}"></i>\n</span>\n');
    }
]);
angular.module("template/tabs/tab.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/tabs/tab.html", '<li ng-class="{active: active, disabled: disabled}">\n  <a href ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n</li>\n');
    }
]);
angular.module("template/tabs/tabset.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/tabs/tabset.html", '<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         uib-tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n');
    }
]);
angular.module("template/timepicker/timepicker.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/timepicker/timepicker.html", '<table>\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group" ng-class="{\'has-error\': invalidHours}">\n        <input style="width:50px;" type="text" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}">\n      </td>\n      <td>:</td>\n      <td class="form-group" ng-class="{\'has-error\': invalidMinutes}">\n        <input style="width:50px;" type="text" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}">\n      </td>\n      <td ng-show="showMeridian"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n');
    }
]);
angular.module("template/typeahead/typeahead-match.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/typeahead/typeahead-match.html", '<a href tabindex="-1" ng-bind-html="match.label | uibTypeaheadHighlight:query"></a>\n');
    }
]);
angular.module("template/typeahead/typeahead-popup.html", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("template/typeahead/typeahead-popup.html", '<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n');
    }
]);
!angular.$$csp() && angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

},{}],"hxe0Q":[function(require,module,exports) {
/**
 * State-based routing for AngularJS
 * @version v0.4.3
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ /* commonjs package manager support (eg componentjs) */ if (module.exports === exports) module.exports = "ui.router";
(function(window1, angular, undefined) {
    /*jshint globalstrict:true*/ /*global angular:false*/ "use strict";
    var isDefined = angular.isDefined, isFunction = angular.isFunction, isString = angular.isString, isObject = angular.isObject, isArray = angular.isArray, forEach = angular.forEach, extend = angular.extend, copy = angular.copy, toJson = angular.toJson;
    function inherit(parent, extra) {
        return extend(new (extend(function() {}, {
            prototype: parent
        }))(), extra);
    }
    function merge(dst) {
        forEach(arguments, function(obj) {
            if (obj !== dst) forEach(obj, function(value, key) {
                if (!dst.hasOwnProperty(key)) dst[key] = value;
            });
        });
        return dst;
    }
    /**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */ function ancestors(first, second) {
        var path = [];
        for(var n in first.path){
            if (first.path[n] !== second.path[n]) break;
            path.push(first.path[n]);
        }
        return path;
    }
    /**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */ function objectKeys(object) {
        if (Object.keys) return Object.keys(object);
        var result = [];
        forEach(object, function(val, key) {
            result.push(key);
        });
        return result;
    }
    /**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */ function indexOf(array, value) {
        if (Array.prototype.indexOf) return array.indexOf(value, Number(arguments[2]) || 0);
        var len = array.length >>> 0, from = Number(arguments[2]) || 0;
        from = from < 0 ? Math.ceil(from) : Math.floor(from);
        if (from < 0) from += len;
        for(; from < len; from++){
            if (from in array && array[from] === value) return from;
        }
        return -1;
    }
    /**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */ function inheritParams(currentParams, newParams, $current, $to) {
        var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
        for(var i in parents){
            if (!parents[i] || !parents[i].params) continue;
            parentParams = objectKeys(parents[i].params);
            if (!parentParams.length) continue;
            for(var j in parentParams){
                if (indexOf(inheritList, parentParams[j]) >= 0) continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = currentParams[parentParams[j]];
            }
        }
        return extend({}, inherited, newParams);
    }
    /**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */ function equalForKeys(a, b, keys) {
        if (!keys) {
            keys = [];
            for(var n in a)keys.push(n); // Used instead of Object.keys() for IE8 compatibility
        }
        for(var i = 0; i < keys.length; i++){
            var k = keys[i];
            if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
        }
        return true;
    }
    /**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */ function filterByKeys(keys, values) {
        var filtered = {};
        forEach(keys, function(name) {
            filtered[name] = values[name];
        });
        return filtered;
    }
    // like _.indexBy
    // when you know that your index values will be unique, or you want last-one-in to win
    function indexBy(array, propName) {
        var result = {};
        forEach(array, function(item) {
            result[item[propName]] = item;
        });
        return result;
    }
    // extracted from underscore.js
    // Return a copy of the object only containing the whitelisted properties.
    function pick(obj) {
        var copy = {};
        var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
        forEach(keys, function(key) {
            if (key in obj) copy[key] = obj[key];
        });
        return copy;
    }
    // extracted from underscore.js
    // Return a copy of the object omitting the blacklisted properties.
    function omit(obj) {
        var copy = {};
        var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
        for(var key in obj)if (indexOf(keys, key) == -1) copy[key] = obj[key];
        return copy;
    }
    function pluck(collection, key) {
        var result = isArray(collection) ? [] : {};
        forEach(collection, function(val, i) {
            result[i] = isFunction(key) ? key(val) : val[key];
        });
        return result;
    }
    function filter(collection, callback) {
        var array = isArray(collection);
        var result = array ? [] : {};
        forEach(collection, function(val, i) {
            if (callback(val, i)) result[array ? result.length : i] = val;
        });
        return result;
    }
    function map(collection, callback) {
        var result = isArray(collection) ? [] : {};
        forEach(collection, function(val, i) {
            result[i] = callback(val, i);
        });
        return result;
    }
    // issue #2676 #2889
    function silenceUncaughtInPromise(promise) {
        return promise.then(undefined, function() {}) && promise;
    }
    /**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */ angular.module("ui.router.util", [
        "ng"
    ]);
    /**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */ angular.module("ui.router.router", [
        "ui.router.util"
    ]);
    /**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */ angular.module("ui.router.state", [
        "ui.router.router",
        "ui.router.util"
    ]);
    /**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */ angular.module("ui.router", [
        "ui.router.state"
    ]);
    angular.module("ui.router.compat", [
        "ui.router"
    ]);
    /**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */ $Resolve.$inject = [
        "$q",
        "$injector"
    ];
    function $Resolve($q, $injector) {
        var VISIT_IN_PROGRESS = 1, VISIT_DONE = 2, NOTHING = {}, NO_DEPENDENCIES = [], NO_LOCALS = NOTHING, NO_PARENT = extend($q.when(NOTHING), {
            $$promises: NOTHING,
            $$values: NOTHING
        });
        /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */ this.study = function(invocables) {
            if (!isObject(invocables)) throw new Error("'invocables' must be an object");
            var invocableKeys = objectKeys(invocables || {});
            // Perform a topological sort of invocables to build an ordered plan
            var plan = [], cycle = [], visited = {};
            function visit(value, key) {
                if (visited[key] === VISIT_DONE) return;
                cycle.push(key);
                if (visited[key] === VISIT_IN_PROGRESS) {
                    cycle.splice(0, indexOf(cycle, key));
                    throw new Error("Cyclic dependency: " + cycle.join(" -> "));
                }
                visited[key] = VISIT_IN_PROGRESS;
                if (isString(value)) plan.push(key, [
                    function() {
                        return $injector.get(value);
                    }
                ], NO_DEPENDENCIES);
                else {
                    var params = $injector.annotate(value);
                    forEach(params, function(param) {
                        if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
                    });
                    plan.push(key, value, params);
                }
                cycle.pop();
                visited[key] = VISIT_DONE;
            }
            forEach(invocables, visit);
            invocables = cycle = visited = null; // plan is all that's required
            function isResolve(value) {
                return isObject(value) && value.then && value.$$promises;
            }
            return function(locals, parent, self) {
                if (isResolve(locals) && self === undefined) {
                    self = parent;
                    parent = locals;
                    locals = null;
                }
                if (!locals) locals = NO_LOCALS;
                else if (!isObject(locals)) throw new Error("'locals' must be an object");
                if (!parent) parent = NO_PARENT;
                else if (!isResolve(parent)) throw new Error("'parent' must be a promise returned by $resolve.resolve()");
                // To complete the overall resolution, we have to wait for the parent
                // promise and for the promise for each invokable in our plan.
                var resolution = $q.defer(), result = silenceUncaughtInPromise(resolution.promise), promises = result.$$promises = {}, values = extend({}, locals), wait = 1 + plan.length / 3, merged = false;
                silenceUncaughtInPromise(result);
                function done() {
                    // Merge parent values we haven't got yet and publish our own $$values
                    if (!--wait) {
                        if (!merged) merge(values, parent.$$values);
                        result.$$values = values;
                        result.$$promises = result.$$promises || true; // keep for isResolve()
                        delete result.$$inheritedValues;
                        resolution.resolve(values);
                    }
                }
                function fail(reason) {
                    result.$$failure = reason;
                    resolution.reject(reason);
                }
                // Short-circuit if parent has already failed
                if (isDefined(parent.$$failure)) {
                    fail(parent.$$failure);
                    return result;
                }
                if (parent.$$inheritedValues) merge(values, omit(parent.$$inheritedValues, invocableKeys));
                // Merge parent values if the parent has already resolved, or merge
                // parent promises and wait if the parent resolve is still in progress.
                extend(promises, parent.$$promises);
                if (parent.$$values) {
                    merged = merge(values, omit(parent.$$values, invocableKeys));
                    result.$$inheritedValues = omit(parent.$$values, invocableKeys);
                    done();
                } else {
                    if (parent.$$inheritedValues) result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
                    parent.then(done, fail);
                }
                // Process each invocable in the plan, but ignore any where a local of the same name exists.
                for(var i = 0, ii = plan.length; i < ii; i += 3)if (locals.hasOwnProperty(plan[i])) done();
                else invoke(plan[i], plan[i + 1], plan[i + 2]);
                function invoke(key, invocable, params) {
                    // Create a deferred for this invocation. Failures will propagate to the resolution as well.
                    var invocation = $q.defer(), waitParams = 0;
                    function onfailure(reason) {
                        invocation.reject(reason);
                        fail(reason);
                    }
                    // Wait for any parameter that we have a promise for (either from parent or from this
                    // resolve; in that case study() will have made sure it's ordered before us in the plan).
                    forEach(params, function(dep) {
                        if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
                            waitParams++;
                            promises[dep].then(function(result) {
                                values[dep] = result;
                                if (!--waitParams) proceed();
                            }, onfailure);
                        }
                    });
                    if (!waitParams) proceed();
                    function proceed() {
                        if (isDefined(result.$$failure)) return;
                        try {
                            invocation.resolve($injector.invoke(invocable, self, values));
                            invocation.promise.then(function(result) {
                                values[key] = result;
                                done();
                            }, onfailure);
                        } catch (e) {
                            onfailure(e);
                        }
                    }
                    // Publish promise synchronously; invocations further down in the plan may depend on it.
                    promises[key] = silenceUncaughtInPromise(invocation.promise);
                }
                return result;
            };
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */ this.resolve = function(invocables, locals, parent, self) {
            return this.study(invocables)(locals, parent, self);
        };
    }
    angular.module("ui.router.util").service("$resolve", $Resolve);
    /**
 * @ngdoc object
 * @name ui.router.util.$templateFactoryProvider
 *
 * @description
 * Provider for $templateFactory. Manages which template-loading mechanism to
 * use, and will default to the most recent one ($templateRequest on Angular
 * versions starting from 1.3, $http otherwise).
 */ function TemplateFactoryProvider() {
        var shouldUnsafelyUseHttp = angular.version.minor < 3;
        /**
   * @ngdoc function
   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
   * @methodOf ui.router.util.$templateFactoryProvider
   *
   * @description
   * Forces $templateFactory to use $http instead of $templateRequest. This
   * might cause XSS, as $http doesn't enforce the regular security checks for
   * templates that have been introduced in Angular 1.3. Note that setting this
   * to false on Angular older than 1.3.x will crash, as the $templateRequest
   * service (and the security checks) are not implemented on these versions.
   *
   * See the $sce documentation, section
   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
   * Impact on loading templates</a> for more details about this mechanism.
   *
   * @param {boolean} value
   */ this.shouldUnsafelyUseHttp = function(value) {
            shouldUnsafelyUseHttp = !!value;
        };
        /**
   * @ngdoc object
   * @name ui.router.util.$templateFactory
   *
   * @requires $http
   * @requires $templateCache
   * @requires $injector
   *
   * @description
   * Service. Manages loading of templates.
   */ this.$get = [
            "$http",
            "$templateCache",
            "$injector",
            function($http, $templateCache, $injector) {
                return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);
            }
        ];
    }
    /**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */ function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {
        /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */ this.fromConfig = function(config, params, locals) {
            return isDefined(config.template) ? this.fromString(config.template, params) : isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) : isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) : null;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */ this.fromString = function(template, params) {
            return isFunction(template) ? template(params) : template;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */ this.fromUrl = function(url, params) {
            if (isFunction(url)) url = url(params);
            if (url == null) return null;
            else {
                if (!shouldUnsafelyUseHttp) return $injector.get("$templateRequest")(url);
                else return $http.get(url, {
                    cache: $templateCache,
                    headers: {
                        Accept: "text/html"
                    }
                }).then(function(response) {
                    return response.data;
                });
            }
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */ this.fromProvider = function(provider, params, locals) {
            return $injector.invoke(provider, null, locals || {
                params: params
            });
        };
    }
    angular.module("ui.router.util").provider("$templateFactory", TemplateFactoryProvider);
    var $$UMFP; // reference to $UrlMatcherFactoryProvider
    /**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */ function UrlMatcher(pattern, config, parentMatcher) {
        config = extend({
            params: {}
        }, isObject(config) ? config : {});
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, compiled = "^", last = 0, m, segments = this.segments = [], parentParams = parentMatcher ? parentMatcher.params : {}, params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(), paramNames = [];
        function addParameter(id, type, config, location) {
            paramNames.push(id);
            if (parentParams[id]) return parentParams[id];
            if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
            params[id] = new $$UMFP.Param(id, type, config, location);
            return params[id];
        }
        function quoteRegExp(string, pattern, squash, optional) {
            var surroundPattern = [
                "",
                ""
            ], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
            if (!pattern) return result;
            switch(squash){
                case false:
                    surroundPattern = [
                        "(",
                        ")" + (optional ? "?" : "")
                    ];
                    break;
                case true:
                    result = result.replace(/\/$/, "");
                    surroundPattern = [
                        "(?:/(",
                        ")|/)?"
                    ];
                    break;
                default:
                    surroundPattern = [
                        "(" + squash + "|",
                        ")?"
                    ];
                    break;
            }
            return result + surroundPattern[0] + pattern + surroundPattern[1];
        }
        this.source = pattern;
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        function matchDetails(m, isSearch) {
            var id, regexp, segment, type, cfg, arrayMode;
            id = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
            cfg = config.params[id];
            segment = pattern.substring(last, m.index);
            regexp = isSearch ? m[4] : m[4] || (m[1] == "*" ? ".*" : null);
            if (regexp) type = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), {
                pattern: new RegExp(regexp, config.caseInsensitive ? "i" : undefined)
            });
            return {
                id: id,
                regexp: regexp,
                segment: segment,
                type: type,
                cfg: cfg
            };
        }
        var p, param, segment;
        while(m = placeholder.exec(pattern)){
            p = matchDetails(m, false);
            if (p.segment.indexOf("?") >= 0) break; // we're into the search part
            param = addParameter(p.id, p.type, p.cfg, "path");
            compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
            segments.push(p.segment);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf("?");
        if (i >= 0) {
            var search = this.sourceSearch = segment.substring(i);
            segment = segment.substring(0, i);
            this.sourcePath = pattern.substring(0, last + i);
            if (search.length > 0) {
                last = 0;
                while(m = searchPlaceholder.exec(search)){
                    p = matchDetails(m, true);
                    param = addParameter(p.id, p.type, p.cfg, "search");
                    last = placeholder.lastIndex;
                // check if ?&
                }
            }
        } else {
            this.sourcePath = pattern;
            this.sourceSearch = "";
        }
        compiled += quoteRegExp(segment) + (config.strict === false ? "/?" : "") + "$";
        segments.push(segment);
        this.regexp = new RegExp(compiled, config.caseInsensitive ? "i" : undefined);
        this.prefix = segments[0];
        this.$$paramNames = paramNames;
    }
    /**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */ UrlMatcher.prototype.concat = function(pattern, config) {
        // Because order of search parameters is irrelevant, we can add our own search
        // parameters to the end of the new pattern. Parse the new pattern by itself
        // and then join the bits together, but it's much easier to do this on a string level.
        var defaultConfig = {
            caseInsensitive: $$UMFP.caseInsensitive(),
            strict: $$UMFP.strictMode(),
            squash: $$UMFP.defaultSquashPolicy()
        };
        return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
    };
    UrlMatcher.prototype.toString = function() {
        return this.source;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */ UrlMatcher.prototype.exec = function(path, searchParams) {
        var m = this.regexp.exec(path);
        if (!m) return null;
        searchParams = searchParams || {};
        var paramNames = this.parameters(), nTotal = paramNames.length, nPath = this.segments.length - 1, values = {}, i, j, cfg, paramName;
        if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
        function decodePathArray(string) {
            function reverseString(str) {
                return str.split("").reverse().join("");
            }
            function unquoteDashes(str) {
                return str.replace(/\\-/g, "-");
            }
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = map(split, reverseString);
            return map(allReversed, unquoteDashes).reverse();
        }
        var param, paramVal;
        for(i = 0; i < nPath; i++){
            paramName = paramNames[i];
            param = this.params[paramName];
            paramVal = m[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for(j = 0; j < param.replace.length; j++)if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
            if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
            if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
            values[paramName] = param.value(paramVal);
        }
        for(; i < nTotal; i++){
            paramName = paramNames[i];
            values[paramName] = this.params[paramName].value(searchParams[paramName]);
            param = this.params[paramName];
            paramVal = searchParams[paramName];
            for(j = 0; j < param.replace.length; j++)if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
            if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
            values[paramName] = param.value(paramVal);
        }
        return values;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */ UrlMatcher.prototype.parameters = function(param) {
        if (!isDefined(param)) return this.$$paramNames;
        return this.params[param] || null;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */ UrlMatcher.prototype.validates = function(params) {
        return this.params.$$validates(params);
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */ UrlMatcher.prototype.format = function(values) {
        values = values || {};
        var segments = this.segments, params = this.parameters(), paramset = this.params;
        if (!this.validates(values)) return null;
        var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
        function encodeDashes(str) {
            return encodeURIComponent(str).replace(/-/g, function(c) {
                return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase();
            });
        }
        for(i = 0; i < nTotal; i++){
            var isPathParam = i < nPath;
            var name = params[i], param = paramset[name], value = param.value(values[name]);
            var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
            var squash = isDefaultValue ? param.squash : false;
            var encoded = param.type.encode(value);
            if (isPathParam) {
                var nextSegment = segments[i + 1];
                var isFinalPathParam = i + 1 === nPath;
                if (squash === false) {
                    if (encoded != null) {
                        if (isArray(encoded)) result += map(encoded, encodeDashes).join("-");
                        else result += encodeURIComponent(encoded);
                    }
                    result += nextSegment;
                } else if (squash === true) {
                    var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
                    result += nextSegment.match(capture)[1];
                } else if (isString(squash)) result += squash + nextSegment;
                if (isFinalPathParam && param.squash === true && result.slice(-1) === "/") result = result.slice(0, -1);
            } else {
                if (encoded == null || isDefaultValue && squash !== false) continue;
                if (!isArray(encoded)) encoded = [
                    encoded
                ];
                if (encoded.length === 0) continue;
                encoded = map(encoded, encodeURIComponent).join("&" + name + "=");
                result += (search ? "&" : "?") + (name + "=" + encoded);
                search = true;
            }
        }
        return result;
    };
    /**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */ function Type(config) {
        extend(this, config);
    }
    /**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */ Type.prototype.is = function(val, key) {
        return true;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */ Type.prototype.encode = function(val, key) {
        return val;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */ Type.prototype.decode = function(val, key) {
        return val;
    };
    /**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */ Type.prototype.equals = function(a, b) {
        return a == b;
    };
    Type.prototype.$subPattern = function() {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    Type.prototype.pattern = /.*/;
    Type.prototype.toString = function() {
        return "{Type:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */ Type.prototype.$normalize = function(val) {
        return this.is(val) ? val : this.decode(val);
    };
    /*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */ Type.prototype.$asArray = function(mode, isSearch) {
        if (!mode) return this;
        if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
        function ArrayType(type, mode) {
            function bindTo(type, callbackName) {
                return function() {
                    return type[callbackName].apply(type, arguments);
                };
            }
            // Wrap non-array value as array
            function arrayWrap(val) {
                return isArray(val) ? val : isDefined(val) ? [
                    val
                ] : [];
            }
            // Unwrap array value for "auto" mode. Return undefined for empty array.
            function arrayUnwrap(val) {
                switch(val.length){
                    case 0:
                        return undefined;
                    case 1:
                        return mode === "auto" ? val[0] : val;
                    default:
                        return val;
                }
            }
            function falsey(val) {
                return !val;
            }
            // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
            function arrayHandler(callback, allTruthyMode) {
                return function handleArray(val) {
                    if (isArray(val) && val.length === 0) return val;
                    val = arrayWrap(val);
                    var result = map(val, callback);
                    if (allTruthyMode === true) return filter(result, falsey).length === 0;
                    return arrayUnwrap(result);
                };
            }
            // Wraps type (.equals) functions to operate on each value of an array
            function arrayEqualsHandler(callback) {
                return function handleArray(val1, val2) {
                    var left = arrayWrap(val1), right = arrayWrap(val2);
                    if (left.length !== right.length) return false;
                    for(var i = 0; i < left.length; i++){
                        if (!callback(left[i], right[i])) return false;
                    }
                    return true;
                };
            }
            this.encode = arrayHandler(bindTo(type, "encode"));
            this.decode = arrayHandler(bindTo(type, "decode"));
            this.is = arrayHandler(bindTo(type, "is"), true);
            this.equals = arrayEqualsHandler(bindTo(type, "equals"));
            this.pattern = type.pattern;
            this.$normalize = arrayHandler(bindTo(type, "$normalize"));
            this.name = type.name;
            this.$arrayMode = mode;
        }
        return new ArrayType(this, mode);
    };
    /**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */ function $UrlMatcherFactory() {
        $$UMFP = this;
        var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
        // Use tildes to pre-encode slashes.
        // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
        // and bidirectional encoding/decoding fails.
        // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
        function valToString(val) {
            return val != null ? val.toString().replace(/(~|\/)/g, function(m) {
                return ({
                    "~": "~~",
                    "/": "~2F"
                })[m];
            }) : val;
        }
        function valFromString(val) {
            return val != null ? val.toString().replace(/(~~|~2F)/g, function(m) {
                return ({
                    "~~": "~",
                    "~2F": "/"
                })[m];
            }) : val;
        }
        var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
            "string": {
                encode: valToString,
                decode: valFromString,
                // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
                // In 0.2.x, string params are optional by default for backwards compat
                is: function(val) {
                    return val == null || !isDefined(val) || typeof val === "string";
                },
                pattern: /[^/]*/
            },
            "int": {
                encode: valToString,
                decode: function(val) {
                    return parseInt(val, 10);
                },
                is: function(val) {
                    return val !== undefined && val !== null && this.decode(val.toString()) === val;
                },
                pattern: /-?\d+/
            },
            "bool": {
                encode: function(val) {
                    return val ? 1 : 0;
                },
                decode: function(val) {
                    return parseInt(val, 10) !== 0;
                },
                is: function(val) {
                    return val === true || val === false;
                },
                pattern: /0|1/
            },
            "date": {
                encode: function(val) {
                    if (!this.is(val)) return undefined;
                    return [
                        val.getFullYear(),
                        ("0" + (val.getMonth() + 1)).slice(-2),
                        ("0" + val.getDate()).slice(-2)
                    ].join("-");
                },
                decode: function(val) {
                    if (this.is(val)) return val;
                    var match = this.capture.exec(val);
                    return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
                },
                is: function(val) {
                    return val instanceof Date && !isNaN(val.valueOf());
                },
                equals: function(a, b) {
                    return this.is(a) && this.is(b) && a.toISOString() === b.toISOString();
                },
                pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
                capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
            },
            "json": {
                encode: angular.toJson,
                decode: angular.fromJson,
                is: angular.isObject,
                equals: angular.equals,
                pattern: /[^/]*/
            },
            "any": {
                encode: angular.identity,
                decode: angular.identity,
                equals: angular.equals,
                pattern: /.*/
            }
        };
        function getDefaultConfig() {
            return {
                strict: isStrictMode,
                caseInsensitive: isCaseInsensitive
            };
        }
        function isInjectable(value) {
            return isFunction(value) || isArray(value) && isFunction(value[value.length - 1]);
        }
        /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */ $UrlMatcherFactory.$$getDefaultValue = function(config) {
            if (!isInjectable(config.value)) return config.value;
            if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
            return injector.invoke(config.value);
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */ this.caseInsensitive = function(value) {
            if (isDefined(value)) isCaseInsensitive = value;
            return isCaseInsensitive;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */ this.strictMode = function(value) {
            if (isDefined(value)) isStrictMode = value;
            return isStrictMode;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */ this.defaultSquashPolicy = function(value) {
            if (!isDefined(value)) return defaultSquashPolicy;
            if (value !== true && value !== false && !isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
            defaultSquashPolicy = value;
            return value;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */ this.compile = function(pattern, config) {
            return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */ this.isMatcher = function(o) {
            if (!isObject(o)) return false;
            var result = true;
            forEach(UrlMatcher.prototype, function(val, name) {
                if (isFunction(val)) result = result && isDefined(o[name]) && isFunction(o[name]);
            });
            return result;
        };
        /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */ this.type = function(name, definition, definitionFn) {
            if (!isDefined(definition)) return $types[name];
            if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
            $types[name] = new Type(extend({
                name: name
            }, definition));
            if (definitionFn) {
                typeQueue.push({
                    name: name,
                    def: definitionFn
                });
                if (!enqueue) flushTypeQueue();
            }
            return this;
        };
        // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
        function flushTypeQueue() {
            while(typeQueue.length){
                var type = typeQueue.shift();
                if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
                angular.extend($types[type.name], injector.invoke(type.def));
            }
        }
        // Register default types. Store them in the prototype of $types.
        forEach(defaultTypes, function(type, name) {
            $types[name] = new Type(extend({
                name: name
            }, type));
        });
        $types = inherit($types, {});
        /* No need to document $get, since it returns this */ this.$get = [
            "$injector",
            function($injector) {
                injector = $injector;
                enqueue = false;
                flushTypeQueue();
                forEach(defaultTypes, function(type, name) {
                    if (!$types[name]) $types[name] = new Type(type);
                });
                return this;
            }
        ];
        this.Param = function Param(id, type, config, location) {
            var self = this;
            config = unwrapShorthand(config);
            type = getType(config, type, location);
            var arrayMode = getArrayMode();
            type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
            if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined) config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
            var isOptional = config.value !== undefined;
            var squash = getSquashPolicy(config, isOptional);
            var replace = getReplace(config, arrayMode, isOptional, squash);
            function unwrapShorthand(config) {
                var keys = isObject(config) ? objectKeys(config) : [];
                var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 && indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
                if (isShorthand) config = {
                    value: config
                };
                config.$$fn = isInjectable(config.value) ? config.value : function() {
                    return config.value;
                };
                return config;
            }
            function getType(config, urlType, location) {
                if (config.type && urlType) throw new Error("Param '" + id + "' has two type configurations.");
                if (urlType) return urlType;
                if (!config.type) return location === "config" ? $types.any : $types.string;
                if (angular.isString(config.type)) return $types[config.type];
                if (config.type instanceof Type) return config.type;
                return new Type(config.type);
            }
            // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
            function getArrayMode() {
                var arrayDefaults = {
                    array: location === "search" ? "auto" : false
                };
                var arrayParamNomenclature = id.match(/\[\]$/) ? {
                    array: true
                } : {};
                return extend(arrayDefaults, arrayParamNomenclature, config).array;
            }
            /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */ function getSquashPolicy(config, isOptional) {
                var squash = config.squash;
                if (!isOptional || squash === false) return false;
                if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
                if (squash === true || isString(squash)) return squash;
                throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
            }
            function getReplace(config, arrayMode, isOptional, squash) {
                var replace, configuredKeys, defaultPolicy = [
                    {
                        from: "",
                        to: isOptional || arrayMode ? undefined : ""
                    },
                    {
                        from: null,
                        to: isOptional || arrayMode ? undefined : ""
                    }
                ];
                replace = isArray(config.replace) ? config.replace : [];
                if (isString(squash)) replace.push({
                    from: squash,
                    to: undefined
                });
                configuredKeys = map(replace, function(item) {
                    return item.from;
                });
                return filter(defaultPolicy, function(item) {
                    return indexOf(configuredKeys, item.from) === -1;
                }).concat(replace);
            }
            /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */ function $$getDefaultValue() {
                if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
                var defaultValue = injector.invoke(config.$$fn);
                if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
                return defaultValue;
            }
            /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */ function $value(value) {
                function hasReplaceVal(val) {
                    return function(obj) {
                        return obj.from === val;
                    };
                }
                function $replace(value) {
                    var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) {
                        return obj.to;
                    });
                    return replacement.length ? replacement[0] : value;
                }
                value = $replace(value);
                return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
            }
            function toString() {
                return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}";
            }
            extend(this, {
                id: id,
                type: type,
                location: location,
                array: arrayMode,
                squash: squash,
                replace: replace,
                isOptional: isOptional,
                value: $value,
                dynamic: undefined,
                config: config,
                toString: toString
            });
        };
        function ParamSet(params) {
            extend(this, params || {});
        }
        ParamSet.prototype = {
            $$new: function() {
                return inherit(this, extend(new ParamSet(), {
                    $$parent: this
                }));
            },
            $$keys: function() {
                var keys = [], chain = [], parent = this, ignore = objectKeys(ParamSet.prototype);
                while(parent){
                    chain.push(parent);
                    parent = parent.$$parent;
                }
                chain.reverse();
                forEach(chain, function(paramset) {
                    forEach(objectKeys(paramset), function(key) {
                        if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
                    });
                });
                return keys;
            },
            $$values: function(paramValues) {
                var values = {}, self = this;
                forEach(self.$$keys(), function(key) {
                    values[key] = self[key].value(paramValues && paramValues[key]);
                });
                return values;
            },
            $$equals: function(paramValues1, paramValues2) {
                var equal = true, self = this;
                forEach(self.$$keys(), function(key) {
                    var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
                    if (!self[key].type.equals(left, right)) equal = false;
                });
                return equal;
            },
            $$validates: function $$validate(paramValues) {
                var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
                for(i = 0; i < keys.length; i++){
                    param = this[keys[i]];
                    rawVal = paramValues[keys[i]];
                    if ((rawVal === undefined || rawVal === null) && param.isOptional) break; // There was no parameter value, but the param is optional
                    normalized = param.type.$normalize(rawVal);
                    if (!param.type.is(normalized)) return false; // The value was not of the correct Type, and could not be decoded to the correct Type
                    encoded = param.type.encode(normalized);
                    if (angular.isString(encoded) && !param.type.pattern.exec(encoded)) return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
                }
                return true;
            },
            $$parent: undefined
        };
        this.ParamSet = ParamSet;
    }
    // Register as a provider so it's available to other providers
    angular.module("ui.router.util").provider("$urlMatcherFactory", $UrlMatcherFactory);
    angular.module("ui.router.util").run([
        "$urlMatcherFactory",
        function($urlMatcherFactory) {}
    ]);
    /**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */ $UrlRouterProvider.$inject = [
        "$locationProvider",
        "$urlMatcherFactoryProvider"
    ];
    function $UrlRouterProvider($locationProvider, $urlMatcherFactory) {
        var rules = [], otherwise = null, interceptDeferred = false, listener;
        // Returns a string that is a prefix of all strings matching the RegExp
        function regExpPrefix(re) {
            var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
            return prefix != null ? prefix[1].replace(/\\(.)/g, "$1") : "";
        }
        // Interpolates matched values into a String.replace()-style pattern
        function interpolate(pattern, match) {
            return pattern.replace(/\$(\$|\d{1,2})/, function(m, what) {
                return match[what === "$" ? 0 : Number(what)];
            });
        }
        /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */ this.rule = function(rule) {
            if (!isFunction(rule)) throw new Error("'rule' must be a function");
            rules.push(rule);
            return this;
        };
        /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */ this.otherwise = function(rule) {
            if (isString(rule)) {
                var redirect = rule;
                rule = function() {
                    return redirect;
                };
            } else if (!isFunction(rule)) throw new Error("'rule' must be a function");
            otherwise = rule;
            return this;
        };
        function handleIfMatch($injector, handler, match) {
            if (!match) return false;
            var result = $injector.invoke(handler, handler, {
                $match: match
            });
            return isDefined(result) ? result : true;
        }
        /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */ this.when = function(what, handler) {
            var redirect, handlerIsString = isString(handler);
            if (isString(what)) what = $urlMatcherFactory.compile(what);
            if (!handlerIsString && !isFunction(handler) && !isArray(handler)) throw new Error("invalid 'handler' in when()");
            var strategies = {
                matcher: function(what, handler) {
                    if (handlerIsString) {
                        redirect = $urlMatcherFactory.compile(handler);
                        handler = [
                            "$match",
                            function($match) {
                                return redirect.format($match);
                            }
                        ];
                    }
                    return extend(function($injector, $location) {
                        return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
                    }, {
                        prefix: isString(what.prefix) ? what.prefix : ""
                    });
                },
                regex: function(what, handler) {
                    if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
                    if (handlerIsString) {
                        redirect = handler;
                        handler = [
                            "$match",
                            function($match) {
                                return interpolate(redirect, $match);
                            }
                        ];
                    }
                    return extend(function($injector, $location) {
                        return handleIfMatch($injector, handler, what.exec($location.path()));
                    }, {
                        prefix: regExpPrefix(what)
                    });
                }
            };
            var check = {
                matcher: $urlMatcherFactory.isMatcher(what),
                regex: what instanceof RegExp
            };
            for(var n in check){
                if (check[n]) return this.rule(strategies[n](what, handler));
            }
            throw new Error("invalid 'what' in when()");
        };
        /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */ this.deferIntercept = function(defer) {
            if (defer === undefined) defer = true;
            interceptDeferred = defer;
        };
        /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */ this.$get = $get;
        $get.$inject = [
            "$location",
            "$rootScope",
            "$injector",
            "$browser",
            "$sniffer"
        ];
        function $get($location, $rootScope, $injector, $browser, $sniffer) {
            var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
            function appendBasePath(url, isHtml5, absolute) {
                if (baseHref === "/") return url;
                if (isHtml5) return baseHref.slice(0, -1) + url;
                if (absolute) return baseHref.slice(1) + url;
                return url;
            }
            // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
            function update(evt) {
                if (evt && evt.defaultPrevented) return;
                var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
                lastPushedUrl = undefined;
                // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
                //if (ignoreUpdate) return true;
                function check(rule) {
                    var handled = rule($injector, $location);
                    if (!handled) return false;
                    if (isString(handled)) $location.replace().url(handled);
                    return true;
                }
                var n = rules.length, i;
                for(i = 0; i < n; i++){
                    if (check(rules[i])) return;
                }
                // always check otherwise last to allow dynamic updates to the set of rules
                if (otherwise) check(otherwise);
            }
            function listen() {
                listener = listener || $rootScope.$on("$locationChangeSuccess", update);
                return listener;
            }
            if (!interceptDeferred) listen();
            return {
                /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */ sync: function() {
                    update();
                },
                listen: function() {
                    return listen();
                },
                update: function(read) {
                    if (read) {
                        location = $location.url();
                        return;
                    }
                    if ($location.url() === location) return;
                    $location.url(location);
                    $location.replace();
                },
                push: function(urlMatcher, params, options) {
                    var url = urlMatcher.format(params || {});
                    // Handle the special hash param, if needed
                    if (url !== null && params && params["#"]) url += "#" + params["#"];
                    $location.url(url);
                    lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
                    if (options && options.replace) $location.replace();
                },
                /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */ href: function(urlMatcher, params, options) {
                    if (!urlMatcher.validates(params)) return null;
                    var isHtml5 = $locationProvider.html5Mode();
                    if (angular.isObject(isHtml5)) isHtml5 = isHtml5.enabled;
                    isHtml5 = isHtml5 && $sniffer.history;
                    var url = urlMatcher.format(params);
                    options = options || {};
                    if (!isHtml5 && url !== null) url = "#" + $locationProvider.hashPrefix() + url;
                    // Handle special hash param, if needed
                    if (url !== null && params && params["#"]) url += "#" + params["#"];
                    url = appendBasePath(url, isHtml5, options.absolute);
                    if (!options.absolute || !url) return url;
                    var slash = !isHtml5 && url ? "/" : "", port = $location.port();
                    port = port === 80 || port === 443 ? "" : ":" + port;
                    return [
                        $location.protocol(),
                        "://",
                        $location.host(),
                        port,
                        slash,
                        url
                    ].join("");
                }
            };
        }
    }
    angular.module("ui.router.router").provider("$urlRouter", $UrlRouterProvider);
    /**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */ $StateProvider.$inject = [
        "$urlRouterProvider",
        "$urlMatcherFactoryProvider"
    ];
    function $StateProvider($urlRouterProvider, $urlMatcherFactory) {
        var root, states = {}, $state, queue = {}, abstractKey = "abstract";
        // Builds state properties from definition passed to registerState()
        var stateBuilder = {
            // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
            // state.children = [];
            // if (parent) parent.children.push(state);
            parent: function(state) {
                if (isDefined(state.parent) && state.parent) return findState(state.parent);
                // regex matches any valid composite state name
                // would match "contact.list" but not "contacts"
                var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
                return compositeName ? findState(compositeName[1]) : root;
            },
            // inherit 'data' from parent and override by own values (if any)
            data: function(state) {
                if (state.parent && state.parent.data) state.data = state.self.data = inherit(state.parent.data, state.data);
                return state.data;
            },
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: function(state) {
                var url = state.url, config = {
                    params: state.params || {}
                };
                if (isString(url)) {
                    if (url.charAt(0) == "^") return $urlMatcherFactory.compile(url.substring(1), config);
                    return (state.parent.navigable || root).url.concat(url, config);
                }
                if (!url || $urlMatcherFactory.isMatcher(url)) return url;
                throw new Error("Invalid url '" + url + "' in state '" + state + "'");
            },
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: function(state) {
                return state.url ? state : state.parent ? state.parent.navigable : null;
            },
            // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
            ownParams: function(state) {
                var params = state.url && state.url.params || new $$UMFP.ParamSet();
                forEach(state.params || {}, function(config, id) {
                    if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
                });
                return params;
            },
            // Derive parameters for this state and ensure they're a super-set of parent's parameters
            params: function(state) {
                var ownParams = pick(state.ownParams, state.ownParams.$$keys());
                return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
            },
            // If there is no explicit multi-view configuration, make one up so we don't have
            // to handle both cases in the view directive later. Note that having an explicit
            // 'views' property will mean the default unnamed view properties are ignored. This
            // is also a good time to resolve view names to absolute names, so everything is a
            // straight lookup at link time.
            views: function(state) {
                var views = {};
                forEach(isDefined(state.views) ? state.views : {
                    "": state
                }, function(view, name) {
                    if (name.indexOf("@") < 0) name += "@" + state.parent.name;
                    view.resolveAs = view.resolveAs || state.resolveAs || "$resolve";
                    views[name] = view;
                });
                return views;
            },
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: function(state) {
                return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
            },
            // Speed up $state.contains() as it's used a lot
            includes: function(state) {
                var includes = state.parent ? extend({}, state.parent.includes) : {};
                includes[state.name] = true;
                return includes;
            },
            $delegates: {}
        };
        function isRelative(stateName) {
            return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
        }
        function findState(stateOrName, base) {
            if (!stateOrName) return undefined;
            var isStr = isString(stateOrName), name = isStr ? stateOrName : stateOrName.name, path = isRelative(name);
            if (path) {
                if (!base) throw new Error("No reference point given for path '" + name + "'");
                base = findState(base);
                var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
                for(; i < pathLength; i++){
                    if (rel[i] === "" && i === 0) {
                        current = base;
                        continue;
                    }
                    if (rel[i] === "^") {
                        if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
                        current = current.parent;
                        continue;
                    }
                    break;
                }
                rel = rel.slice(i).join(".");
                name = current.name + (current.name && rel ? "." : "") + rel;
            }
            var state = states[name];
            if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) return state;
            return undefined;
        }
        function queueState(parentName, state) {
            if (!queue[parentName]) queue[parentName] = [];
            queue[parentName].push(state);
        }
        function flushQueuedChildren(parentName) {
            var queued = queue[parentName] || [];
            while(queued.length)registerState(queued.shift());
        }
        function registerState(state) {
            // Wrap a new object around the state so we can store our private details easily.
            state = inherit(state, {
                self: state,
                resolve: state.resolve || {},
                toString: function() {
                    return this.name;
                }
            });
            var name = state.name;
            if (!isString(name) || name.indexOf("@") >= 0) throw new Error("State must have a valid name");
            if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
            // Get parent name
            var parentName = name.indexOf(".") !== -1 ? name.substring(0, name.lastIndexOf(".")) : isString(state.parent) ? state.parent : isObject(state.parent) && isString(state.parent.name) ? state.parent.name : "";
            // If parent is not registered yet, add state to queue and register later
            if (parentName && !states[parentName]) return queueState(parentName, state.self);
            for(var key in stateBuilder)if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
            states[name] = state;
            // Register the state in the global state list and with $urlRouter if necessary.
            if (!state[abstractKey] && state.url) $urlRouterProvider.when(state.url, [
                "$match",
                "$stateParams",
                function($match, $stateParams) {
                    if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) $state.transitionTo(state, $match, {
                        inherit: true,
                        location: false
                    });
                }
            ]);
            // Register any queued children
            flushQueuedChildren(name);
            return state;
        }
        // Checks text to see if it looks like a glob.
        function isGlob(text) {
            return text.indexOf("*") > -1;
        }
        // Returns true if glob matches current $state name.
        function doesStateMatchGlob(glob) {
            var globSegments = glob.split("."), segments = $state.$current.name.split(".");
            //match single stars
            for(var i = 0, l = globSegments.length; i < l; i++)if (globSegments[i] === "*") segments[i] = "*";
            //match greedy starts
            if (globSegments[0] === "**") {
                segments = segments.slice(indexOf(segments, globSegments[1]));
                segments.unshift("**");
            }
            //match greedy ends
            if (globSegments[globSegments.length - 1] === "**") {
                segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
                segments.push("**");
            }
            if (globSegments.length != segments.length) return false;
            return segments.join("") === globSegments.join("");
        }
        // Implicit root state that is always active
        root = registerState({
            name: "",
            url: "^",
            views: null,
            "abstract": true
        });
        root.navigable = null;
        /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */ this.decorator = decorator;
        function decorator(name, func) {
            /*jshint validthis: true */ if (isString(name) && !isDefined(func)) return stateBuilder[name];
            if (!isFunction(func) || !isString(name)) return this;
            if (stateBuilder[name] && !stateBuilder.$delegates[name]) stateBuilder.$delegates[name] = stateBuilder[name];
            stateBuilder[name] = func;
            return this;
        }
        /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */ this.state = state;
        function state(name, definition) {
            /*jshint validthis: true */ if (isObject(name)) definition = name;
            else definition.name = name;
            registerState(definition);
            return this;
        }
        /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */ this.$get = $get;
        $get.$inject = [
            "$rootScope",
            "$q",
            "$view",
            "$injector",
            "$resolve",
            "$stateParams",
            "$urlRouter",
            "$location",
            "$urlMatcherFactory"
        ];
        function $get($rootScope, $q, $view, $injector, $resolve, $stateParams, $urlRouter, $location, $urlMatcherFactory) {
            var TransitionSupersededError = new Error("transition superseded");
            var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
            var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error("transition prevented")));
            var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error("transition aborted")));
            var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error("transition failed")));
            // Handles the case where a state which is the target of a transition is not found, and the user
            // can optionally retry or defer the transition
            function handleRedirect(redirect, state, params, options) {
                /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */ var evt = $rootScope.$broadcast("$stateNotFound", redirect, state, params);
                if (evt.defaultPrevented) {
                    $urlRouter.update();
                    return TransitionAborted;
                }
                if (!evt.retry) return null;
                // Allow the handler to return a promise to defer state lookup retry
                if (options.$retry) {
                    $urlRouter.update();
                    return TransitionFailed;
                }
                var retryTransition = $state.transition = $q.when(evt.retry);
                retryTransition.then(function() {
                    if (retryTransition !== $state.transition) {
                        $rootScope.$broadcast("$stateChangeCancel", redirect.to, redirect.toParams, state, params);
                        return TransitionSuperseded;
                    }
                    redirect.options.$retry = true;
                    return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
                }, function() {
                    return TransitionAborted;
                });
                $urlRouter.update();
                return retryTransition;
            }
            root.locals = {
                resolve: null,
                globals: {
                    $stateParams: {}
                }
            };
            $state = {
                params: {},
                current: root.self,
                $current: root,
                transition: null
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */ $state.reload = function reload(state) {
                return $state.transitionTo($state.current, $stateParams, {
                    reload: state || true,
                    inherit: false,
                    notify: true
                });
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */ $state.go = function go(to, params, options) {
                return $state.transitionTo(to, params, extend({
                    inherit: true,
                    relative: $state.$current
                }, options));
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */ $state.transitionTo = function transitionTo(to, toParams, options) {
                toParams = toParams || {};
                options = extend({
                    location: true,
                    inherit: false,
                    relative: null,
                    notify: true,
                    reload: false,
                    $retry: false
                }, options || {});
                var from = $state.$current, fromParams = $state.params, fromPath = from.path;
                var evt, toState = findState(to, options.relative);
                // Store the hash param for later (since it will be stripped out by various methods)
                var hash = toParams["#"];
                if (!isDefined(toState)) {
                    var redirect = {
                        to: to,
                        toParams: toParams,
                        options: options
                    };
                    var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
                    if (redirectResult) return redirectResult;
                    // Always retry once if the $stateNotFound was not prevented
                    // (handles either redirect changed or state lazy-definition)
                    to = redirect.to;
                    toParams = redirect.toParams;
                    options = redirect.options;
                    toState = findState(to, options.relative);
                    if (!isDefined(toState)) {
                        if (!options.relative) throw new Error("No such state '" + to + "'");
                        throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
                    }
                }
                if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
                if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
                if (!toState.params.$$validates(toParams)) return TransitionFailed;
                toParams = toState.params.$$values(toParams);
                to = toState;
                var toPath = to.path;
                // Starting from the root of the path, keep all levels that haven't changed
                var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
                if (!options.reload) while(state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)){
                    locals = toLocals[keep] = state.locals;
                    keep++;
                    state = toPath[keep];
                }
                else if (isString(options.reload) || isObject(options.reload)) {
                    if (isObject(options.reload) && !options.reload.name) throw new Error("Invalid reload state object");
                    var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
                    if (options.reload && !reloadState) throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
                    while(state && state === fromPath[keep] && state !== reloadState){
                        locals = toLocals[keep] = state.locals;
                        keep++;
                        state = toPath[keep];
                    }
                }
                // If we're going to the same state and all locals are kept, we've got nothing to do.
                // But clear 'transition', as we still want to cancel any other pending transitions.
                // TODO: We may not want to bump 'transition' if we're called from a location change
                // that we've initiated ourselves, because we might accidentally abort a legitimate
                // transition initiated from code?
                if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
                    if (hash) toParams["#"] = hash;
                    $state.params = toParams;
                    copy($state.params, $stateParams);
                    copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
                    if (options.location && to.navigable && to.navigable.url) {
                        $urlRouter.push(to.navigable.url, toParams, {
                            $$avoidResync: true,
                            replace: options.location === "replace"
                        });
                        $urlRouter.update(true);
                    }
                    $state.transition = null;
                    return $q.when($state.current);
                }
                // Filter parameters before we pass them to event handlers etc.
                toParams = filterByKeys(to.params.$$keys(), toParams || {});
                // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
                if (hash) toParams["#"] = hash;
                // Broadcast start event and cancel the transition if requested
                if (options.notify) /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */ {
                    if ($rootScope.$broadcast("$stateChangeStart", to.self, toParams, from.self, fromParams, options).defaultPrevented) {
                        $rootScope.$broadcast("$stateChangeCancel", to.self, toParams, from.self, fromParams);
                        //Don't update and resync url if there's been a new transition started. see issue #2238, #600
                        if ($state.transition == null) $urlRouter.update();
                        return TransitionPrevented;
                    }
                }
                // Resolve locals for the remaining states, but don't update any global state just
                // yet -- if anything fails to resolve the current state needs to remain untouched.
                // We also set up an inheritance chain for the locals here. This allows the view directive
                // to quickly look up the correct definition for each view in the current state. Even
                // though we create the locals object itself outside resolveState(), it is initially
                // empty and gets filled asynchronously. We need to keep track of the promise for the
                // (fully resolved) current locals, and pass this down the chain.
                var resolved = $q.when(locals);
                for(var l = keep; l < toPath.length; l++, state = toPath[l]){
                    locals = toLocals[l] = inherit(locals);
                    resolved = resolveState(state, toParams, state === to, resolved, locals, options);
                }
                // Once everything is resolved, we are ready to perform the actual transition
                // and return a promise for the new state. We also keep track of what the
                // current promise is, so that we can detect overlapping transitions and
                // keep only the outcome of the last transition.
                var transition = $state.transition = resolved.then(function() {
                    var l, entering, exiting;
                    if ($state.transition !== transition) {
                        $rootScope.$broadcast("$stateChangeCancel", to.self, toParams, from.self, fromParams);
                        return TransitionSuperseded;
                    }
                    // Exit 'from' states not kept
                    for(l = fromPath.length - 1; l >= keep; l--){
                        exiting = fromPath[l];
                        if (exiting.self.onExit) $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
                        exiting.locals = null;
                    }
                    // Enter 'to' states not kept
                    for(l = keep; l < toPath.length; l++){
                        entering = toPath[l];
                        entering.locals = toLocals[l];
                        if (entering.self.onEnter) $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
                    }
                    // Run it again, to catch any transitions in callbacks
                    if ($state.transition !== transition) {
                        $rootScope.$broadcast("$stateChangeCancel", to.self, toParams, from.self, fromParams);
                        return TransitionSuperseded;
                    }
                    // Update globals in $state
                    $state.$current = to;
                    $state.current = to.self;
                    $state.params = toParams;
                    copy($state.params, $stateParams);
                    $state.transition = null;
                    if (options.location && to.navigable) $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
                        $$avoidResync: true,
                        replace: options.location === "replace"
                    });
                    if (options.notify) /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */ $rootScope.$broadcast("$stateChangeSuccess", to.self, toParams, from.self, fromParams);
                    $urlRouter.update(true);
                    return $state.current;
                }).then(null, function(error) {
                    // propagate TransitionSuperseded error without emitting $stateChangeCancel
                    // as it was already emitted in the success handler above
                    if (error === TransitionSupersededError) return TransitionSuperseded;
                    if ($state.transition !== transition) {
                        $rootScope.$broadcast("$stateChangeCancel", to.self, toParams, from.self, fromParams);
                        return TransitionSuperseded;
                    }
                    $state.transition = null;
                    /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */ evt = $rootScope.$broadcast("$stateChangeError", to.self, toParams, from.self, fromParams, error);
                    if (!evt.defaultPrevented) $urlRouter.update();
                    return $q.reject(error);
                });
                silenceUncaughtInPromise(transition);
                return transition;
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */ $state.is = function is(stateOrName, params, options) {
                options = extend({
                    relative: $state.$current
                }, options || {});
                var state = findState(stateOrName, options.relative);
                if (!isDefined(state)) return undefined;
                if ($state.$current !== state) return false;
                return !params || objectKeys(params).reduce(function(acc, key) {
                    var paramDef = state.params[key];
                    return acc && (!paramDef || paramDef.type.equals($stateParams[key], params[key]));
                }, true);
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */ $state.includes = function includes(stateOrName, params, options) {
                options = extend({
                    relative: $state.$current
                }, options || {});
                if (isString(stateOrName) && isGlob(stateOrName)) {
                    if (!doesStateMatchGlob(stateOrName)) return false;
                    stateOrName = $state.$current.name;
                }
                var state = findState(stateOrName, options.relative);
                if (!isDefined(state)) return undefined;
                if (!isDefined($state.$current.includes[state.name])) return false;
                if (!params) return true;
                var keys = objectKeys(params);
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i], paramDef = state.params[key];
                    if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) return false;
                }
                return objectKeys(params).reduce(function(acc, key) {
                    var paramDef = state.params[key];
                    return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
                }, true);
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */ $state.href = function href(stateOrName, params, options) {
                options = extend({
                    lossy: true,
                    inherit: true,
                    absolute: false,
                    relative: $state.$current
                }, options || {});
                var state = findState(stateOrName, options.relative);
                if (!isDefined(state)) return null;
                if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
                var nav = state && options.lossy ? state.navigable : state;
                if (!nav || nav.url === undefined || nav.url === null) return null;
                return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat("#"), params || {}), {
                    absolute: options.absolute
                });
            };
            /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */ $state.get = function(stateOrName, context) {
                if (arguments.length === 0) return map(objectKeys(states), function(name) {
                    return states[name].self;
                });
                var state = findState(stateOrName, context || $state.$current);
                return state && state.self ? state.self : null;
            };
            function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
                // Make a restricted $stateParams with only the parameters that apply to this state if
                // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
                // we also need $stateParams to be available for any $injector calls we make during the
                // dependency resolution process.
                var $stateParams = paramsAreFiltered ? params : filterByKeys(state.params.$$keys(), params);
                var locals = {
                    $stateParams: $stateParams
                };
                // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
                // We're also including $stateParams in this; that way the parameters are restricted
                // to the set that should be visible to the state, and are independent of when we update
                // the global $state and $stateParams values.
                dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
                var promises = [
                    dst.resolve.then(function(globals) {
                        dst.globals = globals;
                    })
                ];
                if (inherited) promises.push(inherited);
                function resolveViews() {
                    var viewsPromises = [];
                    // Resolve template and dependencies for all views.
                    forEach(state.views, function(view, name) {
                        var injectables = view.resolve && view.resolve !== state.resolve ? view.resolve : {};
                        injectables.$template = [
                            function() {
                                return $view.load(name, {
                                    view: view,
                                    locals: dst.globals,
                                    params: $stateParams,
                                    notify: options.notify
                                }) || "";
                            }
                        ];
                        viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function(result) {
                            // References to the controller (only instantiated at link time)
                            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
                                var injectLocals = angular.extend({}, injectables, dst.globals);
                                result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
                            } else result.$$controller = view.controller;
                            // Provide access to the state itself for internal use
                            result.$$state = state;
                            result.$$controllerAs = view.controllerAs;
                            result.$$resolveAs = view.resolveAs;
                            dst[name] = result;
                        }));
                    });
                    return $q.all(viewsPromises).then(function() {
                        return dst.globals;
                    });
                }
                // Wait for all the promises and then return the activation object
                return $q.all(promises).then(resolveViews).then(function(values) {
                    return dst;
                });
            }
            return $state;
        }
        function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
            // Return true if there are no differences in non-search (path/object) params, false if there are differences
            function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
                // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
                function notSearchParam(key) {
                    return fromAndToState.params[key].location != "search";
                }
                var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
                var nonQueryParams = pick.apply({}, [
                    fromAndToState.params
                ].concat(nonQueryParamKeys));
                var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
                return nonQueryParamSet.$$equals(fromParams, toParams);
            }
            // If reload was not explicitly requested
            // and we're transitioning to the same state we're already in
            // and    the locals didn't change
            //     or they changed in a way that doesn't merit reloading
            //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
            // Then return true.
            if (!options.reload && to === from && (locals === from.locals || to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams))) return true;
        }
    }
    angular.module("ui.router.state").factory("$stateParams", function() {
        return {};
    }).constant("$state.runtime", {
        autoinject: true
    }).provider("$state", $StateProvider)// Inject $state to initialize when entering runtime. #2574
    .run([
        "$injector",
        function($injector) {
            // Allow tests (stateSpec.js) to turn this off by defining this constant
            if ($injector.get("$state.runtime").autoinject) $injector.get("$state");
        }
    ]);
    $ViewProvider.$inject = [];
    function $ViewProvider() {
        this.$get = $get;
        /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */ $get.$inject = [
            "$rootScope",
            "$templateFactory"
        ];
        function $get($rootScope, $templateFactory) {
            return {
                // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
                /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */ load: function load(name, options) {
                    var result, defaults = {
                        template: null,
                        controller: null,
                        view: null,
                        locals: null,
                        notify: true,
                        async: true,
                        params: {}
                    };
                    options = extend(defaults, options);
                    if (options.view) result = $templateFactory.fromConfig(options.view, options.params, options.locals);
                    return result;
                }
            };
        }
    }
    angular.module("ui.router.state").provider("$view", $ViewProvider);
    /**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */ function $ViewScrollProvider() {
        var useAnchorScroll = false;
        /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */ this.useAnchorScroll = function() {
            useAnchorScroll = true;
        };
        /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */ this.$get = [
            "$anchorScroll",
            "$timeout",
            function($anchorScroll, $timeout) {
                if (useAnchorScroll) return $anchorScroll;
                return function($element) {
                    return $timeout(function() {
                        $element[0].scrollIntoView();
                    }, 0, false);
                };
            }
        ];
    }
    angular.module("ui.router.state").provider("$uiViewScroll", $ViewScrollProvider);
    /**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @example
 * A view can be unnamed or named.
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre>
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * </pre>
 *
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * Example usage of $resolve in a view template
 * <pre>
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * </pre>
 */ $ViewDirective.$inject = [
        "$state",
        "$injector",
        "$uiViewScroll",
        "$interpolate",
        "$q"
    ];
    function $ViewDirective($state, $injector, $uiViewScroll, $interpolate, $q) {
        function getService() {
            return $injector.has ? function(service) {
                return $injector.has(service) ? $injector.get(service) : null;
            } : function(service) {
                try {
                    return $injector.get(service);
                } catch (e) {
                    return null;
                }
            };
        }
        var service = getService(), $animator = service("$animator"), $animate = service("$animate");
        // Returns a set of DOM manipulation functions based on which Angular version
        // it should use
        function getRenderer(attrs, scope) {
            var statics = function() {
                return {
                    enter: function(element, target, cb) {
                        target.after(element);
                        cb();
                    },
                    leave: function(element, cb) {
                        element.remove();
                        cb();
                    }
                };
            };
            if ($animate) return {
                enter: function(element, target, cb) {
                    if (angular.version.minor > 2) $animate.enter(element, null, target).then(cb);
                    else $animate.enter(element, null, target, cb);
                },
                leave: function(element, cb) {
                    if (angular.version.minor > 2) $animate.leave(element).then(cb);
                    else $animate.leave(element, cb);
                }
            };
            if ($animator) {
                var animate = $animator && $animator(scope, attrs);
                return {
                    enter: function(element, target, cb) {
                        animate.enter(element, null, target);
                        cb();
                    },
                    leave: function(element, cb) {
                        animate.leave(element);
                        cb();
                    }
                };
            }
            return statics();
        }
        var directive = {
            restrict: "ECA",
            terminal: true,
            priority: 400,
            transclude: "element",
            compile: function(tElement, tAttrs, $transclude) {
                return function(scope, $element, attrs) {
                    var previousEl, currentEl, currentScope, latestLocals, onloadExp = attrs.onload || "", autoScrollExp = attrs.autoscroll, renderer = getRenderer(attrs, scope), inherited = $element.inheritedData("$uiView");
                    scope.$on("$stateChangeSuccess", function() {
                        updateView(false);
                    });
                    updateView(true);
                    function cleanupLastView() {
                        if (previousEl) {
                            previousEl.remove();
                            previousEl = null;
                        }
                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentEl) {
                            var $uiViewData = currentEl.data("$uiViewAnim");
                            renderer.leave(currentEl, function() {
                                $uiViewData.$$animLeave.resolve();
                                previousEl = null;
                            });
                            previousEl = currentEl;
                            currentEl = null;
                        }
                    }
                    function updateView(firstTime) {
                        var newScope, name = getUiViewName(scope, attrs, $element, $interpolate), previousLocals = name && $state.$current && $state.$current.locals[name];
                        if (!firstTime && previousLocals === latestLocals) return; // nothing to do
                        newScope = scope.$new();
                        latestLocals = $state.$current.locals[name];
                        /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */ newScope.$emit("$viewContentLoading", name);
                        var clone = $transclude(newScope, function(clone) {
                            var animEnter = $q.defer(), animLeave = $q.defer();
                            var viewAnimData = {
                                $animEnter: animEnter.promise,
                                $animLeave: animLeave.promise,
                                $$animLeave: animLeave
                            };
                            clone.data("$uiViewAnim", viewAnimData);
                            renderer.enter(clone, $element, function onUiViewEnter() {
                                animEnter.resolve();
                                if (currentScope) currentScope.$emit("$viewContentAnimationEnded");
                                if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) $uiViewScroll(clone);
                            });
                            cleanupLastView();
                        });
                        currentEl = clone;
                        currentScope = newScope;
                        /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */ currentScope.$emit("$viewContentLoaded", name);
                        currentScope.$eval(onloadExp);
                    }
                };
            }
        };
        return directive;
    }
    $ViewDirectiveFill.$inject = [
        "$compile",
        "$controller",
        "$state",
        "$interpolate"
    ];
    function $ViewDirectiveFill($compile, $controller, $state, $interpolate) {
        return {
            restrict: "ECA",
            priority: -400,
            compile: function(tElement) {
                var initial = tElement.html();
                if (tElement.empty) tElement.empty();
                else // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
                tElement[0].innerHTML = null;
                return function(scope, $element, attrs) {
                    var current = $state.$current, name = getUiViewName(scope, attrs, $element, $interpolate), locals = current && current.locals[name];
                    if (!locals) {
                        $element.html(initial);
                        $compile($element.contents())(scope);
                        return;
                    }
                    $element.data("$uiView", {
                        name: name,
                        state: locals.$$state
                    });
                    $element.html(locals.$template ? locals.$template : initial);
                    var resolveData = angular.extend({}, locals);
                    scope[locals.$$resolveAs] = resolveData;
                    var link = $compile($element.contents());
                    if (locals.$$controller) {
                        locals.$scope = scope;
                        locals.$element = $element;
                        var controller = $controller(locals.$$controller, locals);
                        if (locals.$$controllerAs) {
                            scope[locals.$$controllerAs] = controller;
                            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
                        }
                        if (isFunction(controller.$onInit)) controller.$onInit();
                        $element.data("$ngControllerController", controller);
                        $element.children().data("$ngControllerController", controller);
                    }
                    link(scope);
                };
            }
        };
    }
    /**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */ function getUiViewName(scope, attrs, element, $interpolate) {
        var name = $interpolate(attrs.uiView || attrs.name || "")(scope);
        var uiViewCreatedBy = element.inheritedData("$uiView");
        return name.indexOf("@") >= 0 ? name : name + "@" + (uiViewCreatedBy ? uiViewCreatedBy.state.name : "");
    }
    angular.module("ui.router.state").directive("uiView", $ViewDirective);
    angular.module("ui.router.state").directive("uiView", $ViewDirectiveFill);
    function parseStateRef(ref, current) {
        var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
        if (preparsed) ref = current + "(" + preparsed[1] + ")";
        parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
        if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
        return {
            state: parsed[1],
            paramExpr: parsed[3] || null
        };
    }
    function stateContext(el) {
        var stateData = el.parent().inheritedData("$uiView");
        if (stateData && stateData.state && stateData.state.name) return stateData.state;
    }
    function getTypeInfo(el) {
        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var isSvg = Object.prototype.toString.call(el.prop("href")) === "[object SVGAnimatedString]";
        var isForm = el[0].nodeName === "FORM";
        return {
            attr: isForm ? "action" : isSvg ? "xlink:href" : "href",
            isAnchor: el.prop("tagName").toUpperCase() === "A",
            clickable: !isForm
        };
    }
    function clickHook(el, $state, $timeout, type, current) {
        return function(e) {
            var button = e.which || e.button, target = current();
            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr("target"))) {
                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
                var transition = $timeout(function() {
                    $state.go(target.state, target.params, target.options);
                });
                e.preventDefault();
                // if the state has no URL, ignore one preventDefault from the <a> directive.
                var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
                e.preventDefault = function() {
                    if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
                };
            }
        };
    }
    function defaultOpts(el, $state) {
        return {
            relative: stateContext(el) || $state.$current,
            inherit: true
        };
    }
    /**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */ $StateRefDirective.$inject = [
        "$state",
        "$timeout"
    ];
    function $StateRefDirective($state, $timeout) {
        return {
            restrict: "A",
            require: [
                "?^uiSrefActive",
                "?^uiSrefActiveEq"
            ],
            link: function(scope, element, attrs, uiSrefActive) {
                var ref = parseStateRef(attrs.uiSref, $state.current.name);
                var def = {
                    state: ref.state,
                    href: null,
                    params: null
                };
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
                var update = function(val) {
                    if (val) def.params = angular.copy(val);
                    def.href = $state.href(ref.state, def.params, def.options);
                    if (unlinkInfoFn) unlinkInfoFn();
                    if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
                    if (def.href !== null) attrs.$set(type.attr, def.href);
                };
                if (ref.paramExpr) {
                    scope.$watch(ref.paramExpr, function(val) {
                        if (val !== def.params) update(val);
                    }, true);
                    def.params = angular.copy(scope.$eval(ref.paramExpr));
                }
                update();
                if (!type.clickable) return;
                hookFn = clickHook(element, $state, $timeout, type, function() {
                    return def;
                });
                element[element.on ? "on" : "bind"]("click", hookFn);
                scope.$on("$destroy", function() {
                    element[element.off ? "off" : "unbind"]("click", hookFn);
                });
            }
        };
    }
    /**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */ $StateRefDynamicDirective.$inject = [
        "$state",
        "$timeout"
    ];
    function $StateRefDynamicDirective($state, $timeout) {
        return {
            restrict: "A",
            require: [
                "?^uiSrefActive",
                "?^uiSrefActiveEq"
            ],
            link: function(scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var group = [
                    attrs.uiState,
                    attrs.uiStateParams || null,
                    attrs.uiStateOpts || null
                ];
                var watch = "[" + group.map(function(val) {
                    return val || "null";
                }).join(", ") + "]";
                var def = {
                    state: null,
                    params: null,
                    options: null,
                    href: null
                };
                var unlinkInfoFn = null;
                var hookFn;
                function runStateRefLink(group) {
                    def.state = group[0];
                    def.params = group[1];
                    def.options = group[2];
                    def.href = $state.href(def.state, def.params, def.options);
                    if (unlinkInfoFn) unlinkInfoFn();
                    if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
                    if (def.href) attrs.$set(type.attr, def.href);
                }
                scope.$watch(watch, runStateRefLink, true);
                runStateRefLink(scope.$eval(watch));
                if (!type.clickable) return;
                hookFn = clickHook(element, $state, $timeout, type, function() {
                    return def;
                });
                element[element.on ? "on" : "bind"]("click", hookFn);
                scope.$on("$destroy", function() {
                    element[element.off ? "off" : "unbind"]("click", hookFn);
                });
            }
        };
    }
    /**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */ /**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */ $StateRefActiveDirective.$inject = [
        "$state",
        "$stateParams",
        "$interpolate"
    ];
    function $StateRefActiveDirective($state, $stateParams, $interpolate) {
        return {
            restrict: "A",
            controller: [
                "$scope",
                "$element",
                "$attrs",
                "$timeout",
                function($scope, $element, $attrs, $timeout) {
                    var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
                    // There probably isn't much point in $observing this
                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
                    // slight difference in logic routing
                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || "", false)($scope);
                    try {
                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                    } catch (e) {
                    // Do nothing. uiSrefActive is not a valid expression.
                    // Fall back to using $interpolate below
                    }
                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || "", false)($scope);
                    if (isObject(uiSrefActive)) forEach(uiSrefActive, function(stateOrName, activeClass) {
                        if (isString(stateOrName)) {
                            var ref = parseStateRef(stateOrName, $state.current.name);
                            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                        }
                    });
                    // Allow uiSref to communicate with uiSrefActive[Equals]
                    this.$$addStateInfo = function(newState, newParams) {
                        // we already got an explicit state provided by ui-sref-active, so we
                        // shadow the one that comes from ui-sref
                        if (isObject(uiSrefActive) && states.length > 0) return;
                        var deregister = addState(newState, newParams, uiSrefActive);
                        update();
                        return deregister;
                    };
                    $scope.$on("$stateChangeSuccess", update);
                    function addState(stateName, stateParams, activeClass) {
                        var state = $state.get(stateName, stateContext($element));
                        var stateHash = createStateHash(stateName, stateParams);
                        var stateInfo = {
                            state: state || {
                                name: stateName
                            },
                            params: stateParams,
                            hash: stateHash
                        };
                        states.push(stateInfo);
                        activeClasses[stateHash] = activeClass;
                        return function removeState() {
                            var idx = states.indexOf(stateInfo);
                            if (idx !== -1) states.splice(idx, 1);
                        };
                    }
                    /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */ function createStateHash(state, params) {
                        if (!isString(state)) throw new Error("state should be a string");
                        if (isObject(params)) return state + toJson(params);
                        params = $scope.$eval(params);
                        if (isObject(params)) return state + toJson(params);
                        return state;
                    }
                    // Update route state
                    function update() {
                        for(var i = 0; i < states.length; i++){
                            if (anyMatch(states[i].state, states[i].params)) addClass($element, activeClasses[states[i].hash]);
                            else removeClass($element, activeClasses[states[i].hash]);
                            if (exactMatch(states[i].state, states[i].params)) addClass($element, activeEqClass);
                            else removeClass($element, activeEqClass);
                        }
                    }
                    function addClass(el, className) {
                        $timeout(function() {
                            el.addClass(className);
                        });
                    }
                    function removeClass(el, className) {
                        el.removeClass(className);
                    }
                    function anyMatch(state, params) {
                        return $state.includes(state.name, params);
                    }
                    function exactMatch(state, params) {
                        return $state.is(state.name, params);
                    }
                    update();
                }
            ]
        };
    }
    angular.module("ui.router.state").directive("uiSref", $StateRefDirective).directive("uiSrefActive", $StateRefActiveDirective).directive("uiSrefActiveEq", $StateRefActiveDirective).directive("uiState", $StateRefDynamicDirective);
    /**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */ $IsStateFilter.$inject = [
        "$state"
    ];
    function $IsStateFilter($state) {
        var isFilter = function(state, params) {
            return $state.is(state, params);
        };
        isFilter.$stateful = true;
        return isFilter;
    }
    /**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */ $IncludedByStateFilter.$inject = [
        "$state"
    ];
    function $IncludedByStateFilter($state) {
        var includesFilter = function(state, params, options) {
            return $state.includes(state, params, options);
        };
        includesFilter.$stateful = true;
        return includesFilter;
    }
    angular.module("ui.router.state").filter("isState", $IsStateFilter).filter("includedByState", $IncludedByStateFilter);
})(window, window.angular);

},{}],"gIegj":[function(require,module,exports) {
/**
 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
 * @version v0.2.2 - 2015-02-18
 * @link http://angular-ui.github.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ angular.module("ui.alias", []).config([
    "$compileProvider",
    "uiAliasConfig",
    function($compileProvider, uiAliasConfig) {
        "use strict";
        uiAliasConfig = uiAliasConfig || {};
        angular.forEach(uiAliasConfig, function(config, alias) {
            if (angular.isString(config)) config = {
                replace: true,
                template: config
            };
            $compileProvider.directive(alias, function() {
                return config;
            });
        });
    }
]);
/**
 * General-purpose Event binding. Bind any event not natively supported by Angular
 * Pass an object with keynames for events to ui-event
 * Allows $event object and $params object to be passed
 *
 * @example <input ui-event="{ focus : 'counter++', blur : 'someCallback()' }">
 * @example <input ui-event="{ myCustomEvent : 'myEventHandler($event, $params)'}">
 *
 * @param ui-event {string|object literal} The event to bind to as a string or a hash of events with their callbacks
 */ angular.module("ui.event", []).directive("uiEvent", [
    "$parse",
    function($parse) {
        "use strict";
        return function($scope, elm, attrs) {
            var events = $scope.$eval(attrs.uiEvent);
            angular.forEach(events, function(uiEvent, eventName) {
                var fn = $parse(uiEvent);
                elm.bind(eventName, function(evt) {
                    var params = Array.prototype.slice.call(arguments);
                    //Take out first paramater (event object);
                    params = params.splice(1);
                    fn($scope, {
                        $event: evt,
                        $params: params
                    });
                    if (!$scope.$$phase) $scope.$apply();
                });
            });
        };
    }
]);
/**
 * A replacement utility for internationalization very similar to sprintf.
 *
 * @param replace {mixed} The tokens to replace depends on type
 *  string: all instances of $0 will be replaced
 *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order
 *  object: all attributes will be iterated through, with :key being replaced with its corresponding value
 * @return string
 *
 * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })
 * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])
 * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')
 */ angular.module("ui.format", []).filter("format", function() {
    "use strict";
    return function(value, replace) {
        var target = value;
        if (angular.isString(target) && replace !== undefined) {
            if (!angular.isArray(replace) && !angular.isObject(replace)) replace = [
                replace
            ];
            if (angular.isArray(replace)) {
                var rlen = replace.length;
                var rfx = function(str, i) {
                    i = parseInt(i, 10);
                    return i >= 0 && i < rlen ? replace[i] : str;
                };
                target = target.replace(/\$([0-9]+)/g, rfx);
            } else angular.forEach(replace, function(value, key) {
                target = target.split(":" + key).join(value);
            });
        }
        return target;
    };
});
/**
 * Wraps the
 * @param text {string} haystack to search through
 * @param search {string} needle to search for
 * @param [caseSensitive] {boolean} optional boolean to use case-sensitive searching
 */ angular.module("ui.highlight", []).filter("highlight", function() {
    "use strict";
    return function(text, search, caseSensitive) {
        if (text && (search || angular.isNumber(search))) {
            text = text.toString();
            search = search.toString();
            if (caseSensitive) return text.split(search).join('<span class="ui-match">' + search + "</span>");
            else return text.replace(new RegExp(search, "gi"), '<span class="ui-match">$&</span>');
        } else return text;
    };
});
// modeled after: angular-1.0.7/src/ng/directive/ngInclude.js
angular.module("ui.include", []).directive("uiInclude", [
    "$http",
    "$templateCache",
    "$anchorScroll",
    "$compile",
    function($http, $templateCache, $anchorScroll, $compile) {
        "use strict";
        return {
            restrict: "ECA",
            terminal: true,
            compile: function(element, attr) {
                var srcExp = attr.uiInclude || attr.src, fragExp = attr.fragment || "", onloadExp = attr.onload || "", autoScrollExp = attr.autoscroll;
                return function(scope, element) {
                    var changeCounter = 0, childScope;
                    var clearContent = function() {
                        if (childScope) {
                            childScope.$destroy();
                            childScope = null;
                        }
                        element.html("");
                    };
                    function ngIncludeWatchAction() {
                        var thisChangeId = ++changeCounter;
                        var src = scope.$eval(srcExp);
                        var fragment = scope.$eval(fragExp);
                        if (src) $http.get(src, {
                            cache: $templateCache
                        }).success(function(response) {
                            if (thisChangeId !== changeCounter) return;
                            if (childScope) childScope.$destroy();
                            childScope = scope.$new();
                            var contents;
                            if (fragment) contents = angular.element("<div/>").html(response).find(fragment);
                            else contents = angular.element("<div/>").html(response).contents();
                            element.html(contents);
                            $compile(contents)(childScope);
                            if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) $anchorScroll();
                            childScope.$emit("$includeContentLoaded");
                            scope.$eval(onloadExp);
                        }).error(function() {
                            if (thisChangeId === changeCounter) clearContent();
                        });
                        else clearContent();
                    }
                    scope.$watch(fragExp, ngIncludeWatchAction);
                    scope.$watch(srcExp, ngIncludeWatchAction);
                };
            }
        };
    }
]);
/**
 * Provides an easy way to toggle a checkboxes indeterminate property
 *
 * @example <input type="checkbox" ui-indeterminate="isUnkown">
 */ angular.module("ui.indeterminate", []).directive("uiIndeterminate", [
    function() {
        "use strict";
        return {
            compile: function(tElm, tAttrs) {
                if (!tAttrs.type || tAttrs.type.toLowerCase() !== "checkbox") return angular.noop;
                return function($scope, elm, attrs) {
                    $scope.$watch(attrs.uiIndeterminate, function(newVal) {
                        elm[0].indeterminate = !!newVal;
                    });
                };
            }
        };
    }
]);
/**
 * Converts variable-esque naming conventions to something presentational, capitalized words separated by space.
 * @param {String} value The value to be parsed and prettified.
 * @param {String} [inflector] The inflector to use. Default: humanize.
 * @return {String}
 * @example {{ 'Here Is my_phoneNumber' | inflector:'humanize' }} => Here Is My Phone Number
 *          {{ 'Here Is my_phoneNumber' | inflector:'underscore' }} => here_is_my_phone_number
 *          {{ 'Here Is my_phoneNumber' | inflector:'variable' }} => hereIsMyPhoneNumber
 */ angular.module("ui.inflector", []).filter("inflector", function() {
    "use strict";
    function tokenize(text) {
        text = text.replace(/([A-Z])|([\-|\_])/g, function(_, $1) {
            return " " + ($1 || "");
        });
        return text.replace(/\s\s+/g, " ").trim().toLowerCase().split(" ");
    }
    function capitalizeTokens(tokens) {
        var result = [];
        angular.forEach(tokens, function(token) {
            result.push(token.charAt(0).toUpperCase() + token.substr(1));
        });
        return result;
    }
    var inflectors = {
        humanize: function(value) {
            return capitalizeTokens(tokenize(value)).join(" ");
        },
        underscore: function(value) {
            return tokenize(value).join("_");
        },
        variable: function(value) {
            value = tokenize(value);
            value = value[0] + capitalizeTokens(value.slice(1)).join("");
            return value;
        }
    };
    return function(text, inflector) {
        if (inflector !== false && angular.isString(text)) {
            inflector = inflector || "humanize";
            return inflectors[inflector](text);
        } else return text;
    };
});
/**
 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
 *
 * It is possible to specify a default set of parameters for each jQuery plugin.
 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
 * Unfortunately, at this time you can only pre-define the first parameter.
 * @example { jq : { datepicker : { showOn:'click' } } }
 *
 * @param ui-jq {string} The $elm.[pluginName]() to call.
 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
 *     Multiple parameters can be separated by commas
 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
 *
 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
 */ angular.module("ui.jq", []).value("uiJqConfig", {}).directive("uiJq", [
    "uiJqConfig",
    "$timeout",
    function uiJqInjectingFunction(uiJqConfig, $timeout) {
        "use strict";
        return {
            restrict: "A",
            compile: function uiJqCompilingFunction(tElm, tAttrs) {
                if (!angular.isFunction(tElm[tAttrs.uiJq])) throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
                var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];
                return function uiJqLinkingFunction(scope, elm, attrs) {
                    // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
                    if (attrs.ngModel && elm.is("select,input,textarea")) elm.bind("change", function() {
                        elm.trigger("input");
                    });
                    function createLinkOptions() {
                        var linkOptions = [];
                        // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
                        if (attrs.uiOptions) {
                            linkOptions = scope.$eval("[" + attrs.uiOptions + "]");
                            if (angular.isObject(options) && angular.isObject(linkOptions[0])) linkOptions[0] = angular.extend({}, options, linkOptions[0]);
                        } else if (options) linkOptions = [
                            options
                        ];
                        return linkOptions;
                    }
                    // Call jQuery method and pass relevant options
                    function callPlugin() {
                        $timeout(function() {
                            elm[attrs.uiJq].apply(elm, createLinkOptions());
                        }, 0, false);
                    }
                    // If ui-refresh is used, re-fire the the method upon every change
                    if (attrs.uiRefresh) scope.$watch(attrs.uiRefresh, function() {
                        callPlugin();
                    });
                    callPlugin();
                };
            }
        };
    }
]);
angular.module("ui.keypress", []).factory("keypressHelper", [
    "$parse",
    function keypress($parse) {
        "use strict";
        var keysByCode = {
            8: "backspace",
            9: "tab",
            13: "enter",
            27: "esc",
            32: "space",
            33: "pageup",
            34: "pagedown",
            35: "end",
            36: "home",
            37: "left",
            38: "up",
            39: "right",
            40: "down",
            45: "insert",
            46: "delete"
        };
        var capitaliseFirstLetter = function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };
        return function(mode, scope, elm, attrs) {
            var params, combinations = [];
            params = scope.$eval(attrs["ui" + capitaliseFirstLetter(mode)]);
            // Prepare combinations for simple checking
            angular.forEach(params, function(v, k) {
                var combination, expression;
                expression = $parse(v);
                angular.forEach(k.split(" "), function(variation) {
                    combination = {
                        expression: expression,
                        keys: {}
                    };
                    angular.forEach(variation.split("-"), function(value) {
                        combination.keys[value] = true;
                    });
                    combinations.push(combination);
                });
            });
            // Check only matching of pressed keys one of the conditions
            elm.bind(mode, function(event) {
                // No need to do that inside the cycle
                var metaPressed = !!(event.metaKey && !event.ctrlKey);
                var altPressed = !!event.altKey;
                var ctrlPressed = !!event.ctrlKey;
                var shiftPressed = !!event.shiftKey;
                var keyCode = event.keyCode;
                // normalize keycodes
                if (mode === "keypress" && !shiftPressed && keyCode >= 97 && keyCode <= 122) keyCode = keyCode - 32;
                // Iterate over prepared combinations
                angular.forEach(combinations, function(combination) {
                    var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];
                    var metaRequired = !!combination.keys.meta;
                    var altRequired = !!combination.keys.alt;
                    var ctrlRequired = !!combination.keys.ctrl;
                    var shiftRequired = !!combination.keys.shift;
                    if (mainKeyPressed && metaRequired === metaPressed && altRequired === altPressed && ctrlRequired === ctrlPressed && shiftRequired === shiftPressed) // Run the function
                    scope.$apply(function() {
                        combination.expression(scope, {
                            "$event": event
                        });
                    });
                });
            });
        };
    }
]);
/**
 * Bind one or more handlers to particular keys or their combination
 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
 **/ angular.module("ui.keypress").directive("uiKeydown", [
    "keypressHelper",
    function(keypressHelper) {
        "use strict";
        return {
            link: function(scope, elm, attrs) {
                keypressHelper("keydown", scope, elm, attrs);
            }
        };
    }
]);
angular.module("ui.keypress").directive("uiKeypress", [
    "keypressHelper",
    function(keypressHelper) {
        "use strict";
        return {
            link: function(scope, elm, attrs) {
                keypressHelper("keypress", scope, elm, attrs);
            }
        };
    }
]);
angular.module("ui.keypress").directive("uiKeyup", [
    "keypressHelper",
    function(keypressHelper) {
        "use strict";
        return {
            link: function(scope, elm, attrs) {
                keypressHelper("keyup", scope, elm, attrs);
            }
        };
    }
]);
/*
 Attaches input mask onto input element
 */ angular.module("ui.mask", []).value("uiMaskConfig", {
    "maskDefinitions": {
        "9": /\d/,
        "A": /[a-zA-Z]/,
        "*": /[a-zA-Z0-9]/
    },
    "clearOnBlur": true
}).directive("uiMask", [
    "uiMaskConfig",
    "$parse",
    function(maskConfig, $parse) {
        "use strict";
        return {
            priority: 100,
            require: "ngModel",
            restrict: "A",
            compile: function uiMaskCompilingFunction() {
                var options = maskConfig;
                return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
                    var maskProcessed = false, eventsBound = false, maskCaretMap, maskPatterns, maskPlaceholder, maskComponents, // Minimum required length of the value to be considered valid
                    minRequiredLength, value, valueMasked, isValid, // Vars for initializing/uninitializing
                    originalPlaceholder = iAttrs.placeholder, originalMaxlength = iAttrs.maxlength, // Vars used exclusively in eventHandler()
                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;
                    function initialize(maskAttr) {
                        if (!angular.isDefined(maskAttr)) return uninitialize();
                        processRawMask(maskAttr);
                        if (!maskProcessed) return uninitialize();
                        initializeElement();
                        bindEventListeners();
                        return true;
                    }
                    function initPlaceholder(placeholderAttr) {
                        if (!angular.isDefined(placeholderAttr)) return;
                        maskPlaceholder = placeholderAttr;
                        // If the mask is processed, then we need to update the value
                        if (maskProcessed) eventHandler();
                    }
                    function formatter(fromModelValue) {
                        if (!maskProcessed) return fromModelValue;
                        value = unmaskValue(fromModelValue || "");
                        isValid = validateValue(value);
                        controller.$setValidity("mask", isValid);
                        return isValid && value.length ? maskValue(value) : undefined;
                    }
                    function parser(fromViewValue) {
                        if (!maskProcessed) return fromViewValue;
                        value = unmaskValue(fromViewValue || "");
                        isValid = validateValue(value);
                        // We have to set viewValue manually as the reformatting of the input
                        // value performed by eventHandler() doesn't happen until after
                        // this parser is called, which causes what the user sees in the input
                        // to be out-of-sync with what the controller's $viewValue is set to.
                        controller.$viewValue = value.length ? maskValue(value) : "";
                        controller.$setValidity("mask", isValid);
                        if (value === "" && iAttrs.required) controller.$setValidity("required", !controller.$error.required);
                        return isValid ? value : undefined;
                    }
                    var linkOptions = {};
                    if (iAttrs.uiOptions) {
                        linkOptions = scope.$eval("[" + iAttrs.uiOptions + "]");
                        if (angular.isObject(linkOptions[0])) // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
                        linkOptions = function(original, current) {
                            for(var i in original)if (Object.prototype.hasOwnProperty.call(original, i)) {
                                if (current[i] === undefined) current[i] = angular.copy(original[i]);
                                else angular.extend(current[i], original[i]);
                            }
                            return current;
                        }(options, linkOptions[0]);
                    } else linkOptions = options;
                    iAttrs.$observe("uiMask", initialize);
                    iAttrs.$observe("placeholder", initPlaceholder);
                    var modelViewValue = false;
                    iAttrs.$observe("modelViewValue", function(val) {
                        if (val === "true") modelViewValue = true;
                    });
                    scope.$watch(iAttrs.ngModel, function(val) {
                        if (modelViewValue && val) {
                            var model = $parse(iAttrs.ngModel);
                            model.assign(scope, controller.$viewValue);
                        }
                    });
                    controller.$formatters.push(formatter);
                    controller.$parsers.push(parser);
                    function uninitialize() {
                        maskProcessed = false;
                        unbindEventListeners();
                        if (angular.isDefined(originalPlaceholder)) iElement.attr("placeholder", originalPlaceholder);
                        else iElement.removeAttr("placeholder");
                        if (angular.isDefined(originalMaxlength)) iElement.attr("maxlength", originalMaxlength);
                        else iElement.removeAttr("maxlength");
                        iElement.val(controller.$modelValue);
                        controller.$viewValue = controller.$modelValue;
                        return false;
                    }
                    function initializeElement() {
                        value = oldValueUnmasked = unmaskValue(controller.$viewValue || "");
                        valueMasked = oldValue = maskValue(value);
                        isValid = validateValue(value);
                        var viewValue = isValid && value.length ? valueMasked : "";
                        if (iAttrs.maxlength) iElement.attr("maxlength", maskCaretMap[maskCaretMap.length - 1] * 2);
                        iElement.attr("placeholder", maskPlaceholder);
                        iElement.val(viewValue);
                        controller.$viewValue = viewValue;
                    // Not using $setViewValue so we don't clobber the model value and dirty the form
                    // without any kind of user interaction.
                    }
                    function bindEventListeners() {
                        if (eventsBound) return;
                        iElement.bind("blur", blurHandler);
                        iElement.bind("mousedown mouseup", mouseDownUpHandler);
                        iElement.bind("input keyup click focus", eventHandler);
                        eventsBound = true;
                    }
                    function unbindEventListeners() {
                        if (!eventsBound) return;
                        iElement.unbind("blur", blurHandler);
                        iElement.unbind("mousedown", mouseDownUpHandler);
                        iElement.unbind("mouseup", mouseDownUpHandler);
                        iElement.unbind("input", eventHandler);
                        iElement.unbind("keyup", eventHandler);
                        iElement.unbind("click", eventHandler);
                        iElement.unbind("focus", eventHandler);
                        eventsBound = false;
                    }
                    function validateValue(value) {
                        // Zero-length value validity is ngRequired's determination
                        return value.length ? value.length >= minRequiredLength : true;
                    }
                    function unmaskValue(value) {
                        var valueUnmasked = "", maskPatternsCopy = maskPatterns.slice();
                        // Preprocess by stripping mask components from value
                        value = value.toString();
                        angular.forEach(maskComponents, function(component) {
                            value = value.replace(component, "");
                        });
                        angular.forEach(value.split(""), function(chr) {
                            if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
                                valueUnmasked += chr;
                                maskPatternsCopy.shift();
                            }
                        });
                        return valueUnmasked;
                    }
                    function maskValue(unmaskedValue) {
                        var valueMasked = "", maskCaretMapCopy = maskCaretMap.slice();
                        angular.forEach(maskPlaceholder.split(""), function(chr, i) {
                            if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
                                valueMasked += unmaskedValue.charAt(0) || "_";
                                unmaskedValue = unmaskedValue.substr(1);
                                maskCaretMapCopy.shift();
                            } else valueMasked += chr;
                        });
                        return valueMasked;
                    }
                    function getPlaceholderChar(i) {
                        var placeholder = iAttrs.placeholder;
                        if (typeof placeholder !== "undefined" && placeholder[i]) return placeholder[i];
                        else return "_";
                    }
                    // Generate array of mask components that will be stripped from a masked value
                    // before processing to prevent mask components from being added to the unmasked value.
                    // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
                    // If a maskable char is followed by a mask char and has a mask
                    // char behind it, we'll split it into it's own component so if
                    // a user is aggressively deleting in the input and a char ahead
                    // of the maskable char gets deleted, we'll still be able to strip
                    // it in the unmaskValue() preprocessing.
                    function getMaskComponents() {
                        return maskPlaceholder.replace(/[_]+/g, "_").replace(/([^_]+)([a-zA-Z0-9])([^_])/g, "$1$2_$3").split("_");
                    }
                    function processRawMask(mask) {
                        var characterCount = 0;
                        maskCaretMap = [];
                        maskPatterns = [];
                        maskPlaceholder = "";
                        if (typeof mask === "string") {
                            minRequiredLength = 0;
                            var isOptional = false, splitMask = mask.split("");
                            angular.forEach(splitMask, function(chr, i) {
                                if (linkOptions.maskDefinitions[chr]) {
                                    maskCaretMap.push(characterCount);
                                    maskPlaceholder += getPlaceholderChar(i);
                                    maskPatterns.push(linkOptions.maskDefinitions[chr]);
                                    characterCount++;
                                    if (!isOptional) minRequiredLength++;
                                } else if (chr === "?") isOptional = true;
                                else {
                                    maskPlaceholder += chr;
                                    characterCount++;
                                }
                            });
                        }
                        // Caret position immediately following last position is valid.
                        maskCaretMap.push(maskCaretMap.slice().pop() + 1);
                        maskComponents = getMaskComponents();
                        maskProcessed = maskCaretMap.length > 1 ? true : false;
                    }
                    function blurHandler() {
                        if (linkOptions.clearOnBlur) {
                            oldCaretPosition = 0;
                            oldSelectionLength = 0;
                            if (!isValid || value.length === 0) {
                                valueMasked = "";
                                iElement.val("");
                                scope.$apply(function() {
                                    controller.$setViewValue("");
                                });
                            }
                        }
                    }
                    function mouseDownUpHandler(e) {
                        if (e.type === "mousedown") iElement.bind("mouseout", mouseoutHandler);
                        else iElement.unbind("mouseout", mouseoutHandler);
                    }
                    iElement.bind("mousedown mouseup", mouseDownUpHandler);
                    function mouseoutHandler() {
                        /*jshint validthis: true */ oldSelectionLength = getSelectionLength(this);
                        iElement.unbind("mouseout", mouseoutHandler);
                    }
                    function eventHandler(e) {
                        /*jshint validthis: true */ e = e || {};
                        // Allows more efficient minification
                        var eventWhich = e.which, eventType = e.type;
                        // Prevent shift and ctrl from mucking with old values
                        if (eventWhich === 16 || eventWhich === 91) return;
                        var val = iElement.val(), valOld = oldValue, valMasked, valUnmasked = unmaskValue(val), valUnmaskedOld = oldValueUnmasked, valAltered = false, caretPos = getCaretPosition(this) || 0, caretPosOld = oldCaretPosition || 0, caretPosDelta = caretPos - caretPosOld, caretPosMin = maskCaretMap[0], caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(), selectionLenOld = oldSelectionLength || 0, isSelected = getSelectionLength(this) > 0, wasSelected = selectionLenOld > 0, // Case: Typing a character to overwrite a selection
                        isAddition = val.length > valOld.length || selectionLenOld && val.length > valOld.length - selectionLenOld, // Case: Delete and backspace behave identically on a selection
                        isDeletion = val.length < valOld.length || selectionLenOld && val.length === valOld.length - selectionLenOld, isSelection = eventWhich >= 37 && eventWhich <= 40 && e.shiftKey, isKeyLeftArrow = eventWhich === 37, // Necessary due to "input" event not providing a key code
                        isKeyBackspace = eventWhich === 8 || eventType !== "keyup" && isDeletion && caretPosDelta === -1, isKeyDelete = eventWhich === 46 || eventType !== "keyup" && isDeletion && caretPosDelta === 0 && !wasSelected, // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
                        // a character when clicking within a filled input.
                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === "click") && caretPos > caretPosMin;
                        oldSelectionLength = getSelectionLength(this);
                        // These events don't require any action
                        if (isSelection || isSelected && (eventType === "click" || eventType === "keyup")) return;
                        // Value Handling
                        // ==============
                        // User attempted to delete but raw value was unaffected--correct this grievous offense
                        if (eventType === "input" && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
                            while(isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos))caretPos--;
                            while(isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1)caretPos++;
                            var charIndex = maskCaretMap.indexOf(caretPos);
                            // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
                            valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
                            valAltered = true;
                        }
                        // Update values
                        valMasked = maskValue(valUnmasked);
                        oldValue = valMasked;
                        oldValueUnmasked = valUnmasked;
                        iElement.val(valMasked);
                        if (valAltered) // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.
                        scope.$apply(function() {
                            controller.$setViewValue(valUnmasked);
                        });
                        // Caret Repositioning
                        // ===================
                        // Ensure that typing always places caret ahead of typed character in cases where the first char of
                        // the input is a mask char and the caret is placed at the 0 position.
                        if (isAddition && caretPos <= caretPosMin) caretPos = caretPosMin + 1;
                        if (caretBumpBack) caretPos--;
                        // Make sure caret is within min and max position limits
                        caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
                        // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
                        while(!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax)caretPos += caretBumpBack ? -1 : 1;
                        if (caretBumpBack && caretPos < caretPosMax || isAddition && !isValidCaretPosition(caretPosOld)) caretPos++;
                        oldCaretPosition = caretPos;
                        setCaretPosition(this, caretPos);
                    }
                    function isValidCaretPosition(pos) {
                        return maskCaretMap.indexOf(pos) > -1;
                    }
                    function getCaretPosition(input) {
                        if (!input) return 0;
                        if (input.selectionStart !== undefined) return input.selectionStart;
                        else if (document.selection) {
                            // Curse you IE
                            input.focus();
                            var selection = document.selection.createRange();
                            selection.moveStart("character", input.value ? -input.value.length : 0);
                            return selection.text.length;
                        }
                        return 0;
                    }
                    function setCaretPosition(input, pos) {
                        if (!input) return 0;
                        if (input.offsetWidth === 0 || input.offsetHeight === 0) return; // Input's hidden
                        if (input.setSelectionRange) {
                            input.focus();
                            input.setSelectionRange(pos, pos);
                        } else if (input.createTextRange) {
                            // Curse you IE
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.moveEnd("character", pos);
                            range.moveStart("character", pos);
                            range.select();
                        }
                    }
                    function getSelectionLength(input) {
                        if (!input) return 0;
                        if (input.selectionStart !== undefined) return input.selectionEnd - input.selectionStart;
                        if (document.selection) return document.selection.createRange().text.length;
                        return 0;
                    }
                    // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
                    if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement /*, fromIndex */ ) {
                        if (this === null) throw new TypeError();
                        var t = Object(this);
                        var len = t.length >>> 0;
                        if (len === 0) return -1;
                        var n = 0;
                        if (arguments.length > 1) {
                            n = Number(arguments[1]);
                            if (n !== n) n = 0;
                            else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
                        }
                        if (n >= len) return -1;
                        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
                        for(; k < len; k++){
                            if (k in t && t[k] === searchElement) return k;
                        }
                        return -1;
                    };
                };
            }
        };
    }
]);
/**
 * Add a clear button to form inputs to reset their value
 */ angular.module("ui.reset", []).value("uiResetConfig", null).directive("uiReset", [
    "uiResetConfig",
    function(uiResetConfig) {
        "use strict";
        var resetValue = null;
        if (uiResetConfig !== undefined) resetValue = uiResetConfig;
        return {
            require: "ngModel",
            link: function(scope, elm, attrs, ctrl) {
                var aElement;
                aElement = angular.element('<a class="ui-reset" />');
                elm.wrap('<span class="ui-resetwrap" />').after(aElement);
                aElement.bind("click", function(e) {
                    e.preventDefault();
                    scope.$apply(function() {
                        if (attrs.uiReset) ctrl.$setViewValue(scope.$eval(attrs.uiReset));
                        else ctrl.$setViewValue(resetValue);
                        ctrl.$render();
                    });
                });
            }
        };
    }
]);
/**
 * Set a $uiRoute boolean to see if the current route matches
 */ angular.module("ui.route", []).directive("uiRoute", [
    "$location",
    "$parse",
    function($location, $parse) {
        "use strict";
        return {
            restrict: "AC",
            scope: true,
            compile: function(tElement, tAttrs) {
                var useProperty;
                if (tAttrs.uiRoute) useProperty = "uiRoute";
                else if (tAttrs.ngHref) useProperty = "ngHref";
                else if (tAttrs.href) useProperty = "href";
                else throw new Error("uiRoute missing a route or href property on " + tElement[0]);
                return function($scope, elm, attrs) {
                    var modelSetter = $parse(attrs.ngModel || attrs.routeModel || "$uiRoute").assign;
                    var watcher = angular.noop;
                    // Used by href and ngHref
                    function staticWatcher(newVal) {
                        var hash = newVal.indexOf("#");
                        if (hash > -1) newVal = newVal.substr(hash + 1);
                        watcher = function watchHref() {
                            modelSetter($scope, $location.path().indexOf(newVal) > -1);
                        };
                        watcher();
                    }
                    // Used by uiRoute
                    function regexWatcher(newVal) {
                        var hash = newVal.indexOf("#");
                        if (hash > -1) newVal = newVal.substr(hash + 1);
                        watcher = function watchRegex() {
                            var regexp = new RegExp("^" + newVal + "$", [
                                "i"
                            ]);
                            modelSetter($scope, regexp.test($location.path()));
                        };
                        watcher();
                    }
                    switch(useProperty){
                        case "uiRoute":
                            // if uiRoute={{}} this will be undefined, otherwise it will have a value and $observe() never gets triggered
                            if (attrs.uiRoute) regexWatcher(attrs.uiRoute);
                            else attrs.$observe("uiRoute", regexWatcher);
                            break;
                        case "ngHref":
                            // Setup watcher() every time ngHref changes
                            if (attrs.ngHref) staticWatcher(attrs.ngHref);
                            else attrs.$observe("ngHref", staticWatcher);
                            break;
                        case "href":
                            // Setup watcher()
                            staticWatcher(attrs.href);
                    }
                    $scope.$on("$routeChangeSuccess", function() {
                        watcher();
                    });
                    //Added for compatibility with ui-router
                    $scope.$on("$stateChangeSuccess", function() {
                        watcher();
                    });
                };
            }
        };
    }
]);
angular.module("ui.scroll.jqlite", [
    "ui.scroll"
]).service("jqLiteExtras", [
    "$log",
    "$window",
    function(console, window1) {
        "use strict";
        return {
            registerFor: function(element) {
                var convertToPx, css, getMeasurements, getStyle, getWidthHeight, isWindow, scrollTo;
                css = angular.element.prototype.css;
                element.prototype.css = function(name, value) {
                    var elem, self;
                    self = this;
                    elem = self[0];
                    if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) return css.call(self, name, value);
                };
                isWindow = function(obj) {
                    return obj && obj.document && obj.location && obj.alert && obj.setInterval;
                };
                scrollTo = function(self, direction, value) {
                    var elem, method, preserve, prop, _ref;
                    elem = self[0];
                    _ref = ({
                        top: [
                            "scrollTop",
                            "pageYOffset",
                            "scrollLeft"
                        ],
                        left: [
                            "scrollLeft",
                            "pageXOffset",
                            "scrollTop"
                        ]
                    })[direction], method = _ref[0], prop = _ref[1], preserve = _ref[2];
                    if (isWindow(elem)) {
                        if (angular.isDefined(value)) return elem.scrollTo(self[preserve].call(self), value);
                        else {
                            if (prop in elem) return elem[prop];
                            else return elem.document.documentElement[method];
                        }
                    } else {
                        if (angular.isDefined(value)) return elem[method] = value;
                        else return elem[method];
                    }
                };
                if (window1.getComputedStyle) {
                    getStyle = function(elem) {
                        return window1.getComputedStyle(elem, null);
                    };
                    convertToPx = function(elem, value) {
                        return parseFloat(value);
                    };
                } else {
                    getStyle = function(elem) {
                        return elem.currentStyle;
                    };
                    convertToPx = function(elem, value) {
                        var core_pnum, left, result, rnumnonpx, rs, rsLeft, style;
                        core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
                        rnumnonpx = new RegExp("^(" + core_pnum + ")(?!px)[a-z%]+$", "i");
                        if (!rnumnonpx.test(value)) return parseFloat(value);
                        else {
                            style = elem.style;
                            left = style.left;
                            rs = elem.runtimeStyle;
                            rsLeft = rs && rs.left;
                            if (rs) rs.left = style.left;
                            style.left = value;
                            result = style.pixelLeft;
                            style.left = left;
                            if (rsLeft) rs.left = rsLeft;
                            return result;
                        }
                    };
                }
                getMeasurements = function(elem, measure) {
                    var base, borderA, borderB, computedMarginA, computedMarginB, computedStyle, dirA, dirB, marginA, marginB, paddingA, paddingB, _ref;
                    if (isWindow(elem)) {
                        base = document.documentElement[({
                            height: "clientHeight",
                            width: "clientWidth"
                        })[measure]];
                        return {
                            base: base,
                            padding: 0,
                            border: 0,
                            margin: 0
                        };
                    }
                    _ref = ({
                        width: [
                            elem.offsetWidth,
                            "Left",
                            "Right"
                        ],
                        height: [
                            elem.offsetHeight,
                            "Top",
                            "Bottom"
                        ]
                    })[measure], base = _ref[0], dirA = _ref[1], dirB = _ref[2];
                    computedStyle = getStyle(elem);
                    paddingA = convertToPx(elem, computedStyle["padding" + dirA]) || 0;
                    paddingB = convertToPx(elem, computedStyle["padding" + dirB]) || 0;
                    borderA = convertToPx(elem, computedStyle["border" + dirA + "Width"]) || 0;
                    borderB = convertToPx(elem, computedStyle["border" + dirB + "Width"]) || 0;
                    computedMarginA = computedStyle["margin" + dirA];
                    computedMarginB = computedStyle["margin" + dirB];
                    marginA = convertToPx(elem, computedMarginA) || 0;
                    marginB = convertToPx(elem, computedMarginB) || 0;
                    return {
                        base: base,
                        padding: paddingA + paddingB,
                        border: borderA + borderB,
                        margin: marginA + marginB
                    };
                };
                getWidthHeight = function(elem, direction, measure) {
                    var computedStyle, measurements, result;
                    measurements = getMeasurements(elem, direction);
                    if (measurements.base > 0) return ({
                        base: measurements.base - measurements.padding - measurements.border,
                        outer: measurements.base,
                        outerfull: measurements.base + measurements.margin
                    })[measure];
                    else {
                        computedStyle = getStyle(elem);
                        result = computedStyle[direction];
                        if (result < 0 || result === null) result = elem.style[direction] || 0;
                        result = parseFloat(result) || 0;
                        return ({
                            base: result - measurements.padding - measurements.border,
                            outer: result,
                            outerfull: result + measurements.padding + measurements.border + measurements.margin
                        })[measure];
                    }
                };
                return angular.forEach({
                    before: function(newElem) {
                        var children, elem, i, parent, self, _i, _ref;
                        self = this;
                        elem = self[0];
                        parent = self.parent();
                        children = parent.contents();
                        if (children[0] === elem) return parent.prepend(newElem);
                        else {
                            for(i = _i = 1, _ref = children.length - 1; 1 <= _ref ? _i <= _ref : _i >= _ref; i = 1 <= _ref ? ++_i : --_i)if (children[i] === elem) {
                                angular.element(children[i - 1]).after(newElem);
                                return;
                            }
                            throw new Error("invalid DOM structure " + elem.outerHTML);
                        }
                    },
                    height: function(value) {
                        var self;
                        self = this;
                        if (angular.isDefined(value)) {
                            if (angular.isNumber(value)) value = value + "px";
                            return css.call(self, "height", value);
                        } else return getWidthHeight(this[0], "height", "base");
                    },
                    outerHeight: function(option) {
                        return getWidthHeight(this[0], "height", option ? "outerfull" : "outer");
                    },
                    /*
          UIScroller no longer relies on jQuery method offset. The jQLite implementation of the method
          is kept here just for the reference. Also the offset setter method was never implemented
          */ offset: function(value) {
                        var box, doc, docElem, elem, self, win;
                        self = this;
                        if (arguments.length) {
                            if (value === void 0) return self;
                            else throw new Error("offset setter method is not implemented");
                        }
                        box = {
                            top: 0,
                            left: 0
                        };
                        elem = self[0];
                        doc = elem && elem.ownerDocument;
                        if (!doc) return;
                        docElem = doc.documentElement;
                        if (elem.getBoundingClientRect != null) box = elem.getBoundingClientRect();
                        win = doc.defaultView || doc.parentWindow;
                        return {
                            top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
                            left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
                        };
                    },
                    scrollTop: function(value) {
                        return scrollTo(this, "top", value);
                    },
                    scrollLeft: function(value) {
                        return scrollTo(this, "left", value);
                    }
                }, function(value, key) {
                    if (!element.prototype[key]) return element.prototype[key] = value;
                });
            }
        };
    }
]).run([
    "$log",
    "$window",
    "jqLiteExtras",
    function(console, window1, jqLiteExtras) {
        "use strict";
        if (!window1.jQuery) return jqLiteExtras.registerFor(angular.element);
    }
]);
/*
//# sourceURL=src/scripts/ui-scroll-jqlite.js
*/ /*
globals: angular, window

	List of used element methods available in JQuery but not in JQuery Lite

		element.before(elem)
		element.height()
		element.outerHeight(true)
		element.height(value) = only for Top/Bottom padding elements
		element.scrollTop()
		element.scrollTop(value)
*/ angular.module("ui.scroll", []).directive("uiScrollViewport", [
    "$log",
    function() {
        "use strict";
        return {
            controller: [
                "$scope",
                "$element",
                function(scope, element) {
                    this.viewport = element;
                    return this;
                }
            ]
        };
    }
]).directive("uiScroll", [
    "$log",
    "$injector",
    "$rootScope",
    "$timeout",
    function(console, $injector, $rootScope, $timeout) {
        "use strict";
        return {
            require: [
                "?^uiScrollViewport"
            ],
            transclude: "element",
            priority: 1000,
            terminal: true,
            compile: function(elementTemplate, attr, linker) {
                return function($scope, element, $attr, controllers) {
                    var adapter, adjustBuffer, adjustRowHeight, bof, bottomVisiblePos, buffer, bufferPadding, bufferSize, clipBottom, clipTop, datasource, datasourceName, doAdjustment, enqueueFetch, eof, eventListener, fetch, finalize, first, getValueChain, hideElementBeforeAppend, insert, isDatasource, isLoading, itemName, loading, log, match, next, pending, reload, removeFromBuffer, resizeHandler, ridActual, scrollHandler, scrollHeight, shouldLoadBottom, shouldLoadTop, showElementAfterRender, tempScope, topVisible, topVisibleElement, topVisibleItem, topVisiblePos, topVisibleScope, viewport, viewportScope, wheelHandler;
                    log = console.debug || console.log;
                    match = $attr.uiScroll.match(/^\s*(\w+)\s+in\s+([\w\.]+)\s*$/);
                    if (!match) throw new Error("Expected uiScroll in form of '_item_ in _datasource_' but got '" + $attr.uiScroll + "'");
                    itemName = match[1];
                    datasourceName = match[2];
                    isDatasource = function(datasource) {
                        return angular.isObject(datasource) && datasource.get && angular.isFunction(datasource.get);
                    };
                    getValueChain = function(targetScope, target) {
                        var chain;
                        if (!targetScope) return null;
                        chain = target.match(/^([\w]+)\.(.+)$/);
                        if (!chain || chain.length !== 3) return targetScope[target];
                        return getValueChain(targetScope[chain[1]], chain[2]);
                    };
                    datasource = getValueChain($scope, datasourceName);
                    if (!isDatasource(datasource)) {
                        datasource = $injector.get(datasourceName);
                        if (!isDatasource(datasource)) throw new Error("" + datasourceName + " is not a valid datasource");
                    }
                    bufferSize = Math.max(3, +$attr.bufferSize || 10);
                    bufferPadding = function() {
                        return viewport.outerHeight() * Math.max(0.1, +$attr.padding || 0.1);
                    };
                    scrollHeight = function(elem) {
                        var _ref;
                        return (_ref = elem[0].scrollHeight) != null ? _ref : elem[0].document.documentElement.scrollHeight;
                    };
                    adapter = null;
                    linker(tempScope = $scope.$new(), function(template) {
                        var bottomPadding, createPadding, padding, repeaterType, topPadding, viewport;
                        repeaterType = template[0].localName;
                        if (repeaterType === "dl") throw new Error("ui-scroll directive does not support <" + template[0].localName + "> as a repeating tag: " + template[0].outerHTML);
                        if (repeaterType !== "li" && repeaterType !== "tr") repeaterType = "div";
                        viewport = controllers[0] && controllers[0].viewport ? controllers[0].viewport : angular.element(window);
                        viewport.css({
                            "overflow-y": "auto",
                            "display": "block"
                        });
                        padding = function(repeaterType) {
                            var div, result, table;
                            switch(repeaterType){
                                case "tr":
                                    table = angular.element("<table><tr><td><div></div></td></tr></table>");
                                    div = table.find("div");
                                    result = table.find("tr");
                                    result.paddingHeight = function() {
                                        return div.height.apply(div, arguments);
                                    };
                                    return result;
                                default:
                                    result = angular.element("<" + repeaterType + "></" + repeaterType + ">");
                                    result.paddingHeight = result.height;
                                    return result;
                            }
                        };
                        createPadding = function(padding, element, direction) {
                            element[({
                                top: "before",
                                bottom: "after"
                            })[direction]](padding);
                            return {
                                paddingHeight: function() {
                                    return padding.paddingHeight.apply(padding, arguments);
                                },
                                insert: function(element) {
                                    return padding[({
                                        top: "after",
                                        bottom: "before"
                                    })[direction]](element);
                                }
                            };
                        };
                        topPadding = createPadding(padding(repeaterType), element, "top");
                        bottomPadding = createPadding(padding(repeaterType), element, "bottom");
                        tempScope.$destroy();
                        return adapter = {
                            viewport: viewport,
                            topPadding: topPadding.paddingHeight,
                            bottomPadding: bottomPadding.paddingHeight,
                            append: bottomPadding.insert,
                            prepend: topPadding.insert,
                            bottomDataPos: function() {
                                return scrollHeight(viewport) - bottomPadding.paddingHeight();
                            },
                            topDataPos: function() {
                                return topPadding.paddingHeight();
                            }
                        };
                    });
                    viewport = adapter.viewport;
                    viewportScope = viewport.scope() || $rootScope;
                    if (angular.isDefined($attr.topVisible)) topVisibleItem = function(item) {
                        return viewportScope[$attr.topVisible] = item;
                    };
                    if (angular.isDefined($attr.topVisibleElement)) topVisibleElement = function(element) {
                        return viewportScope[$attr.topVisibleElement] = element;
                    };
                    if (angular.isDefined($attr.topVisibleScope)) topVisibleScope = function(scope) {
                        return viewportScope[$attr.topVisibleScope] = scope;
                    };
                    topVisible = function(item) {
                        if (topVisibleItem) topVisibleItem(item.scope[itemName]);
                        if (topVisibleElement) topVisibleElement(item.element);
                        if (topVisibleScope) topVisibleScope(item.scope);
                        if (datasource.topVisible) return datasource.topVisible(item);
                    };
                    if (angular.isDefined($attr.isLoading)) loading = function(value) {
                        viewportScope[$attr.isLoading] = value;
                        if (datasource.loading) return datasource.loading(value);
                    };
                    else loading = function(value) {
                        if (datasource.loading) return datasource.loading(value);
                    };
                    ridActual = 0;
                    first = 1;
                    next = 1;
                    buffer = [];
                    pending = [];
                    eof = false;
                    bof = false;
                    isLoading = false;
                    removeFromBuffer = function(start, stop) {
                        var i, _i;
                        for(i = _i = start; start <= stop ? _i < stop : _i > stop; i = start <= stop ? ++_i : --_i){
                            buffer[i].scope.$destroy();
                            buffer[i].element.remove();
                        }
                        return buffer.splice(start, stop - start);
                    };
                    reload = function() {
                        ridActual++;
                        first = 1;
                        next = 1;
                        removeFromBuffer(0, buffer.length);
                        adapter.topPadding(0);
                        adapter.bottomPadding(0);
                        pending = [];
                        eof = false;
                        bof = false;
                        return adjustBuffer(ridActual, false);
                    };
                    bottomVisiblePos = function() {
                        return viewport.scrollTop() + viewport.outerHeight();
                    };
                    topVisiblePos = function() {
                        return viewport.scrollTop();
                    };
                    shouldLoadBottom = function() {
                        return !eof && adapter.bottomDataPos() < bottomVisiblePos() + bufferPadding();
                    };
                    clipBottom = function() {
                        var bottomHeight, i, item, itemHeight, itemTop, newRow, overage, rowTop, _i, _ref;
                        bottomHeight = 0;
                        overage = 0;
                        for(i = _i = _ref = buffer.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i){
                            item = buffer[i];
                            itemTop = item.element.offset().top;
                            newRow = rowTop !== itemTop;
                            rowTop = itemTop;
                            if (newRow) itemHeight = item.element.outerHeight(true);
                            if (adapter.bottomDataPos() - bottomHeight - itemHeight > bottomVisiblePos() + bufferPadding()) {
                                if (newRow) bottomHeight += itemHeight;
                                overage++;
                                eof = false;
                            } else {
                                if (newRow) break;
                                overage++;
                            }
                        }
                        if (overage > 0) {
                            adapter.bottomPadding(adapter.bottomPadding() + bottomHeight);
                            removeFromBuffer(buffer.length - overage, buffer.length);
                            next -= overage;
                            return log("clipped off bottom " + overage + " bottom padding " + adapter.bottomPadding());
                        }
                    };
                    shouldLoadTop = function() {
                        return !bof && adapter.topDataPos() > topVisiblePos() - bufferPadding();
                    };
                    clipTop = function() {
                        var item, itemHeight, itemTop, newRow, overage, rowTop, topHeight, _i, _len;
                        topHeight = 0;
                        overage = 0;
                        for(_i = 0, _len = buffer.length; _i < _len; _i++){
                            item = buffer[_i];
                            itemTop = item.element.offset().top;
                            newRow = rowTop !== itemTop;
                            rowTop = itemTop;
                            if (newRow) itemHeight = item.element.outerHeight(true);
                            if (adapter.topDataPos() + topHeight + itemHeight < topVisiblePos() - bufferPadding()) {
                                if (newRow) topHeight += itemHeight;
                                overage++;
                                bof = false;
                            } else {
                                if (newRow) break;
                                overage++;
                            }
                        }
                        if (overage > 0) {
                            adapter.topPadding(adapter.topPadding() + topHeight);
                            removeFromBuffer(0, overage);
                            first += overage;
                            return log("clipped off top " + overage + " top padding " + adapter.topPadding());
                        }
                    };
                    enqueueFetch = function(rid, direction, scrolling) {
                        if (!isLoading) {
                            isLoading = true;
                            loading(true);
                        }
                        if (pending.push(direction) === 1) return fetch(rid, scrolling);
                    };
                    hideElementBeforeAppend = function(element) {
                        element.displayTemp = element.css("display");
                        return element.css("display", "none");
                    };
                    showElementAfterRender = function(element) {
                        if (element.hasOwnProperty("displayTemp")) return element.css("display", element.displayTemp);
                    };
                    insert = function(index, item) {
                        var itemScope, toBeAppended, wrapper;
                        itemScope = $scope.$new();
                        itemScope[itemName] = item;
                        toBeAppended = index > first;
                        itemScope.$index = index;
                        if (toBeAppended) itemScope.$index--;
                        wrapper = {
                            scope: itemScope
                        };
                        linker(itemScope, function(clone) {
                            wrapper.element = clone;
                            if (toBeAppended) {
                                if (index === next) {
                                    hideElementBeforeAppend(clone);
                                    adapter.append(clone);
                                    return buffer.push(wrapper);
                                } else {
                                    buffer[index - first].element.after(clone);
                                    return buffer.splice(index - first + 1, 0, wrapper);
                                }
                            } else {
                                hideElementBeforeAppend(clone);
                                adapter.prepend(clone);
                                return buffer.unshift(wrapper);
                            }
                        });
                        return {
                            appended: toBeAppended,
                            wrapper: wrapper
                        };
                    };
                    adjustRowHeight = function(appended, wrapper) {
                        var newHeight;
                        if (appended) return adapter.bottomPadding(Math.max(0, adapter.bottomPadding() - wrapper.element.outerHeight(true)));
                        else {
                            newHeight = adapter.topPadding() - wrapper.element.outerHeight(true);
                            if (newHeight >= 0) return adapter.topPadding(newHeight);
                            else return viewport.scrollTop(viewport.scrollTop() + wrapper.element.outerHeight(true));
                        }
                    };
                    doAdjustment = function(rid, scrolling, finalize) {
                        var item, itemHeight, itemTop, newRow, rowTop, topHeight, _i, _len, _results;
                        log("top {actual=" + adapter.topDataPos() + " visible from=" + topVisiblePos() + " bottom {visible through=" + bottomVisiblePos() + " actual=" + adapter.bottomDataPos() + "}");
                        if (shouldLoadBottom()) enqueueFetch(rid, true, scrolling);
                        else if (shouldLoadTop()) enqueueFetch(rid, false, scrolling);
                        if (finalize) finalize(rid);
                        if (pending.length === 0) {
                            topHeight = 0;
                            _results = [];
                            for(_i = 0, _len = buffer.length; _i < _len; _i++){
                                item = buffer[_i];
                                itemTop = item.element.offset().top;
                                newRow = rowTop !== itemTop;
                                rowTop = itemTop;
                                if (newRow) itemHeight = item.element.outerHeight(true);
                                if (newRow && adapter.topDataPos() + topHeight + itemHeight < topVisiblePos()) _results.push(topHeight += itemHeight);
                                else {
                                    if (newRow) topVisible(item);
                                    break;
                                }
                            }
                            return _results;
                        }
                    };
                    adjustBuffer = function(rid, scrolling, newItems, finalize) {
                        if (newItems && newItems.length) return $timeout(function() {
                            var itemTop, row, rowTop, rows, _i, _j, _len, _len1;
                            rows = [];
                            for(_i = 0, _len = newItems.length; _i < _len; _i++){
                                row = newItems[_i];
                                element = row.wrapper.element;
                                showElementAfterRender(element);
                                itemTop = element.offset().top;
                                if (rowTop !== itemTop) {
                                    rows.push(row);
                                    rowTop = itemTop;
                                }
                            }
                            for(_j = 0, _len1 = rows.length; _j < _len1; _j++){
                                row = rows[_j];
                                adjustRowHeight(row.appended, row.wrapper);
                            }
                            return doAdjustment(rid, scrolling, finalize);
                        });
                        else return doAdjustment(rid, scrolling, finalize);
                    };
                    finalize = function(rid, scrolling, newItems) {
                        return adjustBuffer(rid, scrolling, newItems, function() {
                            pending.shift();
                            if (pending.length === 0) {
                                isLoading = false;
                                return loading(false);
                            } else return fetch(rid, scrolling);
                        });
                    };
                    fetch = function(rid, scrolling) {
                        var direction;
                        direction = pending[0];
                        if (direction) {
                            if (buffer.length && !shouldLoadBottom()) return finalize(rid, scrolling);
                            else return datasource.get(next, bufferSize, function(result) {
                                var item, newItems, _i, _len;
                                if (rid && rid !== ridActual) return;
                                newItems = [];
                                if (result.length < bufferSize) {
                                    eof = true;
                                    adapter.bottomPadding(0);
                                }
                                if (result.length > 0) {
                                    clipTop();
                                    for(_i = 0, _len = result.length; _i < _len; _i++){
                                        item = result[_i];
                                        newItems.push(insert(++next, item));
                                    }
                                }
                                return finalize(rid, scrolling, newItems);
                            });
                        } else {
                            if (buffer.length && !shouldLoadTop()) return finalize(rid, scrolling);
                            else return datasource.get(first - bufferSize, bufferSize, function(result) {
                                var i, newItems, _i, _ref;
                                if (rid && rid !== ridActual) return;
                                newItems = [];
                                if (result.length < bufferSize) {
                                    bof = true;
                                    adapter.topPadding(0);
                                }
                                if (result.length > 0) {
                                    if (buffer.length) clipBottom();
                                    for(i = _i = _ref = result.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i)newItems.unshift(insert(--first, result[i]));
                                }
                                return finalize(rid, scrolling, newItems);
                            });
                        }
                    };
                    resizeHandler = function() {
                        if (!$rootScope.$$phase && !isLoading) {
                            adjustBuffer(null, false);
                            return $scope.$apply();
                        }
                    };
                    viewport.bind("resize", resizeHandler);
                    scrollHandler = function() {
                        if (!$rootScope.$$phase && !isLoading) {
                            adjustBuffer(null, true);
                            return $scope.$apply();
                        }
                    };
                    viewport.bind("scroll", scrollHandler);
                    wheelHandler = function(event) {
                        var scrollTop, yMax;
                        scrollTop = viewport[0].scrollTop;
                        yMax = viewport[0].scrollHeight - viewport[0].clientHeight;
                        if (scrollTop === 0 && !bof || scrollTop === yMax && !eof) return event.preventDefault();
                    };
                    viewport.bind("mousewheel", wheelHandler);
                    $scope.$watch(datasource.revision, function() {
                        return reload();
                    });
                    if (datasource.scope) eventListener = datasource.scope.$new();
                    else eventListener = $scope.$new();
                    $scope.$on("$destroy", function() {
                        eventListener.$destroy();
                        viewport.unbind("resize", resizeHandler);
                        viewport.unbind("scroll", scrollHandler);
                        return viewport.unbind("mousewheel", wheelHandler);
                    });
                    eventListener.$on("update.items", function(event, locator, newItem) {
                        var wrapper, _fn, _i, _len, _ref;
                        if (angular.isFunction(locator)) {
                            _fn = function(wrapper) {
                                return locator(wrapper.scope);
                            };
                            for(_i = 0, _len = buffer.length; _i < _len; _i++){
                                wrapper = buffer[_i];
                                _fn(wrapper);
                            }
                        } else if (0 <= (_ref = locator - first - 1) && _ref < buffer.length) buffer[locator - first - 1].scope[itemName] = newItem;
                        return null;
                    });
                    eventListener.$on("delete.items", function(event, locator) {
                        var i, item, temp, wrapper, _fn, _i, _j, _k, _len, _len1, _len2, _ref;
                        if (angular.isFunction(locator)) {
                            temp = [];
                            for(_i = 0, _len = buffer.length; _i < _len; _i++){
                                item = buffer[_i];
                                temp.unshift(item);
                            }
                            _fn = function(wrapper) {
                                if (locator(wrapper.scope)) {
                                    removeFromBuffer(temp.length - 1 - i, temp.length - i);
                                    return next--;
                                }
                            };
                            for(i = _j = 0, _len1 = temp.length; _j < _len1; i = ++_j){
                                wrapper = temp[i];
                                _fn(wrapper);
                            }
                        } else if (0 <= (_ref = locator - first - 1) && _ref < buffer.length) {
                            removeFromBuffer(locator - first - 1, locator - first);
                            next--;
                        }
                        for(i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k){
                            item = buffer[i];
                            item.scope.$index = first + i;
                        }
                        return adjustBuffer(null, false);
                    });
                    return eventListener.$on("insert.item", function(event, locator, item) {
                        var i, inserted, _i, _len, _ref;
                        inserted = [];
                        if (angular.isFunction(locator)) throw new Error("not implemented - Insert with locator function");
                        else if (0 <= (_ref = locator - first - 1) && _ref < buffer.length) {
                            inserted.push(insert(locator, item));
                            next++;
                        }
                        for(i = _i = 0, _len = buffer.length; _i < _len; i = ++_i){
                            item = buffer[i];
                            item.scope.$index = first + i;
                        }
                        return adjustBuffer(null, false, inserted);
                    });
                };
            }
        };
    }
]);
/*
//# sourceURL=src/scripts/ui-scroll.js
*/ /**
 * Adds a 'ui-scrollfix' class to the element when the page scrolls past it's position.
 * @param [offset] {int} optional Y-offset to override the detected offset.
 *   Takes 300 (absolute) or -300 or +300 (relative to detected)
 */ angular.module("ui.scrollfix", []).directive("uiScrollfix", [
    "$window",
    function($window) {
        "use strict";
        function getWindowScrollTop() {
            if (angular.isDefined($window.pageYOffset)) return $window.pageYOffset;
            else {
                var iebody = document.compatMode && document.compatMode !== "BackCompat" ? document.documentElement : document.body;
                return iebody.scrollTop;
            }
        }
        return {
            require: "^?uiScrollfixTarget",
            link: function(scope, elm, attrs, uiScrollfixTarget) {
                var absolute = true, shift = 0, fixLimit, $target = uiScrollfixTarget && uiScrollfixTarget.$element || angular.element($window);
                if (!attrs.uiScrollfix) absolute = false;
                else if (typeof attrs.uiScrollfix === "string") {
                    // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat
                    if (attrs.uiScrollfix.charAt(0) === "-") {
                        absolute = false;
                        shift = -parseFloat(attrs.uiScrollfix.substr(1));
                    } else if (attrs.uiScrollfix.charAt(0) === "+") {
                        absolute = false;
                        shift = parseFloat(attrs.uiScrollfix.substr(1));
                    }
                }
                fixLimit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
                function onScroll() {
                    var limit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
                    // if pageYOffset is defined use it, otherwise use other crap for IE
                    var offset = uiScrollfixTarget ? $target[0].scrollTop : getWindowScrollTop();
                    if (!elm.hasClass("ui-scrollfix") && offset > limit) {
                        elm.addClass("ui-scrollfix");
                        fixLimit = limit;
                    } else if (elm.hasClass("ui-scrollfix") && offset < fixLimit) elm.removeClass("ui-scrollfix");
                }
                $target.on("scroll", onScroll);
                // Unbind scroll event handler when directive is removed
                scope.$on("$destroy", function() {
                    $target.off("scroll", onScroll);
                });
            }
        };
    }
]).directive("uiScrollfixTarget", [
    function() {
        "use strict";
        return {
            controller: [
                "$element",
                function($element) {
                    this.$element = $element;
                }
            ]
        };
    }
]);
/**
 * uiShow Directive
 *
 * Adds a 'ui-show' class to the element instead of display:block
 * Created to allow tighter control  of CSS without bulkier directives
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */ angular.module("ui.showhide", []).directive("uiShow", [
    function() {
        "use strict";
        return function(scope, elm, attrs) {
            scope.$watch(attrs.uiShow, function(newVal) {
                if (newVal) elm.addClass("ui-show");
                else elm.removeClass("ui-show");
            });
        };
    }
])/**
 * uiHide Directive
 *
 * Adds a 'ui-hide' class to the element instead of display:block
 * Created to allow tighter control  of CSS without bulkier directives
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */ .directive("uiHide", [
    function() {
        "use strict";
        return function(scope, elm, attrs) {
            scope.$watch(attrs.uiHide, function(newVal) {
                if (newVal) elm.addClass("ui-hide");
                else elm.removeClass("ui-hide");
            });
        };
    }
])/**
 * uiToggle Directive
 *
 * Adds a class 'ui-show' if true, and a 'ui-hide' if false to the element instead of display:block/display:none
 * Created to allow tighter control  of CSS without bulkier directives. This also allows you to override the
 * default visibility of the element using either class.
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */ .directive("uiToggle", [
    function() {
        "use strict";
        return function(scope, elm, attrs) {
            scope.$watch(attrs.uiToggle, function(newVal) {
                if (newVal) elm.removeClass("ui-hide").addClass("ui-show");
                else elm.removeClass("ui-show").addClass("ui-hide");
            });
        };
    }
]);
/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */ angular.module("ui.unique", []).filter("unique", [
    "$parse",
    function($parse) {
        "use strict";
        return function(items, filterOn) {
            if (filterOn === false) return items;
            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var newItems = [], get = angular.isString(filterOn) ? $parse(filterOn) : function(item) {
                    return item;
                };
                var extractValueToCompare = function(item) {
                    return angular.isObject(item) ? get(item) : item;
                };
                angular.forEach(items, function(item) {
                    var isDuplicate = false;
                    for(var i = 0; i < newItems.length; i++)if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                        isDuplicate = true;
                        break;
                    }
                    if (!isDuplicate) newItems.push(item);
                });
                items = newItems;
            }
            return items;
        };
    }
]);
/*
 * Author: Remy Alain Ticona Carbajal http://realtica.org
 * Description: The main objective of ng-uploader is to have a user control,
 * clean, simple, customizable, and above all very easy to implement.
 * Licence: MIT
 */ angular.module("ui.uploader", []).service("uiUploader", uiUploader);
uiUploader.$inject = [
    "$log"
];
function uiUploader($log) {
    "use strict";
    /*jshint validthis: true */ var self = this;
    self.files = [];
    self.options = {};
    self.activeUploads = 0;
    $log.info("uiUploader loaded");
    function addFiles(files) {
        for(var i = 0; i < files.length; i++)self.files.push(files[i]);
    }
    function getFiles() {
        return self.files;
    }
    function startUpload(options) {
        self.options = options;
        for(var i = 0; i < self.files.length; i++){
            if (self.activeUploads == self.options.concurrency) break;
            if (self.files[i].active) continue;
            ajaxUpload(self.files[i], self.options.url);
        }
    }
    function removeFile(file) {
        self.files.splice(self.files.indexOf(file), 1);
    }
    function removeAll() {
        self.files.splice(0, self.files.length);
    }
    return {
        addFiles: addFiles,
        getFiles: getFiles,
        files: self.files,
        startUpload: startUpload,
        removeFile: removeFile,
        removeAll: removeAll
    };
    function getHumanSize(bytes) {
        var sizes = [
            "n/a",
            "bytes",
            "KiB",
            "MiB",
            "GiB",
            "TB",
            "PB",
            "EiB",
            "ZiB",
            "YiB"
        ];
        var i = +Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + " " + sizes[isNaN(bytes) ? 0 : i + 1];
    }
    function ajaxUpload(file, url) {
        var xhr, formData, prop, data = "", key = "file";
        self.activeUploads += 1;
        file.active = true;
        xhr = new window.XMLHttpRequest();
        formData = new window.FormData();
        xhr.open("POST", url);
        // Triggered when upload starts:
        xhr.upload.onloadstart = function() {};
        // Triggered many times during upload:
        xhr.upload.onprogress = function(event) {
            if (!event.lengthComputable) return;
            // Update file size because it might be bigger than reported by
            // the fileSize:
            //$log.info("progres..");
            //console.info(event.loaded);
            file.loaded = event.loaded;
            file.humanSize = getHumanSize(event.loaded);
            self.options.onProgress(file);
        };
        // Triggered when upload is completed:
        xhr.onload = function() {
            self.activeUploads -= 1;
            startUpload(self.options);
            self.options.onCompleted(file, xhr.responseText);
        };
        // Triggered when upload fails:
        xhr.onerror = function() {};
        // Append additional data if provided:
        if (data) {
            for(prop in data)if (data.hasOwnProperty(prop)) formData.append(prop, data[prop]);
        }
        // Append file data:
        formData.append(key, file, file.name);
        // Initiate upload:
        xhr.send(formData);
        return xhr;
    }
}
/**
 * General-purpose validator for ngModel.
 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
 * an arbitrary validation function requires creation of a custom formatters and / or parsers.
 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
 * A validator function will trigger validation on both model and input changes.
 *
 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
 *
 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
 */ angular.module("ui.validate", []).directive("uiValidate", function() {
    "use strict";
    return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, elm, attrs, ctrl) {
            var validateFn, validators = {}, validateExpr = scope.$eval(attrs.uiValidate);
            if (!validateExpr) return;
            if (angular.isString(validateExpr)) validateExpr = {
                validator: validateExpr
            };
            angular.forEach(validateExpr, function(exprssn, key) {
                validateFn = function(valueToValidate) {
                    var expression = scope.$eval(exprssn, {
                        "$value": valueToValidate
                    });
                    if (angular.isObject(expression) && angular.isFunction(expression.then)) {
                        // expression is a promise
                        expression.then(function() {
                            ctrl.$setValidity(key, true);
                        }, function() {
                            ctrl.$setValidity(key, false);
                        });
                        return valueToValidate;
                    } else if (expression) {
                        // expression is true
                        ctrl.$setValidity(key, true);
                        return valueToValidate;
                    } else {
                        // expression is false
                        ctrl.$setValidity(key, false);
                        return valueToValidate;
                    }
                };
                validators[key] = validateFn;
                ctrl.$formatters.push(validateFn);
                ctrl.$parsers.push(validateFn);
            });
            function apply_watch(watch) {
                //string - update all validators on expression change
                if (angular.isString(watch)) {
                    scope.$watch(watch, function() {
                        angular.forEach(validators, function(validatorFn) {
                            validatorFn(ctrl.$modelValue);
                        });
                    });
                    return;
                }
                //array - update all validators on change of any expression
                if (angular.isArray(watch)) {
                    angular.forEach(watch, function(expression) {
                        scope.$watch(expression, function() {
                            angular.forEach(validators, function(validatorFn) {
                                validatorFn(ctrl.$modelValue);
                            });
                        });
                    });
                    return;
                }
                //object - update appropriate validator
                if (angular.isObject(watch)) angular.forEach(watch, function(expression, validatorKey) {
                    //value is string - look after one expression
                    if (angular.isString(expression)) scope.$watch(expression, function() {
                        validators[validatorKey](ctrl.$modelValue);
                    });
                    //value is array - look after all expressions in array
                    if (angular.isArray(expression)) angular.forEach(expression, function(intExpression) {
                        scope.$watch(intExpression, function() {
                            validators[validatorKey](ctrl.$modelValue);
                        });
                    });
                });
            }
            // Support for ui-validate-watch
            if (attrs.uiValidateWatch) apply_watch(scope.$eval(attrs.uiValidateWatch));
        }
    };
});
angular.module("ui.utils", [
    "ui.event",
    "ui.format",
    "ui.highlight",
    "ui.include",
    "ui.indeterminate",
    "ui.inflector",
    "ui.jq",
    "ui.keypress",
    "ui.mask",
    "ui.reset",
    "ui.route",
    "ui.scrollfix",
    "ui.scroll",
    "ui.scroll.jqlite",
    "ui.showhide",
    "ui.unique",
    "ui.validate"
]);

},{}],"g0bYc":[function(require,module,exports) {
/*!
angular-xeditable - 0.1.12
Edit-in-place for angular.js
Build date: 2016-04-14 
*/ /**
 * Angular-xeditable module 
 *
 */ angular.module("xeditable", [])/**
 * Default options. 
 *
 * @namespace editable-options
 */ //todo: maybe better have editableDefaults, not options...
.value("editableOptions", {
    /**
   * Theme. Possible values `bs3`, `bs2`, `default`.
   * 
   * @var {string} theme
   * @memberOf editable-options
   */ theme: "default",
    /**
   * Icon Set. Possible values `font-awesome`, `default`.
   * 
   * @var {string} icon set
   * @memberOf editable-options
   */ icon_set: "default",
    /**
   * Whether to show buttons for single editalbe element.  
   * Possible values `right` (default), `no`.
   * 
   * @var {string} buttons
   * @memberOf editable-options
   */ buttons: "right",
    /**
   * Default value for `blur` attribute of single editable element.  
   * Can be `cancel|submit|ignore`.
   * 
   * @var {string} blurElem
   * @memberOf editable-options
   */ blurElem: "cancel",
    /**
   * Default value for `blur` attribute of editable form.  
   * Can be `cancel|submit|ignore`.
   * 
   * @var {string} blurForm
   * @memberOf editable-options
   */ blurForm: "ignore",
    /**
   * How input elements get activated. Possible values: `focus|select|none`.
   *
   * @var {string} activate
   * @memberOf editable-options
   */ activate: "focus",
    /**
   * Whether to disable x-editable. Can be overloaded on each element.
   *
   * @var {boolean} isDisabled
   * @memberOf editable-options
   */ isDisabled: false,
    /**
   * Event, on which the edit mode gets activated. 
   * Can be any event.
   *
   * @var {string} activationEvent
   * @memberOf editable-options
   */ activationEvent: "click"
});
/*
 Angular-ui bootstrap datepicker
 http://angular-ui.github.io/bootstrap/#/datepicker
 */ angular.module("xeditable").directive("editableBsdate", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        return editableDirectiveFactory({
            directiveName: "editableBsdate",
            inputTpl: "<div></div>",
            render: function() {
                /** This basically renders a datepicker as in the example shown in
                 **  http://angular-ui.github.io/bootstrap/#/datepicker
                 **  The attributes are all the same as in the bootstrap-ui datepicker with e- as prefix
                 **/ this.parent.render.call(this);
                var inputDatePicker = angular.element('<input type="text" class="form-control" ng-model="$data"/>');
                var buttonDatePicker = angular.element('<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>');
                var buttonWrapper = angular.element('<span class="input-group-btn"></span>');
                inputDatePicker.attr("uib-datepicker-popup", this.attrs.eDatepickerPopupXEditable || "yyyy/MM/dd");
                inputDatePicker.attr("is-open", this.attrs.eIsOpen);
                inputDatePicker.attr("date-disabled", this.attrs.eDateDisabled);
                inputDatePicker.attr("uib-datepicker-popup", this.attrs.eDatepickerPopup);
                inputDatePicker.attr("min-date", this.attrs.eMinDate);
                inputDatePicker.attr("max-date", this.attrs.eMaxDate);
                inputDatePicker.attr("year-range", this.attrs.eYearRange || 20);
                inputDatePicker.attr("show-button-bar", this.attrs.eShowButtonBar || true);
                inputDatePicker.attr("current-text", this.attrs.eCurrentText || "Today");
                inputDatePicker.attr("clear-text", this.attrs.eClearText || "Clear");
                inputDatePicker.attr("close-text", this.attrs.eCloseText || "Done");
                inputDatePicker.attr("close-on-date-selection", this.attrs.eCloseOnDateSelection || true);
                inputDatePicker.attr("datepicker-append-to-body", this.attrs.eDatePickerAppendToBody || false);
                inputDatePicker.attr("date-disabled", this.attrs.eDateDisabled);
                inputDatePicker.attr("name", this.attrs.eName);
                this.scope.dateOptions = {
                    formatDay: this.attrs.eFormatDay || "dd",
                    formatMonth: this.attrs.eFormatMonth || "MMMM",
                    formatYear: this.attrs.eFormatYear || "yyyy",
                    formatDayHeader: this.attrs.eFormatDayHeader || "EEE",
                    formatDayTitle: this.attrs.eFormatDayTitle || "MMMM yyyy",
                    formatMonthTitle: this.attrs.eFormatMonthTitle || "yyyy",
                    showWeeks: this.attrs.eShowWeeks ? this.attrs.eShowWeeks.toLowerCase() === "true" : true,
                    startingDay: this.attrs.eStartingDay || 0,
                    minMode: this.attrs.eMinMode || "day",
                    maxMode: this.attrs.eMaxMode || "year",
                    initDate: this.attrs.eInitDate || new Date(),
                    datepickerMode: this.attrs.eDatepickerMode || "day"
                };
                inputDatePicker.attr("datepicker-options", "dateOptions");
                buttonDatePicker.attr("ng-click", this.attrs.eNgClick);
                buttonWrapper.append(buttonDatePicker);
                this.inputEl.prepend(inputDatePicker);
                this.inputEl.append(buttonWrapper);
                this.inputEl.removeAttr("class");
                this.inputEl.removeAttr("ng-click");
                this.inputEl.removeAttr("is-open");
                this.inputEl.removeAttr("init-date");
                this.inputEl.removeAttr("datepicker-popup");
                this.inputEl.removeAttr("required");
                this.inputEl.removeAttr("ng-model");
                this.inputEl.removeAttr("date-picker-append-to-body");
                this.inputEl.removeAttr("name");
                this.inputEl.attr("class", "input-group");
            }
        });
    }
]);
/*
Angular-ui bootstrap editable timepicker
http://angular-ui.github.io/bootstrap/#/timepicker
*/ angular.module("xeditable").directive("editableBstime", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        return editableDirectiveFactory({
            directiveName: "editableBstime",
            inputTpl: "<uib-timepicker></uib-timepicker>",
            render: function() {
                this.parent.render.call(this);
                // timepicker can't update model when ng-model set directly to it
                // see: https://github.com/angular-ui/bootstrap/issues/1141
                // so we wrap it into DIV
                var div = angular.element('<div class="well well-small" style="display:inline-block;"></div>');
                // move ng-model to wrapping div
                div.attr("ng-model", this.inputEl.attr("ng-model"));
                this.inputEl.removeAttr("ng-model");
                // move ng-change to wrapping div
                if (this.attrs.eNgChange) {
                    div.attr("ng-change", this.inputEl.attr("ng-change"));
                    this.inputEl.removeAttr("ng-change");
                }
                // wrap
                this.inputEl.wrap(div);
            }
        });
    }
]);
//checkbox
angular.module("xeditable").directive("editableCheckbox", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        return editableDirectiveFactory({
            directiveName: "editableCheckbox",
            inputTpl: '<input type="checkbox">',
            render: function() {
                this.parent.render.call(this);
                if (this.attrs.eTitle) {
                    this.inputEl.wrap("<label></label>");
                    this.inputEl.parent().append(this.attrs.eTitle);
                }
            },
            autosubmit: function() {
                var self = this;
                self.inputEl.bind("change", function() {
                    setTimeout(function() {
                        self.scope.$apply(function() {
                            self.scope.$form.$submit();
                        });
                    }, 500);
                });
            }
        });
    }
]);
// checklist
angular.module("xeditable").directive("editableChecklist", [
    "editableDirectiveFactory",
    "editableNgOptionsParser",
    function(editableDirectiveFactory, editableNgOptionsParser) {
        return editableDirectiveFactory({
            directiveName: "editableChecklist",
            inputTpl: "<span></span>",
            useCopy: true,
            render: function() {
                this.parent.render.call(this);
                var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
                var html = '<label ng-repeat="' + parsed.ngRepeat + '">' + '<input type="checkbox" checklist-model="$parent.$data" checklist-value="' + parsed.locals.valueFn + '">' + '<span ng-bind="' + parsed.locals.displayFn + '"></span></label>';
                this.inputEl.removeAttr("ng-model");
                this.inputEl.removeAttr("ng-options");
                this.inputEl.html(html);
            }
        });
    }
]);
angular.module("xeditable").directive("editableCombodate", [
    "editableDirectiveFactory",
    "editableCombodate",
    function(editableDirectiveFactory, editableCombodate) {
        return editableDirectiveFactory({
            directiveName: "editableCombodate",
            inputTpl: '<input type="text">',
            render: function() {
                this.parent.render.call(this);
                var options = {
                    value: new Date(this.scope.$data)
                };
                var self = this;
                angular.forEach([
                    "format",
                    "template",
                    "minYear",
                    "maxYear",
                    "yearDescending",
                    "minuteStep",
                    "secondStep",
                    "firstItem",
                    "errorClass",
                    "customClass",
                    "roundTime",
                    "smartDays"
                ], function(name) {
                    var attrName = "e" + name.charAt(0).toUpperCase() + name.slice(1);
                    if (attrName in self.attrs) options[name] = self.attrs[attrName];
                });
                var combodate = editableCombodate.getInstance(this.inputEl, options);
                combodate.$widget.find("select").bind("change", function(e) {
                    self.scope.$data = new Date(combodate.getValue()).toISOString();
                });
            }
        });
    }
]);
/*
Input types: text|email|tel|number|url|search|color|date|datetime|time|month|week
*/ (function() {
    var types = "text|password|email|tel|number|url|search|color|date|datetime|time|month|week|file".split("|");
    //todo: datalist
    // generate directives
    angular.forEach(types, function(type) {
        var directiveName = "editable" + type.charAt(0).toUpperCase() + type.slice(1);
        angular.module("xeditable").directive(directiveName, [
            "editableDirectiveFactory",
            function(editableDirectiveFactory) {
                return editableDirectiveFactory({
                    directiveName: directiveName,
                    inputTpl: '<input type="' + type + '">'
                });
            }
        ]);
    });
    //`range` is bit specific
    angular.module("xeditable").directive("editableRange", [
        "editableDirectiveFactory",
        function(editableDirectiveFactory) {
            return editableDirectiveFactory({
                directiveName: "editableRange",
                inputTpl: '<input type="range" id="range" name="range">',
                render: function() {
                    this.parent.render.call(this);
                    this.inputEl.after("<output>{{$data}}</output>");
                }
            });
        }
    ]);
})();
// radiolist
angular.module("xeditable").directive("editableRadiolist", [
    "editableDirectiveFactory",
    "editableNgOptionsParser",
    function(editableDirectiveFactory, editableNgOptionsParser) {
        return editableDirectiveFactory({
            directiveName: "editableRadiolist",
            inputTpl: "<span></span>",
            render: function() {
                this.parent.render.call(this);
                var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
                var html = '<label ng-repeat="' + parsed.ngRepeat + '">' + '<input type="radio" ng-disabled="' + this.attrs.eNgDisabled + '" ng-model="$parent.$data" value="{{' + parsed.locals.valueFn + '}}">' + '<span ng-bind="' + parsed.locals.displayFn + '"></span></label>';
                this.inputEl.removeAttr("ng-model");
                this.inputEl.removeAttr("ng-options");
                this.inputEl.html(html);
            },
            autosubmit: function() {
                var self = this;
                self.inputEl.bind("change", function() {
                    setTimeout(function() {
                        self.scope.$apply(function() {
                            self.scope.$form.$submit();
                        });
                    }, 500);
                });
            }
        });
    }
]);
//select
angular.module("xeditable").directive("editableSelect", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        return editableDirectiveFactory({
            directiveName: "editableSelect",
            inputTpl: "<select></select>",
            autosubmit: function() {
                var self = this;
                self.inputEl.bind("change", function() {
                    self.scope.$apply(function() {
                        self.scope.$form.$submit();
                    });
                });
            }
        });
    }
]);
//textarea
angular.module("xeditable").directive("editableTextarea", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        return editableDirectiveFactory({
            directiveName: "editableTextarea",
            inputTpl: "<textarea></textarea>",
            addListeners: function() {
                var self = this;
                self.parent.addListeners.call(self);
                // submit textarea by ctrl+enter even with buttons
                if (self.single && self.buttons !== "no") self.autosubmit();
            },
            autosubmit: function() {
                var self = this;
                self.inputEl.bind("keydown", function(e) {
                    if ((e.ctrlKey || e.metaKey) && e.keyCode === 13) self.scope.$apply(function() {
                        self.scope.$form.$submit();
                    });
                });
            }
        });
    }
]);
/*
 AngularJS-native version of Select2 and Selectize
 https://github.com/angular-ui/ui-select
 */ angular.module("xeditable").directive("editableUiSelect", [
    "editableDirectiveFactory",
    function(editableDirectiveFactory) {
        var rename = function(tag, el) {
            var newEl = angular.element("<" + tag + "/>");
            newEl.html(el.html());
            var attrs = el[0].attributes;
            for(var i = 0; i < attrs.length; ++i)newEl.attr(attrs.item(i).nodeName, attrs.item(i).value);
            return newEl;
        };
        var match = null;
        var choices = null;
        var dir = editableDirectiveFactory({
            directiveName: "editableUiSelect",
            inputTpl: "<ui-select></ui-select>",
            render: function() {
                this.parent.render.call(this);
                this.inputEl.append(rename("ui-select-match", match));
                this.inputEl.append(rename("ui-select-choices", choices));
                this.inputEl.removeAttr("ng-model");
                this.inputEl.attr("ng-model", "$parent.$data");
            }
        });
        var linkOrg = dir.link;
        dir.link = function(scope, el, attrs, ctrl) {
            var matchEl = el.find("editable-ui-select-match");
            var choicesEl = el.find("editable-ui-select-choices");
            match = matchEl.clone();
            choices = choicesEl.clone();
            matchEl.remove();
            choicesEl.remove();
            return linkOrg(scope, el, attrs, ctrl);
        };
        return dir;
    }
]);
/**
 * EditableController class. 
 * Attached to element with `editable-xxx` directive.
 *
 * @namespace editable-element
 */ /*
TODO: this file should be refactored to work more clear without closures!
*/ angular.module("xeditable").factory("editableController", [
    "$q",
    "editableUtils",
    function($q, editableUtils) {
        //EditableController function
        EditableController.$inject = [
            "$scope",
            "$attrs",
            "$element",
            "$parse",
            "editableThemes",
            "editableIcons",
            "editableOptions",
            "$rootScope",
            "$compile",
            "$q"
        ];
        function EditableController($scope, $attrs, $element, $parse, editableThemes, editableIcons, editableOptions, $rootScope, $compile, $q) {
            var valueGetter;
            //if control is disabled - it does not participate in waiting process
            var inWaiting;
            var self = this;
            self.scope = $scope;
            self.elem = $element;
            self.attrs = $attrs;
            self.inputEl = null;
            self.editorEl = null;
            self.single = true;
            self.error = "";
            self.theme = editableThemes[editableOptions.theme] || editableThemes["default"];
            self.parent = {};
            //will be undefined if icon_set is default and theme is default
            self.icon_set = editableOptions.icon_set === "default" ? editableIcons.default[editableOptions.theme] : editableIcons.external[editableOptions.icon_set];
            //to be overwritten by directive
            self.inputTpl = "";
            self.directiveName = "";
            // with majority of controls copy is not needed, but..
            // copy MUST NOT be used for `select-multiple` with objects as items
            // copy MUST be used for `checklist`
            self.useCopy = false;
            //runtime (defaults)
            self.single = null;
            /**
     * Attributes defined with `e-*` prefix automatically transfered from original element to
     * control.  
     * For example, if you set `<span editable-text="user.name" e-style="width: 100px"`>
     * then input will appear as `<input style="width: 100px">`.  
     * See [demo](#text-customize).
     * 
     * @var {any|attribute} e-*
     * @memberOf editable-element
     */ /**
     * Whether to show ok/cancel buttons. Values: `right|no`.
     * If set to `no` control automatically submitted when value changed.  
     * If control is part of form buttons will never be shown. 
     * 
     * @var {string|attribute} buttons
     * @memberOf editable-element
     */ self.buttons = "right";
            /**
     * Action when control losses focus. Values: `cancel|submit|ignore`.
     * Has sense only for single editable element.
     * Otherwise, if control is part of form - you should set `blur` of form, not of individual element.
     * 
     * @var {string|attribute} blur
     * @memberOf editable-element
     */ // no real `blur` property as it is transfered to editable form
            //init
            self.init = function(single) {
                self.single = single;
                self.name = $attrs.eName || $attrs[self.directiveName];
                /*
      if(!$attrs[directiveName] && !$attrs.eNgModel && ($attrs.eValue === undefined)) {
        throw 'You should provide value for `'+directiveName+'` or `e-value` in editable element!';
      }
      */ if ($attrs[self.directiveName]) valueGetter = $parse($attrs[self.directiveName]);
                else throw "You should provide value for `" + self.directiveName + "` in editable element!";
                // settings for single and non-single
                if (!self.single) // hide buttons for non-single
                self.buttons = "no";
                else self.buttons = self.attrs.buttons || editableOptions.buttons;
                //if name defined --> watch changes and update $data in form
                if ($attrs.eName) self.scope.$watch("$data", function(newVal) {
                    self.scope.$form.$data[$attrs.eName] = newVal;
                });
                /**
       * Called when control is shown.  
       * See [demo](#select-remote).
       * 
       * @var {method|attribute} onshow
       * @memberOf editable-element
       */ if ($attrs.onshow) self.onshow = function() {
                    return self.catchError($parse($attrs.onshow)($scope));
                };
                /**
       * Called when control is hidden after both save or cancel.  
       * 
       * @var {method|attribute} onhide
       * @memberOf editable-element
       */ if ($attrs.onhide) self.onhide = function() {
                    return $parse($attrs.onhide)($scope);
                };
                /**
       * Called when control is cancelled.  
       * 
       * @var {method|attribute} oncancel
       * @memberOf editable-element
       */ if ($attrs.oncancel) self.oncancel = function() {
                    return $parse($attrs.oncancel)($scope);
                };
                /**
       * Called during submit before value is saved to model.  
       * See [demo](#onbeforesave).
       * 
       * @var {method|attribute} onbeforesave
       * @memberOf editable-element
       */ if ($attrs.onbeforesave) self.onbeforesave = function() {
                    return self.catchError($parse($attrs.onbeforesave)($scope));
                };
                /**
       * Called during submit after value is saved to model.  
       * See [demo](#onaftersave).
       * 
       * @var {method|attribute} onaftersave
       * @memberOf editable-element
       */ if ($attrs.onaftersave) self.onaftersave = function() {
                    return self.catchError($parse($attrs.onaftersave)($scope));
                };
                // watch change of model to update editable element
                // now only add/remove `editable-empty` class.
                // Initially this method called with newVal = undefined, oldVal = undefined
                // so no need initially call handleEmpty() explicitly
                $scope.$parent.$watch($attrs[self.directiveName], function(newVal, oldVal) {
                    self.setLocalValue();
                    self.handleEmpty();
                });
            };
            self.render = function() {
                var theme = self.theme;
                //build input
                self.inputEl = angular.element(self.inputTpl);
                //build controls
                self.controlsEl = angular.element(theme.controlsTpl);
                self.controlsEl.append(self.inputEl);
                //build buttons
                if (self.buttons !== "no") {
                    self.buttonsEl = angular.element(theme.buttonsTpl);
                    self.submitEl = angular.element(theme.submitTpl);
                    self.cancelEl = angular.element(theme.cancelTpl);
                    if (self.icon_set) {
                        self.submitEl.find("span").addClass(self.icon_set.ok);
                        self.cancelEl.find("span").addClass(self.icon_set.cancel);
                    }
                    self.buttonsEl.append(self.submitEl).append(self.cancelEl);
                    self.controlsEl.append(self.buttonsEl);
                    self.inputEl.addClass("editable-has-buttons");
                }
                //build error
                self.errorEl = angular.element(theme.errorTpl);
                self.controlsEl.append(self.errorEl);
                //build editor
                self.editorEl = angular.element(self.single ? theme.formTpl : theme.noformTpl);
                self.editorEl.append(self.controlsEl);
                // transfer `e-*|data-e-*|x-e-*` attributes
                for(var k in $attrs.$attr){
                    if (k.length <= 1) continue;
                    var transferAttr = false;
                    var nextLetter = k.substring(1, 2);
                    // if starts with `e` + uppercase letter
                    if (k.substring(0, 1) === "e" && nextLetter === nextLetter.toUpperCase()) transferAttr = k.substring(1); // cut `e`
                    else continue;
                    // exclude `form` and `ng-submit`, 
                    if (transferAttr === "Form" || transferAttr === "NgSubmit") continue;
                    // convert back to lowercase style
                    transferAttr = transferAttr.substring(0, 1).toLowerCase() + editableUtils.camelToDash(transferAttr.substring(1));
                    // workaround for attributes without value (e.g. `multiple = "multiple"`)
                    // except for 'e-value'
                    var attrValue = transferAttr !== "value" && $attrs[k] === "" ? transferAttr : $attrs[k];
                    // set attributes to input
                    self.inputEl.attr(transferAttr, attrValue);
                }
                self.inputEl.addClass("editable-input");
                self.inputEl.attr("ng-model", "$data");
                // add directiveName class to editor, e.g. `editable-text`
                self.editorEl.addClass(editableUtils.camelToDash(self.directiveName));
                if (self.single) {
                    self.editorEl.attr("editable-form", "$form");
                    // transfer `blur` to form
                    self.editorEl.attr("blur", self.attrs.blur || (self.buttons === "no" ? "cancel" : editableOptions.blurElem));
                }
                //apply `postrender` method of theme
                if (angular.isFunction(theme.postrender)) theme.postrender.call(self);
            };
            // with majority of controls copy is not needed, but..
            // copy MUST NOT be used for `select-multiple` with objects as items
            // copy MUST be used for `checklist`
            self.setLocalValue = function() {
                self.scope.$data = self.useCopy ? angular.copy(valueGetter($scope.$parent)) : valueGetter($scope.$parent);
            };
            //show
            self.show = function() {
                // set value of scope.$data
                self.setLocalValue();
                /*
      Originally render() was inside init() method, but some directives polluting editorEl,
      so it is broken on second openning.
      Cloning is not a solution as jqLite can not clone with event handler's.
      */ self.render();
                // insert into DOM
                $element.after(self.editorEl);
                // compile (needed to attach ng-* events from markup)
                $compile(self.editorEl)($scope);
                // attach listeners (`escape`, autosubmit, etc)
                self.addListeners();
                // hide element
                $element.addClass("editable-hide");
                // onshow
                return self.onshow();
            };
            //hide
            self.hide = function() {
                self.editorEl.remove();
                $element.removeClass("editable-hide");
                // onhide
                return self.onhide();
            };
            // cancel
            self.cancel = function() {
                // oncancel
                self.oncancel();
            // don't call hide() here as it called in form's code
            };
            /*
    Called after show to attach listeners
    */ self.addListeners = function() {
                // bind keyup for `escape`
                self.inputEl.bind("keyup", function(e) {
                    if (!self.single) return;
                    // todo: move this to editable-form!
                    switch(e.keyCode){
                        // hide on `escape` press
                        case 27:
                            self.scope.$apply(function() {
                                self.scope.$form.$cancel();
                            });
                            break;
                    }
                });
                // autosubmit when `no buttons`
                if (self.single && self.buttons === "no") self.autosubmit();
                // click - mark element as clicked to exclude in document click handler
                self.editorEl.bind("click", function(e) {
                    // ignore right/middle button click
                    if (e.which && e.which !== 1) return;
                    if (self.scope.$form.$visible) self.scope.$form._clicked = true;
                });
            };
            // setWaiting
            self.setWaiting = function(value) {
                if (value) {
                    // participate in waiting only if not disabled
                    inWaiting = !self.inputEl.attr("disabled") && !self.inputEl.attr("ng-disabled") && !self.inputEl.attr("ng-enabled");
                    if (inWaiting) {
                        self.inputEl.attr("disabled", "disabled");
                        if (self.buttonsEl) self.buttonsEl.find("button").attr("disabled", "disabled");
                    }
                } else if (inWaiting) {
                    self.inputEl.removeAttr("disabled");
                    if (self.buttonsEl) self.buttonsEl.find("button").removeAttr("disabled");
                }
            };
            self.activate = function(start, end) {
                setTimeout(function() {
                    var el = self.inputEl[0];
                    if (editableOptions.activate === "focus" && el.focus) {
                        if (start) {
                            end = end || start;
                            el.onfocus = function() {
                                var that = this;
                                setTimeout(function() {
                                    that.setSelectionRange(start, end);
                                });
                            };
                        }
                        el.focus();
                    }
                    if (editableOptions.activate === "select" && el.select) el.select();
                }, 0);
            };
            self.setError = function(msg) {
                if (!angular.isObject(msg)) {
                    $scope.$error = msg;
                    self.error = msg;
                }
            };
            /*
    Checks that result is string or promise returned string and shows it as error message
    Applied to onshow, onbeforesave, onaftersave
    */ self.catchError = function(result, noPromise) {
                if (angular.isObject(result) && noPromise !== true) $q.when(result).then(//success and fail handlers are equal
                angular.bind(this, function(r) {
                    this.catchError(r, true);
                }), angular.bind(this, function(r) {
                    this.catchError(r, true);
                }));
                else if (noPromise && angular.isObject(result) && result.status && result.status !== 200 && result.data && angular.isString(result.data)) {
                    this.setError(result.data);
                    //set result to string: to let form know that there was error
                    result = result.data;
                } else if (angular.isString(result)) this.setError(result);
                return result;
            };
            self.save = function() {
                valueGetter.assign($scope.$parent, self.useCopy ? angular.copy(self.scope.$data) : self.scope.$data);
            // no need to call handleEmpty here as we are watching change of model value
            // self.handleEmpty();
            };
            /*
    attach/detach `editable-empty` class to element
    */ self.handleEmpty = function() {
                var val = valueGetter($scope.$parent);
                var isEmpty = val === null || val === undefined || val === "" || angular.isArray(val) && val.length === 0;
                $element.toggleClass("editable-empty", isEmpty);
            };
            /*
    Called when `buttons = "no"` to submit automatically
    */ self.autosubmit = angular.noop;
            self.onshow = angular.noop;
            self.onhide = angular.noop;
            self.oncancel = angular.noop;
            self.onbeforesave = angular.noop;
            self.onaftersave = angular.noop;
        }
        return EditableController;
    }
]);
/*
editableFactory is used to generate editable directives (see `/directives` folder)
Inside it does several things:
- detect form for editable element. Form may be one of three types:
  1. autogenerated form (for single editable elements)
  2. wrapper form (element wrapped by <form> tag)
  3. linked form (element has `e-form` attribute pointing to existing form)

- attach editableController to element

Depends on: editableController, editableFormFactory
*/ angular.module("xeditable").factory("editableDirectiveFactory", [
    "$parse",
    "$compile",
    "editableThemes",
    "$rootScope",
    "$document",
    "editableController",
    "editableFormController",
    "editableOptions",
    function($parse, $compile, editableThemes, $rootScope, $document, editableController, editableFormController, editableOptions) {
        //directive object
        return function(overwrites) {
            return {
                restrict: "A",
                scope: true,
                require: [
                    overwrites.directiveName,
                    "?^form"
                ],
                controller: editableController,
                link: function(scope, elem, attrs, ctrl) {
                    // editable controller
                    var eCtrl = ctrl[0];
                    // form controller
                    var eFormCtrl;
                    // this variable indicates is element is bound to some existing form, 
                    // or it's single element who's form will be generated automatically
                    // By default consider single element without any linked form.ß
                    var hasForm = false;
                    // element wrapped by form
                    if (ctrl[1]) {
                        eFormCtrl = ctrl[1];
                        hasForm = attrs.eSingle === undefined;
                    } else if (attrs.eForm) {
                        var getter = $parse(attrs.eForm)(scope);
                        if (getter) {
                            eFormCtrl = getter;
                            hasForm = true;
                        } else {
                            for(var i = 0; i < $document[0].forms.length; i++)if ($document[0].forms[i].name === attrs.eForm) {
                                // form is below and not processed yet
                                eFormCtrl = null;
                                hasForm = true;
                                break;
                            }
                        }
                    }
                    /*
        if(hasForm && !attrs.eName) {
          throw 'You should provide `e-name` for editable element inside form!';
        }
        */ //check for `editable-form` attr in form
                    /*
        if(eFormCtrl && ) {
          throw 'You should provide `e-name` for editable element inside form!';
        }
        */ // store original props to `parent` before merge
                    angular.forEach(overwrites, function(v, k) {
                        if (eCtrl[k] !== undefined) eCtrl.parent[k] = eCtrl[k];
                    });
                    // merge overwrites to base editable controller
                    angular.extend(eCtrl, overwrites);
                    // x-editable can be disabled using editableOption or edit-disabled attribute
                    var disabled = angular.isDefined(attrs.editDisabled) ? scope.$eval(attrs.editDisabled) : editableOptions.isDisabled;
                    if (disabled) return;
                    // init editable ctrl
                    eCtrl.init(!hasForm);
                    // publich editable controller as `$editable` to be referenced in html
                    scope.$editable = eCtrl;
                    // add `editable` class to element
                    elem.addClass("editable");
                    // hasForm
                    if (hasForm) {
                        if (eFormCtrl) {
                            scope.$form = eFormCtrl;
                            if (!scope.$form.$addEditable) throw "Form with editable elements should have `editable-form` attribute.";
                            scope.$form.$addEditable(eCtrl);
                        } else {
                            // future form (below): add editable controller to buffer and add to form later
                            $rootScope.$$editableBuffer = $rootScope.$$editableBuffer || {};
                            $rootScope.$$editableBuffer[attrs.eForm] = $rootScope.$$editableBuffer[attrs.eForm] || [];
                            $rootScope.$$editableBuffer[attrs.eForm].push(eCtrl);
                            scope.$form = null; //will be re-assigned later
                        }
                    } else {
                        // create editableform controller
                        scope.$form = editableFormController();
                        // add self to editable controller
                        scope.$form.$addEditable(eCtrl);
                        // if `e-form` provided, publish local $form in scope
                        if (attrs.eForm) scope.$parent[attrs.eForm] = scope.$form;
                        // bind click - if no external form defined
                        if (!attrs.eForm || attrs.eClickable) {
                            elem.addClass("editable-click");
                            elem.bind(editableOptions.activationEvent, function(e) {
                                e.preventDefault();
                                e.editable = eCtrl;
                                scope.$apply(function() {
                                    scope.$form.$show();
                                });
                            });
                        }
                    }
                }
            };
        };
    }
]);
/*
Returns editableForm controller
*/ angular.module("xeditable").factory("editableFormController", [
    "$parse",
    "$document",
    "$rootScope",
    "editablePromiseCollection",
    "editableUtils",
    function($parse, $document, $rootScope, editablePromiseCollection, editableUtils) {
        // array of opened editable forms
        var shown = [];
        //Check if the child element correspond or is a descendant of the parent element
        var isSelfOrDescendant = function(parent, child) {
            if (child == parent) return true;
            var node = child.parentNode;
            while(node !== null){
                if (node == parent) return true;
                node = node.parentNode;
            }
            return false;
        };
        //Check if it is a real blur : if the click event appear on a shown editable elem, this is not a blur.
        var isBlur = function(shown, event) {
            var isBlur = true;
            var editables = shown.$editables;
            angular.forEach(editables, function(v) {
                var element = v.editorEl[0];
                if (isSelfOrDescendant(element, event.target)) isBlur = false;
            });
            return isBlur;
        };
        // bind click to body: cancel|submit|ignore forms
        $document.bind("click", function(e) {
            // ignore right/middle button click
            if (e.which && e.which !== 1) return;
            var toCancel = [];
            var toSubmit = [];
            for(var i = 0; i < shown.length; i++){
                // exclude clicked
                if (shown[i]._clicked) {
                    shown[i]._clicked = false;
                    continue;
                }
                // exclude waiting
                if (shown[i].$waiting) continue;
                if (shown[i]._blur === "cancel" && isBlur(shown[i], e)) toCancel.push(shown[i]);
                if (shown[i]._blur === "submit" && isBlur(shown[i], e)) toSubmit.push(shown[i]);
            }
            if (toCancel.length || toSubmit.length) $rootScope.$apply(function() {
                angular.forEach(toCancel, function(v) {
                    v.$cancel();
                });
                angular.forEach(toSubmit, function(v) {
                    v.$submit();
                });
            });
        });
        $rootScope.$on("closeEdit", function() {
            for(var i = 0; i < shown.length; i++)shown[i].$hide();
        });
        var base = {
            $addEditable: function(editable) {
                //console.log('add editable', editable.elem, editable.elem.bind);
                this.$editables.push(editable);
                //'on' is not supported in angular 1.0.8
                editable.elem.bind("$destroy", angular.bind(this, this.$removeEditable, editable));
                //bind editable's local $form to self (if not bound yet, below form) 
                if (!editable.scope.$form) editable.scope.$form = this;
                //if form already shown - call show() of new editable
                if (this.$visible) editable.catchError(editable.show());
                editable.catchError(editable.setWaiting(this.$waiting));
            },
            $removeEditable: function(editable) {
                //arrayRemove
                for(var i = 0; i < this.$editables.length; i++)if (this.$editables[i] === editable) {
                    this.$editables.splice(i, 1);
                    return;
                }
            },
            /**
     * Shows form with editable controls.
     * 
     * @method $show()
     * @memberOf editable-form
     */ $show: function() {
                if (this.$visible) return;
                this.$visible = true;
                var pc = editablePromiseCollection();
                //own show
                pc.when(this.$onshow());
                //clear errors
                this.$setError(null, "");
                //children show
                angular.forEach(this.$editables, function(editable) {
                    pc.when(editable.show());
                });
                //wait promises and activate
                pc.then({
                    onWait: angular.bind(this, this.$setWaiting),
                    onTrue: angular.bind(this, this.$activate),
                    onFalse: angular.bind(this, this.$activate),
                    onString: angular.bind(this, this.$activate)
                });
                // add to internal list of shown forms
                // setTimeout needed to prevent closing right after opening (e.g. when trigger by button)
                setTimeout(angular.bind(this, function() {
                    // clear `clicked` to get ready for clicks on visible form
                    this._clicked = false;
                    if (editableUtils.indexOf(shown, this) === -1) shown.push(this);
                }), 0);
            },
            /**
     * Sets focus on form field specified by `name`.
     * 
     * @method $activate(name)
     * @param {string} name name of field
     * @memberOf editable-form
     */ $activate: function(name) {
                var i;
                if (this.$editables.length) {
                    //activate by name
                    if (angular.isString(name)) {
                        for(i = 0; i < this.$editables.length; i++)if (this.$editables[i].name === name) {
                            this.$editables[i].activate();
                            return;
                        }
                    }
                    //try activate error field
                    for(i = 0; i < this.$editables.length; i++)if (this.$editables[i].error) {
                        this.$editables[i].activate();
                        return;
                    }
                    //by default activate first field
                    this.$editables[0].activate(this.$editables[0].elem[0].selectionStart, this.$editables[0].elem[0].selectionEnd);
                }
            },
            /**
     * Hides form with editable controls without saving.
     * 
     * @method $hide()
     * @memberOf editable-form
     */ $hide: function() {
                if (!this.$visible) return;
                this.$visible = false;
                // self hide
                this.$onhide();
                // children's hide
                angular.forEach(this.$editables, function(editable) {
                    editable.hide();
                });
                // remove from internal list of shown forms
                editableUtils.arrayRemove(shown, this);
            },
            /**
     * Triggers `oncancel` event and calls `$hide()`.
     * 
     * @method $cancel()
     * @memberOf editable-form
     */ $cancel: function() {
                if (!this.$visible) return;
                // self cancel
                this.$oncancel();
                // children's cancel      
                angular.forEach(this.$editables, function(editable) {
                    editable.cancel();
                });
                // self hide
                this.$hide();
            },
            $setWaiting: function(value) {
                this.$waiting = !!value;
                // we can't just set $waiting variable and use it via ng-disabled in children
                // because in editable-row form is not accessible
                angular.forEach(this.$editables, function(editable) {
                    editable.setWaiting(!!value);
                });
            },
            /**
     * Shows error message for particular field.
     * 
     * @method $setError(name, msg)
     * @param {string} name name of field
     * @param {string} msg error message
     * @memberOf editable-form
     */ $setError: function(name, msg) {
                angular.forEach(this.$editables, function(editable) {
                    if (!name || editable.name === name) editable.setError(msg);
                });
            },
            $submit: function() {
                if (this.$waiting) return;
                //clear errors
                this.$setError(null, "");
                //children onbeforesave
                var pc = editablePromiseCollection();
                angular.forEach(this.$editables, function(editable) {
                    pc.when(editable.onbeforesave());
                });
                /*
      onbeforesave result:
      - true/undefined: save data and close form
      - false: close form without saving
      - string: keep form open and show error
      */ pc.then({
                    onWait: angular.bind(this, this.$setWaiting),
                    onTrue: angular.bind(this, checkSelf, true),
                    onFalse: angular.bind(this, checkSelf, false),
                    onString: angular.bind(this, this.$activate)
                });
                //save
                function checkSelf(childrenTrue) {
                    var pc = editablePromiseCollection();
                    pc.when(this.$onbeforesave());
                    pc.then({
                        onWait: angular.bind(this, this.$setWaiting),
                        onTrue: childrenTrue ? angular.bind(this, this.$save) : angular.bind(this, this.$hide),
                        onFalse: angular.bind(this, this.$hide),
                        onString: angular.bind(this, this.$activate)
                    });
                }
            },
            $save: function() {
                // write model for each editable
                angular.forEach(this.$editables, function(editable) {
                    editable.save();
                });
                //call onaftersave of self and children
                var pc = editablePromiseCollection();
                pc.when(this.$onaftersave());
                angular.forEach(this.$editables, function(editable) {
                    pc.when(editable.onaftersave());
                });
                /*
      onaftersave result:
      - true/undefined/false: just close form
      - string: keep form open and show error
      */ pc.then({
                    onWait: angular.bind(this, this.$setWaiting),
                    onTrue: angular.bind(this, this.$hide),
                    onFalse: angular.bind(this, this.$hide),
                    onString: angular.bind(this, this.$activate)
                });
            },
            $onshow: angular.noop,
            $oncancel: angular.noop,
            $onhide: angular.noop,
            $onbeforesave: angular.noop,
            $onaftersave: angular.noop
        };
        return function() {
            return angular.extend({
                $editables: [],
                /**
       * Form visibility flag.
       * 
       * @var {bool} $visible
       * @memberOf editable-form
       */ $visible: false,
                /**
       * Form waiting flag. It becomes `true` when form is loading or saving data.
       * 
       * @var {bool} $waiting
       * @memberOf editable-form
       */ $waiting: false,
                $data: {},
                _clicked: false,
                _blur: null
            }, base);
        };
    }
]);
/**
 * EditableForm directive. Should be defined in <form> containing editable controls.  
 * It add some usefull methods to form variable exposed to scope by `name="myform"` attribute.
 *
 * @namespace editable-form
 */ angular.module("xeditable").directive("editableForm", [
    "$rootScope",
    "$parse",
    "editableFormController",
    "editableOptions",
    function($rootScope, $parse, editableFormController, editableOptions) {
        return {
            restrict: "A",
            require: [
                "form"
            ],
            //require: ['form', 'editableForm'],
            //controller: EditableFormController,
            compile: function() {
                return {
                    pre: function(scope, elem, attrs, ctrl) {
                        var form = ctrl[0];
                        var eForm;
                        //if `editableForm` has value - publish smartly under this value
                        //this is required only for single editor form that is created and removed
                        if (attrs.editableForm) {
                            if (scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
                                eForm = scope[attrs.editableForm];
                                angular.extend(form, eForm);
                            } else {
                                eForm = editableFormController();
                                scope[attrs.editableForm] = eForm;
                                angular.extend(eForm, form);
                            }
                        } else {
                            eForm = editableFormController();
                            angular.extend(form, eForm);
                        }
                        //read editables from buffer (that appeared before FORM tag)
                        var buf = $rootScope.$$editableBuffer;
                        var name = form.$name;
                        if (name && buf && buf[name]) {
                            angular.forEach(buf[name], function(editable) {
                                eForm.$addEditable(editable);
                            });
                            delete buf[name];
                        }
                    },
                    post: function(scope, elem, attrs, ctrl) {
                        var eForm;
                        if (attrs.editableForm && scope[attrs.editableForm] && scope[attrs.editableForm].$show) eForm = scope[attrs.editableForm];
                        else eForm = ctrl[0];
                        /**
             * Called when form is shown.
             * 
             * @var {method|attribute} onshow 
             * @memberOf editable-form
             */ if (attrs.onshow) eForm.$onshow = angular.bind(eForm, $parse(attrs.onshow), scope);
                        /**
             * Called when form hides after both save or cancel.
             * 
             * @var {method|attribute} onhide 
             * @memberOf editable-form
             */ if (attrs.onhide) eForm.$onhide = angular.bind(eForm, $parse(attrs.onhide), scope);
                        /**
             * Called when form is cancelled.
             * 
             * @var {method|attribute} oncancel
             * @memberOf editable-form
             */ if (attrs.oncancel) eForm.$oncancel = angular.bind(eForm, $parse(attrs.oncancel), scope);
                        /**
             * Whether form initially rendered in shown state.
             *
             * @var {bool|attribute} shown
             * @memberOf editable-form
             */ if (attrs.shown && $parse(attrs.shown)(scope)) eForm.$show();
                        /**
             * Action when form losses focus. Values: `cancel|submit|ignore`.
             * Default is `ignore`.
             * 
             * @var {string|attribute} blur
             * @memberOf editable-form
             */ eForm._blur = attrs.blur || editableOptions.blurForm;
                        // onbeforesave, onaftersave
                        if (!attrs.ngSubmit && !attrs.submit) {
                            /**
               * Called after all children `onbeforesave` callbacks but before saving form values
               * to model.  
               * If at least one children callback returns `non-string` - it will not not be called.  
               * See [editable-form demo](#editable-form) for details.
               * 
               * @var {method|attribute} onbeforesave
               * @memberOf editable-form
               * 
               */ if (attrs.onbeforesave) eForm.$onbeforesave = function() {
                                return $parse(attrs.onbeforesave)(scope, {
                                    $data: eForm.$data
                                });
                            };
                            /**
               * Called when form values are saved to model.  
               * See [editable-form demo](#editable-form) for details.
               * 
               * @var {method|attribute} onaftersave 
               * @memberOf editable-form
               * 
               */ if (attrs.onaftersave) eForm.$onaftersave = function() {
                                return $parse(attrs.onaftersave)(scope, {
                                    $data: eForm.$data
                                });
                            };
                            elem.bind("submit", function(event) {
                                event.preventDefault();
                                scope.$apply(function() {
                                    eForm.$submit();
                                });
                            });
                        }
                        // click - mark form as clicked to exclude in document click handler
                        elem.bind("click", function(e) {
                            // ignore right/middle button click
                            if (e.which && e.which !== 1) return;
                            if (eForm.$visible) eForm._clicked = true;
                        });
                    }
                };
            }
        };
    }
]);
/**
 * editablePromiseCollection
 *  
 * Collect results of function calls. Shows waiting if there are promises. 
 * Finally, applies callbacks if:
 * - onTrue(): all results are true and all promises resolved to true
 * - onFalse(): at least one result is false or promise resolved to false
 * - onString(): at least one result is string or promise rejected or promise resolved to string
 */ angular.module("xeditable").factory("editablePromiseCollection", [
    "$q",
    function($q) {
        function promiseCollection() {
            return {
                promises: [],
                hasFalse: false,
                hasString: false,
                when: function(result, noPromise) {
                    if (result === false) this.hasFalse = true;
                    else if (!noPromise && angular.isObject(result)) this.promises.push($q.when(result));
                    else if (angular.isString(result)) this.hasString = true;
                    else return;
                },
                //callbacks: onTrue, onFalse, onString
                then: function(callbacks) {
                    callbacks = callbacks || {};
                    var onTrue = callbacks.onTrue || angular.noop;
                    var onFalse = callbacks.onFalse || angular.noop;
                    var onString = callbacks.onString || angular.noop;
                    var onWait = callbacks.onWait || angular.noop;
                    var self = this;
                    if (this.promises.length) {
                        onWait(true);
                        $q.all(this.promises).then(//all resolved       
                        function(results) {
                            onWait(false);
                            //check all results via same `when` method (without checking promises)
                            angular.forEach(results, function(result) {
                                self.when(result, true);
                            });
                            applyCallback();
                        }, //some rejected
                        function(error) {
                            onWait(false);
                            onString();
                        });
                    } else applyCallback();
                    function applyCallback() {
                        if (!self.hasString && !self.hasFalse) onTrue();
                        else if (!self.hasString && self.hasFalse) onFalse();
                        else onString();
                    }
                }
            };
        }
        return promiseCollection;
    }
]);
/**
 * editableUtils
 */ angular.module("xeditable").factory("editableUtils", [
    function() {
        return {
            indexOf: function(array, obj) {
                if (array.indexOf) return array.indexOf(obj);
                for(var i = 0; i < array.length; i++){
                    if (obj === array[i]) return i;
                }
                return -1;
            },
            arrayRemove: function(array, value) {
                var index = this.indexOf(array, value);
                if (index >= 0) array.splice(index, 1);
                return value;
            },
            // copy from https://github.com/angular/angular.js/blob/master/src/Angular.js
            camelToDash: function(str) {
                var SNAKE_CASE_REGEXP = /[A-Z]/g;
                return str.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
                    return (pos ? "-" : "") + letter.toLowerCase();
                });
            },
            dashToCamel: function(str) {
                var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
                var MOZ_HACK_REGEXP = /^moz([A-Z])/;
                return str.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
                    return offset ? letter.toUpperCase() : letter;
                }).replace(MOZ_HACK_REGEXP, "Moz$1");
            }
        };
    }
]);
/**
 * editableNgOptionsParser
 *
 * see: https://github.com/angular/angular.js/blob/master/src/ng/directive/select.js#L131
 */ angular.module("xeditable").factory("editableNgOptionsParser", [
    function() {
        //0000111110000000000022220000000000000000000000333300000000000000444444444444444000000000555555555555555000000066666666666666600000000000000007777000000000000000000088888
        var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
        function parser(optionsExp) {
            var match;
            if (!(match = optionsExp.match(NG_OPTIONS_REGEXP))) throw "ng-options parse error";
            var displayFn = match[2] || match[1], valueName = match[4] || match[6], keyName = match[5], groupByFn = match[3] || "", valueFn = match[2] ? match[1] : valueName, valuesFn = match[7], track = match[8], trackFn = track ? match[8] : null;
            var ngRepeat;
            if (keyName === undefined) {
                ngRepeat = valueName + " in " + valuesFn;
                if (track !== undefined) ngRepeat += " track by " + trackFn;
            } else ngRepeat = "(" + keyName + ", " + valueName + ") in " + valuesFn;
            // group not supported yet
            return {
                ngRepeat: ngRepeat,
                locals: {
                    valueName: valueName,
                    keyName: keyName,
                    valueFn: valueFn,
                    displayFn: displayFn
                }
            };
        }
        return parser;
    }
]);
/**
 * editableCombodate
 *
 * angular version of https://github.com/vitalets/combodate
 */ angular.module("xeditable").factory("editableCombodate", [
    function() {
        function Combodate(element, options) {
            this.$element = angular.element(element);
            if (this.$element[0].nodeName != "INPUT") throw "Combodate should be applied to INPUT element";
            var currentYear = new Date().getFullYear();
            this.defaults = {
                //in this format value stored in original input
                format: "YYYY-MM-DD HH:mm",
                //in this format items in dropdowns are displayed
                template: "D / MMM / YYYY   H : mm",
                //initial value, can be `new Date()`
                value: null,
                minYear: 1970,
                maxYear: currentYear,
                yearDescending: true,
                minuteStep: 5,
                secondStep: 1,
                firstItem: "empty",
                errorClass: null,
                customClass: "",
                roundTime: true,
                smartDays: true // whether days in combo depend on selected month: 31, 30, 28
            };
            this.options = angular.extend({}, this.defaults, options);
            this.init();
        }
        Combodate.prototype = {
            constructor: Combodate,
            init: function() {
                this.map = {
                    //key   regexp    moment.method
                    day: [
                        "D",
                        "date"
                    ],
                    month: [
                        "M",
                        "month"
                    ],
                    year: [
                        "Y",
                        "year"
                    ],
                    hour: [
                        "[Hh]",
                        "hours"
                    ],
                    minute: [
                        "m",
                        "minutes"
                    ],
                    second: [
                        "s",
                        "seconds"
                    ],
                    ampm: [
                        "[Aa]",
                        ""
                    ]
                };
                this.$widget = angular.element('<span class="combodate"></span>').html(this.getTemplate());
                this.initCombos();
                if (this.options.smartDays) {
                    var combo = this;
                    this.$widget.find("select").bind("change", function(e) {
                        // update days count if month or year changes
                        if (angular.element(e.target).hasClass("month") || angular.element(e.target).hasClass("year")) combo.fillCombo("day");
                    });
                }
                this.$widget.find("select").css("width", "auto");
                // hide original input and insert widget                                       
                this.$element.css("display", "none").after(this.$widget);
                // set initial value
                this.setValue(this.$element.val() || this.options.value);
            },
            /*
     Replace tokens in template with <select> elements 
     */ getTemplate: function() {
                var tpl = this.options.template;
                var customClass = this.options.customClass;
                //first pass
                angular.forEach(this.map, function(v, k) {
                    v = v[0];
                    var r = new RegExp(v + "+");
                    var token = v.length > 1 ? v.substring(1, 2) : v;
                    tpl = tpl.replace(r, "{" + token + "}");
                });
                //replace spaces with &nbsp;
                tpl = tpl.replace(/ /g, "&nbsp;");
                //second pass
                angular.forEach(this.map, function(v, k) {
                    v = v[0];
                    var token = v.length > 1 ? v.substring(1, 2) : v;
                    tpl = tpl.replace("{" + token + "}", '<select class="' + k + " " + customClass + '"></select>');
                });
                return tpl;
            },
            /*
     Initialize combos that presents in template 
     */ initCombos: function() {
                for(var k in this.map){
                    var c = this.$widget[0].querySelectorAll("." + k);
                    // set properties like this.$day, this.$month etc.
                    this["$" + k] = c.length ? angular.element(c) : null;
                    // fill with items
                    this.fillCombo(k);
                }
            },
            /*
     Fill combo with items 
     */ fillCombo: function(k) {
                var $combo = this["$" + k];
                if (!$combo) return;
                // define method name to fill items, e.g `fillDays`
                var f = "fill" + k.charAt(0).toUpperCase() + k.slice(1);
                var items = this[f]();
                var value = $combo.val();
                $combo.html("");
                for(var i = 0; i < items.length; i++)$combo.append('<option value="' + items[i][0] + '">' + items[i][1] + "</option>");
                $combo.val(value);
            },
            /*
     Initialize items of combos. Handles `firstItem` option 
     */ fillCommon: function(key) {
                var values = [], relTime;
                if (this.options.firstItem === "name") {
                    //need both to support moment ver < 2 and  >= 2
                    relTime = moment.relativeTime || moment.langData()._relativeTime;
                    var header = typeof relTime[key] === "function" ? relTime[key](1, true, key, false) : relTime[key];
                    //take last entry (see momentjs lang files structure) 
                    header = header.split(" ").reverse()[0];
                    values.push([
                        "",
                        header
                    ]);
                } else if (this.options.firstItem === "empty") values.push([
                    "",
                    ""
                ]);
                return values;
            },
            /*
    fill day
    */ fillDay: function() {
                var items = this.fillCommon("d"), name, i, twoDigit = this.options.template.indexOf("DD") !== -1, daysCount = 31;
                // detect days count (depends on month and year)
                // originally https://github.com/vitalets/combodate/pull/7
                if (this.options.smartDays && this.$month && this.$year) {
                    var month = parseInt(this.$month.val(), 10);
                    var year = parseInt(this.$year.val(), 10);
                    if (!isNaN(month) && !isNaN(year)) daysCount = moment([
                        year,
                        month
                    ]).daysInMonth();
                }
                for(i = 1; i <= daysCount; i++){
                    name = twoDigit ? this.leadZero(i) : i;
                    items.push([
                        i,
                        name
                    ]);
                }
                return items;
            },
            /*
    fill month
    */ fillMonth: function() {
                var items = this.fillCommon("M"), name, i, longNames = this.options.template.indexOf("MMMM") !== -1, shortNames = this.options.template.indexOf("MMM") !== -1, twoDigit = this.options.template.indexOf("MM") !== -1;
                for(i = 0; i <= 11; i++){
                    if (longNames) //see https://github.com/timrwood/momentjs.com/pull/36
                    name = moment().date(1).month(i).format("MMMM");
                    else if (shortNames) name = moment().date(1).month(i).format("MMM");
                    else if (twoDigit) name = this.leadZero(i + 1);
                    else name = i + 1;
                    items.push([
                        i,
                        name
                    ]);
                }
                return items;
            },
            /*
    fill year
    */ fillYear: function() {
                var items = [], name, i, longNames = this.options.template.indexOf("YYYY") !== -1;
                for(i = this.options.maxYear; i >= this.options.minYear; i--){
                    name = longNames ? i : (i + "").substring(2);
                    items[this.options.yearDescending ? "push" : "unshift"]([
                        i,
                        name
                    ]);
                }
                items = this.fillCommon("y").concat(items);
                return items;
            },
            /*
    fill hour
    */ fillHour: function() {
                var items = this.fillCommon("h"), name, i, h12 = this.options.template.indexOf("h") !== -1, h24 = this.options.template.indexOf("H") !== -1, twoDigit = this.options.template.toLowerCase().indexOf("hh") !== -1, min = h12 ? 1 : 0, max = h12 ? 12 : 23;
                for(i = min; i <= max; i++){
                    name = twoDigit ? this.leadZero(i) : i;
                    items.push([
                        i,
                        name
                    ]);
                }
                return items;
            },
            /*
    fill minute
    */ fillMinute: function() {
                var items = this.fillCommon("m"), name, i, twoDigit = this.options.template.indexOf("mm") !== -1;
                for(i = 0; i <= 59; i += this.options.minuteStep){
                    name = twoDigit ? this.leadZero(i) : i;
                    items.push([
                        i,
                        name
                    ]);
                }
                return items;
            },
            /*
    fill second
    */ fillSecond: function() {
                var items = this.fillCommon("s"), name, i, twoDigit = this.options.template.indexOf("ss") !== -1;
                for(i = 0; i <= 59; i += this.options.secondStep){
                    name = twoDigit ? this.leadZero(i) : i;
                    items.push([
                        i,
                        name
                    ]);
                }
                return items;
            },
            /*
    fill ampm
    */ fillAmpm: function() {
                var ampmL = this.options.template.indexOf("a") !== -1, ampmU = this.options.template.indexOf("A") !== -1, items = [
                    [
                        "am",
                        ampmL ? "am" : "AM"
                    ],
                    [
                        "pm",
                        ampmL ? "pm" : "PM"
                    ]
                ];
                return items;
            },
            /*
     Returns current date value from combos. 
     If format not specified - `options.format` used.
     If format = `null` - Moment object returned.
     */ getValue: function(format) {
                var dt, values = {}, that = this, notSelected = false;
                //getting selected values    
                angular.forEach(this.map, function(v, k) {
                    if (k === "ampm") return;
                    var def = k === "day" ? 1 : 0;
                    values[k] = that["$" + k] ? parseInt(that["$" + k].val(), 10) : def;
                    if (isNaN(values[k])) {
                        notSelected = true;
                        return false;
                    }
                });
                //if at least one visible combo not selected - return empty string
                if (notSelected) return "";
                //convert hours 12h --> 24h 
                if (this.$ampm) {
                    //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
                    if (values.hour === 12) values.hour = this.$ampm.val() === "am" ? 0 : 12;
                    else values.hour = this.$ampm.val() === "am" ? values.hour : values.hour + 12;
                }
                dt = moment([
                    values.year,
                    values.month,
                    values.day,
                    values.hour,
                    values.minute,
                    values.second
                ]);
                //highlight invalid date
                this.highlight(dt);
                format = format === undefined ? this.options.format : format;
                if (format === null) return dt.isValid() ? dt : null;
                else return dt.isValid() ? dt.format(format) : "";
            },
            setValue: function(value) {
                if (!value) return;
                // parse in strict mode (third param `true`)
                var dt = typeof value === "string" ? moment(value, this.options.format, true) : moment(value), that = this, values = {};
                //function to find nearest value in select options
                function getNearest($select, value) {
                    var delta = {};
                    angular.forEach($select.children("option"), function(opt, i) {
                        var optValue = angular.element(opt).attr("value");
                        if (optValue === "") return;
                        var distance = Math.abs(optValue - value);
                        if (typeof delta.distance === "undefined" || distance < delta.distance) delta = {
                            value: optValue,
                            distance: distance
                        };
                    });
                    return delta.value;
                }
                if (dt.isValid()) {
                    //read values from date object
                    angular.forEach(this.map, function(v, k) {
                        if (k === "ampm") return;
                        values[k] = dt[v[1]]();
                    });
                    if (this.$ampm) {
                        //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
                        if (values.hour >= 12) {
                            values.ampm = "pm";
                            if (values.hour > 12) values.hour -= 12;
                        } else {
                            values.ampm = "am";
                            if (values.hour === 0) values.hour = 12;
                        }
                    }
                    angular.forEach(values, function(v, k) {
                        //call val() for each existing combo, e.g. this.$hour.val()
                        if (that["$" + k]) {
                            if (k === "minute" && that.options.minuteStep > 1 && that.options.roundTime) v = getNearest(that["$" + k], v);
                            if (k === "second" && that.options.secondStep > 1 && that.options.roundTime) v = getNearest(that["$" + k], v);
                            that["$" + k].val(v);
                        }
                    });
                    // update days count
                    if (this.options.smartDays) this.fillCombo("day");
                    this.$element.val(dt.format(this.options.format)).triggerHandler("change");
                }
            },
            /*
     highlight combos if date is invalid
     */ highlight: function(dt) {
                if (!dt.isValid()) {
                    if (this.options.errorClass) this.$widget.addClass(this.options.errorClass);
                    else {
                        //store original border color
                        if (!this.borderColor) this.borderColor = this.$widget.find("select").css("border-color");
                        this.$widget.find("select").css("border-color", "red");
                    }
                } else if (this.options.errorClass) this.$widget.removeClass(this.options.errorClass);
                else this.$widget.find("select").css("border-color", this.borderColor);
            },
            leadZero: function(v) {
                return v <= 9 ? "0" + v : v;
            },
            destroy: function() {
                this.$widget.remove();
                this.$element.removeData("combodate").show();
            }
        };
        return {
            getInstance: function(element, options) {
                return new Combodate(element, options);
            }
        };
    }
]);
/*
Editable icons:
- default
- font-awesome

*/ angular.module("xeditable").factory("editableIcons", function() {
    var icons = {
        //Icon-set to use, defaults to bootstrap icons
        default: {
            "bs2": {
                ok: "icon-ok icon-white",
                cancel: "icon-remove"
            },
            "bs3": {
                ok: "glyphicon glyphicon-ok",
                cancel: "glyphicon glyphicon-remove"
            }
        },
        external: {
            "font-awesome": {
                ok: "fa fa-check",
                cancel: "fa fa-times"
            }
        }
    };
    return icons;
});
/*
Editable themes:
- default
- bootstrap 2
- bootstrap 3
- semantic-ui

Note: in postrender() `this` is instance of editableController
*/ angular.module("xeditable").factory("editableThemes", function() {
    var themes = {
        //default
        "default": {
            formTpl: '<form class="editable-wrap"></form>',
            noformTpl: '<span class="editable-wrap"></span>',
            controlsTpl: '<span class="editable-controls"></span>',
            inputTpl: "",
            errorTpl: '<div class="editable-error" ng-show="$error" ng-bind="$error"></div>',
            buttonsTpl: '<span class="editable-buttons"></span>',
            submitTpl: '<button type="submit">save</button>',
            cancelTpl: '<button type="button" ng-click="$form.$cancel()">cancel</button>'
        },
        //bs2
        "bs2": {
            formTpl: '<form class="form-inline editable-wrap" role="form"></form>',
            noformTpl: '<span class="editable-wrap"></span>',
            controlsTpl: '<div class="editable-controls controls control-group" ng-class="{\'error\': $error}"></div>',
            inputTpl: "",
            errorTpl: '<div class="editable-error help-block" ng-show="$error" ng-bind="$error"></div>',
            buttonsTpl: '<span class="editable-buttons"></span>',
            submitTpl: '<button type="submit" class="btn btn-primary"><span></span></button>',
            cancelTpl: '<button type="button" class="btn" ng-click="$form.$cancel()"><span></span></button>'
        },
        //bs3
        "bs3": {
            formTpl: '<form class="form-inline editable-wrap" role="form"></form>',
            noformTpl: '<span class="editable-wrap"></span>',
            controlsTpl: '<div class="editable-controls form-group" ng-class="{\'has-error\': $error}"></div>',
            inputTpl: "",
            errorTpl: '<div class="editable-error help-block" ng-show="$error" ng-bind="$error"></div>',
            buttonsTpl: '<span class="editable-buttons"></span>',
            submitTpl: '<button type="submit" class="btn btn-primary"><span></span></button>',
            cancelTpl: '<button type="button" class="btn btn-default" ng-click="$form.$cancel()"><span></span></button>',
            //bs3 specific prop to change buttons class: btn-sm, btn-lg
            buttonsClass: "",
            //bs3 specific prop to change standard inputs class: input-sm, input-lg
            inputClass: "",
            postrender: function() {
                //apply `form-control` class to std inputs
                switch(this.directiveName){
                    case "editableText":
                    case "editableSelect":
                    case "editableTextarea":
                    case "editableEmail":
                    case "editableTel":
                    case "editableNumber":
                    case "editableUrl":
                    case "editableSearch":
                    case "editableDate":
                    case "editableDatetime":
                    case "editableBsdate":
                    case "editableTime":
                    case "editableMonth":
                    case "editableWeek":
                    case "editablePassword":
                        this.inputEl.addClass("form-control");
                        if (this.theme.inputClass) {
                            // don`t apply `input-sm` and `input-lg` to select multiple
                            // should be fixed in bs itself!
                            if (this.inputEl.attr("multiple") && (this.theme.inputClass === "input-sm" || this.theme.inputClass === "input-lg")) break;
                            this.inputEl.addClass(this.theme.inputClass);
                        }
                        break;
                    case "editableCheckbox":
                        this.editorEl.addClass("checkbox");
                }
                //apply buttonsClass (bs3 specific!)
                if (this.buttonsEl && this.theme.buttonsClass) this.buttonsEl.find("button").addClass(this.theme.buttonsClass);
            }
        },
        //semantic-ui
        "semantic": {
            formTpl: '<form class="editable-wrap ui form" ng-class="{\'error\': $error}" role="form"></form>',
            noformTpl: '<span class="editable-wrap"></span>',
            controlsTpl: '<div class="editable-controls ui fluid input" ng-class="{\'error\': $error}"></div>',
            inputTpl: "",
            errorTpl: '<div class="editable-error ui error message" ng-show="$error" ng-bind="$error"></div>',
            buttonsTpl: '<span class="mini ui buttons"></span>',
            submitTpl: '<button type="submit" class="ui primary button"><i class="ui check icon"></i></button>',
            cancelTpl: '<button type="button" class="ui button" ng-click="$form.$cancel()"><i class="ui cancel icon"></i></button>'
        }
    };
    return themes;
});

},{}],"abhSD":[function(require,module,exports) {
/*
 jQuery UI Sortable plugin wrapper

 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */ angular.module("ui.sortable", []).value("uiSortableConfig", {}).directive("uiSortable", [
    "uiSortableConfig",
    "$timeout",
    "$log",
    function(uiSortableConfig, $timeout, $log) {
        return {
            require: "?ngModel",
            scope: {
                ngModel: "=",
                uiSortable: "="
            },
            link: function(scope, element, attrs, ngModel) {
                var savedNodes;
                function combineCallbacks(first, second) {
                    if (second && typeof second === "function") return function() {
                        first.apply(this, arguments);
                        second.apply(this, arguments);
                    };
                    return first;
                }
                function getSortableWidgetInstance(element) {
                    // this is a fix to support jquery-ui prior to v1.11.x
                    // otherwise we should be using `element.sortable('instance')`
                    var data = element.data("ui-sortable");
                    if (data && typeof data === "object" && data.widgetFullName === "ui-sortable") return data;
                    return null;
                }
                function hasSortingHelper(element, ui) {
                    var helperOption = element.sortable("option", "helper");
                    return helperOption === "clone" || typeof helperOption === "function" && ui.item.sortable.isCustomHelperUsed();
                }
                // thanks jquery-ui
                function isFloating(item) {
                    return /left|right/.test(item.css("float")) || /inline|table-cell/.test(item.css("display"));
                }
                function getElementScope(elementScopes, element) {
                    var result = null;
                    for(var i = 0; i < elementScopes.length; i++){
                        var x = elementScopes[i];
                        if (x.element[0] === element[0]) {
                            result = x.scope;
                            break;
                        }
                    }
                    return result;
                }
                function afterStop(e, ui) {
                    ui.item.sortable._destroy();
                }
                var opts = {};
                // directive specific options
                var directiveOpts = {
                    "ui-floating": undefined
                };
                var callbacks = {
                    receive: null,
                    remove: null,
                    start: null,
                    stop: null,
                    update: null
                };
                var wrappers = {
                    helper: null
                };
                angular.extend(opts, directiveOpts, uiSortableConfig, scope.uiSortable);
                if (!angular.element.fn || !angular.element.fn.jquery) {
                    $log.error("ui.sortable: jQuery should be included before AngularJS!");
                    return;
                }
                if (ngModel) {
                    // When we add or remove elements, we need the sortable to 'refresh'
                    // so it can find the new/removed elements.
                    scope.$watch("ngModel.length", function() {
                        // Timeout to let ng-repeat modify the DOM
                        $timeout(function() {
                            // ensure that the jquery-ui-sortable widget instance
                            // is still bound to the directive's element
                            if (!!getSortableWidgetInstance(element)) element.sortable("refresh");
                        }, 0, false);
                    });
                    callbacks.start = function(e, ui) {
                        if (opts["ui-floating"] === "auto") {
                            // since the drag has started, the element will be
                            // absolutely positioned, so we check its siblings
                            var siblings = ui.item.siblings();
                            var sortableWidgetInstance = getSortableWidgetInstance(angular.element(e.target));
                            sortableWidgetInstance.floating = isFloating(siblings);
                        }
                        // Save the starting position of dragged item
                        ui.item.sortable = {
                            model: ngModel.$modelValue[ui.item.index()],
                            index: ui.item.index(),
                            source: ui.item.parent(),
                            sourceModel: ngModel.$modelValue,
                            cancel: function() {
                                ui.item.sortable._isCanceled = true;
                            },
                            isCanceled: function() {
                                return ui.item.sortable._isCanceled;
                            },
                            isCustomHelperUsed: function() {
                                return !!ui.item.sortable._isCustomHelperUsed;
                            },
                            _isCanceled: false,
                            _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
                            _destroy: function() {
                                angular.forEach(ui.item.sortable, function(value, key) {
                                    ui.item.sortable[key] = undefined;
                                });
                            }
                        };
                    };
                    callbacks.activate = function(e, ui) {
                        // We need to make a copy of the current element's contents so
                        // we can restore it after sortable has messed it up.
                        // This is inside activate (instead of start) in order to save
                        // both lists when dragging between connected lists.
                        savedNodes = element.contents();
                        // If this list has a placeholder (the connected lists won't),
                        // don't inlcude it in saved nodes.
                        var placeholder = element.sortable("option", "placeholder");
                        // placeholder.element will be a function if the placeholder, has
                        // been created (placeholder will be an object).  If it hasn't
                        // been created, either placeholder will be false if no
                        // placeholder class was given or placeholder.element will be
                        // undefined if a class was given (placeholder will be a string)
                        if (placeholder && placeholder.element && typeof placeholder.element === "function") {
                            var phElement = placeholder.element();
                            // workaround for jquery ui 1.9.x,
                            // not returning jquery collection
                            phElement = angular.element(phElement);
                            // exact match with the placeholder's class attribute to handle
                            // the case that multiple connected sortables exist and
                            // the placehoilder option equals the class of sortable items
                            var excludes = element.find('[class="' + phElement.attr("class") + '"]:not([ng-repeat], [data-ng-repeat])');
                            savedNodes = savedNodes.not(excludes);
                        }
                        // save the directive's scope so that it is accessible from ui.item.sortable
                        var connectedSortables = ui.item.sortable._connectedSortables || [];
                        connectedSortables.push({
                            element: element,
                            scope: scope
                        });
                        ui.item.sortable._connectedSortables = connectedSortables;
                    };
                    callbacks.update = function(e, ui) {
                        // Save current drop position but only if this is not a second
                        // update that happens when moving between lists because then
                        // the value will be overwritten with the old value
                        if (!ui.item.sortable.received) {
                            ui.item.sortable.dropindex = ui.item.index();
                            var droptarget = ui.item.parent();
                            ui.item.sortable.droptarget = droptarget;
                            var droptargetScope = getElementScope(ui.item.sortable._connectedSortables, droptarget);
                            ui.item.sortable.droptargetModel = droptargetScope.ngModel;
                            // Cancel the sort (let ng-repeat do the sort for us)
                            // Don't cancel if this is the received list because it has
                            // already been canceled in the other list, and trying to cancel
                            // here will mess up the DOM.
                            element.sortable("cancel");
                        }
                        // Put the nodes back exactly the way they started (this is very
                        // important because ng-repeat uses comment elements to delineate
                        // the start and stop of repeat sections and sortable doesn't
                        // respect their order (even if we cancel, the order of the
                        // comments are still messed up).
                        if (hasSortingHelper(element, ui) && !ui.item.sortable.received && element.sortable("option", "appendTo") === "parent") // restore all the savedNodes except .ui-sortable-helper element
                        // (which is placed last). That way it will be garbage collected.
                        savedNodes = savedNodes.not(savedNodes.last());
                        savedNodes.appendTo(element);
                        // If this is the target connected list then
                        // it's safe to clear the restored nodes since:
                        // update is currently running and
                        // stop is not called for the target list.
                        if (ui.item.sortable.received) savedNodes = null;
                        // If received is true (an item was dropped in from another list)
                        // then we add the new item to this list otherwise wait until the
                        // stop event where we will know if it was a sort or item was
                        // moved here from another list
                        if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) scope.$apply(function() {
                            ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0, ui.item.sortable.moved);
                        });
                    };
                    callbacks.stop = function(e, ui) {
                        // If the received flag hasn't be set on the item, this is a
                        // normal sort, if dropindex is set, the item was moved, so move
                        // the items in the list.
                        if (!ui.item.sortable.received && "dropindex" in ui.item.sortable && !ui.item.sortable.isCanceled()) scope.$apply(function() {
                            ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0, ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]);
                        });
                        else // if the item was not moved, then restore the elements
                        // so that the ngRepeat's comment are correct.
                        if ((!("dropindex" in ui.item.sortable) || ui.item.sortable.isCanceled()) && !hasSortingHelper(element, ui)) savedNodes.appendTo(element);
                        // It's now safe to clear the savedNodes
                        // since stop is the last callback.
                        savedNodes = null;
                    };
                    callbacks.receive = function(e, ui) {
                        // An item was dropped here from another list, set a flag on the
                        // item.
                        ui.item.sortable.received = true;
                    };
                    callbacks.remove = function(e, ui) {
                        // Workaround for a problem observed in nested connected lists.
                        // There should be an 'update' event before 'remove' when moving
                        // elements. If the event did not fire, cancel sorting.
                        if (!("dropindex" in ui.item.sortable)) {
                            element.sortable("cancel");
                            ui.item.sortable.cancel();
                        }
                        // Remove the item from this list's model and copy data into item,
                        // so the next list can retrive it
                        if (!ui.item.sortable.isCanceled()) scope.$apply(function() {
                            ui.item.sortable.moved = ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0];
                        });
                    };
                    wrappers.helper = function(inner) {
                        if (inner && typeof inner === "function") return function(e, item) {
                            var innerResult = inner.apply(this, arguments);
                            item.sortable._isCustomHelperUsed = item !== innerResult;
                            return innerResult;
                        };
                        return inner;
                    };
                    scope.$watch("uiSortable", function(newVal /*, oldVal*/ ) {
                        // ensure that the jquery-ui-sortable widget instance
                        // is still bound to the directive's element
                        var sortableWidgetInstance = getSortableWidgetInstance(element);
                        if (!!sortableWidgetInstance) angular.forEach(newVal, function(value, key) {
                            // if it's a custom option of the directive,
                            // handle it approprietly
                            if (key in directiveOpts) {
                                if (key === "ui-floating" && (value === false || value === true)) sortableWidgetInstance.floating = value;
                                opts[key] = value;
                                return;
                            }
                            if (callbacks[key]) {
                                if (key === "stop") {
                                    // call apply after stop
                                    value = combineCallbacks(value, function() {
                                        scope.$apply();
                                    });
                                    value = combineCallbacks(value, afterStop);
                                }
                                // wrap the callback
                                value = combineCallbacks(callbacks[key], value);
                            } else if (wrappers[key]) value = wrappers[key](value);
                            opts[key] = value;
                            element.sortable("option", key, value);
                        });
                    }, true);
                    angular.forEach(callbacks, function(value, key) {
                        opts[key] = combineCallbacks(value, opts[key]);
                        if (key === "stop") opts[key] = combineCallbacks(opts[key], afterStop);
                    });
                } else $log.info("ui.sortable: ngModel not provided!", element);
                // Create sortable
                element.sortable(opts);
            }
        };
    }
]);

},{}],"kiozJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TruTerritorySide", ()=>TruTerritorySide);
parcelHelpers.export(exports, "AngularTruTerritorySide", ()=>AngularTruTerritorySide);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react2Angular = require("react2angular");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactInAngularjs = require("react-in-angularjs");
var _sortable = require("@dnd-kit/sortable");
var _withReduxProvider = require("../../../services/withReduxProvider");
var _useAppSelector = require("../../../hooks/useAppSelector");
var _truTerritorySideFilters = require("./TruTerritorySideFilters");
var _sortableUl = require("../../../components/Sortable/SortableUl");
var _collectionLi = require("./CollectionLi");
const TruTerritorySide = ({ isPublicPage, close, removeCollection, toggleVisible, setMapLabel, setMapTheme, addTheme: ogAddTheme, editTheme: ogEditTheme, cloneTheme: ogCloneTheme, setFilters, setCollections, $scope })=>{
    const hasAccess = (0, _reactInAngularjs.getService)("hasMapAccess");
    const { map, currentThemes } = (0, _useAppSelector.useAppSelector)((state)=>state.pages.truterritory);
    const [openCollections, setOpenCollections] = (0, _react.useState)({});
    const [selectedCollection, setSelectedCollection] = (0, _react.useState)(); // when the map changes, close all collections and go back to the collections view
    (0, _react.useEffect)(()=>{
        setOpenCollections({});
        setSelectedCollection(undefined);
    }, [
        map?.ID
    ]);
    const onClose = ()=>$scope.$apply(()=>close());
    const toggleCollectionOpen = (ID)=>{
        setOpenCollections((openCollections)=>({
                ...openCollections,
                [ID]: !openCollections[ID]
            }));
    };
    const handleRemoveCollection = (ID)=>{
        $scope.$root.$apply(()=>{
            removeCollection && removeCollection(ID);
        });
    };
    const handleVisibleToggle = (ID)=>{
        $scope.$apply(()=>{
            toggleVisible(ID);
        });
    };
    const setTheme = (ID, theme)=>{
        $scope.$apply(()=>{
            setMapTheme(ID, theme);
        });
    };
    const setLabel = (ID, label)=>{
        $scope.$apply(()=>{
            setMapLabel(ID, label);
        });
    };
    const addTheme = (ID)=>{
        $scope.$apply(()=>{
            ogAddTheme && ogAddTheme(ID);
        });
    };
    const editTheme = (collectionID)=>{
        $scope.$apply(()=>{
            ogEditTheme && ogEditTheme(collectionID);
        });
        onClose();
    };
    const cloneTheme = (collectionID, theme)=>{
        $scope.$apply(()=>{
            ogCloneTheme && ogCloneTheme(collectionID, theme);
        });
    };
    const applyFilterChanges = (collectionID, filters)=>{
        $scope.$apply(()=>{
            setFilters && setFilters(collectionID, filters);
        });
    };
    const handleDragEnd = ({ active, over })=>{
        if (!map) return;
        if (active.data.current && active.id !== over?.id) {
            const oldIndex = map.collections.findIndex((c)=>c.ID === active.id);
            const newIndex = map.collections.findIndex((c)=>c.ID === over?.id);
            if (oldIndex === -1 || oldIndex === undefined || newIndex === -1 || newIndex === undefined) return;
            const newCollections = (0, _sortable.arrayMove)(map.collections ?? [], oldIndex, newIndex);
            $scope.$apply(()=>{
                setCollections(newCollections);
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "side-menu",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toggle-triangle open",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "triangle",
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "inner",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "map-tab tab-content",
                        style: selectedCollection ? {
                            width: "0px"
                        } : {},
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "input-search centered",
                                style: selectedCollection ? {
                                    opacity: 0
                                } : {},
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "search",
                                    type: "text",
                                    placeholder: "Search",
                                    "ng-model": "search"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "collections-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortableUl.SortableUl), {
                                    className: "collections",
                                    id: `side-collections-sortable`,
                                    items: map?.collections.map((c)=>c.ID) ?? [],
                                    onDragStart: ()=>setOpenCollections({}),
                                    onDragEnd: handleDragEnd,
                                    children: map?.collections.map((collection)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionLi.CollectionLi), {
                                            isOpen: openCollections[collection.ID],
                                            toggleOpen: ()=>toggleCollectionOpen(collection.ID),
                                            collection: collection,
                                            isVisible: map.visible[collection.ID],
                                            label: map.labels[collection.ID],
                                            isPublicPage: isPublicPage,
                                            theme: currentThemes[collection.ID],
                                            hasAccess: hasAccess,
                                            handleVisibleToggle: handleVisibleToggle,
                                            handleRemoveCollection: handleRemoveCollection,
                                            editTheme: editTheme,
                                            cloneTheme: cloneTheme,
                                            setTheme: setTheme,
                                            addTheme: addTheme,
                                            setLabel: setLabel,
                                            onSelect: setSelectedCollection
                                        }, `collection-${collection.ID}`))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "collections-tab tab-content",
                        style: selectedCollection ? {
                            width: "100%"
                        } : {
                            width: "0px",
                            paddingLeft: "0px"
                        },
                        children: selectedCollection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn plain back-button",
                                        onClick: ()=>setSelectedCollection(undefined),
                                        title: "Go back to collections list",
                                        children: "< Back"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _truTerritorySideFilters.TruTerritorySideFilters), {
                                    selectedCollection: selectedCollection,
                                    onApplyChanges: applyFilterChanges
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
TruTerritorySide.propTypes = {
    isPublicPage: (0, _propTypesDefault.default).bool,
    close: (0, _propTypesDefault.default).func.isRequired,
    removeCollection: (0, _propTypesDefault.default).func,
    toggleVisible: (0, _propTypesDefault.default).func.isRequired,
    setMapLabel: (0, _propTypesDefault.default).func.isRequired,
    setMapTheme: (0, _propTypesDefault.default).func.isRequired,
    addTheme: (0, _propTypesDefault.default).func,
    editTheme: (0, _propTypesDefault.default).func,
    cloneTheme: (0, _propTypesDefault.default).func,
    setFilters: (0, _propTypesDefault.default).func,
    setCollections: (0, _propTypesDefault.default).func.isRequired
};
const AngularTruTerritorySide = (0, _react2Angular.react2angular)((0, _withReduxProvider.withReduxProvider)(TruTerritorySide), Object.keys(TruTerritorySide.propTypes), [
    "$scope"
]);

},{"react/jsx-runtime":"38att","react":"llNeF","react2angular":"lq1hx","prop-types":"cRFmb","react-in-angularjs":"ink5J","@dnd-kit/sortable":"cb4ui","../../../services/withReduxProvider":"hKZ95","../../../hooks/useAppSelector":"eyWgN","./TruTerritorySideFilters":"k6bkT","../../../components/Sortable/SortableUl":"czKxS","./CollectionLi":"KTIf3","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"38att":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"aTNch"}],"aTNch":[function(require,module,exports) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"b6LNK","3fd2a064dc1f3641":"llNeF"}],"b6LNK":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"llNeF":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"65Fwc"}],"65Fwc":[function(require,module,exports) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"f790cf940e488cc5":"b6LNK"}],"lq1hx":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var fromPairs = require("983df138f6f376dd");
var ngcomponent_1 = require("f0c48df266fe2af5");
var React = require("6c15a48eaeccddff");
var react_dom_1 = require("d10eee684abf2e4c");
/**
 * Wraps a React component in Angular. Returns a new Angular component.
 *
 * Usage:
 *
 *   ```ts
 *   type Props = { foo: number }
 *   class ReactComponent extends React.Component<Props, S> {}
 *   const AngularComponent = react2angular(ReactComponent, ['foo'])
 *   ```
 */ function react2angular(Class, bindingNames, injectNames) {
    if (bindingNames === void 0) bindingNames = null;
    if (injectNames === void 0) injectNames = [];
    var names = bindingNames || Class.propTypes && Object.keys(Class.propTypes) || [];
    return {
        bindings: fromPairs(names.map(function(_) {
            return [
                _,
                "<"
            ];
        })),
        controller: [
            "$element"
        ].concat(injectNames, [
            /** @class */ function(_super) {
                __extends(class_1, _super);
                function class_1($element) {
                    var injectedProps = [];
                    for(var _i = 1; _i < arguments.length; _i++)injectedProps[_i - 1] = arguments[_i];
                    var _this = _super.call(this) || this;
                    _this.$element = $element;
                    _this.isDestroyed = false;
                    _this.injectedProps = {};
                    injectNames.forEach(function(name, i) {
                        _this.injectedProps[name] = injectedProps[i];
                    });
                    return _this;
                }
                Object.defineProperty(class_1, "$$ngIsClass", {
                    get: function() {
                        return true;
                    },
                    enumerable: true,
                    configurable: true
                });
                class_1.prototype.render = function() {
                    if (!this.isDestroyed) react_dom_1.render(React.createElement(Class, __assign({}, this.props, this.injectedProps)), this.$element[0]);
                };
                class_1.prototype.componentWillUnmount = function() {
                    this.isDestroyed = true;
                    react_dom_1.unmountComponentAtNode(this.$element[0]);
                };
                return class_1;
            }(ngcomponent_1.default)
        ])
    };
}
exports.react2angular = react2angular;

},{"983df138f6f376dd":"cr3E6","f0c48df266fe2af5":"5TPwl","6c15a48eaeccddff":"llNeF","d10eee684abf2e4c":"6sT93"}],"cr3E6":[function(require,module,exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['fred', 30], ['barney', 40]]);
 * // => { 'fred': 30, 'barney': 40 }
 */ function fromPairs(pairs) {
    var index = -1, length = pairs ? pairs.length : 0, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = fromPairs;

},{}],"5TPwl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var assign = require("1e76da40e11059ef");
var mapValues = require("76e44cc351a70435");
var some = require("b50b9bd692b78592");
var NgComponent = /** @class */ function() {
    function NgComponent() {
        this.__isFirstRender = true;
        this.state = {};
        this.props = {};
    }
    /*
      eg. {
        as: {currentValue: [1, 2, 3], previousValue: [1, 2]},
        bs: {currentValue: 42, previousValue: undefined}
      }
    */ // nb: this method is explicity exposed for unit testing
    NgComponent.prototype.$onChanges = function(changes) {
        var oldProps = this.props;
        // TODO: fix Lodash typings upstream
        var newProps = mapValues(changes, "currentValue");
        // TODO: implement nextState (which also means implement this.setState)
        var nextProps = assign({}, this.props, newProps);
        if (this.__isFirstRender) {
            assign(this, {
                props: nextProps
            });
            this.componentWillMount();
            this.render();
            this.__isFirstRender = false;
        } else {
            if (!this.didPropsChange(newProps, oldProps)) return;
            this.componentWillReceiveProps(nextProps);
            var shouldUpdate = this.shouldComponentUpdate(nextProps, this.state);
            assign(this, {
                props: nextProps
            });
            if (!shouldUpdate) return;
            this.componentWillUpdate(this.props, this.state);
            this.render();
            this.componentDidUpdate(this.props, this.state);
        }
    };
    NgComponent.prototype.$postLink = function() {
        this.componentDidMount();
    };
    NgComponent.prototype.$onDestroy = function() {
        this.componentWillUnmount();
    };
    NgComponent.prototype.didPropsChange = function(newProps, oldProps) {
        return some(newProps, function(v, k) {
            return v !== oldProps[k];
        });
    };
    /*
      lifecycle hooks
    */ NgComponent.prototype.componentWillMount = function() {};
    NgComponent.prototype.componentDidMount = function() {};
    NgComponent.prototype.componentWillReceiveProps = function(_props) {};
    NgComponent.prototype.shouldComponentUpdate = function(_nextProps, _nextState) {
        return true;
    };
    NgComponent.prototype.componentWillUpdate = function(_props, _state) {};
    NgComponent.prototype.componentDidUpdate = function(_props, _state) {};
    NgComponent.prototype.componentWillUnmount = function() {};
    NgComponent.prototype.render = function() {};
    return NgComponent;
}();
exports.default = NgComponent;

},{"1e76da40e11059ef":"jgVaw","76e44cc351a70435":"kqBo0","b50b9bd692b78592":"8E3WV"}],"jgVaw":[function(require,module,exports) {
var assignValue = require("b645784df286ac29"), copyObject = require("9c5572cc3d315b3d"), createAssigner = require("e38953ee464b2295"), isArrayLike = require("3f2c64f5be5d6409"), isPrototype = require("acd2b51bea31b33b"), keys = require("44229a3d70ce7c98");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var assign = createAssigner(function(object, source) {
    if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
    }
    for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
});
module.exports = assign;

},{"b645784df286ac29":"cVX54","9c5572cc3d315b3d":"l086A","e38953ee464b2295":"3ebkU","3f2c64f5be5d6409":"9wZOb","acd2b51bea31b33b":"lRykv","44229a3d70ce7c98":"kkFip"}],"cVX54":[function(require,module,exports) {
var baseAssignValue = require("52d19c395358dd2d"), eq = require("cd18a3602c8bc7af");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"52d19c395358dd2d":"9wnYn","cd18a3602c8bc7af":"3C4io"}],"9wnYn":[function(require,module,exports) {
var defineProperty = require("948cd960af79c6f2");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"948cd960af79c6f2":"qX1gi"}],"qX1gi":[function(require,module,exports) {
var getNative = require("bc271f6ee96de8e1");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"bc271f6ee96de8e1":"2sDCG"}],"2sDCG":[function(require,module,exports) {
var baseIsNative = require("1d87fe6011b4e25"), getValue = require("60a8000618940144");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"1d87fe6011b4e25":"ksYZz","60a8000618940144":"8iQ8P"}],"ksYZz":[function(require,module,exports) {
var isFunction = require("25c7479828cdf2c0"), isMasked = require("779f4ec20f0131fc"), isObject = require("7d96f883ed0a8e18"), toSource = require("62000c088ab8c74c");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"25c7479828cdf2c0":"9A09L","779f4ec20f0131fc":"1CPUc","7d96f883ed0a8e18":"jlVr8","62000c088ab8c74c":"gJ4r4"}],"9A09L":[function(require,module,exports) {
var baseGetTag = require("471abae21c11f12b"), isObject = require("bbe1c8aa11881a7f");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"471abae21c11f12b":"bSj1I","bbe1c8aa11881a7f":"jlVr8"}],"bSj1I":[function(require,module,exports) {
var Symbol = require("7f69f85cd33863fc"), getRawTag = require("c03c6d949ce9f584"), objectToString = require("27083b7073af1266");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"7f69f85cd33863fc":"ai5hG","c03c6d949ce9f584":"eVs08","27083b7073af1266":"adA7P"}],"ai5hG":[function(require,module,exports) {
var root = require("e67cb8e1ce221b43");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"e67cb8e1ce221b43":"hxxVb"}],"hxxVb":[function(require,module,exports) {
var freeGlobal = require("69b3fde8a41760b2");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"69b3fde8a41760b2":"hqz5J"}],"hqz5J":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"eVs08":[function(require,module,exports) {
var Symbol = require("ae827a288ea79f16");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"ae827a288ea79f16":"ai5hG"}],"adA7P":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"jlVr8":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"1CPUc":[function(require,module,exports) {
var coreJsData = require("6fb51207c11e4954");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"6fb51207c11e4954":"bRSt8"}],"bRSt8":[function(require,module,exports) {
var root = require("9e3a5c97ec528689");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"9e3a5c97ec528689":"hxxVb"}],"gJ4r4":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"8iQ8P":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"3C4io":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"l086A":[function(require,module,exports) {
var assignValue = require("a1df2909684b4b43"), baseAssignValue = require("65bc2b4288fbc909");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"a1df2909684b4b43":"cVX54","65bc2b4288fbc909":"9wnYn"}],"3ebkU":[function(require,module,exports) {
var baseRest = require("5e46217789065284"), isIterateeCall = require("2478b5357da1b4c8");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"5e46217789065284":"dv4IN","2478b5357da1b4c8":"g3mzK"}],"dv4IN":[function(require,module,exports) {
var identity = require("d59f674df14adeb3"), overRest = require("cd64e1e34ded7c62"), setToString = require("c9c8efc32e81c095");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"d59f674df14adeb3":"klK4k","cd64e1e34ded7c62":"hZjwU","c9c8efc32e81c095":"1xCZb"}],"klK4k":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"hZjwU":[function(require,module,exports) {
var apply = require("6eae5885614931a4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6eae5885614931a4":"krR0M"}],"krR0M":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"1xCZb":[function(require,module,exports) {
var baseSetToString = require("f4b320e76b19ad6e"), shortOut = require("de799d7511586837");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"f4b320e76b19ad6e":"g1u1Y","de799d7511586837":"3WRbK"}],"g1u1Y":[function(require,module,exports) {
var constant = require("3067808a654803d5"), defineProperty = require("42915b5a354619e9"), identity = require("136eb4a925ca8098");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"3067808a654803d5":"c3ncF","42915b5a354619e9":"qX1gi","136eb4a925ca8098":"klK4k"}],"c3ncF":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"3WRbK":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"g3mzK":[function(require,module,exports) {
var eq = require("363c4b2d97d1f016"), isArrayLike = require("65b55c986b3eb332"), isIndex = require("83d9db399a91b8c9"), isObject = require("c681ff00caff3976");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"363c4b2d97d1f016":"3C4io","65b55c986b3eb332":"9wZOb","83d9db399a91b8c9":"5432W","c681ff00caff3976":"jlVr8"}],"9wZOb":[function(require,module,exports) {
var isFunction = require("77428d2bb9797f9a"), isLength = require("299df8ee73e1c1ab");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"77428d2bb9797f9a":"9A09L","299df8ee73e1c1ab":"HGg0b"}],"HGg0b":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"5432W":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"lRykv":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"kkFip":[function(require,module,exports) {
var arrayLikeKeys = require("2eea47fa1de00b6f"), baseKeys = require("26e2bc2b32868bf9"), isArrayLike = require("38c3a58024525ca6");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"2eea47fa1de00b6f":"24vXl","26e2bc2b32868bf9":"isnXG","38c3a58024525ca6":"9wZOb"}],"24vXl":[function(require,module,exports) {
var baseTimes = require("dcbec8b7ce8fcc77"), isArguments = require("c08ba32f7aee0cdd"), isArray = require("f21cabeb066555f4"), isBuffer = require("adf47bc3172d4792"), isIndex = require("fafdd2502e13f53c"), isTypedArray = require("caec4102864ace27");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"dcbec8b7ce8fcc77":"aMyPE","c08ba32f7aee0cdd":"2L33C","f21cabeb066555f4":"1C8T5","adf47bc3172d4792":"1VI9w","fafdd2502e13f53c":"5432W","caec4102864ace27":"lVehZ"}],"aMyPE":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"2L33C":[function(require,module,exports) {
var baseIsArguments = require("fd8df4a3b2f8ac74"), isObjectLike = require("2a73ab561ae98209");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"fd8df4a3b2f8ac74":"23s9U","2a73ab561ae98209":"3fce1"}],"23s9U":[function(require,module,exports) {
var baseGetTag = require("5664452df5fc1637"), isObjectLike = require("c53380cc6e39ea02");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"5664452df5fc1637":"bSj1I","c53380cc6e39ea02":"3fce1"}],"3fce1":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"1C8T5":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"1VI9w":[function(require,module,exports) {
var root = require("73474ad74a2bb607"), stubFalse = require("6b0b0458c3ddd01d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"73474ad74a2bb607":"hxxVb","6b0b0458c3ddd01d":"cdeU7"}],"cdeU7":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"lVehZ":[function(require,module,exports) {
var baseIsTypedArray = require("2f1e10e80bc8ced4"), baseUnary = require("585a2b533a491c07"), nodeUtil = require("9ab6c1060aaa78bb");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"2f1e10e80bc8ced4":"l9lJK","585a2b533a491c07":"9Chqy","9ab6c1060aaa78bb":"aKFGo"}],"l9lJK":[function(require,module,exports) {
var baseGetTag = require("891c102cf63fe8f1"), isLength = require("c9cca0d2fcd03daf"), isObjectLike = require("7413f5c17f8eb3b");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"891c102cf63fe8f1":"bSj1I","c9cca0d2fcd03daf":"HGg0b","7413f5c17f8eb3b":"3fce1"}],"9Chqy":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"aKFGo":[function(require,module,exports) {
var freeGlobal = require("1b4968b707799c75");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"1b4968b707799c75":"hqz5J"}],"isnXG":[function(require,module,exports) {
var isPrototype = require("3ab9f77f16e0dca0"), nativeKeys = require("dd6804c8431939b0");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"3ab9f77f16e0dca0":"lRykv","dd6804c8431939b0":"cco4c"}],"cco4c":[function(require,module,exports) {
var overArg = require("d6eaf31123e7e338");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"d6eaf31123e7e338":"iEYiD"}],"iEYiD":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"kqBo0":[function(require,module,exports) {
var baseAssignValue = require("fbd6f0eb1d931855"), baseForOwn = require("cb16954396447fd3"), baseIteratee = require("288ea519b00e9a14");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"fbd6f0eb1d931855":"9wnYn","cb16954396447fd3":"d0uos","288ea519b00e9a14":"6BB6V"}],"d0uos":[function(require,module,exports) {
var baseFor = require("b421d5dc1243e519"), keys = require("f062d99c7fab0a4a");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"b421d5dc1243e519":"ToYpO","f062d99c7fab0a4a":"kkFip"}],"ToYpO":[function(require,module,exports) {
var createBaseFor = require("c684f9955c2baee2");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"c684f9955c2baee2":"3OMJk"}],"3OMJk":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"6BB6V":[function(require,module,exports) {
var baseMatches = require("b9eb941db1c07910"), baseMatchesProperty = require("64ae16fe0ac48568"), identity = require("2c5395e629f4cf65"), isArray = require("b24ce86d3c317dfb"), property = require("c73863d9808c0d54");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"b9eb941db1c07910":"2wKtZ","64ae16fe0ac48568":"1r2bR","2c5395e629f4cf65":"klK4k","b24ce86d3c317dfb":"1C8T5","c73863d9808c0d54":"18NDY"}],"2wKtZ":[function(require,module,exports) {
var baseIsMatch = require("f835c01a68cbf3b2"), getMatchData = require("bf8180cbb07017b8"), matchesStrictComparable = require("7ac3f4b8f0e5c93c");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"f835c01a68cbf3b2":"2KBA4","bf8180cbb07017b8":"a0enJ","7ac3f4b8f0e5c93c":"faImM"}],"2KBA4":[function(require,module,exports) {
var Stack = require("7c39e84150c378a5"), baseIsEqual = require("2ef4abb2cf395772");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"7c39e84150c378a5":"eUCye","2ef4abb2cf395772":"eGdf2"}],"eUCye":[function(require,module,exports) {
var ListCache = require("4139e18ff1ea2fba"), stackClear = require("a4b9925cce4ee32d"), stackDelete = require("6bd858967ae35653"), stackGet = require("48458d40fb7f1728"), stackHas = require("671f118275665e3a"), stackSet = require("a695625934efed20");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"4139e18ff1ea2fba":"3acZD","a4b9925cce4ee32d":"joQZn","6bd858967ae35653":"52g4z","48458d40fb7f1728":"cNm4b","671f118275665e3a":"3s84r","a695625934efed20":"6o0dz"}],"3acZD":[function(require,module,exports) {
var listCacheClear = require("f85b5749bf0e78aa"), listCacheDelete = require("1e1d90b098975ab6"), listCacheGet = require("21c96c8d75c57bd6"), listCacheHas = require("110a599a121381a0"), listCacheSet = require("5b652d9eb771fcbc");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"f85b5749bf0e78aa":"lW8On","1e1d90b098975ab6":"dBnjU","21c96c8d75c57bd6":"c0NKj","110a599a121381a0":"ef1bo","5b652d9eb771fcbc":"5DsA3"}],"lW8On":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"dBnjU":[function(require,module,exports) {
var assocIndexOf = require("8ccedb15d8f16813");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"8ccedb15d8f16813":"2aXO6"}],"2aXO6":[function(require,module,exports) {
var eq = require("bd75166f5bc33dd7");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"bd75166f5bc33dd7":"3C4io"}],"c0NKj":[function(require,module,exports) {
var assocIndexOf = require("36988f847c099435");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"36988f847c099435":"2aXO6"}],"ef1bo":[function(require,module,exports) {
var assocIndexOf = require("9578c21ba768ed42");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"9578c21ba768ed42":"2aXO6"}],"5DsA3":[function(require,module,exports) {
var assocIndexOf = require("eba24abcfd70324d");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"eba24abcfd70324d":"2aXO6"}],"joQZn":[function(require,module,exports) {
var ListCache = require("309d0c7ee04016ed");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"309d0c7ee04016ed":"3acZD"}],"52g4z":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"cNm4b":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"3s84r":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"6o0dz":[function(require,module,exports) {
var ListCache = require("ce3f85b166438924"), Map = require("a19a1a9234850f52"), MapCache = require("693f29226b53bf88");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"ce3f85b166438924":"3acZD","a19a1a9234850f52":"j8G4Y","693f29226b53bf88":"54WoC"}],"j8G4Y":[function(require,module,exports) {
var getNative = require("33fdeb64fccf6642"), root = require("29ba12d7d0b466ed");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"33fdeb64fccf6642":"2sDCG","29ba12d7d0b466ed":"hxxVb"}],"54WoC":[function(require,module,exports) {
var mapCacheClear = require("44d78db521611b60"), mapCacheDelete = require("2d72975df17409d7"), mapCacheGet = require("cd3d107c93e20b89"), mapCacheHas = require("187996c51d548502"), mapCacheSet = require("2b9b8d88324ad3eb");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"44d78db521611b60":"1mbkX","2d72975df17409d7":"hfTOv","cd3d107c93e20b89":"8klRF","187996c51d548502":"emJP5","2b9b8d88324ad3eb":"ccq9f"}],"1mbkX":[function(require,module,exports) {
var Hash = require("670b16b7856de449"), ListCache = require("168b4a7d8d971601"), Map = require("10bf72dd143ba88a");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"670b16b7856de449":"cQ1cz","168b4a7d8d971601":"3acZD","10bf72dd143ba88a":"j8G4Y"}],"cQ1cz":[function(require,module,exports) {
var hashClear = require("3be49fa513781aa"), hashDelete = require("2e737ef90c68ca80"), hashGet = require("ececcb39eb6c1b4b"), hashHas = require("8935df3db892927c"), hashSet = require("7681f837bb71c38");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"3be49fa513781aa":"drge0","2e737ef90c68ca80":"37bN2","ececcb39eb6c1b4b":"lCyIQ","8935df3db892927c":"g3mu1","7681f837bb71c38":"b1I4L"}],"drge0":[function(require,module,exports) {
var nativeCreate = require("545760b94d8f7be3");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"545760b94d8f7be3":"bvzUm"}],"bvzUm":[function(require,module,exports) {
var getNative = require("7eb52ee8ffc59d73");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"7eb52ee8ffc59d73":"2sDCG"}],"37bN2":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"lCyIQ":[function(require,module,exports) {
var nativeCreate = require("4dc90e667281166a");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"4dc90e667281166a":"bvzUm"}],"g3mu1":[function(require,module,exports) {
var nativeCreate = require("a97e4770fc89b446");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"a97e4770fc89b446":"bvzUm"}],"b1I4L":[function(require,module,exports) {
var nativeCreate = require("8b6297c67406fd0e");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"8b6297c67406fd0e":"bvzUm"}],"hfTOv":[function(require,module,exports) {
var getMapData = require("98a1298607080938");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"98a1298607080938":"18gW1"}],"18gW1":[function(require,module,exports) {
var isKeyable = require("4830a555c6c41e37");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"4830a555c6c41e37":"gGFq8"}],"gGFq8":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"8klRF":[function(require,module,exports) {
var getMapData = require("1306712252fed38e");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"1306712252fed38e":"18gW1"}],"emJP5":[function(require,module,exports) {
var getMapData = require("3078dbbc77c3a256");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"3078dbbc77c3a256":"18gW1"}],"ccq9f":[function(require,module,exports) {
var getMapData = require("23c289da3a398b3d");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"23c289da3a398b3d":"18gW1"}],"eGdf2":[function(require,module,exports) {
var baseIsEqualDeep = require("7400ef53e1a47d70"), isObjectLike = require("3dea3286eb4cbcdf");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"7400ef53e1a47d70":"Sy89q","3dea3286eb4cbcdf":"3fce1"}],"Sy89q":[function(require,module,exports) {
var Stack = require("de8d3c1b2456524c"), equalArrays = require("188ba788993a398"), equalByTag = require("d5d0abee5170da85"), equalObjects = require("23dbea8e466d5db6"), getTag = require("19541bd2df26d6b6"), isArray = require("f6ab7012f583f232"), isBuffer = require("b68a3fe69ddb3a8b"), isTypedArray = require("89bbbdf57a65f177");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"de8d3c1b2456524c":"eUCye","188ba788993a398":"jlp3D","d5d0abee5170da85":"qpAp2","23dbea8e466d5db6":"9XG5L","19541bd2df26d6b6":"lLF0I","f6ab7012f583f232":"1C8T5","b68a3fe69ddb3a8b":"1VI9w","89bbbdf57a65f177":"lVehZ"}],"jlp3D":[function(require,module,exports) {
var SetCache = require("c2a18607fce9eb5c"), arraySome = require("d067cb65697b9568"), cacheHas = require("ed02e6a613a423b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"c2a18607fce9eb5c":"hXTR9","d067cb65697b9568":"eXXwI","ed02e6a613a423b6":"eI1tX"}],"hXTR9":[function(require,module,exports) {
var MapCache = require("6f011567fecebdee"), setCacheAdd = require("8331cf6def89f31"), setCacheHas = require("6122ffba96abba65");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"6f011567fecebdee":"54WoC","8331cf6def89f31":"cFxKX","6122ffba96abba65":"hpBm9"}],"cFxKX":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"hpBm9":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"eXXwI":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"eI1tX":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"qpAp2":[function(require,module,exports) {
var Symbol = require("e3e6b7e4e30c373d"), Uint8Array = require("60fd470e968b30a6"), eq = require("d123cfed318b21f6"), equalArrays = require("3896b9f5930991b0"), mapToArray = require("1cf81d6ee3d53d8b"), setToArray = require("c52951a6246fb16b");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"e3e6b7e4e30c373d":"ai5hG","60fd470e968b30a6":"bFyZM","d123cfed318b21f6":"3C4io","3896b9f5930991b0":"jlp3D","1cf81d6ee3d53d8b":"6dW5t","c52951a6246fb16b":"cRpBI"}],"bFyZM":[function(require,module,exports) {
var root = require("13d9e2deef06dbb0");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"13d9e2deef06dbb0":"hxxVb"}],"6dW5t":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"cRpBI":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"9XG5L":[function(require,module,exports) {
var getAllKeys = require("8b4d59128aff9c97");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"8b4d59128aff9c97":"lxdNO"}],"lxdNO":[function(require,module,exports) {
var baseGetAllKeys = require("3c92d2643311abac"), getSymbols = require("b6ee62133887d9ba"), keys = require("ac1b2e7b8ffdc64c");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"3c92d2643311abac":"fKf6o","b6ee62133887d9ba":"hJWjH","ac1b2e7b8ffdc64c":"kkFip"}],"fKf6o":[function(require,module,exports) {
var arrayPush = require("4626175be62163f8"), isArray = require("c257dc4f9b63219e");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"4626175be62163f8":"6hsGv","c257dc4f9b63219e":"1C8T5"}],"6hsGv":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"hJWjH":[function(require,module,exports) {
var arrayFilter = require("3f9d935c26f26803"), stubArray = require("83dc11fb4864430d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"3f9d935c26f26803":"2KdCQ","83dc11fb4864430d":"2ggkW"}],"2KdCQ":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"2ggkW":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"lLF0I":[function(require,module,exports) {
var DataView = require("7cc36a8314d2ee56"), Map = require("2b17c674b25e5fe1"), Promise = require("ccc99b8e65f8606c"), Set = require("5a0a1f16a1279524"), WeakMap = require("2a04c84ed7db306b"), baseGetTag = require("5e20bf2dad25c37c"), toSource = require("3aa8b5d79a2a9024");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7cc36a8314d2ee56":"4WTcl","2b17c674b25e5fe1":"j8G4Y","ccc99b8e65f8606c":"bCcZK","5a0a1f16a1279524":"9IcT3","2a04c84ed7db306b":"lpVet","5e20bf2dad25c37c":"bSj1I","3aa8b5d79a2a9024":"gJ4r4"}],"4WTcl":[function(require,module,exports) {
var getNative = require("46bebcddf9480112"), root = require("579404377b3ca6bc");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"46bebcddf9480112":"2sDCG","579404377b3ca6bc":"hxxVb"}],"bCcZK":[function(require,module,exports) {
var getNative = require("d18624500ef4096"), root = require("78e30bb194ff7ea6");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"d18624500ef4096":"2sDCG","78e30bb194ff7ea6":"hxxVb"}],"9IcT3":[function(require,module,exports) {
var getNative = require("5d5a4ba86fc6e7c"), root = require("e0428df6429ea1ba");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"5d5a4ba86fc6e7c":"2sDCG","e0428df6429ea1ba":"hxxVb"}],"lpVet":[function(require,module,exports) {
var getNative = require("b83f27d0a01f5d42"), root = require("bd3d09bddb011b02");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"b83f27d0a01f5d42":"2sDCG","bd3d09bddb011b02":"hxxVb"}],"a0enJ":[function(require,module,exports) {
var isStrictComparable = require("d1ccd6dd93daf60b"), keys = require("a03929aee687cf05");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"d1ccd6dd93daf60b":"7Ajxh","a03929aee687cf05":"kkFip"}],"7Ajxh":[function(require,module,exports) {
var isObject = require("ce64ce4e1b21a48f");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"ce64ce4e1b21a48f":"jlVr8"}],"faImM":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"1r2bR":[function(require,module,exports) {
var baseIsEqual = require("d9f5066cf6965a28"), get = require("e1d23b5a76cf41f7"), hasIn = require("b5acfc41f5314bce"), isKey = require("b0637a9fd4d7c379"), isStrictComparable = require("569af222bd22f9ef"), matchesStrictComparable = require("998591d77422d8a9"), toKey = require("45b2e7359156ee1");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"d9f5066cf6965a28":"eGdf2","e1d23b5a76cf41f7":"21Gj9","b5acfc41f5314bce":"59luz","b0637a9fd4d7c379":"k77Kf","569af222bd22f9ef":"7Ajxh","998591d77422d8a9":"faImM","45b2e7359156ee1":"ffiay"}],"21Gj9":[function(require,module,exports) {
var baseGet = require("1034a1dc97620aef");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"1034a1dc97620aef":"7ZXUG"}],"7ZXUG":[function(require,module,exports) {
var castPath = require("5f35c8b5f221d78"), toKey = require("d9e048d4e1798d80");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"5f35c8b5f221d78":"1bgnN","d9e048d4e1798d80":"ffiay"}],"1bgnN":[function(require,module,exports) {
var isArray = require("33c160b60e8e8d72"), isKey = require("814d1d01bf176112"), stringToPath = require("67a26e49693a0de3"), toString = require("aa2b67ad9f7044b9");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"33c160b60e8e8d72":"1C8T5","814d1d01bf176112":"k77Kf","67a26e49693a0de3":"7IX9w","aa2b67ad9f7044b9":"Qw1Mv"}],"k77Kf":[function(require,module,exports) {
var isArray = require("47df07883be77fb6"), isSymbol = require("61414e6f7da80cb2");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"47df07883be77fb6":"1C8T5","61414e6f7da80cb2":"byXKN"}],"byXKN":[function(require,module,exports) {
var baseGetTag = require("f603ecefcae0f251"), isObjectLike = require("74839f2aa74aad2f");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"f603ecefcae0f251":"bSj1I","74839f2aa74aad2f":"3fce1"}],"7IX9w":[function(require,module,exports) {
var memoizeCapped = require("5b207a32f66ded11");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"5b207a32f66ded11":"ahYXC"}],"ahYXC":[function(require,module,exports) {
var memoize = require("cc830ff677864624");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cc830ff677864624":"lOE50"}],"lOE50":[function(require,module,exports) {
var MapCache = require("4ed88c938b7118ae");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"4ed88c938b7118ae":"54WoC"}],"Qw1Mv":[function(require,module,exports) {
var baseToString = require("888a6989ff3a4955");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"888a6989ff3a4955":"7fMGk"}],"7fMGk":[function(require,module,exports) {
var Symbol = require("c66d8ed18871ab9a"), arrayMap = require("16cfd3af57961b54"), isArray = require("3e7ecdd8fbd769f6"), isSymbol = require("69f20aa05244ef94");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"c66d8ed18871ab9a":"ai5hG","16cfd3af57961b54":"bVOIb","3e7ecdd8fbd769f6":"1C8T5","69f20aa05244ef94":"byXKN"}],"bVOIb":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"ffiay":[function(require,module,exports) {
var isSymbol = require("29646a0b5aa22a4a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"29646a0b5aa22a4a":"byXKN"}],"59luz":[function(require,module,exports) {
var baseHasIn = require("513988c0b08cdba3"), hasPath = require("64a7003ea85f207");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"513988c0b08cdba3":"77ack","64a7003ea85f207":"4KLZR"}],"77ack":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"4KLZR":[function(require,module,exports) {
var castPath = require("fd6266c08211453"), isArguments = require("5247df4a89c10edf"), isArray = require("cca4f5d398db7716"), isIndex = require("7d4ee01c6cf3d68e"), isLength = require("369feb6135a3db3c"), toKey = require("c4a05f35d4f3e82c");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"fd6266c08211453":"1bgnN","5247df4a89c10edf":"2L33C","cca4f5d398db7716":"1C8T5","7d4ee01c6cf3d68e":"5432W","369feb6135a3db3c":"HGg0b","c4a05f35d4f3e82c":"ffiay"}],"18NDY":[function(require,module,exports) {
var baseProperty = require("5cf71a1ad47f15b2"), basePropertyDeep = require("85d0cf8c5704163b"), isKey = require("4d5076538182b75"), toKey = require("b28199ff32768ef8");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"5cf71a1ad47f15b2":"6o44F","85d0cf8c5704163b":"1ypIY","4d5076538182b75":"k77Kf","b28199ff32768ef8":"ffiay"}],"6o44F":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"1ypIY":[function(require,module,exports) {
var baseGet = require("2776b53bb4a3effc");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"2776b53bb4a3effc":"7ZXUG"}],"8E3WV":[function(require,module,exports) {
var arraySome = require("7e9f479b33a003be"), baseIteratee = require("303144ffa13993c9"), baseSome = require("60ec5f9c497ca1f8"), isArray = require("1590e853fbe178f0"), isIterateeCall = require("fc4f7a9ae03286d9");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"7e9f479b33a003be":"eXXwI","303144ffa13993c9":"6BB6V","60ec5f9c497ca1f8":"h5ZyP","1590e853fbe178f0":"1C8T5","fc4f7a9ae03286d9":"g3mzK"}],"h5ZyP":[function(require,module,exports) {
var baseEach = require("db671886cf1f613a");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"db671886cf1f613a":"8raUY"}],"8raUY":[function(require,module,exports) {
var baseForOwn = require("db7b9586f0e21109"), createBaseEach = require("884573eebe18a86");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"db7b9586f0e21109":"d0uos","884573eebe18a86":"2YA8f"}],"2YA8f":[function(require,module,exports) {
var isArrayLike = require("ee9e1e98d776a5");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"ee9e1e98d776a5":"9wZOb"}],"6sT93":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"fMDqv"}],"fMDqv":[function(require,module,exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"5393afc8c463ef07":"llNeF","dc13beaf0535b548":"b6LNK","ece50e903283a22f":"dndVj"}],"dndVj":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"ckXMD"}],"ckXMD":[function(require,module,exports) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function(a, b) {
        u = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{}],"cRFmb":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"kRSE0"}],"kRSE0":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"dcBXm"}],"dcBXm":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"ink5J":[function(require,module,exports) {
"use strict";
var React = require("432dc035333119a6");
var ReactDOM = require("cd2d0a8ace410530");
var isPlainObject = require("5fca8e8edbed3953");
var isEqual = require("618ab30110234acd");
function angularize(Component, componentName, angularApp, bindings) {
    bindings = bindings || {};
    if (typeof window === "undefined" || typeof angularApp === "undefined") return;
    angularApp.component(componentName, {
        bindings: bindings,
        controller: [
            "$element",
            function($element) {
                var _this = this;
                if (window.angular) {
                    this.$scope = window.angular.element($element).scope();
                    var previous = {};
                    this.$onInit = function() {
                        for(var _i = 0, _Object$keys = Object.keys(bindings); _i < _Object$keys.length; _i++){
                            var bindingKey = _Object$keys[_i];
                            if (/^data[A-Z]/.test(bindingKey)) console.warn("'".concat(bindingKey, "' binding for ").concat(componentName, " component will be undefined because AngularJS ignores attributes starting with data-"));
                            if (bindings[bindingKey] === "=") previous[bindingKey] = window.angular.copy(_this[bindingKey]);
                        }
                    };
                    this.$doCheck = function() {
                        for(var _i2 = 0, _Object$keys2 = Object.keys(previous); _i2 < _Object$keys2.length; _i2++){
                            var previousKey = _Object$keys2[_i2];
                            if (!equals(_this[previousKey], previous[previousKey])) {
                                _this.$onChanges();
                                previous[previousKey] = window.angular.copy(_this[previousKey]);
                                return;
                            }
                        }
                    };
                }
                this.$onChanges = function() {
                    ReactDOM.render(React.createElement(Component, _this), $element[0]);
                };
            }
        ]
    });
}
function angularizeDirective(Component, directiveName, angularApp, bindings) {
    bindings = bindings || {};
    if (typeof window === "undefined" || typeof angularApp === "undefined") return;
    angularApp.directive(directiveName, function() {
        return {
            scope: bindings,
            replace: true,
            link: function link(scope, element) {
                scope.$scope = scope;
                ReactDOM.render(React.createElement(Component, scope), element[0]);
                var keys = [];
                for(var _i3 = 0, _Object$keys3 = Object.keys(bindings); _i3 < _Object$keys3.length; _i3++){
                    var bindingKey = _Object$keys3[_i3];
                    if (/^data[A-Z]/.test(bindingKey)) console.warn("'".concat(bindingKey, "' binding for ").concat(directiveName, " directive will be undefined because AngularJS ignores attributes starting with data-"));
                    if (bindings[bindingKey] !== "&") keys.push(bindingKey);
                }
                scope.$watchGroup(keys, function() {
                    ReactDOM.render(React.createElement(Component, scope), element[0]);
                });
            }
        };
    });
}
function getService(serviceName) {
    if (typeof window === "undefined" || typeof window.angular === "undefined") return {};
    return window.angular.element(document.body).injector().get(serviceName);
}
function equals(o1, o2) {
    if (isPlainObject(o1) && isPlainObject(o2)) return isEqual(o1, o2);
    return window.angular.equals(o1, o2);
}
module.exports = {
    getService: getService,
    angularize: angularize,
    angularizeDirective: angularizeDirective
};

},{"432dc035333119a6":"llNeF","cd2d0a8ace410530":"6sT93","5fca8e8edbed3953":"grIhH","618ab30110234acd":"2qMRA"}],"grIhH":[function(require,module,exports) {
var baseGetTag = require("3b9b0013504a2e4d"), getPrototype = require("2fe580d7273df1d"), isObjectLike = require("b89ffc92213016ce");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"3b9b0013504a2e4d":"cFgiY","2fe580d7273df1d":"8UxI1","b89ffc92213016ce":"8XhSq"}],"cFgiY":[function(require,module,exports) {
var Symbol = require("edac0c313caf83e8"), getRawTag = require("d963558eb0d568c3"), objectToString = require("f49af18948cc00a4");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"edac0c313caf83e8":"9P6To","d963558eb0d568c3":"enIcV","f49af18948cc00a4":"e4BSV"}],"9P6To":[function(require,module,exports) {
var root = require("b8dbde5c65aefdae");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"b8dbde5c65aefdae":"gBbgA"}],"gBbgA":[function(require,module,exports) {
var freeGlobal = require("847a997b9568e73a");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"847a997b9568e73a":"hhJuA"}],"hhJuA":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"enIcV":[function(require,module,exports) {
var Symbol = require("e16bee9e60de4e43");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e16bee9e60de4e43":"9P6To"}],"e4BSV":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"8UxI1":[function(require,module,exports) {
var overArg = require("c5a895e1a45c53aa");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"c5a895e1a45c53aa":"doyqH"}],"doyqH":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"8XhSq":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"2qMRA":[function(require,module,exports) {
var baseIsEqual = require("759983f5aa8465aa");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"759983f5aa8465aa":"kzR92"}],"kzR92":[function(require,module,exports) {
var baseIsEqualDeep = require("41d50135be43b5ee"), isObjectLike = require("2c6b42d64e95f18e");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"41d50135be43b5ee":"57TvQ","2c6b42d64e95f18e":"8XhSq"}],"57TvQ":[function(require,module,exports) {
var Stack = require("c85e5c0b370e9324"), equalArrays = require("c1e196a631cacd41"), equalByTag = require("64e5ca92ee67e9dc"), equalObjects = require("df6fb8a7544cd42c"), getTag = require("6670c8429460b474"), isArray = require("3dc78ea8225841f7"), isBuffer = require("b1da9376bf55ad5f"), isTypedArray = require("d8d6a5ee8a51d219");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"c85e5c0b370e9324":"7R6yR","c1e196a631cacd41":"5ZbaU","64e5ca92ee67e9dc":"bHcMO","df6fb8a7544cd42c":"kYP0U","6670c8429460b474":"jw4rG","3dc78ea8225841f7":"hcc5S","b1da9376bf55ad5f":"1u4Ot","d8d6a5ee8a51d219":"ggZn2"}],"7R6yR":[function(require,module,exports) {
var ListCache = require("650ecd9b2e0bf94"), stackClear = require("dc1815135375ff4d"), stackDelete = require("507b88272055277e"), stackGet = require("c3ae62b496bd8a1c"), stackHas = require("96f2e350e79db81b"), stackSet = require("db2cc644a9991c73");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"650ecd9b2e0bf94":"3IjXR","dc1815135375ff4d":"feQVy","507b88272055277e":"6hng2","c3ae62b496bd8a1c":"ipjlM","96f2e350e79db81b":"f46rY","db2cc644a9991c73":"1VJtK"}],"3IjXR":[function(require,module,exports) {
var listCacheClear = require("44335a3f9a26754d"), listCacheDelete = require("43c8278c275ea12f"), listCacheGet = require("f3ac869e15a44c96"), listCacheHas = require("707b0f793c8624f1"), listCacheSet = require("da6599348d72631a");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"44335a3f9a26754d":"4czgV","43c8278c275ea12f":"a6DM7","f3ac869e15a44c96":"4vohf","707b0f793c8624f1":"4g6M7","da6599348d72631a":"kHR6R"}],"4czgV":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"a6DM7":[function(require,module,exports) {
var assocIndexOf = require("59708c84dbd34fe1");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"59708c84dbd34fe1":"bRuGw"}],"bRuGw":[function(require,module,exports) {
var eq = require("d2f4575be7848c8c");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"d2f4575be7848c8c":"hK6qh"}],"hK6qh":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"4vohf":[function(require,module,exports) {
var assocIndexOf = require("97e41ac90c246400");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"97e41ac90c246400":"bRuGw"}],"4g6M7":[function(require,module,exports) {
var assocIndexOf = require("8e085604c139efd3");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"8e085604c139efd3":"bRuGw"}],"kHR6R":[function(require,module,exports) {
var assocIndexOf = require("8253f0c18f581fbe");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"8253f0c18f581fbe":"bRuGw"}],"feQVy":[function(require,module,exports) {
var ListCache = require("bd8956cbd250818c");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"bd8956cbd250818c":"3IjXR"}],"6hng2":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ipjlM":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"f46rY":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"1VJtK":[function(require,module,exports) {
var ListCache = require("f9752fd2bc9bdb45"), Map = require("43395c0afd821aae"), MapCache = require("5e114ad2458f6519");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"f9752fd2bc9bdb45":"3IjXR","43395c0afd821aae":"liJvJ","5e114ad2458f6519":"2ItXm"}],"liJvJ":[function(require,module,exports) {
var getNative = require("88334579167d319c"), root = require("a2ba422ba9fb800c");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"88334579167d319c":"3g7CW","a2ba422ba9fb800c":"gBbgA"}],"3g7CW":[function(require,module,exports) {
var baseIsNative = require("5ddb20cd9d648504"), getValue = require("923b12d8c7d55f7");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"5ddb20cd9d648504":"d5DeD","923b12d8c7d55f7":"aP3IE"}],"d5DeD":[function(require,module,exports) {
var isFunction = require("963e0e002a10ec09"), isMasked = require("81715b92d26d65bd"), isObject = require("678f02173f8d9e5"), toSource = require("b9f31e0b73f3c791");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"963e0e002a10ec09":"4y0s7","81715b92d26d65bd":"4HEuD","678f02173f8d9e5":"d7H8b","b9f31e0b73f3c791":"61Yur"}],"4y0s7":[function(require,module,exports) {
var baseGetTag = require("ab9b15b27c8f2998"), isObject = require("f3020124b2130dfc");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"ab9b15b27c8f2998":"cFgiY","f3020124b2130dfc":"d7H8b"}],"d7H8b":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"4HEuD":[function(require,module,exports) {
var coreJsData = require("49a965b7afafccfe");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"49a965b7afafccfe":"lsem9"}],"lsem9":[function(require,module,exports) {
var root = require("e7a7164556fb617f");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"e7a7164556fb617f":"gBbgA"}],"61Yur":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"aP3IE":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"2ItXm":[function(require,module,exports) {
var mapCacheClear = require("b1ae2605f809e394"), mapCacheDelete = require("bec08ba897c0804"), mapCacheGet = require("cf8b3bd95cf918d3"), mapCacheHas = require("b2e4a2555b618bc0"), mapCacheSet = require("4dfa5e805baf4d76");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"b1ae2605f809e394":"lFotz","bec08ba897c0804":"cWtNg","cf8b3bd95cf918d3":"2tEMF","b2e4a2555b618bc0":"fGgp8","4dfa5e805baf4d76":"lKaZi"}],"lFotz":[function(require,module,exports) {
var Hash = require("203d0a3b07146ea1"), ListCache = require("7cd9961be95eb2cc"), Map = require("c5c92f6b2a9a6959");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"203d0a3b07146ea1":"4zyfO","7cd9961be95eb2cc":"3IjXR","c5c92f6b2a9a6959":"liJvJ"}],"4zyfO":[function(require,module,exports) {
var hashClear = require("f264dd4698aa17eb"), hashDelete = require("dac4f3acdf1ad3d7"), hashGet = require("1ad4b40a45dda387"), hashHas = require("e77cf2a6be5cc0ab"), hashSet = require("c631306529b381d4");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f264dd4698aa17eb":"adI8j","dac4f3acdf1ad3d7":"6SQXu","1ad4b40a45dda387":"ieor8","e77cf2a6be5cc0ab":"7C4AC","c631306529b381d4":"gxilg"}],"adI8j":[function(require,module,exports) {
var nativeCreate = require("e5b136905439959a");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"e5b136905439959a":"gxijM"}],"gxijM":[function(require,module,exports) {
var getNative = require("bff175617ccd4316");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"bff175617ccd4316":"3g7CW"}],"6SQXu":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"ieor8":[function(require,module,exports) {
var nativeCreate = require("b79034e1c47189e8");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"b79034e1c47189e8":"gxijM"}],"7C4AC":[function(require,module,exports) {
var nativeCreate = require("cd2a29821535379c");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"cd2a29821535379c":"gxijM"}],"gxilg":[function(require,module,exports) {
var nativeCreate = require("a5ace166e8476fc9");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"a5ace166e8476fc9":"gxijM"}],"cWtNg":[function(require,module,exports) {
var getMapData = require("b3bc8da29e2c54c2");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"b3bc8da29e2c54c2":"gELXN"}],"gELXN":[function(require,module,exports) {
var isKeyable = require("2752a0b260d20c3a");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"2752a0b260d20c3a":"60PIH"}],"60PIH":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"2tEMF":[function(require,module,exports) {
var getMapData = require("17be4751c5ba48fb");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"17be4751c5ba48fb":"gELXN"}],"fGgp8":[function(require,module,exports) {
var getMapData = require("91592335e1b06d33");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"91592335e1b06d33":"gELXN"}],"lKaZi":[function(require,module,exports) {
var getMapData = require("728c960aedc95634");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"728c960aedc95634":"gELXN"}],"5ZbaU":[function(require,module,exports) {
var SetCache = require("88f95ab916e97aea"), arraySome = require("f607fe563e6f7c2c"), cacheHas = require("e3b7cee4e270afff");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"88f95ab916e97aea":"9mP0m","f607fe563e6f7c2c":"5xq6X","e3b7cee4e270afff":"1zyTd"}],"9mP0m":[function(require,module,exports) {
var MapCache = require("b0ab161837dceb78"), setCacheAdd = require("71c93dece4350466"), setCacheHas = require("2b2973f1c5f4bac0");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"b0ab161837dceb78":"2ItXm","71c93dece4350466":"hEEoF","2b2973f1c5f4bac0":"fSYwN"}],"hEEoF":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"fSYwN":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"5xq6X":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"1zyTd":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"bHcMO":[function(require,module,exports) {
var Symbol = require("8758ba8ad523a9bf"), Uint8Array = require("59badcb7b43a2179"), eq = require("86875282c23474af"), equalArrays = require("8085e55fd56499f5"), mapToArray = require("e87fa1fff14d779b"), setToArray = require("ddd7807e3bb8d9de");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"8758ba8ad523a9bf":"9P6To","59badcb7b43a2179":"7kjgT","86875282c23474af":"hK6qh","8085e55fd56499f5":"5ZbaU","e87fa1fff14d779b":"4LoAr","ddd7807e3bb8d9de":"3kSFa"}],"7kjgT":[function(require,module,exports) {
var root = require("452c362c9eb9dc5b");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"452c362c9eb9dc5b":"gBbgA"}],"4LoAr":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"3kSFa":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kYP0U":[function(require,module,exports) {
var getAllKeys = require("728ca498009f399");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"728ca498009f399":"bi7QD"}],"bi7QD":[function(require,module,exports) {
var baseGetAllKeys = require("8a29f40009e6191b"), getSymbols = require("b578c6ff900f80c0"), keys = require("4b3ca8d8aaaa645f");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"8a29f40009e6191b":"1rw6E","b578c6ff900f80c0":"he25D","4b3ca8d8aaaa645f":"1sUwC"}],"1rw6E":[function(require,module,exports) {
var arrayPush = require("b82503bcf021dfad"), isArray = require("37d5d2f8b716f0c1");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"b82503bcf021dfad":"aMYum","37d5d2f8b716f0c1":"hcc5S"}],"aMYum":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"hcc5S":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"he25D":[function(require,module,exports) {
var arrayFilter = require("cfdbacc4fbb2b664"), stubArray = require("48fb95d5bace589f");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"cfdbacc4fbb2b664":"aMCMZ","48fb95d5bace589f":"e8uFc"}],"aMCMZ":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"e8uFc":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"1sUwC":[function(require,module,exports) {
var arrayLikeKeys = require("1d76a394475b8178"), baseKeys = require("c9e7d602dfb34ef3"), isArrayLike = require("e0345cab13c380ad");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"1d76a394475b8178":"djEQL","c9e7d602dfb34ef3":"bo09I","e0345cab13c380ad":"9FH7s"}],"djEQL":[function(require,module,exports) {
var baseTimes = require("c6d1a2d988baa5d1"), isArguments = require("3c022192b62b27fd"), isArray = require("2ba3cb9ab832a897"), isBuffer = require("b40f2032de0f6c93"), isIndex = require("6704fe3575ce10d3"), isTypedArray = require("a0a0bf05c40c4643");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"c6d1a2d988baa5d1":"Xnc9F","3c022192b62b27fd":"fMEZP","2ba3cb9ab832a897":"hcc5S","b40f2032de0f6c93":"1u4Ot","6704fe3575ce10d3":"g3aQw","a0a0bf05c40c4643":"ggZn2"}],"Xnc9F":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"fMEZP":[function(require,module,exports) {
var baseIsArguments = require("dd1b2cbc6993a9c4"), isObjectLike = require("e29bf4ea9d7433f8");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"dd1b2cbc6993a9c4":"cSaOm","e29bf4ea9d7433f8":"8XhSq"}],"cSaOm":[function(require,module,exports) {
var baseGetTag = require("ce3c99aee49b8403"), isObjectLike = require("cf26dcf9883403fe");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"ce3c99aee49b8403":"cFgiY","cf26dcf9883403fe":"8XhSq"}],"1u4Ot":[function(require,module,exports) {
var root = require("d1d09e424cc6daf1"), stubFalse = require("41d8a652df6f298d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"d1d09e424cc6daf1":"gBbgA","41d8a652df6f298d":"1JCWu"}],"1JCWu":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"g3aQw":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"ggZn2":[function(require,module,exports) {
var baseIsTypedArray = require("159d65c9a2cc2204"), baseUnary = require("e8554a90f3e42f65"), nodeUtil = require("1c1e845dda6352b0");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"159d65c9a2cc2204":"efPfu","e8554a90f3e42f65":"6HhpD","1c1e845dda6352b0":"9HknD"}],"efPfu":[function(require,module,exports) {
var baseGetTag = require("dfc53713c17d3ce1"), isLength = require("f362f2eb118453a4"), isObjectLike = require("f4ad4e13f58981c1");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"dfc53713c17d3ce1":"cFgiY","f362f2eb118453a4":"i2HUg","f4ad4e13f58981c1":"8XhSq"}],"i2HUg":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"6HhpD":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"9HknD":[function(require,module,exports) {
var freeGlobal = require("b2b53218d2639ac6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"b2b53218d2639ac6":"hhJuA"}],"bo09I":[function(require,module,exports) {
var isPrototype = require("6d50cf3c6c506466"), nativeKeys = require("9cdd92523535aef0");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"6d50cf3c6c506466":"aLSEq","9cdd92523535aef0":"cU5WT"}],"aLSEq":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"cU5WT":[function(require,module,exports) {
var overArg = require("a955cef580834425");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"a955cef580834425":"doyqH"}],"9FH7s":[function(require,module,exports) {
var isFunction = require("1c5fa33455ab9d70"), isLength = require("64404149a3883e81");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"1c5fa33455ab9d70":"4y0s7","64404149a3883e81":"i2HUg"}],"jw4rG":[function(require,module,exports) {
var DataView = require("5bc641cc68fa8af3"), Map = require("54ba395f6e43ca8d"), Promise = require("972f6970cbb5a21b"), Set = require("752f77cfd81c2226"), WeakMap = require("11386c0861e0d870"), baseGetTag = require("e17eab4a2f619467"), toSource = require("8b72b994e6702a38");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"5bc641cc68fa8af3":"uKIox","54ba395f6e43ca8d":"liJvJ","972f6970cbb5a21b":"ejoDY","752f77cfd81c2226":"1Ezj4","11386c0861e0d870":"kOZe8","e17eab4a2f619467":"cFgiY","8b72b994e6702a38":"61Yur"}],"uKIox":[function(require,module,exports) {
var getNative = require("42b11d064961e39a"), root = require("ff44cee7362659e9");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"42b11d064961e39a":"3g7CW","ff44cee7362659e9":"gBbgA"}],"ejoDY":[function(require,module,exports) {
var getNative = require("1f1bacd594c37488"), root = require("a714c0fe8f91f00c");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"1f1bacd594c37488":"3g7CW","a714c0fe8f91f00c":"gBbgA"}],"1Ezj4":[function(require,module,exports) {
var getNative = require("516c03181a2d5ffe"), root = require("6b8927f27c9cfa37");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"516c03181a2d5ffe":"3g7CW","6b8927f27c9cfa37":"gBbgA"}],"kOZe8":[function(require,module,exports) {
var getNative = require("85ca39304ee23054"), root = require("ba27281d9d455d7");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"85ca39304ee23054":"3g7CW","ba27281d9d455d7":"gBbgA"}],"cb4ui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortableContext", ()=>SortableContext);
parcelHelpers.export(exports, "arrayMove", ()=>arrayMove);
parcelHelpers.export(exports, "arraySwap", ()=>arraySwap);
parcelHelpers.export(exports, "defaultAnimateLayoutChanges", ()=>defaultAnimateLayoutChanges);
parcelHelpers.export(exports, "defaultNewIndexGetter", ()=>defaultNewIndexGetter);
parcelHelpers.export(exports, "hasSortableData", ()=>hasSortableData);
parcelHelpers.export(exports, "horizontalListSortingStrategy", ()=>horizontalListSortingStrategy);
parcelHelpers.export(exports, "rectSortingStrategy", ()=>rectSortingStrategy);
parcelHelpers.export(exports, "rectSwappingStrategy", ()=>rectSwappingStrategy);
parcelHelpers.export(exports, "sortableKeyboardCoordinates", ()=>sortableKeyboardCoordinates);
parcelHelpers.export(exports, "useSortable", ()=>useSortable);
parcelHelpers.export(exports, "verticalListSortingStrategy", ()=>verticalListSortingStrategy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@dnd-kit/core");
var _utilities = require("@dnd-kit/utilities");
/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function arrayMove(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function arraySwap(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function isValidIndex(index) {
    return index !== null && index >= 0;
}
function itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function normalizeDisabled(disabled) {
    if (typeof disabled === "boolean") return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const horizontalListSortingStrategy = (_ref)=>{
    var _rects$activeIndex;
    let { rects, activeNodeRect: fallbackActiveRect, activeIndex, overIndex, index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...defaultScale
    };
};
function getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const rectSortingStrategy = (_ref)=>{
    let { rects, activeIndex, overIndex, index } = _ref;
    const newRects = arrayMove(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const rectSwappingStrategy = (_ref)=>{
    let { activeIndex, index, rects, overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const verticalListSortingStrategy = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex, activeNodeRect: fallbackActiveRect, index, rects, overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...defaultScale$1
        };
    }
    const itemGap = getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...defaultScale$1
    };
};
function getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const ID_PREFIX = "Sortable";
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    activeIndex: -1,
    containerId: ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: rectSortingStrategy,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function SortableContext(_ref) {
    let { children, id, items: userDefinedItems, strategy = rectSortingStrategy, disabled: disabledProp = false } = _ref;
    const { active, dragOverlay, droppableRects, over, measureDroppableContainers } = (0, _core.useDndContext)();
    const containerId = (0, _utilities.useUniqueId)(ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, _react.useMemo)(()=>userDefinedItems.map((item)=>typeof item === "object" && "id" in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, _react.useRef)(items);
    const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = normalizeDisabled(disabledProp);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, _react.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            activeIndex,
            containerId,
            disabled,
            disableTransforms,
            items,
            overIndex,
            useDragOverlay,
            sortedRects: getSortedRects(items, droppableRects),
            strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
const defaultNewIndexGetter = (_ref)=>{
    let { id, items, activeIndex, overIndex } = _ref;
    return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
const defaultAnimateLayoutChanges = (_ref2)=>{
    let { containerId, isSorting, wasDragging, index, items, newIndex, previousItems, previousContainerId, transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const defaultTransition = {
    duration: 200,
    easing: "ease"
};
const transitionProperty = "transform";
const disabledTransition = /*#__PURE__*/ (0, _utilities.CSS).Transition.toString({
    property: transitionProperty,
    duration: 0,
    easing: "linear"
});
const defaultAttributes = {
    roleDescription: "sortable"
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function useDerivedTransform(_ref) {
    let { disabled, index, node, rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, _react.useState)(null);
    const previousIndex = (0, _react.useRef)(index);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, _core.getClientRect)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, _react.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function useSortable(_ref) {
    let { animateLayoutChanges = defaultAnimateLayoutChanges, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex = defaultNewIndexGetter, id, strategy: localStrategy, resizeObserverConfig, transition = defaultTransition } = _ref;
    const { items, containerId, activeIndex, disabled: globalDisabled, disableTransforms, sortedRects, overIndex, useDragOverlay, strategy: globalStrategy } = (0, _react.useContext)(Context);
    const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, _react.useMemo)(()=>({
            sortable: {
                containerId,
                index,
                items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, _react.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect, node, isOver, setNodeRef: setDroppableNodeRef } = (0, _core.useDroppable)({
        id,
        data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active, activatorEvent, activeNodeRect, attributes, setNodeRef: setDraggableNodeRef, listeners, isDragging, over, setActivatorNodeRef, transform } = (0, _core.useDraggable)({
        id,
        data,
        attributes: {
            ...defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, _utilities.useCombinedRefs)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect,
        activeIndex,
        overIndex,
        index
    }) : null;
    const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
        id,
        items,
        activeIndex,
        overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, _react.useRef)({
        activeId,
        items,
        newIndex,
        containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active,
        containerId,
        isDragging,
        isSorting,
        id,
        index,
        items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index,
        node,
        rect
    });
    (0, _react.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, _react.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active,
        activeIndex,
        attributes,
        data,
        rect,
        index,
        newIndex,
        items,
        isOver,
        isSorting,
        isDragging,
        listeners,
        node,
        overIndex,
        over,
        setNodeRef,
        setActivatorNodeRef,
        setDroppableNodeRef,
        setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return disabledTransition;
        if (shouldDisplaceDragSource && !(0, _utilities.isKeyboardEvent)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, _utilities.CSS).Transition.toString({
            ...transition,
            property: transitionProperty
        });
        return undefined;
    }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === "boolean") return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function hasSortableData(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) return true;
    return false;
}
const directions = [
    (0, _core.KeyboardCode).Down,
    (0, _core.KeyboardCode).Right,
    (0, _core.KeyboardCode).Up,
    (0, _core.KeyboardCode).Left
];
const sortableKeyboardCoordinates = (event, _ref)=>{
    let { context: { active, collisionRect, droppableRects, droppableContainers, over, scrollableAncestors } } = _ref;
    if (directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, _core.KeyboardCode).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, _core.closestCorners)({
            active,
            collisionRect: collisionRect,
            droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, _core.getFirstCollision)(collisions, "id");
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, _core.getScrollableAncestors)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, _utilities.subtract)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function isSameContainer(a, b) {
    if (!hasSortableData(a) || !hasSortableData(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function isAfter(a, b) {
    if (!hasSortableData(a) || !hasSortableData(b)) return false;
    if (!isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}

},{"react":"llNeF","@dnd-kit/core":"cJjFL","@dnd-kit/utilities":"8dZaa","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cJjFL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoScrollActivator", ()=>AutoScrollActivator);
parcelHelpers.export(exports, "DndContext", ()=>DndContext);
parcelHelpers.export(exports, "DragOverlay", ()=>DragOverlay);
parcelHelpers.export(exports, "KeyboardCode", ()=>KeyboardCode);
parcelHelpers.export(exports, "KeyboardSensor", ()=>KeyboardSensor);
parcelHelpers.export(exports, "MeasuringFrequency", ()=>MeasuringFrequency);
parcelHelpers.export(exports, "MeasuringStrategy", ()=>MeasuringStrategy);
parcelHelpers.export(exports, "MouseSensor", ()=>MouseSensor);
parcelHelpers.export(exports, "PointerSensor", ()=>PointerSensor);
parcelHelpers.export(exports, "TouchSensor", ()=>TouchSensor);
parcelHelpers.export(exports, "TraversalOrder", ()=>TraversalOrder);
parcelHelpers.export(exports, "applyModifiers", ()=>applyModifiers);
parcelHelpers.export(exports, "closestCenter", ()=>closestCenter);
parcelHelpers.export(exports, "closestCorners", ()=>closestCorners);
parcelHelpers.export(exports, "defaultAnnouncements", ()=>defaultAnnouncements);
parcelHelpers.export(exports, "defaultCoordinates", ()=>defaultCoordinates);
parcelHelpers.export(exports, "defaultDropAnimation", ()=>defaultDropAnimationConfiguration);
parcelHelpers.export(exports, "defaultDropAnimationSideEffects", ()=>defaultDropAnimationSideEffects);
parcelHelpers.export(exports, "defaultScreenReaderInstructions", ()=>defaultScreenReaderInstructions);
parcelHelpers.export(exports, "getClientRect", ()=>getClientRect);
parcelHelpers.export(exports, "getFirstCollision", ()=>getFirstCollision);
parcelHelpers.export(exports, "getScrollableAncestors", ()=>getScrollableAncestors);
parcelHelpers.export(exports, "pointerWithin", ()=>pointerWithin);
parcelHelpers.export(exports, "rectIntersection", ()=>rectIntersection);
parcelHelpers.export(exports, "useDndContext", ()=>useDndContext);
parcelHelpers.export(exports, "useDndMonitor", ()=>useDndMonitor);
parcelHelpers.export(exports, "useDraggable", ()=>useDraggable);
parcelHelpers.export(exports, "useDroppable", ()=>useDroppable);
parcelHelpers.export(exports, "useSensor", ()=>useSensor);
parcelHelpers.export(exports, "useSensors", ()=>useSensors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _utilities = require("@dnd-kit/utilities");
var _accessibility = require("@dnd-kit/accessibility");
const DndMonitorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useDndMonitor(listener) {
    const registerListener = (0, _react.useContext)(DndMonitorContext);
    (0, _react.useEffect)(()=>{
        if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function useDndMonitorProvider() {
    const [listeners] = (0, _react.useState)(()=>new Set());
    const registerListener = (0, _react.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, _react.useCallback)((_ref)=>{
        let { type, event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const defaultScreenReaderInstructions = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
    onDragStart (_ref) {
        let { active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active, over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active, over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function Accessibility(_ref) {
    let { announcements = defaultAnnouncements, container, hiddenTextDescribedById, screenReaderInstructions = defaultScreenReaderInstructions } = _ref;
    const { announce, announcement } = (0, _accessibility.useAnnouncement)();
    const liveRegionId = (0, _utilities.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setMounted(true);
    }, []);
    useDndMonitor((0, _react.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active } = _ref2;
                announce(announcements.onDragStart({
                    active
                }));
            },
            onDragMove (_ref3) {
                let { active, over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active,
                    over
                }));
            },
            onDragOver (_ref4) {
                let { active, over } = _ref4;
                announce(announcements.onDragOver({
                    active,
                    over
                }));
            },
            onDragEnd (_ref5) {
                let { active, over } = _ref5;
                announce(announcements.onDragEnd({
                    active,
                    over
                }));
            },
            onDragCancel (_ref6) {
                let { active, over } = _ref6;
                announce(announcements.onDragCancel({
                    active,
                    over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _accessibility.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, _reactDefault.default).createElement((0, _accessibility.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, _reactDom.createPortal)(markup, container) : markup;
}
var Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop() {}
function useSensor(sensor, options) {
    return (0, _react.useMemo)(()=>({
            sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function useSensors() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const defaultCoordinates = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, _utilities.getEventCoordinates)(event);
    if (!eventCoordinates) return "0 0";
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function cornersOfRectangle(_ref5) {
    let { left, top, height, width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function getFirstCollision(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const closestCenter = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const closestCorners = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const corners = cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const rectIntersection = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort(sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function isPointWithinRect(point, rect) {
    const { top, left, bottom, right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const pointerWithin = (_ref)=>{
    let { droppableContainers, droppableRects, pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
function adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const getAdjustedRect = /*#__PURE__*/ createRectAdjustmentFn(1);
function parseTransform(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX, scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function getClientRect(element, options) {
    if (options === void 0) options = defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform, transformOrigin } = (0, _utilities.getWindow)(element).getComputedStyle(element);
        if (transform) rect = inverseTransform(rect, transform, transformOrigin);
    }
    const { top, left, width, height, bottom, right } = rect;
    return {
        top,
        left,
        width,
        height,
        bottom,
        right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function getTransformAgnosticClientRect(element) {
    return getClientRect(element, {
        ignoreTransform: true
    });
}
function getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width,
        height
    };
}
function isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === "fixed";
}
function isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
function getScrollableAncestors(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, _utilities.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, _utilities.isHTMLElement)(node) || (0, _utilities.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if (isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if (isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return null;
    if ((0, _utilities.isWindow)(element)) return element;
    if (!(0, _utilities.isNode)(element)) return null;
    if ((0, _utilities.isDocument)(element) || element === (0, _utilities.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, _utilities.isHTMLElement)(element)) return element;
    return null;
}
function getScrollXCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function getScrollYCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function getScrollCoordinates(element) {
    return {
        x: getScrollXCoordinate(element),
        y: getScrollYCoordinate(element)
    };
}
var Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop,
        isLeft,
        isBottom,
        isRight,
        maxScroll,
        minScroll
    };
}
const defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top, left, right, bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = defaultThreshold;
    const { isTop, isBottom, isLeft, isRight } = getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction,
        speed
    };
}
function getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth, innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top, left, right, bottom } = element.getBoundingClientRect();
    return {
        top,
        left,
        right,
        bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, _utilities.add)(acc, getScrollCoordinates(node));
    }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollXCoordinate(node);
    }, 0);
}
function getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollYCoordinate(node);
    }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = getClientRect;
    if (!element) return;
    const { top, left, bottom, right } = measure(element);
    const firstScrollableAncestor = getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: "center",
        inline: "center"
    });
}
const properties = [
    [
        "x",
        [
            "left",
            "right"
        ],
        getScrollXOffset
    ],
    [
        "y",
        [
            "top",
            "bottom"
        ],
        getScrollYOffset
    ]
];
class Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = getScrollableAncestors(element);
        const scrollOffsets = getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, "rect", {
            enumerable: false
        });
    }
}
class Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget } = (0, _utilities.getWindow)(target);
    return target instanceof EventTarget ? target : (0, _utilities.getOwnerDocument)(target);
}
function hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
    if ("x" in measurement) return dx > measurement.x;
    if ("y" in measurement) return dy > measurement.y;
    return false;
}
var EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
    event.preventDefault();
}
function stopPropagation(event) {
    event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
    start: [
        KeyboardCode.Space,
        KeyboardCode.Enter
    ],
    cancel: [
        KeyboardCode.Esc
    ],
    end: [
        KeyboardCode.Space,
        KeyboardCode.Enter
    ]
};
const defaultKeyboardCoordinateGetter = (event, _ref)=>{
    let { currentCoordinates } = _ref;
    switch(event.code){
        case KeyboardCode.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case KeyboardCode.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case KeyboardCode.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case KeyboardCode.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class KeyboardSensor {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target } } = props;
        this.props = props;
        this.listeners = new Listeners((0, _utilities.getOwnerDocument)(target));
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add(EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode, onStart } = this.props;
        const node = activeNode.node.current;
        if (node) scrollIntoViewIfNeeded(node);
        onStart(defaultCoordinates);
    }
    handleKeyDown(event) {
        if ((0, _utilities.isKeyboardEvent)(event)) {
            const { active, context, options } = this.props;
            const { keyboardCodes = defaultKeyboardCodes, coordinateGetter = defaultKeyboardCoordinateGetter, scrollBehavior = "smooth" } = options;
            const { code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : defaultCoordinates;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active,
                context: context.current,
                currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, _utilities.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop, isRight, isLeft, isBottom, maxScroll, minScroll } = getScrollPosition(scrollContainer);
                    const scrollElementRect = getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
                    const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, _utilities.add)((0, _utilities.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
KeyboardSensor.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes = defaultKeyboardCodes, onActivation } = _ref;
            let { active } = _ref2;
            const { code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function isDistanceConstraint(constraint) {
    return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
    return Boolean(constraint && "delay" in constraint);
}
class AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event } = props;
        const { target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, _utilities.getOwnerDocument)(target);
        this.documentListeners = new Listeners(this.document);
        this.listeners = new Listeners(listenerTarget);
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates : defaultCoordinates;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events, props: { options: { activationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.DragStart, preventDefault);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add(EventName.ContextMenu, preventDefault);
        this.documentListeners.add(EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (isDistanceConstraint(activationConstraint)) return;
            if (isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handleStart() {
        const { initialCoordinates } = this;
        const { onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add(EventName.Click, stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated, initialCoordinates, props } = this;
        const { onMove, options: { activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
        const delta = (0, _utilities.subtract)(initialCoordinates, coordinates);
        if (!activated && activationConstraint) {
            // Constraint validation
            if (isDelayConstraint(activationConstraint)) {
                if (hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                return;
            }
            if (isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if (hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
                return;
            }
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onEnd } = this.props;
        this.detach();
        onEnd();
    }
    handleCancel() {
        const { onCancel } = this.props;
        this.detach();
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === KeyboardCode.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const events = {
    move: {
        name: "pointermove"
    },
    end: {
        name: "pointerup"
    }
};
class PointerSensor extends AbstractPointerSensor {
    constructor(props){
        const { event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, _utilities.getOwnerDocument)(event.target);
        super(props, events, listenerTarget);
    }
}
PointerSensor.activators = [
    {
        eventName: "onPointerDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$1 = {
    move: {
        name: "mousemove"
    },
    end: {
        name: "mouseup"
    }
};
var MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$1, (0, _utilities.getOwnerDocument)(props.event.target));
    }
}
MouseSensor.activators = [
    {
        eventName: "onMouseDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (event.button === MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$2 = {
    move: {
        name: "touchmove"
    },
    end: {
        name: "touchend"
    }
};
class TouchSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener(events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener(events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
TouchSensor.activators = [
    {
        eventName: "onTouchStart",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            const { touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
var AutoScrollActivator;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
    let { acceleration, activator = AutoScrollActivator.Pointer, canScroll, draggingRect, enabled, interval = 5, order = TraversalOrder.TreeOrder, pointerCoordinates, scrollableAncestors, scrollableAncestorRects, delta, threshold } = _ref;
    const scrollIntent = useScrollIntent({
        delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, _utilities.useInterval)();
    const scrollSpeed = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, _react.useMemo)(()=>{
        switch(activator){
            case AutoScrollActivator.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case AutoScrollActivator.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, _react.useRef)(null);
    const autoScroll = (0, _react.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, _react.useMemo)(()=>order === TraversalOrder.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction, speed } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                "x",
                "y"
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const defaultScrollIntent = {
    x: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    },
    y: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    }
};
function useScrollIntent(_ref2) {
    let { delta, disabled } = _ref2;
    const previousDelta = (0, _utilities.usePrevious)(delta);
    return (0, _utilities.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
                [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
            },
            y: {
                [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
                [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function useCachedNode(draggableNodes, id) {
    const draggableNode = id !== null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, _utilities.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id === null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
    return (0, _react.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var MeasuringStrategy;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /*#__PURE__*/ new Map();
function useDroppableMeasuring(containers, _ref) {
    let { dragging, dependencies, config } = _ref;
    const [queue, setQueue] = (0, _react.useState)(null);
    const { frequency, measure, strategy } = config;
    const containersRef = (0, _react.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, _utilities.useLatestValue)(disabled);
    const measureDroppableContainers = (0, _react.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, _react.useRef)(null);
    const droppableRects = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return defaultValue;
        if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, _react.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects,
        measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case MeasuringStrategy.Always:
                return false;
            case MeasuringStrategy.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function useInitialValue(value, computeFn) {
    return (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === "function" ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function useInitialRect(node, measure) {
    return useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function useMutationObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleMutations = (0, _utilities.useEvent)(callback);
    const mutationObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return undefined;
        const { MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function useResizeObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleResize = (0, _utilities.useEvent)(callback);
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return undefined;
        const { ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function defaultMeasure(element) {
    return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = defaultMeasure;
    const [rect, measureRect] = (0, _react.useReducer)(reducer, null);
    const mutationObserver = useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type, target } = record;
                if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = useResizeObserver({
        callback: measureRect
    });
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
    function reducer(currentRect) {
        if (!element) return null;
        if (element.isConnected === false) {
            var _ref;
            // Fall back to last rect we measured if the element is
            // no longer connected to the DOM.
            return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
        }
        const newRect = measure(element);
        if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
        return newRect;
    }
}
function useRectDelta(rect) {
    const initialRect = useInitialValue(rect);
    return getRectDelta(rect, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node) {
    const previousNode = (0, _react.useRef)(node);
    const ancestors = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!node) return defaultValue$1;
        if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return getScrollableAncestors(node);
    }, [
        node
    ]);
    (0, _react.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, _react.useState)(null);
    const prevElements = (0, _react.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, _react.useCallback)((event)=>{
        const scrollingElement = getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, _react.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener("scroll", handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener("scroll", handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, _react.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, _utilities.add)(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
        return defaultCoordinates;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, _react.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, _utilities.subtract)(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
    (0, _react.useEffect)(()=>{
        if (!(0, _utilities.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor } = _ref2;
        return sensor;
    }));
}
function useSyntheticListeners(listeners, id) {
    return (0, _react.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName, handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function useWindowRect(element) {
    return (0, _react.useMemo)(()=>element ? getWindowClientRect(element) : null, [
        element
    ]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
    if (measure === void 0) measure = getClientRect;
    const [firstElement] = elements;
    const windowRect = useWindowRect(firstElement ? (0, _utilities.getWindow)(firstElement) : null);
    const [rects, measureRects] = (0, _react.useReducer)(reducer, defaultValue$2);
    const resizeObserver = useResizeObserver({
        callback: measureRects
    });
    if (elements.length > 0 && rects === defaultValue$2) measureRects();
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (elements.length) elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
        else {
            resizeObserver == null || resizeObserver.disconnect();
            measureRects();
        }
    }, [
        elements
    ]);
    return rects;
    function reducer() {
        if (!elements.length) return defaultValue$2;
        return elements.map((element)=>isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
    }
}
function getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, _utilities.isHTMLElement)(firstChild) ? firstChild : node;
}
function useDragOverlayMeasuring(_ref) {
    let { measure } = _ref;
    const [rect, setRect] = (0, _react.useState)(null);
    const handleResize = (0, _react.useCallback)((entries)=>{
        for (const { target } of entries)if ((0, _utilities.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, _react.useCallback)((element)=>{
        const node = getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    return (0, _react.useMemo)(()=>({
            nodeRef,
            rect,
            setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const defaultSensors = [
    {
        sensor: PointerSensor,
        options: {}
    },
    {
        sensor: KeyboardSensor,
        options: {}
    }
];
const defaultData = {
    current: {}
};
const defaultMeasuringConfiguration = {
    draggable: {
        measure: getTransformAgnosticClientRect
    },
    droppable: {
        measure: getTransformAgnosticClientRect,
        strategy: MeasuringStrategy.WhileDragging,
        frequency: MeasuringFrequency.Optimized
    },
    dragOverlay: {
        measure: getClientRect
    }
};
class DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: defaultMeasuringConfiguration,
    measureDroppableContainers: noop,
    windowRect: null,
    measuringScheduled: false
};
const defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ""
    },
    dispatch: noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: noop
};
const InternalContext = /*#__PURE__*/ (0, _react.createContext)(defaultInternalContext);
const PublicContext = /*#__PURE__*/ (0, _react.createContext)(defaultPublicContext);
function getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new DroppableContainersMap()
        }
    };
}
function reducer(state, action) {
    switch(action.type){
        case Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case Action.DragMove:
            if (!state.draggable.active) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case Action.DragEnd:
        case Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case Action.RegisterDroppable:
            {
                const { element } = action;
                const { id } = element;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.SetDroppableDisabled:
            {
                const { id, key, disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.UnregisterDroppable:
            {
                const { id, key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        default:
            return state;
    }
}
function RestoreFocus(_ref) {
    let { disabled } = _ref;
    const { active, activatorEvent, draggableNodes } = (0, _react.useContext)(InternalContext);
    const previousActivatorEvent = (0, _utilities.usePrevious)(activatorEvent);
    const previousActiveId = (0, _utilities.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, _utilities.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode, node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, _utilities.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function applyModifiers(modifiers, _ref) {
    let { transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function useMeasuringConfiguration(config) {
    return (0, _react.useMemo)(()=>({
            draggable: {
                ...defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function useLayoutShiftScrollCompensation(_ref) {
    let { activeNode, measure, initialRect, config = true } = _ref;
    const initialized = (0, _react.useRef)(false);
    const { x, y } = typeof config === "boolean" ? {
        x: config,
        y: config
    } : config;
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const ActiveDraggableContext = /*#__PURE__*/ (0, _react.createContext)({
    ...defaultCoordinates,
    scaleX: 1,
    scaleY: 1
});
var Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /*#__PURE__*/ (0, _react.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id, accessibility, autoScroll = true, children, sensors = defaultSensors, collisionDetection = rectIntersection, measuring, modifiers, ...props } = _ref;
    const store = (0, _react.useReducer)(reducer, undefined, getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
    const [status, setStatus] = (0, _react.useState)(Status.Uninitialized);
    const isInitialized = status === Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId ? draggableNodes.get(activeId) : null;
    const activeRects = (0, _react.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, _react.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, _react.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, _react.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, _react.useState)(null);
    const latestProps = (0, _utilities.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, _utilities.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, _react.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = useMeasuringConfiguration(measuring);
    const { droppableRects, measureDroppableContainers, measuringScheduled } = useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, _react.useMemo)(()=>activatorEvent ? (0, _utilities.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    useLayoutShiftScrollCompensation({
        activeNode: activeId ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, _react.useRef)({
        activatorEvent: null,
        active: null,
        activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects,
        draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = useWindowRect(draggingNode ? (0, _utilities.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = applyModifiers(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, _utilities.add)(activationCoordinates, translate) : null;
    const scrollOffsets = useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, _utilities.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active,
        collisionRect,
        droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates
    }) : null;
    const overId = getFirstCollision(collisions, "id");
    const [over, setOver] = (0, _react.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, _utilities.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const instantiateSensor = (0, _react.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode,
            event: activatorEvent,
            options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart } = latestProps.current;
                const event = {
                    active: {
                        id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus(Status.Initializing);
                    dispatch({
                        type: Action.DragStart,
                        initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: "onDragStart",
                        event
                    });
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: Action.DragMove,
                    coordinates
                });
            },
            onEnd: createHandler(Action.DragEnd),
            onCancel: createHandler(Action.DragCancel)
        });
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            setActiveSensor(sensorInstance);
            setActivatorEvent(event.nativeEvent);
        });
        function createHandler(type) {
            return async function handler() {
                const { active, collisions, over, scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent,
                        active: active,
                        collisions,
                        delta: scrollAdjustedTranslate,
                        over
                    };
                    if (type === Action.DragEnd && typeof cancelDrop === "function") {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type
                    });
                    setStatus(Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    const eventName = type === Action.DragEnd ? "onDragEnd" : "onDragCancel";
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, _react.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    useSensorSetup(sensors);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === Status.Initializing) setStatus(Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, _react.useEffect)(()=>{
        const { onDragMove } = latestProps.current;
        const { active, activatorEvent, collisions, over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: "onDragMove",
                event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, _react.useEffect)(()=>{
        const { active, activatorEvent, collisions, droppableContainers, scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: "onDragOver",
                event
            });
        });
    }, [
        overId
    ]);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent,
            active,
            activeNode,
            collisionRect,
            collisions,
            droppableRects,
            draggableNodes,
            draggingNode,
            draggingNodeRect,
            droppableContainers,
            over,
            scrollableAncestors,
            scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates,
        scrollableAncestors,
        scrollableAncestorRects
    });
    const publicContext = (0, _react.useMemo)(()=>{
        const context = {
            active,
            activeNode,
            activeNodeRect,
            activatorEvent,
            collisions,
            containerNodeRect,
            dragOverlay,
            draggableNodes,
            droppableContainers,
            droppableRects,
            over,
            measureDroppableContainers,
            scrollableAncestors,
            scrollableAncestorRects,
            measuringConfiguration,
            measuringScheduled,
            windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, _react.useMemo)(()=>{
        const context = {
            activatorEvent,
            activators,
            active,
            activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch,
            draggableNodes,
            over,
            measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, _reactDefault.default).createElement(DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: internalContext
    }, (0, _reactDefault.default).createElement(PublicContext.Provider, {
        value: publicContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, _reactDefault.default).createElement(RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, _reactDefault.default).createElement(Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === "object") return {
            ...autoScroll,
            enabled
        };
        return {
            enabled
        };
    }
});
const NullContext = /*#__PURE__*/ (0, _react.createContext)(null);
const defaultRole = "button";
const ID_PREFIX = "Droppable";
function useDraggable(_ref) {
    let { id, data, disabled = false, attributes } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX);
    const { activators, activatorEvent, active, activeNodeRect, ariaDescribedById, draggableNodes, over } = (0, _react.useContext)(InternalContext);
    const { role = defaultRole, roleDescription = "draggable", tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, _react.useContext)(isDragging ? ActiveDraggableContext : NullContext);
    const [node, setNodeRef] = (0, _utilities.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, _utilities.useNodeRef)();
    const listeners = useSyntheticListeners(activators, id);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id,
            key,
            node,
            activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, _react.useMemo)(()=>({
            role,
            tabIndex,
            "aria-disabled": disabled,
            "aria-pressed": isDragging && role === defaultRole ? true : undefined,
            "aria-roledescription": roleDescription,
            "aria-describedby": ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active,
        activatorEvent,
        activeNodeRect,
        attributes: memoizedAttributes,
        isDragging,
        listeners: disabled ? undefined : listeners,
        node,
        over,
        setNodeRef,
        setActivatorNodeRef,
        transform
    };
}
function useDndContext() {
    return (0, _react.useContext)(PublicContext);
}
const ID_PREFIX$1 = "Droppable";
const defaultResizeObserverConfig = {
    timeout: 25
};
function useDroppable(_ref) {
    let { data, disabled = false, id, resizeObserverConfig } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX$1);
    const { active, dispatch, over, measureDroppableContainers } = (0, _react.useContext)(InternalContext);
    const previous = (0, _react.useRef)({
        disabled
    });
    const resizeObserverConnected = (0, _react.useRef)(false);
    const rect = (0, _react.useRef)(null);
    const callbackId = (0, _react.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, _utilities.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, _react.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, _react.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _react.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        dispatch({
            type: Action.RegisterDroppable,
            element: {
                id,
                key,
                disabled,
                node: nodeRef,
                rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: Action.UnregisterDroppable,
                key,
                id
            });
    }, [
        id
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: Action.SetDroppableDisabled,
                id,
                key,
                disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active,
        rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over,
        setNodeRef
    };
}
function AnimationManager(_ref) {
    let { animation, children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, _react.useState)(null);
    const [element, setElement] = (0, _react.useState)(null);
    const previousChildren = (0, _utilities.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children, clonedChildren ? (0, _react.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function NullifiedContextProvider(_ref) {
    let { children } = _ref;
    return (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: defaultInternalContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: defaultTransform
    }, children));
}
const baseStyles = {
    position: "fixed",
    touchAction: "none"
};
const defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, _utilities.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? "transform 250ms ease" : undefined;
};
const PositionedOverlay = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { as, activatorEvent, adjustScale, children, className, rect, style, transform, transition = defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, _utilities.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === "function" ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, _reactDefault.default).createElement(as, {
        className,
        style: styles,
        ref
    }, children);
});
const defaultDropAnimationSideEffects = (options)=>(_ref)=>{
        let { active, dragOverlay } = _ref;
        const originalStyles = {};
        const { styles, className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial, final } } = _ref2;
    return [
        {
            transform: (0, _utilities.CSS).Transform.toString(initial)
        },
        {
            transform: (0, _utilities.CSS).Transform.toString(final)
        }
    ];
};
const defaultDropAnimationConfiguration = {
    duration: 250,
    easing: "ease",
    keyframes: defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: "0"
            }
        }
    })
};
function useDropAnimation(_ref3) {
    let { config, draggableNodes, droppableContainers, measuringConfiguration } = _ref3;
    return (0, _utilities.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform } = (0, _utilities.getWindow)(node).getComputedStyle(node);
        const parsedTransform = parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === "function" ? config : createDefaultDropAnimation(config);
        scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes,
            dragOverlay: {
                node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers,
            measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function createDefaultDropAnimation(options) {
    const { duration, easing, sideEffects, keyframes } = {
        ...defaultDropAnimationConfiguration,
        ...options
    };
    return (_ref4)=>{
        let { active, dragOverlay, transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active,
            dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active,
            dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration,
            easing,
            fill: "forwards"
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let key = 0;
function useKey(id) {
    return (0, _react.useMemo)(()=>{
        if (id == null) return;
        key++;
        return key;
    }, [
        id
    ]);
}
const DragOverlay = /*#__PURE__*/ (0, _reactDefault.default).memo((_ref)=>{
    let { adjustScale = false, children, dropAnimation: dropAnimationConfig, style, transition, modifiers, wrapperElement = "div", className, zIndex = 999 } = _ref;
    const { activatorEvent, active, activeNodeRect, containerNodeRect, draggableNodes, droppableContainers, dragOverlay, over, measuringConfiguration, scrollableAncestors, scrollableAncestorRects, windowRect } = useDndContext();
    const transform = (0, _react.useContext)(ActiveDraggableContext);
    const key = useKey(active == null ? void 0 : active.id);
    const modifiedTransform = applyModifiers(modifiers, {
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        transform,
        windowRect
    });
    const initialRect = useInitialValue(activeNodeRect);
    const dropAnimation = useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes,
        droppableContainers,
        measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, _reactDefault.default).createElement(NullifiedContextProvider, null, (0, _reactDefault.default).createElement(AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, _reactDefault.default).createElement(PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

},{"react":"llNeF","react-dom":"6sT93","@dnd-kit/utilities":"8dZaa","@dnd-kit/accessibility":"ej0Oy","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8dZaa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSS", ()=>CSS);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "findFirstFocusableNode", ()=>findFirstFocusableNode);
parcelHelpers.export(exports, "getEventCoordinates", ()=>getEventCoordinates);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "hasViewportRelativeCoordinates", ()=>hasViewportRelativeCoordinates);
parcelHelpers.export(exports, "isDocument", ()=>isDocument);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
parcelHelpers.export(exports, "isTouchEvent", ()=>isTouchEvent);
parcelHelpers.export(exports, "isWindow", ()=>isWindow);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "useCombinedRefs", ()=>useCombinedRefs);
parcelHelpers.export(exports, "useEvent", ()=>useEvent);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useLatestValue", ()=>useLatestValue);
parcelHelpers.export(exports, "useLazyMemo", ()=>useLazyMemo);
parcelHelpers.export(exports, "useNodeRef", ()=>useNodeRef);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId);
var _react = require("react");
function useCombinedRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function isNode(node) {
    return "nodeType" in node;
}
function getWindow(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if (isWindow(target)) return target;
    if (!isNode(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node) {
    const { Document } = getWindow(node);
    return node instanceof Document;
}
function isHTMLElement(node) {
    if (isWindow(node)) return false;
    return node instanceof getWindow(node).HTMLElement;
}
function isSVGElement(node) {
    return node instanceof getWindow(node).SVGElement;
}
function getOwnerDocument(target) {
    if (!target) return document;
    if (isWindow(target)) return target.document;
    if (!isNode(target)) return document;
    if (isDocument(target)) return target;
    if (isHTMLElement(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const useIsomorphicLayoutEffect = canUseDOM ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEvent(handler) {
    const handlerRef = (0, _react.useRef)(handler);
    useIsomorphicLayoutEffect(()=>{
        handlerRef.current = handler;
    });
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function useInterval() {
    const intervalRef = (0, _react.useRef)(null);
    const set = (0, _react.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, _react.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function useLatestValue(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, _react.useRef)(value);
    useIsomorphicLayoutEffect(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function useLazyMemo(callback, dependencies) {
    const valueRef = (0, _react.useRef)();
    return (0, _react.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function useNodeRef(onChange) {
    const onChangeHandler = useEvent(onChange);
    const node = (0, _react.useRef)(null);
    const setNodeRef = (0, _react.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function usePrevious(value) {
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let ids = {};
function useUniqueId(prefix, value) {
    return (0, _react.useMemo)(()=>{
        if (value) return value;
        const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
        ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const add = /*#__PURE__*/ createAdjustmentFn(1);
const subtract = /*#__PURE__*/ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
    return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
    if (!event) return false;
    const { KeyboardEvent } = getWindow(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
    if (!event) return false;
    const { TouchEvent } = getWindow(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function getEventCoordinates(event) {
    if (isTouchEvent(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x,
                y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x,
                y
            };
        }
    }
    if (hasViewportRelativeCoordinates(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const CSS = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x, y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX, scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                CSS.Translate.toString(transform),
                CSS.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property, duration, easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element) {
    if (element.matches(SELECTOR)) return element;
    return element.querySelector(SELECTOR);
}

},{"react":"llNeF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dpH1E":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ej0Oy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiddenText", ()=>HiddenText);
parcelHelpers.export(exports, "LiveRegion", ()=>LiveRegion);
parcelHelpers.export(exports, "useAnnouncement", ()=>useAnnouncement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const hiddenStyles = {
    display: "none"
};
function HiddenText(_ref) {
    let { id, value } = _ref;
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: hiddenStyles
    }, value);
}
const visuallyHidden = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
};
function LiveRegion(_ref) {
    let { id, announcement } = _ref;
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": true
    }, announcement);
}
function useAnnouncement() {
    const [announcement, setAnnouncement] = (0, _react.useState)("");
    const announce = (0, _react.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce,
        announcement
    };
}

},{"react":"llNeF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hKZ95":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This HOC is wrapper for providing the redux store to the provided component
 * Long term this isn't really needed, but for the interim while there's no root store / provider in the app,
 *  this is necessary for usage of hooks and the main redux store
 *
 * @example
 * // this is an example of a functional component with props
 * const Component: React.FC<IComponentProps & JSX.IntrinsicAttributes> = ({name}: IComponentProps) => <>{name}</>
 * export WrappedComponent = withReduxProvider(Component)
 *
 * @example
 * // this is an example of a functional component without props
 * const Component = withReduxProvider(() => <></>)
 *
 */ parcelHelpers.export(exports, "withReduxProvider", ()=>withReduxProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _store = require("../store");
function withReduxProvider(Component) {
    const Wrapped = (props)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
            store: (0, _store.store),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...props
            })
        });
    }; // retain propTypes for react2angular
    Wrapped.propTypes = Component.propTypes;
    return Wrapped;
}

},{"react/jsx-runtime":"38att","react-redux":"l8b2G","../store":"7WrEn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"l8b2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch"); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"./exports":"bKxDw","./utils/reactBatchedUpdates":"73rh7","./utils/batch":"6ZQcu","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"bKxDw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "connectAdvanced", ()=>(0, _connectAdvancedDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _context = require("./components/Context");
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);

},{"./components/Provider":"f4h1b","./components/connectAdvanced":"tXdi9","./components/Context":"3BStp","./connect/connect":"7n2ru","./hooks/useDispatch":"gN4Yw","./hooks/useSelector":"khs4E","./hooks/useStore":"aloiE","./utils/shallowEqual":"6Cmdo","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"f4h1b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, _react.useMemo)(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, _react.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"llNeF","prop-types":"bpTna","./Context":"3BStp","../utils/Subscription":"8RO4b","../utils/useIsomorphicLayoutEffect":"cos7b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"bpTna":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("bd7abe2222bea3c0")();

},{"bd7abe2222bea3c0":"4v0Xy"}],"4v0Xy":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("3ad1f307b21e9541");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"3ad1f307b21e9541":"5huL1"}],"5huL1":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"3BStp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ReactReduxContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = ReactReduxContext;

},{"react":"llNeF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8RO4b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"6ZQcu","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6ZQcu":[function(require,module,exports) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function setBatch(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function getBatch() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cos7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"llNeF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"tXdi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>connectAdvanced);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("./Context"); // Define some constant arrays just to avoid re-creating these
var _excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], _excluded2 = [
    "reactReduxForwardedRef"
];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, _context.ReactReduxContext) : _ref2$context, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, _react.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, _react.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, _react.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, _react.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, _react.useMemo)(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, _react.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, _react.useRef)();
            var lastWrapperProps = (0, _react.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, _react.useRef)();
            var renderIsScheduled = (0, _react.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, _react.useMemo)(function() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, _react.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, _reactDefault.default).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/extends":"ao47X","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ehqty","hoist-non-react-statics":"3x788","react":"llNeF","react-is":"a7uPm","../utils/Subscription":"8RO4b","../utils/useIsomorphicLayoutEffect":"cos7b","./Context":"3BStp","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ao47X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ehqty":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3x788":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"9RhDv"}],"9RhDv":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"7OSwO"}],"7OSwO":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"a7uPm":[function(require,module,exports) {
"use strict";
module.exports = require("c09df6e873313925");

},{"c09df6e873313925":"jMwuH"}],"jMwuH":[function(require,module,exports) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"7n2ru":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", ()=>createConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, _excluded);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = /*#__PURE__*/ createConnect();

},{"@babel/runtime/helpers/esm/extends":"ao47X","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ehqty","../components/connectAdvanced":"tXdi9","../utils/shallowEqual":"6Cmdo","./mapDispatchToProps":"2vnwg","./mapStateToProps":"6kE4T","./mergeProps":"hKpjw","./selectorFactory":"3nhLG","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6Cmdo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"2vnwg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", ()=>whenMapDispatchToPropsIsFunction);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", ()=>whenMapDispatchToPropsIsMissing);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", ()=>whenMapDispatchToPropsIsObject);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"../utils/bindActionCreators":"kEetM","./wrapMapToProps":"91y6b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kEetM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"91y6b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"oUJvZ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"oUJvZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"7ckuE","./warning":"8WQt5","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7ckuE":[function(require,module,exports) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8WQt5":[function(require,module,exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6kE4T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", ()=>whenMapStateToPropsIsFunction);
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", ()=>whenMapStateToPropsIsMissing);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"91y6b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hKpjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "whenMergePropsIsFunction", ()=>whenMergePropsIsFunction);
parcelHelpers.export(exports, "whenMergePropsIsOmitted", ()=>whenMergePropsIsOmitted);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"ao47X","../utils/verifyPlainObject":"oUJvZ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3nhLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", ()=>impureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ehqty","./verifySubselectors":"9laIq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9laIq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, "mapStateToProps", displayName);
    verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    verify(mergeProps, "mergeProps", displayName);
}

},{"../utils/warning":"8WQt5","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gN4Yw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"3BStp","./useStore":"aloiE","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aloiE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"react":"llNeF","../components/Context":"3BStp","./useReduxContext":"3091K","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3091K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    var contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"llNeF","../components/Context":"3BStp","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"khs4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("../components/Context");
var refEquality = function refEquality(a, b) {
    return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, _react.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, _react.useMemo)(function() {
        return (0, _subscription.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, _react.useRef)();
    var latestSelector = (0, _react.useRef)();
    var latestStoreState = (0, _react.useRef)();
    var latestSelectedState = (0, _react.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function createSelectorHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"llNeF","./useReduxContext":"3091K","../utils/Subscription":"8RO4b","../utils/useIsomorphicLayoutEffect":"cos7b","../components/Context":"3BStp","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"73rh7":[function(require,module,exports) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"6sT93","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7WrEn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "store", ()=>store);
var _toolkit = require("@reduxjs/toolkit");
var _apiSlice = require("./slices/apiSlice");
var _appSlice = require("./slices/appSlice");
var _appSliceDefault = parcelHelpers.interopDefault(_appSlice);
var _pagesSlice = require("./slices/pagesSlice");
var _pagesSliceDefault = parcelHelpers.interopDefault(_pagesSlice);
const store = (0, _toolkit.configureStore)({
    reducer: {
        app: (0, _appSliceDefault.default),
        pages: (0, _pagesSliceDefault.default),
        [(0, _apiSlice.baseApi).reducerPath]: (0, _apiSlice.baseApi).reducer
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "pages/setMap",
                    "pages/setWorkspace"
                ],
                ignoredPaths: [
                    "pages.truterritory.map",
                    "pages.truterritory.workspace",
                    "pages.truterritory.currentThemes"
                ]
            }
        }).concat((0, _apiSlice.baseApi).middleware)
}); // Infer the `RootState` and `AppDispatch` types from the store itself

},{"@reduxjs/toolkit":"1vrnJ","./slices/apiSlice":"fcKYC","./slices/appSlice":"w3GXi","./slices/pagesSlice":"1GDaH","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1vrnJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnhancerArray", ()=>EnhancerArray);
parcelHelpers.export(exports, "MiddlewareArray", ()=>MiddlewareArray);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immerDefault.default));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "getDefaultMiddleware", ()=>getDefaultMiddleware);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
// src/index.ts
var _immer = require("immer");
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immerDefault = parcelHelpers.interopDefault(_immer);
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var process = require("728135d01089d859");
var global = arguments[3];
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for(var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
var __async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var createDraftSafeSelector = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, _reselect.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, __spreadArray([
            (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function isAction(action) {
    return isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var MiddlewareArray = /** @class */ function(_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var EnhancerArray = /** @class */ function(_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immerDefault.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = isPlain;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunkDefault.default));
        else middlewareArray.push((0, _reduxThunkDefault.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = true;
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if (isPlainObject(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, _redux.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        trace: !IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = __spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) getInitialState = function() {
        return freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immerDefault.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof process;
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createDraftSafeSelector(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, _immer.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, _immerDefault.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !(selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) options = {};
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var miniSerializeError = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var createAsyncThunk = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = createAction(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = createAction(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return __async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof RejectWithValue) throw result;
                                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function(matcher, action) {
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function isAllOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var noop = function() {};
var catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = noop;
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var validateActive = function(signal) {
    if (signal.aborted) throw new TaskAbortError(signal.reason);
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new TaskAbortError(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = noop;
    });
}
var runTask = function(task2, cleanUp) {
    return __async(void 0, null, function() {
        var value, error_1;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var createPause = function(signal) {
    return function(promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function(output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function(signal) {
    var pause = createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return addAbortSignalListener(parentAbortSignal, function() {
            return abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function() {
            return __async(void 0, null, function() {
                var result2;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            validateActive(parentAbortSignal);
                            validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: createPause(childAbortController.signal),
                                    delay: createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return abortControllerWithReason(childAbortController, taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function() {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return __async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return catchRejection(take(predicate, timeout));
    };
};
var getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var createListenerEntry = function(options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, __spreadArray([
        alm + "/error"
    ], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return __async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: createDelay(internalTaskController.signal),
                                pause: createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            abortControllerWithReason(controller, listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof TaskAbortError)) safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        abortControllerWithReason(internalTaskController, listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!isAction(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
        };
    };
};
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function(cb) {
    return (promise || (promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, _immer.enableES5)();

},{"728135d01089d859":"eXpi0","immer":"f53pe","redux":"kHzuJ","reselect":"2pmMJ","redux-thunk":"6dOtb","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eXpi0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"f53pe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>un);
parcelHelpers.export(exports, "applyPatches", ()=>pn);
parcelHelpers.export(exports, "castDraft", ()=>K);
parcelHelpers.export(exports, "castImmutable", ()=>$);
parcelHelpers.export(exports, "createDraft", ()=>ln);
parcelHelpers.export(exports, "current", ()=>R);
parcelHelpers.export(exports, "enableAllPlugins", ()=>J);
parcelHelpers.export(exports, "enableES5", ()=>F);
parcelHelpers.export(exports, "enableMapSet", ()=>C);
parcelHelpers.export(exports, "enablePatches", ()=>T);
parcelHelpers.export(exports, "finishDraft", ()=>dn);
parcelHelpers.export(exports, "freeze", ()=>d);
parcelHelpers.export(exports, "immerable", ()=>L);
parcelHelpers.export(exports, "isDraft", ()=>r);
parcelHelpers.export(exports, "isDraftable", ()=>t);
parcelHelpers.export(exports, "nothing", ()=>H);
parcelHelpers.export(exports, "original", ()=>e);
parcelHelpers.export(exports, "produce", ()=>fn);
parcelHelpers.export(exports, "produceWithPatches", ()=>cn);
parcelHelpers.export(exports, "setAutoFreeze", ()=>sn);
parcelHelpers.export(exports, "setUseProxies", ()=>vn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kHzuJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"eIZs3","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eIZs3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"l6BsS","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"l6BsS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"4TGCk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4TGCk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : String(i);
}

},{"./typeof.js":"6gJqG","./toPrimitive.js":"l6e3O","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6gJqG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"l6e3O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"6gJqG","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"2pmMJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"dbNxc","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dbNxc":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6dOtb":[function(require,module,exports) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"fcKYC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baseApi", ()=>baseApi);
parcelHelpers.export(exports, "useUpdateUserPreferencesMutation", ()=>useUpdateUserPreferencesMutation);
parcelHelpers.export(exports, "useGetFaqsQuery", ()=>useGetFaqsQuery);
parcelHelpers.export(exports, "useGetCollectionFeaturesQuery", ()=>useGetCollectionFeaturesQuery);
parcelHelpers.export(exports, "useLazyGetCollectionFeaturesQuery", ()=>useLazyGetCollectionFeaturesQuery);
parcelHelpers.export(exports, "useGetCollectionColumnDefsQuery", ()=>useGetCollectionColumnDefsQuery);
parcelHelpers.export(exports, "useGetCollectionsQuery", ()=>useGetCollectionsQuery);
parcelHelpers.export(exports, "useDeleteCollectionMutation", ()=>useDeleteCollectionMutation);
parcelHelpers.export(exports, "useUpdateCollectionMutation", ()=>useUpdateCollectionMutation);
parcelHelpers.export(exports, "useGetCollectionAggregatesQuery", ()=>useGetCollectionAggregatesQuery);
parcelHelpers.export(exports, "useGetWorkspacesWithMapsQuery", ()=>useGetWorkspacesWithMapsQuery);
parcelHelpers.export(exports, "useUpdateWorkspaceMutation", ()=>useUpdateWorkspaceMutation);
parcelHelpers.export(exports, "useUpdateMapMutation", ()=>useUpdateMapMutation);
parcelHelpers.export(exports, "useCreateMapMutation", ()=>useCreateMapMutation);
parcelHelpers.export(exports, "useSearchUsersQuery", ()=>useSearchUsersQuery);
parcelHelpers.export(exports, "useUpdateThemeMutation", ()=>useUpdateThemeMutation);
parcelHelpers.export(exports, "useCreateThemeMutation", ()=>useCreateThemeMutation);
parcelHelpers.export(exports, "useValidateCSSMutation", ()=>useValidateCSSMutation);
parcelHelpers.export(exports, "useGetMapActionsQuery", ()=>useGetMapActionsQuery);
parcelHelpers.export(exports, "useGetMapActionTypesQuery", ()=>useGetMapActionTypesQuery);
parcelHelpers.export(exports, "useGetMapActionPreflightQuery", ()=>useGetMapActionPreflightQuery);
parcelHelpers.export(exports, "useInvokeMapActionMutation", ()=>useInvokeMapActionMutation);
var _react = require("@reduxjs/toolkit/query/react");
var _configuration = require("../../app/configuration");
var _configurationDefault = parcelHelpers.interopDefault(_configuration);
var _appSlice = require("./appSlice");
//  except if passed `skipEntityId: true` in the params of the query
// it also unwraps the `data`, `meta`, and `status` properties of the response
const baseQueryWithEntityId = async (args, api, extraOptions)=>{
    // pull the entityID from the app's root state, or set to undefined if skip entity id is set
    const entityID = typeof args !== "string" && args.skipEntityId ? undefined : api.getState().app.entityID; // if the entity id is missing, throw a 400 error instead of sending a bad request
    if (!entityID && !(typeof args !== "string" && args.skipEntityId)) return {
        error: {
            status: 400,
            statusText: "No entity selected",
            data: {
                message: "No entity selected",
                exception: "NoEntitySelected"
            }
        }
    };
     // construct the new args with the additional entityID param
    const adjustedArgs = typeof args === "string" ? {
        url: args,
        params: {
            entityID
        }
    } : {
        ...args,
        params: {
            entityID,
            ...args.params ?? {}
        }
    }; // make sure credentials include is true
    const result = await (0, _react.fetchBaseQuery)({
        baseUrl: (0, _configurationDefault.default).API_ROOT
    })({
        ...adjustedArgs,
        credentials: "include"
    }, api, extraOptions);
    if (typeof args !== "string" && args.skipUnwrap) return result;
    if (result.error) {
        api.dispatch((0, _appSlice.setError)(result.error.data.status));
        return result;
    } else // unwrap .data
    return {
        ...result,
        data: result.data.data
    };
};
const baseApi = (0, _react.createApi)({
    reducerPath: "baseApi",
    baseQuery: baseQueryWithEntityId,
    tagTypes: [
        "Session",
        "Faqs",
        "CollectionFeatures",
        "Collections",
        "CollectionAggregates",
        "Workspaces",
        "Maps",
        "MapActions",
        "MapActionTypes"
    ],
    endpoints: (builder)=>({
            getSession: builder.query({
                query: ()=>"/session",
                providesTags: [
                    {
                        type: "Session",
                        id: "LIST"
                    }
                ]
            }),
            /**
     * Set a user's preferences (formerly "meta")
     */ updateUserPreferences: builder.mutation({
                query: ({ ID, preferences })=>({
                        method: "PUT",
                        url: `users/${ID}/preferences`,
                        body: preferences
                    }),
                invalidatesTags: [
                    {
                        type: "Session",
                        id: "LIST"
                    }
                ]
            }),
            getFaqs: builder.query({
                query: ()=>({
                        url: "/faq",
                        skipEntityId: true
                    }),
                providesTags: [
                    {
                        type: "Faqs",
                        id: "LIST"
                    }
                ]
            }),
            getCollectionFeatures: builder.query({
                query: ({ id, filters, ...params })=>({
                        url: `mapping/collections/${id}/features`,
                        skipUnwrap: true,
                        params: {
                            ...params,
                            ...filters ? filtersToQueryStringObject(filters) : {}
                        }
                    }),
                providesTags: (_r, _e, { id, ...params })=>[
                        {
                            type: "CollectionFeatures",
                            id: id + JSON.stringify(params)
                        }
                    ]
            }),
            getCollectionColumnDefs: builder.query({
                query: (collectionId)=>`mapping/collections/${collectionId}`,
                transformResponse: (r)=>{
                    return r.properties.map(({ name, column })=>({
                            headerName: name,
                            field: column
                        }));
                },
                providesTags: (_r, _e, id)=>[
                        {
                            type: "Collections",
                            id
                        }
                    ]
            }),
            getCollections: builder.query({
                query: (params)=>({
                        url: `mapping/collections`,
                        params: {
                            with: params?.with ? params.with.join(",") : undefined
                        }
                    }),
                providesTags: (_r, _e)=>[
                        {
                            type: "Collections",
                            id: "LIST"
                        }
                    ]
            }),
            deleteCollection: builder.mutation({
                query: (id)=>({
                        method: "delete",
                        url: `mapping/collections/${id}`
                    }),
                invalidatesTags: (_r, _e, id)=>[
                        {
                            type: "Collections",
                            id: "LIST"
                        },
                        {
                            type: "Collections",
                            id
                        }
                    ]
            }),
            updateCollection: builder.mutation({
                query: ({ ID, ...body })=>({
                        method: "PATCH",
                        url: `mapping/collections/${ID}`,
                        body
                    }),
                invalidatesTags: (_r, _e, { ID })=>[
                        {
                            type: "Collections",
                            id: "LIST"
                        },
                        {
                            type: "Collections",
                            id: ID
                        }
                    ]
            }),
            getCollectionAggregates: builder.query({
                query: ({ ID, ids })=>({
                        method: "POST",
                        url: `mapping/collections/${ID}/aggregate`,
                        body: {
                            ids
                        }
                    }),
                providesTags: (_r, _e, body)=>[
                        {
                            type: "CollectionAggregates",
                            id: `${body.ID}-${body.ids.join("-")}`
                        }
                    ]
            }),
            /**
     * Get the complete list of workspaces available to a user with maps nested in them.
     */ getWorkspacesWithMaps: builder.query({
                query: ()=>`mapping/workspaces?createDefault=1&with=maps,maps.views,maps.reports`,
                providesTags: [
                    {
                        type: "Workspaces",
                        id: "LIST"
                    }
                ]
            }),
            /**
     * Perform a partial update on a workspace.
     */ updateWorkspace: builder.mutation({
                query: (body)=>({
                        method: "PATCH",
                        url: `mapping/workspaces/${body.ID}`,
                        body
                    }),
                invalidatesTags: (resp, err, body)=>[
                        {
                            type: "Workspaces",
                            id: "LIST"
                        },
                        {
                            type: "Workspaces",
                            id: body.ID
                        }
                    ],
                // Apply this update to the cached data immediately so that the UI updates.
                async onQueryStarted ({ ID, ...body }, { dispatch, queryFulfilled }) {
                    const localResult = dispatch(baseApi.util.updateQueryData("getWorkspacesWithMaps", undefined, (workspaces)=>workspaces.filter((w)=>w.ID == ID).forEach((w)=>Object.assign(w, body))));
                }
            }),
            /**
     * Perform a partial update on a map.
     */ updateMap: builder.mutation({
                query: (body)=>({
                        method: "PATCH",
                        url: `mapping/maps/${body.ID}`,
                        body
                    }),
                invalidatesTags: (resp, err, body)=>[
                        {
                            type: "Workspaces",
                            id: "LIST"
                        },
                        {
                            type: "Workspaces",
                            id: body.workspaceID
                        },
                        {
                            type: "MapActions",
                            id: `mapID-${body.ID}`
                        },
                        {
                            type: "MapActionTypes",
                            id: `mapID-${body.ID}`
                        }
                    ],
                // Apply this update to the map as cached by the getWorkspacesWithMaps query (immediately, so that the UI updates).
                async onQueryStarted ({ ID, ...body }, { dispatch, queryFulfilled }) {
                    const localResult = dispatch(baseApi.util.updateQueryData("getWorkspacesWithMaps", undefined, (workspaces)=>workspaces.filter((w)=>w.ID == body.workspaceID).flatMap((w)=>w.maps).flatMap((m)=>[
                                m,
                                ...m.views || []
                            ]) // Added for backward-compatibility with API returning nested maps/views.
                        .filter((m)=>m.ID == ID).forEach((m)=>Object.assign(m, body))));
                }
            }),
            /**
     * Create a new map.
     */ createMap: builder.mutation({
                query: (body)=>({
                        method: "POST",
                        url: "mapping/maps",
                        body
                    }),
                invalidatesTags: (resp, err, body)=>[
                        {
                            type: "Workspaces",
                            id: "LIST"
                        },
                        {
                            type: "Workspaces",
                            id: body.workspaceID
                        }
                    ]
            }),
            /**
     * Delete a map.
     */ deleteMap: builder.mutation({
                query: (body)=>({
                        method: "DELETE",
                        url: `mapping/maps/${body.ID}`
                    }),
                invalidatesTags: (resp, err, body)=>[
                        {
                            type: "Workspaces",
                            id: "LIST"
                        },
                        {
                            type: "Workspaces",
                            id: body.workspaceID
                        }
                    ]
            }),
            /**
     * Get the actions associated with a map.
     */ getMapActions: builder.query({
                query: (mapID)=>`mapping/actions?mapID=${mapID}`,
                providesTags: (_r, _e, mapID)=>[
                        {
                            type: "MapActions",
                            id: `mapID-${mapID}`
                        }
                    ]
            }),
            /**
     * Get the possible action types for a map.
     */ getMapActionTypes: builder.query({
                query: (collectionIDs)=>`mapping/action-types?collectionIDs=${collectionIDs.join(",")}`,
                providesTags: (_r, _e, mapID)=>[
                        {
                            type: "MapActionTypes",
                            id: `mapID-${mapID}`
                        }
                    ]
            }),
            /**
     * Get any input requirements or validation results before running an action.
     */ getMapActionPreflight: builder.query({
                query: (req)=>({
                        method: "POST",
                        url: `mapping/actions/${req.actionID}/preflight`,
                        body: req
                    })
            }),
            /**
     * Invoke a map action.
     */ invokeMapAction: builder.mutation({
                query: (req)=>({
                        method: "POST",
                        url: `mapping/actions/${req.actionID}/invoke`,
                        body: req
                    })
            }),
            /**
     * Update a theme.
     */ updateTheme: builder.mutation({
                query: (body)=>({
                        method: "PUT",
                        url: `mapping/themes/${body.ID}`,
                        body
                    }),
                invalidatesTags: [] // @todo when we start fetching themes via RTK
            }),
            /**
     * Create a new theme.
     */ createTheme: builder.mutation({
                query: (body)=>({
                        method: "POST",
                        url: "mapping/themes",
                        body
                    }),
                invalidatesTags: [] // @todo when we start fetching themes via RTK
            }),
            /**
     * Delete a map.
     */ deleteTheme: builder.mutation({
                query: (body)=>({
                        method: "DELETE",
                        url: `mapping/themes/${body.ID}`
                    }),
                invalidatesTags: [] // @todo when we start fetching themes via RTK
            }),
            /**
     * Search for users by name
     */ searchUsers: builder.query({
                query: (name)=>({
                        url: `users/search`,
                        params: {
                            name
                        }
                    })
            }),
            validateCSS: builder.mutation({
                query: ({ css, ...variables })=>({
                        method: "POST",
                        url: "mapping/themes/validate",
                        body: {
                            css,
                            variables
                        }
                    })
            })
        })
});
const { useUpdateUserPreferencesMutation, useGetFaqsQuery, useGetCollectionFeaturesQuery, useLazyGetCollectionFeaturesQuery, useGetCollectionColumnDefsQuery, useGetCollectionsQuery, useDeleteCollectionMutation, useUpdateCollectionMutation, useGetCollectionAggregatesQuery, useGetWorkspacesWithMapsQuery, useUpdateWorkspaceMutation, useUpdateMapMutation, useCreateMapMutation, useSearchUsersQuery, useUpdateThemeMutation, useCreateThemeMutation, useValidateCSSMutation, useGetMapActionsQuery, useGetMapActionTypesQuery, useGetMapActionPreflightQuery, useInvokeMapActionMutation } = baseApi;
const filtersToQueryStringObject = (filters)=>{
    const filterObject = {};
    filters.forEach(({ column, operator, value }, index)=>{
        filterObject[`filters[${index}][operator]`] = operator;
        filterObject[`filters[${index}][column]`] = column;
        filterObject[`filters[${index}][value]`] = value.toString();
    });
    return filterObject;
};

},{"@reduxjs/toolkit/query/react":"kKObC","../../app/configuration":"liepd","./appSlice":"w3GXi","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kKObC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApiProvider", ()=>ApiProvider);
parcelHelpers.export(exports, "createApi", ()=>createApi);
parcelHelpers.export(exports, "reactHooksModule", ()=>reactHooksModule);
parcelHelpers.export(exports, "reactHooksModuleName", ()=>reactHooksModuleName);
// src/query/react/index.ts
var _query = require("@reduxjs/toolkit/query");
// src/query/react/buildHooks.ts
var _toolkit = require("@reduxjs/toolkit");
var _react = require("react");
var _reactRedux = require("react-redux");
// src/query/react/index.ts
parcelHelpers.exportAll(_query, exports);
var _reactDefault = parcelHelpers.interopDefault(_react);
var process = require("de50a014d8bd0037");
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for(var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
function useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    var incoming = (0, _react.useMemo)(function() {
        return {
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        };
    }, [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    var cache2 = (0, _react.useRef)(incoming);
    (0, _react.useEffect)(function() {
        if (cache2.current.serialized !== incoming.serialized) cache2.current = incoming;
    }, [
        incoming
    ]);
    return cache2.current.serialized === incoming.serialized ? cache2.current.queryArgs : queryArgs;
}
// src/query/react/constants.ts
var UNINITIALIZED_VALUE = Symbol();
function useShallowStableValue(value) {
    var cache2 = (0, _react.useRef)(value);
    (0, _react.useEffect)(function() {
        if (!(0, _reactRedux.shallowEqual)(cache2.current, value)) cache2.current = value;
    }, [
        value
    ]);
    return (0, _reactRedux.shallowEqual)(cache2.current, value) ? cache2.current : value;
}
var cache = WeakMap ? new WeakMap() : void 0;
var defaultSerializeQueryArgs = function(_c) {
    var endpointName = _c.endpointName, queryArgs = _c.queryArgs;
    var serialized = "";
    var cached = cache == null ? void 0 : cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, _toolkit.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, _toolkit.isPlainObject)(queryArgs)) cache == null || cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
// src/query/react/buildHooks.ts
var useIsomorphicLayoutEffect = typeof window !== "undefined" && !!window.document && !!window.document.createElement ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var defaultMutationStateSelector = function(x) {
    return x;
};
var noPendingQueryStateSelector = function(selected) {
    if (selected.isUninitialized) return __spreadProps(__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, _query.QueryStatus).pending
    });
    return selected;
};
function buildHooks(_c) {
    var api = _c.api, _d = _c.moduleOptions, batch = _d.batch, useDispatch = _d.useDispatch, useSelector = _d.useSelector, useStore = _d.useStore, unstable__sideEffectsInRender = _d.unstable__sideEffectsInRender, serializeQueryArgs = _c.serializeQueryArgs, context = _c.context;
    var usePossiblyImmediateEffect = unstable__sideEffectsInRender ? function(cb) {
        return cb();
    } : (0, _react.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            var endpointName = lastResult.endpointName;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            if (serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        var data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        var hasData = data !== void 0;
        var isFetching = currentState.isLoading;
        var isLoading = !hasData && isFetching;
        var isSuccess = currentState.isSuccess || isFetching && hasData;
        return __spreadProps(__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        var dispatch = useDispatch();
        var stableDefaultOptions = useShallowStableValue(defaultOptions);
        return (0, _react.useCallback)(function(arg, options) {
            return dispatch(api.util.prefetch(endpointName, arg, __spreadValues(__spreadValues({}, stableDefaultOptions), options)));
        }, [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function buildQueryHooks(name) {
        var useQuerySubscription = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, refetchOnMountOrArgChange = _d.refetchOnMountOrArgChange, _e = _d.skip, skip = _e === void 0 ? false : _e, _f = _d.pollingInterval, pollingInterval = _f === void 0 ? 0 : _f;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var stableArg = useStableQueryArgs(skip ? (0, _query.skipToken) : arg, defaultSerializeQueryArgs, context.endpointDefinitions[name], name);
            var stableSubscriptionOptions = useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            var lastRenderHadSubscription = (0, _react.useRef)(false);
            var promiseRef = (0, _react.useRef)();
            var _g = promiseRef.current || {}, queryCacheKey = _g.queryCacheKey, requestId = _g.requestId;
            var currentRenderHasSubscription = false;
            if (queryCacheKey && requestId) {
                var returnedValue = dispatch(api.internalActions.internal_probeSubscription({
                    queryCacheKey: queryCacheKey,
                    requestId: requestId
                }));
                currentRenderHasSubscription = !!returnedValue;
            }
            var subscriptionRemoved = !currentRenderHasSubscription && lastRenderHadSubscription.current;
            usePossiblyImmediateEffect(function() {
                lastRenderHadSubscription.current = currentRenderHasSubscription;
            });
            usePossiblyImmediateEffect(function() {
                if (subscriptionRemoved) promiseRef.current = void 0;
            }, [
                subscriptionRemoved
            ]);
            usePossiblyImmediateEffect(function() {
                var _a;
                var lastPromise = promiseRef.current;
                typeof process;
                if (stableArg === (0, _query.skipToken)) {
                    lastPromise == null || lastPromise.unsubscribe();
                    promiseRef.current = void 0;
                    return;
                }
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (!lastPromise || lastPromise.arg !== stableArg) {
                    lastPromise == null || lastPromise.unsubscribe();
                    var promise = dispatch(initiate(stableArg, {
                        subscriptionOptions: stableSubscriptionOptions,
                        forceRefetch: refetchOnMountOrArgChange
                    }));
                    promiseRef.current = promise;
                } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                dispatch,
                initiate,
                refetchOnMountOrArgChange,
                stableArg,
                stableSubscriptionOptions,
                subscriptionRemoved
            ]);
            (0, _react.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = void 0;
                };
            }, []);
            return (0, _react.useMemo)(function() {
                return {
                    refetch: function() {
                        var _a;
                        if (!promiseRef.current) throw new Error("Cannot refetch a query that has not been started yet.");
                        return (_a = promiseRef.current) == null ? void 0 : _a.refetch();
                    }
                };
            }, []);
        };
        var useLazyQuerySubscription = function(_c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, _e = _d.pollingInterval, pollingInterval = _e === void 0 ? 0 : _e;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var _f = (0, _react.useState)(UNINITIALIZED_VALUE), arg = _f[0], setArg = _f[1];
            var promiseRef = (0, _react.useRef)();
            var stableSubscriptionOptions = useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            usePossiblyImmediateEffect(function() {
                var _a, _b;
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            var subscriptionOptionsRef = (0, _react.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(function() {
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            var trigger = (0, _react.useCallback)(function(arg2, preferCacheValue) {
                if (preferCacheValue === void 0) preferCacheValue = false;
                var promise;
                batch(function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            (0, _react.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef == null ? void 0 : promiseRef.current) == null || _a.unsubscribe();
                };
            }, []);
            (0, _react.useEffect)(function() {
                if (arg !== UNINITIALIZED_VALUE && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, _react.useMemo)(function() {
                return [
                    trigger,
                    arg
                ];
            }, [
                trigger,
                arg
            ]);
        };
        var useQueryState = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.skip, skip = _e === void 0 ? false : _e, selectFromResult = _d.selectFromResult;
            var select = api.endpoints[name].select;
            var stableArg = useStableQueryArgs(skip ? (0, _query.skipToken) : arg, serializeQueryArgs, context.endpointDefinitions[name], name);
            var lastValue = (0, _react.useRef)();
            var selectDefaultResult = (0, _react.useMemo)(function() {
                return (0, _toolkit.createSelector)([
                    select(stableArg),
                    function(_, lastResult) {
                        return lastResult;
                    },
                    function(_) {
                        return stableArg;
                    }
                ], queryStatePreSelector);
            }, [
                select,
                stableArg
            ]);
            var querySelector = (0, _react.useMemo)(function() {
                return selectFromResult ? (0, _toolkit.createSelector)([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult;
            }, [
                selectDefaultResult,
                selectFromResult
            ]);
            var currentState = useSelector(function(state) {
                return querySelector(state, lastValue.current);
            }, (0, _reactRedux.shallowEqual));
            var store = useStore();
            var newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            useIsomorphicLayoutEffect(function() {
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery: function(options) {
                var _c = useLazyQuerySubscription(options), trigger = _c[0], arg = _c[1];
                var queryStateResults = useQueryState(arg, __spreadProps(__spreadValues({}, options), {
                    skip: arg === UNINITIALIZED_VALUE
                }));
                var info = (0, _react.useMemo)(function() {
                    return {
                        lastArg: arg
                    };
                }, [
                    arg
                ]);
                return (0, _react.useMemo)(function() {
                    return [
                        trigger,
                        queryStateResults,
                        info
                    ];
                }, [
                    trigger,
                    queryStateResults,
                    info
                ]);
            },
            useQuery: function(arg, options) {
                var querySubscriptionResults = useQuerySubscription(arg, options);
                var queryStateResults = useQueryState(arg, __spreadValues({
                    selectFromResult: arg === (0, _query.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : noPendingQueryStateSelector
                }, options));
                var data = queryStateResults.data, status = queryStateResults.status, isLoading = queryStateResults.isLoading, isSuccess = queryStateResults.isSuccess, isError = queryStateResults.isError, error = queryStateResults.error;
                (0, _react.useDebugValue)({
                    data: data,
                    status: status,
                    isLoading: isLoading,
                    isSuccess: isSuccess,
                    isError: isError,
                    error: error
                });
                return (0, _react.useMemo)(function() {
                    return __spreadValues(__spreadValues({}, queryStateResults), querySubscriptionResults);
                }, [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return function(_c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.selectFromResult, selectFromResult = _e === void 0 ? defaultMutationStateSelector : _e, fixedCacheKey = _d.fixedCacheKey;
            var _f = api.endpoints[name], select = _f.select, initiate = _f.initiate;
            var dispatch = useDispatch();
            var _g = (0, _react.useState)(), promise = _g[0], setPromise = _g[1];
            (0, _react.useEffect)(function() {
                return function() {
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                };
            }, [
                promise
            ]);
            var triggerMutation = (0, _react.useCallback)(function(arg) {
                var promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            var requestId = (promise || {}).requestId;
            var mutationSelector = (0, _react.useMemo)(function() {
                return (0, _toolkit.createSelector)([
                    select({
                        fixedCacheKey: fixedCacheKey,
                        requestId: promise == null ? void 0 : promise.requestId
                    })
                ], selectFromResult);
            }, [
                select,
                promise,
                selectFromResult,
                fixedCacheKey
            ]);
            var currentState = useSelector(mutationSelector, (0, _reactRedux.shallowEqual));
            var originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            var reset = (0, _react.useCallback)(function() {
                batch(function() {
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            var endpointName = currentState.endpointName, data = currentState.data, status = currentState.status, isLoading = currentState.isLoading, isSuccess = currentState.isSuccess, isError = currentState.isError, error = currentState.error;
            (0, _react.useDebugValue)({
                endpointName: endpointName,
                data: data,
                status: status,
                isLoading: isLoading,
                isSuccess: isSuccess,
                isError: isError,
                error: error
            });
            var finalState = (0, _react.useMemo)(function() {
                return __spreadProps(__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                });
            }, [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, _react.useMemo)(function() {
                return [
                    triggerMutation,
                    finalState
                ];
            }, [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/endpointDefinitions.ts
var DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})(DefinitionType || (DefinitionType = {}));
function isQueryDefinition(e) {
    return e.type === DefinitionType.query;
}
function isMutationDefinition(e) {
    return e.type === DefinitionType.mutation;
}
// src/query/utils/capitalize.ts
function capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/tsHelpers.ts
function safeAssign(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    Object.assign.apply(Object, __spreadArray([
        target
    ], args));
}
var reactHooksModuleName = /* @__PURE__ */ Symbol();
var reactHooksModule = function(_c) {
    var _d = _c === void 0 ? {} : _c, _e = _d.batch, batch = _e === void 0 ? (0, _reactRedux.batch) : _e, _f = _d.useDispatch, useDispatch = _f === void 0 ? (0, _reactRedux.useDispatch) : _f, _g = _d.useSelector, useSelector = _g === void 0 ? (0, _reactRedux.useSelector) : _g, _h = _d.useStore, useStore = _h === void 0 ? (0, _reactRedux.useStore) : _h, _j = _d.unstable__sideEffectsInRender, unstable__sideEffectsInRender = _j === void 0 ? false : _j;
    return {
        name: reactHooksModuleName,
        init: function(api, _c, context) {
            var serializeQueryArgs = _c.serializeQueryArgs;
            var anyApi = api;
            var _d = buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    useDispatch: useDispatch,
                    useSelector: useSelector,
                    useStore: useStore,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildQueryHooks = _d.buildQueryHooks, buildMutationHook = _d.buildMutationHook, usePrefetch = _d.usePrefetch;
            safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint: function(endpointName, definition) {
                    if (isQueryDefinition(definition)) {
                        var _c = buildQueryHooks(endpointName), useQuery = _c.useQuery, useLazyQuery = _c.useLazyQuery, useLazyQuerySubscription = _c.useLazyQuerySubscription, useQueryState = _c.useQueryState, useQuerySubscription = _c.useQuerySubscription;
                        safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api["use" + capitalize(endpointName) + "Query"] = useQuery;
                        api["useLazy" + capitalize(endpointName) + "Query"] = useLazyQuery;
                    } else if (isMutationDefinition(definition)) {
                        var useMutation = buildMutationHook(endpointName);
                        safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api["use" + capitalize(endpointName) + "Mutation"] = useMutation;
                    }
                }
            };
        }
    };
};
function ApiProvider(props) {
    var store = (0, _reactDefault.default).useState(function() {
        var _c;
        return (0, _toolkit.configureStore)({
            reducer: (_c = {}, _c[props.api.reducerPath] = props.api.reducer, _c),
            middleware: function(gDM) {
                return gDM().concat(props.api.middleware);
            }
        });
    })[0];
    (0, _react.useEffect)(function() {
        return props.setupListeners === false ? void 0 : (0, _query.setupListeners)(store.dispatch, props.setupListeners);
    }, [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        store: store,
        context: props.context
    }, props.children);
}
// src/query/react/index.ts
var createApi = /* @__PURE__ */ (0, _query.buildCreateApi)((0, _query.coreModule)(), reactHooksModule());

},{"de50a014d8bd0037":"eXpi0","@reduxjs/toolkit/query":"6gANs","@reduxjs/toolkit":"1vrnJ","react":"llNeF","react-redux":"l8b2G","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6gANs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryStatus", ()=>QueryStatus);
parcelHelpers.export(exports, "buildCreateApi", ()=>buildCreateApi);
parcelHelpers.export(exports, "copyWithStructuralSharing", ()=>copyWithStructuralSharing);
parcelHelpers.export(exports, "coreModule", ()=>coreModule);
parcelHelpers.export(exports, "coreModuleName", ()=>coreModuleName);
parcelHelpers.export(exports, "createApi", ()=>createApi);
parcelHelpers.export(exports, "defaultSerializeQueryArgs", ()=>defaultSerializeQueryArgs);
parcelHelpers.export(exports, "fakeBaseQuery", ()=>fakeBaseQuery);
parcelHelpers.export(exports, "fetchBaseQuery", ()=>fetchBaseQuery);
parcelHelpers.export(exports, "retry", ()=>retry);
parcelHelpers.export(exports, "setupListeners", ()=>setupListeners);
parcelHelpers.export(exports, "skipSelector", ()=>skipSelector);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
// src/query/utils/copyWithStructuralSharing.ts
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
var _reselect = require("reselect");
var process = require("51a55a5d1c6cd353");
var global = arguments[3];
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for(var _j = 0, _k = __getOwnPropSymbols(b); _j < _k.length; _j++){
        var prop = _k[_j];
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) for(var _j = 0, _k = __getOwnPropSymbols(source); _j < _k.length; _j++){
        var prop = _k[_j];
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/query/core/apiState.ts
var QueryStatus;
(function(QueryStatus2) {
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
})(QueryStatus || (QueryStatus = {}));
function getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === QueryStatus.uninitialized,
        isLoading: status === QueryStatus.pending,
        isSuccess: status === QueryStatus.fulfilled,
        isError: status === QueryStatus.rejected
    };
}
// src/query/utils/isAbsoluteUrl.ts
function isAbsoluteUrl(url) {
    return new RegExp("(^|:)//").test(url);
}
// src/query/utils/joinUrls.ts
var withoutTrailingSlash = function(url) {
    return url.replace(/\/$/, "");
};
var withoutLeadingSlash = function(url) {
    return url.replace(/^\//, "");
};
function joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if (isAbsoluteUrl(url)) return url;
    var delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = withoutTrailingSlash(base);
    url = withoutLeadingSlash(url);
    return "" + base + delimiter + url;
}
// src/query/utils/flatten.ts
var flatten = function(arr) {
    return [].concat.apply([], arr);
};
// src/query/utils/isOnline.ts
function isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
var isPlainObject = (0, _toolkit.isPlainObject);
function copyWithStructuralSharing(oldObj, newObj) {
    if (oldObj === newObj || !(isPlainObject(oldObj) && isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    var newKeys = Object.keys(newObj);
    var oldKeys = Object.keys(oldObj);
    var isSameObject = newKeys.length === oldKeys.length;
    var mergeObj = Array.isArray(newObj) ? [] : {};
    for(var _j = 0, newKeys_1 = newKeys; _j < newKeys_1.length; _j++){
        var key = newKeys_1[_j];
        mergeObj[key] = copyWithStructuralSharing(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
var defaultFetchFn = function() {
    var args = [];
    for(var _j = 0; _j < arguments.length; _j++)args[_j] = arguments[_j];
    return fetch.apply(void 0, args);
};
var defaultValidateStatus = function(response) {
    return response.status >= 200 && response.status <= 299;
};
var defaultIsJsonContentType = function(headers) {
    return /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
};
function stripUndefined(obj) {
    if (!(0, _toolkit.isPlainObject)(obj)) return obj;
    var copy = __spreadValues({}, obj);
    for(var _j = 0, _k = Object.entries(copy); _j < _k.length; _j++){
        var _l = _k[_j], k = _l[0], v = _l[1];
        if (v === void 0) delete copy[k];
    }
    return copy;
}
function fetchBaseQuery(_a) {
    var _this = this;
    if (_a === void 0) _a = {};
    var _b = _a, baseUrl = _b.baseUrl, _j = _b.prepareHeaders, prepareHeaders = _j === void 0 ? function(x) {
        return x;
    } : _j, _k = _b.fetchFn, fetchFn = _k === void 0 ? defaultFetchFn : _k, paramsSerializer = _b.paramsSerializer, _l = _b.isJsonContentType, isJsonContentType = _l === void 0 ? defaultIsJsonContentType : _l, _m = _b.jsonContentType, jsonContentType = _m === void 0 ? "application/json" : _m, jsonReplacer = _b.jsonReplacer, defaultTimeout = _b.timeout, globalResponseHandler = _b.responseHandler, globalValidateStatus = _b.validateStatus, baseFetchOptions = __objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return function(arg, api) {
        return __async(_this, null, function() {
            var signal, getState, extra, endpoint, forced, type, meta, _a2, url, _j, headers, _k, params, _l, responseHandler, _m, validateStatus, _o, timeout, rest, config, _p, isJsonifiable, divider, query, request, requestClone, response, timedOut, timeoutId, e_1, responseClone, resultData, responseText, handleResponseError_1, e_2;
            return __generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        signal = api.signal, getState = api.getState, extra = api.extra, endpoint = api.endpoint, forced = api.forced, type = api.type;
                        _a2 = typeof arg == "string" ? {
                            url: arg
                        } : arg, url = _a2.url, _j = _a2.headers, headers = _j === void 0 ? new Headers(baseFetchOptions.headers) : _j, _k = _a2.params, params = _k === void 0 ? void 0 : _k, _l = _a2.responseHandler, responseHandler = _l === void 0 ? globalResponseHandler != null ? globalResponseHandler : "json" : _l, _m = _a2.validateStatus, validateStatus = _m === void 0 ? globalValidateStatus != null ? globalValidateStatus : defaultValidateStatus : _m, _o = _a2.timeout, timeout = _o === void 0 ? defaultTimeout : _o, rest = __objRest(_a2, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]);
                        config = __spreadValues(__spreadProps(__spreadValues({}, baseFetchOptions), {
                            signal: signal
                        }), rest);
                        headers = new Headers(stripUndefined(headers));
                        _p = config;
                        return [
                            4 /*yield*/ ,
                            prepareHeaders(headers, {
                                getState: getState,
                                extra: extra,
                                endpoint: endpoint,
                                forced: forced,
                                type: type
                            })
                        ];
                    case 1:
                        _p.headers = _q.sent() || headers;
                        isJsonifiable = function(body) {
                            return typeof body === "object" && ((0, _toolkit.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
                        };
                        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
                        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
                        if (params) {
                            divider = ~url.indexOf("?") ? "&" : "?";
                            query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams(stripUndefined(params));
                            url += divider + query;
                        }
                        url = joinUrls(baseUrl, url);
                        request = new Request(url, config);
                        requestClone = new Request(url, config);
                        meta = {
                            request: requestClone
                        };
                        timedOut = false, timeoutId = timeout && setTimeout(function() {
                            timedOut = true;
                            api.abort();
                        }, timeout);
                        _q.label = 2;
                    case 2:
                        _q.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetchFn(request)
                        ];
                    case 3:
                        response = _q.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String(e_1)
                                },
                                meta: meta
                            }
                        ];
                    case 5:
                        if (timeoutId) clearTimeout(timeoutId);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        responseClone = response.clone();
                        meta.response = responseClone;
                        responseText = "";
                        _q.label = 7;
                    case 7:
                        _q.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                handleResponse(response, responseHandler).then(function(r) {
                                    return resultData = r;
                                }, function(e) {
                                    return handleResponseError_1 = e;
                                }),
                                responseClone.text().then(function(r) {
                                    return responseText = r;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        _q.sent();
                        if (handleResponseError_1) throw handleResponseError_1;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: response.status,
                                    data: responseText,
                                    error: String(e_2)
                                },
                                meta: meta
                            }
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            validateStatus(response, resultData) ? {
                                data: resultData,
                                meta: meta
                            } : {
                                error: {
                                    status: response.status,
                                    data: resultData
                                },
                                meta: meta
                            }
                        ];
                }
            });
        });
    };
    function handleResponse(response, responseHandler) {
        return __async(this, null, function() {
            var text;
            return __generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        if (typeof responseHandler === "function") return [
                            2 /*return*/ ,
                            responseHandler(response)
                        ];
                        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
                        if (!(responseHandler === "json")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        text = _j.sent();
                        return [
                            2 /*return*/ ,
                            text.length ? JSON.parse(text) : null
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.text()
                        ];
                }
            });
        });
    }
}
// src/query/HandledError.ts
var HandledError = /** @class */ function() {
    function HandledError(value, meta) {
        if (meta === void 0) meta = void 0;
        this.value = value;
        this.meta = meta;
    }
    return HandledError;
}();
// src/query/retry.ts
function defaultBackoff(attempt, maxRetries) {
    if (attempt === void 0) attempt = 0;
    if (maxRetries === void 0) maxRetries = 5;
    return __async(this, null, function() {
        var attempts, timeout;
        return __generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    attempts = Math.min(attempt, maxRetries);
                    timeout = ~~((Math.random() + 0.4) * (300 << attempts));
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(function(res) {
                                return resolve(res);
                            }, timeout);
                        })
                    ];
                case 1:
                    _j.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function fail(e) {
    throw Object.assign(new HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var EMPTY_OPTIONS = {};
var retryWithBackoff = function(baseQuery, defaultOptions) {
    return function(args, api, extraOptions) {
        return __async(void 0, null, function() {
            var possibleMaxRetries, maxRetries, defaultRetryCondition, options, retry2, result, e_3;
            return __generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        possibleMaxRetries = [
                            5,
                            (defaultOptions || EMPTY_OPTIONS).maxRetries,
                            (extraOptions || EMPTY_OPTIONS).maxRetries
                        ].filter(function(x) {
                            return x !== void 0;
                        });
                        maxRetries = possibleMaxRetries.slice(-1)[0];
                        defaultRetryCondition = function(_, __, _j) {
                            var attempt = _j.attempt;
                            return attempt <= maxRetries;
                        };
                        options = __spreadValues(__spreadValues({
                            maxRetries: maxRetries,
                            backoff: defaultBackoff,
                            retryCondition: defaultRetryCondition
                        }, defaultOptions), extraOptions);
                        retry2 = 0;
                        _j.label = 1;
                    case 1:
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            baseQuery(args, api, extraOptions)
                        ];
                    case 3:
                        result = _j.sent();
                        if (result.error) throw new HandledError(result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        e_3 = _j.sent();
                        retry2++;
                        if (e_3.throwImmediately) {
                            if (e_3 instanceof HandledError) return [
                                2 /*return*/ ,
                                e_3.value
                            ];
                            throw e_3;
                        }
                        if (e_3 instanceof HandledError && !options.retryCondition(e_3.value.error, args, {
                            attempt: retry2,
                            baseQueryApi: api,
                            extraOptions: extraOptions
                        })) return [
                            2 /*return*/ ,
                            e_3.value
                        ];
                        return [
                            4 /*yield*/ ,
                            options.backoff(retry2, options.maxRetries)
                        ];
                    case 5:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var retry = /* @__PURE__ */ Object.assign(retryWithBackoff, {
    fail: fail
});
var onFocus = /* @__PURE__ */ (0, _toolkit.createAction)("__rtkq/focused");
var onFocusLost = /* @__PURE__ */ (0, _toolkit.createAction)("__rtkq/unfocused");
var onOnline = /* @__PURE__ */ (0, _toolkit.createAction)("__rtkq/online");
var onOffline = /* @__PURE__ */ (0, _toolkit.createAction)("__rtkq/offline");
var initialized = false;
function setupListeners(dispatch, customHandler) {
    function defaultHandler() {
        var handleFocus = function() {
            return dispatch(onFocus());
        };
        var handleFocusLost = function() {
            return dispatch(onFocusLost());
        };
        var handleOnline = function() {
            return dispatch(onOnline());
        };
        var handleOffline = function() {
            return dispatch(onOffline());
        };
        var handleVisibilityChange = function() {
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                initialized = true;
            }
        }
        var unsubscribe = function() {
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: onFocus,
        onFocusLost: onFocusLost,
        onOffline: onOffline,
        onOnline: onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})(DefinitionType || (DefinitionType = {}));
function isQueryDefinition(e) {
    return e.type === DefinitionType.query;
}
function isMutationDefinition(e) {
    return e.type === DefinitionType.mutation;
}
function calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if (isFunction(description)) return description(result, error, queryArg, meta).map(expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map(expandTagDescription).map(assertTagTypes);
    return [];
}
function isFunction(t) {
    return typeof t === "function";
}
function expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function isNotNullish(v) {
    return v != null;
}
// src/query/core/buildInitiate.ts
var forceQueryFnSymbol = Symbol("forceQueryFn");
var isUpsertQuery = function(arg) {
    return typeof arg[forceQueryFnSymbol] === "function";
};
function buildInitiate(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, api = _j.api, context = _j.context;
    var runningQueries = new Map();
    var runningMutations = new Map();
    var _k = api.internalActions, unsubscribeQueryResult = _k.unsubscribeQueryResult, removeMutationResult = _k.removeMutationResult, updateSubscriptionOptions = _k.updateSubscriptionOptions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk,
        getRunningOperationPromises: getRunningOperationPromises,
        removalWarning: removalWarning
    };
    function removalWarning() {
        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
    }
    function getRunningOperationPromises() {
        typeof process;
        var extract = function(v) {
            return Array.from(v.values()).flatMap(function(queriesForStore) {
                return queriesForStore ? Object.values(queriesForStore) : [];
            });
        };
        return __spreadArray(__spreadArray([], extract(runningQueries)), extract(runningMutations)).filter(isNotNullish);
    }
    function getRunningQueryThunk(endpointName, queryArgs) {
        return function(dispatch) {
            var _a;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return function(dispatch) {
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return function(dispatch) {
            return Object.values(runningQueries.get(dispatch) || {}).filter(isNotNullish);
        };
    }
    function getRunningMutationsThunk() {
        return function(dispatch) {
            return Object.values(runningMutations.get(dispatch) || {}).filter(isNotNullish);
        };
    }
    function middlewareWarning(dispatch) {
        var registered;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        var queryAction = function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.subscribe, subscribe = _l === void 0 ? true : _l, forceRefetch = _k.forceRefetch, subscriptionOptions = _k.subscriptionOptions, _m = forceQueryFnSymbol, forceQueryFn = _k[_m];
            return function(dispatch, getState) {
                var _j;
                var _a;
                var queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                var thunk = queryThunk((_j = {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey
                }, _j[forceQueryFnSymbol] = forceQueryFn, _j));
                var selector = api.endpoints[endpointName].select(arg);
                var thunkResult = dispatch(thunk);
                var stateAfter = selector(getState());
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort;
                var skippedSynchronously = stateAfter.requestId !== requestId;
                var runningQuery = (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
                var selectFromState = function() {
                    return selector(getState());
                };
                var statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    unwrap: function() {
                        return __async(this, null, function() {
                            var result;
                            return __generator(this, function(_j) {
                                switch(_j.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            statePromise
                                        ];
                                    case 1:
                                        result = _j.sent();
                                        if (result.isError) throw result.error;
                                        return [
                                            2 /*return*/ ,
                                            result.data
                                        ];
                                }
                            });
                        });
                    },
                    refetch: function() {
                        return dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        }));
                    },
                    unsubscribe: function() {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions: function(options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    var running_1 = runningQueries.get(dispatch) || {};
                    running_1[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running_1);
                    statePromise.then(function() {
                        delete running_1[queryCacheKey];
                        if (!Object.keys(running_1).length) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.track, track = _l === void 0 ? true : _l, fixedCacheKey = _k.fixedCacheKey;
            return function(dispatch, getState) {
                var thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                var thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort, unwrap = thunkResult.unwrap;
                var returnValuePromise = thunkResult.unwrap().then(function(data) {
                    return {
                        data: data
                    };
                }).catch(function(error) {
                    return {
                        error: error
                    };
                });
                var reset = function() {
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                var ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    unsubscribe: reset,
                    reset: reset
                });
                var running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(function() {
                    delete running[requestId];
                    if (!Object.keys(running).length) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(function() {
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!Object.keys(running).length) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
        };
    }
}
function defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function buildThunks(_j) {
    var _this = this;
    var reducerPath = _j.reducerPath, baseQuery = _j.baseQuery, endpointDefinitions = _j.context.endpointDefinitions, serializeQueryArgs = _j.serializeQueryArgs, api = _j.api, assertTagType = _j.assertTagType;
    var patchQueryData = function(endpointName, args, patches, updateProvided) {
        return function(dispatch, getState) {
            var endpointDefinition = endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: args,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            var newValue = api.endpoints[endpointName].select(args)(getState());
            var providedTags = calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, args, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy({
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            }));
        };
    };
    var updateQueryData = function(endpointName, args, updateRecipe, updateProvided) {
        if (updateProvided === void 0) updateProvided = true;
        return function(dispatch, getState) {
            var _j, _k;
            var endpointDefinition = api.endpoints[endpointName];
            var currentState = endpointDefinition.select(args)(getState());
            var ret = {
                patches: [],
                inversePatches: [],
                undo: function() {
                    return dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches, updateProvided));
                }
            };
            if (currentState.status === QueryStatus.uninitialized) return ret;
            var newValue;
            if ("data" in currentState) {
                if ((0, _immer.isDraftable)(currentState.data)) {
                    var _l = (0, _immer.produceWithPatches)(currentState.data, updateRecipe), value = _l[0], patches = _l[1], inversePatches = _l[2];
                    (_j = ret.patches).push.apply(_j, patches);
                    (_k = ret.inversePatches).push.apply(_k, inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches, updateProvided));
            return ret;
        };
    };
    var upsertQueryData = function(endpointName, args, value) {
        return function(dispatch) {
            var _j;
            return dispatch(api.endpoints[endpointName].initiate(args, (_j = {
                subscribe: false,
                forceRefetch: true
            }, _j[forceQueryFnSymbol] = function() {
                return {
                    data: value
                };
            }, _j)));
        };
    };
    var executeEndpoint = function(_0, _1) {
        return __async(_this, [
            _0,
            _1
        ], function(arg, _j) {
            var endpointDefinition, transformResponse, result, baseQueryApi_1, forceQueryFn, what, err, _k, _l, key, _m, error_1, catchedError, transformErrorResponse, _o, e_4;
            var _p, _q;
            var signal = _j.signal, abort = _j.abort, rejectWithValue = _j.rejectWithValue, fulfillWithValue = _j.fulfillWithValue, dispatch = _j.dispatch, getState = _j.getState, extra = _j.extra;
            return __generator(this, function(_r) {
                switch(_r.label){
                    case 0:
                        endpointDefinition = endpointDefinitions[arg.endpointName];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            8,
                            ,
                            13
                        ]);
                        transformResponse = defaultTransformResponse;
                        result = void 0;
                        baseQueryApi_1 = {
                            signal: signal,
                            abort: abort,
                            dispatch: dispatch,
                            getState: getState,
                            extra: extra,
                            endpoint: arg.endpointName,
                            type: arg.type,
                            forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
                        };
                        forceQueryFn = arg.type === "query" ? arg[forceQueryFnSymbol] : void 0;
                        if (!forceQueryFn) return [
                            3 /*break*/ ,
                            2
                        ];
                        result = forceQueryFn();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!endpointDefinition.query) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi_1, endpointDefinition.extraOptions)
                        ];
                    case 3:
                        result = _r.sent();
                        if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            endpointDefinition.queryFn(arg.originalArgs, baseQueryApi_1, endpointDefinition.extraOptions, function(arg2) {
                                return baseQuery(arg2, baseQueryApi_1, endpointDefinition.extraOptions);
                            })
                        ];
                    case 5:
                        result = _r.sent();
                        _r.label = 6;
                    case 6:
                        typeof process;
                        if (result.error) throw new HandledError(result.error, result.meta);
                        _m = fulfillWithValue;
                        return [
                            4 /*yield*/ ,
                            transformResponse(result.data, result.meta, arg.originalArgs)
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _m.apply(void 0, [
                                _r.sent(),
                                (_p = {
                                    fulfilledTimeStamp: Date.now(),
                                    baseQueryMeta: result.meta
                                }, _p[0, _toolkit.SHOULD_AUTOBATCH] = true, _p)
                            ])
                        ];
                    case 8:
                        error_1 = _r.sent();
                        catchedError = error_1;
                        if (!(catchedError instanceof HandledError)) return [
                            3 /*break*/ ,
                            12
                        ];
                        transformErrorResponse = defaultTransformResponse;
                        if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                        _r.label = 9;
                    case 9:
                        _r.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        _o = rejectWithValue;
                        return [
                            4 /*yield*/ ,
                            transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs)
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _o.apply(void 0, [
                                _r.sent(),
                                (_q = {
                                    baseQueryMeta: catchedError.meta
                                }, _q[0, _toolkit.SHOULD_AUTOBATCH] = true, _q)
                            ])
                        ];
                    case 11:
                        e_4 = _r.sent();
                        catchedError = e_4;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 12:
                        typeof process;
                        console.error(catchedError);
                        throw catchedError;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    function isForcedQuery(arg, state) {
        var _a, _b, _c, _d;
        var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[arg.queryCacheKey];
        var baseFetchOnMountOrArgChange = (_c = state[reducerPath]) == null ? void 0 : _c.config.refetchOnMountOrArgChange;
        var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        var refetchVal = (_d = arg.forceRefetch) != null ? _d : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    var queryThunk = (0, _toolkit.createAsyncThunk)(reducerPath + "/executeQuery", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, _toolkit.SHOULD_AUTOBATCH] = true, _j;
        },
        condition: function(queryThunkArgs, _j) {
            var getState = _j.getState;
            var _a, _b, _c;
            var state = getState();
            var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[queryThunkArgs.queryCacheKey];
            var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
            var currentArg = queryThunkArgs.originalArgs;
            var previousArg = requestState == null ? void 0 : requestState.originalArgs;
            var endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if (isUpsertQuery(queryThunkArgs)) return true;
            if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if (isQueryDefinition(endpointDefinition) && ((_c = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _c.call(endpointDefinition, {
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            }))) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    var mutationThunk = (0, _toolkit.createAsyncThunk)(reducerPath + "/executeMutation", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, _toolkit.SHOULD_AUTOBATCH] = true, _j;
        }
    });
    var hasTheForce = function(options) {
        return "force" in options;
    };
    var hasMaxAge = function(options) {
        return "ifOlderThan" in options;
    };
    var prefetch = function(endpointName, arg, options) {
        return function(dispatch, getState) {
            var force = hasTheForce(options) && options.force;
            var maxAge = hasMaxAge(options) && options.ifOlderThan;
            var queryAction = function(force2) {
                if (force2 === void 0) force2 = true;
                return api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            };
            var latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                var lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                var shouldRetrigger = (Number(new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    };
    function matchesEndpoint(endpointName) {
        return function(action) {
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, _toolkit.isAllOf)((0, _toolkit.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, _toolkit.isAllOf)((0, _toolkit.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, _toolkit.isAllOf)((0, _toolkit.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, _toolkit.isFulfilled)(action) ? action.payload : void 0, (0, _toolkit.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function updateQuerySubstateIfExists(state, queryCacheKey, update) {
    var substate = state[queryCacheKey];
    if (substate) update(substate);
}
function getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function updateMutationSubstateIfExists(state, id, update) {
    var substate = state[getMutationCacheKey(id)];
    if (substate) update(substate);
}
var initialState = {};
function buildSlice(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, _k = _j.context, definitions = _k.endpointDefinitions, apiUid = _k.apiUid, extractRehydrationInfo = _k.extractRehydrationInfo, hasRehydrationInfo = _k.hasRehydrationInfo, assertTagType = _j.assertTagType, config = _j.config;
    var resetApiState = (0, _toolkit.createAction)(reducerPath + "/resetApiState");
    var querySlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/queries",
        initialState: initialState,
        reducers: {
            removeQueryResult: {
                reducer: function(draft, _j) {
                    var queryCacheKey = _j.payload.queryCacheKey;
                    delete draft[queryCacheKey];
                },
                prepare: (0, _toolkit.prepareAutoBatched)()
            },
            queryResultPatched: {
                reducer: function(draft, _j) {
                    var _k = _j.payload, queryCacheKey = _k.queryCacheKey, patches = _k.patches;
                    updateQuerySubstateIfExists(draft, queryCacheKey, function(substate) {
                        substate.data = (0, _immer.applyPatches)(substate.data, patches.concat());
                    });
                },
                prepare: (0, _toolkit.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(queryThunk.pending, function(draft, _j) {
                var meta = _j.meta, arg = _j.meta.arg;
                var _a, _b;
                var upserting = isUpsertQuery(arg);
                if (arg.subscribe || upserting) (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
                    status: QueryStatus.uninitialized,
                    endpointName: arg.endpointName
                };
                updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    substate.status = QueryStatus.pending;
                    substate.requestId = upserting && substate.requestId ? substate.requestId : meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, function(draft, _j) {
                var meta = _j.meta, payload = _j.payload;
                updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, function(substate) {
                    var _a;
                    if (substate.requestId !== meta.requestId && !isUpsertQuery(meta.arg)) return;
                    var merge = definitions[meta.arg.endpointName].merge;
                    substate.status = QueryStatus.fulfilled;
                    if (merge) {
                        if (substate.data !== void 0) {
                            var fulfilledTimeStamp_1 = meta.fulfilledTimeStamp, arg_1 = meta.arg, baseQueryMeta_1 = meta.baseQueryMeta, requestId_1 = meta.requestId;
                            var newData = (0, _toolkit.createNextState)(substate.data, function(draftSubstateData) {
                                return merge(draftSubstateData, payload, {
                                    arg: arg_1.originalArgs,
                                    baseQueryMeta: baseQueryMeta_1,
                                    fulfilledTimeStamp: fulfilledTimeStamp_1,
                                    requestId: requestId_1
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? copyWithStructuralSharing((0, _immer.isDraft)(substate.data) ? (0, _immer.original)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, function(draft, _j) {
                var _k = _j.meta, condition = _k.condition, arg = _k.arg, requestId = _k.requestId, error = _j.error, payload = _j.payload;
                updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = QueryStatus.rejected;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var queries = extractRehydrationInfo(action).queries;
                for(var _j = 0, _k = Object.entries(queries); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if ((entry == null ? void 0 : entry.status) === QueryStatus.fulfilled || (entry == null ? void 0 : entry.status) === QueryStatus.rejected) draft[key] = entry;
                }
            });
        }
    });
    var mutationSlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/mutations",
        initialState: initialState,
        reducers: {
            removeMutationResult: {
                reducer: function(draft, _j) {
                    var payload = _j.payload;
                    var cacheKey = getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, _toolkit.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(mutationThunk.pending, function(draft, _j) {
                var meta = _j.meta, _k = _j.meta, requestId = _k.requestId, arg = _k.arg, startedTimeStamp = _k.startedTimeStamp;
                if (!arg.track) return;
                draft[getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: QueryStatus.pending,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, function(draft, _j) {
                var payload = _j.payload, meta = _j.meta;
                if (!meta.arg.track) return;
                updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = QueryStatus.fulfilled;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, function(draft, _j) {
                var payload = _j.payload, error = _j.error, meta = _j.meta;
                if (!meta.arg.track) return;
                updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = QueryStatus.rejected;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var mutations = extractRehydrationInfo(action).mutations;
                for(var _j = 0, _k = Object.entries(mutations); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if (((entry == null ? void 0 : entry.status) === QueryStatus.fulfilled || (entry == null ? void 0 : entry.status) === QueryStatus.rejected) && key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
                }
            });
        }
    });
    var invalidationSlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/invalidation",
        initialState: initialState,
        reducers: {
            updateProvidedBy: {
                reducer: function(draft, action) {
                    var _a, _b, _c, _d;
                    var _j = action.payload, queryCacheKey = _j.queryCacheKey, providedTags = _j.providedTags;
                    for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                        var tagTypeSubscriptions = _l[_k];
                        for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                            var idSubscriptions = _o[_m];
                            var foundAt = idSubscriptions.indexOf(queryCacheKey);
                            if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                        }
                    }
                    for(var _p = 0, providedTags_1 = providedTags; _p < providedTags_1.length; _p++){
                        var _q = providedTags_1[_p], type = _q.type, id = _q.id;
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                    }
                },
                prepare: (0, _toolkit.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(querySlice.actions.removeQueryResult, function(draft, _j) {
                var queryCacheKey = _j.payload.queryCacheKey;
                for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                    var tagTypeSubscriptions = _l[_k];
                    for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                        var idSubscriptions = _o[_m];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var _a, _b, _c, _d;
                var provided = extractRehydrationInfo(action).provided;
                for(var _j = 0, _k = Object.entries(provided); _j < _k.length; _j++){
                    var _l = _k[_j], type = _l[0], incomingTags = _l[1];
                    for(var _m = 0, _o = Object.entries(incomingTags); _m < _o.length; _m++){
                        var _p = _o[_m], id = _p[0], cacheKeys = _p[1];
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        for(var _q = 0, cacheKeys_1 = cacheKeys; _q < cacheKeys_1.length; _q++){
                            var queryCacheKey = cacheKeys_1[_q];
                            var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                    }
                }
            }).addMatcher((0, _toolkit.isAnyOf)((0, _toolkit.isFulfilled)(queryThunk), (0, _toolkit.isRejectedWithValue)(queryThunk)), function(draft, action) {
                var providedTags = calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                var queryCacheKey = action.meta.arg.queryCacheKey;
                invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy({
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }));
            });
        }
    });
    var subscriptionSlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/subscriptions",
        initialState: initialState,
        reducers: {
            updateSubscriptionOptions: function(d, a) {},
            unsubscribeQueryResult: function(d, a) {},
            internal_probeSubscription: function(d, a) {}
        }
    });
    var internalSubscriptionsSlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/internalSubscriptions",
        initialState: initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer: function(state, action) {
                    return (0, _immer.applyPatches)(state, action.payload);
                },
                prepare: (0, _toolkit.prepareAutoBatched)()
            }
        }
    });
    var configSlice = (0, _toolkit.createSlice)({
        name: reducerPath + "/config",
        initialState: __spreadValues({
            online: isOnline(),
            focused: isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered: function(state, _j) {
                var payload = _j.payload;
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: function(builder) {
            builder.addCase(onOnline, function(state) {
                state.online = true;
            }).addCase(onOffline, function(state) {
                state.online = false;
            }).addCase(onFocus, function(state) {
                state.focused = true;
            }).addCase(onFocusLost, function(state) {
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, function(draft) {
                return __spreadValues({}, draft);
            });
        }
    });
    var combinedReducer = (0, _toolkit.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    var reducer = function(state, action) {
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    var actions = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), invalidationSlice.actions), {
        unsubscribeMutationResult: mutationSlice.actions.removeMutationResult,
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var skipToken = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var skipSelector = skipToken;
var initialSubState = {
    status: QueryStatus.uninitialized
};
var defaultQuerySubState = /* @__PURE__ */ (0, _toolkit.createNextState)(initialSubState, function() {});
var defaultMutationSubState = /* @__PURE__ */ (0, _toolkit.createNextState)(initialSubState, function() {});
function buildSelectors(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, reducerPath = _j.reducerPath;
    var selectSkippedQuery = function(state) {
        return defaultQuerySubState;
    };
    var selectSkippedMutation = function(state) {
        return defaultMutationSubState;
    };
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy
    };
    function withRequestFlags(substate) {
        return __spreadValues(__spreadValues({}, substate), getRequestStatusFlags(substate.status));
    }
    function selectInternalState(rootState) {
        var state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return function(queryArgs) {
            var serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            var selectQuerySubstate = function(state) {
                var _a, _b, _c;
                return (_c = (_b = (_a = selectInternalState(state)) == null ? void 0 : _a.queries) == null ? void 0 : _b[serializedArgs]) != null ? _c : defaultQuerySubState;
            };
            var finalSelectQuerySubState = queryArgs === skipToken ? selectSkippedQuery : selectQuerySubstate;
            return (0, _toolkit.createSelector)(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return function(id) {
            var _a;
            var mutationId;
            if (typeof id === "object") mutationId = (_a = getMutationCacheKey(id)) != null ? _a : skipToken;
            else mutationId = id;
            var selectMutationSubstate = function(state) {
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectInternalState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : defaultMutationSubState;
            };
            var finalSelectMutationSubstate = mutationId === skipToken ? selectSkippedMutation : selectMutationSubstate;
            return (0, _toolkit.createSelector)(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        var apiState = state[reducerPath];
        var toInvalidate = new Set();
        for(var _j = 0, _k = tags.map(expandTagDescription); _j < _k.length; _j++){
            var tag = _k[_j];
            var provided = apiState.provided[tag.type];
            if (!provided) continue;
            var invalidateSubscriptions = (_a = tag.id !== void 0 ? provided[tag.id] : flatten(Object.values(provided))) != null ? _a : [];
            for(var _l = 0, invalidateSubscriptions_1 = invalidateSubscriptions; _l < invalidateSubscriptions_1.length; _l++){
                var invalidate = invalidateSubscriptions_1[_l];
                toInvalidate.add(invalidate);
            }
        }
        return flatten(Array.from(toInvalidate.values()).map(function(queryCacheKey) {
            var querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
}
var cache = WeakMap ? new WeakMap() : void 0;
var defaultSerializeQueryArgs = function(_j) {
    var endpointName = _j.endpointName, queryArgs = _j.queryArgs;
    var serialized = "";
    var cached = cache == null ? void 0 : cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, _toolkit.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, _toolkit.isPlainObject)(queryArgs)) cache == null || cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
function buildCreateApi() {
    var modules = [];
    for(var _j = 0; _j < arguments.length; _j++)modules[_j] = arguments[_j];
    return function baseCreateApi(options) {
        var extractRehydrationInfo = (0, _reselect.defaultMemoize)(function(action) {
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        var optionsWithDefaults = __spreadProps(__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs: function(queryArgsApi) {
                var finalSerializeQueryArgs = defaultSerializeQueryArgs;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    var endpointSQA_1 = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = function(queryArgsApi2) {
                        var initialResult = endpointSQA_1(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return defaultSerializeQueryArgs(__spreadProps(__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: __spreadArray([], options.tagTypes || [])
        });
        var context = {
            endpointDefinitions: {},
            batch: function(fn) {
                fn();
            },
            apiUid: (0, _toolkit.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, _reselect.defaultMemoize)(function(action) {
                return extractRehydrationInfo(action) != null;
            })
        };
        var api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints: function(_j) {
                var addTagTypes = _j.addTagTypes, endpoints = _j.endpoints;
                if (addTagTypes) for(var _k = 0, addTagTypes_1 = addTagTypes; _k < addTagTypes_1.length; _k++){
                    var eT = addTagTypes_1[_k];
                    if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for(var _l = 0, _m = Object.entries(endpoints); _l < _m.length; _l++){
                    var _o = _m[_l], endpointName = _o[0], partialDefinition = _o[1];
                    if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        var initializedModules = modules.map(function(m) {
            return m.init(api, optionsWithDefaults, context);
        });
        function injectEndpoints(inject) {
            var evaluatedEndpoints = inject.endpoints({
                query: function(x) {
                    return __spreadProps(__spreadValues({}, x), {
                        type: DefinitionType.query
                    });
                },
                mutation: function(x) {
                    return __spreadProps(__spreadValues({}, x), {
                        type: DefinitionType.mutation
                    });
                }
            });
            for(var _j = 0, _k = Object.entries(evaluatedEndpoints); _j < _k.length; _j++){
                var _l = _k[_j], endpointName = _l[0], definition = _l[1];
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof process;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for(var _m = 0, initializedModules_1 = initializedModules; _m < initializedModules_1.length; _m++){
                    var m = initializedModules_1[_m];
                    m.injectEndpoint(endpointName, definition);
                }
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
// src/query/fakeBaseQuery.ts
function fakeBaseQuery() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function isObjectEmpty(obj) {
    for(var k in obj)return false;
    return true;
}
var THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var buildCacheCollectionHandler = function(_j) {
    var reducerPath = _j.reducerPath, api = _j.api, context = _j.context, internalState = _j.internalState;
    var _k = api.internalActions, removeQueryResult = _k.removeQueryResult, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !isObjectEmpty(subscriptions);
    }
    var currentRemovalTimeouts = {};
    var handler = function(action, mwApi, internalState2) {
        var _a;
        if (unsubscribeQueryResult.match(action)) {
            var state = mwApi.getState()[reducerPath];
            var queryCacheKey = action.payload.queryCacheKey;
            handleUnsubscribe(queryCacheKey, (_a = state.queries[queryCacheKey]) == null ? void 0 : _a.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(currentRemovalTimeouts); _j < _k.length; _j++){
            var _l = _k[_j], key = _l[0], timeout = _l[1];
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            var state = mwApi.getState()[reducerPath];
            var queries = context.extractRehydrationInfo(action).queries;
            for(var _m = 0, _o = Object.entries(queries); _m < _o.length; _m++){
                var _p = _o[_m], queryCacheKey = _p[0], queryState = _p[1];
                handleUnsubscribe(queryCacheKey, queryState == null ? void 0 : queryState.endpointName, mwApi, state.config);
            }
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        var finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            var currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(function() {
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
var buildInvalidationByTagsHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, endpointDefinitions = _j.context.endpointDefinitions, mutationThunk = _j.mutationThunk, api = _j.api, assertTagType = _j.assertTagType, refetchQuery = _j.refetchQuery;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var isThunkActionWithTags = (0, _toolkit.isAnyOf)((0, _toolkit.isFulfilled)(mutationThunk), (0, _toolkit.isRejectedWithValue)(mutationThunk));
    var handler = function(action, mwApi) {
        if (isThunkActionWithTags(action)) invalidateTags(calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        if (api.util.invalidateTags.match(action)) invalidateTags(calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function invalidateTags(tags, mwApi) {
        var rootState = mwApi.getState();
        var state = rootState[reducerPath];
        var toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(function() {
            var _a;
            var valuesArray = Array.from(toInvalidate.values());
            for(var _j = 0, valuesArray_1 = valuesArray; _j < valuesArray_1.length; _j++){
                var queryCacheKey = valuesArray_1[_j].queryCacheKey;
                var querySubState = state.queries[queryCacheKey];
                var subscriptionSubState = (_a = state.subscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if (Object.keys(subscriptionSubState).length === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== QueryStatus.uninitialized) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var buildPollingHandler = function(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var currentPolls = {};
    var handler = function(action, mwApi) {
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === QueryStatus.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        var currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        var currentInterval = currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(function() {
                currentInterval.timeout = void 0;
                api2.dispatch(refetchQuery(querySubState, queryCacheKey));
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === QueryStatus.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        var currentPoll = currentPolls[queryCacheKey];
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        var existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for(var _j = 0, _k = Object.keys(currentPolls); _j < _k.length; _j++){
            var key = _k[_j];
            cleanupPollForKey(key);
        }
    }
    function findLowestPollingInterval(subscribers) {
        if (subscribers === void 0) subscribers = {};
        var lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(var key in subscribers)if (!!subscribers[key].pollingInterval) lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
        return lowestPollingInterval;
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var buildWindowEventHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var handler = function(action, mwApi) {
        if (onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if (onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        var state = api2.getState()[reducerPath];
        var queries = state.queries;
        var subscriptions = internalState.currentSubscriptions;
        context.batch(function() {
            for(var _j = 0, _k = Object.keys(subscriptions); _j < _k.length; _j++){
                var queryCacheKey = _k[_j];
                var querySubState = queries[queryCacheKey];
                var subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                var shouldRefetch = Object.values(subscriptionSubState).some(function(sub) {
                    return sub[type] === true;
                }) || Object.values(subscriptionSubState).every(function(sub) {
                    return sub[type] === void 0;
                }) && state.config[type];
                if (shouldRefetch) {
                    if (Object.keys(subscriptionSubState).length === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== QueryStatus.uninitialized) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
var neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var buildCacheLifecycleHandler = function(_j) {
    var api = _j.api, reducerPath = _j.reducerPath, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, internalState = _j.internalState;
    var isQueryThunk = (0, _toolkit.isAsyncThunkAction)(queryThunk);
    var isMutationThunk = (0, _toolkit.isAsyncThunkAction)(mutationThunk);
    var isFulfilledThunk = (0, _toolkit.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi, stateBefore) {
        var cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            var oldState = stateBefore[reducerPath].queries[cacheKey];
            var state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            var state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(lifecycleMap); _j < _k.length; _j++){
            var _l = _k[_j], cacheKey2 = _l[0], lifecycle = _l[1];
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        var lifecycle = {};
        var cacheEntryRemoved = new Promise(function(resolve) {
            lifecycle.cacheEntryRemoved = resolve;
        });
        var cacheDataLoaded = Promise.race([
            new Promise(function(resolve) {
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(function() {
                throw neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(function() {});
        lifecycleMap[queryCacheKey] = lifecycle;
        var selector = api.endpoints[endpointName].select(endpointDefinition.type === DefinitionType.query ? originalArgs : queryCacheKey);
        var extra = mwApi.dispatch(function(_, __, extra2) {
            return extra2;
        });
        var lifecycleApi = __spreadProps(__spreadValues({}, mwApi), {
            getCacheEntry: function() {
                return selector(mwApi.getState());
            },
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === DefinitionType.query ? function(updateRecipe) {
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        var runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch(function(e) {
            if (e === neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
var buildQueryLifecycleHandler = function(_j) {
    var api = _j.api, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk;
    var isPendingThunk = (0, _toolkit.isPending)(queryThunk, mutationThunk);
    var isRejectedThunk = (0, _toolkit.isRejected)(queryThunk, mutationThunk);
    var isFullfilledThunk = (0, _toolkit.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi) {
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            var _j = action.meta, requestId = _j.requestId, _k = _j.arg, endpointName_1 = _k.endpointName, originalArgs_1 = _k.originalArgs;
            var endpointDefinition = context.endpointDefinitions[endpointName_1];
            var onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                var lifecycle_1 = {};
                var queryFulfilled = new Promise(function(resolve, reject) {
                    lifecycle_1.resolve = resolve;
                    lifecycle_1.reject = reject;
                });
                queryFulfilled.catch(function() {});
                lifecycleMap[requestId] = lifecycle_1;
                var selector_1 = api.endpoints[endpointName_1].select(endpointDefinition.type === DefinitionType.query ? originalArgs_1 : requestId);
                var extra = mwApi.dispatch(function(_, __, extra2) {
                    return extra2;
                });
                var lifecycleApi = __spreadProps(__spreadValues({}, mwApi), {
                    getCacheEntry: function() {
                        return selector_1(mwApi.getState());
                    },
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === DefinitionType.query ? function(updateRecipe) {
                        return mwApi.dispatch(api.util.updateQueryData(endpointName_1, originalArgs_1, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs_1, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            var _l = action.meta, requestId = _l.requestId, baseQueryMeta = _l.baseQueryMeta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            var _m = action.meta, requestId = _m.requestId, rejectedWithValue = _m.rejectedWithValue, baseQueryMeta = _m.baseQueryMeta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var buildDevCheckHandler = function(_j) {
    var api = _j.api, apiUid = _j.context.apiUid, reducerPath = _j.reducerPath;
    return function(action, mwApi) {
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof process;
    };
};
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function(cb) {
    return (promise || (promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var buildBatchedActionsHandler = function(_j) {
    var api = _j.api, queryThunk = _j.queryThunk, internalState = _j.internalState;
    var subscriptionsPrefix = api.reducerPath + "/subscriptions";
    var previousSubscriptions = null;
    var dispatchQueued = false;
    var _k = api.internalActions, updateSubscriptionOptions = _k.updateSubscriptionOptions, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    var actuallyMutateSubscriptions = function(mutableState, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId, options = _j.options;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            var _k = action.payload, queryCacheKey = _k.queryCacheKey, requestId = _k.requestId;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            var _l = action.meta, arg = _l.arg, requestId = _l.requestId;
            if (arg.subscribe) {
                var substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
                substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
                return true;
            }
        }
        if (queryThunk.rejected.match(action)) {
            var _m = action.meta, condition = _m.condition, arg = _m.arg, requestId = _m.requestId;
            if (condition && arg.subscribe) {
                var substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                return true;
            }
        }
        return false;
    };
    return function(action, mwApi) {
        var _a, _b;
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_probeSubscription.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId;
            var hasSubscription = !!((_a = internalState.currentSubscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
            return [
                false,
                hasSubscription
            ];
        }
        var didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate) {
            if (!dispatchQueued) {
                queueMicrotaskShim(function() {
                    var newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                    var _j = (0, _immer.produceWithPatches)(previousSubscriptions, function() {
                        return newSubscriptions;
                    }), patches = _j[1];
                    mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                    previousSubscriptions = newSubscriptions;
                    dispatchQueued = false;
                });
                dispatchQueued = true;
            }
            var isSubscriptionSliceAction = !!((_b = action.type) == null ? void 0 : _b.startsWith(subscriptionsPrefix));
            var isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            var actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
            return [
                actionShouldContinue,
                false
            ];
        }
        return [
            true,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function buildMiddleware(input) {
    var reducerPath = input.reducerPath, queryThunk = input.queryThunk, api = input.api, context = input.context;
    var apiUid = context.apiUid;
    var actions = {
        invalidateTags: (0, _toolkit.createAction)(reducerPath + "/invalidateTags")
    };
    var isThisApiSliceAction = function(action) {
        return !!action && typeof action.type === "string" && action.type.startsWith(reducerPath + "/");
    };
    var handlerBuilders = [
        buildDevCheckHandler,
        buildCacheCollectionHandler,
        buildInvalidationByTagsHandler,
        buildPollingHandler,
        buildCacheLifecycleHandler,
        buildQueryLifecycleHandler
    ];
    var middleware = function(mwApi) {
        var initialized2 = false;
        var internalState = {
            currentSubscriptions: {}
        };
        var builderArgs = __spreadProps(__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery
        });
        var handlers = handlerBuilders.map(function(build) {
            return build(builderArgs);
        });
        var batchedActionsHandler = buildBatchedActionsHandler(builderArgs);
        var windowEventsHandler = buildWindowEventHandler(builderArgs);
        return function(next) {
            return function(action) {
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                var mwApiWithNext = __spreadProps(__spreadValues({}, mwApi), {
                    next: next
                });
                var stateBefore = mwApi.getState();
                var _j = batchedActionsHandler(action, mwApiWithNext, stateBefore), actionShouldContinue = _j[0], hasSubscription = _j[1];
                var res;
                if (actionShouldContinue) res = next(action);
                else res = hasSubscription;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for(var _k = 0, handlers_1 = handlers; _k < handlers_1.length; _k++){
                        var handler = handlers_1[_k];
                        handler(action, mwApiWithNext, stateBefore);
                    }
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override) {
        if (override === void 0) override = {};
        return queryThunk(__spreadValues({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey
        }, override));
    }
}
// src/query/tsHelpers.ts
function assertCast(v) {}
function safeAssign(target) {
    var args = [];
    for(var _j = 1; _j < arguments.length; _j++)args[_j - 1] = arguments[_j];
    Object.assign.apply(Object, __spreadArray([
        target
    ], args));
}
var coreModuleName = /* @__PURE__ */ Symbol();
var coreModule = function() {
    return {
        name: coreModuleName,
        init: function(api, _j, context) {
            var baseQuery = _j.baseQuery, tagTypes = _j.tagTypes, reducerPath = _j.reducerPath, serializeQueryArgs = _j.serializeQueryArgs, keepUnusedDataFor = _j.keepUnusedDataFor, refetchOnMountOrArgChange = _j.refetchOnMountOrArgChange, refetchOnFocus = _j.refetchOnFocus, refetchOnReconnect = _j.refetchOnReconnect;
            (0, _immer.enablePatches)();
            assertCast(serializeQueryArgs);
            var assertTagType = function(tag) {
                typeof process;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: onOnline,
                    onOffline: onOffline,
                    onFocus: onFocus,
                    onFocusLost: onFocusLost
                },
                util: {}
            });
            var _k = buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType
            }), queryThunk = _k.queryThunk, mutationThunk = _k.mutationThunk, patchQueryData = _k.patchQueryData, updateQueryData = _k.updateQueryData, upsertQueryData = _k.upsertQueryData, prefetch = _k.prefetch, buildMatchThunkActions = _k.buildMatchThunkActions;
            var _l = buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath
                }
            }), reducer = _l.reducer, sliceActions = _l.actions;
            safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            safeAssign(api.internalActions, sliceActions);
            var _m = buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            }), middleware = _m.middleware, middlewareActions = _m.actions;
            safeAssign(api.util, middlewareActions);
            safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            var _o = buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath
            }), buildQuerySelector = _o.buildQuerySelector, buildMutationSelector = _o.buildMutationSelector, selectInvalidatedBy = _o.selectInvalidatedBy;
            safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy
            });
            var _p = buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildInitiateQuery = _p.buildInitiateQuery, buildInitiateMutation = _p.buildInitiateMutation, getRunningMutationThunk = _p.getRunningMutationThunk, getRunningMutationsThunk = _p.getRunningMutationsThunk, getRunningQueriesThunk = _p.getRunningQueriesThunk, getRunningQueryThunk = _p.getRunningQueryThunk, getRunningOperationPromises = _p.getRunningOperationPromises, removalWarning = _p.removalWarning;
            safeAssign(api.util, {
                getRunningOperationPromises: getRunningOperationPromises,
                getRunningOperationPromise: removalWarning,
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: coreModuleName,
                injectEndpoint: function(endpointName, definition) {
                    var _a, _b;
                    var anyApi = api;
                    (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if (isQueryDefinition(definition)) safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if (isMutationDefinition(definition)) safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    };
};
// src/query/core/index.ts
var createApi = /* @__PURE__ */ buildCreateApi(coreModule());

},{"51a55a5d1c6cd353":"eXpi0","@reduxjs/toolkit":"1vrnJ","immer":"f53pe","reselect":"2pmMJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"liepd":[function(require,module,exports) {
/**
 * Global application configuration
 */ var config = {};
config.protocol = "https:";
config.DOMAIN = "epiphanyanalytics.com";
config.ROOT = config.protocol + "//app." + config.DOMAIN;
config.REACT_ROOT = config.ROOT + "/react";
config.API_ROOT = config.protocol + "//tardis." + config.DOMAIN + "/api";
config.SHARING_ROOT = config.protocol + "//" + config.DOMAIN + "/maps";
config.LEGACY_DOMAIN = config.protocol + "//reports." + config.DOMAIN;
config.DEV = false;
config.TILE_URL = config.protocol + "//tiles." + config.DOMAIN;
config.TEGOLA_URL = config.protocol + "//vectors." + config.DOMAIN;
config.PUBLIC_GA_ID = "UA-44954143-3";
config.APP_GA_ID = "UA-44954143-4"; // Google geocoder API key
config.GEOCODE_KEY = "AIzaSyAEmYSgkebJuliyVrE40cUJzNVTDyDVUxc"; // Settings for Fine Uploader
config.S3_BUCKET_URL = "https://epiphany-files-production.s3.amazonaws.com";
config.S3_ACCESS_KEY = "AKIAIEKZRFDDAM7BJVQQ";
config.S3_REGION = "us-west-1"; // The mapbox tile info
config.MAPBOX_USER = "geostrategies";
config.MAPBOX_STYLE_ID = "ckhlcedni05ps19rq0a0xd7ls";
config.MAPBOX_TILE_SIZE = 256;
config.MAPBOX_HIGHDPI = false;
config.MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZ2Vvc3RyYXRlZ2llcyIsImEiOiI0NC1DRVhrIn0.OIEcZz0WqPaMgsyKRu6ycg"; // The Datadog application id
config.DATADOG_APP_ID = "0d17233e-3182-4eb8-ae8c-ef7945d129e3";
config.THEME = "";
if (0, module.exports) module.exports = config;

},{}],"w3GXi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "appSlice", ()=>appSlice);
parcelHelpers.export(exports, "updateGlobalState", ()=>updateGlobalState);
parcelHelpers.export(exports, "setEntityID", ()=>setEntityID);
parcelHelpers.export(exports, "setSession", ()=>setSession);
parcelHelpers.export(exports, "setH1", ()=>setH1);
parcelHelpers.export(exports, "setError", ()=>setError);
parcelHelpers.export(exports, "clearError", ()=>clearError);
parcelHelpers.export(exports, "updateWorkspaceFolding", ()=>updateWorkspaceFolding);
parcelHelpers.export(exports, "updateMapFolding", ()=>updateMapFolding);
var _toolkit = require("@reduxjs/toolkit");
var _store = require("../store");
var _apiSlice = require("./apiSlice");
const initialState = {
    h1: "",
    title: "",
    activePage: "",
    activeSection: ""
};
const appSlice = (0, _toolkit.createSlice)({
    name: "app",
    initialState,
    reducers: {
        updateGlobalState: (state, { payload })=>{
            return {
                ...state,
                ...payload
            };
        },
        setEntityID: (state, { payload })=>{
            // it can be a number or string depending on the part of the app
            const parsedEntityId = typeof payload === "string" ? parseInt(payload) : payload; // if it's the same, don't do anything
            if (state.entityID === parsedEntityId) return; // else set it on the state
            state.entityID = parsedEntityId;
            state.entity = state.session?.entityList.find((e)=>e.ID === parsedEntityId); // this is frustrating but there's no other good way to clear the api cache without this
            setTimeout(()=>{
                (0, _store.store).dispatch((0, _apiSlice.baseApi).util.resetApiState());
            });
        },
        setSession: (state, { payload })=>{
            state.session = payload; // if the page has been refreshed, it's possible the entity isn't set, so just make sure it's set
            if (!state.entity) state.entity = state.session?.entityList.find((e)=>e.ID === state.entityID);
        },
        setH1: (state, { payload })=>{
            state.h1 = payload;
        },
        setError: (state, { payload })=>{
            if (!state.error) state.error = payload;
        },
        clearError: (state)=>{
            state.error = undefined;
        },
        updateWorkspaceFolding: (state, { payload })=>{
            if (!state.session) return;
            if (state.session.preferences == undefined) state.session.preferences = {};
            state.session.preferences.workspaceFolding = payload;
        },
        updateMapFolding: (state, { payload })=>{
            if (!state.session) return;
            if (state.session.preferences == undefined) state.session.preferences = {};
            state.session.preferences.mapFolding = payload;
        }
    }
});
const { updateGlobalState, setEntityID, setSession, setH1, setError, clearError, updateWorkspaceFolding, updateMapFolding } = appSlice.actions;
exports.default = appSlice.reducer;

},{"@reduxjs/toolkit":"1vrnJ","../store":"7WrEn","./apiSlice":"fcKYC","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1GDaH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "pagesSlice", ()=>pagesSlice);
parcelHelpers.export(exports, "toggleShowArchived", ()=>toggleShowArchived);
parcelHelpers.export(exports, "toggleType", ()=>toggleType);
parcelHelpers.export(exports, "setDataSearch", ()=>setDataSearch);
parcelHelpers.export(exports, "resetDataState", ()=>resetDataState);
parcelHelpers.export(exports, "setConsoleCollection", ()=>setConsoleCollection);
parcelHelpers.export(exports, "setCurrentlyEditingCollection", ()=>setCurrentlyEditingCollection);
parcelHelpers.export(exports, "resetTruTerritoryState", ()=>resetTruTerritoryState);
parcelHelpers.export(exports, "setMap", ()=>setMap);
parcelHelpers.export(exports, "setCollectionOrder", ()=>setCollectionOrder);
parcelHelpers.export(exports, "toggleTopPanelSection", ()=>toggleTopPanelSection);
parcelHelpers.export(exports, "setSidePanelOpen", ()=>setSidePanelOpen);
parcelHelpers.export(exports, "setCurrentlyEditingThemeAndCollection", ()=>setCurrentlyEditingThemeAndCollection);
parcelHelpers.export(exports, "updateCurrentlyEditingTheme", ()=>updateCurrentlyEditingTheme);
parcelHelpers.export(exports, "setWorkspace", ()=>setWorkspace);
parcelHelpers.export(exports, "setWorkspaces", ()=>setWorkspaces);
parcelHelpers.export(exports, "setMapDirty", ()=>setMapDirty);
parcelHelpers.export(exports, "setIsSnippetToolOpen", ()=>setIsSnippetToolOpen);
var _toolkit = require("@reduxjs/toolkit");
var _collectionTypes = require("../types/CollectionTypes");
const initialState = {
    data: {
        showArchived: false,
        selectedTypesFilter: (0, _collectionTypes.CollectionTypes).map(({ type })=>type)
    },
    truterritory: {
        currentThemes: {},
        topPanelSections: {
            layers: false,
            theme: false,
            mapReports: false
        },
        isSidePanelOpen: false,
        isMapDirty: false,
        isSnippetToolOpen: false
    }
};
const pagesSlice = (0, _toolkit.createSlice)({
    name: "pages",
    initialState,
    reducers: {
        // data collections
        toggleShowArchived: (state)=>{
            state.data.showArchived = !state.data.showArchived;
        },
        toggleType: (state, { payload })=>{
            if (state.data.selectedTypesFilter.includes(payload)) state.data.selectedTypesFilter = state.data.selectedTypesFilter.filter((t)=>t !== payload);
            else state.data.selectedTypesFilter.push(payload);
        },
        setDataSearch: (state, { payload })=>{
            state.data.searchString = payload;
        },
        resetDataState: (state)=>{
            state.data = initialState.data;
        },
        setConsoleCollection: (state, { payload })=>{
            state.data.consoleCollection = payload;
        },
        setCurrentlyEditingCollection: (state, { payload })=>{
            state.data.currentlyEditingCollection = payload;
        },
        // truterritory
        resetTruTerritoryState: (state)=>{
            state.truterritory = initialState.truterritory;
        },
        setMap: (state, { payload: map })=>{
            state.truterritory.map = map;
            state.truterritory.currentThemes = {};
            if (!map) return;
            for(let i = 0; i < map.collections.length; i++){
                const collection = map.collections[i];
                const theme = collection.findTheme ? collection.findTheme(map, false) : null;
                if (!theme) continue;
                state.truterritory.currentThemes[collection.ID] = theme;
            }
        },
        setCollectionOrder: (state, { payload })=>{
            if (!state.truterritory.map) return;
            const newCollections = payload.map((id)=>state.truterritory.map.collections.find((c)=>c.ID === id));
            state.truterritory.map.collections = newCollections;
        },
        toggleTopPanelSection: (state, { payload })=>{
            state.truterritory.topPanelSections[payload] = !state.truterritory.topPanelSections[payload]; // close all the other panels
            Object.keys(state.truterritory.topPanelSections).forEach((section)=>{
                if (section !== payload) state.truterritory.topPanelSections[section] = false;
            });
        },
        setSidePanelOpen (state, { payload }) {
            state.truterritory.isSidePanelOpen = payload;
        },
        setMapDirty (state, { payload }) {
            state.truterritory.isMapDirty = payload;
        },
        setIsSnippetToolOpen (state, { payload }) {
            state.truterritory.isSnippetToolOpen = payload;
        },
        setCurrentlyEditingThemeAndCollection: (state, { payload: { theme, collection } })=>{
            state.truterritory.currentEditingTheme = theme;
            state.truterritory.currentEditingCollection = {
                properties: collection.properties,
                aggregates: collection.aggregates
            };
        },
        updateCurrentlyEditingTheme: (state, { payload })=>{
            if (!state.truterritory.currentEditingTheme) return;
            state.truterritory.currentEditingTheme = {
                ...state.truterritory.currentEditingTheme,
                ...payload
            };
        },
        setWorkspace: (state, { payload: workspace })=>{
            state.truterritory.workspace = workspace;
        },
        setWorkspaces (state, { payload: workspaces }) {
            state.truterritory.workspaces = workspaces;
        }
    }
});
const { toggleShowArchived, toggleType, setDataSearch, resetDataState, setConsoleCollection, setCurrentlyEditingCollection, resetTruTerritoryState, setMap, setCollectionOrder, toggleTopPanelSection, setSidePanelOpen, setCurrentlyEditingThemeAndCollection, updateCurrentlyEditingTheme, setWorkspace, setWorkspaces, setMapDirty, setIsSnippetToolOpen } = pagesSlice.actions;
exports.default = pagesSlice.reducer;

},{"@reduxjs/toolkit":"1vrnJ","../types/CollectionTypes":"984si","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"984si":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectionType", ()=>CollectionType);
parcelHelpers.export(exports, "CollectionTypes", ()=>CollectionTypes);
var CollectionType;
(function(CollectionType) {
    CollectionType["Master"] = "master";
    CollectionType["Transformation"] = "transform";
    CollectionType["Dynamic"] = "dynamic";
    CollectionType["Writable"] = "writable";
})(CollectionType || (CollectionType = {}));
const CollectionTypes = [
    {
        type: "master",
        name: "Master"
    },
    {
        type: "transform",
        name: "Transformation"
    },
    {
        type: "dynamic",
        name: "Dynamic"
    },
    {
        type: "writable",
        name: "Writable"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eyWgN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAppSelector", ()=>useAppSelector);
var _reactRedux = require("react-redux");
const useAppSelector = (0, _reactRedux.useSelector);

},{"react-redux":"l8b2G","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"k6bkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TruTerritorySideFilters", ()=>TruTerritorySideFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useAppSelector = require("../../../hooks/useAppSelector");
var _apiSlice = require("../../../slices/apiSlice");
var _paging = require("../../../components/Paging");
var _button = require("../../../design/Button");
const operators = Object.freeze([
    {
        name: "=",
        op: "="
    },
    {
        name: "!=",
        op: "!="
    },
    {
        name: "IN",
        op: "IN"
    },
    {
        name: "NOT IN",
        op: "NOT IN"
    },
    {
        name: "LIKE",
        op: "ILIKE"
    },
    {
        name: "NOT LIKE",
        op: "NOT ILIKE"
    },
    {
        name: ">",
        op: ">"
    },
    {
        name: "<",
        op: "<"
    },
    {
        name: ">=",
        op: ">="
    },
    {
        name: "<=",
        op: "<="
    }
]);
const TruTerritorySideFilters = ({ onApplyChanges, selectedCollection })=>{
    const { map } = (0, _useAppSelector.useAppSelector)((state)=>state.pages.truterritory);
    const [filters, setFilters] = (0, _react.useState)();
    const [nameColumn, setNameColumn] = (0, _react.useState)();
    const [dataColumn, setDataColumn] = (0, _react.useState)();
    const [page, setPage] = (0, _react.useState)(1);
    const { data: { data: features, meta } = {} } = (0, _apiSlice.useGetCollectionFeaturesQuery)({
        id: selectedCollection?.ID,
        filters,
        limit: 10,
        page
    }, {
        skip: !selectedCollection
    });
    (0, _react.useEffect)(()=>{
        if (!map || !selectedCollection) return;
        setFilters(map?.filters[selectedCollection.ID]);
    }, [
        map,
        selectedCollection
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                children: [
                    "Selected collection: ",
                    selectedCollection?.name
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterCreator, {
                filters: filters,
                onChange: (f)=>setFilters(f),
                onApplyChanges: (f)=>onApplyChanges(selectedCollection.ID, f),
                selectedCollection: selectedCollection
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "truterritory-collection-list",
                "ng-hide": "!selectedCollection || !features.length",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                        children: [
                            "Total: ",
                            meta?.total
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        id: "truterritory-feature-data",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                            colSpan: 2,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Name:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "select-holder",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                        onChange: ({ target })=>setNameColumn(target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            selectedCollection?.properties.map((property)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: property.column,
                                                                    children: property.name
                                                                }, `property-${property.column}`))
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Data:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "select-holder",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                        onChange: ({ target })=>setDataColumn(target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            selectedCollection?.properties.map((property)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: property.column,
                                                                    children: property.name
                                                                }, `property-${property.column}`))
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: features?.map((feature, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        "ng-repeat": "feature in features",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: nameColumn && dataColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `map-type ${feature.geometryType.toLowerCase()}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: nameColumn && feature[nameColumn]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: dataColumn && feature[dataColumn]
                                            })
                                        ]
                                    }, `feature-${selectedCollection?.ID}-${i}`))
                            })
                        ]
                    }),
                    !features && !meta?.total && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "empty",
                        children: "No features"
                    }),
                    meta && features && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paging.Paging), {
                        pages: meta,
                        onChange: (page)=>setPage(page)
                    })
                ]
            })
        ]
    });
};
const FilterCreator = ({ filters = [], onChange = ()=>{}, onApplyChanges, error, selectedCollection })=>{
    const addFilter = function() {
        // Add our new filter, which hopefully shouldn't be breaking anything
        onChange(filters.concat([
            getNewFilter(filters, selectedCollection)
        ]));
    };
    /**
   *
   * @param {array} filters Filters currently being displayed
   * @param {Object} selectedCollection The collection currently
   */ const getNewFilter = function(filters, selectedCollection) {
        let defaultProperty = getDefaultProperty(selectedCollection.properties, filters);
        let jsType = getPgTypeToJs(defaultProperty.type);
        let defaultOperator = jsType === "number" ? ">" : "=";
        return {
            operator: defaultOperator,
            column: defaultProperty.name,
            attribute: defaultProperty.name,
            value: getJsTypeDefault(jsType)
        };
    };
    /**
   *
   * @param {array} properties
   * @param {array} filters
   * @return {*}
   */ const getDefaultProperty = function(properties, filters) {
        // If we don't have any filters yet, return the first property
        if (!filters.length) return properties[0];
         // Otherwise add the next property in line to filter by
        // find the last added filter
        let lastFilter = filters.slice(-1)[0]; // Now find the index of the matching property
        let lastPropertyIndex = properties.findIndex(function(property) {
            return property.column === lastFilter.column;
        }); // Now, get the index of the "next" property we should use
        let targetIndex = (lastPropertyIndex + 1) % properties.length;
        return properties[targetIndex];
    };
    /**
   *
   * @param {string} pgType
   * @return {string}
   */ const getPgTypeToJs = function(pgType) {
        if (pgType === "varchar" || pgType === "text") return "string";
        else if (pgType.startsWith("int") || pgType === "numeric" || pgType.startsWith("float") || pgType.endsWith("int")) return "number";
        else if (pgType === "boolean" || pgType === "bool") return "boolean";
        else if (pgType.startsWith("timestamp")) return "date";
        else if (pgType.startsWith("json")) return "json";
        else if (pgType.endsWith("[]")) return "array";
        else return "unknown";
    };
    /**
   *
   * @param jsType
   * @return string|number|boolean|Date
   */ const getJsTypeDefault = function(jsType) {
        if (jsType === "string") return "";
        else if (jsType === "number") return 1;
        else if (jsType === "boolean") return true;
        else if (jsType === "date") return new Date().toLocaleString();
        else if (jsType === "json" || jsType === "jsonb") return "{}";
        else if (jsType === "array" || jsType === "array") return "[]";
         // In all other cases, return the default for an unknown / "other" case
        return "";
    };
    /**
   * Remove a single filter on the selected collection
   * @param  {int} index
   * @return {void}
   */ const removeFilter = function(index) {
        let newFilters = [
            ...filters
        ];
        newFilters.splice(index, 1);
        onChange(newFilters);
    };
    const onFilterChange = function(index, filter) {
        let newFilters = [
            ...filters
        ];
        newFilters[index] = filter;
        onChange(newFilters);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "filters-holder",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                className: "filter-header",
                children: "Live Filters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                className: "filter-creator",
                name: "filter-creator",
                children: filters.length ? filters.map((filter, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "filter",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {
                                    filter: filter,
                                    columns: selectedCollection.properties,
                                    onChange: (f)=>onFilterChange(index, f)
                                })
                            }, `filter-${index}`),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "del",
                                onClick: ()=>removeFilter(index)
                            }),
                            index === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "add",
                                onClick: ()=>addFilter()
                            })
                        ]
                    }, `filter-${index}`)) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filter",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "empty",
                            children: "No filters"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "btn add",
                            onClick: ()=>addFilter()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "controls",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-danger error-message",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn",
                        disabled: Boolean(error),
                        onClick: ()=>onApplyChanges(filters),
                        title: "Click to apply the current filters to the map",
                        children: "Apply Filters"
                    })
                ]
            })
        ]
    });
};
const Filter = ({ filter, columns, attributeClass, operatorClass, valueClass, onChange })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `filter-select-holder ${attributeClass}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                    name: "column{{$index}}",
                    onChange: ({ target })=>onChange({
                            ...filter,
                            column: target.value
                        }),
                    value: filter.column,
                    children: columns.map((property)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            value: property.column,
                            children: property.name
                        }, `property-${property.column}`))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `filter-select-holder ${operatorClass}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                    name: "operator{{$index}}",
                    onChange: ({ target })=>onChange({
                            ...filter,
                            operator: target.value
                        }),
                    value: filter.operator,
                    children: operators.map((operator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            value: operator.op,
                            children: operator.name
                        }, `operator-${operator.op}`))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                onChange: ({ target })=>onChange({
                        ...filter,
                        value: target.value
                    }),
                placeholder: "",
                className: valueClass,
                value: filter.value + ""
            })
        ]
    });

},{"react/jsx-runtime":"38att","react":"llNeF","../../../hooks/useAppSelector":"eyWgN","../../../slices/apiSlice":"fcKYC","../../../components/Paging":"kva25","../../../design/Button":"kEQbZ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kva25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paging", ()=>Paging);
var _jsxRuntime = require("react/jsx-runtime");
const Paging = ({ onChange, pages, verbosity = 1 })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "epi-paging",
        children: (()=>{
            switch(verbosity){
                case 1:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "page-selector",
                            children: [
                                pages.page > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "prev",
                                    onClick: ()=>onChange && onChange(pages.page - 1),
                                    children: "<prev"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "page",
                                    children: [
                                        "Page ",
                                        pages.page,
                                        " of ",
                                        pages.totalPages
                                    ]
                                }),
                                pages.page < pages.totalPages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "next",
                                    onClick: ()=>onChange && onChange(pages.page + 1),
                                    children: "next>"
                                })
                            ]
                        })
                    });
                case 2:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "info",
                                children: [
                                    "Records: ",
                                    pages.total
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "page-selector",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "prev",
                                        "ng-click": "prevPage()",
                                        "ng-show": "pages.page > 1",
                                        children: "<prev"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "page",
                                        children: [
                                            "Page ",
                                            pages.page,
                                            " of ",
                                            pages.totalPages
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "next",
                                        "ng-click": "nextPage()",
                                        "ng-show": "pages.page < pages.totalPages",
                                        children: "next>"
                                    })
                                ]
                            })
                        ]
                    });
                case 3:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "info",
                                children: [
                                    "Pages: ",
                                    pages.totalPages,
                                    " Records: ",
                                    pages.total
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "records",
                                children: [
                                    "Records",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            pages.range[0],
                                            " - ",
                                            pages.range[1]
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "page-selector",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "prev",
                                        "ng-click": "prevPage()",
                                        "ng-show": "pages.page > 1",
                                        children: "<prev"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "page",
                                        children: [
                                            "Page ",
                                            pages.page
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "next",
                                        "ng-click": "nextPage()",
                                        "ng-show": "pages.page < pages.totalPages",
                                        children: "next>"
                                    })
                                ]
                            })
                        ]
                    });
            }
        })()
    });

},{"react/jsx-runtime":"38att","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kEQbZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "AngularButton", ()=>AngularButton);
parcelHelpers.export(exports, "LoadingButton", ()=>LoadingButton);
parcelHelpers.export(exports, "AngularLoadingButton", ()=>AngularLoadingButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _smallLoadingIndicator = require("./SmallLoadingIndicator");
var _react2Angular = require("react2angular");
const Button = ({ children, value, className, onClick, disabled = false, loading = false, loadingText, type = "button", hide, show, title, variant, id })=>{
    const shouldShow = (0, _react.useMemo)(()=>{
        if (typeof show === "undefined" && typeof hide === "undefined") return true;
        if (typeof show !== "undefined" && show === true) return true;
        if (typeof hide !== "undefined" && hide === false) return true;
        return false;
    }, [
        show,
        hide
    ]);
    return shouldShow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        onClick: onClick,
        className: `btn ${className ?? ""} ${variant ?? ""}`,
        type: type,
        disabled: disabled || loading,
        title: title,
        id: id,
        children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smallLoadingIndicator.SmallLoadingIndicator), {}),
                loadingText || children || value
            ]
        }) : children || value
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
};
Button.propTypes = {
    children: (0, _propTypesDefault.default).node,
    value: (0, _propTypesDefault.default).string,
    onClick: (0, _propTypesDefault.default).func,
    type: (0, _propTypesDefault.default).oneOf([
        "button",
        "submit",
        "reset"
    ]),
    hide: (0, _propTypesDefault.default).bool,
    show: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool
};
const AngularButton = (0, _react2Angular.react2angular)(Button);
const LoadingButton = ({ children, value, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Button, {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smallLoadingIndicator.SmallLoadingIndicator), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: children || value
            })
        ]
    });
};
LoadingButton.propTypes = {
    ...Button.propTypes
};
const AngularLoadingButton = (0, _react2Angular.react2angular)(LoadingButton);

},{"react/jsx-runtime":"38att","react":"llNeF","prop-types":"cRFmb","./SmallLoadingIndicator":"ilr96","react2angular":"lq1hx","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ilr96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallLoadingIndicator", ()=>SmallLoadingIndicator);
parcelHelpers.export(exports, "AngularSmallLoadingIndicator", ()=>AngularSmallLoadingIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _react2Angular = require("react2angular");
const SmallLoadingIndicator = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "small-loading-indicator",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "icon-notched-circle"
        })
    });
};
const AngularSmallLoadingIndicator = (0, _react2Angular.react2angular)(SmallLoadingIndicator);

},{"react/jsx-runtime":"38att","react2angular":"lq1hx","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"czKxS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortableUl", ()=>SortableUl);
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@dnd-kit/core");
var _modifiers = require("@dnd-kit/modifiers");
var _sortable = require("@dnd-kit/sortable");
const SortableUl = ({ items, id, children, onDragEnd, onDragStart, className })=>{
    const sensors = (0, _core.useSensors)((0, _core.useSensor)((0, _core.PointerSensor)), (0, _core.useSensor)((0, _core.KeyboardSensor), {
        coordinateGetter: (0, _sortable.sortableKeyboardCoordinates)
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.DndContext), {
        sensors: sensors,
        collisionDetection: (0, _core.closestCenter),
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        modifiers: [
            (0, _modifiers.restrictToVerticalAxis),
            (0, _modifiers.restrictToParentElement)
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortable.SortableContext), {
            items: items,
            strategy: (0, _sortable.verticalListSortingStrategy),
            id: id,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: className,
                children: children
            })
        })
    });
};

},{"react/jsx-runtime":"38att","@dnd-kit/core":"cJjFL","@dnd-kit/modifiers":"50gxo","@dnd-kit/sortable":"cb4ui","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"50gxo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSnapModifier", ()=>createSnapModifier);
parcelHelpers.export(exports, "restrictToFirstScrollableAncestor", ()=>restrictToFirstScrollableAncestor);
parcelHelpers.export(exports, "restrictToHorizontalAxis", ()=>restrictToHorizontalAxis);
parcelHelpers.export(exports, "restrictToParentElement", ()=>restrictToParentElement);
parcelHelpers.export(exports, "restrictToVerticalAxis", ()=>restrictToVerticalAxis);
parcelHelpers.export(exports, "restrictToWindowEdges", ()=>restrictToWindowEdges);
parcelHelpers.export(exports, "snapCenterToCursor", ()=>snapCenterToCursor);
var _utilities = require("@dnd-kit/utilities");
function createSnapModifier(gridSize) {
    return (_ref)=>{
        let { transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const restrictToHorizontalAxis = (_ref)=>{
    let { transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const restrictToParentElement = (_ref)=>{
    let { containerNodeRect, draggingNodeRect, transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const restrictToFirstScrollableAncestor = (_ref)=>{
    let { draggingNodeRect, transform, scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const restrictToVerticalAxis = (_ref)=>{
    let { transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const restrictToWindowEdges = (_ref)=>{
    let { transform, draggingNodeRect, windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const snapCenterToCursor = (_ref)=>{
    let { activatorEvent, draggingNodeRect, transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, _utilities.getEventCoordinates)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};

},{"@dnd-kit/utilities":"8dZaa","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"KTIf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectionLi", ()=>CollectionLi);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _sortable = require("@dnd-kit/sortable");
var _classNameMapper = require("../../../utils/classNameMapper");
var _useOutsideClick = require("../../../hooks/useOutsideClick");
var _sortableLi = require("../../../components/Sortable/SortableLi");
var _checkbox = require("../../../design/Checkbox");
var _iconFilter = require("../../../resources/icons/IconFilter");
var _useAppSelector = require("../../../hooks/useAppSelector");
const CollectionLi = ({ isOpen, toggleOpen, collection, isVisible, label, isPublicPage, theme, hasAccess, handleVisibleToggle, handleRemoveCollection, editTheme, cloneTheme, setTheme, addTheme, setLabel, onSelect })=>{
    const { map } = (0, _useAppSelector.useAppSelector)((state)=>state.pages.truterritory);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sortableLi.SortableLi), {
        className: `collection collection-${collection.ID} ` + (0, _classNameMapper.classNameMapper)({
            visible: isVisible
        }),
        id: collection.ID,
        useSeparateDragHandle: true,
        children: [
            !isPublicPage && hasAccess("update") && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DragHandle, {
                id: collection.ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "name",
                onClick: toggleOpen,
                children: collection.name
            }),
            !isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                onClick: toggleOpen,
                children: label ? "Label: " + label : "(no label)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                name: `visible${collection.ID}`,
                id: `visible${collection.ID}`,
                onChange: ()=>handleVisibleToggle(collection.ID),
                checked: isVisible
            }),
            !isPublicPage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "collection-controls",
                children: [
                    (map?.filters ?? {})[collection.ID]?.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        title: "Collection has active filters. Click to open filters panel",
                        className: "btn icon-btn filter active",
                        onClick: ()=>onSelect(collection),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconFilter.IconFilter), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn arrow-right",
                        onClick: ()=>onSelect(collection),
                        title: "Click to open filters panel"
                    }),
                    hasAccess("delete") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn del",
                        onClick: ()=>handleRemoveCollection(collection.ID)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: [
                    "collapsible",
                    isOpen ? "opened" : "closed"
                ].join(" "),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "controls",
                    children: [
                        hasAccess("update") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Dropdown, {
                            className: "theme-selector",
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dropdown-toggle",
                                        children: [
                                            "Theme: ",
                                            theme?.name || "(no name)"
                                        ]
                                    }),
                                    !isPublicPage && hasAccess("update") && theme && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn edit",
                                                onClick: ()=>editTheme(collection.ID)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn copy",
                                                onClick: ()=>cloneTheme(collection.ID, theme)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            children: [
                                collection.themes.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        className: `theme ${(0, _classNameMapper.classNameMapper)({
                                            selected: t.ID === theme?.ID
                                        })}`,
                                        onClick: ()=>setTheme(collection.ID, t),
                                        children: t.name
                                    }, `theme-${t.ID}`)),
                                !isPublicPage && hasAccess("create") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    className: "add-new",
                                    onClick: ()=>addTheme(collection.ID),
                                    "ng-if": "!isPublicPage && hasAccess('create')",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Add New Theme"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "btn add"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Dropdown, {
                            className: "label-selector",
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dropdown-toggle",
                                children: [
                                    " Label: ",
                                    label || "(no label)"
                                ]
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "option",
                                    onClick: ()=>setLabel(collection.ID, null),
                                    children: "(no label)"
                                }),
                                collection.properties.map((prop)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: `option ${(0, _classNameMapper.classNameMapper)({
                                            "theme-label": theme?.label === prop.column
                                        })}`,
                                        onClick: ()=>setLabel(collection.ID, prop.column),
                                        children: prop.name
                                    }, `label-${prop.column}`))
                            ]
                        })
                    ]
                })
            })
        ]
    }, `collection-${collection.ID}`);
};
const Dropdown = ({ label, children, className })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const dropdownRef = (0, _react.useRef)(null);
    (0, _useOutsideClick.useOutsideClick)(dropdownRef, ()=>setIsOpen(false));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${className} ${(0, _classNameMapper.classNameMapper)({
            open: isOpen
        })}`,
        onClick: ()=>setIsOpen((o)=>!o),
        ref: dropdownRef,
        children: [
            label,
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "dropdown",
                onClick: ()=>setTimeout(()=>setIsOpen(false)),
                children: children
            })
        ]
    });
};
const DragHandle = ({ id })=>{
    const { listeners, attributes } = (0, _sortable.useSortable)({
        id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "draggable ui-sortable-handle",
        title: "Drag here to reorder",
        ...listeners,
        ...attributes
    });
};

},{"react/jsx-runtime":"38att","react":"llNeF","@dnd-kit/sortable":"cb4ui","../../../utils/classNameMapper":"7tx4L","../../../hooks/useOutsideClick":"1tz7W","../../../components/Sortable/SortableLi":"eeXmT","../../../design/Checkbox":"gwra2","../../../resources/icons/IconFilter":"rFOwV","../../../hooks/useAppSelector":"eyWgN","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7tx4L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNameMapper", ()=>classNameMapper);
const classNameMapper = (map, addtlClasses)=>{
    return Object.entries(map).filter(([_, filter])=>filter).reduce((acc, curr)=>acc + (acc.length ? " " : "") + curr[0], "") + (addtlClasses ? " " + addtlClasses : "");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1tz7W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOutsideClick", ()=>useOutsideClick);
var _react = require("react");
function useOutsideClick(ref, cb) {
    (0, _react.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) cb();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ]);
}

},{"react":"llNeF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eeXmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortableLi", ()=>SortableLi);
var _jsxRuntime = require("react/jsx-runtime");
var _sortable = require("@dnd-kit/sortable");
var _utilities = require("@dnd-kit/utilities");
const SortableLi = ({ id, children, className, useSeparateDragHandle })=>{
    const { setNodeRef, transform, transition, isDragging, listeners, attributes } = (0, _sortable.useSortable)({
        id
    });
    const style = {
        // CSS.Translate doesn't cause the element to become 100% the height of whatever it's over like CSS.Transform does.
        transform: (0, _utilities.CSS).Translate.toString(transform),
        transition,
        zIndex: isDragging ? 9999 : undefined
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ref: setNodeRef,
        style: style,
        className: className,
        ...useSeparateDragHandle ? {} : {
            ...listeners,
            ...attributes
        },
        children: children
    });
};

},{"react/jsx-runtime":"38att","@dnd-kit/sortable":"cb4ui","@dnd-kit/utilities":"8dZaa","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gwra2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _classNameMapper = require("../utils/classNameMapper");
const Checkbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                className: (0, _classNameMapper.classNameMapper)({
                    _checked: props.checked ?? false
                }) + (props.className ? ` ${props.className}` : ""),
                ...props
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "checkbox",
                htmlFor: props.id,
                children: props.label
            })
        ]
    });

},{"react/jsx-runtime":"38att","../utils/classNameMapper":"7tx4L","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"rFOwV":[function(require,module,exports) {
// <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconFilter", ()=>IconFilter);
var _jsxRuntime = require("react/jsx-runtime");
const IconFilter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            d: "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
        })
    });

},{"react/jsx-runtime":"38att","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cNzLb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EpiMap", ()=>EpiMap);
parcelHelpers.export(exports, "AngularEpiMap", ()=>AngularEpiMap);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactInAngularjs = require("react-in-angularjs");
var _leaflet = require("leaflet");
var _leafletDefault = parcelHelpers.interopDefault(_leaflet);
var _react2Angular = require("react2angular");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _index = require("../../../app/configuration/index");
var _withReduxProvider = require("../../services/withReduxProvider");
var _store = require("../../store");
var _mapSelectionActions = require("./MapSelectionActions");
var _useAppSelector = require("../../hooks/useAppSelector");
const defaultZoom = 5;
const defaultCenter = [
    38.23818,
    -97.866211
];
const EpiMap = ({ tiles, scale, contextMenuEnabled = true, isPublicPage, center, zoom, init, selectedFeatures, actions, reload })=>{
    const TruMap = (0, _reactInAngularjs.getService)("TruMap");
    const ContextMenu = (0, _reactInAngularjs.getService)("ContextMenu");
    const Storage = (0, _reactInAngularjs.getService)("Storage");
    zoom = zoom != undefined ? zoom : Storage.getItem("mapZoom");
    center = center != undefined ? center : Storage.getItem("mapCenter");
    const { entityID } = (0, _useAppSelector.useAppSelector)((state)=>state.app);
    const mapRef = (0, _react.useRef)(null);
    const map = (0, _store.store).getState().pages.truterritory?.map;
    (0, _react.useEffect)(()=>{
        const leafletMap = new TruMap((0, _leafletDefault.default).map(mapRef.current, {
            center: getCenter(center),
            zoom: zoom ?? defaultZoom,
            zoomAnimationThreshold: 15,
            maxBounds: [
                [
                    -90,
                    -190
                ],
                [
                    90,
                    190
                ]
            ],
            minZoom: 1,
            boxZoom: false
        }), isPublicPage); // set the base tile layer
        leafletMap.addMapBoxTileLayer(tiles || (0, _index.MAPBOX_USER), (0, _index.MAPBOX_STYLE_ID), (0, _index.MAPBOX_TILE_SIZE), (0, _index.MAPBOX_HIGHDPI), (0, _index.MAPBOX_ACCESS_TOKEN));
        if (scale) leafletMap.addScale(); // Enable context menu
        if (contextMenuEnabled) leafletMap.setContextMenu(ContextMenu.make.bind(null, findCollection, isPublicPage, ""));
         // run init
        if (init) init(leafletMap); // save zoom & center on reload and on tab change
        document.addEventListener("visibilitychange", saveZoomAndCenter.bind(null, leafletMap)); // save zoom & center on component unmount and remove the above event listener
        return ()=>{
            saveZoomAndCenter(leafletMap);
            document.removeEventListener("visibilitychange", saveZoomAndCenter.bind(null, leafletMap));
        };
    }, []); // Empty dependency array ensures the effect runs only once on component mount
    /**
   * Put the map's zoom and center into local storage
   * @return {void}
   */ function saveZoomAndCenter(truMap) {
        Storage.setItem("mapZoom", truMap.getZoom() < 3 ? 3 : truMap.getZoom(), entityID);
        Storage.setItem("mapCenter", truMap.getCenter(), entityID);
    }
    /**
   * This function is used to figure out what the center of the map should be set to,
   *   the center prop should be a LatLngExpression but it is not typed as such,
   *   since it's in localStorage and interfaced with AngularJS
   * @param center unknown but should be LatLngExpression
   */ const getCenter = (center)=>{
        if (!center) return defaultCenter;
        try {
            const parsedCenter = (0, _leafletDefault.default).latLng(center);
            if (parsedCenter && parsedCenter.lat && parsedCenter.lng) return parsedCenter;
        } catch (e) {
            return defaultCenter;
        }
        return defaultCenter;
    };
    /**
   * Find a collection by ID
   * @param  {int} ID
   * @return {Object}
   */ const findCollection = (ID)=>{
        const { map } = (0, _store.store).getState().pages.truterritory;
        return map && map.collections.find((collection)=>collection.ID === ID) || undefined;
    };
    let featureCount = 0, layerCount = 0;
    if (selectedFeatures) for(const layerName in selectedFeatures){
        layerCount++;
        for(const featureId in selectedFeatures[layerName])featureCount++;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "map",
                style: {
                    width: "100%",
                    height: "100%"
                },
                ref: mapRef
            }),
            featureCount && map && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "selection-status",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "counts",
                        children: [
                            featureCount,
                            " feature",
                            featureCount != 1 && "s",
                            " selected from ",
                            layerCount,
                            " layer",
                            layerCount != 1 && "s",
                            "."
                        ]
                    }),
                    actions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mapSelectionActions.MapSelectionActions), {
                        mapID: map.ID,
                        selectedFeatures: selectedFeatures,
                        defaultActions: actions,
                        collections: map?.collections || [],
                        reload: reload
                    })
                ]
            })
        ]
    });
};
EpiMap.propTypes = {
    tiles: (0, _propTypesDefault.default).string,
    scale: (0, _propTypesDefault.default).bool,
    contextMenuEnabled: (0, _propTypesDefault.default).bool,
    isPublicPage: (0, _propTypesDefault.default).bool,
    center: (0, _propTypesDefault.default).any,
    zoom: (0, _propTypesDefault.default).any,
    init: (0, _propTypesDefault.default).func,
    selectedFeatures: (0, _propTypesDefault.default).any,
    actions: (0, _propTypesDefault.default).any,
    reload: (0, _propTypesDefault.default).func
};
const AngularEpiMap = (0, _react2Angular.react2angular)((0, _withReduxProvider.withReduxProvider)(EpiMap));

},{"react/jsx-runtime":"38att","react":"llNeF","react-in-angularjs":"ink5J","leaflet":"kg6Jw","react2angular":"lq1hx","prop-types":"cRFmb","../../../app/configuration/index":"liepd","../../services/withReduxProvider":"hKZ95","../../store":"7WrEn","./MapSelectionActions":"8vqVO","../../hooks/useAppSelector":"eyWgN","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8vqVO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapSelectionActions", ()=>MapSelectionActions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mapSelectionSummary = require("./MapSelectionSummary");
var _classNameMapper = require("../../utils/classNameMapper");
var _reactDom = require("react-dom");
var _modal = require("../../components/Modal");
var _apiSlice = require("../../slices/apiSlice");
var _query = require("@reduxjs/toolkit/dist/query");
var _formik = require("formik");
var _button = require("../../design/Button");
const snippetFilteredImage = require("ac1a643cbe8210be");
const snippetNotFilteredImage = require("c267a904bbbe55c5");
const optionImages = {
    "handle-overlap.allow": require("78f3f19ee6912fa4"),
    "handle-overlap.deselect": require("a6f46054fc7b9e8c"),
    "handle-overlap.replace": require("b68d202eefd39375")
};
const MapSelectionActions = ({ mapID, selectedFeatures, defaultActions, collections, reload })=>{
    const [showSummary, setShowSummary] = (0, _react.useState)(true);
    const [errorMsg, setErrorMsg] = (0, _react.useState)("");
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const [askForReportSettings, setAskForReportSettings] = (0, _react.useState)(false);
    const [applyFilters, setApplyFilters] = (0, _react.useState)(true);
    const [backendActionInProgress, setBackendActionInProgress] = (0, _react.useState)();
    const [confirmationMessages, setConfirmationMessages] = (0, _react.useState)();
    const [confirmed, setConfirmed] = (0, _react.useState)(false);
    const { data: backendActions = [] } = (0, _apiSlice.useGetMapActionsQuery)(mapID);
    const selectedCollections = (0, _react.useMemo)(()=>Object.keys(selectedFeatures).map((layerName)=>collections?.find((c)=>c.tableName == layerName)), [
        selectedFeatures,
        collections
    ]);
    const enabledBackendActions = (0, _react.useMemo)(()=>{
        return backendActions.filter((a)=>a.enabled && (a.sourceID === null || !!selectedCollections.find((c)=>c?.ID === a.sourceID)));
    }, [
        backendActions,
        selectedCollections
    ]);
    const selectionIDs = (0, _react.useMemo)(()=>Object.keys(selectedFeatures).reduce((accum, layerName)=>({
                ...accum,
                [layerName]: Object.keys(selectedFeatures[layerName])
            }), {}), [
        selectedFeatures
    ]);
    const ableToSummarize = collections.filter((c)=>!!c.aggSql).length > 0; // Make the preflight call if an action is in progress on a non-empty selection.
    const buildPreflightRequest = ()=>backendActionInProgress && backendActionInProgress.ID && {
            actionID: backendActionInProgress.ID,
            selection: selectionIDs
        };
    const { data: preflightResponseRaw, isFetching: preflightInProgress } = (0, _apiSlice.useGetMapActionPreflightQuery)(buildPreflightRequest() || (0, _query.skipToken)); // Never use a cached preflight while another one is in-progress.
    const preflightResponse = preflightResponseRaw && !preflightInProgress ? preflightResponseRaw : undefined; // Handle error coming from preflight.
    if (!errorMsg && preflightResponse?.errors.length) {
        setErrorMsg(preflightResponse.errors[0]);
        setBackendActionInProgress(undefined);
    } // If preflight requires a top-level confirmation, show the message to the user.
    if (!confirmationMessages && preflightResponse?.required.confirmationMessage) setConfirmationMessages([
        preflightResponse.required.confirmationMessage
    ]);
     // If preflight does not require any fields, set submitted fields to an empty answer
    // so that we know to proceed with invoking the action.
    const [submittedFields, setSubmittedFields] = (0, _react.useState)();
    if (!submittedFields && preflightResponse?.required.fields.length === 0) setSubmittedFields({});
     // If preflight does not require any decisions, set submitted decisions to an empty answer
    // so that we know to proceed with invoking the action.
    const [submittedDecisions, setSubmittedDecisions] = (0, _react.useState)();
    if (!submittedDecisions && preflightResponse?.required.decisions.length === 0) setSubmittedDecisions({});
     // If preflight does not require decisions and does not require top-level confirmation, mark this as confirmed.
    if (!confirmed && !preflightResponse?.required.confirmationMessage && preflightResponse?.required.decisions.length === 0) setConfirmed(true);
     // If fields and decisions are both set, and we've received confirmation from the user, complete the input for the invocation.
    const [backendActionInput, setBackendActionInput] = (0, _react.useState)();
    if (!backendActionInput && submittedFields && submittedDecisions && confirmed) setBackendActionInput({
        fields: submittedFields,
        decisions: submittedDecisions
    });
     // If input is set and there's no error from preflight, invoke the action.
    const [invokeBackendAction, invokeResponse] = (0, _apiSlice.useInvokeMapActionMutation)();
    (0, _react.useEffect)(()=>{
        (async ()=>{
            if (backendActionInProgress?.ID && preflightResponse && !preflightResponse?.errors.length) {
                if (backendActionInput != undefined) try {
                    await invokeBackendAction({
                        actionID: backendActionInProgress.ID,
                        selection: selectionIDs,
                        input: backendActionInput || {}
                    }).unwrap();
                    defaultActions.clear();
                    if (backendActionInProgress.reloadOnCompletion && reload) reload();
                } catch (e) {
                    console.log("Error invoking action", e); // The global error handler will already display an error modal.
                } finally{
                    setBackendActionInProgress(undefined);
                    setBackendActionInput(undefined);
                    setConfirmationMessages(undefined);
                    setConfirmed(false);
                }
            }
        })();
    }, [
        backendActionInProgress,
        preflightResponse,
        backendActionInput
    ]);
    function toggleSummary() {
        setShowSummary(!showSummary);
    }
    function clickToDownload() {
        if (downloading || !defaultActions || !defaultActions.downloadReport) return;
        setDownloading(true);
        setAskForReportSettings(true);
    }
    async function downloadReport() {
        setAskForReportSettings(false);
        if (defaultActions && defaultActions.downloadReport) setErrorMsg(await defaultActions.downloadReport(applyFilters));
        setDownloading(false);
    }
    function cancelDownload() {
        setAskForReportSettings(false);
        setDownloading(false);
    }
    function oxfordConcat(vals, addQuotes = false) {
        if (addQuotes) vals = vals.map((s)=>`"${s}"`);
        if (vals.length == 0) return "";
        if (vals.length == 1) return vals[0];
        if (vals.length == 2) return vals.join("and");
         // Prefix last element with "and", then join all with commas.
        vals[vals.length - 1] = "and " + vals[vals.length - 1];
        return vals.join(", ");
    }
    function onSelectFilterOption(e) {
        setApplyFilters(e.target.value === "true");
    }
    /**
   * Begin working to perform an action at the user's request.
   * 1. Make a preflight call to the backend to check if any user input is required.
   * 2. If input required, open a modal to get it (the modal will then invoke the action
   *    or cancel). If no input required, invoke the action right away.
   */ async function startBackendAction(action) {
        setBackendActionInProgress(action);
    }
    function cancelAction() {
        setBackendActionInProgress(undefined);
        setBackendActionInput(undefined);
        setConfirmationMessages([]);
        setConfirmed(false);
    } // A single confirmation will clear the first of any required confirmations.
    function confirm() {
        setConfirmationMessages(confirmationMessages?.slice(1));
        setConfirmed(!confirmationMessages?.slice(1).length);
    } // Translate the layer names into propert Collection names.
    const selectedCollectionNames = selectedCollections.map((c)=>c?.name || "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                className: "actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "go-to",
                            onClick: defaultActions.goTo,
                            children: "Go To"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "filter-by",
                            onClick: defaultActions.filterBy,
                            children: "Filter By"
                        })
                    }),
                    ableToSummarize && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            className: "summarize",
                            onClick: toggleSummary,
                            children: [
                                showSummary ? "Hide" : "Show",
                                " Summary"
                            ]
                        })
                    }),
                    defaultActions.downloadReport && defaultActions.canDownloadReport() && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: `download-report ${(0, _classNameMapper.classNameMapper)({
                                loading: downloading
                            })}`,
                            onClick: clickToDownload,
                            children: downloading ? "Downloading" : "Download Report"
                        })
                    }),
                    enabledBackendActions.map((action)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                onClick: startBackendAction.bind(null, action),
                                className: `${(0, _classNameMapper.classNameMapper)({
                                    loading: backendActionInProgress?.ID == action.ID && (preflightInProgress || invokeResponse.isLoading)
                                })}`,
                                children: action.label || action.defaultName
                            })
                        }, action.ID)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "clear",
                            onClick: defaultActions.clear,
                            children: "Clear Selection"
                        })
                    })
                ]
            }),
            ableToSummarize && showSummary && /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mapSelectionSummary.MapSelectionSummary), {
                selectedFeatures: selectedFeatures,
                collections: collections
            }), document.getElementById("map-holder")),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modal.Modal), {
                isOpen: askForReportSettings,
                onClose: ()=>{},
                id: "truterritory-selection-report-modal",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "modal-header",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: "Download Report"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "modal-body",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "You have selected shapes in ",
                                    oxfordConcat(selectedCollectionNames, true),
                                    ". How would you like to display the shapes in ",
                                    oxfordConcat(selectedCollectionNames, true),
                                    " which you didn't select?"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "image-buttons",
                                onChange: onSelectFilterOption,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: snippetFilteredImage,
                                                alt: "selection"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "radio",
                                                name: "report-filter-option",
                                                value: "true",
                                                checked: applyFilters
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Filter out other shapes in selected layers"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: snippetNotFilteredImage,
                                                alt: "selection"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "radio",
                                                name: "report-filter-option",
                                                value: "false"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Highlight my selection, but show all shapes"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "controls",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn light",
                                        type: "button",
                                        onClick: downloadReport,
                                        children: "Download Report"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn plain",
                                        type: "button",
                                        onClick: cancelDownload,
                                        children: "Cancel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "modal-footer"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: !!errorMsg,
                onClose: ()=>{},
                id: "truterritory-selection-error-modal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: "Error"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Could not perform action. ",
                                errorMsg
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "controls",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn orange",
                                type: "button",
                                onClick: setErrorMsg.bind(null, ""),
                                children: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-footer"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: !!confirmationMessages && confirmationMessages.length > 0,
                onClose: ()=>{},
                id: "truterritory-selection-error-modal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: "Confirmation Required"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: confirmationMessages && confirmationMessages[0]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "controls",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn light",
                                    type: "button",
                                    onClick: confirm,
                                    children: "Yes, continue"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn plain",
                                    type: "button",
                                    onClick: cancelAction,
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-footer"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: !!backendActionInProgress && !!preflightResponse?.required.fields.length && !submittedFields,
                onClose: ()=>{},
                id: "truterritory-selection-action-input-modal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Formik), {
                    initialValues: preflightResponse?.required.fields.reduce((accum, field)=>({
                            ...accum,
                            [field.column]: ""
                        }), {}) || {},
                    onSubmit: (values, { setSubmitting })=>{
                        setSubmitting(true);
                        setSubmittedFields(values);
                    },
                    children: ({ values, handleChange, handleSubmit, isSubmitting, errors, touched })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                className: "form-horizontal",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "modal-body col-md-12",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "Input Required"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: "This action requires additional input."
                                            }),
                                            preflightResponse?.required.fields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "form-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                            className: "control-label col-md-3",
                                                            htmlFor: `action-required-${field.column}`,
                                                            children: field.name
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col-md-6",
                                                            children: field.type == "text" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Field), {
                                                                name: field.column,
                                                                type: "text",
                                                                id: `action-required-${field.column}`,
                                                                className: "form-control"
                                                            }) || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Field), {
                                                                name: field.column,
                                                                type: "number" // inputmode="numeric"
                                                                ,
                                                                pattern: field.type == "decimal" ? "d+.d+" : "d+",
                                                                step: field.type == "decimal" ? 0.01 : 1,
                                                                id: `action-required-${field.column}`,
                                                                className: "form-control"
                                                            })
                                                        })
                                                    ]
                                                }, field.column))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-footer",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "controls",
                                            children: [
                                                isSubmitting ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    type: "submit",
                                                    variant: "light-blue",
                                                    disabled: true,
                                                    children: "Running..."
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    type: "submit",
                                                    variant: "light-blue",
                                                    children: "Continue"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    variant: "plain",
                                                    onClick: cancelAction,
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: !!backendActionInProgress && !!preflightResponse?.required.decisions.length && !!submittedFields && !confirmationMessages?.length && !backendActionInput,
                onClose: ()=>{},
                id: "truterritory-selection-action-input-modal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Formik), {
                    initialValues: preflightResponse?.required.decisions.reduce((accum, decision)=>({
                            ...accum,
                            [decision.id]: ""
                        }), {}) || {},
                    onSubmit: (values, { setSubmitting })=>{
                        setSubmitting(true);
                        setSubmittedDecisions(values); // If a chosen option requires confirmation, get its message.
                        const decisions = preflightResponse?.required.decisions || [];
                        const messages = Object.keys(values).map((decisionID)=>decisions.find((d)=>d.id == decisionID)).map((decision)=>decision?.options.find((o)=>o.id == values[decision.id])).map((option)=>option?.confirmationMessage).filter((msg)=>!!msg);
                        setConfirmationMessages(messages); // Yay for TS
                        // If there are no messages, go ahead and mark this as confirmed.
                        if (!messages.length) setConfirmed(true);
                    },
                    children: ({ values, handleChange, handleSubmit, isSubmitting, errors, touched })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                className: "form-horizontal",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "modal-body col-md-12",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "Decision Required"
                                            }),
                                            preflightResponse?.required.decisions.map((decision, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            children: decision.description
                                                        }),
                                                        decision.useImages && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "image-buttons",
                                                            children: decision.options.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            src: optionImages[`${decision.id}.${option.id}`]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Field), {
                                                                            name: `${decision.id}`,
                                                                            id: `decisions.${decision.id}.${option.id}`,
                                                                            type: "radio",
                                                                            value: option.id,
                                                                            className: ""
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: option.text
                                                                        })
                                                                    ]
                                                                }, option.id))
                                                        }) || /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "decision-options-radios",
                                                            children: decision.options.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "decision-option",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formik.Field), {
                                                                            name: `${decision.id}`,
                                                                            id: `decisions.${decision.id}.${option.id}`,
                                                                            type: "radio",
                                                                            value: option.id,
                                                                            className: ""
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                            htmlFor: `decisions.${decision.id}.${option.id}`,
                                                                            children: option.text
                                                                        })
                                                                    ]
                                                                }, option.id))
                                                        })
                                                    ]
                                                }, index))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-footer",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "controls",
                                            children: [
                                                isSubmitting ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    type: "submit",
                                                    variant: "light-blue",
                                                    disabled: true,
                                                    children: "Running..."
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    type: "submit",
                                                    variant: "light-blue",
                                                    children: "Run"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    variant: "plain",
                                                    onClick: cancelAction,
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"38att","react":"llNeF","./MapSelectionSummary":"bexYm","../../utils/classNameMapper":"7tx4L","react-dom":"6sT93","../../components/Modal":"rhmf8","../../slices/apiSlice":"fcKYC","@reduxjs/toolkit/dist/query":"4lyQX","formik":"hIn7L","../../design/Button":"kEQbZ","ac1a643cbe8210be":"iUNvs","c267a904bbbe55c5":"h8t9E","78f3f19ee6912fa4":"aXGao","a6f46054fc7b9e8c":"kagyJ","b68d202eefd39375":"5sqc2","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"bexYm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapSelectionSummary", ()=>MapSelectionSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _apiSlice = require("../../slices/apiSlice");
const LayerSummary = ({ collection, selection })=>{
    const ids = Object.keys(selection);
    const { data: values } = (0, _apiSlice.useGetCollectionAggregatesQuery)({
        ID: collection.ID,
        ids
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                children: [
                    collection.name,
                    " (",
                    ids.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: (collection.aggregates || []).map((field)=>typeof field == "string" ? {
                            name: field,
                            column: field,
                            type: ""
                        } : field).map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                    children: [
                                        field.name,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    children: values && values[field.column]
                                })
                            ]
                        }, field.column))
                })
            })
        ]
    });
};
const MapSelectionSummary = ({ selectedFeatures, collections })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "selection-summary",
            children: collections.filter((c)=>c.tableName in selectedFeatures).map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerSummary, {
                    collection: c,
                    selection: selectedFeatures[c.tableName]
                }, c.ID))
        })
    });
};

},{"react/jsx-runtime":"38att","react":"llNeF","../../slices/apiSlice":"fcKYC","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"rhmf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>Modal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
const Modal = ({ isOpen: externalIsOpen, onClose, keyboard = true, children, id, className })=>{
    const [shouldAnimate, setShouldAnimate] = (0, _react.useState)(false);
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const modalRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (externalIsOpen) {
            setTimeout(()=>setShouldAnimate(true), 1);
            setIsOpen(true);
        } else {
            setShouldAnimate(false);
            if (modalRef && modalRef.current) modalRef.current.addEventListener("transitionend", ()=>setIsOpen(false));
        }
    }, [
        externalIsOpen
    ]);
    const escFunction = (0, _react.useCallback)((event)=>{
        if (event.key === "Escape") onClose();
    }, [
        onClose
    ]);
    (0, _react.useEffect)(()=>{
        if (keyboard) document.addEventListener("keydown", escFunction, false);
        return ()=>{
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isOpen && /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            onClick: (e)=>e.stopPropagation(),
            children: [
                " ",
                isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `fade modal-backdrop ${shouldAnimate ? "in" : ""}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `modal fade ${shouldAnimate ? "in" : ""} ${className ?? ""}`,
                    style: isOpen ? {
                        display: "block"
                    } : {},
                    ref: modalRef,
                    children: isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "modal-dialog",
                        id: id,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-content",
                            children: children
                        })
                    })
                })
            ]
        }), document.getElementById("page"))
    });
};

},{"react/jsx-runtime":"38att","react":"llNeF","react-dom":"6sT93","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4lyQX":[function(require,module,exports) {
"use strict";
module.exports = require("1c6794ba82f6d720");

},{"1c6794ba82f6d720":"phywe"}],"phywe":[function(require,module,exports) {
var global = arguments[3];
var e, t, n = this && this.__generator || function(e, t) {
    var n, r, i, a, u = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; u;)try {
                    if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;
                    switch(r = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return u.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            u.label++, r = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = u.ops.pop(), u.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = u.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                u = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                u.label = a[1];
                                break;
                            }
                            if (6 === a[0] && u.label < i[1]) {
                                u.label = i[1], i = a;
                                break;
                            }
                            if (i && u.label < i[2]) {
                                u.label = i[2], u.ops.push(a);
                                break;
                            }
                            i[2] && u.ops.pop(), u.trys.pop();
                            continue;
                    }
                    a = t.call(e, u);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}, r = this && this.__spreadArray || function(e, t) {
    for(var n = 0, r = t.length, i = e.length; n < r; n++, i++)e[i] = t[n];
    return e;
}, i = Object.create, a = Object.defineProperty, u = Object.defineProperties, o = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyDescriptors, c = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, d = Object.getPrototypeOf, f = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable, h = function(e, t, n) {
    return t in e ? a(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
}, v = function(e, t) {
    for(var n in t || (t = {}))f.call(t, n) && h(e, n, t[n]);
    if (l) for(var r = 0, i = l(t); r < i.length; r++)p.call(t, n = i[r]) && h(e, n, t[n]);
    return e;
}, y = function(e, t) {
    return u(e, s(t));
}, m = function(e) {
    return a(e, "__esModule", {
        value: !0
    });
}, g = function(e, t) {
    var n = {};
    for(var r in e)f.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && l) for(var i = 0, a = l(e); i < a.length; i++)t.indexOf(r = a[i]) < 0 && p.call(e, r) && (n[r] = e[r]);
    return n;
}, b = function(e) {
    return function(e, t, n) {
        if (t && "object" == typeof t || "function" == typeof t) for(var r = function(r) {
            f.call(e, r) || "default" === r || a(e, r, {
                get: function() {
                    return t[r];
                },
                enumerable: !(n = o(t, r)) || n.enumerable
            });
        }, i = 0, u = c(t); i < u.length; i++)r(u[i]);
        return e;
    }(m(a(null != e ? i(d(e)) : {}, "default", e && e.__esModule && "default" in e ? {
        get: function() {
            return e.default;
        },
        enumerable: !0
    } : {
        value: e,
        enumerable: !0
    })), e);
}, q = function(e, t, n) {
    return new Promise(function(r, i) {
        var a = function(e) {
            try {
                o(n.next(e));
            } catch (e) {
                i(e);
            }
        }, u = function(e) {
            try {
                o(n.throw(e));
            } catch (e) {
                i(e);
            }
        }, o = function(e) {
            return e.done ? r(e.value) : Promise.resolve(e.value).then(a, u);
        };
        o((n = n.apply(e, t)).next());
    });
};
m(exports), function(e, t) {
    for(var n in t)a(e, n, {
        get: t[n],
        enumerable: !0
    });
}(exports, {
    QueryStatus: function() {
        return e;
    },
    buildCreateApi: function() {
        return ge;
    },
    copyWithStructuralSharing: function() {
        return A;
    },
    coreModule: function() {
        return Ke;
    },
    coreModuleName: function() {
        return Ne;
    },
    createApi: function() {
        return Ee;
    },
    defaultSerializeQueryArgs: function() {
        return ve;
    },
    fakeBaseQuery: function() {
        return be;
    },
    fetchBaseQuery: function() {
        return x;
    },
    retry: function() {
        return I;
    },
    setupListeners: function() {
        return F;
    },
    skipSelector: function() {
        return ce;
    },
    skipToken: function() {
        return se;
    }
}), (t = e || (e = {})).uninitialized = "uninitialized", t.pending = "pending", t.fulfilled = "fulfilled", t.rejected = "rejected";
var S = function(e) {
    return [].concat.apply([], e);
}, O = b(require("62591fe60f98f4bd")).isPlainObject;
function A(e, t) {
    if (e === t || !(O(e) && O(t) || Array.isArray(e) && Array.isArray(t))) return t;
    for(var n = Object.keys(t), r = Object.keys(e), i = n.length === r.length, a = Array.isArray(t) ? [] : {}, u = 0, o = n; u < o.length; u++){
        var s = o[u];
        a[s] = A(e[s], t[s]), i && (i = e[s] === a[s]);
    }
    return i ? e : a;
}
var T = b(require("62591fe60f98f4bd")), R = function() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return fetch.apply(void 0, e);
}, j = function(e) {
    return e.status >= 200 && e.status <= 299;
}, w = function(e) {
    return /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "");
};
function k(e) {
    if (!(0, T.isPlainObject)(e)) return e;
    for(var t = v({}, e), n = 0, r = Object.entries(t); n < r.length; n++){
        var i = r[n];
        void 0 === i[1] && delete t[i[0]];
    }
    return t;
}
function x(e) {
    var t = this;
    void 0 === e && (e = {});
    var r = e.baseUrl, i = e.prepareHeaders, a = void 0 === i ? function(e) {
        return e;
    } : i, u = e.fetchFn, o = void 0 === u ? R : u, s = e.paramsSerializer, c = e.isJsonContentType, l = void 0 === c ? w : c, d = e.jsonContentType, f = void 0 === d ? "application/json" : d, p = e.jsonReplacer, h = e.timeout, m = e.responseHandler, b = e.validateStatus, S = g(e, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    return "undefined" == typeof fetch && o === R && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), function(e, i) {
        return q(t, null, function() {
            var t, u, c, d, q, A, R, w, x, P, Q, C, I, M, D, N, K, E, _, F, z, U, B, L, W, H, J, V, G, Y, $, X, Z, ee, te, ne;
            return n(this, function(n) {
                switch(n.label){
                    case 0:
                        return t = i.signal, u = i.getState, c = i.extra, d = i.endpoint, q = i.forced, A = i.type, x = (w = "string" == typeof e ? {
                            url: e
                        } : e).url, Q = void 0 === (P = w.headers) ? new Headers(S.headers) : P, I = void 0 === (C = w.params) ? void 0 : C, D = void 0 === (M = w.responseHandler) ? null != m ? m : "json" : M, K = void 0 === (N = w.validateStatus) ? null != b ? b : j : N, _ = void 0 === (E = w.timeout) ? h : E, F = g(w, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]), z = v(y(v({}, S), {
                            signal: t
                        }), F), Q = new Headers(k(Q)), U = z, [
                            4,
                            a(Q, {
                                getState: u,
                                extra: c,
                                endpoint: d,
                                forced: q,
                                type: A
                            })
                        ];
                    case 1:
                        U.headers = n.sent() || Q, B = function(e) {
                            return "object" == typeof e && ((0, T.isPlainObject)(e) || Array.isArray(e) || "function" == typeof e.toJSON);
                        }, !z.headers.has("content-type") && B(z.body) && z.headers.set("content-type", f), B(z.body) && l(z.headers) && (z.body = JSON.stringify(z.body, p)), I && (L = ~x.indexOf("?") ? "&" : "?", W = s ? s(I) : new URLSearchParams(k(I)), x += L + W), x = function(e, t) {
                            if (!e) return t;
                            if (!t) return e;
                            if (function(e) {
                                return new RegExp("(^|:)//").test(e);
                            }(t)) return t;
                            var n = e.endsWith("/") || !t.startsWith("?") ? "/" : "";
                            return e = function(e) {
                                return e.replace(/\/$/, "");
                            }(e), "" + e + n + function(e) {
                                return e.replace(/^\//, "");
                            }(t);
                        }(r, x), H = new Request(x, z), J = new Request(x, z), R = {
                            request: J
                        }, G = !1, Y = _ && setTimeout(function() {
                            G = !0, i.abort();
                        }, _), n.label = 2;
                    case 2:
                        return n.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]), [
                            4,
                            o(H)
                        ];
                    case 3:
                        return V = n.sent(), [
                            3,
                            6
                        ];
                    case 4:
                        return $ = n.sent(), [
                            2,
                            {
                                error: {
                                    status: G ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String($)
                                },
                                meta: R
                            }
                        ];
                    case 5:
                        return Y && clearTimeout(Y), [
                            7
                        ];
                    case 6:
                        X = V.clone(), R.response = X, ee = "", n.label = 7;
                    case 7:
                        return n.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]), [
                            4,
                            Promise.all([
                                O(V, D).then(function(e) {
                                    return Z = e;
                                }, function(e) {
                                    return te = e;
                                }),
                                X.text().then(function(e) {
                                    return ee = e;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        if (n.sent(), te) throw te;
                        return [
                            3,
                            10
                        ];
                    case 9:
                        return ne = n.sent(), [
                            2,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: V.status,
                                    data: ee,
                                    error: String(ne)
                                },
                                meta: R
                            }
                        ];
                    case 10:
                        return [
                            2,
                            K(V, Z) ? {
                                data: Z,
                                meta: R
                            } : {
                                error: {
                                    status: V.status,
                                    data: Z
                                },
                                meta: R
                            }
                        ];
                }
            });
        });
    };
    function O(e, t) {
        return q(this, null, function() {
            var r;
            return n(this, function(n) {
                switch(n.label){
                    case 0:
                        return "function" == typeof t ? [
                            2,
                            t(e)
                        ] : ("content-type" === t && (t = l(e.headers) ? "json" : "text"), "json" !== t ? [
                            3,
                            2
                        ] : [
                            4,
                            e.text()
                        ]);
                    case 1:
                        return [
                            2,
                            (r = n.sent()).length ? JSON.parse(r) : null
                        ];
                    case 2:
                        return [
                            2,
                            e.text()
                        ];
                }
            });
        });
    }
}
var P = function(e, t) {
    void 0 === t && (t = void 0), this.value = e, this.meta = t;
};
function Q(e, t) {
    return void 0 === e && (e = 0), void 0 === t && (t = 5), q(this, null, function() {
        var r, i;
        return n(this, function(n) {
            switch(n.label){
                case 0:
                    return r = Math.min(e, t), i = ~~((Math.random() + .4) * (300 << r)), [
                        4,
                        new Promise(function(e) {
                            return setTimeout(function(t) {
                                return e(t);
                            }, i);
                        })
                    ];
                case 1:
                    return n.sent(), [
                        2
                    ];
            }
        });
    });
}
var C = {}, I = Object.assign(function(e, t) {
    return function(r, i, a) {
        return q(void 0, null, function() {
            var u, o, s, c, l, d, f;
            return n(this, function(n) {
                switch(n.label){
                    case 0:
                        u = [
                            5,
                            (t || C).maxRetries,
                            (a || C).maxRetries
                        ].filter(function(e) {
                            return void 0 !== e;
                        }), o = u.slice(-1)[0], s = function(e, t, n) {
                            return n.attempt <= o;
                        }, c = v(v({
                            maxRetries: o,
                            backoff: Q,
                            retryCondition: s
                        }, t), a), l = 0, n.label = 1;
                    case 1:
                        n.label = 2;
                    case 2:
                        return n.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]), [
                            4,
                            e(r, i, a)
                        ];
                    case 3:
                        if ((d = n.sent()).error) throw new P(d);
                        return [
                            2,
                            d
                        ];
                    case 4:
                        if (f = n.sent(), l++, f.throwImmediately) {
                            if (f instanceof P) return [
                                2,
                                f.value
                            ];
                            throw f;
                        }
                        return f instanceof P && !c.retryCondition(f.value.error, r, {
                            attempt: l,
                            baseQueryApi: i,
                            extraOptions: a
                        }) ? [
                            2,
                            f.value
                        ] : [
                            4,
                            c.backoff(l, c.maxRetries)
                        ];
                    case 5:
                        return n.sent(), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    };
}, {
    fail: function(e) {
        throw Object.assign(new P({
            error: e
        }), {
            throwImmediately: !0
        });
    }
}), M = b(require("62591fe60f98f4bd")), D = (0, M.createAction)("__rtkq/focused"), N = (0, M.createAction)("__rtkq/unfocused"), K = (0, M.createAction)("__rtkq/online"), E = (0, M.createAction)("__rtkq/offline"), _ = !1;
function F(e, t) {
    var n, r, i, a;
    return t ? t(e, {
        onFocus: D,
        onFocusLost: N,
        onOffline: E,
        onOnline: K
    }) : (n = function() {
        return e(D());
    }, r = function() {
        return e(K());
    }, i = function() {
        return e(E());
    }, a = function() {
        "visible" === window.document.visibilityState ? n() : e(N());
    }, _ || "undefined" != typeof window && window.addEventListener && (window.addEventListener("visibilitychange", a, !1), window.addEventListener("focus", n, !1), window.addEventListener("online", r, !1), window.addEventListener("offline", i, !1), _ = !0), function() {
        window.removeEventListener("focus", n), window.removeEventListener("visibilitychange", a), window.removeEventListener("online", r), window.removeEventListener("offline", i), _ = !1;
    });
}
var z, U, B = b(require("62591fe60f98f4bd"));
function L(e) {
    return e.type === z.query;
}
function W(e, t, n, r, i, a) {
    return "function" == typeof e ? e(t, n, r, i).map(H).map(a) : Array.isArray(e) ? e.map(H).map(a) : [];
}
function H(e) {
    return "string" == typeof e ? {
        type: e
    } : e;
}
(U = z || (z = {})).query = "query", U.mutation = "mutation";
var J = b(require("62591fe60f98f4bd"));
function V(e) {
    return null != e;
}
var G = Symbol("forceQueryFn"), Y = function(e) {
    return "function" == typeof e[G];
}, $ = b(require("62591fe60f98f4bd")), X = b(require("4555dd63c97c6461")), Z = b(require("62591fe60f98f4bd"));
function ee(e) {
    return e;
}
function te(e, t, n, r) {
    return W(n[e.meta.arg.endpointName][t], (0, $.isFulfilled)(e) ? e.payload : void 0, (0, $.isRejectedWithValue)(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, r);
}
var ne = b(require("4555dd63c97c6461")), re = b(require("4555dd63c97c6461"));
function ie(e, t, n) {
    var r = e[t];
    r && n(r);
}
function ae(e) {
    var t;
    return null != (t = "arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) ? t : e.requestId;
}
function ue(e, t, n) {
    var r = e[ae(t)];
    r && n(r);
}
var oe = {}, se = Symbol.for("RTKQ/skipToken"), ce = se, le = {
    status: e.uninitialized
}, de = (0, B.createNextState)(le, function() {}), fe = (0, B.createNextState)(le, function() {}), pe = b(require("62591fe60f98f4bd")), he = WeakMap ? new WeakMap : void 0, ve = function(e) {
    var t = e.endpointName, n = e.queryArgs, r = "", i = null == he ? void 0 : he.get(n);
    if ("string" == typeof i) r = i;
    else {
        var a = JSON.stringify(n, function(e, t) {
            return (0, pe.isPlainObject)(t) ? Object.keys(t).sort().reduce(function(e, n) {
                return e[n] = t[n], e;
            }, {}) : t;
        });
        (0, pe.isPlainObject)(n) && (null == he || he.set(n, a)), r = a;
    }
    return t + "(" + r + ")";
}, ye = b(require("62591fe60f98f4bd")), me = b(require("1077e1aea010c932"));
function ge() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return function(t) {
        var n = (0, me.defaultMemoize)(function(e) {
            var n, r;
            return null == (r = t.extractRehydrationInfo) ? void 0 : r.call(t, e, {
                reducerPath: null != (n = t.reducerPath) ? n : "api"
            });
        }), i = y(v({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: !1,
            refetchOnFocus: !1,
            refetchOnReconnect: !1
        }, t), {
            extractRehydrationInfo: n,
            serializeQueryArgs: function(e) {
                var n = ve;
                if ("serializeQueryArgs" in e.endpointDefinition) {
                    var r = e.endpointDefinition.serializeQueryArgs;
                    n = function(e) {
                        var t = r(e);
                        return "string" == typeof t ? t : ve(y(v({}, e), {
                            queryArgs: t
                        }));
                    };
                } else t.serializeQueryArgs && (n = t.serializeQueryArgs);
                return n(e);
            },
            tagTypes: r([], t.tagTypes || [])
        }), a = {
            endpointDefinitions: {},
            batch: function(e) {
                e();
            },
            apiUid: (0, ye.nanoid)(),
            extractRehydrationInfo: n,
            hasRehydrationInfo: (0, me.defaultMemoize)(function(e) {
                return null != n(e);
            })
        }, u = {
            injectEndpoints: function(e) {
                for(var t = e.endpoints({
                    query: function(e) {
                        return y(v({}, e), {
                            type: z.query
                        });
                    },
                    mutation: function(e) {
                        return y(v({}, e), {
                            type: z.mutation
                        });
                    }
                }), n = 0, r = Object.entries(t); n < r.length; n++){
                    var i = r[n], s = i[0], c = i[1];
                    if (e.overrideExisting || !(s in a.endpointDefinitions)) {
                        a.endpointDefinitions[s] = c;
                        for(var l = 0, d = o; l < d.length; l++)d[l].injectEndpoint(s, c);
                    }
                }
                return u;
            },
            enhanceEndpoints: function(e) {
                var t = e.addTagTypes, n = e.endpoints;
                if (t) for(var r = 0, o = t; r < o.length; r++){
                    var s = o[r];
                    i.tagTypes.includes(s) || i.tagTypes.push(s);
                }
                if (n) for(var c = 0, l = Object.entries(n); c < l.length; c++){
                    var d = l[c], f = d[0], p = d[1];
                    "function" == typeof p ? p(a.endpointDefinitions[f]) : Object.assign(a.endpointDefinitions[f] || {}, p);
                }
                return u;
            }
        }, o = e.map(function(e) {
            return e.init(u, i, a);
        });
        return u.injectEndpoints({
            endpoints: t.endpoints
        });
    };
}
function be() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
var qe, Se = b(require("62591fe60f98f4bd")), Oe = function(e) {
    var t = e.reducerPath, n = e.api, r = e.context, i = e.internalState, a = n.internalActions, u = a.removeQueryResult, o = a.unsubscribeQueryResult;
    function s(e) {
        var t = i.currentSubscriptions[e];
        return !!t && !function(e) {
            for(var t in e)return !1;
            return !0;
        }(t);
    }
    var c = {};
    function l(e, t, n, i) {
        var a, o = r.endpointDefinitions[t], l = null != (a = null == o ? void 0 : o.keepUnusedDataFor) ? a : i.keepUnusedDataFor;
        if (Infinity !== l) {
            var d = Math.max(0, Math.min(l, 2147482.647));
            if (!s(e)) {
                var f = c[e];
                f && clearTimeout(f), c[e] = setTimeout(function() {
                    s(e) || n.dispatch(u({
                        queryCacheKey: e
                    })), delete c[e];
                }, 1e3 * d);
            }
        }
    }
    return function(e, i, a) {
        var u;
        if (o.match(e)) {
            var s = i.getState()[t];
            l(b = e.payload.queryCacheKey, null == (u = s.queries[b]) ? void 0 : u.endpointName, i, s.config);
        }
        if (n.util.resetApiState.match(e)) for(var d = 0, f = Object.entries(c); d < f.length; d++){
            var p = f[d], h = p[0], v = p[1];
            v && clearTimeout(v), delete c[h];
        }
        if (r.hasRehydrationInfo(e)) {
            s = i.getState()[t];
            for(var y = r.extractRehydrationInfo(e).queries, m = 0, g = Object.entries(y); m < g.length; m++){
                var b, q = g[m], S = q[1];
                l(b = q[0], null == S ? void 0 : S.endpointName, i, s.config);
            }
        }
    };
}, Ae = b(require("62591fe60f98f4bd")), Te = function(t) {
    var n = t.reducerPath, r = t.context, i = t.context.endpointDefinitions, a = t.mutationThunk, u = t.api, o = t.assertTagType, s = t.refetchQuery, c = u.internalActions.removeQueryResult, l = (0, Ae.isAnyOf)((0, Ae.isFulfilled)(a), (0, Ae.isRejectedWithValue)(a));
    function d(t, i) {
        var a = i.getState(), o = a[n], l = u.util.selectInvalidatedBy(a, t);
        r.batch(function() {
            for(var t, n = 0, r = Array.from(l.values()); n < r.length; n++){
                var a = r[n].queryCacheKey, u = o.queries[a], d = null != (t = o.subscriptions[a]) ? t : {};
                u && (0 === Object.keys(d).length ? i.dispatch(c({
                    queryCacheKey: a
                })) : u.status !== e.uninitialized && i.dispatch(s(u, a)));
            }
        });
    }
    return function(e, t) {
        l(e) && d(te(e, "invalidatesTags", i, o), t), u.util.invalidateTags.match(e) && d(W(e.payload, void 0, void 0, void 0, void 0, o), t);
    };
}, Re = function(t) {
    var n = t.reducerPath, r = t.queryThunk, i = t.api, a = t.refetchQuery, u = t.internalState, o = {};
    function s(t, r) {
        var i = t.queryCacheKey, s = r.getState()[n].queries[i];
        if (s && s.status !== e.uninitialized) {
            var c = d(u.currentSubscriptions[i]);
            if (Number.isFinite(c)) {
                var l = o[i];
                (null == l ? void 0 : l.timeout) && (clearTimeout(l.timeout), l.timeout = void 0);
                var f = Date.now() + c, p = o[i] = {
                    nextPollTimestamp: f,
                    pollingInterval: c,
                    timeout: setTimeout(function() {
                        p.timeout = void 0, r.dispatch(a(s, i));
                    }, c)
                };
            }
        }
    }
    function c(t, r) {
        var i = t.queryCacheKey, a = r.getState()[n].queries[i];
        if (a && a.status !== e.uninitialized) {
            var c = d(u.currentSubscriptions[i]);
            if (Number.isFinite(c)) {
                var f = o[i], p = Date.now() + c;
                (!f || p < f.nextPollTimestamp) && s({
                    queryCacheKey: i
                }, r);
            } else l(i);
        }
    }
    function l(e) {
        var t = o[e];
        (null == t ? void 0 : t.timeout) && clearTimeout(t.timeout), delete o[e];
    }
    function d(e) {
        void 0 === e && (e = {});
        var t = Number.POSITIVE_INFINITY;
        for(var n in e)e[n].pollingInterval && (t = Math.min(e[n].pollingInterval, t));
        return t;
    }
    return function(e, t) {
        (i.internalActions.updateSubscriptionOptions.match(e) || i.internalActions.unsubscribeQueryResult.match(e)) && c(e.payload, t), (r.pending.match(e) || r.rejected.match(e) && e.meta.condition) && c(e.meta.arg, t), (r.fulfilled.match(e) || r.rejected.match(e) && !e.meta.condition) && s(e.meta.arg, t), i.util.resetApiState.match(e) && function() {
            for(var e = 0, t = Object.keys(o); e < t.length; e++)l(t[e]);
        }();
    };
}, je = b(require("62591fe60f98f4bd")), we = new Error("Promise never resolved before cacheEntryRemoved."), ke = function(e) {
    var t = e.api, n = e.reducerPath, r = e.context, i = e.queryThunk, a = e.mutationThunk, u = (0, je.isAsyncThunkAction)(i), o = (0, je.isAsyncThunkAction)(a), s = (0, je.isFulfilled)(i, a), c = {};
    function l(e, n, i, a, u) {
        var o = r.endpointDefinitions[e], s = null == o ? void 0 : o.onCacheEntryAdded;
        if (s) {
            var l = {}, d = new Promise(function(e) {
                l.cacheEntryRemoved = e;
            }), f = Promise.race([
                new Promise(function(e) {
                    l.valueResolved = e;
                }),
                d.then(function() {
                    throw we;
                })
            ]);
            f.catch(function() {}), c[i] = l;
            var p = t.endpoints[e].select(o.type === z.query ? n : i), h = a.dispatch(function(e, t, n) {
                return n;
            }), m = y(v({}, a), {
                getCacheEntry: function() {
                    return p(a.getState());
                },
                requestId: u,
                extra: h,
                updateCachedData: o.type === z.query ? function(r) {
                    return a.dispatch(t.util.updateQueryData(e, n, r));
                } : void 0,
                cacheDataLoaded: f,
                cacheEntryRemoved: d
            }), g = s(n, m);
            Promise.resolve(g).catch(function(e) {
                if (e !== we) throw e;
            });
        }
    }
    return function(e, r, d) {
        var f = function(e) {
            return u(e) ? e.meta.arg.queryCacheKey : o(e) ? e.meta.requestId : t.internalActions.removeQueryResult.match(e) ? e.payload.queryCacheKey : t.internalActions.removeMutationResult.match(e) ? ae(e.payload) : "";
        }(e);
        if (i.pending.match(e)) {
            var p = d[n].queries[f], h = r.getState()[n].queries[f];
            !p && h && l(e.meta.arg.endpointName, e.meta.arg.originalArgs, f, r, e.meta.requestId);
        } else if (a.pending.match(e)) (h = r.getState()[n].mutations[f]) && l(e.meta.arg.endpointName, e.meta.arg.originalArgs, f, r, e.meta.requestId);
        else if (s(e)) (null == (g = c[f]) ? void 0 : g.valueResolved) && (g.valueResolved({
            data: e.payload,
            meta: e.meta.baseQueryMeta
        }), delete g.valueResolved);
        else if (t.internalActions.removeQueryResult.match(e) || t.internalActions.removeMutationResult.match(e)) (g = c[f]) && (delete c[f], g.cacheEntryRemoved());
        else if (t.util.resetApiState.match(e)) for(var v = 0, y = Object.entries(c); v < y.length; v++){
            var m = y[v], g = m[1];
            delete c[m[0]], g.cacheEntryRemoved();
        }
    };
}, xe = b(require("62591fe60f98f4bd")), Pe = function(e) {
    var t = e.api, n = e.context, r = e.queryThunk, i = e.mutationThunk, a = (0, xe.isPending)(r, i), u = (0, xe.isRejected)(r, i), o = (0, xe.isFulfilled)(r, i), s = {};
    return function(e, r) {
        var i, c, l;
        if (a(e)) {
            var d = e.meta, f = d.requestId, p = d.arg, h = p.endpointName, m = p.originalArgs, g = n.endpointDefinitions[h], b = null == g ? void 0 : g.onQueryStarted;
            if (b) {
                var q = {}, S = new Promise(function(e, t) {
                    q.resolve = e, q.reject = t;
                });
                S.catch(function() {}), s[f] = q;
                var O = t.endpoints[h].select(g.type === z.query ? m : f), A = r.dispatch(function(e, t, n) {
                    return n;
                }), T = y(v({}, r), {
                    getCacheEntry: function() {
                        return O(r.getState());
                    },
                    requestId: f,
                    extra: A,
                    updateCachedData: g.type === z.query ? function(e) {
                        return r.dispatch(t.util.updateQueryData(h, m, e));
                    } : void 0,
                    queryFulfilled: S
                });
                b(m, T);
            }
        } else if (o(e)) {
            var R = e.meta, j = R.baseQueryMeta;
            null == (i = s[f = R.requestId]) || i.resolve({
                data: e.payload,
                meta: j
            }), delete s[f];
        } else if (u(e)) {
            var w = e.meta;
            j = w.baseQueryMeta, null == (l = s[f = w.requestId]) || l.reject({
                error: null != (c = e.payload) ? c : e.error,
                isUnhandledError: !w.rejectedWithValue,
                meta: j
            }), delete s[f];
        }
    };
}, Qe = function(e) {
    var t = e.api, n = e.context.apiUid;
    return function(e, r) {
        t.util.resetApiState.match(e) && r.dispatch(t.internalActions.middlewareRegistered(n));
    };
}, Ce = b(require("4555dd63c97c6461")), Ie = "function" == typeof queueMicrotask ? queueMicrotask.bind("undefined" != typeof window ? window : "undefined" != typeof global ? global : globalThis) : function(e) {
    return (qe || (qe = Promise.resolve())).then(e).catch(function(e) {
        return setTimeout(function() {
            throw e;
        }, 0);
    });
};
function Me(e) {
    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
    Object.assign.apply(Object, r([
        e
    ], t));
}
var De = b(require("4555dd63c97c6461")), Ne = Symbol(), Ke = function() {
    return {
        name: Ne,
        init: function(t, i, a) {
            var u = i.baseQuery, o = i.reducerPath, s = i.serializeQueryArgs, c = i.keepUnusedDataFor, l = i.refetchOnMountOrArgChange, d = i.refetchOnFocus, f = i.refetchOnReconnect;
            (0, De.enablePatches)();
            var p = function(e) {
                return e;
            };
            Object.assign(t, {
                reducerPath: o,
                endpoints: {},
                internalActions: {
                    onOnline: K,
                    onOffline: E,
                    onFocus: D,
                    onFocusLost: N
                },
                util: {}
            });
            var h = function(t) {
                var r = this, i = t.reducerPath, a = t.baseQuery, u = t.context.endpointDefinitions, o = t.serializeQueryArgs, s = t.api, c = t.assertTagType, l = function(e, t) {
                    return q(r, [
                        e,
                        t
                    ], function(e, t) {
                        var r, i, o, s, c, l, f, p, h, v, y, m, g, b = t.signal, q = t.abort, S = t.rejectWithValue, O = t.fulfillWithValue, A = t.dispatch, T = t.getState, R = t.extra;
                        return n(this, function(t) {
                            switch(t.label){
                                case 0:
                                    r = u[e.endpointName], t.label = 1;
                                case 1:
                                    return t.trys.push([
                                        1,
                                        8,
                                        ,
                                        13
                                    ]), i = ee, o = void 0, s = {
                                        signal: b,
                                        abort: q,
                                        dispatch: A,
                                        getState: T,
                                        extra: R,
                                        endpoint: e.endpointName,
                                        type: e.type,
                                        forced: "query" === e.type ? d(e, T()) : void 0
                                    }, (c = "query" === e.type ? e[G] : void 0) ? (o = c(), [
                                        3,
                                        6
                                    ]) : [
                                        3,
                                        2
                                    ];
                                case 2:
                                    return r.query ? [
                                        4,
                                        a(r.query(e.originalArgs), s, r.extraOptions)
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return o = t.sent(), r.transformResponse && (i = r.transformResponse), [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        r.queryFn(e.originalArgs, s, r.extraOptions, function(e) {
                                            return a(e, s, r.extraOptions);
                                        })
                                    ];
                                case 5:
                                    o = t.sent(), t.label = 6;
                                case 6:
                                    if (o.error) throw new P(o.error, o.meta);
                                    return l = O, [
                                        4,
                                        i(o.data, o.meta, e.originalArgs)
                                    ];
                                case 7:
                                    return [
                                        2,
                                        l.apply(void 0, [
                                            t.sent(),
                                            (m = {
                                                fulfilledTimeStamp: Date.now(),
                                                baseQueryMeta: o.meta
                                            }, m[Z.SHOULD_AUTOBATCH] = !0, m)
                                        ])
                                    ];
                                case 8:
                                    if (f = t.sent(), !((p = f) instanceof P)) return [
                                        3,
                                        12
                                    ];
                                    h = ee, r.query && r.transformErrorResponse && (h = r.transformErrorResponse), t.label = 9;
                                case 9:
                                    return t.trys.push([
                                        9,
                                        11,
                                        ,
                                        12
                                    ]), v = S, [
                                        4,
                                        h(p.value, p.meta, e.originalArgs)
                                    ];
                                case 10:
                                    return [
                                        2,
                                        v.apply(void 0, [
                                            t.sent(),
                                            (g = {
                                                baseQueryMeta: p.meta
                                            }, g[Z.SHOULD_AUTOBATCH] = !0, g)
                                        ])
                                    ];
                                case 11:
                                    return y = t.sent(), p = y, [
                                        3,
                                        12
                                    ];
                                case 12:
                                    throw console.error(p), p;
                                case 13:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
                function d(e, t) {
                    var n, r, a, u, o = null == (r = null == (n = t[i]) ? void 0 : n.queries) ? void 0 : r[e.queryCacheKey], s = null == (a = t[i]) ? void 0 : a.config.refetchOnMountOrArgChange, c = null == o ? void 0 : o.fulfilledTimeStamp, l = null != (u = e.forceRefetch) ? u : e.subscribe && s;
                    return !!l && (!0 === l || (Number(new Date) - Number(c)) / 1e3 >= l);
                }
                var f = (0, Z.createAsyncThunk)(i + "/executeQuery", l, {
                    getPendingMeta: function() {
                        var e;
                        return (e = {
                            startedTimeStamp: Date.now()
                        })[Z.SHOULD_AUTOBATCH] = !0, e;
                    },
                    condition: function(e, t) {
                        var n, r, a, o = (0, t.getState)(), s = null == (r = null == (n = o[i]) ? void 0 : n.queries) ? void 0 : r[e.queryCacheKey], c = null == s ? void 0 : s.fulfilledTimeStamp, l = e.originalArgs, f = null == s ? void 0 : s.originalArgs, p = u[e.endpointName];
                        return !(!Y(e) && ("pending" === (null == s ? void 0 : s.status) || !d(e, o) && (!L(p) || !(null == (a = null == p ? void 0 : p.forceRefetch) ? void 0 : a.call(p, {
                            currentArg: l,
                            previousArg: f,
                            endpointState: s,
                            state: o
                        }))) && c));
                    },
                    dispatchConditionRejection: !0
                }), p = (0, Z.createAsyncThunk)(i + "/executeMutation", l, {
                    getPendingMeta: function() {
                        var e;
                        return (e = {
                            startedTimeStamp: Date.now()
                        })[Z.SHOULD_AUTOBATCH] = !0, e;
                    }
                });
                function h(e) {
                    return function(t) {
                        var n, r;
                        return (null == (r = null == (n = null == t ? void 0 : t.meta) ? void 0 : n.arg) ? void 0 : r.endpointName) === e;
                    };
                }
                return {
                    queryThunk: f,
                    mutationThunk: p,
                    prefetch: function(e, t, n) {
                        return function(r, i) {
                            var a = function(e) {
                                return "force" in e;
                            }(n) && n.force, u = function(e) {
                                return "ifOlderThan" in e;
                            }(n) && n.ifOlderThan, o = function(n) {
                                return void 0 === n && (n = !0), s.endpoints[e].initiate(t, {
                                    forceRefetch: n
                                });
                            }, c = s.endpoints[e].select(t)(i());
                            if (a) r(o());
                            else if (u) {
                                var l = null == c ? void 0 : c.fulfilledTimeStamp;
                                if (!l) return void r(o());
                                (Number(new Date) - Number(new Date(l))) / 1e3 >= u && r(o());
                            } else r(o(!1));
                        };
                    },
                    updateQueryData: function(t, n, r, i) {
                        return void 0 === i && (i = !0), function(a, u) {
                            var o, c, l, d = s.endpoints[t].select(n)(u()), f = {
                                patches: [],
                                inversePatches: [],
                                undo: function() {
                                    return a(s.util.patchQueryData(t, n, f.inversePatches, i));
                                }
                            };
                            if (d.status === e.uninitialized) return f;
                            if ("data" in d) {
                                if ((0, X.isDraftable)(d.data)) {
                                    var p = (0, X.produceWithPatches)(d.data, r), h = p[0], v = p[2];
                                    (o = f.patches).push.apply(o, p[1]), (c = f.inversePatches).push.apply(c, v), l = h;
                                } else l = r(d.data), f.patches.push({
                                    op: "replace",
                                    path: [],
                                    value: l
                                }), f.inversePatches.push({
                                    op: "replace",
                                    path: [],
                                    value: d.data
                                });
                            }
                            return a(s.util.patchQueryData(t, n, f.patches, i)), f;
                        };
                    },
                    upsertQueryData: function(e, t, n) {
                        return function(r) {
                            var i;
                            return r(s.endpoints[e].initiate(t, ((i = {
                                subscribe: !1,
                                forceRefetch: !0
                            })[G] = function() {
                                return {
                                    data: n
                                };
                            }, i)));
                        };
                    },
                    patchQueryData: function(e, t, n, r) {
                        return function(i, a) {
                            var l = u[e], d = o({
                                queryArgs: t,
                                endpointDefinition: l,
                                endpointName: e
                            });
                            if (i(s.internalActions.queryResultPatched({
                                queryCacheKey: d,
                                patches: n
                            })), r) {
                                var f = s.endpoints[e].select(t)(a()), p = W(l.providesTags, f.data, void 0, t, {}, c);
                                i(s.internalActions.updateProvidedBy({
                                    queryCacheKey: d,
                                    providedTags: p
                                }));
                            }
                        };
                    },
                    buildMatchThunkActions: function(e, t) {
                        return {
                            matchPending: (0, $.isAllOf)((0, $.isPending)(e), h(t)),
                            matchFulfilled: (0, $.isAllOf)((0, $.isFulfilled)(e), h(t)),
                            matchRejected: (0, $.isAllOf)((0, $.isRejected)(e), h(t))
                        };
                    }
                };
            }({
                baseQuery: u,
                reducerPath: o,
                context: a,
                api: t,
                serializeQueryArgs: s,
                assertTagType: p
            }), m = h.queryThunk, g = h.mutationThunk, b = h.patchQueryData, O = h.updateQueryData, T = h.upsertQueryData, R = h.prefetch, j = h.buildMatchThunkActions, w = function(t) {
                var n = t.reducerPath, r = t.queryThunk, i = t.mutationThunk, a = t.context, u = a.endpointDefinitions, o = a.apiUid, s = a.extractRehydrationInfo, c = a.hasRehydrationInfo, l = t.assertTagType, d = t.config, f = (0, J.createAction)(n + "/resetApiState"), p = (0, J.createSlice)({
                    name: n + "/queries",
                    initialState: oe,
                    reducers: {
                        removeQueryResult: {
                            reducer: function(e, t) {
                                delete e[t.payload.queryCacheKey];
                            },
                            prepare: (0, J.prepareAutoBatched)()
                        },
                        queryResultPatched: {
                            reducer: function(e, t) {
                                var n = t.payload, r = n.patches;
                                ie(e, n.queryCacheKey, function(e) {
                                    e.data = (0, re.applyPatches)(e.data, r.concat());
                                });
                            },
                            prepare: (0, J.prepareAutoBatched)()
                        }
                    },
                    extraReducers: function(t) {
                        t.addCase(r.pending, function(t, n) {
                            var r, i = n.meta, a = n.meta.arg, u = Y(a);
                            (a.subscribe || u) && (null != t[r = a.queryCacheKey] || (t[r] = {
                                status: e.uninitialized,
                                endpointName: a.endpointName
                            })), ie(t, a.queryCacheKey, function(t) {
                                t.status = e.pending, t.requestId = u && t.requestId ? t.requestId : i.requestId, void 0 !== a.originalArgs && (t.originalArgs = a.originalArgs), t.startedTimeStamp = i.startedTimeStamp;
                            });
                        }).addCase(r.fulfilled, function(t, n) {
                            var r = n.meta, i = n.payload;
                            ie(t, r.arg.queryCacheKey, function(t) {
                                var n;
                                if (t.requestId === r.requestId || Y(r.arg)) {
                                    var a = u[r.arg.endpointName].merge;
                                    if (t.status = e.fulfilled, a) {
                                        if (void 0 !== t.data) {
                                            var o = r.fulfilledTimeStamp, s = r.arg, c = r.baseQueryMeta, l = r.requestId, d = (0, J.createNextState)(t.data, function(e) {
                                                return a(e, i, {
                                                    arg: s.originalArgs,
                                                    baseQueryMeta: c,
                                                    fulfilledTimeStamp: o,
                                                    requestId: l
                                                });
                                            });
                                            t.data = d;
                                        } else t.data = i;
                                    } else t.data = null == (n = u[r.arg.endpointName].structuralSharing) || n ? A((0, ne.isDraft)(t.data) ? (0, re.original)(t.data) : t.data, i) : i;
                                    delete t.error, t.fulfilledTimeStamp = r.fulfilledTimeStamp;
                                }
                            });
                        }).addCase(r.rejected, function(t, n) {
                            var r = n.meta, i = r.condition, a = r.requestId, u = n.error, o = n.payload;
                            ie(t, r.arg.queryCacheKey, function(t) {
                                if (i) ;
                                else {
                                    if (t.requestId !== a) return;
                                    t.status = e.rejected, t.error = null != o ? o : u;
                                }
                            });
                        }).addMatcher(c, function(t, n) {
                            for(var r = s(n).queries, i = 0, a = Object.entries(r); i < a.length; i++){
                                var u = a[i], o = u[1];
                                (null == o ? void 0 : o.status) !== e.fulfilled && (null == o ? void 0 : o.status) !== e.rejected || (t[u[0]] = o);
                            }
                        });
                    }
                }), h = (0, J.createSlice)({
                    name: n + "/mutations",
                    initialState: oe,
                    reducers: {
                        removeMutationResult: {
                            reducer: function(e, t) {
                                var n = ae(t.payload);
                                n in e && delete e[n];
                            },
                            prepare: (0, J.prepareAutoBatched)()
                        }
                    },
                    extraReducers: function(t) {
                        t.addCase(i.pending, function(t, n) {
                            var r = n.meta, i = r.requestId, a = r.arg, u = r.startedTimeStamp;
                            a.track && (t[ae(n.meta)] = {
                                requestId: i,
                                status: e.pending,
                                endpointName: a.endpointName,
                                startedTimeStamp: u
                            });
                        }).addCase(i.fulfilled, function(t, n) {
                            var r = n.payload, i = n.meta;
                            i.arg.track && ue(t, i, function(t) {
                                t.requestId === i.requestId && (t.status = e.fulfilled, t.data = r, t.fulfilledTimeStamp = i.fulfilledTimeStamp);
                            });
                        }).addCase(i.rejected, function(t, n) {
                            var r = n.payload, i = n.error, a = n.meta;
                            a.arg.track && ue(t, a, function(t) {
                                t.requestId === a.requestId && (t.status = e.rejected, t.error = null != r ? r : i);
                            });
                        }).addMatcher(c, function(t, n) {
                            for(var r = s(n).mutations, i = 0, a = Object.entries(r); i < a.length; i++){
                                var u = a[i], o = u[0], c = u[1];
                                (null == c ? void 0 : c.status) !== e.fulfilled && (null == c ? void 0 : c.status) !== e.rejected || o === (null == c ? void 0 : c.requestId) || (t[o] = c);
                            }
                        });
                    }
                }), m = (0, J.createSlice)({
                    name: n + "/invalidation",
                    initialState: oe,
                    reducers: {
                        updateProvidedBy: {
                            reducer: function(e, t) {
                                for(var n, r, i, a, u = t.payload, o = u.queryCacheKey, s = u.providedTags, c = 0, l = Object.values(e); c < l.length; c++)for(var d = 0, f = Object.values(l[c]); d < f.length; d++){
                                    var p = f[d], h = p.indexOf(o);
                                    -1 !== h && p.splice(h, 1);
                                }
                                for(var v = 0, y = s; v < y.length; v++){
                                    var m = y[v], g = m.type, b = m.id, q = null != (a = (r = null != (n = e[g]) ? n : e[g] = {})[i = b || "__internal_without_id"]) ? a : r[i] = [];
                                    q.includes(o) || q.push(o);
                                }
                            },
                            prepare: (0, J.prepareAutoBatched)()
                        }
                    },
                    extraReducers: function(e) {
                        e.addCase(p.actions.removeQueryResult, function(e, t) {
                            for(var n = t.payload.queryCacheKey, r = 0, i = Object.values(e); r < i.length; r++)for(var a = 0, u = Object.values(i[r]); a < u.length; a++){
                                var o = u[a], s = o.indexOf(n);
                                -1 !== s && o.splice(s, 1);
                            }
                        }).addMatcher(c, function(e, t) {
                            for(var n, r, i, a, u = s(t).provided, o = 0, c = Object.entries(u); o < c.length; o++)for(var l = c[o], d = l[0], f = 0, p = Object.entries(l[1]); f < p.length; f++)for(var h = p[f], v = h[0], y = h[1], m = null != (a = (r = null != (n = e[d]) ? n : e[d] = {})[i = v || "__internal_without_id"]) ? a : r[i] = [], g = 0, b = y; g < b.length; g++){
                                var q = b[g];
                                m.includes(q) || m.push(q);
                            }
                        }).addMatcher((0, J.isAnyOf)((0, J.isFulfilled)(r), (0, J.isRejectedWithValue)(r)), function(e, t) {
                            var n = te(t, "providesTags", u, l);
                            m.caseReducers.updateProvidedBy(e, m.actions.updateProvidedBy({
                                queryCacheKey: t.meta.arg.queryCacheKey,
                                providedTags: n
                            }));
                        });
                    }
                }), g = (0, J.createSlice)({
                    name: n + "/subscriptions",
                    initialState: oe,
                    reducers: {
                        updateSubscriptionOptions: function(e, t) {},
                        unsubscribeQueryResult: function(e, t) {},
                        internal_probeSubscription: function(e, t) {}
                    }
                }), b = (0, J.createSlice)({
                    name: n + "/internalSubscriptions",
                    initialState: oe,
                    reducers: {
                        subscriptionsUpdated: {
                            reducer: function(e, t) {
                                return (0, re.applyPatches)(e, t.payload);
                            },
                            prepare: (0, J.prepareAutoBatched)()
                        }
                    }
                }), q = (0, J.createSlice)({
                    name: n + "/config",
                    initialState: v({
                        online: "undefined" == typeof navigator || void 0 === navigator.onLine || navigator.onLine,
                        focused: "undefined" == typeof document || "hidden" !== document.visibilityState,
                        middlewareRegistered: !1
                    }, d),
                    reducers: {
                        middlewareRegistered: function(e, t) {
                            e.middlewareRegistered = "conflict" !== e.middlewareRegistered && o === t.payload || "conflict";
                        }
                    },
                    extraReducers: function(e) {
                        e.addCase(K, function(e) {
                            e.online = !0;
                        }).addCase(E, function(e) {
                            e.online = !1;
                        }).addCase(D, function(e) {
                            e.focused = !0;
                        }).addCase(N, function(e) {
                            e.focused = !1;
                        }).addMatcher(c, function(e) {
                            return v({}, e);
                        });
                    }
                }), S = (0, J.combineReducers)({
                    queries: p.reducer,
                    mutations: h.reducer,
                    provided: m.reducer,
                    subscriptions: b.reducer,
                    config: q.reducer
                });
                return {
                    reducer: function(e, t) {
                        return S(f.match(t) ? void 0 : e, t);
                    },
                    actions: y(v(v(v(v(v(v({}, q.actions), p.actions), g.actions), b.actions), h.actions), m.actions), {
                        unsubscribeMutationResult: h.actions.removeMutationResult,
                        resetApiState: f
                    })
                };
            }({
                context: a,
                queryThunk: m,
                mutationThunk: g,
                reducerPath: o,
                assertTagType: p,
                config: {
                    refetchOnFocus: d,
                    refetchOnReconnect: f,
                    refetchOnMountOrArgChange: l,
                    keepUnusedDataFor: c,
                    reducerPath: o
                }
            }), k = w.reducer, x = w.actions;
            Me(t.util, {
                patchQueryData: b,
                updateQueryData: O,
                upsertQueryData: T,
                prefetch: R,
                resetApiState: x.resetApiState
            }), Me(t.internalActions, x);
            var Q = function(t) {
                var n = t.reducerPath, r = t.queryThunk, i = t.api, a = t.context, u = a.apiUid, o = {
                    invalidateTags: (0, Se.createAction)(n + "/invalidateTags")
                }, s = [
                    Qe,
                    Oe,
                    Te,
                    Re,
                    ke,
                    Pe
                ];
                return {
                    middleware: function(r) {
                        var o = !1, l = y(v({}, t), {
                            internalState: {
                                currentSubscriptions: {}
                            },
                            refetchQuery: c
                        }), d = s.map(function(e) {
                            return e(l);
                        }), f = function(e) {
                            var t = e.api, n = e.queryThunk, r = e.internalState, i = t.reducerPath + "/subscriptions", a = null, u = !1, o = t.internalActions, s = o.updateSubscriptionOptions, c = o.unsubscribeQueryResult;
                            return function(e, o) {
                                var l, d;
                                if (a || (a = JSON.parse(JSON.stringify(r.currentSubscriptions))), t.util.resetApiState.match(e)) return a = r.currentSubscriptions = {}, [
                                    !0,
                                    !1
                                ];
                                if (t.internalActions.internal_probeSubscription.match(e)) {
                                    var f = e.payload;
                                    return [
                                        !1,
                                        !!(null == (l = r.currentSubscriptions[f.queryCacheKey]) ? void 0 : l[f.requestId])
                                    ];
                                }
                                var p = function(e, r) {
                                    var i, a, u, o, l, d, f, p, h;
                                    if (s.match(r)) {
                                        var v = r.payload, y = v.queryCacheKey, m = v.requestId;
                                        return (null == (i = null == e ? void 0 : e[y]) ? void 0 : i[m]) && (e[y][m] = v.options), !0;
                                    }
                                    if (c.match(r)) {
                                        var g = r.payload;
                                        return m = g.requestId, e[y = g.queryCacheKey] && delete e[y][m], !0;
                                    }
                                    if (t.internalActions.removeQueryResult.match(r)) return delete e[r.payload.queryCacheKey], !0;
                                    if (n.pending.match(r)) {
                                        var b = r.meta;
                                        if (m = b.requestId, (O = b.arg).subscribe) return (q = null != (u = e[a = O.queryCacheKey]) ? u : e[a] = {})[m] = null != (l = null != (o = O.subscriptionOptions) ? o : q[m]) ? l : {}, !0;
                                    }
                                    if (n.rejected.match(r)) {
                                        var q, S = r.meta, O = S.arg;
                                        if (m = S.requestId, S.condition && O.subscribe) return (q = null != (f = e[d = O.queryCacheKey]) ? f : e[d] = {})[m] = null != (h = null != (p = O.subscriptionOptions) ? p : q[m]) ? h : {}, !0;
                                    }
                                    return !1;
                                }(r.currentSubscriptions, e);
                                if (p) {
                                    u || (Ie(function() {
                                        var e = JSON.parse(JSON.stringify(r.currentSubscriptions)), n = (0, Ce.produceWithPatches)(a, function() {
                                            return e;
                                        });
                                        o.next(t.internalActions.subscriptionsUpdated(n[1])), a = e, u = !1;
                                    }), u = !0);
                                    var h = !!(null == (d = e.type) ? void 0 : d.startsWith(i)), v = n.rejected.match(e) && e.meta.condition && !!e.meta.arg.subscribe;
                                    return [
                                        !h && !v,
                                        !1
                                    ];
                                }
                                return [
                                    !0,
                                    !1
                                ];
                            };
                        }(l), p = function(t) {
                            var n = t.reducerPath, r = t.context, i = t.refetchQuery, a = t.internalState, u = t.api.internalActions.removeQueryResult;
                            function o(t, o) {
                                var s = t.getState()[n], c = s.queries, l = a.currentSubscriptions;
                                r.batch(function() {
                                    for(var n = 0, r = Object.keys(l); n < r.length; n++){
                                        var a = r[n], d = c[a], f = l[a];
                                        f && d && (Object.values(f).some(function(e) {
                                            return !0 === e[o];
                                        }) || Object.values(f).every(function(e) {
                                            return void 0 === e[o];
                                        }) && s.config[o]) && (0 === Object.keys(f).length ? t.dispatch(u({
                                            queryCacheKey: a
                                        })) : d.status !== e.uninitialized && t.dispatch(i(d, a)));
                                    }
                                });
                            }
                            return function(e, t) {
                                D.match(e) && o(t, "refetchOnFocus"), K.match(e) && o(t, "refetchOnReconnect");
                            };
                        }(l);
                        return function(e) {
                            return function(t) {
                                o || (o = !0, r.dispatch(i.internalActions.middlewareRegistered(u)));
                                var s, c = y(v({}, r), {
                                    next: e
                                }), l = r.getState(), h = f(t, c, l), m = h[1];
                                if (s = h[0] ? e(t) : m, r.getState()[n] && (p(t, c, l), function(e) {
                                    return !!e && "string" == typeof e.type && e.type.startsWith(n + "/");
                                }(t) || a.hasRehydrationInfo(t))) for(var g = 0, b = d; g < b.length; g++)(0, b[g])(t, c, l);
                                return s;
                            };
                        };
                    },
                    actions: o
                };
                function c(e, t, n) {
                    return void 0 === n && (n = {}), r(v({
                        type: "query",
                        endpointName: e.endpointName,
                        originalArgs: e.originalArgs,
                        subscribe: !1,
                        forceRefetch: !0,
                        queryCacheKey: t
                    }, n));
                }
            }({
                reducerPath: o,
                context: a,
                queryThunk: m,
                mutationThunk: g,
                api: t,
                assertTagType: p
            }), C = Q.middleware;
            Me(t.util, Q.actions), Me(t, {
                reducer: k,
                middleware: C
            });
            var I = function(t) {
                var n = t.serializeQueryArgs, r = t.reducerPath, i = function(e) {
                    return de;
                }, a = function(e) {
                    return fe;
                };
                return {
                    buildQuerySelector: function(e, t) {
                        return function(r) {
                            var a = n({
                                queryArgs: r,
                                endpointDefinition: t,
                                endpointName: e
                            });
                            return (0, B.createSelector)(r === se ? i : function(e) {
                                var t, n, r;
                                return null != (r = null == (n = null == (t = o(e)) ? void 0 : t.queries) ? void 0 : n[a]) ? r : de;
                            }, u);
                        };
                    },
                    buildMutationSelector: function() {
                        return function(e) {
                            var t, n;
                            return n = "object" == typeof e ? null != (t = ae(e)) ? t : se : e, (0, B.createSelector)(n === se ? a : function(e) {
                                var t, r, i;
                                return null != (i = null == (r = null == (t = o(e)) ? void 0 : t.mutations) ? void 0 : r[n]) ? i : fe;
                            }, u);
                        };
                    },
                    selectInvalidatedBy: function(e, t) {
                        for(var n, i = e[r], a = new Set, u = 0, o = t.map(H); u < o.length; u++){
                            var s = o[u], c = i.provided[s.type];
                            if (c) for(var l = 0, d = null != (n = void 0 !== s.id ? c[s.id] : S(Object.values(c))) ? n : []; l < d.length; l++)a.add(d[l]);
                        }
                        return S(Array.from(a.values()).map(function(e) {
                            var t = i.queries[e];
                            return t ? [
                                {
                                    queryCacheKey: e,
                                    endpointName: t.endpointName,
                                    originalArgs: t.originalArgs
                                }
                            ] : [];
                        }));
                    }
                };
                function u(t) {
                    var n;
                    return v(v({}, t), {
                        status: n = t.status,
                        isUninitialized: n === e.uninitialized,
                        isLoading: n === e.pending,
                        isSuccess: n === e.fulfilled,
                        isError: n === e.rejected
                    });
                }
                function o(e) {
                    return e[r];
                }
            }({
                serializeQueryArgs: s,
                reducerPath: o
            }), M = I.buildQuerySelector, _ = I.buildMutationSelector;
            Me(t.util, {
                selectInvalidatedBy: I.selectInvalidatedBy
            });
            var F = function(e) {
                var t = e.serializeQueryArgs, i = e.queryThunk, a = e.mutationThunk, u = e.api, o = e.context, s = new Map, c = new Map, l = u.internalActions, d = l.unsubscribeQueryResult, f = l.removeMutationResult, p = l.updateSubscriptionOptions;
                return {
                    buildInitiateQuery: function(e, r) {
                        var a = function(o, c) {
                            var l = void 0 === c ? {} : c, f = l.subscribe, h = void 0 === f || f, v = l.forceRefetch, y = l.subscriptionOptions, m = l[G];
                            return function(c, l) {
                                var f, g, b = t({
                                    queryArgs: o,
                                    endpointDefinition: r,
                                    endpointName: e
                                }), S = i(((f = {
                                    type: "query",
                                    subscribe: h,
                                    forceRefetch: v,
                                    subscriptionOptions: y,
                                    endpointName: e,
                                    originalArgs: o,
                                    queryCacheKey: b
                                })[G] = m, f)), O = u.endpoints[e].select(o), A = c(S), T = O(l()), R = A.requestId, j = A.abort, w = T.requestId !== R, k = null == (g = s.get(c)) ? void 0 : g[b], x = function() {
                                    return O(l());
                                }, P = Object.assign(m ? A.then(x) : w && !k ? Promise.resolve(T) : Promise.all([
                                    k,
                                    A
                                ]).then(x), {
                                    arg: o,
                                    requestId: R,
                                    subscriptionOptions: y,
                                    queryCacheKey: b,
                                    abort: j,
                                    unwrap: function() {
                                        return q(this, null, function() {
                                            var e;
                                            return n(this, function(t) {
                                                switch(t.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            P
                                                        ];
                                                    case 1:
                                                        if ((e = t.sent()).isError) throw e.error;
                                                        return [
                                                            2,
                                                            e.data
                                                        ];
                                                }
                                            });
                                        });
                                    },
                                    refetch: function() {
                                        return c(a(o, {
                                            subscribe: !1,
                                            forceRefetch: !0
                                        }));
                                    },
                                    unsubscribe: function() {
                                        h && c(d({
                                            queryCacheKey: b,
                                            requestId: R
                                        }));
                                    },
                                    updateSubscriptionOptions: function(t) {
                                        P.subscriptionOptions = t, c(p({
                                            endpointName: e,
                                            requestId: R,
                                            queryCacheKey: b,
                                            options: t
                                        }));
                                    }
                                });
                                if (!k && !w && !m) {
                                    var Q = s.get(c) || {};
                                    Q[b] = P, s.set(c, Q), P.then(function() {
                                        delete Q[b], Object.keys(Q).length || s.delete(c);
                                    });
                                }
                                return P;
                            };
                        };
                        return a;
                    },
                    buildInitiateMutation: function(e) {
                        return function(t, n) {
                            var r = void 0 === n ? {} : n, i = r.track, u = void 0 === i || i, o = r.fixedCacheKey;
                            return function(n, r) {
                                var i = a({
                                    type: "mutation",
                                    endpointName: e,
                                    originalArgs: t,
                                    track: u,
                                    fixedCacheKey: o
                                }), s = n(i), l = s.requestId, d = s.abort, p = s.unwrap, h = s.unwrap().then(function(e) {
                                    return {
                                        data: e
                                    };
                                }).catch(function(e) {
                                    return {
                                        error: e
                                    };
                                }), v = function() {
                                    n(f({
                                        requestId: l,
                                        fixedCacheKey: o
                                    }));
                                }, y = Object.assign(h, {
                                    arg: s.arg,
                                    requestId: l,
                                    abort: d,
                                    unwrap: p,
                                    unsubscribe: v,
                                    reset: v
                                }), m = c.get(n) || {};
                                return c.set(n, m), m[l] = y, y.then(function() {
                                    delete m[l], Object.keys(m).length || c.delete(n);
                                }), o && (m[o] = y, y.then(function() {
                                    m[o] === y && (delete m[o], Object.keys(m).length || c.delete(n));
                                })), y;
                            };
                        };
                    },
                    getRunningQueryThunk: function(e, n) {
                        return function(r) {
                            var i, a = t({
                                queryArgs: n,
                                endpointDefinition: o.endpointDefinitions[e],
                                endpointName: e
                            });
                            return null == (i = s.get(r)) ? void 0 : i[a];
                        };
                    },
                    getRunningMutationThunk: function(e, t) {
                        return function(e) {
                            var n;
                            return null == (n = c.get(e)) ? void 0 : n[t];
                        };
                    },
                    getRunningQueriesThunk: function() {
                        return function(e) {
                            return Object.values(s.get(e) || {}).filter(V);
                        };
                    },
                    getRunningMutationsThunk: function() {
                        return function(e) {
                            return Object.values(c.get(e) || {}).filter(V);
                        };
                    },
                    getRunningOperationPromises: function() {
                        var e = function(e) {
                            return Array.from(e.values()).flatMap(function(e) {
                                return e ? Object.values(e) : [];
                            });
                        };
                        return r(r([], e(s)), e(c)).filter(V);
                    },
                    removalWarning: function() {
                        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
                    }
                };
            }({
                queryThunk: m,
                mutationThunk: g,
                api: t,
                serializeQueryArgs: s,
                context: a
            }), U = F.buildInitiateQuery, ce = F.buildInitiateMutation;
            return Me(t.util, {
                getRunningOperationPromises: F.getRunningOperationPromises,
                getRunningOperationPromise: F.removalWarning,
                getRunningMutationThunk: F.getRunningMutationThunk,
                getRunningMutationsThunk: F.getRunningMutationsThunk,
                getRunningQueryThunk: F.getRunningQueryThunk,
                getRunningQueriesThunk: F.getRunningQueriesThunk
            }), {
                name: Ne,
                injectEndpoint: function(e, n) {
                    var r, i = t;
                    null != (r = i.endpoints)[e] || (r[e] = {}), L(n) ? Me(i.endpoints[e], {
                        name: e,
                        select: M(e, n),
                        initiate: U(e, n)
                    }, j(m, e)) : n.type === z.mutation && Me(i.endpoints[e], {
                        name: e,
                        select: _(),
                        initiate: ce(e)
                    }, j(g, e));
                }
            };
        }
    };
}, Ee = ge(Ke());

},{"62591fe60f98f4bd":"1vrnJ","4555dd63c97c6461":"f53pe","1077e1aea010c932":"2pmMJ"}],"hIn7L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorMessage", ()=>ErrorMessage);
parcelHelpers.export(exports, "FastField", ()=>FastField);
parcelHelpers.export(exports, "Field", ()=>Field);
parcelHelpers.export(exports, "FieldArray", ()=>FieldArray);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Formik", ()=>Formik);
parcelHelpers.export(exports, "FormikConsumer", ()=>FormikConsumer);
parcelHelpers.export(exports, "FormikContext", ()=>FormikContext);
parcelHelpers.export(exports, "FormikProvider", ()=>FormikProvider);
parcelHelpers.export(exports, "connect", ()=>connect);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getIn", ()=>getIn);
parcelHelpers.export(exports, "insert", ()=>insert);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isEmptyChildren", ()=>isEmptyChildren);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isInputEvent", ()=>isInputEvent);
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
parcelHelpers.export(exports, "isNaN", ()=>isNaN$1);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "move", ()=>move);
parcelHelpers.export(exports, "prepareDataForValidation", ()=>prepareDataForValidation);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "setIn", ()=>setIn);
parcelHelpers.export(exports, "setNestedObjectValues", ()=>setNestedObjectValues);
parcelHelpers.export(exports, "swap", ()=>swap);
parcelHelpers.export(exports, "useField", ()=>useField);
parcelHelpers.export(exports, "useFormik", ()=>useFormik);
parcelHelpers.export(exports, "useFormikContext", ()=>useFormikContext);
parcelHelpers.export(exports, "validateYupSchema", ()=>validateYupSchema);
parcelHelpers.export(exports, "withFormik", ()=>withFormik);
parcelHelpers.export(exports, "yupToFormErrors", ()=>yupToFormErrors);
var _react = require("react");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _deepmerge = require("deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _isPlainObject = require("lodash-es/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _clone = require("lodash-es/clone");
var _cloneDefault = parcelHelpers.interopDefault(_clone);
var _toPath = require("lodash-es/toPath");
var _toPathDefault = parcelHelpers.interopDefault(_toPath);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _cloneDeep = require("lodash-es/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, _react.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, _toPathDefault.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, _cloneDefault.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, _toPathDefault.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, _cloneDefault.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, _react.useContext)(FormikContext);
    !!!formik && (0, _tinyWarningDefault.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, _reactFastCompareDefault.default)(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, _react.useRef)(props.initialValues);
    var initialErrors = (0, _react.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, _react.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, _react.useRef)(props.initialStatus);
    var isMounted = (0, _react.useRef)(false);
    var fieldRegistry = (0, _react.useRef)({});
    (0, _react.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, _react.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, _react.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, _react.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, _react.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, _react.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, _react.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, _deepmergeDefault.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, _react.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, _reactFastCompareDefault.default)(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, _react.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, _react.useEffect)(function() {
        if (isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, _react.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, _react.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, _react.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, _react.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, _react.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, _react.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, _react.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, _react.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, _react.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, _react.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, _react.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, _react.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, _react.useMemo)(function() {
        return !(0, _reactFastCompareDefault.default)(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, _react.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, _react.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, _react.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, _react.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, _react.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, _isPlainObjectDefault.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, _isPlainObjectDefault.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, _deepmergeDefault.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, _deepmergeDefault.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEventCallback(fn) {
    var ref = (0, _react.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, _react.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, _tinyWarningDefault.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, _react.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, _react.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, _react.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, _react.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, _react.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, _react.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, _react.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, _react.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, _react.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, _hoistNonReactStaticsDefault.default)(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, _react.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, _tinyWarningDefault.default)(false);
            return (0, _react.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, _hoistNonReactStaticsDefault.default)(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === "function" ? alterErrors : fn;
                var updateTouched = typeof alterTouched === "function" ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, _cloneDeepDefault.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, _reactFastCompareDefault.default)(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, _react.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, _react.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, _react.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, _react.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, _react.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, _tinyWarningDefault.default)(false);
        !!(component && render) && (0, _tinyWarningDefault.default)(false);
        !!(is && children && isFunction(children)) && (0, _tinyWarningDefault.default)(false);
        !!(component && children && isFunction(children)) && (0, _tinyWarningDefault.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, _tinyWarningDefault.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, _react.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, _react.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, _react.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, _react.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, _react.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

},{"react":"llNeF","react-fast-compare":"kVfaA","deepmerge":"jiT2H","lodash-es/isPlainObject":"6hJrx","lodash-es/clone":"719BZ","lodash-es/toPath":"dA0OX","tiny-warning":"7fgGU","hoist-non-react-statics":"3x788","lodash-es/cloneDeep":"jkThK","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kVfaA":[function(require,module,exports) {
"use strict";
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== "undefined";
function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = isArray(a), arrB = isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = keyList(a);
        length = keys.length;
        if (length !== keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"jiT2H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = deepmerge(target[key], source[key], options);
    });
    return destination;
}
function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return mergeObject(target, source, options);
}
deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
    }, {});
};
var deepmerge_1 = deepmerge;
exports.default = deepmerge_1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6hJrx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"5cxd6","./_getPrototype.js":"jjvti","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5cxd6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"jNjci","./_getRawTag.js":"enOpk","./_objectToString.js":"jbjOR","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jNjci":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4RDSn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function("return this")();
exports.default = root;

},{"./_freeGlobal.js":"5IKjN","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5IKjN":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"enOpk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"jNjci","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jbjOR":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jjvti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"8snHp","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8snHp":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6OD37":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == "object";
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"719BZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCloneJs = require("./_baseClone.js");
var _baseCloneJsDefault = parcelHelpers.interopDefault(_baseCloneJs);
/** Used to compose bitmasks for cloning. */ var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function clone(value) {
    return (0, _baseCloneJsDefault.default)(value, CLONE_SYMBOLS_FLAG);
}
exports.default = clone;

},{"./_baseClone.js":"7CnCb","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7CnCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignJs = require("./_baseAssign.js");
var _baseAssignJsDefault = parcelHelpers.interopDefault(_baseAssignJs);
var _baseAssignInJs = require("./_baseAssignIn.js");
var _baseAssignInJsDefault = parcelHelpers.interopDefault(_baseAssignInJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _copySymbolsJs = require("./_copySymbols.js");
var _copySymbolsJsDefault = parcelHelpers.interopDefault(_copySymbolsJs);
var _copySymbolsInJs = require("./_copySymbolsIn.js");
var _copySymbolsInJsDefault = parcelHelpers.interopDefault(_copySymbolsInJs);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
var _getAllKeysInJs = require("./_getAllKeysIn.js");
var _getAllKeysInJsDefault = parcelHelpers.interopDefault(_getAllKeysInJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _initCloneArrayJs = require("./_initCloneArray.js");
var _initCloneArrayJsDefault = parcelHelpers.interopDefault(_initCloneArrayJs);
var _initCloneByTagJs = require("./_initCloneByTag.js");
var _initCloneByTagJsDefault = parcelHelpers.interopDefault(_initCloneByTagJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isMapJs = require("./isMap.js");
var _isMapJsDefault = parcelHelpers.interopDefault(_isMapJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSetJs = require("./isSet.js");
var _isSetJsDefault = parcelHelpers.interopDefault(_isSetJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, _isObjectJsDefault.default)(value)) return value;
    var isArr = (0, _isArrayJsDefault.default)(value);
    if (isArr) {
        result = (0, _initCloneArrayJsDefault.default)(value);
        if (!isDeep) return (0, _copyArrayJsDefault.default)(value, result);
    } else {
        var tag = (0, _getTagJsDefault.default)(value), isFunc = tag == funcTag || tag == genTag;
        if ((0, _isBufferJsDefault.default)(value)) return (0, _cloneBufferJsDefault.default)(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, _initCloneObjectJsDefault.default)(value);
            if (!isDeep) return isFlat ? (0, _copySymbolsInJsDefault.default)(value, (0, _baseAssignInJsDefault.default)(result, value)) : (0, _copySymbolsJsDefault.default)(value, (0, _baseAssignJsDefault.default)(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = (0, _initCloneByTagJsDefault.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, _stackJsDefault.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, _isSetJsDefault.default)(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, _isMapJsDefault.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, _getAllKeysInJsDefault.default) : (0, _getAllKeysJsDefault.default) : isFlat ? (0, _keysInJsDefault.default) : (0, _keysJsDefault.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, _arrayEachJsDefault.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, _assignValueJsDefault.default)(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
exports.default = baseClone;

},{"./_Stack.js":"5Pc82","./_arrayEach.js":"4rEno","./_assignValue.js":"htgUG","./_baseAssign.js":"7z4gk","./_baseAssignIn.js":"aNkKC","./_cloneBuffer.js":"hS0DJ","./_copyArray.js":"drupU","./_copySymbols.js":"cPwBh","./_copySymbolsIn.js":"y2Vcq","./_getAllKeys.js":"9uh0s","./_getAllKeysIn.js":"lJ6Cc","./_getTag.js":"ll8YT","./_initCloneArray.js":"1h3hH","./_initCloneByTag.js":"1ZRtl","./_initCloneObject.js":"4UcQE","./isArray.js":"g67fT","./isBuffer.js":"12Myq","./isMap.js":"6nu38","./isObject.js":"ihIiu","./isSet.js":"gjaIE","./keys.js":"aVTMq","./keysIn.js":"76CGf","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5Pc82":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype["delete"] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"hd7U9","./_stackClear.js":"4Lb2V","./_stackDelete.js":"ad14B","./_stackGet.js":"fBPkU","./_stackHas.js":"eC9jh","./_stackSet.js":"iTyXj","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hd7U9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype["delete"] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"508Sw","./_listCacheDelete.js":"i1JWd","./_listCacheGet.js":"UMWHx","./_listCacheHas.js":"itzIJ","./_listCacheSet.js":"57hTA","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"508Sw":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"i1JWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"3cvT1","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3cvT1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"dII7b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dII7b":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"UMWHx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"3cvT1","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"itzIJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"3cvT1","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"57hTA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"3cvT1","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4Lb2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"hd7U9","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ad14B":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"fBPkU":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eC9jh":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"iTyXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"hd7U9","./_Map.js":"8fyCG","./_MapCache.js":"jfpmY","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8fyCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Map");
exports.default = Map;

},{"./_getNative.js":"9r14d","./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9r14d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"3eHQd","./_getValue.js":"dtDHZ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3eHQd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"lrhzi","./_isMasked.js":"jSk0t","./isObject.js":"ihIiu","./_toSource.js":"7xEF7","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"lrhzi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"5cxd6","./isObject.js":"ihIiu","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ihIiu":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jSk0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"eEjRJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eEjRJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)["__core-js_shared__"];
exports.default = coreJsData;

},{"./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7xEF7":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dtDHZ":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jfpmY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype["delete"] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"ed3Xe","./_mapCacheDelete.js":"cqww3","./_mapCacheGet.js":"jOn7R","./_mapCacheHas.js":"DOoEE","./_mapCacheSet.js":"9VEjO","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ed3Xe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, _hashJsDefault.default),
        "map": new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        "string": new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"f1h23","./_ListCache.js":"hd7U9","./_Map.js":"8fyCG","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"f1h23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype["delete"] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"ciyCe","./_hashDelete.js":"4IK8t","./_hashGet.js":"3SC5R","./_hashHas.js":"iKuN0","./_hashSet.js":"2sdLz","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ciyCe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"bFwro","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"bFwro":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, "create");
exports.default = nativeCreate;

},{"./_getNative.js":"9r14d","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4IK8t":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3SC5R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"bFwro","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"iKuN0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"bFwro","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"2sdLz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"bFwro","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cqww3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"hKpPJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hKpPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"88kpM","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"88kpM":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jOn7R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"hKpPJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"DOoEE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"hKpPJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9VEjO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"hKpPJ","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4rEno":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"htgUG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"by9F2","./eq.js":"dII7b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"by9F2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"kUdim","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kUdim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"9r14d","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7z4gk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && (0, _copyObjectJsDefault.default)(source, (0, _keysJsDefault.default)(source), object);
}
exports.default = baseAssign;

},{"./_copyObject.js":"51q4t","./keys.js":"aVTMq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"51q4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"htgUG","./_baseAssignValue.js":"by9F2","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aVTMq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"cwQgu","./_baseKeys.js":"lzlhx","./isArrayLike.js":"e1HRV","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cwQgu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"48Rb4","./isArguments.js":"dBfbc","./isArray.js":"g67fT","./isBuffer.js":"12Myq","./_isIndex.js":"edZSb","./isTypedArray.js":"8JBVH","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"48Rb4":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dBfbc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"l7hGr","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"l7hGr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"5cxd6","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"g67fT":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"12Myq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"4RDSn","./stubFalse.js":"iC3pd","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"iC3pd":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"edZSb":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8JBVH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"ebqJ7","./_baseUnary.js":"g5iOA","./_nodeUtil.js":"kjtPq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ebqJ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"5cxd6","./isLength.js":"1idFe","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1idFe":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"g5iOA":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kjtPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"5IKjN","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"lzlhx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"gY5rB","./_nativeKeys.js":"3Wm8X","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gY5rB":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3Wm8X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"8snHp","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"e1HRV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"lrhzi","./isLength.js":"1idFe","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aNkKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && (0, _copyObjectJsDefault.default)(source, (0, _keysInJsDefault.default)(source), object);
}
exports.default = baseAssignIn;

},{"./_copyObject.js":"51q4t","./keysIn.js":"76CGf","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"76CGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"cwQgu","./_baseKeysIn.js":"ICte8","./isArrayLike.js":"e1HRV","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ICte8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"ihIiu","./_isPrototype.js":"gY5rB","./_nativeKeysIn.js":"2C58b","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"2C58b":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hS0DJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"drupU":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"cPwBh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return (0, _copyObjectJsDefault.default)(source, (0, _getSymbolsJsDefault.default)(source), object);
}
exports.default = copySymbols;

},{"./_copyObject.js":"51q4t","./_getSymbols.js":"5muTn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5muTn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"e9g2S","./stubArray.js":"k35YI","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"e9g2S":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"k35YI":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"y2Vcq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _getSymbolsInJs = require("./_getSymbolsIn.js");
var _getSymbolsInJsDefault = parcelHelpers.interopDefault(_getSymbolsInJs);
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return (0, _copyObjectJsDefault.default)(source, (0, _getSymbolsInJsDefault.default)(source), object);
}
exports.default = copySymbolsIn;

},{"./_copyObject.js":"51q4t","./_getSymbolsIn.js":"2rrF4","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"2rrF4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    var result = [];
    while(object){
        (0, _arrayPushJsDefault.default)(result, (0, _getSymbolsJsDefault.default)(object));
        object = (0, _getPrototypeJsDefault.default)(object);
    }
    return result;
};
exports.default = getSymbolsIn;

},{"./_arrayPush.js":"6Bn6W","./_getPrototype.js":"jjvti","./_getSymbols.js":"5muTn","./stubArray.js":"k35YI","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6Bn6W":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9uh0s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"demvG","./_getSymbols.js":"5muTn","./keys.js":"aVTMq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"demvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"6Bn6W","./isArray.js":"g67fT","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"lJ6Cc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsInJs = require("./_getSymbolsIn.js");
var _getSymbolsInJsDefault = parcelHelpers.interopDefault(_getSymbolsInJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysInJsDefault.default), (0, _getSymbolsInJsDefault.default));
}
exports.default = getAllKeysIn;

},{"./_baseGetAllKeys.js":"demvG","./_getSymbolsIn.js":"2rrF4","./keysIn.js":"76CGf","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ll8YT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"a55tg","./_Map.js":"8fyCG","./_Promise.js":"kHmUq","./_Set.js":"5m4Yf","./_WeakMap.js":"7wwPb","./_baseGetTag.js":"5cxd6","./_toSource.js":"7xEF7","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"a55tg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "DataView");
exports.default = DataView;

},{"./_getNative.js":"9r14d","./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kHmUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Promise");
exports.default = Promise;

},{"./_getNative.js":"9r14d","./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5m4Yf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Set");
exports.default = Set;

},{"./_getNative.js":"9r14d","./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7wwPb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "WeakMap");
exports.default = WeakMap;

},{"./_getNative.js":"9r14d","./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1h3hH":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
exports.default = initCloneArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1ZRtl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
var _cloneDataViewJs = require("./_cloneDataView.js");
var _cloneDataViewJsDefault = parcelHelpers.interopDefault(_cloneDataViewJs);
var _cloneRegExpJs = require("./_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _cloneSymbolJs = require("./_cloneSymbol.js");
var _cloneSymbolJsDefault = parcelHelpers.interopDefault(_cloneSymbolJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return (0, _cloneArrayBufferJsDefault.default)(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return (0, _cloneDataViewJsDefault.default)(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return (0, _cloneTypedArrayJsDefault.default)(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return (0, _cloneRegExpJsDefault.default)(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return (0, _cloneSymbolJsDefault.default)(object);
    }
}
exports.default = initCloneByTag;

},{"./_cloneArrayBuffer.js":"7K11Z","./_cloneDataView.js":"6Xz7u","./_cloneRegExp.js":"1BT2b","./_cloneSymbol.js":"fsc2F","./_cloneTypedArray.js":"1egmT","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7K11Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"ezlCv","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"ezlCv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"4RDSn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6Xz7u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
exports.default = cloneDataView;

},{"./_cloneArrayBuffer.js":"7K11Z","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1BT2b":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
exports.default = cloneRegExp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"fsc2F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
exports.default = cloneSymbol;

},{"./_Symbol.js":"jNjci","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1egmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"7K11Z","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4UcQE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"gCqFp","./_getPrototype.js":"jjvti","./_isPrototype.js":"gY5rB","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gCqFp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"ihIiu","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"6nu38":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMapJs = require("./_baseIsMap.js");
var _baseIsMapJsDefault = parcelHelpers.interopDefault(_baseIsMapJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsMap = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? (0, _baseUnaryJsDefault.default)(nodeIsMap) : (0, _baseIsMapJsDefault.default);
exports.default = isMap;

},{"./_baseIsMap.js":"5V2XY","./_baseUnary.js":"g5iOA","./_nodeUtil.js":"kjtPq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5V2XY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _getTagJsDefault.default)(value) == mapTag;
}
exports.default = baseIsMap;

},{"./_getTag.js":"ll8YT","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gjaIE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsSetJs = require("./_baseIsSet.js");
var _baseIsSetJsDefault = parcelHelpers.interopDefault(_baseIsSetJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsSet = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? (0, _baseUnaryJsDefault.default)(nodeIsSet) : (0, _baseIsSetJsDefault.default);
exports.default = isSet;

},{"./_baseIsSet.js":"iWUc3","./_baseUnary.js":"g5iOA","./_nodeUtil.js":"kjtPq","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"iWUc3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _getTagJsDefault.default)(value) == setTag;
}
exports.default = baseIsSet;

},{"./_getTag.js":"ll8YT","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dA0OX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
    if ((0, _isArrayJsDefault.default)(value)) return (0, _arrayMapJsDefault.default)(value, (0, _toKeyJsDefault.default));
    return (0, _isSymbolJsDefault.default)(value) ? [
        value
    ] : (0, _copyArrayJsDefault.default)((0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value)));
}
exports.default = toPath;

},{"./_arrayMap.js":"eFEwS","./_copyArray.js":"drupU","./isArray.js":"g67fT","./isSymbol.js":"5vwms","./_stringToPath.js":"eGQMG","./_toKey.js":"3JL7S","./toString.js":"gjxm0","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eFEwS":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5vwms":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"5cxd6","./isObjectLike.js":"6OD37","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eGQMG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"5Hhir","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"5Hhir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"lCplB","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"lCplB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"jfpmY","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3JL7S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = toKey;

},{"./isSymbol.js":"5vwms","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gjxm0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"95doF","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"95doF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + "";
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"jNjci","./_arrayMap.js":"eFEwS","./isArray.js":"g67fT","./isSymbol.js":"5vwms","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"7fgGU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jkThK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCloneJs = require("./_baseClone.js");
var _baseCloneJsDefault = parcelHelpers.interopDefault(_baseCloneJs);
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return (0, _baseCloneJsDefault.default)(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
exports.default = cloneDeep;

},{"./_baseClone.js":"7CnCb","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"iUNvs":[function(require,module,exports) {
module.exports = require("3bb19fb035b5ae7e").getBundleURL("2OE9k") + require("b88fa90aee2bb976").resolve("lR6Zd");

},{"3bb19fb035b5ae7e":"gQU1w","b88fa90aee2bb976":"2poic"}],"gQU1w":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"h8t9E":[function(require,module,exports) {
module.exports = require("6554478980d71128").getBundleURL("2OE9k") + require("26d24c7b4bb11ee5").resolve("5k3xo");

},{"6554478980d71128":"gQU1w","26d24c7b4bb11ee5":"2poic"}],"aXGao":[function(require,module,exports) {
module.exports = require("2a83f101bb87e0f3").getBundleURL("2OE9k") + require("c639dbade38fc699").resolve("avxai");

},{"2a83f101bb87e0f3":"gQU1w","c639dbade38fc699":"2poic"}],"kagyJ":[function(require,module,exports) {
module.exports = require("91db0eeff2decf31").getBundleURL("2OE9k") + require("da5cbe36d1fd577").resolve("jklZY");

},{"91db0eeff2decf31":"gQU1w","da5cbe36d1fd577":"2poic"}],"5sqc2":[function(require,module,exports) {
module.exports = require("59262c41c829ab56").getBundleURL("2OE9k") + require("ba976875d40bdb83").resolve("3xBZS");

},{"59262c41c829ab56":"gQU1w","ba976875d40bdb83":"2poic"}],"cMsXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("views", []).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("/NoEntitySelected.html", require("57ae4a8106af53bf"));
        $templateCache.put("/login.html", require("d7cf7090889a3ad2"));
        $templateCache.put("/newVersionAvailable.html", require("781c3b84a584ce5"));
        $templateCache.put("/generic.html", require("b62d4267922820d4"));
        $templateCache.put("/not-found.html", require("58ec4dff19d73f11"));
        $templateCache.put("/directives/epi-checkbox-switch.html", require("574315a7d135bb7f"));
        $templateCache.put("/directives/epi-checkbox.html", require("1d5f88c9d0587342"));
        $templateCache.put("/directives/epi-collapse-triangle.html", require("6e0353725fd001ed"));
        $templateCache.put("/directives/epi-confirm.html", require("f88cb58ab2e19e74"));
        $templateCache.put("/directives/epi-filter.html", require("624aae07fc93f639"));
        $templateCache.put("/directives/epi-filters-creator.html", require("6240243cd60d06fb"));
        $templateCache.put("/directives/epi-menu.html", require("9284ddcb4ed51fa1"));
        $templateCache.put("/directives/epi-modal.html", require("8f32873214798dc9"));
        $templateCache.put("/directives/epi-paging.html", require("89b97d5038e86c5a"));
        $templateCache.put("/directives/epi-right.html", require("64ceb23b1c61718f"));
        $templateCache.put("/directives/epi-sliding-panel.html", require("55b55f8f280dc238"));
        $templateCache.put("/directives/epi-spinner.html", require("a2b14f0030a31186"));
        $templateCache.put("/directives/epi-tag-filters-creator.html", require("74c87ccb2a23f61a"));
        $templateCache.put("/directives/epi-tags.html", require("c45bcd545494f6fc"));
        $templateCache.put("/directives/epi-user-selector.html", require("b1f089a07b2e2ebe"));
        $templateCache.put("/directives/fine-uploader.html", require("2da5144b886be207"));
        $templateCache.put("fine-uploader-gallery", require("d60bd47a3af30302"));
        $templateCache.put("fine-uploader-button", require("dc9a9c0950d5c125"));
        $templateCache.put("fine-uploader-empty", require("fbbbd350de60469c"));
        $templateCache.put("/directives/loading-indicator.html", require("8cff9a81d81526a9"));
        $templateCache.put("/truterritory/map-reports.html", require("8006320caccb3464"));
        $templateCache.put("/directives/multi-select.html", require("d1c11257469d5ff2"));
        $templateCache.put("/directives/progress-indicator.html", require("c9a25ea8c3694b7f"));
        $templateCache.put("/directives/small-loading-indicator.html", require("1e499ab02ab85c07"));
        $templateCache.put("/directives/clipboard.html", require("c062e3db55902578"));
        $templateCache.put("/admin/admin-init.html", require("17e045d5bf294006"));
        $templateCache.put("/admin/edit-entity-permissions.html", require("9a434b73e4453cbe"));
        $templateCache.put("/admin/edit-entity.html", require("665c743891a3cff9"));
        $templateCache.put("/admin/edit-user-permissions.html", require("3f241bcf865332b0"));
        $templateCache.put("/admin/edit-user.html", require("aceb4ae9298b122f"));
        $templateCache.put("/admin/email-edit.html", require("3e85a248d4668df4"));
        $templateCache.put("/admin/emails.html", require("82e458542ed43b6"));
        $templateCache.put("/admin/users-and-entities.html", require("2c663b6767892992"));
        $templateCache.put("/data/directives/index-creator.html", require("649ddf26d2d5cbbb"));
        $templateCache.put("/data/directives/indexes-creator.html", require("dd68d5bd5c2ca303"));
        $templateCache.put("/data/collections-create-edit.html", require("174548ba6a65d1f3"));
        $templateCache.put("/collections/overwrite.merge.html", require("8304a47811d61d91"));
        $templateCache.put("/collections/save-as-master.html", require("4c1aff8c72a451b1"));
        $templateCache.put("/data/collections.html", require("d1b9fd8a1075407b"));
        $templateCache.put("/error/error-init.html", require("1638d15baf9c87d1"));
        $templateCache.put("/error/generic.html", require("c566b69a4fa279bd"));
        $templateCache.put("/truterritory/clone-theme.html", require("260c4985901869a6"));
        $templateCache.put("/truterritory/download-image.html", require("1eea30c37e578344"));
        $templateCache.put("mapping/get-permalink-modal.html", require("35bf31343b47ab94"));
        $templateCache.put("/truterritory/layers.html", require("8f1467df704bed4a"));
        $templateCache.put("/truterritory/confirm-remove-user-workspace.html", require("c5a4844d160593e2"));
        $templateCache.put("mapping/password-modal.html", require("f2618ee69d9811d6"));
        $templateCache.put("mapping/save-workspace-modal.html", require("4095c55520f41728"));
        $templateCache.put("/truterritory/sql-editor.html", require("be48aa0343b6ec13"));
        $templateCache.put("/truterritory/theme.html", require("49152a35e3de110a"));
        $templateCache.put("/truterritory/truterritory.html", require("fc58a1df82c3a054"));
        $templateCache.put("mapping/unsaved-changes-modal.html", require("920585ec1276a85d"));
        $templateCache.put("/directives/mapping/context-menu.html", require("f3a6c4060426ac46"));
        $templateCache.put("/directives/map-point-detail.html", require("6de289286bab6d83"));
        $templateCache.put("/directives/month-day-select.html", require("8db1350fca34642a"));
    }
]).name;

},{"57ae4a8106af53bf":"dspA9","d7cf7090889a3ad2":"4QEoe","781c3b84a584ce5":"iBbv1","b62d4267922820d4":"1g2on","58ec4dff19d73f11":"87iLb","574315a7d135bb7f":"ik1qi","1d5f88c9d0587342":"2liiI","6e0353725fd001ed":"z9Txc","f88cb58ab2e19e74":"fjlqQ","624aae07fc93f639":"5qm9d","6240243cd60d06fb":"8HOj9","9284ddcb4ed51fa1":"1bhI1","8f32873214798dc9":"dOEfX","89b97d5038e86c5a":"iXWrX","64ceb23b1c61718f":"5Ol9y","55b55f8f280dc238":"4Bslz","a2b14f0030a31186":"4nOkK","74c87ccb2a23f61a":"50aOy","c45bcd545494f6fc":"kj37r","b1f089a07b2e2ebe":"dFOoT","2da5144b886be207":"dbXnk","d60bd47a3af30302":"Uy7hh","dc9a9c0950d5c125":"ib7Oy","fbbbd350de60469c":"5cacn","8cff9a81d81526a9":"8hKLD","8006320caccb3464":"jMQLT","d1c11257469d5ff2":"346W9","c9a25ea8c3694b7f":"625hT","1e499ab02ab85c07":"lKRij","c062e3db55902578":"b955Z","17e045d5bf294006":"4sCh5","9a434b73e4453cbe":"2x2uW","665c743891a3cff9":"1dA8g","3f241bcf865332b0":"1rkpY","aceb4ae9298b122f":"dJYg3","3e85a248d4668df4":"ea8CE","82e458542ed43b6":"T8ALW","2c663b6767892992":"iuZSk","649ddf26d2d5cbbb":"gz0L3","dd68d5bd5c2ca303":"9KHDP","174548ba6a65d1f3":"joJim","8304a47811d61d91":"awWHi","4c1aff8c72a451b1":"iRNa5","d1b9fd8a1075407b":"kEGXz","1638d15baf9c87d1":"gb10u","c566b69a4fa279bd":"8q2BH","260c4985901869a6":"1jPlQ","1eea30c37e578344":"jnuye","35bf31343b47ab94":"53Ksa","8f1467df704bed4a":"l9eLe","c5a4844d160593e2":"kk1Wg","f2618ee69d9811d6":"fkUrO","4095c55520f41728":"fdMav","be48aa0343b6ec13":"cCWhu","49152a35e3de110a":"bDQzb","fc58a1df82c3a054":"3K6VK","920585ec1276a85d":"1FnHi","f3a6c4060426ac46":"kALrP","6de289286bab6d83":"hjc13","8db1350fca34642a":"6XAL3","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dspA9":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><h3>No entity selected</h3><p>Please select an entity from the home page</p></div><div class=\"modal-footer\"><button class=\"btn\" ng-click=\"close('logout')\">Logout</button><button class=\"btn\" ng-click=\"close('init.home')\">Go to home page</button></div>";

},{}],"4QEoe":[function(require,module,exports) {
module.exports = "<div class=\"modal-header\" ng-if=\"!didForgetPassword\"><h3 ng-if=\"!isLoginPage\">You are not logged in</h3><h3 ng-if=\"isLoginPage\">Login:</h3></div><form name=\"loginForm\" ng-submit=\"loginSubmit(loginForm, login)\" novalidate ng-if=\"!didForgetPassword\"><div class=\"modal-body\"><p ng-if=\"!isLoginPage\">Please login below:</p><input type=\"text\" required ng-model=\"login.uname\" name=\"uname\" placeholder=\"Username\"><input type=\"password\" required ng-model=\"login.password\" name=\"password\" placeholder=\"Password\"></div><div class=\"modal-footer\"><small class=\"forgot-password\" ng-click=\"goToForgotPassword()\">I forgot my password</small><button class=\"btn orange\" ng-disabled=\"request == true\" ng-show=\"request == true\"><span class=\"small-loading-indicator\"></span><span>Logging you in...</span></button><input class=\"btn orange\" type=\"submit\" value=\"Login\" ng-hide=\"request == true\"></div></form><div class=\"modal-addendum text-danger\" ng-show=\"!didForgetPassword &amp;&amp; ((error.message &amp;&amp; error.message != 'Login Required' ) || login.errors)\"><p ng-show=\"error.message\">{{error.message}}</p><p ng-show=\"login.errors\" ng-repeat=\"(exception, message) in login.errors\">{{message}}</p></div><form id=\"forgot-password-form\" name=\"forgotPasswordForm\" ng-submit=\"forgotPassword(forgotPasswordForm, forgot)\" novalidate ng-if=\"didForgetPassword\"><div class=\"modal-header\"><h3>Password Reset:</h3><h4>Please enter your email or username</h4></div><div class=\"modal-body\"><p>If your credentials match, we'll send an email with further instructions.</p><input type=\"text\" required ng-model=\"forgot.uname\" name=\"uname\" placeholder=\"Email or Username\"></div><div class=\"modal-footer\"><button class=\"btn orange\" ng-disabled=\"request == true\" ng-show=\"request == true\"><span class=\"small-loading-indicator\"></span><span>Sending Email...</span></button><button class=\"btn\" ng-click=\"goBackToLogin()\">Back to Login</button><input class=\"btn orange\" type=\"submit\" value=\"Request Email\" ng-hide=\"request || forgot.success\"></div><div class=\"modal-addendum text-danger\" ng-show=\"forgot.errors\"><p ng-repeat=\"(exception, message) in forgot.errors\">{{message[0]}}</p></div><div class=\"modal-addendum text-success\" ng-show=\"forgot.success\"><p>{{forgot.success}}</p></div></form>";

},{}],"iBbv1":[function(require,module,exports) {
module.exports = "<div class=\"modal-header\"><h3>A new version of Epiphany is available.</h3></div><div class=\"modal-body\"><p>Please save your work, then refresh the page to update to the new version.</p></div><div class=\"modal-footer\"><button class=\"btn plain\" ng-click=\"$dismiss()\">Not now</button><button class=\"btn\" ng-click=\"refresh()\">Refresh</button></div>";

},{}],"1g2on":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><p>{{error.code}}</p><p>{{error.message}}</p></div><div class=\"modal-footer\"><button class=\"btn\" ng-click=\"close()\">Close</button></div>";

},{}],"87iLb":[function(require,module,exports) {
module.exports = "<div id=\"content\"><h1>404 Not Found</h1><p>I&apos;m sorry, the page you requested could not be found</p></div>";

},{}],"ik1qi":[function(require,module,exports) {
module.exports = "<div class=\"checkbox-switch\"><input type=\"checkbox\" name=\"{{name}}\" id=\"{{id}}\" value=\"{{value}}\" ng-checked=\"{{checked}}\" ng-model=\"model\"><label for=\"{{id}}\"><div class=\"inner\"><div class=\"inner-on\" ng-bind=\"onText\"></div><div class=\"inner-off\" ng-bind=\"offText\"></div></div><div class=\"switch\"></div></label></div>";

},{}],"2liiI":[function(require,module,exports) {
module.exports = "<input type=\"checkbox\" name=\"{{name}}\" id=\"{{id}}\" value=\"{{value}}\" ng-model=\"model\" ng-false-value=\"0\" ng-true-value=\"1\" ng-class=\"model == 1 ? '_checked' : '' \" ng-change=\"change()\" ng-disabled=\"disabled == true\"><label class=\"checkbox\" for=\"{{id}}\">{{label}}</label>";

},{}],"z9Txc":[function(require,module,exports) {
module.exports = "<div class=\"collapse-triangle\"><div class=\"square1\"></div><a class=\"triangle\" ng-click=\"action()\"><span class=\"dash\">-</span></a><div class=\"square2\"></div></div>";

},{}],"fjlqQ":[function(require,module,exports) {
module.exports = "<form name=\"confirmForm\" ng-submit=\"submit(confirmForm.$valid)\" novalidate><div class=\"modal-header\"><h3>{{ text }}</h3></div><div class=\"modal-body\" ng-if=\"idiotTest || details\"><p ng-if=\"details\" ng-bind-html=\"details\">{{ details }}</p><div ng-if=\"idiotTest\"><p>Please type '{{idiotTest}}' to in order to proceed</p><input type=\"text\" ng-model=\"idiotTestCheck\" ui-validate=\"{valid: '$value == idiotTest' }\"></div></div><div class=\"modal-footer\"><span class=\"btn plain\" ng-click=\"cancel($event)\">{{ no }}</span><input class=\"btn\" type=\"submit\" value=\"{{yes}}\" ng-class=\"confirmForm.$invalid == false ? '' : 'disabled' \" ng-disabled=\"confirmForm.$invalid\" ng-click=\"click($event)\"></div></form>";

},{}],"5qm9d":[function(require,module,exports) {
module.exports = "<div class=\"filter-select-holder\" ng-class=\"attributeClass\"><select name=\"column{{$index}}\" ng-model=\"filter[attribute]\" epi-validate=\"alphanumeric\" ng-options=\"property.column as property.name for (key, property) in columns\"></select></div><div class=\"filter-select-holder\" ng-class=\"operatorClass\"><select name=\"operator{{$index}}\" ng-model=\"filter.operator\" epi-validate=\"required\" ng-options=\"operator.op as operator.name for operator in operators\"></select></div><input type=\"text\" name=\"value{{$index}}\" ng-model=\"filter.value\" epi-validate=\"required\" ng-class=\"valueClass\">";

},{}],"8HOj9":[function(require,module,exports) {
module.exports = "<div class=\"filter-creator\"><h4>Column Filters</h4><div class=\"filter\" ng-hide=\"filters.length\"><span class=\"empty\">No filters</span><span class=\"add btn\" ng-click=\"addFilter()\" ng-show=\"showAdd\"></span></div><div class=\"filter\" ng-repeat=\"filter in filters track by $index\"><div class=\"filter-select-holder\"><select name=\"columnID{{$index}}\" ng-model=\"filter.columnID\" epi-validate=\"required\" ng-change=\"filterDidChange(filter)\"><option value=\"{{column.ID}}\" ng-repeat=\"column in columns\" ng-selected=\"filter.columnID == column.ID\">{{column.name}}</option></select></div><div class=\"filter-select-holder\"><select name=\"operatorID{{$index}}\" ng-model=\"filter.operatorID\" epi-validate=\"required\" ng-change=\"filterDidChange(filter)\"><option value=\"{{ID}}\" ng-repeat=\"(ID, operator) in operators\" ng-selected=\"filter.operatorID == ID\" ng-change=\"filterDidChange(filter)\">{{operator}}</option></select></div><input type=\"text\" ng-model=\"filter.value\" name=\"value{{$index}}\" epi-validate=\"required\" ng-change=\"filterDidChange(filter)\"><span class=\"btn del\" ng-click=\"removeFilter($index)\"></span><span class=\"add btn\" ng-if=\"$last\" ng-click=\"addFilter()\" ng-show=\"showAdd\"></span></div></div>";

},{}],"1bhI1":[function(require,module,exports) {
module.exports = "<ul class=\"nav nav-collapse nav-pills nav-stacked\" ng-if=\"!menuParent\"><li ng-repeat=\"item in menu.get()\" ng-class=\"[activePage == item.id ? 'active' : '', item.id, entityID &amp;&amp; item.enabled ? '' : 'disabled']\" ng-if=\"item.visible != false\"><a ui-sref=\"{{item.id}}({entityID: entityID})\" ng-disabled=\"!item.enabled\" uib-tooltip=\"{{item.name}}\" tooltip-placement=\"right\" tooltip-popup-delay=\"1000\" ng-if=\"entityID &amp;&amp; item.enabled\"><span>{{ item.name }}</span></a><a ng-if=\"!entityID &amp;&amp; item.enabled\" disabled></a></li></ul><div ng-if=\"!!menuParent &amp;&amp; menu.get(menuParent).length\" ng-repeat=\"section in menu.get(menuParent)\"><h3>{{ section.text }}</h3><ul><li ng-repeat=\"item in section.routes\" ng-if=\"item.enabled\" ng-class=\"{'active': activeSection == item.sref}\"><a ui-sref=\"{{ item.sref }}\">{{ item.name }}</a></li></ul></div>";

},{}],"dOEfX":[function(require,module,exports) {
module.exports = "<div class=\"modal-header\" ng-if=\"header\"><h3>{{header}}</h3></div><div class=\"modal-body\" ng-if=\"bodySafe\" ng-bind-html=\"bodySafe\"></div><div class=\"modal-footer\" ng-if=\"buttonCancelText &amp;&amp; buttonConfirmText\"><span class=\"btn\" ng-click=\"cancel()\">{{buttonCancelText}}</span><span class=\"btn\" ng-click=\"confirm()\">{{buttonConfirmText}}</span></div>";

},{}],"iXWrX":[function(require,module,exports) {
module.exports = "<span ng-if=\"verbosity == '1' || !verbosity \"><span class=\"page-selector\"><span class=\"prev\" ng-click=\"prevPage()\" ng-show=\"pages.page &gt; 1\">&lt;prev</span><span class=\"page\">Page {{ pages.page }} of {{ pages.totalPages }}</span><span class=\"next\" ng-click=\"nextPage()\" ng-show=\"pages.page &lt; pages.totalPages\">next&gt;</span></span></span><span ng-if=\"verbosity == 2\"><span class=\"info\">Records: {{ pages.total }}</span><span class=\"page-selector\"><span class=\"prev\" ng-click=\"prevPage()\" ng-show=\"pages.page &gt; 1\">&lt;prev</span><span class=\"page\">Page {{ pages.page }} of {{ pages.totalPages }}</span><span class=\"next\" ng-click=\"nextPage()\" ng-show=\"pages.page &lt; pages.totalPages\">next&gt;</span></span></span><span ng-if=\"verbosity == 3 \"><span class=\"info\">Pages: {{pages.totalPages}} Records: {{pages.total}}</span><span class=\"records\">Records<span>{{ pages.range[0]}} - {{ pages.range[1] }}</span></span><span class=\"page-selector\"><span class=\"prev\" ng-click=\"prevPage()\" ng-show=\"pages.page &gt; 1\">&lt;prev</span><span class=\"page\">Page {{pages.page}}</span><span class=\"next\" ng-click=\"nextPage()\" ng-show=\"pages.page &lt; pages.totalPages\">next&gt;</span></span></span>";

},{}],"5Ol9y":[function(require,module,exports) {
module.exports = "<div class=\"right\" ng-transclude=\"ng-transclude\"></div>";

},{}],"4Bslz":[function(require,module,exports) {
module.exports = "<div class=\"sliding-panel\" ng-transclude=\"ng-transclude\" ng-class=\"class\"></div>";

},{}],"4nOkK":[function(require,module,exports) {
module.exports = "<span ng-if=\"css3\"></span><span ng-if=\"!css3\"><img alt=\"\" src=\"data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAAKAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQACgABACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkEAAoAAgAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkEAAoAAwAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkEAAoABAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQACgAFACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQACgAGACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAAKAAcALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==\"></span>";

},{}],"50aOy":[function(require,module,exports) {
module.exports = "<div class=\"tag-filters-creator\"><h4>Tag Filters</h4><div class=\"col-md-6\"><div class=\"col-md-6\"><div class=\"header\"><span>Must have</span><div class=\"radio-buttons\"><input id=\"includes-any\" type=\"radio\" name=\"includeIfAny\" value=\"1\" ng-model=\"tagFilters.includeIfAny\"><label class=\"first\" for=\"includes-any\">any of</label><input id=\"includes-all\" type=\"radio\" name=\"includeIfAny\" value=\"0\" ng-model=\"tagFilters.includeIfAny\"><label for=\"includes-all\">all of</label></div></div><ul class=\"drop\" ui-sortable=\"tagFilterSortable\" ng-model=\"tagFilters.include\"><li class=\"cancel\" ng-if=\"!tagFilters.include.length\">Drop tags here</li><li class=\"tag\" ng-repeat=\"tag in tagFilters.include track by $index\" ng-style=\"tag.style()\" ng-class=\"{private: tag.private}\">{{tag.name}}</li></ul></div><div class=\"col-md-6\"><div class=\"header\"><span>Must<b>&nbsp;not&nbsp;</b>have</span><div class=\"radio-buttons\"><input id=\"excludes-any\" type=\"radio\" name=\"excludeIfAny\" value=\"1\" ng-model=\"tagFilters.excludeIfAny\"><label class=\"first\" for=\"excludes-any\">any of</label><input id=\"excludes-all\" type=\"radio\" name=\"excludeIfAny\" value=\"0\" ng-model=\"tagFilters.excludeIfAny\"><label for=\"excludes-all\">all of</label></div></div><ul class=\"drop\" ui-sortable=\"tagFilterSortable\" ng-model=\"tagFilters.exclude\"><li class=\"cancel\" ng-if=\"!tagFilters.exclude.length\">Drop tags here</li><li class=\"tag\" ng-repeat=\"tag in tagFilters.exclude track by $index\" ng-style=\"tag.style()\">{{tag.name}}</li></ul></div></div><div class=\"col-md-6\"><h5>Tags</h5><ul class=\"tag-list\" ui-sortable=\"tagListSortable\" ng-model=\"tags\"><li class=\"tag\" ng-repeat=\"tag in tags track by $index\" ng-style=\"tag.style()\" ng-if=\"allowPrivate || !tag.private\" ng-class=\"{private: tag.private}\">{{tag.name}}</li></ul></div></div>";

},{}],"kj37r":[function(require,module,exports) {
module.exports = "<ul class=\"tag-list\" ui-sortable=\"tagList\" ng-model=\"entryTags\" ng-if=\"sortable\" ng-mouseleave=\"resetWidths()\"><li class=\"tag\" ng-repeat=\"tag in entryTags track by $index\" ng-class=\"{dark: tag.isDark, private: tag.private}\" ng-style=\"tagStyle(tag)\" ng-mouseenter=\"mouseEnter($index)\"><span class=\"name\">{{tag.name}}</span></li></ul><ul class=\"tag-list\" ng-if=\"!sortable\" ng-mouseleave=\"resetWidths()\"><li class=\"tag\" ng-repeat=\"tag in entryTags track by $index\" ng-class=\"{dark: tag.isDark, private: tag.private}\" ng-style=\"tagStyle(tag)\" ng-mouseenter=\"mouseEnter($index)\"><span class=\"name\">{{tag.name}}</span></li></ul>";

},{}],"dFOoT":[function(require,module,exports) {
module.exports = "<div class=\"user-selector\"><h4 ng-if=\"showHeader\">Users</h4><input type=\"text\" ng-model=\"textQuery\" placeholder=\"{{placeholder}}\" uib-typeahead=\"user as user.fullName for user in searchUsers($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"3\" typeahead-editable=\"true\" typeahead-on-select=\"addUser($item, $model, $label)\" ng-class=\"{'invalid': invalid == true}\" ng-enter=\"addEmail(textQuery)\"><div ng-transclude=\"ng-transclude\" ng-if=\"transclude\"></div><div ng-if=\"transclude != true\"><div class=\"users\" ng-repeat=\"user in users\" ng-if=\"showCurrent == false &amp;&amp; user.ID != currentUserID || showCurrent == true\"><div class=\"text\">{{user.fullName}}</div><button class=\"btn del\" ng-click=\"removeUser($index)\" ng-if=\"showDelete(user)\"></button></div></div></div>";

},{}],"dbXnk":[function(require,module,exports) {
module.exports = "<div ng-transclude=\"ng-transclude\"></div>";

},{}],"Uy7hh":[function(require,module,exports) {
module.exports = "<div id=\"fine-uploader-gallery\"><div class=\"qq-gallery qq-uploader qq-uploader-selector\" qq-drop-area-text=\"Drop files here\"><div class=\"progress qq-progress-bar-container-selector qq-total-progress-bar-container qq-total-progress-bar-container-selector\"><div class=\"bar qq-progress-bar-selector\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><div class=\"qq-upload-drop-area qq-upload-drop-area-selector\" qq-hide-dropzone=\"\"><span class=\"qq-upload-drop-area-text-selector\"></span></div><button class=\"btn qq-upload-button-selector\"><span>Upload a file</span></button><span class=\"qq-drop-processing qq-drop-processing-selector\"><span>Processing dropped files...</span><span class=\"qq-drop-processing-spinner qq-drop-processing-spinner-selector\"></span></span><ul class=\"qq-upload-list qq-upload-list-selector\" role=\"region\" aria-live=\"polite\" aria-relevant=\"additions removals\"><li><span class=\"qq-upload-status-text qq-upload-status-text-selector\" role=\"status\"></span><div class=\"qq-progress-bar-container qq-progress-bar-container-selector\"><div class=\"qq-progress-bar qq-progress-bar-selector\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><span class=\"qq-upload-spinner qq-upload-spinner-selector\"></span><div class=\"qq-thumbnail-wrapper\"><a class=\"preview-link\" target=\"_blank\"><img class=\"qq-thumbnail-selector\" qq-max-size=\"120\" qq-server-scale=\"\"></a></div><button class=\"qq-upload-cancel qq-upload-cancel-selector\" type=\"button\">X</button><button class=\"qq-upload-retry qq-upload-retry-selector\" type=\"button\"><span class=\"qq-btn qq-retry-icon\" aria-label=\"Retry\"></span> Retry</button><div class=\"qq-file-info\"><div class=\"qq-file-name\"><span class=\"qq-upload-file qq-upload-file-selector\"></span><span class=\"qq-edit-filename-icon qq-edit-filename-icon-selector\" aria-label=\"Edit filename\"></span></div><input class=\"qq-edit-filename qq-edit-filename-selector\" tabindex=\"0\" type=\"text\"><span class=\"qq-upload-size qq-upload-size-selector\"></span><button class=\"btn del qq-btn qq-upload-delete qq-upload-delete-selector\" type=\"button\"><span class=\"qq-btn qq-delete-icon\" aria-label=\"Delete\"></span></button><button class=\"qq-btn qq-upload-pause qq-upload-pause-selector\" type=\"button\"><span class=\"qq-btn qq-pause-icon\" aria-label=\"Pause\"></span></button><button class=\"qq-btn qq-upload-continue qq-upload-continue-selector\" type=\"button\"><span class=\"qq-btn qq-continue-icon\" aria-label=\"Continue\"></span></button></div></li></ul><dialog class=\"modal qq-alert-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">Close</button></div></div></div></div></dialog><dialog class=\"modal qq-confirm-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">No</button><button class=\"btn qq-ok-button-selector\">Yes</button></div></div></div></div></dialog><dialog class=\"modal qq-prompt-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"><input type=\"text\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">No</button><button class=\"btn qq-ok-button-selector\">Yes</button></div></div></div></div></dialog></div></div>";

},{}],"ib7Oy":[function(require,module,exports) {
module.exports = "<div id=\"fine-uploader-button\"><div class=\"qq-button qq-uploader qq-uploader-selector\"><div class=\"progress qq-total-progress-bar-container qq-total-progress-bar-container-selector\"><div class=\"progress-bar qq-total-progress-bar qq-total-progress-bar-selector\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><button class=\"btn qq-upload-button-selector\"><span>Upload a file</span></button><span class=\"qq-drop-processing qq-drop-processing-selector\"><span>Processing dropped files...</span><span class=\"qq-drop-processing-spinner qq-drop-processing-spinner-selector\"></span></span><ul class=\"qq-upload-list qq-upload-list-selector\" role=\"region\" aria-live=\"polite\" aria-relevant=\"additions removals\"><li><span class=\"qq-upload-status-text qq-upload-status-text-selector\" role=\"status\"></span><span class=\"qq-upload-spinner qq-upload-spinner-selector\"></span><div class=\"qq-thumbnail-wrapper\"><a class=\"preview-link\" target=\"_blank\"><img class=\"qq-thumbnail-selector\" qq-max-size=\"120\" qq-server-scale=\"\"></a></div><button class=\"qq-upload-cancel qq-upload-cancel-selector\" type=\"button\">X</button><button class=\"qq-upload-retry qq-upload-retry-selector\" type=\"button\"><span class=\"qq-btn qq-retry-icon\" aria-label=\"Retry\"></span> Retry</button><div class=\"qq-file-info\"><div class=\"qq-file-name\"><span class=\"qq-upload-file qq-upload-file-selector\"></span><span class=\"qq-edit-filename-icon qq-edit-filename-icon-selector\" aria-label=\"Edit filename\"></span></div><input class=\"qq-edit-filename qq-edit-filename-selector\" tabindex=\"0\" type=\"text\"><span class=\"qq-upload-size qq-upload-size-selector\"></span><button class=\"btn del qq-btn qq-upload-delete qq-upload-delete-selector\" type=\"button\"><span class=\"qq-btn qq-delete-icon\" aria-label=\"Delete\"></span></button><button class=\"qq-btn qq-upload-pause qq-upload-pause-selector\" type=\"button\"><span class=\"qq-btn qq-pause-icon\" aria-label=\"Pause\"></span></button><button class=\"qq-btn qq-upload-continue qq-upload-continue-selector\" type=\"button\"><span class=\"qq-btn qq-continue-icon\" aria-label=\"Continue\"></span></button></div></li></ul><dialog class=\"modal qq-alert-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">Close</button></div></div></div></div></dialog><dialog class=\"modal qq-confirm-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">No</button><button class=\"btn qq-ok-button-selector\">Yes</button></div></div></div></div></dialog><dialog class=\"modal qq-prompt-dialog-selector\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body qq-dialog-message-selector\"><input type=\"text\"></div><div class=\"modal-footer\"><div class=\"controls qq-dialog-buttons\"><button class=\"btn qq-cancel-button-selector\">No</button><button class=\"btn qq-ok-button-selector\">Yes</button></div></div></div></div></dialog></div></div>";

},{}],"5cacn":[function(require,module,exports) {
module.exports = "<div id=\"fine-uploader-empty\"><div class=\"qq-uploader qq-uploader-selector\"><ul class=\"qq-upload-list-selector\"><li class=\"hidden\"></li></ul></div></div>";

},{}],"8hKLD":[function(require,module,exports) {
module.exports = "<div class=\"loading-indicator\" ng-show=\"active\"><div class=\"text\">{{text}}</div><div class=\"top\"></div><div class=\"right-side\"></div><div class=\"bottom\"></div><div class=\"left\"></div></div>";

},{}],"jMQLT":[function(require,module,exports) {
module.exports = "<div id=\"map-reports-module\"><div class=\"row\"><button class=\"btn\" disabled>New</button><button class=\"btn\" ng-click=\"alert('Save not yet supported!')\" disabled>Save</button></div><div class=\"row\"><div class=\"form-group\"><table class=\"striped-table\"><tr><th class=\"icon-delete-2 report-field-delete\" title=\"Delete Report From Map\"></th><th class=\"icon-view report-field-enabled\" title=\"Report Enabled / Disabled\"></th><th class=\"report-field-collection\" title=\"Report Enabled / Disabled\">Collection</th><th class=\"report-field-template\" title=\"Report Enabled / Disabled\">Template</th><th class=\"report-field-label\" title=\"The name this label has when the user right-clicks on the map\">Label</th><th class=\"icon-truterritory-polygon report-field-geometry-required\" title=\"Whether or not to require geometry for this report to appear\"></th><th class=\"report-field-variables\" title=\"Manually declared variables to pass to the report template\">Variables</th><th class=\"report-field-meta\" title=\"Any additional metadata to pass to the report template\">Meta</th><th class=\"report-field-notes\" title=\"Any notes for other users\">Notes</th></tr><tr ng-repeat=\"report in reports\"><td class=\"report-field-delete\"><btn class=\"icon-delete-3\" disabled title=\"Delete report\" onclick=\"alert('Delete not yet supported!')\" style=\"cursor:not-allowed\"></btn></td><td class=\"report-field-enabled\"><input class=\"report-field-enabled\" disabled type=\"checkbox\" ng-model=\"report.enabled\" ng-class=\"{_checked: report.enabled}\"></td><td class=\"report-field-collection\"><select class=\"report-field-collection\" disabled type=\"select\" ng-options=\"collection.ID as collection.name for collection in map.collections\" ng-model=\"report.collectionID\"><option value=\"\">No collection</option></select></td><td class=\"report-field-template\"><select class=\"report-field-template\" disabled type=\"select\" ng-options=\"template.ID as template.slug for template in templates\" ng-model=\"report.templateID\"><option value=\"\">No template selected</option></select></td><td class=\"report-field-label\"><input class=\"report-field-label\" disabled type=\"text\" ng-model=\"report.label\"></td><td class=\"report-field-require-geometry\"><input class=\"report-field-require-geometry\" disabled type=\"checkbox\" ng-model=\"report.requireGeometry\" ng-class=\"{_checked: report.requireGeometry}\"></td><td class=\"report-field-variables\"><textarea class=\"report-field-variables\" disabled json-text=\"json-text\" ng-model=\"report.variables\" rows=\"5\"></textarea></td><td class=\"report-field-meta\"><textarea class=\"report-field-meta\" disabled json-text=\"json-text\" ng-model=\"report.meta\" rows=\"5\"></textarea></td><td class=\"report-field-notes\"><textarea class=\"report-field-notes\" disabled ng-model=\"report.notes\" rows=\"5\"></textarea></td></tr></table></div></div></div>";

},{}],"346W9":[function(require,module,exports) {
module.exports = "<div class=\"multiselect\" off-click=\"isDropdownOpen = false\"><div class=\"toggle\" ng-show=\"!items\">Loading...</div><div class=\"toggle\" ng-click=\"isDropdownOpen = !isDropdownOpen\" ng-hide=\"!items\" title=\"{{getLabel()}}\">{{getLabel()}}</div><div class=\"dropdown\" ng-show=\"isDropdownOpen\"><div class=\"option\" ng-repeat=\"item in items\" ng-show=\"items\" ng-init=\"id = generateID($index)\"><input type=\"checkbox\" checklist-model=\"model\" checklist-value=\"get('value', item, $index)\" id=\"{{id}}\" ng-class=\"this.checked ? '_checked' : ''\"><label class=\"checkbox\" for=\"{{id}}\"><div class=\"text\">{{get('label', item, $index)}}</div></label></div></div></div>";

},{}],"625hT":[function(require,module,exports) {
module.exports = "<div class=\"wrapper\" fade-away=\"displayed &amp;&amp; progress !== null &amp;&amp; progress != 100\"><div class=\"holder\" ng-class=\"{completed: progress == 100 || progress == null}\"><div class=\"header\">{{text}}...</div><div class=\"bar\"><div class=\"inner\"></div></div><div class=\"percent\">{{progress == null ? 100 : progress}}%</div></div></div>";

},{}],"lKRij":[function(require,module,exports) {
module.exports = "<div class=\"icon-notched-circle\"></div>";

},{}],"b955Z":[function(require,module,exports) {
module.exports = "<div><div class=\"fade tooltip top\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">Copied!</div></div><span ng-transclude=\"ng-transclude\" ng-hide=\"showUnsupportedCopy\"></span><textarea ng-if=\"showUnsupportedCopy\" rows=\"{{rows}}\">{{content}}</textarea><button class=\"btn\" ng-show=\"showUnsupportedCopy\" ng-click=\"showUnsupportedCopy = false\">Close</button></div>";

},{}],"4sCh5":[function(require,module,exports) {
module.exports = "<epi-admin-menu active-section=\"activeSection\"></epi-admin-menu><div id=\"content-wrap\" ui-view=\"\"></div>";

},{}],"2x2uW":[function(require,module,exports) {
module.exports = "<div class=\"manage-header\"><h4>Manage Permissions</h4></div><div class=\"manage-body\"><table class=\"permissions table\"><tbody><tr ng-repeat=\"permission in permissions\"><td><span>{{permission.name}}</span></td><td><div class=\"epi-checkbox-switch\" input-id=\"{{permission.permission}}{{entity.ID}}\" value=\"1\" name=\"permissions[]\" checked model=\"entity.permissions[permission.permission]\" on-text=\"ACTIVE\" off-text=\"DISABLED\"></div></td></tr></tbody></table></div><div class=\"controls\"><button class=\"btn\" ng-click=\"closeSidePanel()\">Close</button></div>";

},{}],"1dA8g":[function(require,module,exports) {
module.exports = "<div class=\"entity-details\"><div class=\"manage-header\">Entity Details</div><div class=\"manage-body\"><div class=\"text-danger\" ng-if=\"error\" ng-repeat=\"error in errors\"><span ng-repeat=\"err in error\">{{err}}</span></div><div class=\"col-md-12\"><form ng-submit=\"update(entity)\" epi-validate=\"\" name=\"entityForm\" epi-validate-show-messages=\"epi-validate-show-messages\"><label for=\"name\">Name:</label><input id=\"name\" type=\"text\" placeholder=\"NAME\" ng-model=\"entity.name\" name=\"name\" epi-validate=\"required\"><label for=\"address\">Address:</label><input id=\"address\" type=\"text\" placeholder=\"ADDRESS\" ng-model=\"entity.address\" name=\"address\"><label for=\"city\">City:</label><input id=\"city\" type=\"text\" placeholder=\"CITY\" ng-model=\"entity.city\" name=\"city\"><label for=\"state\">State:</label><input id=\"state\" type=\"text\" placeholder=\"STATE\" ng-model=\"entity.state\" name=\"state\"><label for=\"zip\">Zip:</label><input id=\"zip\" type=\"text\" placeholder=\"ZIP\" ng-model=\"entity.zip\" name=\"zip\"><label for=\"country\">Country:</label><input id=\"country\" type=\"text\" placeholder=\"COUNTRY\" ng-model=\"entity.country\" name=\"country\"><label for=\"website\">Website:</label><input id=\"website\" type=\"text\" placeholder=\"WEBSITE\" ng-model=\"entity.website\" name=\"website\"><label for=\"phone\">Phone:</label><input id=\"phone\" type=\"text\" placeholder=\"PHONE\" ng-model=\"entity.phone\" name=\"phone\"><h5 class=\"col-md-12\">Fiscal year start:</h5><month-day-select ng-model=\"entity\"></month-day-select><div class=\"controls\"><span class=\"btn\" ng-click=\"closeSidePanel()\">Close</span><input class=\"btn\" type=\"submit\" ng-if=\"!processing\" value=\"Save\"><span class=\"btn disabled\" ng-if=\"processing\" disabled><span class=\"small-loading-indicator\"></span><span>Saving...</span></span></div></form></div></div></div>";

},{}],"1rkpY":[function(require,module,exports) {
module.exports = "<div class=\"overflow-hidden\" id=\"content\"><div class=\"user-permissions\"><div class=\"side-bar\"><button class=\"btn\" ui-sref=\"admin.users-and-entities\">Back</button><h3>Permissions at Selected Levels:</h3><div class=\"permissions-list\"><div class=\"delete permission\" ng-class=\"isTypeDisabled('delete') == true ? 'disabled' : '' \"><span>All</span><div class=\"controls\"><input id=\"deletePermission\" type=\"checkbox\" ng-model=\"currentPermission.delete\" ng-checked=\"currentPermission.delete == 1\" ng-true-value=\"1\" ng-false-value=\"0\" ng-class=\"{'_checked' : currentPermission.delete == 1, disabled: isTypeDisabled('delete')}\" ng-change=\"changedPermission('delete', currentPermission.delete)\"><label class=\"checkbox\" for=\"deletePermission\"></label></div></div><div class=\"create permission\" ng-class=\"isTypeDisabled('create') == true ? 'disabled' : '' \"><span>Add</span><div class=\"controls\"><input id=\"createPermission\" type=\"checkbox\" ng-model=\"currentPermission.create\" ng-checked=\"currentPermission.create == 1\" ng-true-value=\"1\" ng-false-value=\"0\" ng-class=\"{'_checked' : currentPermission.create == 1, disabled: isTypeDisabled('create')}\" ng-change=\"changedPermission('create', currentPermission.create)\"><label class=\"checkbox\" for=\"createPermission\"></label></div></div><div class=\"permission update\" ng-class=\"isTypeDisabled('update') == true ? 'disabled' : '' \"><span>Edit</span><div class=\"controls\"><input id=\"updatePermission\" type=\"checkbox\" ng-model=\"currentPermission.update\" ng-checked=\"currentPermission.update == 1\" ng-true-value=\"1\" ng-false-value=\"0\" ng-class=\"{'_checked' : currentPermission.update == 1, disabled: isTypeDisabled('update')}\" ng-change=\"changedPermission('update', currentPermission.update)\"><label class=\"checkbox\" for=\"updatePermission\"></label></div></div><div class=\"collaborate permission\" ng-class=\"isTypeDisabled('collaborate') == true ? 'disabled' : '' \"><span>Collaborate</span><div class=\"controls\"><input id=\"collaboratePermission\" type=\"checkbox\" ng-model=\"currentPermission.collaborate\" ng-checked=\"currentPermission.collaborate == 1\" ng-true-value=\"1\" ng-false-value=\"0\" ng-class=\"{'_checked' : currentPermission.collaborate == 1, disabled: isTypeDisabled('collaborate')}\" ng-change=\"changedPermission('collaborate', currentPermission.collaborate)\"><label class=\"checkbox\" for=\"collaboratePermission\"></label></div></div><div class=\"permission read\" ng-class=\"isTypeDisabled('read') == true ? 'disabled' : '' \"><span>View</span><div class=\"controls\"><input id=\"readPermission\" type=\"checkbox\" ng-model=\"currentPermission.read\" ng-checked=\"currentPermission.read == 1\" ng-true-value=\"1\" ng-false-value=\"0\" ng-class=\"{'_checked' : currentPermission.read == 1, disabled: isTypeDisabled('read')}\" ng-change=\"changedPermission('read', currentPermission.read)\"><label class=\"checkbox\" for=\"readPermission\"></label></div></div><div class=\"controls\"><button class=\"btn\" ng-click=\"cascadePermissions()\">Cascade</button></div></div></div><div class=\"permission-wrapper\" nicescroll=\"nicescroll\"><div class=\"main\"><div class=\"breadcrumbs\"><div class=\"breadcrumb\"><span class=\"text\">{{user.fname}} {{user.lname}}</span></div><div class=\"breadcrumb\" ng-if=\"permissionList[$index + 1].children\" ng-repeat=\"level in current track by $index\" ng-class=\"$last == true ? 'disabled' : ''\"><span class=\"text\" ng-if=\"$index == 0\">{{entity.name}}</span><span class=\"text\">{{permissionList[$index + 1].name}}</span></div></div><div style=\"clear:both\"></div><div class=\"column\" ng-repeat=\"permission in permissionList\" ng-init=\"currentIndex = $index\"><div class=\"permissions\" ng-if=\"permission[0].ID\"><div class=\"next permission\" ng-repeat=\"entity in permission\" ng-click=\"setEntity(entity, user)\" ng-class=\"getPermissionClass(entity, index)\"><div class=\"text\">{{entity.name}}</div><div class=\"sidebar\"></div></div></div><div class=\"permissions\" ng-if=\"!permission[0].ID\"><div class=\"permission\" ng-repeat=\"(key, permission) in permission.children\" ng-click=\"openPermission(key, permission, currentIndex)\" ng-class=\"getPermissionClass(permission, index)\"><div class=\"text\">{{permission.name}}</div><div class=\"sidebar\"></div></div></div></div></div></div></div></div>";

},{}],"dJYg3":[function(require,module,exports) {
module.exports = "<div class=\"user-details\"><div class=\"manage-header\">User Details</div><div class=\"manage-body\"><div class=\"text-danger\" ng-if=\"error\" ng-repeat=\"error in errors\"><span ng-repeat=\"err in error\">{{err}}</span></div><div class=\"col-md-12\"><form ng-submit=\"update(user)\" epi-validate=\"\" name=\"userForm\" epi-validate-show-messages=\"epi-validate-show-messages\"><label for=\"first\">First Name:</label><input id=\"first\" name=\"first\" type=\"text\" placeholder=\"FIRST NAME\" ng-model=\"user.fname\" epi-validate=\"required\"><label for=\"last\">Last Name:</label><input id=\"last\" name=\"last\" type=\"text\" placeholder=\"LAST NAME\" ng-model=\"user.lname\" epi-validate=\"required\"><label for=\"email\">Email:</label><input id=\"email\" name=\"email\" type=\"text\" placeholder=\"EMAIL\" ng-model=\"user.email\" epi-validate=\"required|email\"><label for=\"username\">Username:</label><input id=\"username\" name=\"username\" type=\"text\" placeholder=\"USERNAME\" ng-model=\"user.uname\" epi-validate=\"required|min:5|alphanumeric\"><div class=\"password\"><label for=\"password\">Password:</label><input id=\"password\" name=\"password\" type=\"password\" placeholder=\"PASSWORD\" ng-model=\"user.password\" epi-validate=\"requiredWith:passwordConfirm|min:6\"><input type=\"password\" name=\"passwordConfirm\" placeholder=\"CONFIRM\" ng-model=\"user.passwordConfirm\" epi-validate=\"requiredWith:password|matches:password|min:6\"></div><label>Login restricted to:</label><span class=\"login-brands\" ng-repeat=\"(name,brand) in brands\"><input id=\"allowed-login-brand-{{brand}}\" type=\"checkbox\" ng-model=\"allowed\" ng-class=\"allowed != false ? '_checked' : ''\" ng-change=\"setAllowedLoginBrand(allowed, brand)\"><label class=\"checkbox col-md-12\" for=\"allowed-login-brand-{{brand}}\" ng-init=\"allowed = isAllowedLoginBrand(brand)\">{{ name }}</label></span><input id=\"active\" name=\"active\" type=\"checkbox\" ng-model=\"user.active\" ng-class=\"user.active != false ? '_checked' : ''\"><label class=\"activated checkbox col-md-12\" for=\"active\">Activated</label><input id=\"multisession\" name=\"multisession\" type=\"checkbox\" ng-model=\"user.multisession\" ng-class=\"user.multisession == true ? '_checked' : ''\"><label class=\"activated checkbox col-md-12\" for=\"multisession\">Multisession user</label><div class=\"controls\"><span class=\"btn\" ng-click=\"closeSidePanel()\">Close</span><input class=\"btn\" type=\"submit\" ng-if=\"!processing\" value=\"Save\"><span class=\"btn disabled\" ng-if=\"processing\" disabled><span class=\"small-loading-indicator\"></span><span>Saving...</span></span></div></form></div></div></div>";

},{}],"ea8CE":[function(require,module,exports) {
module.exports = "<form class=\"edit-email\" name=\"editEmail\" epi-validate-show-messages=\"epi-validate-show-messages\" ng-submit=\"saveEmail(email)\"><h4>Email Details for '{{email.subject}}'</h4><p class=\"text-danger\" ng-if=\"errors\" ng-repeat=\"(key, error) in errors\"><span ng-repeat=\"err in error\">{{err}}</span></p><input class=\"name\" type=\"text\" placeholder=\"Name\" ng-model=\"email.description\" epi-validate=\"required\" epi-validate-messages=\"{required: 'Please enter a name for this email'}\" name=\"name\"><input class=\"subject\" type=\"text\" placeholder=\"Subject\" ng-model=\"email.subject\" epi-validate=\"required\" epi-validate-messages=\"{required: 'Please enter a subject for this email'}\" name=\"subject\"><textarea id=\"main-editor\" redactor=\"redactor\" ng-model=\"email.body\" epi-validate=\"required\" epi-validate-messages=\"{required: 'Please enter text for this email'}\" name=\"body\"></textarea><div class=\"controls\"><span class=\"btn plain\" ng-click=\"closeRightSide()\">Cancel</span><input class=\"btn\" type=\"submit\" value=\"Save\" ng-hide=\"saving\"><button class=\"btn\" ng-disabled=\"true\" ng-show=\"saving\"><span class=\"small-loading-indicator\"></span><span>Saving...</span></button></div></form>";

},{}],"T8ALW":[function(require,module,exports) {
module.exports = "<nav class=\"navbar navbar-default\" id=\"top-nav-secondary\"><h3>Emails</h3><ul class=\"nav navbar-nav\"></ul></nav><div class=\"row\" id=\"content\"><div id=\"data\"><div id=\"data-emails-wrap\" left-side=\"left-side\"><h4 ng-show=\"!emails.length\">No emails matched your search</h4><table id=\"data-emails\"><tbody ng-if=\"emails.length == 0 &amp;&amp; search != ''\"><tr><td>Sorry, no emails matched your search</td></tr></tbody><tbody><tr ng-repeat=\"email in emails track by email.ID\" ng-if=\"!email.archived || !showArchive\" ng-class=\"savedEmail == email.ID ? 'active' : '' \"><td class=\"name\">{{email.description}}</td><td class=\"controls\"><button class=\"btn edit\" ui-sref=\"admin.emails.edit({ emailID: email.ID })\" ui-sref-opts=\"{location: false}\" title=\"Edit '{{email.subject}}'\"></button></td><td class=\"controls\"><button class=\"btn del\" epi-confirm=\"Are you sure you want to do this?\" confirm-idiot=\"{{email.subject}}\" confirm-callback=\"deleteEmail(email)\" confirm-yes=\"delete\" title=\"Delete '{{email.subject}}'\"></button></td></tr></tbody></table></div><div class=\"right-wrap\"><div ui-view=\"right\" right-side-width=\"50%\"></div></div></div></div>";

},{}],"iuZSk":[function(require,module,exports) {
module.exports = "<nav class=\"navbar navbar-default\" id=\"top-nav-secondary\"><ul class=\"nav navbar-nav\"><li>Users:<input type=\"text\" placeholder=\"SEARCH\" ng-model=\"searchQueries.users\"></li><li class=\"search-filter\"><div class=\"select-holder\"><select ng-model=\"searchFields.users\"><option value=\"name\">Name</option><option value=\"email\">Email</option></select></div></li><li>Entities:<input type=\"text\" placeholder=\"SEARCH\" ng-model=\"searchQueries.entities\"></li><li class=\"search-filter\"><div class=\"select-holder\"><select ng-model=\"searchFields.entities\"><option value=\"name\">Name</option><option value=\"username\">User Name</option></select></div></li></ul></nav><div id=\"content\"><div class=\"admin-entities row\"><div class=\"col-sm-4\"><ul class=\"sortable-list user-list\" ui-sortable=\"sortableOptions\" ng-model=\"users\"><li ng-repeat=\"user in users\"><span ng-show=\"!!user.fname || !!user.lname\">{{user.fname}} {{user.lname}}</span><span ng-show=\"!user.fname &amp;&amp; !user.lname\">[no name] {{user.uname}}</span><div class=\"controls\"><button class=\"btn del\" title=\"Delete '{{user.fname}} {{user.lname}}'\" epi-confirm=\"Are you sure you want to delete '{{user.fname}} {{user.lname}}'?\" confirm-yes=\"Delete\" confirm-callback=\"deleteUser($index, user)\"></button><button class=\"btn settings\" title=\"Edit settings for '{{user.fname}} {{user.lname}}'\" ui-sref=\"admin.users-and-entities.edit-user.permissions({userID: user.ID})\"></button><button class=\"btn edit white\" title=\"Edit '{{user.fname}} {{user.lname}}'\" ui-sref=\"admin.users-and-entities.edit-user({userID: user.ID})\"></button></div></li></ul><div class=\"bottom-bar\"><button class=\"add btn\" ng-click=\"createUser()\"></button><div class=\"epi-paging pagination\" pages=\"users.meta\" collection=\"users\" verbosity=\"2\"></div></div></div><div class=\"col-sm-4\"><ul class=\"entity-list\"><li ng-repeat=\"entity in entities\"><h4>{{entity.name}}</h4><div class=\"controls\"><a ui-sref=\"admin.users-and-entities.edit-entity({id: entity.ID})\"><button class=\"btn edit\" title=\"Edit '{{entity.name}}'\"></button></a><a ui-sref=\"admin.users-and-entities.edit-entity-permissions({id: entity.ID})\"><button class=\"btn settings\" title=\"Edit the settings for '{{entity.name}}'\"></button></a></div><ul class=\"entities-user-sublist sortable-list\" ui-sortable=\"sortableOptions\" ng-model=\"entity.users\" ng-class=\"!entity.users.length ? 'empty' : ''\"><li ng-repeat=\"user in entity.users\">{{user.fname}} {{user.lname}}</li></ul></li></ul><div class=\"bottom-bar\"><button class=\"add btn\" ng-click=\"createEntity()\"></button><div class=\"epi-paging pagination\" pages=\"entities.meta\" collection=\"entities\" verbosity=\"2\"></div></div></div><div class=\"right-wrap\"><div ui-view=\"right\"></div></div></div></div>";

},{}],"gz0L3":[function(require,module,exports) {
module.exports = "<div class=\"multiselect\" off-click=\"isDropdownOpen = false\"><div class=\"toggle\" ng-click=\"isDropdownOpen = !isDropdownOpen\">{{ index.columns.length ? getNames() : 'Select...' }}</div><div class=\"dropdown\" ng-show=\"isDropdownOpen\" ui-sortable=\"sortableOptions\" ng-model=\"columns\"><div class=\"option\" ng-repeat=\"column in columns track by column.column\" ng-init=\"id = 'column-' + generateID(column.name)\"><div class=\"btn draggable\" ng-show=\"isChecked(index, column.column)\"></div><input type=\"checkbox\" checklist-model=\"index.columns\" checklist-value=\"column\" id=\"{{id}}\" ng-class=\"{_checked: isChecked(index, column.column)}\"><label class=\"checkbox\" for=\"{{id}}\">{{column.name}}</label><div class=\"select-holder\" ng-show=\"isChecked(index, column.column)\"><select ng-model=\"column.order\" ng-options=\"order for order in ['ASC', 'DESC']\"><option disabled selected value=\"\">Order...</option></select></div></div></div></div><input type=\"checkbox\" ng-model=\"index.unique\" id=\"{{checkboxID}}\" ng-class=\"{_checked: index.unique}\"><label class=\"checkbox\" for=\"{{checkboxID}}\">Unique</label><button class=\"btn del\" ng-click=\"removeIndex()\" ng-show=\"removeIndex\"></button>";

},{}],"9KHDP":[function(require,module,exports) {
module.exports = "<h4>Indexes</h4><index-creator ng-repeat=\"index in indexes\" ng-model=\"index\" collection=\"collection\" remove-index=\"indexes.splice($index,1)\"></index-creator><hr><div class=\"create\" ng-init=\"index = {columns: []}\"><index-creator ng-model=\"index\" collection=\"collection\"></index-creator><button class=\"btn\" ng-click=\"indexes.push(index); index = {columns: []}\" ng-disabled=\"!index.columns.length\">Add Index</button></div>";

},{}],"joJim":[function(require,module,exports) {
module.exports = "<div id=\"collection-create\"><h3 ng-if=\"mode == 'creating'\">Create Collection</h3><h3 ng-if=\"mode == 'editing'\" title=\"Collection ID: {{collection.ID}}\">Edit '{{collection.name}}'</h3><form class=\"form-horizontal\" name=\"create\" epi-validate-show-messages=\"true\"><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"name\">Name:</label><input class=\"col-md-6\" type=\"text\" placeholder=\"Collection Name\" epi-validate=\"required|unique:collections,name,collectionIndex\" epi-validate-messages=\"{required: 'Please enter a name for this collection', unique: 'Sorry this name is already being used'}\" name=\"name\" ng-model=\"collection.name\"></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"type\">Type:</label><div class=\"select-holder\"><select ng-model=\"collection.type\" ng-options=\"type.type as type.name for type in collectionTypes\" name=\"type\" epi-validate=\"required\" ng-change=\"collection.indexes = []; collection.refreshEnabled = false\" ng-disabled=\"!!collection.ID\"></select></div><span ng-show=\"collection.type == 'transform'\"><input type=\"checkbox\" ng-model=\"collection.refreshEnabled\" id=\"refresh-enabled\" ng-class=\"{_checked: collection.refreshEnabled}\"><label class=\"checkbox\" for=\"refresh-enabled\">Automatically Refresh</label></span></div><section ng-show=\"collection.type == 'master'\" ng-disabled=\"collectionIsSaving||uploader.getInProgress()\"><div class=\"form-group\"><fieldset><legend>Files</legend><div class=\"filenames\" ng-init=\"showMoreFiles = false\"><p class=\"error-message text-danger\" ng-show=\"errorMsg\">{{errorMsg}}</p><p ng-show=\"uploader.getInProgress()\">{{uploadState.prettyProgress}}</p><p ng-show=\"uploadState.uploads.length == 0\">[no file(s) selected]</p><p ng-show=\"uploadState.uploads.length == 0\">Supported file types:</p><ul ng-show=\"uploadState.uploads.length == 0\"><li ng-repeat=\"fileType in collections.meta.fileTypesForHumans\">{{fileType}}</li></ul><p ng-show=\"uploadState.uploads.length != 0\" ng-repeat=\"file in uploadState.uploads track by file.id\" ng-if=\"$index &lt; 2\">{{file.name}}</p><p class=\"show-more\" ng-show=\"uploadState.uploads.length &gt;= 3 &amp;&amp; !showMoreFiles\" ng-click=\"showMoreFiles = true\">show {{ uploadState.uploads.length - 2}} more...</p><p class=\"show-more\" ng-show=\"uploadState.uploads.length &gt;= 3 &amp;&amp; showMoreFiles\" ng-click=\"showMoreFiles = false\">show less...</p><p slide-away=\"showMoreFiles\" ng-repeat=\"file in uploadState.uploads track by file.id\" ng-if=\"$index &gt;= 2\" ng-click=\"showMoreFiles = !showMoreFiles\">{{file.name}}</p><span class=\"text-success\" fade-away=\"uploadState.uploadstate.uploadComplete\">File uploaded</span></div><span class=\"btn clear-files del\" ng-show=\"!uploader.getInProgress() &amp;&amp; uploadState.progress != 1 &amp;&amp; uploadState.uploads.length &amp;&amp; !uploadState.uploadComplete\" ng-click=\"cancel()\" title=\"Clear File{{uploadState.uploads.length &gt; 1 ? 's' : ''}}\"></span><span class=\"btn clear-files del\" ng-show=\"uploadState.uploads.length\" ng-click=\"cancel()\" title=\"Clear File{{uploadState.uploads.length &gt; 1 ? 's' : ''}}\"></span></fieldset><div class=\"file-controls\"><p ng-show=\"uploader.getInProgress() &amp;&amp; uploader.state.progress != 1\">Uploading...</p><p ng-show=\"uploader.getInProgress() &amp;&amp; uploader.state.progress == 1\">Processing...</p><progressbar value=\"uploadState.progress * 100\" type=\"{{uploadState.progress == 1 &amp;&amp; !$scope.errorMsg ? 'success' : ''}}\" ng-class=\"{'progress-striped active': uploadState.progress == 1}\" ng-show=\"uploader.getInProgress() || collectionIsSaving\"></progressbar><span class=\"btn disabled orange\" ng-show=\"uploadState.uploads.length\"><span ng-if=\"mode === 'creating'\">Select File</span><span ng-if=\"mode === 'editing'\">Select New File</span></span><fine-uploader options=\"uploaderOptions\"><span class=\"btn orange\" fine-uploader-button=\"fine-uploader-button\" title=\"Select a collection file to upload\" id=\"select-file\" ng-hide=\"uploadState.uploads.length\"><span ng-if=\"mode === 'creating'\">Select File</span><span ng-if=\"mode === 'editing'\">Select New File</span></span></fine-uploader></div></div></section><section class=\"user-defined-properties\" ng-if=\"collection.type == 'writable'\"><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"srid\">SRID:</label><input class=\"col-md-6\" type=\"number\" placeholder=\"SRID (integer)\" epi-validate=\"required|regex:^\\d+$\" epi-validate-messages=\"{required: 'Please enter an SRID', regex: 'Must be an integer'}\" name=\"srid\" ng-model=\"collection.srid\" list=\"srid-suggestions\"><datalist id=\"srid-suggestions\"><option value=\"2163\" label=\"2163: US National Atlas Equal Area. Unit: Meter (IOGP deprecated)\"></option><option value=\"2784\" label=\"2784: NAD83(HARN) / Hawaii zone 3. Unit: Meter\"></option><option value=\"2784\" label=\"3857: Web Mercator. Unit: Meter\"></option><option value=\"4269\" label=\"4269: NAD83. Unit: Degree\"></option><option value=\"4326\" label=\"4326: WGS 84 / World Geodetic System 1984. Unit: Degree\"></option><option value=\"9311\" label=\"9311: NAD27 / US Equal Area. Unit: Meter (Replaces 2163)\"></option></datalist></div><div class=\"form-group\"><h4>Extra Properties</h4><p ng-if=\"!userDefinedProperties\">No User Defined Properties</p><div class=\"property\" ng-repeat=\"property in userDefinedProperties\" title=\"{{property}}\"><input type=\"text\" ng-model=\"property.name\" placeholder=\"Property name\" title=\"User facing name for the property\"><div class=\"select-holder\"><select ng-model=\"property.type\" ng-options=\"type.type as type.label for type in userDefinedPropertyTypes\" ng-disabled=\"mode == 'editing' &amp;&amp; !!property.column\"></select></div><div class=\"property-options\"><div class=\"property-option\"><input type=\"checkbox\" ng-model=\"property.required\" id=\"property-required-{{ $index }}\" ng-class=\"{_checked: property.required}\" title=\"If true, the property is marked as required for map actions\"><label class=\"checkbox\" for=\"property-required-{{ $index }}\" title=\"If true, the property is marked as required for map actions\">Required</label></div><div class=\"property-option\"><input type=\"checkbox\" ng-model=\"property.hidden\" id=\"property-hidden-{{ $index }}\" ng-class=\"{_checked: property.hidden}\" title=\"If true, the property should be hidden from the user\"><label class=\"checkbox\" for=\"property-hidden-{{ $index }}\" title=\"If true, the property should be hidden from the user\">Hidden</label></div><div class=\"property-option\"><input type=\"checkbox\" ng-model=\"property.protected\" id=\"property-protected-{{ $index }}\" ng-class=\"{_checked: property.protected}\" title=\"If true, users will not be able to edit this property\"><label class=\"checkbox\" for=\"property-protected-{{ $index }}\" title=\"If true, the property should be protected from the user\">Protected</label></div></div><input type=\"text\" ng-model=\"property.column\" disabled placeholder=\"Property column\" title=\"Name of the column for the property in the database\"><button class=\"btn del\" ng-click=\"removeUserDefinedProperty(property)\" title=\"Delete the property. Warning: all maps using this collection will be broken until a browser refresh.\"></button></div><div class=\"add-property\" ng-click=\"newUserDefinedProperty()\"><button class=\"add btn\"></button><span>Add Property</span></div></div></section><div class=\"sql-editor\" ng-if=\"collection.type == 'transform' || collection.type == 'dynamic'\" sql-model=\"collection.sql\" sql-results=\"sqlResults\"></div><p class=\"error-message text-danger\" ng-show=\"errorMsg &amp;&amp; collection.type != 'master'\">{{errorMsg}}</p><div class=\"date-column form-group\" slide-away=\"collection.type == 'dynamic'\"><div class=\"col-md-3 control-label\"><label for=\"dateColumn\">Date Column:</label></div><div class=\"col-md-9\"><input id=\"dateColumn\" type=\"text\" ng-model=\"collection.dateColumn\" name=\"dateColumn\"></div></div><div class=\"text-danger\">{{indexesError}}</div><div class=\"indexes-creator\" ng-model=\"collection.indexes\" collection=\"collection\" slide-away=\"(uploadState.uploadComplete &amp;&amp; collection.type == 'master') || (collection.type == 'transform' &amp;&amp; sqlTestPassed) || (collection.ID &amp;&amp; mode == 'editing' &amp;&amp; collection.type != 'dynamic')\"></div><div class=\"form-group\" ng-if=\"collection.ID &amp;&amp; mode == 'editing' &amp;&amp; collection.type != 'writable'\"><label class=\"col-md-3 control-label\" for=\"idColName\">ID Column:</label><div class=\"select-holder\"><select ng-model=\"collection.idColName\" ng-options=\"prop.column as prop.name for prop in collection.properties\" name=\"idColName\"><option value=\"\">None</option></select></div></div><div class=\"form-group\"><div class=\"col-md-3 control-label\"><label for=\"noun\">Noun (singular—for action messages):</label></div><div class=\"col-md-9\"><input id=\"noun\" type=\"text\" ng-model=\"collection.noun\" name=\"noun\"></div></div><div><div class=\"epi-checkbox form-group\" model=\"showAggregates\" input-id=\"showAggregates\" label=\"Add Aggregate Values\"></div><div class=\"aggregates\" ng-if=\"showAggregates\"><div class=\"sql-editor\" sql-model=\"collection.aggSql\" sql-results=\"aggResults\"></div></div></div><div class=\"controls\"><span class=\"btn plain\" ng-click=\"closePanel()\">Close</span><span class=\"btn\" ng-click=\"saveAsMaster(collection)\" ng-if=\"collection.type == 'transform' &amp;&amp; mode == 'editing'\">Save as Master</span><span class=\"btn orange\" ng-class=\"{'disabled': collectionIsSaving}\" ng-click=\"uploadState.uploads.length &amp;&amp; !uploadState.uploadComplete ? beginUpload() : collectionIsSaving || save(collection)\"><span>{{ (collection.ID ? 'Updat' : 'Creat') + (collectionIsSaving ? 'ing' : 'e') }}</span><span class=\"small-loading-indicator\" ng-if=\"collectionIsSaving\"></span></span></div></form></div>";

},{}],"awWHi":[function(require,module,exports) {
module.exports = "<div class=\"modal-header\"><h3>Records already exist in this collection. <br> Would you like to:</h3></div><div class=\"modal-footer\"><button class=\"btn\" ng-click=\"$dismiss()\">Cancel</button><button class=\"btn\" ng-click=\"$close(false)\">Overwrite</button><button class=\"btn\" ng-click=\"$close(true)\">Append / Merge</button></div>";

},{}],"iRNa5":[function(require,module,exports) {
module.exports = "<div class=\"modal-header\"><h3>Save as Master</h3></div><div class=\"modal-body\"><form epi-validate-show-messages=\"true\" ng-submit=\"forms.saveAsMaster.isValid() ? $close(masterCollectionName) : ''\" name=\"saveAsMaster\"><input type=\"text\" placeholder=\"Collection name\" epi-validate=\"unique:collections,name\" ng-model=\"masterCollectionName\" name=\"collectionName\"></form></div><div class=\"modal-footer\"><button class=\"btn plain\" ng-click=\"$dismiss()\">Cancel</button><button class=\"btn\" ng-click=\"$close(masterCollectionName)\" ng-disabled=\"!forms.saveAsMaster.isValid()\">Save</button></div>";

},{}],"kEGXz":[function(require,module,exports) {
module.exports = "<div id=\"content-wrap\"><epi-data-navbar></epi-data-navbar><div class=\"has-navbar no-secondary-menu row\" id=\"content\"><div id=\"data\"><epi-data-collections> </epi-data-collections><div class=\"right-wrap\"><div ui-view=\"right\" right-side-width=\"48%\"></div></div><epi-infinite-console></epi-infinite-console></div></div></div>";

},{}],"gb10u":[function(require,module,exports) {
module.exports = "<div id=\"content-wrap\" ui-view=\"\"></div>";

},{}],"8q2BH":[function(require,module,exports) {
module.exports = "<div class=\"error full-width\" id=\"content\"><h1>{{error.code}}</h1><p><em>{{error.message}}</em></p></div>";

},{}],"1jPlQ":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><h4>Enter a name for the cloned theme</h4><input type=\"text\" ng-model=\"theme.name\"></div><div class=\"modal-footer\"><div class=\"controls\"><button class=\"btn light-blue\" ng-click=\"$close(theme)\">Save</button><button class=\"btn plain\" ng-click=\"$dismiss()\">Cancel</button></div></div>";

},{}],"jnuye":[function(require,module,exports) {
module.exports = "<div class=\"truterritory-download-image\" ng-class=\"{'bounding-box-is-visible': boundingBoxIsVisible, test: true}\"><form class=\"selector\" fade-away=\"boundingBoxIsVisible\" name=\"downloadImageForm\" ng-submit=\"downloadImage()\"><div class=\"dimension\"><label>Width:</label><input class=\"sm\" type=\"number\" ng-model=\"dimensions.width\" name=\"width\" max=\"{{mapSize.x}}\" ng-change=\"changeSize(dimensions.width, dimensions.height)\"><span>px</span></div><div class=\"dimension\"><label>Height:</label><input class=\"sm\" type=\"number\" ng-model=\"dimensions.height\" name=\"height\" max=\"{{mapSize.y}}\" ng-change=\"changeSize(dimensions.width, dimensions.height)\"><span>px</span></div><div class=\"dimension\"><label title=\"Magnification\">Mag:</label><div class=\"select-holder\"><select ng-model=\"dimensions.zoom\" ng-options=\"size.value as size.name for size in sizes\"></select></div></div><div class=\"controls\"><button class=\"btn\" type=\"submit\">Download Image</button></div></form><button class=\"btn done\" ng-show=\"boundingBoxIsVisible\" ng-click=\"close(); boundingBoxIsVisible = false\">Done</button><button class=\"btn download\" ng-hide=\"boundingBoxIsVisible\" ng-click=\"createBoundingBox(); boundingBoxIsVisible = true\" ng-disabled=\"boundingBoxIsVisible\"></button></div>";

},{}],"53Ksa":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><h4>Permalink:</h4><input class=\"link\" type=\"text\" ng-model=\"modal.link\" select-element=\"select-element\" readonly ng-disabled=\"modal.expires &amp;&amp; !modal.expiringUUID || modal.showAnnotations &amp;&amp; !modal.annotationsOption\"><input id=\"useCenterZoom\" type=\"checkbox\" ng-model=\"modal.useCenterZoom\" ng-change=\"modal.generateLink()\" ng-class=\"{_checked: modal.useCenterZoom}\"><label class=\"checkbox\" for=\"useCenterZoom\">Use current center and zoom</label><input id=\"showAnnotations\" type=\"checkbox\" ng-model=\"modal.showAnnotations\" ng-change=\"modal.generateLink()\" ng-class=\"{_checked: modal.showAnnotations}\"><label class=\"checkbox\" for=\"showAnnotations\">Show annotations</label><div class=\"expires\" ng-form=\"ng-form\" name=\"expiresForm\"><input id=\"expires\" type=\"checkbox\" ng-model=\"modal.expires\" ng-class=\"{_checked: modal.expires}\" ng-change=\"modal.setExpiresAt()\"><label class=\"checkbox\" for=\"expires\">Expires At:</label><input type=\"text\" ng-model=\"modal.expiresAt\" ng-disabled=\"!modal.expires\" ng-click=\"expiresAtOpen = true\" ng-change=\"modal.setExpiresAt()\" uib-datepicker-popup=\"yyyy/MM/dd\" is-open=\"expiresAtOpen\" datepicker-options=\"modal.datepickerOptions\" placeholder=\"Today\"></div><div class=\"password\" ng-if=\"modal.hasAccess('update')\"><input id=\"requirePassword\" type=\"checkbox\" ng-model=\"modal.requirePassword\" ng-class=\"{_checked: modal.requirePassword}\" ng-change=\"modal.setPassword()\"><label class=\"checkbox\" for=\"requirePassword\">Require Password:</label><input type=\"text\" ng-model=\"modal.map.password\" ng-disabled=\"!modal.requirePassword\"><button class=\"btn generate\" ng-click=\"modal.generatePassword()\" ng-disabled=\"modal.generating\"></button><button class=\"apply btn light-blue\" ng-click=\"modal.setPassword()\" ng-disabled=\"!modal.requirePassword || modal.map.password == modal.oldPassword\">Apply</button></div><div class=\"password\" ng-if=\"!modal.hasAccess('update') &amp;&amp; !!modal.map.password\"><p>Password:<em> {{ modal.map.password }}</em></p></div></div><div class=\"modal-footer\"><div class=\"controls\"><div ng-if=\"modal.hasAccess('update')\"><p class=\"text-danger\" ng-show=\"modal.confirming\">Generating a new link will break the previous link. Continue?</p><button class=\"btn reset\" ng-click=\"modal.confirming = true\" ng-show=\"!modal.confirming\">Generate New Link</button><button class=\"btn confirm\" ng-click=\"modal.reset()\" ng-show=\"modal.confirming\" ng-disabled=\"modal.saving\">Continue</button><button class=\"btn cancel\" ng-click=\"modal.confirming = false\" ng-show=\"modal.confirming\" ng-disabled=\"modal.saving\">Cancel</button></div><button class=\"btn light-blue\" ng-click=\"$close()\">Close</button></div></div>";

},{}],"l9eLe":[function(require,module,exports) {
module.exports = "<div id=\"truterritory-workspace-module\"><epi-dropdown-selector selection=\"workspace\" items=\"workspaces\" on-click=\"selectWorkspace\" on-delete=\"removeWorkspace\" max-width=\"'170%'\" min-width=\"'85%'\" restricted=\"'default'\" open-workspace-modal=\"openWorkspaceModal\" create-workspace=\"createWorkspace\"></epi-dropdown-selector><div class=\"workspaces\"><h4>Maps in '{{workspace.name}}'</h4><h4 class=\"empty\" slide-away=\"!workspace.maps.length\">There are no maps in this workspace</h4><ul class=\"map-list\" ui-sortable=\"mapDroppable\" ng-model=\"workspace.maps\" nicescroll=\"{autohidemode: false}\"><li class=\"map-drop\" ng-repeat=\"map in workspace.maps\" ng-class=\"{active: map.ID == $parent.map.ID}\"><div class=\"text\">{{map.name}}</div><button class=\"btn del\" ng-if=\"hasAccess('delete')\" epi-confirm=\"Are you sure you want to delete '{{map.name}}'?\" confirm-yes=\"Delete\" confirm-callback=\"deleteMap(map)\"></button></li></ul><p class=\"info\">You can choose which map to view in order to get the data you need</p></div><div class=\"collections\"><h4>Collections</h4><div class=\"input-search\"><input class=\"search\" type=\"text\" placeholder=\"Search:\" ng-model=\"search\" ng-change=\"filterCollections(search, limitToWorkspace)\"></div><input type=\"checkbox\" ng-model=\"limitToWorkspace\" id=\"limitToWorkspace\" name=\"limitToWorkspace\" ng-class=\"{_checked: !!limitToWorkspace}\" ng-change=\"filterCollections(search, limitToWorkspace)\"><label class=\"checkbox\" for=\"limitToWorkspace\" title=\"Limit the collections to the current workspace\">&nbsp; Limit to Workspace</label><h4 class=\"empty\" slide-away=\"collections.length &lt;= 0 &amp;&amp; limitToWorkspace\">There are no collections in this workspace</h4><ul class=\"collection-list\" ui-sortable=\"collectionDroppable\" ng-model=\"collections\" nicescroll=\"{autohidemode: false}\"><li class=\"collection collection-drop\" ng-repeat=\"collection in collections track by collection.ID\" uib-tooltip=\"{{collection.name}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\" ng-class=\"{'active': isCollectionActive(collection.ID), disabled: !hasAccess('update')}\"><div class=\"{{collection.geometryType}} text\" ng-class=\"\">{{collection.name}}</div><button class=\"btn del\" ng-if=\"limitToWorkspace == true &amp;&amp; hasAccess('delete')\" epi-confirm=\"Are you sure you want to remove '{{collection.name}}' from the current workspace?\" confirm-yes=\"Remove\" confirm-callback=\"removeCollection(collection.ID)\"></button></li></ul><p class=\"info\">You can drag any collection from this section onto the map to see the result</p></div><div epi-user-selector=\"epi-user-selector\" users=\"workspace.users\" allow-emails=\"false\" on-add=\"saveUsers($users)\" on-remove=\"removeUser($user.ID)\" show-header=\"true\" fade-switch=\"!workspace.default\" show-delete=\"canRemoveUser(user.ID)\"></div><div class=\"options\"><input type=\"checkbox\" ng-model=\"workspace.sharingEnabled\" id=\"sharingEnabled\" ng-class=\"{_checked: !!workspace.sharingEnabled}\" ng-change=\"updateWorkspace()\"><label class=\"checkbox\" for=\"sharingEnabled\">Enable sharing via public links</label></div><h4 class=\"empty share-default\" fade-switch=\"workspace.default\">To share your workspace, first create and name a new one</h4></div>";

},{}],"kk1Wg":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><p>You are the last user in this workspace. Removing yourself from this workspace will also delete the workspace. Are you sure you want to do this?</p></div><div class=\"modal-footer\"><div class=\"controls\"><button class=\"btn\" ng-click=\"$close()\">Confirm</button><button class=\"btn plain\" ng-click=\"$dismiss()\">Cancel</button></div></div>";

},{}],"fkUrO":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><form ng-submit=\"$close(name)\"><p ng-if=\"first\">A password is required to view this map.</p><p ng-if=\"!first\">The password you entered is incorrect. Please try again.</p><input type=\"password\" ng-model=\"password\"><button class=\"btn light-blue\" ng-click=\"$close(password)\" ng-disabled=\"!password\">Continue</button></form></div>";

},{}],"fdMav":[function(require,module,exports) {
module.exports = "<form name=\"newWorkspace\" ng-submit=\"save()\" epi-validate-show-messages=\"epi-validate-show-messages\" epi-validate=\"\"><div class=\"modal-body\"><h4>Workspace Name:</h4><input type=\"text\" ng-model=\"workspace.name\" name=\"workspaceName\" epi-validate=\"required|unique:workspaces,name\" epi-validate-messages=\"{unique: 'Sorry this name is already being used'}\"></div><div class=\"modal-footer\"><div class=\"controls\"><button class=\"btn light-blue\" type=\"submit\" ng-disabled=\"saving\">Save</button><button class=\"btn plain\" type=\"button\" ng-click=\"$dismiss()\">Cancel</button></div></div></form>";

},{}],"cCWhu":[function(require,module,exports) {
module.exports = "<code-mirror options=\"codeMirrorOptions\" ng-model=\"sql\" ng-change=\"results.success = false\" epi-validate=\"requiredIf:type,transform\" name=\"sql\"></code-mirror><span class=\"btn\" ng-click=\"!results.success &amp;&amp; !testing &amp;&amp; test()\" ng-class=\"{disabled: testing || results.success}\">Explain SQL</span><span class=\"text-success\" fade-away=\"showSuccess\">SQL passed!</span><div class=\"errors text-danger\">{{errors}}</div><div class=\"sql-explain\" ng-if=\"results.explain\"><textarea disabled>{{ results.explain.join(\"\\n\") }}</textarea></div>";

},{}],"bDQzb":[function(require,module,exports) {
module.exports = "<div id=\"truterritory-theme-editor\"><div class=\"left-side\"><h4 editable-text=\"theme.name\" onaftersave=\"save()\">{{theme.name}}</h4><button class=\"btn del delete-theme\" ng-if=\"theme.ID\" epi-confirm=\"Are you sure you want to delete this theme?\" confirm-callback=\"deleteTheme()\" confirm-yes=\"Delete\" title=\"Delete '{{theme.name}}'\"></button><div class=\"attribute\"><label>Label</label><div class=\"select-holder\"><select ng-model=\"theme.label\">//- ng-options=\"prop.column as prop.name for (key, prop) in collection.properties\")<option value=\"\" ng-selected=\"!theme.label\">(no label)</option><option ng-repeat=\"prop in collection.properties\" value=\"{{prop.column}}\" ng-selected=\"prop.column == theme.label\">{{prop.name}}</option></select></div></div><div class=\"attribute\"><label>Custom Label</label><input type=\"text\" ng-model=\"theme.customLabel\"></div><div class=\"attribute\"><label>Font Size</label><input type=\"number\" ng-model=\"theme.fontSize\"></div><div class=\"attribute\"><input type=\"checkbox\" ng-model=\"theme.previewFeatures\" id=\"enablePreviewFeatures\" title=\"Enable Preview Features?\" ng-class=\"{'_checked': theme.previewFeatures}\"><label class=\"checkbox\" for=\"enablePreviewFeatures\" title=\"Enable use of features-in-progress\">Preview Features</label></div><div class=\"format-labels\"><label>Format Labels:</label><div class=\"label-format-header\"><h5 class=\"col-md-6\">Label</h5><h5 class=\"col-md-3\">Format</h5><h5 class=\"col-md-3 strip-zeroes\">Strip Zeroes</h5></div><div class=\"label-format\"><div class=\"attribute select-holder\"><select ng-model=\"editingLabelFormat\"><option ng-repeat=\"prop in collection.properties track by prop.column\" ng-value=\"'{{prop.column}}'\" ng-disabled=\"propertyLabelShouldBeDisabled(prop, theme)\" ng-selected=\"prop.column == editingLabelFormat\">{{prop.name}}</option></select></div><input class=\"number\" ng-model=\"theme.labelFormats[editingLabelFormat]\" type=\"text\"><input type=\"checkbox\" ng-model=\"theme.labelZeroes[editingLabelFormat]\" id=\"labelZeroes\" ng-class=\"{'_checked': theme.labelZeroes[editingLabelFormat]}\"><label class=\"checkbox\" for=\"labelZeroes\" title=\"Strip zeroes from formatted labels\"></label></div></div><div class=\"controls\"><button class=\"btn plain\" ng-click=\"close()\">Cancel</button><button class=\"btn\" ng-click=\"save()\" ng-disabled=\"areErrors || saveInProgress\">Save</button><button class=\"btn\" ng-click=\"save(); close()\" ng-disabled=\"areErrors || saveInProgress\">Save &amp; Close</button></div></div><div class=\"right-side\" ng-init=\"tab = 'css'\"><div class=\"tabs\"><div class=\"tab\" ng-click=\"tab = 'css'\" ng-class=\"{active: tab == 'css'}\">CSS</div><div class=\"tab\" ng-click=\"tab = 'expanded-css'; validateCSS(theme.css)\" ng-class=\"{active: tab == 'expanded-css'}\">Expanded CSS</div><div class=\"tab\" ng-click=\"tab = 'legend'\" ng-class=\"{active: tab == 'legend'}\">Legend Editor</div></div><div class=\"tab-content\"><div class=\"css-editor\" fade-away=\"tab == 'css'\"><code-mirror options=\"editorOptions\" entityID=\"$root.entityID\" ng-model=\"theme.css\" on-blur=\"validateCSS(theme.css)\" cm-color-picker=\"cm-color-picker\" cm-image-uploader=\"cm-marker cm-markerUrl\" cm-image-preview=\"cm-url\" cm-errors=\"cssErrors\" ng-change=\"validateCSSOnKeystroke(theme.css)\"></code-mirror></div><div class=\"css-expanded-view\" fade-away=\"tab == 'expanded-css'\"><code-mirror id=\"expanded-css\" disabled options=\"{mode:'cartocss',readOnly:true}\" ng-model=\"parsedCSS\" cm-errors=\"cssErrors\"></code-mirror></div><div class=\"legend-editor\" fade-away=\"tab == 'legend'\"><div class=\"legend\"><div class=\"entries\"><h4>Entries</h4><div class=\"entry\" ng-repeat=\"legend in theme.legend\"><div class=\"select-holder\"><select ng-options=\"key as name for (key, name) in legendTypes\" ng-model=\"legend.type\"></select></div><input type=\"text\" ng-model=\"legend.text\" placeholder=\"Legend Text\"><input type=\"number\" ng-model=\"legend.value\" ng-if=\"legend.type == 'line-width'\"><spectrum-colorpicker class=\"color\" ng-if=\"isLegendColor(legend.type)\" format=\"hex\" options=\"legendColorOptions\" ng-model=\"legend.value\"></spectrum-colorpicker><span ng-if=\"legend.type == 'aggregate'\"><div class=\"select-holder\"><select ng-options=\"column for column in collection.aggregates\" ng-model=\"legend.value\"></select></div><input type=\"text\" ng-model=\"legend.aggFormat\" placeholder=\"Number Format\"></span><button class=\"btn del\" ng-click=\"theme.legend.splice($index, 1)\"></button></div><div class=\"controls\"><button class=\"add-full btn\" ng-click=\"theme.legend.push({})\">Add Legend</button></div></div><div class=\"headers\"><h4>Headers</h4><input id=\"show-collection-name\" type=\"radio\" name=\"headerSettings\" value=\"1\" ng-model=\"legendSetting\"><label for=\"show-collection-name\" ng-click=\"theme.showLegendHeader = 0; theme.customLegendHeader = ''\">Show collection name only if other legends are present</label><input id=\"always-show-collection-name\" type=\"radio\" name=\"headerSettings\" value=\"2\" ng-model=\"legendSetting\"><label for=\"always-show-collection-name\" ng-click=\"theme.showLegendHeader = 1; theme.customLegendHeader = ''\">Always show collection name</label><input id=\"custom-header\" type=\"radio\" name=\"headerSettings\" value=\"3\" ng-model=\"legendSetting\"><label id=\"custom-header-label\" for=\"custom-header\" ng-click=\"theme.showLegendHeader = 1;\">Custom header:<input type=\"text\" placeholder=\"Custom header\" ng-model=\"theme.customLegendHeader\" ng-disabled=\"legendSetting != 3\"></label></div></div></div><div class=\"help-holder\" ng-init=\"helpOpen = false\" ng-show=\"tab=='css'||tab=='expanded-css'\"><div class=\"help-button\" ng-click=\"helpOpen = !helpOpen\"></div><div class=\"help\" slide-away=\"helpOpen\"><h4>Macros:</h4><div class=\"block\"><pre><b>setMarker(filename.ext)</b></pre><span>— Set a custom marker image</span></div><div class=\"block\"><pre><b>setLabel(label, size, color=null, dx=0, dy=0)</b></pre><span>— Set an automatically scaling label</span></div><div class=\"block\"><pre><b>smartScale(propertyName, valueToBeScaled, minimumResultValue=null, maximumResultValue=null, useDefaults=false)</b></pre><span>— Scales the value of an arbitrary property based on zoom level, such as text-size, marker-size, opacity, etc. Optionally set a minimum and maximum value (such as minimum or maximum text-size). If useDefaults is true, then the min/max values are used when out of bounds, rather than hiding the property.</span></div></div></div></div></div></div>";

},{}],"3K6VK":[function(require,module,exports) {
module.exports = "<div class=\"col-xs-2\" id=\"side-nav-right\" ng-class=\"{'bounding-box-is-visible': boundingBoxIsVisible, test: true}\"><button class=\"btn\" id=\"truterritory-draw\" ng-click=\"toggleDrawing()\" ng-class=\"{enabled: drawingEnabled}\" ng-disabled=\"!map.ID\"></button><div id=\"truterritory-permalink\" modal-map-permalink=\"modal-map-permalink\" ng-disabled=\"!map.ID || !workspace.sharingEnabled\"></div><epi-truterritory-download-image id=\"truterritory-download-image\" tru-map=\"truMap\" map=\"map\" ng-if=\"truMap &amp;&amp; map\" marker-id=\"markerID\" ng-class=\"{'bounding-box-is-visible': isSnippetToolOpen}\"></epi-truterritory-download-image><epi-tru-territory-bookmarks class=\"truterritory-bookmarks\" load-map=\"loadMapBookmark\" delete-map=\"deleteMap\" current-map=\"map\"></epi-tru-territory-bookmarks></div><epi-truterritory-navbar on-search=\"mapSearch\" map=\"map\" location-active=\"locationActive\" center-on-current-location=\"centerOnCurrentLocation\" update-map=\"updateMap\" are-tiles-loading=\"tilesLoading\" save-map=\"saveMap\" create-map=\"createMap\" workspace=\"workspace\" create-workspace-clone=\"createWorkspaceClone\" create-new-map=\"createNewMap\"></epi-truterritory-navbar><div class=\"has-navbar row\" id=\"content\"><div class=\"mapping\" id=\"top-nav-slider\" slide-away=\"topPanelSections.layers || topPanelSections.theme || topPanelSections.mapReports\"><epi-truterritory-theme-v2 ng-if=\"topPanelSections.theme\" on-save=\"onThemeSave\" on-delete=\"onThemeDelete\"></epi-truterritory-theme-v2><epi-truterritory-layers-v2 ng-if=\"topPanelSections.layers\" map=\"map\" workspace=\"workspace\" workspaces=\"workspaces\" set-workspace=\"setWorkspace\" remove-workspace=\"removeWorkspace\" update-workspace=\"updateWorkspace\" delete-map=\"deleteMap\" remove-collection=\"removeCollectionFromWorkspace\" create-workspace=\"createWorkspace\" save-users=\"saveUsers\" remove-user=\"removeUser\" add-map=\"addMapById\" add-collection=\"addCollectionForLayers\" remove-collection-from-map=\"removeCollection\"></epi-truterritory-layers-v2><div map-reports=\"map-reports\" ng-if=\"topPanelSections.mapReports\" map=\"map\" reports=\"map.reports\" workspace=\"workspace\"></div></div><div id=\"truterritory\"><div class=\"map-holder\"><div class=\"map-holder\" id=\"map-holder\"><epi-map-v2 center=\"savedCenter\" zoom=\"savedZoom\" scale=\"scale\" init=\"setupMap\" map=\"map\" selected-features=\"selectedFeatures\" actions=\"selectionActions\" reload=\"reload\"></epi-map-v2></div><epi-truterritory-history-slider ng-if=\"map.dateEnabled\" leaflet-map=\"truMap.getLeafletMap()\" on-change=\"timeframeChanged\"></epi-truterritory-history-slider><interval-slider ng-if=\"map.dateEnabled &amp;&amp; map.compEnabled\" map=\"truMap.getLeafletMap()\" ng-model=\"map.compInterval\" ng-change=\"timeframeChanged()\"></interval-slider><div class=\"legend\" map=\"truMap.getLeafletMap()\" legends=\"map.legends\" aggregates=\"map.aggregates\"></div></div><epi-truterritory-toggle-triangle></epi-truterritory-toggle-triangle><div class=\"right-side-menu right-wrap\" show=\"isSidePanelOpen\"><epi-truterritory-side key=\"map.ID\" right-side-width=\"400px\" right-side-width-small=\"300px\" map=\"map\" close=\"closeSidePanel\" remove-collection=\"removeCollection\" toggle-visible=\"toggleVisible\" toggle-selectable=\"toggleSelectable\" set-map-label=\"setMapLabel\" set-map-theme=\"setMapTheme\" add-theme=\"addTheme\" edit-theme=\"onThemeEdit\" clone-theme=\"cloneTheme\" set-filters=\"setFilters\" set-collections=\"setCollections\"></epi-truterritory-side></div></div></div>";

},{}],"1FnHi":[function(require,module,exports) {
module.exports = "<div class=\"modal-body\"><p>There are unsaved changes to the map. {{ msg }}</p></div><div class=\"controls\"><button class=\"btn\" ng-click=\"save()\">{{ saveText }}</button><button class=\"btn plain\" ng-click=\"$dismiss()\">{{ cancelText }}</button></div>";

},{}],"kALrP":[function(require,module,exports) {
module.exports = "<div class=\"menu\"><section ng-repeat=\"section in sections\"><h3 class=\"empty\" ng-if=\"!section.items.length\">Nothing here</h3><h3 ng-if=\"section.items.length\">{{section.header}}</h3><ul><li ng-repeat=\"item in section.items\" ng-click=\"select(section, item, $event)\">{{item.name}}</li></ul></section></div>";

},{}],"hjc13":[function(require,module,exports) {
module.exports = "<div class=\"map-point-detail\"><div class=\"controls\" ng-hide=\"editing || saving\"><button class=\"btn edit leaflet-btn plain\" ng-if=\"editable &amp;&amp; hasEditableColumns\" ng-click=\"$parent.editing = true\" title=\"Edit this feature\"></button><div class=\"copy-holder\" clipboard=\"csvCopy\"><button class=\"btn copy leaflet-btn\" title=\"Copy properties as CSV\"></button></div><button class=\"btn delete-3\" ng-click=\"close()\" title=\"Close popup\"></button></div><form class=\"form-horizontal\" ng-submit=\"save(feature, feature.properties, forms.pointEdit)\" name=\"point-edit\" epi-validate-show-messages=\"epi-validate-show-messages\"><table><tr ng-repeat=\"property in collection.properties\" ng-if=\"property.column != 'tags' &amp;&amp; !property.hidden &amp;&amp; !((property.system || property.protected) &amp;&amp; editing)\"><td title=\"{{property.column}}\">{{property.name}}:</td><td title=\"{{formattedDates[property.column] || feature.properties[property.column+'_label'] || feature.properties[property.column]}}\"><input type=\"text\" ng-model=\"feature.properties[property.column]\" ng-change=\"feature.properties[property.column+'_label'] = feature.properties[property.column]\" epi-validate=\"{{feature.validationRules[property.column]}}\" name=\"{{property.column}}\" ng-show=\"saving || editing\" title=\"{{feature.properties[property.column+'_label'] || feature.properties[property.column]}} ({{property.type}})\"><span ng-hide=\"saving || editing\">{{formattedDates[property.column] || feature.properties[property.column+'_label'] || feature.properties[property.column]}}</span></td></tr></table><div class=\"edit-controls\" ng-show=\"saving || editing\"><button class=\"btn leaflet-btn\" type=\"submit\" ng-hide=\"saving\">Save</button><button class=\"btn leaflet-btn\" type=\"submit\" ng-show=\"saving\" disabled><span class=\"small-loading-indicator\"></span><span>Saving...</span></button><span class=\"btn leaflet-btn plain\" ng-click=\"cancel()\" ng-hide=\"saving\">Cancel</span></div></form></div>";

},{}],"6XAL3":[function(require,module,exports) {
module.exports = "<div><div class=\"select-holder\"><select ng-model=\"model.fyMonth\" ng-change=\"days = getMonthDays(model.fyMonth)\"><option value=\"\" disabled>Select a month...</option><option ng-repeat=\"month in months\" ng-value=\"$index + 1\" ng-selected=\"$index + 1 == model.fyMonth\">{{ month }}</option></select></div><div class=\"select-holder\"><select ng-model=\"model.fyDay\" ng-disabled=\"\"><option value=\"\" disabled>Select a day...</option><option ng-repeat=\"day in days\" ng-value=\"$index + 1\" ng-selected=\"$index + 1 == model.fyDay\">{{ day }}</option></select></div></div>";

},{}],"91Jm1":[function(require,module,exports) {
/**
 * Configuration setup
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var constants = typeof globalConstants == "undefined" ? require("1e26c87263ee39ab") : globalConstants;
constants.INSTANCE_ID = getInstanceID();
var configModule = angular.module("configuration", []);
for(var name in constants)configModule.constant(name, constants[name]);
/**
 * Generates a random number between 0 and 1 (not including 1). It uses a cryptographically secure library when possible (window.crypto or window.mscrypto for some ie versions), and falls back to Math.random
 *
 * @returns {number}
 */ function random() {
    try {
        if (window && (window.crypto || window.msCrypto)) return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / 0x100000000; // 0x100000000 = max possible value for Uint32 + 1
    } catch (e) {
        // continue on, using basic math library. Be very conservative in how the warning is displayed to avoid another error
        window && window.console && window.console.warn("Failed to use cryptography library while generating a random number. Falling back to Math.random");
    } // Fall back to using the traditional (not cryptographically secure, but more universal) Math.random library
    return Math.random();
}
/**
 * Generates a random whole number between a start number and an end number (inclusive).
 * It uses a cryptographically secure library when possible (window.crypto or window.mscrypto for some ie versions), and
 * falls back to Math.random
 * @param min
 * @param max
 * @returns {int}
 */ function randomBetween(min, max) {
    return Math.floor(random() * Math.abs(max + 1 - min)) + min;
}
/**
 * Get a random string uniquely identifying the current instance of the app
 * @return {string}
 */ function getInstanceID() {
    var id_length = 15; // The length of the random string to generate, in characters
    var id = "";
    while(id.length < id_length)// Valid characters are 0-9, and a-z (lowercase). You can get this number by converting a random number between 0 to 36 to base 36.
    id += randomBetween(0, 35).toString(36);
    return id;
}
exports.default = configModule.name;

},{"1e26c87263ee39ab":"liepd","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1KXgw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("configuration.http", []).config([
    "$httpProvider",
    "$locationProvider",
    function($httpProvider, $locationProvider) {
        $httpProvider.interceptors.push("httpInterceptor");
    }
]).name;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"hoUVw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("configuration.other", [
    "ui.router"
]).config([
    "$urlRouterProvider",
    "$locationProvider",
    "$logProvider",
    "DEV",
    function($urlRouterProvider, $locationProvider, $logProvider, DEV) {
        $locationProvider.hashPrefix("");
        $locationProvider.html5Mode(true); // Turn on logging (if this is a development environment)
        $logProvider.debugEnabled(DEV); // Set the default 404 url
        $urlRouterProvider.when("", "/").otherwise("/not-found");
    }
]).name;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aweGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("configuration.restangular", [
    "restangular"
]).config([
    "RestangularProvider",
    "API_ROOT",
    function(RestangularProvider, API_ROOT) {
        // setup Restangular
        RestangularProvider.setBaseUrl(API_ROOT);
        RestangularProvider.setRestangularFields({
            id: "ID"
        });
        RestangularProvider.addFullRequestInterceptor(function(element, operation, route, url, headers, params) {
            if (operation == "remove") element = undefined;
            return {
                headers: headers,
                params: params,
                element: element,
                httpConfig: {}
            };
        });
        RestangularProvider.setResponseExtractor(function(response, operation, what, url) {
            var newResponse;
            if (operation == "getList") {
                newResponse = response.data;
                newResponse.meta = response.meta;
            } else newResponse = response.data;
            return newResponse;
        });
        RestangularProvider.setOnElemRestangularized(function(elem, isCollection, what, Restangular) {
            if (!isCollection) return elem;
            /**
     * find an item in a collection by id or other column
     * @param  {int} id
     * @param {string} column
     * @return {object|null}
     */ elem.find = function(id, column) {
                if (!column) column = "ID";
                for(var i = 0; i < elem.length; ++i){
                    if (elem[i][column] == id) return elem[i];
                }
                return null;
            };
            /**
     * returns the index of a ID
     * @param  {int} id
     * @return {int|false}
     */ elem.indexOfID = function(id) {
                for(var i = 0; i < elem.length; ++i){
                    if (elem[i].ID == id) return i;
                }
                return false;
            };
            return elem;
        });
        return;
    }
]).name;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"4zI1v":[function(require,module,exports) {
/**
 * Sets the storage provider prefix
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("configuration.storage", [
    "common"
]).config([
    "StorageProvider",
    function(StorageProvider) {
        StorageProvider.setPrefix("epiphany-analytics-app");
    }
]).name;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gXMvV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("bootstrap.http", []).run([
    "$http",
    "$rootScope",
    "promiseTracker",
    function($http, $rootScope, promiseTracker) {
        $http.defaults.withCredentials = true;
        if (typeof $rootScope.promiseTracker == "undefined") $rootScope.promiseTracker = promiseTracker({
            activationDelay: 500
        });
    }
]).name;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1g7LZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("views:mapping", [
    require("659560524118925b").default
]).run([
    "$templateCache",
    function($templateCache) {
        $templateCache.put("/maps/map.html", require("6946f6d2ffc386e0"));
        $templateCache.put("/maps/not-found.html", require("769714afb970a8c5"));
    }
]).name;

},{"659560524118925b":"cMsXP","6946f6d2ffc386e0":"3Na5H","769714afb970a8c5":"03Rv1","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3Na5H":[function(require,module,exports) {
module.exports = "<div class=\"public\" id=\"page\" nicescroll=\"nicescroll\"><div class=\"row\" id=\"public-content\"><div id=\"truterritory\"><div class=\"public-controls\"><button class=\"btn current-location location\" ng-click=\"centerOnCurrentLocation()\" title=\"Show your current location on the map\"></button><form class=\"location-search\" ng-submit=\"mapSearch(mapSearchText)\"><span class=\"input-search\"><input type=\"text\" placeholder=\"Search:\" ng-model=\"mapSearchText\"></span></form><div class=\"map-name\">{{map.name}}</div></div><div class=\"map-holder\" ui-sortable=\"mapDroppable\" ng-model=\"mapDropModel\"><div class=\"map-holder\"><epi-map-v2 center=\"center\" zoom=\"zoom\" scale=\"scale\" is-public-page=\"isPublicPage\" init=\"setupMap\" map=\"map\"></epi-map-v2></div><history-slider ng-if=\"map.dateEnabled\" map=\"truMap.getLeafletMap()\" ng-model=\"map.dateRange\" max-date-range=\"map.maxDateRange\" ng-change=\"timeframeChanged()\" mode=\"map.sliderType\" interval=\"map.sliderInterval\"></history-slider><interval-slider ng-if=\"map.dateEnabled &amp;&amp; map.compEnabled\" map=\"truMap.getLeafletMap()\" ng-model=\"map.compInterval\" ng-change=\"timeframeChanged()\"></interval-slider><div class=\"legend\" map=\"truMap.getLeafletMap()\" legends=\"map.legends\" aggregates=\"map.aggregates\" open></div></div><div class=\"toggle-triangle\"><div class=\"closed triangle\" ng-click=\"openSidePanel()\"></div></div><div class=\"right-side-menu right-wrap\" show=\"isSidePanelOpen\"><epi-truterritory-side right-side-width=\"400px\" right-side-width-small=\"300px\" map=\"map\" close=\"closeSidePanel\" toggle-visible=\"toggleVisible\" set-map-label=\"setMapLabel\" set-map-theme=\"setMapTheme\" set-collection-ids=\"setCollectionIds\" is-public-page=\"true\"></epi-truterritory-side></div></div></div></div>";

},{}],"03Rv1":[function(require,module,exports) {
module.exports = "<div class=\"public\" id=\"page\" nicescroll=\"nicescroll\"><div class=\"row\" id=\"public-content\"><div id=\"truterritory\" ng-init=\"center=[16.7665887, -3.0025615]; zoom=14\"><div class=\"public-controls\"><div class=\"map-name\"><h3>Welcome to Timbuktu!</h3><p>We couldn't find the map you were looking for.</p><p>This probably means it was mis-typed, no longer exists, or the link expired.</p><p>Please don't hesitate to contact us at <a href=\"tel:18007384436\">1-800-738-4GEO</a> or <a href=\"mailto:priority@geostrategies.com?subject=Missing%20Map\">priority@geostrategies.com</a> for assistance.</p><p style=\"padding-left:3em\"><strong><em>Happy journeys!</em></strong></p></div></div><div class=\"map-holder\" ui-sortable=\"mapDroppable\" ng-model=\"mapDropModel\"><div class=\"map-holder\"><epi-map-v2 name=\"truMap\" zoom-animation-threshold=\"15\" zoom=\"zoom\" center=\"center\"></epi-map-v2></div></div></div></div></div>";

},{}],"abIGM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("routes", [
    "routes:mapping"
]).config([
    "$stateProvider",
    function($stateProvider) {
        $stateProvider.state("not-found", {
            url: "/not-found",
            templateUrl: "/maps/not-found.html"
        }).state("map", {
            url: "/{UUID:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}?lng&lat&zoom&view&legend&o",
            templateUrl: "/maps/map.html",
            controller: "map",
            resolve: {
                workspaces: function() {
                    return {};
                },
                workspace: function() {
                    return {};
                },
                entity: function() {
                    return {};
                }
            }
        });
    }
]).name;
require("30d7ce01a058e208");

},{"30d7ce01a058e208":"eP0B3","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"eP0B3":[function(require,module,exports) {
/**
 * Main map page
 */ angular.module("routes").controller("map", [
    "$rootScope",
    "$scope",
    "$geolocation",
    "GoogleGeocoder",
    "$state",
    "workspaces",
    "workspace",
    "Collection",
    "$window",
    "$q",
    "$timeout",
    "Map",
    "Workspace",
    "Session",
    "entity",
    "Storage",
    "$location",
    "INSTANCE_ID",
    "MappingModals",
    "hasMapAccess",
    "$controller",
    function($rootScope, $scope, $geolocation, GoogleGeocoder, $state, workspaces, workspace, Collection, $window, $q, $timeout, Map, Workspace, Session, entity, Storage, $location, INSTANCE_ID, MappingModals, hasMapAccess, $controller) {
        $scope.isPublicPage = true; // Inherit from the original TruTerritory controller
        $controller("truterritory", {
            $rootScope,
            $scope,
            $geolocation,
            GoogleGeocoder,
            $state,
            workspaces,
            workspace,
            Collection,
            $window,
            $q,
            $timeout,
            Map,
            Workspace,
            Session,
            entity,
            Storage,
            $location,
            INSTANCE_ID,
            MappingModals,
            hasMapAccess
        });
        $scope.zoom = $state.params.zoom;
        $scope.center = [
            $state.params.lat || null,
            $state.params.lng || null
        ];
        $scope.map = Map.getEmptyMap();
        let mapOptions = {};
        if ($state.params.o) {
            let o = $state.params.o;
            mapOptions.o = o instanceof Array ? o : [
                o
            ];
        }
        $scope.hasAccess = function() {
            return false;
        };
        $scope.setupMap = function(truMap) {
            $scope.truMap = truMap;
            Map.getByUUID($state.params.UUID, mapOptions).then(function(map) {
                // Get a password from the user if required
                if (map.passwordRequired) requirePassword(map);
                else load(map);
            }).catch(function(response) {
                console.log("Error loading map", response);
                $state.go("not-found");
            });
        };
        function load(map) {
            $scope.setOriginalMap(map);
            map.isPublic = true;
            $scope.workspace = {
                collections: map.collections
            };
            return $scope.addMap(map, false).then(function() {
                if (map.annotations && map.annotations.features) $scope.truMap.setDrawnItems(map.annotations.features);
            });
        }
        function requirePassword(map, first = true) {
            MappingModals.openPassword(first).then(function(password) {
                map.password = password;
                load(map).catch(function(response) {
                    if (response.status == 403) requirePassword(map, false);
                });
            });
        }
    }
]);

},{}],"dX9bK":[function(require,module,exports) {
/**
 * Common modules
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("modules", [
    require("eebc2a74dd573fd7").default,
    require("efafa75f1369b93a").default
]).name;
require("5e8f0f7922547067");
require("37b8dcdbe599d7e1");
require("b9e336f181216ca1");
require("d4c1be1fd95c44ee");
require("d095dd1535ca42dc");

},{"eebc2a74dd573fd7":"dugeI","efafa75f1369b93a":"kxn86","5e8f0f7922547067":"ebEA6","37b8dcdbe599d7e1":"3Uh24","b9e336f181216ca1":"kkVSt","d4c1be1fd95c44ee":"84sMs","d095dd1535ca42dc":"iGNrP","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"dugeI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("modules:admin", [
    "modules"
]).name;
require("7173d0b85be70620");
require("61fc4000c54ba3a9");
require("abed5a9790e1be6c");

},{"7173d0b85be70620":"8kmgH","61fc4000c54ba3a9":"an8cO","abed5a9790e1be6c":"hxSK8","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8kmgH":[function(require,module,exports) {
/**
 * Resource for emails
 */ angular.module("modules:admin").factory("Email", [
    "Restangular",
    function(Restangular) {
        var Email = Restangular.all("system/emails");
        Restangular.addElementTransformer("system/emails", true, function(emails) {
            emails.addRestangularMethod("create", "post");
            emails.addRestangularMethod("search", "getList", "search");
            return emails;
        });
        Restangular.addElementTransformer("system/emails", false, function(email) {
            email.saveEmail = function() {
                return email.put();
            };
            return email;
        });
        return Email;
    }
]);

},{}],"an8cO":[function(require,module,exports) {
angular.module("modules:admin").factory("Permission", [
    "Restangular",
    "$log",
    function(Restangular, $log) {
        var Permission = Restangular.one("permissions"); // add a custom methods to collection
        Restangular.addElementTransformer("permissions", true, function(permission) {
            // don't try to work on uninitialized collection
            if (!("one" in permission)) return permission;
            permission.addRestangularMethod("search", "getList", "search");
            return permission;
        });
        /**
   * Makes a request to get the permissions for an entity
   * @param  {integer} entityID
   * @param  {integer} userID
   * @return {object} the promise for the request
   */ Permission.getEntityPermissionList = function(entityID, userID) {
            var promise = Permission.customGET("", {
                entityID: entityID,
                userID: userID
            }); // Process the return data and add the slug for each entity and the unassigned permissions for each entity
            promise.then(function(response) {
                for(var permission in response.children){
                    response.children[permission].permission = "entity." + entityID + "." + permission;
                    var unassignedPermissions = response.children[permission].unassigned;
                    if (unassignedPermissions) {
                        if (response.children[permission].children instanceof Array) response.children[permission].children = {};
                        for(var unassigned in unassignedPermissions){
                            response.children[permission].children[unassigned] = unassignedPermissions[unassigned];
                            response.children[permission].children[unassigned].permission = response.children[permission].permission + "." + unassigned;
                            response.children[permission].children[unassigned].isUnassigned = true;
                        }
                    }
                }
            });
            return promise;
        };
        /**
   * Makes a request to get a specific permission string (and children)
   * @param  {array} permissionArray
   * @param  {integer} entityID
   * @param  {integer} userID
   * @return {object} the promise for the request
   */ Permission.getPermission = function(permissionArray, entityID, userID) {
            var permissionString = permissionArray.join(".");
            var promise = Permission.customGET(permissionString, {
                entityID: entityID,
                userID: userID
            }); // After the promise is fulfilled, process all the entries and add a slug for the permission
            promise.then(function(response) {
                response.permission = "entity." + entityID + "." + permissionString;
                if (!response.children || !_.isEmpty(response.unassigned) && response.children instanceof Array) response.children = {};
                for(var permission in response.unassigned){
                    response.children[permission] = response.unassigned[permission];
                    response.children[permission].isUnassigned = true;
                }
                for(var permission in response.children)response.children[permission].permission = response.permission + "." + permission;
            });
            return promise;
        };
        return Permission;
    }
]);

},{}],"hxSK8":[function(require,module,exports) {
/**
 * Permission manager factory
 */ var _permissionManager = require("../../../../src/services/permission-manager");
angular.module("modules:admin").factory("PermissionManager", [
    "$log",
    function($log) {
        return 0, _permissionManager.PermissionManager;
    }
]);

},{"../../../../src/services/permission-manager":"4U28K"}],"4U28K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PermissionManager", ()=>PermissionManager);
const PermissionManager = function(permissions) {
    /**
   * The user's permissions
   * @type {Object}
   */ this.permissions = permissions;
    /**
   * All the different permission types as:
   *         <permission name>: <permission string>
   * @type {Object}
   */ this.types = {
        delete: "",
        create: ".create",
        read: ".read",
        update: ".update",
        collaborate: ".collaborate"
    };
    /**
   * The permission hierarchy
   * Zero-indexed, with zero being the highest
   * @type {Array}
   */ this.permissionHierarchy = [
        "delete",
        "create",
        "update",
        "collaborate",
        "read"
    ];
};
PermissionManager.prototype = {
    ////////////////////
    // Getter methods //
    ////////////////////
    /**
   * Get the permission types
   * @return {object}
   */ getPermissionTypes: function() {
        return this.types;
    },
    /**
   * Get the permission hierarchy
   * @return {array}
   */ getTypeHierarchy: function() {
        return this.permissionHierarchy;
    },
    ////////////////////
    // Public Methods //
    ////////////////////
    /**
   * Set the effective permissions on a given area, taking ancestors into account
   * @param {string} area
   * @param {string} accessType
   * @return {void}
   */ set: function(area, accessType) {
        this.removePermissionArea(area); // get effective permissions of parent (i.e., inherited permissions)
        var granted = this.get(area), // expand access type to include its children
        desired = typeof accessType == "string" ? this.expandAccessType(accessType) : accessType, // get index of accessType (will be max desired index)
        index = this.findHighestType(desired), toSet = {}, grantedSum = 0; // Loop through the hierarchy starting at the bottom
        for(var i = 0; i < this.permissionHierarchy.length; i++){
            var value = 0; // If the current index in hierarchy is less than or equal to max desired index, set as 1
            if (i >= index && index !== null) value = 1;
            else if (granted[this.permissionHierarchy[i]]) value = -1;
            grantedSum += value;
            if (value != 0) toSet[this.permissionHierarchy[i]] = value;
        }
        if (grantedSum == 4) this.permissions[area] = 1;
        else for(var permission in toSet)this.permissions[area + "." + permission] = toSet[permission];
    },
    /**
   * Get the effective permissions on a given area, taking ancestors into account
   * @param  {string} area
   * @return {object} a dictionary of the permissions
   */ get: function(area) {
        var permissions = {};
        for(var i = 0; i < this.permissionHierarchy.length; i++){
            var accessAbove = this.hasAccessAbove(area, this.permissionHierarchy[i]); // console.log('accessAbove', area, this.permissionHierarchy[i], accessAbove)
            var access = this.permissions[area + "." + this.permissionHierarchy[i]];
            permissions[this.permissionHierarchy[i]] = access ? Number(access > 0) : Number(accessAbove);
        }
        return permissions;
    },
    /**
   * Delete permissions for all descendants so that only the parent's are effective
   * @param  {string} area
   * @return {void}
   */ clearDescendants: function(area) {
        // Loop through all the permissions and figure out
        // if the permission is below the area in question
        for(var permission in this.permissions){
            // Split the permission so that splitArea is the area only
            var splitPermission = this._splitPermission(permission), splitArea = splitPermission[0]; // If the beginning of the area contains the area in question
            // And it *isn't* the area,
            // Delete it
            if (splitArea.indexOf(area) === 0 && splitArea !== area) delete this.permissions[permission];
        }
    },
    /**
   * Get a summary of the permissions under a certain area
   * @param  {string} area
   * @return {object} the summary
   *         {"access": "<area access>", "high": "<highest granted permission>", "low": "<lowest granted permission>"}
   */ summarize: function(area) {
        var permissions = this.getAccessUnder(area), highsArray = [], highs = {}, areaHigh; // Loop through all the user permissions
        for(var i = 0; i < permissions.length; i++){
            var split = this._splitPermission(permissions[i]), splitArea = split[0], splitType = split[1], index = _.indexOf(this.permissionHierarchy, splitType);
            if (splitType === null) index = 0; // Create an object with the highest type for each permission
            if (!(splitArea in highs)) highs[splitArea] = index;
            else if (index < highs[splitArea]) highs[splitArea] = index;
        } // Now loop through that object and push it to a new array
        for(var each in highs)highsArray.push(highs[each]);
         // Sort it numerically (highest is at the beginning)
        highsArray.sort(); // At this point, the highest & lowest permission has been found,
        // Now all that's left is the find the highest granted permission for the area in question
        if (this.permissions[area] == 1) areaHigh = 0;
        else if (this._hasLocalRules(area) == true) {
            var permissions = this.get(area);
            areaHigh = this.findHighestType(permissions);
        }
         // Return all the *string* values for the type indexes
        return {
            access: this.permissionHierarchy[areaHigh],
            high: this.permissionHierarchy[highsArray[0]],
            low: this.permissionHierarchy[highsArray[highsArray.length - 1]]
        };
    },
    /**
   * Expand access type to include children
   * @param  {string} type
   * @return {object}
   */ expandAccessType: function(type) {
        var types = this.permissionHierarchy.slice(_.indexOf(this.permissionHierarchy, type), this.permissionHierarchy.length);
        var returnTypes = {};
        for(var i = 0; i < this.permissionHierarchy.length; i++)returnTypes[this.permissionHierarchy[i]] = _.indexOf(types, this.permissionHierarchy[i]) === -1 ? 0 : 1;
        return returnTypes;
    },
    /**
   * Deletes all the permissions for a specific area in a user's permission object
   * @param  {object} userPermissions
   * @param  {string} permissionString
   * @return {void}
   */ removePermissionArea: function(permissionString) {
        for(var type in this.types)delete this.permissions[permissionString + this.types[type]];
    },
    /**
   * Finds the highest permission type from an array of permission types
   * @param  {object} types an object of types with values
   * @return {integer}
   */ findHighestType: function(types) {
        // Start at one more than the lowest permission (which is 4)
        var highest = 5; // Loop through all the types that were passed in
        for(var type in types)// For those that are set to 1 (turned on)
        if (types[type] * 1 === 1) {
            var typeHierarchy = _.indexOf(this.permissionHierarchy, type); // If the type hierarchy is less than (higher up the permission hierarchy),
            // Then set the highest to that type
            if (typeHierarchy < highest) highest = typeHierarchy;
        }
        if (highest === 5) highest = null;
        return highest;
    },
    /////////////////////
    // Private methods //
    /////////////////////
    /**
   * Split a permission into area and type
   * @param  {string} permission
   * @return {array} an array of the [area, type|null]
   */ _splitPermission: function(permission) {
        // Split the permission at the last dot
        // Find the area and the last dot
        var lastDot = permission.lastIndexOf(".");
        var type = permission.substr(lastDot + 1, permission.length);
        var area = permission.substr(0, lastDot); // If the type is found in the permissions list
        // Return the [area, type]
        if (_.indexOf(this.permissionHierarchy, type) >= 0) return [
            area,
            type
        ]; // Otherwise return the permission (there's no type in the permission string)
        // And null for the type
        return [
            permission,
            null
        ];
    },
    /**
   * Find out whether an area has a permission
   *    for a certain type at *or* above the area in question
   *
   * @todo: needs to support denial of permission (-1)
   *
   * @param  {string}  area
   * @param  {string}  [type]
   * @return {Boolean}
   */ hasAccessAbove: function(area, type) {
        if (this.isSuper() || this.permissions[area + "." + type] == 1) return true;
        if (this.permissions[area + "." + type] == -1) return false;
        for(var permission in this.permissions){
            if (area.indexOf(permission) === 0 && this.permissions[permission] === 1) return true;
            var permissionSplit = this._splitPermission(permission), splitArea = permissionSplit[0], splitType = permissionSplit[1];
            if (area.indexOf(splitArea) === 0 && (type == splitType || splitType == null) && this.permissions[permission] === 1) return true;
        }
        return false;
    },
    /**
   * Get the access below a specific area
   * @param  {string} area
   * @return {array}
   */ getAccessUnder: function(area) {
        var matching = [];
        for(var permission in this.permissions){
            var splitArea = this._splitPermission(permission)[0];
            if (splitArea.indexOf(area) === 0 && this.permissions[permission] === 1 && splitArea !== area) matching.push(permission);
        }
        return matching;
    },
    /**
   * Determine if this user is super/admin
   * @return {boolean}
   */ isSuper: function() {
        return this.permissions && this.permissions.superuser == 1;
    },
    /**
   * Check whether the person has enought of a related permission that they should see the menu item
   * @param {string} area
   * @return {boolean}
   */ hasMenuAccess: function(area) {
        if (this.isSuper()) return true;
        for(var permission in this.permissions){
            var grantedArea = this._splitPermission(permission)[0]; // if the granted permission exactly matches the area, they have access
            if (grantedArea == area && this.permissions[permission] == 1) return true; // If the granted area is an ancestor of the requested area, they have access above and can see the menu
            if (area.indexOf(grantedArea) === 0 && this.permissions[permission] == 1) return true; // If the granted area is a child of the requested area, they have access below and can see the menu
            if (grantedArea.indexOf(area) === 0 && this.permissions[permission] == 1) return true;
        }
        return false;
    },
    _hasLocalRules: function(area) {
        if (this.permissions[area]) return true;
        for(var i = this.permissionHierarchy.length - 1; i >= 0; i--){
            if (this.permissions[area + "." + this.permissionHierarchy[i]]) return true;
        }
        return false;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kxn86":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("modules:mapping", [
    "modules"
]).name;
require("b874ab406d0b700f");
require("e71c9dbee3f1e6a8");
require("fe46b683254bc493");
require("4d5a22a6add3210e");
require("72e36f21deb7ef82");
require("c581da09ec285a66");
require("62242fd2e91dca7f");
require("8a62e47904e1cce5");
require("92c5b00e3d6959b0");
require("4f71cb17a1c5c5d8");
require("a22e2da0dece746c");
require("51eb3b52d90ed00e");
require("16588be2e3f59283");

},{"b874ab406d0b700f":"euUGg","e71c9dbee3f1e6a8":"aYSAY","fe46b683254bc493":"12qKE","4d5a22a6add3210e":"6xYyS","72e36f21deb7ef82":"dKSO3","c581da09ec285a66":"5MNVg","62242fd2e91dca7f":"4QH0f","8a62e47904e1cce5":"3soQH","92c5b00e3d6959b0":"jBeP5","4f71cb17a1c5c5d8":"dVXRy","a22e2da0dece746c":"kBROE","51eb3b52d90ed00e":"9BRb3","16588be2e3f59283":"9vsUD","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"euUGg":[function(require,module,exports) {
var _constants = require("../../../constants");
angular.module("modules:mapping").factory("Collection", [
    "Restangular",
    "$q",
    "$window",
    "$http",
    "Theme",
    "API_ROOT",
    function(Restangular, $q, $window, $http, Theme, API_ROOT) {
        var Collection = Restangular.all("mapping/collections"); // add methods to single collections
        Restangular.addElementTransformer("mapping/collections", false, function(collection) {
            if (!("one" in collection)) return collection;
            collection.getFeatures = function(filters, paginated, UUID) {
                var parameters = {}, url;
                if (filters) parameters.filters = filters;
                if (paginated) parameters.limit = 10;
                if (UUID) url = "../" + UUID + "-" + collection.ID + "/features?";
                else url = "features?";
                return collection.customGETLIST(url + $.param(parameters));
            };
            collection.getFeaturesPaginated = function(parameters) {
                // parameters.filters = collection.filters
                return collection.customGETLIST("features?" + $routeParams(parameters));
            };
            /**
     * Gets the collection theme either from the collection or gets the default theme
     * @param  {object}  map              the map object
     * @param  {boolean} [preferMapLabel=true] whether to prefer the map label over the theme label
     * @return {object}                   the theme
     */ collection.findTheme = function(map, preferMapLabel = true) {
                var theme = _.find(this.themes, {
                    ID: map.themes[this.ID]
                }); // If a theme isn't set on the map, grab the collection's first
                if (!theme && this.themes) theme = this.themes[0]; // still nothing? use defaults
                if (!theme) theme = Theme.getDefaultTheme(this, map.workspaceID, "Default"); // Copy the theme, so the original isn't modified
                theme = Restangular.copy(theme); // If there's a label set at the map level,
                // change the label, and return the modified theme
                if (typeof map.labels[this.ID] != "undefined" && preferMapLabel) theme.label = map.labels[this.ID];
                return theme;
            };
            /**
     * Toggle whether this import is archived
     * @return {void}
     */ collection.toggleArchived = function() {
                this.archived = !this.archived;
                return this.patch({
                    archived: this.archived
                });
            };
            /**
     * Save a collection by posting or patching. The request is queued for processing on the backend,
     * so we poll to get the result.
     * @param  {array} fileIDs
     * @return {objects} a promise
     */ collection.save = function(fileIDs) {
                if (fileIDs && fileIDs.length) collection.files = fileIDs;
                var promise;
                if (!("ID" in collection)) promise = collection.post();
                else promise = collection.patch(); // Repeatedly ask for an update
                function poll(requestID) {
                    var params = {
                        requestID: requestID,
                        poll: (0, _constants.POLL_TIME)
                    };
                    return Collection.one("status").get(params).then(function(response) {
                        if (response == null) return poll(requestID);
                        return response;
                    });
                }
                return promise.then(function(response) {
                    return poll(response.requestID);
                });
            };
            if (collection.themes) for(var i = 0; i < collection.themes.length; i++)Restangular.restangularizeElement(null, collection.themes[i], "mapping/themes");
            return collection;
        }); // add a custom methods to collections of collections
        Restangular.addElementTransformer("mapping/collections", true, function(collections) {
            // don't try to work on uninitialized collection
            if (!("one" in collections)) return collections;
            collections.addRestangularMethod("search", "getList", "search");
            return collections;
        });
        Collection.types = require("b261c1145aeba383").CollectionTypes;
        Collection.userDefinedPropertyTypes = [
            {
                "label": "Text",
                "type": "text"
            },
            {
                "label": "Integer",
                "type": "int8"
            },
            {
                "label": "Decimal",
                "type": "numeric"
            }
        ];
        Object.freeze(Collection.types);
        Collection.create = function(entityID) {
            var collection = {
                type: "master",
                indexes: [],
                entityID: entityID,
                sql: "",
                aggSql: ""
            };
            Restangular.restangularizeElement(null, collection, Collection.route);
            return collection;
        };
        Collection.saveAsMaster = function(collection, name) {
            if (collection.type != "transform") throw new TypeError(`${collection.name} is not a transformation layer`);
            return Collection.customPOST({
                name
            }, `${collection.ID}`);
        };
        Collection.testSql = function(sql, entityID) {
            return $http.post(API_ROOT + "/" + Collection.route + "/test", {
                sql: sql
            }, {
                params: {
                    entityID: entityID
                }
            }).then(function(response) {
                return response.data.data;
            });
        };
        return Collection;
    }
]);

},{"../../../constants":"5euJ0","b261c1145aeba383":"984si"}],"5euJ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POLL_TIME", ()=>POLL_TIME);
parcelHelpers.export(exports, "Theme", ()=>Theme);
const POLL_TIME = 55;
var Theme;
(function(Theme) {
    Theme["morrowHill"] = "morrow-hill";
})(Theme || (Theme = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aYSAY":[function(require,module,exports) {
var _store = require("../../../../src/store");
const getMap = ()=>(0, _store.store).getState().pages.truterritory.map;
angular.module("modules:mapping").factory("ContextMenu", [
    "$rootScope",
    "$http",
    "$compile",
    "$window",
    "$stateParams",
    "$q",
    "API_ROOT",
    "$timeout",
    function($rootScope, $http, $compile, $window, $stateParams, $q, API_ROOT, $timeout) {
        return {
            /**
     * Create an instance of L.ContextMenu
     * @param {function} getMap
     * @param {function} findCollection A function to find a collection by ID
     * @param {bool} isPublicPage
     * @param  {L.LatLng} latlng
     * @param {TruMap} truMap
     * @return {Promise}
     */ make (findCollection, isPublicPage, searchText, latlng, truMap, customOptions = []) {
                const infoReq = $http.get(makeInfoURL(truMap, latlng), {
                    withCredentials: false
                }).then((resp)=>resp.data.data);
                const reportsReq = !isPublicPage && getMap().ID ? $http.get(makeVisibleReportsURL(getMap(), latlng)).then((resp)=>resp.data.data) : Promise.resolve([]);
                return Promise.all([
                    infoReq,
                    reportsReq
                ]).then(function([features, reports]) {
                    let sections = makeMenuSections(features, reports, getMap(), findCollection, isPublicPage, searchText, truMap, customOptions);
                    return new L.ContextMenu(latlng, $compile, sections, $rootScope);
                });
            },
            /**
     * Create an instance of L.ContextMenu, but don't look for intersecting features
     * @param  {function}  getMap
     * @param  {Boolean} isPublicPage
     * @param  {L.LatLn}  latlng
     * @param  {TruMap}  truMap
     * @return {Promise}
     */ makeWithoutFeatures (getMap, isPublicPage, searchText, latlng, truMap, customOptions = []) {
                let sections = makeMenuSections(false, false, getMap(), null, isPublicPage, searchText, truMap, customOptions), menu = new L.ContextMenu(latlng, $compile, sections, $rootScope);
                return $q.when(menu);
            }
        };
        /**
   * Generate the URL for fetching information about a point
   * @param  {TruMap} truMap
   * @param  {L.LatLng} latlng
   * @return {string}
   */ function makeInfoURL(truMap, latlng) {
            return truMap._tileUrl + "/info/" + truMap._tileLayerID + "/" + truMap._map.getZoom() + "/" + latlng.lat + "/" + latlng.lng;
        }
        /**
   * Generate the URL for fetching list of visible reports.
   */ function makeVisibleReportsURL(map, latlng) {
            return `${API_ROOT}/mapping/reports/visible/${map.ID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}`;
        }
        /**
   * Generate the content for the menu
   * @param  {array} features The array of features returned for the info request
   * @param {Object} map The map model
   * @param {function} findCollection
   * @param {bool} isPublicPage
   * @param {TruMap} truMap
   * @return {array}
   */ function makeMenuSections(features, reports, map, findCollection, isPublicPage, searchText, truMap, customOptions = []) {
            let sections = [];
            if (features !== false) sections.push({
                header: "Select layer:",
                items: features,
                onSelect: showFeatureProperties.bind(null, findCollection, isPublicPage)
            });
            let options = {
                header: "Options:",
                items: angular.copy(customOptions),
                onSelect: null
            };
            if (map.reportsEnabled && !isPublicPage) options.items.push({
                name: "Download Site Report",
                onSelect: downloadSiteReport.bind(null, map, truMap, searchText)
            });
            if (options.items && options.items.length) sections.push(options);
            if (reports && !isPublicPage) {
                let reportSection = {
                    header: "Reports:",
                    items: [],
                    onSelect: null
                };
                for (let report of reports)reportSection.items.push({
                    name: report.label,
                    onSelect: downloadMapReport.bind(null, report, truMap, searchText)
                });
                if (reportSection.items.length) sections.push(reportSection);
            }
            return sections;
        }
        /**
   * Make a popup showing a feature's properties
   * @param {function} findCollection
   * @param {bool} isPublicPage
   * @param  {Object} feature
   * @param  {L.Map} map
   * @param  {L.LatLng} latlng
   * @return {void}
   */ function showFeatureProperties(findCollection, isPublicPage, feature, map, latlng) {
            var popupScope = $rootScope.$new();
            popupScope.feature = feature;
            popupScope.map = map;
            popupScope.findCollection = findCollection;
            popupScope.editable = !isPublicPage;
            var el = $compile('<span map-point-detail feature="feature" map="map" find-collection="findCollection" editable="editable"></span>')(popupScope);
            el.css({
                "max-height": map.getContainer().clientHeight * 0.8 - 52
            });
            var popup = L.popup({
                minWidth: "250",
                closeButton: false
            });
            $timeout(function() {
                popup.setLatLng(latlng).setContent(el.get(0)).openOn(map);
            }); // Close the popup on opening another context menu.
            map.on("contextmenu", close);
            function close() {
                map.closePopup(popup);
                map.off("contextmenu", close);
            }
        }
        /**
   * Get a site report
   * @param  {Object} map     The map model
   * @param  {TruMap} truMap
   * @param  {string} searchText
   * @param  {Object} feature
   * @param  {void} _
   * @param  {L.LatLng} latlng
   * @return {void}
   */ function downloadSiteReport(map, truMap, searchText, feature, _, latlng) {
            let url = `${API_ROOT}/mapping/maps/${map.ID}/reports/${truMap._tileLayerID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}&address=${searchText}`;
            $window.open(url);
        }
        /**
   * Get a map report
   * @param  {Object} report  The mapReport model
   * @param  {TruMap} truMap
   * @param  {string} searchText
   * @param  {Object} feature
   * @param  {void} _
   * @param  {L.LatLng} latlng
   * @return {void}
   */ function downloadMapReport(report, truMap, searchText, feature, _, latlng) {
            let url = `${API_ROOT}/mapping/reports/${report.ID}/${truMap._tileLayerID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}&address=${searchText}&format=pdf`;
            $window.open(url);
        }
    }
]);

},{"../../../../src/store":"7WrEn"}],"12qKE":[function(require,module,exports) {
angular.module("modules:mapping").factory("Feature", [
    "Restangular",
    "Validator",
    function(Restangular, Validator) {
        var Feature = Restangular.all("mapping/collections/features"); // add methods to single collections
        Restangular.addElementTransformer("mapping/collections/features", false, function(feature) {
            if (!("one" in feature)) return feature;
            var validationRules = {};
            for(var key in feature.properties)if (typeof feature.properties[key] == "number") validationRules[key] = "decimal";
            else validationRules[key] = "";
            feature.validationRules = validationRules;
            feature.saveProperties = function(collectionID, properties, mapID, workspaceID) {
                for(var key in properties)if (validationRules[key] == "decimal") properties[key] = parseFloat(properties[key]);
                 // Don't send the original feature; clone it, & set the properties
                var toSend = feature.clone();
                toSend.properties = properties;
                return feature.customPUT(toSend, "../../" + collectionID + "/features" + (mapID && workspaceID ? `?mapID=${mapID}&workspaceID=${workspaceID}` : ""));
            };
            /**
     * Get this feature's properties as CSV
     * @param  {array} columns Array of header,column tuples to put the columns in the right order
     * @return {string}
     */ feature.toCSV = function(columns) {
                let headers = [], values = [];
                for(let i = 0; i < columns.length; i++){
                    let [header, field] = columns[i];
                    if (field in this.properties) {
                        headers.push(header);
                        values.push(this.properties[field]);
                    }
                }
                return makeCSV(headers) + "\n" + makeCSV(values);
            };
            function makeCSV(properties) {
                var csv = "", value;
                for(var i = 0; i < properties.length; i++){
                    value = properties[i] === null ? "" : properties[i].toString();
                    value = value.replace(/"/g, '""');
                    if (value.search(/("|,|\n)/g) >= 0) value = '"' + value + '"';
                    if (i > 0) csv += ",";
                    csv += value;
                }
                return csv;
            }
            return feature;
        }); // add a custom methods to collections of collections
        Restangular.addElementTransformer("mapping/collections/features", true, function(features) {
            // don't try to work on uninitialized collection
            if (!("one" in features)) return features;
            return features;
        });
        Feature.restangularize = function(feature) {
            Restangular.restangularizeElement(null, feature, "mapping/collections/features");
        };
        return Feature;
    }
]);

},{}],"6xYyS":[function(require,module,exports) {
/**
 * Service for storing map reports on the backend
 *
 * THIS MIGHT BE NEEDED.... wait until proven needed
 *
 */ angular.module("modules:mapping").factory("MapReports", [
    "Restangular",
    "Storage",
    "CondenseTo",
    "ObjectFilter",
    "$q",
    function(Restangular, Storage, CondenseTo, ObjectFilter, $q) {
        var storageKey = "truterritory-map-reports";
        var Reports = Restangular.all("mapping/reports");
        Restangular.addElementTransformer("mapping/reports", true, function(reports) {
            /**
     * Save all the reports
     * @return {Promise}
     */ reports.saveAll = function() {
                return Reports.customPUT(reports);
            };
            return reports;
        });
        /**
   * Load all the reports
   * @return {Promise<Array>}
   */ Reports.load = function() {
            // If there are reports in localStorage, migrate them to the backend, otherwise just make a request to get all of the reports
            return Storage.getItem(storageKey) ? Reports._migrate(Storage.getItem(storageKey)) : Reports.getList();
        };
        /**
   * Migrate the local storage reports to the database
   * @param  {array} reports
   * @return {Promise<Array>}
   */ Reports._migrate = function(reports) {
            var toCreate = []; // Loop through all the reports, and create an object in the correct format
            for(var i = 0; i < reports.length; i++){
                var report = reports[i];
                for(var j = 0; j < report.reports.length; j++)toCreate.push({
                    mapID: report.reports[j],
                    workspaceID: reports[i].ID,
                    sorder: j
                });
            } // PUT all the reports
            return Reports.customPUT(toCreate).then(function(reports) {
                // Remove from local storage
                Storage.removeItem(storageKey);
                Restangular.restangularizeCollection(null, reports, "mapping/reports");
                return reports;
            });
        };
        return Reports;
    }
]);

},{}],"dKSO3":[function(require,module,exports) {
angular.module("modules:mapping").factory("Map", [
    "Restangular",
    "Collection",
    "ObjectFilter",
    "$q",
    "$http",
    "API_ROOT",
    "INSTANCE_ID",
    "TILE_URL",
    "MAPBOX_USER",
    "MAPBOX_STYLE_ID",
    "MAPBOX_TILE_SIZE",
    "MAPBOX_ACCESS_TOKEN",
    "Interval",
    function(Restangular, Collection, ObjectFilter, $q, $http, API_ROOT, INSTANCE_ID, TILE_URL, MAPBOX_USER, MAPBOX_STYLE_ID, MAPBOX_TILE_SIZE, MAPBOX_ACCESS_TOKEN, Interval) {
        var Maps = Restangular.all("mapping/maps"); // add methods to single collections
        Restangular.addElementTransformer("mapping/maps", false, function(map) {
            if (!("one" in map)) return map;
            if ("collections" in map) for(var i = 0; i < map.collections.length; i++)Restangular.restangularizeElement(null, map.collections[i], "mapping/collections");
            /**
     * Creates the date range for the map, if enabled
     * @return {void}
     */ map.createDateRangeIfEnabled = function() {
                if (!this.dateEnabled) return; // Create the objects to hold the date range
                // maxDate range is the object that holds the max (and min) values of the map's data,
                this.maxDateRange = {}; // Loop through all the collections, finding the minimum date range and the maximum date range
                for(var i = 0; i < this.collections.length; i++){
                    var collection = this.collections[i];
                    if (!this.visible[collection.ID] || !collection.dateRange) continue;
                    var min = moment(collection.dateRange[0]), max = moment(collection.dateRange[1]); // If the date is undefined or before the minDate, set it
                    if (typeof this.maxDateRange.minDate == "undefined" || min.isBefore(this.maxDateRange.minDate)) this.maxDateRange.minDate = min; // If the date is undefined or after the maxDate, set it
                    if (typeof this.maxDateRange.maxDate == "undefined" || max.isAfter(this.maxDateRange.maxDate)) this.maxDateRange.maxDate = max;
                } // If the dates aren't set, make it a range that spans the last three years
                if (!this.maxDateRange.maxDate) this.maxDateRange.maxDate = moment();
                if (!this.maxDateRange.minDate) this.maxDateRange.minDate = moment().subtract(3, "year"); // dateRange holds the dates that the user has set, which will be sent back to the server in the preflight request
                if (!this.dateRange) {
                    this.dateRange = {}; // For single-point sliders, default to showing the first period only, not all dates.
                    if (this.sliderType == 1) {
                        let interval = Interval.getNoun(this.sliderInterval);
                        this.dateRange.minDate = this.maxDateRange.minDate.clone().startOf(interval);
                        this.dateRange.maxDate = this.maxDateRange.minDate.clone().endOf(interval);
                    }
                }
            };
            map.getLegends = function() {
                let legends = [];
                this.collections.forEach((collection)=>{
                    let theme = collection.findTheme(this);
                    if (!theme.legend.length || !this.visible[collection.ID]) return;
                    let entry = {
                        entries: theme.legend,
                        collectionID: collection.ID,
                        theme
                    };
                    if (!theme.customLegendHeader || theme.showLegendHeader) entry.name = collection.name;
                    if (theme.customLegendHeader) entry.name = theme.customLegendHeader;
                    legends.push(entry);
                });
                legends.forEach(function(legend) {
                    if (!legend.theme.showLegendHeader && legends.length <= 1) delete legend.name;
                    delete legend.theme;
                });
                return legends;
            };
            /**
     * Setup the map for use by the frontend
     * @param  {array} collections
     * @return {void}
     */ map.setup = function(collections) {
                // Create the collections array (it doesn't exist when fetched from the server, so it needs to be populated from the workspace)
                this.collections = []; // Loop through all the collectionIDs and push them on the map
                for(var i = 0; i < this.collectionIDs.length; i++){
                    var ID = this.collectionIDs[i];
                    this.collections.push(_.find(collections, {
                        ID: ID
                    }));
                }
                if (this.compEnabled) this.compInterval = this.compInterval || "1 year";
                this.createDateRangeIfEnabled();
                this.legends = this.getLegends();
            };
            var preflightCanceler;
            /**
     * Prepare the map object to send in a preflight request.
     * @return {object}
     */ map.getPreflightMap = function() {
                // Prep the preflighted map by only including the necessary properties
                var preflightMap = new ObjectFilter([
                    {
                        collections: [
                            "ID",
                            "name",
                            "tableName"
                        ]
                    },
                    "entityID",
                    "selectable"
                ], this).getClean(); // Strip all the non-visible collections from the preflighted map
                for(var ID in this.visible)if (!this.visible[ID]) preflightMap.collections.splice(_.findIndex(preflightMap.collections, {
                    ID: parseInt(ID)
                }), 1);
                 // Loop through all the map collections
                for(var i = 0; i < this.collections.length; i++){
                    // Set the collection so it's easy to access and find the theme
                    var collection = this.collections[i], theme = collection.findTheme(this); // If it's a visible collection, add the theme & filters to the preflighted collection
                    if (this.visible[collection.ID]) {
                        var preflightCollection = _.find(preflightMap.collections, {
                            ID: collection.ID
                        });
                        preflightCollection.theme = theme;
                        preflightCollection.filters = this.filters[collection.ID] || [];
                    }
                } // Make sure collections is defined
                if (!preflightMap.collections) preflightMap.collections = []; // Reorder all the collections so that the layers are rendered in the correct order
                var reorderedCollections = [];
                for(var i = preflightMap.collections.length - 1; i >= 0; i--)reorderedCollections.push(preflightMap.collections[i]);
                preflightMap.collections = reorderedCollections;
                if (this.dateEnabled) {
                    preflightMap.minDate = this.dateRange.minDate ? this.dateRange.minDate.format("YYYY-MM-DD HH:mm:ss") : null;
                    preflightMap.maxDate = this.dateRange.maxDate ? this.dateRange.maxDate.format("YYYY-MM-DD HH:mm:ss") : null;
                    preflightMap.compInterval = this.compInterval || null;
                }
                return preflightMap;
            };
            /**
     * Preflighting for the map before rendering
     * @param  {boolean} [appendID] whether to append the map ID to the end of the instanceID
     * @return {promise}
     */ map.sendRenderingPreflight = function(appendID = false) {
                // If there's a canceler for the preflight request, cancel it (by resolving the promise)
                if (preflightCanceler) preflightCanceler.resolve(); // Create the promise for the preflight canceler
                // If the promise is resolved, the request will cancel, else it will continue
                preflightCanceler = $q.defer();
                const preflightMap = this.getPreflightMap(); // If this is a public map, send the UUID in the URL
                var UUID = this.isPublic ? "/" + this.UUID : ""; // Post the map to the preflight endpoint
                return $http.post(API_ROOT + "/mapping/maps/preflight/" + INSTANCE_ID + (appendID ? this.ID : "") + UUID + "?entityID=" + this.entityID, {
                    map: preflightMap,
                    password: this.password
                }, {
                    timeout: preflightCanceler.promise
                }).then(function(response) {
                    // Unset the preflight canceler
                    preflightCanceler = null;
                    return response.data.data;
                });
            };
            map.getImageDownloadUrl = function(zoom, sw, ne, marker) {
                var url = [
                    TILE_URL,
                    "tile",
                    INSTANCE_ID,
                    zoom,
                    "snippet.png"
                ], params = {
                    user: MAPBOX_USER,
                    styleID: MAPBOX_STYLE_ID,
                    tileSize: MAPBOX_TILE_SIZE,
                    highdpi: false,
                    accessToken: MAPBOX_ACCESS_TOKEN,
                    bbox: JSON.stringify([
                        [
                            sw.lng,
                            sw.lat
                        ],
                        [
                            ne.lng,
                            ne.lat
                        ]
                    ]),
                    marker: marker && JSON.stringify(marker)
                };
                return url.join("/") + "?" + $.param(params);
            };
            /**
     * Remove a given collection from this map
     * @param {int} collectionID
     * @return {void}
     */ map.removeCollection = function(collectionID) {
                _.pull(this.collectionIDs, collectionID);
                _.remove(this.collections, {
                    ID: collectionID
                });
                delete this.visible[collectionID];
                delete this.labels[collectionID];
            };
            /**
     * Create a new UUID for this map
     */ map.getNewUUID = function() {
                return this.customPOST({}, "uuid").then((uuid)=>{
                    this.UUID = uuid;
                    return uuid;
                });
            };
            /**
     * Get an expiring UUID
     * @param {string} expiresAt
     */ map.getExpiringUUID = function(expiresAt) {
                return this.customPOST({
                    expiresAt
                }, "expiring-uuid");
            };
            /**
     * Retrieve the map's annotations.
     * @param {object} after A moment.js date object
     * @return {Promise}
     */ map.getAnnotations = function(after) {
                let params = after ? {
                    after: after.format()
                } : null;
                return this.customGET("annotations", params);
            };
            /**
     * Add a shape to the map's annotations layer.
     * @param {object} feature GeoJSON feature
     * @param {object} after A moment.js date object
     * @return {Promise}
     */ map.addAnnotation = function(feature, after) {
                return this.customPOST(Object.assign(feature, {
                    after: after.format()
                }), "annotations");
            };
            /**
     * Edit one or more shapes in the map's annotations layer.
     * @param {array} features Array of GeoJSON features
     * @param {object} after A moment.js date object
     * @return {Promise}
     */ map.editAnnotations = function(features, after) {
                return this.customPUT(Object.assign(features, {
                    after: after.format()
                }), "annotations");
            };
            /**
     * Remove a shape from the map's annotations layer.
     * @param {array} ids Array of feature IDs
     * @param {object} after A moment.js date object*
     * @return {Promise}
     */ map.deleteAnnotations = function(ids, after) {
                return this.customDELETE("annotations", {
                    "ids[]": ids,
                    after: after.format()
                });
            };
            /**
     * Get a hashed value from the server which will be used to enable the annotations layer in a public link.
     * @return {Promise}
     */ map.getAnnotationsOption = function() {
                return $http.get(API_ROOT + "/hash/?in=annotations=on_" + moment(this.createdAt).format("YYYY-MM-DD")).then(function(response) {
                    return response.data.data;
                });
            };
            return map;
        }); // add a custom methods to collections of collections
        Restangular.addElementTransformer("mapping/maps", true, function(maps) {
            // don't try to work on uninitialized collection
            if (!("one" in maps)) return maps;
            maps.addRestangularMethod("search", "getList", "search");
            return maps;
        });
        function _prepMapForSave(map) {
            var clonedMap = "clone" in map ? map.clone() : angular.copy(map);
            delete clonedMap.collections;
            return clonedMap;
        }
        Maps.getByUUID = function(UUID, params) {
            return Maps.customGET(UUID, params);
        };
        Maps.getEmptyMap = function(workspaceID, entityID) {
            let map = {
                name: "Untitled Map",
                collections: [],
                collectionIDs: [],
                visible: {},
                selectable: {},
                themes: {},
                labels: {},
                filters: {},
                entityID: entityID,
                workspaceID: workspaceID,
                dateRange: {},
                sliderType: 1,
                sliderInterval: 1,
                reports: []
            };
            this.restangularize(map);
            return map;
        };
        /**
   * Restangularizes a map
   * @param  {object} map
   * @return {void}
   */ Maps.restangularize = function(map) {
            Restangular.restangularizeElement(null, map, Maps.route);
        };
        /**
   * Strip everything off the object except for data.
   * (Note: not recursive.)
   */ Maps.dataOnly = function(dirty) {
            return Object.keys(Restangular.stripRestangular(dirty)).filter((k)=>typeof dirty[k] !== "function").reduce((clean, k)=>({
                    ...clean,
                    [k]: dirty[k]
                }), {});
        };
        Maps.intervals = [
            "1 month",
            "3 months",
            "6 months",
            "1 year",
            "2 years",
            "5 years"
        ];
        Object.freeze(Maps.intervals);
        return Maps;
    }
]);

},{}],"5MNVg":[function(require,module,exports) {
/**
 * Service for managing text templates on the backend
 */ angular.module("modules:mapping").factory("Templates", [
    "Restangular",
    "Storage",
    "CondenseTo",
    "ObjectFilter",
    "$q",
    function(Restangular, Storage, CondenseTo, ObjectFilter, $q) {
        var storageKey = "truterritory-templates";
        var Templates = Restangular.all("templates");
        Restangular.addElementTransformer("templates", true, function(templates) {
            /**
     * Save all the templates
     * @return {Promise}
     */ templates.saveAll = function() {
                return Templates.customPUT(templates);
            };
            /**
     * Removes a template and all its maps
     * @param  {object} template
     * @return {Promise}
     */ templates.removeTemplate = function(template) {
                // Find the index
                var index = _.findIndex(templates, {
                    ID: template.ID
                }); // Make the request to remove the template and splice it
                templates.splice(index, 1);
                return templates.saveAll();
            };
            return templates;
        });
        /**
   * Load all the templates
   * @return {Promise<Array>}
   */ Templates.load = function() {
            // If there are templates in localStorage, migrate them to the backend, otherwise just make a request to get all of the templates
            return Storage.getItem(storageKey) ? Templates._migrate(Storage.getItem(storageKey)) : Templates.getList();
        };
        /**
   * Migrate the local storage templates to the database
   * @param  {array} templates
   * @return {Promise<Array>}
   */ Templates._migrate = function(templates) {
            var toCreate = []; // Loop through all the templates, and create an object in the correct format
            for(var i = 0; i < templates.length; i++){
                var template = templates[i];
                for(var j = 0; j < template.templates.length; j++)toCreate.push({
                    mapID: template.templates[j],
                    workspaceID: templates[i].ID,
                    sorder: j
                });
            } // PUT all the templates
            return Templates.customPUT(toCreate).then(function(templates) {
                // Remove from local storage
                Storage.removeItem(storageKey);
                Restangular.restangularizeCollection(null, templates, "mapping/templates");
                return templates;
            });
        };
        return Templates;
    }
]);

},{}],"4QH0f":[function(require,module,exports) {
angular.module("modules:mapping").factory("Theme", [
    "Restangular",
    "API_ROOT",
    function(Restangular, API_ROOT) {
        var Themes = Restangular.all("mapping/themes"); // add a custom methods to collections of collections
        Restangular.addElementTransformer("mapping/themes", true, function(themes) {
            // don't try to work on uninitialized collection
            if (!("one" in themes)) return themes;
            return themes;
        });
        Themes.validateCSS = function(css, label, fontSize) {
            return Themes.customPOST({
                css,
                variables: {
                    label,
                    fontSize
                }
            }, "validate");
        };
        /**
   *
   * @param collection
   * @return {{}}
   */ Themes.getDefaultLabelFormats = function(collection) {
            var result = {};
            if ("properties" in collection) collection.properties.forEach(function(property) {
                if (Themes.shouldGetDefaultFormat(property)) // Apply the number format
                result[property.column] = Themes.getDefaultNumericLabelFormat(property);
            });
            return result;
        };
        /**
   * Return whether or not we should even apply a default label format
   *
   * @param property
   * @return {boolean}
   */ Themes.shouldGetDefaultFormat = function(property) {
            if (Themes.isNumericColumnType(property.type)) {
                if (property.column === "lat" || property.column === "lon" || property.column === "lon" || property.column.toLowerCase().includes("latitude") || property.column.toLowerCase().includes("longitude")) return false;
                 // Integers that shouldn't be formated (commas, etc). ID's and similar.
                if (property.column === "ogc_fid" || property.name === "ogc_fid" || property.column.endsWith("ID") || property.column.toLowerCase().endsWith("_id")) return false;
                return true;
            }
            return false;
        };
        /**
   * Takes a given column type (intv, text, varchar, numeric, etc)
   *
   * @param type string
   */ Themes.isDecimalColumnType = function(type) {
            return type.startsWith("float") || type.startsWith("numeric") || type.startsWith("money");
        };
        /**
   * Takes a column type and returns whether or not it represents a number column
   *
   * @param type
   * @return {*|boolean}
   */ Themes.isNumericColumnType = function(type) {
            return Themes.isDecimalColumnType(type) || type.startsWith("int");
        };
        /**
   * Given a property, returns the appropriate number format, assuming it is a numeric column
   *
   * @param property
   * @return string
   */ Themes.getDefaultNumericLabelFormat = function(property) {
            var looksLikePercent = property.column.includes("%") || property.column.includes("pct") || property.column.toLowerCase().includes("percent") || property.name.includes("%") || property.name.includes("pct") || property.name.toLowerCase().includes("percent");
            var looksLikeMoney = property.type.startsWith("money") || property.column.includes("dollar") || property.column.includes("revenue") || property.column.includes("spend") || property.column.includes("sales") && (property.column.includes("total") || property.column.includes("by")) || property.name.includes("dollar") || property.name.includes("spend") || property.name.includes("sales") && (property.name.includes("total") || property.name.includes("by")); // As factor - If column name or name includes "factor"
            var looksLikeFactor = property.column.includes("factor") || property.name.includes("factor"); // Set the baseline format based on whether this basically looks like a decimal value or not
            var format = Themes.isDecimalColumnType(property.type) || looksLikeFactor ? "0.0" : "0,0";
            if (looksLikePercent) format += "%";
            if (looksLikeMoney) format = "$" + format;
            return format;
        };
        /**
   *
   * @param collection
   * @return {{}}
   */ Themes.getDefaultLabelZeros = function(collection) {
            var result = {};
            if ("properties" in collection) collection.properties.forEach(function(property) {
                if (Themes.isNumericColumnType(property.type)) // Apply the number format
                result[property.column] = true;
            });
            return result;
        };
        Themes.getDefaultCss = function(collection) {
            var body = "";
            if (collection === undefined || !("geometryType" in collection) || !("tableName" in collection)) return body;
            if ([
                "multilinestring",
                "linestring",
                "multipolygon",
                "polygon"
            ].includes(collection.geometryType)) body = [
                "line-color:      #66686b",
                "line-width:      1",
                "line-opacity:    1",
                "polygon-fill:    #0b80d0",
                "polygon-opacity: 0.3",
                "setLabel(_, _,   #000)"
            ].join(";\n  ") + ";";
            else if ([
                "multipoint",
                "point"
            ].includes(collection.geometryType)) body = [
                "marker-fill:          #1883ce",
                "marker-file:          url(marker.svg)",
                "marker-width:         15",
                "marker-transform:     translate(0,-10)",
                "marker-allow-overlap: true",
                "setLabel(_, _,        #000)"
            ].join(";\n  ") + ";";
            else if (collection.type == "writable") body = [
                "line-color:           #66686b;",
                "line-width:           1;",
                "line-opacity:         1;",
                "polygon-fill:         #0b80d0;",
                "polygon-opacity:      0.3;",
                "setLabel(_, _,        #000);",
                "[__vis_id=1] {polygon-fill: #e41a1c}",
                "[__vis_id=2] {polygon-fill: #377eb8}",
                "[__vis_id=3] {polygon-fill: #4daf4a}",
                "[__vis_id=4] {polygon-fill: #984ea3}",
                "[__vis_id=5] {polygon-fill: #ff7f00}",
                "[__vis_id=6] {polygon-fill: #ffff33}",
                "[__vis_id=7] {polygon-fill: #a65628}",
                "[__vis_id=8] {polygon-fill: #f781bf}"
            ].join("\n  ");
            else if ([
                "geometry",
                "geometrycollection"
            ].includes(collection.geometryType)) body = [
                "line-color:           #66686b",
                "line-width:           1",
                "line-opacity:         1",
                "polygon-fill:         #0b80d0",
                "polygon-opacity:      0.3",
                "marker-fill:          #1883ce",
                "marker-file:          url(marker.svg)",
                "marker-width:         15",
                "marker-transform:     translate(0,-10)",
                "marker-allow-overlap: true",
                "setLabel(_, _,        #000)"
            ].join(";\n  ") + ";";
            return "#" + collection.tableName + " {\n  " + body + "\n}";
        };
        Themes.getDefaultTheme = function(collection, workspaceID, name = null) {
            return {
                collectionID: collection === undefined ? null : collection.ID,
                workspaceID,
                name: name || new Date().toLocaleString(),
                legend: [],
                label: null,
                customLabel: null,
                labelFormats: collection === undefined ? {} : Themes.getDefaultLabelFormats(collection),
                labelZeroes: collection === undefined ? {} : Themes.getDefaultLabelZeros(collection),
                fontSize: 10,
                css: collection === undefined ? "" : Themes.getDefaultCss(collection)
            };
        };
        /**
   * Strip everything off the object except for data.
   * (Note: not recursive.)
   */ Themes.dataOnly = function(dirty) {
            return Object.keys(Restangular.stripRestangular(dirty)).filter((k)=>typeof dirty[k] !== "function").reduce((clean, k)=>({
                    ...clean,
                    [k]: dirty[k]
                }), {});
        };
        return Themes;
    }
]);

},{}],"3soQH":[function(require,module,exports) {
angular.module("modules:mapping").factory("Workspace", [
    "$rootScope",
    "Restangular",
    "Collection",
    "Map",
    "$http",
    "$timeout",
    "Session",
    "PermissionManager",
    function($rootScope, Restangular, Collection, Map, $http, $timeout, Session, PermissionManager) {
        var Workspaces = Restangular.all("mapping/workspaces"); // add a custom methods to collections of collections
        Restangular.addElementTransformer("mapping/workspaces", true, function(workspaces) {
            // don't try to work on uninitialized collection
            if (!("one" in workspaces)) return workspaces;
            workspaces.addRestangularMethod("search", "getList", "search");
            workspaces.getWorkspace = function(ID) {
                if (!ID) ID = workspaces[0].ID;
                return workspaces.get(ID, {
                    with: "all"
                }).catch(function(response) {
                    // don't show the error modal. just try to get another workspace
                    $timeout.cancel(response.modalTimeout);
                    return workspaces.get(_.find(workspaces, {
                        default: true
                    }).ID, {
                        with: "all"
                    });
                });
            };
            /**
     * Finds a map by ID in the workspaces
     * @param  {integer} mapID
     * @return {object}  the found map
     */ workspaces.findMap = function(mapID) {
                for(var i = 0; i < workspaces.length; i++){
                    var map = _.find(workspaces[i].maps, {
                        ID: mapID * 1
                    });
                    if (map) return map;
                }
            };
            return workspaces;
        }); // add methods to single collections
        Restangular.addElementTransformer("mapping/workspaces", false, function(workspace) {
            if (!("one" in workspace)) return workspace;
            workspace.postClone = function() {
                return workspace.post("", {
                    name: workspace.name
                }, {
                    with: "all"
                }).then(function(response) {
                    Restangular.restangularizeElement(null, response, "mapping/workspaces");
                    restangularizeCollections(response.collections);
                    restangularizeMaps(response.maps);
                    return response;
                });
            };
            workspace.removeUser = function(userID) {
                return workspace.customDELETE("users/" + userID);
            }; // workspace.confirmRemoveUser = function(userID) {
            //   return workspace.customDELETE('users/'+userID, {confirm: true})
            // }
            workspace.saveUsers = function(users) {
                return workspace.customPUT(_.map(users, "ID"), "users");
            };
            workspace.getTopLevelMaps = function() {
                return workspace.maps ? workspace.maps.filter((m)=>!m.parentID) : [];
            };
            /**
     * Remove a collection from this workspace
     * @param  {int} collectionID
     * @return {Promise}
     */ workspace.removeCollection = function(collectionID) {
                return this.customDELETE("collections/" + collectionID).then((response)=>{
                    this.collections.splice(_.findIndex(this.collections, {
                        ID: collectionID
                    }), 1);
                    for(let i = 0; i < this.maps.length; i++)this.maps[i].removeCollection(collectionID);
                    return response;
                });
            };
            restangularizeCollections(workspace.collections);
            restangularizeMaps(workspace.maps);
            return workspace;
        });
        function restangularizeCollections(collections) {
            if (collections) for(var i = 0; i < collections.length; i++)Restangular.restangularizeElement(null, collections[i], "mapping/collections");
        }
        function restangularizeMaps(maps) {
            if (maps) for(var i = 0; i < maps.length; i++)Restangular.restangularizeElement(null, maps[i], "mapping/maps");
        }
        return Workspaces;
    }
]);

},{}],"jBeP5":[function(require,module,exports) {
angular.module("modules:mapping").directive("contextMenu", function() {
    return {
        templateUrl: "/directives/mapping/context-menu.html",
        scope: {
            sections: "=",
            select: "="
        }
    };
});

},{}],"dVXRy":[function(require,module,exports) {
L.ContextMenu = L.Layer.extend({
    initialize: function(latlng, $compile, sections, $scope) {
        this._latlng = latlng;
        this.$compile = $compile;
        this.$scope = $scope.$new();
        this.$scope.sections = sections;
        this.$scope.select = (section, item, e)=>{
            e.stopPropagation();
            let func = typeof item.onSelect == "function" ? item.onSelect : section.onSelect, map = this._map;
            this._map.removeLayer(this);
            func(item, map, this._latlng);
        };
    },
    onAdd: function(map) {
        this._map = map; // create a DOM element and put it into one of the map panes
        this._el = L.DomUtil.create("div", "context-menu leaflet-zoom-hide");
        $(this._el).append(this.$compile('<span context-menu class="leaflet-zoom-hide" sections="sections" select="select"></span>')(this.$scope).get(0));
        map.getPanes().overlayPane.appendChild(this._el); // add a viewreset event listener for updating layer's position, do the latter
        map.on("viewreset", this._reset, this);
        this._reset();
    },
    onRemove: function(map) {
        // remove layer's DOM elements and listeners
        map.getPanes().overlayPane.removeChild(this._el);
        map.off("viewreset", this._reset, this);
    },
    _reset: function() {
        // update layer's position
        var pos = this._map.latLngToLayerPoint(this._latlng);
        L.DomUtil.setPosition(this._el, pos);
    }
});

},{}],"kBROE":[function(require,module,exports) {
/**
 * A Leaflet layer for text layers
 */ angular.module("modules:mapping").factory("LabelLayer", [
    "$log",
    function($log) {
        var LabelLayer = L.Layer.extend({
            options: {
                class: "map-feature-label",
                text: "",
                fontSize: 26,
                enableEditing: true
            },
            _visible: false,
            _parent: null,
            _parentBounds: null,
            _latlng: null,
            _editing: false,
            _overBtn: false,
            // initialize a new label
            initialize: function(layer, options) {
                L.setOptions(this, options);
                this._parent = layer;
                this._parentBounds = layer.getBounds();
                try {
                    this._latlng = this._getCentroid(layer.feature);
                } catch (e) {
                    $log.error(e);
                }
            },
            onAdd: function(map) {
                if (!this._latlng) return;
                this._map = map; // add a moveend event listener for updating layer's position
                map.on("moveend", this._adjustToViewport, this);
                this._el = L.DomUtil.create("div", this.options.class + " leaflet-zoom-hide");
                $(this._el).append(this._getLabel());
                if (this.options.enableEditing) {
                    let editBtn = this._getEditButton();
                    $(this._el).append(editBtn);
                }
                this._adjustToViewport();
            },
            onRemove: function(map) {
                if (!this._latlng) return; // remove layer's DOM elements and listeners
                if (this._el && this._visible) map.getPanes().overlayPane.removeChild(this._el);
                this._visible = false;
                map.off("moveend", this._adjustToViewport, this);
            },
            getLatLng: function() {
                return this._latlng;
            },
            _getLabel: function() {
                return '<span class="text">' + (this.options.text || "") + "</span>";
            },
            _getEditButton () {
                let btn = $('<span class="icon-edit"></span>'); // Hide the button by default.
                btn.hide(); // Show the edit button when hovering over the polygon.
                this._parent.on("mouseover", ()=>{
                    if (this._editing) return;
                    btn.show();
                }); // Hide the edit button when mouse leaves the polygon (but put it
                // in a timeout in case the mouse goes to the edit button itself).
                this._parent.on("mouseout", ()=>{
                    if (this._editing) return;
                    this._hideIconTimeout = setTimeout(function() {
                        btn.hide();
                    }, 0);
                }); // If the mouse is over the edit button, don't hide it!
                btn.mouseenter(()=>{
                    if (this._hideIconTimeout != null) {
                        clearTimeout(this._hideIconTimeout);
                        this._hideIconTimeout = null;
                    }
                });
                btn.click(this._openEditor.bind(this));
                return btn;
            },
            _openEditor () {
                if (this._editing) return;
                this._editing = true; // Hide the label, and put this element on top of everything.
                let el = $(this._el);
                el.find(".text, .icon-edit").hide();
                el.css("z-index", 1000000); // Also disable map interaction while editing.
                this._map.dragging.disable();
                this._map.touchZoom.disable();
                this._map.doubleClickZoom.disable();
                this._map.scrollWheelZoom.disable();
                this._map.keyboard.disable();
                if (this._map.tap) this._map.tap.disable(); // Create a textarea filled with the label text.
                // Add a tiny toolbar with save, cancel, and fontsize (show pre-scaled value, but set scaled; up/down buttons).
                let editor = $(`<div class="editor">
          <div class="toolbar">
            <button class="save">Save</button>
            <button class="cancel">Cancel</button>
            <select class="font-size">
              ${fontSizeOptions(this.options.fontSize)}
            </select>
          </div>
          <textarea>${this.options.text || ""}</textarea>
        </div>`); // On save, update label and close editor.
                editor.find(".save").click(()=>{
                    this.options.text = editor.find("textarea").val();
                    this.options.fontSize = parseInt(editor.find("select").val());
                    el.find(".text").html(this.options.text || "");
                    this._closeEditor();
                    this.fire("text-edit", {
                        text: this.options.text,
                        fontSize: this.options.fontSize
                    });
                }); // On close, close but don't update label.
                editor.find(".cancel").click(this._closeEditor.bind(this)); // On font size change, update and scale font size.
                editor.find(".font-size").change((e)=>{
                    this._updateFontSize(e.target.value);
                });
                el.append(editor);
                function fontSizeOptions(selected) {
                    nums = [
                        8,
                        10,
                        12,
                        14,
                        16,
                        18,
                        20,
                        22,
                        24,
                        26,
                        28,
                        36,
                        48,
                        72,
                        120,
                        240,
                        500,
                        750,
                        1000
                    ];
                    return _.map(nums, function(val) {
                        return `<option value="${val}" ${val == selected ? 'selected="selected"' : ""}">${val}</option>`;
                    });
                }
            },
            _closeEditor () {
                this._editing = false; // Show the label, and put this layer back into its place in the stack.
                let el = $(this._el);
                el.find(".text, .icon-edit").show();
                el.css("z-index", ""); // Enable map interactions.
                this._map.dragging.enable();
                this._map.touchZoom.enable();
                this._map.doubleClickZoom.enable();
                this._map.scrollWheelZoom.enable();
                this._map.keyboard.enable();
                if (this._map.tap) this._map.tap.enable(); // Remove the editor
                el.find(".editor").remove();
                this._adjustToViewport();
            },
            /**
     * Get centroid of a polygon
     * http://en.wikipedia.org/wiki/Centroid#Centroid_of_polygon
     * @param  {object} feature
     * @return {L.LatLng}
     */ _getCentroid: function(feature) {
                var points, center, area = 0, lat = 0, lng = 0; // if a multipolygon, choose the biggest polygon
                if (feature.geometry.type == "MultiPolygon") {
                    points = feature.geometry.coordinates[0][0];
                    for(var i = 0; i < feature.geometry.coordinates.length; i++)if (feature.geometry.coordinates[i][0].length > points.length) points = feature.geometry.coordinates[i][0];
                } else if (feature.geometry.type == "Point") return new L.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
                else points = feature.geometry.coordinates[0];
                for(var i = 0; i < points.length - 1; i++)// each point is [lng,lat]
                area += points[i][0] * points[i + 1][1] - points[i + 1][0] * points[i][1];
                area = 0.5 * area; // get longitude (x)
                for(var i = 0; i < points.length - 1; i++)lng += (points[i][0] + points[i + 1][0]) * (points[i][0] * points[i + 1][1] - points[i + 1][0] * points[i][1]);
                lng = 1 / (6 * area) * lng; // get latitude (y)
                for(var i = 0; i < points.length - 1; i++)lat += (points[i][1] + points[i + 1][1]) * (points[i][0] * points[i + 1][1] - points[i + 1][0] * points[i][1]);
                lat = 1 / (6 * area) * lat;
                return new L.LatLng(lat, lng);
            },
            _scaleFontSize: function(fontSize, zoom, min, max) {
                let size = fontSize * Math.pow(2, zoom - 11);
                if (min && size < min) return min;
                if (max && size > max) return max;
                return size;
            },
            // Set and return scaled font size
            _updateFontSize (fontSize) {
                let scaledFontSize = this._scaleFontSize(fontSize || this.options.fontSize, this._map.getZoom());
                this._el.style.fontSize = scaledFontSize + "px";
                return scaledFontSize;
            },
            // hide label, or show label and update position
            _adjustToViewport: function() {
                let fontSize = this._updateFontSize(); // hide label
                if (this._visible && !this._shouldBeVisible(fontSize)) {
                    this._map.getPanes().overlayPane.removeChild(this._el);
                    this._visible = false;
                    return;
                } // show label
                if (!this._visible && this._shouldBeVisible(fontSize)) {
                    this._map.getPanes().overlayPane.appendChild(this._el);
                    this._visible = true;
                } // set position
                var pos = this._map.latLngToLayerPoint(this._latlng), size = this._getSize();
                pos.x -= size.width / 2;
                L.DomUtil.setPosition(this._el, pos);
                this._el.style.width = size.width + "px";
            },
            // Check if the parent is at all visible. If not, don't show this one.
            _shouldBeVisible (fontSize) {
                if (!this._map) return false;
                if (fontSize < 8 || fontSize > 100) return false;
                return !("_parts" in this._parent) || !!this._parent._parts.length;
            },
            _getSize: function() {
                var topLeft = this._map.latLngToLayerPoint(this._parentBounds.getNorthWest()), bottomRight = this._map.latLngToLayerPoint(this._parentBounds.getSouthEast());
                return {
                    width: Math.abs(bottomRight.x - topLeft.x),
                    height: Math.abs(topLeft.y - bottomRight.y)
                };
            }
        });
        return LabelLayer;
    }
]);

},{}],"9BRb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _bbox = require("@turf/bbox");
var _bboxDefault = parcelHelpers.interopDefault(_bbox);
var _bboxPolygon = require("@turf/bbox-polygon");
var _bboxPolygonDefault = parcelHelpers.interopDefault(_bboxPolygon);
var _area = require("@turf/area");
var _areaDefault = parcelHelpers.interopDefault(_area);
var _intersect = require("@turf/intersect");
var _intersectDefault = parcelHelpers.interopDefault(_intersect);
var _booleanContains = require("@turf/boolean-contains");
var _booleanContainsDefault = parcelHelpers.interopDefault(_booleanContains);
var _helpers = require("@turf/helpers");
/**
 * An object with a variety of map-related method which a controller can use to interact with Leaflet
 * @param {object} map A instance of L.map
 * @return {void}
 */ angular.module("modules:mapping").factory("TruMap", [
    "$rootScope",
    "$compile",
    "TILE_URL",
    "TEGOLA_URL",
    "LabelLayer",
    function($rootScope, $compile, TILE_URL, TEGOLA_URL, LabelLayer) {
        function TruMap(map, isPublicPage) {
            this._map = map;
            this._layers = {};
            this._uuid = 0;
            this._tileUrl = TILE_URL;
            this._tegolaUrl = TEGOLA_URL;
            this._tileLayerID = null;
            this.isPublicPage = isPublicPage;
            this._contextMenu = null;
            this._drawnItems = null;
            this._drawControl = null;
            this._drawOptionsToolbar = null;
            this._vectorLayer = null;
            this._vectorLayerNames = null;
            this._map.attributionControl.addAttribution('<a href="https://www.mapbox.com/about/maps/" target="_blank">\xa9 Mapbox</a> <a href="https://openstreetmap.org/about/" target="_blank">\xa9 OpenStreetMap</a> <a class="mapbox-improve-map" href="https://www.mapbox.com/map-feedback/#mapbox.streets/-76.880/38.880/11" target="_blank">Improve this map</a>');
            this._map.attributionControl.setPrefix(""); // Remove flag
        }
        TruMap.prototype = {
            /**
     * Add a tile layer to the map
     * @param user     A Mapbox user to fetch the style from
     * @param styleID  A valid MapBox tile set style identifier
     * @param tileSize The size of the tiles. Either 256 or 512 pixels
     * @param highDPI  If true, use high dpi tiles
     * @param {string} accessToken MapBox access token
     * @return {void}
     */ addMapBoxTileLayer: function(user, styleID, tileSize, highDPI, accessToken) {
                highDPI = highDPI === true || highDPI === "true" || highDPI === "TRUE" ? "@2x" : "";
                L.tileLayer("https://api.mapbox.com/styles/v1/" + user + "/" + styleID + "/tiles/" + tileSize + "/{z}/{x}/{y}" + highDPI + "?access_token=" + accessToken, {
                    maxZoom: 18
                }).addTo(this._map);
            },
            /**
     * Add a vector tile layer from Epiphany. For now, this vector layer is invisible and used only for interactions.
     * @param {string} id
     * @param {string[]} layerNames
     * @param {object} layerIds
     * @param {function} onSelect
     * @param {function} onDeselect
     * @returns {void}
     */ addOrUpdateTruVectorLayer: function(id, layerNames, layerIds, onSelect, onDeselect) {
                this._vectorLayerNames = layerNames; // If no layers, remove the vector layer entirely.
                if (!id || !layerNames || !layerNames.length) {
                    if (this._vectorLayer) {
                        this._map.removeLayer(this._vectorLayer);
                        this._vectorLayer = null;
                    }
                    return;
                }
                const url = `${this._tegolaUrl}/maps/${id}/{z}/{x}/{y}.pbf`; // Add the vector layer.
                if (!this._vectorLayer) {
                    this._vectorLayer = L.maplibreGL({
                        style: {
                            "version": 8,
                            "sources": {
                                "tileSource": {
                                    "type": "vector",
                                    tiles: [
                                        url
                                    ],
                                    "promoteId": layerIds
                                }
                            },
                            "layers": layerNames.flatMap(this._makeVectorLayerStyles)
                        },
                        interactive: true,
                        // Disable most zoom/pan interactions so that Leaflet can control it all
                        boxZoom: false,
                        scrollZoom: false,
                        doubleClickZoom: false,
                        keyboard: false,
                        dragPan: false,
                        dragRotate: false,
                        touchPitch: false,
                        touchZoomRotate: false
                    }).addTo(this._map);
                    const maplibreMap = this._vectorLayer.getMaplibreMap(); // Enable selecting shapes in the layer.
                    this._addClickSelectHandler(onSelect, onDeselect);
                    this._addMarqueeSelectHandler(onSelect, onDeselect);
                    return;
                }
                const maplibreMap = this._vectorLayer.getMaplibreMap(); // Remove layers not required.
                for (const layer of maplibreMap.style.stylesheet.layers)if (!layerNames.includes(layer["source-layer"])) maplibreMap.removeLayer(layer.id);
                 // Add new layers.
                for (const name1 of layerNames)if (!maplibreMap.style.hasLayer(name1)) this._makeVectorLayerStyles(name1).forEach((s)=>maplibreMap.addLayer(s));
                 // Ensure that the promoteId dictionary is current.
                maplibreMap.getSource("tileSource").promoteId = layerIds; // Force a reload of the tiles.
                maplibreMap.getSource("tileSource").setTiles([
                    `${url}?ts=${Date.now()}`
                ]);
            },
            _makeVectorLayerStyles: function(name1) {
                // Two layers are required: a fill to receive clicks and a line to highlight.
                return [
                    {
                        "id": name1,
                        "source": "tileSource",
                        "source-layer": name1,
                        "type": "fill",
                        "layout": {
                            "visibility": "visible"
                        },
                        "paint": {
                            "fill-color": [
                                "case",
                                [
                                    "boolean",
                                    [
                                        "feature-state",
                                        "selected"
                                    ],
                                    false
                                ],
                                "rgba(63,96,165,0.2)",
                                "rgba(63,96,165,0)" // hidden when selected=false
                            ]
                        }
                    },
                    {
                        "id": `${name1}-border`,
                        "source": "tileSource",
                        "source-layer": name1,
                        "type": "line",
                        "layout": {
                            "visibility": "visible"
                        },
                        "paint": {
                            "line-color": [
                                "case",
                                [
                                    "boolean",
                                    [
                                        "feature-state",
                                        "selected"
                                    ],
                                    false
                                ],
                                "#3f60a5",
                                "rgba(63,96,165,0)" // hidden when selected=false
                            ],
                            "line-width": 2
                        }
                    }
                ];
            },
            /**
     * Select or deselect a single feature on shift/ctrl+click or alt+click.
     */ _addClickSelectHandler (onSelect, onDeselect) {
                if (!this._vectorLayer) return;
                const maplibreMap = this._vectorLayer.getMaplibreMap(); // Where a click lands on multiple layers, process the click only for the topmost.
                maplibreMap.on("click", (e)=>{
                    const features = maplibreMap.queryRenderedFeatures(e.point);
                    let selected = undefined;
                    for (layerName of this._vectorLayerNames){
                        selected = features.find((f)=>f.layer.id == layerName);
                        if (selected != undefined) break;
                    }
                    if (!selected) return;
                    const select = this._shouldSelect(e), deselect = this._shouldDeselect(e);
                    if (select || deselect) {
                        maplibreMap.setFeatureState({
                            source: selected.source,
                            sourceLayer: selected.sourceLayer,
                            id: selected.id
                        }, {
                            selected: select
                        });
                        if (select && onSelect) onSelect([
                            selected
                        ]);
                        else if (!select && onDeselect) onDeselect([
                            selected
                        ]);
                    }
                });
            },
            /**
     * Select or deselect multiple features in a box drawn by shift/ctrl+mousedown+drag or alt+mousedown+drag.
     */ _addMarqueeSelectHandler (onSelect, onDeselect) {
                if (!this._vectorLayer) return;
                const maplibreMap = this._vectorLayer.getMaplibreMap();
                const truMap = this;
                let startPoint, currentPoint, startLatLng, currentLatLng, box, adding;
                maplibreMap.on("mousedown", mouseDown.bind(this));
                function mouseDown(e) {
                    startPoint = currentPoint = startLatLng = currentLatLng = null;
                    const select = this._shouldSelect(e), deselect = this._shouldDeselect(e); // Don't do anything if the user isn't holding down shift/ctrl or alt.
                    if (!select && !deselect) return;
                    truMap._map.dragging.disable();
                    maplibreMap.on("mousemove", mouseMove);
                    maplibreMap.on("mouseup", mouseUp);
                    startPoint = e.point;
                    startLatLng = e.lngLat;
                    adding = select; // if not adding, then removing (alt).
                }
                function mouseMove(e) {
                    currentPoint = e.point;
                    currentLatLng = e.lngLat;
                    if (!box) {
                        box = document.createElement("div");
                        box.classList.add("marquee-select");
                        maplibreMap.getCanvasContainer().appendChild(box);
                    }
                    const minX = Math.min(startPoint.x, currentPoint.x), maxX = Math.max(startPoint.x, currentPoint.x), minY = Math.min(startPoint.y, currentPoint.y), maxY = Math.max(startPoint.y, currentPoint.y);
                    const pos = `translate(${minX}px, ${minY}px)`;
                    box.style.transform = pos;
                    box.style.width = maxX - minX + "px";
                    box.style.height = maxY - minY + "px";
                }
                function mouseUp(e) {
                    truMap._map.dragging.enable();
                    maplibreMap.off("mousemove", mouseMove);
                    maplibreMap.off("mouseup", mouseUp);
                    if (box) {
                        box.parentNode.removeChild(box);
                        box = null;
                    }
                    if (!currentPoint) return;
                    const bounds = [
                        startPoint,
                        currentPoint
                    ];
                    const latlngs = [
                        startLatLng,
                        currentLatLng
                    ];
                    startPoint = currentPoint = startLatLng = currentLatLng = undefined; // For marquee select, we select ONLY from the topmost selectable layer.
                    const features = maplibreMap.queryRenderedFeatures(bounds, {
                        layers: [
                            truMap._vectorLayerNames[0]
                        ]
                    });
                    if (!features) return;
                    const boundsPolygon = (0, _bboxPolygonDefault.default)(latlngs.flatMap((b)=>[
                            b.lng,
                            b.lat
                        ]));
                    const finalFeatures = features.filter((f)=>{
                        // Get the bounding box of the shape. If it's entirely contained inside the selection box, it's definitely in.
                        const geo = f.toJSON(); // toJSON() leaves behind _geometry which can be huge and makes future copying of this object extremely expensive. Clear it.
                        delete f._geometry; // For speed, if the feature's bounding box is entirely contained in the selection box, we don't need to calculate its area, etc.
                        if ((0, _booleanContainsDefault.default)(boundsPolygon, (0, _bboxPolygonDefault.default)((0, _bboxDefault.default)(geo)))) return true;
                         // Count this feature as selected only if the selection box covers more than 30% of its area.
                        const intersection = (0, _intersectDefault.default)(geo, boundsPolygon);
                        if (!intersection) return false;
                        return (0, _areaDefault.default)(intersection) / (0, _areaDefault.default)(geo) > 0.3;
                    });
                    for (feature of finalFeatures)maplibreMap.setFeatureState({
                        source: feature.source,
                        sourceLayer: feature.sourceLayer,
                        id: feature.id
                    }, {
                        selected: adding
                    });
                    if (adding && onSelect) onSelect(finalFeatures);
                    else if (onDeselect) onDeselect(finalFeatures);
                }
            },
            /**
     * Detect a shift or ctrl/cmd keypress from the given event, depending on OS.
     */ _shouldSelect (event) {
                const isMac = !!(navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform).match(/^mac/i);
                return !!event.originalEvent.shiftKey || isMac && !!event.originalEvent.metaKey || !isMac && !!event.originalEvent.ctrlKey;
            },
            /**
     * Detect an alt/option keypress from the given event.
     */ _shouldDeselect (event) {
                return !!event.originalEvent.altKey;
            },
            /**
     * Restore feature state of all vector layers with selections.
     * @param {string[]} layerNames
     * @returns
     */ clearSelection (layerNames) {
                if (!this._vectorLayer || !layerNames) return;
                const maplibreMap = this._vectorLayer.getMaplibreMap();
                for (name of layerNames){
                    maplibreMap.removeFeatureState({
                        source: "tileSource",
                        sourceLayer: name
                    });
                    maplibreMap.removeFeatureState({
                        source: "tileSource",
                        sourceLayer: name + "-border"
                    });
                }
            },
            /**
     * Add a tile layer from Epiphany
     * @param {int} id
     * @return {void}
     */ addOrUpdateTruTileLayer: function(id) {
                if (this._tileLayer) this._map.removeLayer(this._tileLayer);
                this._tileLayer = L.tileLayer(this._tileUrl + "/tile/{id}/{z}/{x}/{y}.png?request=" + new Date().getTime(), {
                    maxZoom: 18,
                    id: id
                }).addTo(this._map);
                this._tileLayerID = id;
                return this._tileLayer;
            },
            /**
     * Add the draw control
     * @param {function} onCreate Creation callback
     * @param {function} onEdit Edit callback
     * @param {function} onDelete Deletion callback
     * @param {function} onRefresh Refresh callback
     */ enableDrawing (onCreate, onEdit, onDelete, onRefresh) {
                if (!this._drawnItems) this._drawnItems = new L.FeatureGroup();
                this._map.addLayer(this._drawnItems);
                this._drawControl = new L.Control.Draw({
                    draw: {
                        polyline: {
                            shapeOptions: {}
                        },
                        polygon: {
                            shapeOptions: {}
                        },
                        rectangle: {
                            showArea: true,
                            metric: false,
                            shapeOptions: {}
                        },
                        circle: {
                            metric: "yards",
                            shapeOptions: {}
                        }
                    },
                    edit: {
                        featureGroup: this._drawnItems
                    }
                });
                this._map.addControl(this._drawControl);
                this._drawOptionsToolbar = this._newDrawOptionsToolbar({
                    refresh: onRefresh
                });
                this._map.addControl(this._drawOptionsToolbar); // Setup callbacks
                this._map.on(L.Draw.Event.CREATED, (e)=>{
                    this._drawnItems.addLayer(e.layer);
                });
                this._map.on(L.Draw.Event.CREATED, create.bind(this));
                this._map.on(L.Draw.Event.EDITED, edit.bind(this));
                this._map.on(L.Draw.Event.DELETED, remove.bind(this)); // On layer creation, setup the GeoJSON property.
                function create(e) {
                    e.layer.feature = {
                        type: "Feature",
                        properties: {
                            id: Date.now(),
                            color: e.layer.options.color
                        }
                    }; // If this is a circle, record its radius (since it otherwise will be indistinguishable from a point).
                    if (e.layer instanceof L.Circle) e.layer.feature.properties.radius = e.layer.options.radius;
                    if (typeof onCreate == "function") onCreate.call(null, e.layer.toGeoJSON());
                } // On layer edit, send an array of edited features.
                function edit(e) {
                    if (typeof onEdit == "function") onEdit.call(null, e.layers.toGeoJSON().features);
                } // On layer deletion, send an array of feature IDs.
                function remove(e) {
                    if (typeof onDelete == "function") {
                        let ids = _.map(e.layers.toGeoJSON().features, function(feature1) {
                            return feature1.properties.id;
                        });
                        onDelete.call(null, ids);
                    }
                }
            },
            /**
     * Remove the draw control
     */ disableDrawing () {
                this._map.removeLayer(this._drawnItems);
                this._map.removeControl(this._drawControl);
                this._drawOptionsToolbar.remove();
                this._map.off(L.Draw.Event.CREATED);
                this._map.off(L.Draw.Event.EDITED);
                this._map.off(L.Draw.Event.DELETED);
            },
            /**
     * Given a GeoJSON layer, setup the drawnItems layer.
     * @param {array} features
     */ setDrawnItems (features) {
                let newDrawn = new L.GeoJSON(features, {
                    style: function(feature1) {
                        return {
                            color: feature1.properties.color,
                            opacity: 0.5
                        };
                    },
                    // Make sure that points with radii are interpreted as circles.
                    pointToLayer: function(feature1, latlng) {
                        if (feature1.properties.radius != null) return L.circle(latlng, {
                            radius: feature1.properties.radius
                        });
                        else return new L.Marker(latlng);
                    }
                });
                if (!this._drawnItems) {
                    this._drawnItems = new L.FeatureGroup();
                    this._map.addLayer(this._drawnItems);
                } // Index current layers by ID.
                let layersByID = {};
                this._drawnItems.getLayers().forEach(function(layer) {
                    layersByID[layer.feature.properties.id] = layer;
                }); // Add new layers, replacing current where ID matches.
                newDrawn.eachLayer((layer)=>{
                    if (layer.feature.properties.id in layersByID) this._drawnItems.removeLayer(layersByID[layer.feature.properties.id]);
                    this._setupTextAnnotation(layer); // Forward events onto the MapLibre canvas so selection can still work over/through annotation shapes.
                    this._forwardEventsToMapLibre(layer, [
                        "mousedown",
                        "mouseup",
                        "mousemove"
                    ]);
                    this._drawnItems.addLayer(layer);
                });
            },
            /**
     * Remove drawn items by ID.
     * @param {array} IDs
     */ removeDrawnItems (IDs) {
                if (!this._drawnItems || !IDs) return;
                this._drawnItems.eachLayer((layer)=>{
                    if (IDs.indexOf(layer.feature.properties.id) != -1) this._drawnItems.removeLayer(layer);
                });
            },
            /**
     * Show text for annotations, and allow editing.
     * @param {object} layer
     */ _setupTextAnnotation (layer) {
                if (!(layer instanceof L.Polygon) && !(layer instanceof L.Circle) && !(layer instanceof L.Rectangle)) return;
                layer.on("add", (e)=>{
                    let props = layer.feature.properties;
                    layer.label = new LabelLayer(layer, {
                        text: props.notes,
                        fontSize: props.font_size || 26,
                        enableEditing: !this.isPublicPage
                    });
                    layer.label.addTo(this._map);
                    layer.label.on("text-edit", (e)=>{
                        props.notes = e.text;
                        props.font_size = e.fontSize; // Manually fire the L.Draw.Event.EDITED event.
                        this._map.fire(L.Draw.Event.EDITED, {
                            layers: new L.LayerGroup([
                                layer
                            ])
                        });
                    });
                });
                layer.on("remove", ()=>{
                    layer.label.remove();
                });
            },
            /**
     * Copy incoming events of the specified types and pass them to the given callback.
     */ _forwardEventsToMapLibre (layer, eventTypes) {
                for (const type of eventTypes)layer.on(type, (e)=>{
                    if (this._vectorLayer) {
                        const event = new MouseEvent(type, {
                            screenX: e.originalEvent.screenX,
                            screenY: e.originalEvent.screenY,
                            clientX: e.originalEvent.clientX,
                            clientY: e.originalEvent.clientY,
                            ctrlKey: e.originalEvent.ctrlKey,
                            shiftKey: e.originalEvent.shiftKey,
                            altKey: e.originalEvent.altKey,
                            metaKey: e.originalEvent.metaKey,
                            button: e.originalEvent.button
                        });
                        this._vectorLayer.getMaplibreMap().getCanvasContainer().dispatchEvent(event);
                    }
                });
            },
            /**
     * Set the menu to open when the map is right-clicked
     * @param {Function} makeMenu A function that returns a L.ContextMenu object
     */ setContextMenu (makeMenu) {
                this._map.on("contextmenu", (e)=>{
                    this.closeContextMenu();
                    makeMenu(e.latlng, this).then((menu)=>{
                        this._contextMenu = menu;
                        this._map.addLayer(menu);
                    });
                });
                this._map.on("click", this.closeContextMenu.bind(this));
            },
            /**
     * Close any context menu that's open
     */ closeContextMenu () {
                if (this._contextMenu) {
                    this._map.removeLayer(this._contextMenu);
                    this._contextMenu = null;
                }
            },
            /**
     * Remove a collection from the map
     * @param  {string} id Unique ID as generated by uniqueId()
     * @return {void}
     */ removeCollection: function(id) {
                this.removeLayer(id);
            },
            /**
     * Check whether a collection is on the map
     * @param {string} id
     * @return {bool}
     */ hasCollection: function(id) {
                return id in this._layers;
            },
            /**
     * Add a single point to the map
     * @param {array} center lat/lon
     * @param {function} makeMenu
     * @return {string} Unique ID for layer
     */ addMarker: function(center, makeMenu) {
                let id = this.uniqueId(), layer = L.marker(center, {
                    icon: L.divIcon({
                        className: "leaflet-marker",
                        iconSize: 40
                    })
                });
                let options = [
                    {
                        name: "Remove marker",
                        onSelect: ()=>{
                            this.closeContextMenu();
                            this.removeLayer(id);
                        }
                    }
                ];
                this._layers[id] = layer;
                layer.addTo(this._map);
                layer.on("contextmenu", (e)=>{
                    this.closeContextMenu();
                    makeMenu(e.latlng, this, options).then((menu)=>{
                        this._contextMenu = menu;
                        this._map.addLayer(menu);
                    });
                });
                return id;
            },
            /**
     * Remove a layer from the map
     * @param  {string} id Unique ID as generated by uniqueId()
     * @return {vodi}
     */ removeLayer: function(id) {
                if (id in this._layers) {
                    this._map.removeLayer(this._layers[id]);
                    delete this._layers[id];
                }
            },
            /**
     * Closes a popup
     * @param {object} popup
     */ closePopup: function(popup) {
                return this._map.closePopup(popup);
            },
            /**
     * Adds a scale indicator to the map
     */ addScale: function() {
                this._scaleIndicator = L.control.scale({
                    metric: false,
                    position: "bottomright"
                });
                this._scaleIndicator.addTo(this._map);
            },
            /**
     * Removes the scale indicator from the map
     */ removeScale: function() {
                this._map.removeControl(this._scaleIndicator);
            },
            /**
     * Remove all layers from the map
     * @param {array} List of layer IDs not to clear.
     * @return {void}
     */ clear: function(except) {
                for(var id in this._layers){
                    if (except && except.includes(id)) continue;
                    this._map.removeLayer(this._layers[id]);
                    delete this._layers[id];
                }
                if (this._tileLayer) this._map.removeLayer(this._tileLayer);
                if (this._vectorLayer) {
                    this._map.removeLayer(this._vectorLayer);
                    this._vectorLayer = null;
                    this._vectorLayerNames = null;
                }
                if (this._drawnItems) {
                    this.disableDrawing();
                    this._drawnItems = null;
                }
            },
            /**
     * Set map center
     * @param {array} center lat/lon
     * @return {void}
     */ setCenter: function(center) {
                this._map.setView(center);
            },
            /**
     * Gets the map's center
     * @return {}
     */ getCenter: function() {
                return this._map.getCenter();
            },
            /**
     * Gets the map's current zoom
     * @return {}
     */ getZoom: function() {
                return this._map.getZoom();
            },
            /**
     * Set map zoom
     * @param {int} zoom
     * @return {void}
     */ setZoom: function(zoom, animate) {
                var animate = !!animate;
                this._map.setZoom(zoom, {
                    animate: animate
                });
            },
            /**
     * Set map center and zoom
     * @param {array} center lat/lon
     * @param {int} zoom
     * @param {object} options
     * @return {void}
     */ setView: function(center, zoom, options) {
                this._map.setView(center, zoom, options);
            },
            /**
     * Returns the Leaflet map object
     * @return {object}
     */ getLeafletMap: function() {
                return this._map;
            },
            /**
     * Reset's the map size
     */ invalidateSize: function() {
                this._map.invalidateSize();
            },
            /**
     * Create a unique ID for a layer
     * @return {string}
     */ uniqueId: function() {
                return "id" + ++this._uuid;
            },
            /**
     * Zoom/pan as necessary to fit the given features into the maps view.
     * @param {*} features 
     */ goTo: function(features) {
                const bounds = (0, _bboxDefault.default)((0, _helpers.featureCollection)(features.map((f)=>f.toJSON())));
                this._map.flyToBounds([
                    [
                        bounds[1],
                        bounds[0]
                    ],
                    [
                        bounds[3],
                        bounds[2]
                    ]
                ], {
                    duration: 0.75,
                    animate: true
                });
            },
            /**
     * Make a toolbar for additional draw controls, like color and refresh.
     * @param {object} options
     * @return {return}
     */ _newDrawOptionsToolbar (options) {
                // Prep a function to change the color for leaflet-draw.
                let setColor = (color)=>{
                    this._drawControl.options.draw.polyline.shapeOptions.color = color;
                    this._drawControl.options.draw.polygon.shapeOptions.color = color;
                    this._drawControl.options.draw.rectangle.shapeOptions.color = color;
                    this._drawControl.options.draw.circle.shapeOptions.color = color;
                };
                let toolbar = L.Control.extend({
                    options: {
                        position: "topleft",
                        colors: [
                            "#d61e42",
                            "#1b8a3b",
                            "#fcb232",
                            "#0884c2",
                            "#040384"
                        ],
                        color: "#d61e42"
                    },
                    _isPaletteOpen: false,
                    onAdd (map) {
                        let div = L.DomUtil.create("div", "leaflet-bar leaflet-control-draw-options");
                        let colorBtn = $(`<a href="#" title="Pick Color" class="color"><span style="background-color: ${this.options.color}"></span></a>`);
                        let refreshBtn = $('<a href="#" title="Refresh Annotations" class="refresh"></a>');
                        colorBtn.click(this._togglePalette.bind(this)).appendTo(div);
                        refreshBtn.click(this.options.refresh).appendTo(div);
                        setColor(this.options.color);
                        return div;
                    },
                    _openPalette () {
                        this._isPaletteOpen = true;
                        if ($(this._container).find("ul.colors").length) return;
                        let actions = $('<ul class="colors leaflet-draw-actions leaflet-draw-actions-bottom"></ul>');
                        actions.css({
                            width: this.options.colors.length * 24
                        });
                        for(let i = 0; i < this.options.colors.length; i++){
                            let color = this.options.colors[i];
                            let li = $(`<li style="background-color:${color}" data-color=${color}></li>`);
                            li.click(this._setColor.bind(this));
                            actions.append(li);
                        }
                        $(this._container).append(actions);
                    },
                    _closePalette () {
                        this._isPaletteOpen = false;
                        $(this._container).find("ul.colors").remove();
                    },
                    _togglePalette () {
                        this._isPaletteOpen ? this._closePalette() : this._openPalette();
                    },
                    _setColor (e) {
                        this.options.color = e.target.getAttribute("data-color");
                        $(this._container).find("a span").css({
                            "background-color": this.options.color
                        });
                        this._closePalette();
                        setColor(this.options.color);
                    }
                });
                return new toolbar(options);
            }
        };
        return TruMap;
    }
]);

},{"@turf/bbox":"g2eLG","@turf/bbox-polygon":"gBwGZ","@turf/area":"aeVQs","@turf/intersect":"8oBIC","@turf/boolean-contains":"7PpTC","@turf/helpers":"j8Evk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"g2eLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _meta = require("@turf/meta");
/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */ function bbox(geojson) {
    var result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, _meta.coordEach)(geojson, function(coord) {
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
bbox["default"] = bbox;
exports.default = bbox;

},{"@turf/meta":"jr58Y","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jr58Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "coordAll", ()=>coordAll);
parcelHelpers.export(exports, "coordEach", ()=>coordEach);
parcelHelpers.export(exports, "coordReduce", ()=>coordReduce);
parcelHelpers.export(exports, "featureEach", ()=>featureEach);
parcelHelpers.export(exports, "featureReduce", ()=>featureReduce);
parcelHelpers.export(exports, "findPoint", ()=>findPoint);
parcelHelpers.export(exports, "findSegment", ()=>findSegment);
parcelHelpers.export(exports, "flattenEach", ()=>flattenEach);
parcelHelpers.export(exports, "flattenReduce", ()=>flattenReduce);
parcelHelpers.export(exports, "geomEach", ()=>geomEach);
parcelHelpers.export(exports, "geomReduce", ()=>geomReduce);
parcelHelpers.export(exports, "lineEach", ()=>lineEach);
parcelHelpers.export(exports, "lineReduce", ()=>lineReduce);
parcelHelpers.export(exports, "propEach", ()=>propEach);
parcelHelpers.export(exports, "propReduce", ()=>propReduce);
parcelHelpers.export(exports, "segmentEach", ()=>segmentEach);
parcelHelpers.export(exports, "segmentReduce", ()=>segmentReduce);
var _helpers = require("@turf/helpers");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function coordEach(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    coordEach(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function propEach(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function propReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    propEach(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function featureEach(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function featureReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    featureEach(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function coordAll(geojson) {
    var coords = [];
    coordEach(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function geomEach(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function geomReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    geomEach(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function flattenEach(geojson, callback) {
    geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, _helpers.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, _helpers.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function flattenReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    flattenEach(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function segmentEach(geojson, callback) {
    flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if (coordEach(feature, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, _helpers.lineString)([
                previousCoords,
                currentCoord
            ], feature.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function segmentReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    segmentEach(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function lineEach(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
        if (feature.geometry === null) return;
        var type = feature.geometry.type;
        var coords = feature.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, _helpers.lineString)(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function lineReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    lineEach(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function findSegment(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, _helpers.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, _helpers.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, _helpers.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, _helpers.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, _helpers.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function findPoint(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, _helpers.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, _helpers.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, _helpers.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, _helpers.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, _helpers.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

},{"@turf/helpers":"j8Evk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"j8Evk":[function(require,module,exports) {
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "earthRadius", ()=>earthRadius);
parcelHelpers.export(exports, "factors", ()=>factors);
parcelHelpers.export(exports, "unitsFactors", ()=>unitsFactors);
parcelHelpers.export(exports, "areaFactors", ()=>areaFactors);
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ parcelHelpers.export(exports, "feature", ()=>feature);
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */ parcelHelpers.export(exports, "geometry", ()=>geometry);
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ parcelHelpers.export(exports, "point", ()=>point);
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ parcelHelpers.export(exports, "points", ()=>points);
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ parcelHelpers.export(exports, "polygon", ()=>polygon);
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ parcelHelpers.export(exports, "polygons", ()=>polygons);
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ parcelHelpers.export(exports, "lineString", ()=>lineString);
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ parcelHelpers.export(exports, "lineStrings", ()=>lineStrings);
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ parcelHelpers.export(exports, "featureCollection", ()=>featureCollection);
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ parcelHelpers.export(exports, "multiLineString", ()=>multiLineString);
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ parcelHelpers.export(exports, "multiPoint", ()=>multiPoint);
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ parcelHelpers.export(exports, "multiPolygon", ()=>multiPolygon);
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */ parcelHelpers.export(exports, "geometryCollection", ()=>geometryCollection);
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */ parcelHelpers.export(exports, "radiansToLength", ()=>radiansToLength);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */ parcelHelpers.export(exports, "lengthToRadians", ()=>lengthToRadians);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */ parcelHelpers.export(exports, "lengthToDegrees", ()=>lengthToDegrees);
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ parcelHelpers.export(exports, "bearingToAzimuth", ()=>bearingToAzimuth);
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ parcelHelpers.export(exports, "radiansToDegrees", ()=>radiansToDegrees);
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ parcelHelpers.export(exports, "degreesToRadians", ()=>degreesToRadians);
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */ parcelHelpers.export(exports, "convertLength", ()=>convertLength);
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */ parcelHelpers.export(exports, "convertArea", ()=>convertArea);
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ parcelHelpers.export(exports, "isNumber", ()=>isNumber);
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateBBox", ()=>validateBBox);
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateId", ()=>validateId);
var earthRadius = 6371008.8;
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
};
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133
};
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function feature(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function geometry(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function point(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function points(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return point(coords, properties);
    }), options);
}
function polygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function polygons(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return polygon(coords, properties);
    }), options);
}
function lineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return lineString(coords, properties);
    }), options);
}
function featureCollection(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function multiLineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return feature(geom, properties, options);
}
function round(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function lengthToRadians(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
    return !!input && input.constructor === Object;
}
function validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
function validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gBwGZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bboxPolygon);
var _helpers = require("@turf/helpers");
function bboxPolygon(bbox, options) {
    if (options === void 0) options = {};
    // Convert BBox positions to Numbers
    // No performance loss for including Number()
    // https://github.com/Turfjs/turf/issues/1119
    var west = Number(bbox[0]);
    var south = Number(bbox[1]);
    var east = Number(bbox[2]);
    var north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    var lowLeft = [
        west,
        south
    ];
    var topLeft = [
        west,
        north
    ];
    var topRight = [
        east,
        north
    ];
    var lowRight = [
        east,
        south
    ];
    return (0, _helpers.polygon)([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}

},{"@turf/helpers":"j8Evk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"aeVQs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>area);
var _meta = require("@turf/meta");
// Note: change RADIUS => earthRadius
var RADIUS = 6378137;
function area(geojson) {
    return (0, _meta.geomReduce)(geojson, function(value, geom) {
        return value + calculateArea(geom);
    }, 0);
}
/**
 * Calculate Area
 *
 * @private
 * @param {Geometry} geom GeoJSON Geometries
 * @returns {number} area
 */ function calculateArea(geom) {
    var total = 0;
    var i;
    switch(geom.type){
        case "Polygon":
            return polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function polygonArea(coords) {
    var total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs(ringArea(coords[0]));
        for(var i = 1; i < coords.length; i++)total -= Math.abs(ringArea(coords[i]));
    }
    return total;
}
/**
 * @private
 * Calculate the approximate area of the polygon were it projected onto the earth.
 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
 *
 * Reference:
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
 * JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007 https://trs.jpl.nasa.gov/handle/2014/40409
 *
 * @param {Array<Array<number>>} coords Ring Coordinates
 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
 */ function ringArea(coords) {
    var p1;
    var p2;
    var p3;
    var lowerIndex;
    var middleIndex;
    var upperIndex;
    var i;
    var total = 0;
    var coordsLength = coords.length;
    if (coordsLength > 2) {
        for(i = 0; i < coordsLength; i++){
            if (i === coordsLength - 2) {
                // i = N-2
                lowerIndex = coordsLength - 2;
                middleIndex = coordsLength - 1;
                upperIndex = 0;
            } else if (i === coordsLength - 1) {
                // i = N-1
                lowerIndex = coordsLength - 1;
                middleIndex = 0;
                upperIndex = 1;
            } else {
                // i = 0 to N-3
                lowerIndex = i;
                middleIndex = i + 1;
                upperIndex = i + 2;
            }
            p1 = coords[lowerIndex];
            p2 = coords[middleIndex];
            p3 = coords[upperIndex];
            total += (rad(p3[0]) - rad(p1[0])) * Math.sin(rad(p2[1]));
        }
        total = total * RADIUS * RADIUS / 2;
    }
    return total;
}
function rad(num) {
    return num * Math.PI / 180;
}

},{"@turf/meta":"jr58Y","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"8oBIC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersect);
var _helpers = require("@turf/helpers");
var _invariant = require("@turf/invariant");
var _polygonClipping = require("polygon-clipping");
var _polygonClippingDefault = parcelHelpers.interopDefault(_polygonClipping);
function intersect(poly1, poly2, options) {
    if (options === void 0) options = {};
    var geom1 = (0, _invariant.getGeom)(poly1);
    var geom2 = (0, _invariant.getGeom)(poly2);
    var intersection = (0, _polygonClippingDefault.default).intersection(geom1.coordinates, geom2.coordinates);
    if (intersection.length === 0) return null;
    if (intersection.length === 1) return (0, _helpers.polygon)(intersection[0], options.properties);
    return (0, _helpers.multiPolygon)(intersection, options.properties);
}

},{"@turf/helpers":"j8Evk","@turf/invariant":"9TTWn","polygon-clipping":"44VwM","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9TTWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ parcelHelpers.export(exports, "getCoord", ()=>getCoord);
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ parcelHelpers.export(exports, "getCoords", ()=>getCoords);
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ parcelHelpers.export(exports, "containsNumber", ()=>containsNumber);
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "geojsonType", ()=>geojsonType);
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ parcelHelpers.export(exports, "featureOf", ()=>featureOf);
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "collectionOf", ()=>collectionOf);
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ parcelHelpers.export(exports, "getGeom", ()=>getGeom);
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ parcelHelpers.export(exports, "getType", ()=>getType);
var _helpers = require("@turf/helpers");
function getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber(coordinates) {
    if (coordinates.length > 1 && (0, _helpers.isNumber)(coordinates[0]) && (0, _helpers.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

},{"@turf/helpers":"j8Evk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"44VwM":[function(require,module,exports) {
var process = require("a8bb8fc6e9bc397d");
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    /**
   * splaytree v3.1.0
   * Fast Splay tree for Node and browser
   *
   * @author Alexander Milevski <info@w8r.name>
   * @license MIT
   * @preserve
   */ var Node = /** @class */ function() {
        function Node(key, data) {
            this.next = null;
            this.key = key;
            this.data = data;
            this.left = null;
            this.right = null;
        }
        return Node;
    }();
    /* follows "An implementation of top-down splaying"
   * by D. Sleator <sleator@cs.cmu.edu> March 1992
   */ function DEFAULT_COMPARE(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    /**
   * Simple top down splay, not requiring i to be in the tree t.
   */ function splay(i, t, comparator) {
        var N = new Node(null, null);
        var l = N;
        var r = N;
        while(true){
            var cmp = comparator(i, t.key); //if (i < t.key) {
            if (cmp < 0) {
                if (t.left === null) break; //if (i < t.left.key) {
                if (comparator(i, t.left.key) < 0) {
                    var y = t.left;
                    /* rotate right */ t.left = y.right;
                    y.right = t;
                    t = y;
                    if (t.left === null) break;
                }
                r.left = t;
                /* link right */ r = t;
                t = t.left; //} else if (i > t.key) {
            } else if (cmp > 0) {
                if (t.right === null) break; //if (i > t.right.key) {
                if (comparator(i, t.right.key) > 0) {
                    var y = t.right;
                    /* rotate left */ t.right = y.left;
                    y.left = t;
                    t = y;
                    if (t.right === null) break;
                }
                l.right = t;
                /* link left */ l = t;
                t = t.right;
            } else break;
        }
        /* assemble */ l.right = t.left;
        r.left = t.right;
        t.left = N.right;
        t.right = N.left;
        return t;
    }
    function insert(i, data, t, comparator) {
        var node = new Node(i, data);
        if (t === null) {
            node.left = node.right = null;
            return node;
        }
        t = splay(i, t, comparator);
        var cmp = comparator(i, t.key);
        if (cmp < 0) {
            node.left = t.left;
            node.right = t;
            t.left = null;
        } else if (cmp >= 0) {
            node.right = t.right;
            node.left = t;
            t.right = null;
        }
        return node;
    }
    function split(key, v, comparator) {
        var left = null;
        var right = null;
        if (v) {
            v = splay(key, v, comparator);
            var cmp = comparator(v.key, key);
            if (cmp === 0) {
                left = v.left;
                right = v.right;
            } else if (cmp < 0) {
                right = v.right;
                v.right = null;
                left = v;
            } else {
                left = v.left;
                v.left = null;
                right = v;
            }
        }
        return {
            left: left,
            right: right
        };
    }
    function merge(left, right, comparator) {
        if (right === null) return left;
        if (left === null) return right;
        right = splay(left.key, right, comparator);
        right.left = left;
        return right;
    }
    /**
   * Prints level of the tree
   */ function printRow(root, prefix, isTail, out, printNode) {
        if (root) {
            out("" + prefix + (isTail ? "└── " : "├── ") + printNode(root) + "\n");
            var indent = prefix + (isTail ? "    " : "│   ");
            if (root.left) printRow(root.left, indent, false, out, printNode);
            if (root.right) printRow(root.right, indent, true, out, printNode);
        }
    }
    var Tree = /** @class */ function() {
        function Tree(comparator) {
            if (comparator === void 0) comparator = DEFAULT_COMPARE;
            this._root = null;
            this._size = 0;
            this._comparator = comparator;
        }
        /**
     * Inserts a key, allows duplicates
     */ Tree.prototype.insert = function(key, data) {
            this._size++;
            return this._root = insert(key, data, this._root, this._comparator);
        };
        /**
     * Adds a key, if it is not present in the tree
     */ Tree.prototype.add = function(key, data) {
            var node = new Node(key, data);
            if (this._root === null) {
                node.left = node.right = null;
                this._size++;
                this._root = node;
            }
            var comparator = this._comparator;
            var t = splay(key, this._root, comparator);
            var cmp = comparator(key, t.key);
            if (cmp === 0) this._root = t;
            else {
                if (cmp < 0) {
                    node.left = t.left;
                    node.right = t;
                    t.left = null;
                } else if (cmp > 0) {
                    node.right = t.right;
                    node.left = t;
                    t.right = null;
                }
                this._size++;
                this._root = node;
            }
            return this._root;
        };
        /**
     * @param  {Key} key
     * @return {Node|null}
     */ Tree.prototype.remove = function(key) {
            this._root = this._remove(key, this._root, this._comparator);
        };
        /**
     * Deletes i from the tree if it's there
     */ Tree.prototype._remove = function(i, t, comparator) {
            var x;
            if (t === null) return null;
            t = splay(i, t, comparator);
            var cmp = comparator(i, t.key);
            if (cmp === 0) {
                /* found it */ if (t.left === null) x = t.right;
                else {
                    x = splay(i, t.left, comparator);
                    x.right = t.right;
                }
                this._size--;
                return x;
            }
            return t;
        /* It wasn't there */ };
        /**
     * Removes and returns the node with smallest key
     */ Tree.prototype.pop = function() {
            var node = this._root;
            if (node) {
                while(node.left)node = node.left;
                this._root = splay(node.key, this._root, this._comparator);
                this._root = this._remove(node.key, this._root, this._comparator);
                return {
                    key: node.key,
                    data: node.data
                };
            }
            return null;
        };
        /**
     * Find without splaying
     */ Tree.prototype.findStatic = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return current;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return null;
        };
        Tree.prototype.find = function(key) {
            if (this._root) {
                this._root = splay(key, this._root, this._comparator);
                if (this._comparator(key, this._root.key) !== 0) return null;
            }
            return this._root;
        };
        Tree.prototype.contains = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return true;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return false;
        };
        Tree.prototype.forEach = function(visitor, ctx) {
            var current = this._root;
            var Q = [];
            /* Initialize stack s */ var done = false;
            while(!done){
                if (current !== null) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length !== 0) {
                    current = Q.pop();
                    visitor.call(ctx, current);
                    current = current.right;
                } else done = true;
            }
            return this;
        };
        /**
     * Walk key range from `low` to `high`. Stops if `fn` returns a value.
     */ Tree.prototype.range = function(low, high, fn, ctx) {
            var Q = [];
            var compare = this._comparator;
            var node = this._root;
            var cmp;
            while(Q.length !== 0 || node)if (node) {
                Q.push(node);
                node = node.left;
            } else {
                node = Q.pop();
                cmp = compare(node.key, high);
                if (cmp > 0) break;
                else if (compare(node.key, low) >= 0) {
                    if (fn.call(ctx, node)) return this; // stop if smth is returned
                }
                node = node.right;
            }
            return this;
        };
        /**
     * Returns array of keys
     */ Tree.prototype.keys = function() {
            var keys = [];
            this.forEach(function(_a) {
                var key = _a.key;
                return keys.push(key);
            });
            return keys;
        };
        /**
     * Returns array of all the data in the nodes
     */ Tree.prototype.values = function() {
            var values = [];
            this.forEach(function(_a) {
                var data = _a.data;
                return values.push(data);
            });
            return values;
        };
        Tree.prototype.min = function() {
            if (this._root) return this.minNode(this._root).key;
            return null;
        };
        Tree.prototype.max = function() {
            if (this._root) return this.maxNode(this._root).key;
            return null;
        };
        Tree.prototype.minNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.left)t = t.left;
            return t;
        };
        Tree.prototype.maxNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.right)t = t.right;
            return t;
        };
        /**
     * Returns node at given index
     */ Tree.prototype.at = function(index) {
            var current = this._root;
            var done = false;
            var i = 0;
            var Q = [];
            while(!done){
                if (current) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length > 0) {
                    current = Q.pop();
                    if (i === index) return current;
                    i++;
                    current = current.right;
                } else done = true;
            }
            return null;
        };
        Tree.prototype.next = function(d) {
            var root = this._root;
            var successor = null;
            if (d.right) {
                successor = d.right;
                while(successor.left)successor = successor.left;
                return successor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) {
                    successor = root;
                    root = root.left;
                } else root = root.right;
            }
            return successor;
        };
        Tree.prototype.prev = function(d) {
            var root = this._root;
            var predecessor = null;
            if (d.left !== null) {
                predecessor = d.left;
                while(predecessor.right)predecessor = predecessor.right;
                return predecessor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) root = root.left;
                else {
                    predecessor = root;
                    root = root.right;
                }
            }
            return predecessor;
        };
        Tree.prototype.clear = function() {
            this._root = null;
            this._size = 0;
            return this;
        };
        Tree.prototype.toList = function() {
            return toList(this._root);
        };
        /**
     * Bulk-load items. Both array have to be same size
     */ Tree.prototype.load = function(keys, values, presort) {
            if (values === void 0) values = [];
            if (presort === void 0) presort = false;
            var size = keys.length;
            var comparator = this._comparator; // sort if needed
            if (presort) sort(keys, values, 0, size - 1, comparator);
            if (this._root === null) {
                // empty tree
                this._root = loadRecursive(keys, values, 0, size);
                this._size = size;
            } else {
                // that re-builds the whole tree from two in-order traversals
                var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
                size = this._size + size;
                this._root = sortedListToBST({
                    head: mergedList
                }, 0, size);
            }
            return this;
        };
        Tree.prototype.isEmpty = function() {
            return this._root === null;
        };
        Object.defineProperty(Tree.prototype, "size", {
            get: function get() {
                return this._size;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tree.prototype, "root", {
            get: function get() {
                return this._root;
            },
            enumerable: true,
            configurable: true
        });
        Tree.prototype.toString = function(printNode) {
            if (printNode === void 0) printNode = function printNode(n) {
                return String(n.key);
            };
            var out = [];
            printRow(this._root, "", true, function(v) {
                return out.push(v);
            }, printNode);
            return out.join("");
        };
        Tree.prototype.update = function(key, newKey, newData) {
            var comparator = this._comparator;
            var _a = split(key, this._root, comparator), left = _a.left, right = _a.right;
            if (comparator(key, newKey) < 0) right = insert(newKey, newData, right, comparator);
            else left = insert(newKey, newData, left, comparator);
            this._root = merge(left, right, comparator);
        };
        Tree.prototype.split = function(key) {
            return split(key, this._root, this._comparator);
        };
        return Tree;
    }();
    function loadRecursive(keys, values, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var key = keys[middle];
            var data = values[middle];
            var node = new Node(key, data);
            node.left = loadRecursive(keys, values, start, middle);
            node.right = loadRecursive(keys, values, middle + 1, end);
            return node;
        }
        return null;
    }
    function createList(keys, values) {
        var head = new Node(null, null);
        var p = head;
        for(var i = 0; i < keys.length; i++)p = p.next = new Node(keys[i], values[i]);
        p.next = null;
        return head.next;
    }
    function toList(root) {
        var current = root;
        var Q = [];
        var done = false;
        var head = new Node(null, null);
        var p = head;
        while(!done){
            if (current) {
                Q.push(current);
                current = current.left;
            } else if (Q.length > 0) {
                current = p = p.next = Q.pop();
                current = current.right;
            } else done = true;
        }
        p.next = null; // that'll work even if the tree was empty
        return head.next;
    }
    function sortedListToBST(list, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var left = sortedListToBST(list, start, middle);
            var root = list.head;
            root.left = left;
            list.head = list.head.next;
            root.right = sortedListToBST(list, middle + 1, end);
            return root;
        }
        return null;
    }
    function mergeLists(l1, l2, compare) {
        var head = new Node(null, null); // dummy
        var p = head;
        var p1 = l1;
        var p2 = l2;
        while(p1 !== null && p2 !== null){
            if (compare(p1.key, p2.key) < 0) {
                p.next = p1;
                p1 = p1.next;
            } else {
                p.next = p2;
                p2 = p2.next;
            }
            p = p.next;
        }
        if (p1 !== null) p.next = p1;
        else if (p2 !== null) p.next = p2;
        return head.next;
    }
    function sort(keys, values, left, right, compare) {
        if (left >= right) return;
        var pivot = keys[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while(true){
            do i++;
            while (compare(keys[i], pivot) < 0);
            do j--;
            while (compare(keys[j], pivot) > 0);
            if (i >= j) break;
            var tmp = keys[i];
            keys[i] = keys[j];
            keys[j] = tmp;
            tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
        sort(keys, values, left, j, compare);
        sort(keys, values, j + 1, right, compare);
    }
    /**
   * A bounding box has the format:
   *
   *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
   *
   */ var isInBbox = function isInBbox(bbox, point) {
        return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
    };
    /* Returns either null, or a bbox (aka an ordered pair of points)
   * If there is only one point of overlap, a bbox with identical points
   * will be returned */ var getBboxOverlap = function getBboxOverlap(b1, b2) {
        // check if the bboxes overlap at all
        if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null; // find the middle two X values
        var lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
        var upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x; // find the middle two Y values
        var lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
        var upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y; // put those middle values together to get the overlap
        return {
            ll: {
                x: lowerX,
                y: lowerY
            },
            ur: {
                x: upperX,
                y: upperY
            }
        };
    };
    /* Javascript doesn't do integer math. Everything is
   * floating point with percision Number.EPSILON.
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
   */ var epsilon = Number.EPSILON; // IE Polyfill
    if (epsilon === undefined) epsilon = Math.pow(2, -52);
    var EPSILON_SQ = epsilon * epsilon;
    /* FLP comparator */ var cmp = function cmp(a, b) {
        // check if they're both 0
        if (-epsilon < a && a < epsilon) {
            if (-epsilon < b && b < epsilon) return 0;
        } // check if they're flp equal
        var ab = a - b;
        if (ab * ab < EPSILON_SQ * a * b) return 0;
         // normal comparison
        return a < b ? -1 : 1;
    };
    /**
   * This class rounds incoming values sufficiently so that
   * floating points problems are, for the most part, avoided.
   *
   * Incoming points are have their x & y values tested against
   * all previously seen x & y values. If either is 'too close'
   * to a previously seen value, it's value is 'snapped' to the
   * previously seen value.
   *
   * All points should be rounded by this class before being
   * stored in any data structures in the rest of this algorithm.
   */ var PtRounder = /*#__PURE__*/ function() {
        function PtRounder() {
            _classCallCheck(this, PtRounder);
            this.reset();
        }
        _createClass(PtRounder, [
            {
                key: "reset",
                value: function reset() {
                    this.xRounder = new CoordRounder();
                    this.yRounder = new CoordRounder();
                }
            },
            {
                key: "round",
                value: function round(x, y) {
                    return {
                        x: this.xRounder.round(x),
                        y: this.yRounder.round(y)
                    };
                }
            }
        ]);
        return PtRounder;
    }();
    var CoordRounder = /*#__PURE__*/ function() {
        function CoordRounder() {
            _classCallCheck(this, CoordRounder);
            this.tree = new Tree(); // preseed with 0 so we don't end up with values < Number.EPSILON
            this.round(0);
        } // Note: this can rounds input values backwards or forwards.
        //       You might ask, why not restrict this to just rounding
        //       forwards? Wouldn't that allow left endpoints to always
        //       remain left endpoints during splitting (never change to
        //       right). No - it wouldn't, because we snap intersections
        //       to endpoints (to establish independence from the segment
        //       angle for t-intersections).
        _createClass(CoordRounder, [
            {
                key: "round",
                value: function round(coord) {
                    var node = this.tree.add(coord);
                    var prevNode = this.tree.prev(node);
                    if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
                        this.tree.remove(coord);
                        return prevNode.key;
                    }
                    var nextNode = this.tree.next(node);
                    if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
                        this.tree.remove(coord);
                        return nextNode.key;
                    }
                    return coord;
                }
            }
        ]);
        return CoordRounder;
    }(); // singleton available by import
    var rounder = new PtRounder();
    /* Cross Product of two vectors with first point at origin */ var crossProduct = function crossProduct(a, b) {
        return a.x * b.y - a.y * b.x;
    };
    /* Dot Product of two vectors with first point at origin */ var dotProduct = function dotProduct(a, b) {
        return a.x * b.x + a.y * b.y;
    };
    /* Comparator for two vectors with same starting point */ var compareVectorAngles = function compareVectorAngles(basePt, endPt1, endPt2) {
        var v1 = {
            x: endPt1.x - basePt.x,
            y: endPt1.y - basePt.y
        };
        var v2 = {
            x: endPt2.x - basePt.x,
            y: endPt2.y - basePt.y
        };
        var kross = crossProduct(v1, v2);
        return cmp(kross, 0);
    };
    var length = function length(v) {
        return Math.sqrt(dotProduct(v, v));
    };
    /* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */ var sineOfAngle = function sineOfAngle(pShared, pBase, pAngle) {
        var vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        var vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */ var cosineOfAngle = function cosineOfAngle(pShared, pBase, pAngle) {
        var vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        var vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the x coordinate where the given line (defined by a point and vector)
   * crosses the horizontal line with the given y coordiante.
   * In the case of parrallel lines (including overlapping ones) returns null. */ var horizontalIntersection = function horizontalIntersection(pt, v, y) {
        if (v.y === 0) return null;
        return {
            x: pt.x + v.x / v.y * (y - pt.y),
            y: y
        };
    };
    /* Get the y coordinate where the given line (defined by a point and vector)
   * crosses the vertical line with the given x coordiante.
   * In the case of parrallel lines (including overlapping ones) returns null. */ var verticalIntersection = function verticalIntersection(pt, v, x) {
        if (v.x === 0) return null;
        return {
            x: x,
            y: pt.y + v.y / v.x * (x - pt.x)
        };
    };
    /* Get the intersection of two lines, each defined by a base point and a vector.
   * In the case of parrallel lines (including overlapping ones) returns null. */ var intersection = function intersection(pt1, v1, pt2, v2) {
        // take some shortcuts for vertical and horizontal lines
        // this also ensures we don't calculate an intersection and then discover
        // it's actually outside the bounding box of the line
        if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
        if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
        if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
        if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y); // General case for non-overlapping segments.
        // This algorithm is based on Schneider and Eberly.
        // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244
        var kross = crossProduct(v1, v2);
        if (kross == 0) return null;
        var ve = {
            x: pt2.x - pt1.x,
            y: pt2.y - pt1.y
        };
        var d1 = crossProduct(ve, v1) / kross;
        var d2 = crossProduct(ve, v2) / kross; // take the average of the two calculations to minimize rounding error
        var x1 = pt1.x + d2 * v1.x, x2 = pt2.x + d1 * v2.x;
        var y1 = pt1.y + d2 * v1.y, y2 = pt2.y + d1 * v2.y;
        var x = (x1 + x2) / 2;
        var y = (y1 + y2) / 2;
        return {
            x: x,
            y: y
        };
    };
    var SweepEvent = /*#__PURE__*/ function() {
        _createClass(SweepEvent, null, [
            {
                key: "compare",
                // for ordering sweep events in the sweep event queue
                value: function compare(a, b) {
                    // favor event with a point that the sweep line hits first
                    var ptCmp = SweepEvent.comparePoints(a.point, b.point);
                    if (ptCmp !== 0) return ptCmp; // the points are the same, so link them if needed
                    if (a.point !== b.point) a.link(b); // favor right events over left
                    if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1; // we have two matching left or right endpoints
                    // ordering of this case is the same as for their segments
                    return Segment.compare(a.segment, b.segment);
                } // for ordering points in sweep line order
            },
            {
                key: "comparePoints",
                value: function comparePoints(aPt, bPt) {
                    if (aPt.x < bPt.x) return -1;
                    if (aPt.x > bPt.x) return 1;
                    if (aPt.y < bPt.y) return -1;
                    if (aPt.y > bPt.y) return 1;
                    return 0;
                } // Warning: 'point' input will be modified and re-used (for performance)
            }
        ]);
        function SweepEvent(point, isLeft) {
            _classCallCheck(this, SweepEvent);
            if (point.events === undefined) point.events = [
                this
            ];
            else point.events.push(this);
            this.point = point;
            this.isLeft = isLeft; // this.segment, this.otherSE set by factory
        }
        _createClass(SweepEvent, [
            {
                key: "link",
                value: function link(other) {
                    if (other.point === this.point) throw new Error("Tried to link already linked events");
                    var otherEvents = other.point.events;
                    for(var i = 0, iMax = otherEvents.length; i < iMax; i++){
                        var evt = otherEvents[i];
                        this.point.events.push(evt);
                        evt.point = this.point;
                    }
                    this.checkForConsuming();
                }
            },
            {
                key: "checkForConsuming",
                value: function checkForConsuming() {
                    // FIXME: The loops in this method run O(n^2) => no good.
                    //        Maintain little ordered sweep event trees?
                    //        Can we maintaining an ordering that avoids the need
                    //        for the re-sorting with getLeftmostComparator in geom-out?
                    // Compare each pair of events to see if other events also match
                    var numEvents = this.point.events.length;
                    for(var i = 0; i < numEvents; i++){
                        var evt1 = this.point.events[i];
                        if (evt1.segment.consumedBy !== undefined) continue;
                        for(var j = i + 1; j < numEvents; j++){
                            var evt2 = this.point.events[j];
                            if (evt2.consumedBy !== undefined) continue;
                            if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                            evt1.segment.consume(evt2.segment);
                        }
                    }
                }
            },
            {
                key: "getAvailableLinkedEvents",
                value: function getAvailableLinkedEvents() {
                    // point.events is always of length 2 or greater
                    var events = [];
                    for(var i = 0, iMax = this.point.events.length; i < iMax; i++){
                        var evt = this.point.events[i];
                        if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
                    }
                    return events;
                }
            },
            {
                key: "getLeftmostComparator",
                value: function getLeftmostComparator(baseEvent) {
                    var _this = this;
                    var cache = new Map();
                    var fillCache = function fillCache(linkedEvent) {
                        var nextEvent = linkedEvent.otherSE;
                        cache.set(linkedEvent, {
                            sine: sineOfAngle(_this.point, baseEvent.point, nextEvent.point),
                            cosine: cosineOfAngle(_this.point, baseEvent.point, nextEvent.point)
                        });
                    };
                    return function(a, b) {
                        if (!cache.has(a)) fillCache(a);
                        if (!cache.has(b)) fillCache(b);
                        var _cache$get = cache.get(a), asine = _cache$get.sine, acosine = _cache$get.cosine;
                        var _cache$get2 = cache.get(b), bsine = _cache$get2.sine, bcosine = _cache$get2.cosine; // both on or above x-axis
                        if (asine >= 0 && bsine >= 0) {
                            if (acosine < bcosine) return 1;
                            if (acosine > bcosine) return -1;
                            return 0;
                        } // both below x-axis
                        if (asine < 0 && bsine < 0) {
                            if (acosine < bcosine) return -1;
                            if (acosine > bcosine) return 1;
                            return 0;
                        } // one above x-axis, one below
                        if (bsine < asine) return -1;
                        if (bsine > asine) return 1;
                        return 0;
                    };
                }
            }
        ]);
        return SweepEvent;
    }();
    // segments and sweep events when all else is identical
    var segmentId = 0;
    var Segment = /*#__PURE__*/ function() {
        _createClass(Segment, null, [
            {
                key: "compare",
                /* This compare() function is for ordering segments in the sweep
       * line tree, and does so according to the following criteria:
       *
       * Consider the vertical line that lies an infinestimal step to the
       * right of the right-more of the two left endpoints of the input
       * segments. Imagine slowly moving a point up from negative infinity
       * in the increasing y direction. Which of the two segments will that
       * point intersect first? That segment comes 'before' the other one.
       *
       * If neither segment would be intersected by such a line, (if one
       * or more of the segments are vertical) then the line to be considered
       * is directly on the right-more of the two left inputs.
       */ value: function compare(a, b) {
                    var alx = a.leftSE.point.x;
                    var blx = b.leftSE.point.x;
                    var arx = a.rightSE.point.x;
                    var brx = b.rightSE.point.x; // check if they're even in the same vertical plane
                    if (brx < alx) return 1;
                    if (arx < blx) return -1;
                    var aly = a.leftSE.point.y;
                    var bly = b.leftSE.point.y;
                    var ary = a.rightSE.point.y;
                    var bry = b.rightSE.point.y; // is left endpoint of segment B the right-more?
                    if (alx < blx) {
                        // are the two segments in the same horizontal plane?
                        if (bly < aly && bly < ary) return 1;
                        if (bly > aly && bly > ary) return -1; // is the B left endpoint colinear to segment A?
                        var aCmpBLeft = a.comparePoint(b.leftSE.point);
                        if (aCmpBLeft < 0) return 1;
                        if (aCmpBLeft > 0) return -1; // is the A right endpoint colinear to segment B ?
                        var bCmpARight = b.comparePoint(a.rightSE.point);
                        if (bCmpARight !== 0) return bCmpARight; // colinear segments, consider the one with left-more
                        // left endpoint to be first (arbitrary?)
                        return -1;
                    } // is left endpoint of segment A the right-more?
                    if (alx > blx) {
                        if (aly < bly && aly < bry) return -1;
                        if (aly > bly && aly > bry) return 1; // is the A left endpoint colinear to segment B?
                        var bCmpALeft = b.comparePoint(a.leftSE.point);
                        if (bCmpALeft !== 0) return bCmpALeft; // is the B right endpoint colinear to segment A?
                        var aCmpBRight = a.comparePoint(b.rightSE.point);
                        if (aCmpBRight < 0) return 1;
                        if (aCmpBRight > 0) return -1; // colinear segments, consider the one with left-more
                        // left endpoint to be first (arbitrary?)
                        return 1;
                    } // if we get here, the two left endpoints are in the same
                    // vertical plane, ie alx === blx
                    // consider the lower left-endpoint to come first
                    if (aly < bly) return -1;
                    if (aly > bly) return 1; // left endpoints are identical
                    // check for colinearity by using the left-more right endpoint
                    // is the A right endpoint more left-more?
                    if (arx < brx) {
                        var _bCmpARight = b.comparePoint(a.rightSE.point);
                        if (_bCmpARight !== 0) return _bCmpARight;
                    } // is the B right endpoint more left-more?
                    if (arx > brx) {
                        var _aCmpBRight = a.comparePoint(b.rightSE.point);
                        if (_aCmpBRight < 0) return 1;
                        if (_aCmpBRight > 0) return -1;
                    }
                    if (arx !== brx) {
                        // are these two [almost] vertical segments with opposite orientation?
                        // if so, the one with the lower right endpoint comes first
                        var ay = ary - aly;
                        var ax = arx - alx;
                        var by = bry - bly;
                        var bx = brx - blx;
                        if (ay > ax && by < bx) return 1;
                        if (ay < ax && by > bx) return -1;
                    } // we have colinear segments with matching orientation
                    // consider the one with more left-more right endpoint to be first
                    if (arx > brx) return 1;
                    if (arx < brx) return -1; // if we get here, two two right endpoints are in the same
                    // vertical plane, ie arx === brx
                    // consider the lower right-endpoint to come first
                    if (ary < bry) return -1;
                    if (ary > bry) return 1; // right endpoints identical as well, so the segments are idential
                    // fall back on creation order as consistent tie-breaker
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1; // identical segment, ie a === b
                    return 0;
                }
            }
        ]);
        function Segment(leftSE, rightSE, rings, windings) {
            _classCallCheck(this, Segment);
            this.id = ++segmentId;
            this.leftSE = leftSE;
            leftSE.segment = this;
            leftSE.otherSE = rightSE;
            this.rightSE = rightSE;
            rightSE.segment = this;
            rightSE.otherSE = leftSE;
            this.rings = rings;
            this.windings = windings; // left unset for performance, set later in algorithm
        // this.ringOut, this.consumedBy, this.prev
        }
        _createClass(Segment, [
            {
                key: "replaceRightSE",
                /* When a segment is split, the rightSE is replaced with a new sweep event */ value: function replaceRightSE(newRightSE) {
                    this.rightSE = newRightSE;
                    this.rightSE.segment = this;
                    this.rightSE.otherSE = this.leftSE;
                    this.leftSE.otherSE = this.rightSE;
                }
            },
            {
                key: "bbox",
                value: function bbox() {
                    var y1 = this.leftSE.point.y;
                    var y2 = this.rightSE.point.y;
                    return {
                        ll: {
                            x: this.leftSE.point.x,
                            y: y1 < y2 ? y1 : y2
                        },
                        ur: {
                            x: this.rightSE.point.x,
                            y: y1 > y2 ? y1 : y2
                        }
                    };
                }
            },
            {
                key: "vector",
                value: function vector() {
                    return {
                        x: this.rightSE.point.x - this.leftSE.point.x,
                        y: this.rightSE.point.y - this.leftSE.point.y
                    };
                }
            },
            {
                key: "isAnEndpoint",
                value: function isAnEndpoint(pt) {
                    return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
                }
            },
            {
                key: "comparePoint",
                value: function comparePoint(point) {
                    if (this.isAnEndpoint(point)) return 0;
                    var lPt = this.leftSE.point;
                    var rPt = this.rightSE.point;
                    var v = this.vector(); // Exactly vertical segments.
                    if (lPt.x === rPt.x) {
                        if (point.x === lPt.x) return 0;
                        return point.x < lPt.x ? 1 : -1;
                    } // Nearly vertical segments with an intersection.
                    // Check to see where a point on the line with matching Y coordinate is.
                    var yDist = (point.y - lPt.y) / v.y;
                    var xFromYDist = lPt.x + yDist * v.x;
                    if (point.x === xFromYDist) return 0; // General case.
                    // Check to see where a point on the line with matching X coordinate is.
                    var xDist = (point.x - lPt.x) / v.x;
                    var yFromXDist = lPt.y + xDist * v.y;
                    if (point.y === yFromXDist) return 0;
                    return point.y < yFromXDist ? -1 : 1;
                }
            },
            {
                key: "getIntersection",
                value: function getIntersection(other) {
                    // If bboxes don't overlap, there can't be any intersections
                    var tBbox = this.bbox();
                    var oBbox = other.bbox();
                    var bboxOverlap = getBboxOverlap(tBbox, oBbox);
                    if (bboxOverlap === null) return null; // We first check to see if the endpoints can be considered intersections.
                    // This will 'snap' intersections to endpoints if possible, and will
                    // handle cases of colinearity.
                    var tlp = this.leftSE.point;
                    var trp = this.rightSE.point;
                    var olp = other.leftSE.point;
                    var orp = other.rightSE.point; // does each endpoint touch the other segment?
                    // note that we restrict the 'touching' definition to only allow segments
                    // to touch endpoints that lie forward from where we are in the sweep line pass
                    var touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
                    var touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
                    var touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
                    var touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0; // do left endpoints match?
                    if (touchesThisLSE && touchesOtherLSE) {
                        // these two cases are for colinear segments with matching left
                        // endpoints, and one segment being longer than the other
                        if (touchesThisRSE && !touchesOtherRSE) return trp;
                        if (!touchesThisRSE && touchesOtherRSE) return orp; // either the two segments match exactly (two trival intersections)
                        // or just on their left endpoint (one trivial intersection
                        return null;
                    } // does this left endpoint matches (other doesn't)
                    if (touchesThisLSE) {
                        // check for segments that just intersect on opposing endpoints
                        if (touchesOtherRSE) {
                            if (tlp.x === orp.x && tlp.y === orp.y) return null;
                        } // t-intersection on left endpoint
                        return tlp;
                    } // does other left endpoint matches (this doesn't)
                    if (touchesOtherLSE) {
                        // check for segments that just intersect on opposing endpoints
                        if (touchesThisRSE) {
                            if (trp.x === olp.x && trp.y === olp.y) return null;
                        } // t-intersection on left endpoint
                        return olp;
                    } // trivial intersection on right endpoints
                    if (touchesThisRSE && touchesOtherRSE) return null; // t-intersections on just one right endpoint
                    if (touchesThisRSE) return trp;
                    if (touchesOtherRSE) return orp; // None of our endpoints intersect. Look for a general intersection between
                    // infinite lines laid over the segments
                    var pt = intersection(tlp, this.vector(), olp, other.vector()); // are the segments parrallel? Note that if they were colinear with overlap,
                    // they would have an endpoint intersection and that case was already handled above
                    if (pt === null) return null; // is the intersection found between the lines not on the segments?
                    if (!isInBbox(bboxOverlap, pt)) return null; // round the the computed point if needed
                    return rounder.round(pt.x, pt.y);
                }
            },
            {
                key: "split",
                value: function split(point) {
                    var newEvents = [];
                    var alreadyLinked = point.events !== undefined;
                    var newLeftSE = new SweepEvent(point, true);
                    var newRightSE = new SweepEvent(point, false);
                    var oldRightSE = this.rightSE;
                    this.replaceRightSE(newRightSE);
                    newEvents.push(newRightSE);
                    newEvents.push(newLeftSE);
                    var newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice()); // when splitting a nearly vertical downward-facing segment,
                    // sometimes one of the resulting new segments is vertical, in which
                    // case its left and right events may need to be swapped
                    if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
                    if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
                     // in the point we just used to create new sweep events with was already
                    // linked to other events, we need to check if either of the affected
                    // segments should be consumed
                    if (alreadyLinked) {
                        newLeftSE.checkForConsuming();
                        newRightSE.checkForConsuming();
                    }
                    return newEvents;
                }
            },
            {
                key: "swapEvents",
                value: function swapEvents() {
                    var tmpEvt = this.rightSE;
                    this.rightSE = this.leftSE;
                    this.leftSE = tmpEvt;
                    this.leftSE.isLeft = true;
                    this.rightSE.isLeft = false;
                    for(var i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
                }
            },
            {
                key: "consume",
                value: function consume(other) {
                    var consumer = this;
                    var consumee = other;
                    while(consumer.consumedBy)consumer = consumer.consumedBy;
                    while(consumee.consumedBy)consumee = consumee.consumedBy;
                    var cmp = Segment.compare(consumer, consumee);
                    if (cmp === 0) return; // already consumed
                    // the winner of the consumption is the earlier segment
                    // according to sweep line ordering
                    if (cmp > 0) {
                        var tmp = consumer;
                        consumer = consumee;
                        consumee = tmp;
                    } // make sure a segment doesn't consume it's prev
                    if (consumer.prev === consumee) {
                        var _tmp = consumer;
                        consumer = consumee;
                        consumee = _tmp;
                    }
                    for(var i = 0, iMax = consumee.rings.length; i < iMax; i++){
                        var ring = consumee.rings[i];
                        var winding = consumee.windings[i];
                        var index = consumer.rings.indexOf(ring);
                        if (index === -1) {
                            consumer.rings.push(ring);
                            consumer.windings.push(winding);
                        } else consumer.windings[index] += winding;
                    }
                    consumee.rings = null;
                    consumee.windings = null;
                    consumee.consumedBy = consumer; // mark sweep events consumed as to maintain ordering in sweep event queue
                    consumee.leftSE.consumedBy = consumer.leftSE;
                    consumee.rightSE.consumedBy = consumer.rightSE;
                }
            },
            {
                key: "prevInResult",
                value: function prevInResult() {
                    if (this._prevInResult !== undefined) return this._prevInResult;
                    if (!this.prev) this._prevInResult = null;
                    else if (this.prev.isInResult()) this._prevInResult = this.prev;
                    else this._prevInResult = this.prev.prevInResult();
                    return this._prevInResult;
                }
            },
            {
                key: "beforeState",
                value: function beforeState() {
                    if (this._beforeState !== undefined) return this._beforeState;
                    if (!this.prev) this._beforeState = {
                        rings: [],
                        windings: [],
                        multiPolys: []
                    };
                    else {
                        var seg = this.prev.consumedBy || this.prev;
                        this._beforeState = seg.afterState();
                    }
                    return this._beforeState;
                }
            },
            {
                key: "afterState",
                value: function afterState() {
                    if (this._afterState !== undefined) return this._afterState;
                    var beforeState = this.beforeState();
                    this._afterState = {
                        rings: beforeState.rings.slice(0),
                        windings: beforeState.windings.slice(0),
                        multiPolys: []
                    };
                    var ringsAfter = this._afterState.rings;
                    var windingsAfter = this._afterState.windings;
                    var mpsAfter = this._afterState.multiPolys; // calculate ringsAfter, windingsAfter
                    for(var i = 0, iMax = this.rings.length; i < iMax; i++){
                        var ring = this.rings[i];
                        var winding = this.windings[i];
                        var index = ringsAfter.indexOf(ring);
                        if (index === -1) {
                            ringsAfter.push(ring);
                            windingsAfter.push(winding);
                        } else windingsAfter[index] += winding;
                    } // calcualte polysAfter
                    var polysAfter = [];
                    var polysExclude = [];
                    for(var _i = 0, _iMax = ringsAfter.length; _i < _iMax; _i++){
                        if (windingsAfter[_i] === 0) continue; // non-zero rule
                        var _ring = ringsAfter[_i];
                        var poly = _ring.poly;
                        if (polysExclude.indexOf(poly) !== -1) continue;
                        if (_ring.isExterior) polysAfter.push(poly);
                        else {
                            if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                            var _index = polysAfter.indexOf(_ring.poly);
                            if (_index !== -1) polysAfter.splice(_index, 1);
                        }
                    } // calculate multiPolysAfter
                    for(var _i2 = 0, _iMax2 = polysAfter.length; _i2 < _iMax2; _i2++){
                        var mp = polysAfter[_i2].multiPoly;
                        if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
                    }
                    return this._afterState;
                }
            },
            {
                key: "isInResult",
                value: function isInResult() {
                    // if we've been consumed, we're not in the result
                    if (this.consumedBy) return false;
                    if (this._isInResult !== undefined) return this._isInResult;
                    var mpsBefore = this.beforeState().multiPolys;
                    var mpsAfter = this.afterState().multiPolys;
                    switch(operation.type){
                        case "union":
                            // UNION - included iff:
                            //  * On one side of us there is 0 poly interiors AND
                            //  * On the other side there is 1 or more.
                            var noBefores = mpsBefore.length === 0;
                            var noAfters = mpsAfter.length === 0;
                            this._isInResult = noBefores !== noAfters;
                            break;
                        case "intersection":
                            // INTERSECTION - included iff:
                            //  * on one side of us all multipolys are rep. with poly interiors AND
                            //  * on the other side of us, not all multipolys are repsented
                            //    with poly interiors
                            var least;
                            var most;
                            if (mpsBefore.length < mpsAfter.length) {
                                least = mpsBefore.length;
                                most = mpsAfter.length;
                            } else {
                                least = mpsAfter.length;
                                most = mpsBefore.length;
                            }
                            this._isInResult = most === operation.numMultiPolys && least < most;
                            break;
                        case "xor":
                            // XOR - included iff:
                            //  * the difference between the number of multipolys represented
                            //    with poly interiors on our two sides is an odd number
                            var diff = Math.abs(mpsBefore.length - mpsAfter.length);
                            this._isInResult = diff % 2 === 1;
                            break;
                        case "difference":
                            // DIFFERENCE included iff:
                            //  * on exactly one side, we have just the subject
                            var isJustSubject = function isJustSubject(mps) {
                                return mps.length === 1 && mps[0].isSubject;
                            };
                            this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                            break;
                        default:
                            throw new Error("Unrecognized operation type found ".concat(operation.type));
                    }
                    return this._isInResult;
                }
            }
        ], [
            {
                key: "fromRing",
                value: function fromRing(pt1, pt2, ring) {
                    var leftPt, rightPt, winding; // ordering the two points according to sweep line ordering
                    var cmpPts = SweepEvent.comparePoints(pt1, pt2);
                    if (cmpPts < 0) {
                        leftPt = pt1;
                        rightPt = pt2;
                        winding = 1;
                    } else if (cmpPts > 0) {
                        leftPt = pt2;
                        rightPt = pt1;
                        winding = -1;
                    } else throw new Error("Tried to create degenerate segment at [".concat(pt1.x, ", ").concat(pt1.y, "]"));
                    var leftSE = new SweepEvent(leftPt, true);
                    var rightSE = new SweepEvent(rightPt, false);
                    return new Segment(leftSE, rightSE, [
                        ring
                    ], [
                        winding
                    ]);
                }
            }
        ]);
        return Segment;
    }();
    var RingIn = /*#__PURE__*/ function() {
        function RingIn(geomRing, poly, isExterior) {
            _classCallCheck(this, RingIn);
            if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.poly = poly;
            this.isExterior = isExterior;
            this.segments = [];
            if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
            this.bbox = {
                ll: {
                    x: firstPoint.x,
                    y: firstPoint.y
                },
                ur: {
                    x: firstPoint.x,
                    y: firstPoint.y
                }
            };
            var prevPoint = firstPoint;
            for(var i = 1, iMax = geomRing.length; i < iMax; i++){
                if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                var point = rounder.round(geomRing[i][0], geomRing[i][1]); // skip repeated points
                if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
                this.segments.push(Segment.fromRing(prevPoint, point, this));
                if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
                if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
                if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
                if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
                prevPoint = point;
            } // add segment from last to first if last is not the same as first
            if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
        }
        _createClass(RingIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = [];
                    for(var i = 0, iMax = this.segments.length; i < iMax; i++){
                        var segment = this.segments[i];
                        sweepEvents.push(segment.leftSE);
                        sweepEvents.push(segment.rightSE);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return RingIn;
    }();
    var PolyIn = /*#__PURE__*/ function() {
        function PolyIn(geomPoly, multiPoly) {
            _classCallCheck(this, PolyIn);
            if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new RingIn(geomPoly[0], this, true); // copy by value
            this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            };
            this.interiorRings = [];
            for(var i = 1, iMax = geomPoly.length; i < iMax; i++){
                var ring = new RingIn(geomPoly[i], this, false);
                if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
                if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
                if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
                if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
                this.interiorRings.push(ring);
            }
            this.multiPoly = multiPoly;
        }
        _createClass(PolyIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = this.exteriorRing.getSweepEvents();
                    for(var i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                        var ringSweepEvents = this.interiorRings[i].getSweepEvents();
                        for(var j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return PolyIn;
    }();
    var MultiPolyIn = /*#__PURE__*/ function() {
        function MultiPolyIn(geom, isSubject) {
            _classCallCheck(this, MultiPolyIn);
            if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                // if the input looks like a polygon, convert it to a multipolygon
                if (typeof geom[0][0][0] === "number") geom = [
                    geom
                ];
            } catch (ex) {
            // In either case, it will be handled later on.
            }
            this.polys = [];
            this.bbox = {
                ll: {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                },
                ur: {
                    x: Number.NEGATIVE_INFINITY,
                    y: Number.NEGATIVE_INFINITY
                }
            };
            for(var i = 0, iMax = geom.length; i < iMax; i++){
                var poly = new PolyIn(geom[i], this);
                if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
                if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
                if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
                if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
                this.polys.push(poly);
            }
            this.isSubject = isSubject;
        }
        _createClass(MultiPolyIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = [];
                    for(var i = 0, iMax = this.polys.length; i < iMax; i++){
                        var polySweepEvents = this.polys[i].getSweepEvents();
                        for(var j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return MultiPolyIn;
    }();
    var RingOut = /*#__PURE__*/ function() {
        _createClass(RingOut, null, [
            {
                key: "factory",
                /* Given the segments from the sweep line pass, compute & return a series
       * of closed rings from all the segments marked to be part of the result */ value: function factory(allSegments) {
                    var ringsOut = [];
                    for(var i = 0, iMax = allSegments.length; i < iMax; i++){
                        var segment = allSegments[i];
                        if (!segment.isInResult() || segment.ringOut) continue;
                        var prevEvent = null;
                        var event = segment.leftSE;
                        var nextEvent = segment.rightSE;
                        var events = [
                            event
                        ];
                        var startingPoint = event.point;
                        var intersectionLEs = [];
                        /* Walk the chain of linked events to form a closed ring */ while(true){
                            prevEvent = event;
                            event = nextEvent;
                            events.push(event);
                            /* Is the ring complete? */ if (event.point === startingPoint) break;
                            while(true){
                                var availableLEs = event.getAvailableLinkedEvents();
                                /* Did we hit a dead end? This shouldn't happen. Indicates some earlier
               * part of the algorithm malfunctioned... please file a bug report. */ if (availableLEs.length === 0) {
                                    var firstPt = events[0].point;
                                    var lastPt = events[events.length - 1].point;
                                    throw new Error("Unable to complete output ring starting at [".concat(firstPt.x, ",") + " ".concat(firstPt.y, "]. Last matching segment found ends at") + " [".concat(lastPt.x, ", ").concat(lastPt.y, "]."));
                                }
                                /* Only one way to go, so cotinue on the path */ if (availableLEs.length === 1) {
                                    nextEvent = availableLEs[0].otherSE;
                                    break;
                                }
                                /* We must have an intersection. Check for a completed loop */ var indexLE = null;
                                for(var j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                                    indexLE = j;
                                    break;
                                }
                                /* Found a completed loop. Cut that off and make a ring */ if (indexLE !== null) {
                                    var intersectionLE = intersectionLEs.splice(indexLE)[0];
                                    var ringEvents = events.splice(intersectionLE.index);
                                    ringEvents.unshift(ringEvents[0].otherSE);
                                    ringsOut.push(new RingOut(ringEvents.reverse()));
                                    continue;
                                }
                                /* register the intersection */ intersectionLEs.push({
                                    index: events.length,
                                    point: event.point
                                });
                                /* Choose the left-most option to continue the walk */ var comparator = event.getLeftmostComparator(prevEvent);
                                nextEvent = availableLEs.sort(comparator)[0].otherSE;
                                break;
                            }
                        }
                        ringsOut.push(new RingOut(events));
                    }
                    return ringsOut;
                }
            }
        ]);
        function RingOut(events) {
            _classCallCheck(this, RingOut);
            this.events = events;
            for(var i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
            this.poly = null;
        }
        _createClass(RingOut, [
            {
                key: "getGeom",
                value: function getGeom() {
                    // Remove superfluous points (ie extra points along a straight line),
                    var prevPt = this.events[0].point;
                    var points = [
                        prevPt
                    ];
                    for(var i = 1, iMax = this.events.length - 1; i < iMax; i++){
                        var _pt = this.events[i].point;
                        var _nextPt = this.events[i + 1].point;
                        if (compareVectorAngles(_pt, prevPt, _nextPt) === 0) continue;
                        points.push(_pt);
                        prevPt = _pt;
                    } // ring was all (within rounding error of angle calc) colinear points
                    if (points.length === 1) return null; // check if the starting point is necessary
                    var pt = points[0];
                    var nextPt = points[1];
                    if (compareVectorAngles(pt, prevPt, nextPt) === 0) points.shift();
                    points.push(points[0]);
                    var step = this.isExteriorRing() ? 1 : -1;
                    var iStart = this.isExteriorRing() ? 0 : points.length - 1;
                    var iEnd = this.isExteriorRing() ? points.length : -1;
                    var orderedPoints = [];
                    for(var _i = iStart; _i != iEnd; _i += step)orderedPoints.push([
                        points[_i].x,
                        points[_i].y
                    ]);
                    return orderedPoints;
                }
            },
            {
                key: "isExteriorRing",
                value: function isExteriorRing() {
                    if (this._isExteriorRing === undefined) {
                        var enclosing = this.enclosingRing();
                        this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
                    }
                    return this._isExteriorRing;
                }
            },
            {
                key: "enclosingRing",
                value: function enclosingRing() {
                    if (this._enclosingRing === undefined) this._enclosingRing = this._calcEnclosingRing();
                    return this._enclosingRing;
                }
            },
            {
                key: "_calcEnclosingRing",
                value: function _calcEnclosingRing() {
                    // start with the ealier sweep line event so that the prevSeg
                    // chain doesn't lead us inside of a loop of ours
                    var leftMostEvt = this.events[0];
                    for(var i = 1, iMax = this.events.length; i < iMax; i++){
                        var evt = this.events[i];
                        if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
                    }
                    var prevSeg = leftMostEvt.segment.prevInResult();
                    var prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                    while(true){
                        // no segment found, thus no ring can enclose us
                        if (!prevSeg) return null; // no segments below prev segment found, thus the ring of the prev
                        // segment must loop back around and enclose us
                        if (!prevPrevSeg) return prevSeg.ringOut; // if the two segments are of different rings, the ring of the prev
                        // segment must either loop around us or the ring of the prev prev
                        // seg, which would make us and the ring of the prev peers
                        if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                            if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                            else return prevSeg.ringOut.enclosingRing();
                        } // two segments are from the same ring, so this was a penisula
                        // of that ring. iterate downward, keep searching
                        prevSeg = prevPrevSeg.prevInResult();
                        prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                    }
                }
            }
        ]);
        return RingOut;
    }();
    var PolyOut = /*#__PURE__*/ function() {
        function PolyOut(exteriorRing) {
            _classCallCheck(this, PolyOut);
            this.exteriorRing = exteriorRing;
            exteriorRing.poly = this;
            this.interiorRings = [];
        }
        _createClass(PolyOut, [
            {
                key: "addInterior",
                value: function addInterior(ring) {
                    this.interiorRings.push(ring);
                    ring.poly = this;
                }
            },
            {
                key: "getGeom",
                value: function getGeom() {
                    var geom = [
                        this.exteriorRing.getGeom()
                    ]; // exterior ring was all (within rounding error of angle calc) colinear points
                    if (geom[0] === null) return null;
                    for(var i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                        var ringGeom = this.interiorRings[i].getGeom(); // interior ring was all (within rounding error of angle calc) colinear points
                        if (ringGeom === null) continue;
                        geom.push(ringGeom);
                    }
                    return geom;
                }
            }
        ]);
        return PolyOut;
    }();
    var MultiPolyOut = /*#__PURE__*/ function() {
        function MultiPolyOut(rings) {
            _classCallCheck(this, MultiPolyOut);
            this.rings = rings;
            this.polys = this._composePolys(rings);
        }
        _createClass(MultiPolyOut, [
            {
                key: "getGeom",
                value: function getGeom() {
                    var geom = [];
                    for(var i = 0, iMax = this.polys.length; i < iMax; i++){
                        var polyGeom = this.polys[i].getGeom(); // exterior ring was all (within rounding error of angle calc) colinear points
                        if (polyGeom === null) continue;
                        geom.push(polyGeom);
                    }
                    return geom;
                }
            },
            {
                key: "_composePolys",
                value: function _composePolys(rings) {
                    var polys = [];
                    for(var i = 0, iMax = rings.length; i < iMax; i++){
                        var ring = rings[i];
                        if (ring.poly) continue;
                        if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
                        else {
                            var enclosingRing = ring.enclosingRing();
                            if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
                            enclosingRing.poly.addInterior(ring);
                        }
                    }
                    return polys;
                }
            }
        ]);
        return MultiPolyOut;
    }();
    /**
   * NOTE:  We must be careful not to change any segments while
   *        they are in the SplayTree. AFAIK, there's no way to tell
   *        the tree to rebalance itself - thus before splitting
   *        a segment that's in the tree, we remove it from the tree,
   *        do the split, then re-insert it. (Even though splitting a
   *        segment *shouldn't* change its correct position in the
   *        sweep line tree, the reality is because of rounding errors,
   *        it sometimes does.)
   */ var SweepLine = /*#__PURE__*/ function() {
        function SweepLine(queue) {
            var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;
            _classCallCheck(this, SweepLine);
            this.queue = queue;
            this.tree = new Tree(comparator);
            this.segments = [];
        }
        _createClass(SweepLine, [
            {
                key: "process",
                value: function process(event) {
                    var segment = event.segment;
                    var newEvents = []; // if we've already been consumed by another segment,
                    // clean up our body parts and get out
                    if (event.consumedBy) {
                        if (event.isLeft) this.queue.remove(event.otherSE);
                        else this.tree.remove(segment);
                        return newEvents;
                    }
                    var node = event.isLeft ? this.tree.insert(segment) : this.tree.find(segment);
                    if (!node) throw new Error("Unable to find segment #".concat(segment.id, " ") + "[".concat(segment.leftSE.point.x, ", ").concat(segment.leftSE.point.y, "] -> ") + "[".concat(segment.rightSE.point.x, ", ").concat(segment.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
                    var prevNode = node;
                    var nextNode = node;
                    var prevSeg = undefined;
                    var nextSeg = undefined; // skip consumed segments still in tree
                    while(prevSeg === undefined){
                        prevNode = this.tree.prev(prevNode);
                        if (prevNode === null) prevSeg = null;
                        else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
                    } // skip consumed segments still in tree
                    while(nextSeg === undefined){
                        nextNode = this.tree.next(nextNode);
                        if (nextNode === null) nextSeg = null;
                        else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
                    }
                    if (event.isLeft) {
                        // Check for intersections against the previous segment in the sweep line
                        var prevMySplitter = null;
                        if (prevSeg) {
                            var prevInter = prevSeg.getIntersection(segment);
                            if (prevInter !== null) {
                                if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                                if (!prevSeg.isAnEndpoint(prevInter)) {
                                    var newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                                    for(var i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                                }
                            }
                        } // Check for intersections against the next segment in the sweep line
                        var nextMySplitter = null;
                        if (nextSeg) {
                            var nextInter = nextSeg.getIntersection(segment);
                            if (nextInter !== null) {
                                if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                                if (!nextSeg.isAnEndpoint(nextInter)) {
                                    var _newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                                    for(var _i = 0, _iMax = _newEventsFromSplit.length; _i < _iMax; _i++)newEvents.push(_newEventsFromSplit[_i]);
                                }
                            }
                        } // For simplicity, even if we find more than one intersection we only
                        // spilt on the 'earliest' (sweep-line style) of the intersections.
                        // The other intersection will be handled in a future process().
                        if (prevMySplitter !== null || nextMySplitter !== null) {
                            var mySplitter = null;
                            if (prevMySplitter === null) mySplitter = nextMySplitter;
                            else if (nextMySplitter === null) mySplitter = prevMySplitter;
                            else {
                                var cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                                mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                            } // Rounding errors can cause changes in ordering,
                            // so remove afected segments and right sweep events before splitting
                            this.queue.remove(segment.rightSE);
                            newEvents.push(segment.rightSE);
                            var _newEventsFromSplit2 = segment.split(mySplitter);
                            for(var _i2 = 0, _iMax2 = _newEventsFromSplit2.length; _i2 < _iMax2; _i2++)newEvents.push(_newEventsFromSplit2[_i2]);
                        }
                        if (newEvents.length > 0) {
                            // We found some intersections, so re-do the current event to
                            // make sure sweep line ordering is totally consistent for later
                            // use with the segment 'prev' pointers
                            this.tree.remove(segment);
                            newEvents.push(event);
                        } else {
                            // done with left event
                            this.segments.push(segment);
                            segment.prev = prevSeg;
                        }
                    } else {
                        // event.isRight
                        // since we're about to be removed from the sweep line, check for
                        // intersections between our previous and next segments
                        if (prevSeg && nextSeg) {
                            var inter = prevSeg.getIntersection(nextSeg);
                            if (inter !== null) {
                                if (!prevSeg.isAnEndpoint(inter)) {
                                    var _newEventsFromSplit3 = this._splitSafely(prevSeg, inter);
                                    for(var _i3 = 0, _iMax3 = _newEventsFromSplit3.length; _i3 < _iMax3; _i3++)newEvents.push(_newEventsFromSplit3[_i3]);
                                }
                                if (!nextSeg.isAnEndpoint(inter)) {
                                    var _newEventsFromSplit4 = this._splitSafely(nextSeg, inter);
                                    for(var _i4 = 0, _iMax4 = _newEventsFromSplit4.length; _i4 < _iMax4; _i4++)newEvents.push(_newEventsFromSplit4[_i4]);
                                }
                            }
                        }
                        this.tree.remove(segment);
                    }
                    return newEvents;
                }
            },
            {
                key: "_splitSafely",
                value: function _splitSafely(seg, pt) {
                    // Rounding errors can cause changes in ordering,
                    // so remove afected segments and right sweep events before splitting
                    // removeNode() doesn't work, so have re-find the seg
                    // https://github.com/w8r/splay-tree/pull/5
                    this.tree.remove(seg);
                    var rightSE = seg.rightSE;
                    this.queue.remove(rightSE);
                    var newEvents = seg.split(pt);
                    newEvents.push(rightSE); // splitting can trigger consumption
                    if (seg.consumedBy === undefined) this.tree.insert(seg);
                    return newEvents;
                }
            }
        ]);
        return SweepLine;
    }();
    var POLYGON_CLIPPING_MAX_QUEUE_SIZE = (typeof process !== "undefined" && undefined, 1000000);
    var POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = (typeof process !== "undefined" && undefined, 1000000);
    var Operation = /*#__PURE__*/ function() {
        function Operation() {
            _classCallCheck(this, Operation);
        }
        _createClass(Operation, [
            {
                key: "run",
                value: function run(type, geom, moreGeoms) {
                    operation.type = type;
                    rounder.reset();
                    /* Convert inputs to MultiPoly objects */ var multipolys = [
                        new MultiPolyIn(geom, true)
                    ];
                    for(var i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new MultiPolyIn(moreGeoms[i], false));
                    operation.numMultiPolys = multipolys.length;
                    /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */ if (operation.type === "difference") {
                        // in place removal
                        var subject = multipolys[0];
                        var _i = 1;
                        while(_i < multipolys.length)if (getBboxOverlap(multipolys[_i].bbox, subject.bbox) !== null) _i++;
                        else multipolys.splice(_i, 1);
                    }
                    /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */ if (operation.type === "intersection") // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
                    //       it could be optimized to O(n * ln(n))
                    for(var _i2 = 0, _iMax = multipolys.length; _i2 < _iMax; _i2++){
                        var mpA = multipolys[_i2];
                        for(var j = _i2 + 1, jMax = multipolys.length; j < jMax; j++){
                            if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
                        }
                    }
                    /* Put segment endpoints in a priority queue */ var queue = new Tree(SweepEvent.compare);
                    for(var _i3 = 0, _iMax2 = multipolys.length; _i3 < _iMax2; _i3++){
                        var sweepEvents = multipolys[_i3].getSweepEvents();
                        for(var _j = 0, _jMax = sweepEvents.length; _j < _jMax; _j++){
                            queue.insert(sweepEvents[_j]);
                            if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                            throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
                        }
                    }
                    /* Pass the sweep line over those endpoints */ var sweepLine = new SweepLine(queue);
                    var prevQueueSize = queue.size;
                    var node = queue.pop();
                    while(node){
                        var evt = node.key;
                        if (queue.size === prevQueueSize) {
                            // prevents an infinite loop, an otherwise common manifestation of bugs
                            var seg = evt.segment;
                            throw new Error("Unable to pop() ".concat(evt.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(evt.point.x, ", ").concat(evt.point.y, "] from segment #").concat(seg.id, " ") + "[".concat(seg.leftSE.point.x, ", ").concat(seg.leftSE.point.y, "] -> ") + "[".concat(seg.rightSE.point.x, ", ").concat(seg.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
                        }
                        if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                        throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
                        if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) // prevents an infinite loop, an otherwise common manifestation of bugs
                        throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
                        var newEvents = sweepLine.process(evt);
                        for(var _i4 = 0, _iMax3 = newEvents.length; _i4 < _iMax3; _i4++){
                            var _evt = newEvents[_i4];
                            if (_evt.consumedBy === undefined) queue.insert(_evt);
                        }
                        prevQueueSize = queue.size;
                        node = queue.pop();
                    } // free some memory we don't need anymore
                    rounder.reset();
                    /* Collect and compile segments we're keeping into a multipolygon */ var ringsOut = RingOut.factory(sweepLine.segments);
                    var result = new MultiPolyOut(ringsOut);
                    return result.getGeom();
                }
            }
        ]);
        return Operation;
    }(); // singleton available by import
    var operation = new Operation();
    var union = function union(geom) {
        for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)moreGeoms[_key - 1] = arguments[_key];
        return operation.run("union", geom, moreGeoms);
    };
    var intersection$1 = function intersection(geom) {
        for(var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)moreGeoms[_key2 - 1] = arguments[_key2];
        return operation.run("intersection", geom, moreGeoms);
    };
    var xor = function xor(geom) {
        for(var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)moreGeoms[_key3 - 1] = arguments[_key3];
        return operation.run("xor", geom, moreGeoms);
    };
    var difference = function difference(subjectGeom) {
        for(var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)clippingGeoms[_key4 - 1] = arguments[_key4];
        return operation.run("difference", subjectGeom, clippingGeoms);
    };
    var index = {
        union: union,
        intersection: intersection$1,
        xor: xor,
        difference: difference
    };
    return index;
});

},{"a8bb8fc6e9bc397d":"eXpi0"}],"7PpTC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>booleanContains);
parcelHelpers.export(exports, "isPointInMultiPoint", ()=>isPointInMultiPoint);
parcelHelpers.export(exports, "isMultiPointInMultiPoint", ()=>isMultiPointInMultiPoint);
parcelHelpers.export(exports, "isMultiPointOnLine", ()=>isMultiPointOnLine);
parcelHelpers.export(exports, "isMultiPointInPoly", ()=>isMultiPointInPoly);
parcelHelpers.export(exports, "isLineOnLine", ()=>isLineOnLine);
parcelHelpers.export(exports, "isLineInPoly", ()=>isLineInPoly);
/**
 * Is Polygon2 in Polygon1
 * Only takes into account outer rings
 *
 * @private
 * @param {Geometry|Feature<Polygon>} feature1 Polygon1
 * @param {Geometry|Feature<Polygon>} feature2 Polygon2
 * @returns {boolean} true/false
 */ parcelHelpers.export(exports, "isPolyInPoly", ()=>isPolyInPoly);
parcelHelpers.export(exports, "doBBoxOverlap", ()=>doBBoxOverlap);
/**
 * compareCoords
 *
 * @private
 * @param {Position} pair1 point [x,y]
 * @param {Position} pair2 point [x,y]
 * @returns {boolean} true/false if coord pairs match
 */ parcelHelpers.export(exports, "compareCoords", ()=>compareCoords);
parcelHelpers.export(exports, "getMidpoint", ()=>getMidpoint);
var _bbox = require("@turf/bbox");
var _bboxDefault = parcelHelpers.interopDefault(_bbox);
var _booleanPointInPolygon = require("@turf/boolean-point-in-polygon");
var _booleanPointInPolygonDefault = parcelHelpers.interopDefault(_booleanPointInPolygon);
var _booleanPointOnLine = require("@turf/boolean-point-on-line");
var _booleanPointOnLineDefault = parcelHelpers.interopDefault(_booleanPointOnLine);
var _invariant = require("@turf/invariant");
function booleanContains(feature1, feature2) {
    var geom1 = (0, _invariant.getGeom)(feature1);
    var geom2 = (0, _invariant.getGeom)(feature2);
    var type1 = geom1.type;
    var type2 = geom2.type;
    var coords1 = geom1.coordinates;
    var coords2 = geom2.coordinates;
    switch(type1){
        case "Point":
            switch(type2){
                case "Point":
                    return compareCoords(coords1, coords2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "MultiPoint":
            switch(type2){
                case "Point":
                    return isPointInMultiPoint(geom1, geom2);
                case "MultiPoint":
                    return isMultiPointInMultiPoint(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "LineString":
            switch(type2){
                case "Point":
                    return (0, _booleanPointOnLineDefault.default)(geom2, geom1, {
                        ignoreEndVertices: true
                    });
                case "LineString":
                    return isLineOnLine(geom1, geom2);
                case "MultiPoint":
                    return isMultiPointOnLine(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        case "Polygon":
            switch(type2){
                case "Point":
                    return (0, _booleanPointInPolygonDefault.default)(geom2, geom1, {
                        ignoreBoundary: true
                    });
                case "LineString":
                    return isLineInPoly(geom1, geom2);
                case "Polygon":
                    return isPolyInPoly(geom1, geom2);
                case "MultiPoint":
                    return isMultiPointInPoly(geom1, geom2);
                default:
                    throw new Error("feature2 " + type2 + " geometry not supported");
            }
        default:
            throw new Error("feature1 " + type1 + " geometry not supported");
    }
}
function isPointInMultiPoint(multiPoint, pt) {
    var i;
    var output = false;
    for(i = 0; i < multiPoint.coordinates.length; i++)if (compareCoords(multiPoint.coordinates[i], pt.coordinates)) {
        output = true;
        break;
    }
    return output;
}
function isMultiPointInMultiPoint(multiPoint1, multiPoint2) {
    for(var _i = 0, _a = multiPoint2.coordinates; _i < _a.length; _i++){
        var coord2 = _a[_i];
        var matchFound = false;
        for(var _b = 0, _c = multiPoint1.coordinates; _b < _c.length; _b++){
            var coord1 = _c[_b];
            if (compareCoords(coord2, coord1)) {
                matchFound = true;
                break;
            }
        }
        if (!matchFound) return false;
    }
    return true;
}
function isMultiPointOnLine(lineString, multiPoint) {
    var haveFoundInteriorPoint = false;
    for(var _i = 0, _a = multiPoint.coordinates; _i < _a.length; _i++){
        var coord = _a[_i];
        if ((0, _booleanPointOnLineDefault.default)(coord, lineString, {
            ignoreEndVertices: true
        })) haveFoundInteriorPoint = true;
        if (!(0, _booleanPointOnLineDefault.default)(coord, lineString)) return false;
    }
    if (haveFoundInteriorPoint) return true;
    return false;
}
function isMultiPointInPoly(polygon, multiPoint) {
    for(var _i = 0, _a = multiPoint.coordinates; _i < _a.length; _i++){
        var coord = _a[_i];
        if (!(0, _booleanPointInPolygonDefault.default)(coord, polygon, {
            ignoreBoundary: true
        })) return false;
    }
    return true;
}
function isLineOnLine(lineString1, lineString2) {
    var haveFoundInteriorPoint = false;
    for(var _i = 0, _a = lineString2.coordinates; _i < _a.length; _i++){
        var coords = _a[_i];
        if ((0, _booleanPointOnLineDefault.default)({
            type: "Point",
            coordinates: coords
        }, lineString1, {
            ignoreEndVertices: true
        })) haveFoundInteriorPoint = true;
        if (!(0, _booleanPointOnLineDefault.default)({
            type: "Point",
            coordinates: coords
        }, lineString1, {
            ignoreEndVertices: false
        })) return false;
    }
    return haveFoundInteriorPoint;
}
function isLineInPoly(polygon, linestring) {
    var output = false;
    var i = 0;
    var polyBbox = (0, _bboxDefault.default)(polygon);
    var lineBbox = (0, _bboxDefault.default)(linestring);
    if (!doBBoxOverlap(polyBbox, lineBbox)) return false;
    for(i; i < linestring.coordinates.length - 1; i++){
        var midPoint = getMidpoint(linestring.coordinates[i], linestring.coordinates[i + 1]);
        if ((0, _booleanPointInPolygonDefault.default)({
            type: "Point",
            coordinates: midPoint
        }, polygon, {
            ignoreBoundary: true
        })) {
            output = true;
            break;
        }
    }
    return output;
}
function isPolyInPoly(feature1, feature2) {
    // Handle Nulls
    if (feature1.type === "Feature" && feature1.geometry === null) return false;
    if (feature2.type === "Feature" && feature2.geometry === null) return false;
    var poly1Bbox = (0, _bboxDefault.default)(feature1);
    var poly2Bbox = (0, _bboxDefault.default)(feature2);
    if (!doBBoxOverlap(poly1Bbox, poly2Bbox)) return false;
    var coords = (0, _invariant.getGeom)(feature2).coordinates;
    for(var _i = 0, coords_1 = coords; _i < coords_1.length; _i++){
        var ring = coords_1[_i];
        for(var _a = 0, ring_1 = ring; _a < ring_1.length; _a++){
            var coord = ring_1[_a];
            if (!(0, _booleanPointInPolygonDefault.default)(coord, feature1)) return false;
        }
    }
    return true;
}
function doBBoxOverlap(bbox1, bbox2) {
    if (bbox1[0] > bbox2[0]) return false;
    if (bbox1[2] < bbox2[2]) return false;
    if (bbox1[1] > bbox2[1]) return false;
    if (bbox1[3] < bbox2[3]) return false;
    return true;
}
function compareCoords(pair1, pair2) {
    return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
function getMidpoint(pair1, pair2) {
    return [
        (pair1[0] + pair2[0]) / 2,
        (pair1[1] + pair2[1]) / 2
    ];
}

},{"@turf/bbox":"g2eLG","@turf/boolean-point-in-polygon":"a1t9c","@turf/boolean-point-on-line":"gV7nj","@turf/invariant":"9TTWn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"a1t9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>booleanPointInPolygon);
var _invariant = require("@turf/invariant");
function booleanPointInPolygon(point, polygon, options) {
    if (options === void 0) options = {};
    // validation
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    var pt = (0, _invariant.getCoord)(point);
    var geom = (0, _invariant.getGeom)(polygon);
    var type = geom.type;
    var bbox = polygon.bbox;
    var polys = geom.coordinates;
    // Quick elimination if point is not inside bbox
    if (bbox && inBBox(pt, bbox) === false) return false;
    // normalize to multipolygon
    if (type === "Polygon") polys = [
        polys
    ];
    var insidePoly = false;
    for(var i = 0; i < polys.length && !insidePoly; i++)// check if it is in the outer ring first
    if (inRing(pt, polys[i][0], options.ignoreBoundary)) {
        var inHole = false;
        var k = 1;
        // check for the point in any of the holes
        while(k < polys[i].length && !inHole){
            if (inRing(pt, polys[i][k], !options.ignoreBoundary)) inHole = true;
            k++;
        }
        if (!inHole) insidePoly = true;
    }
    return insidePoly;
}
/**
 * inRing
 *
 * @private
 * @param {Array<number>} pt [x,y]
 * @param {Array<Array<number>>} ring [[x,y], [x,y],..]
 * @param {boolean} ignoreBoundary ignoreBoundary
 * @returns {boolean} inRing
 */ function inRing(pt, ring, ignoreBoundary) {
    var isInside = false;
    if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) ring = ring.slice(0, ring.length - 1);
    for(var i = 0, j = ring.length - 1; i < ring.length; j = i++){
        var xi = ring[i][0];
        var yi = ring[i][1];
        var xj = ring[j][0];
        var yj = ring[j][1];
        var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
        if (onBoundary) return !ignoreBoundary;
        var intersect = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
/**
 * inBBox
 *
 * @private
 * @param {Position} pt point [x,y]
 * @param {BBox} bbox BBox [west, south, east, north]
 * @returns {boolean} true/false if point is inside BBox
 */ function inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}

},{"@turf/invariant":"9TTWn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"gV7nj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invariant = require("@turf/invariant");
/**
 * Returns true if a point is on a line. Accepts a optional parameter to ignore the
 * start and end vertices of the linestring.
 *
 * @name booleanPointOnLine
 * @param {Coord} pt GeoJSON Point
 * @param {Feature<LineString>} line GeoJSON LineString
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.ignoreEndVertices=false] whether to ignore the start and end vertices.
 * @param {number} [options.epsilon] Fractional number to compare with the cross product result. Useful for dealing with floating points such as lng/lat points
 * @returns {boolean} true/false
 * @example
 * var pt = turf.point([0, 0]);
 * var line = turf.lineString([[-1, -1],[1, 1],[1.5, 2.2]]);
 * var isPointOnLine = turf.booleanPointOnLine(pt, line);
 * //=true
 */ function booleanPointOnLine(pt, line, options) {
    if (options === void 0) options = {};
    // Normalize inputs
    var ptCoords = (0, _invariant.getCoord)(pt);
    var lineCoords = (0, _invariant.getCoords)(line);
    // Main
    for(var i = 0; i < lineCoords.length - 1; i++){
        var ignoreBoundary = false;
        if (options.ignoreEndVertices) {
            if (i === 0) ignoreBoundary = "start";
            if (i === lineCoords.length - 2) ignoreBoundary = "end";
            if (i === 0 && i + 1 === lineCoords.length - 1) ignoreBoundary = "both";
        }
        if (isPointOnLineSegment(lineCoords[i], lineCoords[i + 1], ptCoords, ignoreBoundary, typeof options.epsilon === "undefined" ? null : options.epsilon)) return true;
    }
    return false;
}
// See http://stackoverflow.com/a/4833823/1979085
// See https://stackoverflow.com/a/328122/1048847
/**
 * @private
 * @param {Position} lineSegmentStart coord pair of start of line
 * @param {Position} lineSegmentEnd coord pair of end of line
 * @param {Position} pt coord pair of point to check
 * @param {boolean|string} excludeBoundary whether the point is allowed to fall on the line ends.
 * @param {number} epsilon Fractional number to compare with the cross product result. Useful for dealing with floating points such as lng/lat points
 * If true which end to ignore.
 * @returns {boolean} true/false
 */ function isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt, excludeBoundary, epsilon) {
    var x = pt[0];
    var y = pt[1];
    var x1 = lineSegmentStart[0];
    var y1 = lineSegmentStart[1];
    var x2 = lineSegmentEnd[0];
    var y2 = lineSegmentEnd[1];
    var dxc = pt[0] - x1;
    var dyc = pt[1] - y1;
    var dxl = x2 - x1;
    var dyl = y2 - y1;
    var cross = dxc * dyl - dyc * dxl;
    if (epsilon !== null) {
        if (Math.abs(cross) > epsilon) return false;
    } else if (cross !== 0) return false;
    if (!excludeBoundary) {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 <= x && x <= x2 : x2 <= x && x <= x1;
        return dyl > 0 ? y1 <= y && y <= y2 : y2 <= y && y <= y1;
    } else if (excludeBoundary === "start") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 < x && x <= x2 : x2 <= x && x < x1;
        return dyl > 0 ? y1 < y && y <= y2 : y2 <= y && y < y1;
    } else if (excludeBoundary === "end") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 <= x && x < x2 : x2 < x && x <= x1;
        return dyl > 0 ? y1 <= y && y < y2 : y2 < y && y <= y1;
    } else if (excludeBoundary === "both") {
        if (Math.abs(dxl) >= Math.abs(dyl)) return dxl > 0 ? x1 < x && x < x2 : x2 < x && x < x1;
        return dyl > 0 ? y1 < y && y < y2 : y2 < y && y < y1;
    }
    return false;
}
exports.default = booleanPointOnLine;

},{"@turf/invariant":"9TTWn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"9vsUD":[function(require,module,exports) {
var _store = require("../../../../../src/store");
angular.module("modules:mapping").directive("mapPointDetail", [
    "Restangular",
    "Feature",
    "hasMapAccess",
    function(Restangular, Feature, hasMapAccess) {
        return {
            restrict: "A",
            templateUrl: "/directives/map-point-detail.html",
            scope: {
                leafletMap: "=map",
                feature: "=",
                findCollection: "=",
                editable: "="
            },
            controller: [
                "$scope",
                function($scope) {
                    Feature.restangularize($scope.feature);
                    var originalFeature = Restangular.copy($scope.feature);
                    $scope.collection = angular.copy($scope.findCollection($scope.feature.layerID));
                    const { map, workspace } = (0, _store.store).getState().pages.truterritory;
                    $scope.editable = ($scope.collection.type == "master" || $scope.collection.type == "writable") && hasMapAccess("collaborate") && map.editable && map.editable[$scope.collection.ID] && (typeof $scope.editable == "undefined" ? true : $scope.editable);
                    $scope.hasEditableColumns = !!$scope.collection.properties.find((prop)=>!prop["system"] && !prop["protected"] && !prop["hidden"]);
                    $scope.formattedDates = $scope.collection.properties.filter((prop)=>prop["type"] == "timestamptz").reduce((dict, prop)=>({
                            ...dict,
                            [prop["column"]]: $scope.feature.properties[prop["column"]] && new Date($scope.feature.properties[prop["column"]]).toLocaleString()
                        }), {});
                    $scope.csvCopy = $scope.feature.toCSV(makeColumnTuples($scope.collection.featureColumns, $scope.collection.properties)); // Set the forms object so it can be accessed
                    $scope.forms = {};
                    $scope.save = function(feature, properties, form) {
                        form.validate();
                        if (form.isValid()) {
                            $scope.editing = false;
                            $scope.saving = true;
                            feature.saveProperties(feature.layerID, properties, map.ID, workspace.ID).finally(function() {
                                $scope.saving = false;
                                originalFeature = feature.clone();
                            });
                        }
                    };
                    $scope.close = function() {
                        $scope.leafletMap.closePopup();
                    };
                    $scope.cancel = function(feature) {
                        $scope.editing = false;
                        $scope.feature = originalFeature.clone();
                    };
                    /**
       * Make an array of tuples to pass into feature.toCSV()
       * @param  {array} featureColumns Columns names in order
       * @param  {object} properties    Dictionary of info for each columns
       * @return {array}
       */ function makeColumnTuples(featureColumns, properties) {
                        let columns = [];
                        properties.forEach(function(info, index, arr) {
                            columns.push([
                                info.name,
                                info.column
                            ]);
                        });
                        return columns;
                    }
                }
            ]
        };
    }
]);

},{"../../../../../src/store":"7WrEn"}],"ebEA6":[function(require,module,exports) {
/**
 * @name CondenseTo
 * @description Service that takes an array of objects and condenses it down to an array of properties
 * @ngdoc service
 * @memberOf modules
 *
 * @example
 * var toBeCondensed = [ {id: 1, name: "a"}, {id: 2, name: "b"}, {id: 3, name: "c"}, {id: 4, name: "d"}]
 * new CondenseTo(toBeCondensed, 'id').getClean() // [1,2,3,4]
 *
 */ angular.module("modules").factory("CondenseTo", function() {
    /**
   * @memberOf modules.CondenseTo
   * @param {Array} array the array of objects that needs to be condensed
   * @param {String} property the property to condense
   * @return {void}
   */ var Condenser = function(array, property) {
        /**
     * The array of IDs
     * @type {Array}
     */ this.array = []; // If the array isn't an Array, throw an error
        if (!(array instanceof Array)) throw new ReferenceError("CondenseTo: argument is not an array"); // If the array doesn't have length, throw an error
        if (!array.length) return this; // Loop through the array and create the array of IDs
        for(var i = 0; i < array.length; i++)this.array[i] = array[i][property];
    };
    /**
   * Returns the array
   * @memberOf modules.CondenseTo
   * @return {Array} an array of objects
   */ Condenser.prototype.getClean = function() {
        return this.array;
    };
    return Condenser;
});

},{}],"3Uh24":[function(require,module,exports) {
/**
 * @name Entity
 * @ngdoc service
 * @description A Restangular service for entities
 * @memberOf modules
 */ angular.module("modules").factory("Entity", [
    "Restangular",
    function(Restangular) {
        var Entity = Restangular.all("entities");
        Entity.addRestangularMethod("getSummary", "getList", "summary"); // add a custom users method
        Restangular.addElementTransformer("entities", false, function(entity) {
            if (!("one" in entity)) return entity; // assign users
            entity.addRestangularMethod("putUsers", "put", "users"); // set permissions
            entity.addRestangularMethod("putPermissions", "put", "permissions"); // get user IDs
            entity.userIDs = function() {
                var IDs = [];
                for(var i = 0; i < this.users.length; ++i)IDs.push(this.users[i].ID);
                return IDs;
            };
            entity.userIDsWithout = function(ID) {
                var IDs = [];
                for(var i = 0; i < this.users.length; ++i)if (this.users[i].ID != ID) IDs.push(this.users[i].ID);
                return IDs;
            };
            /**
     * Get email addresses from which an entity can send email
     * @param  {bool} activated Limit to activated addresses
     * @return {object} promise
     */ entity.getEmailList = function(activated) {
                var params = {
                    entityID: entity.ID
                };
                if (typeof activated != "undefined") params.activated = activated;
                var promise = entity.customGET("emails", params);
                promise.then(function(response) {
                    Restangular.restangularizeElement(null, response, "entities/" + entity.ID + "/emails");
                    return response;
                });
                return promise;
            };
            return entity;
        }); // add a custom methods to collection
        Restangular.addElementTransformer("entities", true, function(collection) {
            // don't try to work on uninitialized collection
            if (!("one" in collection)) return collection;
            collection.addRestangularMethod("search", "getList", "search");
            return collection;
        });
        Entity.getEmailList = function(entityID, activated) {
            // Create a new entity with just the entityID
            var entity = Restangular.restangularizeElement(null, {
                ID: entityID * 1
            }, "entities"); // Then return the email list (promise)
            return entity.getEmailList(activated);
        };
        return Entity;
    }
]);

},{}],"kkVSt":[function(require,module,exports) {
/**
 * @name Interval
 * @ngdoc service
 * @description A service for interacting with and creating intervals
 * @memberOf modules
 * @example
 * Interval.getNouns('day')
 * Interval.getNouns(['day'])
 */ angular.module("modules").factory("Interval", function() {
    var Interval = function() {};
    var nouns = {
        1: "day",
        2: "week",
        3: "month",
        4: "quarter",
        5: "year"
    };
    var adverbs = {
        0: "One-Time",
        1: "Daily",
        2: "Weekly",
        3: "Monthly",
        4: "Quarterly",
        5: "Annually"
    };
    /**
   * Gets a list of interval nouns (day, week, month, quarter, etc...)
   * @memberOf modules.Interval
   * @param  {(array|string)} exclude a list of nouns to exclude
   * @return {array} the array of requested nouns
   */ Interval.getNouns = function(exclude) {
        return excludeFromList(nouns, exclude);
    };
    /**
   * Gets a list of interval adverbs (daily, weekly, monthly, quarterly, etc...)
   * @memberOf modules.Interval
   * @param  {(array|string)} exclude a list of adverbs to exclude
   * @return {array} the array of requested adverbs
   */ Interval.getAdverbs = function(exclude) {
        return excludeFromList(adverbs, exclude);
    };
    /**
   * Gets the value of a noun
   * @memberOf modules.Interval
   * @param  {string} noun
   * @return {Integer} the value of the noun
   */ Interval.getNoun = function(noun) {
        return findByValue(nouns, noun);
    };
    /**
   * Gets the value of a adverb
   * @memberOf modules.Interval
   * @param  {string} adverb
   * @return {Integer} the value of the adverb
   */ Interval.getAdverb = function(adverb) {
        return findByValue(adverbs, adverb);
    };
    function findByValue(list, search) {
        return _.invert(list)[search] * 1 || null;
    }
    function excludeFromList(list, exclude) {
        var inverted = _.invert(list);
        return _.invert(_.omit(inverted, exclude));
    }
    return Interval;
});

},{}],"84sMs":[function(require,module,exports) {
/**
 * @name ObjectFilter
 * @ngdoc service
 * @memberOf modules
 * @description
 *
 *  Service to filter an object and ensure that required properties are set whilst stripping out unwanted properties
 *
 *  Filters should be an array of mixed elements. For simple nested properties, use a string (['ID', 'name'])
 *  For arrays, use an object syntax with an array of strings (['ID', 'name', {tiles: ['ID', 'name']}])
 *
 * @example
 *
 *  var object = {
 *    name: "Parent",
 *    children: [
 *      {
 *        name: 'Child',
 *        grandChildren: [
 *          {name: 'Grandchild'}
 *        ]
 *      }
 *    ]
 *  }
 *
 *  var filters = [
 *    'name',
 *    {
 *      children: [
 *        'name',
 *        grandChildren: ['name']
 *      ]
 *    }
 *  ]
 *
 *  var cleanedObject = new ObjectFilter(filters, object).getClean()
 *
 */ angular.module("modules").factory("ObjectFilter", function() {
    /**
   * @memberOf modules.ObjectFilter
   * @param {Array} filters an array of object properties
   * @param {Object} object
   */ var ObjectFilter = function(filters, object) {
        /**
     * These are the filters that were passed in on initialization
     * @type {Object}
     */ this._filters = filters;
        this._flattenedFilters = [];
        /**
     * This is the object that will be returned after being cleaned up
     * @type {Object}
     */ this.cleanObject = {};
        /**
     * This is the original object that was passed in on initalization
     * @type {Object}
     */ this.originalObject = object;
        if (!this._filters) throw new ReferenceError("ObjectFilter: no filters passed in!");
        if (!this.originalObject) throw new ReferenceError("ObjectFilter: no object passed in!"); // Loop through all the filters
        this._filterProperties(this._prepareFilters(filters, this.originalObject));
    };
    ObjectFilter.prototype = {
        _filterProperties: function(filters) {
            for(var i = 0; i < filters.length; i++){
                //   if (typeof filters[i] == 'object') {
                //     var filter = filters[i]
                //     for (var key in filter) {
                //       var array = this.getProperty(key, this.originalObject)
                //       for (var j = 0; j < array.length; j++) {
                //         this._filterProperties(filter[key], array[j])
                //       };
                //     };
                // } else {
                // First get the value of the filter
                var value = this.getProperty(filters[i], this.originalObject); // Then set the value on the cleanObject
                this.setProperty(filters[i], value); // }
            }
        },
        /**
     * Prepares an array of filters to be used by _filterProperties
     *   Flattens an array of mixed elements into a simple array of strings
     *
     * @param  {array} filters
     * @param  {object} object    the object to reference when getting values
     * @param  {string} [prefix]  an optional prefix to add to the filter keys (used with nested filter rules)
     * @return {object}
     */ _prepareFilters: function(filters, object, prefix) {
            // Loop through all the filters
            for(var i = 0; i < filters.length; i++)// If this is an object, it's a list of validation rules for each element of an array
            if (typeof filters[i] == "object") {
                // For easy access
                var filter = filters[i]; // "Loop" through the object to get the first key
                for(var key in filters[i]){
                    // Get the array that this key is referencing
                    var array = this.getProperty(key, object);
                    if (!array) array = []; // For each element in the array
                    for(var j = 0; j < array.length; j++){
                        // First set the cleaned object to an array so it doesn't get auto-set to an object
                        this.setProperty(prefix ? prefix + "." + key : key, []); // For each set of child rules
                        for(var x = 0; x < filter[key].length; x++){
                            // Grab the filter & key
                            var childFilter = filter[key][x], childKey = prefix ? prefix + "." + key : key;
                            childKey += "." + j; // If the child filter is an object, it's another nested rule, so run over it again
                            if (typeof childFilter == "object") this._prepareFilters([
                                childFilter
                            ], array[j], childKey); // Otherwise push the key onto the flattened array
                            else this._flattenedFilters.push(childKey + "." + childFilter);
                        }
                    }
                } // Nothing special to do! Hooray! Easy as pie: push the filter onto the array
            } else {
                var key = prefix ? prefix + "." + filters[i] : filters[i];
                this._flattenedFilters.push(key);
            }
             // And, after all that work has been done,
            //  return the array of flattened filters
            return this._flattenedFilters;
        },
        /**
     * Returns the cleanObject
     * @return {Object} the cleaned object
     * @memberOf modules.ObjectFilter
     */ getClean: function() {
            return this.cleanObject;
        },
        /**
     * Sets a property on the cleanObject by a dot notated key
     * @param {string} key    the dot-delimited string of the key in the object
     * @param {Object|string} the value to be set
     * @return {void}
     */ setProperty: function(key, value) {
            // Set the cleanObject on a new var so that it's cleaner to access
            var object = this.cleanObject; // If the key is already on the object
            if (key in object) {
                // Set the value & return
                object[key] = value;
                return;
            } // Otherwise, split the key into an array
            var keyArray = key.split("."); // Loop through each segment of the keyArray
            for(var i = 0; i < keyArray.length; i++){
                // When this reaches the end, set the value & return
                if (i == keyArray.length - 1) {
                    object[keyArray[i]] = value;
                    return;
                } // If this isn't at the end of the loop,
                // Check to see if the current key exists in the object
                // If it doesn't, create an empty object
                if (!(keyArray[i] in object)) object[keyArray[i]] = {};
                 // Move on down the tree
                object = object[keyArray[i]];
            }
        },
        /**
     * [getProperty description]
     * @param  {string} key    dot-delimited string of the key in the object
     *                         i.e., user.firstName => object.user.firstName
     * @param  {Object} object the target object
     * @return {Object|string} the results of looking for the key in the object
     */ getProperty: function(key, object) {
            // If the key is on the first level of the object, return it
            if (key in object) return object[key]; // Otherwise, split the key into an array
            var keyArray = key.split("."); // Loop through each segment of the keyArray
            for(var i = 0; i < keyArray.length; i++){
                // If the object isn't an object & the key isn't in the object,
                // That means that the key isn't in the object,
                // So return null
                if (typeof object != "object" || !(keyArray[i] in object)) return null; // At the end of each loop, descend down further into the object
                object = object[keyArray[i]];
            } // If the loop finishes
            // That means this is now the object that was being searched for
            // So return it
            return object;
        }
    };
    return ObjectFilter;
});

},{}],"iGNrP":[function(require,module,exports) {
angular.module("modules").factory("User", [
    "Restangular",
    "ObjectFilter",
    function(Restangular, ObjectFilter) {
        var User = Restangular.all("users"); // add a custom methods to collection
        Restangular.addElementTransformer("users", true, function(collection) {
            // don't try to work on uninitialized collection
            if (!("one" in collection)) return collection;
            collection.addRestangularMethod("search", "getList", "search");
            collection.addRestangularMethod("getEmails", "getList", "emails");
            return collection;
        }); // add custom methods to individual user and imports
        Restangular.extendModel("users", function(user) {
            if (!("one" in user)) return user; // make sure permissions are an object, not an array
            if (user.permissions instanceof Array) user.permissions = {};
            user.savePermissions = function() {
                return user.customPUT(user.permissions, "permissions");
            };
            return user;
        });
        var allowedColumns = [
            "lname",
            "fname",
            "email",
            "password",
            "passwordConfirm"
        ];
        User.saveUser = function(user) {
            var filtered = new ObjectFilter(allowedColumns, user).getClean();
            if (filtered.password === null && filtered.passwordConfirm === null) {
                delete filtered.password;
                delete filtered.passwordConfirm;
            }
            return User.customPUT(filtered, user.ID);
        };
        User.getEmails = function(userID) {
            return User.customGETLIST(userID + "/emails");
        };
        return User;
    }
]);

},{}],"9ijip":[function(require,module,exports) {
/**
 * Common/index.js
 * This is where all the services, resources, directives, etc, are included
 * @module common
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
require("5f098ad11681509e");
exports.default = angular.module("common", [
    "ui.sortable"
]).name;
require("50342212b1df246e");
require("a45974c2b4b7892d");
require("539009d1c71ca22");
require("85af229b8886dbb7");
require("df2c7313e997af10");
require("eb0852bc23551f9b");
require("e1c64f0b1bb3a4a1");
require("82e0a6acf20d5a9c");
require("4f7930700438bb2f");
require("1a5a3ab2d0d182b5");
require("8ddb7458e5d6851");
require("2957db6ba520b8ac");
require("ae5fe84d8c82812a");
require("c892ecee0b19d85e");
require("9f4bc860cbc8db57");
require("5d6323e3761cad53");
require("8d664ef0a28cfe87");
require("2e0047ab3cea67bf");
require("6173317083e422f8");
require("d22b49b3cd5cf74e");
require("302d8aace16098e4");
require("187821e52a082d4d");
require("60adfd5b22d9bef1");
require("7be1b11b77f94ada");
require("e4d5ea89bf10f16");
require("db64c2d642a425b9");
require("5797eeceb978c149");
require("f8ef9e4888e0f214");
require("e5054722f562a59c");
require("ea461f4f44ad33de");
require("c41d0d4b241817c6");
require("d11f90579fd55c40");
require("5d0185a7c8267032");
require("27d6d6034939687");
require("c2e95db3d4931d62");
require("a1ef102a8366988a");
require("ac0acd865042bdf5");
require("e190f301770b523d");
require("540ddac1cf99cf3d");
require("cdffcbeec2ac9355");
require("e70c469246a6a4b8");
require("ea051a75811f2ecc");
require("30621f632c34394d");
require("6177f8ca38327ef7");
require("d4f0c81a6ea04b61");
require("115b8b33c95a60d4");
require("bbf788adb492ee38");
require("16d43f957ed64589");
require("7ce4014f06b9a668");
require("c39aabcc8aaaee89");
require("202d70a0dc12c48c");
require("9c3438b3d2a552fe");
require("b47c7595cbda5a51");
require("63c9773dacddf2d0");
require("a26693547547c7b");
require("f851a3371e56caea");
require("ef9ec4167130fee2");
require("bc9e9c0ced63f3b0");
require("b410f91e14ba96d3");
require("ea7cfdb5def30bc7");
require("36cdc61dc834cfca");
require("20845d453117c536");
require("505eadcd3f4eca59");
require("224d38ad8a5ffa76");
require("4f375dc0b35e062");
require("4d0d348b2a7fad86");

},{"5f098ad11681509e":"jVL9z","50342212b1df246e":"9GX2h","a45974c2b4b7892d":"ajDV3","539009d1c71ca22":"kKtRm","85af229b8886dbb7":"iiv3I","df2c7313e997af10":"bRzPy","eb0852bc23551f9b":"9lU2u","e1c64f0b1bb3a4a1":"jQA6h","82e0a6acf20d5a9c":"auMQZ","4f7930700438bb2f":"lBEys","1a5a3ab2d0d182b5":"eyqtb","8ddb7458e5d6851":"eeTTF","2957db6ba520b8ac":"eQTQn","ae5fe84d8c82812a":"hdH6V","c892ecee0b19d85e":"OeyTT","9f4bc860cbc8db57":"5dl8y","5d6323e3761cad53":"li7AB","8d664ef0a28cfe87":"8fAnD","2e0047ab3cea67bf":"5jvTj","6173317083e422f8":"klBVx","d22b49b3cd5cf74e":"hNilF","302d8aace16098e4":"1HfYw","187821e52a082d4d":"bafIA","60adfd5b22d9bef1":"l2n4C","7be1b11b77f94ada":"f3opG","e4d5ea89bf10f16":"eG2sT","db64c2d642a425b9":"1qH6e","5797eeceb978c149":"bqkxB","f8ef9e4888e0f214":"ANTXI","e5054722f562a59c":"krqoD","ea461f4f44ad33de":"kih3b","c41d0d4b241817c6":"4D1Lz","d11f90579fd55c40":"6phZM","5d0185a7c8267032":"dNFK6","27d6d6034939687":"8Xi5a","c2e95db3d4931d62":"8ecCx","a1ef102a8366988a":"6Xf8a","ac0acd865042bdf5":"kIpG9","e190f301770b523d":"iYUj4","540ddac1cf99cf3d":"87AXe","cdffcbeec2ac9355":"2kh7b","e70c469246a6a4b8":"eq0ZF","ea051a75811f2ecc":"jgQO3","30621f632c34394d":"fqE0A","6177f8ca38327ef7":"hZZFe","d4f0c81a6ea04b61":"f0Qal","115b8b33c95a60d4":"8oru6","bbf788adb492ee38":"ivrGl","16d43f957ed64589":"1Gg25","7ce4014f06b9a668":"iPiEq","c39aabcc8aaaee89":"6PkpN","202d70a0dc12c48c":"1cVsH","9c3438b3d2a552fe":"5ZDlp","b47c7595cbda5a51":"iZ4ER","63c9773dacddf2d0":"cNWet","a26693547547c7b":"bDlSF","f851a3371e56caea":"2Tx5R","ef9ec4167130fee2":"1xdwv","bc9e9c0ced63f3b0":"773EM","b410f91e14ba96d3":"6Csdm","ea7cfdb5def30bc7":"bwCXv","36cdc61dc834cfca":"7xHb8","20845d453117c536":"hkQ1c","505eadcd3f4eca59":"j5nbi","224d38ad8a5ffa76":"bedEt","4f375dc0b35e062":"3Mz3q","4d0d348b2a7fad86":"eT9Dh","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"jVL9z":[function(require,module,exports) {
(function($, undefined) {
    $.widget("ui.dragslider", $.ui.slider, {
        options: $.extend({}, $.ui.slider.prototype.options, {
            rangeDrag: false
        }),
        _create: function() {
            $.ui.slider.prototype._create.apply(this, arguments);
            this._rangeCapture = false;
        },
        _mouseCapture: function(event) {
            var o = this.options;
            if (o.disabled) return false;
            if (this.range && event.target == this.range.get(0) && o.rangeDrag && o.range) {
                this._rangeCapture = true;
                this._rangeStart = null;
            } else this._rangeCapture = false;
            $.ui.slider.prototype._mouseCapture.apply(this, arguments);
            if (this._rangeCapture == true) this.handles.removeClass("ui-state-active").blur();
            return true;
        },
        _mouseStop: function(event) {
            this._rangeStart = null;
            return $.ui.slider.prototype._mouseStop.apply(this, arguments);
        },
        _slide: function(event, index, newVal) {
            if (!this._rangeCapture) return $.ui.slider.prototype._slide.apply(this, arguments);
            if (this._rangeStart == null) this._rangeStart = newVal;
            var oldValLeft = this.options.values[0], oldValRight = this.options.values[1], slideDist = newVal - this._rangeStart, newValueLeft = oldValLeft + slideDist, newValueRight = oldValRight + slideDist, allowed;
            if (this.options.values && this.options.values.length) {
                if (newValueRight > this._valueMax() && slideDist > 0) {
                    slideDist -= newValueRight - this._valueMax();
                    newValueLeft = oldValLeft + slideDist;
                    newValueRight = oldValRight + slideDist;
                }
                if (newValueLeft < this._valueMin()) {
                    slideDist += this._valueMin() - newValueLeft;
                    newValueLeft = oldValLeft + slideDist;
                    newValueRight = oldValRight + slideDist;
                }
                if (slideDist != 0) {
                    newValues = this.values();
                    newValues[0] = newValueLeft;
                    newValues[1] = newValueRight; // A slide can be canceled by returning false from the slide callback
                    allowed = this._trigger("slide", event, {
                        handles: this.handles,
                        values: newValues
                    });
                    if (allowed !== false) {
                        this.values(0, newValueLeft, true);
                        this.values(1, newValueRight, true);
                    }
                    this._rangeStart = newVal;
                }
            }
        }
    });
})(jQuery);

},{}],"9GX2h":[function(require,module,exports) {
/**
 * @name cmErrors
 * @memberOf common
 * @ngdoc directive
 * @requires common.CodeMirror
 * @description Provides an API to show error on a Code Mirror instance
 */ angular.module("common").directive("cmErrors", function() {
    return {
        link: function($scope, $element, $attrs) {
            let editor = $element.children(".CodeMirror")[0].CodeMirror;
            editor.setOption("gutters", [
                "CodeMirror-lint-markers",
                "CodeMirror-linenumbers"
            ]);
            $scope.$watch($attrs.cmErrors, function(errors) {
                setTimeout(function() {
                    editor.clearGutter("CodeMirror-lint-markers");
                    editor.eachLine(function(line) {
                        editor.removeLineClass(line.lineNo(), "background", "error-background");
                        if (errors && errors[line.lineNo() + 1]) {
                            editor.setGutterMarker(line, "CodeMirror-lint-markers", createMarker(errors[line.lineNo() + 1]));
                            editor.addLineClass(line, "background", "error-background");
                        }
                    });
                });
            });
            function createMarker(text) {
                let elem = $('<span class="CodeMirror-lint-marker-warning"></span>');
                let tooltip = $(`<div class="error-tooltip">${text}</div>`);
                tooltip.css("position", "absolute");
                let { top, left } = $element.parent().offset();
                let timeout;
                elem.on("mouseover", function() {
                    $element.parent().parent().append(tooltip);
                });
                elem.on("mousemove", function(event) {
                    tooltip.css({
                        top: event.pageY - top,
                        left: 23
                    });
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        tooltip.remove();
                    }, 10000);
                });
                elem.on("mouseout", function() {
                    tooltip.remove();
                });
                return elem.get(0);
            }
        }
    };
});

},{}],"ajDV3":[function(require,module,exports) {
/**
 * @name fade-in
 * @memberOf common
 * @ngdoc animation
 * @description
 *   Animation to fade in
 */ angular.module("common").animation(".fade-in", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).fadeIn();
        }
    };
});

},{}],"kKtRm":[function(require,module,exports) {
/**
 * @name fade-out
 * @memberOf common
 * @ngdoc animation
 * @description
 *   Animation to fade out
 */ angular.module("common").animation(".fade-in", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).fadeOut();
        }
    };
});

},{}],"iiv3I":[function(require,module,exports) {
/**
 * @name scroll-top
 * @memberOf common
 * @ngdoc animation
 *
 * @description
 * Scroll animation
 * Requires the parent of the element to have a class of .scroll-parent
 * Add a class of .scroll-top to the element
 * When you want to scroll, add .scroll-to to the element
 *
 */ angular.module("common").animation(".scroll-top", function() {
    return {
        addClass: function(element, className, done) {
            var parent = $(element).closest(".scroll-parent");
            var parentTop = $(parent).scrollTop();
            var eleTop = $(element).offset().top;
            var height = $(element).height();
            var target = parentTop + eleTop - height - 55; // console.log('parentTop: '+parentTop);
            // console.log('eleTop: '+eleTop);
            // console.log('height: '+height);
            // console.log('target: '+target);
            $(parent).animate({
                scrollTop: target
            }, 1000);
            $(element).removeClass("scroll-to");
        }
    };
});

},{}],"bRzPy":[function(require,module,exports) {
/**
 * @name slide-down
 * @memberOf common
 * @ngdoc animation
 */ angular.module("common").animation(".slide-down", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).slideDown();
        },
        removeClass: function(element, className, done) {
            jQuery(element).slideUp();
        }
    };
});

},{}],"9lU2u":[function(require,module,exports) {
/**
 * @name slide-left
 * @memberOf common
 * @ngdoc animation
 */ angular.module("common").animation(".slide-left", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).hide("slide", {
                direction: "left"
            });
        },
        removeClass: function(element, className, done) {
            jQuery(element).show("slide", {
                direction: "left"
            });
        }
    };
});

},{}],"jQA6h":[function(require,module,exports) {
/**
 * @name slide-right
 * @memberOf common
 * @ngdoc animation
 */ angular.module("common").animation(".slide-right", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).hide("slide", {
                direction: "right"
            });
        },
        removeClass: function(element, className, done) {
            jQuery(element).show("slide", {
                direction: "right"
            });
        }
    };
});

},{}],"auMQZ":[function(require,module,exports) {
/**
 * @name slide-up
 * @memberOf common
 * @ngdoc animation
 */ angular.module("common").animation(".slide-up", function() {
    return {
        addClass: function(element, className, done) {
            jQuery(element).slideUp();
        },
        removeClass: function(element, className, done) {
            jQuery(element).slideDown();
        }
    };
});

},{}],"lBEys":[function(require,module,exports) {
/**
 * @name cmColorPicker
 * @description Color picker plugin for CodeMirror
 * Requires the CodeMirror.cartocss mode, or the color to be wrapped in `cm-url`. Example: `<span>#FFF</span>` `<span>rgb(255,255,255)</span>`
 * Supports hex, short hex, rgb, and rgba
 *
 * @requires common.codeMirror
 *
 * @example
 *
 * <code-mirror options="options" ng-model="model" cm-color-picker></code-mirror>
 */ angular.module("common").directive("cmColorPicker", function() {
    return {
        restrict: "A",
        require: "^codeMirror",
        link: function($scope, $element, $attrs, $controllers) {
            let editor = $element.children(".CodeMirror")[0].CodeMirror;
            let wrapper = $(editor.getWrapperElement());
            wrapper.on("keyup", createColorBoxes);
            $scope.$on("codeMirrorReady", createColorBoxes); // If there are color pickers around, delete them!
            wrapper.on("mouseup", function(event) {
                if (!$(event.target).parents(".sp-container").length) wrapper.children(".sp-container").remove();
            });
            function createColorBoxes() {
                wrapper.find(".cm-color").each(function() {
                    let element = $(this);
                    let colorBox = element.children(".color-box");
                    if (!colorBox.length) {
                        let lineNumber = element.parent().parent().prev().children().text();
                        colorBox = $(`<span class="color-box box" line-number="${lineNumber - 1}"></span>`);
                        colorBox.on("click", onColorBoxClick);
                        element.prepend(colorBox);
                    }
                    colorBox.css("background", element.text());
                });
            }
            function onColorBoxClick(event) {
                let colorElement = $(event.target).parent();
                let lineNumber = parseInt($(event.target).attr("line-number"));
                let startingRange = editor.getLine(lineNumber).indexOf(":") + 2;
                let picker = $(`<input type="text" value="${colorElement.text()}" />`);
                wrapper.prepend(picker);
                picker.spectrum({
                    flat: true,
                    showButtons: false,
                    showAlpha: true,
                    preferredFormat: "hex",
                    move: function(color) {
                        editor.replaceRange(color.toString() + ";", {
                            line: lineNumber,
                            ch: startingRange
                        }, {
                            line: lineNumber
                        });
                        createColorBoxes();
                    }
                });
                let container = picker.spectrum("container");
                container.css("position", "absolute");
                container.css($(event.target).position());
            }
        }
    };
});

},{}],"eyqtb":[function(require,module,exports) {
/**
 * @name cmImagePreview
 * @description Provides an image preview for urls in a Code Mirror instance
 * @ngdoc directive
 * @requires common.codeMirror
 *
 * @example
 *
 * <code-mirror options="options" ng-model="model" cm-image-preview="cm-class"></code-mirror>
 */ angular.module("common").directive("cmImagePreview", function() {
    return {
        restrict: "A",
        require: "^codeMirror",
        link: function($scope, $element, $attrs) {
            let editor = $element.children(".CodeMirror")[0].CodeMirror;
            let wrapper = $(editor.getWrapperElement());
            let classes = $attrs.cmImagePreview.split(" ");
            wrapper.on("keyup", createPreviewBoxes);
            $scope.$on("codeMirrorReady", createPreviewBoxes);
            function createPreviewBoxes() {
                classes.forEach(function(classString) {
                    wrapper.find(`.${classString}`).each(function() {
                        let element = $(this);
                        let urlBox = element.children(".image-preview");
                        if (!urlBox.length) {
                            urlBox = $(`<span class="image-preview box"></span>`);
                            element.prepend(urlBox);
                        }
                        urlBox.css("background-image", `url("${element.next().text()}")`);
                    });
                });
            }
        }
    };
});

},{}],"eeTTF":[function(require,module,exports) {
/**
 * @description Image uploader/picker plugin for CodeMirror
 * Requires the CodeMirror.cartocss mode, or the url() to have the class of `cm-url`, and the url string to have a class of `cm-urlString`. Example: `<span class="cm-url">url</span>(<span class="cmUrlString"></span>)`
 * @requires common.codeMirror
 *
 * @example
 *
 * <code-mirror options="options" ng-model="model" cm-image-uploader></code-mirror>
 */ angular.module("common").directive("cmImageUploader", [
    "$compile",
    function($compile) {
        return {
            restrict: "A",
            require: "^codeMirror",
            link: function($scope, $element, $attrs, $controllers) {
                let editor = $element.children(".CodeMirror")[0].CodeMirror;
                let wrapper = $(editor.getWrapperElement());
                let classes = $attrs.cmImageUploader.split(" ") || [];
                let urlClass = classes.splice(classes.length - 1, 1);
                wrapper.on("keyup", createPreviewBoxes);
                wrapper.on("click", function(event) {
                    let target = $(event.target);
                    if (!target.parents("fine-uploader").length && !target.hasClass("image-preview")) wrapper.children("fine-uploader").css("display", "none");
                }); // $scope.$on('codeMirrorReady', createPreviewBoxes)
                createUploader();
                var selectedLineNumber, uploaderElement, uploaderInstance;
                function createPreviewBoxes() {
                    if (!uploaderInstance) return;
                    let files = uploaderInstance.getUploads();
                    classes.forEach(function(classString) {
                        wrapper.find(`.${classString}`).each(function() {
                            let element = $(this);
                            let previewBox = element.children(".image-preview");
                            if (!previewBox.length) {
                                let lineNumber = element.parent().parent().prev().children().text();
                                previewBox = $(`<span class="image-preview box" line-number="${lineNumber - 1}"></span>`);
                                previewBox.on("click", onPreviewBoxClick);
                                element.prepend(previewBox);
                            }
                            let file = files.find(function(file) {
                                return file.name == element.next().text() && !file.parentId;
                            });
                            let thumbnailUrl;
                            if (file) thumbnailUrl = file.thumbnailUrl || uploaderInstance._thumbnailUrls[file.id];
                            else thumbnailUrl = null;
                            if (thumbnailUrl === null) previewBox.addClass("empty");
                            else previewBox.removeClass("empty");
                            previewBox.css("background-image", `url("${thumbnailUrl}")`);
                        });
                    });
                }
                function createUploader() {
                    let scope = $scope.$new();
                    scope.options = {
                        directory: "mapping/media",
                        gallery: true,
                        scaling: {
                            hideScaled: true,
                            sizes: [
                                {
                                    maxSize: 100
                                }
                            ]
                        },
                        validation: {
                            sizeLimit: 50000,
                            image: {
                                maxHeight: 512,
                                maxWidth: 512
                            }
                        },
                        signature: {
                            endpoint: "mapping/themes/media/sign"
                        },
                        uploadSuccess: {
                            endpoint: "mapping/themes/media"
                        },
                        deleteFile: {
                            endpoint: "mapping/themes/media"
                        },
                        session: {
                            endpoint: "mapping/themes/media"
                        },
                        callbacks: {
                            onSessionRequestComplete: function(response) {
                                uploaderInstance = this;
                                createPreviewBoxes();
                            },
                            onSelect: function(file) {
                                if (!this.getParentId(file.id)) {
                                    let line = editor.getLine(selectedLineNumber);
                                    let endCh = line.indexOf(")") == -1 ? line.length : line.indexOf(")");
                                    let { start, end } = {
                                        start: {
                                            line: selectedLineNumber,
                                            ch: line.indexOf("(") + 1
                                        },
                                        end: {
                                            line: selectedLineNumber,
                                            ch: endCh
                                        }
                                    };
                                    let replacement = `${file.name}${endCh == line.length ? ");" : ""}`;
                                    editor.replaceRange(replacement, start, end);
                                    createPreviewBoxes();
                                    uploaderElement.css("display", "none");
                                }
                            }
                        }
                    };
                    uploaderElement = $compile('<fine-uploader options="options"></fine-uploader>')(scope);
                    uploaderElement.css("display", "none");
                    wrapper.append(uploaderElement);
                }
                function addThumbnailPreviews(files, uploader) {
                    $(`.${urlClass}`).each(function() {
                        let elem = $(this);
                        let file = _.find(files, {
                            name: elem.text()
                        });
                        let thumbnailUrl = file.thumbnailUrl || uploader._thumbnailUrls[file.id];
                        elem.prev("." + classes.join(",.")).children(".image-preview").css("background-image", `url('${thumbnailUrl}')`);
                    });
                }
                function onPreviewBoxClick(event) {
                    selectedLineNumber = parseInt($(event.target).attr("line-number"));
                    uploaderElement.css($(event.target).position());
                    uploaderElement.css("display", "block");
                }
            }
        };
    }
]);

},{}],"eQTQn":[function(require,module,exports) {
var _codemirror = require("codemirror");
var _showHint = require("../../../node_modules/codemirror/addon/hint/show-hint");
var _sqlHint = require("../../../node_modules/codemirror/addon/hint/sql-hint");
var _overlay = require("../../../node_modules/codemirror/addon/mode/overlay");
var _sql = require("../../../node_modules/codemirror/mode/sql/sql");
var _css = require("../../../node_modules/codemirror/mode/css/css");
var _fullscreen = require("../../../node_modules/codemirror/addon/display/fullscreen");
window.CodeMirror = _codemirror;
/**
 * @name codeMirror
 * @memberOf common
 * @ngdoc directive
 * @scope true
 * @restrict E
 * @see {@link http://codemirror.net/|Code Mirror}
 * @description A directive for the CodeMirror editor
 *
 * @attribute {Object} options The CodeMirror options to pass into the instance. See [the CodeMirror options](http://codemirror.net/doc/manual.html#config)
 * @example
 *   <code-mirror ng-model="model" options="options" ></code-mirror>
 */ angular.module("common").directive("codeMirror", function() {
    return {
        scope: {
            options: "=",
            onBlur: "&"
        },
        require: "ngModel",
        restrict: "E",
        template: "<textarea></textarea>",
        controller: function() {},
        // This empty controller function is here so that you can "require" this directive
        link: function($scope, $element, $attrs, ngModel) {
            var options = angular.extend({
                indentWithTabs: true,
                smartIndent: true,
                matchBrackets: true,
                autofocus: true,
                theme: "neat epiphany"
            }, $scope.options, {
                lineNumbers: false
            }); // Create the editor, extending the default settings
            var editor = _codemirror.fromTextArea($element.children()[0], options);
            ngModel.$render = function() {
                // Wrap in a timeout, b/c Code Mirror is weird
                setTimeout(function() {
                    // Set the editor value to the model's value
                    editor.setValue(ngModel.$modelValue); // Turn on line numbers by default, else, use the options passed in
                    editor.setOption("lineNumbers", "lineNumbers" in $scope.options ? $scope.options.lineNumbers : true);
                    $scope.$emit("codeMirrorReady");
                    editor.focus();
                });
            }; // On change, set the model to the editor's value
            editor.on("change", function(event) {
                ngModel.$setViewValue(event.getValue());
            });
            editor.on("blur", $scope.onBlur); // Add a fullscreen toggle button
            var fullscreen = document.createElement("span");
            fullscreen.className = "re-icon redactor-btn-image re-fullscreen";
            fullscreen.onclick = function() {
                editor.setOption("fullScreen", !editor.getOption("fullScreen"));
                $(this).toggleClass("re-fullscreen re-normalscreen");
            };
            $element.children(".CodeMirror").prepend(fullscreen);
        }
    };
});
_codemirror.defineMode("cartocss", function(config, parserConfig) {
    var cartoOverlay = {
        token: function(stream, state) {
            let rgb = /\([0-9]{1,3},\s?[0-9]{1,3},\s?[0-9]{1,3}(,\s?(0\.[0-9]{1,3}|1))?\)/;
            let hex = /#([0-9A-Fa-f]{3}){1,2}/;
            let ch = stream.peek(); // Match hex, but not css ids
            if (ch == "#" && stream.match(/#/, false)) {
                stream.eat(/#/);
                stream.match(/(?!.*\s*{)([0-9A-Fa-f]{1,6})/, true);
                if (stream.current().length > 1 || stream.eol() || stream.match(";", false)) return "atom color";
            }
            if (ch == "r" && stream.match(/rgb(a)?/, true)) {
                stream.match(rgb, true);
                return "atom color";
            }
            if (stream.match("setMarker(")) {
                stream.backUp(1);
                this.markerState = [
                    stream.current()
                ];
                return "atom marker";
            }
            if (ch == "(" && this.markerState) {
                stream.next();
                this.markerState.push("(");
                return null;
            }
            if (this.markerState && this.markerState.length == 2 && this.markerState.join("") == "setMarker(") {
                stream.match(/(.*)(?:\))/, true);
                stream.backUp(1);
                this.markerState = null;
                return "string markerUrl";
            }
            if (stream.next() == null) return null;
        }
    };
    return _codemirror.overlayMode(_codemirror.getMode(config, parserConfig.backdrop || "css"), cartoOverlay);
});

},{"codemirror":"akde7","../../../node_modules/codemirror/addon/hint/show-hint":"fz9SD","../../../node_modules/codemirror/addon/hint/sql-hint":"hrRDs","../../../node_modules/codemirror/addon/mode/overlay":"8ZPxM","../../../node_modules/codemirror/mode/sql/sql":"j5YpV","../../../node_modules/codemirror/mode/css/css":"9B1o7","../../../node_modules/codemirror/addon/display/fullscreen":"6mnLj"}],"akde7":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\//.test(userAgent);
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) presto_version = Number(presto_version[1]);
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count)e.removeChild(e.firstChild);
        return e;
    }
    function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) e.className = className;
        if (style) e.style.cssText = style;
        if (typeof content == "string") e.appendChild(document.createTextNode(content));
        else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
        return e;
    }
    // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    }
    var range;
    if (document.createRange) range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
    };
    else range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
            r.moveToElementText(node.parentNode);
        } catch (e) {
            return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
    };
    function contains(parent, child) {
        if (child.nodeType == 3) child = child.parentNode;
        if (parent.contains) return parent.contains(child);
        do {
            if (child.nodeType == 11) child = child.host;
            if (child == parent) return true;
        }while (child = child.parentNode);
    }
    function activeElt() {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var activeElement;
        try {
            activeElement = document.activeElement;
        } catch (e) {
            activeElement = document.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)activeElement = activeElement.shadowRoot.activeElement;
        return activeElement;
    }
    function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
    }
    function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++)if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
        return b;
    }
    var selectInput = function(node) {
        node.select();
    };
    if (ios) selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
    };
    else if (ie) selectInput = function(node) {
        try {
            node.select();
        } catch (_e) {}
    };
    function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    }
    function copyObj(obj, target, overwrite) {
        if (!target) target = {};
        for(var prop in obj)if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) target[prop] = obj[prop];
        return target;
    }
    // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) end = string.length;
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("	", i);
            if (nextTab < 0 || nextTab >= end) return n + (end - i);
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    }
    var Delayed = function() {
        this.id = null;
        this.f = null;
        this.time = 0;
        this.handler = bind(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self) {
        self.id = 0;
        if (self.time <= +new Date) self.f();
        else setTimeout(self.handler, self.time - +new Date);
    };
    Delayed.prototype.set = function(ms, f) {
        this.f = f;
        var time = +new Date + ms;
        if (!this.id || time < this.time) {
            clearTimeout(this.id);
            this.id = setTimeout(this.handler, ms);
            this.time = time;
        }
    };
    function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) return i;
        }
        return -1;
    }
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 50;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("	", pos);
            if (nextTab == -1) nextTab = string.length;
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) return pos + Math.min(skipped, goal - col);
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) return pos;
        }
    }
    var spaceStrs = [
        ""
    ];
    function spaceStr(n) {
        while(spaceStrs.length <= n)spaceStrs.push(lst(spaceStrs) + " ");
        return spaceStrs[n];
    }
    function lst(arr) {
        return arr[arr.length - 1];
    }
    function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = f(array[i], i);
        return out;
    }
    function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority)pos++;
        array.splice(pos, 0, value);
    }
    function nothing() {}
    function createObj(base, props) {
        var inst;
        if (Object.create) inst = Object.create(base);
        else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) copyObj(props, inst);
        return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
        if (!helper) return isWordCharBasic(ch);
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
        return helper.test(ch);
    }
    function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) return false;
        }
        return true;
    }
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos)))pos += dir;
        return pos;
    }
    // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) return from;
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) return pred(mid) ? from : to;
            if (pred(mid)) to = mid;
            else from = mid + dir;
        }
    }
    // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) return f(from, to, "ltr", 0);
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) f(from, to, "ltr");
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) return i;
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") found = i;
                else bidiOther = i;
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") found = i;
                else bidiOther = i;
            }
        }
        return found != null ? found : bidiOther;
    }
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function charType(code) {
            if (code <= 0xf7) return lowTypes.charAt(code);
            else if (0x590 <= code && code <= 0x5f4) return "R";
            else if (0x600 <= code && code <= 0x6f9) return arabicTypes.charAt(code - 0x600);
            else if (0x6ee <= code && code <= 0x8ac) return "r";
            else if (0x2000 <= code && code <= 0x200b) return "w";
            else if (code == 0x200c) return "b";
            else return "L";
        }
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        }
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) return false;
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i)types.push(charType(str.charCodeAt(i)));
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") types[i$1] = prev;
                else prev = type;
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") types[i$2] = "n";
                else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") types[i$2] = "R";
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") types[i$3] = "1";
                else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) types[i$3] = prev$1;
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") types[i$4] = "N";
                else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end);
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j)types[j] = replace;
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") types[i$5] = "L";
                else if (isStrong.test(type$4)) cur$1 = type$4;
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6)if (isNeutral.test(types[i$6])) {
                var end$1 = void 0;
                for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1);
                var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                var after = (end$1 < len ? types[end$1] : outerType) == "L";
                var replace$1 = before == after ? before ? "L" : "R" : outerType;
                for(var j$1 = i$6; j$1 < end$1; ++j$1)types[j$1] = replace$1;
                i$6 = end$1 - 1;
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;)if (countsAsLeft.test(types[i$7])) {
                var start = i$7;
                for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7);
                order.push(new BidiSpan(0, start, i$7));
            } else {
                var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
                for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7);
                for(var j$2 = pos; j$2 < i$7;)if (countsAsNum.test(types[j$2])) {
                    if (pos < j$2) {
                        order.splice(at, 0, new BidiSpan(1, pos, j$2));
                        at += isRTL;
                    }
                    var nstart = j$2;
                    for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2);
                    order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                    at += isRTL;
                    pos = j$2;
                } else ++j$2;
                if (pos < i$7) order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) order = line.order = bidiOrdering(line.text, direction);
        return order;
    }
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function(emitter, type, f) {
        if (emitter.addEventListener) emitter.addEventListener(type, f, false);
        else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
        else {
            var map = emitter._handlers || (emitter._handlers = {});
            map[type] = (map[type] || noHandlers).concat(f);
        }
    };
    function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off(emitter, type, f) {
        if (emitter.removeEventListener) emitter.removeEventListener(type, f, false);
        else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
        else {
            var map = emitter._handlers, arr = map && map[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
            }
        }
    }
    function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) return;
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i)handlers[i].apply(null, args);
    }
    // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") e = {
            type: e,
            preventDefault: function() {
                this.defaultPrevented = true;
            }
        };
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) return;
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i)if (indexOf(set, arr[i]) == -1) set.push(arr[i]);
    }
    function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    }
    // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    }
    // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function e_stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    }
    function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    }
    function e_target(e) {
        return e.target || e.srcElement;
    }
    function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) b = 1;
            else if (e.button & 2) b = 3;
            else if (e.button & 4) b = 2;
        }
        if (mac && e.ctrlKey && b == 1) b = 3;
        return b;
    }
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) return false;
        var div = elt("div");
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "​");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
        var node = zwspSupported ? elt("span", "​") : elt("span", "\xa0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    }
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    function hasBadBidiRects(measure) {
        if (badBidiRects != null) return badBidiRects;
        var txt = removeChildrenAndAdd(measure, document.createTextNode("AخA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) return false;
         // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    }
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) nl = string.length;
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range;
        try {
            range = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range || range.parentElement() != te) return false;
        return range.compareEndPoints("StartToEnd", range) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) return true;
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) return badZoomedRects;
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) mode.dependencies = Array.prototype.slice.call(arguments, 2);
        modes[name] = mode;
    }
    function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    }
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) spec = mimeModes[spec];
        else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") found = {
                name: found
            };
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) return resolveMode("application/xml");
        else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) return resolveMode("application/json");
        if (typeof spec == "string") return {
            name: spec
        };
        else return spec || {
            name: "null"
        };
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) return getMode(options, "text/plain");
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) continue;
                if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) modeObj.helperType = spec.helperType;
        if (spec.modeProps) for(var prop$1 in spec.modeProps)modeObj[prop$1] = spec.modeProps[prop$1];
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    }
    function copyState(mode, state) {
        if (state === true) return state;
        if (mode.copyState) return mode.copyState(state);
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (val instanceof Array) val = val.concat([]);
            nstate[n] = val;
        }
        return nstate;
    }
    // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) break;
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    }
    function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    }
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match.test ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
        var chunk = doc;
        while(!chunk.lines)for(var i = 0;; ++i){
            var child = chunk.children[i], sz = child.chunkSize();
            if (n < sz) {
                chunk = child;
                break;
            }
            n -= sz;
        }
        return chunk.lines[n];
    }
    // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) text = text.slice(0, end.ch);
            if (n == start.line) text = text.slice(start.ch);
            out.push(text);
            ++n;
        });
        return out;
    }
    // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    }
    // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) for(var n = line; n; n = n.parent)n.height += diff;
    }
    // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) return null;
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent)for(var i = 0;; ++i){
            if (chunk.children[i] == cur) break;
            no += chunk.children[i].chunkSize();
        }
        return no + cur.first;
    }
    // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) break;
            h -= lh;
        }
        return n + i;
    }
    function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    }
    function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    }
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!(this instanceof Pos)) return new Pos(line, ch, sticky);
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
        return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    }
    function clipPos(doc, pos) {
        if (pos.line < doc.first) return Pos(doc.first, 0);
        var last = doc.first + doc.size - 1;
        if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) return Pos(pos.line, linelen);
        else if (ch < 0) return Pos(pos.line, 0);
        else return pos;
    }
    function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = clipPos(doc, array[i]);
        return out;
    }
    var SavedContext = function(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) this.maxLookAhead = n;
        return line;
    };
    Context.prototype.baseToken = function(n) {
        if (!this.baseTokens) return null;
        while(this.baseTokens[this.baseTokenPos] <= n)this.baseTokenPos += 2;
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) this.maxLookAhead--;
    };
    Context.fromSaved = function(doc, saved, line) {
        if (saved instanceof SavedContext) return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        else return new Context(doc, copyState(doc.mode, saved), line);
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) st.splice(i, 1, end, st[i + 1], i_end);
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) return;
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else for(; start < i; start += 2){
                    var cur = st[start + 1];
                    st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    }
    function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) context.state = resetState;
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) line.styleClasses = result.classes;
            else if (line.styleClasses) line.styleClasses = null;
            if (updateFrontier === cm.doc.highlightFrontier) cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
        return line.styles;
    }
    function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) return new Context(doc, true, n);
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) doc.modeFrontier = context.line;
        return context;
    }
    // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") callBlankLine(mode, context.state);
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    }
    function callBlankLine(mode, state) {
        if (mode.blankLine) return mode.blankLine(state);
        if (!mode.innerMode) return;
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
    }
    function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) inner[0] = innerMode(mode, state).mode;
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) return style;
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) tokens = [];
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
        if (type) for(;;){
            var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!lineClass) break;
            type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
            var prop = lineClass[1] ? "bgClass" : "textClass";
            if (output[prop] == null) output[prop] = lineClass[2];
            else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) output[prop] += " " + lineClass[2];
        }
        return type;
    }
    // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) processLine(cm, text, context, stream.pos);
                stream.pos = text.length;
                style = null;
            } else style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            if (inner) {
                var mName = inner[0].name;
                if (mName) style = "m-" + (style ? mName + " " + style : mName);
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    }
    // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) return doc.first;
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) return search;
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    }
    function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) return;
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    }
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    }
    // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    }
    // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.marker == marker) return span;
        }
    }
    // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i)if (spans[i] != span) (r || (r = [])).push(spans[i]);
        return r;
    }
    // Add a span to a line.
    function addMarkedSpan(line, span, op) {
        var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
        if (inThisOp && inThisOp.has(line.markedSpans)) line.markedSpans.push(span);
        else {
            line.markedSpans = line.markedSpans ? line.markedSpans.concat([
                span
            ]) : [
                span
            ];
            if (inThisOp) inThisOp.add(line.markedSpans);
        }
        span.marker.attachLine(line);
    }
    // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
            if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
            }
        }
        return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
            if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
            }
        }
        return nw;
    }
    // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) return null;
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) return null;
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) // Fix up .to properties of first
        for(var i = 0; i < first.length; ++i){
            var span = first[i];
            if (span.to == null) {
                var found = getMarkedSpanFor(last, span.marker);
                if (!found) span.to = startCh;
                else if (sameLine) span.to = found.to == null ? null : found.to + offset;
            }
        }
        if (last) // Fix up .from in last (or move them into first in case of sameLine)
        for(var i$1 = 0; i$1 < last.length; ++i$1){
            var span$1 = last[i$1];
            if (span$1.to != null) span$1.to += offset;
            if (span$1.from == null) {
                var found$1 = getMarkedSpanFor(first, span$1.marker);
                if (!found$1) {
                    span$1.from = offset;
                    if (sameLine) (first || (first = [])).push(span$1);
                }
            } else {
                span$1.from += offset;
                if (sameLine) (first || (first = [])).push(span$1);
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) first = clearEmptySpans(first);
        if (last && last != first) last = clearEmptySpans(last);
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2)if (first[i$2].to == null) (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
            }
            for(var i$3 = 0; i$3 < gap; ++i$3)newMarkers.push(gapMarkers);
            newMarkers.push(last);
        }
        return newMarkers;
    }
    // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) spans.splice(i--, 1);
        }
        if (!spans.length) return null;
        return spans;
    }
    // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
                var mark = line.markedSpans[i].marker;
                if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) (markers || (markers = [])).push(mark);
            }
        });
        if (!markers) return null;
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) newParts.push({
                    from: p.from,
                    to: m.from
                });
                if (dto > 0 || !mk.inclusiveRight && !dto) newParts.push({
                    from: m.to,
                    to: p.to
                });
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    }
    // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.detachLine(line);
        line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.attachLine(line);
        line.markedSpans = spans;
    }
    // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    }
    // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) return lenDiff;
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) return -fromCmp;
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) return toCmp;
        return b.id - a.id;
    }
    // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
        var line = getLine(doc, lineNo);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (!sp.marker.collapsed) continue;
            var found = sp.marker.find(0);
            var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
            var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
            if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
            if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) return true;
        }
    }
    // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line))line = merged.find(-1, true).line;
        return line;
    }
    function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return line;
    }
    // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    }
    // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) return lineN;
        return lineNo(vis);
    }
    // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) return lineN;
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) return lineN;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return lineNo(line) + 1;
    }
    // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (!sp.marker.collapsed) continue;
            if (sp.from == null) return true;
            if (sp.marker.widgetNode) continue;
            if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) return true;
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) break;
            else h += line.height;
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent)for(var i$1 = 0; i$1 < p.children.length; ++i$1){
            var cur = p.children[i$1];
            if (cur == chunk) break;
            else h += cur.height;
        }
        return h;
    }
    // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) return 0;
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    }
    // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) line.stateAfter = null;
        if (line.styles) line.styles = null;
        if (line.order != null) line.order = null;
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) updateLineHeight(line, estHeight);
    }
    // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    }
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) return null;
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    }
    // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) builder.addToken = buildTokenBadBidi(builder.addToken, order);
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                if (line.styleClasses.textClass) builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) builder.content.className = "cm-tab-wrap-hack";
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "•", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    }
    // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) return;
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) mustWrap = true;
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt
                    ]));
                    else content.appendChild(txt);
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) break;
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "	") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "	");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "␍" : "␤", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt$1
                    ]));
                    else content.appendChild(txt$1);
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css || attributes) {
            var fullStyle = style || "";
            if (startStyle) fullStyle += startStyle;
            if (endStyle) fullStyle += endStyle;
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes)if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") token.setAttribute(attr, attributes[attr]);
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    }
    // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) return text;
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) ch = "\xa0";
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    }
    // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) break;
                }
                if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, css, attributes);
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) widget = builder.content.appendChild(document.createElement("span"));
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    }
    // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2)builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) foundBookmarks.push(m);
                    else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) spanStyle += " " + m.className;
                        if (m.css) css = (css ? css + ";" : "") + m.css;
                        if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
                        if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) (attributes || (attributes = {})).title = m.title;
                        if (m.attributes) for(var attr in m.attributes)(attributes || (attributes = {}))[attr] = m.attributes[attr];
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) collapsed = sp;
                    } else if (sp.from > pos && nextChange > sp.from) nextChange = sp.from;
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2)if (endStyles[j$1 + 1] == nextChange) spanEndStyle += " " + endStyles[j$1];
                }
                if (!collapsed || collapsed.from == pos) for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) return;
                    if (collapsed.to == pos) collapsed = false;
                }
            }
            if (pos >= len) break;
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    }
    // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    }
    // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
        if (operationGroup) operationGroup.ops.push(op);
        else op.ownsGroup = operationGroup = {
            ops: [
                op
            ],
            delayedCallbacks: []
        };
    }
    function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++)callbacks[i].call(null);
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) while(op.cursorActivityCalled < op.cursorActivityHandlers.length)op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
        }while (i < callbacks.length);
    }
    function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) return;
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    }
    var orphanDelayedCallbacks = null;
    // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) return;
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) list = operationGroup.delayedCallbacks;
        else if (orphanDelayedCallbacks) list = orphanDelayedCallbacks;
        else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    }
    function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i)delayed[i]();
    }
    // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") updateLineText(cm, lineView);
            else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
            else if (type == "class") updateLineClasses(cm, lineView);
            else if (type == "widget") updateLineWidgets(cm, lineView, dims);
        }
        lineView.changes = null;
    }
    // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
        }
        return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) cls += " CodeMirror-linebackground";
        if (lineView.background) {
            if (cls) lineView.background.className = cls;
            else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    }
    // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    }
    // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) lineView.node = built.pre;
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) lineView.text.className = cls;
    }
    function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        else if (lineView.node != lineView.text) lineView.node.className = "";
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            gutterWrap.setAttribute("aria-hidden", "true");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) gutterWrap.className += " " + lineView.line.gutterClass;
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            if (markers) for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                if (found) gutterWrap.appendChild(elt("div", [
                    found
                ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
            }
        }
    }
    function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) lineView.alignable = null;
        var isWidget = classTest("CodeMirror-linewidget");
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (isWidget.test(node.className)) lineView.node.removeChild(node);
        }
        insertLineWidgets(cm, lineView, dims);
    }
    // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) lineView.bgClass = built.bgClass;
        if (built.textClass) lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    }
    // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) return;
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
            if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) wrap.insertBefore(node, lineView.gutter || lineView.text);
            else wrap.appendChild(node);
            signalLater(widget, "redraw");
        }
    }
    function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
    }
    function widgetHeight(widget) {
        if (widget.height != null) return widget.height;
        var cm = widget.doc.cm;
        if (!cm) return 0;
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            if (widget.noHScroll) parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    }
    // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) return true;
        }
    }
    // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
        if (display.cachedPaddingH) return display.cachedPaddingH;
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
        return data;
    }
    function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) heights.push((cur.bottom + next.top) / 2 - rect.top);
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    }
    // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) return {
            map: lineView.measure.map,
            cache: lineView.measure.cache
        };
        for(var i = 0; i < lineView.rest.length; i++){
            if (lineView.rest[i] == line) return {
                map: lineView.measure.maps[i],
                cache: lineView.measure.caches[i]
            };
        }
        for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
            if (lineNo(lineView.rest[i$1]) > lineN) return {
                map: lineView.measure.maps[i$1],
                cache: lineView.measure.caches[i$1],
                before: true
            };
        }
    }
    // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    }
    // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) return cm.display.view[findViewIndex(cm, lineN)];
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) return ext;
    }
    // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) view = null;
        else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) view = updateExternalMeasurement(cm, line);
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    }
    // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) ch = -1;
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) found = prepared.cache[key];
        else {
            if (!prepared.rect) prepared.rect = prepared.view.text.getBoundingClientRect();
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) prepared.cache[key] = found;
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    }
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    function nodeAndOffsetInLineMap(map, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map.length; i += 3){
            mStart = map[i];
            mEnd = map[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) collapse = "right";
            }
            if (start != null) {
                node = map[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) collapse = bias;
                if (bias == "left" && start == 0) while(i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft){
                    node = map[(i -= 3) + 2];
                    collapse = "left";
                }
                if (bias == "right" && start == mEnd - mStart) while(i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft){
                    node = map[(i += 3) + 2];
                    collapse = "right";
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    }
    function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") for(var i = 0; i < rects.length; i++){
            if ((rect = rects[i]).left != rect.right) break;
        }
        else for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
            if ((rect = rects[i$1]).left != rect.right) break;
        }
        return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start)))--start;
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end)))++end;
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) rect = node.parentNode.getBoundingClientRect();
                else rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                if (rect.left || rect.right || start == 0) break;
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        } else {
            if (start > 0) collapse = bias = "right";
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) rect = rects[bias == "right" ? rects.length - 1 : 0];
            else rect = node.getBoundingClientRect();
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) rect = {
                left: rSpan.left,
                right: rSpan.left + charWidth(cm.display),
                top: rSpan.top,
                bottom: rSpan.bottom
            };
            else rect = nullRect;
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) break;
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) result.bogus = true;
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    }
    // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) return rect;
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    }
    function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)lineView.measure.caches[i] = {};
        }
    }
    function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++)clearLineMeasurementCacheFor(cm.display.view[i]);
    }
    function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
        cm.display.lineNumChars = null;
    }
    function pageScrollX() {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft));
        return window.pageXOffset || (document.documentElement || document.body).scrollLeft;
    }
    function pageScrollY() {
        if (chrome && android) return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop));
        return window.pageYOffset || (document.documentElement || document.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
        var height = 0;
        if (lineObj.widgets) {
            for(var i = 0; i < lineObj.widgets.length; ++i)if (lineObj.widgets[i].above) height += widgetHeight(lineObj.widgets[i]);
        }
        return height;
    }
    // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") return rect;
        if (!context) context = "local";
        var yOff = heightAtLine(lineObj);
        if (context == "local") yOff += paddingTop(cm.display);
        else yOff -= cm.display.viewOffset;
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    }
    // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") return coords;
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX();
            top -= pageScrollY();
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) lineObj = getLine(cm.doc, pos.line);
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) m.left = m.right;
            else m.right = m.left;
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) val.other = getBidi(ch, other, sticky != "before");
        return val;
    }
    // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    }
    // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) pos.outside = outside;
        return pos;
    }
    // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) return PosWithInfo(doc.first, 0, null, -1, -1);
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        if (x < 0) x = 0;
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) return found;
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) return rangeEnd;
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight;
            box.bottom += widgetHeight;
            if (!boxIsAfter(box, x, y, false)) return false;
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) ch++;
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) part = order[index - 1];
        }
        return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) end--;
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) continue;
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) part = order[order.length - 1];
        // Clip the part to the wrapped line.
        if (part.from < begin) part = {
            from: begin,
            to: part.to,
            level: part.level
        };
        if (part.to > end) part = {
            from: part.from,
            to: end,
            level: part.level
        };
        return part;
    }
    var measureText;
    // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) return display.cachedTextHeight;
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) display.cachedTextHeight = height;
        removeChildren(display.measure);
        return height || 1;
    }
    // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) return display.cachedCharWidth;
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) display.cachedCharWidth = width;
        return width || 10;
    }
    // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    }
    // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) return 0;
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
            }
            if (wrapping) return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            else return widgetsHeight + th;
        };
    }
    function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) updateLineHeight(line, estHeight);
        });
    }
    // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e$1) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    }
    // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) return null;
        n -= cm.display.viewFrom;
        if (n < 0) return null;
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) return i;
        }
    }
    // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) from = cm.doc.first;
        if (to == null) to = cm.doc.first + cm.doc.size;
        if (!lendiff) lendiff = 0;
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) display.updateLineNumbers = from;
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) resetView(cm);
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) resetView(cm);
            else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) resetView(cm);
        else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else resetView(cm);
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else resetView(cm);
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else resetView(cm);
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) ext.lineN += lendiff;
            else if (from < ext.lineN + ext.size) display.externalMeasured = null;
        }
    }
    // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) display.externalMeasured = null;
        if (line < display.viewFrom || line >= display.viewTo) return;
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) return;
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) arr.push(type);
    }
    // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) return {
            index: index,
            lineN: newN
        };
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++)n += view[i].size;
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) return null;
                diff = n + view[index].size - oldN;
                index++;
            } else diff = n - oldN;
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) return null;
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    }
    // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            else if (display.viewFrom < from) display.view = display.view.slice(findViewIndex(cm, from));
            display.viewFrom = from;
            if (display.viewTo < to) display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            else if (display.viewTo > to) display.view = display.view.slice(0, findViewIndex(cm, to));
        }
        display.viewTo = to;
    }
    // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
        }
        return dirty;
    }
    function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) continue;
            var range = doc.sel.ranges[i];
            if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) continue;
            var collapsed = range.empty();
            if (collapsed || cm.options.showCursorWhenSelecting) drawSelectionCursor(cm, range.head, curFragment);
            if (!collapsed) drawSelectionRange(cm, range, selFragment);
        }
        return result;
    }
    // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    }
    function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    }
    // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) top = 0;
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) add(leftSide, fromPos.bottom, null, toPos.top);
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) start = fromPos;
                if (cmpCoords(toPos, start) < 0) start = toPos;
                if (!end || cmpCoords(fromPos, end) < 0) end = fromPos;
                if (cmpCoords(toPos, end) < 0) end = toPos;
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range.from(), sTo = range.to();
        if (sFrom.line == sTo.line) drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
            }
            if (leftEnd.bottom < rightStart.top) add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
        output.appendChild(fragment);
    }
    // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) return;
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) display.blinker = setInterval(function() {
            if (!cm.hasFocus()) onBlur(cm);
            display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
        else if (cm.options.cursorBlinkRate < 0) display.cursorDiv.style.visibility = "hidden";
    }
    function ensureFocus(cm) {
        if (!cm.hasFocus()) {
            cm.display.input.focus();
            if (!cm.state.focused) onFocus(cm);
        }
    }
    function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                if (cm.state.focused) onBlur(cm);
            }
        }, 100);
    }
    function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent && !cm.state.draggingText) cm.state.delayingBlurEvent = false;
        if (cm.options.readOnly == "nocursor") return;
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) setTimeout(function() {
                    return cm.display.input.reset(true);
                }, 20);
                 // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    }
    function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) return;
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) cm.display.shift = false;
        }, 150);
    }
    // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) continue;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -0.005) {
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) for(var j = 0; j < cur.rest.length; j++)updateWidgetHeight(cur.rest[j]);
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
    }
    // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) for(var i = 0; i < line.widgets.length; ++i){
            var w = line.widgets[i], parent = w.node.parentNode;
            if (parent) w.height = parent.offsetHeight;
        }
    }
    // Compute the lines that are visible in a given viewport (defaults
    // the the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    }
    // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        if (rect.top + box.top < 0) doScroll = true;
        else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) doScroll = false;
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "​", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    }
    // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) margin = 0;
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
            }
            if (!changed) break;
        }
        return rect;
    }
    // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) updateScrollTop(cm, scrollPos.scrollTop);
        if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
    }
    // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) rect.top = 0;
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) rect.bottom = rect.top + screen1;
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) result.scrollTop = atTop ? 0 : rect.top;
        else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) result.scrollTop = newTop;
        }
        var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
        var screenw = displayWidth(cm) - display.gutters.offsetWidth;
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) rect.right = rect.left + screenw;
        if (rect.left < 10) result.scrollLeft = 0;
        else if (rect.left < screenleft) result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
        else if (rect.right > screenw + screenleft - 3) result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        return result;
    }
    // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) return;
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    }
    function scrollToCoords(cm, x, y) {
        if (x != null || y != null) resolveScrollToPos(cm);
        if (x != null) cm.curOp.scrollLeft = x;
        if (y != null) cm.curOp.scrollTop = y;
    }
    function scrollToRange(cm, range) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range;
    }
    // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range = cm.curOp.scrollToPos;
        if (range) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
            scrollToCoordsRange(cm, from, to, range.margin);
        }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) return;
        if (!gecko) updateDisplaySimple(cm, {
            top: val
        });
        setScrollTop(cm, val, true);
        if (gecko) updateDisplaySimple(cm);
        startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
        val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
        if (cm.display.scroller.scrollTop == val && !forceScroll) return;
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
    }
    // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) return;
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
        cm.display.scrollbars.setScrollLeft(val);
    }
    // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    }
    var NativeScrollbars = function(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) this.zeroWidthHack();
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
        if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
        if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.pointerEvents = "auto";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt != bar) bar.style.pointerEvents = "none";
            else delay.set(1000, maybeDisable);
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    function updateScrollbars(cm, measure) {
        if (!measure) measure = measureForScrollbars(cm);
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) updateHeightsInViewport(cm);
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    }
    // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else d.scrollbarFiller.style.display = "";
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else d.gutterFiller.style.display = "";
    }
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) setTimeout(function() {
                    return cm.display.input.focus();
                }, 0);
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") setScrollLeft(cm, pos);
            else updateScrollTop(cm, pos);
        }, cm);
        if (cm.display.scrollbars.addClass) addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
    }
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId,
            markArrays: null // Used by addMarkedSpan
        };
        pushOperation(cm.curOp);
    }
    // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) finishOperation(op, function(group) {
            for(var i = 0; i < group.ops.length; i++)group.ops[i].cm.curOp = null;
            endOperations(group);
        });
    }
    // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++)endOperation_R1(ops[i]);
        for(var i$1 = 0; i$1 < ops.length; i$1++)endOperation_W1(ops[i$1]);
        for(var i$2 = 0; i$2 < ops.length; i$2++)endOperation_R2(ops[i$2]);
        for(var i$3 = 0; i$3 < ops.length; i$3++)endOperation_W2(ops[i$3]);
        for(var i$4 = 0; i$4 < ops.length; i$4++)endOperation_finish(ops[i$4]);
    }
    function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) findMaxLine(cm);
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    }
    function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) updateHeightsInViewport(cm);
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) op.preparedSelection = display.input.prepareSelection();
    }
    function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt();
        if (op.preparedSelection) cm.display.input.showSelection(op.preparedSelection, takeFocus);
        if (op.updatedDisplay || op.startHeight != cm.doc.height) updateScrollbars(cm, op.barMeasure);
        if (op.updatedDisplay) setDocumentHeight(cm, op.barMeasure);
        if (op.selectionChanged) restartBlink(cm);
        if (cm.state.focused && op.updateInput) cm.display.input.reset(op.typing);
        if (takeFocus) ensureFocus(op.cm);
    }
    function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) display.wheelStartX = display.wheelStartY = null;
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) setScrollTop(cm, op.scrollTop, op.forceScroll);
        if (op.scrollLeft != null) setScrollLeft(cm, op.scrollLeft, true, true);
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i)if (!hidden[i].lines.length) signal(hidden[i], "hide");
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1)if (unhidden[i$1].lines.length) signal(unhidden[i$1], "unhide");
        }
        if (display.wrapper.offsetHeight) doc.scrollTop = cm.display.scroller.scrollTop;
        // Fire change events, and delayed event handlers
        if (op.changeObjs) signal(cm, "changes", cm, op.changeObjs);
        if (op.update) op.update.finish();
    }
    // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) return f();
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    }
    // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) return f.apply(cm, arguments);
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) return f.apply(this, arguments);
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    }
    function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) return f.apply(this, arguments);
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) cm.state.highlight.set(time, bind(highlightWorker, cm));
    }
    function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) return;
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) context.state = resetState;
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) line.styleClasses = newCls;
                else if (oldCls) line.styleClasses = null;
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i)ischange = oldStyles[i] != line.styles[i];
                if (ischange) changedLines.push(context.line);
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) processLine(cm, line.text, context);
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) runInOp(cm, function() {
            for(var i = 0; i < changedLines.length; i++)regLineChange(cm, changedLines[i], "text");
        });
    }
    // DISPLAY DRAWING
    var DisplayUpdate = function(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) this.events.push(arguments);
    };
    DisplayUpdate.prototype.finish = function() {
        for(var i = 0; i < this.events.length; i++)signal.apply(null, this.events[i]);
    };
    function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    }
    function selectionSnapshot(cm) {
        if (cm.hasFocus()) return null;
        var active = activeElt();
        if (!active || !contains(cm.display.lineDiv, active)) return null;
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    }
    function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) return;
        snapshot.activeElt.focus();
        if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var sel = window.getSelection(), range = document.createRange();
            range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    }
    // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) return false;
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
        if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) return false;
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) display.lineDiv.style.display = "none";
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) display.lineDiv.style.display = "";
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    }
    function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) viewport = {
                    top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                };
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) break;
            } else if (first) update.visible = visibleLines(cm.display, cm.doc, viewport);
            if (!updateDisplayIfNeeded(cm, update)) break;
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    }
    function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    }
    // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) node.style.display = "none";
            else node.parentNode.removeChild(node);
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node)cur = rm(cur);
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur)cur = rm(cur);
    }
    function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
        // Send an event to consumers responding to changes in gutter width.
        signalLater(display, "gutterChanged", display);
    }
    function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++)if (!view[i].hidden) {
            if (cm.options.fixedGutter) {
                if (view[i].gutter) view[i].gutter.style.left = left;
                if (view[i].gutterBackground) view[i].gutterBackground.style.left = left;
            }
            var align = view[i].alignable;
            if (align) for(var j = 0; j < align.length; j++)align[j].style.left = left;
        }
        if (cm.options.fixedGutter) display.gutters.style.left = comp + gutterW + "px";
    }
    // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) return false;
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    }
    function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) continue;
                else sawLineNumbers = true;
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) result.push({
            className: "CodeMirror-linenumbers",
            style: null
        });
        return result;
    }
    // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) gElt.style.cssText = style;
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    }
    function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    }
    // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
        if (place) {
            if (place.appendChild) place.appendChild(d.wrapper);
            else place(d.wrapper);
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    }
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) wheelPixelsPerUnit = -0.53;
    else if (gecko) wheelPixelsPerUnit = 15;
    else if (chrome) wheelPixelsPerUnit = -0.7;
    else if (safari) wheelPixelsPerUnit = -1 / 3;
    function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
        else if (dy == null) dy = e.wheelDelta;
        return {
            x: dx,
            y: dy
        };
    }
    function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    }
    function onScrollWheel(cm, e) {
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) return;
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
            for(var i = 0; i < view.length; i++)if (view[i].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
            if (dy && canScrollY) updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit));
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) e_preventDefault(e);
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && wheelPixelsPerUnit != null) {
            var pixels = dy * wheelPixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) top = Math.max(0, top + pixels - 50);
            else bot = Math.min(cm.doc.height, bot + pixels + 50);
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) return;
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) return;
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        if (other == this) return true;
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
        for(var i = 0; i < this.ranges.length; i++){
            var here = this.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) return false;
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var out = [];
        for(var i = 0; i < this.ranges.length; i++)out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        for(var i = 0; i < this.ranges.length; i++){
            if (!this.ranges[i].empty()) return true;
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        if (!end) end = pos;
        for(var i = 0; i < this.ranges.length; i++){
            var range = this.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) return i;
        }
        return -1;
    };
    var Range = function(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) --primIndex;
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    }
    // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) return change.to;
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    }
    // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) return pos;
        if (cmp(pos, change.to) <= 0) return changeEnd(change);
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
        return Pos(line, ch);
    }
    function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
        if (pos.line == old.line) return Pos(nw.line, pos.ch - old.ch + nw.ch);
        else return Pos(nw.line + (pos.line - old.line), pos.ch);
    }
    // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else out[i] = new Range(from, from);
        }
        return new Selection(out, doc.sel.primIndex);
    }
    // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    }
    function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) line.stateAfter = null;
            if (line.styles) line.styles = null;
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) regChange(cm);
    }
    // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    }
    // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i)result.push(new Line(text[i], spansFor(i), estimateHeight));
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) doc.remove(from.line, nlines);
            if (added.length) doc.insert(from.line, added);
        } else if (firstLine == lastLine) {
            if (text.length == 1) update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    }
    // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) for(var i = 0; i < doc.linked.length; ++i){
                var rel = doc.linked[i];
                if (rel.doc == skip) continue;
                var shared = sharedHist && rel.sharedHist;
                if (sharedHistOnly && !shared) continue;
                f(rel.doc, shared);
                propagate(rel.doc, doc, shared);
            }
        }
        propagate(doc, null, true);
    }
    // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) throw new Error("This document is already in use.");
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        cm.options.direction = doc.direction;
        if (!cm.options.lineWrapping) findMaxLine(cm);
        cm.options.mode = doc.modeOption;
        regChange(cm);
    }
    function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    }
    function History(prev) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = prev ? prev.undoDepth : Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
    }
    // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    }
    // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) array.pop();
            else break;
        }
    }
    // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) return lst(hist.done);
        else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    }
    // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) // Optimized case for simple insertion -- don't want to add
            // new changesets for every character typed
            last.to = changeEnd(change);
            else // Add new sub-event
            cur.changes.push(historyChangeFromChange(doc, change));
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) pushSelectionToHistory(doc.sel, hist.done);
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) hist.done.shift();
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) signal(doc, "historyAdded");
    }
    function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    }
    // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) hist.done[hist.done.length - 1] = sel;
        else pushSelectionToHistory(sel, hist.done);
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) clearSelectionEvents(hist.undone);
    }
    function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) dest.push(sel);
    }
    // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            ++n;
        });
    }
    // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) return null;
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) out = spans.slice(0, i);
            } else if (out) out.push(spans[i]);
        }
        return !out ? spans : out.length ? out : null;
    }
    // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) return null;
        var nw = [];
        for(var i = 0; i < change.text.length; ++i)nw.push(removeClearedSpans(found[i]));
        return nw;
    }
    // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) return stretched;
        if (!stretched) return old;
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) spans: for(var j = 0; j < stretchCur.length; ++j){
                var span = stretchCur[j];
                for(var k = 0; k < oldCur.length; ++k){
                    if (oldCur[k].marker == span.marker) continue spans;
                }
                oldCur.push(span);
            }
            else if (stretchCur) old[i] = stretchCur;
        }
        return old;
    }
    // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) for(var prop in change){
                    if (m = prop.match(/^spans_(\d+)$/)) {
                        if (indexOf(newGroup, Number(m[1])) > -1) {
                            lst(newChanges)[prop] = change[prop];
                            delete change[prop];
                        }
                    }
                }
            }
        }
        return copy;
    }
    // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) head = other;
            }
            return new Range(anchor, head);
        } else return new Range(other || head, head);
    }
    // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) extend = doc.cm && (doc.cm.display.shift || doc.extend);
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    }
    // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++)out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    }
    // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    }
    // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    }
    // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function(ranges) {
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++)this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        if (obj.ranges != sel.ranges) return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        else return sel;
    }
    function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else setSelection(doc, sel, options);
    }
    // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) sel = filterSelectionChange(doc, sel, options);
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") ensureCursorVisible(doc.cm);
    }
    function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) return;
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    }
    // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    }
    // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) out = sel.ranges.slice(0, i);
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
            var sp = line.markedSpans[i], m = sp.marker;
            // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
            // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
            // is with selectLeft/Right
            var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
            var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
            if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                if (mayClear) {
                    signal(m, "beforeCursorEnter");
                    if (m.explicitlyCleared) {
                        if (!line.markedSpans) break;
                        else {
                            --i;
                            continue;
                        }
                    }
                }
                if (!m.atomic) continue;
                if (oldPos) {
                    var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                    if (dir < 0 ? preventCursorRight : preventCursorLeft) near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                    if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) return skipAtomicInner(doc, near, pos, dir, mayClear);
                }
                var far = m.find(dir < 0 ? -1 : 1);
                if (dir < 0 ? preventCursorLeft : preventCursorRight) far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
            }
        }
        return pos;
    }
    // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    }
    function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
            else return null;
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
            else return null;
        } else return new Pos(pos.line, pos.ch + dir);
    }
    function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function() {
                return obj.canceled = true;
            }
        };
        if (update) obj.update = function(from, to, text, origin) {
            if (from) obj.from = clipPos(doc, from);
            if (to) obj.to = clipPos(doc, to);
            if (text) obj.text = text;
            if (origin !== undefined) obj.origin = origin;
        };
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
        if (obj.canceled) {
            if (doc.cm) doc.cm.curOp.updateInput = 2;
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            if (doc.cm.state.suppressEdits) return;
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) return;
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) for(var i = split.length - 1; i >= 0; --i)makeChangeInner(doc, {
            from: split[i].from,
            to: split[i].to,
            text: i ? [
                ""
            ] : change.text,
            origin: change.origin
        });
        else makeChangeInner(doc, change);
    }
    function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    }
    // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) return;
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) break;
        }
        if (i == source.length) return;
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else break;
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) doc.cm.scrollIntoView({
                from: change.from,
                to: changeEnd(change)
            });
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    }
    // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) return;
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)regLineChange(doc.cm, l, "gutter");
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) return;
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) change = {
            from: change.from,
            to: Pos(last, getLine(doc, last).text.length),
            text: [
                change.text[0]
            ],
            origin: change.origin
        };
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) selAfter = computeSelAfterChange(doc, change);
        if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
        else updateDoc(doc, change, spans);
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) doc.cantEdit = false;
    }
    // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) signalCursorActivity(cm);
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) regChange(cm);
        else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) regLineChange(cm, from.line, "text");
        else regChange(cm, from.line, to.line + 1, lendiff);
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) signalLater(cm, "change", cm, obj);
            if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
        cm.display.selForContextMenu = null;
    }
    function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) to = from;
        if (cmp(to, from) < 0) assign = [
            to,
            from
        ], from = assign[0], to = assign[1];
        if (typeof code == "string") code = doc.splitLines(code);
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    }
    // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) pos.line += diff;
        else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    }
    // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    }
    function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    }
    // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
        else no = lineNo(handle);
        if (no == null) return null;
        if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
        return line;
    }
    // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this;
            height += lines[i].height;
        }
        this.height = height;
    }
    LeafChunk.prototype = {
        chunkSize: function() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(at, n) {
            for(var i = at, e = at + n; i < e; ++i){
                var line = this.lines[i];
                this.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(at, lines, height) {
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i)lines[i].parent = this;
        },
        // Used to iterate over a part of the tree.
        iterN: function(at, n, op) {
            for(var e = at + n; at < e; ++at){
                if (op(this.lines[at])) return true;
            }
        }
    };
    function BranchChunk(children) {
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    }
    BranchChunk.prototype = {
        chunkSize: function() {
            return this.size;
        },
        removeInner: function(at, n) {
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) break;
                    at = 0;
                } else at -= sz;
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function(lines) {
            for(var i = 0; i < this.children.length; ++i)this.children[i].collapse(lines);
        },
        insertInner: function(at, lines, height) {
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this.children.splice(++i, 0, leaf);
                            leaf.parent = this;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
            if (this.children.length <= 10) return;
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function(at, n, op) {
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) return true;
                    if ((n -= used) == 0) break;
                    at = 0;
                } else at -= sz;
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function(doc, node, options) {
        if (options) {
            for(var opt in options)if (options.hasOwnProperty(opt)) this[opt] = options[opt];
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) return;
        for(var i = 0; i < ws.length; ++i)if (ws[i] == this) ws.splice(i--, 1);
        if (!ws.length) line.widgets = null;
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) return;
        if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);
        if (cm) runInOp(cm, function() {
            cm.curOp.forceUpdate = true;
            adjustScrollWhenAboveVisible(cm, line, diff);
            signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
        });
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
    }
    function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) cm.display.alignWidgets = true;
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) widgets.push(widget);
            else widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) addToScrollTop(cm, widget.height);
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        return widget;
    }
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) startOperation(cm);
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) signalLater(this, "clear", found.from, found.to);
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (cm && !this.collapsed) regLineChange(cm, lineNo(line), "text");
            else if (cm) {
                if (span.to != null) max = lineNo(line);
                if (span.from != null) min = lineNo(line);
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) updateLineHeight(line, textHeight(cm.display));
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
            var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
            if (len > cm.display.maxLineLength) {
                cm.display.maxLine = visual;
                cm.display.maxLineLength = len;
                cm.display.maxLineChanged = true;
            }
        }
        if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) reCheckSelection(cm.doc);
        }
        if (cm) signalLater(cm, "markerCleared", cm, this, min, max);
        if (withOp) endOperation(cm);
        if (this.parent) this.parent.clear();
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        if (side == null && this.type == "bookmark") side = 1;
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) return from;
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) return to;
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) return;
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) updateLineHeight(line, line.height + dHeight);
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) return markTextShared(doc, from, to, options, type);
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) copyObj(options, marker, false);
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) return marker;
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
            if (options.insertLeft) marker.widgetNode.insertLeft = true;
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            seeCollapsedSpans();
        }
        if (marker.addToHistory) addChangeToHistory(doc, {
            from: from,
            to: to,
            origin: "markText"
        }, doc.sel, NaN);
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) updateMaxLine = true;
            if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
            if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
        });
        if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() {
            return marker.clear();
        });
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) doc.clearHistory();
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) cm.curOp.updateMaxLine = true;
            if (marker.collapsed) regChange(cm, from.line, to.line + 1);
            else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) for(var i = from.line; i <= to.line; i++)regLineChange(cm, i, "text");
            if (marker.atomic) reCheckSelection(cm.doc);
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function(markers, primary) {
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i)markers[i].parent = this;
    };
    SharedTextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i)this.markers[i].clear();
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) options.widgetNode = widget.cloneNode(true);
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) return;
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    }
    function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    }
    function detachSharedMarkers(markers) {
        var loop = function(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
        if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep, direction);
        if (firstLine == null) firstLine = 0;
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") text = this.splitLines(text);
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(from, to, op) {
            if (op) this.iterN(from - this.first, to - from, op);
            else this.iterN(this.first, this.first + this.size, from);
        },
        // Non-public interface for adding and removing lines.
        insert: function(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i)height += lines[i].height;
            this.insertInner(at - this.first, lines, height);
        },
        remove: function(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) scrollToCoords(this.cm, 0, 0);
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function(line) {
            if (isLine(this, line)) return getLine(this, line);
        },
        getLineNumber: function(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function(line) {
            if (typeof line == "number") line = getLine(this, line);
            return visualLine(line);
        },
        lineCount: function() {
            return this.size;
        },
        firstLine: function() {
            return this.first;
        },
        lastLine: function() {
            return this.first + this.size - 1;
        },
        clipPos: function(pos) {
            return clipPos(this, pos);
        },
        getCursor: function(start) {
            var range = this.sel.primary(), pos;
            if (start == null || start == "head") pos = range.head;
            else if (start == "anchor") pos = range.anchor;
            else if (start == "end" || start == "to" || start === false) pos = range.to();
            else pos = range.from();
            return pos;
        },
        listSelections: function() {
            return this.sel.ranges;
        },
        somethingSelected: function() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            if (!ranges.length) return;
            var out = [];
            for(var i = 0; i < ranges.length; i++)out[i] = new Range(clipPos(this, ranges[i].anchor), clipPos(this, ranges[i].head || ranges[i].anchor));
            if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function(lineSep) {
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) return lines;
            else return lines.join(lineSep || this.lineSeparator());
        },
        getSelections: function(lineSep) {
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) sel = sel.join(lineSep || this.lineSeparator());
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++)dup[i] = code;
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range = sel.ranges[i];
                changes[i] = {
                    from: range.from(),
                    to: range.to(),
                    text: this.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--)makeChange(this, changes[i$1]);
            if (newSel) setSelectionReplaceHistory(this, newSel);
            else if (this.cm) ensureCursorVisible(this.cm);
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function(val) {
            this.extend = val;
        },
        getExtending: function() {
            return this.extend;
        },
        historySize: function() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++)if (!hist.done[i].ranges) ++done;
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++)if (!hist.undone[i$1].ranges) ++undone;
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function() {
            var this$1 = this;
            this.history = new History(this.history);
            linkedDocs(this, function(doc) {
                return doc.history = this$1.history;
            }, true);
        },
        markClean: function() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function(forceSplit) {
            if (forceSplit) this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            return this.history.generation;
        },
        isClean: function(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function(histData) {
            var hist = this.history = new History(this.history);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) line.gutterMarkers = null;
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) changeLine(this$1, line, "gutter", function() {
                    line.gutterMarkers[gutterID] = null;
                    if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
                    return true;
                });
            });
        }),
        lineInfo: function(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) return null;
                n = line;
                line = getLine(this, line);
                if (!line) return null;
            } else {
                n = lineNo(line);
                if (n == null) return null;
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) line[prop] = cls;
                else if (classTest(cls).test(line[prop])) return false;
                else line[prop] += " " + cls;
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) return false;
                else if (cls == null) line[prop] = null;
                else {
                    var found = cur.match(classTest(cls));
                    if (!found) return false;
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function(widget) {
            widget.clear();
        },
        markText: function(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) markers.push(span.marker.parent || span.marker);
            }
            return markers;
        },
        findMarks: function(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) for(var i = 0; i < spans.length; i++){
                    var span = spans[i];
                    if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) found.push(span.marker.parent || span.marker);
                }
                ++lineNo;
            });
            return found;
        },
        getAllMarks: function() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i)if (sps[i].from != null) markers.push(sps[i].marker);
                }
            });
            return markers;
        },
        posFromIndex: function(off) {
            var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo;
            });
            return clipPos(this, Pos(lineNo, ch));
        },
        indexFromPos: function(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) return 0;
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function(options) {
            if (!options) options = {};
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) from = options.from;
            if (options.to != null && options.to < to) to = options.to;
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) copy.history = this.history;
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function(other) {
            if (other instanceof CodeMirror) other = other.doc;
            if (this.linked) for(var i = 0; i < this.linked.length; ++i){
                var link = this.linked[i];
                if (link.doc != other) continue;
                this.linked.splice(i, 1);
                other.unlinkDoc(this);
                detachSharedMarkers(findSharedMarkers(this));
                break;
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function(f) {
            linkedDocs(this, f);
        },
        getMode: function() {
            return this.mode;
        },
        getEditor: function() {
            return this.cm;
        },
        splitLines: function(str) {
            if (this.lineSep) return str.split(this.lineSep);
            return splitLinesAuto(str);
        },
        lineSeparator: function() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") dir = "ltr";
            if (dir == this.direction) return;
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) directionChanged(this.cm);
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e_preventDefault(e);
        if (ie) lastDrop = +new Date;
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) return;
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var markAsReadAndPasteIfAllFilesAreRead = function() {
                if (++read == n) operation(cm, function() {
                    pos = clipPos(cm.doc, pos);
                    var change = {
                        from: pos,
                        to: pos,
                        text: cm.doc.splitLines(text.filter(function(t) {
                            return t != null;
                        }).join(cm.doc.lineSeparator())),
                        origin: "paste"
                    };
                    makeChange(cm.doc, change);
                    setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
                })();
            };
            var readTextFromFile = function(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
                    markAsReadAndPasteIfAllFilesAreRead();
                    return;
                }
                var reader = new FileReader;
                reader.onerror = function() {
                    return markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.onload = function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
                        markAsReadAndPasteIfAllFilesAreRead();
                        return;
                    }
                    text[i] = content;
                    markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.readAsText(file);
            };
            for(var i = 0; i < files.length; i++)readTextFromFile(files[i], i);
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) selected = cm.listSelections();
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) for(var i$1 = 0; i$1 < selected.length; ++i$1)replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e$1) {}
        }
    }
    function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) img.parentNode.removeChild(img);
        }
    }
    function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) return;
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    }
    // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) return;
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) editors.push(cm);
        }
        if (editors.length) editors[0].operation(function() {
            for(var i = 0; i < editors.length; i++)f(editors[i]);
        });
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
        if (globalsRegistered) return;
        registerGlobalHandlers();
        globalsRegistered = true;
    }
    function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) resizeTimer = setTimeout(function() {
                resizeTimer = null;
                forEachCodeMirror(onResize);
            }, 100);
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    }
    // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    }
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++)keyNames[i + 48] = keyNames[i + 96] = String(i);
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++)keyNames[i$1] = String.fromCharCode(i$1);
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++)keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) name = "Alt-" + name;
        if (ctrl) name = "Ctrl-" + name;
        if (cmd) name = "Cmd-" + name;
        if (shift) name = "Shift-" + name;
        return name;
    }
    // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap)if (keymap.hasOwnProperty(keyname)) {
            var value = keymap[keyname];
            if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
            if (value == "...") {
                delete keymap[keyname];
                continue;
            }
            var keys = map(keyname.split(" "), normalizeKeyName);
            for(var i = 0; i < keys.length; i++){
                var val = void 0, name = void 0;
                if (i == keys.length - 1) {
                    name = keys.join(" ");
                    val = value;
                } else {
                    name = keys.slice(0, i + 1).join(" ");
                    val = "...";
                }
                var prev = copy[name];
                if (!prev) copy[name] = val;
                else if (prev != val) throw new Error("Inconsistent bindings for " + name);
            }
            delete keymap[keyname];
        }
        for(var prop in copy)keymap[prop] = copy[prop];
        return keymap;
    }
    function lookupKey(key, map, handle, context) {
        map = getKeyMap(map);
        var found = map.call ? map.call(key, context) : map[key];
        if (found === false) return "nothing";
        if (found === "...") return "multi";
        if (found != null && handle(found)) return "handled";
        if (map.fallthrough) {
            if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") return lookupKey(key, map.fallthrough, handle, context);
            for(var i = 0; i < map.fallthrough.length; i++){
                var result = lookupKey(key, map.fallthrough[i], handle, context);
                if (result) return result;
            }
        }
    }
    // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") name = "Alt-" + name;
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") name = "Cmd-" + name;
        if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
        return name;
    }
    // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) return false;
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) return false;
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) name = event.code;
        return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    }
    // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--)replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            ensureCursorVisible(cm);
        });
    }
    function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            if (cm.doc.direction == "rtl") dir = -dir;
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") ch = moveCharLogically(lineObj, ch, 1);
                } else ch = dir < 0 ? part.to : part.from;
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) return moveLogically(line, start, dir);
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
        // nothing interesting happens.
        return moveLogically(line, start, dir);
        var mv = function(pos, dir) {
            return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function(ch) {
            if (!cm.options.lineWrapping) return {
                begin: 0,
                end: line.text.length
            };
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function(partPos, dir, wrappedLineExtent) {
            var getRes = function(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) return getRes(ch, moveInStorageOrder);
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) return getRes(ch, moveInStorageOrder);
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) return res;
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) return res;
        }
        // Case 4: Nowhere to move
        return null;
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) return {
                        from: range.head,
                        to: Pos(range.head.line + 1, 0)
                    };
                    else return {
                        from: range.head,
                        to: Pos(range.head.line, len)
                    };
                } else return {
                    from: range.from(),
                    to: range.to()
                };
            });
        },
        deleteLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function(cm) {
            return cm.undo();
        },
        redo: function(cm) {
            return cm.redo();
        },
        undoSelection: function(cm) {
            return cm.undoSelection();
        },
        redoSelection: function(cm) {
            return cm.redoSelection();
        },
        goDocStart: function(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
                return pos;
            }, sel_move);
        },
        goLineUp: function(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function(cm) {
            return cm.deleteH(-1, "codepoint");
        },
        delCharAfter: function(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function(cm) {
            return cm.replaceSelection("	");
        },
        insertSoftTab: function(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function(cm) {
            if (cm.somethingSelected()) cm.indentSelection("add");
            else cm.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) continue;
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--)cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++)cm.indentLine(sels[i$1].from().line, null, true);
                ensureCursorVisible(cm);
            });
        },
        openLine: function(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function(cm) {
            return cm.toggleOverwrite();
        }
    };
    function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    }
    // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) return false;
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) cm.state.suppressEdits = true;
            if (dropShift) cm.display.shift = false;
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) return result;
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) return "handled";
            if (/\'$/.test(name)) cm.state.keySeq = null;
            else stopSeq.set(50, function() {
                if (cm.state.keySeq == seq) {
                    cm.state.keySeq = null;
                    cm.display.input.reset();
                }
            });
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) return true;
        }
        return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") cm.state.keySeq = name;
        if (result == "handled") signalLater(cm, "keyHandled", cm, name, e);
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    }
    // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) return false;
        if (e.shiftKey && !cm.state.keySeq) // First try to resolve full name (including 'Shift-'). Failing
        // that, see if there is a cursor-motion command (starting with
        // 'go') bound to the keyname without 'Shift-'.
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
            return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
            if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) return doHandleBinding(cm, b);
        });
        else return dispatchKey(cm, name, e, function(b) {
            return doHandleBinding(cm, b);
        });
    }
    // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        cm.curOp.focus = activeElt();
        if (signalDOMEvent(cm, e)) return;
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) cm.replaceSelection("", null, "cut");
        }
        if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) document.execCommand("cut");
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) showCrossHair(cm);
    }
    function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    }
    function onKeyUp(e) {
        if (e.keyCode == 16) this.doc.sel.shift = false;
        signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) return;
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\b") return;
        if (handleCharBinding(cm, e, ch)) return;
        cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    }
    // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) return;
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        window.focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) cm.state.selectingText(e);
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) return;
        if (button == 1) {
            if (pos) leftButtonDown(cm, pos, repeat, e);
            else if (e_target(e) == display.scroller) e_preventDefault(e);
        } else if (button == 2) {
            if (pos) extendSelection(cm.doc, pos);
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) cm.display.input.onContextMenu(e);
            else delayBlurEvent(cm);
        }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") name = "Double" + name;
        else if (repeat == "triple") name = "Triple" + name;
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") bound = commands[bound];
            if (!bound) return false;
            var done = false;
            try {
                if (cm.isReadOnly()) cm.state.suppressEdits = true;
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    }
    function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) value.extend = cm.doc.extend || event.shiftKey;
        if (value.addNew == null) value.addNew = mac ? event.metaKey : event.ctrlKey;
        if (value.moveOnDrag == null) value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
        if (ie) setTimeout(bind(ensureFocus, cm), 0);
        else cm.curOp.focus = activeElt();
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) leftButtonStartDrag(cm, event, pos, behavior);
        else leftButtonSelect(cm, event, pos, behavior);
    }
    // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) display.scroller.draggable = false;
            cm.state.draggingText = false;
            if (cm.state.delayingBlurEvent) {
                if (cm.hasFocus()) cm.state.delayingBlurEvent = false;
                else delayBlurEvent(cm);
            }
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) extendSelection(cm.doc, pos, null, null, behavior.extend);
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit && !safari || ie && ie_version == 9) setTimeout(function() {
                    display.wrapper.ownerDocument.body.focus({
                        preventScroll: true
                    });
                    display.input.focus();
                }, 20);
                else display.input.focus();
            }
        });
        var mouseMove = function(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) display.scroller.draggable = true;
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            return display.input.focus();
        }, 20);
        // IE's approach to draggable
        if (display.scroller.dragDrop) display.scroller.dragDrop();
    }
    function rangeForUnit(cm, pos, unit) {
        if (unit == "char") return new Range(pos, pos);
        if (unit == "word") return cm.findWordAt(pos);
        if (unit == "line") return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    }
    // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        if (ie) delayBlurEvent(cm);
        var display = cm.display, doc = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc.sel.contains(start);
            if (ourIndex > -1) ourRange = ranges[ourIndex];
            else ourRange = new Range(start, start);
        } else {
            ourRange = doc.sel.primary();
            ourIndex = doc.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) ourRange = new Range(start, start);
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
            else ourRange = range;
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc.sel;
        } else replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) return;
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    else if (text.length > leftPos) ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                }
                if (!ranges.length) ranges.push(new Range(start, start));
                setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range.anchor, anchor) > 0) {
                    head = range.head;
                    anchor = minPos(oldRange.from(), range.anchor);
                } else {
                    head = range.anchor;
                    anchor = maxPos(oldRange.to(), range.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
                setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) return;
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt();
                extendTo(cur);
                var visible = visibleLines(display, doc);
                if (cur.line >= visible.to || cur.line < visible.from) setTimeout(operation(cm, function() {
                    if (counter == curCount) extend(e);
                }), 150);
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) setTimeout(operation(cm, function() {
                    if (counter != curCount) return;
                    display.scroller.scrollTop += outside;
                    extend(e);
                }), 50);
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) done(e);
            else extend(e);
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    }
    // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range) {
        var anchor = range.anchor;
        var head = range.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) return range;
        var order = getOrder(anchorLine);
        if (!order) return range;
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) return range;
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) return range;
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) leftSide = dir < 0;
            else leftSide = dir > 0;
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else try {
            mX = e.clientX;
            mY = e.clientY;
        } catch (e$1) {
            return false;
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
        if (prevent) e_preventDefault(e);
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    }
    function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    }
    // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
        if (signalDOMEvent(cm, e, "contextmenu")) return;
        if (!captureRightClick) cm.display.input.onContextMenu(e);
    }
    function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) return false;
        return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    }
    var Init = {
        toString: function() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) optionHandlers[name] = notOnInit ? function(cm, val, old) {
                if (old != Init) handle(cm, val, old);
            } : handle;
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) return;
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) break;
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--)replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("	") ? "" : "|	"), "g");
            if (old != Init) cm.refresh();
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) prev.detach(cm, next);
            if (next.attach) next.attach(cm, prev || null);
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("screenReaderLabel", null, function(cm, val) {
            val = val === "" ? null : val;
            cm.display.input.screenReaderLabelChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) cm.display.input.reset();
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) cm.display.input.resetPosition();
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    }
    function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    }
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        else if (options.mode) doc.modeOption = options.mode;
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) this.display.wrapper.className += " CodeMirror-wrap";
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) display.input.focus();
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) setTimeout(function() {
            return this$1.display.input.reset(true);
        }, 20);
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) setTimeout(function() {
            if (this$1.hasFocus() && !this$1.state.focused) onFocus(this$1);
        }, 20);
        else onBlur(this);
        for(var opt in optionHandlers)if (optionHandlers.hasOwnProperty(opt)) optionHandlers[opt](this, options[opt], Init);
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) options.finishInit(this);
        for(var i = 0; i < initHooks.length; ++i)initHooks[i](this);
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") display.lineDiv.style.textRendering = "auto";
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) on(d.scroller, "dblclick", operation(cm, function(e) {
            if (signalDOMEvent(cm, e)) return;
            var pos = posFromMouse(cm, e);
            if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
            e_preventDefault(e);
            var word = cm.findWordAt(pos);
            extendSelection(cm.doc, word.anchor, word.head);
        }));
        else on(d.scroller, "dblclick", function(e) {
            return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        on(d.input.getField(), "contextmenu", function(e) {
            if (!d.scroller.contains(e.target)) onContextMenu(cm, e);
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) return false;
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) return true;
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 400;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) d.activeTouch.moved = true;
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) range = new Range(pos, pos);
                else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) range = cm.findWordAt(pos);
                else range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function(e) {
                if (!signalDOMEvent(cm, e)) e_stop(e);
            },
            over: function(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function(e) {
                if (!signalDOMEvent(cm, e)) clearDragCursor(cm);
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    }
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) how = "add";
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) how = "prev";
            else state = getContextBefore(cm, n).state;
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) line.stateAfter = null;
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) return;
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            else indentation = 0;
        } else if (how == "add") indentation = curSpace + cm.options.indentUnit;
        else if (how == "subtract") indentation = curSpace - cm.options.indentUnit;
        else if (typeof how == "number") indentation = curSpace + how;
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) for(var i = Math.floor(indentation / tabSize); i; --i){
            pos += tabSize;
            indentString += "	";
        }
        if (pos < indentation) indentString += spaceStr(indentation - pos);
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else // Ensure that, if the cursor was in the whitespace at the start
        // of the line, it is moved to the end of that space.
        for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
            var range = doc.sel.ranges[i$1];
            if (range.head.line == n && range.head.ch < curSpaceString.length) {
                var pos$1 = Pos(n, curSpaceString.length);
                replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                break;
            }
        }
    }
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) sel = doc.sel;
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++)multiPaste.push(doc.splitLines(lastCopied.text[i]));
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) multiPaste = map(textLines, function(l) {
                return [
                    l
                ];
            });
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range = sel.ranges[i$1];
            var from = range.from(), to = range.to();
            if (range.empty()) {
                if (deleted && deleted > 0) from = Pos(from.line, from.ch - deleted);
                else if (cm.state.overwrite && !paste) to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) from = to = Pos(from.line, 0);
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) triggerElectric(cm, inserted);
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) cm.curOp.updateInput = updateInput;
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput) runInOp(cm, function() {
                return applyTextInput(cm, pasted, 0, null, "paste");
            });
            return true;
        }
    }
    function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) return;
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range = sel.ranges[i];
            if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) continue;
            var mode = cm.getModeAt(range.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++)if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                    indented = indentLine(cm, range.head.line, "smart");
                    break;
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) indented = indentLine(cm, range.head.line, "smart");
            }
            if (indented) signalLater(cm, "electricInput", cm, range.head.line);
        }
    }
    function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) te.style.width = "1000px";
        else te.setAttribute("wrap", "off");
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) te.style.border = "1px solid black";
        disableBrowserMagic(te);
        return div;
    }
    // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function() {
                window.focus();
                this.display.input.focus();
            },
            setOption: function(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") return;
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) operation(this, optionHandlers[option])(this, value, old);
                signal(this, "optionChange", this, option);
            },
            getOption: function(option) {
                return this.options[option];
            },
            getDoc: function() {
                return this.doc;
            },
            addKeyMap: function(map, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
            },
            removeKeyMap: function(map) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i)if (maps[i] == map || maps[i].name == map) {
                    maps.splice(i, 1);
                    return true;
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) throw new Error("Overlays may not be stateful.");
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this.state.modeGen++;
                        regChange(this);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
                    else dir = dir ? "add" : "subtract";
                }
                if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
            }),
            indentSelection: methodOp(function(how) {
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (!range.empty()) {
                        var from = range.from(), to = range.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j)indentLine(this, j, how);
                        var newRanges = this.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                    } else if (range.head.line > end) {
                        indentLine(this, range.head.line, how, true);
                        end = range.head.line;
                        if (i == this.doc.sel.primIndex) ensureCursorVisible(this);
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) type = styles[2];
                else for(;;){
                    var mid = before + after >> 1;
                    if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
                    else if (styles[mid * 2 + 1] < ch) before = mid + 1;
                    else {
                        type = styles[mid * 2 + 2];
                        break;
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) return mode;
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function(pos, type) {
                var found = [];
                if (!helpers.hasOwnProperty(type)) return found;
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) found.push(help[mode[type]]);
                } else if (mode[type]) for(var i = 0; i < mode[type].length; i++){
                    var val = help[mode[type][i]];
                    if (val) found.push(val);
                }
                else if (mode.helperType && help[mode.helperType]) found.push(help[mode.helperType]);
                else if (help[mode.name]) found.push(help[mode.name]);
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) found.push(cur.val);
                }
                return found;
            },
            getStateAfter: function(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function(start, mode) {
                var pos, range = this.doc.sel.primary();
                if (start == null) pos = range.head;
                else if (typeof start == "object") pos = clipPos(this.doc, start);
                else pos = start ? range.from() : range.to();
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) line = this.doc.first;
                    else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else lineObj = line;
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function() {
                return textHeight(this.display);
            },
            defaultCharWidth: function() {
                return charWidth(this.display);
            },
            getViewport: function() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") top = pos.top;
                else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == "above" || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) top = pos.top - node.offsetHeight;
                    else if (pos.bottom + node.offsetHeight <= vspace) top = pos.bottom;
                    if (left + node.offsetWidth > hspace) left = hspace - node.offsetWidth;
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") left = 0;
                    else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    node.style.left = left + "px";
                }
                if (scroll) scrollIntoView(this, {
                    left: left,
                    top: top,
                    right: left + node.offsetWidth,
                    bottom: top + node.offsetHeight
                });
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function(cmd) {
                if (commands.hasOwnProperty(cmd)) return commands[cmd].call(null, this);
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function(from, amount, unit, visually) {
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this.doc, cur, dir, unit, visually);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range) {
                    if (this$1.display.shift || this$1.doc.extend || range.empty()) return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
                    else return dir < 0 ? range.from() : range.to();
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) doc.replaceSelection("", null, "+delete");
                else deleteNearSelection(this, function(range) {
                    var other = findPosH(doc, range.head, dir, unit, false);
                    return dir < 0 ? {
                        from: other,
                        to: range.head
                    } : {
                        from: range.head,
                        to: other
                    };
                });
            }),
            findPosV: function(from, amount, unit, goalColumn) {
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this, cur, "div");
                    if (x == null) x = coords.left;
                    else coords.left = x;
                    cur = findPosV(this, coords, dir, unit);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range) {
                    if (collapse) return dir < 0 ? range.from() : range.to();
                    var headPos = cursorCoords(this$1, range.head, "div");
                    if (range.goalColumn != null) headPos.left = range.goalColumn;
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range == doc.sel.primary()) addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    return pos;
                }, sel_move);
                if (goals.length) for(var i = 0; i < doc.sel.ranges.length; i++)doc.sel.ranges[i].goalColumn = goals[i];
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) --start;
                    else ++end;
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1)))--start;
                    while(end < line.length && check(line.charAt(end)))++end;
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function(value) {
                if (value != null && value == this.state.overwrite) return;
                if (this.state.overwrite = !this.state.overwrite) addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                else rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function() {
                return this.display.input.getField() == activeElt();
            },
            isReadOnly: function() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range, margin) {
                if (range == null) {
                    range = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) margin = this.options.cursorScrollMargin;
                } else if (typeof range == "number") range = {
                    from: Pos(range, 0),
                    to: null
                };
                else if (range.from == null) range = {
                    from: range,
                    to: null
                };
                if (!range.to) range.to = range.from;
                range.margin = margin || 0;
                if (range.from.line != null) scrollToRange(this, range);
                else scrollToCoordsRange(this, range.from, range.to, range.margin);
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) this.display.wrapper.style.width = interpret(width);
                if (height != null) this.display.wrapper.style.height = interpret(height);
                if (this.options.lineWrapping) clearLineMeasurementCache(this);
                var lineNo = this.display.viewFrom;
                this.doc.iter(lineNo, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].noHScroll) {
                            regLineChange(this$1, lineNo, "widget");
                            break;
                        }
                    }
                    ++lineNo;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function(f) {
                return runInOp(this, f);
            },
            startOperation: function() {
                return startOperation(this);
            },
            endOperation: function() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) estimateLineHeights(this);
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) this.state.selectingText();
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function() {
                return this.display.input.getField();
            },
            getWrapperElement: function() {
                return this.display.wrapper;
            },
            getScrollerElement: function() {
                return this.display.scroller;
            },
            getGutterElement: function() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {
                _global: []
            };
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    }
    // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "codepoint", "char", "column" (like char, but
    // doesn't cross line boundaries), "word" (across next word), or
    // "group" (to the start of next group of word or
    // non-word-non-whitespace chars). The visually param controls
    // whether, in right-to-left text, direction 1 means to move towards
    // the next index in the string, or towards the character to the right
    // of the current position. The resulting position will have a
    // hitSide=true property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
        function findNextLine() {
            var l = pos.line + lineDir;
            if (l < doc.first || l >= doc.first + doc.size) return false;
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (unit == "codepoint") {
                var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
                if (isNaN(ch)) next = null;
                else {
                    var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
                    next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
                }
            } else if (visually) next = moveVisually(doc.cm, lineObj, pos, dir);
            else next = moveLogically(lineObj, pos, dir);
            if (next == null) {
                if (!boundToLine && findNextLine()) pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
                else return false;
            } else pos = next;
            return true;
        }
        if (unit == "char" || unit == "codepoint") moveOnce();
        else if (unit == "column") moveOnce(true);
        else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) break;
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) type = "s";
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) sawType = type;
                if (dir > 0 && !moveOnce(!first)) break;
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) result.hitSide = true;
        return result;
    }
    // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) break;
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    }
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        div.contentEditable = true;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        function belongsToInput(e) {
            for(var t = e.target; t; t = t.parentNode){
                if (t == div) return true;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
            }
            return false;
        }
        on(div, "paste", function(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) setTimeout(operation(cm, function() {
                return this$1.updateFromDOM();
            }), 20);
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) this$1.readFromDOMSoon();
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) this$1.readFromDOMSoon();
        });
        function onCopyCut(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") cm.replaceSelection("", null, "cut");
            } else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.operation(function() {
                    cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                    cm.replaceSelection("", null, "cut");
                });
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = activeElt();
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) input.showPrimarySelection();
            }, 50);
        }
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.div.setAttribute("aria-label", label);
        else this.div.removeAttribute("aria-label");
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = activeElt() == this.div;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) return;
        if (info.focus || takeFocus) this.showPrimarySelection();
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) return;
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map[map.length - 1],
                offset: map[map.length - 2] - map[map.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) sel.addRange(old);
            else if (gecko) this.startGracePeriod();
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) this$1.cm.operation(function() {
                return this$1.cm.curOp.selectionChanged = true;
            });
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) return false;
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor() || activeElt() != this.div) this.showSelection(this.prepareSelection(), true);
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var input = this;
        if (this.selectionInEditor()) this.pollSelection();
        else runInOp(this.cm, function() {
            return input.cm.curOp.selectionChanged = true;
        });
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) return;
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) return;
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) runInOp(cm, function() {
            setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
            if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
        });
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) to = Pos(to.line + 1, 0);
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) return false;
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else break;
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))++cutFront;
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))++cutEnd;
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            cutFront--;
            cutEnd++;
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) return;
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) return;
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) this$1.composing = null;
                else return;
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) runInOp(this.cm, function() {
            return regChange(this$1.cm);
        });
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) return;
        e.preventDefault();
        if (!this.cm.isReadOnly()) operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) return null;
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    }
    function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) return true;
        }
        return false;
    }
    function badPos(pos, bad) {
        if (bad) pos.bad = true;
        return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) text += lineSep;
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range = found[0].find(0))) addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") return;
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) return;
                if (isBlock) close();
                for(var i = 0; i < node.childNodes.length; i++)walk(node.childNodes[i]);
                if (/^(pre|p)$/i.test(node.nodeName)) extraLinebreak = true;
                if (isBlock) closing = true;
            } else if (node.nodeType == 3) addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for(;;){
            walk(from);
            if (from == to) break;
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    }
    function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            node = null;
            offset = 0;
        } else for(lineNode = node;; lineNode = lineNode.parentNode){
            if (!lineNode || lineNode == cm.display.lineDiv) return null;
            if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) return locateNodeInLineView(lineView, node, offset);
        }
    }
    function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) offset = textNode.nodeValue.length;
        }
        while(topNode.parentNode != wrapper)topNode = topNode.parentNode;
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map.length; j += 3){
                    var curNode = map[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map[j] + offset;
                        if (offset < 0 || curNode != textNode) ch = map[j + (offset ? 1 : 0)];
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) return badPos(found, bad);
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) return badPos(Pos(found.line, found.ch - dist), bad);
            else dist += after.textContent.length;
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) return badPos(Pos(found.line, found.ch + dist$1), bad);
            else dist$1 += before.textContent.length;
        }
    }
    // TEXTAREA INPUT STYLE
    var TextareaInput = function(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
    };
    TextareaInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) te.style.width = "0px";
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) this$1.hasSelection = null;
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) setLastCopied({
                lineWise: false,
                text: cm.getSelections()
            });
            else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.setSelections(ranges.ranges, null, sel_dontScroll);
                else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") cm.state.cutIncoming = +new Date;
        }
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) e_preventDefault(e);
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) input.composing.range.clear();
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.textarea.setAttribute("aria-label", label);
        else this.textarea.removeAttribute("aria-label");
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing) return;
        var cm = this.cm;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) selectInput(this.textarea);
            if (ie && ie_version >= 9) this.hasSelection = content;
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) this.hasSelection = null;
        }
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) try {
            this.textarea.focus();
        } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) return;
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) this$1.slowPoll();
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) return false;
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) return false;
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) prevInput = "​";
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same))++same;
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) input.value = this$1.prevInput = "";
            else this$1.prevInput = text;
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) this.pollingFast = false;
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) this.hasSelection = null;
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) input.contextMenuPending();
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) return;
         // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) oldScrollY = window.scrollY;
         // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) window.scrollTo(null, oldScrollY);
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) te.value = input.prevInput = " ";
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "​" + (selected ? te.value : "");
                te.value = "⇚"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "​";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        }
        function rehide() {
            if (input.contextMenuPending != rehide) return;
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) prepareSelectAllHack();
                var i = 0, poll = function() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "​") operation(cm, selectAll)(cm);
                    else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
                    else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) prepareSelectAllHack();
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else setTimeout(rehide, 50);
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) this.reset();
        this.textarea.disabled = val == "nocursor";
        this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) options.tabindex = textarea.tabIndex;
        if (!options.placeholder && textarea.placeholder) options.placeholder = textarea.placeholder;
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt();
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") textarea.form.submit = realSubmit;
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    }
    function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    }
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype)if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) CodeMirror.prototype[prop] = function(method) {
        return function() {
            return method.apply(this.doc, arguments);
        };
    }(Doc.prototype[prop]);
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.61.1";
    return CodeMirror;
});

},{}],"fz9SD":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// declare global: DOMRect
(function(mod) {
    mod(require("50c5ec1cb6ab049c"));
})(function(CodeMirror) {
    "use strict";
    var HINT_ELEMENT_CLASS = "CodeMirror-hint";
    var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
    // This is the old interface, kept around for now to stay
    // backwards-compatible.
    CodeMirror.showHint = function(cm, getHints, options) {
        if (!getHints) return cm.showHint(options);
        if (options && options.async) getHints.async = true;
        var newOpts = {
            hint: getHints
        };
        if (options) for(var prop in options)newOpts[prop] = options[prop];
        return cm.showHint(newOpts);
    };
    CodeMirror.defineExtension("showHint", function(options) {
        options = parseOptions(this, this.getCursor("start"), options);
        var selections = this.listSelections();
        if (selections.length > 1) return;
        // By default, don't allow completion when something is selected.
        // A hint function can have a `supportsSelection` property to
        // indicate that it can handle selections.
        if (this.somethingSelected()) {
            if (!options.hint.supportsSelection) return;
            // Don't try with cross-line selections
            for(var i = 0; i < selections.length; i++)if (selections[i].head.line != selections[i].anchor.line) return;
        }
        if (this.state.completionActive) this.state.completionActive.close();
        var completion = this.state.completionActive = new Completion(this, options);
        if (!completion.options.hint) return;
        CodeMirror.signal(this, "startCompletion", this);
        completion.update(true);
    });
    CodeMirror.defineExtension("closeHint", function() {
        if (this.state.completionActive) this.state.completionActive.close();
    });
    function Completion(cm, options) {
        this.cm = cm;
        this.options = options;
        this.widget = null;
        this.debounce = 0;
        this.tick = 0;
        this.startPos = this.cm.getCursor("start");
        this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
        if (this.options.updateOnCursorActivity) {
            var self = this;
            cm.on("cursorActivity", this.activityFunc = function() {
                self.cursorActivity();
            });
        }
    }
    var requestAnimationFrame = window.requestAnimationFrame || function(fn) {
        return setTimeout(fn, 1000 / 60);
    };
    var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
    Completion.prototype = {
        close: function() {
            if (!this.active()) return;
            this.cm.state.completionActive = null;
            this.tick = null;
            if (this.options.updateOnCursorActivity) this.cm.off("cursorActivity", this.activityFunc);
            if (this.widget && this.data) CodeMirror.signal(this.data, "close");
            if (this.widget) this.widget.close();
            CodeMirror.signal(this.cm, "endCompletion", this.cm);
        },
        active: function() {
            return this.cm.state.completionActive == this;
        },
        pick: function(data, i) {
            var completion = data.list[i], self = this;
            this.cm.operation(function() {
                if (completion.hint) completion.hint(self.cm, data, completion);
                else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
                CodeMirror.signal(data, "pick", completion);
                self.cm.scrollIntoView();
            });
            if (this.options.closeOnPick) this.close();
        },
        cursorActivity: function() {
            if (this.debounce) {
                cancelAnimationFrame(this.debounce);
                this.debounce = 0;
            }
            var identStart = this.startPos;
            if (this.data) identStart = this.data.from;
            var pos = this.cm.getCursor(), line = this.cm.getLine(pos.line);
            if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch || pos.ch < identStart.ch || this.cm.somethingSelected() || !pos.ch || this.options.closeCharacters.test(line.charAt(pos.ch - 1))) this.close();
            else {
                var self = this;
                this.debounce = requestAnimationFrame(function() {
                    self.update();
                });
                if (this.widget) this.widget.disable();
            }
        },
        update: function(first) {
            if (this.tick == null) return;
            var self = this, myTick = ++this.tick;
            fetchHints(this.options.hint, this.cm, this.options, function(data) {
                if (self.tick == myTick) self.finishUpdate(data, first);
            });
        },
        finishUpdate: function(data, first) {
            if (this.data) CodeMirror.signal(this.data, "update");
            var picked = this.widget && this.widget.picked || first && this.options.completeSingle;
            if (this.widget) this.widget.close();
            this.data = data;
            if (data && data.list.length) {
                if (picked && data.list.length == 1) this.pick(data, 0);
                else {
                    this.widget = new Widget(this, data);
                    CodeMirror.signal(data, "shown");
                }
            }
        }
    };
    function parseOptions(cm, pos, options) {
        var editor = cm.options.hintOptions;
        var out = {};
        for(var prop in defaultOptions)out[prop] = defaultOptions[prop];
        if (editor) {
            for(var prop in editor)if (editor[prop] !== undefined) out[prop] = editor[prop];
        }
        if (options) {
            for(var prop in options)if (options[prop] !== undefined) out[prop] = options[prop];
        }
        if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
        return out;
    }
    function getText(completion) {
        if (typeof completion == "string") return completion;
        else return completion.text;
    }
    function buildKeyMap(completion, handle) {
        var baseMap = {
            Up: function() {
                handle.moveFocus(-1);
            },
            Down: function() {
                handle.moveFocus(1);
            },
            PageUp: function() {
                handle.moveFocus(-handle.menuSize() + 1, true);
            },
            PageDown: function() {
                handle.moveFocus(handle.menuSize() - 1, true);
            },
            Home: function() {
                handle.setFocus(0);
            },
            End: function() {
                handle.setFocus(handle.length - 1);
            },
            Enter: handle.pick,
            Tab: handle.pick,
            Esc: handle.close
        };
        var mac = /Mac/.test(navigator.platform);
        if (mac) {
            baseMap["Ctrl-P"] = function() {
                handle.moveFocus(-1);
            };
            baseMap["Ctrl-N"] = function() {
                handle.moveFocus(1);
            };
        }
        var custom = completion.options.customKeys;
        var ourMap = custom ? {} : baseMap;
        function addBinding(key, val) {
            var bound;
            if (typeof val != "string") bound = function(cm) {
                return val(cm, handle);
            };
            else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];
            else bound = val;
            ourMap[key] = bound;
        }
        if (custom) {
            for(var key in custom)if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
        }
        var extra = completion.options.extraKeys;
        if (extra) {
            for(var key in extra)if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
        }
        return ourMap;
    }
    function getHintElement(hintsElement, el) {
        while(el && el != hintsElement){
            if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
            el = el.parentNode;
        }
    }
    function Widget(completion, data) {
        this.completion = completion;
        this.data = data;
        this.picked = false;
        var widget = this, cm = completion.cm;
        var ownerDocument = cm.getInputField().ownerDocument;
        var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
        var hints = this.hints = ownerDocument.createElement("ul");
        var theme = completion.cm.options.theme;
        hints.className = "CodeMirror-hints " + theme;
        this.selectedHint = data.selectedHint || 0;
        var completions = data.list;
        for(var i = 0; i < completions.length; ++i){
            var elt = hints.appendChild(ownerDocument.createElement("li")), cur = completions[i];
            var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
            if (cur.className != null) className = cur.className + " " + className;
            elt.className = className;
            if (cur.render) cur.render(elt, data, cur);
            else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
            elt.hintId = i;
        }
        var container = completion.options.container || ownerDocument.body;
        var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
        var left = pos.left, top = pos.bottom, below = true;
        var offsetLeft = 0, offsetTop = 0;
        if (container !== ownerDocument.body) {
            // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
            var isContainerPositioned = [
                "absolute",
                "relative",
                "fixed"
            ].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
            var offsetParent = isContainerPositioned ? container : container.offsetParent;
            var offsetParentPosition = offsetParent.getBoundingClientRect();
            var bodyPosition = ownerDocument.body.getBoundingClientRect();
            offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
            offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
        }
        hints.style.left = left - offsetLeft + "px";
        hints.style.top = top - offsetTop + "px";
        // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
        var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
        var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
        container.appendChild(hints);
        var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
        var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;
        // Compute in the timeout to avoid reflow on init
        var startScroll;
        setTimeout(function() {
            startScroll = cm.getScrollInfo();
        });
        var overlapY = box.bottom - winH;
        if (overlapY > 0) {
            var height = box.bottom - box.top, curTop = pos.top - (pos.bottom - box.top);
            if (curTop - height > 0) {
                hints.style.top = (top = pos.top - height - offsetTop) + "px";
                below = false;
            } else if (height > winH) {
                hints.style.height = winH - 5 + "px";
                hints.style.top = (top = pos.bottom - box.top - offsetTop) + "px";
                var cursor = cm.getCursor();
                if (data.from.ch != cursor.ch) {
                    pos = cm.cursorCoords(cursor);
                    hints.style.left = (left = pos.left - offsetLeft) + "px";
                    box = hints.getBoundingClientRect();
                }
            }
        }
        var overlapX = box.right - winW;
        if (scrolls) overlapX += cm.display.nativeBarWidth;
        if (overlapX > 0) {
            if (box.right - box.left > winW) {
                hints.style.width = winW - 5 + "px";
                overlapX -= box.right - box.left - winW;
            }
            hints.style.left = (left = pos.left - overlapX - offsetLeft) + "px";
        }
        if (scrolls) for(var node = hints.firstChild; node; node = node.nextSibling)node.style.paddingRight = cm.display.nativeBarWidth + "px";
        cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
            moveFocus: function(n, avoidWrap) {
                widget.changeActive(widget.selectedHint + n, avoidWrap);
            },
            setFocus: function(n) {
                widget.changeActive(n);
            },
            menuSize: function() {
                return widget.screenAmount();
            },
            length: completions.length,
            close: function() {
                completion.close();
            },
            pick: function() {
                widget.pick();
            },
            data: data
        }));
        if (completion.options.closeOnUnfocus) {
            var closingOnBlur;
            cm.on("blur", this.onBlur = function() {
                closingOnBlur = setTimeout(function() {
                    completion.close();
                }, 100);
            });
            cm.on("focus", this.onFocus = function() {
                clearTimeout(closingOnBlur);
            });
        }
        cm.on("scroll", this.onScroll = function() {
            var curScroll = cm.getScrollInfo(), editor = cm.getWrapperElement().getBoundingClientRect();
            if (!startScroll) startScroll = cm.getScrollInfo();
            var newTop = top + startScroll.top - curScroll.top;
            var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
            if (!below) point += hints.offsetHeight;
            if (point <= editor.top || point >= editor.bottom) return completion.close();
            hints.style.top = newTop + "px";
            hints.style.left = left + startScroll.left - curScroll.left + "px";
        });
        CodeMirror.on(hints, "dblclick", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                widget.pick();
            }
        });
        CodeMirror.on(hints, "click", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                if (completion.options.completeOnSingleClick) widget.pick();
            }
        });
        CodeMirror.on(hints, "mousedown", function() {
            setTimeout(function() {
                cm.focus();
            }, 20);
        });
        // The first hint doesn't need to be scrolled to on init
        var selectedHintRange = this.getSelectedHintRange();
        if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) this.scrollToActive();
        CodeMirror.signal(data, "select", completions[this.selectedHint], hints.childNodes[this.selectedHint]);
        return true;
    }
    Widget.prototype = {
        close: function() {
            if (this.completion.widget != this) return;
            this.completion.widget = null;
            if (this.hints.parentNode) this.hints.parentNode.removeChild(this.hints);
            this.completion.cm.removeKeyMap(this.keyMap);
            var cm = this.completion.cm;
            if (this.completion.options.closeOnUnfocus) {
                cm.off("blur", this.onBlur);
                cm.off("focus", this.onFocus);
            }
            cm.off("scroll", this.onScroll);
        },
        disable: function() {
            this.completion.cm.removeKeyMap(this.keyMap);
            var widget = this;
            this.keyMap = {
                Enter: function() {
                    widget.picked = true;
                }
            };
            this.completion.cm.addKeyMap(this.keyMap);
        },
        pick: function() {
            this.completion.pick(this.data, this.selectedHint);
        },
        changeActive: function(i, avoidWrap) {
            if (i >= this.data.list.length) i = avoidWrap ? this.data.list.length - 1 : 0;
            else if (i < 0) i = avoidWrap ? 0 : this.data.list.length - 1;
            if (this.selectedHint == i) return;
            var node = this.hints.childNodes[this.selectedHint];
            if (node) node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
            node = this.hints.childNodes[this.selectedHint = i];
            node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
            this.scrollToActive();
            CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
        },
        scrollToActive: function() {
            var selectedHintRange = this.getSelectedHintRange();
            var node1 = this.hints.childNodes[selectedHintRange.from];
            var node2 = this.hints.childNodes[selectedHintRange.to];
            var firstNode = this.hints.firstChild;
            if (node1.offsetTop < this.hints.scrollTop) this.hints.scrollTop = node1.offsetTop - firstNode.offsetTop;
            else if (node2.offsetTop + node2.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) this.hints.scrollTop = node2.offsetTop + node2.offsetHeight - this.hints.clientHeight + firstNode.offsetTop;
        },
        screenAmount: function() {
            return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
        },
        getSelectedHintRange: function() {
            var margin = this.completion.options.scrollMargin || 0;
            return {
                from: Math.max(0, this.selectedHint - margin),
                to: Math.min(this.data.list.length - 1, this.selectedHint + margin)
            };
        }
    };
    function applicableHelpers(cm, helpers) {
        if (!cm.somethingSelected()) return helpers;
        var result = [];
        for(var i = 0; i < helpers.length; i++)if (helpers[i].supportsSelection) result.push(helpers[i]);
        return result;
    }
    function fetchHints(hint, cm, options, callback) {
        if (hint.async) hint(cm, callback, options);
        else {
            var result = hint(cm, options);
            if (result && result.then) result.then(callback);
            else callback(result);
        }
    }
    function resolveAutoHints(cm, pos) {
        var helpers = cm.getHelpers(pos, "hint"), words;
        if (helpers.length) {
            var resolved = function(cm, callback, options) {
                var app = applicableHelpers(cm, helpers);
                function run(i) {
                    if (i == app.length) return callback(null);
                    fetchHints(app[i], cm, options, function(result) {
                        if (result && result.list.length > 0) callback(result);
                        else run(i + 1);
                    });
                }
                run(0);
            };
            resolved.async = true;
            resolved.supportsSelection = true;
            return resolved;
        } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) return function(cm) {
            return CodeMirror.hint.fromList(cm, {
                words: words
            });
        };
        else if (CodeMirror.hint.anyword) return function(cm, options) {
            return CodeMirror.hint.anyword(cm, options);
        };
        else return function() {};
    }
    CodeMirror.registerHelper("hint", "auto", {
        resolve: resolveAutoHints
    });
    CodeMirror.registerHelper("hint", "fromList", function(cm, options) {
        var cur = cm.getCursor(), token = cm.getTokenAt(cur);
        var term, from = CodeMirror.Pos(cur.line, token.start), to = cur;
        if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) term = token.string.substr(0, cur.ch - token.start);
        else {
            term = "";
            from = cur;
        }
        var found = [];
        for(var i = 0; i < options.words.length; i++){
            var word = options.words[i];
            if (word.slice(0, term.length) == term) found.push(word);
        }
        if (found.length) return {
            list: found,
            from: from,
            to: to
        };
    });
    CodeMirror.commands.autocomplete = CodeMirror.showHint;
    var defaultOptions = {
        hint: CodeMirror.hint.auto,
        completeSingle: true,
        alignWithWord: true,
        closeCharacters: /[\s()\[\]{};:>,]/,
        closeOnPick: true,
        closeOnUnfocus: true,
        updateOnCursorActivity: true,
        completeOnSingleClick: true,
        container: null,
        customKeys: null,
        extraKeys: null,
        paddingForScrollbar: true,
        moveOnOverlap: true
    };
    CodeMirror.defineOption("hintOptions", null);
});

},{"50c5ec1cb6ab049c":"akde7"}],"hrRDs":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(require("faedf4d22ffc3d05"), require("e6eb33be50c723a3"));
})(function(CodeMirror) {
    "use strict";
    var tables;
    var defaultTable;
    var keywords;
    var identifierQuote;
    var CONS = {
        QUERY_DIV: ";",
        ALIAS_KEYWORD: "AS"
    };
    var Pos = CodeMirror.Pos, cmpPos = CodeMirror.cmpPos;
    function isArray(val) {
        return Object.prototype.toString.call(val) == "[object Array]";
    }
    function getKeywords(editor) {
        var mode = editor.doc.modeOption;
        if (mode === "sql") mode = "text/x-sql";
        return CodeMirror.resolveMode(mode).keywords;
    }
    function getIdentifierQuote(editor) {
        var mode = editor.doc.modeOption;
        if (mode === "sql") mode = "text/x-sql";
        return CodeMirror.resolveMode(mode).identifierQuote || "`";
    }
    function getText(item) {
        return typeof item == "string" ? item : item.text;
    }
    function wrapTable(name, value) {
        if (isArray(value)) value = {
            columns: value
        };
        if (!value.text) value.text = name;
        return value;
    }
    function parseTables(input) {
        var result = {};
        if (isArray(input)) for(var i = input.length - 1; i >= 0; i--){
            var item = input[i];
            result[getText(item).toUpperCase()] = wrapTable(getText(item), item);
        }
        else if (input) for(var name in input)result[name.toUpperCase()] = wrapTable(name, input[name]);
        return result;
    }
    function getTable(name) {
        return tables[name.toUpperCase()];
    }
    function shallowClone(object) {
        var result = {};
        for(var key in object)if (object.hasOwnProperty(key)) result[key] = object[key];
        return result;
    }
    function match(string, word) {
        var len = string.length;
        var sub = getText(word).substr(0, len);
        return string.toUpperCase() === sub.toUpperCase();
    }
    function addMatches(result, search, wordlist, formatter) {
        if (isArray(wordlist)) {
            for(var i = 0; i < wordlist.length; i++)if (match(search, wordlist[i])) result.push(formatter(wordlist[i]));
        } else {
            for(var word in wordlist)if (wordlist.hasOwnProperty(word)) {
                var val = wordlist[word];
                if (!val || val === true) val = word;
                else val = val.displayText ? {
                    text: val.text,
                    displayText: val.displayText
                } : val.text;
                if (match(search, val)) result.push(formatter(val));
            }
        }
    }
    function cleanName(name) {
        // Get rid name from identifierQuote and preceding dot(.)
        if (name.charAt(0) == ".") name = name.substr(1);
        // replace duplicated identifierQuotes with single identifierQuotes
        // and remove single identifierQuotes
        var nameParts = name.split(identifierQuote + identifierQuote);
        for(var i = 0; i < nameParts.length; i++)nameParts[i] = nameParts[i].replace(new RegExp(identifierQuote, "g"), "");
        return nameParts.join(identifierQuote);
    }
    function insertIdentifierQuotes(name) {
        var nameParts = getText(name).split(".");
        for(var i = 0; i < nameParts.length; i++)nameParts[i] = identifierQuote + // duplicate identifierQuotes
        nameParts[i].replace(new RegExp(identifierQuote, "g"), identifierQuote + identifierQuote) + identifierQuote;
        var escaped = nameParts.join(".");
        if (typeof name == "string") return escaped;
        name = shallowClone(name);
        name.text = escaped;
        return name;
    }
    function nameCompletion(cur, token, result, editor) {
        // Try to complete table, column names and return start position of completion
        var useIdentifierQuotes = false;
        var nameParts = [];
        var start = token.start;
        var cont = true;
        while(cont){
            cont = token.string.charAt(0) == ".";
            useIdentifierQuotes = useIdentifierQuotes || token.string.charAt(0) == identifierQuote;
            start = token.start;
            nameParts.unshift(cleanName(token.string));
            token = editor.getTokenAt(Pos(cur.line, token.start));
            if (token.string == ".") {
                cont = true;
                token = editor.getTokenAt(Pos(cur.line, token.start));
            }
        }
        // Try to complete table names
        var string = nameParts.join(".");
        addMatches(result, string, tables, function(w) {
            return useIdentifierQuotes ? insertIdentifierQuotes(w) : w;
        });
        // Try to complete columns from defaultTable
        addMatches(result, string, defaultTable, function(w) {
            return useIdentifierQuotes ? insertIdentifierQuotes(w) : w;
        });
        // Try to complete columns
        string = nameParts.pop();
        var table = nameParts.join(".");
        var alias = false;
        var aliasTable = table;
        // Check if table is available. If not, find table by Alias
        if (!getTable(table)) {
            var oldTable = table;
            table = findTableByAlias(table, editor);
            if (table !== oldTable) alias = true;
        }
        var columns = getTable(table);
        if (columns && columns.columns) columns = columns.columns;
        if (columns) addMatches(result, string, columns, function(w) {
            var tableInsert = table;
            if (alias == true) tableInsert = aliasTable;
            if (typeof w == "string") w = tableInsert + "." + w;
            else {
                w = shallowClone(w);
                w.text = tableInsert + "." + w.text;
            }
            return useIdentifierQuotes ? insertIdentifierQuotes(w) : w;
        });
        return start;
    }
    function eachWord(lineText, f) {
        var words = lineText.split(/\s+/);
        for(var i = 0; i < words.length; i++)if (words[i]) f(words[i].replace(/[`,;]/g, ""));
    }
    function findTableByAlias(alias, editor) {
        var doc = editor.doc;
        var fullQuery = doc.getValue();
        var aliasUpperCase = alias.toUpperCase();
        var previousWord = "";
        var table = "";
        var separator = [];
        var validRange = {
            start: Pos(0, 0),
            end: Pos(editor.lastLine(), editor.getLineHandle(editor.lastLine()).length)
        };
        //add separator
        var indexOfSeparator = fullQuery.indexOf(CONS.QUERY_DIV);
        while(indexOfSeparator != -1){
            separator.push(doc.posFromIndex(indexOfSeparator));
            indexOfSeparator = fullQuery.indexOf(CONS.QUERY_DIV, indexOfSeparator + 1);
        }
        separator.unshift(Pos(0, 0));
        separator.push(Pos(editor.lastLine(), editor.getLineHandle(editor.lastLine()).text.length));
        //find valid range
        var prevItem = null;
        var current = editor.getCursor();
        for(var i = 0; i < separator.length; i++){
            if ((prevItem == null || cmpPos(current, prevItem) > 0) && cmpPos(current, separator[i]) <= 0) {
                validRange = {
                    start: prevItem,
                    end: separator[i]
                };
                break;
            }
            prevItem = separator[i];
        }
        if (validRange.start) {
            var query = doc.getRange(validRange.start, validRange.end, false);
            for(var i = 0; i < query.length; i++){
                var lineText = query[i];
                eachWord(lineText, function(word) {
                    var wordUpperCase = word.toUpperCase();
                    if (wordUpperCase === aliasUpperCase && getTable(previousWord)) table = previousWord;
                    if (wordUpperCase !== CONS.ALIAS_KEYWORD) previousWord = word;
                });
                if (table) break;
            }
        }
        return table;
    }
    CodeMirror.registerHelper("hint", "sql", function(editor, options) {
        tables = parseTables(options && options.tables);
        var defaultTableName = options && options.defaultTable;
        var disableKeywords = options && options.disableKeywords;
        defaultTable = defaultTableName && getTable(defaultTableName);
        keywords = getKeywords(editor);
        identifierQuote = getIdentifierQuote(editor);
        if (defaultTableName && !defaultTable) defaultTable = findTableByAlias(defaultTableName, editor);
        defaultTable = defaultTable || [];
        if (defaultTable.columns) defaultTable = defaultTable.columns;
        var cur = editor.getCursor();
        var result = [];
        var token = editor.getTokenAt(cur), start, end, search;
        if (token.end > cur.ch) {
            token.end = cur.ch;
            token.string = token.string.slice(0, cur.ch - token.start);
        }
        if (token.string.match(/^[.`"'\w@][\w$#]*$/g)) {
            search = token.string;
            start = token.start;
            end = token.end;
        } else {
            start = end = cur.ch;
            search = "";
        }
        if (search.charAt(0) == "." || search.charAt(0) == identifierQuote) start = nameCompletion(cur, token, result, editor);
        else {
            var objectOrClass = function(w, className) {
                if (typeof w === "object") w.className = className;
                else w = {
                    text: w,
                    className: className
                };
                return w;
            };
            addMatches(result, search, defaultTable, function(w) {
                return objectOrClass(w, "CodeMirror-hint-table CodeMirror-hint-default-table");
            });
            addMatches(result, search, tables, function(w) {
                return objectOrClass(w, "CodeMirror-hint-table");
            });
            if (!disableKeywords) addMatches(result, search, keywords, function(w) {
                return objectOrClass(w.toUpperCase(), "CodeMirror-hint-keyword");
            });
        }
        return {
            list: result,
            from: Pos(cur.line, start),
            to: Pos(cur.line, end)
        };
    });
});

},{"faedf4d22ffc3d05":"akde7","e6eb33be50c723a3":"j5YpV"}],"j5YpV":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(require("383741b9a1300259"));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineMode("sql", function(config, parserConfig) {
        var client = parserConfig.client || {}, atoms = parserConfig.atoms || {
            "false": true,
            "true": true,
            "null": true
        }, builtin = parserConfig.builtin || set(defaultBuiltin), keywords = parserConfig.keywords || set(sqlKeywords), operatorChars = parserConfig.operatorChars || /^[*+\-%<>!=&|~^\/]/, support = parserConfig.support || {}, hooks = parserConfig.hooks || {}, dateSQL = parserConfig.dateSQL || {
            "date": true,
            "time": true,
            "timestamp": true
        }, backslashStringEscapes = parserConfig.backslashStringEscapes !== false, brackets = parserConfig.brackets || /^[\{}\(\)\[\]]/, punctuation = parserConfig.punctuation || /^[;.,:]/;
        function tokenBase(stream, state) {
            var ch = stream.next();
            // call hooks from the mime type
            if (hooks[ch]) {
                var result = hooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (support.hexNumber && (ch == "0" && stream.match(/^[xX][0-9a-fA-F]+/) || (ch == "x" || ch == "X") && stream.match(/^'[0-9a-fA-F]+'/))) // hex
            // ref: http://dev.mysql.com/doc/refman/5.5/en/hexadecimal-literals.html
            return "number";
            else if (support.binaryNumber && ((ch == "b" || ch == "B") && stream.match(/^'[01]+'/) || ch == "0" && stream.match(/^b[01]+/))) // bitstring
            // ref: http://dev.mysql.com/doc/refman/5.5/en/bit-field-literals.html
            return "number";
            else if (ch.charCodeAt(0) > 47 && ch.charCodeAt(0) < 58) {
                // numbers
                // ref: http://dev.mysql.com/doc/refman/5.5/en/number-literals.html
                stream.match(/^[0-9]*(\.[0-9]+)?([eE][-+]?[0-9]+)?/);
                support.decimallessFloat && stream.match(/^\.(?!\.)/);
                return "number";
            } else if (ch == "?" && (stream.eatSpace() || stream.eol() || stream.eat(";"))) // placeholders
            return "variable-3";
            else if (ch == "'" || ch == '"' && support.doubleQuote) {
                // strings
                // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
                state.tokenize = tokenLiteral(ch);
                return state.tokenize(stream, state);
            } else if ((support.nCharCast && (ch == "n" || ch == "N") || support.charsetCast && ch == "_" && stream.match(/[a-z][a-z0-9]*/i)) && (stream.peek() == "'" || stream.peek() == '"')) // charset casting: _utf8'str', N'str', n'str'
            // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
            return "keyword";
            else if (support.escapeConstant && (ch == "e" || ch == "E") && (stream.peek() == "'" || stream.peek() == '"' && support.doubleQuote)) {
                // escape constant: E'str', e'str'
                // ref: https://www.postgresql.org/docs/current/sql-syntax-lexical.html#SQL-SYNTAX-STRINGS-ESCAPE
                state.tokenize = function(stream, state) {
                    return (state.tokenize = tokenLiteral(stream.next(), true))(stream, state);
                };
                return "keyword";
            } else if (support.commentSlashSlash && ch == "/" && stream.eat("/")) {
                // 1-line comment
                stream.skipToEnd();
                return "comment";
            } else if (support.commentHash && ch == "#" || ch == "-" && stream.eat("-") && (!support.commentSpaceRequired || stream.eat(" "))) {
                // 1-line comments
                // ref: https://kb.askmonty.org/en/comment-syntax/
                stream.skipToEnd();
                return "comment";
            } else if (ch == "/" && stream.eat("*")) {
                // multi-line comments
                // ref: https://kb.askmonty.org/en/comment-syntax/
                state.tokenize = tokenComment(1);
                return state.tokenize(stream, state);
            } else if (ch == ".") {
                // .1 for 0.1
                if (support.zerolessFloat && stream.match(/^(?:\d+(?:e[+-]?\d+)?)/i)) return "number";
                if (stream.match(/^\.+/)) return null;
                // .table_name (ODBC)
                // // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
                if (support.ODBCdotTable && stream.match(/^[\w\d_$#]+/)) return "variable-2";
            } else if (operatorChars.test(ch)) {
                // operators
                stream.eatWhile(operatorChars);
                return "operator";
            } else if (brackets.test(ch)) // brackets
            return "bracket";
            else if (punctuation.test(ch)) {
                // punctuation
                stream.eatWhile(punctuation);
                return "punctuation";
            } else if (ch == "{" && (stream.match(/^( )*(d|D|t|T|ts|TS)( )*'[^']*'( )*}/) || stream.match(/^( )*(d|D|t|T|ts|TS)( )*"[^"]*"( )*}/))) // dates (weird ODBC syntax)
            // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
            return "number";
            else {
                stream.eatWhile(/^[_\w\d]/);
                var word = stream.current().toLowerCase();
                // dates (standard SQL syntax)
                // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
                if (dateSQL.hasOwnProperty(word) && (stream.match(/^( )+'[^']*'/) || stream.match(/^( )+"[^"]*"/))) return "number";
                if (atoms.hasOwnProperty(word)) return "atom";
                if (builtin.hasOwnProperty(word)) return "builtin";
                if (keywords.hasOwnProperty(word)) return "keyword";
                if (client.hasOwnProperty(word)) return "string-2";
                return null;
            }
        }
        // 'string', with char specified in quote escaped by '\'
        function tokenLiteral(quote, backslashEscapes) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        state.tokenize = tokenBase;
                        break;
                    }
                    escaped = (backslashStringEscapes || backslashEscapes) && !escaped && ch == "\\";
                }
                return "string";
            };
        }
        function tokenComment(depth) {
            return function(stream, state) {
                var m = stream.match(/^.*?(\/\*|\*\/)/);
                if (!m) stream.skipToEnd();
                else if (m[1] == "/*") state.tokenize = tokenComment(depth + 1);
                else if (depth > 1) state.tokenize = tokenComment(depth - 1);
                else state.tokenize = tokenBase;
                return "comment";
            };
        }
        function pushContext(stream, state, type) {
            state.context = {
                prev: state.context,
                indent: stream.indentation(),
                col: stream.column(),
                type: type
            };
        }
        function popContext(state) {
            state.indent = state.context.indent;
            state.context = state.context.prev;
        }
        return {
            startState: function() {
                return {
                    tokenize: tokenBase,
                    context: null
                };
            },
            token: function(stream, state) {
                if (stream.sol()) {
                    if (state.context && state.context.align == null) state.context.align = false;
                }
                if (state.tokenize == tokenBase && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (style == "comment") return style;
                if (state.context && state.context.align == null) state.context.align = true;
                var tok = stream.current();
                if (tok == "(") pushContext(stream, state, ")");
                else if (tok == "[") pushContext(stream, state, "]");
                else if (state.context && state.context.type == tok) popContext(state);
                return style;
            },
            indent: function(state, textAfter) {
                var cx = state.context;
                if (!cx) return CodeMirror.Pass;
                var closing = textAfter.charAt(0) == cx.type;
                if (cx.align) return cx.col + (closing ? 0 : 1);
                else return cx.indent + (closing ? 0 : config.indentUnit);
            },
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: support.commentSlashSlash ? "//" : support.commentHash ? "#" : "--",
            closeBrackets: "()[]{}''\"\"``"
        };
    });
    // `identifier`
    function hookIdentifier(stream) {
        // MySQL/MariaDB identifiers
        // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
        var ch;
        while((ch = stream.next()) != null){
            if (ch == "`" && !stream.eat("`")) return "variable-2";
        }
        stream.backUp(stream.current().length - 1);
        return stream.eatWhile(/\w/) ? "variable-2" : null;
    }
    // "identifier"
    function hookIdentifierDoublequote(stream) {
        // Standard SQL /SQLite identifiers
        // ref: http://web.archive.org/web/20160813185132/http://savage.net.au/SQL/sql-99.bnf.html#delimited%20identifier
        // ref: http://sqlite.org/lang_keywords.html
        var ch;
        while((ch = stream.next()) != null){
            if (ch == '"' && !stream.eat('"')) return "variable-2";
        }
        stream.backUp(stream.current().length - 1);
        return stream.eatWhile(/\w/) ? "variable-2" : null;
    }
    // variable token
    function hookVar(stream) {
        // variables
        // @@prefix.varName @varName
        // varName can be quoted with ` or ' or "
        // ref: http://dev.mysql.com/doc/refman/5.5/en/user-variables.html
        if (stream.eat("@")) {
            stream.match("session.");
            stream.match("local.");
            stream.match("global.");
        }
        if (stream.eat("'")) {
            stream.match(/^.*'/);
            return "variable-2";
        } else if (stream.eat('"')) {
            stream.match(/^.*"/);
            return "variable-2";
        } else if (stream.eat("`")) {
            stream.match(/^.*`/);
            return "variable-2";
        } else if (stream.match(/^[0-9a-zA-Z$\.\_]+/)) return "variable-2";
        return null;
    }
    // short client keyword token
    function hookClient(stream) {
        // \N means NULL
        // ref: http://dev.mysql.com/doc/refman/5.5/en/null-values.html
        if (stream.eat("N")) return "atom";
        // \g, etc
        // ref: http://dev.mysql.com/doc/refman/5.5/en/mysql-commands.html
        return stream.match(/^[a-zA-Z.#!?]/) ? "variable-2" : null;
    }
    // these keywords are used by all SQL dialects (however, a mode can still overwrite it)
    var sqlKeywords = "alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit ";
    // turn a space-separated list into an array
    function set(str) {
        var obj = {}, words = str.split(" ");
        for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
        return obj;
    }
    var defaultBuiltin = "bool boolean bit blob enum long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision real date datetime year unsigned signed decimal numeric";
    // A generic SQL Mode. It's not a standard, it just try to support what is generally supported
    CodeMirror.defineMIME("text/x-sql", {
        name: "sql",
        keywords: set(sqlKeywords + "begin"),
        builtin: set(defaultBuiltin),
        atoms: set("false true null unknown"),
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
    });
    CodeMirror.defineMIME("text/x-mssql", {
        name: "sql",
        client: set("$partition binary_checksum checksum connectionproperty context_info current_request_id error_line error_message error_number error_procedure error_severity error_state formatmessage get_filestream_transaction_context getansinull host_id host_name isnull isnumeric min_active_rowversion newid newsequentialid rowcount_big xact_state object_id"),
        keywords: set(sqlKeywords + "begin trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec go if use index holdlock nolock nowait paglock readcommitted readcommittedlock readpast readuncommitted repeatableread rowlock serializable snapshot tablock tablockx updlock with"),
        builtin: set("bigint numeric bit smallint decimal smallmoney int tinyint money float real char varchar text nchar nvarchar ntext binary varbinary image cursor timestamp hierarchyid uniqueidentifier sql_variant xml table "),
        atoms: set("is not null like and or in left right between inner outer join all any some cross unpivot pivot exists"),
        operatorChars: /^[*+\-%<>!=^\&|\/]/,
        brackets: /^[\{}\(\)]/,
        punctuation: /^[;.,:/]/,
        backslashStringEscapes: false,
        dateSQL: set("date datetimeoffset datetime2 smalldatetime datetime time"),
        hooks: {
            "@": hookVar
        }
    });
    CodeMirror.defineMIME("text/x-mysql", {
        name: "sql",
        client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
        keywords: set(sqlKeywords + "accessible action add after algorithm all analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general get global grant grants group group_concat handler hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show signal slave slow smallint snapshot soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
        hooks: {
            "@": hookVar,
            "`": hookIdentifier,
            "\\": hookClient
        }
    });
    CodeMirror.defineMIME("text/x-mariadb", {
        name: "sql",
        client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
        keywords: set(sqlKeywords + "accessible action add after algorithm all always analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general generated get global grant grants group groupby_concat handler hard hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password persistent phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show shutdown signal slave slow smallint snapshot soft soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views virtual warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
        hooks: {
            "@": hookVar,
            "`": hookIdentifier,
            "\\": hookClient
        }
    });
    // provided by the phpLiteAdmin project - phpliteadmin.org
    CodeMirror.defineMIME("text/x-sqlite", {
        name: "sql",
        // commands of the official SQLite client, ref: https://www.sqlite.org/cli.html#dotcmd
        client: set("auth backup bail binary changes check clone databases dbinfo dump echo eqp exit explain fullschema headers help import imposter indexes iotrace limit lint load log mode nullvalue once open output print prompt quit read restore save scanstats schema separator session shell show stats system tables testcase timeout timer trace vfsinfo vfslist vfsname width"),
        // ref: http://sqlite.org/lang_keywords.html
        keywords: set(sqlKeywords + "abort action add after all analyze attach autoincrement before begin cascade case cast check collate column commit conflict constraint cross current_date current_time current_timestamp database default deferrable deferred detach each else end escape except exclusive exists explain fail for foreign full glob if ignore immediate index indexed initially inner instead intersect isnull key left limit match natural no notnull null of offset outer plan pragma primary query raise recursive references regexp reindex release rename replace restrict right rollback row savepoint temp temporary then to transaction trigger unique using vacuum view virtual when with without"),
        // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text clob bigint int int2 int8 integer float double char varchar date datetime year unsigned signed numeric real"),
        // ref: http://sqlite.org/syntax/literal-value.html
        atoms: set("null current_date current_time current_timestamp"),
        // ref: http://sqlite.org/lang_expr.html#binaryops
        operatorChars: /^[*+\-%<>!=&|/~]/,
        // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
        dateSQL: set("date time timestamp datetime"),
        support: set("decimallessFloat zerolessFloat"),
        identifierQuote: '"',
        hooks: {
            // bind-parameters ref:http://sqlite.org/lang_expr.html#varparam
            "@": hookVar,
            ":": hookVar,
            "?": hookVar,
            "$": hookVar,
            // The preferred way to escape Identifiers is using double quotes, ref: http://sqlite.org/lang_keywords.html
            '"': hookIdentifierDoublequote,
            // there is also support for backticks, ref: http://sqlite.org/lang_keywords.html
            "`": hookIdentifier
        }
    });
    // the query language used by Apache Cassandra is called CQL, but this mime type
    // is called Cassandra to avoid confusion with Contextual Query Language
    CodeMirror.defineMIME("text/x-cassandra", {
        name: "sql",
        client: {},
        keywords: set("add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime"),
        builtin: set("ascii bigint blob boolean counter decimal double float frozen inet int list map static text timestamp timeuuid tuple uuid varchar varint"),
        atoms: set("false true infinity NaN"),
        operatorChars: /^[<>=]/,
        dateSQL: {},
        support: set("commentSlashSlash decimallessFloat"),
        hooks: {}
    });
    // this is based on Peter Raganitsch's 'plsql' mode
    CodeMirror.defineMIME("text/x-plsql", {
        name: "sql",
        client: set("appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define describe echo editfile embedded escape exec execute feedback flagger flush heading headsep instance linesize lno loboffset logsource long longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar release repfooter repheader serveroutput shiftinout show showmode size spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout time timing trimout trimspool ttitle underline verify version wrap"),
        keywords: set("abort accept access add all alter and any array arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body boolean by case cast char char_base check close cluster clusters colauth column comment commit compress connect connected constant constraint crash create current currval cursor data_base database date dba deallocate debugoff debugon decimal declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry escape exception exception_init exchange exclusive exists exit external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging long loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base object of off offline on online only open option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw read rebuild record ref references refresh release rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate session set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work"),
        builtin: set("abs acos add_months ascii asin atan atan2 average bfile bfilename bigserial bit blob ceil character chartorowid chr clob concat convert cos cosh count dec decode deref dual dump dup_val_on_index empty error exp false float floor found glb greatest hextoraw initcap instr instrb int integer isopen last_day least length lengthb ln lower lpad ltrim lub make_ref max min mlslabel mod months_between natural naturaln nchar nclob new_time next_day nextval nls_charset_decl_len nls_charset_id nls_charset_name nls_initcap nls_lower nls_sort nls_upper nlssort no_data_found notfound null number numeric nvarchar2 nvl others power rawtohex real reftohex round rowcount rowidtochar rowtype rpad rtrim serial sign signtype sin sinh smallint soundex sqlcode sqlerrm sqrt stddev string substr substrb sum sysdate tan tanh to_char text to_date to_label to_multi_byte to_number to_single_byte translate true trunc uid unlogged upper user userenv varchar varchar2 variance varying vsize xml"),
        operatorChars: /^[*\/+\-%<>!=~]/,
        dateSQL: set("date time timestamp"),
        support: set("doubleQuote nCharCast zerolessFloat binaryNumber hexNumber")
    });
    // Created to support specific hive keywords
    CodeMirror.defineMIME("text/x-hive", {
        name: "sql",
        keywords: set("select alter $elem$ $key$ $value$ add after all analyze and archive as asc before between binary both bucket buckets by cascade case cast change cluster clustered clusterstatus collection column columns comment compute concatenate continue create cross cursor data database databases dbproperties deferred delete delimited desc describe directory disable distinct distribute drop else enable end escaped exclusive exists explain export extended external fetch fields fileformat first format formatted from full function functions grant group having hold_ddltime idxproperties if import in index indexes inpath inputdriver inputformat insert intersect into is items join keys lateral left like limit lines load local location lock locks mapjoin materialized minus msck no_drop nocompress not of offline on option or order out outer outputdriver outputformat overwrite partition partitioned partitions percent plus preserve procedure purge range rcfile read readonly reads rebuild recordreader recordwriter recover reduce regexp rename repair replace restrict revoke right rlike row schema schemas semi sequencefile serde serdeproperties set shared show show_database sort sorted ssl statistics stored streamtable table tables tablesample tblproperties temporary terminated textfile then tmp to touch transform trigger unarchive undo union uniquejoin unlock update use using utc utc_tmestamp view when where while with admin authorization char compact compactions conf cube current current_date current_timestamp day decimal defined dependency directories elem_type exchange file following for grouping hour ignore inner interval jar less logical macro minute month more none noscan over owner partialscan preceding pretty principals protection reload rewrite role roles rollup rows second server sets skewed transactions truncate unbounded unset uri user values window year"),
        builtin: set("bool boolean long timestamp tinyint smallint bigint int float double date datetime unsigned string array struct map uniontype key_type utctimestamp value_type varchar"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=]/,
        dateSQL: set("date timestamp"),
        support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
    });
    CodeMirror.defineMIME("text/x-pgsql", {
        name: "sql",
        client: set("source"),
        // For PostgreSQL - https://www.postgresql.org/docs/11/sql-keywords-appendix.html
        // For pl/pgsql lang - https://github.com/postgres/postgres/blob/REL_11_2/src/pl/plpgsql/src/pl_scanner.c
        keywords: set(sqlKeywords + "a abort abs absent absolute access according action ada add admin after aggregate alias all allocate also alter always analyse analyze and any are array array_agg array_max_cardinality as asc asensitive assert assertion assignment asymmetric at atomic attach attribute attributes authorization avg backward base64 before begin begin_frame begin_partition bernoulli between bigint binary bit bit_length blob blocked bom boolean both breadth by c cache call called cardinality cascade cascaded case cast catalog catalog_name ceil ceiling chain char char_length character character_length character_set_catalog character_set_name character_set_schema characteristics characters check checkpoint class class_origin clob close cluster coalesce cobol collate collation collation_catalog collation_name collation_schema collect column column_name columns command_function command_function_code comment comments commit committed concurrently condition condition_number configuration conflict connect connection connection_name constant constraint constraint_catalog constraint_name constraint_schema constraints constructor contains content continue control conversion convert copy corr corresponding cost count covar_pop covar_samp create cross csv cube cume_dist current current_catalog current_date current_default_transform_group current_path current_role current_row current_schema current_time current_timestamp current_transform_group_for_type current_user cursor cursor_name cycle data database datalink datatype date datetime_interval_code datetime_interval_precision day db deallocate debug dec decimal declare default defaults deferrable deferred defined definer degree delete delimiter delimiters dense_rank depends depth deref derived desc describe descriptor detach detail deterministic diagnostics dictionary disable discard disconnect dispatch distinct dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue do document domain double drop dump dynamic dynamic_function dynamic_function_code each element else elseif elsif empty enable encoding encrypted end end_frame end_partition endexec enforced enum equals errcode error escape event every except exception exclude excluding exclusive exec execute exists exit exp explain expression extension external extract false family fetch file filter final first first_value flag float floor following for force foreach foreign fortran forward found frame_row free freeze from fs full function functions fusion g general generated get global go goto grant granted greatest group grouping groups handler having header hex hierarchy hint hold hour id identity if ignore ilike immediate immediately immutable implementation implicit import in include including increment indent index indexes indicator info inherit inherits initially inline inner inout input insensitive insert instance instantiable instead int integer integrity intersect intersection interval into invoker is isnull isolation join k key key_member key_type label lag language large last last_value lateral lead leading leakproof least left length level library like like_regex limit link listen ln load local localtime localtimestamp location locator lock locked log logged loop lower m map mapping match matched materialized max max_cardinality maxvalue member merge message message_length message_octet_length message_text method min minute minvalue mod mode modifies module month more move multiset mumps name names namespace national natural nchar nclob nesting new next nfc nfd nfkc nfkd nil no none normalize normalized not nothing notice notify notnull nowait nth_value ntile null nullable nullif nulls number numeric object occurrences_regex octet_length octets of off offset oids old on only open operator option options or order ordering ordinality others out outer output over overlaps overlay overriding owned owner p pad parallel parameter parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partial partition pascal passing passthrough password path percent percent_rank percentile_cont percentile_disc perform period permission pg_context pg_datatype_name pg_exception_context pg_exception_detail pg_exception_hint placing plans pli policy portion position position_regex power precedes preceding precision prepare prepared preserve primary print_strict_params prior privileges procedural procedure procedures program public publication query quote raise range rank read reads real reassign recheck recovery recursive ref references referencing refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex relative release rename repeatable replace replica requiring reset respect restart restore restrict result result_oid return returned_cardinality returned_length returned_octet_length returned_sqlstate returning returns reverse revoke right role rollback rollup routine routine_catalog routine_name routine_schema routines row row_count row_number rows rowtype rule savepoint scale schema schema_name schemas scope scope_catalog scope_name scope_schema scroll search second section security select selective self sensitive sequence sequences serializable server server_name session session_user set setof sets share show similar simple size skip slice smallint snapshot some source space specific specific_name specifictype sql sqlcode sqlerror sqlexception sqlstate sqlwarning sqrt stable stacked standalone start state statement static statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset subscription substring substring_regex succeeds sum symmetric sysid system system_time system_user t table table_name tables tablesample tablespace temp template temporary text then ties time timestamp timezone_hour timezone_minute to token top_level_count trailing transaction transaction_active transactions_committed transactions_rolled_back transform transforms translate translate_regex translation treat trigger trigger_catalog trigger_name trigger_schema trim trim_array true truncate trusted type types uescape unbounded uncommitted under unencrypted union unique unknown unlink unlisten unlogged unnamed unnest until untyped update upper uri usage use_column use_variable user user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema using vacuum valid validate validator value value_of values var_pop var_samp varbinary varchar variable_conflict variadic varying verbose version versioning view views volatile warning when whenever where while whitespace width_bucket window with within without work wrapper write xml xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate year yes zone"),
        // https://www.postgresql.org/docs/11/datatype.html
        builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*\/+\-%<>!=&|^\/#@?~]/,
        backslashStringEscapes: false,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast escapeConstant")
    });
    // Google's SQL-like query language, GQL
    CodeMirror.defineMIME("text/x-gql", {
        name: "sql",
        keywords: set("ancestor and asc by contains desc descendant distinct from group has in is limit offset on order select superset where"),
        atoms: set("false true"),
        builtin: set("blob datetime first key __key__ string integer double boolean null"),
        operatorChars: /^[*+\-%<>!=]/
    });
    // Greenplum
    CodeMirror.defineMIME("text/x-gpsql", {
        name: "sql",
        client: set("source"),
        //https://github.com/greenplum-db/gpdb/blob/master/src/include/parser/kwlist.h
        keywords: set("abort absolute access action active add admin after aggregate all also alter always analyse analyze and any array as asc assertion assignment asymmetric at authorization backward before begin between bigint binary bit boolean both by cache called cascade cascaded case cast chain char character characteristics check checkpoint class close cluster coalesce codegen collate column comment commit committed concurrency concurrently configuration connection constraint constraints contains content continue conversion copy cost cpu_rate_limit create createdb createexttable createrole createuser cross csv cube current current_catalog current_date current_role current_schema current_time current_timestamp current_user cursor cycle data database day deallocate dec decimal declare decode default defaults deferrable deferred definer delete delimiter delimiters deny desc dictionary disable discard distinct distributed do document domain double drop dxl each else enable encoding encrypted end enum errors escape every except exchange exclude excluding exclusive execute exists explain extension external extract false family fetch fields filespace fill filter first float following for force foreign format forward freeze from full function global grant granted greatest group group_id grouping handler hash having header hold host hour identity if ignore ilike immediate immutable implicit in including inclusive increment index indexes inherit inherits initially inline inner inout input insensitive insert instead int integer intersect interval into invoker is isnull isolation join key language large last leading least left level like limit list listen load local localtime localtimestamp location lock log login mapping master match maxvalue median merge minute minvalue missing mode modifies modify month move name names national natural nchar new newline next no nocreatedb nocreateexttable nocreaterole nocreateuser noinherit nologin none noovercommit nosuperuser not nothing notify notnull nowait null nullif nulls numeric object of off offset oids old on only operator option options or order ordered others out outer over overcommit overlaps overlay owned owner parser partial partition partitions passing password percent percentile_cont percentile_disc placing plans position preceding precision prepare prepared preserve primary prior privileges procedural procedure protocol queue quote randomly range read readable reads real reassign recheck recursive ref references reindex reject relative release rename repeatable replace replica reset resource restart restrict returning returns revoke right role rollback rollup rootpartition row rows rule savepoint scatter schema scroll search second security segment select sequence serializable session session_user set setof sets share show similar simple smallint some split sql stable standalone start statement statistics stdin stdout storage strict strip subpartition subpartitions substring superuser symmetric sysid system table tablespace temp template temporary text then threshold ties time timestamp to trailing transaction treat trigger trim true truncate trusted type unbounded uncommitted unencrypted union unique unknown unlisten until update user using vacuum valid validation validator value values varchar variadic varying verbose version view volatile web when where whitespace window with within without work writable write xml xmlattributes xmlconcat xmlelement xmlexists xmlforest xmlparse xmlpi xmlroot xmlserialize year yes zone"),
        builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast")
    });
    // Spark SQL
    CodeMirror.defineMIME("text/x-sparksql", {
        name: "sql",
        keywords: set("add after all alter analyze and anti archive array as asc at between bucket buckets by cache cascade case cast change clear cluster clustered codegen collection column columns comment commit compact compactions compute concatenate cost create cross cube current current_date current_timestamp database databases data dbproperties defined delete delimited deny desc describe dfs directories distinct distribute drop else end escaped except exchange exists explain export extended external false fields fileformat first following for format formatted from full function functions global grant group grouping having if ignore import in index indexes inner inpath inputformat insert intersect interval into is items join keys last lateral lazy left like limit lines list load local location lock locks logical macro map minus msck natural no not null nulls of on optimize option options or order out outer outputformat over overwrite partition partitioned partitions percent preceding principals purge range recordreader recordwriter recover reduce refresh regexp rename repair replace reset restrict revoke right rlike role roles rollback rollup row rows schema schemas select semi separated serde serdeproperties set sets show skewed sort sorted start statistics stored stratify struct table tables tablesample tblproperties temp temporary terminated then to touch transaction transactions transform true truncate unarchive unbounded uncache union unlock unset use using values view when where window with"),
        builtin: set("tinyint smallint int bigint boolean float double string binary timestamp decimal array map struct uniontype delimited serde sequencefile textfile rcfile inputformat outputformat"),
        atoms: set("false true null"),
        operatorChars: /^[*\/+\-%<>!=~&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable doubleQuote zerolessFloat")
    });
    // Esper
    CodeMirror.defineMIME("text/x-esper", {
        name: "sql",
        client: set("source"),
        // http://www.espertech.com/esper/release-5.5.0/esper-reference/html/appendix_keywords.html
        keywords: set("alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit after all and as at asc avedev avg between by case cast coalesce count create current_timestamp day days delete define desc distinct else end escape events every exists false first from full group having hour hours in inner insert instanceof into irstream is istream join last lastweekday left limit like max match_recognize matches median measures metadatasql min minute minutes msec millisecond milliseconds not null offset on or order outer output partition pattern prev prior regexp retain-union retain-intersection right rstream sec second seconds select set some snapshot sql stddev sum then true unidirectional until update variable weekday when where window"),
        builtin: {},
        atoms: set("false true null"),
        operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
        dateSQL: set("time"),
        support: set("decimallessFloat zerolessFloat binaryNumber hexNumber")
    });
}); /*
  How Properties of Mime Types are used by SQL Mode
  =================================================

  keywords:
    A list of keywords you want to be highlighted.
  builtin:
    A list of builtin types you want to be highlighted (if you want types to be of class "builtin" instead of "keyword").
  operatorChars:
    All characters that must be handled as operators.
  client:
    Commands parsed and executed by the client (not the server).
  support:
    A list of supported syntaxes which are not common, but are supported by more than 1 DBMS.
    * ODBCdotTable: .tableName
    * zerolessFloat: .1
    * doubleQuote
    * nCharCast: N'string'
    * charsetCast: _utf8'string'
    * commentHash: use # char for comments
    * commentSlashSlash: use // for comments
    * commentSpaceRequired: require a space after -- for comments
  atoms:
    Keywords that must be highlighted as atoms,. Some DBMS's support more atoms than others:
    UNKNOWN, INFINITY, UNDERFLOW, NaN...
  dateSQL:
    Used for date/time SQL standard syntax, because not all DBMS's support same temporal types.
*/ 

},{"383741b9a1300259":"akde7"}],"8ZPxM":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// Utility function that allows modes to be combined. The mode given
// as the base argument takes care of most of the normal mode
// functionality, but a second (typically simple) mode is used, which
// can override the style of text. Both modes get to parse all of the
// text, but when both assign a non-null style to a piece of code, the
// overlay wins, unless the combine argument was true and not overridden,
// or state.overlay.combineTokens was true, in which case the styles are
// combined.
(function(mod) {
    mod(require("8291dfc263560ff3"));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.overlayMode = function(base, overlay, combine) {
        return {
            startState: function() {
                return {
                    base: CodeMirror.startState(base),
                    overlay: CodeMirror.startState(overlay),
                    basePos: 0,
                    baseCur: null,
                    overlayPos: 0,
                    overlayCur: null,
                    streamSeen: null
                };
            },
            copyState: function(state) {
                return {
                    base: CodeMirror.copyState(base, state.base),
                    overlay: CodeMirror.copyState(overlay, state.overlay),
                    basePos: state.basePos,
                    baseCur: null,
                    overlayPos: state.overlayPos,
                    overlayCur: null
                };
            },
            token: function(stream, state) {
                if (stream != state.streamSeen || Math.min(state.basePos, state.overlayPos) < stream.start) {
                    state.streamSeen = stream;
                    state.basePos = state.overlayPos = stream.start;
                }
                if (stream.start == state.basePos) {
                    state.baseCur = base.token(stream, state.base);
                    state.basePos = stream.pos;
                }
                if (stream.start == state.overlayPos) {
                    stream.pos = stream.start;
                    state.overlayCur = overlay.token(stream, state.overlay);
                    state.overlayPos = stream.pos;
                }
                stream.pos = Math.min(state.basePos, state.overlayPos);
                // state.overlay.combineTokens always takes precedence over combine,
                // unless set to null
                if (state.overlayCur == null) return state.baseCur;
                else if (state.baseCur != null && state.overlay.combineTokens || combine && state.overlay.combineTokens == null) return state.baseCur + " " + state.overlayCur;
                else return state.overlayCur;
            },
            indent: base.indent && function(state, textAfter, line) {
                return base.indent(state.base, textAfter, line);
            },
            electricChars: base.electricChars,
            innerMode: function(state) {
                return {
                    state: state.base,
                    mode: base
                };
            },
            blankLine: function(state) {
                var baseToken, overlayToken;
                if (base.blankLine) baseToken = base.blankLine(state.base);
                if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);
                return overlayToken == null ? baseToken : combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken;
            }
        };
    };
});

},{"8291dfc263560ff3":"akde7"}],"9B1o7":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(require("b71448171334a2b2"));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineMode("css", function(config, parserConfig) {
        var inline = parserConfig.inline;
        if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
        var indentUnit = config.indentUnit, tokenHooks = parserConfig.tokenHooks, documentTypes = parserConfig.documentTypes || {}, mediaTypes = parserConfig.mediaTypes || {}, mediaFeatures = parserConfig.mediaFeatures || {}, mediaValueKeywords = parserConfig.mediaValueKeywords || {}, propertyKeywords = parserConfig.propertyKeywords || {}, nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {}, fontProperties = parserConfig.fontProperties || {}, counterDescriptors = parserConfig.counterDescriptors || {}, colorKeywords = parserConfig.colorKeywords || {}, valueKeywords = parserConfig.valueKeywords || {}, allowNested = parserConfig.allowNested, lineComment = parserConfig.lineComment, supportsAtComponent = parserConfig.supportsAtComponent === true, highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
        var type, override;
        function ret(style, tp) {
            type = tp;
            return style;
        }
        // Tokenizers
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (tokenHooks[ch]) {
                var result = tokenHooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (ch == "@") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("def", stream.current());
            } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) return ret(null, "compare");
            else if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "#") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("atom", "hash");
            } else if (ch == "!") {
                stream.match(/^\s*\w*/);
                return ret("keyword", "important");
            } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
                stream.eatWhile(/[\w.%]/);
                return ret("number", "unit");
            } else if (ch === "-") {
                if (/[\d.]/.test(stream.peek())) {
                    stream.eatWhile(/[\w.%]/);
                    return ret("number", "unit");
                } else if (stream.match(/^-[\w\\\-]*/)) {
                    stream.eatWhile(/[\w\\\-]/);
                    if (stream.match(/^\s*:/, false)) return ret("variable-2", "variable-definition");
                    return ret("variable-2", "variable");
                } else if (stream.match(/^\w+-/)) return ret("meta", "meta");
            } else if (/[,+>*\/]/.test(ch)) return ret(null, "select-op");
            else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) return ret("qualifier", "qualifier");
            else if (/[:;{}\[\]\(\)]/.test(ch)) return ret(null, ch);
            else if (stream.match(/^[\w-.]+(?=\()/)) {
                if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) state.tokenize = tokenParenthesized;
                return ret("variable callee", "variable");
            } else if (/[\w\\\-]/.test(ch)) {
                stream.eatWhile(/[\w\\\-]/);
                return ret("property", "word");
            } else return ret(null, null);
        }
        function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        if (quote == ")") stream.backUp(1);
                        break;
                    }
                    escaped = !escaped && ch == "\\";
                }
                if (ch == quote || !escaped && quote != ")") state.tokenize = null;
                return ret("string", "string");
            };
        }
        function tokenParenthesized(stream, state) {
            stream.next(); // Must be '('
            if (!stream.match(/^\s*[\"\')]/, false)) state.tokenize = tokenString(")");
            else state.tokenize = null;
            return ret(null, "(");
        }
        // Context management
        function Context(type, indent, prev) {
            this.type = type;
            this.indent = indent;
            this.prev = prev;
        }
        function pushContext(state, stream, type, indent) {
            state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
            return type;
        }
        function popContext(state) {
            if (state.context.prev) state.context = state.context.prev;
            return state.context.type;
        }
        function pass(type, stream, state) {
            return states[state.context.type](type, stream, state);
        }
        function popAndPass(type, stream, state, n) {
            for(var i = n || 1; i > 0; i--)state.context = state.context.prev;
            return pass(type, stream, state);
        }
        // Parser
        function wordAsValue(stream) {
            var word = stream.current().toLowerCase();
            if (valueKeywords.hasOwnProperty(word)) override = "atom";
            else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
            else override = "variable";
        }
        var states = {};
        states.top = function(type, stream, state) {
            if (type == "{") return pushContext(state, stream, "block");
            else if (type == "}" && state.context.prev) return popContext(state);
            else if (supportsAtComponent && /@component/i.test(type)) return pushContext(state, stream, "atComponentBlock");
            else if (/^@(-moz-)?document$/i.test(type)) return pushContext(state, stream, "documentTypes");
            else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) return pushContext(state, stream, "atBlock");
            else if (/^@(font-face|counter-style)/i.test(type)) {
                state.stateArg = type;
                return "restricted_atBlock_before";
            } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) return "keyframes";
            else if (type && type.charAt(0) == "@") return pushContext(state, stream, "at");
            else if (type == "hash") override = "builtin";
            else if (type == "word") override = "tag";
            else if (type == "variable-definition") return "maybeprop";
            else if (type == "interpolation") return pushContext(state, stream, "interpolation");
            else if (type == ":") return "pseudo";
            else if (allowNested && type == "(") return pushContext(state, stream, "parens");
            return state.context.type;
        };
        states.block = function(type, stream, state) {
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (propertyKeywords.hasOwnProperty(word)) {
                    override = "property";
                    return "maybeprop";
                } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
                    override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                    return "maybeprop";
                } else if (allowNested) {
                    override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
                    return "block";
                } else {
                    override += " error";
                    return "maybeprop";
                }
            } else if (type == "meta") return "block";
            else if (!allowNested && (type == "hash" || type == "qualifier")) {
                override = "error";
                return "block";
            } else return states.top(type, stream, state);
        };
        states.maybeprop = function(type, stream, state) {
            if (type == ":") return pushContext(state, stream, "prop");
            return pass(type, stream, state);
        };
        states.prop = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
            if (type == "}" || type == "{") return popAndPass(type, stream, state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) override += " error";
            else if (type == "word") wordAsValue(stream);
            else if (type == "interpolation") return pushContext(state, stream, "interpolation");
            return "prop";
        };
        states.propBlock = function(type, _stream, state) {
            if (type == "}") return popContext(state);
            if (type == "word") {
                override = "property";
                return "maybeprop";
            }
            return state.context.type;
        };
        states.parens = function(type, stream, state) {
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == ")") return popContext(state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") wordAsValue(stream);
            return "parens";
        };
        states.pseudo = function(type, stream, state) {
            if (type == "meta") return "pseudo";
            if (type == "word") {
                override = "variable-3";
                return state.context.type;
            }
            return pass(type, stream, state);
        };
        states.documentTypes = function(type, stream, state) {
            if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
                override = "tag";
                return state.context.type;
            } else return states.atBlock(type, stream, state);
        };
        states.atBlock = function(type, stream, state) {
            if (type == "(") return pushContext(state, stream, "atBlock_parens");
            if (type == "}" || type == ";") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (word == "only" || word == "not" || word == "and" || word == "or") override = "keyword";
                else if (mediaTypes.hasOwnProperty(word)) override = "attribute";
                else if (mediaFeatures.hasOwnProperty(word)) override = "property";
                else if (mediaValueKeywords.hasOwnProperty(word)) override = "keyword";
                else if (propertyKeywords.hasOwnProperty(word)) override = "property";
                else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                else if (valueKeywords.hasOwnProperty(word)) override = "atom";
                else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
                else override = "error";
            }
            return state.context.type;
        };
        states.atComponentBlock = function(type, stream, state) {
            if (type == "}") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
            if (type == "word") override = "error";
            return state.context.type;
        };
        states.atBlock_parens = function(type, stream, state) {
            if (type == ")") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
            return states.atBlock(type, stream, state);
        };
        states.restricted_atBlock_before = function(type, stream, state) {
            if (type == "{") return pushContext(state, stream, "restricted_atBlock");
            if (type == "word" && state.stateArg == "@counter-style") {
                override = "variable";
                return "restricted_atBlock_before";
            }
            return pass(type, stream, state);
        };
        states.restricted_atBlock = function(type, stream, state) {
            if (type == "}") {
                state.stateArg = null;
                return popContext(state);
            }
            if (type == "word") {
                if (state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase()) || state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())) override = "error";
                else override = "property";
                return "maybeprop";
            }
            return "restricted_atBlock";
        };
        states.keyframes = function(type, stream, state) {
            if (type == "word") {
                override = "variable";
                return "keyframes";
            }
            if (type == "{") return pushContext(state, stream, "top");
            return pass(type, stream, state);
        };
        states.at = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == "word") override = "tag";
            else if (type == "hash") override = "builtin";
            return "at";
        };
        states.interpolation = function(type, stream, state) {
            if (type == "}") return popContext(state);
            if (type == "{" || type == ";") return popAndPass(type, stream, state);
            if (type == "word") override = "variable";
            else if (type != "variable" && type != "(" && type != ")") override = "error";
            return "interpolation";
        };
        return {
            startState: function(base) {
                return {
                    tokenize: null,
                    state: inline ? "block" : "top",
                    stateArg: null,
                    context: new Context(inline ? "block" : "top", base || 0, null)
                };
            },
            token: function(stream, state) {
                if (!state.tokenize && stream.eatSpace()) return null;
                var style = (state.tokenize || tokenBase)(stream, state);
                if (style && typeof style == "object") {
                    type = style[1];
                    style = style[0];
                }
                override = style;
                if (type != "comment") state.state = states[state.state](type, stream, state);
                return override;
            },
            indent: function(state, textAfter) {
                var cx = state.context, ch = textAfter && textAfter.charAt(0);
                var indent = cx.indent;
                if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
                if (cx.prev) {
                    if (ch == "}" && (cx.type == "block" || cx.type == "top" || cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
                        // Resume indentation from parent context.
                        cx = cx.prev;
                        indent = cx.indent;
                    } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && (cx.type == "at" || cx.type == "atBlock")) // Dedent relative to current context.
                    indent = Math.max(0, cx.indent - indentUnit);
                }
                return indent;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: lineComment,
            fold: "brace"
        };
    });
    function keySet(array) {
        var keys = {};
        for(var i = 0; i < array.length; ++i)keys[array[i].toLowerCase()] = true;
        return keys;
    }
    var documentTypes_ = [
        "domain",
        "regexp",
        "url",
        "url-prefix"
    ], documentTypes = keySet(documentTypes_);
    var mediaTypes_ = [
        "all",
        "aural",
        "braille",
        "handheld",
        "print",
        "projection",
        "screen",
        "tty",
        "tv",
        "embossed"
    ], mediaTypes = keySet(mediaTypes_);
    var mediaFeatures_ = [
        "width",
        "min-width",
        "max-width",
        "height",
        "min-height",
        "max-height",
        "device-width",
        "min-device-width",
        "max-device-width",
        "device-height",
        "min-device-height",
        "max-device-height",
        "aspect-ratio",
        "min-aspect-ratio",
        "max-aspect-ratio",
        "device-aspect-ratio",
        "min-device-aspect-ratio",
        "max-device-aspect-ratio",
        "color",
        "min-color",
        "max-color",
        "color-index",
        "min-color-index",
        "max-color-index",
        "monochrome",
        "min-monochrome",
        "max-monochrome",
        "resolution",
        "min-resolution",
        "max-resolution",
        "scan",
        "grid",
        "orientation",
        "device-pixel-ratio",
        "min-device-pixel-ratio",
        "max-device-pixel-ratio",
        "pointer",
        "any-pointer",
        "hover",
        "any-hover",
        "prefers-color-scheme"
    ], mediaFeatures = keySet(mediaFeatures_);
    var mediaValueKeywords_ = [
        "landscape",
        "portrait",
        "none",
        "coarse",
        "fine",
        "on-demand",
        "hover",
        "interlace",
        "progressive",
        "dark",
        "light"
    ], mediaValueKeywords = keySet(mediaValueKeywords_);
    var propertyKeywords_ = [
        "align-content",
        "align-items",
        "align-self",
        "alignment-adjust",
        "alignment-baseline",
        "all",
        "anchor-point",
        "animation",
        "animation-delay",
        "animation-direction",
        "animation-duration",
        "animation-fill-mode",
        "animation-iteration-count",
        "animation-name",
        "animation-play-state",
        "animation-timing-function",
        "appearance",
        "azimuth",
        "backdrop-filter",
        "backface-visibility",
        "background",
        "background-attachment",
        "background-blend-mode",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-position-x",
        "background-position-y",
        "background-repeat",
        "background-size",
        "baseline-shift",
        "binding",
        "bleed",
        "block-size",
        "bookmark-label",
        "bookmark-level",
        "bookmark-state",
        "bookmark-target",
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-left-radius",
        "border-bottom-right-radius",
        "border-bottom-style",
        "border-bottom-width",
        "border-collapse",
        "border-color",
        "border-image",
        "border-image-outset",
        "border-image-repeat",
        "border-image-slice",
        "border-image-source",
        "border-image-width",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-radius",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-spacing",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-left-radius",
        "border-top-right-radius",
        "border-top-style",
        "border-top-width",
        "border-width",
        "bottom",
        "box-decoration-break",
        "box-shadow",
        "box-sizing",
        "break-after",
        "break-before",
        "break-inside",
        "caption-side",
        "caret-color",
        "clear",
        "clip",
        "color",
        "color-profile",
        "column-count",
        "column-fill",
        "column-gap",
        "column-rule",
        "column-rule-color",
        "column-rule-style",
        "column-rule-width",
        "column-span",
        "column-width",
        "columns",
        "contain",
        "content",
        "counter-increment",
        "counter-reset",
        "crop",
        "cue",
        "cue-after",
        "cue-before",
        "cursor",
        "direction",
        "display",
        "dominant-baseline",
        "drop-initial-after-adjust",
        "drop-initial-after-align",
        "drop-initial-before-adjust",
        "drop-initial-before-align",
        "drop-initial-size",
        "drop-initial-value",
        "elevation",
        "empty-cells",
        "fit",
        "fit-position",
        "flex",
        "flex-basis",
        "flex-direction",
        "flex-flow",
        "flex-grow",
        "flex-shrink",
        "flex-wrap",
        "float",
        "float-offset",
        "flow-from",
        "flow-into",
        "font",
        "font-family",
        "font-feature-settings",
        "font-kerning",
        "font-language-override",
        "font-optical-sizing",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-synthesis",
        "font-variant",
        "font-variant-alternates",
        "font-variant-caps",
        "font-variant-east-asian",
        "font-variant-ligatures",
        "font-variant-numeric",
        "font-variant-position",
        "font-variation-settings",
        "font-weight",
        "gap",
        "grid",
        "grid-area",
        "grid-auto-columns",
        "grid-auto-flow",
        "grid-auto-rows",
        "grid-column",
        "grid-column-end",
        "grid-column-gap",
        "grid-column-start",
        "grid-gap",
        "grid-row",
        "grid-row-end",
        "grid-row-gap",
        "grid-row-start",
        "grid-template",
        "grid-template-areas",
        "grid-template-columns",
        "grid-template-rows",
        "hanging-punctuation",
        "height",
        "hyphens",
        "icon",
        "image-orientation",
        "image-rendering",
        "image-resolution",
        "inline-box-align",
        "inset",
        "inset-block",
        "inset-block-end",
        "inset-block-start",
        "inset-inline",
        "inset-inline-end",
        "inset-inline-start",
        "isolation",
        "justify-content",
        "justify-items",
        "justify-self",
        "left",
        "letter-spacing",
        "line-break",
        "line-height",
        "line-height-step",
        "line-stacking",
        "line-stacking-ruby",
        "line-stacking-shift",
        "line-stacking-strategy",
        "list-style",
        "list-style-image",
        "list-style-position",
        "list-style-type",
        "margin",
        "margin-bottom",
        "margin-left",
        "margin-right",
        "margin-top",
        "marks",
        "marquee-direction",
        "marquee-loop",
        "marquee-play-count",
        "marquee-speed",
        "marquee-style",
        "mask-clip",
        "mask-composite",
        "mask-image",
        "mask-mode",
        "mask-origin",
        "mask-position",
        "mask-repeat",
        "mask-size",
        "mask-type",
        "max-block-size",
        "max-height",
        "max-inline-size",
        "max-width",
        "min-block-size",
        "min-height",
        "min-inline-size",
        "min-width",
        "mix-blend-mode",
        "move-to",
        "nav-down",
        "nav-index",
        "nav-left",
        "nav-right",
        "nav-up",
        "object-fit",
        "object-position",
        "offset",
        "offset-anchor",
        "offset-distance",
        "offset-path",
        "offset-position",
        "offset-rotate",
        "opacity",
        "order",
        "orphans",
        "outline",
        "outline-color",
        "outline-offset",
        "outline-style",
        "outline-width",
        "overflow",
        "overflow-style",
        "overflow-wrap",
        "overflow-x",
        "overflow-y",
        "padding",
        "padding-bottom",
        "padding-left",
        "padding-right",
        "padding-top",
        "page",
        "page-break-after",
        "page-break-before",
        "page-break-inside",
        "page-policy",
        "pause",
        "pause-after",
        "pause-before",
        "perspective",
        "perspective-origin",
        "pitch",
        "pitch-range",
        "place-content",
        "place-items",
        "place-self",
        "play-during",
        "position",
        "presentation-level",
        "punctuation-trim",
        "quotes",
        "region-break-after",
        "region-break-before",
        "region-break-inside",
        "region-fragment",
        "rendering-intent",
        "resize",
        "rest",
        "rest-after",
        "rest-before",
        "richness",
        "right",
        "rotate",
        "rotation",
        "rotation-point",
        "row-gap",
        "ruby-align",
        "ruby-overhang",
        "ruby-position",
        "ruby-span",
        "scale",
        "scroll-behavior",
        "scroll-margin",
        "scroll-margin-block",
        "scroll-margin-block-end",
        "scroll-margin-block-start",
        "scroll-margin-bottom",
        "scroll-margin-inline",
        "scroll-margin-inline-end",
        "scroll-margin-inline-start",
        "scroll-margin-left",
        "scroll-margin-right",
        "scroll-margin-top",
        "scroll-padding",
        "scroll-padding-block",
        "scroll-padding-block-end",
        "scroll-padding-block-start",
        "scroll-padding-bottom",
        "scroll-padding-inline",
        "scroll-padding-inline-end",
        "scroll-padding-inline-start",
        "scroll-padding-left",
        "scroll-padding-right",
        "scroll-padding-top",
        "scroll-snap-align",
        "scroll-snap-type",
        "shape-image-threshold",
        "shape-inside",
        "shape-margin",
        "shape-outside",
        "size",
        "speak",
        "speak-as",
        "speak-header",
        "speak-numeral",
        "speak-punctuation",
        "speech-rate",
        "stress",
        "string-set",
        "tab-size",
        "table-layout",
        "target",
        "target-name",
        "target-new",
        "target-position",
        "text-align",
        "text-align-last",
        "text-combine-upright",
        "text-decoration",
        "text-decoration-color",
        "text-decoration-line",
        "text-decoration-skip",
        "text-decoration-skip-ink",
        "text-decoration-style",
        "text-emphasis",
        "text-emphasis-color",
        "text-emphasis-position",
        "text-emphasis-style",
        "text-height",
        "text-indent",
        "text-justify",
        "text-orientation",
        "text-outline",
        "text-overflow",
        "text-rendering",
        "text-shadow",
        "text-size-adjust",
        "text-space-collapse",
        "text-transform",
        "text-underline-position",
        "text-wrap",
        "top",
        "touch-action",
        "transform",
        "transform-origin",
        "transform-style",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function",
        "translate",
        "unicode-bidi",
        "user-select",
        "vertical-align",
        "visibility",
        "voice-balance",
        "voice-duration",
        "voice-family",
        "voice-pitch",
        "voice-range",
        "voice-rate",
        "voice-stress",
        "voice-volume",
        "volume",
        "white-space",
        "widows",
        "width",
        "will-change",
        "word-break",
        "word-spacing",
        "word-wrap",
        "writing-mode",
        "z-index",
        // SVG-specific
        "clip-path",
        "clip-rule",
        "mask",
        "enable-background",
        "filter",
        "flood-color",
        "flood-opacity",
        "lighting-color",
        "stop-color",
        "stop-opacity",
        "pointer-events",
        "color-interpolation",
        "color-interpolation-filters",
        "color-rendering",
        "fill",
        "fill-opacity",
        "fill-rule",
        "image-rendering",
        "marker",
        "marker-end",
        "marker-mid",
        "marker-start",
        "paint-order",
        "shape-rendering",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-rendering",
        "baseline-shift",
        "dominant-baseline",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "text-anchor",
        "writing-mode"
    ], propertyKeywords = keySet(propertyKeywords_);
    var nonStandardPropertyKeywords_ = [
        "border-block",
        "border-block-color",
        "border-block-end",
        "border-block-end-color",
        "border-block-end-style",
        "border-block-end-width",
        "border-block-start",
        "border-block-start-color",
        "border-block-start-style",
        "border-block-start-width",
        "border-block-style",
        "border-block-width",
        "border-inline",
        "border-inline-color",
        "border-inline-end",
        "border-inline-end-color",
        "border-inline-end-style",
        "border-inline-end-width",
        "border-inline-start",
        "border-inline-start-color",
        "border-inline-start-style",
        "border-inline-start-width",
        "border-inline-style",
        "border-inline-width",
        "margin-block",
        "margin-block-end",
        "margin-block-start",
        "margin-inline",
        "margin-inline-end",
        "margin-inline-start",
        "padding-block",
        "padding-block-end",
        "padding-block-start",
        "padding-inline",
        "padding-inline-end",
        "padding-inline-start",
        "scroll-snap-stop",
        "scrollbar-3d-light-color",
        "scrollbar-arrow-color",
        "scrollbar-base-color",
        "scrollbar-dark-shadow-color",
        "scrollbar-face-color",
        "scrollbar-highlight-color",
        "scrollbar-shadow-color",
        "scrollbar-track-color",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "shape-inside",
        "zoom"
    ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
    var fontProperties_ = [
        "font-display",
        "font-family",
        "src",
        "unicode-range",
        "font-variant",
        "font-feature-settings",
        "font-stretch",
        "font-weight",
        "font-style"
    ], fontProperties = keySet(fontProperties_);
    var counterDescriptors_ = [
        "additive-symbols",
        "fallback",
        "negative",
        "pad",
        "prefix",
        "range",
        "speak-as",
        "suffix",
        "symbols",
        "system"
    ], counterDescriptors = keySet(counterDescriptors_);
    var colorKeywords_ = [
        "aliceblue",
        "antiquewhite",
        "aqua",
        "aquamarine",
        "azure",
        "beige",
        "bisque",
        "black",
        "blanchedalmond",
        "blue",
        "blueviolet",
        "brown",
        "burlywood",
        "cadetblue",
        "chartreuse",
        "chocolate",
        "coral",
        "cornflowerblue",
        "cornsilk",
        "crimson",
        "cyan",
        "darkblue",
        "darkcyan",
        "darkgoldenrod",
        "darkgray",
        "darkgreen",
        "darkkhaki",
        "darkmagenta",
        "darkolivegreen",
        "darkorange",
        "darkorchid",
        "darkred",
        "darksalmon",
        "darkseagreen",
        "darkslateblue",
        "darkslategray",
        "darkturquoise",
        "darkviolet",
        "deeppink",
        "deepskyblue",
        "dimgray",
        "dodgerblue",
        "firebrick",
        "floralwhite",
        "forestgreen",
        "fuchsia",
        "gainsboro",
        "ghostwhite",
        "gold",
        "goldenrod",
        "gray",
        "grey",
        "green",
        "greenyellow",
        "honeydew",
        "hotpink",
        "indianred",
        "indigo",
        "ivory",
        "khaki",
        "lavender",
        "lavenderblush",
        "lawngreen",
        "lemonchiffon",
        "lightblue",
        "lightcoral",
        "lightcyan",
        "lightgoldenrodyellow",
        "lightgray",
        "lightgreen",
        "lightpink",
        "lightsalmon",
        "lightseagreen",
        "lightskyblue",
        "lightslategray",
        "lightsteelblue",
        "lightyellow",
        "lime",
        "limegreen",
        "linen",
        "magenta",
        "maroon",
        "mediumaquamarine",
        "mediumblue",
        "mediumorchid",
        "mediumpurple",
        "mediumseagreen",
        "mediumslateblue",
        "mediumspringgreen",
        "mediumturquoise",
        "mediumvioletred",
        "midnightblue",
        "mintcream",
        "mistyrose",
        "moccasin",
        "navajowhite",
        "navy",
        "oldlace",
        "olive",
        "olivedrab",
        "orange",
        "orangered",
        "orchid",
        "palegoldenrod",
        "palegreen",
        "paleturquoise",
        "palevioletred",
        "papayawhip",
        "peachpuff",
        "peru",
        "pink",
        "plum",
        "powderblue",
        "purple",
        "rebeccapurple",
        "red",
        "rosybrown",
        "royalblue",
        "saddlebrown",
        "salmon",
        "sandybrown",
        "seagreen",
        "seashell",
        "sienna",
        "silver",
        "skyblue",
        "slateblue",
        "slategray",
        "snow",
        "springgreen",
        "steelblue",
        "tan",
        "teal",
        "thistle",
        "tomato",
        "turquoise",
        "violet",
        "wheat",
        "white",
        "whitesmoke",
        "yellow",
        "yellowgreen"
    ], colorKeywords = keySet(colorKeywords_);
    var valueKeywords_ = [
        "above",
        "absolute",
        "activeborder",
        "additive",
        "activecaption",
        "afar",
        "after-white-space",
        "ahead",
        "alias",
        "all",
        "all-scroll",
        "alphabetic",
        "alternate",
        "always",
        "amharic",
        "amharic-abegede",
        "antialiased",
        "appworkspace",
        "arabic-indic",
        "armenian",
        "asterisks",
        "attr",
        "auto",
        "auto-flow",
        "avoid",
        "avoid-column",
        "avoid-page",
        "avoid-region",
        "axis-pan",
        "background",
        "backwards",
        "baseline",
        "below",
        "bidi-override",
        "binary",
        "bengali",
        "blink",
        "block",
        "block-axis",
        "bold",
        "bolder",
        "border",
        "border-box",
        "both",
        "bottom",
        "break",
        "break-all",
        "break-word",
        "bullets",
        "button",
        "button-bevel",
        "buttonface",
        "buttonhighlight",
        "buttonshadow",
        "buttontext",
        "calc",
        "cambodian",
        "capitalize",
        "caps-lock-indicator",
        "caption",
        "captiontext",
        "caret",
        "cell",
        "center",
        "checkbox",
        "circle",
        "cjk-decimal",
        "cjk-earthly-branch",
        "cjk-heavenly-stem",
        "cjk-ideographic",
        "clear",
        "clip",
        "close-quote",
        "col-resize",
        "collapse",
        "color",
        "color-burn",
        "color-dodge",
        "column",
        "column-reverse",
        "compact",
        "condensed",
        "contain",
        "content",
        "contents",
        "content-box",
        "context-menu",
        "continuous",
        "copy",
        "counter",
        "counters",
        "cover",
        "crop",
        "cross",
        "crosshair",
        "currentcolor",
        "cursive",
        "cyclic",
        "darken",
        "dashed",
        "decimal",
        "decimal-leading-zero",
        "default",
        "default-button",
        "dense",
        "destination-atop",
        "destination-in",
        "destination-out",
        "destination-over",
        "devanagari",
        "difference",
        "disc",
        "discard",
        "disclosure-closed",
        "disclosure-open",
        "document",
        "dot-dash",
        "dot-dot-dash",
        "dotted",
        "double",
        "down",
        "e-resize",
        "ease",
        "ease-in",
        "ease-in-out",
        "ease-out",
        "element",
        "ellipse",
        "ellipsis",
        "embed",
        "end",
        "ethiopic",
        "ethiopic-abegede",
        "ethiopic-abegede-am-et",
        "ethiopic-abegede-gez",
        "ethiopic-abegede-ti-er",
        "ethiopic-abegede-ti-et",
        "ethiopic-halehame-aa-er",
        "ethiopic-halehame-aa-et",
        "ethiopic-halehame-am-et",
        "ethiopic-halehame-gez",
        "ethiopic-halehame-om-et",
        "ethiopic-halehame-sid-et",
        "ethiopic-halehame-so-et",
        "ethiopic-halehame-ti-er",
        "ethiopic-halehame-ti-et",
        "ethiopic-halehame-tig",
        "ethiopic-numeric",
        "ew-resize",
        "exclusion",
        "expanded",
        "extends",
        "extra-condensed",
        "extra-expanded",
        "fantasy",
        "fast",
        "fill",
        "fill-box",
        "fixed",
        "flat",
        "flex",
        "flex-end",
        "flex-start",
        "footnotes",
        "forwards",
        "from",
        "geometricPrecision",
        "georgian",
        "graytext",
        "grid",
        "groove",
        "gujarati",
        "gurmukhi",
        "hand",
        "hangul",
        "hangul-consonant",
        "hard-light",
        "hebrew",
        "help",
        "hidden",
        "hide",
        "higher",
        "highlight",
        "highlighttext",
        "hiragana",
        "hiragana-iroha",
        "horizontal",
        "hsl",
        "hsla",
        "hue",
        "icon",
        "ignore",
        "inactiveborder",
        "inactivecaption",
        "inactivecaptiontext",
        "infinite",
        "infobackground",
        "infotext",
        "inherit",
        "initial",
        "inline",
        "inline-axis",
        "inline-block",
        "inline-flex",
        "inline-grid",
        "inline-table",
        "inset",
        "inside",
        "intrinsic",
        "invert",
        "italic",
        "japanese-formal",
        "japanese-informal",
        "justify",
        "kannada",
        "katakana",
        "katakana-iroha",
        "keep-all",
        "khmer",
        "korean-hangul-formal",
        "korean-hanja-formal",
        "korean-hanja-informal",
        "landscape",
        "lao",
        "large",
        "larger",
        "left",
        "level",
        "lighter",
        "lighten",
        "line-through",
        "linear",
        "linear-gradient",
        "lines",
        "list-item",
        "listbox",
        "listitem",
        "local",
        "logical",
        "loud",
        "lower",
        "lower-alpha",
        "lower-armenian",
        "lower-greek",
        "lower-hexadecimal",
        "lower-latin",
        "lower-norwegian",
        "lower-roman",
        "lowercase",
        "ltr",
        "luminosity",
        "malayalam",
        "manipulation",
        "match",
        "matrix",
        "matrix3d",
        "media-controls-background",
        "media-current-time-display",
        "media-fullscreen-button",
        "media-mute-button",
        "media-play-button",
        "media-return-to-realtime-button",
        "media-rewind-button",
        "media-seek-back-button",
        "media-seek-forward-button",
        "media-slider",
        "media-sliderthumb",
        "media-time-remaining-display",
        "media-volume-slider",
        "media-volume-slider-container",
        "media-volume-sliderthumb",
        "medium",
        "menu",
        "menulist",
        "menulist-button",
        "menulist-text",
        "menulist-textfield",
        "menutext",
        "message-box",
        "middle",
        "min-intrinsic",
        "mix",
        "mongolian",
        "monospace",
        "move",
        "multiple",
        "multiple_mask_images",
        "multiply",
        "myanmar",
        "n-resize",
        "narrower",
        "ne-resize",
        "nesw-resize",
        "no-close-quote",
        "no-drop",
        "no-open-quote",
        "no-repeat",
        "none",
        "normal",
        "not-allowed",
        "nowrap",
        "ns-resize",
        "numbers",
        "numeric",
        "nw-resize",
        "nwse-resize",
        "oblique",
        "octal",
        "opacity",
        "open-quote",
        "optimizeLegibility",
        "optimizeSpeed",
        "oriya",
        "oromo",
        "outset",
        "outside",
        "outside-shape",
        "overlay",
        "overline",
        "padding",
        "padding-box",
        "painted",
        "page",
        "paused",
        "persian",
        "perspective",
        "pinch-zoom",
        "plus-darker",
        "plus-lighter",
        "pointer",
        "polygon",
        "portrait",
        "pre",
        "pre-line",
        "pre-wrap",
        "preserve-3d",
        "progress",
        "push-button",
        "radial-gradient",
        "radio",
        "read-only",
        "read-write",
        "read-write-plaintext-only",
        "rectangle",
        "region",
        "relative",
        "repeat",
        "repeating-linear-gradient",
        "repeating-radial-gradient",
        "repeat-x",
        "repeat-y",
        "reset",
        "reverse",
        "rgb",
        "rgba",
        "ridge",
        "right",
        "rotate",
        "rotate3d",
        "rotateX",
        "rotateY",
        "rotateZ",
        "round",
        "row",
        "row-resize",
        "row-reverse",
        "rtl",
        "run-in",
        "running",
        "s-resize",
        "sans-serif",
        "saturation",
        "scale",
        "scale3d",
        "scaleX",
        "scaleY",
        "scaleZ",
        "screen",
        "scroll",
        "scrollbar",
        "scroll-position",
        "se-resize",
        "searchfield",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "self-start",
        "self-end",
        "semi-condensed",
        "semi-expanded",
        "separate",
        "serif",
        "show",
        "sidama",
        "simp-chinese-formal",
        "simp-chinese-informal",
        "single",
        "skew",
        "skewX",
        "skewY",
        "skip-white-space",
        "slide",
        "slider-horizontal",
        "slider-vertical",
        "sliderthumb-horizontal",
        "sliderthumb-vertical",
        "slow",
        "small",
        "small-caps",
        "small-caption",
        "smaller",
        "soft-light",
        "solid",
        "somali",
        "source-atop",
        "source-in",
        "source-out",
        "source-over",
        "space",
        "space-around",
        "space-between",
        "space-evenly",
        "spell-out",
        "square",
        "square-button",
        "start",
        "static",
        "status-bar",
        "stretch",
        "stroke",
        "stroke-box",
        "sub",
        "subpixel-antialiased",
        "svg_masks",
        "super",
        "sw-resize",
        "symbolic",
        "symbols",
        "system-ui",
        "table",
        "table-caption",
        "table-cell",
        "table-column",
        "table-column-group",
        "table-footer-group",
        "table-header-group",
        "table-row",
        "table-row-group",
        "tamil",
        "telugu",
        "text",
        "text-bottom",
        "text-top",
        "textarea",
        "textfield",
        "thai",
        "thick",
        "thin",
        "threeddarkshadow",
        "threedface",
        "threedhighlight",
        "threedlightshadow",
        "threedshadow",
        "tibetan",
        "tigre",
        "tigrinya-er",
        "tigrinya-er-abegede",
        "tigrinya-et",
        "tigrinya-et-abegede",
        "to",
        "top",
        "trad-chinese-formal",
        "trad-chinese-informal",
        "transform",
        "translate",
        "translate3d",
        "translateX",
        "translateY",
        "translateZ",
        "transparent",
        "ultra-condensed",
        "ultra-expanded",
        "underline",
        "unidirectional-pan",
        "unset",
        "up",
        "upper-alpha",
        "upper-armenian",
        "upper-greek",
        "upper-hexadecimal",
        "upper-latin",
        "upper-norwegian",
        "upper-roman",
        "uppercase",
        "urdu",
        "url",
        "var",
        "vertical",
        "vertical-text",
        "view-box",
        "visible",
        "visibleFill",
        "visiblePainted",
        "visibleStroke",
        "visual",
        "w-resize",
        "wait",
        "wave",
        "wider",
        "window",
        "windowframe",
        "windowtext",
        "words",
        "wrap",
        "wrap-reverse",
        "x-large",
        "x-small",
        "xor",
        "xx-large",
        "xx-small"
    ], valueKeywords = keySet(valueKeywords_);
    var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_).concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_).concat(valueKeywords_);
    CodeMirror.registerHelper("hintWords", "css", allWords);
    function tokenCComment(stream, state) {
        var maybeEnd = false, ch;
        while((ch = stream.next()) != null){
            if (maybeEnd && ch == "/") {
                state.tokenize = null;
                break;
            }
            maybeEnd = ch == "*";
        }
        return [
            "comment",
            "comment"
        ];
    }
    CodeMirror.defineMIME("text/css", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css"
    });
    CodeMirror.defineMIME("text/x-scss", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else return [
                    "operator",
                    "operator"
                ];
            },
            ":": function(stream) {
                if (stream.match(/^\s*\{/, false)) return [
                    null,
                    null
                ];
                return false;
            },
            "$": function(stream) {
                stream.match(/^[\w-]+/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "#": function(stream) {
                if (!stream.eat("{")) return false;
                return [
                    null,
                    "interpolation"
                ];
            }
        },
        name: "css",
        helperType: "scss"
    });
    CodeMirror.defineMIME("text/x-less", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else return [
                    "operator",
                    "operator"
                ];
            },
            "@": function(stream) {
                if (stream.eat("{")) return [
                    null,
                    "interpolation"
                ];
                if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
                stream.eatWhile(/[\w\\\-]/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "&": function() {
                return [
                    "atom",
                    "atom"
                ];
            }
        },
        name: "css",
        helperType: "less"
    });
    CodeMirror.defineMIME("text/x-gss", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        supportsAtComponent: true,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css",
        helperType: "gss"
    });
});

},{"b71448171334a2b2":"akde7"}],"6mnLj":[function(require,module,exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(require("ad973226d541e3b9"));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineOption("fullScreen", false, function(cm, val, old) {
        if (old == CodeMirror.Init) old = false;
        if (!old == !val) return;
        if (val) setFullscreen(cm);
        else setNormal(cm);
    });
    function setFullscreen(cm) {
        var wrap = cm.getWrapperElement();
        cm.state.fullScreenRestore = {
            scrollTop: window.pageYOffset,
            scrollLeft: window.pageXOffset,
            width: wrap.style.width,
            height: wrap.style.height
        };
        wrap.style.width = "";
        wrap.style.height = "auto";
        wrap.className += " CodeMirror-fullscreen";
        document.documentElement.style.overflow = "hidden";
        cm.refresh();
    }
    function setNormal(cm) {
        var wrap = cm.getWrapperElement();
        wrap.className = wrap.className.replace(/\s*CodeMirror-fullscreen\b/, "");
        document.documentElement.style.overflow = "";
        var info = cm.state.fullScreenRestore;
        wrap.style.width = info.width;
        wrap.style.height = info.height;
        window.scrollTo(info.scrollLeft, info.scrollTop);
        cm.refresh();
    }
});

},{"ad973226d541e3b9":"akde7"}],"hdH6V":[function(require,module,exports) {
/**
 * Create a problem ;)
 */ angular.module("common").directive("createProblem", [
    "$window",
    function($window) {
        return {
            scope: {
                on: "="
            },
            restrict: "A",
            template: '<canvas id="problem"></canvas>',
            link: function(scope, element, attrs) {
                scope.$watch("on", function(on) {
                    if (on) createProblem();
                });
                var canvas = document.getElementById("problem"), ctx = canvas.getContext("2d");
                function resize() {
                    canvas.style.width = $window.innerWidth + "px";
                    canvas.style.height = $window.innerHeight + "px";
                }
                resize();
                $window.onresize = resize;
                function createProblem() {
                    $(canvas).show(); // a variant using fixed canvas size but stretches the result.
                    // emulates interference/bad reception
                    // using a different "noise" algo
                    canvas.width = canvas.height = 256;
                    function noise(ctx) {
                        var w = ctx.canvas.width, h = ctx.canvas.height, idata = ctx.getImageData(0, 0, w, h), buffer32 = new Uint32Array(idata.data.buffer), len = buffer32.length, i = 0, pr = 456 * Math.random(), prs = 716 * Math.random();
                        for(; i < len;){
                            buffer32[i++] = (pr % 255 | 0) << 24;
                            pr += prs * 1.2;
                        }
                        ctx.putImageData(idata, 0, 0);
                    }
                    (function loop() {
                        noise(ctx);
                        requestID = $window.requestAnimationFrame(loop);
                    })();
                }
            }
        };
    }
]);

},{}],"OeyTT":[function(require,module,exports) {
/**
 * @name epiCheckbox
 * @ngdoc directive
 * @memberOf common
 * @scope true
 * @restrict C
 *
 * @attribute {String} inputId
 * @attribute {String} [value]
 * @attribute {String} [name]
 * @attribute {String} [label]
 * @attribute {String} model
 * @attribute {Expression} [change]
 * @attribute {Boolean} [disabled]
 *
 */ angular.module("common").directive("epiCheckbox", [
    "$parse",
    "$log",
    function($parse, $log) {
        return {
            restrict: "C",
            templateUrl: "/directives/epi-checkbox.html",
            scope: {
                id: "@inputId",
                value: "@?value",
                name: "@?name",
                label: "@?label",
                model: "=model",
                change: "&?change",
                disabled: "=?disabled"
            },
            link: function(scope, element, attrs) {
                if (scope.model) scope.model = scope.model.toString();
                if (typeof scope.change == "undefined") scope.change = function() {
                    return;
                };
                else {
                    var oldFn = scope.change;
                    scope.change = function() {
                        var fn = $parse(oldFn);
                        fn(scope);
                    };
                }
                if (!scope.disabled) scope.disabled = false;
            }
        };
    }
]);

},{}],"5dl8y":[function(require,module,exports) {
/**
 * @name epiCheckboxSwitch
 * @ngdoc directive
 * @memberOf common
 * @scope true
 * @restrict C
 *
 * @attribute {String} inputId
 * @attribute {String} value
 * @attribute {String} name
 * @attribute {Boolean} checked
 * @attribute {Object} model
 * @attribute {String} onText
 * @attribute {String} offText
 */ angular.module("common").directive("epiCheckboxSwitch", function() {
    return {
        restrict: "C",
        templateUrl: "/directives/epi-checkbox-switch.html",
        scope: {
            id: "@inputId",
            value: "@value",
            name: "@name",
            checked: "=checked",
            model: "=model",
            onText: "@onText",
            offText: "@offText"
        }
    };
});

},{}],"li7AB":[function(require,module,exports) {
/**
 * Directive for the .collapse-triangle
 */ angular.module("common").directive("epiCollapseTriangle", [
    "$parse",
    function($parse) {
        return {
            restrict: "A",
            templateUrl: "/directives/epi-collapse-triangle.html",
            replace: true,
            link: function(scope, element, attrs) {
                var action = $parse(attrs.action);
                scope.action = function() {
                    action(scope);
                };
            }
        };
    }
]);

},{}],"8fAnD":[function(require,module,exports) {
angular.module("common").directive("epiConfirm", function() {
    return {
        restrict: "A",
        scope: {
            text: "@epiConfirm",
            yes: "@confirmYes",
            no: "@confirmNo",
            idiotTest: "@confirmIdiot",
            details: "@confirmDetails",
            callback: "&confirmCallback",
            stopPropagation: "="
        },
        controller: [
            "$scope",
            "$uibModal",
            function($scope, $uibModal) {
                /**
       * Open the confirmation dialog modal
       * @return {void}
       */ $scope.open = function() {
                    var modal = $uibModal.open({
                        templateUrl: "/directives/epi-confirm.html",
                        controller: [
                            "$scope",
                            "$sce",
                            function($uibModalScope, $sce) {
                                // set some default text values
                                $uibModalScope.text = $scope.text ? $scope.text : "Are you sure you want to proceed?";
                                $uibModalScope.yes = !!$scope.yes ? $scope.yes : "Proceed";
                                $uibModalScope.no = $scope.no ? $scope.no : "Cancel";
                                $uibModalScope.idiotTest = $scope.idiotTest;
                                $uibModalScope.details = $sce.trustAsHtml($scope.details);
                                $uibModalScope.callback = $scope.callback; // Keeps track of whether the form has been submitted
                                $scope.hasSubmitted = false;
                                if (!$scope.idiotTest) $uibModalScope.$on("enter", function() {
                                    $uibModalScope.submit();
                                });
                                /**
             * Close the modal and fire the callback
             * @return {void}
             */ $uibModalScope.submit = function() {
                                    // Make sure that the form isn't submitted twice
                                    if ($scope.hasSubmitted) return;
                                    $scope.hasSubmitted = true;
                                    $scope.callback();
                                    modal.close();
                                };
                                /**
             * Dismiss the modal
             * @return {void}
             */ $uibModalScope.cancel = function($event) {
                                    if ($scope.stopPropagation) $event.stopPropagation();
                                    modal.dismiss("cancel");
                                };
                                $uibModalScope.click = function($event) {
                                    if ($scope.stopPropagation) $event.stopPropagation();
                                };
                            }
                        ]
                    });
                };
            }
        ],
        // Set the click event to open up the modal
        link: function(scope, element, attrs) {
            element.click(scope.open);
        }
    };
});

},{}],"5jvTj":[function(require,module,exports) {
angular.module("common").directive("epiFilter", function() {
    return {
        restrict: "A",
        scope: {
            filter: "=epiFilter",
            columns: "=filterColumns",
            operators: "=filterOperators",
            attribute: "@filterAttribute",
            attributeClass: "@filterAttributeClass",
            operatorClass: "@filterOperatorClass",
            valueClass: "@filterValueClass"
        },
        templateUrl: "/directives/epi-filter.html",
        compile: function(element, attrs) {
            // set default attribute model name
            if (!attrs.filterAttribute) attrs.filterAttribute = "column"; // return the link function
            return function(scope, element, attrs) {
                scope.isArray = scope.columns instanceof Array;
                function toString(value) {
                    return value instanceof Array ? value.join(",") : value;
                }
                function parse(value) {
                    if (scope.filter.operator.toUpperCase() == "IN" || scope.filter.operator.toUpperCase() == "NOT IN") return typeof value == "string" && value.length ? value.split(",") : [];
                    return toString(value);
                }
                var operatorModelCtrl = element.find('[ng-model="filter.operator"]').controller("ngModel"), valueModelCtrl = element.find('[ng-model="filter.value"]').controller("ngModel"); // format the value for display (join arrays into string)
                valueModelCtrl.$formatters.push(toString); // format the input for saving (parse string into array if necessary)
                valueModelCtrl.$parsers.push(parse); // reparse value when operator changes
                operatorModelCtrl.$viewChangeListeners.unshift(function() {
                    scope.filter.value = parse(scope.filter.value);
                });
            };
        }
    };
});

},{}],"klBVx":[function(require,module,exports) {
/**
 * Directive for creating filters (for searching)
 */ angular.module("common").directive("epiFiltersCreator", [
    "$parse",
    function($parse) {
        return {
            restrict: "A",
            scope: {
                columns: "=",
                operators: "=",
                filters: "=",
                change: "&",
                showAdd: "=?"
            },
            replace: true,
            templateUrl: "/directives/epi-filters-creator.html",
            controller: [
                "$scope",
                function($scope) {}
            ],
            link: function($scope, element, attrs) {
                if (!$scope.change) $scope.change = function() {};
                if (typeof $scope.showAdd == "undefined") $scope.showAdd = true;
                for(var i = 0; $scope.filters && i < $scope.filters.length; i++){
                    var filter = $scope.filters[i];
                    if (filter.value instanceof Array) filter.value = filter.value.join(",");
                }
                $scope.filterDidChange = function(filter) {
                    if ("columnID" in filter && "operatorID" in filter && "value" in filter && filter.columnID, filter.operatorID !== "" && filter.value !== "") $scope.change();
                };
                $scope.addFilter = function() {
                    $scope.filters.push({
                        operatorID: 1,
                        columnID: $scope.columns[0].ID,
                        value: ""
                    });
                };
                $scope.removeFilter = function(index) {
                    $scope.filters.splice(index, 1);
                    $scope.change();
                };
            }
        };
    }
]);

},{}],"hNilF":[function(require,module,exports) {
angular.module("common").directive("epiMenu", [
    "Menu",
    function(Menu) {
        return {
            restrict: "A",
            template: require("fd20ce664337adeb"),
            link: function(scope, _, attr) {
                scope.menuParent = attr.epiMenu === "epi-menu" ? undefined : attr.epiMenu;
            }
        };
    }
]);

},{"fd20ce664337adeb":"19DeU"}],"19DeU":[function(require,module,exports) {
module.exports = "<ul class=\"nav nav-collapse nav-pills nav-stacked\" ng-if=\"!menuParent\"><li ng-repeat=\"item in menu.get()\" ng-class=\"[activePage == item.id ? 'active' : '', item.id, entityID &amp;&amp; item.enabled ? '' : 'disabled']\" ng-if=\"item.visible != false\"><a ui-sref=\"{{item.id}}({entityID: entityID})\" ng-disabled=\"!item.enabled\" uib-tooltip=\"{{item.name}}\" tooltip-placement=\"right\" tooltip-popup-delay=\"1000\" ng-if=\"entityID &amp;&amp; item.enabled\"><span>{{ item.name }}</span></a><a ng-if=\"!entityID &amp;&amp; item.enabled\" disabled></a></li></ul><div ng-if=\"!!menuParent &amp;&amp; menu.get(menuParent).length\" ng-repeat=\"section in menu.get(menuParent)\"><h3>{{ section.text }}</h3><ul><li ng-repeat=\"item in section.routes\" ng-if=\"item.enabled\" ng-class=\"{'active': activeSection == item.sref}\"><a ui-sref=\"{{ item.sref }}\">{{ item.name }}</a></li></ul></div>";

},{}],"1HfYw":[function(require,module,exports) {
angular.module("common").directive("epiModal", [
    "$uibModal",
    "$log",
    "$parse",
    function($uibModal, $log, $parse) {
        return {
            restrict: "C",
            transclude: true,
            templateUrl: "/directives/epi-modal.html",
            link: function(scope, elements, attrs) {
                if (typeof attrs.template == "undefined") attrs.template = "/directives/epi-modal.html";
                if (typeof attrs.keyboard == "undefined") attrs.keyboard = false;
                if (typeof attrs.background == "undefined") attrs.background = "static";
                else // Otherwise evaluate the string as a boolean
                attrs.background = attrs.background === "true";
                scope.epiModalOpen = function() {
                    scope.epiModalInstance = $uibModal.open({
                        templateUrl: attrs.template,
                        backdrop: attrs.background,
                        keyboard: attrs.keyboard,
                        windowClass: attrs.classes,
                        scope: scope
                    });
                    scope.$on("enter", scope.epiModalConfirm);
                };
                scope.epiModalClose = function() {
                    scope.epiModalInstance.dismiss("closed");
                    scope.epiModalInstance.closed = true;
                };
                scope.epiModalConfirm = function() {
                    scope.epiModalClose();
                    var fn = $parse(attrs.callbackConfirm);
                    fn(scope);
                };
                scope.epiModalCancel = function() {
                    scope.epiModalClose();
                    var fn = $parse(attrs.callbackCancel);
                    fn(scope);
                };
                scope.$watch(attrs.isOpen, function(val) {
                    if (val) scope.epiModalOpen();
                    else if (val === false && "epiModalInstance" in scope) scope.epiModalClose();
                });
                scope.$on("$destroy", function() {
                    if ("epiModalInstance" in scope && !scope.epiModalInstance.closed) scope.epiModalClose();
                });
            }
        };
    }
]);

},{}],"bafIA":[function(require,module,exports) {
angular.module("common").directive("epiPaging", function() {
    return {
        restrict: "C",
        templateUrl: "/directives/epi-paging.html",
        scope: {
            pages: "=pages",
            collection: "=collection",
            verbosity: "@verbosity",
            request: "=",
            params: "="
        },
        link: function(scope, element, attrs) {
            scope.nextPage = function() {
                this.page(this.pages.nextPage);
            };
            scope.prevPage = function() {
                this.page(this.pages.prevPage);
            };
            scope.page = function(page) {
                var request;
                if (!scope.request) request = this.collection.getList;
                else request = scope.request;
                var params = angular.extend({
                    page: page
                }, scope.params);
                request(params).then(function(collection) {
                    scope.collection = collection;
                });
            };
        }
    };
});

},{}],"l2n4C":[function(require,module,exports) {
/**
 * Directive for the right sliding panel
 */ angular.module("common").directive("rightWrap", [
    "$state",
    "$rootScope",
    "$timeout",
    "$window",
    function($state, $rootScope, $timeout, $window) {
        return {
            restrict: "AEC",
            replace: true,
            transclude: true,
            templateUrl: "/directives/epi-right.html",
            link: function(scope, element, attrs) {
                var currentState; // Keep track of what is currently being animated
                var animate = {
                    panel: false,
                    left: false
                };
                if (!rightInState($state.current)) element.hide();
                var leftSide = element.prev("[left-side]");
                scope.$watch(attrs.show, function epiRightWatchShow(value, oldVal) {
                    showHide(null, $state.current);
                });
                /**
       * Checks to see if a state object has a right view
       * @param  {object} stateObject ui router $state object
       * @return {boolean}
       */ function rightInState(stateObject) {
                    if (!stateObject) return false; // First, check to make sure that there *is* a views object
                    if ("views" in stateObject) {
                        // The regex to test the key against
                        var regex = /right(@)?/gi; // Loop through the keys & check them
                        for(var view in stateObject.views){
                            // If it matches, return true
                            if (view.match(regex)) {
                                currentState = stateObject.name;
                                return true;
                            } else if ($state.includes(currentState)) return true;
                        }
                    } // If this executes, either there were no views, or the regex didn't match
                    // So return false
                    return false;
                }
                /**
       * Hides the panel
       * @param  {Object} element
       * @return {void}
       */ function hidePanel(element) {
                    animate.panel = true;
                    $timeout(function() {
                        element.hide("blind", {
                            direction: "right",
                            queue: false,
                            complete: function() {
                                animate.panel = false;
                            }
                        });
                    });
                }
                /**
       * Shows the panel
       * @param  {Object} element
       * @return {void}
       */ function showPanel(element) {
                    element.css({
                        width: findRightWidth()
                    });
                    animate.panel = true;
                    $timeout(function() {
                        element.show("blind", {
                            direction: "right",
                            queue: false,
                            complete: function() {
                                animate.panel = false;
                            }
                        });
                    });
                }
                /**
       * Finds the width that the right side should be
       * @return {integer}
       */ function findRightWidth() {
                    var viewChildren = element.children("[ui-view]").children(":first"), children = element.children(":first"), isSmall = $window.innerWidth <= 768, attr = isSmall ? "right-side-width-small" : "right-side-width";
                    var width = viewChildren.attr(attr) || children.attr(attr);
                    if (!width && isSmall) width = viewChildren.attr("right-side-width") || children.attr("right-side-width");
                    return width;
                }
                /**
       * Squishes the left side element
       * @param  {object} element
       * @return {void}
       */ function squishLeft(element) {
                    var rightWidth = findRightWidth();
                    if (!element || !rightWidth) return;
                    rightWidth = rightWidth.replace("%", "");
                    var leftWidth = 100 - rightWidth;
                    animate.left = true;
                    $timeout(function() {
                        element.animate({
                            width: leftWidth + "%"
                        }, {
                            queue: false,
                            complete: function() {
                                animate.left = false;
                            }
                        });
                    });
                }
                /**
       * Expands the left side element
       * @param  {object} element
       * @return {void}
       */ function expandLeft(element) {
                    if (!element) return;
                    animate.left = true;
                    $timeout(function() {
                        element.animate({
                            width: "100%"
                        }, {
                            queue: false,
                            complete: function() {
                                animate.left = false;
                            }
                        });
                    });
                }
                /**
       * Shows/hides the left/right side
       * @param  {object} event
       * @param  {object} toState
       * @param  {object} toParams
       * @param  {object} fromState
       * @param  {object} fromParams
       * @return {void}
       */ function showHide(event, toState, toParams, fromState, fromParams) {
                    // If the to state has the right view,
                    // Or…the event is a state start, check to see if the fromState has the right view
                    var stateHasRight = rightInState(toState) || !_.isEmpty(event) && event.name == "$stateChangeStart" && rightInState(fromState); // If the panel shouldn't be open in this state,
                    // Or the show attribute is truthy,
                    if (stateHasRight || scope[attrs.show]) {
                        // If the element is visible, return, since nothing needs to be done
                        if (element.is(":visible")) return; // Only animate if they are not already being animated
                        if (!animate.left) squishLeft(leftSide);
                        if (!animate.panel) showPanel(element);
                    } else {
                        // Close everything and
                        // only animate if they are not already being animated
                        if (!animate.left) expandLeft(leftSide);
                        if (!animate.panel) hidePanel(element);
                    }
                }
                /**
       * Opens the right side
       * @return {void}
       */ $rootScope.$on("$stateChangeSuccess", showHide);
                /**
       * Closes the right side
       * @return {void}
       */ $rootScope.$on("$stateChangeStart", showHide);
            }
        };
    }
]);

},{}],"f3opG":[function(require,module,exports) {
/**
 * Directive for a sliding panel
 *
 * @author Matthew Davies <daviesgeek@icloud.com>
 * @param {variable} visible requires this to show/hide the panel
 * @param {string} direction the direction that the panel slides
 */ angular.module("common").directive("epiSlidingPanel", function() {
    return {
        restrict: "C",
        transclude: true,
        scope: {
            visible: "=visible",
            direction: "@direction"
        },
        templateUrl: "/directives/epi-sliding-panel.html",
        controller: [
            "$scope",
            "$log",
            "$sce",
            function($scope, $log, $sce) {
                if ($scope.visible === false) $(".sliding-panel").hide();
                $scope.$watch("visible", function(newVal, oldVal) {
                    if (newVal == oldVal) return;
                    if ($scope.visible === true) $scope.class = "slide-" + $scope.direction;
                    else $scope.class = "";
                });
            }
        ]
    };
});

},{}],"eG2sT":[function(require,module,exports) {
/**
 * Spinner directive
 */ angular.module("common").directive("epiSpinner", function() {
    return {
        restrict: "C",
        templateUrl: "/directives/epi-spinner.html",
        link: function() {
            "WebkitTransition" in document.body.style || "MozTransition" in document.body.style || "OTransition" in document.body.style || document.body.style;
        }
    };
});

},{}],"1qH6e":[function(require,module,exports) {
/**
 * Tag filters directive
 */ angular.module("common").directive("epiTagFiltersCreator", [
    "$parse",
    function($parse) {
        return {
            restrict: "A",
            scope: {
                tags: "=tags",
                tagFilters: "=tagFilters",
                allowPrivate: "=?",
                fullWidth: "=?"
            },
            templateUrl: "/directives/epi-tag-filters-creator.html",
            link: function(scope, element, attrs) {
                if (!scope.allowPrivate) scope.allowPrivate = false;
                scope.tagFilterSortable = {
                    appendTo: "body",
                    placeholder: "placeholder",
                    connectWith: ".tag-list",
                    cancel: ".cancel"
                };
                if (!scope.tags) throw new ReferenceError("epi-tag-filters-creator: no tags provided!");
                if (!scope.tagFilters) throw new ReferenceError("epi-tag-filters-creator: no tag filters object provided!");
                else {
                    var filterDefaults = {
                        includeIfAny: 1,
                        excludeIfAny: 1,
                        exclude: [],
                        include: []
                    };
                    scope.tagFilters = _.merge(filterDefaults, scope.tagFilters);
                }
                scope.tagListSortable = {
                    appendTo: "body",
                    placeholder: "placeholder",
                    connectWith: ".drop",
                    zIndex: 5000,
                    helper: function(event, element) {
                        return $($(element).clone().css({
                            width: 75,
                            height: 25
                        }));
                    }
                };
            }
        };
    }
]);

},{}],"bqkxB":[function(require,module,exports) {
/**
 * Tags directive (for the list manager)
 * @param {array} tags the array of tag objects
 * @param {boolean} [sortable=true] whether the tags should be sortable/draggable
 */ angular.module("common").directive("epiTags", [
    "ColorHelper",
    "$timeout",
    "Collapser",
    function(ColorHelper, $timeout, Collapser) {
        return {
            restrict: "A",
            scope: {
                entryTags: "=tags",
                sortable: "="
            },
            templateUrl: "/directives/epi-tags.html",
            controller: [
                "$scope",
                "ColorHelper",
                function($scope, ColorHelper) {
                    var appScope = $scope.$parent.grid.appScope;
                    /**
       * Returns the styling for a tag
       * @param  {object} tag
       * @return {string} the styling for specific tag
       */ $scope.tagStyle = function(tag) {
                        if (typeof tag == "undefined") return;
                        var style = tag.style();
                        style.width = $scope.width + "%";
                        return style;
                    };
                    /**
       * Set the tag width on scope for all the tags
       * @return {void}
       */ $scope.resizeTags = function() {
                        $scope.width = $scope.getWidth();
                    };
                    /**
       * Gets the percentage width for each tag
       * @return {integer)
       */ $scope.getWidth = function() {
                        return 100 / $scope.entryTags.length;
                    };
                    /**
       * Removes a tag and makes a request
       * @param  {integer} index the index of the tag
       * @return {void}
       */ $scope.removeTag = function(index) {
                        $timeout(function() {
                            var tag = $scope.entryTags[index];
                            $scope.entryTags.splice(index, 1);
                            appScope.removeTag($scope.$parent.row.entity.ID, tag.ID).then(function() {}, function() {});
                        });
                    };
                    /**
       * The options for the taglist
       * @type {Object}
       */ $scope.tagList = {
                        appendTo: "body",
                        helper: function(event, element) {
                            var el = $(element).clone();
                            el.width($(element).width());
                            return el;
                        },
                        placeholder: "tag tag-placeholder",
                        update: function(event, ui) {
                            if (!ui.item.sortable.moved) {
                                ui.item.sortable.cancel();
                                return;
                            } // If the event hasn't been already canceled, and this isn't a sort event
                            if (ui.item.sortable.moved || !ui.item.sortable.isCanceled()) {
                                // Set this for easy access
                                var sortable = ui.item.sortable; // Is this a private tag or a public tag?
                                var chooser = sortable.moved.private ? "privateTags" : "publicTags"; // If this tag is coming from the tag panel (editing tags)
                                // Add the tag back to the list where it came from
                                if (ui.sender.hasClass("edit-tags")) appScope[chooser].splice(sortable.index, 0, sortable.moved);
                                 // Make sure the tag lists (the small lists) are up-to-date
                                appScope.refreshTagLists(); // Save the tags (makes a PATCH request)
                                appScope.saveTags($scope.$parent.row.entity, sortable.moved.ID);
                            }
                        },
                        over: function(event, ui) {
                            // If the item is being dragged back over, willDelete become false
                            ui.item.sortable.model.willDelete = false; // And set the opacity back to normal
                            $(".ui-sortable-helper").css("opacity", "1");
                        },
                        out: function(event, ui) {
                            // If the item is being dragged back over, willDelete becomes true
                            ui.item.sortable.model.willDelete = true; // And set the opacity to half
                            $(".ui-sortable-helper").css("opacity", "0.5");
                        },
                        beforeStop: function(event, ui) {
                            // This fires at the end of the cycle,
                            // if this tag is being dragged off,
                            if (ui.item.sortable.model.willDelete) {
                                // Hide the actual item (since it takes a split second to drag it off)
                                ui.item.remove(); // And remove the tag (makes a request)
                                $scope.removeTag(ui.item.sortable.index);
                                $timeout(function() {
                                    // $scope.mouseEnter(0)
                                    $scope.newCollapser();
                                    $scope.resetWidths();
                                });
                            }
                        }
                    };
                }
            ],
            link: function(scope, element, attrs) {
                /**
       * On mouseover for a specific tag, resize everything
       * @param  {integer} index
       * @return {void}
       */ scope.mouseEnter = function(index) {
                    scope.newCollapser();
                    scope.collapser.in(index, 2000, 15);
                };
                scope.newCollapser = function() {
                    scope.collapser = new Collapser(element.children("ul"));
                };
                /**
       * On mouse out for the entire ul, reset everything
       * @return {void}
       */ scope.resetWidths = function() {
                    if (scope.collapser) scope.collapser.out(200);
                }; // When anything changes, reset the widths of the tags
                scope.$watch(function() {
                    scope.resizeTags();
                });
            }
        };
    }
]);

},{}],"ANTXI":[function(require,module,exports) {
/**
 * Directive for selecting user(s)
 */ angular.module("common").directive("epiUserSelector", [
    "$http",
    "User",
    "$parse",
    "$timeout",
    "Validator",
    "Session",
    function($http, User, $parse, $timeout, Validator, Session) {
        /**
   * Adds a new property called fullName (concatentation of fname & lname)
   *   Does not return anything, it actually modifies the original object,
   *   thus eliminating the need to return anything
   * @param  {Array} users
   * @return {void}
   */ function parseUsers(users) {
            for(var i = 0; i < users.length; i++)users[i].fullName = users[i].fname + " " + users[i].lname;
        }
        return {
            restrict: "A",
            scope: {
                showHeader: "=",
                showCurrent: "=?",
                placeholder: "@"
            },
            transclude: true,
            templateUrl: "/directives/epi-user-selector.html",
            controller: [
                "$scope",
                "$http",
                "User",
                "$timeout",
                "$state",
                function($scope, $http, User, $timeout, $state) {
                    $scope.validation = {
                        emailValid: true,
                        noUsers: false
                    };
                    $scope.currentUserID = Session.get("ID");
                    if (typeof $scope.showCurrent == "undefined") $scope.showCurrent = false;
                    /**
       * Sends a request to the server to search for a user
       *    This fires every time the user starts typing (due to the ng-change on the input)
       * @param  {string} text the user's name (first and/or last) to search for
       * @return {object} the user(s) that were searched for
       */ $scope.searchUsers = function(text) {
                        // Build the parameters
                        var params = {
                            params: {
                                name: text,
                                entityID: $state.params.entityID
                            }
                        }; // Return a promise with a callback
                        return $http.get(User.getRestangularUrl() + "/search", params).then(function(response) {
                            var users = response.data.data;
                            if (!users.length) $scope.validation.noUsers = true;
                            else {
                                $scope.validation.noUsers = false;
                                parseUsers(users);
                            }
                            return users;
                        });
                    };
                    $scope.$watch("textQuery", function() {
                        if (Validator.validate($scope.textQuery, "email") == true) $scope.validation.emailValid = true;
                        else $scope.validation.emailValid = false;
                    });
                    $scope.$watch("validation", function(validation) {
                        if (validation.emailValid == true && validation.noUsers == true && $scope.allowEmails || validation.noUsers == false) $scope.invalid = false;
                        else if (validation.emailValid == false && validation.noUsers == true || $scope.allowEmails == false) $scope.invalid = true;
                    }, true);
                    $scope.addUser = function(item, model, label) {
                        if ($scope.allowEmails) $scope.users.push({
                            fullName: item.email,
                            email: item.email
                        });
                        else $scope.users.push(item);
                        $scope.textQuery = "";
                        $scope.invalid = false;
                        runAddCallback(item);
                    };
                    $scope.removeUser = function(index) {
                        runRemoveCallback($scope.users[index]);
                        $scope.users.splice(index, 1);
                    };
                    $scope.addEmail = function(email) {
                        if (email && email.length && $scope.validation.emailValid && $scope.validation.noUsers && $scope.allowEmails) {
                            $scope.users.push({
                                fullName: email,
                                email: email
                            });
                            $scope.textQuery = "";
                            runAddCallback({
                                fullName: email,
                                email: email
                            });
                        }
                    };
                    function runAddCallback(user) {
                        $scope.addCallback($scope.$parent, {
                            $users: $scope.users,
                            $user: user,
                            $userID: user.ID
                        });
                    }
                    function runRemoveCallback(user) {
                        $scope.removeCallback($scope.$parent, {
                            $user: user,
                            $userID: user.ID
                        });
                    }
                }
            ],
            link: function(scope, element, attrs, ctrl, transcludeFn) {
                scope.allowEmails = typeof attrs.allowEmails == "undefined" ? true : attrs.allowEmails === "true";
                scope.addCallback = $parse(attrs.onAdd);
                scope.removeCallback = $parse(attrs.onRemove);
                scope.users = $parse(attrs.users)(scope.$parent);
                scope.textQuery = "";
                scope.transclude = false;
                var showDelete = $parse(attrs.showDelete);
                if (!attrs.showDelete) scope.showDelete = function() {
                    return true;
                };
                else scope.showDelete = function(user) {
                    return showDelete(scope.$parent, {
                        user: user
                    });
                };
                scope.$parent.$watch(attrs.users, function(users) {
                    scope.users = users;
                    if (typeof scope.users == "undefined") throw new ReferenceError("epi-user-selector: no users provided!");
                    else if (scope.users.length) parseUsers(scope.users);
                });
                var transcludedContent = transcludeFn();
                if (transcludedContent.length > 0) scope.transclude = true;
                if (typeof scope.allowEmails == "undefined") scope.allowEmails = false;
                if (typeof scope.placeholder == "undefined") scope.placeholder = scope.allowEmails ? "Add a user/email address here..." : "Add a user here..";
            }
        };
    }
]);

},{}],"krqoD":[function(require,module,exports) {
/**
 * Validation directive
 */ angular.module("common").directive("epiValidate", [
    "$timeout",
    "Validator",
    function($timeout1, Validator1) {
        return {
            restrict: "A",
            controller: [
                "$scope",
                "Validator",
                function($scope1, Validator1) {
                    /**
       * Validate a whole form
       * @param  {string} formName Name of form
       * @return {object} The form object
       */ $scope1.validateForm = function(formName1) {
                        var name1;
                        return $scope1.forms[formName1].validate();
                    };
                }
            ],
            link: function(scope1, element1, attrs1) {
                // Legacy code to preserve backwards compatibility with forms that have epi-validate called on them:
                // @todo: cleanup and remove the epi-validate attribute and remove lines 16-25
                // If the epi-validate attribute is empty, this is called on the form
                if (!attrs1.epiValidate && element1.prop("tagName") == "FORM" && attrs1.name) {
                    var formName1 = toCamelCase(element1.attr("name"));
                    if (!("forms" in scope1)) scope1.forms = {};
                    if (!scope1.forms[formName1]) scope1.forms[formName1] = createForm1(!!attrs1.epiValidateShowMessages);
                    return;
                } // if the control doesn't have a name, throw an error
                if (false in attrs1 || attrs1.name == "" || typeof attrs1.name == "undefined") throw "This " + element1.prop("tagName").toLowerCase() + " does not have a name:"; // if the control doesn't have a model, throw an error
                if (false in attrs1 || attrs1.ngModel == "" || typeof attrs1.ngModel == "undefined") throw "This " + element1.prop("tagName").toLowerCase() + " does not have a model set:"; // prepare objects on scope
                if (!("forms" in scope1)) scope1.forms = {};
                if (!("controls" in scope1)) scope1.controls = {};
                var control1 = new Control(attrs1, element1);
                var model1 = attrs1.ngModel; // find closest parent form; if found, add this model to the named form object in scope
                var formElem1 = element1.closest("form[name]");
                var formName1 = ""; // make camelCase name
                if (formElem1.length) formName1 = toCamelCase(formElem1.attr("name")); // create form object if necessary
                if (formName1 && typeof scope1.forms[formName1] == "undefined") scope1.forms[formName1] = createForm1(!!formElem1.attr("epi-validate-show-messages")); // add control to form and watch control in form object
                if (formName1) scope1.forms[formName1].addControl(control1); // if no form, add to controls object so it's at least in the scope
                else scope1.controls[control1.name] = control1; // watch element's value for change
                var unbind1 = scope1.$watch(attrs1.ngModel, function(newVal1, oldVal1) {
                    control1.value = newVal1;
                    if (newVal1 == oldVal1) return; // add dirty class (will make parent form dirty too)
                    control1.setDirty(true); // run validation rules via controller (set invalid class if necessary)
                    if (formName1 in scope1.forms) scope1.forms[formName1]._validateControl(control1);
                }); // destructor cleanup
                scope1.$on("$destroy", function() {
                    unbind1();
                    if (formName1) {
                        delete scope1.forms[formName1].controls[control1.name];
                        scope1.forms[formName1].checkValidity();
                    }
                });
                function createForm1(showMessages1) {
                    return new Form(showMessages1, $timeout1, Validator1, scope1);
                }
            }
        };
    }
]);
function Form(showMessages1, $timeout1, Validator1, $scope1) {
    this._dirty = false;
    this._invalid = false;
    this._errors = {};
    this._showMessages = !!showMessages1;
    this.$timeout = $timeout1;
    this.Validator = Validator1;
    this.$scope = $scope1;
    this.controls = {};
}
Form.prototype = {
    /**
   * Return whether this form is valid
   * @return {boolean}
   */ isValid: function() {
        return !this._invalid;
    },
    /**
   * Set whether this form is valid
   * @param {boolean} valid
   * @return {void}
   */ setValidity: function(valid1) {
        this._invalid = !valid1;
    },
    /**
   * Reset the form
   * @return {void}
   */ reset: function() {
        // This is wrapped in a timeout because usually this will be called right after a model change
        // If this is called right after a model change, the form will be reset,
        // *Then* the $apply will run and set everything back to invalid
        this.$timeout((function() {
            for(var i1 in this.controls){
                this.controls[i1].setDirty(false);
                this.controls[i1].setValidity(true);
            }
            this._invalid = false;
        }).bind(this));
    },
    /**
   * Go through all the controls and figure out if this form is valid
   * @return {void}
   */ checkValidity: function() {
        for(name in this.controls){
            if (!this.controls[name].isValid()) return;
        } // no invalid controls were found, so set to valid
        this._invalid = false;
    },
    /**
   * Return whether this form is dirty
   * @return {boolean}
   */ isDirty: function() {
        return this._dirty;
    },
    /**
   * Set whether this form is dirty
   * @param {boolean} dirty
   * @return {void}
   */ setDirty: function(dirty1) {
        this._dirty = dirty1;
    },
    /**
   * Get all errors in this form organized by name of control
   * @return {object}
   */ getErrors: function() {
        return this._errors;
    },
    /**
   * Set errors in form by control name
   * @param {string} name
   * @param {array} errors
   * @return {void}
   */ setErrors: function(name1, errors1) {
        this._errors[name1] = errors1;
    },
    /**
   * Remove error(s) in form by control
   * @param  {string} name
   */ removeErrors: function(name1) {
        if (name1 in this._errors) delete this._errors[name1];
    },
    /**
   * Add a control to this form
   * @param {object} control A control object
   * @return {void}
   */ addControl: function(control1) {
        this.controls[control1.name] = control1;
        control1.setForm(this);
    },
    /**
   * Validates the form
   * @return {Form} returns the form
   */ validate: function() {
        this.setValidity(true);
        for(var name1 in this.controls)this._validateControl(this.controls[name1]);
        return this;
    },
    /**
   * Validates a single control
   * @param  {object} control
   * @return {void}
   */ _validateControl: function(control1) {
        // get validation rules from this control
        var rules1 = control1.rules; // get all the other values in case they're needed by validation
        var form1 = this, otherControls1 = form1.controls, otherVals1 = {};
        for(var name1 in otherControls1)otherVals1[name1] = otherControls1[name1].value;
         // feed validation rules and value into service
        var results1 = this.Validator.validate(control1.value, control1.rules, control1.messages, otherVals1, this.$scope); // set control to invalid if necessary (will ascend to parent form)
        if (results1 !== true) {
            control1.setErrors(results1);
            control1.setValidity(false);
        } else {
            control1.resetErrors();
            control1.setValidity(true);
        }
    }
};
function Control(attrs, elem) {
    this._dirty = false;
    this._invalid = false;
    this._errors = {};
    this._elem = elem;
    this._form = null;
    this._showMessages = attrs.epiValidateShowMessages == "true" ? true : false;
    this._messageTemplate = '<span class="text-danger"></span>';
    this.VALID_CLASS = "valid";
    this.INVALID_CLASS = "invalid";
    this.name = attrs.name;
    this.value = null; // set by a watcher
    this.rules = attrs.epiValidate;
    if (attrs.epiValidateMessages) try {
        this.messages = eval("(" + attrs.epiValidateMessages + ")");
    } catch (err) {
        throw 'Unable to evaluate custom validation messages for "' + this.name + '"!';
    }
}
Control.prototype = {
    /**
   * Return whether this form is valid
   * @return {boolean}
   */ isValid: function() {
        return !this._invalid;
    },
    /**
   * Set whether this control is valid (clear errors if valid; if invalid, make form invalid)
   * @param {boolean} valid
   * @return {void}
   */ setValidity: function(valid1) {
        this._invalid = !valid1; // delete old error message
        this._elem.next("span.text-danger").remove(); // if valid, clear errors, clear error class, and add valid class
        // also tell parent form to check its validity
        if (valid1) {
            this._errors = [];
            this._elem.addClass(this.VALID_CLASS).removeClass(this.INVALID_CLASS);
            if (this._elem[0].nodeName == "SELECT" && this._elem.parent(".select-holder")) this._elem.parent(".select-holder").addClass(this.VALID_CLASS).removeClass(this.INVALID_CLASS);
            if (this._form) this._form.checkValidity();
        }
        if (!valid1) {
            this._elem.addClass(this.INVALID_CLASS).removeClass(this.VALID_CLASS);
            if (this._elem[0].nodeName == "SELECT" && this._elem.parent(".select-holder")) this._elem.parent(".select-holder").addClass(this.INVALID_CLASS).removeClass(this.VALID_CLASS); // show message (assumes messages are set first)
            if (this._showMessages && this._errors.length) {
                var span1 = $(this._messageTemplate).html(this._errors[0]);
                this._elem.after(span1);
            }
            if (this._form) this._form.setValidity(false);
        }
    },
    /**
   * Return whether this control is dirty
   * @return {boolean}
   */ isDirty: function() {
        return this._dirty;
    },
    /**
   * Set whether this control is dirty
   * @param {boolean} dirty
   * @return {void}
   */ setDirty: function(dirty1) {
        this._dirty = dirty1;
        if (this._form && dirty1 == true) this._form.setDirty(true);
    },
    /**
   * Get all errors in this control
   * @return {object}
   */ getErrors: function() {
        return this._errors;
    },
    /**
   * Set all errors in this control
   * @param {array} errors
   * @return {void}
   */ setErrors: function(errors1) {
        this._errors = errors1;
        if (this._form) this._form.setErrors(this.name, errors1);
    },
    resetErrors: function() {
        this._errors = null;
        if (this._form) this._form.removeErrors(this.name);
    },
    /**
   * Set this control's parent form
   * @param {object} form Form object
   * @return {void}
   */ setForm: function(form1) {
        this._form = form1;
        this._showMessages = form1._showMessages;
    },
    /**
   * Returns the form object
   * @return {object}
   */ getForm: function() {
        return this._form;
    }
};
function toCamelCase(str1) {
    return str1.replace(/([\:\-\_]+(.))/g, function(_1, separator1, letter1, offset1) {
        return offset1 ? letter1.toUpperCase() : letter1;
    });
}

},{}],"kih3b":[function(require,module,exports) {
/**
 * Directive for toggling fade in/out
 */ angular.module("common").directive("fadeAway", [
    "$parse",
    "$timeout",
    function($parse, $timeout) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                scope.$watch(attrs.fadeAway, function(val, oldVal) {
                    // for the first time run (if val & oldVal equal each other),
                    // *AND* it's false
                    if (val == oldVal && !val) {
                        // Hide the element, and return
                        element.hide();
                        return;
                    }
                    let method; // Standard watch
                    if (val) method = "fadeIn";
                    else method = "fadeOut";
                    element.addClass("isFadingAway");
                    element[method](function() {
                        element.removeClass("isFadingAway");
                    });
                });
            }
        };
    }
]);

},{}],"4D1Lz":[function(require,module,exports) {
angular.module("common").directive("fadeSwitch", [
    "$parse",
    function($parse) {
        return {
            link: function($scope, element, attrs) {
                if (!$parse(attrs.fadeSwitch)($scope)) element.css({
                    opacity: 0,
                    display: "none"
                });
                else element.css({
                    opacity: 1,
                    display: "block"
                });
                $scope.$watch(attrs.fadeSwitch, function(fade, oldVal) {
                    if (fade != oldVal) {
                        element.stop();
                        if (fade) {
                            element.css({
                                position: "relative",
                                display: "block",
                                opacity: 0
                            });
                            element.animate({
                                opacity: 1
                            });
                        } else {
                            element.css({
                                position: "absolute"
                            });
                            element.animate({
                                opacity: 0
                            }, {
                                complete: function() {
                                    element.css({
                                        display: "none"
                                    });
                                }
                            });
                        }
                    }
                });
            }
        };
    }
]);

},{}],"6phZM":[function(require,module,exports) {
/**
 * Upload button for Fine Uploader
 * Note: requires the FineUploader directive
 * @ngdoc directive
 *
 * @example
 *   <fine-uploader options="options">
 *     <button class="btn">Select new file(s)</button>
 *   </fine-uploader>
 *
 * @todo Ultimately support needs to be added for multiple upload buttons per Fine Uploader instance, with custom options for each. See: http://docs.fineuploader.com/features/extra-buttons.html
 */ angular.module("common").directive("fineUploaderButton", function() {
    return {
        restrict: "A",
        require: "^fineUploader",
        link: function(scope, element, attrs, fineUploaderCtrl) {
            fineUploaderCtrl.addButton(element);
        }
    };
});

},{}],"dNFK6":[function(require,module,exports) {
/**
 * Directive for Fine Uploader's S3 module
 * @name fineUploader
 * @memberOf common
 * @ngdoc directive
 * @scope false
 * @restrict E
 * @see [FineUploader](http://fineuploader.com/)
 * @description
 *   # Directive for Fine Uploader
 *
 *   This directive adds a couple of extra events and properties. Note that `API_ROOT`, `ROOT`, `S3_BUCKET_URL`, `S3_ACCESS_KEY`, and `S3_REGION` all have to be set the in configuration file for this to work.
 *
 *   ## Callbacks:
 *
 *   ### `onSelect`
 *
 *     Example:
 *
 *    ```
 *     onSelect: function(selectedFile) {
 *       // `this` is the uploader instance
 *       // selectedFile is…well…the selected file
 *     }
 *    ```
 *
 *   ## Properties
 *
 *   ### `state`
 *
 *   `uploads`: a list of uploads from `getUploads()`
 *   `uploadComplete`: whether the uploads are complete
 *   `isUploading`: whether it's uploading or not…
 *   `progress`: the current progress, as a decimal number between 0 and 1
 *
 *
 *   ## Custom Button
 *   This directive supports a custom button via the fineUploaderButton directive:
 *
 *  ```
 *   <fine-uploader options="options">
 *     <button class="btn">Select new file(s)</button>
 *   </fine-uploader>
 *  ```
 *
 * @example <fine-uploader options="options"></fine-uploader>
 */ angular.module("common").directive("fineUploader", [
    "API_ROOT",
    "ROOT",
    "S3_BUCKET_URL",
    "S3_ACCESS_KEY",
    "S3_REGION",
    "DEV",
    "$rootScope",
    "$parse",
    "$timeout",
    function(API_ROOT, ROOT, S3_BUCKET_URL, S3_ACCESS_KEY, S3_REGION, DEV, $rootScope, $parse, $timeout) {
        return {
            restrict: "E",
            transclude: true,
            templateUrl: "/directives/fine-uploader.html",
            controller: function() {
                /**
       * Setter for the button!
       * @param {Element} button
       */ this.addButton = function(button) {
                    this.button = button;
                };
            },
            link: function($scope, $element, $attrs, ctrl, $transclude) {
                // If there's a button, get it, and add it before this element
                if (ctrl.button) $element.before(ctrl.button); // Grab the uploader options
                let uploaderOptions = $parse($attrs.options)($scope); // First make sure that all the required endpoints are set. If they aren't, throw an error!
                // Upload success and signature are always required
                if (!uploaderOptions.uploadSuccess.endpoint) throw new ReferenceError(`fineUploader: uploadSuccess.endpoint is a required option`);
                if (!uploaderOptions.signature.endpoint) throw new ReferenceError(`fineUploader: signature.endpoint is a required option`)["session"].forEach(function(requiredOption) {
                    if ($scope.gallery && !uploaderOptions[requiredOption].endpoint) throw new ReferenceError(`fineUploader: ${requiredOption}.endpoint is a required option`);
                });
                const placeholder = new URL(require("ec71a5b2f0a6f6d3")).href;
                /**
       * This is the object of default settings. They can be overridden at any time
       * @type {Object}
       */ let defaults = {
                    // Turn off debug in production, on for local development
                    debug: DEV,
                    // Switch the template based on whether the gallery option is turned on or off
                    template: uploaderOptions.gallery ? "fine-uploader-gallery" : "fine-uploader-button",
                    validation: {
                    },
                    // Merge the thumbnail and scaling options with the implementation, and don't break if thumbnails/scaling isn't sepcified
                    thumbnails: angular.extend({
                        enabled: false,
                        timeBetweenThumbs: 0,
                        placeholders: {
                            waitingPath: placeholder,
                            notAvailablePath: placeholder
                        }
                    }, "thumbnails" in uploaderOptions ? uploaderOptions.thumbnails : {}),
                    scaling: angular.extend({
                        hideScaled: true,
                        sizes: []
                    }, "scaling" in uploaderOptions ? uploaderOptions.scaling : {})
                }; // Only add the option if there's a button
                if (ctrl.button) defaults.button = ctrl.button.get(0);
                /**
       * These are the required options. They cannot be overridden at any time for any reason
       * @type {Object}
       */ let required = {
                    element: $element.get(0),
                    maxConnections: 1,
                    chunking: {
                        enabled: true,
                        mandatory: true,
                        concurrent: {
                            enabled: true
                        }
                    },
                    resume: {
                        enabled: true
                    },
                    cors: {
                        expected: true,
                        sendCredentials: true
                    },
                    request: {
                        endpoint: S3_BUCKET_URL,
                        accessKey: S3_ACCESS_KEY
                    },
                    signature: {
                        version: 4,
                        endpoint: `${API_ROOT}/${uploaderOptions.signature.endpoint}?entityID=${$rootScope.entityID}`
                    },
                    uploadSuccess: {
                        enabled: true,
                        endpoint: `${API_ROOT}/${uploaderOptions.uploadSuccess.endpoint}?entityID=${$rootScope.entityID}`
                    },
                    deleteFile: {
                        enabled: true,
                        endpoint: `${API_ROOT}/${uploaderOptions.deleteFile ? uploaderOptions.deleteFile.endpoint : ""}`,
                        params: {
                            entityID: $rootScope.entityID
                        }
                    },
                    objectProperties: {
                        region: S3_REGION,
                        key: function(id) {
                            let directory = `entity_${$rootScope.entityID}/${uploaderOptions.directory}/`; // If this type of FineUploader instance uploads scaled images (thumbnails), use special endpoints
                            if (((uploaderOptions || {}).scaling || {}).sizes && uploaderOptions.scaling.sizes.length > 0) directory += uploader.getParentId(id) ? `thumbs/` : `orig/`;
                            return directory + uploader.getUuid(id) + `_` + uploader.getName(id);
                        }
                    },
                    session: {
                        endpoint: uploaderOptions.gallery == true && uploaderOptions.session && uploaderOptions.session.endpoint ? `${API_ROOT}/${uploaderOptions.session.endpoint}?entityID=${$rootScope.entityID}` : null,
                        cors: {
                            expected: true,
                            sendCredentials: true
                        }
                    },
                    callbacks: angular.extend({}, uploaderOptions.callbacks, {
                        onSubmitted: function() {
                            this.updateState();
                            runCallback("onSubmitted", this, arguments);
                        },
                        onDelete: function(id) {
                            this.setDeleteFileParams({
                                entityID: $rootScope.entityID
                            }, id);
                            runCallback("onDelete", this, arguments);
                        },
                        onError: function(id, name, errorReason, xhrOrXdr) {
                            this.addError(errorReason);
                            this.updateState();
                            runCallback("onError", this, arguments);
                        },
                        onUpload: function() {
                            this.state.isUploading = true;
                            this.clearErrors();
                            this.updateState();
                            runCallback("onUpload", this, arguments);
                        },
                        onUploadChunk: function() {
                            this.updateState();
                            runCallback("onUploadChunk", this, arguments);
                        },
                        onTotalProgress: function(uploaded, total) {
                            this.state.progress = uploaded / total;
                            runCallback("onTotalProgress", this, arguments);
                        },
                        onSelect: function(selectedFile) {},
                        onComplete: function(id, name, responseJSON, xhrOrXdr) {
                            bindOnSelect.call(this);
                            this.updateState();
                            this.state.isUploading = false;
                            runCallback("onComplete", this, arguments);
                        },
                        onSessionRequestComplete: function(response) {
                            let uploader = this;
                            bindOnSelect.call(this);
                            runCallback("onSessionRequestComplete", this, arguments);
                        }
                    })
                };
                function bindOnSelect() {
                    $element.find("li.qq-upload-success").each(function() {
                        let id = uploader.getId(this);
                        $(this).on("click", function() {
                            (uploaderOptions.callbacks.onSelect || required.callbacks.onSelect).call(uploader, uploader.getUploads({
                                id
                            }));
                        });
                    });
                }
                /**
       * Runs a particular callback with the correct context and args
       * @param  {string} name    the name of the method that should be called
       * @param  {object} context the context to apply to the method call
       * @param  {array} args     the forwarded args from the original callback
       * @return {void}
       */ function runCallback(name, context, args) {
                    if (uploaderOptions.callbacks && uploaderOptions.callbacks[name]) uploaderOptions.callbacks[name].apply(context, args);
                } // Create the options object, first passing in the defaults, then the instance options, and finally, the required options, so that they override everything
                let options = angular.extend(defaults, uploaderOptions, required); // After extending the options, wrap all the callback in a $scope.$apply so that Angular picks up on changes
                for(let func in options.callbacks){
                    let originalCallback = options.callbacks[func];
                    options.callbacks[func] = function() {
                        let forwardedArgs = arguments; // Wrap the $apply in a timeout, otherwise in some circumstances, it will error out due to a $digest cycle already running
                        // If there isn't a $digest running, this will run right away, else it will wait until the $digest is done, and then run
                        setTimeout(()=>{
                            $scope.$apply(()=>{
                                originalCallback.apply(this, forwardedArgs);
                            });
                        });
                    };
                } // Create an s3 instance of FineUploader!
                let uploader = new qq.s3.FineUploader(options); // Declare the "start" or "base" state of the state value, and initialize the state property using the base state
                let baseState = {
                    progress: 0,
                    hasErrors: false,
                    errors: []
                };
                uploader.state = baseState;
                let originalReset = uploader.reset;
                /**
       * Records an error to the current list of errors
       * @param {string} errorReason
       */ uploader.addError = function(errorReason) {
                    this.state.errors.push(errorReason);
                };
                /**
       * Clears all errors from the error list
       */ uploader.clearErrors = function() {
                    this.state.errors = [];
                };
                /**
       * Updates the state object on the uploader
       * @return {void}
       */ uploader.updateState = function() {
                    // Make sure our list of uploads is correct
                    this.state.uploads = this.getUploads(); // Refresh the "haveUploaded" attribute
                    var netUploads = this.getNetUploads();
                    this.state.uploadComplete = netUploads > 0 && netUploads === this.getUploads().length; // Refresh our tracker for whether or not there are errors
                    this.state.hasErrors = this.state.errors.length > 0;
                };
                /**
       * Resets the uploader
       * @param  {Boolean} [shouldClearErrors=true] whether to clear the errors or not when resetting
       * @return {void}
       */ uploader.reset = function(shouldClearErrors = true) {
                    if (!shouldClearErrors) var savedErrors = uploader.state.errors;
                    uploader.state = baseState;
                    originalReset.call(uploader);
                    if (shouldClearErrors) uploader.clearErrors();
                    else uploader.state.errors = savedErrors;
                    uploader.updateState;
                };
                $scope.uploader = uploader;
            }
        };
    }
]);

},{"ec71a5b2f0a6f6d3":"lvGEg"}],"lvGEg":[function(require,module,exports) {
module.exports = require("f4226f5fb2a1dc8d").getBundleURL("2OE9k") + require("82f6c53b5bb84fa1").resolve("94sgB");

},{"f4226f5fb2a1dc8d":"gQU1w","82f6c53b5bb84fa1":"2poic"}],"8Xi5a":[function(require,module,exports) {
angular.module("common").directive("jsonText", function() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, element, attr, ngModel) {
            function into(input) {
                return JSON.parse(input);
            }
            function out(data) {
                return JSON.stringify(data, undefined, 2);
            }
            ngModel.$parsers.push(into);
            ngModel.$formatters.push(out);
        }
    };
});

},{}],"8ecCx":[function(require,module,exports) {
/**
 * Loading Indicator directive
 */ angular.module("common").directive("loadingIndicator", function() {
    return {
        restrict: "A",
        templateUrl: "/directives/loading-indicator.html",
        replace: true,
        scope: {
            width: "=?width",
            height: "=?height",
            speed: "=?speed",
            active: "=active",
            textStyle: "=?textStyle",
            lineWidth: "=?lineWidth",
            text: "=?text"
        },
        link: function(scope, element, attrs) {
            var defaultSettings = {
                width: 175,
                height: 75,
                speed: 7,
                textStyle: "",
                lineWidth: 4,
                text: "Loading"
            };
            for(var set in defaultSettings)if (typeof scope[set] == "undefined" || scope[set] == "") scope[set] = defaultSettings[set];
            var text = {
                dotsCounter: 0,
                dots: function() {
                    var text = $(element).children(".text").text();
                    $(element).children(".text").text($(element).children(".text").text() + ".");
                    if (this.dotsCounter == 4) {
                        $(element).children(".text").text(scope.text);
                        this.dotsCounter = 0;
                    }
                    this.dotsCounter++;
                }
            };
            var top, right, left, bottom;
            top = $(element).children(".top");
            right = $(element).children(".right-side");
            left = $(element).children(".left");
            bottom = $(element).children(".bottom");
            var indicator = {
                // the current time
                time: 0,
                // approximately the speed of the animation in seconds
                end: scope.speed,
                reset: function() {
                    this.time = 0;
                    this.setPositions();
                    top.css("width", 0);
                    right.css("height", 0);
                    bottom.css("width", 0);
                    left.css("height", 0);
                    top.css("height", scope.lineWidth);
                    right.css("width", scope.lineWidth);
                    bottom.css("height", scope.lineWidth);
                    left.css("width", scope.lineWidth);
                },
                setPositions: function() {
                    top.css({
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: "auto"
                    });
                    right.css({
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: "auto"
                    });
                    bottom.css({
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        left: "auto"
                    });
                    left.css({
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        top: "auto"
                    });
                    top.css("height", scope.lineWidth);
                    right.css("width", scope.lineWidth);
                    bottom.css("height", scope.lineWidth);
                    left.css("width", scope.lineWidth);
                    this.time = 0;
                },
                start: function() {
                    var step = this.end / 32.5, percent; // the first loop
                    if (this.time <= step * 1) {
                        percent = this.time / step * 100;
                        $(element).children(".top").css("width", percent + "%");
                    } else if (this.time > step * 1 && this.time <= step * 2) {
                        percent = this.time / (step * 2) * 200 - 100;
                        top.css("width", "100%");
                        right.css("height", percent + "%");
                    } else if (this.time > step * 2 && this.time <= step * 3) {
                        percent = this.time / (step * 3) * 300 - 200;
                        bottom.css("width", percent + "%");
                    } else if (this.time > step * 3 && this.time <= step * 4) {
                        percent = this.time / (step * 4) * 400 - 300;
                        bottom.css("width", "100%");
                        left.css("height", percent + "%");
                    } // the second loop (going backwards)
                    if (this.time > step * 4 && this.time <= step * 5) {
                        percent = (this.time / (step * 5) * 500 - 400) * -1 + 100;
                        left.css("height", percent + "%");
                    } else if (this.time > step * 5 && this.time <= step * 6) {
                        percent = (this.time / (step * 6) * 600 - 500) * -1 + 100;
                        left.css("height", 0);
                        bottom.css("width", percent + "%");
                    } else if (this.time > step * 6 && this.time <= step * 7) {
                        percent = (this.time / (step * 7) * 700 - 600) * -1 + 100;
                        bottom.css("width", 0);
                        right.css("height", percent + "%");
                    } else if (this.time > step * 7 && this.time <= step * 8) {
                        percent = (this.time / (step * 8) * 800 - 700) * -1 + 100;
                        right.css("height", 0);
                        top.css("width", percent + "%");
                    } else if (this.time > step * 8 && this.time <= step * 9) {
                        top.css({
                            right: 0,
                            left: "auto"
                        });
                        right.css({
                            bottom: 0,
                            top: "auto"
                        });
                        bottom.css({
                            left: 0,
                            right: "auto"
                        });
                        left.css({
                            top: 0,
                            bottom: "auto"
                        });
                        percent = this.time / (step * 9) * 900 - 800;
                        top.css("width", 0);
                        left.css("height", percent + "%");
                    } else if (this.time > step * 9 && this.time <= step * 10) {
                        percent = this.time / (step * 10) * 1000 - 900;
                        bottom.css("width", percent + "%");
                    } else if (this.time > step * 10 && this.time <= step * 11) {
                        percent = this.time / (step * 11) * 1100 - 1000;
                        right.css("height", percent + "%");
                    } else if (this.time > step * 11 && this.time <= step * 12) {
                        percent = this.time / (step * 12) * 1200 - 1100;
                        top.css("width", percent + "%");
                    } else if (this.time > step * 12 && this.time <= step * 13) {
                        percent = (this.time / (step * 13) * 1300 - 1200) * -1 + 100;
                        top.css("width", percent + "%");
                    } else if (this.time > step * 13 && this.time <= step * 14) {
                        percent = (this.time / (step * 14) * 1400 - 1300) * -1 + 100;
                        top.css("width", 0);
                        right.css("height", percent + "%");
                    } else if (this.time > step * 14 && this.time <= step * 15) {
                        percent = (this.time / (step * 15) * 1500 - 1400) * -1 + 100;
                        right.css("height", 0);
                        bottom.css("width", percent + "%");
                    } else if (this.time > step * 15 && this.time <= step * 16) {
                        percent = (this.time / (step * 16) * 1600 - 1500) * -1 + 100;
                        bottom.css("width", 0);
                        left.css("height", percent + "%");
                    } else if (this.time > step * 16 && this.time <= step * 17) {
                        this.setPositions();
                        left.css("height", 0);
                    }
                    this.time += 0.01;
                }
            };
            indicator.setPositions();
            setInterval(function() {
                if (scope.active == true) indicator.start();
                else {
                    indicator.time = 0;
                    indicator.reset();
                }
            }, 10);
            setInterval(function() {
                if (scope.active == true) text.dots();
            }, 250);
        }
    };
});

},{}],"6Xf8a":[function(require,module,exports) {
/**
 * Directive for multi-selection
 * @name multiSelect
 * @ngdoc directive
 * @requires ngModel
 *
 * @attribute items the array of items to build the select from
 * @attribute options the select settings. The options are expected to be a string, separated by comma like so: valueProperty,labelProperty
 * @attribute model the ngModel
 * @attribute [label=] the callback to get a custom label. Will pass in `$values`, where `$values` is the array of selected options, as long as `$values` is one of the params to the function
 *
 * @example
 * <div multi-select="source" options="value,label" ng-model="model"></div>
 */ angular.module("common").directive("multiSelect", [
    "$parse",
    function($parse) {
        return {
            scope: {
                items: "=multiSelect",
                unparsedOptions: "@options",
                model: "=ngModel",
                label: "&"
            },
            require: "ngModel",
            templateUrl: "/directives/multi-select.html",
            link: function($scope, element, attrs, ngModel) {
                var splitOptions = $scope.unparsedOptions.split(",");
                $scope.options = {
                    value: splitOptions[0],
                    label: splitOptions[1] || splitOptions[0]
                };
                $scope.isDropdownOpen = false;
                if (!$scope.model) $scope.model = [];
                $scope.generateID = function($index) {
                    return Math.floor(Math.random() * 1000000) + 1 + "-" + $scope.$id + "-" + $index;
                };
                $scope.getLabel = function() {
                    if (attrs.label) return $scope.label({
                        $values: $scope.model
                    });
                    else return `${$scope.model.length} selected`;
                };
                $scope.get = function(type, item, $index) {
                    if ($scope.options[type] == "$index") return $index;
                    if ($scope.options[type] == "$value") return item;
                    return item[$scope.options[type]];
                };
            }
        };
    }
]);

},{}],"kIpG9":[function(require,module,exports) {
angular.module("common").directive("ngEnter", function() {
    return {
        link: function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    };
});

},{}],"iYUj4":[function(require,module,exports) {
/**
 * Ng-Multi-Transclude directive
 * Lifted from: http://zachsnow.com/#!/blog/2013/angularjs-multi-transclusion/
 */ angular.module("common").directive("ngMultiTransclude", function() {
    return {
        controller: [
            "$scope",
            "$element",
            "$attrs",
            "$transclude",
            "$log",
            function($scope, $element, $attrs, $transclude, $log) {
                if (!$transclude) throw {
                    name: "DirectiveError",
                    message: "ng-multi-transclude found without parent requesting transclusion"
                };
                this.$transclude = $transclude;
            }
        ],
        link: function($scope, $element, $attrs, controller, $log) {
            console.log($element);
            var selector = "[name=" + $attrs.ngMultiTransclude + "]";
            var attach = function(clone) {
                var $part = clone.find(selector).addBack(selector);
                $element.html("");
                $element.append($part);
            };
            if (controller.$transclude.$$element) attach(controller.$transclude.$$element);
            else controller.$transclude(function(clone) {
                controller.$transclude.$$element = clone;
                attach(clone);
            });
        }
    };
});

},{}],"87AXe":[function(require,module,exports) {
/**
 * Directive to wrap [nicescroll](https://github.com/inuyaksa/jquery.nicescroll)
 *   Example:
 *     <div nicescroll></div>
 *
 *  Passing options in:
 *     <div nicescroll nicescroll-options={[options]}></div>
 *
 *  Default offset:
 *    {top: 0, right: 0, left: 0, bottom: 0}
 */ angular.module("common").directive("nicescroll", [
    "$window",
    function($window) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                var defaultOffset = {
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0
                };
                var offset = angular.extend(defaultOffset, scope.$eval(attrs.nicescrollOffset) || {});
                var options = angular.extend({
                    cursorwidth: 10,
                    cursoropacitymax: 0.7,
                    dblclickzoom: false,
                    bouncescroll: true,
                    sensitiverail: true,
                    enablescrollonselection: true,
                    grabcursorenabled: true,
                    enablekeyboard: true,
                    railpadding: offset
                }, scope.$eval(attrs.nicescroll) || {});
                $(element).niceScroll(options);
                $($window).resize(function() {
                    $(element).getNiceScroll().resize();
                });
            }
        };
    }
]);

},{}],"2kh7b":[function(require,module,exports) {
angular.module("common").directive("offClick", [
    "$document",
    "$parse",
    function($document, $parse) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                var offClick = $parse(attrs.offClick);
                function clickHandler(event) {
                    if (event.target != element.get(0) && !element.find(event.target).length) scope.$apply(function() {
                        offClick(scope);
                    });
                }
                $document.bind("click", clickHandler); // When the scope is destroyed, unbind the listener
                scope.$on("$destroy", function() {
                    $document.unbind("click", clickHandler);
                });
            }
        };
    }
]);

},{}],"eq0ZF":[function(require,module,exports) {
angular.module("common").directive("progressIndicator", function() {
    return {
        restrict: "C",
        scope: {
            displayed: "=",
            progress: "=progressDisplay",
            text: "="
        },
        templateUrl: "/directives/progress-indicator.html"
    };
});

},{}],"jgQO3":[function(require,module,exports) {
/**
 * @name redactor
 * @memberOf common
 * @ngdoc directive
 * @scope true
 * @restrict A
 * @description
 *   A directive for the Redactor WYSIWYG editor
 *
 * @attribute {Expression} change The callback
 * @example
 *   <textarea redactor change="onChange()"></textarea>
 */ angular.module("common").directive("redactor", [
    "$parse",
    function($parse) {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                change: "&"
            },
            link: function($scope, element, attrs, ngModel) {
                /**
       * The configuration object for Redactor
       * @type {Object}
       */ var redactorConfig = {
                    buttons: [
                        "html",
                        "formatting",
                        "bold",
                        "italic",
                        "deleted",
                        "underline",
                        "unorderedlist",
                        "orderedlist",
                        "outdent",
                        "indent",
                        "image",
                        "link",
                        "alignment",
                        "horizontalrule",
                        "fontcolor",
                        "fontsize",
                        "backcolor",
                        "fullscreen"
                    ],
                    plugins: [
                        "fontcolor",
                        "fontsize",
                        "fullscreen"
                    ],
                    replaceDivs: false,
                    /**
         * Called before Redactor launches
         * @return {void}
         */ startCallback: function() {
                        ngModel.$setPristine();
                    },
                    /**
         * Called each time text changes in visual mode
         *   (the same as 'codeKeydownCallback', but for visual mode)
         * @return {void}
         */ changeCallback: function() {
                        textDidChange(this.code.get());
                    },
                    /**
         * Called each time text changes in HTML mode
         *   (the same as 'changeCallback', but for HTML mode)
         * @return {void}
         */ codeKeydownCallback: function() {
                        textDidChange(this.code.get());
                    }
                }; // Get the user configuration object
                var userConfig = angular.copy($parse(attrs.redactor)($scope.$parent));
                userConfig = userConfig || {};
                userConfig.addButtons = userConfig.addButtons ? userConfig.addButtons : [];
                userConfig.removeButtons = userConfig.removeButtons ? userConfig.removeButtons : [];
                userConfig.addPlugins = userConfig.addPlugins ? userConfig.addPlugins : [];
                userConfig.removePlugins = userConfig.removePlugins ? userConfig.removePlugins : [];
                redactorConfig.buttons = _.difference(redactorConfig.buttons, userConfig.removeButtons);
                redactorConfig.buttons = _.union(redactorConfig.buttons, userConfig.addButtons);
                redactorConfig.plugins = _.difference(redactorConfig.plugins, userConfig.removePlugins);
                redactorConfig.plugins = _.union(redactorConfig.plugins, userConfig.addPlugins);
                delete userConfig.addPlugins;
                delete userConfig.removePlugins;
                delete userConfig.addButtons;
                delete userConfig.removeButtons;
                redactorConfig = _.extend(redactorConfig, userConfig); // The model isn't available right away (it's initialized as 'NaN')
                // So watch it until it has a value, then run initialize()
                var unbindWatcher = $scope.$watch(function() {
                    return ngModel.$viewValue;
                }, initialize);
                /**
       * Initializes the directive
       * @param  {string} value the HTML from ngModel
       * @return {void}
       */ function initialize(value) {
                    // Unbind the watcher
                    unbindWatcher(); // Initialize Redactor
                    element.redactor(redactorConfig);
                    ngModel.$render = ngModelRender;
                }
                function ngModelRender() {
                    element.redactor("code.set", ngModel.$viewValue);
                }
                /**
       * Runs whenever any text changes (either visual or HTML mode)
       * @param  {string} text the HTML string
       * @return {void}
       */ function textDidChange(text) {
                    $scope.change({
                        $text: text
                    }); // Run this in an $apply
                    $scope.$apply(function() {
                        // And update the view value
                        ngModel.$setViewValue(text);
                    });
                }
            }
        };
    }
]);

},{}],"fqE0A":[function(require,module,exports) {
/**
 * A directive that scrolls the bottom or top of an element
 */ angular.module("common").directive("scrollTo", [
    "$parse",
    function($parse) {
        return {
            scope: {
                direction: "@",
                animate: "@",
                willScroll: "=scrollTo"
            },
            link: function($scope, $element, $attrs) {
                $scope.$watch("willScroll", function(willScroll, oldVal) {
                    if (!willScroll || willScroll == oldVal) return;
                    if ($scope.direction == "top") var scrollTop = 0;
                    else if ($scope.direction == "bottom") var scrollTop = $element[0].scrollHeight;
                    $element.animate({
                        scrollTop: scrollTop
                    }, $scope.animate ? 300 : 0, function() {
                        $(window).trigger("resize");
                    });
                    $scope.willScroll = false;
                });
            }
        };
    }
]);

},{}],"hZZFe":[function(require,module,exports) {
/**
 * Directive for selecting an element
 */ angular.module("common").directive("selectElement", [
    "$parse",
    "$timeout",
    function($parse, $timeout) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                element.on("focusin", function(e) {
                    element.select();
                });
                element.mouseup(function(e) {
                    e.preventDefault();
                });
            }
        };
    }
]);

},{}],"f0Qal":[function(require,module,exports) {
/**
 * Directive for toggling sliding up/down
 */ angular.module("common").directive("slideAway", [
    "$parse",
    "$timeout",
    function($parse, $timeout) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                var callback = $parse(attrs.slideAwayCallback) || function() {};
                scope.$watch(attrs.slideAway, function(val, oldVal) {
                    if (val == oldVal && !!val == false) {
                        element.hide();
                        return;
                    }
                    if (!!val == true) $timeout(function() {
                        element.slideDown({
                            complete: function() {
                                callback(scope, {
                                    $position: "down"
                                });
                            }
                        });
                    }, 0);
                    else element.slideUp({
                        complete: function() {
                            callback(scope, {
                                $position: "up"
                            });
                        }
                    });
                });
            }
        };
    }
]);

},{}],"8oru6":[function(require,module,exports) {
/**
 * Small loading indicator
 */ angular.module("common").directive("smallLoadingIndicator", function() {
    return {
        restrict: "C",
        templateUrl: "/directives/small-loading-indicator.html",
        scope: {},
        link: function(scope, element, attrs) {}
    };
});

},{}],"ivrGl":[function(require,module,exports) {
/// <reference path="../../../node_modules/@types/jquery/JQuery.d.ts" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _angular = require("angular");
var _angularDefault = parcelHelpers.interopDefault(_angular);
(0, _angularDefault.default).module("common").directive("clipboard", function() {
    return {
        restrict: "A",
        transclude: true,
        replace: true,
        templateUrl: "/directives/clipboard.html",
        scope: {
            content: "=clipboard",
            rows: "@"
        },
        link: function(scope, element) {
            scope.rows = typeof scope.rows == "undefined" ? 5 : scope.rows;
            const showFallbackCopy = ()=>{
                scope.$apply(()=>{
                    scope.showUnsupportedCopy = !scope.showUnsupportedCopy;
                    if (scope.showUnsupportedCopy) element.children("textarea").trigger("focus").select();
                });
            };
            const showSuccessfulTooltip = ()=>{
                element.find(".tooltip").addClass("in");
                setTimeout(function() {
                    element.find(".tooltip").removeClass("in");
                }, 1000);
            };
            element.children("[ng-transclude]").css({
                width: 0,
                height: 0
            });
            element.children("[ng-transclude]").children().first().on("click", ()=>{
                if (navigator.clipboard) navigator.clipboard.writeText(scope.content).then(showSuccessfulTooltip, showFallbackCopy);
                else showFallbackCopy();
            });
        }
    };
});

},{"angular":"8oyA9","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1Gg25":[function(require,module,exports) {
/**
 * Capitalize filter
 */ angular.module("common").filter("capitalize", function() {
    return function(input, scope) {
        return typeof input == "string" ? input.substring(0, 1).toUpperCase() + input.substring(1) : input;
    };
});

},{}],"iPiEq":[function(require,module,exports) {
/**
 * Converts a string to ISO date
 */ angular.module("common").filter("dateToISO", function() {
    return function(dateString) {
        var newDate = new Date(dateString).toISOString();
        return newDate;
    };
});

},{}],"6PkpN":[function(require,module,exports) {
/**
 * Number format filter
 * Formats a number like '123456' and returns the correct format for the user's locale
 * I.e., for en_US it would return '123,456'
 */ angular.module("common").filter("numeral", function() {
    return function(string, format) {
        return numeral(string).format();
    };
});

},{}],"1cVsH":[function(require,module,exports) {
/**
 * Mark a URL as a trusted resource url. Used mainly for iFrames.
 *
 * <iframe ng-src="{{object.src | trusted}}" />
 */ angular.module("common").filter("trusted", [
    "$sce",
    function($sce) {
        return function(url) {
            return $sce.trustAsResourceUrl(url);
        };
    }
]);

},{}],"5ZDlp":[function(require,module,exports) {
/**
 * Array manipulation service
 */ angular.module("common").factory("ArrayHelper", function() {
    var ArrayHelper = function() {};
    /**
   * Breaks an array on a split number
   * @param  {array} items
   * @param  {integer} splitNumber how big each array will be
   *                               i.e., a splitNumber of 5 will return arrays with a max length of 5
   * @param  {integer} [startAt=1]     the index to start counting at
   * @param  {boolean} [returnArray=false] whether to return an array of arrays
   * @return {array} either an array of objects
   *                        or if returnArray == true,
   *                        an array of arrays of objects
   */ ArrayHelper.breakAt = function(items, splitNumber, startAt, returnArray) {
        // If there aren't any items, return
        if (!items || items.length == 0) return;
         // Initialize the new array
        var newItems = []; // to keep track of the new array's key
        var j = 0; // If this is returning an array,
        // this the the individual array's current key
        var i = 0; // to keep track of what number the loop is on
        var x = typeof startAt == "undefined" ? 1 : startAt; // Loop through all the items
        angular.forEach(items, function(val, key) {
            // If this array hasn't been initialized, do so
            if (!newItems[j]) {
                if (returnArray) newItems[j] = [];
                else newItems[j] = {};
            } // The key for the array (second level array)
            // If this is returning an array of arrays, it will be i (the array tracker key)
            // If it's not (i.e., it will return an array of objects), the key will be the current key (the "key" variable)
            var theKey = returnArray ? i : key; // Initalize the array with the key and set the object
            newItems[j][theKey] = {};
            newItems[j][theKey] = val; // Increment the array key
            i++; // If the loop has reached the split number
            if (x == splitNumber) {
                // Increment the array key
                j++; // Reset the current number
                x = 1; // Reset the array key
                i = 0; // Otherwise just increment the current number
            } else x++;
        }); // And finally, after all that craziness, *whew*, return the final array
        return newItems;
    };
    /**
   * Make a dictionary out of an array using the specified element as id
   * @param {array} array
   * @param {string} id The name of the property to use a key
   * @return {object}
   */ ArrayHelper.makeDict = function(array, id) {
        var dict = {};
        for(var i = 0; i < array.length; i++)dict[array[i][id]] = array[i];
        return dict;
    };
    return ArrayHelper;
});

},{}],"iZ4ER":[function(require,module,exports) {
angular.module("common").factory("Collapser", function() {
    var Collapser = function(element) {
        this.element = element;
        this.children = this.element.children();
        this.timeout, this.timer;
    };
    Collapser.prototype = {
        /**
     * Animates in
     * @param  {integer} index
     * @param  {integer} timeout
     * @return {void}
     */ in: function(index, timeout) {
            if (this.timeout) window.clearTimeout(this.timeout); // Get all the calculations
            this.target = this.children.eq(index);
            if (!this.target.get(0)) return;
            this.targetWidth = this.target.get(0).scrollWidth / this.element.width() * 100;
            this.siblings = this.target.siblings(); // Make sure that the target isn't animating bigger than the parent
            if (this.targetWidth > 80 && this.siblings.length) this.targetWidth = 80;
            else if (!this.siblings.length) this.targetWidth = 100;
            this.targetSiblingWidth = (100 - this.targetWidth) / this.siblings.length;
            this.groups = [
                {
                    targetWidth: this.targetWidth,
                    elements: this.target
                },
                {
                    targetWidth: this.targetSiblingWidth,
                    elements: this.siblings
                }
            ];
            this.animationLength = 20;
            this.step = 1;
            this.timeout = window.setTimeout(this._run.bind(this), 200);
        },
        /**
     * Animates out
     * @param  {integer} timeout
     * @return {void}
     */ out: function(timeout) {
            if (this.timeout) window.clearTimeout(this.timeout);
            this.animationLength = 20;
            this.step = 1;
            this.groups = [
                {
                    targetWidth: this.element.width() / this.children.length / this.element.width() * 100,
                    elements: this.element.children()
                }
            ];
            this.timeout = window.setTimeout(this._run.bind(this), 200);
        },
        /**
     * Runs the animation for an array of elements
     * @return {void}
     */ _run: function() {
            this.stepsRemaining = this.animationLength - this.step;
            var self = this;
            for(var i = 0; i < this.groups.length; i++){
                var group = this.groups[i];
                group.elements.each(function() {
                    self._step(this, group.targetWidth, self.stepsRemaining);
                });
            }
            if (this.step != this.animationLength) {
                this.step++;
                setTimeout(this._run.bind(this), 5);
            }
        },
        _step: function(element, targetWidth, stepsRemaining) {
            var node = $(element), width = element.getBoundingClientRect().width / this.element.width() * 100, remaining = targetWidth - width;
            node.css("width", width + remaining / stepsRemaining + "%");
        } // _setTimeout: function() {
    };
    return Collapser;
});

},{}],"cNWet":[function(require,module,exports) {
/**
 * Color helper service
 * @param {Object|string} color
 *                Takes an rgb object, like so: {r: 255, g: 255, b: 255}
 *                Or a hex string: '000000', '#000000'
 *                Or an rgb string: '(255, 255, 255)'
 * @return {string} returns either 'dark' or 'light'
 */ angular.module("common").factory("ColorHelper", function() {
    var ColorHelper = {
        /**
     * Gets the contrast of a color (dark|light); used for text color
     * @param  {string} color
     * @param  {integer} [threshold] an integer that changes the threshold
     *                               for what is considered dark/light
     *                               Less = darker
     *                               Higher = lighter
     * @return {string} dark|light
     */ getContrast: function(color, threshold) {
            var rgb = this.parseColor(color);
            if (rgb === null) return rgb;
            var brightness = rgb.r * 299 + rgb.g * 587 + rgb.b * 114, threshold = threshold || 0.8;
            brightness = brightness / 255000; // values range from 0 to 1
            // anything greater than 0.8 should be bright enough for dark text
            if (brightness >= threshold) return "dark";
            else return "light";
        },
        componentToHex: function(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
        },
        rgbToHex: function(rgb, green, blue) {
            if (rgb instanceof Object) {
                var red = rgb.r;
                green = rgb.g;
                blue = rgb.b;
            } else var red = rgb;
            return "#" + this.componentToHex(red) + this.componentToHex(green) + this.componentToHex(blue);
        },
        hexToRgb: function(hex) {
            // Strip the pound symbol
            hex = hex.replace("#", ""); // If it isn't a correct hex color, make it black
            if (hex.length != 3 && hex.length != 6) hex = "000"; // If it's a three character string,
            //  split it and double each element
            if (hex.length == 3) {
                hex = hex.split("");
                for(var i = 0; i < hex.length; i++)hex[i] += hex[i];
                 // If it's a six digit string,
            //  split it into three elements
            } else if (hex.length == 6) {
                var array = [];
                array.push(hex.substr(0, 2));
                array.push(hex.substr(2, 2));
                array.push(hex.substr(4, 2));
                hex = array;
            } // Return the parsed color as an object
            return {
                r: parseInt(hex[0], 16),
                g: parseInt(hex[1], 16),
                b: parseInt(hex[2], 16)
            };
        },
        /**
     * Brightens/darkens an rgb color
     * @param  {string} color
     * @param  {integer} percent a float where 1 = 100 percent
     * @return {object} the brightened color
     */ brighten: function(color, percent, min) {
            if (!isNaN(parseInt(percent)) && percent !== 0) {
                var rgba = this.parseColor(color);
                for(var i in rgba){
                    if (i == "a") continue;
                    rgba[i] += parseInt(percent * 255);
                    if (rgba[i] < 0) rgba[i] = 0;
                    if (rgba[i] > 255) rgba[i] = 255;
                }
            }
            return rgba;
        },
        /**
     * Parses a color and returns an RGB
     * @param  {string} color hex/rgb/rgba
     * @return {object|null} either an rgb(a) object or null
     */ parseColor: function(color) {
            var hexRegex = /^([a-f0-9]{6}|[a-f0-9]{3})$/i, rgbRegex = /^(\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?(?:\.\d+)?)?$/, rgb = {}, matches;
            if (!(color instanceof Object)) var color = color.replace("#", "").replace(/ /g, "").replace(/rgb(a)?/gi, "").replace(/(\()|(\))/gi, ""); // If this is a hex string
            if (hexRegex.test(color)) rgb = this.hexToRgb(color);
            else if (color instanceof Object) rgb = color;
            else if ((matches = rgbRegex.exec(color)) && matches !== null) {
                rgb.r = parseFloat(matches[1], 10);
                rgb.g = parseFloat(matches[2], 10);
                rgb.b = parseFloat(matches[3], 10);
                if (matches[4]) rgb.a = parseFloat(matches[4], 10);
            }
            if (_.isEmpty(rgb)) return null;
            return rgb;
        }
    };
    return ColorHelper;
});

},{}],"bDlSF":[function(require,module,exports) {
/**
 * Date helper for manipulating and working with date objects
 */ angular.module("common").factory("DateHelper", function() {
    var DateHelper = function(date) {
        if (Object.prototype.toString.call(date) !== "[object Date]") throw new TypeError("date is not a valid Date object");
        this._date = date;
    };
    /**
   * "Static" method to parse a yyyy-mm-dd string into a Date object
   * @param  {string} string 'yyyy-mm-dd' date
   * @return {Date}
   */ DateHelper.yyyymmddToDate = function(string) {
        var date = string.split("-");
        return new Date(date[0] * 1, date[1] - 1, date[2] * 1);
    };
    /**
   * Returns a Date from X days ago (with an optional date specified)
   * @param  {integer} days the number of days to offset
   * @param  {Date} [date=Date] an optional Date object
   * @return {Date}
   */ DateHelper.daysAgo = function(days, date) {
        if (!date) date = new Date(); // Get the number of ms offset
        var dayOffset = 86400000 * days;
        return new Date(date.setTime(date.getTime() - dayOffset));
    };
    /**
   * Formats a Date object as yyyy-mm-dd
   * @return {string}
   */ DateHelper.prototype.toString = function() {
        var year = this._date.getFullYear(), month = this._date.getMonth() + 1, date = this._date.getDate();
        return year + "-" + (month > 9 ? month : "0" + month) + "-" + (date > 9 ? date : "0" + date);
    };
    return DateHelper;
});

},{}],"2Tx5R":[function(require,module,exports) {
/**
 * @name DateRange
 * @memberOf common
 * @ngdoc service
 * @description Service to interact with date ranges
 */ angular.module("common").service("DateRange", [
    "Session",
    "$state",
    function(Session, $state) {
        var first12 = moment();
        first12.month(first12.month() - 12);
        var last12 = moment();
        last12.month(last12.month() - 1);
        var last12Text = "(" + first12.format("MMM YY") + " - " + last12.format("MMM YY") + ")";
        this.ranges = [
            {
                value: "all",
                name: "All"
            },
            {
                value: "today",
                name: "Today"
            },
            {
                value: "2",
                name: "Last 2 Days"
            },
            {
                value: "14",
                name: "Last 14 Days"
            },
            {
                value: "30",
                name: "Last 30 Days"
            }
        ];
        this.complexRanges = [
            {
                value: "mtd",
                name: "This Month"
            },
            {
                value: "last-month",
                name: "Last Month"
            },
            {
                value: "last-quarter",
                name: "Last Quarter"
            },
            {
                value: "ytd",
                name: "This Year"
            },
            {
                value: "last-year",
                name: "Last Year (" + (new Date().getFullYear() - 1) + ")"
            },
            {
                value: "12-months",
                name: "Last 12 Months " + last12Text
            }
        ];
        this.getRanges = function(complex) {
            var ranges = angular.copy(this.ranges);
            if (complex) ranges = ranges.concat(angular.copy(this.complexRanges)).concat(this._getFiscalYear());
            ranges.push({
                value: "custom",
                name: "Custom"
            });
            return ranges;
        };
        this._getFiscalYear = function() {
            let entity = this._getEntity();
            if (entity && entity.fyMonth && entity.fyDay) return [
                {
                    value: "fytd",
                    name: "Fiscal Year To Date"
                }
            ];
            return [];
        };
        this._getEntity = function() {
            return _.find(Session.getAll().entityList, {
                ID: parseInt($state.params.entityID)
            });
        };
        this.getRange = function(preset) {
            if (typeof preset == "undefined") return;
            var range = {
                range: preset
            };
            switch(preset){
                case "all":
                    range.minDate = new Date();
                    range.maxDate = new Date();
                    break;
                case "today":
                    range.minDate = new Date();
                    range.maxDate = new Date();
                    break;
                case "mtd":
                    range.minDate = new Date();
                    range.minDate.setDate(1);
                    range.maxDate = new Date();
                    break;
                case "last-month":
                    range.minDate = new Date();
                    var month = range.minDate.getMonth() - 1;
                    range.minDate.setMonth(month);
                    range.minDate.setDate(1);
                    range.maxDate = new Date();
                    range.maxDate.setDate(0);
                    break;
                case "last-quarter":
                    range.minDate = new Date();
                    range.minDate = new Date(range.minDate.getFullYear(), range.minDate.getMonth() - range.minDate.getMonth() % 3);
                    range.minDate.setHours(0, 0, 0, 0);
                    range.minDate = moment(range.minDate).subtract(1, "quarters").toDate();
                    range.maxDate = moment(range.minDate).add(1, "quarters").subtract(1, "days").toDate();
                    range.maxDate.setHours(23, 59, 59, 999);
                    break;
                case "ytd":
                    range.minDate = new Date();
                    range.minDate.setDate(1);
                    range.minDate.setMonth(0);
                    range.minDate.setHours(0, 0, 0, 0);
                    range.maxDate = new Date();
                    break;
                case "last-year":
                    var lastYear = new Date().getFullYear() - 1;
                    range.minDate = new Date(lastYear, 0, 1);
                    range.maxDate = new Date(lastYear, 12, 0);
                    break;
                case "12-months":
                    range.minDate = new Date();
                    range.minDate.setMonth(range.minDate.getMonth() - 12);
                    range.minDate.setDate(1);
                    range.maxDate = new Date();
                    range.maxDate.setDate(0);
                    break;
                case "fytd":
                    let entity = this._getEntity();
                    range.minDate = moment({
                        month: entity.fyMonth - 1,
                        day: entity.fyDay
                    });
                    break;
                // a custom date range just means they've changed it, so don't bother setting anything
                case "custom":
                    range.minDate = preset.minDate;
                    range.maxDate = preset.maxDate;
                    break;
                // by default preset will be an integer number of days that we'll substract from today for minDate
                default:
                    range.minDate = new Date();
                    range.minDate.setDate(range.minDate.getDate() - preset);
                    range.maxDate = new Date();
            }
            return range;
        };
    }
]);

},{}],"1xdwv":[function(require,module,exports) {
/**
 * Service to take over the console logging and keep a running history
 */ angular.module("common").factory("ErrorLogger", [
    "$window",
    "DEV",
    "$state",
    function($window, DEV, $state) {
        var Logger = function Logger() {
            // Set the three different log levels
            this.DEBUG_LEVEL = "debug";
            this.LOG_LEVEL = "log";
            this.WARN_LEVEL = "warn";
            this.ERROR_LEVEL = "error"; // Initizalize the history object
            this._history = {};
            this._history[this.DEBUG_LEVEL] = [];
            this._history[this.LOG_LEVEL] = [];
            this._history[this.WARN_LEVEL] = [];
            this._history[this.ERROR_LEVEL] = [];
        };
        Logger.prototype.start = function() {
            var self = this;
            $window.onerror = function(errorMsg, file, lineNumber) {
                self.logError(self.ERROR_LEVEL, errorMsg, lineNumber, file);
            }; // If this is running in a browser without console *cough* IE,
            // make sure that console is defined
            if (!$window.console) $window.console = {};
            /**
     * Replaces a console method
     * @param  {string} method the method to be replaced
     * @return {Function} the new console function
     */ function replaceMethod(method) {
                // Keep a reference to the original
                var original = $window.console[method]; // Create a new function
                var replacement = function() {
                    self.logError(method, arguments);
                    if (original.apply) // Do this for normal browsers
                    {
                        if (DEV) original.apply(console, arguments);
                    } else {
                        // Do this for IE
                        var message = Array.prototype.slice.apply(arguments).join(" ");
                        if (DEV) original(message);
                    }
                }; // Return the replacement
                return replacement;
            } // These are the methods being replaced
            var methods = [
                "debug",
                "log",
                "warn",
                "error"
            ]; // Loop through each method and replace it
            for(var i = 0; i < methods.length; i++)$window.console[methods[i]] = replaceMethod(methods[i]);
        };
        Logger.prototype.logError = function(errorLevel, message, lineNumber, file) {
            var date = new Date();
            var timestamp = date.getFullYear() + "-" + date.getDate() + "-" + date.getDay() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
            var error = {
                message: message,
                lineNumber: lineNumber,
                file: file,
                url: $window.location,
                state: $state.current,
                timestamp: date
            };
            this._history[errorLevel].push(error);
        };
        Logger.prototype.getAll = function() {
            return this._history;
        };
        var newLogger = new Logger();
        $window.logger = newLogger;
        return newLogger;
    }
]) // Auto-start when loaded
.run([
    "ErrorLogger",
    function(ErrorLogger) {
        ErrorLogger.start();
    }
]);

},{}],"773EM":[function(require,module,exports) {
/**
 * Directive to validate an array of file extensions against a list of extension rules
 * @name FileValidatorFactory
 * @memberOf common
 * @ngdoc service
 *
 * @example
 *   let allowedRules = [
 *     {required: ['XLS']},
 *     {required: ['CSV']},
 *     {required: ['TXT'], allowed: ['SHP']},
 *   ]
 *   let validator = FileValidatorFactory(allowedRules)
 *
 *   let files = ['TXT']
 *   let errorMessages = validator.validate(files) // no errors
 *   errorMessages = validator.validate(['JSON']) // error messages
 */ angular.module("common").factory("FileValidatorFactory", [
    "FileValidator",
    function(FileValidator) {
        // Return the factory/constructor method
        return FileValidator.create;
    }
]).factory("FileValidator", function() {
    var FileValidator = {};
    /**
   * The "constructor" for the validator
   * @param  {object} rules the array of rules in this format:
   *                        [{required: [String], allowed: [String]}...]
   * @return {FileValidator}
   */ FileValidator.create = function(rules) {
        var inst = Object.create(FileValidator);
        inst.rules = rules;
        for(var i = rules.length - 1; i >= 0; i--){
            if (!rules[i].allowed) rules[i].allowed = [];
            if (!rules[i].required || !rules[i].required.length) throw new TypeError("Rules must include a required list");
        }
        return inst;
    };
    /**
   * Gets the extension for a particular file
   * @param  {string} filename the file name to get the extension from
   * @return {string}
   */ FileValidator.getExtension = function(filename) {
        return filename.split(".").pop();
    };
    /**
   * Validates a list of file extensions
   * @param  {array} files
   * @return {null|string}       either returns null or returns an error message
   */ FileValidator.validate = function(files) {
        var message = "", invalid = [], missing = []; // normalize all the file names to be uppercase
        files = files.map(function(name) {
            return name.toUpperCase();
        }); // If no rule is found, this will be the "default" rule and all files will fail this validation
        var rule = {
            required: [],
            allowed: []
        }; // Loop through all the rules and find the one that matches the given files
        for(var i = 0; i < this.rules.length; i++){
            var allowed = this.rules[i].required.concat(this.rules[i].allowed);
            if (allowed.indexOf(files[0]) != -1) rule = this.rules[i];
        } // Loop through the files and find invalid file types
        for(var i = 0; i < files.length; i++){
            var file = files[i];
            if (rule.required.indexOf(file) == -1 && rule.allowed.indexOf(file) == -1) invalid.push(file);
        } // Loop through all the required file types and add that to the missing array
        for(var i = 0; i < rule.required.length; i++)if (files.indexOf(rule.required[i]) == -1) missing.push(rule.required[i]);
         // Create the error message
        if (missing.length) message += missing.length > 1 ? "File types {{missing}} are required. " : "File type {{missing}} is required. ";
        if (invalid.length) message += invalid.length > 1 ? "File types {{invalid}} is invalid. " : "File type {{invalid}} is invalid. ";
        message = message.replace("{{missing}}", missing.toString());
        message = message.replace("{{invalid}}", invalid.toString()); // Either return the message or null
        if (missing.length || invalid.length) return message;
        return null;
    };
    return FileValidator;
});

},{}],"6Csdm":[function(require,module,exports) {
/**
 * Service for geocoding addresses
 */ angular.module("common").factory("GoogleGeocoder", [
    "$http",
    "$q",
    "GEOCODE_KEY",
    function($http, $q, GEOCODE_KEY) {
        var Geocoder = {};
        Geocoder.getLatLong = function(address) {
            var deferred = $q.defer(), promise = deferred.promise;
            function parseResults(response) {
                deferred.resolve(response.data.results[0].geometry.location);
            }
            makeRequest(address, parseResults.bind(this));
            return promise;
        };
        function makeRequest(address, callback) {
            var promise = $http.get("https://maps.googleapis.com/maps/api/geocode/json", {
                params: {
                    address: address,
                    key: GEOCODE_KEY
                },
                withCredentials: false
            });
            promise.then(callback);
            return promise;
        }
        return Geocoder;
    }
]);

},{}],"bwCXv":[function(require,module,exports) {
angular.module("common").factory("httpInterceptor", [
    "$rootScope",
    "$location",
    "$q",
    "$injector",
    "API_ROOT",
    "promiseTracker",
    "$timeout",
    function($rootScope, $location, $q, $injector, API_ROOT, promiseTracker, $timeout) {
        return {
            request: function(config) {
                if (typeof $rootScope.promises == "undefined") $rootScope.promises = [];
                if (typeof $rootScope.deferred == "undefined") $rootScope.deferred = [];
                var deferred = $q.defer();
                $rootScope.deferred.push(deferred);
                $rootScope.promiseTracker = promiseTracker();
                $rootScope.promiseTracker.addPromise(deferred.promise);
                return config;
            },
            response: function(response) {
                $rootScope.deferred.splice(0, 1)[0].resolve();
                return response;
            },
            responseError: function(response) {
                $rootScope.deferred.splice(0, 1);
                if (!response.data) return $q.reject(response); //if the code is a 422 (unprocessable entity) return the data and let the form handle it
                if ("code" in response.data.status && response.data.status.code == "422") return $q.reject(response); // Create a timeout for the error handler that can be
                //  caught later on and canceled with $timeout.cancel()
                response.modalTimeout = $timeout((function() {
                    var error = response.data;
                    error.currentState = $injector.get("$state").current;
                    $rootScope.$broadcast("httpError", {
                        error
                    });
                }).bind(this));
                return $q.reject(response);
            }
        };
    }
]);

},{}],"7xHb8":[function(require,module,exports) {
/**
 * A wrapper service for adding a delay for when the user is entering text
 *
 * @param {function} action the closure to be run
 * @param {integer} [delay] an optional delay (in milliseconds)
 * @return {function}
 *
 *  Example:
 *
 *  $scope.$watch('searchInput', function (value, oldValue) {
 *    if(value == oldValue)
 *      return;
 *
 *    $scope.search($scope.users, value)
 *  })
 *
 *  $scope.search = new KeystrokeSearch(
 *    function(users, value) {
 *      users.search(value)
 *    }.bind(this), // Make sure the closure is bound if arguments need to be passed to it
 *  200) // Optional delay
 *
 */ angular.module("common").factory("KeystrokeSearch", [
    "$timeout",
    function($timeout) {
        var KeystrokeSearch;
        KeystrokeSearch = function(action, delay) {
            // Set a default delay
            if (typeof delay == "undefined") delay = 500; // Keeps track of the $timeout "promise"
            var timer;
            var wrapper = function() {
                // If there's already a timeout running, cancel it
                if (timer) $timeout.cancel(timer); // Save the arguments to the wrapper function (used in the apply)
                var wrapperArgs = arguments; // Run the timeout
                timer = $timeout(function() {
                    action.apply(this, wrapperArgs);
                }, delay);
            }; // And return the new function
            return wrapper;
        };
        return KeystrokeSearch;
    }
]);

},{}],"hkQ1c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("common").factory("Menu", [
    "$rootScope",
    "Session",
    "PermissionManager",
    function($rootScope, Session, PermissionManager) {
        var routes = [
            {
                id: "mapping",
                name: "TruTerritory",
                sections: []
            },
            {
                id: "data",
                name: "Data",
                sections: []
            },
            {
                id: "admin",
                name: "Admin",
                visible: false,
                sections: [
                    {
                        text: "Manage",
                        routes: [
                            {
                                id: "admin.users-entities",
                                sref: "admin.users-and-entities",
                                name: "Users & Entities"
                            },
                            {
                                id: "admin.emails",
                                sref: "admin.emails",
                                name: "System Emails"
                            }
                        ]
                    }
                ]
            }
        ];
        return new Menu(routes, new PermissionManager(Session.getAll().permissions), $rootScope.entityID);
    }
]);
var Menu = function(routes, access, entityID) {
    this._routes = routes;
    this.setPermissionsAndEntity(access, entityID);
};
Menu.prototype = {
    get: function(parent) {
        var routes = []; // get the top-level menu
        if (!parent) routes = this._routes; // OR get the sections under a top-level item (parent)
        else {
            for(var i = 0; i < this._routes.length; i++)if (this._routes[i].id == parent) {
                routes = this._routes[i].sections;
                break;
            }
        }
        return routes;
    },
    getEnabled (parent) {
        return _.filter(this.get(parent), {
            enabled: true
        });
    },
    /**
   * Finds the sref for a given permission
   * @param  {string} id the full permission string (i.e., "entity.1.dashboard.mapping")
   * @return {null|object}
   */ findSref: function(id) {
        // Split the permission on ".",
        //  find the section that it belongs to
        var fullPermission = id.split("."), permission = fullPermission.slice(2, fullPermission.length).join("."), routeSection = _.find(this._routes, {
            id: fullPermission[2]
        }); // If this is a top level section (dashboard, data, tools, etc…return the route)
        if (fullPermission.length == 3) return routeSection;
         // Loop through all the sections in each parent section and find the route!
        for(var i = routeSection.sections.length - 1; i >= 0; i--){
            var route = _.find(routeSection.sections[i].routes, {
                id: permission
            });
            if (route) return route;
        }
        return null;
    },
    setPermissionsAndEntity: function(access, entityID) {
        this.access = access;
        this._entityID = entityID; // rebuild menu (i.e., set 'enabled' on each item)
        this._applyPermissions();
    },
    getFirstRoute: function() {
        var returnRoute = {
            route: "dashboard",
            params: {
                entityID: this._entityID
            }
        };
        for(var i = 0; i < this._routes.length; i++){
            if ("visible" in this._routes[i] && !this._routes[i].visible || !this._routes[i].enabled) continue;
            var route = this._routes[i];
            for(var j = 0; j < route.sections.length; j++){
                var section = route.sections[j];
                for(var k = 0; k < section.routes.length; k++){
                    if (!section.routes[k].enabled) continue;
                    returnRoute.route = section.routes[k].sref;
                    return returnRoute;
                }
            }
            returnRoute.route = route.id;
            return returnRoute;
        }
        returnRoute.params.noAccess = true;
        return returnRoute;
    },
    _applyPermissions: function() {
        // for each item, check granted access
        var primary, section, secondary;
        for(var i = 0; i < this._routes.length; i++){
            primary = this._routes[i];
            primary.enabled = this.access.hasMenuAccess("entity." + this._entityID + "." + primary.id); //this._hasAccess(primary.id);
            // go through secondary menus as well
            for(var j = 0; j < primary.sections.length; j++){
                section = primary.sections[j];
                for(var k = 0; k < section.routes.length; k++){
                    secondary = section.routes[k];
                    secondary.enabled = this.access.hasMenuAccess("entity." + this._entityID + "." + secondary.id); //this._hasAccess(secondary.id);
                }
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"j5nbi":[function(require,module,exports) {
const { setSession } = require("dccb16b91bdbeb06");
const { store } = require("c68fb2b0f2bdd67");
/**
 * @name Session
 * @ngdoc service
 * @memberOf common
 * @description Session service
 */ angular.module("common").factory("Session", [
    "$http",
    "$timeout",
    "$q",
    "API_ROOT",
    function($http, $timeout, $q, API_ROOT) {
        var Session = function() {
            /**
     * The session attributes
     * @private
     * @type {Object}
     */ this._attributes = {};
            this._onFetch = [];
        };
        /**
   * Fetch from server
   * @memberOf common.Session
   * @param {int} poll Seconds of poll time
   * @return {Promise}
   */ Session.prototype.fetch = function(poll) {
            let url = API_ROOT + "/session"; // add polling params
            if (poll) url += "?poll=" + poll + "&hash=" + (this._attributes.hash || null);
            return $http({
                method: "GET",
                url: url,
                withCredentials: true
            }).then((response)=>{
                this.setAll(response.data.data);
                this._runOnFetch();
                return this._attributes;
            });
        };
        /**
   * Register a change listener
   * @param {Function} callback
   */ Session.prototype.onFetch = function(callback) {
            this._onFetch.push(callback);
        };
        /**
   * Unregister a change listener
   * @param {Function} callback
   */ Session.prototype.offFetch = function(callback) {
            this._onFetch = _.without(this._onFetch, callback);
        };
        /**
   * Run the change listeners
   */ Session.prototype._runOnFetch = function() {
            for(let i = 0; i < this._onFetch.length; i++)this._onFetch[i].call(null, this._attributes);
        };
        /**
   * Starts long polling for new session data, returning the first response right away
   * @param {int} time Number of seconds to wait
   * @param {bool} first Whether this is the first time running
   * @return {Promise}
   */ Session.prototype.startPolling = function(time = 55, first = true) {
            this._polling = true; // If we already have data, return it
            let current = null;
            if (first && !_.isEmpty(this._attributes)) current = $q.when(this._attributes); // This might introduce a race condition if stopPolling() is called at just the right time...
            let next = this.fetch(first && !current ? 0 : time).then((attributes)=>{
                // Start the next poll
                if (this._polling) $timeout(this.startPolling.bind(this, time, false));
                return attributes;
            });
            return current || next;
        };
        /**
   * Stop a previously-started polling
   * @return {void}
   */ Session.prototype.stopPolling = function() {
            this._polling = false;
        };
        /**
   * Get all attributes in the session
   * @memberOf common.Session
   * @return {object}
   */ Session.prototype.getAll = function() {
            return this._attributes;
        };
        /**
   * Get a single attribute
   * @memberOf common.Session
   * @param  {string} key
   * @return {mixed}
   */ Session.prototype.get = function(key) {
            if (key in this._attributes) return this._attributes[key];
            return null;
        };
        /**
   * Set a single attribute
   * @memberOf common.Session
   * @param {string} key
   * @param {mixed} val
   * @param {boolean} doRequest If true, update on the server
   * @return {promise|void} If doRequest is true, a promise will be returned
   */ Session.prototype.set = function(key, val, doRequest) {
            // set locally
            this._attributes[key] = val; // set remotely
            if (doRequest) {
                var data = {};
                data[key] = val;
                return $http({
                    method: "PATCH",
                    url: this.API_ROOT + "/session",
                    data: data
                });
            }
        };
        /**
   * Given a dictionary, set the session data
   * @memberOf common.Session
   * @param  {object} dict
   * @return {void}
   */ Session.prototype.setAll = function(dict) {
            for(var key in dict)this._attributes[key] = dict[key];
            store.dispatch(setSession({
                ...this._attributes
            })); //entityList: [this._attributes.entityList[0]]
        };
        return new Session();
    }
]);

},{"dccb16b91bdbeb06":"w3GXi","c68fb2b0f2bdd67":"7WrEn"}],"bedEt":[function(require,module,exports) {
/**
 * String manipulation service
 */ angular.module("common").factory("StringHelper", function() {
    var StringHelper = function() {};
    /**
   * Increments a letter to the next consecutive letter
   *   If "z" is passed in, it will go on to "aa", when "zz" => "aaa", and so on
   * @param  {string} text the letter to increment
   * @return {string}
   */ StringHelper.increment = function(text) {
        var length = text.length, lastChar = text.charAt(text.length - 1), firstChar = text.charAt(0), character = String.fromCharCode(firstChar.charCodeAt(0) + 1);
        if (lastChar == "z" || lastChar == "Z") {
            if (lastChar == "z") character = "a";
            if (lastChar == "Z") character = "A";
            length++;
        }
        return Array(length + 1).join(character);
    };
    var _alphabet = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ];
    StringHelper.getAlphabet = function() {
        return _alphabet;
    };
    return StringHelper;
});

},{}],"3Mz3q":[function(require,module,exports) {
/**
 * Validator service
 *   (used by epi-validate to validate controls against rules)
 * Usage (in epi-validate):
 *    [rule]:[arg1],[arg2],[arg3...]|[rule2]:[arg1...]
 */ angular.module("common").factory("Validator", [
    "$parse",
    function($parse) {
        var Validator = function() {
            // default error messages
            this._messages = {
                required: "This field is required",
                requiredIf: "This field is required",
                alpha: "This field must be letters only",
                alphanumeric: "This field must be letters and numbers only",
                decimal: "This field must be a decimal number",
                min: function(args) {
                    return "This field must be at least " + args[0] + " characters long";
                }
            }; // custom validation rules & messages
            this._customRules = {};
            this._customMessages = {}; // the default validation rules
            this._validationRules = {
                /**
       * required: make sure there is a value
       * @param  {string} value the control's value
       * @return {boolean} whether the control is valid
       */ required: function(value) {
                    return !(typeof value == "undefined" || value === "" || value === null || value instanceof Array && value.length == 0);
                },
                /**
       * email: validates an email
       * @param  {string} value the control's value
       * @return {boolean} whether the control is valid
       */ email: function(value) {
                    var regex = /^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,}$/;
                    return regex.test(value);
                },
                /**
       * Accepts a list of valid email email addresses delimited by commas
       * @param {string} value
       * @return {boolea}
       */ emails: function(value) {
                    var emails = value.split(",");
                    for(var i = 0; i < emails.length; i++){
                        if (!this._validationRules.email(emails[i].trim())) return false;
                    }
                    return true;
                },
                /**
       * requiredIf: required only if another control equals a certain value
       *         Example: requiredIf:type,1 (required if "type" equals "1")
       * @param  {string} value the control's value
       * @return {boolean} whether the control is valid
       */ requiredIf: function(value, args, controls) {
                    var otherVal = typeof controls[args[0]] != "undefined" ? controls[args[0]] : null, match = args[1];
                    if (otherVal == match) return this._validationRules.required(value, args);
                    return true;
                },
                /**
       * requiredWith: required only if another control's value is presentg
       *         Example: requiredWith:password (required if "password" has a value)
       * @param  {string} value the control's value
       * @param  {array} args the arguments passed into epi-validate
       * @param  {object} controls all the controls
       * @return {boolean} whether the control is valid
       */ requiredWith: function(value, args, controls) {
                    if (!controls[args[0]]) return true;
                    return this._validationRules.required(value, args);
                },
                /**
       * matches: does this control match another control's value?
       *         Example: matches:password
       * @param  {string} value the control's value
       * @param  {array} args the arguments passed into epi-validate
       * @param  {object} controls all the controls
       * @return {boolean} whether the control is valid
       */ matches: function(value, args, controls) {
                    return value == controls[args[0]];
                },
                /**
       * min: required a minimum length
       * @param  {string} value the control's value
       * @param  {array} args the arguments passed into epi-validate
       * @return {boolean} whether the control is valid
       */ min: function(value, args) {
                    return value && value.length >= args[0];
                },
                /**
       * alpha: requires an alpha (not numeric) value
       * @param  {string} value the control's value
       */ alpha: function(value) {
                    var regex = /[^A-z]/;
                    return !regex.test(value);
                },
                /**
       * alphanumeric: requires an alphanumeric value
       * @param  {string} value the control's value
       */ alphanumeric: function(value) {
                    var regex = /[^A-z0-9]/;
                    return !regex.test(value);
                },
                /**
       * decimal: requires an decimal value
       * @param  {string} value the control's value
       */ decimal: function(value) {
                    var regex = /^-?\d+(\.\d+)?$/;
                    return regex.test(value);
                },
                /**
       * regex: tests a control's value against a regex
       *       Example: regex:[^A-z]
       * @param  {string} value the control's value
       * @param  {array} args the array of arguments
       */ regex: function(value, args) {
                    var regex = new RegExp(args[0]);
                    return regex.test(value);
                },
                /**
       * unique: tests a control's value against a list of data
       *         Example: unique:list,property,excludedIndex
       *
       *         excludedIndex can also be a string, which will look on scope to find a property with that name
       * @param  {string} value the control's value
       * @param  {array} args the array of arguments
       * @param  {array} values the array of other controls
       * @param  {object} scope the current $scope
       */ unique: function(value, args, values, scope) {
                    var search = {};
                    search[args[1]] = value;
                    var list = $parse(args[0])(scope);
                    var found = _.find(list, function(item, index) {
                        if (index == args[2] || index == scope[args[2]]) return false;
                        else if (item[args[1]] == value) return true;
                    });
                    return !found || false;
                },
                /**
       * eq: checks to see if the value equals a string value
       *     Example: eq:Matthew
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ eq: function(value, args) {
                    return value == args[0];
                },
                /**
       * ne: checks to see if the value doesn't equal a string value
       *     Example: ne:Matthew
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ ne: function(value, args) {
                    return value != args[0];
                },
                /**
       * in: checks to see if a value is contained in a given array of values
       *     Example: in:One,Two,Three
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ in: function(value, args) {
                    return args.indexOf(value) != -1;
                },
                /**
       * not_in: checks to see if a value is *not* contained in a given array of values
       *       Example: not_in:One,Two,Three
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ not_in: function(value, args) {
                    return args.indexOf(value) == -1;
                },
                // For all four comparison rules (gt, gte, lt, lte), the comparison value is first checked to see if it's a number,
                //  if so, it compares it as a number, else it compares it lexographically (the default JavaScript behavior when comparing two strings)
                /**
       * gt: tests to see if the value is greater than a given value,
       *   first parsing it as a number, and comparing numbers, else comparing a string
       *   Example: gt:5
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ gt: function(value, args) {
                    var comparison = isNaN(parseFloat(args[0])) ? args[0] : parseFloat(args[0]);
                    return value > comparison;
                },
                /**
       * gt: tests to see if the value is less than a given value,
       *   first parsing it as a number, and comparing numbers, else comparing a string
       *   Example: lt:5
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ lt: function(value, args) {
                    var comparison = isNaN(parseFloat(args[0])) ? args[0] : parseFloat(args[0]);
                    return value < comparison;
                },
                /**
       * gte: tests to see if the value is greater than or equal to a given value,
       *   first parsing it as a number, and comparing numbers, else comparing a string
       *   Example: gte:5
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ gte: function(value, args) {
                    var comparison = isNaN(parseFloat(args[0])) ? args[0] : parseFloat(args[0]);
                    return value >= comparison;
                },
                /**
       * lte: tests to see if the value is less than or equal a given value,
       *   first parsing it as a number, and comparing numbers, else comparing a string
       *   Example: lte:5
       * @param  {string} value
       * @param  {array} args
       * @return {boolean}
       */ lte: function(value, args) {
                    var comparison = isNaN(parseFloat(args[0])) ? args[0] : parseFloat(args[0]);
                    return value <= comparison;
                }
            };
            /**
     * Validate a single value
     * @param  {mixed} value
     * @param  {string} rules Pipe-delimited string of rules
     * @param  {object} messages Hash of messages to override defaults
     * @return {boolean|array} If valid, returns boolean true; else return array of error messages
     */ this.validate = function(value, rules, messages, controls, $scope) {
                // compile rules string into an object of functions
                var compiled = this._compileRules(rules), valid = true, errors = []; // If there are no rules
                if (!compiled) return true; // If it's not required and it's empty, skip the rest of the rules
                if (!this._isRequired(compiled, controls) && !this._validationRules.required(value)) return true; // call each function, passing in the value
                for(var name in compiled){
                    valid = compiled[name].func.call(this, value, compiled[name].args, controls, $scope); // console.log('Result of "'+name+'" test: '+(valid === true ? 'passed' : 'failed'));
                    // if true, do nothing
                    // if false, add appropriate error message to array
                    if (!valid) errors.push(this._getMessage(name, messages, compiled[name].args));
                }
                if (errors.length) return errors;
                return true;
            };
            /**
     * Add an app-wide custom rule
     * @param {string} name
     * @param {string} message
     * @param {function} func
     * @return {void}
     */ this.createCustomRule = function(name, message, func) {
                this._customRules[name] = func;
                if (message) this._customMessages[name] = message;
            };
            /**
     * Check to see if a given rule exists
     * @param  {string} name
     * @return {boolean}
     */ this.ruleExists = function(name) {
                if (this._validationRules[name] || this._customRules[name]) return true;
                return false;
            };
            /**
     * Compile a string of rules into a hash of validation functions
     * @param  {string} rulesStr
     * @return {object}
     */ this._compileRules = function(rulesStr) {
                var compiled = {}, rules = rulesStr.length ? rulesStr.split("|") : false, funcName = "", args = {}, func;
                if (!rules) return false;
                for(var i = 0; i < rules.length; i++){
                    // expected format is "function:arg1,arg2,arg3|function2:arg1,arg2,arg3..."
                    // Grab the index of the first ":"
                    var index = rules[i].indexOf(":"); // The function name is up to the first colon (allows colons in the args list)
                    funcName = rules[i].substring(0, index) || rules[i]; // the args are everything after the colon (omit the colon by adding one to it)
                    if (index == -1) args = [];
                    else {
                        args = rules[i].substring(index + 1);
                        if (args.length) args = args.split(",");
                    } // find rule function in defaults
                    if (funcName in this._validationRules) func = this._validationRules[funcName]; // otherwise look for it in extended rules
                    else if (funcName in this._customRules) func = this._customRules[funcName];
                    else throw new ReferenceError('No validation rule named "' + funcName + '" could be found.'); // save it in the compiled object
                    compiled[funcName] = {
                        func: func,
                        args: args
                    };
                }
                return compiled;
            };
            /**
     * Get the appropriate error message for a given rule
     * @param  {string} ruleName
     * @param {object} messages Hash of messages to override defaults
     * @return {string}
     */ this._getMessage = function(ruleName, messages, args) {
                if (messages && ruleName in messages) return messages[ruleName];
                if (ruleName in this._customMessages) return this._customMessages[ruleName];
                var rule = this._messages[ruleName];
                return typeof rule == "function" ? rule(args) : rule;
            };
            /**
     * Checks to see if a control is required
     * @param {object} compiled
     * @param {object} controls
     * @return {boolean}
     */ this._isRequired = function(compiled, controls) {
                // if required rule is present
                if ("required" in compiled) return true; // if requiredWith is present, run required on the other control
                if ("requiredWith" in compiled) return this._validationRules.required(controls[compiled.requiredWith.args[0]]);
                 // if requiredIf is present, check to make sure the control
                if ("requiredIf" in compiled) return controls[compiled.requiredIf.args[0]] == compiled.requiredIf.args[1];
                return false;
            };
        };
        return new Validator();
    }
]);

},{}],"eT9Dh":[function(require,module,exports) {
angular.module("common").provider("Storage", function() {
    var prefix;
    return {
        setPrefix: function(newPrefix) {
            prefix = newPrefix;
        },
        $get: [
            "$window",
            "$state",
            "Session",
            function($window, $state, Session) {
                if (!prefix) throw TypeError("Storage needs a set prefix");
                return new Storage($window, $state, prefix + "-" + Session.get("ID"));
            }
        ]
    };
});
var Storage = function($window, $state, prefix) {
    this.prefix = prefix;
    this.state = $state;
    this.parsedStorage;
    this.supported = "localStorage" in $window && $window["localStorage"] !== null ? true : false; // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
    // is available, but trying to call .setItem throws an exception below:
    // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage that exceeded the quota."
    // https://github.com/gsklee/ngStorage/blob/master/ngStorage.js#L59
    if (this.supported) {
        var key = "__" + Math.round(Math.random() * 1e7);
        try {
            $window.localStorage.setItem(key, key);
            $window.localStorage.removeItem(key);
        } catch (err) {
            this.supported = false;
        }
    }
    if (this.supported) {
        this.storage = $window.localStorage;
        this.parsedStorage = JSON.parse($window.localStorage.getItem(this.prefix));
    } else this.storage = new storagePolyfill();
    if (!this.parsedStorage) this.parsedStorage = {};
};
Storage.prototype.getItem = function(key, entityID) {
    return this.parsedStorage[this._getKey(key, entityID)] || null;
};
Storage.prototype.setItem = function(key, value, entityID) {
    this.parsedStorage[this._getKey(key, entityID)] = value;
    this._setStorage();
};
Storage.prototype.removeItem = function(key, entityID) {
    delete this.parsedStorage[this._getKey(key, entityID)];
    this._setStorage();
};
Storage.prototype.clear = function() {
    this.parsedStorage = {};
    this._setStorage();
};
Storage.prototype._setStorage = function() {
    this.storage.setItem(this.prefix, JSON.stringify(this.parsedStorage));
};
Storage.prototype._getKey = function(key, optionalEntityID) {
    var entityID = !optionalEntityID && "params" in this.state && this.state.params.entityID ? this.state.params.entityID : optionalEntityID;
    if (entityID) key = "entity." + entityID + "." + key;
    return key;
};
function storagePolyfill() {
    this.data = {};
}
storagePolyfill.prototype = {
    getItem: function(key) {
        return this.data[key] || null;
    },
    setItem: function(key, value) {
        this.data[key] = value;
    },
    removeItem: function(key) {
        delete this.data[key];
    }
};

},{}],"aBdQI":[function(require,module,exports) {
/**
 * Bootstraps all the relevant modules so that when included,
 *   the needed services, factories, etc., will have a defined module
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = angular.module("routes:mapping", []).name;
require("f8148daa643bb292");
require("87f4efb9524efc4c");
require("f8148daa643bb292");
require("c4fe2e9a9c7e292b");
require("b28145b987725f4a");
require("cfb4bab7583297e9");
require("cc35ff47f93d97a");
require("26f0119eea974924");
require("61d9f504c9390f78");
require("46d67733f962e803");
require("8aae3e1d90b470dd");
require("f26c2e7809d357d8");
require("ec46ae6113da7a3f");
require("781c79a79aefdc1c");

},{"f8148daa643bb292":"179Rr","87f4efb9524efc4c":"4Jtwr","c4fe2e9a9c7e292b":"b9z67","b28145b987725f4a":"kPz9Z","cfb4bab7583297e9":"c3862","cc35ff47f93d97a":"jBGpQ","26f0119eea974924":"89ltO","61d9f504c9390f78":"hhxHk","46d67733f962e803":"1LAFZ","8aae3e1d90b470dd":"7o5UQ","f26c2e7809d357d8":"gsyGW","ec46ae6113da7a3f":"gdCTh","781c79a79aefdc1c":"hjLPy","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"179Rr":[function(require,module,exports) {
/**
 * Various modals required by the mapping module
 */ angular.module("routes:mapping").factory("MappingModals", [
    "$uibModal",
    "$stateParams",
    "Session",
    function($uibModal, $stateParams, Session) {
        return {
            /**
     * Open the "save map" modal
     * TODO: move this to the new react map modal
     * @param  {Object} map
     * @param  {Function} save Function to call on save
     * @param  {map[]} parents An optional list of map objects which could be parents to this the one being saved.
     * @param  {string} saveAs An alternate name to give the map
     * @return {Promise}
     */ openSaveMap (map, save, parents, saveAs) {
                // Clone it so the original isn't modified
                map = angular.copy(map); // By default, the new map's parent will be old map or the old map's parent, if set.
                map.parentID = map.parentID || map.ID;
                if (saveAs) map.name = saveAs; // Create the modal
                let modal = $uibModal.open({
                    template: `<epi-edit-map-form map="map" parents="parents" on-save="save" on-cancel="$dismiss" parent-change-allowed="true" is-creating="true"></epi-edit-map-form>`,
                    windowClass: "truterritory-save-map",
                    controller: [
                        "$scope",
                        "$uibModalInstance",
                        function($scope, $uibModalInstance) {
                            $scope.map = map;
                            $scope.parents = parents;
                            $scope.save = function(map) {
                                save(map).then($uibModalInstance.close);
                            };
                        }
                    ]
                });
                return modal.result;
            },
            /**
     * Open the "map has unsaved changes" modal
     * @param {string} msg
     * @return {Promise}
     */ openSaveMapChanges (msg, save, saveText = "Save", cancelText = "Cancel") {
                let modal = $uibModal.open({
                    templateUrl: "mapping/unsaved-changes-modal.html",
                    controller: [
                        "$scope",
                        "$uibModalInstance",
                        function($scope, $uibModalInstance) {
                            $scope.msg = msg;
                            $scope.saving = false;
                            $scope.saveText = saveText;
                            $scope.cancelText = cancelText;
                            $scope.save = function() {
                                $scope.saving = true;
                                save().then($uibModalInstance.close);
                            };
                            $scope.$on("enter", $scope.save);
                        }
                    ]
                });
                return modal.result;
            },
            /**
     * Open the "save workspace" modal
     * TODO: move this to the new react workspace modal;
     *   the only place this is still used is in the layers panel to add a workspace
     * @param  {Object} workspace
     * @param  {Function} save Function to call on save
     * @param  {string} saveAs An alternate name to give the workspace
     * @return {Promise}
     */ openSaveWorkspace (workspace, save, saveAs) {
                // Clone it so the original isn't modified
                workspace = "clone" in workspace ? workspace.clone() : angular.copy(workspace);
                if (saveAs) workspace.name = saveAs; // Create the modal
                let modal = $uibModal.open({
                    templateUrl: "mapping/save-workspace-modal.html",
                    windowClass: "save-new-workspace",
                    controller: [
                        "$scope",
                        "$uibModalInstance",
                        function($scope, $uibModalInstance) {
                            $scope.workspace = workspace;
                            $scope.saving = false;
                            $scope.save = function() {
                                $scope.saving = true;
                                let form = $scope.validateForm("newWorkspace");
                                if (form.isValid()) save(workspace).then($uibModalInstance.close);
                            };
                        }
                    ]
                });
                return modal.result;
            },
            /**
     * Opens a modal containing the link
     * @param  {object} map
     * @return {void}
     */ openPermalink (map, truMap) {
                // Create a new modal
                var permalinkModal = $uibModal.open({
                    templateUrl: "mapping/get-permalink-modal.html",
                    windowClass: "truterritory-save-permalink-modal",
                    controllerAs: "modal",
                    bindToController: true,
                    controller: [
                        "$scope",
                        "$http",
                        "API_ROOT",
                        "SHARING_ROOT",
                        "hasMapAccess",
                        function($scope, $http, API_ROOT, SHARING_ROOT, hasMapAccess) {
                            this.map = map;
                            this.hasAccess = hasMapAccess;
                            this.saving = false;
                            this.confirming = false;
                            this.useCenterZoom = false;
                            this.showAnnotations = false;
                            this.annotationOption = null;
                            this.requirePassword = !!map.password;
                            this.oldPassword = map.password;
                            this.generating = false;
                            this.expires = false;
                            this.expiresAt = null;
                            this.oldExpiresAt = null;
                            this.expiringUUID = null;
                            this.datepickerOptions = {
                                "show-weeks": false,
                                minDate: moment().add(1, "days"),
                                maxDate: moment().add(90, "days")
                            }; // Create a URL from the map's UUID
                            this.generateLink = function() {
                                let uuid = this.expires ? this.expiringUUID : map.UUID;
                                let link = SHARING_ROOT + "/" + uuid;
                                let params = {};
                                if (this.showAnnotations) {
                                    // If we don't have the hashed value to put in the URL, get it and try again.
                                    if (!this.annotationsOption) {
                                        this.map.getAnnotationsOption().then((option)=>{
                                            this.annotationsOption = option;
                                            this.generateLink();
                                        });
                                        return;
                                    }
                                    params["o"] = this.annotationsOption;
                                }
                                if (this.useCenterZoom) {
                                    let { lat, lng } = truMap.getCenter();
                                    Object.assign(params, {
                                        lat,
                                        lng,
                                        zoom: truMap.getZoom()
                                    });
                                }
                                if (Object.keys(params).length) link += `?${$.param(params)}`;
                                this.link = link;
                            }; // Tell the server to create a new UUID
                            this.reset = function() {
                                this.saving = true;
                                map.getNewUUID().then((uuid)=>{
                                    this.saving = this.confirming = this.expires = false;
                                    this.expiringUUID = this.expiresAt = null;
                                    this.generateLink();
                                });
                            }; // Retrieve a temporary, expiring UUID
                            this.getExpiringUUID = function(expiresAt) {
                                this.expiringUUID = null;
                                map.getExpiringUUID(expiresAt).then((uuid)=>{
                                    this.expiringUUID = uuid;
                                    this.generateLink();
                                });
                            }; // Set a new password
                            this.setPassword = function() {
                                if (!this.requirePassword) map.password = null;
                                if (map.password === "") {
                                    this.requirePassword = false;
                                    map.password = null;
                                }
                                this.oldPassword = map.password;
                                map.patch({
                                    password: map.password
                                });
                            }; // Generate a password
                            this.generatePassword = function() {
                                this.generating = true;
                                $http.get(API_ROOT + "/phrase").then((response)=>{
                                    this.oldPassword = map.password;
                                    map.password = response.data.data;
                                    this.generating = false;
                                });
                            }; // Set the expiration date
                            this.setExpiresAt = function() {
                                if (!this.expires) {
                                    this.expiringUUID = this.expiresAt = null;
                                    this.generateLink();
                                }
                                if (this.expiresAt === "") {
                                    this.expires = false;
                                    this.expiresAt = null;
                                }
                                if (this.expiresAt && $scope.expiresForm.$valid && this.expiresAt != this.oldExpiresAt) this.getExpiringUUID(this.expiresAt);
                            };
                            this.generateLink();
                        }
                    ]
                });
            },
            /**
     * Accept a password
     * @param {bool} first Message changes after the first time showing the modal.
     * @return {Promise}
     */ openPassword (first = true) {
                let modal = $uibModal.open({
                    backdrop: "static",
                    keyboard: false,
                    windowClass: "mapping-password",
                    templateUrl: "mapping/password-modal.html",
                    controller: [
                        "$scope",
                        function($scope) {
                            $scope.first = first;
                        }
                    ]
                });
                return modal.result;
            }
        };
    }
]);

},{}],"4Jtwr":[function(require,module,exports) {
/**
 * mapping.js controller
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _center = require("@turf/center");
var _centerDefault = parcelHelpers.interopDefault(_center);
var _helpers = require("@turf/helpers");
var _appSlice = require("../../../../src/slices/appSlice");
var _pagesSlice = require("../../../../src/slices/pagesSlice");
var _apiSlice = require("../../../../src/slices/apiSlice");
var _store = require("../../../../src/store");
angular.module("routes:mapping").controller("truterritory", [
    "$rootScope",
    "$scope",
    "$geolocation",
    "GoogleGeocoder",
    "$state",
    "workspaces",
    "workspace",
    "Collection",
    "$window",
    "$uibModal",
    "$q",
    "$timeout",
    "Map",
    "Storage",
    "$location",
    "INSTANCE_ID",
    "MappingModals",
    "ContextMenu",
    "hasMapAccess",
    "Theme",
    "Restangular",
    "API_ROOT",
    "Session",
    "Workspace",
    function($rootScope, $scope, $geolocation, GoogleGeocoder, $state, workspaces, workspace, Collection, $window, $uibModal, $q, $timeout, Map, Storage, $location, INSTANCE_ID, MappingModals, ContextMenu, hasMapAccess, Theme, Restangular, API_ROOT, Session, Workspace) {
        var originalMaps = {};
        (0, _store.store).dispatch((0, _appSlice.updateGlobalState)({
            title: "TruTerritory",
            h1: "TruTerritory",
            activePage: "mapping",
            activeSection: "mapping"
        }));
        $scope.workspaces = workspaces;
        $scope.hasAccess = hasMapAccess;
        $scope.annotationsRefreshedAt = null;
        $scope.selectedFeatures = {};
        (0, _store.store).subscribe(()=>{
            const { topPanelSections, isSidePanelOpen, isMapDirty, isSnippetToolOpen } = (0, _store.store).getState().pages.truterritory;
            setTimeout(()=>{
                $scope.$apply(()=>{
                    $scope.topPanelSections = topPanelSections;
                    $scope.isSidePanelOpen = isSidePanelOpen;
                    $scope.isMapDirty = isMapDirty;
                    $scope.isSnippetToolOpen = isSnippetToolOpen;
                });
            });
        });
        const { topPanelSections, isSidePanelOpen, isMapDirty, isSnippetToolOpen } = (0, _store.store).getState().pages.truterritory;
        $scope.topPanelSections = topPanelSections;
        $scope.isSidePanelOpen = isSidePanelOpen;
        $scope.isMapDirty = isMapDirty;
        $scope.isSnippetToolOpen = isSnippetToolOpen;
        $scope.workspace = workspace;
        $scope.mapDropModel = [];
        $scope.markerID = ""; // If there are unsaved changes, don't let the user leave the page without confirmation
        $scope.$on("windowUnload", function(event, response) {
            if ($scope.isMapDirty && hasMapAccess("update")) {
                if (response.event.toState && response.event.toState.name.indexOf("mapping")) response.message = "There are unsaved changes to this map. Are you sure you want to leave?";
                else if (!response.event.toState) response.message = "There are unsaved changes to this map";
            }
        });
        $scope.$watch("map", (map)=>{
            (0, _store.store).dispatch((0, _pagesSlice.setMap)(angular.copy(map)));
        }, true);
        $scope.$watch("workspace", (workspace)=>{
            (0, _store.store).dispatch((0, _pagesSlice.setWorkspace)(angular.copy(workspace)));
        }, true);
        $scope.$watch("workspaces", (workspaces)=>{
            (0, _store.store).dispatch((0, _pagesSlice.setWorkspaces)(JSON.parse(JSON.stringify(workspaces))));
        }, true);
        $scope.$on("$destroy", function() {
            (0, _store.store).dispatch((0, _pagesSlice.resetTruTerritoryState)());
        });
        $scope.setupMap = function(truMap) {
            $scope.truMap = truMap;
            loadEmptyMap(false); // If a collectionID was passed in via the URL, load it
            if ($state.params.collectionID) {
                let ID = $state.params.collectionID; // Remove collectionID from the URL without reloading the page
                $state.current.reloadOnSearch = false;
                $location.search("collectionID", undefined);
                $timeout(function() {
                    $state.current.reloadOnSearch = undefined;
                });
                delete $state.params.collectionID; // Load the collection
                Collection.get(ID, {
                    with: "themes,themes.rules"
                }).then($scope.addCollection);
            } else if (Storage.getItem("mapID")) {
                let map = _.find(workspace.maps.flatMap((m)=>[
                        m,
                        ...m.children || m.views || []
                    ]), {
                    ID: Storage.getItem("mapID")
                });
                if (map) $scope.addMap(map);
            }
        };
        /**
   * Open the left sidebar
   * @return {void}
   */ $scope.openSidePanel = function() {
            (0, _store.store).dispatch((0, _pagesSlice.setSidePanelOpen)(true));
        };
        /**
   * Close the left sidebar
   * @return {void}
   */ $scope.closeSidePanel = function() {
            (0, _store.store).dispatch((0, _pagesSlice.setSidePanelOpen)(false));
        };
        /**
   * Refresh the map based on current settings
   * @param  {Boolean} fireEvent
   * @return {void}
   */ $scope.applyChanges = function(fireEvent = true, makeDirty = true) {
            $scope.map.createDateRangeIfEnabled();
            $scope.map.legends = $scope.map.getLegends();
            refreshTiles(); // Only dirty the map if the user has permission to save it
            if (makeDirty && ($scope.map.allowCollaboration && hasMapAccess("collaborate") || hasMapAccess("update"))) makeMapDirty(fireEvent);
        };
        $scope.reload = $scope.applyChanges.bind(null, false, false);
        /**
   * Open the theme editor with the collection's current theme
   * TODO: move to <TruTerritorySide /> when those changes are merged
   * @param  {number} collectionID
   * @param  {number} themeID
   * @return {void}
   */ $scope.onThemeEdit = function(collectionID) {
            const collection = $scope.map.collections.find((c)=>c.ID === collectionID);
            const theme = collection.findTheme($scope.map, false);
            if (!collection || !theme) return;
            (0, _store.store).dispatch((0, _pagesSlice.setCurrentlyEditingThemeAndCollection)({
                theme: Theme.dataOnly(theme),
                collection: {
                    properties: collection.properties,
                    aggregates: collection.aggregates
                }
            }));
            $scope.toggleTopPanel("theme");
        };
        /**
   * Apply a saved theme
   * @param  {Object} theme
   * @return {void}
   */ $scope.onThemeSave = function(theme) {
            let collection = _.find($scope.map.collections, {
                ID: theme.collectionID
            }), index = _.findIndex(collection.themes, {
                ID: theme.ID
            }), oldTheme = collection.themes[index], labelChanged = oldTheme && oldTheme.label != theme.label; // Replace the original theme with the edited copy
            if (index == -1) {
                // remove the default theme if it's been added
                if (collection.themes[0]?.ID === undefined) collection.themes.splice(0, 1);
                collection.themes.push(theme);
            } else collection.themes[index] = theme; // Apply this theme to its collection.
            // Use the theme's label only if it has changed.
            setTheme(collection, theme, labelChanged);
            $scope.$broadcast("themeUpdated");
            (0, _store.store).dispatch((0, _pagesSlice.setCurrentlyEditingThemeAndCollection)({
                theme,
                collection
            }));
        };
        /**
   * Cleanup after a theme deletion
   * @param  {Object} theme
   * @return {void}
   */ $scope.onThemeDelete = function(theme) {
            (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.deleteTheme.initiate(theme)).then(()=>{
                let collection = _.find($scope.map.collections, {
                    ID: theme.collectionID
                }), index = _.findIndex(collection.themes, {
                    ID: theme.ID
                }); // Remove the theme from the themes array & from the map
                collection.themes.splice(index, 1);
                delete $scope.map.themes[collection.ID];
                setTheme(collection, collection.findTheme($scope.map));
                $scope.$broadcast("themeDeleted");
                (0, _store.store).dispatch((0, _pagesSlice.toggleTopPanelSection)("theme"));
                (0, _store.store).dispatch((0, _pagesSlice.setCurrentlyEditingThemeAndCollection)({
                    theme: null,
                    collection: null
                }));
            });
        };
        /**
   * Geocodes a text string and sets the view based on the return lat/long
   * @param  {string} text
   * @return {void}
   */ $scope.mapSearch = function(text) {
            GoogleGeocoder.getLatLong(text).then(function(latlng) {
                let makeMenu = ContextMenu.make.bind(null, findCollection, false, text);
                $scope.truMap.removeLayer($scope.markerID);
                $scope.markerID = $scope.truMap.addMarker([
                    latlng.lat,
                    latlng.lng
                ], makeMenu);
                $scope.truMap.setView([
                    latlng.lat,
                    latlng.lng
                ], 14, {
                    animate: true
                });
            });
        };
        /**
   * Add the given collection to the map
   * @param  {object} collection the collection to be added
   * @return {Promise}
   */ $scope.addCollection = function(collection) {
            collection = angular.copy(collection);
            collection.themes = collection.themes && collection.themes.filter((t)=>t.workspaceID === $scope.map.workspaceID) || []; // Add collection to workspace
            // Not precisely correct, because it's actually part of the workspace until the map is saved,
            // but this works for now.
            if (!_.find($scope.workspace.collections, {
                ID: collection.ID
            })) $scope.workspace.collections.push(collection); // Add the collection to the map and set necessary data
            $scope.map.collections.push(collection);
            $scope.map.collectionIDs.push(collection.ID);
            $scope.map.visible[collection.ID] = true;
            let theme = collection.findTheme($scope.map);
            $scope.map.themes[collection.ID] = theme.ID;
            $scope.map.labels[collection.ID] = theme.label;
            $scope.$broadcast("collectionAdded");
            $scope.applyChanges();
        };
        /**
   * If a map has been dropped on the canvas
   * @param  {object} map the added map
   * @param  {boolean} [saveOriginal=true] Whether to save a copy of the original map or not
   * @return {Promise}
   */ $scope.addMap = function(map, saveOriginal = true, checkDirtyState = true) {
            // Restangularizing the element because it may be coming from React.
            if (!("setup" in map)) map = Restangular.restangularizeElement(null, angular.copy(map), "mapping/maps");
             // Make sure an unsaved map isn't overwritten by a new one
            if (checkDirtyState && $scope.isMapDirty) return MappingModals.openSaveMapChanges("Do you want to save before loading a new map?", $scope.saveMap.bind(null, $scope.map), "Save", "Don't Save") // If the user wants to save changes, do it.
            .then(function() {
                return $scope.saveMap($scope.map);
            }) // If the user said no to saving changes, ignore changes.
            .catch(function() {
                (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false)); // this has to be forcibly set on scope b/c it's not set right away by the redux dispatch
                $scope.isMapDirty = false;
            }) // Whatever they said, load the new map.
            .finally(function() {
                return $scope.addMap(map, saveOriginal);
            });
            map.setup($scope.workspace.collections);
            Storage.setItem("mapID", map.ID);
            if (saveOriginal) setOriginalMap(map); // Clear the map and set the canvas to clean
            $scope.truMap.clear([
                $scope.markerID
            ]);
            $scope.selectedFeatures = {};
            (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false));
            $scope.drawingEnabled = false;
            $scope.annotationsRefreshedAt = null;
            return refreshTiles(map).then(function() {
                $scope.map = map;
                $scope.$broadcast("newMapCreated", map);
            });
        };
        $scope.loadMapBookmark = function(map) {
            var promise;
            if (map.workspaceID != $scope.workspace.ID) {
                var workspace = _.find($scope.workspaces, {
                    ID: map.workspaceID
                });
                promise = $scope.setWorkspace(workspace);
            } else promise = $q.when();
            promise.then($scope.addMap.bind(null, map, false, true));
            return promise;
        };
        /**
   * Get the original map by map ID
   * @param  {integer} mapID
   * @return {object}
   */ $scope.getOriginalMap = function(mapID) {
            return originalMaps[mapID];
        }; // Just to expose this to the public controller
        $scope.setOriginalMap = setOriginalMap;
        /**
   * Creates a new map
   * @return {void}
   */ $scope.createNewMap = function(saveMarker = false) {
            // Create a new empty map
            loadEmptyMap(true, saveMarker); // Broadcast the changes
            $scope.$broadcast("newMapCreated", $scope.map);
        };
        /**
   * Toggles the layers panel
   * @return {void}
   */ $scope.toggleTopPanel = function(activeSection) {
            (0, _store.store).dispatch((0, _pagesSlice.toggleTopPanelSection)(activeSection));
        };
        /**
   * Centers the canvas on the user's current location
   * @return {void}
   */ $scope.centerOnCurrentLocation = function() {
            $scope.locationActive = true;
            $geolocation.getCurrentPosition({
                timeout: 60000
            }).then(function(position) {
                let makeMenu = ContextMenu.make.bind(null, findCollection, false, "");
                $scope.truMap.removeLayer($scope.markerID);
                $scope.markerID = $scope.truMap.addMarker([
                    position.coords.latitude,
                    position.coords.longitude
                ], makeMenu);
                $scope.truMap.setView([
                    position.coords.latitude,
                    position.coords.longitude
                ], 15, {
                    animate: true
                });
            }).finally(function() {
                $scope.locationActive = false;
            });
        };
        /**
   * Makes a request to save the map if there is an ID, otherwise it saves a new map
   * @param  {object} map
   * @return {object} promise
   */ $scope.saveMap = function(map, refresh = false) {
            return map.ID && (hasMapAccess("update") || hasMapAccess("collaborate") && map.allowCollaboration) ? $scope.updateMap(map, refresh) : MappingModals.openSaveMap({
                ...map,
                ID: undefined
            }, $scope.createMap, workspace.getTopLevelMaps());
        };
        $scope.updateMap = function(map, refresh = false) {
            return (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.updateMap.initiate(angular.copy({
                ...Map.dataOnly(map),
                collections: undefined
            }))).then(function() {
                $scope.$apply(function() {
                    $scope.workspace.maps[_.findIndex($scope.workspace.maps, {
                        ID: map.ID
                    })] = map;
                    $scope.map = map;
                    map.setup($scope.workspace.collections);
                    (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false));
                    setOriginalMap(map);
                });
            }).then(function() {
                if (refresh) $scope.applyChanges();
            });
        };
        $scope.createMap = function(map) {
            return (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.createMap.initiate(map)).then(function({ data: newMap }) {
                map.ID = newMap.ID;
                map.UUID = newMap.UUID;
                Map.restangularize(map);
                map.setup($scope.workspace.collections); // Add map to parent's view (temporary) or to complete list of maps
                if (map.parentID) {
                    // The two copies of the workspace are used by different things and aren't in sync.
                    addMapToParent(map, $scope.workspace);
                    addMapToParent(map, _.find($scope.workspaces, {
                        ID: $scope.workspace.ID
                    }));
                } else {
                    $scope.workspace.maps.push(map);
                    _.find($scope.workspaces, {
                        ID: $scope.workspace.ID
                    }).maps.push(map);
                }
                $scope.map = map;
                $scope.truMap.clearSelection(Object.keys($scope.selectedFeatures));
                $scope.selectedFeatures = {};
                (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false));
                Storage.setItem("mapID", map.ID); // If any layers are selectable, they must have just been set so. Reload the map so that the vector tiles get fetched.
                if (Object.keys(map.selectable).find((k)=>map.selectable[k])) $scope.applyChanges();
            });
        };
        /**
   * Sets the current workspace
   * @param {object} workspace
   * @param {Promise}
   */ $scope.setWorkspace = async function(workspace, fetch1 = true) {
            if ($scope.isMapDirty) try {
                await MappingModals.openSaveMapChanges("Would you like to save changes before switching workspaces?", $scope.saveMap.bind(null, $scope.map), "Save", "Don't Save");
            } catch (e) {
                // A rejection means "no, I don't want to save."
                (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false));
            }
            if (!fetch1) return $q.when(set(workspace));
            else return $scope.workspaces.getWorkspace(workspace.ID).then(set);
            function set(workspace) {
                $scope.workspace = workspace;
                $scope.createNewMap(true);
                Storage.setItem("workspace", workspace.ID);
                return workspace;
            }
        };
        $scope.createWorkspaceClone = function(workspace) {
            return workspace.postClone().then(addWorkspace);
        };
        /**
   * Deletes a map
   * @param  {object} map
   * @return {void}
   */ $scope.deleteMap = function(map) {
            (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.deleteMap.initiate(map)).then(function() {
                if (map.ID == $scope.map.ID) loadEmptyMap(true, true);
                $scope.workspace.maps.splice(_.findIndex($scope.workspace.maps, {
                    ID: map.ID
                }), 1);
                _.find($scope.workspaces, {
                    ID: $scope.workspace.ID
                }).maps.splice(_.findIndex($scope.workspace.maps, {
                    ID: map.ID
                }), 1);
            });
        };
        $scope.timeframeChanged = function(range) {
            $scope.map.dateRange = range;
            refreshTiles();
            $scope.$broadcast("timeframeChanged");
        };
        $scope.toggleDrawing = function() {
            let map = !$scope.map.parentID ? $scope.map : $scope.workspace.maps.find((m)=>m.ID == $scope.map.parentID);
            $scope.drawingEnabled = !$scope.drawingEnabled;
            if ($scope.drawingEnabled) {
                $scope.truMap.enableDrawing(onCreate, onEdit, onDelete, onRefresh);
                map.getAnnotations($scope.annotationsRefreshedAt).then(setDrawn);
            } else $scope.truMap.disableDrawing();
             // Wrap the callbacks so that they always draw the new current layer.
            function onCreate(feature1) {
                map.addAnnotation(feature1, $scope.annotationsRefreshedAt).then(setDrawn);
            }
            function onEdit(features) {
                map.editAnnotations(features, $scope.annotationsRefreshedAt).then(setDrawn);
            }
            function onDelete(ids) {
                map.deleteAnnotations(ids, $scope.annotationsRefreshedAt).then(setDrawn);
            }
            function onRefresh() {
                map.getAnnotations($scope.annotationsRefreshedAt).then(setDrawn);
            }
            function setDrawn(response) {
                $scope.truMap.setDrawnItems(response.updated);
                $scope.truMap.removeDrawnItems(response.deleted);
                $scope.annotationsRefreshedAt = moment(response.timestamp);
            }
        };
        function findCollection(id) {
            return $scope.map.collections.find((c)=>c.ID == id);
        }
        /**
   * Add a new map to its parent in the given workspace.
   */ function addMapToParent(map, workspace) {
            let parent = workspace.maps.find((m)=>m.ID == map.parentID);
            if (parent.views) parent.views.push(map);
            else parent.views = [
                map
            ];
        }
        /**
   * Removes a collection from the map
   * @param  {number} ID collection id
   * @return {void}
   */ $scope.removeCollection = function(ID) {
            $scope.map.collections = $scope.map.collections.filter((c)=>c.ID !== ID);
            $scope.map.collectionIDs = $scope.map.collectionIDs.filter((c)=>c !== ID);
            delete $scope.map.visible[ID];
            delete $scope.map.filters[ID];
            delete $scope.map.themes[ID];
            $scope.applyChanges();
            $scope.map.legends = $scope.map.getLegends();
        }; //#region right side
        $scope.toggleVisible = function(ID) {
            $scope.map.visible[ID] = !$scope.map.visible[ID];
            $scope.applyChanges();
        };
        $scope.setMapLabel = function(ID, label) {
            $scope.map.labels[ID] = label;
            $scope.applyChanges();
        };
        $scope.setMapTheme = function(ID, theme) {
            $scope.map.themes[ID] = theme.ID;
            $scope.map.labels[ID] = theme.label;
            $scope.applyChanges();
        };
        $scope.addTheme = function(collectionID) {
            const collection = $scope.map.collections.find((c)=>c.ID === collectionID);
            const theme = Theme.getDefaultTheme(collection, $scope.map.workspaceID);
            (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.createTheme.initiate(theme)).then(({ data: newTheme })=>postCreateTheme(collection, newTheme));
        };
        /**
   * Clones a theme
   * @param  {number} collectionID
   * @param  {object} toClone    the theme to clone
   * @return {void}
   */ $scope.cloneTheme = function(collectionID, toClone) {
            const collection = $scope.map.collections.find((c)=>c.ID === collectionID);
            $uibModal.open({
                templateUrl: "/truterritory/clone-theme.html",
                controller: [
                    "$scope",
                    function($scope) {
                        $scope.theme = Theme.dataOnly(toClone);
                    }
                ]
            }).result.then(function(theme) {
                (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.createTheme.initiate(theme)).then(({ data: newTheme })=>postCreateTheme(collection, newTheme));
            });
        };
        /**
   * The closure that's fired after creating/cloning a theme
   *   Adds the theme to the collection array
   *   Sets the theme
   * @param  {object} collection
   * @param  {object} theme
   * @return {void}
   */ function postCreateTheme(collection, theme) {
            // Create the themes array if it doesn't exist
            if (!collection.themes) collection.themes = []; // Add the theme to the collections array
            collection.themes.push(theme);
            $scope.setMapTheme(collection.ID, theme);
        }
        $scope.setFilters = function(ID, filters) {
            $scope.map.filters[ID] = filters;
            $scope.applyChanges();
        };
        $scope.setCollections = function(collections) {
            $scope.map.collections = collections;
            $scope.map.collectionIDs = collections.map((c)=>c.ID);
            $scope.applyChanges();
        };
        $scope.selectionActions = {
            // clear undoes all selections and restore feature states.
            clear: ()=>{
                $scope.truMap.clearSelection(Object.keys($scope.selectedFeatures));
                $scope.$apply(()=>$scope.selectedFeatures = {});
            },
            // goTo zooms/pans as needed to fit the selection in the map view.
            goTo: ()=>{
                // Make a flat list of features.
                const features = [];
                for(const layerName in $scope.selectedFeatures)for(const featureId in $scope.selectedFeatures[layerName])features.push($scope.selectedFeatures[layerName][featureId]);
                $scope.truMap.goTo(features);
            },
            // filterBy converts the selection into collection-level filters and applies them to the map.
            filterBy: ()=>{
                if (!$scope.selectedFeatures) return;
                 // For each layer in the selection, filter down to matching feature IDs.
                $scope.$apply(()=>{
                    for(layerName in $scope.selectedFeatures){
                        const collection = $scope.map.collections.find((c)=>c.tableName == layerName);
                        const filter = {
                            operator: "IN",
                            column: collection.idColName,
                            value: Object.keys($scope.selectedFeatures[layerName])
                        }; // To make this work predictably, we have to first remove any "IN" filter(s) on idColName.
                        const baseFilters = ($scope.map.filters[collection.ID] || []).filter((f)=>!(f.operator == "IN" && f.column == collection.idColName)); // We add to existing filters for this collection (implicit AND), if present.
                        $scope.map.filters[collection.ID] = [
                            ...baseFilters,
                            filter
                        ];
                    }
                    $scope.applyChanges();
                }); // For layers not in the selection, don't do anything??
            },
            combine: ()=>{
                console.log("combining...");
            },
            // downloadReport will download a report PDF in a separate tab.
            downloadReport: async (filter = false)=>{
                if (!$scope.selectedFeatures) return;
                 // Choose the first report (parent preferred) which accepts selection.
                const map = $scope.map.parentID ? $scope.workspace.maps.find((m)=>m.ID == $scope.map.parentID) : $scope.map;
                const report = map.reports && map.reports.find((r)=>r.acceptsSelection);
                if (!report) return;
                 // Make the set of selected IDs and a bounding box containing them all.
                let selection = {};
                let features = [];
                for(const layerId in $scope.selectedFeatures){
                    selection[layerId] = Object.keys($scope.selectedFeatures[layerId]);
                    features.push(...selection[layerId].map((k)=>$scope.selectedFeatures[layerId][k].toJSON()));
                }
                const point = (0, _centerDefault.default)((0, _helpers.featureCollection)(features)).geometry.coordinates;
                const preflight = $scope.map.getPreflightMap(); // Set filters.
                if (filter) for(layerName in $scope.selectedFeatures){
                    const collection = $scope.map.collections.find((c)=>c.tableName == layerName);
                    const filter = {
                        operator: "IN",
                        column: collection.idColName,
                        value: Object.keys($scope.selectedFeatures[layerName])
                    }; // To make this work predictably, we have to first remove any "IN" filter(s) on idColName.
                    let preflightCollection = preflight.collections.find((c)=>c.ID == collection.ID);
                    const baseFilters = (preflightCollection.filters[collection.ID] || []).filter((f)=>!(f.operator == "IN" && f.column == collection.idColName)); // We add to existing filters for this collection (implicit AND), if present.
                    preflightCollection.filters = [
                        ...baseFilters,
                        filter
                    ];
                }
                try {
                    // Download the bytestream and load it into a Blob.
                    const resp = await fetch(`${API_ROOT}/mapping/reports/${report.ID}/${INSTANCE_ID}/${point[1]}/${point[0]}?entityID=${$scope.map.entityID}`, {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            selection,
                            map: preflight
                        })
                    });
                    if (resp.status != 200) {
                        const data = await resp.json();
                        if (data.status && data.status.message) return data.status.message;
                        return resp.statusText;
                    } // Create an object URL for the blob, make an anchor element pointing to it, and "click" on the element.
                    const url = URL.createObjectURL(await resp.blob());
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "report.pdf"; // Clean up on click
                    const cleanup = ()=>{
                        setTimeout(()=>{
                            URL.revokeObjectURL(url);
                            removeEventListener("click", cleanup);
                        }, 200);
                    };
                    a.addEventListener("click", cleanup, false);
                    a.click();
                    return "";
                } catch (error) {
                    console.log("returning error", error);
                    return error.toString();
                }
            },
            canDownloadReport: ()=>{
                let map = !$scope.map.parentID ? $scope.map : $scope.workspace.maps.find((m)=>m.ID == $scope.map.parentID);
                return !!(map.reports && map.reports.find((r)=>r.acceptsSelection));
            }
        }; //#endregion
        //#region layers
        /**
   * Remove a collection from the current workspace
   * @param  {int} collectionID
   * @return {void}
   */ $scope.removeCollectionFromWorkspace = function(collectionID) {
            $scope.workspace.removeCollection(collectionID);
        };
        /**
   * Update the name or sharing options of the workspace
   * @param  {object} partialWorkspace The workspace object with only the fields to be updated, only name and sharingEnabled are supported
   */ $scope.updateWorkspace = function(partialWorkspace) {
            $scope.workspace.patch(_.pick(partialWorkspace, [
                "name",
                "sharingEnabled"
            ]));
            $timeout(()=>{
                $scope.workspace.name = partialWorkspace.name;
                $scope.workspace.sharingEnabled = partialWorkspace.sharingEnabled;
            });
        };
        /**
   * Remove the logged-in user from the given workspace
   * @param  {Object} workspace
   * @return {Promise}
   */ $scope.removeWorkspace = function(workspace) {
            let userID = Session.get("ID");
            let modal = $uibModal.open({
                templateUrl: "/truterritory/confirm-remove-user-workspace.html"
            });
            return modal.result.then(function() {
                // workspace might be coming from redux and needs to be restangularized
                const remove = "removeUser" in workspace ? workspace.removeUser : Restangular.restangularizeElement(null, angular.copy(workspace), "mapping/workspaces").removeUser;
                return remove(userID);
            }).then(function() {
                const index = $scope.workspaces.findIndex((w)=>w.ID === workspace.ID);
                $scope.workspaces.splice(index, 1);
                if (workspace.ID == $scope.workspace.ID) {
                    // look, your guess is as good as mine.
                    //  Why doesn't Array.prototype.find work here? No clue. Why didn't lodash _.find work? No clue.
                    //  Why does this work? No clue. But it does, so just move on. Nothing to see here *waves hands* this isn't the code smell you're looking for
                    const defaultWorkpace = Array.from($scope.workspaces).find((w)=>w.default);
                    if (defaultWorkpace) $scope.setWorkspace(defaultWorkpace);
                }
            });
        };
        /**
   * Create a new workspace
   * @param  {Object} workspace
   * @return {Promise}
   */ $scope.createWorkspace = function(workspace) {
            let userID = Session.get("ID");
            workspace = {
                name: workspace.name,
                userID: userID,
                userIDs: [
                    userID
                ]
            };
            return Workspace.post(workspace, {
                with: "all"
            }).then(function(response) {
                $scope.workspaces = $scope.workspaces.concat([
                    response
                ]);
                return $scope.setWorkspace(response, false);
            });
        };
        $scope.saveUsers = function(users) {
            return $scope.workspace.saveUsers(users).then(()=>{
                $scope.workspace.users = users;
            });
        };
        /**
   * Remove a user from the current workspace
   * @param  {int} userID
   * @return {void}
   */ $scope.removeUser = function(userID) {
            $scope.workspace.removeUser(userID).then(()=>{
                $scope.workspace.users = $scope.workspace.users.filter((u)=>u.ID !== userID);
            });
        };
        $scope.addCollectionForLayers = function(data) {
            if (!_.find($scope.map.collections, {
                ID: data.ID
            })) {
                if (!("findTheme" in data)) data = Restangular.restangularizeElement(null, angular.copy(data), "mapping/collections");
                let collection = _.find($scope.workspace.collections, {
                    ID: data.ID
                }) || data;
                $scope.addCollection(collection);
            }
        };
        $scope.addMapById = function(mapID) {
            let map = _.find($scope.workspace.maps, {
                ID: mapID
            });
            $scope.addMap(map);
        }; //#endregion
        /**
   * Loads an empty map
   * @param {bool} forget If true, forget the previous map
   * @return {void}
   */ function loadEmptyMap(forget = true, saveMarker = false) {
            $scope.map = Map.getEmptyMap($scope.workspace.ID, $state.params.entityID);
            (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(false));
            $scope.truMap.clear(saveMarker ? [
                $scope.markerID
            ] : []);
            $scope.selectedFeatures = {};
            if ($scope.drawingEnabled) $scope.toggleDrawing();
            if (forget) Storage.removeItem("mapID");
        }
        /**
   * Clones the passed-in map, and sets it on the originalMaps object
   * @param {object} map
   */ function setOriginalMap(map) {
            originalMaps[map.ID] = map.clone();
        }
        function addWorkspace(workspace) {
            $scope.workspaces.push(workspace);
            $scope.workspace = workspace;
            $scope.createNewMap();
            Storage.setItem("workspace", workspace.ID);
        }
        function refreshTiles(map) {
            map = map || $scope.map;
            return map.sendRenderingPreflight().then(function(data) {
                let tileLayer = $scope.truMap.addOrUpdateTruTileLayer(INSTANCE_ID);
                tileLayer.on("loading", function(e) {
                    $scope.$apply(function() {
                        $scope.tilesLoading = true;
                    });
                });
                tileLayer.on("load", function(e) {
                    $scope.$apply(function() {
                        $scope.tilesLoading = false;
                    });
                });
                try {
                    const layers = map.collections.filter((c)=>map.selectable[c.ID] && map.visible[c.ID] && !!c.idColName);
                    const layerNames = layers.map((c)=>c.tableName);
                    const layerIds = layers.reduce((agg, c)=>({
                            ...agg,
                            [c.tableName]: c.idColName
                        }), {});
                    if (hasMapAccess("collaborate")) $scope.truMap.addOrUpdateTruVectorLayer(INSTANCE_ID, layerNames, layerIds, featuresSelected, featuresDeselected);
                } catch (e) {
                    console.log("Failed initializing vector layer", e);
                }
                map.aggregates = data.aggregates;
            }).catch(function(fallback) {
                // Generate our functional error code / message
                let errorCode = (fallback.data && fallback.data.status && fallback.data.status.code || fallback.status) + "";
                let errorMessage = fallback.data && fallback.data.status && fallback.data.status.message || fallback.statusText; // Only popup a message if we have something meaningful to say
                if (errorCode !== "-1" && errorCode !== "403" && (errorCode || errorMessage)) $rootScope.$broadcast("httpError", {
                    error: {
                        status: {
                            exception: "generic",
                            code: errorCode,
                            message: "Error during map preflight: " + (errorMessage || "unknown error")
                        }
                    }
                });
                return [];
            });
        }
        function featuresSelected(features) {
            $scope.$apply(()=>{
                for (feature of features){
                    if (!(feature.sourceLayer in $scope.selectedFeatures)) $scope.selectedFeatures[feature.sourceLayer] = {};
                    $scope.selectedFeatures[feature.sourceLayer][feature.id] = feature;
                }
                $scope.selectedFeatures = {
                    ...$scope.selectedFeatures
                }; // Copy to trigger re-render in React.
            });
        }
        function featuresDeselected(features) {
            $scope.$apply(()=>{
                let deleted = 0;
                for (feature of features)if (feature.sourceLayer in $scope.selectedFeatures && feature.id in $scope.selectedFeatures[feature.sourceLayer]) {
                    delete $scope.selectedFeatures[feature.sourceLayer][feature.id];
                    deleted++;
                    if (Object.keys($scope.selectedFeatures[feature.sourceLayer]).length == 0) delete $scope.selectedFeatures[feature.sourceLayer];
                }
                if (deleted > 0) $scope.selectedFeatures = {
                    ...$scope.selectedFeatures
                }; // Copy to trigger re-render in React.
            });
        }
        function makeMapDirty(fireEvent = true) {
            if (fireEvent) $scope.$broadcast("mapDirtied");
            (0, _store.store).dispatch((0, _pagesSlice.setMapDirty)(true));
        }
        /**
   * Set the theme for a given collection
   * @param {Object}  collection
   * @param {Object}  theme
   * @param {Boolean} useThemeLabel Whether to override the map's label setting with the theme's
   */ function setTheme(collection, theme, useThemeLabel = true) {
            $scope.map.themes[collection.ID] = theme.ID;
            if (useThemeLabel) $scope.map.labels[collection.ID] = theme.label;
            $scope.applyChanges();
        }
    }
]);

},{"@turf/center":"3RAPU","@turf/helpers":"j8Evk","../../../../src/slices/appSlice":"w3GXi","../../../../src/slices/pagesSlice":"1GDaH","../../../../src/slices/apiSlice":"fcKYC","../../../../src/store":"7WrEn","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"3RAPU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bbox = require("@turf/bbox");
var _bboxDefault = parcelHelpers.interopDefault(_bbox);
var _helpers = require("@turf/helpers");
/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.points([
 *   [-97.522259, 35.4691],
 *   [-97.502754, 35.463455],
 *   [-97.508269, 35.463245]
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */ function center(geojson, options) {
    if (options === void 0) options = {};
    var ext = (0, _bboxDefault.default)(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return (0, _helpers.point)([
        x,
        y
    ], options.properties, options);
}
exports.default = center;

},{"@turf/bbox":"g2eLG","@turf/helpers":"j8Evk","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"b9z67":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _angular = require("angular");
var _angularDefault = parcelHelpers.interopDefault(_angular);
(0, _angularDefault.default).module("routes:mapping").factory("hasMapAccess", [
    "PermissionManager",
    "Session",
    "$stateParams",
    function(PermissionManager, Session, $stateParams) {
        var access = new PermissionManager(Session.getAll().permissions || {});
        /**
   * A simple function-as-a-service to check mapping permissions
   * @param  {[type]}  type [description]
   * @return {Boolean}      [description]
   */ return function hasMapAccess(type) {
            return access.hasAccessAbove("entity." + $stateParams.entityID + ".mapping", type);
        };
    }
]);

},{"angular":"8oyA9","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"kPz9Z":[function(require,module,exports) {
/**
 * Image downloader for TruTerritory
 */ angular.module("routes:mapping").directive("downloadImage", function() {
    return {
        replace: true,
        scope: {
            truMap: "=",
            map: "=",
            markerId: "="
        },
        templateUrl: "/truterritory/download-image.html",
        controller: [
            "$scope",
            "$window",
            "$timeout",
            function($scope, $window, $timeout) {
                $scope.dimensions = {
                    width: null,
                    height: null,
                    zoom: null
                };
                var map = $scope.truMap.getLeafletMap();
                var boundingBox, lastChanged;
                /**
       * Initialize the box selector
       * @return {void}
       */ $scope.createBoundingBox = function() {
                    boundingBox = new $window.L.AreaSelect({
                        width: 200,
                        height: 200
                    });
                    boundingBox.addTo(map);
                    $scope.dimensions.zoom = $scope.truMap.getZoom();
                    $scope.updateDimensions();
                    $scope.createOptions();
                    $scope.mapSize = map.getSize(); // Bind the event listeners
                    boundingBox.on("change", changeListener);
                    boundingBox.on("changing", function() {
                        $scope.$apply($scope.updateDimensions);
                    });
                    map.on("resize", setMapSize);
                    map.on("zoom", changeListener);
                }; // On destroy, make sure everything gets cleaned up
                $scope.$on("$destroy", function() {
                    if (boundingBox) {
                        boundingBox.off("change", changeListener);
                        boundingBox.off("changing", $scope.updateDimensions);
                    }
                    map.off("resize", setMapSize);
                    map.off("zoom", changeListener);
                }); // Fired on map resize
                function setMapSize(event) {
                    $scope.mapSize = event.newSize;
                }
                /**
       * Listens to changes from the bounding box
       * @param  {object} event
       * @return {void}
       */ function changeListener(event) {
                    // If there's a previous event, this means that the user initiated the change,
                    //  If not, return, b/c updating the UI will cause the inputs to be rounded, causing weeeeeird stuff to happen,
                    //  like not being able to increment the inputs by less than 2
                    if (!event.prevEvent) return;
                    $scope.updateDimensions();
                    $scope.createOptions();
                }
                /**
       * Updates the dimensions inputs
       * @return {void}
       */ $scope.updateDimensions = function() {
                    var size = getBoxSize();
                    $scope.dimensions.width = size.width;
                    $scope.dimensions.height = size.height;
                };
                /**
       * Fired when the user inputs a width or height;
       *   Sets the box size and updates the select options
       * @param  {integer} width
       * @param  {integer} height
       * @return {void}
       */ $scope.changeSize = function(width, height) {
                    boundingBox.setDimensions({
                        width: width,
                        height: height
                    });
                    $scope.createOptions();
                };
                /**
       * Create the magnification options
       * @param  {object|null} event
       * @return {void}
       */ $scope.createOptions = function(event) {
                    // Reset the sizes and get the current zoom
                    $scope.sizes = [];
                    var currentZoom = $scope.truMap.getZoom(); // Loop through all valid zoom levels (1-20)
                    for(var i = 1; i <= 20; i++){
                        var size = Math.pow(2, i - currentZoom); // If the dimensions are too big or too small, don't add it
                        if ($scope.dimensions.width * size >= 16384 || $scope.dimensions.height * size >= 16384 || $scope.dimensions.width * size <= 16 || $scope.dimensions.height * size <= 16) continue;
                        $scope.sizes.push({
                            value: i,
                            name: size + "x"
                        });
                    } // If the current user-selected zoom isn't available anymore, set it to the current zoom
                    if (!_.find($scope.sizes, {
                        value: $scope.dimensions.zoom
                    })) $scope.dimensions.zoom = currentZoom;
                };
                /**
       * Gets the size of the bounding box
       * @return {object} {width: integer, height: integer}
       */ function getBoxSize() {
                    var bounds = boundingBox.getBounds();
                    var ne = $scope.truMap.getLeafletMap().latLngToLayerPoint(bounds.getNorthEast());
                    var sw = $scope.truMap.getLeafletMap().latLngToLayerPoint(bounds.getSouthWest());
                    var width = ne.x - sw.x;
                    var height = sw.y - ne.y;
                    return {
                        width: width,
                        height: height
                    };
                }
                /**
       * Actually download the image by opening a link
       * @return {void}
       */ $scope.downloadImage = function() {
                    var bounds = boundingBox.getBounds();
                    const marker = $scope.markerId && $scope.truMap._layers[$scope.markerId] && $scope.truMap._layers[$scope.markerId].getLatLng();
                    $window.open($scope.map.getImageDownloadUrl($scope.dimensions.zoom, bounds.getSouthWest(), bounds.getNorthEast(), marker && [
                        marker.lng,
                        marker.lat
                    ]));
                };
                /**
       * Close everything down!
       * @return {void}
       */ $scope.close = function() {
                    boundingBox.remove();
                };
            }
        ]
    };
});

},{}],"c3862":[function(require,module,exports) {
/**
 * @name historySlider
 * @memberOf routes:mapping
 * @ngdoc directive
 * @description
 *
 * Slider for historical map data
 *
 * @example <history-slider map="map" max-date-range="maxDateRange"></history-slider>
 *
 * @param {L.Map} map a Leaflet map object
 * @param {Object} maxDateRange expected to a Moment date ranges as such: `{ minDate: Moment, maxDate: Moment }`
 * @param {Moment} maxDateRange.minDate a Moment date object
 * @param {Moment} maxDateRange.maxDate a Moment date object
 * @param {integer} mode either 1 or 2, depending on which slider is wanted (i.e., 1 for a single point slider, 2 for a two point slider)
 *
 * @see {@link routes_mapping.OnePointHistorySlider}
 * @see {@link routes_mapping.TwoPointHistorySlider}
 */ angular.module("routes:mapping").directive("historySlider", [
    "HistorySlider",
    "$timeout",
    function(HistorySlider, $timeout) {
        return {
            scope: {
                map: "=",
                maxDateRange: "=",
                dateRange: "=ngModel",
                mode: "=",
                interval: "="
            },
            require: "ngModel",
            link: function($scope, $element, $attrs, $model) {
                /**
       * This holds the control after it's been initialized
       */ let control;
                /**
       * Creates the slider
       * @param  {integer} mode the slider mode to create
       * @return {void}
       */ function initialize(mode) {
                    control = HistorySlider(); // Make sure the slider updates the model
                    control.on("change", function(data) {
                        $model.$setViewValue(data.range);
                    });
                    control.addTo($scope.map);
                }
                /**
       * Runs when settings are changed
       * @return {void}
       */ function updateControlSettings() {
                    // Don't try to work on an uninitialized control
                    if (!control) return;
                    control.initialize({
                        minDate: $scope.dateRange.minDate || $scope.maxDateRange.minDate,
                        maxDate: $scope.dateRange.maxDate || $scope.maxDateRange.maxDate,
                        range: $scope.maxDateRange,
                        mode: $scope.mode,
                        interval: $scope.interval // only used for single point sliders
                    });
                }
                /**
       * Check that two date ranges are equal, even if the objects aren't identical
       * @param  {Object} range1
       * @param  {Object} range2
       * @return {boolean}
       */ function rangesAreEqual(range1, range2) {
                    return range1.minDate.format() == range2.minDate.format() && range1.maxDate.format() == range2.maxDate.format();
                } // Update the slider to reflect the mode setting
                $scope.$watch("mode", function(mode, oldVal) {
                    // Only re-initialize the slider if it's already been initialized and the mode has changed
                    if (mode && control && mode != oldVal) {
                        // Remove any existing controls
                        if (control) control.remove();
                        initialize(mode);
                        updateControlSettings();
                    }
                }); // If the scope is destroyed, make sure the control gets removed
                $scope.$on("$destroy", function() {
                    control.remove();
                }); // If the date range or interval changes, update the control's settings
                $scope.$watchGroup([
                    "maxDateRange",
                    "interval"
                ], function(newVals, oldVals) {
                    if (!rangesAreEqual(newVals[0], oldVals[0]) || newVals[1] != oldVals[1]) updateControlSettings();
                }); // Update the slider when the model changes
                $model.$render = updateControlSettings; // the offender
                // And finally, create the slider for the first time!!
                initialize($scope.mode);
            }
        };
    }
]);

},{}],"jBGpQ":[function(require,module,exports) {
/**
 * Slider for intervals on a map
 *
 * <interval-slider map="map" ng-model="interval"></interval-slider>
 *
 * @param {L.Map} map a Leaflet map object
 * @param {object} ngModel
 *
 */ angular.module("routes:mapping").directive("intervalSlider", [
    "IntervalSlider",
    "Map",
    function(IntervalSlider, Map) {
        return {
            scope: {
                map: "="
            },
            require: "ngModel",
            link: function($scope, $element, $attrs, $model) {
                let control;
                $model.$render = function() {
                    if (control) control.remove();
                    let intervals = Map.intervals;
                    control = IntervalSlider({
                        intervals: intervals,
                        interval: $model.$viewValue
                    });
                    control.on("change", function(data) {
                        $model.$setViewValue(data.interval);
                    });
                    control.addTo($scope.map);
                };
                $scope.$on("$destroy", ()=>{
                    control.remove();
                });
            }
        };
    }
]).factory("IntervalSlider", [
    "$window",
    function($window) {
        var L = $window.L;
        var IntervalSlider = L.Control.extend({
            includes: L.Mixin.Events,
            options: {
                position: "bottomleft"
            },
            onAdd: function(map) {
                // Create the divs to hold the slider, and the slider
                var div = L.DomUtil.create("div", "leaflet-control-interval-slider"), slider = L.DomUtil.create("div", "slider", div); // Disable the click propagation so that the slider events aren't caught by the map
                L.DomEvent.disableClickPropagation(slider);
                $(slider).prepend("<p>Compare:</p>");
                $(slider).slider({
                    orientation: "horizontal",
                    range: false,
                    min: 0,
                    max: this.options.intervals.length - 1,
                    value: this.options.intervals.indexOf(this.options.interval),
                    step: 1,
                    slide: (event, ui)=>{
                        // On slider, change the label and text position if necessary
                        var label = $(ui.handle).children("label");
                        label.text(this.options.intervals[ui.value]);
                        if (ui.value == this.options.intervals.length - 1) label.css("left", -(label.width() + 20));
                        else label.css("left", 10);
                    },
                    create: (event, ui)=>{
                        // Create the label, set the text, and the position
                        var handle = $(slider).children(".ui-slider-handle").eq(0);
                        var label = $("<label>" + this.options.interval + "</label>");
                        label.css("left", 10);
                        handle.html(label);
                    },
                    stop: (event, ui)=>{
                        this.fire("change", {
                            interval: this.options.intervals[ui.value]
                        });
                    }
                });
                return div;
            }
        }); // Return a factory method that creates a new `IntervalSlider`
        return function(options) {
            return new IntervalSlider(options);
        };
    }
]);

},{}],"89ltO":[function(require,module,exports) {
/**
 * @name HistorySlider
 * @memberOf routes:mapping
 * @ngdoc service
 * @description The Leaflet component behind the historySlider directive (for single point selection)
 * @see {@link routes_mapping.historySlider}
 * @returns {Function} a factory method to create a new instance
 */ angular.module("routes:mapping").factory("HistorySlider", [
    "$window",
    "$compile",
    "$rootScope",
    "DateRange",
    "Interval",
    function($window, $compile, $rootScope, DateRange, Interval) {
        let L = $window.L;
        let HistorySlider = L.Control.extend({
            includes: L.Mixin.Events,
            options: {
                minDate: null,
                maxDate: null,
                range: {
                    // this is the maximum range the slider can cover
                    minDate: null,
                    maxDate: null
                },
                interval: null,
                // an integer representation of the interval
                mode: null,
                // 1 | 2
                position: "bottomleft"
            },
            intervals: Interval.getNouns(),
            presets: DateRange.getRanges(true),
            initialize (options) {
                if (options) L.setOptions(this, options);
                if (!this.options.interval) this.options.interval = 1; // Setup the slider
                this._setSliderMode(this.options.mode);
                this._createLabels(); // If there's a map then it's okay to proceed with everything else
                if (this._map) {
                    // Set step interval
                    this._setSteps(); // Update everything
                    this._updateSlider();
                    this._createPresets(); // And fire change!
                // this._fireChange()
                }
            },
            onAdd (map) {
                // Create the divs to hold the slider, and the slider
                var div = L.DomUtil.create("div", "leaflet-control-history-slider");
                this.slider = L.DomUtil.create("div", "slider", div); // Disable the click propagation so that the slider events aren't caught by the map
                L.DomEvent.disableClickPropagation(this.slider); // Create a jQuery UI slider
                $(this.slider).dragslider({
                    orientation: "horizontal",
                    slide: (event, ui)=>{
                        let data = "values" in ui ? {
                            minValue: ui.values[0],
                            maxValue: ui.values[1]
                        } : {
                            minValue: ui.value
                        };
                        this._updateSlider(data);
                    },
                    // Only fire change on stop so that change isn't firing while sliding
                    stop: (event, ui)=>{
                        // Set the preset selector to custom when the slider handles are moved
                        this._setPresetDisplay("custom");
                        this._fireChange();
                    }
                }); // Set the initial mode and labels
                this._setSliderMode(this.options.mode);
                this._createLabels(); // After creating everything, return the div (which now contains all the built HTML), so that Leaflet can add it to the map
                return div;
            },
            /**
     * Fire a change event to anyone listening
     * @return {void}
     */ _fireChange: function() {
                this.fire("change", {
                    range: {
                        minDate: this.options.minDate,
                        maxDate: this.options.maxDate
                    }
                });
            },
            /**
     * Update the slider with newly calculated dates & labels
     * @return {void}
     */ _updateSlider (values) {
                // First get the actual slider values
                let { minValue, maxValue } = values || this._getSliderValues(); // Set the min date
                this.options.minDate = this._calculateDate(this.options.range.minDate, minValue, "minDate"); // If this is a two point slider, set it exactly like the min date
                if (this.options.mode == 2) this.options.maxDate = this._calculateDate(this.options.range.minDate, maxValue, "maxDate"); // Else calculate the max date (for a one point slider)
                else this.options.maxDate = this._calculateMaxDate(); // Update handle text
                let handles = this._getSliderHandles();
                for(let key in handles)this._updateHandle(handles[key], this.options[key]);
            },
            /**
     * Create and set the labels for each of the handles
     * @return {void}
     */ _createLabels () {
                // Get the handles and loop over them
                let handles = this._getSliderHandles();
                for(let key in handles){
                    let label = this._createHandleLabel(this.options[key]); // Bind a double click handler to the label for the date picker
                    label.dblclick((e)=>{
                        // Keep the events from propagating and cancel clicks as necessary
                        e.stopPropagation();
                        e.preventDefault();
                        this._cancelClicks(); // The date picker only needs to show up on daily sliders
                        if (this.getInterval() == "day") this._onDatePopupToggle(e, key, this.options[key]);
                        return false;
                    });
                    handles[key].html(label);
                }
            },
            /**
     * Switch the slider mode between one and two point
     * @param {void} mode integer either 1 or 2
     */ _setSliderMode (mode) {
                if (mode == 1) {
                    $(this.slider).dragslider("option", "range", false);
                    $(this.slider).dragslider("option", "rangeDrag", false);
                } else if (mode == 2) {
                    $(this.slider).dragslider("option", "range", true);
                    $(this.slider).dragslider("option", "rangeDrag", true);
                }
            },
            /**
     * Get the string representation of the set interval
     * @return {string}
     */ getInterval () {
                return this.intervals[this.options.interval];
            },
            /**
     * Get the slider values from the jQuery element
     * @return {object} {minValue: moment, [maxValue: moment]}
     */ _getSliderValues () {
                let values = $(this.slider).dragslider("values");
                if (values.length) return {
                    minValue: values[0],
                    maxValue: values[1]
                };
                else return {
                    minValue: $(this.slider).dragslider("value")
                };
            },
            /**
     * Get the slider handles as jQuery elements
     * @return {object} {minDate: moment, [maxDate: moment]}
     */ _getSliderHandles () {
                let handles = $(this.slider).children(".ui-slider-handle");
                let data = {
                    minDate: handles.eq(0)
                };
                if (handles.get(1)) data.maxDate = handles.eq(1);
                return data;
            },
            /**
     * Calculate a date, given a date, interval and type
     * @param  {moment}  date
     * @param  {integer} intervalCount the number of intervals to add to the starting date
     * @param  {string}  dateType      minDate or maxDate
     * @return {moment}
     */ _calculateDate (date, intervalCount, dateType) {
                let interval = this.getInterval();
                let returnDate = date.clone().add(intervalCount, interval);
                if (dateType == "minDate") returnDate.startOf(interval);
                else if (dateType == "maxDate") returnDate.endOf(interval);
                return returnDate;
            },
            /**
     * Calculate the max date for a single point slider
     * @param  {integer} intervalCount the number of intervals to add to the starting date
     * @return {moment}
     */ _calculateMaxDate (intervalCount) {
                return this.options.minDate.clone().endOf(this.getInterval());
            },
            /**
     * Set the step setting for the slider
     */ _setSteps () {
                let interval = this.getInterval(); // Put the min date at the beginning of the interval; the max at the end
                let periodStart = this.options.range.minDate.clone().startOf(interval);
                let periodEnd = this.options.range.maxDate.clone().endOf(interval); // Calculate the step setting for the slider
                let lastStep = periodEnd.diff(periodStart, interval);
                $(this.slider).dragslider("option", "step", 1);
                $(this.slider).dragslider("option", "min", 0);
                $(this.slider).dragslider("option", "max", lastStep);
                let min = this.options.minDate.diff(periodStart, interval), max = this.options.maxDate.diff(periodStart, interval);
                if (this.options.mode == 2) $(this.slider).dragslider("option", "values", [
                    min,
                    max
                ]);
                else $(this.slider).dragslider("option", "value", min);
            },
            /**
     * Update a given handle with the correct text, tooltip and position
     * @param  {element} the handle element
     * @param  {moment} date
     * @return {void}
     */ _updateHandle (element, date) {
                let label = element.children("label");
                label.text(this._getDisplayLabel(date));
                label.css(this._getLabelPosition(label));
                label.attr("title", this._getTooltipLabel(date));
            },
            /**
     * Create a handle label given an intial date (or not)
     * @param  {moment} [date=null]
     * @return {element}
     */ _createHandleLabel (date = null) {
                // Create the label with the date formatted and set the html of the element
                return $(`<label title="${this._getTooltipLabel(date)}" >${this._getDisplayLabel(date)}</label>`);
            },
            /**
     * Returns a formatted tooltip label given a particular date
     * @param  {moment} [date=null]
     * @return {string} the formatted date
     */ _getTooltipLabel (date = null) {
                if (!date) return "";
                let format = "ddd MMM Do, YYYY";
                if (this.options.mode == 1) return this.options.minDate.format(format) + " - " + this.options.maxDate.format(format) + ` (${Interval.getAdverbs()[this.options.interval]})`;
                else if (this.options.mode == 2) return date.format(format);
            },
            /**
     * Returns a formatted display label given a particular date
     * @param  {moment} [date=null]
     * @return {string} the formatted date
     */ _getDisplayLabel (date = null) {
                if (!date) return "";
                if (this.options.mode === 2) return date.format("l");
                let format;
                switch(this.getInterval()){
                    case "day":
                        format = "l";
                        break;
                    case "week":
                        format = "[Week of] MM/DD/YYYY";
                        break;
                    case "month":
                        format = "MMM YYYY";
                        break;
                    case "quarter":
                        format = "[Q]Q YYYY";
                        break;
                    case "year":
                        format = "YYYY";
                        break;
                }
                return date.format(format);
            },
            /**
     * Calculates a position for a given label
     * @param  {element} label
     * @return {object} {left: <value>}
     */ _getLabelPosition (label) {
                // Left side
                if (label.parent().is("span:first-child")) return {
                    left: -(label.width() + 20)
                }; // Right side
                else return {
                    left: 10
                };
            },
            /**
     * Creates the select for date presets
     * @param  {element} div
     * @return {void}
     */ _createPresets: function() {
                $(this._container).children(".select-holder").remove();
                if (this.options.mode != 2 || this.options.interval > 3) return;
                let selectHolder = $(L.DomUtil.create("div", "select-holder"));
                let htmlString = "<select>";
                let value = "custom";
                if (this._isAll()) value = "all";
                this.presets.forEach((preset)=>{
                    let { minDate, maxDate } = this._getPresetRange(preset.value);
                    let legalRange = this.options.range;
                    let isEnabled = minDate <= legalRange.maxDate && maxDate >= legalRange.minDate && minDate <= maxDate;
                    if (preset.value == "all" || preset.value == "custom") isEnabled = true;
                    if (minDate.format() == this.options.minDate.format() && maxDate.format() == this.options.maxDate.format()) value = preset.value;
                    htmlString += `\n  <option value="${preset.value}" ${isEnabled ? "" : "disabled"}>${preset.name}</option>`;
                });
                htmlString += "\n</select>";
                selectHolder.html(htmlString);
                selectHolder.on("change", this._onPresetChange.bind(this)); // Set the element on `this` so it's available
                this.presetSelect = selectHolder[0];
                this._setPresetDisplay(value);
                this._container.appendChild(selectHolder[0]);
            },
            /**
     * Bound to the preset selector and fires when its value changes
     * @param  {Event} event
     * @return {void}
     */ _onPresetChange (event) {
                // If the preset is custom, there's nothing to do
                if (event.target.value == "custom") return;
                $(this.presetSelect).find("[value=custom]").removeAttr("selected", "selected"); // Figure out which date range to work on
                let { minDate, maxDate } = event.target.value == "all" ? this.options.range : this._getPresetRange(event.target.value);
                let interval = this.getInterval();
                let periodStart = this.options.range.minDate.clone().startOf(interval); // Calculate the actual slider value for each date
                let minDateValue = minDate.diff(periodStart, interval);
                let maxDateValue = maxDate.diff(periodStart, interval);
                let sliderElem = $(this.slider);
                if (sliderElem.dragslider("values")) {
                    sliderElem.dragslider("values", 0, minDateValue);
                    sliderElem.dragslider("values", 1, maxDateValue);
                } else sliderElem.dragslider("value", minDateValue);
                this._updateSlider();
                this._fireChange();
            },
            /**
     * Gets a particular range for a preset value
     * @param  {string} range a preset string as defined by `DateRange.getRanges()`
     * @return {object} a range object, including minDate and maxDate as Moment objects, and the range string
     */ _getPresetRange: function(range) {
                let { minDate, maxDate } = DateRange.getRange(range); // Moment-ify the dates before sending them out
                return {
                    minDate: moment(minDate),
                    maxDate: moment(maxDate),
                    range
                };
            },
            /**
     * Check if selected dates match full legal range
     * @return {bool}
     */ _isAll () {
                let interval = this.getInterval(), min = this.options.range.minDate.clone().startOf(interval), max = this.options.range.maxDate.clone().endOf(interval);
                return this.options.minDate.format() == min.format() && this.options.maxDate.format() == max.format();
            },
            /**
     * Set which preset is displayed in the HTML select
     * @param {string} value
     */ _setPresetDisplay (value) {
                if (this.presetSelect) {
                    this.presetSelect.value = value;
                    $(this.presetSelect).find("[value=" + value + "]").attr("selected", "selected");
                }
            },
            /**
     * An array to hold the IDs of timeout handlers (used in `this._cancelClicks`)
     * @type {Array}
     */ _clickCancelers: [],
            /**
     * Cancels any of the click timeouts contained in `this._clickCancelers
     * @return {void}
     */ _cancelClicks: function() {
                // Loop through all of the clickCancelers, running `clearTimeout` on each of the IDs
                for(var i = 0; i < this._clickCancelers.length; i++)clearTimeout(this._clickCancelers[i]);
                 // Reset everything
                this._clickCancelers = [];
            },
            /**
     * Triggered when double clicking to open the date popup
     * @param  {jQuery.Event} e
     * @return {void}
     */ _onDatePopupToggle: function(e, key, value) {
                // Get the label and add the date popup to it
                let label = $(e.target);
                let slider = $(this.slider);
                label.parent().prepend(this._createDatePopup(moment(value), (date)=>{
                    let calculatedStep = date.diff(this.options.range.minDate, this.getInterval());
                    if (slider.dragslider("values").length) {
                        let index = key == "minDate" ? 0 : 1;
                        slider.dragslider("values", index, calculatedStep);
                    } else slider.dragslider("value", calculatedStep);
                    this._updateSlider();
                }));
            },
            /**
     * Creates the date picker popup
     * @param  {Moment}   date a moment object
     * @param  {Function} cb   the callback to call when the date changes
     * @return {element}       the datepicker element
     */ _createDatePopup: function(date, cb) {
                // Create a new isolate scope
                var scope = $rootScope.$new(true); // Add to the scope
                Object.assign(scope, {
                    date: date.toDate(),
                    minDate: this.options.range.minDate.toDate(),
                    maxDate: this.options.range.maxDate.toDate(),
                    dateDidChange: (date)=>{
                        cb(moment(date));
                        element.remove();
                    },
                    closeDatePicker: ()=>{
                        element.remove();
                    }
                }); // Compile and return the (now Angular-ized) element so it can be displayed
                var element = $compile('<div uib-datepicker ng-model="date" min-date="minDate" max-date="maxDate" off-click="closeDatePicker()" ng-change="dateDidChange(date)"></uib-datepicker>')(scope);
                return element;
            }
        }); // Return a factory method that creates a new `HistorySlider`
        return function createHistorySlider(options) {
            return new HistorySlider(options);
        };
    }
]);

},{}],"hhxHk":[function(require,module,exports) {
var _gravatar = require("../../../../src/utils/gravatar");
/**
 * Truterritory layers
 */ angular.module("routes:mapping").directive("truterritoryLayers", function() {
    return {
        scope: {
            map: "=",
            workspace: "=",
            workspaces: "=",
            setWorkspace: "=",
            saveNewWorkspace: "&",
            deleteMap: "="
        },
        templateUrl: "/truterritory/layers.html",
        controller: [
            "$scope",
            "Collection",
            "Workspace",
            "Session",
            "$uibModal",
            "filterFilter",
            "MappingModals",
            "hasMapAccess",
            function($scope, Collection, Workspace, Session, $uibModal, filterFilter, MappingModals, hasMapAccess) {
                let allCollections = [];
                getAllCollections();
                setupWorkspaceOwners();
                $scope.search = null;
                $scope.limitToWorkspace = false;
                $scope.collections = [];
                $scope.openWorkspaceModal = MappingModals.openSaveWorkspace;
                $scope.hasAccess = hasMapAccess;
                let sharedDroppable = {
                    appendTo: "body",
                    cancel: ".disabled",
                    zIndex: 5000,
                    helper: function(event, element) {
                        return $(element).clone().css({
                            width: $(element).width(),
                            height: $(element).css("height")
                        });
                    },
                    update: function(event, ui) {
                        ui.item.sortable.dropindex = ui.item.sortable.index;
                    }
                };
                $scope.collectionDroppable = angular.copy(sharedDroppable);
                $scope.mapDroppable = angular.copy(sharedDroppable);
                $scope.collectionDroppable.connectWith = ".map-holder";
                $scope.mapDroppable.connectWith = [
                    ".map-holder",
                    ".bookmarks-drop"
                ];
                /**
       * Check whether collection is used in the current map
       * @param  {int}  collectionID
       * @return {Boolean}
       */ $scope.isCollectionActive = function(collectionID) {
                    return _.findIndex($scope.map.collections, {
                        ID: collectionID
                    }) != -1;
                };
                /**
       * Remove a collection from the current workspace
       * @param  {int} collectionID
       * @return {void}
       */ $scope.removeCollection = function(collectionID) {
                    $scope.workspace.removeCollection(collectionID).then(function() {
                        // Re-run search filters
                        $scope.filterCollections($scope.search, $scope.limitToWorkspace);
                    });
                };
                /**
       * Create a new workspace
       * @param  {Object} workspace
       * @return {Promise}
       */ $scope.createWorkspace = function(workspace) {
                    let userID = Session.get("ID");
                    workspace = {
                        name: workspace.name,
                        userID: userID,
                        userIDs: [
                            userID
                        ]
                    };
                    return Workspace.post(workspace, {
                        with: "all"
                    }).then(function(response) {
                        $scope.workspaces.push(response);
                        return $scope.selectWorkspace(response, false);
                    });
                };
                /**
       * Remove the logged-in user from the given workspace
       * @param  {Object} workspace
       * @return {Promise}
       */ $scope.removeWorkspace = function(workspace) {
                    let userID = Session.get("ID");
                    let modal = $uibModal.open({
                        templateUrl: "/truterritory/confirm-remove-user-workspace.html"
                    });
                    return modal.result.then(function() {
                        return workspace.removeUser(userID);
                    }).then(function() {
                        _.remove($scope.workspaces, {
                            ID: workspace.ID
                        });
                        if (workspace.ID == $scope.workspace.ID) $scope.setWorkspace(_.find($scope.workspaces, {
                            default: 1
                        }));
                    });
                };
                /**
       * Update the name or sharing options of the workspace
       */ $scope.updateWorkspace = function() {
                    $scope.workspace.patch(_.pick($scope.workspace, [
                        "name",
                        "sharingEnabled"
                    ]));
                };
                /**
       * Start using the given workspace
       * @param  {Object}  workspace
       * @param  {Boolean} fetch
       * @return {void}
       */ $scope.selectWorkspace = function(workspace, fetch = true) {
                    $scope.setWorkspace(workspace, fetch).then(function() {
                        $scope.resetFilters();
                        $scope.filterCollections($scope.search, $scope.limitToWorkspace);
                    });
                };
                /**
       * Clear the collection search filters
       * @return {void}
       */ $scope.resetFilters = function() {
                    $scope.search = null;
                    $scope.limitToWorkspace = false;
                };
                /**
       * Filters the collections
       * @param  {string} val
       * @param  {boolean} limitToWorkspace
       * @return {void}
       */ $scope.filterCollections = function(val, limitToWorkspace) {
                    // get the list of collections, either limited by workspace, or not
                    var collections = limitToWorkspace ? angular.copy($scope.workspace.collections) : allCollections.clone();
                    collections = _.filter(collections, function(c) {
                        return !!c.geometryType;
                    }); // If there's not a search string, set the whole array
                    //  Else, search
                    if (!val) $scope.collections = collections;
                    else $scope.collections = filterFilter(collections, {
                        name: val
                    });
                };
                /**
       * Set owner information on each workspace to differentiate between owned and shared
       * @return {void}
       */ function setupWorkspaceOwners() {
                    for(let i = 0; i < $scope.workspaces.length; i++){
                        let workspace = $scope.workspaces[i];
                        if (workspace.userID != Session.get("ID") && !workspace.nameAppended) {
                            let user = _.find(workspace.users, {
                                ID: workspace.userID
                            });
                            if (user) {
                                workspace.image = (0, _gravatar.Gravatar)(user.emailSum, 20);
                                workspace.name += " (" + user.fname + " " + user.lname + "'s)";
                                workspace.nameAppended = true;
                            }
                        }
                    }
                }
            }
        ]
    };
});

},{"../../../../src/utils/gravatar":"e2wH7"}],"e2wH7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Gravatar", ()=>Gravatar);
const Gravatar = function(hash, size, defaultType = "identicon") {
    let url = "https://www.gravatar.com/avatar/" + hash, params = {};
    if (arguments.length > 1) {
        url += "?";
        if (size) params["s"] = size;
        params["d"] = defaultType;
        url += $.param(params);
    }
    return url;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"1LAFZ":[function(require,module,exports) {
angular.module("routes:mapping").directive("legend", [
    "Legend",
    function(Legend) {
        return {
            scope: {
                map: "=",
                legends: "=",
                open: "=",
                aggregates: "="
            },
            restrict: "C",
            link: function($scope, $element, $attrs) {
                let legend; // Watch the legends array for changes, adding/removing the legends as necessary
                $scope.$watchGroup([
                    "legends",
                    "aggregates"
                ], function(newValues) {
                    let [legends, aggregates] = newValues; // If there is a legend, remove it
                    if (legend && $scope.map == legend._map) legend.remove(); // If there aren't any legends, return
                    if (!legends || !legends.length) return; // Create the legends!!
                    let open = $scope.open == null ? true : !!$scope.open;
                    if (legend && typeof legend.options.open == "boolean") open = legend.options.open;
                    legend = Legend({
                        legends,
                        open,
                        aggregates: aggregates || {}
                    }); // And…yeah…y'know…add it…
                    legend.addTo($scope.map);
                });
                $scope.$watch("open", function(open) {
                    if (!legend) return;
                    legend.toggle(false, open);
                });
            }
        };
    }
]).factory("Legend", [
    "$window",
    function($window) {
        let L = $window.L;
        let Legend = L.Control.extend({
            includes: L.Mixin.Events,
            options: {
                legends: [],
                open: false,
                aggregates: {},
                position: document.documentElement.clientWidth < 500 ? "bottomleft" : "topright"
            },
            initialize: function(options) {
                L.setOptions(this, options);
            },
            onAdd: function(map) {
                var div = L.DomUtil.create("div", "leaflet-control-legend"); // Create the legend toggle
                let toggle = this._toggle = $('<div class="toggle"></div>');
                toggle.text("Hide -"); // On click, open or close
                toggle.click(()=>{
                    this.toggle();
                });
                $(div).prepend(toggle); // Loop over the legends and create a new legend for each
                this.options.legends.forEach(this.createLegend.bind(this, div));
                L.DomEvent.disableClickPropagation(div); // Temporarily put the legend on the map so that we can toggle it on or off for the
                // first time using the correct width and height.
                let corner = map._controlCorners[this.getPosition()];
                corner.appendChild(div);
                this.toggle(false, this.options.open, div);
                corner.removeChild(div);
                return div;
            },
            /**
     * Toggles the legend open or closed
     * @param  {Boolean} [animate=true] whether to animate the opening/closing
     * @param  {Boolean} [shouldOpen]
     * @param {Node} container A container div to use instead of this._container (good for on creation)
     * @return {void}
     */ toggle: function(animate = true, shouldOpen, container) {
                container = $(container || this._container);
                if (shouldOpen != null) container[shouldOpen ? "removeClass" : "addClass"]("closed");
                else container.toggleClass("closed");
                let method = animate ? "animate" : "css";
                if (!container.hasClass("closed")) {
                    this._toggle.text("Hide -");
                    let initialWidth = container.outerWidth();
                    let initialHeight = container.height();
                    container.css({
                        width: "",
                        height: ""
                    });
                    let width = container.width() + 30;
                    let height = container.height() + 35;
                    container.css({
                        width: initialWidth,
                        height: initialHeight
                    });
                    container[method]({
                        width,
                        height,
                        margin: 10
                    });
                    this.options.open = true;
                } else {
                    this._toggle.text("Show Legend +");
                    container[method]({
                        width: this._toggle.width() + 15,
                        height: this._toggle.height() + 15,
                        margin: 0
                    });
                    this.options.open = false;
                }
            },
            /**
     * Create and append a legend
     * @param  {element} div
     * @param  {object} legend
     * @return {void}
     */ createLegend: function(div, legend) {
                let legendElement = $('<div class="legend">' + (legend.name ? `<h5>${legend.name}</h5>` : "") + '<div class="entries"></div>');
                let aggregates = legend.collectionID in this.options.aggregates ? this.options.aggregates[legend.collectionID] : {};
                legend.entries.forEach(this.createLegendEntry.bind(this, legendElement.children(".entries"), aggregates));
                $(div).append(legendElement);
            },
            /**
     * Create and append a legend entry
     * @param  {element} div
     * @param  {object} legend
     * @return {void}
     */ createLegendEntry: function(div, aggregates, legend) {
                let entry = $(`<div class="entry"><span class="name">${legend.text}</span></div>`);
                if (legend.type == "aggregate") {
                    let value = legend.value in aggregates ? aggregates[legend.value] : null;
                    if (legend.aggFormat) value = numeral(value).format(legend.aggFormat);
                    entry.addClass("aggregate").append($(`<span class="value">${value}</span>`));
                } else {
                    let symbol = $(`<div class="symbol ${legend.type}"></div>`);
                    if (parseInt(legend.value)) symbol.append($('<div class="line">').css("width", legend.value));
                    else if (legend.type == "marker-fill") symbol.css("color", legend.value);
                    else symbol.css("background-color", legend.value);
                    entry.prepend(symbol);
                }
                $(div).append(entry);
            }
        }); // Return a factory function
        return function(options) {
            return new Legend(options);
        };
    }
]);

},{}],"7o5UQ":[function(require,module,exports) {
/**
 * Map Report Editor
 */ angular.module("routes:mapping").directive("mapReports", function() {
    return {
        scope: {
            map: "=",
            reports: "=",
            collections: "@",
            templates: "@"
        },
        templateUrl: "/truterritory/map-reports.html",
        controller: [
            "$scope",
            "Map",
            "MapReports",
            "hasMapAccess",
            "Templates",
            function($scope, Map, MapReports, hasMapAccess, Templates) {
                //getAllCollections();
                $scope.mapReports = MapReports;
                $scope.templates = Templates.getList({
                    columns: "ID,slug"
                }).$object; //Templates.load().$object;
                $scope.collections = Map.collections; // $scope.search = null;
                // $scope.limitToWorkspace = false;
                // $scope.collections = [];
                // $scope.openWorkspaceModal = MappingModals.openSaveWorkspace;
                $scope.hasAccess = hasMapAccess;
                $scope.addEmptyReport = function() {}; // Initialize the current state
                $scope.init = function() {
                    $scope.mapReports = Map.reports;
                    $scope.templates = Templates.getList({
                        columns: "ID,slug"
                    }).$object; //Templates.load().$object;
                    $scope.collections = Map.collections;
                };
                $scope.save = function() {
                    $scope.mapReports.put().then(function() {
                        $scope.onSave($scope.mapReports);
                    });
                }; // /**
            //  * Load the list of all collections, not just in the current workspace
            //  * @return {void}
            //  */
            // function getAllCollections() {
            //     Collection.getList({with: 'themes,themes.rules'}).then(function (collections) {
            //         allCollections = collections;
            //         $scope.collections = collections.clone();
            //
            //         $scope.filterCollections($scope.search, $scope.limitToWorkspace);
            //     });
            // }
            }
        ]
    };
});

},{}],"gsyGW":[function(require,module,exports) {
/**
 * Permalink button & modal
 */ angular.module("modules:mapping").directive("modalMapPermalink", function() {
    return {
        restrict: "A",
        controller: [
            "$scope",
            "$uibModal",
            "MappingModals",
            function($scope, $uibModal, MappingModals) {
                /**
       * Starts the process of getting a map's permalink
       * @return {Promise}
       */ $scope.getPermalink = function() {
                    if (!$scope.map.ID || !$scope.workspace.sharingEnabled) return; // If not saved, open a modal prompting the user to save the changes
                    if ($scope.isMapDirty) return promptForSave().then($scope.getPermalink);
                    return MappingModals.openPermalink($scope.map, $scope.truMap);
                };
                /**
       * Open a modal asking the user to save the map
       * @return {Promise}
       */ function promptForSave() {
                    return MappingModals.openSaveMapChanges("Please save before sharing permalinks.", $scope.saveMap.bind(null, $scope.map));
                }
            }
        ],
        link: function(scope, element, attrs) {
            element.click(scope.getPermalink);
        }
    };
});

},{}],"gdCTh":[function(require,module,exports) {
/**
 * @description Directive for editing SQL
 *
 * @ngdoc directive
 * @name  sqlEditor
 * @memberOf routes:mapping
 * @restrict C
 * @scope true
 * @param {string} sql-model An SQL string model
 * @param {object} sql-results An object to receive validation results.
 * @param {array} sql-results.properties Will put a listing of properties (column names, types, etc) here.
 * @param {array} sql-results.featureColumns Will put a listing of just column names here (overlaps with properties)
 * @param {boolean} sql-results.success True if the SQL passed validation, false if it didn't.
 *
 * @example <div class="sql-editor" sql-model="someSQL" sql-results="someObjectYouWantResultsIn"></div>
 */ angular.module("routes:mapping").directive("sqlEditor", [
    "$stateParams",
    "$timeout",
    "Collection",
    function($stateParams, $timeout, Collection) {
        return {
            restrict: "C",
            templateUrl: "/truterritory/sql-editor.html",
            scope: {
                sql: "=sqlModel",
                results: "=sqlResults"
            },
            controller: [
                "$scope",
                function($scope) {
                    if (!$scope.sql) $scope.sql = "";
                    $scope.results = {
                        success: true
                    };
                    $scope.codeMirrorOptions = {
                        mode: "text/x-pgsql"
                    };
                    $scope.testing = false;
                    $scope.test = function() {
                        $scope.testing = true;
                        return Collection.testSql($scope.sql, $stateParams.entityID).then(function(data) {
                            $scope.errors = null;
                            $scope.results.success = $scope.showSuccess = true;
                            $scope.results.explain = data.explain;
                            $timeout(function() {
                                $scope.showSuccess = false;
                            }, 5000);
                        }, function(error) {
                            $scope.results.success = false;
                            $scope.results.explain = null;
                            $scope.errors = error.data.status.message;
                        }).finally(function() {
                            $scope.testing = false;
                        });
                    };
                }
            ]
        };
    }
]);

},{}],"hjLPy":[function(require,module,exports) {
/**
 * TruTerritory-theme.js controller
 */ var _apiSlice = require("../../../../src/slices/apiSlice");
var _store = require("../../../../src/store");
angular.module("routes:mapping").directive("truterritoryTheme", [
    "$timeout",
    function($timeout) {
        return {
            restrict: "A",
            replace: true,
            scope: {
                close: "&",
                onSave: "=",
                onDelete: "="
            },
            templateUrl: "/truterritory/theme.html",
            controller: [
                "$scope",
                "Theme",
                function($scope, Theme) {
                    $scope.collection = angular.copy((0, _store.store).getState().pages.truterritory.currentEditingCollection); // have to copy for angular to use it
                    $scope.theme = angular.copy((0, _store.store).getState().pages.truterritory.currentEditingTheme);
                    $scope.parsedCSS = "";
                    $scope.saveInProgress = false;
                    $scope.legendSetting = 1; // only show if there are other legends
                    if ($scope.theme.showLegendHeader && !$scope.theme.customLegendHeader) $scope.legendSetting = 2; // always show
                    else if ($scope.theme.showLegendHeader) $scope.legendSetting = 3; // custom legend header
                    $scope.editorOptions = {
                        mode: "cartocss",
                        extraKeys: {
                            Enter: function() {
                                $scope.validateCSS($scope.theme.css);
                                return CodeMirror.Pass;
                            }
                        }
                    };
                    $scope.save = function() {
                        const theme = Theme.dataOnly($scope.theme); // stripping functions since this probably came from Restangular.
                        $scope.saveInProgress = true;
                        let promise;
                        if ($scope.theme.ID) promise = (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.updateTheme.initiate($scope.theme)).then(()=>$scope.onSave($scope.theme));
                        else promise = (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.createTheme.initiate($scope.theme)).then(({ data: newTheme })=>{
                            $scope.onSave(newTheme);
                            $scope.theme = newTheme;
                        });
                        promise.finally(()=>$scope.saveInProgress = false);
                    };
                    $scope.validateCSS = function(css) {
                        return Theme.validateCSS(css, $scope.theme.label, $scope.theme.fontSize).then(function(data) {
                            $scope.cssErrors = data.errors || {};
                            $scope.areErrors = data.errors ? !!Object.keys($scope.cssErrors).length : false;
                            $scope.parsedCSS = $scope.areErrors ? "Error(s) in CSS" : data.parsed;
                        });
                    };
                    let previousTimeout;
                    $scope.validateCSSOnKeystroke = function(css) {
                        $timeout.cancel(previousTimeout);
                        previousTimeout = $timeout(function() {
                            $scope.validateCSS(css);
                        }, 700);
                    };
                    /**
       * Deletes a theme
       * @return {void}
       */ $scope.deleteTheme = function() {
                        // Send the request
                        (0, _store.store).dispatch((0, _apiSlice.baseApi).endpoints.deleteTheme.initiate($scope.theme)).then(()=>{
                            $scope.onDelete($scope.theme);
                            $scope.close();
                        });
                    };
                    $scope.legendTypes = Theme.legendTypes;
                    $scope.isLegendColor = function(type) {
                        return type && !!type.match(/(\-fill|\-color)$/);
                    };
                    $scope.legendColorOptions = {
                        showInput: true,
                        showInitial: true,
                        clickoutFiresChange: true,
                        preferredFormat: "hex",
                        allowEmpty: true,
                        showAlpha: true
                    };
                    /**
       *
       * @param {Object} prop
       * @param {Object} theme
       *
       * @return {boolean}
       */ $scope.propertyLabelShouldBeDisabled = function(prop, theme) {
                        // A prop label should be disabled if the property can't be labeled and it doesn't currently have a format attached
                        let hasFormat = !!theme.labelFormats[prop.name] || theme.labelFormats[prop.name] === 0 || theme.labelFormats[prop.name] === "0";
                        let formattableType = $scope.getPgTypeToJs(prop.type) === "number" || $scope.getPgTypeToJs(prop.type) === "unknown";
                        return !hasFormat && !formattableType;
                    };
                    /**
       *
       * @param {string} pgType
       * @return {string}
       */ $scope.getPgTypeToJs = function(pgType) {
                        if (pgType === "varchar" || pgType === "text") return "string";
                        else if (pgType.startsWith("int") || pgType === "numeric" || pgType.startsWith("float") || pgType.endsWith("int")) return "number";
                        else if (pgType === "boolean" || pgType === "bool") return "boolean";
                        else if (pgType.startsWith("timestamp")) return "date";
                        else if (pgType.startsWith("json")) return "json";
                        else if (pgType.endsWith("[]")) return "array";
                        else return "unknown";
                    };
                }
            ]
        };
    }
]);

},{"../../../../src/slices/apiSlice":"fcKYC","../../../../src/store":"7WrEn"}]},["d0Upo"], "d0Upo", "parcelRequire5cdf")

//# sourceMappingURL=index.8c72f91d.js.map
